// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/figtree/figtree-regular-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/figtree/figtree-regular-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/figtree/figtree-medium-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/figtree/figtree-medium-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/figtree/figtree-semibold-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/figtree/figtree-bold-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../fonts/figtree/figtree-bold-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../fonts/opensans/open-sans-regular-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../fonts/opensans/open-sans-regular-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../fonts/opensans/open-sans-medium-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../fonts/opensans/open-sans-medium-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../fonts/opensans/open-sans-semibold-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../fonts/opensans/open-sans-semibold-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../fonts/opensans/open-sans-bold-latin-ext.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../fonts/opensans/open-sans-bold-latin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2236px%22%20height%3D%2218px%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20points%3D%220%2C%200%208%2C%208%2016%2C0%22%20fill%3D%22#fff%22%20transform%3D%22scale%282.25%29%20rotate%28180 8 4%29%22%3E%3C%2Fpolygon%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2236px%22%20height%3D%2218px%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20points%3D%220%2C%200%208%2C%208%2016%2C0%22%20fill%3D%22#fff%22%20transform%3D%22scale%282.25%29%20rotate%280%29%22%3E%3C%2Fpolygon%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2218px%22%20height%3D%2236px%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20points%3D%220%2C%200%208%2C%208%2016%2C0%22%20fill%3D%22#fff%22%20transform%3D%22scale%282.25%29%20rotate%28270 8 8%29%22%3E%3C%2Fpolygon%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2218px%22%20height%3D%2236px%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20points%3D%220%2C%200%208%2C%208%2016%2C0%22%20fill%3D%22#fff%22%20transform%3D%22scale%282.25%29%20rotate%2890 4 4%29%22%3E%3C%2Fpolygon%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2212px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14.117.323l-6.073%206.075-5.449-6.075c-.431-.431-1.131-.431-1.562%200-.431.431-.431%201.131%200%201.562l5.449%206.075-6.159%206.159c-.431.431-.431%201.134%200%201.562.431.431%201.131.431%201.562%200l6.075-6.073%205.449%206.073c.429.431%201.131.431%201.56%200%20.431-.429.431-1.131%200-1.562l-5.452-6.073%206.159-6.161c.431-.431.431-1.131%200-1.562-.431-.431-1.129-.431-1.56%200z%22%20fill%3D%22rgba%2885, 85, 85, 0.5%29%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author         : G-axon
Template Name  : Jumbo React - Admin Template
Version        : 1.0
*/
/*=============================================================
    Table of Contents:
    =============================
    A. Globals
        01. Custom Animation
    B. Base
        01. Base Styles
        02. Typography Styles
    C. Layouts
        01. App Layout Styles
        02. Sidebar Styles
        03. Header Styles
        04. Main Content Styles
        05. Footer Styles
        06. Right Sidebar Styles
    D. UI Components
        01. Alert Styles
        02. Avatar Styles
        03. Badges Styles
        04. Blockquotes Styles
        05. Bottom Navigation Styles
        06. Breadcrumb Styles
        07. Button Styles
        08. Button Group Styles
        09. Callout Styles
        10. Cards Styles
        11. Charts Styles
        12. Chips Styles
        13. Carousel Styles
        14. Color Picker Styles
        15. Drawer Styles
        16. E-commerce Styles
        17. Grids List Styles
        18. Icons Styles
        19. Label Styles
        20. List Styles
        21. Nav Style
        22. Pricing Styles
        23. Progressbar Styles
        24. Popover Styles
        25. React Joyride Styles
        26. Tables Styles
        27. Tabs Styles
        28. Testimonial Styles
        29. Time Lines Style
        30. Joyride Tour Styles
        31. Form Styles
    E. Pages
        01. Login Styles
        02. Error Styles
        03. Editor Styles
        04. Contact Page Styles
        05. Portfolio Styles
        06. Faqs Styles
        07. Dashboard Styles
    F. Slider
    G. Modules
        01. App Module Style
        02. Chat Module Styles
        03. Mails Module Styles
        04. Contact Module Styles
        05. Calendar Module Style
    H. Color Theme
        01. Theme Indigo Styles
        02. Theme Cyan Styles
        03. Theme Amber Styles
        04. Theme Deep Orange Styles
        05. Theme Pink Styles
        06. Theme Blue Styles
        07. Theme Deep Purple Styles
        08. Theme Green Styles
        09. Theme Dark Indigo Styles
        10. Theme Dark Cyan Styles
        11. Theme Dark Amber Styles
        12. Theme Dark Deep Orange Styles
        13. Theme Dark Pink Styles
        14. Theme Dark Blue Styles
        15. Theme Dark Deep Purple Styles
        16. Theme Dark Green Styles
  =============================================================*/
/* Globals
   ========================================================================== */
.jr-menu-icon .menu-icon {
  --bars-height: 2px;
  position: relative;
  width: 70%;
  height: var(--bars-height);
  min-height: var(--bars-height);
  color: inherit;
  background-color: #808080;
  display: block;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  margin: 6px 0;
  cursor: pointer;
}
.jr-menu-icon .menu-icon:after, .jr-menu-icon .menu-icon:before {
  position: absolute;
  display: block;
  color: inherit;
  background-color: inherit;
  inset-inline-start: 0;
  height: var(--bars-height);
  min-height: var(--bars-height);
  content: "";
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.jr-menu-icon .menu-icon:after {
  width: 120%;
  bottom: -6px;
}
.jr-menu-icon .menu-icon:before {
  width: 130%;
  top: -6px;
}
.jr-menu-icon:hover .menu-icon {
  width: 100%;
}
.jr-menu-icon:hover .menu-icon:after, .jr-menu-icon:hover .menu-icon:before {
  width: 100%;
}

.timeline-badge, .user-list .user-avatar, .jr-fab-btn, .user-avatar, .size-50 {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px;
}

.jr-btn-fab-lg, .size-60 {
  height: 60px !important;
  width: 60px !important;
  line-height: 60px;
}

.size-80 {
  height: 80px !important;
  width: 80px !important;
  line-height: 80px;
}

.size-100 {
  height: 100px !important;
  width: 100px !important;
  line-height: 100px;
}

.size-20 {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px;
}

.icon, .jr-btn-fab-xs, .jr-menu-icon, .size-30 {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px;
}

.jr-btn-fab-sm, .size-40 {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px;
}

.profile-intro img.avatar-circle, .size-120 {
  height: 120px !important;
  width: 120px !important;
  line-height: 120px;
}

.icon-addon {
  display: inline-block;
  text-align: center;
  background-color: inherit;
}

.jr-card {
  padding: 24px 30px;
  margin-bottom: 34px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ced4da;
  position: relative;
}

/* Ripple magic */
.ripple-effect {
  position: relative;
  overflow: hidden;
}
.ripple-effect:after {
  content: "";
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
.ripple-effect:hover:after {
  animation: ripple 1s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
@-webkit-keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
.quick-menu .icon-alert:after {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -o-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  animation: pulse 2s infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
.chat-avatar-mode .chat-mode.offline, .chat-avatar-mode .chat-mode.online {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -moz-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -o-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  animation: online 2s infinite;
}

@-webkit-keyframes online {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
@keyframes online {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
.chat-avatar-mode .chat-mode.away {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -moz-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -o-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  animation: away 2s infinite;
}

@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
/*Different size images set in Equal block height and width*/
.brand-logo, .grid-thumb-equal {
  position: relative;
  padding-bottom: 68%;
  height: 0;
  width: 100%;
  overflow: hidden;
}

.brand-logo .brand-logo-inner, .grid-thumb-cover {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}

.grid-thumb-cover img {
  height: auto;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%;
}

a.badge-dark, a.badge-info, a.badge-warning, a.badge-danger, a.badge-success, a.btn-dark, a.btn-success, a.btn-warning, a.btn-danger, a.btn-info {
  color: #fff !important;
}
a.badge-dark:hover, a.badge-info:hover, a.badge-warning:hover, a.badge-danger:hover, a.badge-success:hover, a.btn-dark:hover, a.btn-success:hover, a.btn-warning:hover, a.btn-danger:hover, a.btn-info:hover, a.badge-dark:focus, a.badge-info:focus, a.badge-warning:focus, a.badge-danger:focus, a.badge-success:focus, a.btn-dark:focus, a.btn-success:focus, a.btn-warning:focus, a.btn-danger:focus, a.btn-info:focus {
  color: #fff !important;
}

.carousel-control-next, .carousel-control-prev {
  cursor: pointer;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.bg-primary {
  background-color: #99BBCD !important;
}

.text-primary {
  color: #99BBCD !important;
}
.text-primary.icon-outline {
  border-color: #99BBCD !important;
}

.bg-primary.lighten-5 {
  background-color: #e8eaf6 !important;
}

.text-primary.text-lighten-5 {
  color: #e8eaf6 !important;
}
.text-primary.text-lighten-5.icon-outline {
  border-color: #e8eaf6 !important;
}

.bg-primary.lighten-4 {
  background-color: #c5cae9 !important;
}

.text-primary.text-lighten-4 {
  color: #c5cae9 !important;
}
.text-primary.text-lighten-4.icon-outline {
  border-color: #c5cae9 !important;
}

.bg-primary.lighten-3 {
  background-color: #9fa8da !important;
}

.text-primary.text-lighten-3 {
  color: #9fa8da !important;
}
.text-primary.text-lighten-3.icon-outline {
  border-color: #9fa8da !important;
}

.bg-primary.lighten-2 {
  background-color: #7986cb !important;
}

.text-primary.text-lighten-2 {
  color: #7986cb !important;
}
.text-primary.text-lighten-2.icon-outline {
  border-color: #7986cb !important;
}

.bg-primary.lighten-1 {
  background-color: #5c6bc0 !important;
}

.text-primary.text-lighten-1 {
  color: #5c6bc0 !important;
}
.text-primary.text-lighten-1.icon-outline {
  border-color: #5c6bc0 !important;
}

.bg-primary.darken-1 {
  background-color: #3949ab !important;
}

.text-primary.text-darken-1 {
  color: #3949ab !important;
}
.text-primary.text-darken-1.icon-outline {
  border-color: #3949ab !important;
}

.bg-primary.darken-2 {
  background-color: #303f9f !important;
}

.text-primary.text-darken-2 {
  color: #303f9f !important;
}
.text-primary.text-darken-2.icon-outline {
  border-color: #303f9f !important;
}

.bg-primary.darken-3 {
  background-color: #283593 !important;
}

.text-primary.text-darken-3 {
  color: #283593 !important;
}
.text-primary.text-darken-3.icon-outline {
  border-color: #283593 !important;
}

.bg-primary.darken-4 {
  background-color: #1a237e !important;
}

.text-primary.text-darken-4 {
  color: #1a237e !important;
}
.text-primary.text-darken-4.icon-outline {
  border-color: #1a237e !important;
}

.bg-primary.accent-1 {
  background-color: #8c9eff !important;
}

.text-primary.text-accent-1 {
  color: #8c9eff !important;
}
.text-primary.text-accent-1.icon-outline {
  border-color: #8c9eff !important;
}

.bg-primary.accent-2 {
  background-color: #536dfe !important;
}

.text-primary.text-accent-2 {
  color: #536dfe !important;
}
.text-primary.text-accent-2.icon-outline {
  border-color: #536dfe !important;
}

.bg-primary.accent-3 {
  background-color: #3d5afe !important;
}

.text-primary.text-accent-3 {
  color: #3d5afe !important;
}
.text-primary.text-accent-3.icon-outline {
  border-color: #3d5afe !important;
}

.bg-primary.accent-4 {
  background-color: #304ffe !important;
}

.text-primary.text-accent-4 {
  color: #304ffe !important;
}
.text-primary.text-accent-4.icon-outline {
  border-color: #304ffe !important;
}

.bg-red {
  background-color: #F44336 !important;
}

.text-red {
  color: #F44336 !important;
}
.text-red.icon-outline {
  border-color: #F44336 !important;
}

.bg-red.lighten-5 {
  background-color: #FFEBEE !important;
}

.text-red.text-lighten-5 {
  color: #FFEBEE !important;
}
.text-red.text-lighten-5.icon-outline {
  border-color: #FFEBEE !important;
}

.bg-red.lighten-4 {
  background-color: #FFCDD2 !important;
}

.text-red.text-lighten-4 {
  color: #FFCDD2 !important;
}
.text-red.text-lighten-4.icon-outline {
  border-color: #FFCDD2 !important;
}

.bg-red.lighten-3 {
  background-color: #EF9A9A !important;
}

.text-red.text-lighten-3 {
  color: #EF9A9A !important;
}
.text-red.text-lighten-3.icon-outline {
  border-color: #EF9A9A !important;
}

.bg-red.lighten-2 {
  background-color: #E57373 !important;
}

.text-red.text-lighten-2 {
  color: #E57373 !important;
}
.text-red.text-lighten-2.icon-outline {
  border-color: #E57373 !important;
}

.bg-red.lighten-1 {
  background-color: #EF5350 !important;
}

.text-red.text-lighten-1 {
  color: #EF5350 !important;
}
.text-red.text-lighten-1.icon-outline {
  border-color: #EF5350 !important;
}

.bg-red.darken-1 {
  background-color: #E53935 !important;
}

.text-red.text-darken-1 {
  color: #E53935 !important;
}
.text-red.text-darken-1.icon-outline {
  border-color: #E53935 !important;
}

.bg-red.darken-2 {
  background-color: #D32F2F !important;
}

.text-red.text-darken-2 {
  color: #D32F2F !important;
}
.text-red.text-darken-2.icon-outline {
  border-color: #D32F2F !important;
}

.bg-red.darken-3 {
  background-color: #C62828 !important;
}

.text-red.text-darken-3 {
  color: #C62828 !important;
}
.text-red.text-darken-3.icon-outline {
  border-color: #C62828 !important;
}

.bg-red.darken-4 {
  background-color: #B71C1C !important;
}

.text-red.text-darken-4 {
  color: #B71C1C !important;
}
.text-red.text-darken-4.icon-outline {
  border-color: #B71C1C !important;
}

.bg-red.accent-1 {
  background-color: #FF8A80 !important;
}

.text-red.text-accent-1 {
  color: #FF8A80 !important;
}
.text-red.text-accent-1.icon-outline {
  border-color: #FF8A80 !important;
}

.bg-red.accent-2 {
  background-color: #FF5252 !important;
}

.text-red.text-accent-2 {
  color: #FF5252 !important;
}
.text-red.text-accent-2.icon-outline {
  border-color: #FF5252 !important;
}

.bg-red.accent-3 {
  background-color: #FF1744 !important;
}

.text-red.text-accent-3 {
  color: #FF1744 !important;
}
.text-red.text-accent-3.icon-outline {
  border-color: #FF1744 !important;
}

.bg-red.accent-4 {
  background-color: #D50000 !important;
}

.text-red.text-accent-4 {
  color: #D50000 !important;
}
.text-red.text-accent-4.icon-outline {
  border-color: #D50000 !important;
}

.bg-pink {
  background-color: #e91e63 !important;
}

.text-pink {
  color: #e91e63 !important;
}
.text-pink.icon-outline {
  border-color: #e91e63 !important;
}

.bg-pink.lighten-5 {
  background-color: #fce4ec !important;
}

.text-pink.text-lighten-5 {
  color: #fce4ec !important;
}
.text-pink.text-lighten-5.icon-outline {
  border-color: #fce4ec !important;
}

.bg-pink.lighten-4 {
  background-color: #f8bbd0 !important;
}

.text-pink.text-lighten-4 {
  color: #f8bbd0 !important;
}
.text-pink.text-lighten-4.icon-outline {
  border-color: #f8bbd0 !important;
}

.bg-pink.lighten-3 {
  background-color: #f48fb1 !important;
}

.text-pink.text-lighten-3 {
  color: #f48fb1 !important;
}
.text-pink.text-lighten-3.icon-outline {
  border-color: #f48fb1 !important;
}

.bg-pink.lighten-2 {
  background-color: #f06292 !important;
}

.text-pink.text-lighten-2 {
  color: #f06292 !important;
}
.text-pink.text-lighten-2.icon-outline {
  border-color: #f06292 !important;
}

.bg-pink.lighten-1 {
  background-color: #ec407a !important;
}

.text-pink.text-lighten-1 {
  color: #ec407a !important;
}
.text-pink.text-lighten-1.icon-outline {
  border-color: #ec407a !important;
}

.bg-pink.darken-1 {
  background-color: #d81b60 !important;
}

.text-pink.text-darken-1 {
  color: #d81b60 !important;
}
.text-pink.text-darken-1.icon-outline {
  border-color: #d81b60 !important;
}

.bg-pink.darken-2 {
  background-color: #c2185b !important;
}

.text-pink.text-darken-2 {
  color: #c2185b !important;
}
.text-pink.text-darken-2.icon-outline {
  border-color: #c2185b !important;
}

.bg-pink.darken-3 {
  background-color: #ad1457 !important;
}

.text-pink.text-darken-3 {
  color: #ad1457 !important;
}
.text-pink.text-darken-3.icon-outline {
  border-color: #ad1457 !important;
}

.bg-pink.darken-4 {
  background-color: #880e4f !important;
}

.text-pink.text-darken-4 {
  color: #880e4f !important;
}
.text-pink.text-darken-4.icon-outline {
  border-color: #880e4f !important;
}

.bg-pink.accent-1 {
  background-color: #ff80ab !important;
}

.text-pink.text-accent-1 {
  color: #ff80ab !important;
}
.text-pink.text-accent-1.icon-outline {
  border-color: #ff80ab !important;
}

.bg-pink.accent-2 {
  background-color: #ff4081 !important;
}

.text-pink.text-accent-2 {
  color: #ff4081 !important;
}
.text-pink.text-accent-2.icon-outline {
  border-color: #ff4081 !important;
}

.bg-pink.accent-3 {
  background-color: #f50057 !important;
}

.text-pink.text-accent-3 {
  color: #f50057 !important;
}
.text-pink.text-accent-3.icon-outline {
  border-color: #f50057 !important;
}

.bg-pink.accent-4 {
  background-color: #c51162 !important;
}

.text-pink.text-accent-4 {
  color: #c51162 !important;
}
.text-pink.text-accent-4.icon-outline {
  border-color: #c51162 !important;
}

.bg-purple {
  background-color: #9C27B0 !important;
}

.text-purple {
  color: #9C27B0 !important;
}
.text-purple.icon-outline {
  border-color: #9C27B0 !important;
}

.bg-purple.lighten-5 {
  background-color: #f3e5f5 !important;
}

.text-purple.text-lighten-5 {
  color: #f3e5f5 !important;
}
.text-purple.text-lighten-5.icon-outline {
  border-color: #f3e5f5 !important;
}

.bg-purple.lighten-4 {
  background-color: #e1bee7 !important;
}

.text-purple.text-lighten-4 {
  color: #e1bee7 !important;
}
.text-purple.text-lighten-4.icon-outline {
  border-color: #e1bee7 !important;
}

.bg-purple.lighten-3 {
  background-color: #ce93d8 !important;
}

.text-purple.text-lighten-3 {
  color: #ce93d8 !important;
}
.text-purple.text-lighten-3.icon-outline {
  border-color: #ce93d8 !important;
}

.bg-purple.lighten-2 {
  background-color: #ba68c8 !important;
}

.text-purple.text-lighten-2 {
  color: #ba68c8 !important;
}
.text-purple.text-lighten-2.icon-outline {
  border-color: #ba68c8 !important;
}

.bg-purple.lighten-1 {
  background-color: #ab47bc !important;
}

.text-purple.text-lighten-1 {
  color: #ab47bc !important;
}
.text-purple.text-lighten-1.icon-outline {
  border-color: #ab47bc !important;
}

.bg-purple.darken-1 {
  background-color: #8e24aa !important;
}

.text-purple.text-darken-1 {
  color: #8e24aa !important;
}
.text-purple.text-darken-1.icon-outline {
  border-color: #8e24aa !important;
}

.bg-purple.darken-2 {
  background-color: #7b1fa2 !important;
}

.text-purple.text-darken-2 {
  color: #7b1fa2 !important;
}
.text-purple.text-darken-2.icon-outline {
  border-color: #7b1fa2 !important;
}

.bg-purple.darken-3 {
  background-color: #6a1b9a !important;
}

.text-purple.text-darken-3 {
  color: #6a1b9a !important;
}
.text-purple.text-darken-3.icon-outline {
  border-color: #6a1b9a !important;
}

.bg-purple.darken-4 {
  background-color: #4a148c !important;
}

.text-purple.text-darken-4 {
  color: #4a148c !important;
}
.text-purple.text-darken-4.icon-outline {
  border-color: #4a148c !important;
}

.bg-purple.accent-1 {
  background-color: #ea80fc !important;
}

.text-purple.text-accent-1 {
  color: #ea80fc !important;
}
.text-purple.text-accent-1.icon-outline {
  border-color: #ea80fc !important;
}

.bg-purple.accent-2 {
  background-color: #e040fb !important;
}

.text-purple.text-accent-2 {
  color: #e040fb !important;
}
.text-purple.text-accent-2.icon-outline {
  border-color: #e040fb !important;
}

.bg-purple.accent-3 {
  background-color: #d500f9 !important;
}

.text-purple.text-accent-3 {
  color: #d500f9 !important;
}
.text-purple.text-accent-3.icon-outline {
  border-color: #d500f9 !important;
}

.bg-purple.accent-4 {
  background-color: #aa00ff !important;
}

.text-purple.text-accent-4 {
  color: #aa00ff !important;
}
.text-purple.text-accent-4.icon-outline {
  border-color: #aa00ff !important;
}

.bg-deep-purple {
  background-color: #673ab7 !important;
}

.text-deep-purple {
  color: #673ab7 !important;
}
.text-deep-purple.icon-outline {
  border-color: #673ab7 !important;
}

.bg-deep-purple.lighten-5 {
  background-color: #ede7f6 !important;
}

.text-deep-purple.text-lighten-5 {
  color: #ede7f6 !important;
}
.text-deep-purple.text-lighten-5.icon-outline {
  border-color: #ede7f6 !important;
}

.bg-deep-purple.lighten-4 {
  background-color: #d1c4e9 !important;
}

.text-deep-purple.text-lighten-4 {
  color: #d1c4e9 !important;
}
.text-deep-purple.text-lighten-4.icon-outline {
  border-color: #d1c4e9 !important;
}

.bg-deep-purple.lighten-3 {
  background-color: #b39ddb !important;
}

.text-deep-purple.text-lighten-3 {
  color: #b39ddb !important;
}
.text-deep-purple.text-lighten-3.icon-outline {
  border-color: #b39ddb !important;
}

.bg-deep-purple.lighten-2 {
  background-color: #9575cd !important;
}

.text-deep-purple.text-lighten-2 {
  color: #9575cd !important;
}
.text-deep-purple.text-lighten-2.icon-outline {
  border-color: #9575cd !important;
}

.bg-deep-purple.lighten-1 {
  background-color: #7e57c2 !important;
}

.text-deep-purple.text-lighten-1 {
  color: #7e57c2 !important;
}
.text-deep-purple.text-lighten-1.icon-outline {
  border-color: #7e57c2 !important;
}

.bg-deep-purple.darken-1 {
  background-color: #5e35b1 !important;
}

.text-deep-purple.text-darken-1 {
  color: #5e35b1 !important;
}
.text-deep-purple.text-darken-1.icon-outline {
  border-color: #5e35b1 !important;
}

.bg-deep-purple.darken-2 {
  background-color: #512da8 !important;
}

.text-deep-purple.text-darken-2 {
  color: #512da8 !important;
}
.text-deep-purple.text-darken-2.icon-outline {
  border-color: #512da8 !important;
}

.bg-deep-purple.darken-3 {
  background-color: #4527a0 !important;
}

.text-deep-purple.text-darken-3 {
  color: #4527a0 !important;
}
.text-deep-purple.text-darken-3.icon-outline {
  border-color: #4527a0 !important;
}

.bg-deep-purple.darken-4 {
  background-color: #311b92 !important;
}

.text-deep-purple.text-darken-4 {
  color: #311b92 !important;
}
.text-deep-purple.text-darken-4.icon-outline {
  border-color: #311b92 !important;
}

.bg-deep-purple.accent-1 {
  background-color: #b388ff !important;
}

.text-deep-purple.text-accent-1 {
  color: #b388ff !important;
}
.text-deep-purple.text-accent-1.icon-outline {
  border-color: #b388ff !important;
}

.bg-deep-purple.accent-2 {
  background-color: #7c4dff !important;
}

.text-deep-purple.text-accent-2 {
  color: #7c4dff !important;
}
.text-deep-purple.text-accent-2.icon-outline {
  border-color: #7c4dff !important;
}

.bg-deep-purple.accent-3 {
  background-color: #651fff !important;
}

.text-deep-purple.text-accent-3 {
  color: #651fff !important;
}
.text-deep-purple.text-accent-3.icon-outline {
  border-color: #651fff !important;
}

.bg-deep-purple.accent-4 {
  background-color: #6200ea !important;
}

.text-deep-purple.text-accent-4 {
  color: #6200ea !important;
}
.text-deep-purple.text-accent-4.icon-outline {
  border-color: #6200ea !important;
}

.bg-indigo {
  background-color: #99BBCD !important;
}

.text-indigo {
  color: #99BBCD !important;
}
.text-indigo.icon-outline {
  border-color: #99BBCD !important;
}

.bg-indigo.lighten-5 {
  background-color: #e8eaf6 !important;
}

.text-indigo.text-lighten-5 {
  color: #e8eaf6 !important;
}
.text-indigo.text-lighten-5.icon-outline {
  border-color: #e8eaf6 !important;
}

.bg-indigo.lighten-4 {
  background-color: #c5cae9 !important;
}

.text-indigo.text-lighten-4 {
  color: #c5cae9 !important;
}
.text-indigo.text-lighten-4.icon-outline {
  border-color: #c5cae9 !important;
}

.bg-indigo.lighten-3 {
  background-color: #9fa8da !important;
}

.text-indigo.text-lighten-3 {
  color: #9fa8da !important;
}
.text-indigo.text-lighten-3.icon-outline {
  border-color: #9fa8da !important;
}

.bg-indigo.lighten-2 {
  background-color: #7986cb !important;
}

.text-indigo.text-lighten-2 {
  color: #7986cb !important;
}
.text-indigo.text-lighten-2.icon-outline {
  border-color: #7986cb !important;
}

.bg-indigo.lighten-1 {
  background-color: #5c6bc0 !important;
}

.text-indigo.text-lighten-1 {
  color: #5c6bc0 !important;
}
.text-indigo.text-lighten-1.icon-outline {
  border-color: #5c6bc0 !important;
}

.bg-indigo.darken-1 {
  background-color: #3949ab !important;
}

.text-indigo.text-darken-1 {
  color: #3949ab !important;
}
.text-indigo.text-darken-1.icon-outline {
  border-color: #3949ab !important;
}

.bg-indigo.darken-2 {
  background-color: #303f9f !important;
}

.text-indigo.text-darken-2 {
  color: #303f9f !important;
}
.text-indigo.text-darken-2.icon-outline {
  border-color: #303f9f !important;
}

.bg-indigo.darken-3 {
  background-color: #283593 !important;
}

.text-indigo.text-darken-3 {
  color: #283593 !important;
}
.text-indigo.text-darken-3.icon-outline {
  border-color: #283593 !important;
}

.bg-indigo.darken-4 {
  background-color: #1a237e !important;
}

.text-indigo.text-darken-4 {
  color: #1a237e !important;
}
.text-indigo.text-darken-4.icon-outline {
  border-color: #1a237e !important;
}

.bg-indigo.accent-1 {
  background-color: #8c9eff !important;
}

.text-indigo.text-accent-1 {
  color: #8c9eff !important;
}
.text-indigo.text-accent-1.icon-outline {
  border-color: #8c9eff !important;
}

.bg-indigo.accent-2 {
  background-color: #536dfe !important;
}

.text-indigo.text-accent-2 {
  color: #536dfe !important;
}
.text-indigo.text-accent-2.icon-outline {
  border-color: #536dfe !important;
}

.bg-indigo.accent-3 {
  background-color: #3d5afe !important;
}

.text-indigo.text-accent-3 {
  color: #3d5afe !important;
}
.text-indigo.text-accent-3.icon-outline {
  border-color: #3d5afe !important;
}

.bg-indigo.accent-4 {
  background-color: #304ffe !important;
}

.text-indigo.text-accent-4 {
  color: #304ffe !important;
}
.text-indigo.text-accent-4.icon-outline {
  border-color: #304ffe !important;
}

.bg-blue {
  background-color: #2196F3 !important;
}

.text-blue {
  color: #2196F3 !important;
}
.text-blue.icon-outline {
  border-color: #2196F3 !important;
}

.bg-blue.lighten-5 {
  background-color: #E3F2FD !important;
}

.text-blue.text-lighten-5 {
  color: #E3F2FD !important;
}
.text-blue.text-lighten-5.icon-outline {
  border-color: #E3F2FD !important;
}

.bg-blue.lighten-4 {
  background-color: #BBDEFB !important;
}

.text-blue.text-lighten-4 {
  color: #BBDEFB !important;
}
.text-blue.text-lighten-4.icon-outline {
  border-color: #BBDEFB !important;
}

.bg-blue.lighten-3 {
  background-color: #90CAF9 !important;
}

.text-blue.text-lighten-3 {
  color: #90CAF9 !important;
}
.text-blue.text-lighten-3.icon-outline {
  border-color: #90CAF9 !important;
}

.bg-blue.lighten-2 {
  background-color: #64B5F6 !important;
}

.text-blue.text-lighten-2 {
  color: #64B5F6 !important;
}
.text-blue.text-lighten-2.icon-outline {
  border-color: #64B5F6 !important;
}

.bg-blue.lighten-1 {
  background-color: #42A5F5 !important;
}

.text-blue.text-lighten-1 {
  color: #42A5F5 !important;
}
.text-blue.text-lighten-1.icon-outline {
  border-color: #42A5F5 !important;
}

.bg-blue.darken-1 {
  background-color: #1E88E5 !important;
}

.text-blue.text-darken-1 {
  color: #1E88E5 !important;
}
.text-blue.text-darken-1.icon-outline {
  border-color: #1E88E5 !important;
}

.bg-blue.darken-2 {
  background-color: #1976D2 !important;
}

.text-blue.text-darken-2 {
  color: #1976D2 !important;
}
.text-blue.text-darken-2.icon-outline {
  border-color: #1976D2 !important;
}

.bg-blue.darken-3 {
  background-color: #1565C0 !important;
}

.text-blue.text-darken-3 {
  color: #1565C0 !important;
}
.text-blue.text-darken-3.icon-outline {
  border-color: #1565C0 !important;
}

.bg-blue.darken-4 {
  background-color: #0D47A1 !important;
}

.text-blue.text-darken-4 {
  color: #0D47A1 !important;
}
.text-blue.text-darken-4.icon-outline {
  border-color: #0D47A1 !important;
}

.bg-blue.accent-1 {
  background-color: #82B1FF !important;
}

.text-blue.text-accent-1 {
  color: #82B1FF !important;
}
.text-blue.text-accent-1.icon-outline {
  border-color: #82B1FF !important;
}

.bg-blue.accent-2 {
  background-color: #448AFF !important;
}

.text-blue.text-accent-2 {
  color: #448AFF !important;
}
.text-blue.text-accent-2.icon-outline {
  border-color: #448AFF !important;
}

.bg-blue.accent-3 {
  background-color: #2979FF !important;
}

.text-blue.text-accent-3 {
  color: #2979FF !important;
}
.text-blue.text-accent-3.icon-outline {
  border-color: #2979FF !important;
}

.bg-blue.accent-4 {
  background-color: #2962FF !important;
}

.text-blue.text-accent-4 {
  color: #2962FF !important;
}
.text-blue.text-accent-4.icon-outline {
  border-color: #2962FF !important;
}

.bg-light-blue {
  background-color: #03a9f4 !important;
}

.text-light-blue {
  color: #03a9f4 !important;
}
.text-light-blue.icon-outline {
  border-color: #03a9f4 !important;
}

.bg-light-blue.lighten-5 {
  background-color: #e1f5fe !important;
}

.text-light-blue.text-lighten-5 {
  color: #e1f5fe !important;
}
.text-light-blue.text-lighten-5.icon-outline {
  border-color: #e1f5fe !important;
}

.bg-light-blue.lighten-4 {
  background-color: #b3e5fc !important;
}

.text-light-blue.text-lighten-4 {
  color: #b3e5fc !important;
}
.text-light-blue.text-lighten-4.icon-outline {
  border-color: #b3e5fc !important;
}

.bg-light-blue.lighten-3 {
  background-color: #81d4fa !important;
}

.text-light-blue.text-lighten-3 {
  color: #81d4fa !important;
}
.text-light-blue.text-lighten-3.icon-outline {
  border-color: #81d4fa !important;
}

.bg-light-blue.lighten-2 {
  background-color: #4fc3f7 !important;
}

.text-light-blue.text-lighten-2 {
  color: #4fc3f7 !important;
}
.text-light-blue.text-lighten-2.icon-outline {
  border-color: #4fc3f7 !important;
}

.bg-light-blue.lighten-1 {
  background-color: #29b6f6 !important;
}

.text-light-blue.text-lighten-1 {
  color: #29b6f6 !important;
}
.text-light-blue.text-lighten-1.icon-outline {
  border-color: #29b6f6 !important;
}

.bg-light-blue.darken-1 {
  background-color: #039be5 !important;
}

.text-light-blue.text-darken-1 {
  color: #039be5 !important;
}
.text-light-blue.text-darken-1.icon-outline {
  border-color: #039be5 !important;
}

.bg-light-blue.darken-2 {
  background-color: #0288d1 !important;
}

.text-light-blue.text-darken-2 {
  color: #0288d1 !important;
}
.text-light-blue.text-darken-2.icon-outline {
  border-color: #0288d1 !important;
}

.bg-light-blue.darken-3 {
  background-color: #0277bd !important;
}

.text-light-blue.text-darken-3 {
  color: #0277bd !important;
}
.text-light-blue.text-darken-3.icon-outline {
  border-color: #0277bd !important;
}

.bg-light-blue.darken-4 {
  background-color: #01579b !important;
}

.text-light-blue.text-darken-4 {
  color: #01579b !important;
}
.text-light-blue.text-darken-4.icon-outline {
  border-color: #01579b !important;
}

.bg-light-blue.accent-1 {
  background-color: #80d8ff !important;
}

.text-light-blue.text-accent-1 {
  color: #80d8ff !important;
}
.text-light-blue.text-accent-1.icon-outline {
  border-color: #80d8ff !important;
}

.bg-light-blue.accent-2 {
  background-color: #40c4ff !important;
}

.text-light-blue.text-accent-2 {
  color: #40c4ff !important;
}
.text-light-blue.text-accent-2.icon-outline {
  border-color: #40c4ff !important;
}

.bg-light-blue.accent-3 {
  background-color: #00b0ff !important;
}

.text-light-blue.text-accent-3 {
  color: #00b0ff !important;
}
.text-light-blue.text-accent-3.icon-outline {
  border-color: #00b0ff !important;
}

.bg-light-blue.accent-4 {
  background-color: #0091ea !important;
}

.text-light-blue.text-accent-4 {
  color: #0091ea !important;
}
.text-light-blue.text-accent-4.icon-outline {
  border-color: #0091ea !important;
}

.bg-cyan {
  background-color: #00bcd4 !important;
}

.text-cyan {
  color: #00bcd4 !important;
}
.text-cyan.icon-outline {
  border-color: #00bcd4 !important;
}

.bg-cyan.lighten-5 {
  background-color: #e0f7fa !important;
}

.text-cyan.text-lighten-5 {
  color: #e0f7fa !important;
}
.text-cyan.text-lighten-5.icon-outline {
  border-color: #e0f7fa !important;
}

.bg-cyan.lighten-4 {
  background-color: #b2ebf2 !important;
}

.text-cyan.text-lighten-4 {
  color: #b2ebf2 !important;
}
.text-cyan.text-lighten-4.icon-outline {
  border-color: #b2ebf2 !important;
}

.bg-cyan.lighten-3 {
  background-color: #80deea !important;
}

.text-cyan.text-lighten-3 {
  color: #80deea !important;
}
.text-cyan.text-lighten-3.icon-outline {
  border-color: #80deea !important;
}

.bg-cyan.lighten-2 {
  background-color: #4dd0e1 !important;
}

.text-cyan.text-lighten-2 {
  color: #4dd0e1 !important;
}
.text-cyan.text-lighten-2.icon-outline {
  border-color: #4dd0e1 !important;
}

.bg-cyan.lighten-1 {
  background-color: #26c6da !important;
}

.text-cyan.text-lighten-1 {
  color: #26c6da !important;
}
.text-cyan.text-lighten-1.icon-outline {
  border-color: #26c6da !important;
}

.bg-cyan.darken-1 {
  background-color: #00acc1 !important;
}

.text-cyan.text-darken-1 {
  color: #00acc1 !important;
}
.text-cyan.text-darken-1.icon-outline {
  border-color: #00acc1 !important;
}

.bg-cyan.darken-2 {
  background-color: #0097a7 !important;
}

.text-cyan.text-darken-2 {
  color: #0097a7 !important;
}
.text-cyan.text-darken-2.icon-outline {
  border-color: #0097a7 !important;
}

.bg-cyan.darken-3 {
  background-color: #00838f !important;
}

.text-cyan.text-darken-3 {
  color: #00838f !important;
}
.text-cyan.text-darken-3.icon-outline {
  border-color: #00838f !important;
}

.bg-cyan.darken-4 {
  background-color: #006064 !important;
}

.text-cyan.text-darken-4 {
  color: #006064 !important;
}
.text-cyan.text-darken-4.icon-outline {
  border-color: #006064 !important;
}

.bg-cyan.accent-1 {
  background-color: #84ffff !important;
}

.text-cyan.text-accent-1 {
  color: #84ffff !important;
}
.text-cyan.text-accent-1.icon-outline {
  border-color: #84ffff !important;
}

.bg-cyan.accent-2 {
  background-color: #18ffff !important;
}

.text-cyan.text-accent-2 {
  color: #18ffff !important;
}
.text-cyan.text-accent-2.icon-outline {
  border-color: #18ffff !important;
}

.bg-cyan.accent-3 {
  background-color: #00e5ff !important;
}

.text-cyan.text-accent-3 {
  color: #00e5ff !important;
}
.text-cyan.text-accent-3.icon-outline {
  border-color: #00e5ff !important;
}

.bg-cyan.accent-4 {
  background-color: #00b8d4 !important;
}

.text-cyan.text-accent-4 {
  color: #00b8d4 !important;
}
.text-cyan.text-accent-4.icon-outline {
  border-color: #00b8d4 !important;
}

.bg-teal {
  background-color: #009688 !important;
}

.text-teal {
  color: #009688 !important;
}
.text-teal.icon-outline {
  border-color: #009688 !important;
}

.bg-teal.lighten-5 {
  background-color: #e0f2f1 !important;
}

.text-teal.text-lighten-5 {
  color: #e0f2f1 !important;
}
.text-teal.text-lighten-5.icon-outline {
  border-color: #e0f2f1 !important;
}

.bg-teal.lighten-4 {
  background-color: #b2dfdb !important;
}

.text-teal.text-lighten-4 {
  color: #b2dfdb !important;
}
.text-teal.text-lighten-4.icon-outline {
  border-color: #b2dfdb !important;
}

.bg-teal.lighten-3 {
  background-color: #80cbc4 !important;
}

.text-teal.text-lighten-3 {
  color: #80cbc4 !important;
}
.text-teal.text-lighten-3.icon-outline {
  border-color: #80cbc4 !important;
}

.bg-teal.lighten-2 {
  background-color: #4db6ac !important;
}

.text-teal.text-lighten-2 {
  color: #4db6ac !important;
}
.text-teal.text-lighten-2.icon-outline {
  border-color: #4db6ac !important;
}

.bg-teal.lighten-1 {
  background-color: #26a69a !important;
}

.text-teal.text-lighten-1 {
  color: #26a69a !important;
}
.text-teal.text-lighten-1.icon-outline {
  border-color: #26a69a !important;
}

.bg-teal.darken-1 {
  background-color: #00897b !important;
}

.text-teal.text-darken-1 {
  color: #00897b !important;
}
.text-teal.text-darken-1.icon-outline {
  border-color: #00897b !important;
}

.bg-teal.darken-2 {
  background-color: #00796b !important;
}

.text-teal.text-darken-2 {
  color: #00796b !important;
}
.text-teal.text-darken-2.icon-outline {
  border-color: #00796b !important;
}

.bg-teal.darken-3 {
  background-color: #00695c !important;
}

.text-teal.text-darken-3 {
  color: #00695c !important;
}
.text-teal.text-darken-3.icon-outline {
  border-color: #00695c !important;
}

.bg-teal.darken-4 {
  background-color: #004d40 !important;
}

.text-teal.text-darken-4 {
  color: #004d40 !important;
}
.text-teal.text-darken-4.icon-outline {
  border-color: #004d40 !important;
}

.bg-teal.accent-1 {
  background-color: #a7ffeb !important;
}

.text-teal.text-accent-1 {
  color: #a7ffeb !important;
}
.text-teal.text-accent-1.icon-outline {
  border-color: #a7ffeb !important;
}

.bg-teal.accent-2 {
  background-color: #64ffda !important;
}

.text-teal.text-accent-2 {
  color: #64ffda !important;
}
.text-teal.text-accent-2.icon-outline {
  border-color: #64ffda !important;
}

.bg-teal.accent-3 {
  background-color: #1de9b6 !important;
}

.text-teal.text-accent-3 {
  color: #1de9b6 !important;
}
.text-teal.text-accent-3.icon-outline {
  border-color: #1de9b6 !important;
}

.bg-teal.accent-4 {
  background-color: #00bfa5 !important;
}

.text-teal.text-accent-4 {
  color: #00bfa5 !important;
}
.text-teal.text-accent-4.icon-outline {
  border-color: #00bfa5 !important;
}

.bg-green {
  background-color: #4CAF50 !important;
}

.text-green {
  color: #4CAF50 !important;
}
.text-green.icon-outline {
  border-color: #4CAF50 !important;
}

.bg-green.lighten-5 {
  background-color: #E8F5E9 !important;
}

.text-green.text-lighten-5 {
  color: #E8F5E9 !important;
}
.text-green.text-lighten-5.icon-outline {
  border-color: #E8F5E9 !important;
}

.bg-green.lighten-4 {
  background-color: #C8E6C9 !important;
}

.text-green.text-lighten-4 {
  color: #C8E6C9 !important;
}
.text-green.text-lighten-4.icon-outline {
  border-color: #C8E6C9 !important;
}

.bg-green.lighten-3 {
  background-color: #A5D6A7 !important;
}

.text-green.text-lighten-3 {
  color: #A5D6A7 !important;
}
.text-green.text-lighten-3.icon-outline {
  border-color: #A5D6A7 !important;
}

.bg-green.lighten-2 {
  background-color: #81C784 !important;
}

.text-green.text-lighten-2 {
  color: #81C784 !important;
}
.text-green.text-lighten-2.icon-outline {
  border-color: #81C784 !important;
}

.bg-green.lighten-1 {
  background-color: #66BB6A !important;
}

.text-green.text-lighten-1 {
  color: #66BB6A !important;
}
.text-green.text-lighten-1.icon-outline {
  border-color: #66BB6A !important;
}

.bg-green.darken-1 {
  background-color: #43A047 !important;
}

.text-green.text-darken-1 {
  color: #43A047 !important;
}
.text-green.text-darken-1.icon-outline {
  border-color: #43A047 !important;
}

.bg-green.darken-2 {
  background-color: #388E3C !important;
}

.text-green.text-darken-2 {
  color: #388E3C !important;
}
.text-green.text-darken-2.icon-outline {
  border-color: #388E3C !important;
}

.bg-green.darken-3 {
  background-color: #2E7D32 !important;
}

.text-green.text-darken-3 {
  color: #2E7D32 !important;
}
.text-green.text-darken-3.icon-outline {
  border-color: #2E7D32 !important;
}

.bg-green.darken-4 {
  background-color: #1B5E20 !important;
}

.text-green.text-darken-4 {
  color: #1B5E20 !important;
}
.text-green.text-darken-4.icon-outline {
  border-color: #1B5E20 !important;
}

.bg-green.accent-1 {
  background-color: #B9F6CA !important;
}

.text-green.text-accent-1 {
  color: #B9F6CA !important;
}
.text-green.text-accent-1.icon-outline {
  border-color: #B9F6CA !important;
}

.bg-green.accent-2 {
  background-color: #69F0AE !important;
}

.text-green.text-accent-2 {
  color: #69F0AE !important;
}
.text-green.text-accent-2.icon-outline {
  border-color: #69F0AE !important;
}

.bg-green.accent-3 {
  background-color: #00E676 !important;
}

.text-green.text-accent-3 {
  color: #00E676 !important;
}
.text-green.text-accent-3.icon-outline {
  border-color: #00E676 !important;
}

.bg-green.accent-4 {
  background-color: #00C853 !important;
}

.text-green.text-accent-4 {
  color: #00C853 !important;
}
.text-green.text-accent-4.icon-outline {
  border-color: #00C853 !important;
}

.bg-light-green {
  background-color: #8bc34a !important;
}

.text-light-green {
  color: #8bc34a !important;
}
.text-light-green.icon-outline {
  border-color: #8bc34a !important;
}

.bg-light-green.lighten-5 {
  background-color: #f1f8e9 !important;
}

.text-light-green.text-lighten-5 {
  color: #f1f8e9 !important;
}
.text-light-green.text-lighten-5.icon-outline {
  border-color: #f1f8e9 !important;
}

.bg-light-green.lighten-4 {
  background-color: #dcedc8 !important;
}

.text-light-green.text-lighten-4 {
  color: #dcedc8 !important;
}
.text-light-green.text-lighten-4.icon-outline {
  border-color: #dcedc8 !important;
}

.bg-light-green.lighten-3 {
  background-color: #c5e1a5 !important;
}

.text-light-green.text-lighten-3 {
  color: #c5e1a5 !important;
}
.text-light-green.text-lighten-3.icon-outline {
  border-color: #c5e1a5 !important;
}

.bg-light-green.lighten-2 {
  background-color: #aed581 !important;
}

.text-light-green.text-lighten-2 {
  color: #aed581 !important;
}
.text-light-green.text-lighten-2.icon-outline {
  border-color: #aed581 !important;
}

.bg-light-green.lighten-1 {
  background-color: #9ccc65 !important;
}

.text-light-green.text-lighten-1 {
  color: #9ccc65 !important;
}
.text-light-green.text-lighten-1.icon-outline {
  border-color: #9ccc65 !important;
}

.bg-light-green.darken-1 {
  background-color: #7cb342 !important;
}

.text-light-green.text-darken-1 {
  color: #7cb342 !important;
}
.text-light-green.text-darken-1.icon-outline {
  border-color: #7cb342 !important;
}

.bg-light-green.darken-2 {
  background-color: #689f38 !important;
}

.text-light-green.text-darken-2 {
  color: #689f38 !important;
}
.text-light-green.text-darken-2.icon-outline {
  border-color: #689f38 !important;
}

.bg-light-green.darken-3 {
  background-color: #558b2f !important;
}

.text-light-green.text-darken-3 {
  color: #558b2f !important;
}
.text-light-green.text-darken-3.icon-outline {
  border-color: #558b2f !important;
}

.bg-light-green.darken-4 {
  background-color: #33691e !important;
}

.text-light-green.text-darken-4 {
  color: #33691e !important;
}
.text-light-green.text-darken-4.icon-outline {
  border-color: #33691e !important;
}

.bg-light-green.accent-1 {
  background-color: #ccff90 !important;
}

.text-light-green.text-accent-1 {
  color: #ccff90 !important;
}
.text-light-green.text-accent-1.icon-outline {
  border-color: #ccff90 !important;
}

.bg-light-green.accent-2 {
  background-color: #b2ff59 !important;
}

.text-light-green.text-accent-2 {
  color: #b2ff59 !important;
}
.text-light-green.text-accent-2.icon-outline {
  border-color: #b2ff59 !important;
}

.bg-light-green.accent-3 {
  background-color: #76ff03 !important;
}

.text-light-green.text-accent-3 {
  color: #76ff03 !important;
}
.text-light-green.text-accent-3.icon-outline {
  border-color: #76ff03 !important;
}

.bg-light-green.accent-4 {
  background-color: #64dd17 !important;
}

.text-light-green.text-accent-4 {
  color: #64dd17 !important;
}
.text-light-green.text-accent-4.icon-outline {
  border-color: #64dd17 !important;
}

.bg-lime {
  background-color: #cddc39 !important;
}

.text-lime {
  color: #cddc39 !important;
}
.text-lime.icon-outline {
  border-color: #cddc39 !important;
}

.bg-lime.lighten-5 {
  background-color: #f9fbe7 !important;
}

.text-lime.text-lighten-5 {
  color: #f9fbe7 !important;
}
.text-lime.text-lighten-5.icon-outline {
  border-color: #f9fbe7 !important;
}

.bg-lime.lighten-4 {
  background-color: #f0f4c3 !important;
}

.text-lime.text-lighten-4 {
  color: #f0f4c3 !important;
}
.text-lime.text-lighten-4.icon-outline {
  border-color: #f0f4c3 !important;
}

.bg-lime.lighten-3 {
  background-color: #e6ee9c !important;
}

.text-lime.text-lighten-3 {
  color: #e6ee9c !important;
}
.text-lime.text-lighten-3.icon-outline {
  border-color: #e6ee9c !important;
}

.bg-lime.lighten-2 {
  background-color: #dce775 !important;
}

.text-lime.text-lighten-2 {
  color: #dce775 !important;
}
.text-lime.text-lighten-2.icon-outline {
  border-color: #dce775 !important;
}

.bg-lime.lighten-1 {
  background-color: #d4e157 !important;
}

.text-lime.text-lighten-1 {
  color: #d4e157 !important;
}
.text-lime.text-lighten-1.icon-outline {
  border-color: #d4e157 !important;
}

.bg-lime.darken-1 {
  background-color: #c0ca33 !important;
}

.text-lime.text-darken-1 {
  color: #c0ca33 !important;
}
.text-lime.text-darken-1.icon-outline {
  border-color: #c0ca33 !important;
}

.bg-lime.darken-2 {
  background-color: #afb42b !important;
}

.text-lime.text-darken-2 {
  color: #afb42b !important;
}
.text-lime.text-darken-2.icon-outline {
  border-color: #afb42b !important;
}

.bg-lime.darken-3 {
  background-color: #9e9d24 !important;
}

.text-lime.text-darken-3 {
  color: #9e9d24 !important;
}
.text-lime.text-darken-3.icon-outline {
  border-color: #9e9d24 !important;
}

.bg-lime.darken-4 {
  background-color: #827717 !important;
}

.text-lime.text-darken-4 {
  color: #827717 !important;
}
.text-lime.text-darken-4.icon-outline {
  border-color: #827717 !important;
}

.bg-lime.accent-1 {
  background-color: #f4ff81 !important;
}

.text-lime.text-accent-1 {
  color: #f4ff81 !important;
}
.text-lime.text-accent-1.icon-outline {
  border-color: #f4ff81 !important;
}

.bg-lime.accent-2 {
  background-color: #eeff41 !important;
}

.text-lime.text-accent-2 {
  color: #eeff41 !important;
}
.text-lime.text-accent-2.icon-outline {
  border-color: #eeff41 !important;
}

.bg-lime.accent-3 {
  background-color: #c6ff00 !important;
}

.text-lime.text-accent-3 {
  color: #c6ff00 !important;
}
.text-lime.text-accent-3.icon-outline {
  border-color: #c6ff00 !important;
}

.bg-lime.accent-4 {
  background-color: #aeea00 !important;
}

.text-lime.text-accent-4 {
  color: #aeea00 !important;
}
.text-lime.text-accent-4.icon-outline {
  border-color: #aeea00 !important;
}

.bg-yellow {
  background-color: #ffeb3b !important;
}

.text-yellow {
  color: #ffeb3b !important;
}
.text-yellow.icon-outline {
  border-color: #ffeb3b !important;
}

.bg-yellow.lighten-5 {
  background-color: #fffde7 !important;
}

.text-yellow.text-lighten-5 {
  color: #fffde7 !important;
}
.text-yellow.text-lighten-5.icon-outline {
  border-color: #fffde7 !important;
}

.bg-yellow.lighten-4 {
  background-color: #fff9c4 !important;
}

.text-yellow.text-lighten-4 {
  color: #fff9c4 !important;
}
.text-yellow.text-lighten-4.icon-outline {
  border-color: #fff9c4 !important;
}

.bg-yellow.lighten-3 {
  background-color: #fff59d !important;
}

.text-yellow.text-lighten-3 {
  color: #fff59d !important;
}
.text-yellow.text-lighten-3.icon-outline {
  border-color: #fff59d !important;
}

.bg-yellow.lighten-2 {
  background-color: #fff176 !important;
}

.text-yellow.text-lighten-2 {
  color: #fff176 !important;
}
.text-yellow.text-lighten-2.icon-outline {
  border-color: #fff176 !important;
}

.bg-yellow.lighten-1 {
  background-color: #ffee58 !important;
}

.text-yellow.text-lighten-1 {
  color: #ffee58 !important;
}
.text-yellow.text-lighten-1.icon-outline {
  border-color: #ffee58 !important;
}

.bg-yellow.darken-1 {
  background-color: #fdd835 !important;
}

.text-yellow.text-darken-1 {
  color: #fdd835 !important;
}
.text-yellow.text-darken-1.icon-outline {
  border-color: #fdd835 !important;
}

.bg-yellow.darken-2 {
  background-color: #fbc02d !important;
}

.text-yellow.text-darken-2 {
  color: #fbc02d !important;
}
.text-yellow.text-darken-2.icon-outline {
  border-color: #fbc02d !important;
}

.bg-yellow.darken-3 {
  background-color: #f9a825 !important;
}

.text-yellow.text-darken-3 {
  color: #f9a825 !important;
}
.text-yellow.text-darken-3.icon-outline {
  border-color: #f9a825 !important;
}

.bg-yellow.darken-4 {
  background-color: #f57f17 !important;
}

.text-yellow.text-darken-4 {
  color: #f57f17 !important;
}
.text-yellow.text-darken-4.icon-outline {
  border-color: #f57f17 !important;
}

.bg-yellow.accent-1 {
  background-color: #ffff8d !important;
}

.text-yellow.text-accent-1 {
  color: #ffff8d !important;
}
.text-yellow.text-accent-1.icon-outline {
  border-color: #ffff8d !important;
}

.bg-yellow.accent-2 {
  background-color: #ffff00 !important;
}

.text-yellow.text-accent-2 {
  color: #ffff00 !important;
}
.text-yellow.text-accent-2.icon-outline {
  border-color: #ffff00 !important;
}

.bg-yellow.accent-3 {
  background-color: #ffea00 !important;
}

.text-yellow.text-accent-3 {
  color: #ffea00 !important;
}
.text-yellow.text-accent-3.icon-outline {
  border-color: #ffea00 !important;
}

.bg-yellow.accent-4 {
  background-color: #ffd600 !important;
}

.text-yellow.text-accent-4 {
  color: #ffd600 !important;
}
.text-yellow.text-accent-4.icon-outline {
  border-color: #ffd600 !important;
}

.bg-amber {
  background-color: #ffc107 !important;
}

.text-amber {
  color: #ffc107 !important;
}
.text-amber.icon-outline {
  border-color: #ffc107 !important;
}

.bg-amber.lighten-5 {
  background-color: #fff8e1 !important;
}

.text-amber.text-lighten-5 {
  color: #fff8e1 !important;
}
.text-amber.text-lighten-5.icon-outline {
  border-color: #fff8e1 !important;
}

.bg-amber.lighten-4 {
  background-color: #ffecb3 !important;
}

.text-amber.text-lighten-4 {
  color: #ffecb3 !important;
}
.text-amber.text-lighten-4.icon-outline {
  border-color: #ffecb3 !important;
}

.bg-amber.lighten-3 {
  background-color: #ffe082 !important;
}

.text-amber.text-lighten-3 {
  color: #ffe082 !important;
}
.text-amber.text-lighten-3.icon-outline {
  border-color: #ffe082 !important;
}

.bg-amber.lighten-2 {
  background-color: #ffd54f !important;
}

.text-amber.text-lighten-2 {
  color: #ffd54f !important;
}
.text-amber.text-lighten-2.icon-outline {
  border-color: #ffd54f !important;
}

.bg-amber.lighten-1 {
  background-color: #ffca28 !important;
}

.text-amber.text-lighten-1 {
  color: #ffca28 !important;
}
.text-amber.text-lighten-1.icon-outline {
  border-color: #ffca28 !important;
}

.bg-amber.darken-1 {
  background-color: #ffb300 !important;
}

.text-amber.text-darken-1 {
  color: #ffb300 !important;
}
.text-amber.text-darken-1.icon-outline {
  border-color: #ffb300 !important;
}

.bg-amber.darken-2 {
  background-color: #ffa000 !important;
}

.text-amber.text-darken-2 {
  color: #ffa000 !important;
}
.text-amber.text-darken-2.icon-outline {
  border-color: #ffa000 !important;
}

.bg-amber.darken-3 {
  background-color: #ff8f00 !important;
}

.text-amber.text-darken-3 {
  color: #ff8f00 !important;
}
.text-amber.text-darken-3.icon-outline {
  border-color: #ff8f00 !important;
}

.bg-amber.darken-4 {
  background-color: #ff6f00 !important;
}

.text-amber.text-darken-4 {
  color: #ff6f00 !important;
}
.text-amber.text-darken-4.icon-outline {
  border-color: #ff6f00 !important;
}

.bg-amber.accent-1 {
  background-color: #ffe57f !important;
}

.text-amber.text-accent-1 {
  color: #ffe57f !important;
}
.text-amber.text-accent-1.icon-outline {
  border-color: #ffe57f !important;
}

.bg-amber.accent-2 {
  background-color: #ffd740 !important;
}

.text-amber.text-accent-2 {
  color: #ffd740 !important;
}
.text-amber.text-accent-2.icon-outline {
  border-color: #ffd740 !important;
}

.bg-amber.accent-3 {
  background-color: #ffc400 !important;
}

.text-amber.text-accent-3 {
  color: #ffc400 !important;
}
.text-amber.text-accent-3.icon-outline {
  border-color: #ffc400 !important;
}

.bg-amber.accent-4 {
  background-color: #ffab00 !important;
}

.text-amber.text-accent-4 {
  color: #ffab00 !important;
}
.text-amber.text-accent-4.icon-outline {
  border-color: #ffab00 !important;
}

.bg-orange {
  background-color: #ff9800 !important;
}

.text-orange {
  color: #ff9800 !important;
}
.text-orange.icon-outline {
  border-color: #ff9800 !important;
}

.bg-orange.lighten-5 {
  background-color: #fff3e0 !important;
}

.text-orange.text-lighten-5 {
  color: #fff3e0 !important;
}
.text-orange.text-lighten-5.icon-outline {
  border-color: #fff3e0 !important;
}

.bg-orange.lighten-4 {
  background-color: #ffe0b2 !important;
}

.text-orange.text-lighten-4 {
  color: #ffe0b2 !important;
}
.text-orange.text-lighten-4.icon-outline {
  border-color: #ffe0b2 !important;
}

.bg-orange.lighten-3 {
  background-color: #ffcc80 !important;
}

.text-orange.text-lighten-3 {
  color: #ffcc80 !important;
}
.text-orange.text-lighten-3.icon-outline {
  border-color: #ffcc80 !important;
}

.bg-orange.lighten-2 {
  background-color: #ffb74d !important;
}

.text-orange.text-lighten-2 {
  color: #ffb74d !important;
}
.text-orange.text-lighten-2.icon-outline {
  border-color: #ffb74d !important;
}

.bg-orange.lighten-1 {
  background-color: #ffa726 !important;
}

.text-orange.text-lighten-1 {
  color: #ffa726 !important;
}
.text-orange.text-lighten-1.icon-outline {
  border-color: #ffa726 !important;
}

.bg-orange.darken-1 {
  background-color: #fb8c00 !important;
}

.text-orange.text-darken-1 {
  color: #fb8c00 !important;
}
.text-orange.text-darken-1.icon-outline {
  border-color: #fb8c00 !important;
}

.bg-orange.darken-2 {
  background-color: #f57c00 !important;
}

.text-orange.text-darken-2 {
  color: #f57c00 !important;
}
.text-orange.text-darken-2.icon-outline {
  border-color: #f57c00 !important;
}

.bg-orange.darken-3 {
  background-color: #ef6c00 !important;
}

.text-orange.text-darken-3 {
  color: #ef6c00 !important;
}
.text-orange.text-darken-3.icon-outline {
  border-color: #ef6c00 !important;
}

.bg-orange.darken-4 {
  background-color: #e65100 !important;
}

.text-orange.text-darken-4 {
  color: #e65100 !important;
}
.text-orange.text-darken-4.icon-outline {
  border-color: #e65100 !important;
}

.bg-orange.accent-1 {
  background-color: #ffd180 !important;
}

.text-orange.text-accent-1 {
  color: #ffd180 !important;
}
.text-orange.text-accent-1.icon-outline {
  border-color: #ffd180 !important;
}

.bg-orange.accent-2 {
  background-color: #ffab40 !important;
}

.text-orange.text-accent-2 {
  color: #ffab40 !important;
}
.text-orange.text-accent-2.icon-outline {
  border-color: #ffab40 !important;
}

.bg-orange.accent-3 {
  background-color: #ff9100 !important;
}

.text-orange.text-accent-3 {
  color: #ff9100 !important;
}
.text-orange.text-accent-3.icon-outline {
  border-color: #ff9100 !important;
}

.bg-orange.accent-4 {
  background-color: #ff6d00 !important;
}

.text-orange.text-accent-4 {
  color: #ff6d00 !important;
}
.text-orange.text-accent-4.icon-outline {
  border-color: #ff6d00 !important;
}

.bg-deep-orange {
  background-color: #ff5722 !important;
}

.text-deep-orange {
  color: #ff5722 !important;
}
.text-deep-orange.icon-outline {
  border-color: #ff5722 !important;
}

.bg-deep-orange.lighten-5 {
  background-color: #fbe9e7 !important;
}

.text-deep-orange.text-lighten-5 {
  color: #fbe9e7 !important;
}
.text-deep-orange.text-lighten-5.icon-outline {
  border-color: #fbe9e7 !important;
}

.bg-deep-orange.lighten-4 {
  background-color: #ffccbc !important;
}

.text-deep-orange.text-lighten-4 {
  color: #ffccbc !important;
}
.text-deep-orange.text-lighten-4.icon-outline {
  border-color: #ffccbc !important;
}

.bg-deep-orange.lighten-3 {
  background-color: #ffab91 !important;
}

.text-deep-orange.text-lighten-3 {
  color: #ffab91 !important;
}
.text-deep-orange.text-lighten-3.icon-outline {
  border-color: #ffab91 !important;
}

.bg-deep-orange.lighten-2 {
  background-color: #ff8a65 !important;
}

.text-deep-orange.text-lighten-2 {
  color: #ff8a65 !important;
}
.text-deep-orange.text-lighten-2.icon-outline {
  border-color: #ff8a65 !important;
}

.bg-deep-orange.lighten-1 {
  background-color: #ff7043 !important;
}

.text-deep-orange.text-lighten-1 {
  color: #ff7043 !important;
}
.text-deep-orange.text-lighten-1.icon-outline {
  border-color: #ff7043 !important;
}

.bg-deep-orange.darken-1 {
  background-color: #f4511e !important;
}

.text-deep-orange.text-darken-1 {
  color: #f4511e !important;
}
.text-deep-orange.text-darken-1.icon-outline {
  border-color: #f4511e !important;
}

.bg-deep-orange.darken-2 {
  background-color: #e64a19 !important;
}

.text-deep-orange.text-darken-2 {
  color: #e64a19 !important;
}
.text-deep-orange.text-darken-2.icon-outline {
  border-color: #e64a19 !important;
}

.bg-deep-orange.darken-3 {
  background-color: #d84315 !important;
}

.text-deep-orange.text-darken-3 {
  color: #d84315 !important;
}
.text-deep-orange.text-darken-3.icon-outline {
  border-color: #d84315 !important;
}

.bg-deep-orange.darken-4 {
  background-color: #bf360c !important;
}

.text-deep-orange.text-darken-4 {
  color: #bf360c !important;
}
.text-deep-orange.text-darken-4.icon-outline {
  border-color: #bf360c !important;
}

.bg-deep-orange.accent-1 {
  background-color: #ff9e80 !important;
}

.text-deep-orange.text-accent-1 {
  color: #ff9e80 !important;
}
.text-deep-orange.text-accent-1.icon-outline {
  border-color: #ff9e80 !important;
}

.bg-deep-orange.accent-2 {
  background-color: #ff6e40 !important;
}

.text-deep-orange.text-accent-2 {
  color: #ff6e40 !important;
}
.text-deep-orange.text-accent-2.icon-outline {
  border-color: #ff6e40 !important;
}

.bg-deep-orange.accent-3 {
  background-color: #ff3d00 !important;
}

.text-deep-orange.text-accent-3 {
  color: #ff3d00 !important;
}
.text-deep-orange.text-accent-3.icon-outline {
  border-color: #ff3d00 !important;
}

.bg-deep-orange.accent-4 {
  background-color: #dd2c00 !important;
}

.text-deep-orange.text-accent-4 {
  color: #dd2c00 !important;
}
.text-deep-orange.text-accent-4.icon-outline {
  border-color: #dd2c00 !important;
}

.bg-brown {
  background-color: #795548 !important;
}

.text-brown {
  color: #795548 !important;
}
.text-brown.icon-outline {
  border-color: #795548 !important;
}

.bg-brown.lighten-5 {
  background-color: #efebe9 !important;
}

.text-brown.text-lighten-5 {
  color: #efebe9 !important;
}
.text-brown.text-lighten-5.icon-outline {
  border-color: #efebe9 !important;
}

.bg-brown.lighten-4 {
  background-color: #d7ccc8 !important;
}

.text-brown.text-lighten-4 {
  color: #d7ccc8 !important;
}
.text-brown.text-lighten-4.icon-outline {
  border-color: #d7ccc8 !important;
}

.bg-brown.lighten-3 {
  background-color: #bcaaa4 !important;
}

.text-brown.text-lighten-3 {
  color: #bcaaa4 !important;
}
.text-brown.text-lighten-3.icon-outline {
  border-color: #bcaaa4 !important;
}

.bg-brown.lighten-2 {
  background-color: #a1887f !important;
}

.text-brown.text-lighten-2 {
  color: #a1887f !important;
}
.text-brown.text-lighten-2.icon-outline {
  border-color: #a1887f !important;
}

.bg-brown.lighten-1 {
  background-color: #8d6e63 !important;
}

.text-brown.text-lighten-1 {
  color: #8d6e63 !important;
}
.text-brown.text-lighten-1.icon-outline {
  border-color: #8d6e63 !important;
}

.bg-brown.darken-1 {
  background-color: #6d4c41 !important;
}

.text-brown.text-darken-1 {
  color: #6d4c41 !important;
}
.text-brown.text-darken-1.icon-outline {
  border-color: #6d4c41 !important;
}

.bg-brown.darken-2 {
  background-color: #5d4037 !important;
}

.text-brown.text-darken-2 {
  color: #5d4037 !important;
}
.text-brown.text-darken-2.icon-outline {
  border-color: #5d4037 !important;
}

.bg-brown.darken-3 {
  background-color: #4e342e !important;
}

.text-brown.text-darken-3 {
  color: #4e342e !important;
}
.text-brown.text-darken-3.icon-outline {
  border-color: #4e342e !important;
}

.bg-brown.darken-4 {
  background-color: #3e2723 !important;
}

.text-brown.text-darken-4 {
  color: #3e2723 !important;
}
.text-brown.text-darken-4.icon-outline {
  border-color: #3e2723 !important;
}

.bg-blue-grey {
  background-color: #607d8b !important;
}

.text-blue-grey {
  color: #607d8b !important;
}
.text-blue-grey.icon-outline {
  border-color: #607d8b !important;
}

.bg-blue-grey.lighten-5 {
  background-color: #eceff1 !important;
}

.text-blue-grey.text-lighten-5 {
  color: #eceff1 !important;
}
.text-blue-grey.text-lighten-5.icon-outline {
  border-color: #eceff1 !important;
}

.bg-blue-grey.lighten-4 {
  background-color: #cfd8dc !important;
}

.text-blue-grey.text-lighten-4 {
  color: #cfd8dc !important;
}
.text-blue-grey.text-lighten-4.icon-outline {
  border-color: #cfd8dc !important;
}

.bg-blue-grey.lighten-3 {
  background-color: #b0bec5 !important;
}

.text-blue-grey.text-lighten-3 {
  color: #b0bec5 !important;
}
.text-blue-grey.text-lighten-3.icon-outline {
  border-color: #b0bec5 !important;
}

.bg-blue-grey.lighten-2 {
  background-color: #90a4ae !important;
}

.text-blue-grey.text-lighten-2 {
  color: #90a4ae !important;
}
.text-blue-grey.text-lighten-2.icon-outline {
  border-color: #90a4ae !important;
}

.bg-blue-grey.lighten-1 {
  background-color: #78909c !important;
}

.text-blue-grey.text-lighten-1 {
  color: #78909c !important;
}
.text-blue-grey.text-lighten-1.icon-outline {
  border-color: #78909c !important;
}

.bg-blue-grey.darken-1 {
  background-color: #546e7a !important;
}

.text-blue-grey.text-darken-1 {
  color: #546e7a !important;
}
.text-blue-grey.text-darken-1.icon-outline {
  border-color: #546e7a !important;
}

.bg-blue-grey.darken-2 {
  background-color: #455a64 !important;
}

.text-blue-grey.text-darken-2 {
  color: #455a64 !important;
}
.text-blue-grey.text-darken-2.icon-outline {
  border-color: #455a64 !important;
}

.bg-blue-grey.darken-3 {
  background-color: #37474f !important;
}

.text-blue-grey.text-darken-3 {
  color: #37474f !important;
}
.text-blue-grey.text-darken-3.icon-outline {
  border-color: #37474f !important;
}

.bg-blue-grey.darken-4 {
  background-color: #263238 !important;
}

.text-blue-grey.text-darken-4 {
  color: #263238 !important;
}
.text-blue-grey.text-darken-4.icon-outline {
  border-color: #263238 !important;
}

.bg-grey {
  background-color: #9e9e9e !important;
}

.text-grey {
  color: #9e9e9e !important;
}
.text-grey.icon-outline {
  border-color: #9e9e9e !important;
}

.bg-grey.lighten-5 {
  background-color: #fafafa !important;
}

.text-grey.text-lighten-5 {
  color: #fafafa !important;
}
.text-grey.text-lighten-5.icon-outline {
  border-color: #fafafa !important;
}

.bg-grey.lighten-4 {
  background-color: #f5f5f5 !important;
}

.text-grey.text-lighten-4 {
  color: #f5f5f5 !important;
}
.text-grey.text-lighten-4.icon-outline {
  border-color: #f5f5f5 !important;
}

.bg-grey.lighten-3 {
  background-color: #eeeeee !important;
}

.text-grey.text-lighten-3 {
  color: #eeeeee !important;
}
.text-grey.text-lighten-3.icon-outline {
  border-color: #eeeeee !important;
}

.bg-grey.lighten-2 {
  background-color: #e0e0e0 !important;
}

.text-grey.text-lighten-2 {
  color: #e0e0e0 !important;
}
.text-grey.text-lighten-2.icon-outline {
  border-color: #e0e0e0 !important;
}

.bg-grey.lighten-1 {
  background-color: #bdbdbd !important;
}

.text-grey.text-lighten-1 {
  color: #bdbdbd !important;
}
.text-grey.text-lighten-1.icon-outline {
  border-color: #bdbdbd !important;
}

.bg-grey.darken-1 {
  background-color: #757575 !important;
}

.text-grey.text-darken-1 {
  color: #757575 !important;
}
.text-grey.text-darken-1.icon-outline {
  border-color: #757575 !important;
}

.bg-grey.darken-2 {
  background-color: #616161 !important;
}

.text-grey.text-darken-2 {
  color: #616161 !important;
}
.text-grey.text-darken-2.icon-outline {
  border-color: #616161 !important;
}

.bg-grey.darken-3 {
  background-color: #424242 !important;
}

.text-grey.text-darken-3 {
  color: #424242 !important;
}
.text-grey.text-darken-3.icon-outline {
  border-color: #424242 !important;
}

.bg-grey.darken-4 {
  background-color: #212121 !important;
}

.text-grey.text-darken-4 {
  color: #212121 !important;
}
.text-grey.text-darken-4.icon-outline {
  border-color: #212121 !important;
}

.bg-celia.gray {
  background-color: #f2f3f5 !important;
}

.text-celia.text-gray {
  color: #f2f3f5 !important;
}
.text-celia.text-gray.icon-outline {
  border-color: #f2f3f5 !important;
}

.bg-celia.white {
  background-color: #FFFFFF !important;
}

.text-celia.text-white {
  color: #FFFFFF !important;
}
.text-celia.text-white.icon-outline {
  border-color: #FFFFFF !important;
}

.bg-celia.online-green {
  background-color: #5FB98F !important;
}

.text-celia.text-online-green {
  color: #5FB98F !important;
}
.text-celia.text-online-green.icon-outline {
  border-color: #5FB98F !important;
}

.bg-celia.orange {
  background-color: rgb(255, 137, 93) !important;
}

.text-celia.text-orange {
  color: rgb(255, 137, 93) !important;
}
.text-celia.text-orange.icon-outline {
  border-color: rgb(255, 137, 93) !important;
}

.bg-celia.orange-25 {
  background-color: rgba(255, 137, 93, 0.25) !important;
}

.text-celia.text-orange-25 {
  color: rgba(255, 137, 93, 0.25) !important;
}
.text-celia.text-orange-25.icon-outline {
  border-color: rgba(255, 137, 93, 0.25) !important;
}

.bg-celia.orange-50 {
  background-color: rgba(255, 137, 93, 0.5) !important;
}

.text-celia.text-orange-50 {
  color: rgba(255, 137, 93, 0.5) !important;
}
.text-celia.text-orange-50.icon-outline {
  border-color: rgba(255, 137, 93, 0.5) !important;
}

.bg-celia.orange-80 {
  background-color: rgba(255, 137, 93, 0.8) !important;
}

.text-celia.text-orange-80 {
  color: rgba(255, 137, 93, 0.8) !important;
}
.text-celia.text-orange-80.icon-outline {
  border-color: rgba(255, 137, 93, 0.8) !important;
}

.bg-celia.gray-blue {
  background-color: rgb(70, 120, 170) !important;
}

.text-celia.text-gray-blue {
  color: rgb(70, 120, 170) !important;
}
.text-celia.text-gray-blue.icon-outline {
  border-color: rgb(70, 120, 170) !important;
}

.bg-celia.gray-blue-5 {
  background-color: #EAEDF2 !important;
}

.text-celia.text-gray-blue-5 {
  color: #EAEDF2 !important;
}
.text-celia.text-gray-blue-5.icon-outline {
  border-color: #EAEDF2 !important;
}

.bg-celia.gray-blue-10 {
  background-color: rgba(70, 120, 170, 0.1) !important;
}

.text-celia.text-gray-blue-10 {
  color: rgba(70, 120, 170, 0.1) !important;
}
.text-celia.text-gray-blue-10.icon-outline {
  border-color: rgba(70, 120, 170, 0.1) !important;
}

.bg-celia.gray-blue-20 {
  background-color: #DAE4EE !important;
}

.text-celia.text-gray-blue-20 {
  color: #DAE4EE !important;
}
.text-celia.text-gray-blue-20.icon-outline {
  border-color: #DAE4EE !important;
}

.bg-celia.gray-blue-25 {
  background-color: rgba(70, 120, 170, 0.25) !important;
}

.text-celia.text-gray-blue-25 {
  color: rgba(70, 120, 170, 0.25) !important;
}
.text-celia.text-gray-blue-25.icon-outline {
  border-color: rgba(70, 120, 170, 0.25) !important;
}

.bg-celia.gray-blue-35 {
  background-color: rgba(70, 120, 170, 0.35) !important;
}

.text-celia.text-gray-blue-35 {
  color: rgba(70, 120, 170, 0.35) !important;
}
.text-celia.text-gray-blue-35.icon-outline {
  border-color: rgba(70, 120, 170, 0.35) !important;
}

.bg-celia.gray-blue-40 {
  background-color: rgba(70, 120, 170, 0.4) !important;
}

.text-celia.text-gray-blue-40 {
  color: rgba(70, 120, 170, 0.4) !important;
}
.text-celia.text-gray-blue-40.icon-outline {
  border-color: rgba(70, 120, 170, 0.4) !important;
}

.bg-celia.gray-blue-50 {
  background-color: rgba(70, 120, 170, 0.5) !important;
}

.text-celia.text-gray-blue-50 {
  color: rgba(70, 120, 170, 0.5) !important;
}
.text-celia.text-gray-blue-50.icon-outline {
  border-color: rgba(70, 120, 170, 0.5) !important;
}

.bg-celia.sharp-border {
  background-color: #A3ADC5 !important;
}

.text-celia.text-sharp-border {
  color: #A3ADC5 !important;
}
.text-celia.text-sharp-border.icon-outline {
  border-color: #A3ADC5 !important;
}

.bg-celia.black-text {
  background-color: #222222 !important;
}

.text-celia.text-black-text {
  color: #222222 !important;
}
.text-celia.text-black-text.icon-outline {
  border-color: #222222 !important;
}

.bg-celia.dark-text {
  background-color: rgb(27, 37, 95) !important;
}

.text-celia.text-dark-text {
  color: rgb(27, 37, 95) !important;
}
.text-celia.text-dark-text.icon-outline {
  border-color: rgb(27, 37, 95) !important;
}

.bg-celia.dark-text-80 {
  background-color: rgba(27, 37, 95, 0.8) !important;
}

.text-celia.text-dark-text-80 {
  color: rgba(27, 37, 95, 0.8) !important;
}
.text-celia.text-dark-text-80.icon-outline {
  border-color: rgba(27, 37, 95, 0.8) !important;
}

.bg-celia.dark-text-30 {
  background-color: rgba(27, 37, 95, 0.3) !important;
}

.text-celia.text-dark-text-30 {
  color: rgba(27, 37, 95, 0.3) !important;
}
.text-celia.text-dark-text-30.icon-outline {
  border-color: rgba(27, 37, 95, 0.3) !important;
}

.bg-celia.black-transparent-5 {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.text-celia.text-black-transparent-5 {
  color: rgba(0, 0, 0, 0.05) !important;
}
.text-celia.text-black-transparent-5.icon-outline {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-celia.black-transparent-10 {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.text-celia.text-black-transparent-10 {
  color: rgba(0, 0, 0, 0.1) !important;
}
.text-celia.text-black-transparent-10.icon-outline {
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.bg-celia.black-transparent-17 {
  background-color: rgba(0, 0, 0, 0.17) !important;
}

.text-celia.text-black-transparent-17 {
  color: rgba(0, 0, 0, 0.17) !important;
}
.text-celia.text-black-transparent-17.icon-outline {
  border-color: rgba(0, 0, 0, 0.17) !important;
}

.bg-celia.gray-light {
  background-color: #BEC7D5 !important;
}

.text-celia.text-gray-light {
  color: #BEC7D5 !important;
}
.text-celia.text-gray-light.icon-outline {
  border-color: #BEC7D5 !important;
}

.bg-celia.gray-light-a {
  background-color: rgba(74, 98, 136, 0.2) !important;
}

.text-celia.text-gray-light-a {
  color: rgba(74, 98, 136, 0.2) !important;
}
.text-celia.text-gray-light-a.icon-outline {
  border-color: rgba(74, 98, 136, 0.2) !important;
}

.bg-black {
  background-color: #000000 !important;
}

.text-black {
  color: #000000 !important;
}
.text-black.icon-outline {
  border-color: #000000 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.text-white {
  color: #FFFFFF !important;
}
.text-white.icon-outline {
  border-color: #FFFFFF !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.text-transparent {
  color: transparent !important;
}
.text-transparent.icon-outline {
  border-color: transparent !important;
}

/*Custom Animation*/
@keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);
  }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: perspective(100000px);
  }
}
@-webkit-keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);
  }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: perspective(100000px);
  }
}
.flipCenter {
  animation-name: flipCenter;
  backface-visibility: visible;
}

@keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0;
  }
}
@-webkit-keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0;
  }
}
.desployDown {
  animation-name: desployDown;
  backface-visibility: visible;
}

@keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@-webkit-keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.fadeInRightTiny {
  animation-name: fadeInRightTiny;
}

@keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@-webkit-keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.fadeInLeftTiny {
  animation-name: fadeInLeftTiny;
}

@keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInRightTiny {
  animation-name: slideInRightTiny;
}

@keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInLeftTiny {
  animation-name: slideInLeftTiny;
}

@keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInUpTiny {
  animation-name: slideInUpTiny;
}

/*Animation Durations*/
.animation-duration-1 {
  animation-duration: 0.1s;
}

.animation-duration-2 {
  animation-duration: 0.2s;
}

.animation-duration-3 {
  animation-duration: 0.3s;
}

.animation-duration-4 {
  animation-duration: 0.4s;
}

.animation-duration-5 {
  animation-duration: 0.5s;
}

.animation-duration-6 {
  animation-duration: 0.6s;
}

.animation-duration-7 {
  animation-duration: 0.7s;
}

.animation-duration-8 {
  animation-duration: 0.8s;
}

.animation-duration-9 {
  animation-duration: 0.9s;
}

.animation-duration-10 {
  animation-duration: 1s;
}

.animation-duration-11 {
  animation-duration: 1.1s;
}

.animation-duration-12 {
  animation-duration: 1.2s;
}

.animation-duration-13 {
  animation-duration: 1.3s;
}

.animation-duration-14 {
  animation-duration: 1.4s;
}

.animation-duration-15 {
  animation-duration: 1.5s;
}

.animation-duration-16 {
  animation-duration: 1.6s;
}

.animation-duration-17 {
  animation-duration: 1.7s;
}

.animation-duration-18 {
  animation-duration: 1.8s;
}

.animation-duration-19 {
  animation-duration: 1.9s;
}

.animation-duration-20 {
  animation-duration: 2s;
}

.animation-duration-21 {
  animation-duration: 2.1s;
}

.animation-duration-22 {
  animation-duration: 2.2s;
}

.animation-duration-23 {
  animation-duration: 2.3s;
}

.animation-duration-24 {
  animation-duration: 2.4s;
}

.animation-duration-25 {
  animation-duration: 2.5s;
}

.animation-duration-26 {
  animation-duration: 2.6s;
}

.animation-duration-27 {
  animation-duration: 2.7s;
}

.animation-duration-28 {
  animation-duration: 2.8s;
}

.animation-duration-29 {
  animation-duration: 2.9s;
}

.animation-duration-30 {
  animation-duration: 3s;
}

.animation-duration-31 {
  animation-duration: 3.1s;
}

.animation-duration-32 {
  animation-duration: 3.2s;
}

.animation-duration-33 {
  animation-duration: 3.3s;
}

.animation-duration-34 {
  animation-duration: 3.4s;
}

.animation-duration-35 {
  animation-duration: 3.5s;
}

.animation-duration-36 {
  animation-duration: 3.6s;
}

.animation-duration-37 {
  animation-duration: 3.7s;
}

.animation-duration-38 {
  animation-duration: 3.8s;
}

.animation-duration-39 {
  animation-duration: 3.9s;
}

.animation-duration-40 {
  animation-duration: 4s;
}

.animation-delay-1 {
  animation-delay: 0.1s;
}

.animation-delay-2 {
  animation-delay: 0.2s;
}

.animation-delay-3 {
  animation-delay: 0.3s;
}

.animation-delay-4 {
  animation-delay: 0.4s;
}

.animation-delay-5 {
  animation-delay: 0.5s;
}

.animation-delay-6 {
  animation-delay: 0.6s;
}

.animation-delay-7 {
  animation-delay: 0.7s;
}

.animation-delay-8 {
  animation-delay: 0.8s;
}

.animation-delay-9 {
  animation-delay: 0.9s;
}

.animation-delay-10 {
  animation-delay: 1s;
}

.animation-delay-11 {
  animation-delay: 1.1s;
}

.animation-delay-12 {
  animation-delay: 1.2s;
}

.animation-delay-13 {
  animation-delay: 1.3s;
}

.animation-delay-14 {
  animation-delay: 1.4s;
}

.animation-delay-15 {
  animation-delay: 1.5s;
}

.animation-delay-16 {
  animation-delay: 1.6s;
}

.animation-delay-17 {
  animation-delay: 1.7s;
}

.animation-delay-18 {
  animation-delay: 1.8s;
}

.animation-delay-19 {
  animation-delay: 1.9s;
}

.animation-delay-20 {
  animation-delay: 2s;
}

.animation-delay-21 {
  animation-delay: 2.1s;
}

.animation-delay-22 {
  animation-delay: 2.2s;
}

.animation-delay-23 {
  animation-delay: 2.3s;
}

.animation-delay-24 {
  animation-delay: 2.4s;
}

.animation-delay-25 {
  animation-delay: 2.5s;
}

.animation-delay-26 {
  animation-delay: 2.6s;
}

.animation-delay-27 {
  animation-delay: 2.6s;
}

.animation-delay-28 {
  animation-delay: 2.8s;
}

.animation-delay-29 {
  animation-delay: 2.9s;
}

.animation-delay-30 {
  animation-delay: 3s;
}

.animation-delay-31 {
  animation-delay: 3.1s;
}

.animation-delay-32 {
  animation-delay: 3.2s;
}

.animation-delay-33 {
  animation-delay: 3.3s;
}

.animation-delay-34 {
  animation-delay: 3.4s;
}

.animation-delay-35 {
  animation-delay: 3.5s;
}

.animation-delay-36 {
  animation-delay: 3.6s;
}

.animation-delay-37 {
  animation-delay: 3.7s;
}

.animation-delay-38 {
  animation-delay: 3.8s;
}

.animation-delay-39 {
  animation-delay: 3.9s;
}

.animation-delay-40 {
  animation-delay: 4s;
}

.animation-delay-41 {
  animation-delay: 4.1s;
}

.animation-delay-42 {
  animation-delay: 4.2s;
}

.animation-delay-43 {
  animation-delay: 4.3s;
}

.animation-delay-44 {
  animation-delay: 4.4s;
}

.animation-delay-45 {
  animation-delay: 4.5s;
}

.animation-delay-46 {
  animation-delay: 4.6s;
}

.animation-delay-47 {
  animation-delay: 4.7s;
}

.animation-delay-48 {
  animation-delay: 4.8s;
}

.animation-delay-49 {
  animation-delay: 4.9s;
}

.animation-delay-50 {
  animation-delay: 5s;
}

/* #endregion */
:root {
  --app-header-height: 80px;
  --jdv-row-offset: 30px;
  --jdv-toggler-header-gap: 8px;
  --jdv-row-min-height: 48px;
  --jdv-row-base-inline-padding: var(--page-panel-inline-padding);
  --jdv-border-style: solid;
  --jdv-border-top-width: 1px;
  --jdv-border-top-color: config("color.gray.200");
  --jdv-base-item-start-padding: 20px;
  --jdv-base-parent-item-start-padding: 8px;
  --ck-border-radius: 8px !important;
}

/* #endregion */
.display-112-regular {
  font: normal 400 112px/116px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-112-medium {
  font: normal 500 112px/116px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-112-semibold {
  font: normal 600 112px/116px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-112-bold {
  font: normal 700 112px/116px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-80-regular {
  font: normal 400 80px/84px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-80-medium {
  font: normal 500 80px/84px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-80-semibold {
  font: normal 600 80px/84px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-80-bold {
  font: normal 700 80px/84px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-60-regular {
  font: normal 400 60px/68px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-60-medium {
  font: normal 500 60px/68px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-60-semibold {
  font: normal 600 60px/68px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.display-60-bold {
  font: normal 700 60px/68px Open Sans, sans-serif;
  letter-spacing: -0.02em;
}

.headline-48-regular {
  font: normal 400 48px/56px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-48-medium {
  font: normal 500 48px/56px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-48-semibold {
  font: normal 600 48px/56px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-48-bold {
  font: normal 700 48px/56px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-36-regular {
  font: normal 400 36px/44px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-36-medium {
  font: normal 500 36px/44px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-36-semibold {
  font: normal 600 36px/44px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-36-bold {
  font: normal 700 36px/44px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-28-regular {
  font: normal 400 28px/36px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-28-medium {
  font: normal 500 28px/36px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-28-semibold {
  font: normal 600 28px/36px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-28-bold {
  font: normal 700 28px/36px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-24-regular {
  font: normal 400 24px/32px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-24-medium {
  font: normal 500 24px/32px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-24-semibold {
  font: normal 600 24px/32px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.headline-24-bold {
  font: normal 700 24px/32px Open Sans, sans-serif;
  letter-spacing: -0.01em;
}

.title-22-regular {
  font: normal 400 22px/28px Open Sans, sans-serif;
}

.title-22-medium {
  font: normal 500 22px/28px Open Sans, sans-serif;
}

.title-22-semibold {
  font: normal 600 22px/28px Open Sans, sans-serif;
}

.title-22-bold {
  font: normal 700 22px/28px Open Sans, sans-serif;
}

.title-16-regular {
  font: normal 400 16px/20px Open Sans, sans-serif;
  letter-spacing: -0.002em;
}

.title-16-medium {
  font: normal 500 16px/20px Open Sans, sans-serif;
  letter-spacing: -0.002em;
}

.title-16-semibold {
  font: normal 600 16px/20px Open Sans, sans-serif;
  letter-spacing: -0.002em;
}

.title-16-bold {
  font: normal 700 16px/20px Open Sans, sans-serif;
  letter-spacing: -0.002em;
}

.title-12-regular {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: -0.005em;
}

.title-12-medium {
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: -0.005em;
}

.title-12-semibold {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: -0.005em;
}

.title-12-bold {
  font: normal 700 12px/16px Open Sans, sans-serif;
  letter-spacing: -0.005em;
}

.body-20-regular {
  font: normal 400 20px/32px Open Sans, sans-serif;
}

.body-20-medium {
  font: normal 500 20px/32px Open Sans, sans-serif;
}

.body-20-semibold {
  font: normal 600 20px/32px Open Sans, sans-serif;
}

.body-20-bold {
  font: normal 700 20px/32px Open Sans, sans-serif;
}

.body-18-regular {
  font: normal 400 18px/28px Open Sans, sans-serif;
}

.body-18-medium {
  font: normal 500 18px/28px Open Sans, sans-serif;
}

.body-18-semibold {
  font: normal 600 18px/28px Open Sans, sans-serif;
}

.body-18-bold {
  font: normal 700 18px/28px Open Sans, sans-serif;
}

.body-16-regular {
  font: normal 400 16px/24px Open Sans, sans-serif;
}

.body-16-medium {
  font: normal 500 16px/24px Open Sans, sans-serif;
}

.body-16-semibold {
  font: normal 600 16px/24px Open Sans, sans-serif;
}

.body-16-bold {
  font: normal 700 16px/24px Open Sans, sans-serif;
}

.body-14-regular {
  font: normal 400 14px/20px Open Sans, sans-serif;
}

.body-14-medium {
  font: normal 500 14px/20px Open Sans, sans-serif;
}

.body-14-semibold {
  font: normal 600 14px/20px Open Sans, sans-serif;
}

.body-14-bold {
  font: normal 700 14px/20px Open Sans, sans-serif;
}

.body-12-regular {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.body-12-medium {
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.body-12-semibold {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.body-12-bold {
  font: normal 700 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-18-regular {
  font: normal 400 18px/28px Open Sans, sans-serif;
}

.label-18-medium {
  font: normal 500 18px/28px Open Sans, sans-serif;
}

.label-18-semibold {
  font: normal 600 18px/28px Open Sans, sans-serif;
}

.label-18-bold {
  font: normal 700 18px/28px Open Sans, sans-serif;
}

.label-16-regular {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}

.label-16-medium {
  font: normal 500 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}

.label-16-semibold {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}

.label-16-bold {
  font: normal 700 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}

.label-14-regular {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-14-medium {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-14-semibold {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-14-bold {
  font: normal 700 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-12-regular {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-12-medium {
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-12-semibold {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-12-bold {
  font: normal 700 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-10-regular {
  font: normal 400 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-10-medium {
  font: normal 500 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-10-semibold {
  font: normal 600 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

.label-10-bold {
  font: normal 700 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}

@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Figtree"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Figtree"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Figtree Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Figtree Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: local("Figtree SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: local("Figtree SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Figtree Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
  font-family: "Figtree";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Figtree Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/**************** Regular */
/* latin-ext */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/**************** Medium */
/* latin-ext */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/**************** SemiBold */
/* latin-ext */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/**************** Bold */
/* latin-ext */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
.text-link {
  color: var(--system-primary-color, #002b8f);
  border-bottom: solid 1px;
  font: normal 500 14px/20px Open Sans, sans-serif;
}

.code-text {
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace;
}

.system-input-container {
  --input-inline-padding: 16px;
  --input-inline-end-padding-select: calc(var(--input-inline-padding) - 4px);
  --field-border-width: 1px;
  --field-gap: 10px;
  --field-icon-square-size: 20px;
  --field-icon-size: 16px;
  --rbt-item-height: 42px;
  --textarea-block-padding: 0px;
  border-radius: var(--field-border-radius, 4px);
  border: solid var(--field-border-width) var(--field-border-color, hsl(216, 12%, 84%));
  min-height: var(--field-height, 40px);
  background-color: hsl(0, 50%, 100%);
  display: flex;
  align-items: center;
  gap: var(--field-gap);
}
.system-input-container :is(input, select, textarea, .rbt-input, .ant-input, .react-select__single-value, .react-select__placeholder) {
  color: hsl(0, 0%, 7%);
  background-color: transparent;
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  border: none;
  height: 100%;
  flex: auto;
  padding-inline: calc(var(--input-inline-padding) - var(--select-container-padding, 0px));
  padding-block: var(--textarea-block-padding, 0px);
  min-width: 50px;
}
.system-input-container :is(input, select, textarea, .rbt-input, .ant-input, .react-select__single-value, .react-select__placeholder)::placeholder {
  color: hsl(220, 9%, 46%);
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container :is(input, select, textarea, .rbt-input, .ant-input, .react-select__single-value, .react-select__placeholder):where(:focus, :focus-visible) {
  outline: none;
}
.system-input-container :is(input, select, textarea, .rbt-input, .ant-input, .react-select__single-value, .react-select__placeholder):disabled {
  background-color: hsl(225, 13%, 94%);
  border-radius: calc(var(--field-border-radius) - 1px);
}
.system-input-container input[type=color] {
  height: calc(var(--field-height, 40px) - var(--field-border-width) * 2);
  flex: 1;
  padding: 0 2px;
  width: 100%;
  cursor: pointer;
}
.system-input-container i.input-icon {
  font-size: var(--field-icon-size);
  padding: 2px;
  min-width: var(--field-icon-square-size);
  min-height: var(--field-icon-square-size);
  margin-inline-start: var(--input-inline-padding);
}
.system-input-container i.input-icon + input {
  margin-inline-start: calc(0px - var(--input-inline-padding) - var(--field-icon-square-size) - var(--field-gap));
  padding-inline-start: calc(var(--input-inline-padding) + var(--field-icon-square-size) + var(--field-gap));
}
.system-input-container.value-s {
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.value-s :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.value-s .rbt-menu .dropdown-item,
.system-input-container.value-s .react-select__option,
.system-input-container.value-s .react-select__single-value {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.value-s.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.value-s .rbt-highlight-text {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.value-m {
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.value-m :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.value-m .rbt-menu .dropdown-item,
.system-input-container.value-m .react-select__option,
.system-input-container.value-m .react-select__single-value {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.value-m.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.value-m .rbt-highlight-text {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.value-l {
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.value-l :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.value-l .rbt-menu .dropdown-item,
.system-input-container.value-l .react-select__option,
.system-input-container.value-l .react-select__single-value {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.value-l.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.value-l .rbt-highlight-text {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-s {
  --field-height: 36px;
  --rbt-item-height: 40px;
  --field-border-radius: 4px;
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.size-s :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-s {
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.size-s.value-s :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-s.value-s .rbt-menu .dropdown-item,
.system-input-container.size-s.value-s .react-select__option,
.system-input-container.size-s.value-s .react-select__single-value {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-s.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-s .rbt-highlight-text {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-m {
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.size-s.value-m :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-s.value-m .rbt-menu .dropdown-item,
.system-input-container.size-s.value-m .react-select__option,
.system-input-container.size-s.value-m .react-select__single-value {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-m.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-m .rbt-highlight-text {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-s.value-l {
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.size-s.value-l :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-s.value-l .rbt-menu .dropdown-item,
.system-input-container.size-s.value-l .react-select__option,
.system-input-container.size-s.value-l .react-select__single-value {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-s.value-l.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-s.value-l .rbt-highlight-text {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-m {
  --field-height: 40px;
  --rbt-item-height: 42px;
  --field-border-radius: 4px;
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.size-m :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-m .rbt-menu .dropdown-item,
.system-input-container.size-m .react-select__option,
.system-input-container.size-m .react-select__single-value {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m .rbt-highlight-text {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-s {
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.size-m.value-s :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-m.value-s .rbt-menu .dropdown-item,
.system-input-container.size-m.value-s .react-select__option,
.system-input-container.size-m.value-s .react-select__single-value {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-s.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-s .rbt-highlight-text {
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-m {
  --field-icon-size: 16px;
  --field-icon-square-size: 20px;
}
.system-input-container.size-m.value-m :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-m.value-m .rbt-menu .dropdown-item,
.system-input-container.size-m.value-m .react-select__option,
.system-input-container.size-m.value-m .react-select__single-value {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-m.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-m .rbt-highlight-text {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-m.value-l {
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.size-m.value-l :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-m.value-l .rbt-menu .dropdown-item,
.system-input-container.size-m.value-l .react-select__option,
.system-input-container.size-m.value-l .react-select__single-value {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-m.value-l.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-m.value-l .rbt-highlight-text {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l {
  --field-height: 48px;
  --rbt-item-height: 48px;
  --field-border-radius: 6px;
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.size-l :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-l .rbt-menu .dropdown-item,
.system-input-container.size-l .react-select__option,
.system-input-container.size-l .react-select__single-value {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l .rbt-highlight-text {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l.value-s {
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.size-l.value-s :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-l.value-s .rbt-menu .dropdown-item,
.system-input-container.size-l.value-s .react-select__option,
.system-input-container.size-l.value-s .react-select__single-value {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-l.value-s.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-l.value-s .rbt-highlight-text {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.size-l.value-m {
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.size-l.value-m :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-l.value-m .rbt-menu .dropdown-item,
.system-input-container.size-l.value-m .react-select__option,
.system-input-container.size-l.value-m .react-select__single-value {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l.value-m.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l.value-m .rbt-highlight-text {
  font: normal 600 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-input-container.size-l.value-l {
  --field-icon-size: 20px;
  --field-icon-square-size: 24px;
}
.system-input-container.size-l.value-l :is(input, select, textarea, .rbt-input, .ant-input),
.system-input-container.size-l.value-l .rbt-menu .dropdown-item,
.system-input-container.size-l.value-l .react-select__option,
.system-input-container.size-l.value-l .react-select__single-value {
  font: normal 400 18px/28px Open Sans, sans-serif;
}
.system-input-container.size-l.value-l.bolder :is(input, select, textarea, .rbt-input, .ant-input) {
  font: normal 600 18px/28px Open Sans, sans-serif;
}
.system-input-container.size-l.value-l .rbt-highlight-text {
  font: normal 600 18px/28px Open Sans, sans-serif;
}
.system-input-container.state-error {
  --field-border-color: hsl(0, 91%, 71%);
}
.system-input-container.state-success {
  --field-border-color: hsl(156, 50%, 53%);
}
.system-input-container:focus-within {
  --field-border-color: hsl(224, 89%, 82%);
  outline: solid 3px hsl(224, 86%, 89%) !important;
}
.system-input-container.disabled {
  --field-border-color: hsl(216, 12%, 84%);
  background-color: hsl(225, 13%, 94%);
}
.system-input-container.disabled :is(input, select, textarea, .rbt-input, .ant-input) {
  color: hsl(218, 11%, 65%);
}
.system-input-container.required:has(.is-invalid) {
  --field-border-color: hsl(0, 91%, 71%);
}
.system-input-container.required + .invalid-feedback {
  display: block;
  color: hsl(0, 84%, 60%);
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.minimal {
  --field-border-width: 0px;
}
.system-input-container.select {
  --select-container-padding: 6px;
  cursor: pointer;
  padding-inline-end: var(--input-inline-end-padding-select);
}
.system-input-container.select select {
  appearance: none;
  background-color: transparent;
  margin-inline-end: calc(0px - var(--input-inline-end-padding-select) - var(--field-gap) - var(--field-icon-square-size));
  padding-inline-start: calc(var(--input-inline-padding) - var(--select-container-padding));
  padding-inline-end: calc(var(--input-inline-end-padding-select) + var(--field-gap) + var(--field-icon-square-size));
  padding-block: 0px !important;
  min-height: calc(var(--field-height) - var(--field-border-width) * 2);
  min-width: initial !important;
  max-width: initial !important;
  z-index: 9;
}
.system-input-container.select select + i.input-icon {
  --field-icon-size: 14px;
  margin-inline-start: 0;
  display: grid;
  place-content: center;
}
.system-input-container.select .type-select-style {
  margin-inline-end: calc(0px - var(--input-inline-end-padding-select));
  width: calc(100% + var(--input-inline-end-padding-select));
  flex: auto;
}
.system-input-container.select .type-select-style .react-select__single-value {
  margin-inline: 0px;
  align-items: center;
  display: flex;
  padding-inline-start: calc(var(--input-inline-padding) - var(--select-container-padding));
  min-width: max-content;
}
.system-input-container.select .type-select-style .react-select__control {
  min-height: calc(var(--field-height) - var(--field-border-width) * 2);
  padding: 0;
  align-items: center;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: var(--field-border-radius);
  flex-wrap: nowrap;
}
.system-input-container.select .type-select-style .react-select__value-container,
.system-input-container.select .type-select-style .react-select__indicators {
  height: 100%;
  padding: 0px;
  min-height: calc(var(--field-height) - var(--field-border-width) * 2);
}
.system-input-container.select .type-select-style .react-select__indicator {
  cursor: pointer;
  padding: 7px;
}
.system-input-container.select .type-select-style .react-select__indicator-separator {
  display: none;
}
.system-input-container.select .type-select-style .react-select__input {
  margin-inline-start: calc(var(--input-inline-padding) - var(--select-container-padding)) !important;
  height: 100%;
}
.system-input-container.select .type-select-style .react-select__value-container {
  gap: 8px;
  padding-inline-start: 8px;
}
.system-input-container.select .type-select-style .react-select__value-container > div:not(.react-select__single-value) {
  height: 100%;
  margin: 0;
  padding: 0;
}
.system-input-container.select .type-select-style .react-select__value-container.react-select__value-container--is-multi.react-select__value-container--has-value {
  padding-block: 6px;
}
.system-input-container.select .type-select-style .react-select__value-container.react-select__value-container--is-multi.react-select__value-container--has-value > .react-select__multi-value {
  height: auto;
  background-color: hsl(220, 13%, 91%);
}
.system-input-container.select .type-select-style .react-select__value-container.react-select__value-container--is-multi.react-select__value-container--has-value + .react-select__indicators {
  align-self: center;
}
.system-input-container.select .type-select-style .react-select__value-container .react-select__multi-value__label:has(.count) > span {
  display: flex;
  gap: 6px;
}
.system-input-container.select .type-select-style .react-select__value-container .react-select__multi-value__label:has(.count) > span .count {
  background-color: hsl(216, 12%, 84%);
  color: hsl(0, 0%, 7%);
  font-size: 11px;
}
.system-input-container.select .type-select-style .react-select__menu {
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1);
  border: 1px solid hsl(220, 13%, 91%);
  border-radius: 4px;
  overflow: hidden;
}
.system-input-container.select .type-select-style .react-select__menu > div {
  padding: 0;
}
.system-input-container.select .type-select-style .react-select__option {
  min-height: var(--rbt-item-height);
  align-items: center;
  display: flex;
  padding-inline: var(--input-inline-padding);
  color: hsl(0, 0%, 7%);
  word-break: break-word;
}
.system-input-container.select .type-select-style .react-select__option .nested-item {
  position: relative;
  padding-inline-start: calc(var(--level) * 15px);
}
.system-input-container.select .type-select-style .react-select__option .nested-item::before {
  position: absolute;
  content: "";
  width: 1px;
  height: calc(19px + 100%);
  inset-inline-start: calc(10px * var(--level) - 14px);
  top: -9px;
  background-color: hsl(216, 12%, 84%);
}
.system-input-container.select .type-select-style .react-select__option .nested-item::after {
  position: absolute;
  content: "";
  width: 8px;
  height: 10px;
  inset-inline-start: calc(10px * var(--level) - 14px);
  top: calc(50% - 8px);
  background-color: transparent;
  border-style: none none solid solid;
  border-color: hsl(216, 12%, 84%);
  border-width: 0px 0px 1px 1px;
  border-radius: 0 0 0 4px;
}
.system-input-container.select .type-select-style .react-select__option .nested-item.first-item::before {
  top: -28px;
  height: calc(38px + 100%);
}
.system-input-container.select .type-select-style .react-select__option .nested-item.last-item::before {
  height: calc(9px + 50%);
}
.system-input-container.select .type-select-style .react-select__option .nested-item.last-item:not([style="--level: 1;"]) > span::after {
  content: "";
  position: absolute;
  width: 1px;
  height: calc(100% + 1px);
  background-color: hsl(216, 12%, 84%);
  top: calc(50% - 2px);
  inset-inline-start: -4px;
}
.system-input-container.select .type-select-style .react-select__option .nested-item:not([style="--level: 1;"])::before {
  box-shadow: -10px 0px hsl(216, 12%, 84%);
}
.system-input-container.select .type-select-style .react-select__option .parent-item > span::before {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  background-color: white;
  border-radius: 5px;
  top: calc(50% - 2px);
  inset-inline-start: 3px;
  outline: solid 1px hsl(216, 12%, 84%);
  z-index: 9;
}
.system-input-container.select .type-select-style .react-select__option .parent-item[style*="--level: 0"] {
  position: relative;
  padding-inline-start: 5px;
}
.system-input-container.select .type-select-style .react-select__option .parent-item[style*="--level: 0"] > span::before {
  inset-inline-start: -7px;
}
.system-input-container.select .type-select-style .react-select__option .parent-item[style="--level: 2;"] > span::before {
  inset-inline-start: 13px;
}
.system-input-container.select .type-select-style .react-select__option--is-selected,
.system-input-container.select .type-select-style .react-select__option--is-focused {
  background-color: hsl(225, 13%, 94%);
}
.system-input-container.select .type-select-style .react-select__multi-value__label {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.system-input-container.select .type-select-style .react-select__placeholder {
  display: flex;
  align-items: center;
  padding-inline: calc(var(--input-inline-padding) - var(--select-container-padding)) !important;
}
.system-input-container.select.multiple {
  height: auto;
  min-height: var(--field-height);
}
.system-input-container.select.multiple .type-select-style .react-select__control {
  height: auto;
}
.system-input-container.select.multiple .type-select-style .react-select__value-container {
  padding: var(--select-container-padding);
  gap: 6px;
}
.system-input-container.select.multiple .type-select-style .react-select__multi-value {
  background-color: hsl(220, 13%, 91%);
}
.system-input-container.select:has(.type-select-style) {
  --input-inline-end-padding-select: 0px;
}
.system-input-container.datetime {
  position: relative;
  container-type: inline-size;
  container-name: date-input;
  min-width: 138px;
}
.system-input-container.datetime .rdt {
  display: contents;
}
.system-input-container.datetime .rdt > div.form-control {
  border: none;
  padding-block: 0px;
  padding-inline: calc(var(--input-inline-padding) - var(--select-container-padding, 0px));
}
.system-input-container.datetime .rdt .item.mustache {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: space-between;
}
.system-input-container.datetime .rdt .item.mustache > span {
  white-space: nowrap;
}
.system-input-container.datetime .rdt .item.mustache [role=button] {
  font-size: 9px;
  width: 15px;
  height: 15px;
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}
.system-input-container.datetime .rdt .item.mustache [role=button]:hover {
  background-color: hsl(225, 13%, 94%);
}
.system-input-container.datetime .rdt.rdtOpen .item.mustache [role=button] {
  display: none;
}
.system-input-container.datetime .rdtPicker {
  top: 100%;
  inset-inline-end: var(--picker-inline-end, 0px);
  padding: 0px;
  box-shadow: 0 1px 28px rgba(0, 0, 0, 0.1);
}
.system-input-container.datetime .rdtPicker > .row {
  margin-inline: 0;
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 12px;
}
.system-input-container.datetime .rdtPicker > .row > .col {
  padding: 12px;
}
.system-input-container.datetime .rdtPicker > .row > .col:first-child {
  border-inline-end: solid 1px hsl(220, 13%, 91%);
}
.system-input-container.datetime .rdtPicker > .row > .col > button {
  padding: 0px 14px;
  min-height: 32px;
  border-radius: 4px;
  width: 100%;
  text-align: start;
  color: hsl(218, 11%, 65%);
  line-height: 1;
}
.system-input-container.datetime .rdtPicker > .row > .col > button:hover {
  background-color: hsl(223, 37%, 93%);
  color: hsl(222, 100%, 28%);
}
.system-input-container.datetime .rdtPicker .dow {
  color: hsl(218, 11%, 65%);
  font-weight: 400;
  text-transform: uppercase;
  font-size: 10px;
}
.system-input-container.datetime .rdtPicker .rdtDay {
  padding: 8px 10.4px;
  font-size: 16px;
  font-weight: 500;
  text-align: center !important;
  border-radius: 6px;
  line-height: 1;
}
.system-input-container.datetime .rdtPicker .rdtDay.rdtToday {
  background-color: hsl(223, 37%, 93%);
  color: hsl(222, 100%, 28%);
  font-weight: 500;
}
.system-input-container.datetime .rdtPicker .rdtDay.rdtToday::before {
  display: none;
}
.system-input-container.datetime .rdtPicker .rdtDay.rdtActive {
  background-color: hsl(222, 100%, 28%);
  color: hsl(0, 50%, 100%);
}
.system-input-container.datetime .rdtPicker .rdtDay:is(.rdtOld, .rdtNew) {
  font-weight: 400;
  color: hsl(218, 11%, 65%);
}
.system-input-container.datetime .rdtPicker .rdtDay.selected-range-day {
  border-radius: 6px 0 0 6px;
  background-color: hsl(225, 13%, 94%);
  color: hsl(0, 0%, 7%);
}
.system-input-container.datetime .rdtPicker .rdtDay.selected-range-day ~ .selected-range-day {
  border-radius: 0;
}
.system-input-container.datetime .rdtPicker .rdtDay.selected-range-day:last-child {
  border-radius: 0 6px 6px 0;
}
.system-input-container.datetime .rdtPicker :is(.rdtMonth, .rdtYear) {
  width: 50px;
  height: 50px;
  padding: 0px 14px;
  border-radius: 4px;
  color: hsl(222, 100%, 28%);
}
.system-input-container.datetime .rdtPicker :is(.rdtMonth, .rdtYear):is(:hover, .rdtActive) {
  background-color: hsl(223, 37%, 93%);
}
.system-input-container.datetime .rdtPicker .rdtSwitch {
  white-space: nowrap;
}
.system-input-container.datetime .rdtPicker :is(th, td) {
  width: 38px;
  height: 38px;
}
.system-input-container.datetime .rdtPicker :is(th, td).dow {
  height: 20px;
}
.system-input-container.datetime :is(.rdtNext, .rdtPrev, .rdtSwitch, .rdtTimeToggle) {
  color: hsl(223, 53%, 42%);
  border-radius: 6px;
}
.system-input-container.datetime :is(.rdtNext, .rdtPrev, .rdtSwitch, .rdtTimeToggle) > span {
  line-height: 26px;
  font-size: 34px;
  font-weight: 400;
  vertical-align: baseline;
  display: inline-block;
  padding-bottom: 8px;
}
.system-input-container.datetime :is(.rdtNext, .rdtPrev, .rdtSwitch, .rdtTimeToggle):hover {
  background-color: hsl(223, 37%, 93%);
  color: hsl(222, 100%, 28%);
}
.system-input-container.datetime .rdtCounters {
  width: 100%;
  display: flex;
}
.system-input-container.datetime .rdtCounter {
  flex: 1;
  height: initial;
}
.system-input-container.datetime .rdtCounter .rdtBtn {
  height: 40px;
  border-radius: 6px;
}
.system-input-container.datetime .rdtCounter .rdtBtn:hover {
  background-color: hsl(223, 37%, 93%);
  color: hsl(222, 100%, 28%);
}
.system-input-container.datetime .rdtCounter .rdtCount {
  height: 36px;
  place-content: center;
}
.system-input-container.datetime .rdtCounterSeparator {
  place-content: center;
}
.system-input-container.datetime .close-dtpk {
  display: none;
  align-items: center;
  height: 100%;
  position: absolute;
  inset-inline-end: 0;
}
.system-input-container.datetime .close-dtpk > span {
  display: flex;
  align-items: center;
  height: 100%;
  padding-inline: 10px;
  cursor: pointer;
}
.system-input-container.datetime .close-dtpk > span:hover {
  background-color: hsl(225, 13%, 94%);
}
.system-input-container.datetime .rdtOpen + .close-dtpk {
  display: flex;
}
.system-input-container.datetime.contains-select {
  gap: 0px;
}
.system-input-container.datetime.contains-select .system-input-container.select {
  width: 100%;
  border-inline: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.system-input-container.datetime.contains-select .system-input-container.select:focus-within {
  outline: none !important;
}
.system-input-container.datetime.opens-right .rdtPicker {
  --picker-inline-end: auto;
}
.system-input-container textarea {
  height: initial;
  padding-block: var(--textarea-block-padding, 0px);
  field-sizing: content;
  word-break: break-word;
}
.system-input-container.textarea {
  --field-height: auto;
  --textarea-block-padding: 16px;
}
.system-input-container.textarea.like-field {
  --textarea-block-padding: 7px;
}
.system-input-container.textarea.like-field textarea {
  resize: none;
  field-sizing: content;
  max-width: 100%;
}
.system-input-container.field-inline {
  display: inline-flex;
}
.system-input-container.autocomplete {
  position: relative;
}
.system-input-container.autocomplete .react-autosuggest__suggestions-container {
  top: 100%;
  width: 100%;
}
.system-input-container.autocomplete .react-autosuggest__suggestions-container--open {
  z-index: 9;
  border: solid 1px hsl(220, 13%, 91%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1);
}
.system-input-container.autocomplete .react-autosuggest__suggestion {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  padding: 8px 16px;
  color: hsl(0, 0%, 7%);
}
.system-input-container.autocomplete .react-autosuggest__suggestion:is(:hover, .react-autosuggest__suggestion--highlighted) {
  background-color: hsl(225, 13%, 94%);
}
.system-input-container.input-group {
  --field-gap: 0;
}
.system-input-container .input-group-text {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  border: none;
  background-color: hsl(225, 13%, 94%);
}
.system-input-container .input-group-prepend {
  margin-right: 0px;
  height: 100%;
}
.system-input-container .data-expression-view {
  white-space: nowrap;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  gap: 8px;
  padding-inline-end: 5px;
  padding-inline-start: 12px;
  flex: auto;
}
.system-input-container .data-expression-view > div {
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
.system-input-container .data-expression-view > div:has(.data-expression-view) {
  display: flex;
}
.system-input-container .data-expression-view .operator {
  margin-inline-end: 5px;
}
.system-input-container:has(.formula-button) {
  gap: 0px;
}
.system-input-container .rbt-input.form-control {
  border: none;
  padding: 0 var(--input-inline-padding);
  min-height: calc(var(--field-height) - var(--field-border-width) * 2);
}
.system-input-container .rbt-input.form-control:focus {
  background-color: transparent;
}
.system-input-container .rbt-menu {
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1) !important;
  border: 1px solid hsl(220, 13%, 91%) !important;
  border-radius: 4px !important;
}
.system-input-container .rbt-menu .dropdown-item {
  min-height: var(--rbt-item-height);
  align-items: center;
  display: flex;
  padding-inline: var(--input-inline-padding) !important;
}
.system-input-container.rbt {
  height: auto;
  min-height: var(--field-height);
}
.system-input-container.rbt > div:not(.rbt-menu, .rbt-input) {
  min-height: calc(var(--field-height) - var(--field-border-width) * 2);
}
.system-input-container .rbt-input-multi.form-control {
  height: 100%;
  padding-inline-start: 8px;
  padding-inline-end: 34px;
  padding-block: 5px;
  min-height: 34px;
}
.system-input-container .rbt-input-multi.form-control .rbt-input-main {
  height: 100%;
  margin: 0;
}
.system-input-container .rbt-input-multi.form-control.focus {
  box-shadow: none;
}
.system-input-container .rbt-input-multi.form-control .rbt-token-removeable {
  padding-inline-start: 6px;
  padding-inline-end: 0px;
}
.system-input-container .rbt-input-multi.form-control:last-child {
  padding-inline-end: 8px;
}
.system-input-container .rbt-input-wrapper {
  height: 100%;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  gap: 6px;
  min-height: calc(var(--field-height) - 12px);
  align-items: center !important;
}
.system-input-container .rbt-input-wrapper .rbt-token {
  min-height: 24px;
  align-items: center;
  display: inline-flex;
  border-radius: 2px;
  background-color: hsl(220, 13%, 91%);
  color: hsl(0, 0%, 7%);
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  padding-block: 0;
  padding-inline-start: 16px;
  padding-inline-end: 6px;
  margin: 0;
  gap: 6px;
}
.system-input-container .rbt-input-wrapper .rbt-token-label {
  padding: 0 !important;
}
.system-input-container .rbt-input-wrapper .rbt-token-remove-button {
  position: initial;
  height: 100%;
  font-size: 19px;
  line-height: 20px;
  width: 20px;
  padding-inline: 0px;
  padding-block: 0px;
}
.system-input-container .rbt-input-wrapper .rbt-token-remove-button:hover {
  background-color: hsl(216, 12%, 84%) !important;
}
.system-input-container .rbt-input-wrapper div:last-child {
  min-width: 110px;
  min-height: 24px;
}
.system-input-container .rbt-input-wrapper div:last-child input {
  min-height: 24px;
}
.system-input-container .rbt-aux .rbt-close {
  margin-top: 0;
}
.system-input-container .rbt-close {
  opacity: 1;
  color: var(--icon-color, hsl(218, 11%, 65%));
}
.system-input-container .rbt-close::before {
  font-family: "Font Awesome 6 Pro";
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  content: "\\f00d";
  font-weight: 400;
  font-size: 14px;
  width: 24px;
  --fa-display: grid;
  height: 24px;
  place-content: center;
}
.system-input-container .rbt-close:hover {
  --icon-color: hsl(215, 14%, 34%);
}
.system-input-container .rbt-close-content {
  display: none !important;
}
.system-input-container .ant-input-number {
  border: none;
  height: 100%;
  width: 100%;
}
.system-input-container .ant-input-number-input-wrap {
  height: 100%;
}
.system-input-container .color-field {
  position: relative;
  cursor: pointer;
}
.system-input-container .color-field::before, .system-input-container .color-field::after {
  content: "";
  display: block;
  position: absolute;
  border-radius: var(--field-border-radius, 4px);
}
.system-input-container .color-field::before {
  inset: 0;
  background-color: hsl(0, 50%, 100%);
}
.system-input-container .color-field::after {
  inset: 6px;
  background-color: var(--color-value);
}
.system-input-container.overflow-focus:focus-within {
  margin-inline-start: 3px;
}
.system-input-container.overflow-focus:focus-within.select {
  margin-top: 3px;
}
.system-input-container.overflow-focus:focus-within.select .react-select__single-value {
  padding-inline-start: calc(var(--input-inline-padding) - 3px);
}
.system-input-container.overflow-focus:focus-within.select .type-select-style .react-select__input {
  margin-inline-start: calc(var(--input-inline-padding) - 3px) !important;
}
.system-input-container.overflow-focus:focus-within.select .type-select-style .react-select__option {
  padding-inline-start: calc(var(--input-inline-padding) - 3px);
}
.system-input-container.overflow-focus:focus-within i.input-icon {
  margin-inline-start: calc(var(--input-inline-padding) - 3px);
}

.system-label {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  display: flex;
  margin-bottom: var(--label-bottom-margin, var(--system-label-bottom-margin, 6px));
  gap: 6px;
}
.system-label.label-inline {
  display: inline-flex;
}
.system-label .help-icon {
  align-self: center;
}
.system-label.required::after {
  display: block;
  min-width: 6px;
  min-height: 6px;
  content: "";
  border-radius: 6px;
  background-color: hsl(0, 72%, 51%);
  align-self: center;
}

.label-space {
  margin-top: 26px;
}

.form-group {
  margin-bottom: 0px;
}

.system-button {
  --focused-outline-border-width: 1px;
  --active-outline-border-width: 1px;
  background-color: var(--button-bg-color, var(--system-primary-color, #002b8f));
  color: var(--button-text-color, hsl(0, 50%, 100%));
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  height: var(--button-height, 40px);
  border: none;
  border-radius: var(--button-border-radius, 4px);
  padding-inline: var(--button-inline-padding, 16px);
  padding-block: 0;
  display: inline-flex;
  align-items: var(--button-vertical-align, center);
  gap: 10px;
  transition: background-color 0.15s ease;
  cursor: pointer;
  white-space: nowrap;
}
.system-button.padding-block {
  padding-block: calc(var(--button-inline-padding, 16px) - 4px) !important;
  height: auto !important;
}
.system-button:hover {
  --button-bg-color: hsl(223, 100%, 22%);
}
.system-button:where(:focus, :focus-visible, .focused) {
  outline: solid var(--focused-outline-border-width, 2px) var(--outline-color, hsl(223, 39%, 71%)) !important;
}
.system-button:where(:active, .active) {
  --button-bg-color: hsl(223, 100%, 22%);
  outline: solid var(--active-outline-border-width, 2px) var(--outline-color, hsl(213, 97%, 87%)) !important;
}
.system-button:where(.disabled, :disabled, [disabled]) {
  --button-bg-color: hsl(223, 38%, 85%);
  pointer-events: none;
  user-select: none;
}
.system-button.outline {
  --button-bg-color: transparent;
  --button-text-color: var(--system-primary-color, #002b8f);
  border: solid var(--button-border-width, 1px) var(--button-border-color, var(--system-primary-color, #002b8f));
}
.system-button.outline:hover {
  --button-bg-color: hsl(223, 37%, 93%);
}
.system-button.outline:where(:active, .active) {
  --button-bg-color: hsl(223, 37%, 93%);
}
.system-button.outline:where(.disabled, :disabled, [disabled]) {
  --button-border-color: hsl(223, 38%, 85%);
  --button-text-color: hsl(223, 38%, 85%);
}
.system-button.outline.grayscale {
  --button-text-color: hsl(217, 19%, 27%);
  --button-border-color: hsl(217, 19%, 27%);
}
.system-button.outline.grayscale:hover {
  --button-bg-color: hsl(225, 13%, 94%);
}
.system-button.outline.grayscale:where(:focus, :focus-visible, .focused) {
  --outline-color: hsl(213, 97%, 87%);
  --button-border-color: hsl(212, 96%, 78%);
}
.system-button.outline.grayscale:active {
  --button-bg-color: transparent;
  --outline-color: hsl(218, 11%, 65%);
}
.system-button.outline.grayscale:where(.disabled, :disabled, [disabled]) {
  --button-border-color: hsl(216, 12%, 84%);
  --button-text-color: hsl(216, 12%, 84%);
}
.system-button.outline.color-error {
  --button-text-color: hsl(0, 72%, 51%);
  --button-border-color: hsl(0, 72%, 51%);
}
.system-button.outline.color-error:hover {
  --button-bg-color: hsl(0, 93%, 94%);
}
.system-button.outline.color-info {
  --button-bg-color: transparent;
  --outline-color: hsl(213, 97%, 87%);
  --button-border-color: hsl(212, 96%, 78%);
}
.system-button.minimal {
  --button-bg-color: transparent;
  --button-text-color: var(--system-primary-color, #002b8f);
}
.system-button.minimal:hover {
  --button-bg-color: hsl(223, 37%, 93%);
}
.system-button.minimal:active {
  --button-bg-color: transparent;
  --button-text-color: hsl(222, 100%, 17%);
}
.system-button.minimal:where(.disabled, :disabled, [disabled]) {
  --button-bg-color: transparent;
  --button-text-color: hsl(223, 38%, 85%);
}
.system-button.minimal.grayscale {
  --button-text-color: hsl(217, 19%, 27%);
}
.system-button.minimal.grayscale:hover {
  --button-bg-color: hsl(225, 13%, 94%);
}
.system-button.minimal.grayscale:where(:focus, :focus-visible) {
  --outline-color: hsl(216, 12%, 84%);
}
.system-button.minimal.grayscale:active {
  --outline-color: hsl(218, 11%, 65%);
}
.system-button.minimal.grayscale:where(.disabled, :disabled, [disabled]) {
  --button-text-color: hsl(216, 12%, 84%);
}
.system-button.minimal.color-error {
  --button-text-color: hsl(0, 72%, 51%);
}
.system-button.minimal.color-error:hover {
  --button-bg-color: hsl(0, 93%, 94%);
}
.system-button.text {
  --button-inline-padding: 0px;
  --button-text-color: var(--system-primary-color, #002b8f);
  --button-bg-color: transparent;
  --button-height: auto;
}
.system-button.text:hover {
  --button-text-color: hsl(223, 100%, 22%);
  --button-bg-color: transparent;
}
.system-button.text:where(:focus, :focus-visible) {
  --button-text-color: var(--system-primary-color, #002b8f);
  --outline-color: transparent;
}
.system-button.text:active {
  --outline-color: transparent;
  --button-bg-color: transparent;
  --button-text-color: hsl(222, 100%, 17%);
}
.system-button.text:where(.disabled, :disabled, [disabled]) {
  --button-bg-color: transparent;
  --button-text-color: hsl(223, 38%, 85%);
}
.system-button.text:is(.size-s, .size-m, .size-l, .size-xl) {
  --button-inline-padding: 0px;
  --button-height: auto;
}
.system-button.text.grayscale {
  --button-text-color: hsl(217, 19%, 27%);
}
.system-button.text.grayscale:hover {
  --button-bg-color: transparent;
  --button-text-color: hsl(217, 19%, 27%);
}
.system-button.text.grayscale:where(:focus, :focus-visible) {
  --button-text-color: hsl(215, 14%, 34%);
  --outline-color: transparent;
}
.system-button.text.grayscale:active {
  --button-text-color: hsl(215, 28%, 17%);
  --outline-color: transparent;
}
.system-button.text.grayscale:where(.disabled, :disabled, [disabled]) {
  --button-text-color: hsl(216, 12%, 84%);
}
.system-button .button-icon {
  font-size: var(--button-icon-size, 13px);
  padding: 2px;
  min-width: var(--button-icon-square-size, 16px);
  min-height: var(--button-icon-square-size, 16px);
}
.system-button.block {
  width: 100%;
}
.system-button.underline {
  text-decoration: underline;
  text-underline-offset: 5px;
}
.system-button.size-s {
  --button-height: 36px;
  --button-border-radius: 4px;
  --button-inline-padding: 16px;
}
.system-button.size-s .button-icon {
  --button-icon-size: 13px;
}
.system-button.size-s.icon-size-s {
  --button-inline-padding: 10px;
}
.system-button.size-s.icon-size-m {
  --button-inline-padding: 10px;
}
.system-button.size-s.icon-size-l {
  --button-inline-padding: 10px;
}
.system-button.size-s.icon-size-xl {
  --button-inline-padding: 8.5px;
}
.system-button.size-m {
  --button-height: 40px;
  --button-border-radius: 4px;
  --button-inline-padding: 16px;
}
.system-button.size-m .button-icon {
  --button-icon-size: 13px;
}
.system-button.size-m.icon-size-s {
  --button-inline-padding: 12px;
}
.system-button.size-m.icon-size-m {
  --button-inline-padding: 12px;
}
.system-button.size-m.icon-size-l {
  --button-inline-padding: 12px;
}
.system-button.size-m.icon-size-xl {
  --button-inline-padding: 10.5px;
}
.system-button.size-l {
  --button-height: 48px;
  --button-border-radius: 6px;
  --button-inline-padding: 18px;
  font: normal 500 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.system-button.size-l .button-icon {
  --button-icon-size: 16px;
}
.system-button.size-l.icon-size-s {
  --button-inline-padding: 16px;
}
.system-button.size-l.icon-size-m {
  --button-inline-padding: 16px;
}
.system-button.size-l.icon-size-l {
  --button-inline-padding: 16px;
}
.system-button.size-l.icon-size-xl {
  --button-inline-padding: 14.5px;
}
.system-button.size-xl {
  --button-height: 60px;
  --button-border-radius: 6px;
  --button-inline-padding: 24px;
  font: normal 500 18px/28px Open Sans, sans-serif;
}
.system-button.size-xl .button-icon {
  --button-icon-size: 20px;
}
.system-button.size-xl.icon-size-s {
  --button-inline-padding: 16px;
}
.system-button.size-xl.icon-size-m {
  --button-inline-padding: 16px;
}
.system-button.size-xl.icon-size-l {
  --button-inline-padding: 16px;
}
.system-button.size-xl.icon-size-xl {
  --button-inline-padding: 20.5px;
}
.system-button.icon-size-s .button-icon {
  --button-icon-size: 13px;
}
.system-button.icon-size-m .button-icon {
  --button-icon-size: 13px;
}
.system-button.icon-size-l .button-icon {
  --button-icon-size: 16px;
}
.system-button.icon-size-xl .button-icon {
  --button-icon-size: 20px;
}
.system-button.trash-button {
  --button-text-color: hsl(0, 91%, 71%);
}
.system-button.trash-button:hover {
  --button-bg-color: hsl(0, 93%, 94%);
}
.system-button.trash-button.outline {
  --button-border-color: hsl(0, 91%, 71%);
}
.system-button.color-success {
  --button-bg-color: hsl(156, 71%, 33%);
}
.system-button.color-info {
  --button-bg-color: hsl(217, 70%, 54%);
}
.system-button.icon-button {
  --button-inline-padding: 0;
  min-width: var(--button-height);
  justify-content: center;
}
.system-button.icon-text-align {
  --button-vertical-align: baseline;
}
.system-button.icon-text-align .button-icon {
  height: 100%;
}
.system-button.icon-text-align span {
  height: 100%;
  align-items: center;
  display: flex;
}
.system-button:is(a) {
  display: inline-flex !important;
  padding-block: 0 !important;
  padding-inline: var(--button-inline-padding, 16px) !important;
  border-radius: var(--button-border-radius, 4px) !important;
}

.buttons-group {
  border: solid 1px hsl(223, 37%, 93%);
  border-radius: 4px;
}
.buttons-group .system-button {
  --button-text-color: hsl(218, 11%, 65%);
}
.buttons-group .system-button.selected {
  --button-text-color: hsl(221, 39%, 11%);
  --button-bg-color: hsl(223, 37%, 93%);
}
.buttons-group .system-button:first-child {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.buttons-group .system-button:last-child {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.buttons-group .system-button:not(:first-child, :last-child) {
  border-radius: 0px;
}

.dropdown .dropdown-menu {
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.09);
}

.dropdown-menu {
  overflow-y: auto;
  max-height: 90vh;
  max-width: 90vw;
  background-color: hsl(0, 50%, 100%);
  border: solid 1px hsl(220, 13%, 91%);
  border-radius: 4px;
  padding: 0;
}
.dropdown-menu .dropdown-item {
  border-radius: 0;
  padding: 8px 16px;
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  cursor: pointer;
  line-break: auto;
}
.dropdown-menu .dropdown-item:hover {
  background-color: hsl(210, 20%, 98%);
}
.dropdown-menu .dropdown-item:active {
  background-color: hsl(225, 13%, 94%);
}

.user-main-menu {
  width: 200px;
}

.user-info-menu {
  text-align: start;
}
.user-info-menu i {
  width: 18px;
  text-align: center;
}

.nestable-item-name.type-object .dropdown .dropdown-toggle {
  height: 36px;
  border-radius: 4px;
  padding-inline: 0;
  min-width: 36px;
  justify-content: center;
  background-color: transparent;
  color: hsl(217, 19%, 27%);
  border: none;
  box-shadow: none;
}
.nestable-item-name.type-object .dropdown .dropdown-toggle:hover {
  background-color: hsl(225, 13%, 94%);
}
.nestable-item-name.type-object .dropdown .dropdown-toggle::after {
  display: none;
}
.nestable-item-name.type-object .dropdown .dropdown-item {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  min-height: 40px;
  align-items: center;
  display: flex;
  padding-inline: 16px;
}

.toggle-icon {
  font-size: var(--toggle-button-icon-size, 20px);
  --toggle-icon-color: hsl(220, 9%, 46%);
  color: var(--toggle-icon-color);
}
.toggle-icon.on {
  --toggle-icon-color: hsl(156, 50%, 53%);
}

.toggle-button {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}
.toggle-button i {
  cursor: pointer;
}
.toggle-button span {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
}
.toggle-button:hover span {
  color: hsl(217, 19%, 27%);
}
.toggle-button .tooltip-icon {
  color: hsl(222, 100%, 28%);
}
.toggle-button.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.toggle-button.disabled * {
  cursor: inherit;
}

.form-switch {
  padding-inline-start: 32px;
}
.form-switch .form-check-input {
  pointer-events: auto !important;
  appearance: none;
  display: block;
  margin: 0;
  inset: 0;
  cursor: pointer;
  z-index: 9;
}
.form-switch label {
  margin-inline-start: 10px;
}
.form-switch::before {
  content: "";
  display: block;
  width: 32px;
  height: 20px;
  position: absolute;
  inset-inline-start: 0px;
  background: hsl(220, 13%, 91%);
  border-radius: 20px;
  outline: solid 1px hsl(216, 12%, 84%);
}
.form-switch::after {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 2px;
  inset-inline-start: 2px;
  background: hsl(218, 11%, 65%);
  border-radius: 20px;
  transition: transform 0.2s ease-in-out;
}
.form-switch:hover::before {
  background: hsl(216, 12%, 84%);
}
.form-switch:hover::after {
  background: hsl(220, 9%, 46%);
}
.form-switch:has(:checked)::before {
  background: hsl(156, 50%, 88%);
  outline: solid 1px hsl(157, 50%, 65%);
}
.form-switch:has(:checked)::after {
  background: hsl(156, 50%, 53%);
  transform: translateX(12px);
}
.form-switch:has(:checked):hover::after {
  background: hsl(156, 50%, 53%);
}

.system-radio-group {
  display: inline-flex;
  gap: 16px;
  align-items: center;
}
.system-radio-group:has(.system-button) {
  gap: 8px;
}
.system-radio-group .radio-item {
  display: flex;
  gap: 6px;
  align-items: center;
  cursor: pointer;
  border-radius: 2px;
}
.system-radio-group .radio-item:hover {
  outline: solid 2px hsl(223, 37%, 93%);
  outline-offset: 3px;
}
.system-radio-group .radio-item.system-button {
  gap: 10px;
  border-radius: var(--button-border-radius, 4px);
  --button-bg-color: transparent;
  --button-text-color: var(--system-primary-color, #002b8f);
  border: solid var(--button-border-width, 1px) var(--button-border-color, var(--system-primary-color, #002b8f));
}
.system-radio-group .radio-item.system-button:hover {
  outline: none;
}
.system-radio-group .radio-item.system-button input {
  display: none;
}
.system-radio-group .radio-item.system-button:has(:disabled) {
  --button-text-color: hsl(0, 50%, 100%);
  --button-bg-color: hsl(223, 38%, 85%);
  border: none;
  pointer-events: none;
  user-select: none;
}
.system-radio-group .radio-item.system-button:has(:checked) {
  --button-bg-color: var(--system-primary-color, #002b8f);
  --button-text-color: hsl(0, 50%, 100%);
  border: none;
}

.system-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.system-checkbox input {
  appearance: none;
  display: block;
  margin: 0;
  inset: 0;
  cursor: pointer;
  z-index: 9;
}
.system-checkbox span {
  margin-inline-start: 10px;
}
.system-checkbox::before {
  font-family: "Font Awesome 6 Pro";
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  content: "";
  display: grid;
  place-content: center;
  width: 16px;
  height: 16px;
  font-size: 10px;
  font-weight: 700;
  background-color: hsl(0, 50%, 100%);
  border-radius: 3px;
  border: solid 1px hsl(216, 12%, 84%);
  transform: translateY(-1px);
}
.system-checkbox:has(:checked)::before {
  content: "\\f00c";
  background-color: hsl(223, 53%, 42%);
  border-color: hsl(223, 100%, 22%);
  color: hsl(0, 50%, 100%);
}
.system-checkbox:hover::before {
  border-color: hsl(222, 38%, 57%);
}

@container date-input (max-width: 160px) {
  .close-dtpk > span > span {
    display: none;
  }
}
:root {
  --page-panel-block-padding: 28px;
  --page-panel-inline-padding: 20px;
  --system-label-bottom-margin: 6px;
  --system-primary-color: hsl(222, 100%, 28%);
}

body {
  background-color: hsl(210, 20%, 98%);
}

.app-header {
  min-height: var(--app-header-height);
  transition: min-height 0.15s ease-in-out;
}
.app-header .app-main-header {
  border-bottom: none !important;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  max-height: var(--app-header-height);
}
.app-header .app-main-header .app-toolbar {
  min-height: var(--app-header-height);
  transition: margin-top 0.15s ease-in-out;
}
.app-header .app-main-header .header-notifications li.user-nav .quick-menu .user-initials-menu-toggler {
  background-color: var(--system-primary-color, #002b8f);
  padding: 6px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  color: hsl(0, 50%, 100%);
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  transition-duration: 0.3s;
  border: solid 2px hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 1px 1px rgba(48, 49, 51, 0.1);
}
.app-header .app-main-header .header-notifications li.user-nav .quick-menu .user-initials-menu-toggler:hover {
  background-color: hsl(222, 100%, 17%);
}
.app-header .app-main-header .header-notifications li.user-nav .quick-menu.show .user-initials-menu-toggler {
  background-color: hsl(223, 100%, 22%);
}
.app-header .app-main-header :where(.db-name, .db-group-name) {
  color: hsl(0, 0%, 7%);
  display: inline-flex;
  max-width: 340px;
  font: normal 600 18px/28px Open Sans, sans-serif;
  text-align: start;
}
.app-header .app-main-header.appbar--collapsed .app-toolbar {
  margin-top: calc(12px - var(--app-header-height));
}
.app-header:has(.appbar--collapsed) {
  min-height: 12px;
}
.app-header:has(.appbar--collapsed) + .app-main-content-wrapper .data-list-container {
  height: calc(100vh - 135px - 12px + var(--app-header-height));
}
.app-header:has(.app-main-header[style*=padding-inline-end]) + .app-main-content-wrapper {
  position: absolute;
  padding-top: var(--app-header-height);
}
.app-header:has(.app-main-header[style*=padding-inline-end]):has(.appbar--collapsed) + .app-main-content-wrapper {
  padding-top: 12px;
}
.app-header:has(.app-main-header[style*=padding-inline-end]):has(.appbar--collapsed) + .app-main-content-wrapper .reports-drawer-open .Pane2 {
  transform: translateY(-37px);
}
.app-header:has(.app-main-header[style*=padding-inline-end]):has(.appbar--collapsed) + .app-main-content-wrapper .reports-drawer-open .Resizer {
  --custom-resizer-top-margin: -37px;
}

.appbar-collapse {
  position: absolute;
  bottom: -12px;
  translate: -50%;
  inset-inline-start: 50%;
  border: none;
  background-color: white;
  border-radius: 50px;
  box-shadow: 0px 3px 1px rgba(48, 49, 51, 0.05), 0px 4px 4px rgba(48, 49, 51, 0.1);
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
}
.appbar-collapse:hover {
  background-color: hsl(225, 13%, 94%);
}
.appbar-collapse:is(:focus, :focus-visible) {
  outline: solid 1px hsl(220, 13%, 91%);
  outline-offset: 0px;
}

.db-logo {
  font: normal 600 18px/28px Open Sans, sans-serif;
  color: var(--system-primary-color, #002b8f);
  border-radius: 16px;
  padding: 3px 20px;
  border: 1px solid var(--system-primary-color, #002b8f);
}

.app-main-content-wrapper .app-main-content {
  background-color: hsl(210, 20%, 98%);
  box-shadow: none;
}

.user-initials-menu-toggler {
  background-color: hsl(223, 53%, 42%);
  padding: 6px;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  color: hsl(0, 50%, 100%);
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  transition-duration: 0.3s;
}
.user-initials-menu-toggler:hover {
  background-color: hsl(223, 100%, 22%);
}

.version-selector .dropdown-item {
  white-space: nowrap;
  min-height: 36px;
}
.version-selector .dropdown-item span:empty {
  display: none;
}
.version-selector .dropdown-menu {
  min-width: 100%;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1) !important;
  border: 1px solid hsl(220, 13%, 91%) !important;
  border-radius: 4px !important;
}

.version-dropdown i {
  color: hsl(218, 11%, 65%);
  font-size: 14px !important;
}

.database-version-label {
  --labels-color: #1b255f;
  display: flex;
  align-items: center;
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  gap: 3px;
  height: 18px;
  align-items: baseline;
  color: var(--labels-color) !important;
}
.database-version-label span:not(.version-warning) {
  color: inherit !important;
}
.database-version-label .version-warning {
  font-size: 16px !important;
  line-height: 10px !important;
  color: hsl(0, 84%, 60%) !important;
  margin-inline-start: 6px;
}

.manage-version-drawer .card-header {
  --card-header-bg-color: hsl(223, 37%, 93%);
}
.manage-version-drawer .card-header .trash-button {
  margin-inline-end: -6px;
}
.manage-version-drawer .service-name {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
}
.manage-version-drawer .service-date {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(218, 11%, 65%);
}

.x-road {
  display: inline-flex;
  align-items: center;
  height: 100%;
  min-height: 32px;
  padding-inline-start: 10px;
  white-space: nowrap;
}
.x-road i {
  font-size: 20px;
  cursor: pointer;
}
.x-road i.toggle-icon {
  color: #3fac82;
  margin-inline-end: 4px;
}
.x-road span {
  font: normal 400 14px/20px Open Sans, sans-serif;
  margin-inline-end: 10px;
}
.x-road:hover {
  background-color: #f6f8fb;
}

.api-list-delete-warning-table thead {
  position: sticky;
  top: 0px;
  background-color: white;
  box-shadow: 0px -16px 0px white;
}
.api-list-delete-warning-table :is(td, th) {
  padding: 6px;
}
.api-list-delete-warning-table tr.warning td {
  background-color: hsl(0, 93%, 94%);
}
.api-list-delete-warning-table tr.warning td:first-child {
  border-radius: 4px 0px 0px 4px;
}
.api-list-delete-warning-table tr.warning td:last-child {
  border-radius: 0px 4px 4px 0px;
}

.apis-delete-warning-message {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  margin-top: 1rem;
  border: solid 1px hsl(0, 91%, 71%);
  padding: 16px;
  border-radius: 6px;
}

.apis-delete-warning-message-modal-body {
  max-height: calc(100vh - 190px);
}

.page-name-bar {
  align-items: center;
  line-height: 1;
  margin-bottom: var(--custom-bottom-margin, 10px);
  min-height: 32px;
  font: normal 500 22px/28px Open Sans, sans-serif;
  margin-inline: 0px;
}
.page-name-bar > .col {
  align-items: center;
  display: flex;
}

.page-name {
  font: normal 500 22px/28px Open Sans, sans-serif;
  color: hsl(0, 0%, 7%);
}
.page-name .badge {
  display: inline-flex;
  align-items: center;
}
.page-name .badge span {
  padding-block: 4px;
}

.backbutton {
  margin-inline-end: 12px;
}

.heading-buttons {
  gap: 8px;
}

/* Page panel */
.page-panel {
  background-color: hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  border-radius: 10px;
  /* Json Schema Editor Visual */
}
.page-panel .page-panel-heading {
  border-bottom: solid 1px hsl(220, 13%, 91%);
  padding: 22px 20px;
}
.page-panel .page-panel-heading.closed {
  border-bottom: none;
}
.page-panel .page-panel-heading i {
  font-size: var(--custom-icon-size, 16px);
}
.page-panel .panel-heading-title {
  font: normal 600 16px/20px Open Sans, sans-serif;
  letter-spacing: -0.002em;
  color: hsl(0, 0%, 7%);
}
.page-panel .page-panel-body {
  padding: var(--page-panel-block-padding) var(--page-panel-inline-padding);
}
.page-panel + .page-panel {
  margin-top: 20px;
}
.page-panel .json-schema-react-editor .schema-editor-header {
  gap: 20px;
}
.page-panel .json-schema-react-editor .schema-editor-header button {
  margin-block: -8px;
}
.page-panel .json-schema-react-editor .panel-heading-title {
  margin-inline-end: auto;
}
.page-panel .json-schema-react-editor .object-style {
  margin: 0;
  padding: 0;
}
.page-panel .json-schema-react-editor .schema-content {
  padding-right: initial;
  padding-inline-end: 0px;
}
.page-panel .json-schema-react-editor .simple-view-toggle-container {
  display: flex;
  align-items: flex-start;
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  gap: 10px;
  cursor: pointer;
}
.page-panel .json-schema-react-editor .schema-item {
  display: flex;
  align-items: center;
  justify-items: flex-end;
  justify-content: flex-end;
  padding: 4px 0px;
  gap: 4px;
}
.page-panel .json-schema-react-editor .schema-item:hover :where(.add-item-button, .duplicate-item-button, .delete-item, .adv-set) {
  opacity: 1;
}
.page-panel .json-schema-react-editor .schema-item-name {
  flex: auto;
  --reserved: 0px;
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge) .system-input-container input {
  padding-inline-end: calc(32px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(1)) .reserved-key-alert {
  --icon-position: calc(30px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(2)) .system-input-container input {
  padding-inline-end: calc(50px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(2)) .reserved-key-alert {
  --icon-position: calc(47px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(3)) .system-input-container input {
  padding-inline-end: calc(66px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(3)) .reserved-key-alert {
  --icon-position: calc(64px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(4)) .system-input-container input {
  padding-inline-end: calc(82px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-badge:nth-last-child(4)) .reserved-key-alert {
  --icon-position: calc(81px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:not(:has(.field-badge)) .reserved-key-alert {
  --icon-position: calc(9px + var(--reserved));
}
.page-panel .json-schema-react-editor .schema-item-name:has(.field-reserved) {
  --reserved: 14px;
}
.page-panel .json-schema-react-editor .field-reserved {
  position: absolute;
  inset-inline-end: 6px;
  top: 10px;
  font-size: 13px;
  color: hsl(222, 90%, 73%);
}
.page-panel .json-schema-react-editor .entry-type {
  min-width: 156px;
  max-width: 156px;
}
.page-panel .json-schema-react-editor .schema-item-actions {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 4px;
  width: initial;
  flex: initial;
}
.page-panel .json-schema-react-editor :where(.add-item-button, .duplicate-item-button, .delete-item, .adv-set) {
  opacity: 0;
}
.page-panel .json-schema-react-editor .add-item-button {
  opacity: 1;
}
.page-panel .json-schema-react-editor .nestable-list {
  padding-inline-start: 40px;
  margin: 0;
}
.page-panel .json-schema-react-editor .nestable-group {
  padding-inline-start: 0px;
  margin-top: 16px;
}
.page-panel .json-schema-react-editor .nestable-item {
  margin: 2px 0 0;
}
.page-panel .json-schema-react-editor .nestable-item-name {
  border-radius: 4px;
}
.page-panel .json-schema-react-editor .nestable-item-name.type-object {
  background-color: hsl(223, 37%, 93%);
}
.page-panel .json-schema-react-editor .nestable-item-name.type-array {
  background-color: hsl(225, 13%, 94%);
}
.page-panel .json-schema-react-editor .nestable-item-name:hover:not(.type-object, .type-array) .schema-item {
  background-color: hsl(210, 20%, 98%);
}
.page-panel .json-schema-react-editor .nestable-item.is-dragging:before {
  left: 0;
  background-color: hsl(223, 37%, 93%);
  border-color: hsl(223, 38%, 85%);
}
.page-panel .json-schema-react-editor .nestable-drag-layer > .nestable-list {
  padding-inline-start: 0;
}
.page-panel .json-schema-react-editor .nestable-item-copy {
  background-color: hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  border-radius: 4px;
  transform: scale(0.95);
  opacity: 0.8;
}
.page-panel .json-schema-react-editor .simple-view input {
  pointer-events: none;
}
.page-panel .json-schema-react-editor .simple-view :where(.entry-type, .schema-item-actions) {
  display: none;
}
.page-panel .json-schema-react-editor .simple-view .system-input-container {
  background-color: transparent;
}
.page-panel .json-schema-react-editor .reserved-key-alert {
  color: hsl(0, 91%, 71%);
  position: absolute;
  inset-inline-end: var(--icon-position);
  font-size: 16px;
}
.page-panel .json-schema-react-editor > .page-panel-body > .row {
  margin-inline: 0;
}

.json-schema-react-editor-adv-modal.modal-dialog.layer {
  height: calc(100vh - 80px);
  top: initial;
}
.json-schema-react-editor-adv-modal .advanced-toggle-row {
  gap: 8px;
}
.json-schema-react-editor-adv-modal .advanced-toggler .ant-switch {
  margin-inline-end: 0px;
}
.json-schema-react-editor-adv-modal .advanced-toggler .other-label {
  flex: 0;
  white-space: nowrap;
  padding: 0;
  min-width: fit-content;
}
.json-schema-react-editor-adv-modal .ant-row {
  gap: 12px;
}
.json-schema-react-editor-adv-modal .toggle-field-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.json-schema-react-editor-adv-modal .toggle-field-container .system-label {
  margin-bottom: 0px;
}
.json-schema-react-editor-adv-modal .toggle-field-container i {
  display: none;
}
.json-schema-react-editor-adv-modal .modal-body {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.json-schema-react-editor-adv-modal .tab-content {
  padding: 28px 0 0 !important;
}
.json-schema-react-editor-adv-modal .nav-tabs {
  border-bottom: none;
}
.json-schema-react-editor-adv-modal .nav-tabs .nav-link {
  padding: 12px 32px;
  border-radius: 0;
}
.json-schema-react-editor-adv-modal .nav-tabs .nav-link:hover {
  border-color: transparent;
  background-color: hsl(225, 13%, 94%);
}
.json-schema-react-editor-adv-modal .nav-tabs .nav-link:is(:focus-visible, :focus) {
  background-color: hsl(225, 13%, 94%);
  outline: none;
}
.json-schema-react-editor-adv-modal .nav-tabs .nav-link.active {
  font: normal 600 14px/20px Open Sans, sans-serif !important;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%) !important;
  background-color: transparent;
  box-shadow: inset 0px -3px 0px 0px hsl(223, 53%, 42%);
  border-radius: 0;
  border-color: transparent;
}
.json-schema-react-editor-adv-modal .system-label .anticon {
  align-items: center;
  display: grid;
}
.json-schema-react-editor-adv-modal .advanced-property.has-warning .system-input-container {
  width: calc(100% - var(--field-height));
  float: left;
}
.json-schema-react-editor-adv-modal .advanced-property.has-warning .duplicated-id-alert {
  min-height: 36px;
  display: flex;
  align-items: center;
  width: 36px;
  justify-content: center;
}
.json-schema-react-editor-adv-modal .fk-fields-list {
  display: grid;
  grid-gap: 6px;
}
.json-schema-react-editor-adv-modal .fk-fields-list:empty {
  display: none;
}
.json-schema-react-editor-adv-modal .fk-fields-list > .row-flex {
  padding: 0px;
}
.json-schema-react-editor-adv-modal .fk-settings-container {
  border-radius: 0 0 10px 10px;
  padding: 18px 24px;
}
.json-schema-react-editor-adv-modal .advanced-settings-rows {
  background-color: hsl(225, 13%, 94%);
  border-radius: 10px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
}
.json-schema-react-editor-adv-modal .advanced-settings-rows::after {
  height: 50px;
  content: "";
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) {
  display: flex;
  padding: 18px 24px;
  margin-bottom: 2px;
  gap: 12px;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .other-row {
  padding: 0;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex):first-child {
  border-radius: 10px 10px 0 0;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) [class*=col-] {
  padding: 0;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-1 {
  flex: 1;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-2 {
  flex: 2;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-3 {
  flex: 3;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-4 {
  flex: 4;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-5 {
  flex: 5;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-6 {
  flex: 6;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-7 {
  flex: 7;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-8 {
  flex: 8;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-9 {
  flex: 9;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-10 {
  flex: 10;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-11 {
  flex: 11;
}
.json-schema-react-editor-adv-modal :is(.other-row, .row-flex) .col-12 {
  flex: 12;
}
.json-schema-react-editor-adv-modal .ant-switch-checked {
  background-color: hsl(156, 50%, 53%);
}
.json-schema-react-editor-adv-modal .trigger-item {
  background-color: hsl(0, 50%, 100%);
  padding: 16px 16px 26px;
  border-radius: 10px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  grid-column-gap: 12px;
  grid-row-gap: 24px;
  z-index: 9;
}
.json-schema-react-editor-adv-modal .trigger-item td {
  padding: 5px;
}
.json-schema-react-editor-adv-modal .trigger-item .trigger-condition-gate {
  padding-inline-start: 0px;
}
.json-schema-react-editor-adv-modal .trigger-item tr:first-child td {
  padding-top: 0px;
}
.json-schema-react-editor-adv-modal .trigger-item tr:last-child td {
  padding-bottom: 0px;
}
.json-schema-react-editor-adv-modal .trigger-item tr:only-child .trigger-condition-gate {
  display: none;
}
.json-schema-react-editor-adv-modal .trigger-item tr:only-child .trigger-condition-logic {
  padding-inline-start: 0;
}
.json-schema-react-editor-adv-modal .trigger-item:has(.react-select__control--menu-is-open) {
  z-index: 10;
}
.json-schema-react-editor-adv-modal .remove-item-container {
  grid-area: 1/2/3/3;
  display: grid;
  place-content: center;
}
.json-schema-react-editor-adv-modal .schema-trigger-condition {
  grid-area: 1/1/2/2;
  position: relative;
  z-index: 9;
}
.json-schema-react-editor-adv-modal :is(.schema-trigger-condition, .schema-trigger-action) tr:has(.react-select__control--menu-is-open) {
  position: relative;
  z-index: 9;
}
.json-schema-react-editor-adv-modal td.trigger-action-field-option {
  padding-inline-start: 0px;
}
.json-schema-react-editor-adv-modal td:is(.trigger-action-actions, .trigger-condition-actions) {
  padding-inline-end: 0px;
  width: 77px;
}
.json-schema-react-editor-adv-modal .bottom-space {
  min-height: 50px;
}

:where(.other-row, .fk-settings-container) {
  background-color: hsl(0, 50%, 100%);
}

.ant-tabs {
  overflow: initial;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
}
.ant-tabs .ant-tabs-bar {
  background-color: transparent;
  padding: 20px 28px 0px;
  border-bottom: none;
  margin-bottom: 0px;
}
.ant-tabs .ant-tabs-bar .ant-tabs-nav-container {
  height: 36px;
}
.ant-tabs .ant-tabs-bar .ant-tabs-nav-container::before {
  display: none;
}
.ant-tabs .ant-tabs-bar .ant-tabs-tab::before {
  display: none;
}
.ant-tabs .ant-tabs-bar .ant-tabs-tab.ant-tabs-tab-active {
  background-color: white;
  color: #262626;
  font-weight: 700;
}
.ant-tabs .ant-tabs-content {
  padding: 0px 28px;
  overflow-y: auto;
  flex: 1;
}
.ant-tabs .ant-tabs-content .ant-tabs-tabpane-active {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 28px;
}
.ant-tabs .ant-tabs-content .ant-tabs-tabpane-active :is(.ace_editor, .ace_layer, ace_content) {
  height: 100% !important;
}
.ant-tabs .ant-tabs-content .ant-tabs-tabpane-active > .ant-row .ant-col {
  font-weight: 600;
}

.ant-tabs-tab {
  font: normal 500 14px/20px Open Sans, sans-serif !important;
  letter-spacing: 0.005em;
  color: hsl(220, 9%, 46%);
  padding: 12px 32px !important;
  background-color: transparent !important;
  border: none !important;
  border-radius: 0px !important;
  height: initial !important;
}
.ant-tabs-tab:hover {
  color: hsl(0, 0%, 7%) !important;
}

.ant-tabs-nav-container {
  height: initial !important;
}

.ant-tabs-tab-active {
  font: normal 600 14px/20px Open Sans, sans-serif !important;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%) !important;
}

.ant-tabs-ink-bar {
  background-color: var(--system-primary-color, #002b8f) !important;
  visibility: visible !important;
}

.system-tabs {
  background-color: transparent;
}
.system-tabs .nav-tabs {
  border-bottom: none;
}

.tab-header .nav-item {
  margin-bottom: 0px;
}
.tab-header .nav-link {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  border: none;
  border-bottom-style: solid;
  border-bottom-width: 2px;
  --tab-border-color: transparent;
  border-bottom-color: var(--tab-border-color) !important;
  padding-inline: 34px;
  padding-block: 14px;
  background-color: transparent !important;
}
.tab-header .nav-link.active {
  --tab-border-color: var(--system-primary-color, #002b8f);
}

.trash-button .system-button:hover {
  --button-text-color: hsl(0, 91%, 71%);
  --button-bg-color: hsl(0, 93%, 94%);
}

.database-logo {
  max-width: 200px;
  max-height: 128px;
  display: inline-block;
  border: dashed 1px hsl(216, 12%, 84%);
  border-radius: 4px;
  padding: 5px;
}

.comparison-field-list p:last-child {
  margin-bottom: 0px;
}

.sidebar-header {
  z-index: 1255;
  position: relative;
}

.action-buttons {
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 1px 1px rgba(48, 49, 51, 0.1);
  border-radius: 6px;
  width: auto !important;
  padding: 6px 8px !important;
  margin: 16px 16px 12px !important;
  background-color: hsl(0, 50%, 100%);
  gap: 7px;
}

.add-db {
  background-color: inherit;
}
.add-db::after {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  content: "+";
  font-weight: 600;
  position: absolute;
  transform: translate(-5px, 5px);
  background: hsl(0, 50%, 100%);
  font-size: 9px;
  padding: 1px;
  border-radius: 20px;
}

.add-db-button:hover .add-db::after {
  background-color: inherit;
}

.sidebar-menu-content-container {
  background-color: hsl(210, 20%, 98%);
}

.drawer-dbs-groups {
  background-color: hsl(0, 50%, 100%);
}

.db-lists-search {
  padding: 12px 16px;
  position: sticky;
  z-index: 1;
  top: 0;
  background-color: hsl(0, 50%, 100%);
}

.db-list-group-name {
  font: normal 400 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
  color: inherit;
}

.db-list-menu {
  height: calc(100% - 30px);
}

ul.nav-menu.db-list-submenu {
  height: max-content;
}

.database-group-link {
  --group-color: transparent;
  --start-line-width: 4px;
  padding-inline-start: 16px;
  padding-inline-end: 16px;
  padding-block: 12px;
  color: hsl(0, 0%, 7%);
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: solid 1px hsl(220, 13%, 91%);
  box-shadow: inset var(--start-line-width) 0px 0px 0px var(--group-color);
  transition-property: box-shadow;
  transition-duration: 0.15s;
}
.database-group-link:is(.group-open, :hover) {
  color: hsl(223, 53%, 42%);
  background-color: hsl(223, 37%, 93%);
  --start-line-width: 8px;
}
.database-group-link.dragging-over {
  outline: dashed;
  outline-offset: -2px;
  outline-width: 2px;
  outline-color: hsl(222, 90%, 73%);
}

.db-link-item {
  padding-inline: 16px;
  padding-block: 12px;
  border-bottom: solid 1px hsl(220, 13%, 91%);
}
.db-link-item:hover {
  color: hsl(223, 53%, 42%);
  background-color: hsl(223, 37%, 93%);
}
.db-link-item[data-rbd-drag-handle-draggable-id][style*=position] {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  transition-property: background, opacity;
}

.version-date-user-container {
  display: flex;
  gap: 12px;
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(220, 9%, 46%);
  margin-top: 4px;
}

.database-list-item {
  position: relative;
}
.database-list-item .system-badge {
  position: absolute;
  inset-inline-end: 0;
  top: 0;
  margin-top: 3px;
}

.database-list-item-name {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  margin-inline-end: 50px;
}

.version-date,
.version-user {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  min-width: 1px;
}

.version-user {
  flex: 1;
  min-width: 50%;
}

.db-group-options {
  padding: 12px 16px;
  position: sticky;
  top: 0px;
  background-color: hsl(0, 50%, 100%);
  z-index: 9;
  text-align: start;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.close-databases-drawer {
  margin-inline-end: -12px;
}
.close-databases-drawer .button-icon {
  --button-icon-size: 20px;
}

:where(.db-heading-settings, .logo-settings-element-drag-drop) .config-item {
  border-top: var(--border-top-style, solid) var(--border-top-width, 1px) var(--border-top-color, hsl(225, 13%, 94%));
  min-height: 48px;
  padding-inline: 20px;
  color: hsl(0, 0%, 7%);
}
:where(.db-heading-settings, .logo-settings-element-drag-drop) [draggable]:first-child .config-item {
  --border-top-style: none;
}
:where(.db-heading-settings, .logo-settings-element-drag-drop) .accordion .toggle-icon {
  --custom-icon-size: 20px;
}

.logo-settings-element-drag-drop .config-item {
  outline: dashed 2px hsl(216, 12%, 84%);
  transform: scale(0.95);
  border-radius: 6px;
}

.multiple-control-badge {
  position: absolute;
  inset-inline-end: 0;
  width: 14px;
  height: 13px !important;
  display: grid;
  place-content: center;
  background-color: hsl(225, 13%, 94%);
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}

:is(.type-array-of-catalog, .type-array-of-file) .multiple-control-badge {
  background-color: hsl(156, 50%, 53%);
  color: hsl(0, 50%, 100%);
}

.column-filter-container {
  min-width: 50px;
  flex: 0 0 100%;
  display: flex;
  gap: 12px;
}
.column-filter-container .system-input-container {
  min-width: 50px;
}

.layer-actions {
  flex: auto;
  display: flex;
  gap: 8px;
  margin-inline-end: 16px;
  margin-inline-start: 12px;
}
.layer-actions .delete-row {
  margin-inline-end: auto;
}
.layer-actions .cancel-edit {
  margin-inline-start: auto;
}

.item-field-cell {
  font: normal 600 14px/20px Open Sans, sans-serif;
}

.rendered-value {
  white-space: pre-wrap;
  word-break: break-all;
  font: normal 400 14px/20px Open Sans, sans-serif;
  align-self: center;
}

span:has(.listing-value) {
  display: flex;
  gap: 8px;
  align-items: center;
}

.listing-value {
  margin-bottom: 6px;
}
.listing-value > .item {
  align-items: center;
  display: inline-flex;
  background-color: #e5e7eb;
  color: #121212;
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  padding-block: 0;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin: 0;
  border-radius: 4px;
}
.listing-value > .item + .item {
  margin-left: 5px;
}

.filters-container {
  padding: 16px;
}

.filters-rows-action {
  padding-top: 16px;
  gap: 10px;
}

.system-badge {
  font: normal 700 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 50%, 100%);
  background-color: hsl(223, 38%, 85%);
}
.system-badge.size-l {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  padding: 3px 6px;
  border-radius: 4px;
}
.system-badge.round {
  border-radius: 50px;
  display: inline-flex;
  padding: 0;
  width: 20px;
  justify-content: center;
}
.system-badge.red {
  color: hsl(0, 50%, 100%) !important;
  background-color: hsl(0, 91%, 71%);
}
.system-badge.small {
  font: normal 500 10px/10px Open Sans, sans-serif !important;
  letter-spacing: 0.005em;
  width: 16px;
  height: 16px;
  align-items: center;
}

.system-badge,
.badge {
  border-radius: 2px;
  padding: 2px 3px;
}

.badge {
  background-color: hsl(223, 39%, 71%);
}
.badge span {
  font: normal 700 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 50%, 100%);
}

.badge-dark {
  background-color: hsl(0, 0%, 7%);
}

.fk-badge {
  font: normal 700 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 50%, 100%);
  background-color: hsl(222, 38%, 57%);
  padding: 2px 4px 3px;
  border-radius: 4px;
}

.mirror-badge {
  font: normal 700 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: hsl(0, 50%, 100%);
  background-color: #D5B78B;
  padding: 2px 4px 3px;
  border-radius: 4px;
}
.mirror-badge i {
  font-size: 10px;
}

.tooltip .tooltip-arrow {
  background: hsl(0, 0%, 7%);
}
.tooltip .tooltip-inner {
  padding: 10px 16px;
  text-align: center;
  background-color: hsl(0, 0%, 7%);
  border-radius: 4px;
}
.tooltip:is(.bs-tooltip-top, .bs-tooltip-bottom) {
  padding-block: 10px;
}
.tooltip:is(.bs-tooltip-top, .bs-tooltip-bottom) .tooltip-arrow {
  left: initial;
  inset-inline-start: 50%;
  width: 14px;
  height: 8px;
}
.tooltip.bs-tooltip-top .tooltip-arrow {
  clip-path: polygon(0 0, 100% 0, 54% 100%, 46% 100%);
  bottom: 2px;
}
.tooltip.bs-tooltip-bottom .tooltip-arrow {
  clip-path: polygon(46% 0, 54% 0, 100% 100%, 0 100%);
  top: 2px;
}
.tooltip:is(.bs-tooltip-start, .bs-tooltip-end) {
  padding-block: 0px;
  padding-inline: 10px;
}
.tooltip:is(.bs-tooltip-start, .bs-tooltip-end) .tooltip-arrow {
  width: 8px;
  height: 14px;
}
.tooltip.bs-tooltip-start .tooltip-arrow {
  clip-path: polygon(0 0, 100% 44%, 100% 54%, 0% 100%);
  inset-inline-end: 2px;
}
.tooltip.bs-tooltip-end .tooltip-arrow {
  clip-path: polygon(0 46%, 100% 0, 100% 100%, 0 54%);
  inset-inline-start: 2px;
}

.modal-content {
  border-radius: 10px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1);
}
.modal-content .modal-title {
  font: normal 500 22px/28px Open Sans, sans-serif;
}
.modal-content .modal-body {
  padding: 1rem !important;
}
.modal-content .modal-body.with-footer {
  max-height: calc(100vh - 140px);
}

.data-read-value-page-container {
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.09);
  border-radius: 6px;
  background-color: hsl(0, 50%, 100%);
  padding: 1.5rem;
  margin: 0 auto 20px;
  overflow-x: auto;
}
.data-read-value-page-container .database-metadata .general-info.institution {
  font: normal 500 22px/28px Open Sans, sans-serif;
  margin-bottom: 8px;
}
.data-read-value-page-container .database-metadata .general-info.description {
  font: normal 400 16px/24px Open Sans, sans-serif;
}
.data-read-value-page-container .database-metadata:has(.institution:empty):has(.description:empty) {
  display: none;
}
.data-read-value-page-container .field-tree-list:empty {
  display: none;
}
.data-read-value-page-container .field-tree:not(:first-child) {
  margin-top: 1rem;
}
.data-read-value-page-container .field-tree .data-read-value-field {
  margin-inline-start: 16px;
}
.data-read-value-page-container .field-tree .data-read-value-field .field-value {
  font-size: 24px;
  line-height: 1.2;
  font-weight: 500;
}
.data-read-value-page-container .field-tree .data-read-value-field .field-description {
  margin-top: 6px;
}
.data-read-value-page-container .file-list-item {
  display: flex;
  padding-block: 8px;
  gap: 10px;
  border-radius: 6px;
  align-items: center;
}
.data-read-value-page-container li:where(.active, :hover) .file-list-item {
  background: #ebf1f7;
  box-shadow: -14px 0 0 #ebf1f7, 14px 0 0 #ebf1f7;
}
.data-read-value-page-container .file-icon {
  font-size: 30px;
}
.data-read-value-page-container .file-icon::after {
  content: "\\f15b";
  color: #363030;
}
.data-read-value-page-container .file-ext-pdf::after {
  content: "\\f1c1";
  color: #FE4534;
}
.data-read-value-page-container .file-ext-doc::after,
.data-read-value-page-container .file-ext-docx::after {
  content: "\\f1c2";
  color: #2C589B;
}
.data-read-value-page-container .file-ext-jpg::after,
.data-read-value-page-container .file-ext-gif::after,
.data-read-value-page-container .file-ext-bmp::after,
.data-read-value-page-container .file-ext-jpeg::after,
.data-read-value-page-container .file-ext-tiff::after,
.data-read-value-page-container .file-ext-png::after {
  content: "\\f1c5";
  color: #4DABE6;
}
.data-read-value-page-container .file-list-item-icon {
  padding-top: 3px;
  min-width: 30px;
}
.data-read-value-page-container .file-list-item-info {
  display: grid;
}
.data-read-value-page-container .file-list-item-info .file-name {
  color: #4678AA;
}
.data-read-value-page-container .file-list-item-info .file-size {
  color: #363030;
  line-height: 1;
}
.data-read-value-page-container .file-preview {
  padding-top: 16px !important;
  margin-top: 28px;
  position: relative;
  isolation: isolate;
}
.data-read-value-page-container .file-preview::before {
  content: "";
  height: 1px;
  display: block;
  background-color: #E4E4E4;
  width: calc(100% + 3rem);
  position: absolute;
  left: -1.5rem;
  top: 0;
}
.data-read-value-page-container .file-viewer-button {
  margin-inline-start: auto;
  display: inline-flex;
  gap: 6px;
  align-items: baseline;
  font-weight: 600;
}
.data-read-value-page-container .file-viewer-container {
  padding: 10px;
  border-radius: 6px;
  border: solid 1px #EBEBEB;
}

.json-data-view-object-item tr:not(.field-type-object) .item-value-cell {
  align-items: center;
}
.json-data-view-object-item tr:not(.field-type-object) .item-value-cell .system-input-container.textarea.like-field {
  margin-block: 6px;
}

.history-icon {
  color: hsl(223, 39%, 71%);
}

.field-history {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.field-history .db-audit-field-log-list-table .rt-table {
  overflow-x: auto !important;
}
.field-history-modal .modal-content > div > div {
  min-width: initial !important;
}
.field-history-info {
  margin-bottom: 1.5rem;
}
.field-history-info .info-heading {
  font-weight: 400;
  color: #4B4B4B;
}
.field-history-info .info-value {
  font-weight: 600;
  color: #222222;
}
.field-history-info :where(th, td) + :where(th, td) {
  padding-inline-start: 16px;
}

.block-history {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.history-entries {
  display: flex;
  overflow-x: auto;
  padding-bottom: 16px;
}

.history-item {
  min-width: 150px;
  border: solid 1px hsl(225, 13%, 94%);
}
.history-item.selected {
  background-color: hsl(223, 37%, 93%);
  transition-duration: 0.15s;
}
.history-item-date {
  padding: 6px 10px;
  font-weight: 600;
}
.history-item-field .pointer {
  align-items: center;
  justify-content: space-between;
}
.history-item-field .pointer:hover {
  background-color: hsl(225, 13%, 94%);
}
.history-item-field.selected .pointer {
  background-color: hsl(223, 38%, 85%);
}
.history-item .item-field-name {
  display: flex;
  padding: 6px 10px;
  gap: 10px;
}

.row-history .json-data-view-object-item tbody tr:hover > td {
  background-color: var(--hover-bg);
}
.row-history .json-data-view-object-item tbody td {
  --hover-bg: hsl(210, 20%, 98%);
}
.row-history .json-data-view-object-item tbody td td {
  --hover-bg: hsl(225, 13%, 94%);
}
.row-history .json-data-view-object-item tbody td td td {
  --hover-bg: hsl(220, 13%, 91%);
}
.row-history .json-data-view-object-item tbody td td td td {
  --hover-bg: hsl(216, 12%, 84%);
}

.json-data-view {
  padding-bottom: 10px;
}
.json-data-view section article:not(.object-parent-item) {
  display: flex;
  gap: 10px;
  padding-block: 5px;
}
.json-data-view section article + article:not(.object-parent-item) {
  border-top: var(--jdv-border-style, solid) var(--jdv-border-top-width, 1px) var(--border-top-color, #e5e7eb);
}
.json-data-view section article:is(.field-type-object, .field-type-array) {
  flex-direction: column;
  padding-block: 0px;
  gap: 0px;
}
.json-data-view section article:is(.field-type-object, .field-type-array) > .item-fieldname-cell {
  padding-block: 5px;
  width: auto;
  background-color: hsl(220, 14%, 96%);
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  flex-basis: initial;
}
.json-data-view section article:is(.field-type-object, .field-type-array).collapsed > .item-fieldname-cell {
  background-color: hsl(210, 20%, 98%);
}
.json-data-view section article:is(.field-type-object, .field-type-array).collapsed > .item-value-cell {
  display: none;
}
.json-data-view section article:is(.field-type-object, .field-type-array).collapsed:last-child > .item-fieldname-cell {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.json-data-view section article.object-parent-item:not(.field-type-catalog).collapsed > section {
  display: none;
}
.json-data-view section article.field-type-object > .item-value-cell {
  padding-inline-end: 0px;
}
.json-data-view section article.field-type-object > .item-value-cell > :is(.json-data-view-object-item, .json-data-view-array) > article:first-child {
  border-top: var(--jdv-border-style, solid) var(--jdv-border-top-width, 1px) var(--border-top-color, #e5e7eb);
}
.json-data-view section article.field-type-object > .item-value-cell > :is(.json-data-view-object-item, .json-data-view-array) > article > .item-fieldname-cell {
  padding-inline-start: calc(var(--jdv-base-item-start-padding) + var(--level) * var(--jdv-row-offset));
}
.json-data-view section article.field-type-array > .item-value-cell {
  padding-inline-end: 0px;
}
.json-data-view section article.field-type-array > .item-value-cell .item-fieldname-cell {
  padding-inline-start: calc(var(--jdv-base-item-start-padding) + var(--level) * var(--jdv-row-offset));
}
.json-data-view section.root-item.json-data-view-array > article {
  background-color: hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  border-radius: 10px;
}
.json-data-view section.root-item.json-data-view-array > article + article {
  margin-top: 24px;
}
.json-data-view section.root-item.json-data-view-object-item {
  background-color: hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  border-radius: 10px;
}
.json-data-view .array-header-collapsible.level-0 {
  border-bottom: solid 1px hsl(225, 13%, 94%);
  min-height: 65px;
  padding-inline-end: 6px;
  padding-inline-start: 20px;
}
.json-data-view .array-header-collapsible:not(.level-0) {
  padding-inline-start: calc(var(--jdv-base-item-start-padding) + var(--level) * var(--jdv-row-offset));
  padding-inline-end: 6px;
  padding-block: 6px;
  border-bottom: solid 1px hsl(225, 13%, 94%);
}
.json-data-view .sub-detail-title {
  font: normal 700 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
}
.json-data-view .item-fieldname-cell {
  flex-basis: 240px;
  min-width: 25%;
  padding-inline-start: var(--jdv-base-item-start-padding);
}
.json-data-view .item-value-cell {
  min-width: 200px;
  flex: 1;
  padding-inline-end: 6px;
}
.json-data-view :is(.rendered-value, .item-fieldname-cell) {
  padding-block: 8px;
}
.json-data-view .toggle-entry {
  margin-inline-start: -12px;
}
.json-data-view .field-type-array_of_file .item-value-cell > div {
  display: flex;
  justify-content: space-between;
}
.json-data-view .field-type-catalog > .item-value-cell > .json-data-view-object-item > article:first-child {
  padding-top: 0px;
}
.json-data-view .field-type-catalog > .item-value-cell > .json-data-view-object-item > article:last-child {
  padding-bottom: 0px;
}
.json-data-view .field-type-catalog > .item-value-cell > .json-data-view-object-item > article > .item-fieldname-cell {
  padding-inline-start: 0px;
}
.json-data-view .field-type-array_of_catalog > .item-value-cell {
  padding-inline-end: 0px;
}
.json-data-view .field-type-array_of_catalog > .item-value-cell .item-fieldname-cell {
  padding-inline-start: 0px;
}
.json-data-view .field-type-array_of_catalog > .item-value-cell .file-multiple-add {
  margin-inline-start: 0px;
}
.json-data-view .field-type-array_of_catalog > .item-value-cell .field-type-catalog:has(> .can-remove-item button:hover) {
  background-color: hsl(0, 93%, 94%);
}
.json-data-view .field-type-array_of_catalog > .item-value-cell .field-type-catalog + .field-type-catalog {
  border-top: solid 1px hsl(218, 11%, 65%);
}
.json-data-view :is(.field-type-date, .field-type-datetime) .rdtPicker {
  position: absolute !important;
}
.json-data-view :is(.field-type-date, .field-type-datetime) .rdtPicker::after {
  content: "";
  display: block;
  height: 36px;
  margin-bottom: -36px;
}
.json-data-view.editor-mode .field-type-array .field-type-object.object-parent-item {
  display: flex;
}
.json-data-view.editor-mode .field-type-array .field-type-object.object-parent-item:has(> .can-remove-item button:hover) {
  background-color: hsl(0, 93%, 94%);
}
.json-data-view.editor-mode .field-type-array .field-type-object.object-parent-item > .can-remove-item {
  position: absolute;
  inset-inline-end: 62px;
  margin-top: 6px;
}
.json-data-view.editor-mode .field-type-array_of_file .item-value-cell > div {
  flex-direction: column;
}
.json-data-view.editor-mode .field-type-array_of_file .item-value-cell > div .json-data-view-array .field-type-file {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.json-data-view.editor-mode .field-type-array_of_file .item-value-cell > div .json-data-view-array .field-type-file + .field-type-file {
  margin-top: 8px;
}
.json-data-view.editor-mode .field-type-array_of_file .file-multiple-add {
  margin-inline-start: 0px;
}
.json-data-view.editor-mode .field-type-array_of_file .upload-component-container {
  gap: 8px;
}
.json-data-view.editor-mode .file-multiple-add {
  margin-top: 10px;
  margin-bottom: 8px;
  margin-inline-start: calc(var(--jdv-base-item-start-padding) + var(--level) * var(--jdv-row-offset));
}
.json-data-view.editor-mode :is(.field-type-catalog, .field-type-array_of_catalog) > .item-value-cell {
  padding-inline-end: 0px;
}

.ck .ck-widget.mustache-placeholder {
  cursor: grab;
  border-radius: 6px;
  padding-inline: 2px;
}
.ck .ck-widget.mustache-placeholder::before, .ck .ck-widget.mustache-placeholder::after {
  font-family: "Font Awesome 6 Pro";
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  font-weight: 400;
  font-size: 115%;
  transform: translateY(1px);
}
.ck .ck-widget.mustache-placeholder::before {
  content: "{";
}
.ck .ck-widget.mustache-placeholder::after {
  content: "}";
}
.ck .ck-widget.mustache-placeholder:hover {
  outline-color: hsl(222, 90%, 73%);
}
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
  background-color: hsl(210, 20%, 98%);
}

.reminder-message-editor {
  height: 100%;
}
.reminder-message-editor .ck-editor {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}
.reminder-message-editor .ck-editor .ck-editor__main {
  flex: 1;
}
.reminder-message-editor .ck-editor .ck-editor__main .ck-content {
  height: 100%;
}

.reminder-pane-title {
  font: normal 600 22px/28px Open Sans, sans-serif;
  color: hsl(221, 39%, 11%);
}

.reports-drawer-open > .Pane1 {
  padding-inline-end: 24px;
  max-width: calc(100% - 340px);
}
.reports-drawer-open .Pane2 {
  z-index: 100;
  background: #F1F5FF;
  height: 100vh;
  transform: translateY(-105px);
  margin-inline-end: -40px;
  padding-inline: 20px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
}
.reports-drawer-open .Pane2 .Pane.vertical {
  overflow: visible;
}
.reports-drawer-open .Resizer {
  z-index: 101;
  --custom-resizer-top-margin: -105px;
  margin-top: var(--custom-resizer-top-margin) !important;
  background: transparent;
}
.reports-drawer-open .Resizer:hover {
  background: hsl(216, 12%, 84%);
}
.reports-drawer-open .wrapper-header {
  height: 80px;
  background: hsl(0, 50%, 100%);
  margin-inline: -20px;
  padding-inline: 24px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
}
.reports-drawer-open .wrapper-header .modal-title {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 0 0.5rem;
  height: 100%;
  font: normal 500 22px/28px Open Sans, sans-serif;
}
.reports-drawer-open .wrapper-header .modal-title .layer-actions .system-button:last-child {
  margin-inline-end: -10px;
}
.reports-drawer-open .wrapper-body {
  padding-block: 24px;
  height: calc(100vh - 80px);
}
.reports-drawer-open .view-report-settings {
  max-height: 100%;
  min-height: 100%;
  overflow-y: auto;
}
.reports-drawer-open .view-report-settings .field-item {
  border-radius: 10px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  padding: 24px;
  background-color: hsl(0, 50%, 100%);
  position: relative;
}
.reports-drawer-open .view-report-settings .field-item .system-input-container.select .type-select-style .react-select__option > span:has(.count) {
  display: flex;
  gap: 6px;
  align-items: baseline;
}
.reports-drawer-open .view-report-settings > .view-fields {
  padding-inline: 4px;
  padding-bottom: 4px;
}
.reports-drawer-open .drag-handle {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
  border-radius: 4px;
  font-size: 12px;
  width: 20px;
  height: 20px;
  display: grid;
  place-content: center;
  color: hsl(218, 11%, 65%);
}
.reports-drawer-open .view-fields > div + div {
  margin-top: 16px;
}
.reports-drawer-open .view-fields [data-rbd-draggable-context-id][style*=left] {
  left: initial !important;
  scale: 0.98;
  opacity: 0.6;
}
.reports-drawer-open .view-sub-fields {
  margin-top: 12px;
}
.reports-drawer-open .view-sub-fields .field-item {
  border: solid 1px hsl(225, 13%, 94%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 1px 1px rgba(48, 49, 51, 0.1);
}
.reports-drawer-open .view-sub-fields > div + div {
  margin-top: 16px;
}
.reports-drawer-open .group-by-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}
.reports-drawer-open .group-by-toggle span {
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(218, 11%, 65%);
}
.reports-drawer-open .group-by-toggle i {
  font-size: 24px;
  line-height: 18px;
}
.reports-drawer-open .count {
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(218, 11%, 65%);
  background-color: hsl(225, 13%, 94%);
  padding: 0px 5px;
  border-radius: 4px;
}
.reports-drawer-open .field-item.item-collapsed .view-sub-fields {
  display: none;
}
.reports-drawer-open .field-item.item-collapsed > .system-label {
  margin-bottom: 0;
}

.report-detail {
  display: grid;
  height: 100%;
  grid-template-rows: min-content auto 50px;
  max-width: 100%;
  overflow-x: hidden;
  grid-gap: 10px;
}
.report-detail .filters-block {
  margin-top: 1rem;
  text-align: start;
}
.report-detail .report-general-info:empty + .filters-block {
  margin-top: 0;
}

.report-info-label {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(218, 11%, 65%);
}

.report-info-value {
  font: normal 500 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
  color: hsl(0, 0%, 7%);
}

.report-filter-entry-group {
  padding: 4px;
  border: solid 1px hsl(216, 12%, 84%);
  border-radius: 4px;
}

:where(.report-filter-entry-group, .report-filter-entry) {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.report-filter-entry .system-badge {
  display: inline-flex;
  column-gap: 6px;
}

.report-applied-filters {
  gap: 6px;
  display: flex;
  flex-wrap: wrap;
}

.filter-logic {
  color: hsl(0, 0%, 7%);
  font-weight: 700;
}

.filters-rows-action .addReport {
  display: none !important;
}

.add-report-form-container {
  width: 500px;
}

.flex-one {
  flex: 1;
}

.report-table {
  max-width: 100%;
  overflow-x: hidden;
}
.report-table .type-array_of_file {
  gap: 12px;
}

.report-table .table-scrollbar {
  background-color: rgba(0, 0, 0, 0.02);
  height: 9px;
}

.report-table .table-scrollbar:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.report-export {
  justify-content: flex-end;
  display: flex;
  align-items: center;
}

.report-options {
  display: flex;
  justify-content: flex-end;
}

.add-sort-field {
  margin-block: -8px;
}

.report-columns-toggler {
  flex-wrap: wrap;
}
.report-columns-toggler .system-badge {
  color: hsl(0, 50%, 100%) !important;
}

:where(.views-source-table-header, .views-target-table-header) {
  font: normal 700 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  background-color: hsl(225, 13%, 94%);
  color: hsl(0, 0%, 7%);
  border-radius: 6px;
  position: sticky;
  top: 0;
}
:where(.views-source-table-header, .views-target-table-header) + .tree-items {
  margin-top: 10px;
}

.views-source-table-grid {
  --rw: (100% - 36px) - 20px;
  --offset: 0px;
  grid-template-columns: calc(36px + var(--offset)) calc((var(--rw)) * 0.7 - var(--offset)) calc((var(--rw)) * 0.3);
  gap: 10px;
}

.views-target-table-grid {
  --rw: (100% - 144px) - 50px;
  --offset: 0px;
  gap: 10px;
  grid-template-columns: calc(72px + var(--offset)) calc((var(--rw)) * 0.3 - var(--offset)) calc((var(--rw)) * 0.3) calc((var(--rw)) * 0.2) calc((var(--rw)) * 0.2) 72px;
}

:where(.views-source-table-header, .views-source-table-entry, .views-target-table-header) > div {
  padding-block: 8px;
}

:where(.views-source-table-entry, .views-target-table-entry) {
  border-radius: 4px;
}
:where(.views-source-table-entry, .views-target-table-entry):hover {
  background-color: hsl(210, 20%, 98%);
}

.views-source-table-entry {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.views-source-table-entry:has(.toggle-entry) {
  background-color: hsl(210, 20%, 98%);
}

.views-target-table-entry {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  align-items: baseline;
  margin-top: 2px;
}
.views-target-table-entry .entry-toggler {
  border-radius: 4px 0 0 4px;
}
.views-target-table-entry:is(.field-type-object, .field-type-array) {
  font: normal 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.views-target-table-entry.field-type-array {
  background-color: hsl(225, 13%, 94%);
}
.views-target-table-entry.field-type-object {
  background-color: hsl(223, 37%, 93%);
}

.views-source-fields-pane .nav-tabs {
  margin-bottom: 10px;
  border: none;
}
.views-source-fields-pane .toggle-entry {
  width: 36px;
  display: grid;
  place-content: center;
  border-radius: 4px 0 0 4px;
  height: calc(100% + 16px);
  margin-top: -8px;
}
.views-source-fields-pane .toggle-entry:hover {
  background-color: hsl(225, 13%, 94%);
}
.views-source-fields-pane .nav-link {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(220, 9%, 46%);
  padding-block: 12px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.views-source-fields-pane .nav-link:where(:hover, .active) {
  color: hsl(0, 0%, 7%) !important;
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  border: none;
  border-color: hsl(222, 38%, 57%) !important;
  border-bottom: solid 2px;
}

.source-entry-toggler {
  display: flex;
  justify-content: flex-end;
}

.entry-handler {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
}
.entry-handler span {
  display: grid;
  width: 36px;
  height: 36px;
  place-content: center;
}
.entry-handler span:hover {
  background-color: hsl(225, 13%, 94%);
}
.entry-handler + div:not(.entry-column):last-child {
  display: contents;
}
.entry-handler + div:not(.entry-column):last-child .entry-actions {
  grid-column: 6;
  text-align: end;
}
.entry-handler .view-deleted-field-notification-dot {
  width: 36px;
  text-align: center;
}

.entry-column {
  padding-block: 5px;
}

.tree-items .views-source-table-grid + .tree-items .views-source-table-entry {
  --offset: 36px;
}
.tree-items .views-source-table-grid + .tree-items .views-source-table-entry + .tree-items .views-source-table-grid {
  --offset: 48px;
}
.tree-items .views-source-table-grid + .tree-items .views-source-table-entry + .tree-items .views-source-table-grid + .tree-items .views-source-table-grid {
  --offset: 72px;
}
.tree-items .views-source-table-grid + .tree-items .views-source-table-entry + .tree-items .views-source-table-grid + .tree-items .views-source-table-grid + .tree-items .views-source-table-grid {
  --offset: 96px;
}

.tree-item > .tree-items > .tree-item .views-target-table-grid {
  --offset: 36px;
}
.tree-item > .tree-items > .tree-item .views-target-table-grid + .tree-items .views-target-table-grid {
  --offset: 72px;
}
.tree-item > .tree-items > .tree-item .views-target-table-grid + .tree-items .views-target-table-grid + .tree-items .views-target-table-grid {
  --offset: 108px;
}
.tree-item > .tree-items > .tree-item .views-target-table-grid + .tree-items .views-target-table-grid + .tree-items .views-target-table-grid + .tree-items .views-target-table-grid {
  --offset: 144px;
}

.views-target-fields-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: fit-content;
}
.views-target-fields-pane :not(.empty-items) .placeholder,
.views-target-fields-pane .empty-items {
  display: grid;
  place-content: center;
  border: dashed 2px hsl(220, 13%, 91%);
  text-align: center;
  border-radius: 6px;
  min-height: 300px;
}
.views-target-fields-pane .empty-items {
  flex: auto;
}
.views-target-fields-pane :not(.empty-items) .placeholder {
  height: auto;
  margin-top: 10px;
}
.views-target-fields-pane :not(.empty-items) .placeholder button {
  justify-self: center;
}
.views-target-fields-pane .tree-item .empty-items {
  min-height: 50px;
}
.views-target-fields-pane .tree-item .tree-items.item-dragging-over {
  border: dashed 2px hsl(222, 90%, 73%);
}
.views-target-fields-pane .item-dragging-over {
  border-color: hsl(222, 90%, 73%);
}
.views-target-fields-pane .item-dragging-over > div:not([class]) {
  background-color: hsl(210, 20%, 98%);
  border-radius: 6px;
  max-width: 98%;
  margin: 0 auto !important;
}
.views-target-fields-pane h4 {
  font: normal 600 22px/28px Open Sans, sans-serif;
  margin-bottom: 22px;
  margin-top: 4px;
}

.drop-drag-fields-view:has(.views-source-fields-pane > .nav-tabs) .views-target-table-header {
  margin-top: 55px;
}

.data-view-field-list-table.target-table {
  flex: auto;
  height: initial;
}

.SplitPane {
  padding: 5px;
  margin: -5px;
}
.SplitPane .Pane2 .Pane {
  overflow-y: auto;
}

.tree-items.item-dragging-over {
  background: transparent;
}

.tree-item-name {
  display: flex;
  align-items: center;
}

.tree-dnd-item .tree-item {
  background-color: hsl(0, 50%, 100%);
  border-radius: 6px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.08);
  outline: dashed 1px hsl(225, 13%, 94%);
}

.view-deleted-field-notification-dot {
  color: hsl(0, 91%, 71%);
  position: sticky;
  inset-inline-end: 0px;
  margin-inline-start: 0px;
}
.view-deleted-field-notification-dot i {
  transform: translateX(13px);
}

.views-source-group-selector {
  margin-bottom: 8px;
}
.views-source-group-selector:focus-within {
  margin-bottom: 5px;
}

.join-databases {
  text-align: start;
}

.applied-reports.system-data-table.data-list-container.data-view-list-container .react-table .rt-table :is(.rt-thead, .rt-tfoot) .tr {
  background-color: hsl(225, 13%, 94%);
}
.applied-reports.system-data-table.data-list-container.data-view-list-container .react-table .rt-table :is(.th, .td) {
  flex: initial !important;
}
.applied-reports.system-data-table.data-list-container.data-view-list-container .react-table .rt-table .rt-tbody .tr:hover {
  background-color: hsl(210, 20%, 98%);
}
.applied-reports.system-data-table.data-list-container.data-view-list-container .react-table .rt-table .rt-tfoot {
  min-width: fit-content;
}

.view-groups {
  margin: 8px;
}
.view-groups:has(button:only-child) {
  padding-block: 10px;
}
.view-groups.empty {
  display: grid;
  place-content: center;
  height: calc(100% - 24px);
  gap: 16px;
  background: hsl(0, 50%, 100%);
  border-radius: 8px;
  border: dashed 2px hsl(220, 13%, 91%);
}
.view-groups.empty .empty-message {
  font: normal 500 16px/24px Open Sans, sans-serif;
  letter-spacing: 0.002em;
  color: hsl(0, 0%, 7%);
}
.view-groups.empty button {
  justify-self: center;
  width: fit-content;
}
.view-groups > button:not(:only-child):last-child {
  margin-top: 32px;
}
.view-groups > div + div {
  margin-top: 4px;
}
.view-groups > div[style*="position: fixed;"] {
  left: initial !important;
  opacity: 0.5;
  zoom: 0.98;
}
.view-groups > div[style*="position: fixed;"] .data-view-list-group-item {
  outline: dashed 1px hsl(218, 11%, 65%);
}

.data-view-list-group-item {
  gap: 12px;
  padding: 4px;
  align-items: center;
  justify-content: start;
  display: flex;
  background-color: hsl(220, 14%, 96%);
  border-radius: 6px;
}

.diagram-menu {
  position: absolute;
  top: calc(50vh - 212px);
  inset-inline-end: 12px;
}
.diagram-menu ul {
  border-radius: 8px;
  background-color: hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 1px 1px rgba(48, 49, 51, 0.1);
  padding: 8px;
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  gap: 12px;
  list-style: none;
}
.diagram-menu ul li {
  display: flex;
  flex-direction: column;
}

.entity-relationship-node .node-header {
  background-color: var(--node-color);
}
.entity-relationship-node .node-header.summarised {
  background-color: hsl(0, 50%, 100%);
  border: solid 1px var(--node-color);
  color: var(--node-color);
}
.entity-relationship-node .node-header.summarised .toggle-icon {
  color: var(--node-color);
}
.entity-relationship-node .node-header.summarised ~ .node-reduced-toggler, .entity-relationship-node .node-header.summarised ~ .nodes-list .expand-collapse-all {
  display: none;
}
.entity-relationship-node.view-minimal {
  background: transparent;
  box-shadow: none;
}
.entity-relationship-node.view-minimal .node-description {
  display: block;
  position: absolute;
  top: -110px;
  inset-inline-start: 50%;
  transform: translateX(-50%);
}
.entity-relationship-node.view-minimal .nodes-list {
  background: white;
  border-bottom-left-radius: 10px;
}

.rows-reduced-collapsed .nodes-list {
  max-height: 314px;
  overflow: hidden;
}

.node-reduced-toggler {
  padding: 10px 20px 18px;
  border-top: solid 1px hsl(216, 12%, 84%);
}
.node-reduced-toggler:hover {
  background-color: hsl(210, 20%, 98%);
}

.data-import-container {
  font: normal 400 14px/20px Open Sans, sans-serif;
}

.system-button:where(.btn, .btn-secondary) span.export-progress {
  background-color: hsl(0, 0%, 7%);
  border-radius: 4px;
  color: hsl(0, 50%, 100%) !important;
  display: block !important;
  font-size: 12px !important;
  opacity: 0.88;
  padding: 5px 10px;
  position: absolute;
  top: 0;
  -webkit-animation: slide-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-top {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
  }
}
@keyframes slide-top {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
  }
}
.flow-root {
  display: flow-root;
}

.display-contents {
  display: contents;
}

.translate-y {
  transform: translateY(var(--translate-y-value));
}

.column-gap {
  column-gap: var(--column-gap, 0px);
}

.row-grid {
  display: grid;
  grid-template-columns: repeat(var(--columns-count, auto), 1fr);
}

.grid-span-column {
  grid-column: var(--columns-span);
}

.bordered-columns {
  border: solid 1px hsl(220, 13%, 91%);
  border-radius: 8px;
  padding: 20px;
}

.mx-start-1 {
  margin-inline-start: 0.25rem !important;
}
.mx-start-2 {
  margin-inline-start: 0.5rem !important;
}
.mx-start-3 {
  margin-inline-start: 1rem !important;
}
.mx-start-4 {
  margin-inline-start: 1.5rem !important;
}
.mx-start-5 {
  margin-inline-start: 3rem !important;
}
.mx-start-auto {
  margin-inline-start: auto !important;
}

.mx-end-1 {
  margin-inline-end: 0.25rem !important;
}
.mx-end-2 {
  margin-inline-end: 0.5rem !important;
}
.mx-end-3 {
  margin-inline-end: 1rem !important;
}
.mx-end-4 {
  margin-inline-end: 1.5rem !important;
}
.mx-end-5 {
  margin-inline-end: 3rem !important;
}
.mx-end-auto {
  margin-inline-end: auto !important;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-track {
  background: hsl(225, 13%, 94%) !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: hsl(218, 11%, 65%);
}

::-webkit-scrollbar-thumb:window-inactive {
  background: hsl(220, 13%, 91%);
}

.react-table .rt-table .rt-tbody .tr .td {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  align-items: center;
  place-content: center start;
}
.react-table .rt-table .rt-tbody .tr .td span {
  vertical-align: baseline;
}
.react-table .rt-table .rt-tbody .tr .td.link-cell .system-button {
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.td.type-array_of_catalog .item + .item {
  border-inline-start: solid 1px hsl(216, 12%, 84%);
  padding-inline-start: 6px;
  margin-inline-start: 6px;
}
.td.type-array_of_catalog:hover .item + .item {
  border-inline-start-color: hsl(215, 14%, 34%);
}

.table-row-actions-cell {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  opacity: 0;
}

.filters-table-container:not(:empty) {
  margin-top: 10px;
}

:is(.data-filter-table, .data-aggregate-table) {
  table-layout: auto;
  width: 100%;
}
:is(.data-filter-table, .data-aggregate-table) tr {
  position: relative;
  z-index: var(--filter-index);
}
:is(.data-filter-table, .data-aggregate-table) tr td {
  padding-inline-start: 0px;
  padding-inline-end: 12px;
  padding-block-start: 12px;
  padding-block-end: 0px;
}
:is(.data-filter-table, .data-aggregate-table) tr .options-buttons-column {
  width: 72px;
  min-width: 72px;
  padding-inline-end: 0px;
}
:is(.data-filter-table, .data-aggregate-table) tr:first-child td {
  padding-block-start: 0px;
}
:is(.data-filter-table, .data-aggregate-table) tr:first-child .logic-operator .system-input-container {
  display: none;
}
:is(.data-filter-table, .data-aggregate-table) tr:first-child .options-buttons-column {
  width: 72px;
  min-width: 72px;
}
:is(.data-filter-table, .data-aggregate-table) tr:only-child .logic-operator {
  padding-inline-end: 0px;
  width: 0px;
}
:is(.data-filter-table, .data-aggregate-table) tr .logic-operator {
  width: 150px;
}
:is(.data-filter-table, .data-aggregate-table) tr .filter-value-column {
  width: 40%;
}
:is(.data-filter-table, .data-aggregate-table) tr .filter-value-column > .select .type-select-style {
  z-index: var(--filter-index);
}
:is(.data-filter-table, .data-aggregate-table) tr .filter-operator-column {
  width: 20%;
}
:is(.data-filter-table, .data-aggregate-table) tr .filter-field-column {
  width: 40%;
  min-width: 200px;
}
:is(.data-filter-table, .data-aggregate-table) tr.filter-group-row .data-filter-table tbody {
  padding: 10px;
  display: block;
  border-radius: 6px;
  border: solid 1px hsl(216, 12%, 84%);
  transition-property: background-color;
  transition-duration: 0.15s;
}
:is(.data-filter-table, .data-aggregate-table) tr.filter-group-row .data-filter-table tbody:hover {
  background-color: hsl(210, 20%, 98%);
}
:is(.data-filter-table, .data-aggregate-table) tr.filter-group-row .data-filter-table tbody:hover tbody {
  background-color: hsl(0, 50%, 100%);
}
:is(.data-filter-table, .data-aggregate-table) tr .expression-operand {
  width: 240px;
}
:is(.data-filter-table, .data-aggregate-table) tr .function-column {
  width: 20%;
  min-width: 200px;
}
:is(.data-filter-table, .data-aggregate-table) tr:has(.react-select__control--menu-is-open) {
  z-index: 99;
}

.imported-table th {
  background-color: hsl(225, 13%, 94%);
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  padding-inline: 16px;
  padding-block: 10px;
}
.imported-table td {
  --inline-padding: 16px;
  --block-padding: 6px;
}

.imported-file-table td,
.imported-db-table td {
  --block-padding: 16px;
}

.header-vertical-align-middle {
  align-items: center;
}

.modal-dialog.layer {
  position: fixed;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  height: 100vh;
}
.modal-dialog.layer .modal-content {
  border: none;
  border-radius: 0;
  height: 100%;
}
.modal-dialog.layer .modal-body {
  height: calc(100vh - 70px);
  overflow-y: auto;
  background-color: hsl(210, 20%, 98%);
}
.modal-dialog.layer .modal-footer {
  position: fixed;
  bottom: 1px;
  inset-inline-end: 1px;
  inset-inline-start: 1px;
}
.modal-dialog.layer .modal-footer:empty {
  display: none;
}
.modal-dialog.layer .table-responsive-material {
  position: relative;
}
.modal-dialog.layer.modal-align-left {
  inset-inline-end: auto;
}

.modal-wrapper-container {
  display: flex;
  flex: auto;
}

.drawer-container {
  display: flex;
  flex-direction: column;
  min-width: 100px;
  max-width: 99vw;
}
.drawer-container .modal-header {
  min-height: var(--app-header-height);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  background-color: hsl(0, 50%, 100%) !important;
  align-items: center;
  z-index: 1;
}
.drawer-container .modal-header .close {
  width: 48px;
  height: 48px;
  min-width: 48px;
  appearance: none;
  font-family: "Font Awesome 6 Pro";
  font-weight: 400;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  opacity: 1;
  font-size: 20px;
  color: hsl(0, 0%, 7%);
  margin-inline: -10px;
  border-radius: 6px;
  transition-duration: 0.15s;
  transition-property: background-color;
}
.drawer-container .modal-header .close span {
  display: none;
}
.drawer-container .modal-header .close:hover {
  background-color: hsl(225, 13%, 94%);
}
.drawer-container .modal-header .close::before {
  content: "\\f00d";
}
.drawer-container .modal-header .close:focus, .drawer-container .modal-header .close:focus-visible {
  outline: none;
  background-color: hsl(220, 13%, 91%);
}
.drawer-container .modal-header button[class=btn-close] {
  color: hsl(0, 0%, 7%);
  border: none;
  padding: 0;
  width: 48px;
  height: 48px;
  cursor: pointer;
  display: grid;
  place-content: center;
  border-radius: 6px;
  transition-duration: 0.15s;
  transition-property: background-color;
}
.drawer-container .modal-header button[class=btn-close]:hover {
  background-color: hsl(225, 13%, 94%);
}
.drawer-container .modal-header button[class=btn-close]:focus, .drawer-container .modal-header button[class=btn-close]:focus-visible {
  outline: none;
  background-color: hsl(220, 13%, 91%);
}
.drawer-container .modal-header button[class=btn-close]::after {
  font-family: "Font Awesome 6 Pro";
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  content: "\\f00d";
  font-weight: 400;
  font-size: 20px;
  width: 24px;
  height: 24px;
  --fa-display: grid;
  place-content: center;
}
.drawer-container .modal-title {
  font: normal 500 22px/28px Open Sans, sans-serif;
}

.sub-drawer-close {
  width: 48px;
  height: 48px;
  min-width: 48px;
  appearance: none;
  font-size: 20px;
  color: hsl(0, 0%, 7%);
  margin-inline: -10px;
  border-radius: 6px;
  transition-duration: 0.15s;
  transition-property: background-color;
  border: none;
  cursor: pointer;
}
.sub-drawer-close:hover {
  background-color: hsl(225, 13%, 94%);
}
.sub-drawer-close:focus, .sub-drawer-close:focus-visible {
  outline: none;
  background-color: hsl(220, 13%, 91%);
}

.resizer {
  background: #efefef;
  bottom: 0;
  top: 0;
  cursor: col-resize;
  display: block;
  font-size: 1rem;
  inset-inline-start: -12px;
  line-height: 100vh;
  opacity: 0;
  padding: 0 3px;
  position: absolute;
  z-index: 1234;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
}

.modal-sizable {
  max-width: 100% !important;
}
.modal-sizable .modal-content:hover .resizer {
  opacity: 1;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.modal-sizable.modal-align-left .resizer {
  inset-inline-start: auto;
  inset-inline-end: -12px;
}

.modal-header-buttons {
  gap: 8px !important;
}
.modal-header-buttons .ok-btn {
  margin-inline-end: 11px;
}

.visualize-data .drawer-container {
  min-width: 40vw;
}

.modal-header {
  border: none;
}
.modal-header .modal-title {
  gap: 0 0.5rem;
}
.modal-header .modal-title .page-name-bar.json-schema-editor-page {
  margin: 0;
  flex: auto;
}
.modal-header .modal-title .page-name-bar.json-schema-editor-page .col-md-6:first-child:empty {
  display: none;
}
.modal-header .modal-title .page-name-bar.json-schema-editor-page .col-md-6:first-child:empty + .col-md-6 {
  margin-inline-start: auto;
  padding-inline-end: 0;
}

.modal-body .page-name-bar {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
  padding-bottom: 16px;
  box-shadow: 0 -16px 0 #fff, 0px 0px 20px rgba(0, 0, 0, 0.05);
}
.modal-body .page-name-bar.json-schema-editor-page {
  margin-top: 0;
}
.modal-body .page-name-bar.json-schema-editor-page > .col-md-6:first-child:empty {
  display: none;
}
.modal-body .page-name-bar.json-schema-editor-page > .col-md-6:first-child:empty + .col-md-6 {
  width: 100%;
  flex: 0 0 auto;
  max-width: 100%;
}
.modal-body.new-language-modal-body {
  overflow-y: visible;
  overflow-x: clip;
}

.modal-footer {
  border: none;
  border-radius: 0 0 6px 6px;
  background: hsl(0, 50%, 100%);
}

.modal-warning-red {
  max-width: 500px;
}
.modal-warning-red .danger-text {
  color: hsl(0, 84%, 60%);
}

/* Base
   ========================================================================== */
/*Base Styles*/
html {
  height: 100%;
}

body {
  font-family: "Nunito Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  background-color: #ffffff;
  height: 100%;
  overflow: hidden;
}
body::-webkit-scrollbar-thumb {
  background-color: hsl(218, 11%, 65%);
}

body.ios-mobile-view-height {
  height: auto !important;
  overflow: visible !important;
}

#nprogress .bar {
  z-index: 5000 !important;
  background: #63a386 !important;
}

#nprogress .peg {
  -webkit-box-shadow: 0 0 10px #63a386, 0 0 5px #63a386 !important;
  -moz-box-shadow: 0 0 10px #63a386, 0 0 5px #63a386 !important;
  -o-box-shadow: 0 0 10px #63a386, 0 0 5px #63a386 !important;
  box-shadow: 0 0 10px #63a386, 0 0 5px #63a386 !important;
}

#nprogress .spinner {
  z-index: 5000 !important;
}

#nprogress .spinner-icon {
  border-top-color: #63a386 !important;
  border-inline-start-color: #63a386 !important;
}

.text-transform-none {
  text-transform: none;
}

.br-break {
  word-break: break-all !important;
}

.font-weight-semibold {
  font-weight: 500 !important;
}

.z-index-20 {
  z-index: 20;
}

.border-bottom {
  border-bottom: solid 1px #dee2e6;
}

.col-with-divider div[class*=col-] {
  border-inline-start: solid 1px #dee2e6;
}
.col-with-divider div[class*=col-]:first-child {
  border: 0 none;
}

.height-100 {
  height: 100px !important;
}

.height-150 {
  height: 150px !important;
}

.height-130 {
  height: 130px !important;
}

.height-200 {
  height: 200px !important;
}

.max-width-100 {
  max-width: 100px !important;
}

.max-height-120 {
  max-height: 120px !important;
}

.right-arrow {
  display: inline-block;
  color: #99BBCD;
  text-transform: capitalize;
}
.right-arrow:after {
  content: "\\f30f";
  font-family: "Material-Design-Iconic-Font";
  color: #99BBCD;
  margin-inline-start: 8px;
  font-size: 20px;
  vertical-align: middle;
}
.right-arrow:hover, .right-arrow:focus {
  text-decoration: none;
}

.letter-spacing-base {
  letter-spacing: 3px;
}

.letter-spacing-lg {
  letter-spacing: 6px;
}

.letter-spacing-xl {
  letter-spacing: 8px;
}

.blue-text {
  color: #5b98d5;
}

.page-heading {
  margin-bottom: 38px;
}
.page-heading .title {
  text-transform: capitalize;
  font-weight: 500;
}
.page-heading .title span {
  display: flex;
  align-items: center;
}
.page-heading .title span span + span.badge {
  margin: 0 1rem;
}
.page-heading .title span > button:not(.btn-success) {
  margin-bottom: 0;
  width: 30px;
  padding: 0;
  height: 30px;
  margin-inline-start: 1rem;
  border-radius: 25px;
}
.page-heading .title span > button:not(.btn-success):hover {
  background: white;
  border: solid 1px #e0e3e7;
}
.page-heading .title span .dropdown button {
  margin: 0;
}
.page-heading .breadcrumb {
  padding: 0;
  background-color: transparent;
  margin-bottom: 0;
}
@media screen and (max-width: 575px) {
  .page-heading {
    margin-bottom: 18px;
  }
}

.sub-heading {
  font-size: 14px;
  color: #adb5bd;
  margin-bottom: 0;
}
.sub-heading:not(:last-child) {
  margin-bottom: 16px !important;
}

.manage-margin {
  margin-bottom: 0;
}
.manage-margin > * {
  margin-bottom: 6px;
}
.manage-margin > *:not(:last-child) {
  margin-inline-end: 16px;
}

.no-shadow {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.shadow-sm {
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.shadow {
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.shadow-lg {
  -webkit-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
}

.shadow-xl {
  -webkit-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
}

.avatar-shadow {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -o-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
}

.remove-table-border td, .remove-table-border th {
  border: 0 none;
}

.media-list {
  margin-bottom: 10px;
}
.media-list:not(:last-child) {
  border-bottom: solid 1px #e9ecef;
  padding-bottom: 15px;
  margin-bottom: 20px;
  position: relative;
}

.border-2 {
  border: 2px solid #ced4da !important;
}

.border-w2 {
  border-width: 2px;
}

.border-primary {
  border-color: #99BBCD !important;
}

.border-red {
  border-color: #F44336 !important;
}

.border-pink {
  border-color: #e91e63 !important;
}

.border-purple {
  border-color: #9C27B0 !important;
}

.border-deep-purple {
  border-color: #673ab7 !important;
}

.border-indigo {
  border-color: #99BBCD !important;
}

.border-blue {
  border-color: #2196F3 !important;
}

.border-light-blue {
  border-color: #03a9f4 !important;
}

.border-cyan {
  border-color: #00bcd4 !important;
}

.border-teal {
  border-color: #009688 !important;
}

.border-green {
  border-color: #4CAF50 !important;
}

.border-light-green {
  border-color: #8bc34a !important;
}

.border-lime {
  border-color: #cddc39 !important;
}

.border-yellow {
  border-color: #ffeb3b !important;
}

.border-amber {
  border-color: #ffc107 !important;
}

.border-orange {
  border-color: #ff9800 !important;
}

.border-deep-orange {
  border-color: #ff5722 !important;
}

.border-brown {
  border-color: #795548 !important;
}

.border-blue-grey {
  border-color: #607d8b !important;
}

.border-grey {
  border-color: #9e9e9e !important;
}

.center-crop-img {
  position: relative;
  width: 100%;
  min-height: 120px;
  overflow: hidden;
}
.center-crop-img img {
  position: absolute;
  inset-inline-start: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.center-crop-img img.portrait {
  width: 100%;
  height: auto;
}

.pointer {
  cursor: pointer;
}

.icon-btn {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
}
.header-notifications .icon-btn {
  padding: 0 4px;
}

.avatar {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #fafafa;
}

.avatar-lg {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fafafa;
}

.avatar-sm {
  width: 40px;
  height: 40px;
  text-align: center;
  color: #fafafa;
}

.animated {
  -webkit-animation-fill-mode: none !important;
  animation-fill-mode: none !important;
}

.overflow-hidden {
  overflow: hidden;
}

.icons-showcase > div {
  cursor: pointer;
  padding: 7px 15px;
  border-radius: 4px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-decoration {
  text-decoration: none !important;
}

.row-5 {
  margin-inline-start: -5px;
  margin-inline-end: -5px;
}
.row-5 > [class*=col-] {
  padding-inline-start: 5px;
  padding-inline-end: 5px;
}

.font-size-16 {
  font-size: 16px !important;
}

/*Typography Styles*/
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-weight: 400;
  margin: 0 0 12.5px;
  color: inherit;
}

h1, .h1 {
  font-size: 25px;
}

h2, .h2 {
  font-size: 19px;
}

h3, .h3 {
  font-size: 17px;
}

h4, .h4 {
  font-size: 15px;
}

h5, .h5 {
  font-size: 14px;
}

h6, .h6 {
  font-size: 13px;
}

.text-strikethrough {
  text-decoration: line-through !important;
}

@media screen and (max-width: 991px) {
  h1, .h1 {
    font-size: 19px;
  }
  h2, .h2 {
    font-size: 17px;
  }
  h3, .h3 {
    font-size: 15px;
  }
}
.desc-list {
  margin-bottom: 0;
}
.desc-list li {
  padding: 24px 30px;
  border-bottom: 1px solid #ced4da;
  margin-inline-start: -30px;
  margin-inline-end: -30px;
}
.desc-list li:last-child {
  border-bottom: 0 none;
}
.desc-list li .card-title {
  margin-bottom: 6px;
}
.desc-list.even-odd li {
  border-bottom: 0 none;
}
.desc-list.even-odd li:nth-child(2n) {
  background-color: #dee2e6;
}

/* Layouts
   ========================================================================== */
/*App Layout Styles*/
:root {
  --permissions-resources-column-width: 368px;
}

#app-site,
.app-main {
  display: flex;
  width: 100%;
  height: 100%;
}

.app-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.app-sidebar {
  /*@include display-flex(flex, column, nowrap);
  width: \$side-nav-width;
  min-width: \$side-nav-width;
  max-width: \$side-nav-width;*/
}

.app-main-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.app-header {
  min-height: 70px;
  z-index: 99;
  position: relative;
}

.instance-logo-container {
  display: flex;
  align-items: center;
  position: relative;
}
.instance-logo-container .instance-logo {
  max-height: 48px;
  max-width: 200px;
}
.instance-logo-container .default-instance-logo {
  font-size: 2rem;
  color: #9cbdce;
}
.instance-logo-container .config-instance-logo {
  padding: 5px;
  color: #666666;
  opacity: 0;
  transition-duration: 0.2s;
  cursor: pointer;
  border-radius: 20px;
  background-color: white;
}
.instance-logo-container .config-instance-logo:hover {
  color: #9cbdce;
  opacity: 1;
}
.instance-logo-container .remove-instance-logo {
  color: #f44336;
  padding: 5px 7px;
  border-radius: 20px;
  background-color: white;
  transition-duration: 0.2s;
  cursor: pointer;
  display: none;
}
.instance-logo-container:hover .config-instance-logo {
  opacity: 0.5;
}
.instance-logo-container:hover .config-instance-logo:hover {
  opacity: 1;
}
.instance-logo-container.has-logo .config-instance-logo {
  inset-inline-end: 9px;
}
.instance-logo-container.has-logo .remove-instance-logo {
  display: inline-block;
  opacity: 0;
}
.instance-logo-container.has-logo:hover .remove-instance-logo {
  opacity: 0.5;
}
.instance-logo-container.has-logo:hover .remove-instance-logo:hover {
  opacity: 1;
}

.app-main-content-wrapper {
  flex: 1;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.app-main-content-wrapper::-webkit-scrollbar-thumb {
  background-color: hsl(218, 11%, 65%);
}

.app-container.fixed-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.collapsible-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.collapsible-drawer .app-main-container {
  position: relative;
}
.app-container.mini-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.mini-drawer .app-sidebar {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.d-grid {
  display: grid;
}

.v-align-middle {
  vertical-align: middle !important;
}

.hide-button-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
}

.mt-04 {
  margin-top: 0.4rem;
}

.white-border {
  border-color: white;
}

.flex-auto {
  flex: auto;
}

.tableshadow {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
}

.tableoptions--closed .ReactTable.limited-height .rt-table {
  max-height: 70vh;
}

.dropdown-columns .dropdown-menu.show {
  transition-duration: 0.2s;
  width: auto;
  display: grid;
  padding: 10px;
  grid-template-columns: repeat(4, 1fr);
}
.dropdown-columns .dropdown-menu.show .dropdown-item.column-type-object {
  background-color: #f4f4f4;
}
.dropdown-columns .dropdown-menu.show .dropdown-item.column-type-object span {
  font-weight: 700;
}

.dropdown-filters.show .dropdown-menu.show {
  transition-duration: 0.2s;
  width: max-content;
  overflow: visible;
  margin-top: 2px;
  border-radius: 4px;
}
.dropdown-filters.show + .dropdown-columns .dropdown-menu.show {
  inset-inline-start: 224px !important;
}

/* User roles rights management */
.user-roles-rights-management {
  padding-inline-start: 0 !important;
  padding-top: 0 !important;
  height: 100%;
}
.user-roles-rights-management .dashboard {
  height: 100%;
}
.user-roles-rights-management .rights-management-container {
  height: 100%;
}
.user-roles-rights-management :where(.users-roles-part, .permissions-part) {
  padding-top: 36px;
}
.user-roles-rights-management .users-roles-part {
  flex: 0 0 320px;
  max-width: 320px;
  min-width: 320px;
  background: white;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 100px);
  position: sticky;
  top: 0;
}
.user-roles-rights-management .users-roles-part .tabs-container {
  padding-inline-start: 32px;
  padding-inline-end: 32px;
  display: flex;
}
.user-roles-rights-management .users-roles-part .tabs-container .tab-link {
  flex: auto;
  border-bottom: solid 2px transparent;
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(220, 9%, 46%);
  padding-bottom: 12px;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-roles-rights-management .users-roles-part .tabs-container .tab-link:where(:hover, .active) {
  color: hsl(0, 0%, 7%);
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  border-bottom: solid 2px hsl(222, 38%, 57%);
}
.user-roles-rights-management .users-roles-part .users-roles-search {
  padding-inline-start: 32px;
  padding-inline-end: 32px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  position: relative;
}
.user-roles-rights-management .users-roles-part .users-roles-search.cas-search-active .import-users-btn {
  background-color: hsl(223, 53%, 42%);
  color: hsl(0, 50%, 100%);
}
.user-roles-rights-management .users-roles-part .users-roles-list {
  overflow-y: auto;
  padding-inline: 32px;
}
.user-roles-rights-management .users-roles-part .users-roles-list p.auth-name {
  padding: 3px 40px;
  display: block;
  width: 100%;
  text-align: left;
  font-size: 12px;
  border: none;
  margin: 0;
  font-style: italic;
  color: #909090;
}
.user-roles-rights-management .permissions-table :is(.filters-columns, .permissions-columns .permission-row) {
  --percent: calc((100% - var(--permissions-resources-column-width) - 130px) * 0.1);
  display: grid;
  grid-template-columns: 368px 130px repeat(4, 1fr) repeat(2, 1.5fr);
}
.user-roles-rights-management .permissions-table :is(.filters-columns, .permissions-columns .permission-row) > div:nth-child(7) {
  padding-inline-start: 53px;
}
.user-roles-rights-management .permissions-table :is(.filters-columns, .permissions-columns .permission-row) > div:nth-child(8) {
  padding-inline-start: 27px;
}
.user-roles-rights-management .permissions-table .filters-columns > div {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  align-items: flex-end;
}
.user-roles-rights-management .permissions-table .filters-columns > div > span {
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 8px;
}
.user-roles-rights-management .permissions-table .filters-columns > div.permissions-item-filter {
  overflow: initial;
}
.user-roles-rights-management .permissions-table .permissions-columns {
  padding-bottom: 20px;
}
.user-roles-rights-management .permissions-table .permission-row {
  margin-top: 0px;
  text-align: start;
}
.user-roles-rights-management .permissions-table .permission-row > div {
  padding-block: 6px;
  background-color: var(--group-row-bg);
}
.user-roles-rights-management .permissions-table .permission-row:hover > div {
  background-color: var(--group-row-bg);
}
.user-roles-rights-management .permissions-table .permission-row.group-row {
  margin-top: 16px;
  margin-bottom: 4px;
  position: sticky;
  top: 56px;
  z-index: 9;
}
.user-roles-rights-management .permissions-table .permission-row.group-row > div {
  background-color: var(--group-row-bg);
}
.user-roles-rights-management .permissions-table .permission-row.database-row {
  margin-top: 2px;
}
.user-roles-rights-management .permissions-table .permission-row .permission-group-name {
  color: hsl(0, 0%, 7%);
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  display: flex;
  gap: 10px;
  padding-inline-end: 16px;
  padding-top: 6px;
  align-items: baseline;
}
.user-roles-rights-management .permissions-table .permission-row .permission-db-name {
  color: hsl(0, 0%, 7%);
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  display: flex;
  min-height: 40px;
  align-items: center;
}
.user-roles-rights-management .permissions-table .permission-row .permission-status i {
  display: flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  font-size: 28px;
  transition-duration: 0.2s;
}
.user-roles-rights-management .permissions-table .permission-row .permission-status i.on.yellow {
  --toggle-icon-color: hsla(48, 96%, 53%, 1);
}
.user-roles-rights-management .permissions-table .permission-row .permission-status i:hover {
  opacity: 0.7;
}
.user-roles-rights-management .permissions-table .permission-row .permission-status .loader {
  width: 30px;
  margin-inline-start: 0;
}
.user-roles-rights-management .permissions-table .permission-row .db-records {
  display: flex;
  border: none;
  color: hsl(220, 9%, 46%);
  border-bottom: solid 1px hsl(215, 14%, 34%);
  text-transform: uppercase;
  font: normal 500 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  align-items: center;
  transition-duration: 0.2s;
  padding: 0;
  cursor: pointer;
}
.user-roles-rights-management .permissions-table .permission-row .db-records:hover, .user-roles-rights-management .permissions-table .permission-row .db-records.active {
  color: hsl(217, 19%, 27%);
  border-bottom: solid 1px hsl(215, 28%, 17%);
}
.user-roles-rights-management .permissions-table .all-rows {
  margin-bottom: 16px;
}
.user-roles-rights-management .permissions-table .all-rows .permission-row > div {
  padding-bottom: 6px;
}
.user-roles-rights-management .tabbed-permissions .tab-content {
  padding-top: 24px;
}
.user-roles-rights-management .permission-db-name-col {
  padding-inline-start: 16px;
  margin-inline-end: 16px;
}
.user-roles-rights-management :where(.permission-filter-element-column, .permissions-item-filter, .permission-filter-column-heading) {
  background-color: hsl(225, 13%, 94%);
}
.user-roles-rights-management .permissions-item-filter {
  padding-inline: 16px;
  margin-inline-end: 16px;
  flex-direction: column;
  gap: 10px;
}
.user-roles-rights-management .permissions-item-filter select {
  min-width: 10px !important;
}
.user-roles-rights-management .permissions-item-filter + div {
  margin-inline-start: 16px;
  padding-inline-start: 16px;
}
.user-roles-rights-management .permission-filter-column-heading {
  color: hsl(0, 0%, 7%);
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.user-roles-rights-management .permission-element {
  margin-inline-start: 16px;
  padding-inline-start: 16px;
  color: hsl(0, 0%, 7%);
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.user-roles-rights-management .permission-element span {
  display: flex;
  height: 40px;
  align-items: center;
}
.user-roles-rights-management .user-role-list-item {
  padding: 8px 16px;
  list-style: none;
  border-radius: 4px;
  cursor: pointer;
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.user-roles-rights-management .user-role-list-item:where(.active, :hover) {
  background-color: hsl(223, 37%, 93%);
}
.user-roles-rights-management .user-role-list-item:where(.active, :hover) .user-full-name {
  color: var(--system-primary-color, #002b8f);
}
.user-roles-rights-management .user-role-list-item:where(.active, :hover) .user-username {
  color: hsl(222, 38%, 57%);
}
.user-roles-rights-management :where(.user-full-name, .user-username) {
  display: block;
}
.user-roles-rights-management .user-full-name {
  color: hsl(0, 0%, 7%);
}
.user-roles-rights-management .user-username {
  color: hsl(218, 11%, 65%);
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.user-roles-rights-management .roles-rights-management-container {
  border-radius: 6px;
  background-color: hsl(0, 50%, 100%);
}
.user-roles-rights-management .role-users-management-table {
  width: 100%;
}
.user-roles-rights-management .role-users-management-table .toggler-column {
  width: 32px;
}
.user-roles-rights-management .role-users-management-table .toggler-column .toggle-icon {
  --fa-display: flex;
}
.user-roles-rights-management .role-users-management-table td {
  border-bottom: solid 4px hsl(210, 20%, 98%);
  padding: 16px;
  vertical-align: middle;
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
}
.user-roles-rights-management .role-users-management-table tr:last-child td {
  border-bottom: none;
}
.user-roles-rights-management .role-users-management-table .user-full-name {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
}
.user-roles-rights-management .role-users-management-table .user-username {
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(220, 9%, 46%);
}

.permissions-part {
  padding-inline-start: 40px;
  flex: auto;
  --group-row-bg: hsl(0, 50%, 100%);
  --permissions-blue-color: #5b98d5;
  --permissions-left-shadow: -2px 0px 1px rgba(0, 0, 0, 0.07);
  --permissions-left-last-shadow: -2px 2px 4px rgba(0, 0, 0, 0.07);
  --permissions-right-shadow: 2px 0px 1px rgba(0, 0, 0, 0.07);
  --permissions-right-last-shadow: 2px 2px 4px rgba(0, 0, 0, 0.07);
  --permissinos-allrows-inset-shadow: inset 0 -16px 0 white;
}
.permissions-part.tabbed-permissions .page-name-section {
  align-items: center;
  display: flex;
}

.permissions-tabs ul {
  list-style: none;
  display: flex;
  margin-bottom: 0px;
  height: 100%;
  align-items: center;
  padding-inline-start: 0;
  width: var(--permissions-resources-column-width);
}
.permissions-tabs ul li {
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(220, 9%, 46%);
  padding-block: 12px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.permissions-tabs ul li:where(:hover, .active) {
  color: hsl(0, 0%, 7%);
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  border-bottom: solid 2px hsl(222, 38%, 57%);
}

.permissions-sections-headers {
  display: grid;
  grid-template-columns: 368px 1fr;
}

.permission-sections-header-column,
.rights-management-roles-table thead th {
  color: hsl(0, 0%, 7%);
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  padding-block: 10px;
  background-color: hsl(225, 13%, 94%);
}

.rights-management-roles-table thead th {
  padding-inline: 16px;
}
.rights-management-roles-table thead th:first-child {
  border-top-left-radius: 6px;
}
.rights-management-roles-table thead th:last-child {
  border-top-right-radius: 6px;
}

.rights-management-roles-table tbody td {
  padding: 10px 16px;
  background-color: hsl(0, 50%, 100%);
}
.rights-management-roles-table tbody td i {
  display: flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  font-size: 28px;
  transition-duration: 0.2s;
}

.permission-sections-header-column {
  border-bottom: solid 1px hsl(210, 20%, 98%);
  padding-inline-start: 16px;
  margin-inline-end: 16px;
  border-radius: 6px 6px 0 0;
  text-align: start;
  overflow: hidden;
}
.permission-sections-header-column:last-child {
  margin-inline-start: 16px;
  margin-inline-end: 0px;
}
.permission-sections-header-column > span {
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

.records-fields-drawer .modal-title {
  justify-content: flex-start;
}
.records-fields-drawer + .modal-body .records-fields-section-title i:hover {
  color: #999999;
}
.records-fields-drawer + .modal-body .records-fields-section-title .add-record-filter {
  color: #5b98d5;
}
.records-fields-drawer + .modal-body .records-fields-section-title .add-record-filter:hover {
  color: #0b65bf;
}
.records-fields-drawer + .modal-body .records-filters-permission-table :where(.permission-table-header, .permission-table-row) {
  grid-template-columns: var(--record-field-column, 50%) repeat(4, 1fr);
  grid-gap: 10px;
  padding-inline: 16px;
  padding-block: 10px;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-header {
  background-color: hsl(225, 13%, 94%);
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-header > div {
  display: flex;
  align-items: center;
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row {
  border-top: solid 1px #f3f3f3;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row:first-of-type {
  border-top: none;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row:hover {
  background-color: #FAFAFA;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row > div {
  display: flex;
  align-items: center;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row > div.permission-status i {
  display: flex;
  height: 30px;
  align-items: center;
  cursor: pointer;
  font-size: 28px;
  transition-duration: 0.2s;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row > div.permission-status i:hover {
  opacity: 0.7;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row > div.permission-status .loader {
  width: 30px;
  margin-inline-start: 0;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row > div.permission-field-name {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table {
  table-layout: fixed;
  margin: 0;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table tr td select,
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table tr td input {
  width: 100%;
  min-width: auto;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table tr td:first-of-type {
  padding-inline-start: 0;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table tr:first-of-type td:first-of-type {
  padding-inline-end: 0;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table tr:first-of-type:last-of-type td:first-of-type + td {
  padding-inline-start: 0;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table ~ button {
  margin-bottom: 0;
  font-size: 12px;
  padding: 0 16px;
  margin-inline-end: 5px;
  margin-top: 5px;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .data-filter-table ~ button.btn-outline-default {
  background: #efefef;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode {
  display: flex;
  align-items: center;
  width: 100%;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode .remove-icon {
  color: rgb(251, 69, 80);
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode .remove-icon,
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode .edit-icon {
  padding: 5px;
  opacity: 0.8;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode .remove-icon:hover,
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode .edit-icon:hover {
  opacity: 1;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode span.badge {
  margin-bottom: 0;
}
.records-fields-drawer + .modal-body .records-filters-permission-table .permission-table-body .permission-table-row .record-filter-read-mode > div > span > span:not(.badge) {
  text-transform: lowercase;
}
.records-fields-drawer + .modal-body .records-filters-permission-table:has(.record-filter-edit-mode) :is(.permission-table-header, .permission-table-row) {
  --record-field-column: 70%;
}

.db-name-container {
  color: hsl(0, 0%, 7%);
  text-align: start;
}

/*Sidebar Styles*/
.side-nav {
  width: 100%;
  background-color: #fff !important;
  color: #333 !important;
  border-inline-end: solid 1px #e9ecef !important;
  z-index: 1250 !important;
}
.side-nav .user-profile {
  background-color: rgb(247.35, 247.35, 247.35);
  padding: 13px 20px !important;
}
.side-nav .user-avatar {
  margin: 0 !important;
  margin-inline-end: 15px !important;
  height: 44px !important;
  width: 44px !important;
  line-height: 44px;
}
.side-nav .user-detail .user-name {
  color: #99BBCD;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.user-detail .user-name {
  cursor: pointer;
}

/*Navbar Styles*/
ul.nav-menu {
  position: relative;
  font-size: 14px;
  list-style: outside none none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

ul.nav-menu li {
  position: relative;
  /*margin-bottom: 1px;*/
}

ul.nav-menu li.menu + .nav-header {
  margin-top: 40px;
}
ul.nav-menu li.menu .sub-menu {
  display: none;
}
ul.nav-menu li.menu.open > .sub-menu {
  display: block;
}
ul.nav-menu li.menu.open .menu.active > .sub-menu {
  display: block;
}
ul.nav-menu li.menu > a[role=button] {
  text-transform: none;
}

ul.nav-menu li a {
  color: #333;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  text-decoration: none;
  border-radius: 0;
}
ul.nav-menu li a .badge {
  margin-bottom: 0;
  padding: 3px 8px 2px;
}

ul.nav-menu .nav-header {
  color: #333;
  padding: 4px 22px;
  font-size: 11px;
  text-transform: uppercase;
}
ul.nav-menu .nav-header:first-child {
  margin-top: 30px;
}

ul.nav-menu li.menu > a:hover:before {
  color: #99BBCD;
}

ul.nav-menu li ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

ul.nav-menu li ul.sub-menu li > a {
  padding-block: 7px;
  padding-inline-end: 20px;
  padding-inline-start: 30px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > a {
  padding-inline-start: 76px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {
  padding-inline-start: 96px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-inline-start: 116px;
}

ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  padding: 3px 7px;
  margin-inline-start: -7px;
  color: #99BBCD;
  border-radius: 4px;
  display: inline-block;
}

ul.nav-menu li.menu .sub-menu li > a:hover,
ul.nav-menu li.menu.open .sub-menu li > a.active:before,
ul.nav-menu li.menu .sub-menu li > a:hover:before {
  color: #99BBCD;
}

.app-container.mini-drawer .side-nav {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  width: 80px;
}
.app-container.mini-drawer .side-nav .nav-menu li span.nav-text, .app-container.mini-drawer .side-nav .customizer {
  display: none;
}
.app-container.mini-drawer .side-nav .user-profile .user-detail {
  display: none !important;
}
.app-container.mini-drawer .side-nav .nav-menu .menu.open > .sub-menu {
  display: none !important;
}
.app-container.mini-drawer .side-nav .nav-menu li {
  text-align: center;
}
.app-container.mini-drawer .side-nav .nav-menu li i {
  margin-inline-end: 0;
}
.app-container.mini-drawer .side-nav .nav-menu li.nav-header {
  padding: 4px 5px;
}
.app-container.mini-drawer .side-nav ul.nav-menu > li > a:before {
  display: none;
}
.app-container.mini-drawer .side-nav .mini-logo-img-hover {
  display: none;
}

.app-container.mini-drawer .side-nav:hover {
  width: 280px;
}
.app-container.mini-drawer .side-nav:hover .nav-menu li span.nav-text {
  display: inline-block !important;
}
.app-container.mini-drawer .side-nav:hover .user-profile .user-detail {
  display: flex !important;
}
.app-container.mini-drawer .side-nav:hover .nav-menu .menu.open > .sub-menu {
  display: block !important;
}
.app-container.mini-drawer .side-nav:hover .customizer {
  display: flex !important;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li {
  text-align: left;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li i {
  margin-inline-end: 16px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li.nav-header {
  padding: 4px 22px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a {
  padding-block: 7px;
  padding-inline-end: 20px;
  padding-inline-start: 56px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > a {
  padding-inline-start: 76px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > a {
  padding-inline-start: 96px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-inline-start: 116px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu > li > a:before {
  display: block;
}
.app-container.mini-drawer .side-nav:hover .mini-logo-img {
  display: none;
}
.app-container.mini-drawer .side-nav:hover .mini-logo-img-hover {
  display: block;
}

.customizer {
  padding: 20px 35px;
}
.customizer img {
  padding: 5px;
  cursor: pointer;
}

.user-info ul li {
  font-size: 15px;
}

.rc-drawer-left .rc-drawer-sidebar, .rc-drawer-right .rc-drawer-sidebar {
  height: 100vh;
}

.rc-drawer-sidebar {
  position: fixed;
  transition: -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
}
.rc-drawer.rc-drawer-left .rc-drawer-sidebar {
  inset-inline-start: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: 903;
}
.rc-drawer.rc-drawer-right .rc-drawer-sidebar {
  inset-inline-end: 0;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  z-index: 903;
}
.rc-drawer.rc-drawer-top .rc-drawer-sidebar {
  z-index: 903;
}
.rc-drawer.rc-drawer-bottom .rc-drawer-sidebar {
  z-index: 903;
}
.rc-drawer-sidebar .sidebar-draggable-area > div ul.nav-menu li.menu[style^="position: fixed"] ~ li.menu:not(.no-arrow) + li.menu.no-arrow {
  margin-top: 100%;
}
.rc-drawer-sidebar .sidebar-draggable-area > div ul.nav-menu li.menu[style^="position: fixed"]:not(.no-arrow) + li.menu.no-arrow {
  margin-top: 100%;
}

.drawer-container {
  position: relative;
}
.drawer-container .main {
  position: relative;
  padding: 10px;
  box-sizing: border-box;
}

.rc-drawer-overlay {
  z-index: 902;
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100vh;
  min-width: 100% !important;
}

.app-sidebar > .rc-drawer-sidebar {
  overflow-x: hidden;
}
.app-sidebar.rc-drawer.rc-drawer-docked {
  position: relative;
}
.app-sidebar ul.nav-menu li.menu a span.nav-text span.db-code {
  font-weight: 700;
  color: #777777;
  text-transform: uppercase;
  font-size: 82%;
}
.app-sidebar ul.nav-menu li.menu a .fa-star {
  opacity: 0;
  transition-duration: 0.2s;
}
.app-sidebar ul.nav-menu li.menu a:hover .fa-star {
  opacity: 1;
  transition-duration: 0.2s;
}
.app-sidebar ul.nav-menu li.menu a[role=button] .group-config-icon {
  margin-inline-start: -27px;
  opacity: 0;
  transition-duration: 0.2s;
}
.app-sidebar ul.nav-menu li.menu a[role=button]:hover .group-config-icon {
  margin-inline-start: 0;
  opacity: 1;
}
.app-sidebar ul.nav-menu li.menu a[role=button] .group-diagram-icon {
  margin-inline-start: -27px;
  opacity: 0;
  transition-duration: 0.2s;
}
.app-sidebar ul.nav-menu li.menu a[role=button]:hover .group-diagram-icon {
  margin-inline-start: 0;
  opacity: 1;
}
.app-sidebar ul.nav-menu.action-buttons {
  position: sticky;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  justify-content: space-between;
  height: auto;
}

/*Header Styles*/
.jr-menu-icon {
  outline: none !important;
  -webkit-justify-content: flex-start !important;
  justify-content: flex-start !important;
  padding: 0 5px !important;
  margin-inline-end: 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
  min-width: 24px;
}

.app-main-header {
  background-color: #fff;
  color: #808080;
  max-height: 70px;
  position: relative;
  border-bottom: none;
}
.app-main-header .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: transparent;
  color: #808080;
}
.app-main-header .search-bar input + .search-icon {
  top: 0;
}
.app-main-header .search-bar input + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
.app-main-header .search-bar input:focus {
  background-color: #ffffff;
  color: #808080;
}
.app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
.app-header .app-main-header {
  border-bottom: 1px solid #dee2e6;
}
.jr-card .app-main-header {
  border: 1px solid #ced4da;
  border-radius: 8px;
}

.app-logo {
  margin-inline-end: 12px;
}
.app-logo img {
  height: 35px;
}
@media screen and (max-width: 575px) {
  .app-logo img {
    height: 28px;
  }
}
.app-header .app-logo {
  margin-inline-end: 20px;
}
@media screen and (max-width: 991px) {
  .app-header .app-logo {
    margin-inline-end: auto;
  }
}

.react-logo-white.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .react-logo-white.d-lg-block {
    display: none !important;
  }
}
.sidebar-header {
  min-height: 70px;
  padding: 10px 22px;
  border-bottom: 1px solid #dee2e6;
}

.app-toolbar {
  min-height: 70px;
  padding: 0 40px;
}
.app-toolbar .search-bar {
  margin-inline-end: auto;
  max-width: 320px;
  width: 300px;
}
@media screen and (max-width: 1199px) {
  .app-toolbar .search-bar {
    width: 240px;
  }
}
@media screen and (max-width: 1099px) {
  .app-toolbar .search-bar {
    width: 200px;
  }
}
@media screen and (max-width: 767px) {
  .app-toolbar .search-bar {
    margin-inline-start: 40px;
    width: 180px;
  }
}
@media screen and (max-width: 575px) {
  .app-toolbar {
    padding: 0 20px;
  }
}
.app-top-nav .app-toolbar {
  min-height: 40px;
}

@media screen and (max-width: 1199px) {
  .app-header-horizontal .app-toolbar .search-bar {
    margin-inline-end: 10px;
  }
}

.app-toolbar-special .search-bar {
  width: 200px;
}
@media screen and (max-width: 991px) {
  .app-toolbar-special .search-bar {
    width: 280px;
  }
}
@media screen and (max-width: 767px) {
  .app-toolbar-special .search-bar {
    width: 200px;
  }
}

.app-toolbar .nav-searchbox .search-bar {
  margin-inline-start: 0;
  width: 100%;
}
.app-toolbar .nav-searchbox .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  color: #333;
}
.app-toolbar .nav-searchbox .search-bar input + .search-icon i {
  color: rgba(51, 51, 51, 0.8);
}
.app-toolbar .nav-searchbox .search-bar input:focus {
  background-color: transparent;
  color: #333;
}
.app-toolbar .nav-searchbox .search-bar input:focus + .search-icon i {
  color: rgba(51, 51, 51, 0.8);
}

.header-notifications {
  margin-bottom: 0;
}
.header-notifications li {
  vertical-align: middle;
}
.header-notifications li.lang-nav .quick-menu {
  display: flex;
}
.header-notifications li.lang-nav .quick-menu span {
  font-size: 13px;
  font-weight: 700;
}
.header-notifications .health-traffic-light span.monitor-status {
  border: solid 2px;
  display: inline-flex;
  width: 14px;
  height: 14px;
  border-radius: 8px;
}
@media screen and (max-width: 449px) {
  .header-notifications .list-inline-item:not(:last-child) {
    margin-inline-end: 0;
  }
}
.header-notifications .general-cog-icon {
  color: #5b98d5;
  font-size: 1.7rem;
  cursor: pointer;
}
.header-notifications .general-cog-icon:hover {
  color: #1874d0;
}

.dropdown-menu {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.quick-menu .dropdown-menu .jr-card-header {
  margin: -5px -10px 5px;
  padding: 10px;
  padding-inline-start: 20px;
  border-bottom: 1px solid #dee2e6;
  z-index: 10;
}
.quick-menu .dropdown-menu:after {
  border-inline-start: 5px solid transparent;
  border-inline-end: 5px solid transparent;
  border-bottom: 5px solid #fff;
  top: -9px;
  content: "";
  height: 9px;
  position: absolute;
  inset-inline-end: 8px;
  width: 10px;
}
.quick-menu .dropdown-menu:before {
  border-inline-start: 5px solid transparent;
  border-inline-end: 5px solid transparent;
  border-bottom: 5px solid #000;
  top: -10px;
  content: "";
  height: 10px;
  position: absolute;
  inset-inline-end: 8px;
  width: 10px;
}
@media screen and (max-width: 449px) {
  .quick-menu .dropdown-menu {
    width: 230px;
  }
}
@media screen and (max-width: 359px) {
  .quick-menu .dropdown-menu {
    width: 180px;
  }
}
.quick-menu .messages-list .user-avatar {
  position: relative;
}
.quick-menu .messages-list .badge {
  position: absolute;
  inset-inline-start: -4px;
  top: -4px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  padding: 0;
}

.app-header .nav-searchbox.quick-menu .dropdown-menu {
  width: 200px;
  inset-inline-start: 0 !important;
  inset-inline-end: auto !important;
}
.app-header .nav-searchbox.quick-menu .dropdown-menu:after {
  inset-inline-end: auto;
  inset-inline-start: 8px;
}
.app-header .nav-searchbox.quick-menu .dropdown-menu:before {
  inset-inline-end: auto;
  inset-inline-start: 8px;
}
@media screen and (max-width: 400px) {
  .app-header .nav-searchbox.quick-menu {
    display: none;
  }
}

@media screen and (max-width: 575px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 200px;
  }
}
@media screen and (max-width: 399px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 100px;
  }
}
.language-list li {
  display: block !important;
}

.messages-list.language-list ul li {
  padding: 7px 6px 6px;
}

.messages-list ul li {
  position: relative;
  padding: 20px 10px 14px;
  border-bottom: 1px solid #dee2e6;
}
.messages-list ul li .user-name a {
  color: #99BBCD;
}
.messages-list ul li .sub-heading {
  font-size: 11px;
  margin-bottom: 6px !important;
}
.messages-list ul li .sub-heading.mb-0 {
  margin-bottom: 0 !important;
}
.messages-list ul li:last-child {
  border-bottom: 0 none;
}
.messages-list ul li .jr-btn {
  margin-inline-end: 0 !important;
}
.messages-list ul li .jr-btn-xs {
  font-size: 11px !important;
  padding: 5px !important;
}

.quick-menu .icon-btn {
  color: #808080;
}
.quick-menu .icon-alert {
  position: relative;
}
.quick-menu .icon-alert:after {
  display: block;
  position: absolute;
  content: "";
  inset-inline-end: 0;
  top: 0;
  z-index: 10;
  width: 8px;
  height: 8px;
  background-color: #f44336;
  border-radius: 50%;
}
.quick-menu i.animated.infinite {
  -moz-animation-iteration-count: 25;
  -webkit-animation-iteration-count: 25;
  -o-animation-iteration-count: 25;
  animation-iteration-count: 25;
}

.module-box-header-right {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}

.app-top-header {
  position: relative;
  z-index: 9999;
}

/*Navbar Styles*/
.app-main-menu .navbar-nav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.navbar-nav {
  position: relative;
}
.navbar-nav ul.sub-menu {
  list-style: none;
  border: solid 1px #ced4da;
  position: absolute;
  inset-inline-start: 0;
  top: 100px;
  opacity: 0;
  padding: 10px 0;
  background-color: #fff;
  visibility: hidden;
  border-radius: 4px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.navbar-nav-mega {
  position: static !important;
}

.app-top-nav {
  background-color: #99BBCD;
}
.app-top-nav .navbar-nav li.nav-item {
  padding: 0 30px;
}
.app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
  padding: 13px 0;
}
.app-top-nav .navbar-nav li.nav-item:hover > a, .app-top-nav .navbar-nav li.nav-item:focus > a, .app-top-nav .navbar-nav li.nav-item > a:hover, .app-top-nav .navbar-nav li.nav-item > a:focus, .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #E91E63;
}
.app-top-nav .navbar-nav ul.sub-menu {
  margin-top: 0;
}

/*Main Content Styles*/
.app-main-content {
  flex: 1;
  width: 100%;
}

.table-scrollbar {
  min-height: 9px;
}
.table-scrollbar[id*=Top] {
  border-radius: 6px 6px 0 0;
  display: none;
}
.table-scrollbar[id*=Top]::-webkit-scrollbar {
  border-radius: 6px;
  width: 9px;
}
.table-scrollbar[id*=Bottom] {
  border-radius: 0 0 6px 6px;
}
.table-scrollbar[id*=Bottom]::-webkit-scrollbar-thumb {
  background-color: hsl(218, 11%, 65%);
}
.table-scrollbar > div {
  height: 8px;
}

.app-wrapper {
  padding-block: 25px 30px;
  padding-inline: 40px;
  width: 100%;
}
@media screen and (max-width: 575px) {
  .app-wrapper {
    padding-inline: 20px;
    padding-bottom: 20px;
  }
}

/*Footer Styles*/
.app-footer {
  padding: 0 40px;
  color: #333;
  line-height: 30px;
  min-height: 30px;
  background-color: #FFFFFF;
  border-top: none;
  font-size: 9px;
}
.app-footer a {
  color: #333;
}
.app-footer a:hover {
  color: #99BBCD;
}
@media screen and (max-width: 575px) {
  .app-footer {
    padding: 20px;
  }
}

/*Right Sidebar Styles*/
.color-theme {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 300px;
  height: 100%;
}
@media screen and (max-width: 499px) {
  .color-theme {
    max-width: 250px;
  }
}

.color-theme-header {
  background-color: #99BBCD;
  color: #fff;
  padding: 19px 25px 20px;
  text-transform: uppercase;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.color-theme-header .color-theme-title {
  margin-bottom: 0;
}

.color-theme-body {
  padding: 28px 25px;
}
.color-theme-body h3 {
  margin-bottom: 20px;
}
@media screen and (max-width: 499px) {
  .color-theme-body {
    padding: 25px 15px;
  }
}

.color-option {
  list-style: none;
  padding-inline-start: 0;
  margin: 0 -7px 10px;
}
.color-option li {
  position: relative;
  display: inline-block;
  padding: 0 7px;
  margin-bottom: 10px;
}
.color-option li a {
  height: 45px;
  width: 45px;
  line-height: 45px;
  display: inline-block;
  color: transparent !important;
  position: relative;
}
.color-option li a:before {
  content: "\\f26b";
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  height: 45px;
  width: 45px;
  line-height: 45px;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  color: #fff;
  text-align: center;
  display: none;
  z-index: 2;
}
.color-option li a.active:before {
  display: block;
}

.cr-op-dark-sidebar li a:after {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background-color: #333;
  width: 8px;
}

.theme-option {
  position: fixed;
  top: 30%;
  inset-inline-end: 0;
  z-index: 1500;
  background-color: #9C27B0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -o-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  color: #fff;
}
.theme-option span.icon-btn {
  position: relative;
  z-index: 1505;
}

.app-sidebar-content.right-sidebar .rc-drawer-sidebar {
  z-index: 1506;
  color: #333;
  background-color: #fff;
}

.material-switch {
  margin-bottom: 24px;
}
.material-switch > input[type=checkbox] {
  display: none;
}
.material-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 40px;
}
.material-switch > label:before {
  background: rgb(0, 0, 0);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  content: "";
  height: 16px;
  margin-top: -8px;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 40px;
}
.material-switch > label:after {
  background: rgb(255, 255, 255);
  border-radius: 16px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  content: "";
  height: 24px;
  inset-inline-start: -4px;
  margin-top: -8px;
  position: absolute;
  top: -4px;
  transition: all 0.3s ease-in-out;
  width: 24px;
}
.material-switch > input[type=checkbox]:checked + label::before {
  background: #000;
  opacity: 0.5;
}
.material-switch > input[type=checkbox]:checked + label::after {
  background: #495057;
  inset-inline-start: 20px;
}

@media screen and (max-width: 499px) {
  .color-theme .jr-btn {
    padding: 10px 15px !important;
  }
}
/* UI Components
   ========================================================================== */
/*Alert Styles*/
.alert {
  border: 0 none;
  padding: 20px 24px;
  border-radius: 8px;
  position: relative;
}
.alert .close {
  line-height: inherit;
  font-weight: 300;
}
.alert .alert-addon {
  width: 60px;
  background-color: rgba(0, 0, 0, 0.2);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.alert-dismissible {
  padding-inline-end: 60px;
}

.alert-addon-card {
  padding-inline-start: 80px;
}

/*Avatar Styles*/
.user-avatar {
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  position: relative;
  overflow: hidden;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  border-radius: 50%;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  border: 1px solid #ced4da;
}
.user-avatar.avatar-shadow {
  border: 0 none;
}

.user-profile {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
.user-profile .user-detail {
  -webkit-flex: 1;
  flex: 1;
  -ms-flex-align: center;
  -webkit-align-self: center;
  align-self: center;
}

.user-detail .user-name {
  margin-bottom: 2px;
  font-weight: 400;
  text-transform: capitalize;
}
.user-detail .user-description {
  font-size: 12px;
  margin-bottom: 0;
  color: #adb5bd;
}

.user-thumb {
  position: relative;
}
.messages-list .user-thumb {
  margin-inline-end: 8px;
}

/*Badges Styles*/
.badge {
  font-weight: 400;
  padding: 3px 8px;
  line-height: inherit;
  margin-bottom: 6px;
  border-radius: 2px;
}
.badge:not(:last-child) {
  margin-inline-end: 15px;
}
table .badge {
  margin-bottom: 0;
}

.badge-pill {
  border-radius: 20px;
}

.badge-border {
  border: 2px solid !important;
}

.badge-outline {
  background-color: transparent;
  border: 1px solid #ced4da;
}

/*Blockquotes Styles*/
blockquote {
  padding-block: 10px;
  padding-inline-end: 0;
  padding-inline-start: 20px;
  font-size: 14px !important;
}
blockquote .blockquote-footer {
  font-size: 14px !important;
}

.blockquote {
  border-inline-start: 5px solid #e9ecef;
}

.blockquote-reverse {
  border-inline-start: 0 none;
  border-inline-end: 5px solid #e9ecef;
  text-align: right;
  padding-inline-start: 0;
  padding-inline-end: 20px;
}

/*Bottom Navigation Styles*/
.bottom-navigation button {
  min-width: 10px !important;
}

/*Breadcrumb Styles*/
.breadcrumb {
  border-radius: 2px;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: "\\f2fb";
  font-family: "Material-Design-Iconic-Font";
  font-size: 16px;
  line-height: 1;
  vertical-align: middle;
}

/*Button Styles*/
.jr-btn {
  position: relative;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  line-height: 1.2;
  border-radius: 4px;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
}
.jr-btn:hover, .jr-btn:focus, .jr-btn:active {
  outline: 0 none;
  text-decoration: none;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}
.login-content .jr-btn {
  padding: 10px 35px;
}

.jr-btn,
.jr-fab-btn,
.jr-flat-btn {
  margin-bottom: 6px;
  text-transform: capitalize;
}
.jr-btn:not(:last-child),
.jr-fab-btn:not(:last-child),
.jr-flat-btn:not(:last-child) {
  margin-inline-end: 15px;
}
.form-inline .jr-btn,
.form-inline .jr-fab-btn,
.form-inline .jr-flat-btn {
  margin-bottom: 0;
  min-height: 35px;
}
.navbar .jr-btn,
.navbar .jr-fab-btn,
.navbar .jr-flat-btn {
  margin-bottom: 0;
}

.jr-fab-btn {
  position: relative;
  display: inline-flex;
  border-radius: 50%;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  background-color: #eeeeee;
  overflow: hidden;
}
.jr-fab-btn:hover, .jr-fab-btn:focus {
  outline: 0 none;
  text-decoration: none;
}

.jr-btn,
.jr-flat-btn {
  padding: 12px 20px;
}
.jr-btn i + span, .jr-btn span + i,
.jr-flat-btn i + span,
.jr-flat-btn span + i {
  margin-inline-start: 6px;
}

.jr-flat-btn {
  background-color: transparent;
  color: #333;
}
.jr-flat-btn:hover, .jr-flat-btn:focus, .jr-flat-btn:active {
  background-color: #f5f5f5;
  color: #333;
}

.jr-btn-group {
  margin: 0 -8px;
}
.jr-btn-group:not(:last-child) {
  margin-bottom: 16px;
}
.jr-btn-group .jr-btn, .jr-btn-group .jr-fab-btn {
  margin: 0 8px 18px;
}

.jr-btn-rounded {
  border-radius: 50px !important;
}

.jr-btn-lg, .btn-group-lg > .jr-btn {
  padding: 16px 24px;
}

.jr-btn-sm, .btn-group-sm > .jr-btn {
  padding: 8px 15px;
}

.jr-btn-xs {
  padding: 6px 10px;
}

.jr-btn-fab-lg,
.jr-btn-lg,
.btn-group-lg > .jr-btn {
  font-size: 18px;
}
.jr-btn-fab-lg i,
.jr-btn-lg i,
.btn-group-lg > .jr-btn i {
  font-size: 20px;
}

.jr-btn-fab-sm,
.jr-btn-sm,
.btn-group-sm > .jr-btn {
  font-size: 12px;
}
.jr-btn-fab-sm i,
.jr-btn-sm i,
.btn-group-sm > .jr-btn i {
  font-size: 12px;
}

.jr-btn-fab-xs,
.jr-btn-xs {
  font-size: 10px;
}
.jr-btn-fab-xs i,
.jr-btn-xs i {
  font-size: 10px;
}

.complex-btn-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-width: 200px;
  width: 100%;
}

.complex-btn {
  position: relative;
  height: 200px;
  overflow: hidden;
  width: 33.333%;
  border: 0 none;
}
@media screen and (max-width: 767px) {
  .complex-btn {
    width: 100%;
    height: 100px;
  }
}
.complex-btn:hover {
  z-index: 1;
}
.complex-btn:hover .img-btn-overlay {
  opacity: 0.15;
}
.complex-btn:hover .img-marked {
  opacity: 0;
}
.complex-btn:hover .img-title {
  border: 4px solid currentColor;
}
.complex-btn .img-btn {
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  top: 0;
  bottom: 0;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  color: #fff;
}
.complex-btn .img-src {
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center 40%;
}
.complex-btn .img-btn-overlay {
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  top: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.complex-btn .img-title {
  position: relative;
  padding: 16px 32px 14px;
}
.complex-btn .img-marked {
  height: 3px;
  width: 18px;
  background: #fff;
  position: absolute;
  bottom: -2px;
  inset-inline-start: calc(50% - 9px);
  -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-group-mins {
  margin: 0 -5px;
}
.btn-group-mins .btn, .btn-group-mins .jr-btn {
  margin: 0 5px 5px;
}

.jr-btn.jr-btn-label i {
  background-color: rgba(255, 255, 255, 0.2);
  width: 40px;
  height: 100%;
  line-height: 42px;
  text-align: center;
}

.jr-btn.jr-btn-label.left i {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  bottom: 0;
  z-index: 1;
}

.jr-btn.jr-btn-label.right i {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  z-index: 1;
}

.jr-btn.jr-btn-label.left i + span {
  margin-inline-start: 30px;
}

.jr-btn.jr-btn-label.right i + span {
  margin-inline-end: 30px;
  margin-inline-start: 0;
}

.jr-btn.jr-btn-label.jr-btn-lg i, .btn-group-lg > .jr-btn.jr-btn-label i {
  line-height: 54px;
}

.jr-btn.jr-btn-label.jr-btn-sm i, .btn-group-sm > .jr-btn.jr-btn-label i {
  line-height: 32px;
}

.jr-btn.jr-btn-label.jr-btn-xs i {
  line-height: 24px;
  width: 30px;
}

.btn-primary {
  background-color: #99BBCD;
  color: #fff;
}
.btn-primary:hover, .btn-primary:focus {
  background-color: rgb(135.8881578947, 175.5921052632, 196.6118421053);
  color: #fff;
}

.btn-red {
  background-color: #F44336;
  color: #fff;
}
.btn-red:hover, .btn-red:focus {
  background-color: rgb(242.6768867925, 44.3867924528, 29.8231132075);
  color: #fff;
}

.btn-pink {
  background-color: #e91e63;
  color: #fff;
}
.btn-pink:hover, .btn-pink:focus {
  background-color: rgb(216.3461538462, 21.1538461538, 87.5);
  color: #fff;
}

.btn-purple {
  background-color: #9C27B0;
  color: #fff;
}
.btn-purple:hover, .btn-purple:focus {
  background-color: rgb(137.4976744186, 34.3744186047, 155.1255813953);
  color: #fff;
}

.btn-deep-purple {
  background-color: #673ab7;
  color: #fff;
}
.btn-deep-purple:hover, .btn-deep-purple:focus {
  background-color: rgb(92.101659751, 51.8630705394, 163.6369294606);
  color: #fff;
}

.btn-indigo {
  background-color: #99BBCD;
  color: #fff;
}
.btn-indigo:hover, .btn-indigo:focus {
  background-color: rgb(135.8881578947, 175.5921052632, 196.6118421053);
  color: #fff;
}

.btn-blue {
  background-color: #2196F3;
  color: #fff;
}
.btn-blue:hover, .btn-blue:focus {
  background-color: rgb(12.8461538462, 138.0961538462, 237.6538461538);
  color: #fff;
}

.btn-light-blue {
  background-color: #03a9f4;
  color: #fff;
}
.btn-light-blue:hover, .btn-light-blue:focus {
  background-color: rgb(2.6902834008, 151.5526315789, 218.8097165992);
  color: #fff;
}

.btn-cyan {
  background-color: #00bcd4;
  color: #fff;
}
.btn-cyan:hover, .btn-cyan:focus {
  background-color: rgb(0, 165.3867924528, 186.5);
  color: #fff;
}

.btn-teal {
  background-color: #009688;
  color: #fff;
}
.btn-teal:hover, .btn-teal:focus {
  background-color: rgb(0, 124.5, 112.88);
  color: #fff;
}

.btn-green {
  background-color: #4CAF50;
  color: #fff;
}
.btn-green:hover, .btn-green:focus {
  background-color: rgb(68.2788844622, 157.2211155378, 71.8725099602);
  color: #fff;
}

.btn-light-green {
  background-color: #8bc34a;
  color: #fff;
}
.btn-light-green:hover, .btn-light-green:focus {
  background-color: rgb(126.2966804979, 182.877593361, 60.622406639);
  color: #fff;
}

.btn-lime {
  background-color: #cddc39;
  color: #fff;
}
.btn-lime:hover, .btn-lime:focus {
  background-color: rgb(197.5300429185, 213.7210300429, 37.7789699571);
  color: #fff;
}

.btn-yellow {
  background-color: #ffeb3b;
  color: #fff;
}
.btn-yellow:hover, .btn-yellow:focus {
  background-color: rgb(255, 232.3979591837, 33.5);
  color: #fff;
}

.btn-amber {
  background-color: #ffc107;
  color: #fff;
}
.btn-amber:hover, .btn-amber:focus {
  background-color: rgb(236.5, 177.375, 0);
  color: #fff;
}

.btn-orange {
  background-color: #ff9800;
  color: #fff;
}
.btn-orange:hover, .btn-orange:focus {
  background-color: rgb(229.5, 136.8, 0);
  color: #fff;
}

.btn-deep-orange {
  background-color: #ff5722;
  color: #fff;
}
.btn-deep-orange:hover, .btn-deep-orange:focus {
  background-color: rgb(255, 67.6153846154, 8.5);
  color: #fff;
}

.btn-brown {
  background-color: #795548;
  color: #fff;
}
.btn-brown:hover, .btn-brown:focus {
  background-color: rgb(105.0129533679, 73.7694300518, 62.4870466321);
  color: #fff;
}

.btn-blue-grey {
  background-color: #607d8b;
  color: #fff;
}
.btn-blue-grey:hover, .btn-blue-grey:focus {
  background-color: rgb(85.5829787234, 111.4361702128, 123.9170212766);
  color: #fff;
}

.btn-grey {
  background-color: #9e9e9e;
  color: #fff;
}
.btn-grey:hover, .btn-grey:focus {
  background-color: rgb(145.25, 145.25, 145.25);
  color: #fff;
}

.jr-btn-shadow {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
}
.jr-btn-shadow:hover, .jr-btn-shadow:focus {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
}
.jr-btn-shadow:active {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.jr-btn.disabled,
.jr-btn.disabled {
  pointer-events: none;
  opacity: 0.65;
}

.jr-btn-default {
  background-color: #fff;
  color: #333;
  border: 1px solid #dee2e6;
}
.jr-btn-default:hover, .jr-btn-default:focus {
  background-color: rgb(242.25, 242.25, 242.25);
  color: #333;
}

.jr-btn-secondary {
  background-color: #E91E63;
  color: #fff;
}
.jr-btn-secondary:hover, .jr-btn-secondary:focus {
  background-color: rgb(216.3461538462, 21.1538461538, 87.5);
  color: #fff;
}

.jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #99BBCD;
}
.jr-flat-btn.jr-btn-primary:hover, .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(153, 187, 205, 0.12);
  color: #99BBCD;
}

.bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #fff;
}
.bg-primary .jr-flat-btn.jr-btn-primary:hover, .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #E91E63;
}
.jr-flat-btn.jr-btn-secondary:hover, .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(233, 30, 99, 0.12);
  color: #E91E63;
}

.bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #fff;
}
.bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.jr-btn-hover:hover:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  z-index: 1;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.06);
}

.dropdown-toggle-split {
  padding-inline-end: 0.5625rem;
  padding-inline-start: 0.5625rem;
}

.action-btn {
  height: 40px;
  width: 40px;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.54);
}
.action-btn:hover, .action-btn:focus, .action-btn:active {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.64);
}
.circle-check .action-btn {
  height: 24px;
  width: 24px;
  font-size: 16px;
}
.chat-main-header .action-btn {
  color: #fff;
}

.action-replay .jr-btn-default {
  font-size: 14px;
  padding: 5px 10px;
  border-color: #6c757d !important;
}

.toggler-btn {
  width: 29px;
  height: 18px;
  background-color: #D4D9DF;
  border-radius: 18px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
}
.toggler-btn::after {
  display: block;
  content: "";
  width: 14px;
  height: 14px;
  background-color: #F4F4F4;
  border-radius: 12px;
  margin-inline-start: 2px;
  margin-inline-end: 2px;
  transition-duration: 0.2s;
}
.toggler-btn:not(.false) {
  background-color: #99bbcd;
}
.toggler-btn:not(.false)::after {
  margin-inline-start: 13px;
  background-color: white;
}
.toggler-btn:active::after, .toggler-btn:focus::after {
  width: 17px;
}

.goback {
  padding: 3px 5px !important;
  overflow: hidden;
  transition-duration: 0.2s;
}
.goback span {
  display: inline-block;
  margin-inline-end: -40px;
  font-weight: 700;
  opacity: 0;
  transition-duration: 0.2s;
}
.goback:hover {
  padding: 3px 16px !important;
  transition-duration: 0.2s;
}
.goback:hover span {
  margin-inline-end: 0;
  opacity: 1;
}

.add-data-entry {
  width: 26px;
  height: 26px;
  border-radius: 24px;
  color: white;
  cursor: pointer;
}
.add-data-entry:hover {
  background-color: white;
  color: #99bbcd;
  border: none;
}

.group-delete-btn {
  color: #EA3D2F;
  font-size: 16px;
  padding: 5px;
  cursor: pointer;
}
.group-delete-btn:hover {
  color: #ba3023;
}

.system-button:where(.btn, .btn-secondary) {
  background-color: var(--button-bg-color) !important;
  color: var(--button-text-color) !important;
  padding-inline: var(--button-inline-padding) !important;
  padding-block: 0 !important;
  height: var(--button-height) !important;
  border-radius: var(--button-border-radius) !important;
  box-shadow: none !important;
}
.system-button:where(.btn, .btn-secondary) span {
  color: inherit !important;
  font: inherit !important;
}
.system-button:where(.btn, .btn-secondary):hover {
  background-color: var(--button-bg-color);
  color: var(--button-text-color);
}
.system-button:where(.btn, .btn-secondary):not(:last-child) {
  margin-inline-end: 0;
}
.system-button:where(.btn, .btn-secondary):active {
  box-shadow: none !important;
  border-color: transparent !important;
}

.db-structure-button {
  margin-inline-start: 20px;
}

.db-trash-button:hover .button-icon {
  color: hsl(0, 84%, 60%);
}

.btn-link {
  cursor: pointer;
}

/*Button Group Styles*/
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .jr-btn,
.btn-group-vertical > .jr-btn {
  position: relative;
  flex: 0 1 auto;
  border-color: #dee2e6;
}
.btn-group > .jr-btn:hover,
.btn-group-vertical > .jr-btn:hover {
  z-index: 2;
}
.btn-group > .jr-btn:focus, .btn-group > .jr-btn:active, .btn-group > .jr-btn.active,
.btn-group-vertical > .jr-btn:focus,
.btn-group-vertical > .jr-btn:active,
.btn-group-vertical > .jr-btn.active {
  z-index: 2;
}
.btn-group > .jr-btn.active,
.btn-group-vertical > .jr-btn.active {
  background-color: #99BBCD;
  color: #fff;
  border-color: #99BBCD;
}
.btn-group > .jr-btn.jr-flat-btn,
.btn-group-vertical > .jr-btn.jr-flat-btn {
  border-color: transparent;
}
.btn-group > .jr-btn.jr-flat-btn.active,
.btn-group-vertical > .jr-btn.jr-flat-btn.active {
  background-color: transparent;
  color: #99BBCD;
}
.btn-group > .jr-btn.jr-flat-btn.active:hover, .btn-group > .jr-btn.jr-flat-btn.active:focus,
.btn-group-vertical > .jr-btn.jr-flat-btn.active:hover,
.btn-group-vertical > .jr-btn.jr-flat-btn.active:focus {
  background-color: rgba(153, 187, 205, 0.12);
  color: #99BBCD;
}
.btn-group .jr-btn + .jr-btn,
.btn-group .jr-btn + .btn-group,
.btn-group .btn-group + .jr-btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .jr-btn + .jr-btn,
.btn-group-vertical .jr-btn + .btn-group,
.btn-group-vertical .btn-group + .jr-btn,
.btn-group-vertical .btn-group + .btn-group {
  margin-inline-start: -1px;
}

.btn-group.no-border > .btn-group > .jr-btn, .btn-group.no-border > .btn-group-vertical > .jr-btn, .btn-group.no-border > .jr-btn,
.btn-group-vertical.no-border > .btn-group > .jr-btn,
.btn-group-vertical.no-border > .btn-group-vertical > .jr-btn,
.btn-group-vertical.no-border > .jr-btn {
  border-color: transparent;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}

.btn-group > .jr-btn:first-child {
  margin-inline-start: 0;
}
.btn-group > .jr-btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .jr-btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group > .btn-group {
  float: inline-start;
}

.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0;
}

.btn-group > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.jr-btn + .dropdown-toggle-split {
  padding-inline-end: 0.5625rem;
  padding-inline-start: 0.5625rem;
}
.jr-btn + .dropdown-toggle-split::after {
  margin-inline-start: 0;
}

.jr-btn-sm + .dropdown-toggle-split, .btn-group-sm > .jr-btn + .dropdown-toggle-split {
  padding-inline-end: 0.375rem;
  padding-inline-start: 0.375rem;
}

.jr-btn-lg + .dropdown-toggle-split, .btn-group-lg > .jr-btn + .dropdown-toggle-split {
  padding-inline-end: 0.75rem;
  padding-inline-start: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -o-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical .jr-btn,
.btn-group-vertical .btn-group {
  width: 100%;
}
.btn-group-vertical > .jr-btn + .jr-btn,
.btn-group-vertical > .jr-btn + .btn-group,
.btn-group-vertical > .btn-group + .jr-btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-inline-start: 0;
}
.btn-group-vertical > .jr-btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.btn-group-vertical > .jr-btn:first-child:not(:last-child) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .jr-btn:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

[data-toggle=buttons] > .jr-btn input[type=radio],
[data-toggle=buttons] > .jr-btn input[type=checkbox],
[data-toggle=buttons] > .btn-group > .jr-btn input[type=radio],
[data-toggle=buttons] > .btn-group > .jr-btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.btn-group > .jr-btn,
.btn-group > .btn,
.btn-group-vertical > .jr-btn,
.btn-group-vertical > .btn {
  margin-inline-end: 0;
  margin-bottom: 0;
}

/*Callout Styles*/
.card-image .grid-thumb-equal {
  padding-bottom: 82%;
}

/*Product listing page style*/
.product-row {
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: right;
}
.product-row.even {
  text-align: left;
}

.product-col {
  order: 1;
  width: 50%;
}

.odd .product-thumb {
  order: 2;
}

.product-content {
  padding: 20px 55px;
}

.product-row .grid-thumb-equal {
  padding-bottom: 69%;
}

.product-thumb img {
  width: 100%;
}

.product-content h4 {
  margin-bottom: 25px;
}

@media screen and (max-width: 1230px) {
  .product-row .grid-thumb-equal {
    padding-bottom: 71%;
  }
}
@media screen and (max-width: 1199px) {
  .product-content h4 {
    margin-bottom: 10px;
  }
  .product-content {
    padding: 20px 35px;
  }
  .product-row .grid-thumb-equal {
    padding-bottom: 85%;
  }
}
@media screen and (max-width: 991px) {
  .card-image .grid-thumb-equal {
    padding-bottom: 120%;
  }
}
@media screen and (max-width: 767px) {
  .product-row {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }
  .product-row.even {
    text-align: center;
  }
  .product-content {
    padding: 20px 0;
  }
  .product-col,
  .odd .product-thumb {
    order: 1;
    width: 100%;
  }
  .product-row .grid-thumb-equal {
    padding-bottom: 44%;
  }
  .card-image .grid-thumb-equal {
    padding-bottom: 44%;
  }
}
/*Cards Styles*/
.profile-intro {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.profile-intro img.avatar-circle {
  display: inline-block;
  border-radius: 50%;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  margin: 0 auto;
  -webkit-transform: translateY(50px);
  -ms-transform: translateY(50px);
  transform: translateY(50px);
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 1;
}
.profile-intro:hover .avatar-circle {
  -webkit-transition: border-radius 0.4s ease 0.1s;
  -o-transition: border-radius 0.4s ease 0.1s;
  transition: border-radius 0.4s ease 0.1s;
  border-radius: 25%;
}

.profile-intro .card-image {
  position: relative;
  width: 100%;
  min-height: 100%;
}
.profile-intro .pi-content {
  padding: 70px 40px 24px;
}
.profile-intro .pi-footer {
  padding: 0 40px 24px;
}
.profile-intro .icon {
  display: inline-block;
  -webkit-transition: all 0.2s ease 0s;
  -o-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
  color: #99BBCD;
}
.profile-intro .icon:hover, .profile-intro .icon:focus, .profile-intro .icon:active {
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}
.profile-intro .icon:not(:last-child) {
  margin-inline-end: 10px;
}

.layer:before {
  display: block;
  content: "";
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.card.jr-card-full-height,
.jr-card.jr-card-full-height {
  height: calc(100% - 34px);
}
@media screen and (max-width: 575px) {
  .card.jr-card-full-height,
  .jr-card.jr-card-full-height {
    height: auto;
  }
}

.jr-card > .jr-card-body:first-child {
  margin-top: 6px;
}
.jr-card.p-0 > .jr-card-body:first-child {
  margin-top: 0;
}
.jr-card .jr-card-thumb {
  margin: -24px -30px 0;
}
.jr-card .jr-card-thumb .card-img {
  border-radius: 8px 8px 0 0;
}
@media screen and (max-width: 575px) {
  .jr-card {
    margin-bottom: 18px;
  }
}

.jr-card-header {
  margin-bottom: 24px;
}
.jr-card-header .card-heading {
  margin-bottom: 4px;
}
.jr-card-header .badge {
  margin-bottom: 0;
}
.jr-card-header .badge:last-child {
  margin-inline-start: 10px;
}
@media screen and (max-width: 575px) {
  .jr-card-header {
    margin-bottom: 18px;
  }
}

.jr-entry-header {
  margin-bottom: 24px;
}
.jr-entry-header .entry-heading {
  margin-bottom: 4px;
}
.jr-entry-header .entry-description {
  margin-bottom: 0;
  font-size: 13px;
  color: #6c757d;
}
@media screen and (max-width: 575px) {
  .jr-entry-header {
    margin-bottom: 18px;
  }
}

.card {
  margin-bottom: 34px;
}
@media screen and (max-width: 575px) {
  .card {
    margin-bottom: 18px;
  }
}

.card-header {
  font-size: 16px;
}
.card-header .badge {
  margin-bottom: 0;
}
.card-header .badge:last-child {
  margin-inline-start: 10px;
}

.card-title {
  font-size: 17px;
  text-transform: capitalize;
}

.card-subtitle {
  font-size: 14px;
  color: #495057;
}
.card-subtitle:not(:last-child) {
  margin-bottom: 17px;
}

.card-mt-footer {
  padding: 0 15px 20px;
  margin-top: -10px;
}

.jr-card-social {
  font-size: 22px;
  padding-top: 26px;
}

.social-link {
  list-style: none;
  padding-inline-start: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin: 0 -5px 10px;
}
.social-link li {
  padding: 0 5px;
  margin-bottom: 5px;
}
.social-link li a {
  color: #333;
}
.social-link li.active a, .social-link li a:hover, .social-link li a:focus {
  color: #E91E63;
}
.jr-card-social .social-link {
  margin-bottom: 0;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}

.jr-cart-ab {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  z-index: 1;
  color: #fff;
  font-size: 17px;
}
.jr-cart-ab i {
  vertical-align: middle;
  font-size: 25px;
}

.img-overlay-card {
  border-radius: 8px;
  margin-bottom: 34px;
}
@media screen and (max-width: 1199px) {
  .img-overlay-card .center-crop-img {
    min-height: 135px;
  }
}
@media screen and (max-width: 767px) {
  .img-overlay-card .center-crop-img {
    min-height: 160px;
  }
}
@media screen and (max-width: 575px) {
  .img-overlay-card {
    margin-bottom: 18px;
  }
}

/*Charts Styles*/
.chart-header {
  padding: 15px 18px;
}
.chart-header .card-title h4 {
  color: #fff;
  margin-bottom: 4px;
}
.chart-header .title h4 {
  margin-bottom: 4px;
}
.chart-header p {
  margin-bottom: 4px;
}

/*Chips Styles*/
.chip-outline {
  background-color: transparent !important;
  border: 1px solid #adb5bd !important;
}

/*Carousel Styles*/
.carousel-caption h3 {
  font-size: 19px;
}

/*Color Picker Styles*/
.cp-color {
  width: 36px;
  height: 14px;
  border-radius: 2px;
}

.cp-swatch {
  padding: 5px;
  background: #fff;
  border-radius: 1px;
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
}

.cp-popover {
  position: absolute;
  z-index: 2;
}

.cp-cover {
  position: fixed;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
}

.photoshop-picker,
.swatches-picker,
.alpha-picker,
.hue-picker {
  width: 100% !important;
}

.material-picker {
  width: 100% !important;
  height: 100% !important;
}

.rc-time-picker-input {
  height: 31px !important;
}

.date-btn {
  display: inline-block;
  vertical-align: top;
}

/*Drawer Styles*/
.drawer {
  width: 250px;
}

.full-drawer {
  width: 100%;
}

/*E-commerce Styles*/
.product-item, .product-item-vertical {
  overflow: hidden;
}

.product-item-vertical .card-image .grid-thumb-equal {
  padding-bottom: 110%;
}
@media screen and (max-width: 1199px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 74%;
  }
}
@media screen and (max-width: 991px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 110%;
  }
}
@media screen and (max-width: 829px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 120%;
  }
}
@media screen and (max-width: 767px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 44%;
  }
}

/*Grids List Styles*/
.gl-image,
.gl-list,
.gl-advanced,
.gl-single-line {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  overflow: hidden;
}

.gl {
  max-width: 100%;
  max-height: 360px;
  transform: translateZ(0);
}
.gl.row.no-gutters {
  margin: 0 -2px;
}
.gl.row.no-gutters .col, .gl.row.no-gutters > [class*=col-] {
  padding-inline-end: 2px;
  padding-inline-start: 2px;
  margin-bottom: 4px;
}

.gl-single-line .slg {
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 100%;
}

.title-gradient {
  background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
}

.title-gradient-bottom {
  background: -webkit-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
}

.g-title {
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

.grid {
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden;
}
.grid > img {
  top: 50%;
  inset-inline-start: 50%;
  position: relative;
  transform: translate(-50%, -50%);
  display: flex;
  padding: 0;
  flex-wrap: wrap;
}

.g-ul {
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  overflow-y: auto;
  list-style: none;
  -webkit-overflow-scrolling: touch;
}

.gradient-text {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  color: white;
}

.title-gradient-bottom {
  padding: 20px;
  bottom: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
}

.title-gradient-top {
  padding: 10px;
  top: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
}

.grid-thumb img {
  max-height: 185px;
}

.gl-advanced-grid {
  position: relative;
}

/*Icons Styles*/
.icon {
  display: inline-block;
  text-align: center;
}

.icons-wrapper {
  display: inline-block;
}
.icons-wrapper + .icons-wrapper {
  margin-inline-start: 25px;
}

/*Label Styles*/
label {
  margin-bottom: 0;
}

/*List Styles*/
.pinned-list {
  position: relative;
  height: 370px;
  overflow: auto;
  width: auto;
}

.user-list {
  width: 100%;
  padding: 20px 15px 10px;
}
.user-list.card {
  padding-inline-start: 30px;
}
@media screen and (max-width: 575px) {
  .user-list.card {
    padding-inline-start: 15px;
  }
}
.user-list .user-avatar {
  margin-inline-end: 20px;
  margin-bottom: 10px;
}
.user-list h3 {
  font-weight: 700;
  margin-bottom: 8px;
}
.user-list a[class*=meta-] i {
  margin-inline-end: 6px;
}
.user-list a[class*=meta-]:hover {
  text-decoration: none;
}
.user-list a[class*=meta-] {
  display: inline-block;
  color: #333;
  font-size: 14px;
  font-weight: 700;
}

.user-list .img-section {
  width: 230px;
}
@media screen and (max-width: 649px) {
  .user-list .img-section {
    width: 100%;
  }
}
.user-list .description {
  width: calc(100% - 300px);
}
@media screen and (max-width: 649px) {
  .user-list .description {
    width: 100%;
  }
}
.user-list .jr-btn-list li:not(:last-child) {
  margin-inline-end: 10px;
}
.user-list .jr-btn-list .btn-light {
  background-color: rgb(211.25, 211.25, 211.25);
  border-color: rgb(211.25, 211.25, 211.25);
  color: #333;
  font-weight: 600;
}
.user-list .jr-btn-list .btn-light:hover, .user-list .jr-btn-list .btn-light:focus, .user-list .jr-btn-list .btn-light:active {
  background-color: rgb(198.5, 198.5, 198.5);
  border-color: rgb(198.5, 198.5, 198.5);
}
.user-list .jr-btn-list.badge-list li:not(:last-child) {
  margin-inline-end: 0;
}

.list-inline {
  margin-inline-start: -5px;
  margin-inline-end: -5px;
}
.list-inline li {
  padding: 0 5px;
  display: inline-block;
}
.list-inline li.media {
  display: flex;
}

.card-strip {
  border-bottom: solid 1px #dee2e6;
  margin-bottom: 10px;
}

.jr-mbtn-list {
  margin-inline-start: -20px;
}

.img-res {
  max-width: 100%;
  height: auto;
}

.publication-page {
  height: 100%;
  overflow-y: auto;
}
.publication-page .item {
  padding-block: 1.8rem;
  border-bottom: solid 2px hsl(225, 13%, 94%);
  text-align: start;
  max-width: 760px;
}
.publication-page .item .item-value-cell {
  margin-top: 12px;
  font: normal 16px/24px Open Sans, sans-serif;
  color: hsl(0, 0%, 7%);
}
.publication-page .item .item-value-cell:nth-child(1) {
  color: hsl(218, 11%, 65%);
  font: normal 600 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  margin-top: 0px;
}
.publication-page .item .item-value-cell:nth-child(2) {
  font: normal 22px/28px Open Sans, sans-serif;
  color: hsl(0, 0%, 7%);
  margin-top: 0px;
}
.publication-page .item .item-value-cell:nth-child(3) {
  font: normal 700 10px/10px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  background-color: #D5B78B;
  color: hsl(0, 50%, 100%);
  margin-top: 10px;
  display: inline-block;
  padding: 4px 8px;
  border-radius: 10px;
  min-width: initial;
}
.publication-page .item .item-value-cell:nth-child(4) {
  font: normal 16px/24px Open Sans, sans-serif;
  color: hsl(0, 0%, 7%);
  margin-top: 18px;
}
.publication-page .item .item-value-cell .system-button:has([class*=fa-file]) {
  font-size: 20px;
  min-width: auto;
  height: auto;
  color: #315a4e;
}
.publication-page .item .item-value-cell .system-button:has([class*=fa-file]):hover {
  --button-bg-color: transparent;
}
.publication-page .item:first-child {
  padding-block-start: 1rem;
}
.publication-page .item:last-child {
  border-bottom: none;
  padding-block-end: 0rem;
}
.publication-page .pagination {
  align-items: center;
}
.publication-page .pagination-controls {
  display: flex;
}
.publication-page .page-summary {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  cursor: pointer;
  padding: 0.5rem;
}

.card-header.bg-primary .nav-link {
  color: #fff;
}
.card-header.bg-primary .nav-link.active, .card-header.bg-primary .nav-link:hover, .card-header.bg-primary .nav-link:focus {
  color: #000;
  background-color: #fff;
}
.card-header.bg-primary .nav-link.disabled {
  color: #f8f9fa;
}
.card-header.bg-primary .nav-link.disabled:hover {
  color: #212529;
}

/*Pricing Styles*/
.pt-classic .package,
.pt-default .package,
.pt-dark .package,
.pt-circle .package {
  position: relative;
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active,
.pt-default .package:hover,
.pt-default .package:focus,
.pt-default .package:active,
.pt-dark .package:hover,
.pt-dark .package:focus,
.pt-dark .package:active,
.pt-circle .package:hover,
.pt-circle .package:focus,
.pt-circle .package:active {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  transform: scale(1.05);
}
.pt-classic .package.highlight,
.pt-default .package.highlight,
.pt-dark .package.highlight,
.pt-circle .package.highlight {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
  z-index: 2;
}
.pt-classic .package-header,
.pt-default .package-header,
.pt-dark .package-header,
.pt-circle .package-header {
  padding: 35px;
  text-align: center;
}
.pt-classic .package-header > .price,
.pt-default .package-header > .price,
.pt-dark .package-header > .price,
.pt-circle .package-header > .price {
  display: inline-block;
  font-size: 36px;
  font-weight: 700;
  margin-inline-start: 0;
  margin-bottom: 12px;
}
.pt-classic .package-header > .price > i,
.pt-default .package-header > .price > i,
.pt-dark .package-header > .price > i,
.pt-circle .package-header > .price > i {
  display: inline-block;
  margin-inline-end: 6px;
  font-weight: bold;
}
.pt-classic .package-header h5,
.pt-default .package-header h5,
.pt-dark .package-header h5,
.pt-circle .package-header h5 {
  color: inherit;
}
.pt-classic .package-items,
.pt-default .package-items,
.pt-dark .package-items,
.pt-circle .package-items {
  list-style: none;
  font-size: 14px;
  margin: 0;
  padding: 50px 50px 120px;
}
.pt-classic .package-items li,
.pt-default .package-items li,
.pt-dark .package-items li,
.pt-circle .package-items li {
  margin-bottom: 16px;
  line-height: inherit;
}
.pt-classic .package-items li:before, .pt-classic .package-items li:after,
.pt-default .package-items li:before,
.pt-default .package-items li:after,
.pt-dark .package-items li:before,
.pt-dark .package-items li:after,
.pt-circle .package-items li:before,
.pt-circle .package-items li:after {
  content: " ";
  display: table;
}
.pt-classic .package-items li:after,
.pt-default .package-items li:after,
.pt-dark .package-items li:after,
.pt-circle .package-items li:after {
  clear: both;
}
.pt-classic .package-items li i,
.pt-default .package-items li i,
.pt-dark .package-items li i,
.pt-circle .package-items li i {
  float: inline-start;
  min-width: 20px;
  margin-inline-end: 16px;
  line-height: inherit;
}
.pt-classic .package-items li span,
.pt-default .package-items li span,
.pt-dark .package-items li span,
.pt-circle .package-items li span {
  display: block;
  overflow: hidden;
}
.pt-classic .package-footer,
.pt-default .package-footer,
.pt-dark .package-footer,
.pt-circle .package-footer {
  bottom: 0;
  inset-inline-start: 0;
  position: absolute;
  inset-inline-end: 0;
  padding: 40px 50px;
  text-align: center;
}
.pt-classic .package-footer .btn,
.pt-default .package-footer .btn,
.pt-dark .package-footer .btn,
.pt-circle .package-footer .btn {
  color: inherit;
  padding: 10px 30px;
  border: 0 none;
}

.pt-classic .package {
  border: 0 none;
  border-radius: 0;
}

.pt-dark .package:hover {
  border-radius: 20px;
}

.pt-circle .package-header {
  border-radius: 50%;
  height: 224px;
  width: 224px;
  margin: 40px auto 0;
  -webkit-align-items: center;
  align-items: center;
}
.pt-circle .package-header .price {
  margin-top: 30px;
}

@media only screen and (max-width: 991px) {
  .pt-classic .package-header,
  .pt-default .package-header,
  .pt-dark .package-header,
  .pt-circle .package-header {
    padding: 30px 20px;
  }
  .pt-classic .package-items,
  .pt-default .package-items,
  .pt-dark .package-items,
  .pt-circle .package-items {
    padding: 30px 20px 120px;
  }
  .pt-circle .package-header {
    height: 204px;
    width: 204px;
  }
}
@media only screen and (max-width: 767px) {
  .pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active, .pt-classic .package.highlight,
  .pt-default .package:hover,
  .pt-default .package:focus,
  .pt-default .package:active,
  .pt-default .package.highlight,
  .pt-dark .package:hover,
  .pt-dark .package:focus,
  .pt-dark .package:active,
  .pt-dark .package.highlight,
  .pt-circle .package:hover,
  .pt-circle .package:focus,
  .pt-circle .package:active,
  .pt-circle .package.highlight {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
}
/*Progressbar Styles*/
.pb-wrapper {
  display: flex;
  align-items: center;
}

.pb-btn-wrapper {
  margin: 8px;
  position: relative;
}
.pb-btn-wrapper .btn-success {
  background-color: #4CAF50;
}
.pb-btn-wrapper .btn-success:hover {
  background-color: #388E3C;
}

.fab-progress {
  color: #4CAF50;
  position: absolute;
  top: -6px;
  inset-inline-start: -6px;
  z-index: 1;
}

.btn-progress {
  color: #4CAF50;
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  margin-top: -12px;
  margin-inline-start: -12px;
}

/*Popover Styles*/
.popover {
  z-index: 1510;
}

.popover-header {
  background-color: transparent;
  border-bottom: 0 none;
  color: #000;
  font-size: 19px;
  padding: 15px 20px 0;
}

.popover-body {
  padding: 15px 20px;
}

/*React Joyride Styles*/
.joyride-beacon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: 0;
  height: 36px;
  position: relative;
  width: 36px;
  z-index: 1500;
}
.joyride-beacon:active, .joyride-beacon:focus, .joyride-beacon:hover {
  outline: none;
}
.joyride-beacon__inner {
  animation: joyride-beacon-inner 1.2s infinite ease-in-out;
  background-color: #f04;
  border-radius: 50%;
  display: block;
  height: 50%;
  inset-inline-start: 50%;
  opacity: 0.7;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
}
.joyride-beacon__outer {
  animation: joyride-beacon-outer 1.2s infinite ease-in-out;
  background-color: rgba(255, 0, 68, 0.2);
  border: 2px solid #f04;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  height: 100%;
  inset-inline-start: 0;
  opacity: 0.9;
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  transform-origin: center;
  width: 100%;
}
.joyride-overlay {
  bottom: 0;
  inset-inline-start: 0;
  position: absolute;
  inset-inline-end: 0;
  top: 0;
  z-index: 1500;
}
.joyride-hole {
  border-radius: 4px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5), 0 0 15px rgba(0, 0, 0, 0.5);
  position: absolute;
}
.joyride-hole.safari {
  box-shadow: 0 0 999px 9999px rgba(0, 0, 0, 0.5), 0 0 15px rgba(0, 0, 0, 0.5);
}
.joyride-tooltip {
  background-color: #fff;
  border-radius: 4px;
  color: #555;
  cursor: default;
  filter: drop-shadow(-1px -2px 3px rgba(0, 0, 0, 0.3)) drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.3));
  opacity: 0;
  padding: 20px;
  transform: translate3d(0, 0, 0);
  width: 290px;
  z-index: 1510;
}
.joyride-tooltip--animate {
  animation: joyride-tooltip 0.4s forwards;
  animation-timing-function: cubic-bezier(0, 1.05, 0.55, 1.18);
}
.joyride-tooltip__triangle {
  background-repeat: no-repeat;
  position: absolute;
}
.joyride-tooltip.bottom, .joyride-tooltip.bottom-left, .joyride-tooltip.bottom-right {
  margin-top: 18px;
}
.joyride-tooltip.bottom .joyride-tooltip__triangle, .joyride-tooltip.bottom-left .joyride-tooltip__triangle, .joyride-tooltip.bottom-right .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  height: 18px;
  inset-inline-start: 50%;
  top: -16px;
  transform: translateX(-50%);
  width: 36px;
}
.joyride-tooltip.top, .joyride-tooltip.top-left, .joyride-tooltip.top-right {
  margin-bottom: 18px;
}
.joyride-tooltip.top .joyride-tooltip__triangle, .joyride-tooltip.top-left .joyride-tooltip__triangle, .joyride-tooltip.top-right .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  bottom: -16px;
  height: 18px;
  inset-inline-start: 50%;
  transform: translateX(-50%);
  width: 36px;
}
.joyride-tooltip.bottom-left .joyride-tooltip__triangle, .joyride-tooltip.top-left .joyride-tooltip__triangle {
  inset-inline-start: 3%;
  transform: translateX(0);
}
@media screen and (min-width: 480px) {
  .joyride-tooltip.bottom-left .joyride-tooltip__triangle, .joyride-tooltip.top-left .joyride-tooltip__triangle {
    inset-inline-start: 2%;
  }
}
.joyride-tooltip.bottom-right .joyride-tooltip__triangle, .joyride-tooltip.top-right .joyride-tooltip__triangle {
  inset-inline-start: auto;
  inset-inline-end: 3%;
  transform: translateX(0);
}
@media screen and (min-width: 480px) {
  .joyride-tooltip.bottom-right .joyride-tooltip__triangle, .joyride-tooltip.top-right .joyride-tooltip__triangle {
    inset-inline-end: 2%;
  }
}
.joyride-tooltip.left {
  margin-inline-end: 18px;
}
.joyride-tooltip.left .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  height: 36px;
  inset-inline-end: -16px;
  width: 18px;
}
.joyride-tooltip.right {
  margin-inline-start: 18px;
}
.joyride-tooltip.right .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  height: 36px;
  inset-inline-start: -16px;
  width: 18px;
}
.joyride-tooltip__close {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-size: contain;
  height: 12px;
  position: absolute;
  text-decoration: none;
  top: 10px;
  width: 12px;
  z-index: 10;
  display: block;
}
.joyride-tooltip__close:active, .joyride-tooltip__close:focus, .joyride-tooltip__close:hover {
  outline: none;
}
.joyride-tooltip__close:hover, .joyride-tooltip__close:focus {
  color: rgba(59.5, 59.5, 59.5, 0.5);
  outline: none;
}
.joyride-tooltip__close--header {
  inset-inline-end: 20px;
  top: 20px;
}
.joyride-tooltip__header {
  border-bottom: 1px solid #f04;
  color: #555;
  font-size: 16px;
  padding-bottom: 6px;
  padding-inline-end: 18px;
  position: relative;
}
.joyride-tooltip__header ~ .joyride-tooltip__main {
  padding: 12px 0 18px;
}
.joyride-tooltip__main {
  font-size: 14px;
  padding-bottom: 18px;
  padding-inline-end: 18px;
}
.joyride-tooltip__footer {
  text-align: right;
}
.joyride-tooltip__button {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: 0;
}
.joyride-tooltip__button:active, .joyride-tooltip__button:focus, .joyride-tooltip__button:hover {
  outline: none;
}
.joyride-tooltip__button--primary {
  background-color: #f04;
  border-radius: 4px;
  color: #fff;
  padding: 6px 12px;
  transition: background-color 0.2s ease-in-out;
}
.joyride-tooltip__button--primary:active, .joyride-tooltip__button--primary:focus, .joyride-tooltip__button--primary:hover {
  background-color: rgb(255, 30.6, 90.44);
  color: #fff;
}
.joyride-tooltip__button--secondary {
  color: #f04;
  margin-inline-end: 10px;
}
.joyride-tooltip__button--skip {
  color: #ccc;
  float: inline-start;
  margin-inline-end: 10px;
}
.joyride-tooltip--standalone .joyride-tooltip__main {
  padding-bottom: 0;
}
.joyride-tooltip--standalone .joyride-tooltip__footer {
  display: none;
}
@media screen and (min-width: 480px) {
  .joyride-tooltip {
    width: 360px;
  }
}
@media screen and (min-width: 960px) {
  .joyride-tooltip {
    width: 450px;
  }
}

@keyframes joyride-tooltip {
  0% {
    transform: scale(0.1);
  }
  100% {
    opacity: 1;
    transform: perspective(1px) scale(1);
  }
}
@keyframes joyride-beacon-inner {
  20% {
    opacity: 0.9;
  }
  90% {
    opacity: 0.7;
  }
}
@keyframes joyride-beacon-outer {
  0% {
    transform: scale(1);
  }
  45% {
    opacity: 0.7;
    transform: scale(0.75);
  }
  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}
/*Tables Styles*/
:root {
  --table-heading-horizontal-border-style: solid;
  --table-heading-horizontal-border-width: 1px;
  --table-heading-horizontal-border-color: hsl(210, 20%, 98%);
}

.table-header {
  padding-inline-end: 2px !important;
  min-height: 64px;
  padding-inline-start: 24px;
  align-items: center;
}
.table-header.highlight-light {
  color: #616161;
  background-color: #e0e0e0;
}
.table-header.highlight-dark {
  color: #fff;
  background-color: #616161;
}

.spacer {
  -webkit-flex: 1 1 100%;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}

.actions {
  color: #F44336;
}

.title {
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}

.table-hover tbody tr:hover {
  background-color: rgba(153, 187, 205, 0.075);
}

.table-material {
  width: 100% !important;
  max-width: 100% !important;
  background-color: transparent !important;
}
.table-material th,
.table-material td {
  padding: 0.75rem !important;
  vertical-align: top !important;
  border-top: 1px solid #dee2e6 !important;
}
.table-material thead th {
  vertical-align: bottom !important;
  border-bottom: 2px solid #dee2e6 !important;
}
.table-material tbody + tbody {
  border-top: 2px solid #dee2e6 !important;
}
.table-material .table-material {
  background-color: #ffffff !important;
}

.d-flex-stretch {
  -webkit-align-items: stretch;
  align-items: stretch;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.default-table {
  margin-bottom: 0;
}
.default-table thead th {
  font-weight: 500;
  font-size: 14px;
  color: rgb(27, 37, 95);
}
.default-table td {
  vertical-align: middle;
  padding: var(--block-padding, 0.7rem) var(--inline-padding, 0.3rem);
}

.table-unbordered th, .table-unbordered td {
  border: 0 none !important;
}
.table-unbordered .th-border-b th {
  border-bottom: 2px solid #ced4da !important;
}

.json-data-view-array {
  margin-bottom: 0px;
}

.table-responsive-material {
  min-height: 0.01%;
  overflow-x: auto;
}

.services-table-list .rt-table .rt-thead .rt-tr .rt-th:last-of-type {
  flex: 10 0 auto !important;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td:last-of-type {
  flex: 10 0 auto !important;
  padding: 0;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td:last-of-type .row-actions-container {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-inline-end: 10px;
  height: 100%;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td:last-of-type .row-actions-container button {
  transition-duration: 0.2s;
  transition-delay: 0.1s;
  position: relative;
  inset-inline-end: -200px;
  padding: 3px 7px;
  margin-inline-end: 0 !important;
  display: inline-flex;
  margin-inline-start: 0;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td:last-of-type .row-actions-container button:nth-of-type(2) {
  transition-duration: 0.25s;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td:last-of-type .row-actions-container button:nth-of-type(3) {
  transition-duration: 0.3s;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td:last-of-type .row-actions-container button:hover {
  background: #dbdbdb;
  border-radius: 2px;
  text-decoration: none;
}
.services-table-list .rt-table .rt-tbody .rt-tr-group .rt-tr:hover .rt-td:last-of-type .row-actions-container button {
  inset-inline-end: 0;
}

.system-data-table ul.nav.nav-tabs {
  gap: 16px;
  border-bottom: none;
  padding-inline: 0px;
}
.system-data-table ul.nav.nav-tabs li.nav-item a.nav-link {
  border: none;
  background-color: transparent;
  font: normal 500 22px/28px Open Sans, sans-serif;
}
.system-data-table ul.nav.nav-tabs li.nav-item a.nav-link.active {
  color: hsl(0, 0%, 7%);
}
.system-data-table .nav-pages {
  gap: 20px;
  flex: auto;
}
.system-data-table .nav-tools {
  gap: 16px;
}
.system-data-table .data-list-table {
  display: flex;
  flex-direction: column;
}
.system-data-table .pagination {
  position: initial;
}

.react-table .rt-table {
  max-height: calc(100vh - 270px);
  border-top: none !important;
  border-radius: 6px;
}
.react-table .rt-table :is(.th, .td) {
  text-align: start;
}
.react-table .rt-table :is(.th, .td).the-first:first-child {
  border-inline-start: none;
}
.react-table .rt-table .rt-tbody {
  min-height: 771px;
}
.react-table .rt-table .rt-tbody .tr {
  min-height: 38px;
}
.react-table .rt-table .rt-tbody .tr .td {
  box-shadow: none;
  padding-inline: 16px;
  padding-block: 10px;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  box-shadow: inset 0px -1px 0px hsl(210, 20%, 98%);
  border-inline-end: none;
  min-height: 40px;
}
.react-table .rt-table .rt-tbody .tr .td .btn-link {
  margin-bottom: 0;
  padding: 0 0.75rem;
}
.react-table .rt-table .rt-tbody .tr .td[data-sticky-first-right-td=true] {
  flex: 70 0 auto !important;
  min-width: 70px !important;
  width: 70px !important;
  padding: 0 !important;
  border-inline-start: solid 1px hsl(225, 13%, 94%);
  padding: 0 !important;
}
.react-table .rt-table .rt-tbody .tr .td[data-sticky-td=true].parent-first-field {
  border-inline-start: none !important;
}
.react-table .rt-table .rt-tbody .tr .td[data-sticky-td=true].parent-last-field {
  border-inline-end: none !important;
}
.react-table .rt-table .rt-tbody .tr .td[data-sticky-last-left-td=true] {
  border-inline-end: none;
  white-space: break-spaces;
  overflow-wrap: anywhere;
  display: flex;
}
.react-table .rt-table .rt-tbody .tr .td.parent-first-field:not(:first-child) {
  border-inline-start: solid 5px hsl(210, 20%, 98%);
}
.react-table .rt-table .rt-tbody .tr .td.actions-cell {
  padding: 0;
  align-items: center;
  display: flex;
  justify-content: end;
  border-inline-start: none;
  overflow-x: visible;
}
.react-table .rt-table .rt-thead .tr:first-of-type .th {
  box-shadow: none;
}
.react-table .rt-table .rt-thead .tr:first-of-type:not(:only-child) .th {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.react-table .rt-table .rt-thead .tr:first-of-type:not(:only-child) .th:nth-last-child(2) {
  border-inline-end: none;
}
.react-table .rt-table .rt-thead .tr .th {
  background-color: hsl(225, 13%, 94%);
  font: normal 500 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  color: hsl(0, 0%, 7%);
  padding-inline: 16px;
  padding-block: 10px;
  transition-duration: 0.3s;
  box-shadow: none;
  position: var(--cell-position, relative) !important;
}
.react-table .rt-table .rt-thead .tr .th[data-sticky-first-right-td=true] {
  flex: 70 0 auto !important;
  min-width: 70px !important;
  width: 70px !important;
}
.react-table .rt-table .rt-thead .tr .th[data-sticky-first-right-td=true] > div {
  display: flex;
  justify-content: center;
}
.react-table .rt-table .rt-thead .tr .th > span:first-child {
  display: inline-flex;
  align-items: center;
}
.react-table .rt-table .rt-thead .tr .th:hover {
  background-color: hsl(220, 13%, 91%);
}
.react-table .rt-table .rt-thead .tr .th[data-sticky-td=true] {
  box-shadow: none;
}
.react-table .rt-table .rt-thead .tr .th[data-sticky-td=true].type-object, .react-table .rt-table .rt-thead .tr .th[data-sticky-td=true].parent-first-field {
  border-inline-start: none !important;
}
.react-table .rt-table .rt-thead .tr .th.type-object {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
  --cell-position: sticky;
  left: 0;
}
.react-table .rt-table .rt-thead .tr .th.type-object:last-child {
  border-inline-end: solid 1px hsl(225, 13%, 94%) !important;
}
.react-table .rt-table .rt-thead .tr .th:where(.parent-first-field, .block-cell):not(:first-child) {
  border-inline-start: solid 5px hsl(210, 20%, 98%);
}
.react-table .rt-table .rt-thead .tr .th.has-filter-field {
  flex-wrap: wrap;
}
.react-table .rt-table .rt-thead .tr .th .filter-container {
  flex: 0 0 100%;
}
.react-table .rt-table .rt-thead .tr .th.block-cell.the-first {
  --cell-position: relative;
}
.react-table .rt-table .rt-thead .tr:first-child .th {
  border-bottom: solid 1px hsl(225, 13%, 94%);
}
.react-table .rt-table .rt-thead .tr:first-child .th:not([colspan="1"]) {
  border-bottom: solid 1px hsl(225, 13%, 94%);
}
.react-table .rt-table .rt-thead .tr:first-child:not(:last-child) .th {
  border-inline-end: none;
}
.react-table .rt-table .rt-thead .tr + .tr {
  border-top: var(--table-heading-horizontal-border-style, none) var(--table-heading-horizontal-border-width, 0px) var(--table-heading-horizontal-border-color, transparent);
}
.react-table .rt-table .rt-thead .tr + .tr .th {
  display: flex;
  z-index: 9;
}
.react-table .rt-table .rt-thead .tr + .tr .th .sorted-arrow {
  margin-inline-start: auto;
}
.react-table .rt-table .rt-thead .tr:last-child .th {
  border-bottom: solid 1px hsl(225, 13%, 94%);
}
.react-table .rt-table .rt-thead .tr:last-child .th[data-sticky-last-left-td=true] {
  border-inline-end: solid 1px hsl(225, 13%, 94%);
}
.react-table .rt-table .th .system-label {
  --label-bottom-margin: 0px;
  font: normal 700 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.react-table .rt-table .th.has-filter-field .system-label {
  --label-bottom-margin: var(--system-label-bottom-margin, 6px);
}
.react-table .rt-table .rt-tfoot .tr .td {
  background-color: hsl(225, 13%, 94%);
  padding-inline: 16px;
  padding-block: 10px;
  color: hsl(220, 9%, 46%);
  font: normal 400 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.react-table .rt-table .rt-tfoot .tr .td[data-sticky-first-right-td=true] {
  flex: 70 0 auto !important;
  min-width: 70px !important;
  width: 70px !important;
}
.react-table .rt-table .rt-tfoot .tr .td[data-sticky-first-right-td=true] > div {
  display: flex;
  justify-content: center;
}
.react-table .rt-table::-webkit-scrollbar-thumb {
  background-color: hsl(218, 11%, 65%);
}
.react-table .pagination {
  margin-block: 0.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.react-table .pagination .page-info {
  margin-inline-end: 3rem;
}
.react-table .pagination .page-info .-pageSizeOptions {
  position: relative;
  cursor: pointer;
}
.react-table .pagination .page-info .-pageSizeOptions select {
  appearance: none;
  border: none;
  background: transparent;
  padding-top: 5px;
  padding-bottom: 7px;
  padding-inline-end: 2rem;
  padding-inline-start: 12px;
  border-radius: 6px;
  margin-inline-end: 12px;
  position: relative;
  z-index: 1;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}
.react-table .pagination .page-info .-pageSizeOptions select:focus, .react-table .pagination .page-info .-pageSizeOptions select:hover {
  outline: none;
  background-color: rgba(70, 120, 170, 0.1);
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
}
.react-table .pagination .page-info .-pageSizeOptions i {
  position: absolute;
  z-index: 0;
  inset-inline-end: 24px;
  height: 12px;
  top: calc(50% - 6px);
  font-size: 11px;
}
.react-table .pagination .pagination-controls {
  display: flex;
  align-items: center;
}
.react-table .pagination .pagination-controls .page-summary {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-inline: 6px;
}
.react-table .pagination .pagination-controls .page-summary input {
  text-align: center;
}
.react-table .pagination .pagination-controls .page-summary input::-webkit-outer-spin-button, .react-table .pagination .pagination-controls .page-summary input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.react-table.service-list-table .table-heading-actions {
  margin-inline-end: 0px;
}
.react-table.service-list-table .table-heading-actions button.btn-link {
  margin: 0px !important;
  margin-inline-end: 0px !important;
  width: 38px;
  height: 28px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 12px;
}
.react-table.service-list-table .table-heading-actions button.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.react-table.data-list-report-table .rt-table {
  max-height: calc(100vh - 390px);
}
.react-table.data-list-report-table .pagination {
  background-color: #F4F4F4;
}
.react-table.db-audit-log-list-table .rt-table {
  max-height: calc(100vh - 306px);
  overflow-x: auto !important;
}
.react-table.db-audit-log-list-table .rt-table .rt-thead .tr .th:last-of-type {
  flex: 150 0 auto !important;
  width: 150px !important;
}
.react-table:where(.data-view-list-table, .data-view-field-list-table) .rt-thead .tr .th:last-of-type {
  flex: 150 0 auto !important;
  width: 150px !important;
}
.react-table.data-view-list-table :is(.rt-thead, .rt-tbody) .tr :is(.th, .td):is(.name-column, .user-column) {
  flex: 3000 0 auto !important;
}
.react-table.data-view-field-list-table .rt-thead .tr .th,
.react-table.data-view-field-list-table .rt-thead .tr .td,
.react-table.data-view-field-list-table .rt-tbody .tr .th,
.react-table.data-view-field-list-table .rt-tbody .tr .td {
  flex: 1 !important;
  border-inline-end: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.react-table.data-view-field-list-table .rt-thead .tr .th:last-of-type,
.react-table.data-view-field-list-table .rt-thead .tr .td:last-of-type,
.react-table.data-view-field-list-table .rt-tbody .tr .th:last-of-type,
.react-table.data-view-field-list-table .rt-tbody .tr .td:last-of-type {
  flex: 1 !important;
  border-inline-end: none;
}
.react-table.data-view-field-list-table.pane-2 .rt-thead .tr .th[data-sticky-td=true],
.react-table.data-view-field-list-table.pane-2 .rt-thead .tr .td[data-sticky-td=true],
.react-table.data-view-field-list-table.pane-2 .rt-tbody .tr .th[data-sticky-td=true],
.react-table.data-view-field-list-table.pane-2 .rt-tbody .tr .td[data-sticky-td=true] {
  max-width: 100px;
}
.react-table.data-view-field-list-table .drop-placeholder {
  font: normal 700 14px/20px Open Sans, sans-serif;
}
.react-table.data-list-table .rt-thead .tr .th:not(.parent-first-field):first-child {
  --cell-position: sticky;
  left: 0;
}
.react-table .row-actions-container {
  text-align: end;
  align-items: center;
  display: flex;
  padding-inline-end: 16px;
}
.react-table .fk-badge {
  background: #749abf;
  line-height: 1;
  display: inline-flex;
  height: 16px;
  width: 16px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;
  color: white;
  align-items: center;
  justify-content: center;
  margin-inline-start: 5px;
  transform: scale(0.88);
}
.react-table .group-badge {
  background: #4678aa;
  line-height: 1;
  display: inline-flex;
  margin-left: 0 !important;
  height: 16px;
  padding-left: 1px;
  padding-right: 1px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;
  color: white;
  align-items: center;
  justify-content: center;
  margin-inline-start: 5px;
  transform: scale(0.88);
}
.react-table.audit-table {
  padding: 0;
  margin-top: -10px;
}
.react-table.audit-table:empty {
  margin-top: 0;
}
.react-table:not(.tableoptions--closed) .react-table.data-list-table .rt-table {
  max-height: calc(100vh - 270px);
}
.react-table ul.nav.nav-tabs {
  background-color: transparent;
  box-shadow: none;
  border: none;
  align-items: center;
  padding-top: 0;
}
.react-table ul.nav.nav-tabs li.nav-item {
  position: relative;
  z-index: 2;
  background: transparent;
  box-shadow: none;
  margin-inline-end: 2rem;
}
.react-table ul.nav.nav-tabs li.nav-item:last-of-type {
  margin-inline-end: 0;
}
.react-table ul.nav.nav-tabs li.nav-item a.nav-link {
  background: transparent;
  border: none;
  color: hsl(0, 0%, 7%);
  font: normal 500 22px/28px Open Sans, sans-serif;
  padding: 0.5rem 0 !important;
  margin: 0;
  transition-duration: 0.3s;
}
.react-table ul.nav.nav-tabs li.nav-item a.nav-link:hover, .react-table ul.nav.nav-tabs li.nav-item a.nav-link.active {
  color: var(--system-primary-color, #002b8f);
}
.react-table ul.nav.nav-tabs li.nav-item a.nav-link .bd-total-records {
  font-size: 13px;
  font-weight: 500;
  background: hsl(0, 50%, 100%);
  padding: 2px 5px;
  border-radius: 20px;
  margin-inline-start: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.react-table ul.nav.nav-tabs li.nav-item a.nav-link .bd-total-records:empty {
  display: none;
}
.react-table ul.nav.nav-tabs .add-data-entry {
  position: relative;
  z-index: 3;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 32px;
  color: rgb(70, 120, 170);
  background-color: rgba(70, 120, 170, 0.1);
  padding: 0;
  font-weight: 500;
  font-size: 13px;
  line-height: 12px;
}
.react-table ul.nav.nav-tabs .add-data-entry i {
  color: rgb(70, 120, 170);
  font-size: 16px;
}
.react-table ul.nav.nav-tabs .search--table {
  height: 32px;
  background-color: #EAEDF2;
  border-radius: 6px;
  padding: 0 12px;
}
.react-table ul.nav.nav-tabs .search--table input {
  color: rgba(27, 37, 95, 0.8);
  font-size: 13px;
  font-weight: 500;
}
.react-table ul.nav.nav-tabs .search--table i {
  color: rgba(27, 37, 95, 0.8);
}

.table-row-click .tr {
  cursor: pointer;
}
.table-row-click .tr:hover .td {
  background: hsl(210, 20%, 98%);
}

.db-options-bar {
  padding-block: 6px;
  padding-inline: 8px;
  background-color: hsl(0, 50%, 100%);
  border-radius: 6px;
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 1px 1px rgba(48, 49, 51, 0.1);
  gap: 10px;
  flex-wrap: wrap;
}
.db-options-bar .filters-row {
  background-color: transparent;
  padding: 0;
  gap: 10px 20px;
  justify-content: flex-end;
}
.db-options-bar .filters-row .responsive-dropdown-container {
  display: flex;
  gap: 10px 0px;
  margin-inline-end: auto;
  flex-wrap: wrap;
}
.db-options-bar .filters-row .responsive-dropdown-container button.system-button span {
  display: none;
}
.db-options-bar .filters-row .responsive-dropdown-container .export-button button.system-button.exporting {
  --button-inline-padding: 16px;
}
.db-options-bar .filters-row .responsive-dropdown-container .export-button button.system-button.exporting span {
  display: block;
}
.db-options-bar .filters-row .responsive-dropdown-container .filters-rows-action button.system-button span {
  display: block;
}
.db-options-bar .filters-row .responsive-dropdown-container .toolbar-separator {
  height: 14px;
  width: 1px;
  background-color: hsl(216, 12%, 84%);
  margin: 0 8px;
  align-self: center;
}
.db-options-bar .filters-row .responsive-menu-toggler {
  display: none;
  align-items: center;
  padding: 0;
  width: 32px;
  border-radius: 6px;
  color: rgb(27, 37, 95);
  justify-content: center;
  margin-inline-end: -4px;
}
.db-options-bar .filters-row .responsive-menu-toggler i {
  font-size: 24px;
}
.db-options-bar .filters-row .responsive-menu-toggler:hover {
  background-color: #EAEDF2;
}
@media screen and (max-width: 768px) {
  .db-options-bar .filters-row {
    flex: 0 0 100%;
    position: relative;
  }
  .db-options-bar .filters-row .responsive-menu-toggler {
    display: flex;
  }
  .db-options-bar .filters-row .responsive-menu-toggler + .responsive-dropdown-container {
    display: none;
  }
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container {
    display: block;
    position: absolute;
    z-index: 100;
    background-color: white;
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.09);
    top: 32px;
  }
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container > div > * {
    width: 100%;
    justify-content: start !important;
  }
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container > div > * > button,
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container > div > * > div > button {
    width: 100%;
    justify-content: start !important;
  }
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container :where(.reports-dropdown, .columns-toggler).show .dropdown-menu.show {
    transform: translate3d(calc(-100% - 1px), -2px, 0px) !important;
  }
  .db-options-bar .filters-row .responsive-menu-toggler.open + .responsive-dropdown-container .dropdown-filters.show .dropdown-menu.show {
    transform: none !important;
    top: 32px !important;
    inset-inline-start: calc(100% - 90vw + 10px) !important;
    width: 90vw;
  }
}
.db-options-bar .options-buttons button.btn {
  border-radius: 6px;
  height: 30px;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: rgb(27, 37, 95) !important;
  padding: 0 1rem;
}
.db-options-bar .options-buttons button.btn span {
  color: rgb(27, 37, 95) !important;
}
.db-options-bar .options-buttons button.btn:hover {
  background-color: rgba(70, 120, 170, 0.1);
}
.db-options-bar .options-buttons button.btn:hover span {
  color: rgb(27, 37, 95) !important;
}
.db-options-bar .options-buttons button.btn.btn-warning {
  background-color: rgba(255, 137, 93, 0.25);
  color: rgb(255, 137, 93) !important;
}
.db-options-bar .options-buttons button.btn.btn-warning span {
  color: rgb(255, 137, 93) !important;
}
.db-options-bar .options-buttons button.btn.btn-warning:hover {
  background-color: rgb(255, 137, 93);
  color: #FFFFFF !important;
}
.db-options-bar .options-buttons button.btn.btn-warning:hover span {
  color: #FFFFFF !important;
}

.columns-toggler .dropdown-menu {
  max-width: 320px;
}
.columns-toggler .dropdown-menu button.dropdown-item {
  font: normal 400 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.columns-toggler .dropdown-menu button.dropdown-item.column-type-object {
  font: normal 600 14px/20px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.columns-toggler .dropdown-menu.show {
  width: max-content;
}
.columns-toggler .search--table {
  --custom-height: 32px;
  background-color: #EAEDF2;
  border-radius: 6px;
  padding: 0 12px;
}
.columns-toggler .search--table input {
  color: rgba(27, 37, 95, 0.8);
  font-size: 13px;
  font-weight: 500;
}
.columns-toggler .search--table i {
  color: rgba(27, 37, 95, 0.8);
}
.columns-toggler .col-status-icon {
  --check-icon-color: var(--system-primary-color, #002b8f);
}

.audit-log-table-toolbar .dropdown > button {
  border-radius: 6px !important;
  padding: 0 0.6rem;
  font-weight: 500;
  font-size: 12px;
  color: rgb(27, 37, 95);
  height: 32px;
  transition-duration: 0.3s;
}
.audit-log-table-toolbar .dropdown > button:hover {
  background-color: #EAEDF2;
}
.audit-log-table-toolbar .dropdown.show > button {
  background-color: #EAEDF2;
}

.log-audit-detail-table {
  width: 100%;
  table-layout: fixed;
}
.log-audit-detail-table td {
  padding-block: 6px;
  border-top: var(--border-top-style, solid) var(--border-top-width, 1px) var(--border-top-color, hsl(220, 13%, 91%));
  height: 48px;
  vertical-align: middle;
}
.log-audit-detail-table td:first-child {
  font: normal 500 14px/20px Open Sans, sans-serif;
  color: hsl(0, 0%, 7%);
  padding-inline-start: 20px;
}
.log-audit-detail-table td:last-child {
  font: normal 400 14px/20px Open Sans, sans-serif;
  color: hsl(0, 0%, 7%);
  padding-inline-end: 20px;
}
.log-audit-detail-table tr:first-child td {
  --border-top-style: none;
}

.diff-item {
  font: normal 400 14px/20px Open Sans, sans-serif;
  gap: 8px;
  padding-block: 6px;
}
.diff-item .rendered-value {
  padding-top: 0px;
}
.diff-item:first-child {
  padding-top: 0px;
}
.diff-item:last-child {
  padding-bottom: 0px;
}

.diff-path {
  font: normal 500 14px/20px Open Sans, sans-serif;
}

.diff-old-value,
.diff-new-value {
  padding: 4px 6px;
  border-radius: 4px;
}

.diff-old-value {
  background-color: hsl(0, 96%, 89%);
}

.diff-new-value {
  background-color: hsl(156, 50%, 76%);
  line-break: anywhere;
}
.diff-new-value .table .table {
  background-color: transparent;
}

.table-row-drag-drop .tr {
  background: hsl(0, 50%, 100%);
  box-shadow: 0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.09);
  align-items: center;
  padding: 14px;
  border-radius: 4px;
}
.table-row-drag-drop .td {
  font: normal 700 12px/16px Open Sans, sans-serif;
  letter-spacing: 0.005em;
}
.table-row-drag-drop .td.actions-cell {
  width: auto;
}
.table-row-drag-drop .td.actions-cell .row-actions-container {
  white-space: nowrap;
}

.service-param-cell {
  width: 60px;
}

.empty-row-msg {
  position: sticky;
  display: grid;
  place-content: center;
  z-index: 9;
  bottom: calc(50% - 115px);
}
.empty-row-msg img {
  display: block;
  margin: auto;
}

@media screen and (max-width: 767px) {
  .table-responsive-material {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
  .table-responsive-material > .table {
    margin-bottom: 0;
  }
  .table-responsive-material > .table > :where(thead, tbody, tfoot) > tr > :where(th, td) {
    white-space: nowrap;
  }
  .table-responsive-material > .table-bordered {
    border: 0;
  }
  .table-responsive-material > .table-bordered > :where(thead, tbody, tfoot) > tr > :where(th, td):first-child {
    border-inline-start: 0;
  }
  .table-responsive-material > .table-bordered > :where(thead, tbody, tfoot) > tr > :where(th, td):last-child {
    border-inline-end: 0;
  }
  .table-responsive-material > .table-bordered > :where(tbody, tfoot) > tr:last-child > :where(th, td) {
    border-bottom: 0;
  }
}
.fst-td-br-tp-0 tr:first-child td {
  border-top: 0 none;
}

/*Tabs Styles*/
.tab {
  min-width: 10px !important;
}

.tab-icon > span {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/*Testimonial Styles*/
.testimonial-in-bg {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 5px 5px 6px rgba(0, 0, 0, 0.06);
  padding: 30px;
  padding-inline-start: 150px;
  overflow: hidden;
  position: relative;
}
@media screen and (max-width: 450px) {
  .testimonial-in-bg {
    padding-inline-start: 100px;
  }
}
.testimonial-in-bg .pic {
  display: inline-block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: 30px;
  inset-inline-start: 20px;
  border: 4px solid #ffa000;
}
@media screen and (max-width: 450px) {
  .testimonial-in-bg .pic {
    width: 50px;
    height: 50px;
  }
}
.testimonial-in-bg .pic img {
  width: 100%;
  height: auto;
}
.testimonial-in-bg .description {
  color: #bdbdbd;
  font-style: italic;
  font-weight: 400;
  line-height: 25px;
  margin-bottom: 15px;
  position: relative;
}
.testimonial-in-bg .description:before {
  content: "\\f1b2";
  font-family: "Material-Design-Iconic-Font";
  font-size: 24px;
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  transform: scaleX(-1);
  position: absolute;
  inset-inline-start: -24px;
}
.testimonial-in-bg .title {
  color: #ffa000;
  margin-bottom: 2px;
}

.classic-testimonial {
  text-align: center;
}
.classic-testimonial .pic {
  margin: 0 auto;
  margin-bottom: 30px;
  width: 120px;
  height: 120px;
}
@media screen and (max-width: 500px) {
  .classic-testimonial .pic {
    width: 80px;
    height: 80px;
  }
}
.classic-testimonial .pic img {
  width: 100%;
  height: 100%;
}

/*Time Lines Style*/
.timeline-left {
  float: inline-start;
  margin-inline-end: 20px;
}

.timeline-right {
  float: inline-end;
  margin-inline-start: 20px;
}

.timeline-circle {
  border-radius: 50%;
}

.timeline-section {
  margin-bottom: 25px;
}

.timeline-item {
  padding-bottom: 25px;
  padding-inline-start: 80px;
  position: relative;
}
.timeline-item:before {
  border-inline-start: solid 2px #dee2e6;
  content: "";
  inset-inline-start: 25px;
  position: absolute;
  top: 25px;
  bottom: -20px;
  width: 2px;
  z-index: 1;
}
.timeline-item:first-child:before {
  border-inline-start-style: dashed;
}
.timeline-item:last-child:before {
  border-inline-start-style: dashed;
  bottom: 25px;
}

.timeline-badge {
  position: absolute;
  inset-inline-start: 0;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
}
.timeline-badge.timeline-img {
  background-color: transparent;
}
.timeline-badge svg {
  vertical-align: calc(100% - 56px);
}

.timeline-badge.timeline-img:after {
  display: none;
}
.timeline-badge:after {
  position: absolute;
  content: "";
  width: 42px;
  height: 42px;
  background-color: transparent;
  border: 4px solid #ffffff;
  border-radius: 50%;
  inset-inline-start: 4px;
  top: 4px;
  z-index: 1;
}

.timeline-img > img,
.timeline-header-img > img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}

.timeline-panel {
  padding: 20px 30px;
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #e9ecef;
}
.timeline-panel:after, .timeline-panel:before {
  content: "";
  position: absolute;
  border-style: solid;
  display: inline-block;
}
.timeline-panel:before {
  border-color: transparent #dee2e6;
  border-width: 10px 17px 10px 0;
  inset-inline-start: -17px;
  top: 30px;
}
.timeline-panel:after {
  border-color: transparent #fff;
  border-width: 10px 16px 10px 0;
  inset-inline-start: -16px;
  top: 30px;
}

.timeline-no-padding {
  padding: 0;
}

.timeline-no-shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.timeline-no-shadow:before, .timeline-no-shadow:after {
  display: none;
}

.timeline-panel-header, .timeline-header-img {
  margin-bottom: 10px;
}

.timeline-inverted .timeline-left {
  float: inline-end;
  margin-inline-end: 0;
  margin-inline-start: 20px;
}

.timeline-heading {
  overflow: hidden;
  margin-bottom: 10px;
}

.timeline-body {
  clear: both;
}

/*Gxtl Center Style*/
.timeline-center .timeline-item {
  clear: both;
  float: inline-end;
  width: 50%;
  padding-inline-start: 55px;
}
.timeline-center .timeline-item:before {
  inset-inline-start: 0;
}

.timeline-center .timeline-badge {
  inset-inline-start: -25px;
  inset-inline-end: auto;
}
.timeline-center .timeline-time {
  position: absolute;
  top: 32px;
  inset-inline-start: -150px;
  inset-inline-end: auto;
  z-index: 2;
}
.timeline-center .timeline-inverted {
  float: inline-start;
  text-align: right;
  padding-inline-start: 0;
  padding-inline-end: 55px;
}
.timeline-center .timeline-inverted:before {
  border-inline-start: 0 none;
  border-inline-end: solid 2px #dee2e6;
  inset-inline-start: auto;
  inset-inline-end: -2px;
}
.timeline-center .timeline-inverted .timeline-badge {
  inset-inline-start: auto;
  inset-inline-end: -25px;
}
.timeline-center .timeline-inverted .timeline-panel:before {
  border-width: 10px 0 10px 17px;
  inset-inline-start: auto;
  inset-inline-end: -17px;
}
.timeline-center .timeline-inverted .timeline-panel:after {
  border-width: 10px 0 10px 16px;
  inset-inline-start: auto;
  inset-inline-end: -16px;
}
.timeline-center .timeline-inverted .timeline-time {
  position: absolute;
  top: 32px;
  inset-inline-end: -150px;
  inset-inline-start: auto;
  z-index: 2;
}

/*Gxtl Zigzag Style*/
.timeline-zigzag .timeline-item {
  padding-inline-start: 150px;
}
.timeline-zigzag .timeline-item + .timeline-item {
  margin-top: -80px;
}
.timeline-zigzag .timeline-img {
  width: 90px;
  height: 90px;
  inset-inline-start: 5px;
}
.timeline-zigzag .timeline-img > img {
  width: 100%;
}
.timeline-zigzag .timeline-inverted .timeline-img {
  inset-inline-end: 5px !important;
}
.timeline-zigzag .timeline-item:before {
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  transform: rotate(35deg);
  top: 20px;
  bottom: 20px;
}
.timeline-zigzag .timeline-inverted {
  padding-inline-start: 0;
  padding-inline-end: 150px;
}
.timeline-zigzag .timeline-inverted:before {
  -webkit-transform: rotate(-35deg);
  -ms-transform: rotate(-35deg);
  -o-transform: rotate(-35deg);
  transform: rotate(-35deg);
}
.timeline-zigzag .timeline-item:first-child:before {
  border-inline-start-style: solid;
}
.timeline-zigzag .timeline-item:last-child:before {
  display: none;
}

.timeline-item:last-child:before {
  bottom: 25px;
}

@media screen and (max-width: 991px) {
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: -60px;
  }
  .timeline-zigzag .timeline-item:before {
    bottom: 0;
  }
  .timeline-zigzag .timeline-item {
    padding-inline-start: 120px;
  }
  .timeline-zigzag .timeline-inverted {
    padding-inline-end: 120px;
    padding-inline-start: 0;
  }
}
@media screen and (max-width: 767px) {
  .timeline-center .timeline-item {
    float: none;
    padding-inline-start: 80px;
    width: auto;
  }
  .timeline-center .timeline-item:before {
    inset-inline-start: 25px;
  }
  .timeline-center .timeline-badge {
    inset-inline-start: 0;
  }
  .timeline-center .timeline-inverted {
    float: none;
    text-align: left;
    padding-inline-end: 0;
  }
  .timeline-center .timeline-inverted:before {
    border-inline-start: solid 2px #dee2e6;
    border-inline-end: 0 none;
    inset-inline-start: 24px;
    inset-inline-end: auto;
  }
  .timeline-center .timeline-inverted .timeline-badge {
    inset-inline-end: auto;
    inset-inline-start: 0;
  }
  .timeline-center .timeline-inverted .timeline-panel:before {
    border-width: 10px 17px 10px 0;
    inset-inline-start: -17px;
    inset-inline-end: auto;
  }
  .timeline-center .timeline-inverted .timeline-panel:after {
    border-width: 10px 16px 10px 0;
    inset-inline-start: -16px;
    inset-inline-end: auto;
  }
  .timeline-inverted .timeline-panel-header {
    float: none;
  }
  .timeline-inverted .timeline-left {
    float: inline-start;
    margin-inline-start: 0;
    margin-inline-end: 20px;
  }
  .timeline-zigzag .timeline-panel {
    max-height: none;
    min-height: 10px;
    overflow-y: visible;
  }
  .timeline-zigzag .timeline-item {
    padding-inline-start: 100px;
  }
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: 0;
  }
  .timeline-zigzag .timeline-item:before {
    transform: none;
    top: 25px;
    bottom: -25px;
    inset-inline-start: 45px;
  }
  .timeline-zigzag .timeline-item:last-child:before {
    bottom: 0;
  }
  .timeline-zigzag .timeline-inverted:before {
    transform: none;
  }
  .timeline-center .timeline-time, .timeline-center .timeline-inverted .timeline-time {
    position: relative;
    top: auto;
    inset-inline-start: auto;
    inset-inline-end: auto;
    margin-bottom: 6px;
  }
  .timeline-center .timeline-time-item .timeline-panel::before {
    top: 10px;
  }
  .timeline-center .timeline-time-item .timeline-panel::after {
    top: 11px;
  }
}
@media screen and (max-width: 399px) {
  .timeline-left {
    float: none;
    margin-inline-end: 0;
  }
  .timeline-right {
    float: none;
    margin-inline-start: 0;
  }
  .timeline-inverted .timeline-left {
    float: none;
    margin-inline-end: 0;
  }
}
/*React Joyride Styles*/
.joyride-beacon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: 0;
  height: 36px;
  position: relative;
  width: 36px;
  z-index: 1500;
}
.joyride-beacon:active, .joyride-beacon:focus, .joyride-beacon:hover {
  outline: none;
}
.joyride-beacon__inner {
  animation: joyride-beacon-inner 1.2s infinite ease-in-out;
  background-color: #f04;
  border-radius: 50%;
  display: block;
  height: 50%;
  inset-inline-start: 50%;
  opacity: 0.7;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
}
.joyride-beacon__outer {
  animation: joyride-beacon-outer 1.2s infinite ease-in-out;
  background-color: rgba(255, 0, 68, 0.2);
  border: 2px solid #f04;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  height: 100%;
  inset-inline-start: 0;
  opacity: 0.9;
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  transform-origin: center;
  width: 100%;
}
.joyride-overlay {
  bottom: 0;
  inset-inline-start: 0;
  position: absolute;
  inset-inline-end: 0;
  top: 0;
  z-index: 1500;
}
.joyride-hole {
  border-radius: 4px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5), 0 0 15px rgba(0, 0, 0, 0.5);
  position: absolute;
}
.joyride-hole.safari {
  box-shadow: 0 0 999px 9999px rgba(0, 0, 0, 0.5), 0 0 15px rgba(0, 0, 0, 0.5);
}
.joyride-tooltip {
  background-color: #fff;
  border-radius: 4px;
  color: #555;
  cursor: default;
  filter: drop-shadow(-1px -2px 3px rgba(0, 0, 0, 0.3)) drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.3));
  opacity: 0;
  padding: 20px;
  transform: translate3d(0, 0, 0);
  width: 290px;
  z-index: 1510;
}
.joyride-tooltip--animate {
  animation: joyride-tooltip 0.4s forwards;
  animation-timing-function: cubic-bezier(0, 1.05, 0.55, 1.18);
}
.joyride-tooltip__triangle {
  background-repeat: no-repeat;
  position: absolute;
}
.joyride-tooltip.bottom, .joyride-tooltip.bottom-left, .joyride-tooltip.bottom-right {
  margin-top: 18px;
}
.joyride-tooltip.bottom .joyride-tooltip__triangle, .joyride-tooltip.bottom-left .joyride-tooltip__triangle, .joyride-tooltip.bottom-right .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  height: 18px;
  inset-inline-start: 50%;
  top: -16px;
  transform: translateX(-50%);
  width: 36px;
}
.joyride-tooltip.top, .joyride-tooltip.top-left, .joyride-tooltip.top-right {
  margin-bottom: 18px;
}
.joyride-tooltip.top .joyride-tooltip__triangle, .joyride-tooltip.top-left .joyride-tooltip__triangle, .joyride-tooltip.top-right .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  bottom: -16px;
  height: 18px;
  inset-inline-start: 50%;
  transform: translateX(-50%);
  width: 36px;
}
.joyride-tooltip.bottom-left .joyride-tooltip__triangle, .joyride-tooltip.top-left .joyride-tooltip__triangle {
  inset-inline-start: 3%;
  transform: translateX(0);
}
@media screen and (min-width: 480px) {
  .joyride-tooltip.bottom-left .joyride-tooltip__triangle, .joyride-tooltip.top-left .joyride-tooltip__triangle {
    inset-inline-start: 2%;
  }
}
.joyride-tooltip.bottom-right .joyride-tooltip__triangle, .joyride-tooltip.top-right .joyride-tooltip__triangle {
  inset-inline-start: auto;
  inset-inline-end: 3%;
  transform: translateX(0);
}
@media screen and (min-width: 480px) {
  .joyride-tooltip.bottom-right .joyride-tooltip__triangle, .joyride-tooltip.top-right .joyride-tooltip__triangle {
    inset-inline-end: 2%;
  }
}
.joyride-tooltip.left {
  margin-inline-end: 18px;
}
.joyride-tooltip.left .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  height: 36px;
  inset-inline-end: -16px;
  width: 18px;
}
.joyride-tooltip.right {
  margin-inline-start: 18px;
}
.joyride-tooltip.right .joyride-tooltip__triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  height: 36px;
  inset-inline-start: -16px;
  width: 18px;
}
.joyride-tooltip__close {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-size: contain;
  height: 12px;
  position: absolute;
  text-decoration: none;
  top: 10px;
  width: 12px;
  z-index: 10;
  display: block;
}
.joyride-tooltip__close:active, .joyride-tooltip__close:focus, .joyride-tooltip__close:hover {
  outline: none;
}
.joyride-tooltip__close:hover, .joyride-tooltip__close:focus {
  color: rgba(59.5, 59.5, 59.5, 0.5);
  outline: none;
}
.joyride-tooltip__close--header {
  inset-inline-end: 20px;
  top: 20px;
}
.joyride-tooltip__header {
  border-bottom: 1px solid #f04;
  color: #555;
  font-size: 16px;
  padding-bottom: 6px;
  padding-inline-end: 18px;
  position: relative;
}
.joyride-tooltip__header ~ .joyride-tooltip__main {
  padding: 12px 0 18px;
}
.joyride-tooltip__main {
  font-size: 14px;
  padding-bottom: 18px;
  padding-inline-end: 18px;
}
.joyride-tooltip__footer {
  text-align: right;
}
.joyride-tooltip__button {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  padding: 0;
}
.joyride-tooltip__button:active, .joyride-tooltip__button:focus, .joyride-tooltip__button:hover {
  outline: none;
}
.joyride-tooltip__button--primary {
  background-color: #f04;
  border-radius: 4px;
  color: #fff;
  padding: 6px 12px;
  transition: background-color 0.2s ease-in-out;
}
.joyride-tooltip__button--primary:active, .joyride-tooltip__button--primary:focus, .joyride-tooltip__button--primary:hover {
  background-color: rgb(255, 30.6, 90.44);
  color: #fff;
}
.joyride-tooltip__button--secondary {
  color: #f04;
  margin-inline-end: 10px;
}
.joyride-tooltip__button--skip {
  color: #ccc;
  float: inline-start;
  margin-inline-end: 10px;
}
.joyride-tooltip--standalone .joyride-tooltip__main {
  padding-bottom: 0;
}
.joyride-tooltip--standalone .joyride-tooltip__footer {
  display: none;
}
@media screen and (min-width: 480px) {
  .joyride-tooltip {
    width: 360px;
  }
}
@media screen and (min-width: 960px) {
  .joyride-tooltip {
    width: 450px;
  }
}

@keyframes joyride-tooltip {
  0% {
    transform: scale(0.1);
  }
  100% {
    opacity: 1;
    transform: perspective(1px) scale(1);
  }
}
@keyframes joyride-beacon-inner {
  20% {
    opacity: 0.9;
  }
  90% {
    opacity: 0.7;
  }
}
@keyframes joyride-beacon-outer {
  0% {
    transform: scale(1);
  }
  45% {
    opacity: 0.7;
    transform: scale(0.75);
  }
  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}
/*Joyride Tour Styles*/
/*Form Styles*/
@media screen and (max-width: 575px) {
  .horizontal-stepper p, .horizontal-stepper span {
    opacity: 0;
    visibility: hidden;
    font-size: 12px;
  }
  .horizontal-stepper.active p, .horizontal-stepper.active span {
    opacity: 1;
    visibility: visible;
  }
  .horizontal-stepper > *, .horizontal-stepper > button > * {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .horizontal-stepper .stepperlabel, .horizontal-stepper .stepperbutton, .horizontal-stepper .stepperlabel span:first-child, .horizontal-stepper .stepperbutton span:first-child {
    opacity: 1;
    visibility: visible;
  }
  .horizontal-stepper-linear {
    padding-inline-start: 0 !important;
    padding-inline-end: 0 !important;
  }
}
.form-checkbox {
  position: relative;
  z-index: 1;
}

.form-checkbox > input {
  height: 18px;
  opacity: 0;
  position: absolute;
  padding: 10px;
  top: 0;
  width: 18px;
  z-index: 2;
  cursor: pointer;
}

.form-control-checkbox .form-checkbox > input {
  height: 48px;
  width: 48px;
}

.form-control-checkbox .form-checkbox {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
}

.form-checkbox > input + .check {
  border: 1px solid #333;
  border-radius: 2px;
  color: #99BBCD;
  cursor: pointer;
  display: inline-block;
  height: 18px;
  position: relative;
  width: 18px;
  z-index: -1;
}

.form-checkbox > input.sm + .check {
  border: 1px solid #333;
  border-radius: 2px;
  color: #99BBCD;
  cursor: pointer;
  display: inline-block;
  height: 14px;
  position: relative;
  top: 3px;
  width: 14px;
  z-index: -1;
}

.form-checkbox > input + .check i {
  display: none;
  inset-inline-start: 1px;
  opacity: 0;
  position: absolute;
  top: 2px;
}

.form-checkbox > input.sm + .check i {
  display: none;
  inset-inline-start: 1px;
  opacity: 0;
  position: absolute;
  top: 2px;
}

.form-checkbox > input:checked + span i {
  display: block;
  opacity: 1;
}

/*Radio and Checkbox styles*/
.checkbox-replace {
  padding-inline-start: 20px;
}

.checkbox-replace input[type=checkbox],
.radio-replace input[type=radio] {
  margin-inline-start: -20px;
  position: absolute;
}

.form-inline .checkbox-replace label {
  padding-inline-start: 5px;
}

.form-inline .checkbox-replace,
.form-inline .radio-replace {
  margin-inline-end: 20px;
}

.form-inline .checkbox-replace:last-child {
  margin-inline-end: 0;
}

.checkbox-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-inline-start: 5px;
}

.checkbox-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  inset-inline-start: 0;
  top: 0;
  margin-inline-start: -20px;
  margin-top: 2px;
  border: 1px solid #333;
  border-radius: 3px;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox-replace label::after {
  display: inline-block;
  position: absolute;
  width: 12px;
  height: 12px;
  inset-inline-start: 3px;
  top: 5px;
  margin-inline-start: -20px;
  font-size: 11px;
  color: #495057;
}

.checkbox-replace input[type=checkbox] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.checkbox-replace input[type=checkbox]:focus + label::before {
  outline: 0 none;
}

.checkbox-replace input[type=checkbox]:checked + label::after {
  background-color: #ced4da;
  content: "";
}

.checkbox-replace input[type=checkbox]:disabled + label {
  opacity: 0.65;
}

.checkbox-replace input[type=checkbox]:disabled + label::before {
  background-color: #fff;
  cursor: not-allowed;
}

.checkbox-replace.checkbox-inline {
  margin-top: 0;
}

.checkbox-primary label::before {
  border-color: #99BBCD;
}

.checkbox-primary input[type=checkbox]:checked + label::after {
  background-color: #99BBCD;
}

.checkbox-danger label::before {
  border-color: #E91E63;
}

.checkbox-danger input[type=checkbox]:checked + label::after {
  border-color: #E91E63;
}

.checkbox-info label::before {
  border-color: #00bcd4;
}

.checkbox-info input[type=checkbox]:checked + label::after {
  border-color: #00bcd4;
}

.checkbox-warning label::before {
  border-color: #e87d0d;
}

.checkbox-warning input[type=checkbox]:checked + label::after {
  border-color: #e87d0d;
}

.checkbox-success label::before {
  border-color: #63a386;
}

.checkbox-success input[type=checkbox]:checked + label::after {
  border-color: #63a386;
}

.radio-replace {
  padding-inline-start: 20px;
}

.radio-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-inline-start: 5px;
}

.radio-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  inset-inline-start: 0;
  top: 0;
  margin-inline-start: -20px;
  margin-top: 2px;
  border: 1px solid #ced4da;
  border-radius: 50%;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out;
  transition: border 0.15s ease-in-out;
}

.radio-replace label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 12px;
  height: 12px;
  inset-inline-start: 3px;
  top: 5px;
  margin-inline-start: -20px;
  border-radius: 50%;
  background-color: #ced4da;
  -webkit-transform: rotate(scale(0, 0));
  -ms-transform: rotate(scale(0, 0));
  -o-transform: rotate(scale(0, 0));
  transform: rotate(scale(0, 0));
  -webkit-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -o-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}

.radio-replace input[type=radio] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.radio-replace input[type=radio]:focus + label::before {
  outline: 0 none;
}

.radio-replace input[type=radio]:checked + label::after {
  -webkit-transform: rotate(scale(1, 1));
  -ms-transform: rotate(scale(1, 1));
  -o-transform: rotate(scale(1, 1));
  transform: rotate(scale(1, 1));
}

.radio-replace input[type=radio]:disabled + label {
  opacity: 0.65;
}

.radio-replace input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}

.radio-replace.radio-inline {
  margin-top: 0;
}

.radio-primary input[type=radio] + label::after {
  background-color: #99BBCD;
}

.radio-primary input[type=radio]:checked + label::before {
  border-color: #99BBCD;
}

.radio-primary input[type=radio]:checked + label::after {
  background-color: #99BBCD;
}

.radio-danger input[type=radio] + label::after {
  background-color: #E91E63;
}

.radio-danger input[type=radio]:checked + label::before {
  border-color: #E91E63;
}

.radio-danger input[type=radio]:checked + label::after {
  background-color: #E91E63;
}

.radio-info input[type=radio] + label::after {
  background-color: #00bcd4;
}

.radio-info input[type=radio]:checked + label::before {
  border-color: #00bcd4;
}

.radio-info input[type=radio]:checked + label::after {
  background-color: #00bcd4;
}

.radio-warning input[type=radio] + label::after {
  background-color: #e87d0d;
}

.radio-warning input[type=radio]:checked + label::before {
  border-color: #e87d0d;
}

.radio-warning input[type=radio]:checked + label::after {
  background-color: #e87d0d;
}

.radio-success input[type=radio] + label::after {
  background-color: #63a386;
}

.radio-success input[type=radio]:checked + label::before {
  border-color: #63a386;
}

.radio-success input[type=radio]:checked + label::after {
  background-color: #63a386;
}

.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0;
}

.form-horizontal .form-inline .checkbox,
.form-horizontal .form-inline .checkbox-inline,
.form-horizontal .form-inline .radio,
.form-horizontal .form-inline .radio-inline {
  padding-top: 0;
}

.form-horizontal .checkbox, .form-horizontal .radio {
  min-height: 27px;
}

.form-wizard .tab-content .pager.wizard .first a {
  margin-inline-end: 8px;
}

.form-wizard .tab-content .pager.wizard .last a {
  margin-inline-start: 8px;
}

.wizard-navbar {
  margin: 60px auto 20px;
}

.wizard-navbar > ul {
  display: table;
  width: 100%;
  text-align: center;
  margin: 0;
  font-weight: 600;
  padding: 0;
  list-style: none outside none;
  table-layout: fixed;
}

.wizard-navbar > ul li {
  display: table-cell;
  width: 1%;
  position: relative;
}

.wizard-navbar > ul li a {
  color: #333;
  position: relative;
  padding: 0 10px;
  display: block;
  text-decoration: none;
}

.wizard-navbar > ul li a span.wz-number {
  background-color: #e9ecef;
  border-radius: 50%;
  color: #adb5bd;
  display: block;
  height: 40px;
  inset-inline-start: 50%;
  line-height: 40px;
  margin-inline-start: -20px;
  margin-top: -50px;
  position: absolute;
  text-align: center;
  -webkit-transition: all 300ms ease-in-out 0s;
  -o-transition: all 300ms ease-in-out 0s;
  transition: all 300ms ease-in-out 0s;
  width: 40px;
  z-index: 5;
}

.wizard-navbar > ul li.completed a span.wz-number {
  background-color: #99BBCD;
  color: #fff;
}

.wizard-navbar > ul li a.active span.wz-number {
  background-color: #E91E63;
  color: #fff;
}

.wizard-navbar > ul li a.active,
.wizard-navbar > ul li.completed a {
  color: #6c757d;
}

.wizard-navbar > ul li a:before,
.wizard-navbar > ul li a:after {
  content: "";
  position: absolute;
  height: 4px;
  width: 50%;
  background-color: #e9ecef;
  top: -32px;
  inset-inline-start: 0;
}

.wizard-navbar > ul li a:after {
  inset-inline-start: auto;
  inset-inline-end: 0;
}

.wizard-navbar > ul li a.active:before,
.wizard-navbar > ul li a.active:after {
  background-color: #E91E63;
}

.wizard-navbar > ul li.completed a:before,
.wizard-navbar > ul li.completed a:after {
  background-color: #99BBCD;
}

label.error {
  display: block;
  color: #f44336;
  font-weight: 400;
  margin: 5px 0;
}

@media screen and (max-width: 479px) {
  .wizard-navbar > ul li a span.wz-label {
    visibility: hidden;
  }
  .wizard-navbar > ul li a.active span.wz-label {
    visibility: visible;
  }
}
.form-checkbox-custom {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 12px;
}

.form-checkbox-custom .check {
  margin-inline-end: 10px;
}

.react-switch {
  vertical-align: middle;
  margin-inline-start: 4px;
}

/*Input Styles*/
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 12px;
  color: rgb(178.5, 178.5, 178.5);
}

::-moz-placeholder { /* Firefox 19+ */
  font-size: 12px;
  color: rgb(178.5, 178.5, 178.5);
}

:-ms-input-placeholder { /* IE 10+ */
  font-size: 12px;
  color: rgb(178.5, 178.5, 178.5);
}

:-moz-placeholder { /* Firefox 18- */
  font-size: 12px;
  color: rgb(178.5, 178.5, 178.5);
}

.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 14px;
}

.module-box-header ::-moz-placeholder { /* Firefox 19+ */
  font-size: 14px;
}

.module-box-header :-ms-input-placeholder { /* IE 10+ */
  font-size: 14px;
}

.module-box-header :-moz-placeholder { /* Firefox 18- */
  font-size: 14px;
}

.search-bar {
  background-color: #fff;
  position: relative;
}
.search-bar .form-group {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
}
.search-bar input[type=search] {
  padding-inline-end: 50px;
}
.search-bar .search-icon {
  background-color: transparent;
  border: 0 none;
  color: rgb(133.7553648069, 142.4849785408, 150.2446351931);
  height: 36px;
  width: 30px;
}
.search-bar .form-control {
  box-shadow: none;
}
.search-bar .form-control.form-control-lg + .search-icon {
  position: absolute;
  inset-inline-end: 14px;
  top: 6px;
}
.search-bar .search-icon {
  position: absolute;
  inset-inline-end: 14px;
  top: 3px;
}
.search-bar.right-side-icon input[type=search] {
  padding-inline-end: 16px;
  padding-inline-start: 50px;
}
.search-bar.right-side-icon .search-icon {
  position: absolute;
  inset-inline-start: 14px;
  top: 2px;
}
.search-bar.right-side-icon .form-control {
  box-shadow: none;
}
.search-bar.right-side-icon .form-control.form-control-lg + .search-icon {
  position: absolute;
  inset-inline-start: 14px;
  top: 6px;
}

.nav-searchbox .search-bar input + .search-icon i {
  color: rgba(51, 51, 51, 0.8);
}

@media screen and (max-width: 767px) {
  .jr-card .app-main-header .search-bar {
    width: 150px;
  }
}
/* Pages
   ========================================================================== */
/*Login Styles*/
/*Login Styles*/
.login-container {
  position: relative;
  height: 100%;
}

.login-content {
  width: 420px;
  margin: auto;
  padding: 35px 35px 20px;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #ced4da;
  font-size: 14px;
  max-width: 94%;
}

.login-header {
  margin-bottom: 30px;
}

.login-content .form-control {
  background-color: #f5f5f5;
}
.login-content .form-control:focus {
  box-shadow: none;
  border-color: #99BBCD;
}

.login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important;
}

.app-login-container {
  position: relative;
  max-width: 680px;
  width: 94%;
  margin: 0 auto;
}
.app-login-container .loader-view {
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  z-index: 2;
}

.app-login-main-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
}

.app-login-content {
  padding: 35px 35px 20px;
  width: 60%;
  order: 1;
}
@media screen and (max-width: 575px) {
  .app-login-content {
    width: 100%;
    order: 2;
  }
}

.app-login-header {
  margin-bottom: 30px;
}

.app-login-content .form-control {
  background-color: #f5f5f5;
}
.app-login-content .form-control:focus {
  box-shadow: none;
  border-color: #99BBCD;
}

.app-login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important;
}

.app-logo-content {
  background-color: #99BBCD;
  padding: 35px 35px 20px;
  width: 40%;
  order: 2;
}
@media screen and (max-width: 575px) {
  .app-logo-content {
    width: 100%;
    order: 1;
  }
}

.app-social-block {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.app-social-block .social-link, .app-social-block .social-link li {
  margin: 0;
}
.app-social-block .social-link span {
  border: solid 1px #99BBCD;
  border-radius: 50%;
  color: #99BBCD;
}
.app-social-block .social-link span:hover, .app-social-block .social-link span:focus {
  color: #fff;
  background-color: #99BBCD;
}
.app-social-block p {
  margin-bottom: 0;
}

/*Error Styles*/
.page-error-container {
  padding: 30px 0;
  position: relative;
}
@media screen and (max-width: 575px) {
  .page-error-container {
    padding: 15px 0;
  }
}

.page-error-content {
  margin: 0 auto;
  padding: 40px 0;
  width: 380px;
  max-width: 94%;
}
@media screen and (max-width: 767px) {
  .page-error-content {
    padding: 15px 0;
  }
}
@media screen and (max-width: 575px) {
  .page-error-content {
    padding: 0;
  }
}

.error-code {
  color: #212529;
  font-size: 160px;
  text-align: center;
  line-height: 1;
  font-weight: 600;
  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);
}
@media screen and (max-width: 991px) {
  .error-code {
    font-size: 130px;
  }
}
@media screen and (max-width: 767px) {
  .error-code {
    font-size: 100px;
  }
}
@media screen and (max-width: 575px) {
  .error-code {
    font-size: 80px;
  }
}

.page-error-content h2 {
  margin-bottom: 50px;
}
@media screen and (max-width: 767px) {
  .page-error-content h2 {
    margin-bottom: 20px;
  }
}

/*Editor Styles*/
.rdw-inline-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.rdw-option-wrapper {
  margin-bottom: 6px;
}

/*Contact Page Styles*/
.contact-form {
  padding: 60px;
}

.contact-block .contact-info {
  list-style: none;
  padding-inline-start: 0;
  margin-bottom: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-align-content: stretch;
  -ms-flex-align: stretch;
  align-content: stretch;
}
.contact-block .contact-info li {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  overflow: hidden;
  padding: 10px 40px;
  border-inline-end: 2px solid #333;
  word-wrap: break-word;
}
.contact-block .contact-info li:last-child {
  border: 0 none;
}
.contact-block .contact-info li > i {
  float: inline-start;
  font-size: 16px;
  margin-inline-end: 5px;
}
.contact-block .contact-info li .contact-body {
  overflow: hidden;
}
.contact-block .contact-info li .contact-body .icons-wrapper {
  margin-top: 15px;
  margin-inline-start: 0;
}
.contact-block .contact-info li .contact-body .icon {
  background-color: #5c6bc0;
  color: #fff;
  border-radius: 50%;
  margin-inline-end: 6px;
  margin-bottom: 6px;
}
.contact-block .contact-info li .contact-body .icon:last-child {
  margin-inline-end: 0;
}
.contact-block .contact-info li .contact-body .twitter-icon {
  background-color: #40c4ff;
}
.contact-block .contact-info li .contact-body .google-icon {
  background-color: #EF5350;
}
.contact-block .contact-info li .contact-body .linkedin-icon {
  background-color: #0277bd;
}
.contact-block .contact-info.vertical {
  display: block;
  margin-bottom: 0;
}
.contact-block .contact-info.vertical li {
  padding: 0 0 24px;
  border-inline-end: 0 none;
  border-bottom: 2px solid #333;
  margin-bottom: 24px;
}
.contact-block .contact-info.vertical li:last-child {
  border: 0 none;
  margin-bottom: 0;
  padding-bottom: 0;
}

@media screen and (max-width: 767px) {
  .contact-form {
    padding: 30px;
  }
  .contact-block .contact-info {
    display: block;
    margin-bottom: 0;
  }
  .contact-block .contact-info li {
    padding: 0 0 24px;
    border-inline-end: 0 none;
    border-bottom: 2px solid #333;
    margin-bottom: 24px;
  }
  .contact-block .contact-info li:last-child {
    border: 0 none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .content-section {
    padding: 20px 10px 0;
    text-align: center;
  }
  .content-section h2 {
    font-size: 28px;
  }
  .content-section p {
    font-size: 18px;
  }
}
/*Portfolio Styles*/
.portfolio-section .card-image {
  margin-bottom: 20px;
}
.portfolio-section .card-image img {
  width: 100%;
  -webkit-transition: all 1200ms ease;
  -o-transition: all 1200ms ease;
  transition: all 1200ms ease;
}
.portfolio-section .card-image:hover img {
  -webkit-transform: scale(1.08);
  -ms-transform: scale(1.08);
  transform: scale(1.08);
}

.filter-with-bg-color ul {
  padding-inline-start: 0;
  margin: 0 -10px 45px;
}
.filter-with-bg-color ul li {
  display: inline-block;
  margin-bottom: 10px;
  padding: 0 10px;
}
.filter-with-bg-color ul li a {
  text-transform: uppercase;
  font-size: 12px;
  padding: 10px 24px;
  border: 1px solid #99BBCD;
  display: block;
  text-decoration: none;
}
.filter-with-bg-color ul li a:hover, .filter-with-bg-color ul li a:focus, .filter-with-bg-color ul li a.active {
  cursor: pointer;
  background-color: #99BBCD;
  border-color: #99BBCD;
  color: #fff;
}
@media screen and (max-width: 575px) {
  .filter-with-bg-color ul {
    margin-bottom: 15px;
  }
}

/*Faqs Styles*/
.Collapsible {
  margin-bottom: 15px;
}

.Collapsible__contentInner {
  padding: 20px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  border-top: 0;
}
.Collapsible__contentInner p {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
}
.Collapsible__contentInner p:last-child {
  margin-bottom: 0;
}

.Collapsible__trigger {
  display: block;
  cursor: pointer;
  font-weight: 400;
  text-decoration: none;
  position: relative;
  padding: 18px 20px;
  border-radius: 8px;
  background: #99BBCD;
  color: #fff;
}
.Collapsible__trigger:after {
  content: "\\f2f9";
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  position: absolute;
  inset-inline-end: 24px;
  top: 16px;
  display: block;
  transition: transform 300ms;
}
.Collapsible__trigger.is-open {
  border-radius: 8px 8px 0 0;
}
.Collapsible__trigger.is-open:after {
  transform: rotateZ(180deg);
}

.categories-list {
  margin-bottom: 0;
}
.categories-list li {
  margin-bottom: 10px;
}
.categories-list li:last-child {
  margin-bottom: 0;
}
.categories-list li.active a {
  color: #99BBCD;
}
.categories-list .badge {
  font-size: 9px;
}

.articles-section .articles {
  margin-bottom: 26px;
}
.articles-section .articles:last-child {
  margin-bottom: 0;
}

.article-image {
  display: block;
  margin-bottom: 12px;
}
.article-image > img {
  border-radius: 8px;
  width: 100%;
}

.article-description p {
  font-weight: 500;
  margin-bottom: 2px;
}

.meta-wrapper {
  margin-bottom: 10px;
}

.meta-date,
.meta-comment {
  font-size: 14px;
  color: #adb5bd;
  display: inline-block;
}
.meta-date i,
.meta-comment i {
  display: inline-block;
  margin-inline-end: 6px;
}

.meta-date + .meta-comment {
  margin-inline-start: 10px;
}

/*Dashboard Styles*/
.box {
  position: relative;
}
.box .box-top,
.box .box-bottom {
  height: 100px;
  padding: 32px 15px;
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 300;
}
.box .box-top .size-h5,
.box .box-bottom .size-h5 {
  font-size: 24px;
  margin-inline-start: 2px;
}
.box .box-top .material-icons,
.box .box-bottom .material-icons {
  font-size: 40px;
  line-height: 40px;
}
.box .box-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}
.box .box-info {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -12px;
  text-align: center;
}
.box .box-info span {
  height: 24px;
  display: inline-block;
  padding: 4px 10px;
  text-transform: uppercase;
  line-height: 14px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 12px;
  color: #6c757d;
  border-radius: 1em;
}
.box .box-info span .material-icons {
  line-height: 14px;
  font-size: 11px;
}

.contact-list {
  margin-bottom: 14px;
}
.contact-list i {
  margin-inline-end: 14px;
  color: #99BBCD;
}
.contact-list .media {
  margin-bottom: 10px;
}

.temp-section .temp-point,
.temp-section .detail-icon {
  font-size: 54px;
}

.assignment-table tbody tr:nth-child(odd) {
  background-color: #dee2e6 !important;
}
.assignment-table td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.status-cell {
  min-width: 100px;
  max-width: 120px;
  padding-inline-end: 24px !important;
}
.status-cell .badge {
  min-width: 70px;
}

.thumbnail-list {
  margin-bottom: 0;
}
.thumbnail-list .thumbnail-item {
  padding: 0 2.5px;
  display: inline-block;
  width: 33.333%;
  margin-bottom: 5px;
}
@media screen and (max-width: 767px) {
  .thumbnail-list .thumbnail-item {
    width: 50%;
  }
}
@media screen and (max-width: 575px) {
  .thumbnail-list .thumbnail-item {
    width: 33.333%;
  }
}

.post-list .post-image .grid-thumb-equal {
  padding-bottom: 100%;
}

/*Ecommerce Dashboard Styles*/
.chart-f30 {
  font-size: 30px;
}
@media screen and (max-width: 1099px) {
  .chart-f30 {
    font-size: 20px;
  }
}

.chart-f20 {
  font-size: 20px;
}
@media screen and (max-width: 1099px) {
  .chart-f20 {
    font-size: 16px;
  }
}

.chart-order .col-5 {
  order: 2;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .chart-order .col-5 {
    order: 1;
  }
}
.chart-order .col-7 {
  order: 1;
}
@media screen and (max-width: 575px) {
  .chart-order .col-7 {
    order: 2;
  }
}

.tab-notifications {
  margin-inline-start: -30px;
  margin-inline-end: -30px;
  border-bottom: 1px solid #adb5bd;
}
@media screen and (max-width: 567px) {
  .tab-notifications button,
  .tab-notifications button * {
    font-size: 12px !important;
  }
}

.chart-title h2 {
  font-size: 22px;
  margin-bottom: 5px;
}

.img-fluid {
  width: 100%;
}

.comment-footer button {
  margin-bottom: 6px;
}

/*Intranet Dashboard Styles*/
.net-chart {
  padding-inline-start: 80px;
  padding-inline-end: 15px;
  min-height: 100px;
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}
.net-chart .jr-card-thumb {
  margin: 0;
  width: 50px;
  height: 50px;
  color: #fff;
  font-size: 20px;
  border-radius: 50%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-transition: all 100ms ease;
  -o-transition: all 100ms ease;
  transition: all 100ms ease;
  position: absolute;
  inset-inline-start: 15px;
}
.net-chart:hover .jr-card-thumb {
  width: 70px;
  height: 100%;
  font-size: 30px;
  border-radius: 0;
  position: absolute;
  inset-inline-start: 0;
}

.net-chart-hr {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  min-height: 120px;
  padding-inline-end: 8px;
  overflow: hidden;
}
.net-chart-hr .jr-card-thumb {
  margin-block: -30px;
  margin-inline-end: 12px;
  margin-inline-start: -30px;
  min-width: 105px;
}
.net-chart-hr .grid-thumb-equal {
  padding-bottom: 130%;
}
.net-chart-hr .jr-card-body {
  width: calc(100% - 100px);
}

.user-profile {
  padding: 10px 0;
}

.mh-120 {
  min-height: 120px;
}

.jr-card-header-top {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-inline-end: -16px;
}

.jr-card-header-color {
  padding: 10px 20px 20px;
  margin: -24px -30px 25px;
}

.todo-cell-group .todo-cell:not(:last-child) {
  margin-bottom: 8px;
}

.social-list-line {
  position: relative;
}
.social-list-line:not(:last-child):before {
  border-inline-start: solid 1px #adb5bd;
  content: "";
  inset-inline-start: 20px;
  position: absolute;
  top: 5px;
  bottom: 0;
  width: 1px;
  z-index: 1;
}

.list-line-item {
  position: relative;
  padding-inline-start: 40px;
}
.list-line-item:not(:last-child):before {
  border-inline-start: solid 1px #adb5bd;
  content: "";
  inset-inline-start: 20px;
  position: absolute;
  top: -25px;
  bottom: -25px;
  width: 1px;
  z-index: 1;
}

.list-line-badge {
  position: absolute;
  inset-inline-start: 16px;
  top: 15px;
  z-index: 2;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #adb5bd;
}

.circle-shape {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.project-list {
  line-height: 1;
}
.project-list:not(:last-child) {
  margin-bottom: 20px;
}
.project-list .circle-shape {
  margin-top: 4px;
  margin-inline-end: 16px;
}
.project-list .project-name {
  display: block;
  margin-bottom: 4px;
  color: #333;
}
.project-list .project-name:hover, .project-list .project-name:focus {
  color: #99BBCD;
  text-decoration: none;
}

.nav-pill-sales li + li {
  margin-inline-end: -1px;
}
.nav-pill-sales .nav-link {
  background-color: #e9ecef;
  border-radius: 0;
  padding: 6px 15px;
  color: #6c757d;
  font-size: 13px;
  border: 1px solid #ced4da;
}
.nav-pill-sales .nav-link.active {
  background-color: #99BBCD;
  color: #fff;
  border-color: #99BBCD;
}
.nav-pill-sales .nav-link.active:hover, .nav-pill-sales .nav-link.active:focus {
  color: #fff;
}
.nav-pill-sales li:first-child .nav-link {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.nav-pill-sales li:last-child .nav-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.temp-week-list {
  list-style: none;
  padding-inline-start: 0;
  margin-bottom: 0;
  color: rgb(128.2832618026, 137.4068669528, 145.5167381974);
}
.temp-week-list li:not(:last-child) {
  margin-bottom: 10px;
}
@media screen and (max-width: 340px) {
  .temp-week-list li:not(:last-child) {
    margin-bottom: 20px;
  }
}
.temp-week-list img {
  width: 24px;
  height: 24px;
}
.temp-week-list span {
  display: inline-block;
}
.temp-week-list span.temp-point {
  margin: 0 20px;
}
@media screen and (max-width: 1199px) {
  .temp-week-list span.temp-point {
    margin: 0 10px;
  }
}
@media screen and (max-width: 1050px) {
  .temp-week-list span.temp-point {
    margin: 0 5px;
  }
}
@media screen and (max-width: 340px) {
  .temp-week-list span.temp-point {
    margin: 0 20px;
  }
}

.temp-section .temp-point {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0;
}
.temp-section .temp-point sub, .temp-section .temp-point sup {
  font-size: 70%;
}

/*Dropzone Styles*/
.dropzone-card {
  position: relative;
}

.dropzone {
  margin-bottom: 20px;
}
.dropzone > div {
  margin: 0 auto;
  padding: 15px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}
.dropzone > div :last-child {
  margin-bottom: 0;
}
.dropzone .btn {
  margin-top: 20px;
}

.upload-file-list {
  list-style: none;
  padding-inline-start: 0;
}
.upload-file-list li {
  margin-bottom: 5px;
}

.form-group-dropzone label {
  margin-bottom: 6px;
}
.form-group-dropzone .form-control {
  max-width: 200px;
  margin: 0 auto;
}

.gdb-home {
  max-width: 980px;
  margin: 0 auto;
  padding: 24px;
}

.gdb-home-hero {
  display: flex;
  align-items: center;
  gap: 24px;
  background: #fff;
  border: 1px solid #e6e9ed;
  border-radius: 10px;
  padding: 28px;
  padding-inline-start: 96px;
}
.gdb-home-hero__text {
  flex: 1.1;
}
.gdb-home-hero__title {
  font-size: 22px;
  font-weight: 700;
  color: #1f2733;
  margin: 0 0 8px;
}
.gdb-home-hero__subtitle {
  color: #69707a;
  font-size: 14px;
  line-height: 1.5;
  max-width: 360px;
  margin: 0 0 18px;
}
.gdb-home-hero__actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.gdb-home-hero__actions a {
  text-decoration: none;
}
.gdb-home-hero__actions .system-button i {
  margin-inline-end: 6px;
}
.gdb-home-hero__art {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.gdb-home-hero__art img {
  max-width: 100%;
  height: auto;
}

.gdb-home-panel {
  background: #fff;
  border: 1px solid #e6e9ed;
  border-radius: 10px;
  padding: 16px 18px;
  margin-top: 14px;
}
.gdb-home-panel__label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9aa1ab;
  font-weight: 600;
  margin-bottom: 8px;
}
.gdb-home-panel__label a {
  color: #1b3a8b;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
}

.gdb-home-recent__list {
  display: flex;
  flex-direction: column;
}
.gdb-home-recent__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-bottom: 1px solid #f0f2f5;
  border-radius: 6px;
  color: inherit;
  text-decoration: none;
}
.gdb-home-recent__row:hover {
  background: #f7f9fc;
  text-decoration: none;
}
.gdb-home-recent__row:focus-visible {
  outline: 2px solid #1b3a8b;
  outline-offset: -2px;
  background: #f7f9fc;
}
.gdb-home-recent__row:last-child {
  border-bottom: none;
}
.gdb-home-recent__swatch {
  width: 8px;
  height: 26px;
  border-radius: 3px;
  flex: none;
}
.gdb-home-recent__name {
  font-size: 13px;
  color: #1f2733;
  font-weight: 600;
  flex: 1;
}
.gdb-home-recent__pill {
  font-size: 9px;
  font-weight: 700;
  color: #a06a00;
  background: #fff4e0;
  border-radius: 10px;
  padding: 1px 7px;
  margin-inline-start: 8px;
}
.gdb-home-recent__when {
  font-size: 11px;
  color: #8a909a;
  white-space: nowrap;
}
.gdb-home-recent__chev {
  color: #c2c8d0;
  font-size: 13px;
}

.gdb-home-features {
  background: #fbfcfd;
}
.gdb-home-features .gdb-home-panel__label {
  justify-content: center;
  margin-bottom: 14px;
}
.gdb-home-features__grid {
  display: flex;
  gap: 18px;
}

.gdb-home-feature {
  flex: 1;
  text-align: center;
  font-size: 11px;
  color: #69707a;
}
.gdb-home-feature__icon {
  font-size: 18px;
  color: #9fb0d6;
  margin-bottom: 4px;
  display: block;
}
.gdb-home-feature b {
  color: #3a4250;
  display: block;
  font-size: 12px;
  margin-bottom: 2px;
}

@media (max-width: 767px) {
  .gdb-home-hero {
    flex-direction: column;
    text-align: center;
  }
  .gdb-home-hero__art {
    justify-content: center;
  }
  .gdb-home-features__grid {
    flex-direction: column;
  }
}
/* Slider
   ========================================================================== */
.brand-logo {
  border: 1px solid #dee2e6;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-bottom: 75%;
}
.brand-logo .brand-logo-inner {
  text-align: center;
}
.brand-logo .brand-logo-inner:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.brand-logo .brand-logo-inner img {
  height: auto;
  max-height: 100%;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
  width: auto !important;
}
.brand-logo:hover {
  -webkit-transition: all 0.4s ease-in-out 0.1s;
  -o-transition: all 0.4s ease-in-out 0.1s;
  transition: all 0.4s ease-in-out 0.1s;
  background-color: rgb(242.25, 242.25, 242.25);
}
@media screen and (max-width: 575px) {
  .brand-logo {
    margin-bottom: 15px;
  }
}

.owl-app-frame.owl-carousel .owl-item img {
  display: inline-block;
  width: auto;
}

.carousel-item img {
  max-width: 100%;
}

/* Modules
   ========================================================================== */
/* App Module Style */
.app-wrapper-module {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: stretch;
  align-items: stretch;
  height: 100%;
}

.app-module {
  position: relative;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-top: -36px;
  margin-bottom: 0;
  margin-inline: -40px;
}
@media screen and (max-width: 575px) {
  .app-module {
    margin: -20px;
  }
}

.module-side {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 230px;
  -ms-flex: 0 1 230px;
  flex: 0 1 230px;
  max-width: 230px;
  min-width: 230px;
}

.module-side-header {
  border-bottom: solid 1px #e9ecef;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.module-side-header .user-detail {
  padding: 15px 10px;
  text-align: center;
}

.module-logo {
  padding: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  min-height: 78px;
  font-size: 20px;
  background-color: rgb(249.4875, 250.275, 251.0625);
  color: rgb(47.4275862069, 52.9, 58.3724137931);
}
.module-logo .zmdi {
  font-size: 28px;
}

.module-user-info, .module-side-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.module-user-detail {
  font-size: 12px;
}

.module-add-task {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 24px;
}

.module-nav {
  list-style: none;
  padding-inline-start: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}
.module-nav li {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.module-nav li a {
  padding: 12px 29px;
  color: #666666;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  text-decoration: none;
}
.module-nav li a:hover, .module-nav li a:focus {
  color: #333;
}
.module-nav li a.active {
  color: #99BBCD;
}
.module-nav li i {
  margin-inline-end: 16px;
  font-size: 16px;
}
.module-nav li span {
  display: inline-block;
  vertical-align: middle;
}
.module-nav li.module-nav-label {
  padding: 12px 29px;
}

.module-box {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 231px);
}

.module-box-header {
  padding: 10px 26px;
  min-height: 79px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #fff;
  border-bottom: solid 1px #e9ecef;
}
.module-box-header .search-bar.right-side-icon {
  min-width: 350px;
}
.module-box-header .search-bar.right-side-icon .form-control {
  border-radius: 0;
  height: 46px;
  padding-block: 10px;
  padding-inline-end: 18px;
  padding-inline-start: 40px;
}
.module-box-header .search-bar.right-side-icon .form-control:focus {
  background-color: #f8f9fa;
}
.module-box-header .search-bar.right-side-icon .search-icon {
  width: 25px;
  height: 46px;
  font-size: 16px;
  inset-inline-start: 10px;
  top: 0;
  padding: 0;
}

.module-box-header-inner {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.module-box-content {
  background-color: #fff;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.module-box-topbar {
  padding: 8px 12px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
}
.module-box-topbar button + button {
  border-radius: 0;
}

.module-box-topbar-todo {
  padding-inline-start: 64px;
}
@media screen and (max-width: 575px) {
  .module-box-topbar-todo {
    padding-inline-start: 27px;
  }
}

.module-list-icon {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding-inline-end: 10px;
}

.bar-icon {
  margin-inline-end: 15px;
}

.toolbar-left {
  margin-inline-start: auto;
}

.module-list {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}

.module-list-item {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding: 15px 28px;
  border-bottom: solid 1px #e9ecef;
  z-index: 5;
  position: relative;
  cursor: pointer;
}
.module-list-item > .check-label {
  margin-inline-start: 0;
  margin-bottom: 0;
}
.module-list-item.mail-cell {
  padding-inline-start: 12px;
  -webkit-align-items: start;
  align-items: start;
}

.module-detail-header {
  margin-bottom: 10px;
}
.module-detail-header > .check-label {
  margin-inline-end: auto;
}

.module-list-info {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: calc(100% - 169px);
}

.module-todo-content {
  position: relative;
}
.module-todo-content .subject {
  margin-bottom: 5px;
}

.module-list-actions {
  text-align: right;
}

.app-module-sidenav {
  background-color: #fff;
  border-inline-end: solid 1px #e9ecef;
  position: relative;
  z-index: 9;
}
.app-module-sidenav .chat-sidenav-main {
  max-width: 300px;
  min-width: 300px;
  width: 90%;
}

.module-date {
  max-width: 160px;
}
.module-date > div:before {
  display: none;
}

.module-detail-item {
  padding: 10px 28px;
}

.task-title {
  font-size: 18px;
}

.chat-todo-avatar {
  margin-inline-end: 15px;
}

.modal-title {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  width: 100%;
  font-size: 18px;
}

.loader-view-block, .loader-view {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.module-date > div {
  -webkit-align-items: center;
  align-items: center;
}

@media screen and (max-width: 1199px) {
  .module-side {
    display: -webkit-block;
    display: -moz-block;
    display: -ms-block;
    display: -o-block;
    display: block;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 280px;
    min-width: 280px;
    background-color: #fff;
  }
  .module-box-header {
    position: relative;
    min-height: 58px;
    padding-block: 5px;
    padding-inline-end: 26px;
    padding-inline-start: 75px;
  }
  .module-box-header .drawer-btn {
    position: absolute;
    inset-inline-start: 0;
    top: 0;
    z-index: 1;
    border-inline-end: solid 1px #e9ecef;
    height: 58px;
    width: 56px;
    border-radius: 0;
    font-size: 22px;
  }
  .module-box-header .search-bar.right-side-icon .form-control {
    height: 38px;
    padding-block: 5px;
    padding-inline-end: 18px;
    padding-inline-start: 40px;
  }
  .module-box-header .search-bar.right-side-icon .search-icon {
    height: 38px;
  }
  .chat-loader-view {
    height: calc(100vh - 120px);
  }
  .module-box {
    max-width: 100%;
  }
}
@media screen and (min-width: 991px) {
  .modal-dialog {
    max-width: 750px;
  }
}
@media screen and (max-width: 991px) {
  .app-module {
    padding-top: 0;
  }
}
@media screen and (max-width: 599px) {
  .module-box-header .search-bar {
    margin-inline-start: 0;
    max-width: none;
  }
  .module-box-header .search-bar.right-side-icon {
    min-width: 250px;
  }
}
@media screen and (max-width: 575px) {
  .module-list-item {
    padding: 10px 12px;
  }
  .module-list-info {
    max-width: 100%;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu {
    inset-inline-end: auto !important;
    inset-inline-start: 0 !important;
  }
  .module-box-header .search-bar.right-side-icon {
    min-width: 200px;
  }
  .module-box-header .search-bar.right-side-icon .form-control {
    border-radius: 0.25rem;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:after {
    inset-inline-end: auto;
    inset-inline-start: 9px;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:before {
    inset-inline-end: auto;
    inset-inline-start: 9px;
  }
  .module-box-header .search-bar {
    padding-inline-end: 2px;
  }
}
@media screen and (max-width: 399px) {
  .module-box-header .search-bar.right-side-icon {
    min-width: 100px;
  }
}
@media screen and (min-width: 399px) {
  .d-xs-flex {
    display: flex !important;
  }
}
/*Chat Module Styles*/
.chat-module {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.chat-module:before {
  inset-inline-start: -29px;
}

.chat-module-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  background-color: #f8f9fa;
  position: relative;
  width: 100%;
}

.chat-sidenav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 315px;
  -ms-flex: 0 1 315px;
  flex: 0 1 315px;
  min-width: 315px;
  border-inline-end: solid 1px #e9ecef;
}

.chat-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  z-index: 2;
}

.chat-sidenav-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 25px 20px 12px;
  background-color: rgb(249.4875, 250.275, 251.0625);
}

.chat-user-hd {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

.chat-sidenav-header .search-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 0;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .form-control {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  padding-inline-start: 42px;
  height: 42px;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .search-icon {
  inset-inline-start: 10px;
  top: 0;
  height: 42px;
  padding: 0;
}

.chat-avatar {
  min-width: 50px;
}
.chat-user-item .chat-avatar {
  padding: 0 5px;
  min-width: 10px;
}
.chat-user-hd .chat-avatar {
  cursor: pointer;
}

.chat-avatar-mode {
  position: relative;
  max-width: 50px;
}
.chat-avatar-mode .chat-mode {
  display: block;
  position: absolute;
  inset-inline-start: 0;
  top: 2px;
  z-index: 1;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.chat-avatar-mode .chat-mode.small {
  width: 8px;
  height: 8px;
}
.chat-avatar-mode .chat-mode.online {
  background-color: #4CAF50;
}
.chat-avatar-mode .chat-mode.offline {
  background-color: #fff;
  border: solid 1px #4CAF50;
}
.chat-avatar-mode .chat-mode.away {
  background-color: #fdd835;
}
.chat-main-header-info .chat-avatar-mode {
  max-width: 60px;
}

.chat-sidenav-content {
  background-color: #fff;
}

.chat-sidenav-title {
  padding: 10px 16px;
  font-size: 14px;
  color: #00bcd4;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}

.chat-tabs-header {
  background-color: rgb(249.4875, 250.275, 251.0625) !important;
}

.chat-user {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.chat-user.chat-user-center {
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}
.chat-user.chat-user-center .chat-avatar {
  margin-inline-start: auto;
}

.chat-user-item {
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  cursor: pointer;
  max-height: 96px;
}
.chat-user-item.active, .chat-user-item:hover {
  background-color: white;
}

.chat-user-row {
  margin: 0 -5px;
  -webkit-align-items: center;
  align-items: center;
}

.chat-info, .chat-contact-col {
  padding: 0 5px;
}
.chat-info p, .chat-contact-col p {
  margin-bottom: 0;
}
.chat-info .h4, .chat-contact-col .h4 {
  display: block;
  margin-bottom: 3px;
}

.chat-info-des {
  color: #6c757d;
  font-size: 13px;
}

.chat-date {
  padding: 0 5px;
  text-align: right;
}

.chat-box-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
}

.module-default {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
  padding: 15px;
}

.s-128 {
  font-size: 128px !important;
  width: 128px !important;
  height: 128px !important;
  line-height: 128px !important;
  margin-bottom: 12px;
}

.chat-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.chat-main-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%;
}

.chat-main-header-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-inline-end: auto;
}

.chat-contact-name {
  font-size: 20px;
  font-weight: 500;
}

.chat-main-footer {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  border-top: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%;
}
.chat-main-footer .form-group {
  margin-bottom: 0;
}

.todo-main-footer {
  padding: 6px 16px;
}

.chat-item {
  padding: 16px;
}
.chat-item .bubble {
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 20px 20px 20px 0px;
  position: relative;
  margin-inline-start: 16px;
  max-width: 600px;
  border: solid 1px #ced4da;
}
.chat-item.flex-row-reverse .bubble {
  margin-inline-end: 16px;
  margin-inline-start: 0;
  background-color: white;
  border-radius: 20px 20px 0 20px;
}

.chat-btn {
  font-size: 38px !important;
  margin-block: 0;
  margin-inline-end: 10px;
  margin-inline-start: -8px;
}

.chat-textarea {
  height: 40px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}

.last-message-time {
  font-size: 11px;
  color: #adb5bd;
}

@media screen and (max-width: 1399px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
  }
}
@media screen and (max-width: 1199px) {
  .chat-module {
    margin: -24px -29px -23px;
    padding-top: 0;
  }
  .chat-main-header {
    padding: 8px 24px;
  }
  .chat-main-header .size-60 {
    height: 50px !important;
    width: 50px !important;
    line-height: 50px;
  }
  .chat-main-header button {
    margin-bottom: 0;
  }
  .chat-main-header-info .chat-avatar-mode {
    max-width: 50px;
  }
  .chat-contact-name,
  .chat-sidenav-title {
    font-size: 16px;
  }
  .chat-main-footer {
    padding: 8px 16px;
  }
  .s-128 {
    font-size: 128px !important;
    width: 128px !important;
    height: 128px !important;
    line-height: 128px !important;
  }
}
@media screen and (max-width: 991px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 767px) {
  .chat-sidenav-title,
  .chat-contact-name {
    font-size: 15px;
  }
  .s-128 {
    font-size: 80px !important;
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
}
@media screen and (max-width: 575px) {
  .module-default h1 {
    font-size: 17px;
  }
  .s-128 {
    font-size: 40px !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }
}
/*Mails Module Styles*/
.module-box-row {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}

.module-box-column {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.mail-user-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}
.mail-user-info .avatar {
  margin-inline-end: 10px;
}
.mail-user-info .time, .mail-user-info button {
  margin-inline-start: auto;
}
.mail-user-info .badge {
  margin-bottom: 0;
}

.module-list-item.mail-cell {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.mail-detail {
  padding: 24px !important;
}

.mail-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}

.mail-header-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.mail-header-content .subject {
  margin-bottom: 5px;
}

.show-detail {
  cursor: pointer;
}

.text-truncate, .module-list-content .message p, .module-list-content .subject {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-list-content .message {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  color: rgb(144.7432432432, 155.5, 166.2567567568);
  font-size: 13px;
}
.module-list-content .message p {
  margin-bottom: 8px;
}

.size {
  margin: 5px 0;
}

.sender-name {
  margin-inline-end: 0;
  font-weight: 500;
  font-size: 15px;
}

.mail-header-actions {
  text-align: right;
  min-width: 100px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.mail-header-actions .icon-btn:not(:last-child) {
  margin-inline-end: 3px;
}

@media screen and (max-width: 991px) {
  .module-list-item.mail-cell {
    padding-inline-end: 20px;
  }
}
@media screen and (max-width: 576px) {
  .mail-list {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    border-inline-end: 0 none;
  }
  .mail-detail {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
  }
  .mail-detail .module-list-scroll {
    padding: 24px;
  }
}
@media screen and (max-width: 499px) {
  .mail-header {
    display: block;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .mail-header-actions {
    text-align: left;
    min-width: 10px;
  }
  .MuiDialog-paperWidthSm-99 {
    max-width: 250px !important;
  }
}
/*Contact Module Styles*/
.contact-item {
  -webkit-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
  padding: 8px 12px;
}

.contact-name {
  font-size: 15px;
}

.modal-box {
  position: relative;
}

.modal-w {
  max-width: 400px;
  min-width: 350px;
}
.modal-box-mail .modal-w {
  min-width: 600px;
}

.modal-box-header {
  color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.modal-box-header h2 {
  color: #fff;
  position: relative;
}
.modal-box-header h2 button {
  position: absolute;
  inset-inline-end: 0;
  top: -10px;
  z-index: 1;
  color: #fff;
}

.modal-box-content {
  padding: 24px;
}
.modal-box-content .avatar {
  margin: 0 auto;
}

.modal-box-footer {
  padding: 0 24px 24px;
}
.modal-box-footer .attach-file {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 15px;
}

.btn-fixed {
  position: fixed !important;
  inset-inline-end: 40px;
  bottom: 60px;
  z-index: 100;
}

.draggable-icon {
  cursor: all-scroll;
  color: #6c757d;
}
.draggable-icon:hover, .draggable-icon:focus, .draggable-icon:active {
  cursor: all-scroll;
  color: #212529;
}

.module-side-nav {
  padding: 20px 0;
}

@media screen and (max-width: 767px) {
  .modal-box-mail .modal-w {
    min-width: 500px;
  }
  .modal-box-header h2 {
    font-size: 18px;
  }
}
@media screen and (max-width: 575px) {
  .modal-w {
    min-width: 300px;
  }
  .modal-box-mail .modal-w {
    min-width: 400px;
  }
  .modal-box-header h2 {
    font-size: 16px;
  }
}
@media screen and (max-width: 419px) {
  .modal-w {
    min-width: 250px;
  }
  .modal-box-mail .modal-w {
    min-width: 250px;
  }
}
@media screen and (max-width: 399px) {
  .con-inf-mw-100 {
    min-width: 100% !important;
  }
}
/* Calendar Module Style */
.app-calendar .rbc-calendar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: calc(100vh - 160px);
}
.app-cul-calendar .rbc-calendar {
  min-height: calc(100vh - 200px);
}

.rbc-event {
  background-color: #99BBCD;
}

.rbc-event.rbc-selected {
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}

.rbc-slot-selection {
  background-color: rgba(153, 187, 205, 0.7);
}

.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  color: #fff;
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  background-color: rgba(153, 187, 205, 0.9);
  border-color: #99BBCD;
}

.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgba(153, 187, 205, 0.9);
  border-color: #99BBCD;
}

.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgba(153, 187, 205, 0.9);
  border-color: #99BBCD;
}

.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgba(153, 187, 205, 0.9);
  border-color: #99BBCD;
}

.rbc-month-row {
  min-height: 100px;
}

.rbc-event {
  min-height: 50px;
}

@media screen and (max-width: 867px) {
  .rbc-toolbar {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }
  .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0;
  }
}
@media screen and (max-height: 600px) {
  .app-calendar .rbc-calendar {
    min-height: 400px;
  }
  .app-cul-calendar .rbc-calendar {
    min-height: 400px;
  }
}
@media screen and (max-width: 467px) {
  .rbc-toolbar {
    font-size: 12px;
  }
  .rbc-toolbar button {
    padding: 5px 10px;
  }
}
/* Color Theme
   ========================================================================== */
/*Theme Indigo Styles*/
.indigo .right-arrow {
  color: #3f51b5;
}
.indigo .right-arrow:after {
  color: #3f51b5;
}

.indigo .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.indigo .btn-primary:focus, .indigo .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.indigo .btn-primary.disabled, .indigo .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.indigo .btn-primary:not(:disabled):not(.disabled):active, .indigo .btn-primary:not(:disabled):not(.disabled).active, .show > .indigo .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.indigo .btn-primary:not(:disabled):not(.disabled):active:focus, .indigo .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.indigo .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.indigo .btn-secondary:focus, .indigo .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.indigo .btn-secondary.disabled, .indigo .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.indigo .btn-secondary:not(:disabled):not(.disabled):active, .indigo .btn-secondary:not(:disabled):not(.disabled).active, .show > .indigo .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.indigo .btn-secondary:not(:disabled):not(.disabled):active:focus, .indigo .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.indigo .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.indigo .btn-success:focus, .indigo .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.indigo .btn-success.disabled, .indigo .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.indigo .btn-success:not(:disabled):not(.disabled):active, .indigo .btn-success:not(:disabled):not(.disabled).active, .show > .indigo .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.indigo .btn-success:not(:disabled):not(.disabled):active:focus, .indigo .btn-success:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.indigo .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.indigo .btn-info:focus, .indigo .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.indigo .btn-info.disabled, .indigo .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.indigo .btn-info:not(:disabled):not(.disabled):active, .indigo .btn-info:not(:disabled):not(.disabled).active, .show > .indigo .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.indigo .btn-info:not(:disabled):not(.disabled):active:focus, .indigo .btn-info:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.indigo .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.indigo .btn-warning:focus, .indigo .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.indigo .btn-warning.disabled, .indigo .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.indigo .btn-warning:not(:disabled):not(.disabled):active, .indigo .btn-warning:not(:disabled):not(.disabled).active, .show > .indigo .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.indigo .btn-warning:not(:disabled):not(.disabled):active:focus, .indigo .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.indigo .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.indigo .btn-danger:focus, .indigo .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.indigo .btn-danger.disabled, .indigo .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.indigo .btn-danger:not(:disabled):not(.disabled):active, .indigo .btn-danger:not(:disabled):not(.disabled).active, .show > .indigo .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.indigo .btn-danger:not(:disabled):not(.disabled):active:focus, .indigo .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.indigo .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.indigo .btn-light:focus, .indigo .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.indigo .btn-light.disabled, .indigo .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.indigo .btn-light:not(:disabled):not(.disabled):active, .indigo .btn-light:not(:disabled):not(.disabled).active, .show > .indigo .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.indigo .btn-light:not(:disabled):not(.disabled):active:focus, .indigo .btn-light:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.indigo .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.indigo .btn-dark:focus, .indigo .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.indigo .btn-dark.disabled, .indigo .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.indigo .btn-dark:not(:disabled):not(.disabled):active, .indigo .btn-dark:not(:disabled):not(.disabled).active, .show > .indigo .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.indigo .btn-dark:not(:disabled):not(.disabled):active:focus, .indigo .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.indigo a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.indigo a.btn-primary:focus, .indigo a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.indigo a.btn-primary.disabled, .indigo a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.indigo a.btn-primary:not(:disabled):not(.disabled):active, .indigo a.btn-primary:not(:disabled):not(.disabled).active, .show > .indigo a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.indigo a.btn-primary:not(:disabled):not(.disabled):active:focus, .indigo a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.indigo a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.indigo a.btn-secondary:focus, .indigo a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.indigo a.btn-secondary.disabled, .indigo a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.indigo a.btn-secondary:not(:disabled):not(.disabled):active, .indigo a.btn-secondary:not(:disabled):not(.disabled).active, .show > .indigo a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.indigo a.btn-secondary:not(:disabled):not(.disabled):active:focus, .indigo a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.indigo a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.indigo a.btn-success:focus, .indigo a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.indigo a.btn-success.disabled, .indigo a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.indigo a.btn-success:not(:disabled):not(.disabled):active, .indigo a.btn-success:not(:disabled):not(.disabled).active, .show > .indigo a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.indigo a.btn-success:not(:disabled):not(.disabled):active:focus, .indigo a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.indigo a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.indigo a.btn-info:focus, .indigo a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.indigo a.btn-info.disabled, .indigo a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.indigo a.btn-info:not(:disabled):not(.disabled):active, .indigo a.btn-info:not(:disabled):not(.disabled).active, .show > .indigo a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.indigo a.btn-info:not(:disabled):not(.disabled):active:focus, .indigo a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.indigo a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.indigo a.btn-warning:focus, .indigo a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.indigo a.btn-warning.disabled, .indigo a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.indigo a.btn-warning:not(:disabled):not(.disabled):active, .indigo a.btn-warning:not(:disabled):not(.disabled).active, .show > .indigo a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.indigo a.btn-warning:not(:disabled):not(.disabled):active:focus, .indigo a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.indigo a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.indigo a.btn-danger:focus, .indigo a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.indigo a.btn-danger.disabled, .indigo a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.indigo a.btn-danger:not(:disabled):not(.disabled):active, .indigo a.btn-danger:not(:disabled):not(.disabled).active, .show > .indigo a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.indigo a.btn-danger:not(:disabled):not(.disabled):active:focus, .indigo a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.indigo a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.indigo a.btn-light:focus, .indigo a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.indigo a.btn-light.disabled, .indigo a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.indigo a.btn-light:not(:disabled):not(.disabled):active, .indigo a.btn-light:not(:disabled):not(.disabled).active, .show > .indigo a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.indigo a.btn-light:not(:disabled):not(.disabled):active:focus, .indigo a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.indigo a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.indigo a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.indigo a.btn-dark:focus, .indigo a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.indigo a.btn-dark.disabled, .indigo a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.indigo a.btn-dark:not(:disabled):not(.disabled):active, .indigo a.btn-dark:not(:disabled):not(.disabled).active, .show > .indigo a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.indigo a.btn-dark:not(:disabled):not(.disabled):active:focus, .indigo a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.indigo .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.indigo .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.indigo .btn-outline-primary:focus, .indigo .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.indigo .btn-outline-primary.disabled, .indigo .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.indigo .btn-outline-primary:not(:disabled):not(.disabled):active, .indigo .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.indigo .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.indigo .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.indigo .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.indigo .btn-outline-secondary:focus, .indigo .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.indigo .btn-outline-secondary.disabled, .indigo .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.indigo .btn-outline-secondary:not(:disabled):not(.disabled):active, .indigo .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.indigo .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.indigo .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.indigo .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.indigo .btn-outline-success:focus, .indigo .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.indigo .btn-outline-success.disabled, .indigo .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.indigo .btn-outline-success:not(:disabled):not(.disabled):active, .indigo .btn-outline-success:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.indigo .btn-outline-success:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.indigo .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.indigo .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.indigo .btn-outline-info:focus, .indigo .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.indigo .btn-outline-info.disabled, .indigo .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.indigo .btn-outline-info:not(:disabled):not(.disabled):active, .indigo .btn-outline-info:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.indigo .btn-outline-info:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.indigo .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.indigo .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.indigo .btn-outline-warning:focus, .indigo .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.indigo .btn-outline-warning.disabled, .indigo .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.indigo .btn-outline-warning:not(:disabled):not(.disabled):active, .indigo .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.indigo .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.indigo .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.indigo .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.indigo .btn-outline-danger:focus, .indigo .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.indigo .btn-outline-danger.disabled, .indigo .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.indigo .btn-outline-danger:not(:disabled):not(.disabled):active, .indigo .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.indigo .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.indigo .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.indigo .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.indigo .btn-outline-light:focus, .indigo .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.indigo .btn-outline-light.disabled, .indigo .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.indigo .btn-outline-light:not(:disabled):not(.disabled):active, .indigo .btn-outline-light:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.indigo .btn-outline-light:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.indigo .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.indigo .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.indigo .btn-outline-dark:focus, .indigo .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.indigo .btn-outline-dark.disabled, .indigo .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.indigo .btn-outline-dark:not(:disabled):not(.disabled):active, .indigo .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.indigo .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .indigo .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .indigo .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.indigo a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.indigo a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.indigo a.btn-outline-primary:focus, .indigo a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.indigo a.btn-outline-primary.disabled, .indigo a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.indigo a.btn-outline-primary:not(:disabled):not(.disabled):active, .indigo a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.indigo a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.indigo a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.indigo a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.indigo a.btn-outline-secondary:focus, .indigo a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.indigo a.btn-outline-secondary.disabled, .indigo a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active, .indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.indigo a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.indigo a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.indigo a.btn-outline-success:focus, .indigo a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.indigo a.btn-outline-success.disabled, .indigo a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.indigo a.btn-outline-success:not(:disabled):not(.disabled):active, .indigo a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.indigo a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.indigo a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.indigo a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.indigo a.btn-outline-info:focus, .indigo a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.indigo a.btn-outline-info.disabled, .indigo a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.indigo a.btn-outline-info:not(:disabled):not(.disabled):active, .indigo a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.indigo a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.indigo a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.indigo a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.indigo a.btn-outline-warning:focus, .indigo a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.indigo a.btn-outline-warning.disabled, .indigo a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.indigo a.btn-outline-warning:not(:disabled):not(.disabled):active, .indigo a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.indigo a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.indigo a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.indigo a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.indigo a.btn-outline-danger:focus, .indigo a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.indigo a.btn-outline-danger.disabled, .indigo a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.indigo a.btn-outline-danger:not(:disabled):not(.disabled):active, .indigo a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.indigo a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.indigo a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.indigo a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.indigo a.btn-outline-light:focus, .indigo a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.indigo a.btn-outline-light.disabled, .indigo a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.indigo a.btn-outline-light:not(:disabled):not(.disabled):active, .indigo a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.indigo a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.indigo a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.indigo a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.indigo a.btn-outline-dark:focus, .indigo a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.indigo a.btn-outline-dark.disabled, .indigo a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.indigo a.btn-outline-dark:not(:disabled):not(.disabled):active, .indigo a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .indigo a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.indigo a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .indigo a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .indigo a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.indigo .btn-outline-primary,
.indigo a.btn-outline-primary {
  color: #3f51b5;
  border-color: #3f51b5;
}
.indigo .btn-outline-primary:focus, .indigo .btn-outline-primary:hover, .indigo .btn-outline-primary.disabled, .indigo .btn-outline-primary:disabled, .indigo .btn-outline-primary:not(:disabled):not(.disabled):active, .indigo .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-primary.dropdown-toggle,
.indigo a.btn-outline-primary:focus,
.indigo a.btn-outline-primary:hover,
.indigo a.btn-outline-primary.disabled,
.indigo a.btn-outline-primary:disabled,
.indigo a.btn-outline-primary:not(:disabled):not(.disabled):active,
.indigo a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .indigo a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #3f51b5;
  background-color: #3f51b5;
}

.indigo .btn-outline-secondary,
.indigo a.btn-outline-secondary {
  color: #FF4081;
  border-color: #FF4081;
}
.indigo .btn-outline-secondary:focus, .indigo .btn-outline-secondary:hover, .indigo .btn-outline-secondary.disabled, .indigo .btn-outline-secondary:disabled, .indigo .btn-outline-secondary:not(:disabled):not(.disabled):active, .indigo .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .indigo .btn-outline-secondary.dropdown-toggle,
.indigo a.btn-outline-secondary:focus,
.indigo a.btn-outline-secondary:hover,
.indigo a.btn-outline-secondary.disabled,
.indigo a.btn-outline-secondary:disabled,
.indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .indigo a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF4081;
  background-color: #FF4081;
}

.indigo a, .indigo a.text-primary {
  color: #3f51b5;
}
.indigo a:focus, .indigo a:hover, .indigo a.text-primary:focus, .indigo a.text-primary:hover {
  color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}
.indigo .text-primary {
  color: #3f51b5 !important;
}
.indigo .page-link {
  color: #3f51b5;
}
.indigo .page-link:focus, .indigo .page-link:hover {
  color: #3f51b5;
}
.indigo .bg-primary, .indigo .badge-primary {
  background-color: #3f51b5 !important;
  color: #fff !important;
}
.indigo .btn-primary, .indigo .jr-btn-primary, .indigo a.btn-primary, .indigo a.jr-btn-primary {
  background-color: #3f51b5;
  border-color: #3f51b5;
  color: #fff;
}
.indigo .btn-primary:hover, .indigo .btn-primary:focus, .indigo .btn-primary:not([disabled]):not(.disabled):active, .indigo .jr-btn-primary:hover, .indigo .jr-btn-primary:focus, .indigo .jr-btn-primary:not([disabled]):not(.disabled):active, .indigo a.btn-primary:hover, .indigo a.btn-primary:focus, .indigo a.btn-primary:not([disabled]):not(.disabled):active, .indigo a.jr-btn-primary:hover, .indigo a.jr-btn-primary:focus, .indigo a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(56.4159836066, 72.5348360656, 162.0840163934) !important;
  border-color: rgb(56.4159836066, 72.5348360656, 162.0840163934) !important;
  color: #fff !important;
}
.indigo .bg-primary.lighten-4 {
  background-color: #c5cae9 !important;
}
.indigo .bg-primary.lighten-3 {
  background-color: #9fa8da !important;
}
.indigo .bg-primary.lighten-2 {
  background-color: #7986cb !important;
}
.indigo .bg-primary.lighten-1 {
  background-color: #5c6bc0 !important;
}
.indigo .bg-primary.darken-1 {
  background-color: #3949ab !important;
}
.indigo .bg-primary.darken-2 {
  background-color: #303f9f !important;
}
.indigo .bg-primary.darken-3 {
  background-color: #283593 !important;
}
.indigo .bg-primary.darken-4 {
  background-color: #1a237e !important;
}
.indigo .bg-primary.accent-1 {
  background-color: #8c9eff !important;
}
.indigo .bg-primary.accent-2 {
  background-color: #536dfe !important;
}
.indigo .bg-primary.accent-3 {
  background-color: #3d5afe !important;
}
.indigo .bg-primary.accent-4 {
  background-color: #304ffe !important;
}

.indigo a.text-secondary {
  color: #FF4081;
}
.indigo a.text-secondary:focus, .indigo a.text-secondary:hover {
  color: rgb(255, 13, 95.3560209424) !important;
}
.indigo .text-secondary {
  color: #FF4081 !important;
}
.indigo .bg-secondary, .indigo .badge-secondary {
  background-color: #FF4081 !important;
  color: #fff !important;
}
.indigo .btn-secondary {
  background-color: #FF4081;
  border-color: #FF4081;
  color: #fff;
}
.indigo .btn-secondary:hover, .indigo .btn-secondary:focus, .indigo .btn-secondary:active {
  background-color: rgb(255, 38.5, 112.1780104712) !important;
  border-color: rgb(255, 38.5, 112.1780104712) !important;
  color: #fff !important;
}

.indigo .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.indigo .jr-flat-btn:hover, .indigo .jr-flat-btn:focus, .indigo .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.indigo .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #3f51b5 !important;
  border-color: transparent !important;
}
.indigo .jr-flat-btn.jr-btn-primary:hover, .indigo .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(63, 81, 181, 0.12) !important;
  color: #3f51b5 !important;
}

.indigo .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.indigo .bg-primary .jr-flat-btn.jr-btn-primary:hover, .indigo .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.indigo .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF4081 !important;
  border-color: transparent !important;
}
.indigo .jr-flat-btn.jr-btn-secondary:hover, .indigo .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 64, 129, 0.12) !important;
  color: #FF4081 !important;
}

.indigo .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .indigo .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.indigo .color-theme-header {
  background-color: #3f51b5;
}

.indigo .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
}
.indigo .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.indigo .side-nav .user-profile .text-white {
  color: #3f51b5 !important;
}
.indigo .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.indigo .side-nav .user-detail .user-name {
  color: #3f51b5;
}

.indigo ul.nav-menu li a {
  color: #868e96;
}

.indigo ul.nav-menu .nav-header {
  color: #868e96;
}

.indigo ul.nav-menu > li.open > a,
.indigo ul.nav-menu > li > a:hover,
.indigo ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #3f51b5;
}

.indigo ul.nav-menu li.menu > a:focus:before,
.indigo ul.nav-menu li.menu > a:hover:before {
  color: #3f51b5;
}

.indigo ul.nav-menu li ul {
  background-color: #fff;
}

.indigo ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.indigo ul.nav-menu li.menu.open > a:before,
.indigo ul.nav-menu li.menu > a:focus:before,
.indigo ul.nav-menu li.menu li > a:hover:before {
  color: #3f51b5;
}

.indigo ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.indigo ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #3f51b5;
}

.indigo ul.nav-menu li.menu .sub-menu li > a:hover,
.indigo ul.nav-menu li.menu .sub-menu li > a:focus,
.indigo ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.indigo ul.nav-menu li.menu .sub-menu li > a:focus:before,
.indigo ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #3f51b5;
}

/*Header top Navbar Styles*/
.indigo .navbar-nav li:hover > a, .indigo .navbar-nav li:focus > a {
  color: #3f51b5;
}
.indigo .navbar-nav li a {
  color: #333;
}
.indigo .navbar-nav li a:hover, .indigo .navbar-nav li a:focus {
  color: #3f51b5;
}
.indigo .navbar-nav li.nav-item.active > a {
  color: #3f51b5;
}
.indigo .navbar-nav ul.sub-menu li a.active, .indigo .navbar-nav ul.sub-menu li.active > a {
  color: #3f51b5;
}
.indigo .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.indigo .navbar-nav .nav-arrow a:hover:before, .indigo .navbar-nav .nav-arrow a:focus:before {
  color: #3f51b5;
}
.indigo .navbar-nav .nav-arrow:hover > a:before, .indigo .navbar-nav .nav-arrow:focus > a:before, .indigo .navbar-nav .nav-arrow.active > a:before {
  color: #3f51b5;
}

.indigo .app-top-nav {
  background-color: #3f51b5;
}
.indigo .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.indigo .app-top-nav .navbar-nav li.nav-item:hover > a, .indigo .app-top-nav .navbar-nav li.nav-item:focus > a, .indigo .app-top-nav .navbar-nav li.nav-item > a:hover, .indigo .app-top-nav .navbar-nav li.nav-item > a:focus, .indigo .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF4081;
}

.indigo .module-nav li a.active {
  border-color: #3f51b5;
}

.indigo .rbc-event {
  background-color: #3f51b5;
}

.indigo .rbc-event.rbc-selected {
  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}

.indigo .rbc-slot-selection {
  background-color: rgba(63, 81, 181, 0.7);
}

.indigo .rbc-toolbar button:active,
.indigo .rbc-toolbar button.rbc-active {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.indigo .rbc-toolbar button:active:hover,
.indigo .rbc-toolbar button.rbc-active:hover,
.indigo .rbc-toolbar button:active:focus,
.indigo .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.indigo .rbc-toolbar button:focus {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.indigo .rbc-toolbar button:hover {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.indigo .rbc-day-slot .rbc-event {
  border-color: #3f51b5;
}

.indigo .chat-sidenav-title {
  color: #3f51b5;
}

.indigo .chat-user-item.active, .indigo .chat-user-item:hover {
  background-color: rgb(227.9241803279, 230.6168032787, 245.5758196721);
}

.indigo .contact-list i {
  color: #3f51b5;
}

.indigo .Collapsible__trigger {
  background: #3f51b5;
}

.indigo .categories-list li a:focus, .indigo .categories-list li a:hover, .indigo .categories-list li.active a {
  color: #3f51b5;
}

.indigo .login-content .form-control:focus {
  border-color: #3f51b5;
}

.indigo .filter-with-bg-color ul li a {
  border-color: #3f51b5;
}
.indigo .filter-with-bg-color ul li a:hover, .indigo .filter-with-bg-color ul li a:focus, .indigo .filter-with-bg-color ul li a.active {
  background-color: #3f51b5;
}

.indigo .profile-intro .icon {
  color: #3f51b5;
}

.indigo .social-link li.active a, .indigo .social-link li a:hover, .indigo .social-link li a:focus {
  color: #FF4081;
}

.indigo .actions {
  color: #FF4081;
}

.indigo .table-hover tbody tr:hover {
  background-color: rgba(63, 81, 181, 0.075);
}

.indigo .border-primary {
  border-color: #3f51b5 !important;
}

.indigo .app-logo-content {
  background-color: #3f51b5;
}

.indigo .app-social-block .social-link button {
  border: solid 1px #3f51b5;
  color: #3f51b5;
}
.indigo .app-social-block .social-link button:hover, .indigo .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #3f51b5;
}

.indigo .btn-group > .jr-btn.active,
.indigo .btn-group > .btn-default.active,
.indigo .btn-group-vertical > .jr-btn.active,
.indigo .btn-group-vertical > .btn-default.active {
  background-color: #3f51b5;
  border-color: #3f51b5;
}
.indigo .btn-group > .jr-flat-btn,
.indigo .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.indigo .btn-group > .jr-flat-btn.active,
.indigo .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #3f51b5 !important;
  border-color: transparent !important;
}
.indigo .btn-group > .jr-flat-btn.active:hover, .indigo .btn-group > .jr-flat-btn.active:focus,
.indigo .btn-group-vertical > .jr-flat-btn.active:hover,
.indigo .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(63, 81, 181, 0.12) !important;
  color: #3f51b5 !important;
}

.indigo .nav-pill-sales .nav-link.active {
  background-color: #3f51b5;
  border-color: #3f51b5;
}

.indigo .form-checkbox > input + .check,
.indigo .form-checkbox > input.sm + .check {
  color: #3f51b5;
}

/*Theme Cyan Styles*/
.cyan .right-arrow {
  color: #00bcd4;
}
.cyan .right-arrow:after {
  color: #00bcd4;
}

.cyan .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.cyan .btn-primary:focus, .cyan .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.cyan .btn-primary.disabled, .cyan .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.cyan .btn-primary:not(:disabled):not(.disabled):active, .cyan .btn-primary:not(:disabled):not(.disabled).active, .show > .cyan .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.cyan .btn-primary:not(:disabled):not(.disabled):active:focus, .cyan .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.cyan .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.cyan .btn-secondary:focus, .cyan .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.cyan .btn-secondary.disabled, .cyan .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.cyan .btn-secondary:not(:disabled):not(.disabled):active, .cyan .btn-secondary:not(:disabled):not(.disabled).active, .show > .cyan .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.cyan .btn-secondary:not(:disabled):not(.disabled):active:focus, .cyan .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.cyan .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.cyan .btn-success:focus, .cyan .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.cyan .btn-success.disabled, .cyan .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.cyan .btn-success:not(:disabled):not(.disabled):active, .cyan .btn-success:not(:disabled):not(.disabled).active, .show > .cyan .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.cyan .btn-success:not(:disabled):not(.disabled):active:focus, .cyan .btn-success:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.cyan .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.cyan .btn-info:focus, .cyan .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.cyan .btn-info.disabled, .cyan .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan .btn-info:not(:disabled):not(.disabled):active, .cyan .btn-info:not(:disabled):not(.disabled).active, .show > .cyan .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.cyan .btn-info:not(:disabled):not(.disabled):active:focus, .cyan .btn-info:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.cyan .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.cyan .btn-warning:focus, .cyan .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.cyan .btn-warning.disabled, .cyan .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.cyan .btn-warning:not(:disabled):not(.disabled):active, .cyan .btn-warning:not(:disabled):not(.disabled).active, .show > .cyan .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.cyan .btn-warning:not(:disabled):not(.disabled):active:focus, .cyan .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.cyan .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.cyan .btn-danger:focus, .cyan .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.cyan .btn-danger.disabled, .cyan .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.cyan .btn-danger:not(:disabled):not(.disabled):active, .cyan .btn-danger:not(:disabled):not(.disabled).active, .show > .cyan .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.cyan .btn-danger:not(:disabled):not(.disabled):active:focus, .cyan .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.cyan .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.cyan .btn-light:focus, .cyan .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.cyan .btn-light.disabled, .cyan .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.cyan .btn-light:not(:disabled):not(.disabled):active, .cyan .btn-light:not(:disabled):not(.disabled).active, .show > .cyan .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.cyan .btn-light:not(:disabled):not(.disabled):active:focus, .cyan .btn-light:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.cyan .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.cyan .btn-dark:focus, .cyan .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.cyan .btn-dark.disabled, .cyan .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.cyan .btn-dark:not(:disabled):not(.disabled):active, .cyan .btn-dark:not(:disabled):not(.disabled).active, .show > .cyan .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.cyan .btn-dark:not(:disabled):not(.disabled):active:focus, .cyan .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.cyan a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.cyan a.btn-primary:focus, .cyan a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.cyan a.btn-primary.disabled, .cyan a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.cyan a.btn-primary:not(:disabled):not(.disabled):active, .cyan a.btn-primary:not(:disabled):not(.disabled).active, .show > .cyan a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.cyan a.btn-primary:not(:disabled):not(.disabled):active:focus, .cyan a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.cyan a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.cyan a.btn-secondary:focus, .cyan a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.cyan a.btn-secondary.disabled, .cyan a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.cyan a.btn-secondary:not(:disabled):not(.disabled):active, .cyan a.btn-secondary:not(:disabled):not(.disabled).active, .show > .cyan a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.cyan a.btn-secondary:not(:disabled):not(.disabled):active:focus, .cyan a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.cyan a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.cyan a.btn-success:focus, .cyan a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.cyan a.btn-success.disabled, .cyan a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.cyan a.btn-success:not(:disabled):not(.disabled):active, .cyan a.btn-success:not(:disabled):not(.disabled).active, .show > .cyan a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.cyan a.btn-success:not(:disabled):not(.disabled):active:focus, .cyan a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.cyan a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.cyan a.btn-info:focus, .cyan a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.cyan a.btn-info.disabled, .cyan a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan a.btn-info:not(:disabled):not(.disabled):active, .cyan a.btn-info:not(:disabled):not(.disabled).active, .show > .cyan a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.cyan a.btn-info:not(:disabled):not(.disabled):active:focus, .cyan a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.cyan a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.cyan a.btn-warning:focus, .cyan a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.cyan a.btn-warning.disabled, .cyan a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.cyan a.btn-warning:not(:disabled):not(.disabled):active, .cyan a.btn-warning:not(:disabled):not(.disabled).active, .show > .cyan a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.cyan a.btn-warning:not(:disabled):not(.disabled):active:focus, .cyan a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.cyan a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.cyan a.btn-danger:focus, .cyan a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.cyan a.btn-danger.disabled, .cyan a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.cyan a.btn-danger:not(:disabled):not(.disabled):active, .cyan a.btn-danger:not(:disabled):not(.disabled).active, .show > .cyan a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.cyan a.btn-danger:not(:disabled):not(.disabled):active:focus, .cyan a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.cyan a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.cyan a.btn-light:focus, .cyan a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.cyan a.btn-light.disabled, .cyan a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.cyan a.btn-light:not(:disabled):not(.disabled):active, .cyan a.btn-light:not(:disabled):not(.disabled).active, .show > .cyan a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.cyan a.btn-light:not(:disabled):not(.disabled):active:focus, .cyan a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.cyan a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.cyan a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.cyan a.btn-dark:focus, .cyan a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.cyan a.btn-dark.disabled, .cyan a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.cyan a.btn-dark:not(:disabled):not(.disabled):active, .cyan a.btn-dark:not(:disabled):not(.disabled).active, .show > .cyan a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.cyan a.btn-dark:not(:disabled):not(.disabled):active:focus, .cyan a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.cyan .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.cyan .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.cyan .btn-outline-primary:focus, .cyan .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.cyan .btn-outline-primary.disabled, .cyan .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.cyan .btn-outline-primary:not(:disabled):not(.disabled):active, .cyan .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.cyan .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.cyan .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.cyan .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.cyan .btn-outline-secondary:focus, .cyan .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.cyan .btn-outline-secondary.disabled, .cyan .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.cyan .btn-outline-secondary:not(:disabled):not(.disabled):active, .cyan .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.cyan .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.cyan .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.cyan .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.cyan .btn-outline-success:focus, .cyan .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.cyan .btn-outline-success.disabled, .cyan .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.cyan .btn-outline-success:not(:disabled):not(.disabled):active, .cyan .btn-outline-success:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.cyan .btn-outline-success:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.cyan .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.cyan .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan .btn-outline-info:focus, .cyan .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.cyan .btn-outline-info.disabled, .cyan .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.cyan .btn-outline-info:not(:disabled):not(.disabled):active, .cyan .btn-outline-info:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan .btn-outline-info:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.cyan .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.cyan .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.cyan .btn-outline-warning:focus, .cyan .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.cyan .btn-outline-warning.disabled, .cyan .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.cyan .btn-outline-warning:not(:disabled):not(.disabled):active, .cyan .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.cyan .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.cyan .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.cyan .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.cyan .btn-outline-danger:focus, .cyan .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.cyan .btn-outline-danger.disabled, .cyan .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.cyan .btn-outline-danger:not(:disabled):not(.disabled):active, .cyan .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.cyan .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.cyan .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.cyan .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.cyan .btn-outline-light:focus, .cyan .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.cyan .btn-outline-light.disabled, .cyan .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.cyan .btn-outline-light:not(:disabled):not(.disabled):active, .cyan .btn-outline-light:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.cyan .btn-outline-light:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.cyan .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.cyan .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.cyan .btn-outline-dark:focus, .cyan .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.cyan .btn-outline-dark.disabled, .cyan .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.cyan .btn-outline-dark:not(:disabled):not(.disabled):active, .cyan .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.cyan .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .cyan .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .cyan .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.cyan a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.cyan a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.cyan a.btn-outline-primary:focus, .cyan a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.cyan a.btn-outline-primary.disabled, .cyan a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.cyan a.btn-outline-primary:not(:disabled):not(.disabled):active, .cyan a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.cyan a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.cyan a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.cyan a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.cyan a.btn-outline-secondary:focus, .cyan a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.cyan a.btn-outline-secondary.disabled, .cyan a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active, .cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.cyan a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.cyan a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.cyan a.btn-outline-success:focus, .cyan a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.cyan a.btn-outline-success.disabled, .cyan a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.cyan a.btn-outline-success:not(:disabled):not(.disabled):active, .cyan a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.cyan a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.cyan a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.cyan a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan a.btn-outline-info:focus, .cyan a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.cyan a.btn-outline-info.disabled, .cyan a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.cyan a.btn-outline-info:not(:disabled):not(.disabled):active, .cyan a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.cyan a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.cyan a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.cyan a.btn-outline-warning:focus, .cyan a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.cyan a.btn-outline-warning.disabled, .cyan a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.cyan a.btn-outline-warning:not(:disabled):not(.disabled):active, .cyan a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.cyan a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.cyan a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.cyan a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.cyan a.btn-outline-danger:focus, .cyan a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.cyan a.btn-outline-danger.disabled, .cyan a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.cyan a.btn-outline-danger:not(:disabled):not(.disabled):active, .cyan a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.cyan a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.cyan a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.cyan a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.cyan a.btn-outline-light:focus, .cyan a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.cyan a.btn-outline-light.disabled, .cyan a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.cyan a.btn-outline-light:not(:disabled):not(.disabled):active, .cyan a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.cyan a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.cyan a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.cyan a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.cyan a.btn-outline-dark:focus, .cyan a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.cyan a.btn-outline-dark.disabled, .cyan a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.cyan a.btn-outline-dark:not(:disabled):not(.disabled):active, .cyan a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .cyan a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.cyan a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .cyan a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .cyan a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.cyan .btn-outline-primary,
.cyan a.btn-outline-primary {
  color: #00bcd4;
  border-color: #00bcd4;
}
.cyan .btn-outline-primary:focus, .cyan .btn-outline-primary:hover, .cyan .btn-outline-primary.disabled, .cyan .btn-outline-primary:disabled, .cyan .btn-outline-primary:not(:disabled):not(.disabled):active, .cyan .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-primary.dropdown-toggle,
.cyan a.btn-outline-primary:focus,
.cyan a.btn-outline-primary:hover,
.cyan a.btn-outline-primary.disabled,
.cyan a.btn-outline-primary:disabled,
.cyan a.btn-outline-primary:not(:disabled):not(.disabled):active,
.cyan a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .cyan a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #00bcd4;
  background-color: #00bcd4;
}

.cyan .btn-outline-secondary,
.cyan a.btn-outline-secondary {
  color: #69F0AE;
  border-color: #69F0AE;
}
.cyan .btn-outline-secondary:focus, .cyan .btn-outline-secondary:hover, .cyan .btn-outline-secondary.disabled, .cyan .btn-outline-secondary:disabled, .cyan .btn-outline-secondary:not(:disabled):not(.disabled):active, .cyan .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .cyan .btn-outline-secondary.dropdown-toggle,
.cyan a.btn-outline-secondary:focus,
.cyan a.btn-outline-secondary:hover,
.cyan a.btn-outline-secondary.disabled,
.cyan a.btn-outline-secondary:disabled,
.cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .cyan a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #69F0AE;
  background-color: #69F0AE;
}

.cyan a, .cyan a.text-primary {
  color: #00bcd4;
}
.cyan a:focus, .cyan a:hover, .cyan a.text-primary:focus, .cyan a.text-primary:hover {
  color: rgb(0, 142.7735849057, 161);
}
.cyan .text-primary {
  color: #00bcd4 !important;
}
.cyan .page-link {
  color: #00bcd4;
}
.cyan .page-link:focus, .cyan .page-link:hover {
  color: #00bcd4;
}
.cyan .bg-primary, .cyan .badge-primary {
  background-color: #00bcd4 !important;
  color: #fff !important;
}
.cyan .btn-primary, .cyan .jr-btn-primary, .cyan a.btn-primary, .cyan a.jr-btn-primary {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
}
.cyan .btn-primary:hover, .cyan .btn-primary:focus, .cyan .btn-primary:not([disabled]):not(.disabled):active, .cyan .jr-btn-primary:hover, .cyan .jr-btn-primary:focus, .cyan .jr-btn-primary:not([disabled]):not(.disabled):active, .cyan a.btn-primary:hover, .cyan a.btn-primary:focus, .cyan a.btn-primary:not([disabled]):not(.disabled):active, .cyan a.jr-btn-primary:hover, .cyan a.jr-btn-primary:focus, .cyan a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(0, 165.3867924528, 186.5) !important;
  border-color: rgb(0, 165.3867924528, 186.5) !important;
  color: #fff !important;
}
.cyan .bg-primary.lighten-4 {
  background-color: #b2ebf2 !important;
}
.cyan .bg-primary.lighten-3 {
  background-color: #80deea !important;
}
.cyan .bg-primary.lighten-2 {
  background-color: #4dd0e1 !important;
}
.cyan .bg-primary.lighten-1 {
  background-color: #26c6da !important;
}
.cyan .bg-primary.darken-1 {
  background-color: #00acc1 !important;
}
.cyan .bg-primary.darken-2 {
  background-color: #0097a7 !important;
}
.cyan .bg-primary.darken-3 {
  background-color: #00838f !important;
}
.cyan .bg-primary.darken-4 {
  background-color: #006064 !important;
}
.cyan .bg-primary.accent-1 {
  background-color: #84ffff !important;
}
.cyan .bg-primary.accent-2 {
  background-color: #18ffff !important;
}
.cyan .bg-primary.accent-3 {
  background-color: #00e5ff !important;
}
.cyan .bg-primary.accent-4 {
  background-color: #00b8d4 !important;
}

.cyan a.text-secondary {
  color: #69F0AE;
}
.cyan a.text-secondary:focus, .cyan a.text-secondary:hover {
  color: rgb(58.6363636364, 235.3636363636, 148.9636363636) !important;
}
.cyan .text-secondary {
  color: #69F0AE !important;
}
.cyan .bg-secondary, .cyan .badge-secondary {
  background-color: #69F0AE !important;
  color: #fff !important;
}
.cyan .btn-secondary {
  background-color: #69F0AE;
  border-color: #69F0AE;
  color: #fff;
}
.cyan .btn-secondary:hover, .cyan .btn-secondary:focus, .cyan .btn-secondary:active {
  background-color: rgb(81.8181818182, 237.6818181818, 161.4818181818) !important;
  border-color: rgb(81.8181818182, 237.6818181818, 161.4818181818) !important;
  color: #fff !important;
}

.cyan .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.cyan .jr-flat-btn:hover, .cyan .jr-flat-btn:focus, .cyan .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.cyan .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #00bcd4 !important;
  border-color: transparent !important;
}
.cyan .jr-flat-btn.jr-btn-primary:hover, .cyan .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(0, 188, 212, 0.12) !important;
  color: #00bcd4 !important;
}

.cyan .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.cyan .bg-primary .jr-flat-btn.jr-btn-primary:hover, .cyan .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.cyan .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #69F0AE !important;
  border-color: transparent !important;
}
.cyan .jr-flat-btn.jr-btn-secondary:hover, .cyan .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(105, 240, 174, 0.12) !important;
  color: #69F0AE !important;
}

.cyan .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .cyan .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.cyan .color-theme-header {
  background-color: #00bcd4;
}

.cyan .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
}
.cyan .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.cyan .side-nav .user-profile .text-white {
  color: #00bcd4 !important;
}
.cyan .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.cyan .side-nav .user-detail .user-name {
  color: #00bcd4;
}

.cyan ul.nav-menu li a {
  color: #868e96;
}

.cyan ul.nav-menu .nav-header {
  color: #868e96;
}

.cyan ul.nav-menu > li.open > a,
.cyan ul.nav-menu > li > a:hover,
.cyan ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #00bcd4;
}

.cyan ul.nav-menu li.menu > a:focus:before,
.cyan ul.nav-menu li.menu > a:hover:before {
  color: #00bcd4;
}

.cyan ul.nav-menu li ul {
  background-color: #fff;
}

.cyan ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.cyan ul.nav-menu li.menu.open > a:before,
.cyan ul.nav-menu li.menu > a:focus:before,
.cyan ul.nav-menu li.menu li > a:hover:before {
  color: #00bcd4;
}

.cyan ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.cyan ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #00bcd4;
}

.cyan ul.nav-menu li.menu .sub-menu li > a:hover,
.cyan ul.nav-menu li.menu .sub-menu li > a:focus,
.cyan ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.cyan ul.nav-menu li.menu .sub-menu li > a:focus:before,
.cyan ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #00bcd4;
}

/*Header top Navbar Styles*/
.cyan .navbar-nav li:hover > a, .cyan .navbar-nav li:focus > a {
  color: #00bcd4;
}
.cyan .navbar-nav li a {
  color: #333;
}
.cyan .navbar-nav li a:hover, .cyan .navbar-nav li a:focus {
  color: #00bcd4;
}
.cyan .navbar-nav li.nav-item.active > a {
  color: #00bcd4;
}
.cyan .navbar-nav ul.sub-menu li a.active, .cyan .navbar-nav ul.sub-menu li.active > a {
  color: #00bcd4;
}
.cyan .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.cyan .navbar-nav .nav-arrow a:hover:before, .cyan .navbar-nav .nav-arrow a:focus:before {
  color: #00bcd4;
}
.cyan .navbar-nav .nav-arrow:hover > a:before, .cyan .navbar-nav .nav-arrow:focus > a:before, .cyan .navbar-nav .nav-arrow.active > a:before {
  color: #00bcd4;
}

.cyan .app-top-nav {
  background-color: #00bcd4;
}
.cyan .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.cyan .app-top-nav .navbar-nav li.nav-item:hover > a, .cyan .app-top-nav .navbar-nav li.nav-item:focus > a, .cyan .app-top-nav .navbar-nav li.nav-item > a:hover, .cyan .app-top-nav .navbar-nav li.nav-item > a:focus, .cyan .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #69F0AE;
}

.cyan .module-nav li a.active {
  border-color: #00bcd4;
}

.cyan .rbc-event {
  background-color: #00bcd4;
}

.cyan .rbc-event.rbc-selected {
  background-color: rgb(0, 142.7735849057, 161);
}

.cyan .rbc-slot-selection {
  background-color: rgba(0, 188, 212, 0.7);
}

.cyan .rbc-toolbar button:active,
.cyan .rbc-toolbar button.rbc-active {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.cyan .rbc-toolbar button:active:hover,
.cyan .rbc-toolbar button.rbc-active:hover,
.cyan .rbc-toolbar button:active:focus,
.cyan .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.cyan .rbc-toolbar button:focus {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.cyan .rbc-toolbar button:hover {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.cyan .rbc-day-slot .rbc-event {
  border-color: #00bcd4;
}

.cyan .chat-sidenav-title {
  color: #00bcd4;
}

.cyan .chat-user-item.active, .cyan .chat-user-item:hover {
  background-color: rgb(186.5, 247.2452830189, 255);
}

.cyan .contact-list i {
  color: #00bcd4;
}

.cyan .Collapsible__trigger {
  background: #00bcd4;
}

.cyan .categories-list li a:focus, .cyan .categories-list li a:hover, .cyan .categories-list li.active a {
  color: #00bcd4;
}

.cyan .login-content .form-control:focus {
  border-color: #00bcd4;
}

.cyan .filter-with-bg-color ul li a {
  border-color: #00bcd4;
}
.cyan .filter-with-bg-color ul li a:hover, .cyan .filter-with-bg-color ul li a:focus, .cyan .filter-with-bg-color ul li a.active {
  background-color: #00bcd4;
}

.cyan .profile-intro .icon {
  color: #00bcd4;
}

.cyan .social-link li.active a, .cyan .social-link li a:hover, .cyan .social-link li a:focus {
  color: #69F0AE;
}

.cyan .actions {
  color: #69F0AE;
}

.cyan .table-hover tbody tr:hover {
  background-color: rgba(0, 188, 212, 0.075);
}

.cyan .border-primary {
  border-color: #00bcd4 !important;
}

.cyan .app-logo-content {
  background-color: #00bcd4;
}

.cyan .app-social-block .social-link button {
  border: solid 1px #00bcd4;
  color: #00bcd4;
}
.cyan .app-social-block .social-link button:hover, .cyan .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #00bcd4;
}

.cyan .btn-group > .jr-btn.active,
.cyan .btn-group > .btn-default.active,
.cyan .btn-group-vertical > .jr-btn.active,
.cyan .btn-group-vertical > .btn-default.active {
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.cyan .btn-group > .jr-flat-btn,
.cyan .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.cyan .btn-group > .jr-flat-btn.active,
.cyan .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #00bcd4 !important;
  border-color: transparent !important;
}
.cyan .btn-group > .jr-flat-btn.active:hover, .cyan .btn-group > .jr-flat-btn.active:focus,
.cyan .btn-group-vertical > .jr-flat-btn.active:hover,
.cyan .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(0, 188, 212, 0.12) !important;
  color: #00bcd4 !important;
}

.cyan .nav-pill-sales .nav-link.active {
  background-color: #00bcd4;
  border-color: #00bcd4;
}

.cyan .form-checkbox > input + .check,
.cyan .form-checkbox > input.sm + .check {
  color: #00bcd4;
}

/*Theme Amber Styles*/
.amber ul.nav-menu li.open > a {
  border-color: #FFC107;
}

.amber .right-arrow {
  color: #FFC107;
}
.amber .right-arrow:after {
  color: #FFC107;
}

.amber .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.amber .btn-primary:focus, .amber .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.amber .btn-primary.disabled, .amber .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.amber .btn-primary:not(:disabled):not(.disabled):active, .amber .btn-primary:not(:disabled):not(.disabled).active, .show > .amber .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.amber .btn-primary:not(:disabled):not(.disabled):active:focus, .amber .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.amber .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.amber .btn-secondary:focus, .amber .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.amber .btn-secondary.disabled, .amber .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.amber .btn-secondary:not(:disabled):not(.disabled):active, .amber .btn-secondary:not(:disabled):not(.disabled).active, .show > .amber .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.amber .btn-secondary:not(:disabled):not(.disabled):active:focus, .amber .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.amber .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.amber .btn-success:focus, .amber .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.amber .btn-success.disabled, .amber .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.amber .btn-success:not(:disabled):not(.disabled):active, .amber .btn-success:not(:disabled):not(.disabled).active, .show > .amber .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.amber .btn-success:not(:disabled):not(.disabled):active:focus, .amber .btn-success:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.amber .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.amber .btn-info:focus, .amber .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.amber .btn-info.disabled, .amber .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.amber .btn-info:not(:disabled):not(.disabled):active, .amber .btn-info:not(:disabled):not(.disabled).active, .show > .amber .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.amber .btn-info:not(:disabled):not(.disabled):active:focus, .amber .btn-info:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.amber .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.amber .btn-warning:focus, .amber .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.amber .btn-warning.disabled, .amber .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.amber .btn-warning:not(:disabled):not(.disabled):active, .amber .btn-warning:not(:disabled):not(.disabled).active, .show > .amber .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.amber .btn-warning:not(:disabled):not(.disabled):active:focus, .amber .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.amber .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.amber .btn-danger:focus, .amber .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.amber .btn-danger.disabled, .amber .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.amber .btn-danger:not(:disabled):not(.disabled):active, .amber .btn-danger:not(:disabled):not(.disabled).active, .show > .amber .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.amber .btn-danger:not(:disabled):not(.disabled):active:focus, .amber .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.amber .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.amber .btn-light:focus, .amber .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.amber .btn-light.disabled, .amber .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.amber .btn-light:not(:disabled):not(.disabled):active, .amber .btn-light:not(:disabled):not(.disabled).active, .show > .amber .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.amber .btn-light:not(:disabled):not(.disabled):active:focus, .amber .btn-light:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.amber .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.amber .btn-dark:focus, .amber .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.amber .btn-dark.disabled, .amber .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.amber .btn-dark:not(:disabled):not(.disabled):active, .amber .btn-dark:not(:disabled):not(.disabled).active, .show > .amber .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.amber .btn-dark:not(:disabled):not(.disabled):active:focus, .amber .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.amber a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.amber a.btn-primary:focus, .amber a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.amber a.btn-primary.disabled, .amber a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.amber a.btn-primary:not(:disabled):not(.disabled):active, .amber a.btn-primary:not(:disabled):not(.disabled).active, .show > .amber a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.amber a.btn-primary:not(:disabled):not(.disabled):active:focus, .amber a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.amber a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.amber a.btn-secondary:focus, .amber a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.amber a.btn-secondary.disabled, .amber a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.amber a.btn-secondary:not(:disabled):not(.disabled):active, .amber a.btn-secondary:not(:disabled):not(.disabled).active, .show > .amber a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.amber a.btn-secondary:not(:disabled):not(.disabled):active:focus, .amber a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.amber a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.amber a.btn-success:focus, .amber a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.amber a.btn-success.disabled, .amber a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.amber a.btn-success:not(:disabled):not(.disabled):active, .amber a.btn-success:not(:disabled):not(.disabled).active, .show > .amber a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.amber a.btn-success:not(:disabled):not(.disabled):active:focus, .amber a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.amber a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.amber a.btn-info:focus, .amber a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.amber a.btn-info.disabled, .amber a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.amber a.btn-info:not(:disabled):not(.disabled):active, .amber a.btn-info:not(:disabled):not(.disabled).active, .show > .amber a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.amber a.btn-info:not(:disabled):not(.disabled):active:focus, .amber a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.amber a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.amber a.btn-warning:focus, .amber a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.amber a.btn-warning.disabled, .amber a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.amber a.btn-warning:not(:disabled):not(.disabled):active, .amber a.btn-warning:not(:disabled):not(.disabled).active, .show > .amber a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.amber a.btn-warning:not(:disabled):not(.disabled):active:focus, .amber a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.amber a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.amber a.btn-danger:focus, .amber a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.amber a.btn-danger.disabled, .amber a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.amber a.btn-danger:not(:disabled):not(.disabled):active, .amber a.btn-danger:not(:disabled):not(.disabled).active, .show > .amber a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.amber a.btn-danger:not(:disabled):not(.disabled):active:focus, .amber a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.amber a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.amber a.btn-light:focus, .amber a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.amber a.btn-light.disabled, .amber a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.amber a.btn-light:not(:disabled):not(.disabled):active, .amber a.btn-light:not(:disabled):not(.disabled).active, .show > .amber a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.amber a.btn-light:not(:disabled):not(.disabled):active:focus, .amber a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.amber a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.amber a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.amber a.btn-dark:focus, .amber a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.amber a.btn-dark.disabled, .amber a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.amber a.btn-dark:not(:disabled):not(.disabled):active, .amber a.btn-dark:not(:disabled):not(.disabled).active, .show > .amber a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.amber a.btn-dark:not(:disabled):not(.disabled):active:focus, .amber a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.amber .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.amber .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.amber .btn-outline-primary:focus, .amber .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.amber .btn-outline-primary.disabled, .amber .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.amber .btn-outline-primary:not(:disabled):not(.disabled):active, .amber .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.amber .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.amber .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.amber .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.amber .btn-outline-secondary:focus, .amber .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.amber .btn-outline-secondary.disabled, .amber .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.amber .btn-outline-secondary:not(:disabled):not(.disabled):active, .amber .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.amber .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.amber .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.amber .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.amber .btn-outline-success:focus, .amber .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.amber .btn-outline-success.disabled, .amber .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.amber .btn-outline-success:not(:disabled):not(.disabled):active, .amber .btn-outline-success:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.amber .btn-outline-success:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.amber .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.amber .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.amber .btn-outline-info:focus, .amber .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.amber .btn-outline-info.disabled, .amber .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.amber .btn-outline-info:not(:disabled):not(.disabled):active, .amber .btn-outline-info:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.amber .btn-outline-info:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.amber .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.amber .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.amber .btn-outline-warning:focus, .amber .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.amber .btn-outline-warning.disabled, .amber .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.amber .btn-outline-warning:not(:disabled):not(.disabled):active, .amber .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.amber .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.amber .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.amber .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.amber .btn-outline-danger:focus, .amber .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.amber .btn-outline-danger.disabled, .amber .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.amber .btn-outline-danger:not(:disabled):not(.disabled):active, .amber .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.amber .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.amber .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.amber .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.amber .btn-outline-light:focus, .amber .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.amber .btn-outline-light.disabled, .amber .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.amber .btn-outline-light:not(:disabled):not(.disabled):active, .amber .btn-outline-light:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.amber .btn-outline-light:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.amber .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.amber .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.amber .btn-outline-dark:focus, .amber .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.amber .btn-outline-dark.disabled, .amber .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.amber .btn-outline-dark:not(:disabled):not(.disabled):active, .amber .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.amber .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .amber .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .amber .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.amber a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.amber a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.amber a.btn-outline-primary:focus, .amber a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.amber a.btn-outline-primary.disabled, .amber a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.amber a.btn-outline-primary:not(:disabled):not(.disabled):active, .amber a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.amber a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.amber a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.amber a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.amber a.btn-outline-secondary:focus, .amber a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.amber a.btn-outline-secondary.disabled, .amber a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.amber a.btn-outline-secondary:not(:disabled):not(.disabled):active, .amber a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.amber a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.amber a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.amber a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.amber a.btn-outline-success:focus, .amber a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.amber a.btn-outline-success.disabled, .amber a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.amber a.btn-outline-success:not(:disabled):not(.disabled):active, .amber a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.amber a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.amber a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.amber a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.amber a.btn-outline-info:focus, .amber a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.amber a.btn-outline-info.disabled, .amber a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.amber a.btn-outline-info:not(:disabled):not(.disabled):active, .amber a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.amber a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.amber a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.amber a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.amber a.btn-outline-warning:focus, .amber a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.amber a.btn-outline-warning.disabled, .amber a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.amber a.btn-outline-warning:not(:disabled):not(.disabled):active, .amber a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.amber a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.amber a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.amber a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.amber a.btn-outline-danger:focus, .amber a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.amber a.btn-outline-danger.disabled, .amber a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.amber a.btn-outline-danger:not(:disabled):not(.disabled):active, .amber a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.amber a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.amber a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.amber a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.amber a.btn-outline-light:focus, .amber a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.amber a.btn-outline-light.disabled, .amber a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.amber a.btn-outline-light:not(:disabled):not(.disabled):active, .amber a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.amber a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.amber a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.amber a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.amber a.btn-outline-dark:focus, .amber a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.amber a.btn-outline-dark.disabled, .amber a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.amber a.btn-outline-dark:not(:disabled):not(.disabled):active, .amber a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .amber a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.amber a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .amber a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .amber a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.amber .btn-outline-primary,
.amber a.btn-outline-primary {
  color: #FFC107;
  border-color: #FFC107;
}
.amber .btn-outline-primary:focus, .amber .btn-outline-primary:hover, .amber .btn-outline-primary.disabled, .amber .btn-outline-primary:disabled, .amber .btn-outline-primary:not(:disabled):not(.disabled):active, .amber .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-primary.dropdown-toggle,
.amber a.btn-outline-primary:focus,
.amber a.btn-outline-primary:hover,
.amber a.btn-outline-primary.disabled,
.amber a.btn-outline-primary:disabled,
.amber a.btn-outline-primary:not(:disabled):not(.disabled):active,
.amber a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .amber a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #FFC107;
  background-color: #FFC107;
}

.amber .btn-outline-secondary,
.amber a.btn-outline-secondary {
  color: #FF3D00;
  border-color: #FF3D00;
}
.amber .btn-outline-secondary:focus, .amber .btn-outline-secondary:hover, .amber .btn-outline-secondary.disabled, .amber .btn-outline-secondary:disabled, .amber .btn-outline-secondary:not(:disabled):not(.disabled):active, .amber .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .amber .btn-outline-secondary.dropdown-toggle,
.amber a.btn-outline-secondary:focus,
.amber a.btn-outline-secondary:hover,
.amber a.btn-outline-secondary.disabled,
.amber a.btn-outline-secondary:disabled,
.amber a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.amber a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .amber a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF3D00;
  background-color: #FF3D00;
}

.amber a, .amber a.text-primary {
  color: #FFC107;
}
.amber a:focus, .amber a:hover, .amber a.text-primary:focus, .amber a.text-primary:hover {
  color: rgb(211, 158.25, 0);
}
.amber .text-primary {
  color: #FFC107 !important;
}
.amber .page-link {
  color: #FFC107;
}
.amber .page-link:focus, .amber .page-link:hover {
  color: #FFC107;
}
.amber .bg-primary, .amber .badge-primary {
  background-color: #FFC107 !important;
  color: #fff !important;
}
.amber .btn-primary, .amber .jr-btn-primary, .amber a.btn-primary, .amber a.jr-btn-primary {
  background-color: #FFC107;
  border-color: #FFC107;
  color: #fff;
}
.amber .btn-primary:hover, .amber .btn-primary:focus, .amber .btn-primary:not([disabled]):not(.disabled):active, .amber .jr-btn-primary:hover, .amber .jr-btn-primary:focus, .amber .jr-btn-primary:not([disabled]):not(.disabled):active, .amber a.btn-primary:hover, .amber a.btn-primary:focus, .amber a.btn-primary:not([disabled]):not(.disabled):active, .amber a.jr-btn-primary:hover, .amber a.jr-btn-primary:focus, .amber a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(236.5, 177.375, 0) !important;
  border-color: rgb(236.5, 177.375, 0) !important;
  color: #fff !important;
}
.amber .bg-primary.lighten-4 {
  background-color: #ffecb3 !important;
}
.amber .bg-primary.lighten-3 {
  background-color: #ffe082 !important;
}
.amber .bg-primary.lighten-2 {
  background-color: #ffd54f !important;
}
.amber .bg-primary.lighten-1 {
  background-color: #ffca28 !important;
}
.amber .bg-primary.darken-1 {
  background-color: #ffb300 !important;
}
.amber .bg-primary.darken-2 {
  background-color: #ffa000 !important;
}
.amber .bg-primary.darken-3 {
  background-color: #ff8f00 !important;
}
.amber .bg-primary.darken-4 {
  background-color: #ff6f00 !important;
}
.amber .bg-primary.accent-1 {
  background-color: #ffe57f !important;
}
.amber .bg-primary.accent-2 {
  background-color: #ffd740 !important;
}
.amber .bg-primary.accent-3 {
  background-color: #ffc400 !important;
}
.amber .bg-primary.accent-4 {
  background-color: #ffab00 !important;
}

.amber a.text-secondary {
  color: #FF3D00;
}
.amber a.text-secondary:focus, .amber a.text-secondary:hover {
  color: rgb(204, 48.8, 0) !important;
}
.amber .text-secondary {
  color: #FF3D00 !important;
}
.amber .bg-secondary, .amber .badge-secondary {
  background-color: #FF3D00 !important;
  color: #fff !important;
}
.amber .btn-secondary {
  background-color: #FF3D00;
  border-color: #FF3D00;
  color: #fff;
}
.amber .btn-secondary:hover, .amber .btn-secondary:focus, .amber .btn-secondary:active {
  background-color: rgb(229.5, 54.9, 0) !important;
  border-color: rgb(229.5, 54.9, 0) !important;
  color: #fff !important;
}

.amber .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.amber .jr-flat-btn:hover, .amber .jr-flat-btn:focus, .amber .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.amber .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #FFC107 !important;
  border-color: transparent !important;
}
.amber .jr-flat-btn.jr-btn-primary:hover, .amber .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 193, 7, 0.12) !important;
  color: #FFC107 !important;
}

.amber .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.amber .bg-primary .jr-flat-btn.jr-btn-primary:hover, .amber .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.amber .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF3D00 !important;
  border-color: transparent !important;
}
.amber .jr-flat-btn.jr-btn-secondary:hover, .amber .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 61, 0, 0.12) !important;
  color: #FF3D00 !important;
}

.amber .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.amber .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .amber .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .amber .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.amber .color-theme-header {
  background-color: #FFC107;
}

.amber .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
}
.amber .side-nav .user-profile {
  background-color: #f8f9fa;
}
.amber .side-nav .user-profile .text-white {
  color: #FFC107 !important;
}
.amber .side-nav .user-detail .user-name {
  color: #FFC107;
}
.amber .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}

.amber ul.nav-menu li a {
  color: #868e96;
}

.amber ul.nav-menu .nav-header {
  color: #868e96;
}

.amber ul.nav-menu > li.open > a,
.amber ul.nav-menu > li > a:hover,
.amber ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #FFC107;
}

.amber ul.nav-menu li.menu > a:focus:before,
.amber ul.nav-menu li.menu > a:hover:before {
  color: #FFC107;
}

.amber ul.nav-menu li ul {
  background-color: #fff;
}

.amber ul.nav-menu li.menu > a:before {
  color: #333;
}

.amber ul.nav-menu li.menu.open > a:before,
.amber ul.nav-menu li.menu > a:focus:before,
.amber ul.nav-menu li.menu li > a:hover:before {
  color: #FFC107;
}

.amber ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.amber ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #FFC107;
}

.amber ul.nav-menu li.menu .sub-menu li > a:hover,
.amber ul.nav-menu li.menu .sub-menu li > a:focus,
.amber ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.amber ul.nav-menu li.menu .sub-menu li > a:focus:before,
.amber ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #FFC107;
}

/*Header top Navbar Styles*/
.amber .navbar-nav li:hover > a, .amber .navbar-nav li:focus > a {
  color: #FFC107;
}
.amber .navbar-nav li a {
  color: #333;
}
.amber .navbar-nav li a:hover, .amber .navbar-nav li a:focus {
  color: #FFC107;
}
.amber .navbar-nav li.nav-item.active > a {
  color: #FFC107;
}
.amber .navbar-nav ul.sub-menu li a.active, .amber .navbar-nav ul.sub-menu li.active > a {
  color: #FFC107;
}
.amber .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.amber .navbar-nav .nav-arrow a:hover:before, .amber .navbar-nav .nav-arrow a:focus:before {
  color: #FFC107;
}
.amber .navbar-nav .nav-arrow:hover > a:before, .amber .navbar-nav .nav-arrow:focus > a:before, .amber .navbar-nav .nav-arrow.active > a:before {
  color: #FFC107;
}

.amber .app-top-nav {
  background-color: #FFC107;
}
.amber .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.amber .app-top-nav .navbar-nav li.nav-item:hover > a, .amber .app-top-nav .navbar-nav li.nav-item:focus > a, .amber .app-top-nav .navbar-nav li.nav-item > a:hover, .amber .app-top-nav .navbar-nav li.nav-item > a:focus, .amber .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF3D00;
}

.amber .module-nav li a.active {
  border-color: #FFC107;
}

.amber .rbc-event {
  background-color: #FFC107;
}

.amber .rbc-event.rbc-selected {
  background-color: rgb(211, 158.25, 0);
}

.amber .rbc-slot-selection {
  background-color: rgba(255, 193, 7, 0.7);
}

.amber .rbc-toolbar button:active,
.amber .rbc-toolbar button.rbc-active {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #FFC107;
}

.amber .rbc-toolbar button:active:hover,
.amber .rbc-toolbar button.rbc-active:hover,
.amber .rbc-toolbar button:active:focus,
.amber .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #FFC107;
}

.amber .rbc-toolbar button:focus {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #FFC107;
}

.amber .rbc-toolbar button:hover {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #FFC107;
}

.amber .rbc-day-slot .rbc-event {
  border-color: #FFC107;
}

.amber .chat-sidenav-title {
  color: #FFC107;
}

.amber .chat-user-item.active, .amber .chat-user-item:hover {
  background-color: rgb(255, 250.375, 236.5);
}

.amber .contact-list i {
  color: #FFC107;
}

.amber .Collapsible__trigger {
  background: #FFC107;
}

.amber .categories-list li a:focus, .amber .categories-list li a:hover, .amber .categories-list li.active a {
  color: #FFC107;
}

.amber .login-content .form-control:focus {
  border-color: #FFC107;
}

.amber .filter-with-bg-color ul li a {
  border-color: #FFC107;
}
.amber .filter-with-bg-color ul li a:hover, .amber .filter-with-bg-color ul li a:focus, .amber .filter-with-bg-color ul li a.active {
  background-color: #FFC107;
}

.amber .profile-intro .icon {
  color: #FFC107;
}

.amber .social-link li.active a, .amber .social-link li a:hover, .amber .social-link li a:focus {
  color: #FF3D00;
}

.amber .actions {
  color: #FF3D00;
}

.amber .table-hover tbody tr:hover {
  background-color: rgba(255, 193, 7, 0.075);
}

.amber .border-primary {
  border-color: #FFC107 !important;
}

.amber .app-logo-content {
  background-color: #FFC107;
}

.amber .app-social-block .social-link button {
  border: solid 1px #FFC107;
  color: #FFC107;
}
.amber .app-social-block .social-link button:hover, .amber .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #FFC107;
}

.amber .btn-group > .jr-btn.active,
.amber .btn-group > .btn-default.active,
.amber .btn-group-vertical > .jr-btn.active,
.amber .btn-group-vertical > .btn-default.active {
  background-color: #FFC107;
  border-color: #FFC107;
}
.amber .btn-group > .jr-flat-btn,
.amber .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.amber .btn-group > .jr-flat-btn.active,
.amber .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #FFC107 !important;
  border-color: transparent !important;
}
.amber .btn-group > .jr-flat-btn.active:hover, .amber .btn-group > .jr-flat-btn.active:focus,
.amber .btn-group-vertical > .jr-flat-btn.active:hover,
.amber .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(255, 193, 7, 0.12) !important;
  color: #FFC107 !important;
}

.amber .nav-pill-sales .nav-link.active {
  background-color: #FFC107;
  border-color: #FFC107;
}

.amber .form-checkbox > input + .check,
.amber .form-checkbox > input.sm + .check {
  color: #FFC107;
}

/*Theme Deep Orange Styles*/
.deep-orange .right-arrow {
  color: #ff5722;
}
.deep-orange .right-arrow:after {
  color: #ff5722;
}

.deep-orange .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.deep-orange .btn-primary:focus, .deep-orange .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-orange .btn-primary.disabled, .deep-orange .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-orange .btn-primary:not(:disabled):not(.disabled):active, .deep-orange .btn-primary:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.deep-orange .btn-primary:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-orange .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.deep-orange .btn-secondary:focus, .deep-orange .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-orange .btn-secondary.disabled, .deep-orange .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-orange .btn-secondary:not(:disabled):not(.disabled):active, .deep-orange .btn-secondary:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.deep-orange .btn-secondary:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-orange .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.deep-orange .btn-success:focus, .deep-orange .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-orange .btn-success.disabled, .deep-orange .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-orange .btn-success:not(:disabled):not(.disabled):active, .deep-orange .btn-success:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.deep-orange .btn-success:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-success:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-orange .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.deep-orange .btn-info:focus, .deep-orange .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-orange .btn-info.disabled, .deep-orange .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-orange .btn-info:not(:disabled):not(.disabled):active, .deep-orange .btn-info:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.deep-orange .btn-info:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-info:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-orange .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.deep-orange .btn-warning:focus, .deep-orange .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-orange .btn-warning.disabled, .deep-orange .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-orange .btn-warning:not(:disabled):not(.disabled):active, .deep-orange .btn-warning:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.deep-orange .btn-warning:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-orange .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.deep-orange .btn-danger:focus, .deep-orange .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-orange .btn-danger.disabled, .deep-orange .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-orange .btn-danger:not(:disabled):not(.disabled):active, .deep-orange .btn-danger:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.deep-orange .btn-danger:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-orange .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.deep-orange .btn-light:focus, .deep-orange .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-orange .btn-light.disabled, .deep-orange .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-orange .btn-light:not(:disabled):not(.disabled):active, .deep-orange .btn-light:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.deep-orange .btn-light:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-light:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-orange .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.deep-orange .btn-dark:focus, .deep-orange .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-orange .btn-dark.disabled, .deep-orange .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-orange .btn-dark:not(:disabled):not(.disabled):active, .deep-orange .btn-dark:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.deep-orange .btn-dark:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-orange a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.deep-orange a.btn-primary:focus, .deep-orange a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-orange a.btn-primary.disabled, .deep-orange a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-orange a.btn-primary:not(:disabled):not(.disabled):active, .deep-orange a.btn-primary:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.deep-orange a.btn-primary:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-orange a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.deep-orange a.btn-secondary:focus, .deep-orange a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-orange a.btn-secondary.disabled, .deep-orange a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-orange a.btn-secondary:not(:disabled):not(.disabled):active, .deep-orange a.btn-secondary:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.deep-orange a.btn-secondary:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-orange a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.deep-orange a.btn-success:focus, .deep-orange a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-orange a.btn-success.disabled, .deep-orange a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-orange a.btn-success:not(:disabled):not(.disabled):active, .deep-orange a.btn-success:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.deep-orange a.btn-success:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-orange a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.deep-orange a.btn-info:focus, .deep-orange a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-orange a.btn-info.disabled, .deep-orange a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-orange a.btn-info:not(:disabled):not(.disabled):active, .deep-orange a.btn-info:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.deep-orange a.btn-info:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-orange a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.deep-orange a.btn-warning:focus, .deep-orange a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-orange a.btn-warning.disabled, .deep-orange a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-orange a.btn-warning:not(:disabled):not(.disabled):active, .deep-orange a.btn-warning:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.deep-orange a.btn-warning:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-orange a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.deep-orange a.btn-danger:focus, .deep-orange a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-orange a.btn-danger.disabled, .deep-orange a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-orange a.btn-danger:not(:disabled):not(.disabled):active, .deep-orange a.btn-danger:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.deep-orange a.btn-danger:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-orange a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.deep-orange a.btn-light:focus, .deep-orange a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-orange a.btn-light.disabled, .deep-orange a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-orange a.btn-light:not(:disabled):not(.disabled):active, .deep-orange a.btn-light:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.deep-orange a.btn-light:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-orange a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-orange a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.deep-orange a.btn-dark:focus, .deep-orange a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-orange a.btn-dark.disabled, .deep-orange a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-orange a.btn-dark:not(:disabled):not(.disabled):active, .deep-orange a.btn-dark:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.deep-orange a.btn-dark:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-orange .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.deep-orange .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-orange .btn-outline-primary:focus, .deep-orange .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-orange .btn-outline-primary.disabled, .deep-orange .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-orange .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.deep-orange .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-orange .btn-outline-secondary:focus, .deep-orange .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-orange .btn-outline-secondary.disabled, .deep-orange .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-orange .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.deep-orange .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-orange .btn-outline-success:focus, .deep-orange .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-orange .btn-outline-success.disabled, .deep-orange .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.deep-orange .btn-outline-success:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-success:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-orange .btn-outline-success:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-orange .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.deep-orange .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-orange .btn-outline-info:focus, .deep-orange .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-orange .btn-outline-info.disabled, .deep-orange .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.deep-orange .btn-outline-info:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-info:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-orange .btn-outline-info:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-orange .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.deep-orange .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-orange .btn-outline-warning:focus, .deep-orange .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-orange .btn-outline-warning.disabled, .deep-orange .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-orange .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.deep-orange .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-orange .btn-outline-danger:focus, .deep-orange .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-orange .btn-outline-danger.disabled, .deep-orange .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-orange .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.deep-orange .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-orange .btn-outline-light:focus, .deep-orange .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-orange .btn-outline-light.disabled, .deep-orange .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.deep-orange .btn-outline-light:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-light:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-orange .btn-outline-light:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-orange .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.deep-orange .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-orange .btn-outline-dark:focus, .deep-orange .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-orange .btn-outline-dark.disabled, .deep-orange .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-orange .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-orange a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.deep-orange a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-orange a.btn-outline-primary:focus, .deep-orange a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-orange a.btn-outline-primary.disabled, .deep-orange a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-orange a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.deep-orange a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-orange a.btn-outline-secondary:focus, .deep-orange a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-orange a.btn-outline-secondary.disabled, .deep-orange a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-orange a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.deep-orange a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-orange a.btn-outline-success:focus, .deep-orange a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-orange a.btn-outline-success.disabled, .deep-orange a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-orange a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.deep-orange a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-orange a.btn-outline-info:focus, .deep-orange a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-orange a.btn-outline-info.disabled, .deep-orange a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-orange a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.deep-orange a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-orange a.btn-outline-warning:focus, .deep-orange a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-orange a.btn-outline-warning.disabled, .deep-orange a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-orange a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.deep-orange a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-orange a.btn-outline-danger:focus, .deep-orange a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-orange a.btn-outline-danger.disabled, .deep-orange a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-orange a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.deep-orange a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-orange a.btn-outline-light:focus, .deep-orange a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-orange a.btn-outline-light.disabled, .deep-orange a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-orange a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.deep-orange a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-orange a.btn-outline-dark:focus, .deep-orange a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-orange a.btn-outline-dark.disabled, .deep-orange a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active, .deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .deep-orange a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-orange a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-orange .btn-outline-primary,
.deep-orange a.btn-outline-primary {
  color: #ff5722;
  border-color: #ff5722;
}
.deep-orange .btn-outline-primary:focus, .deep-orange .btn-outline-primary:hover, .deep-orange .btn-outline-primary.disabled, .deep-orange .btn-outline-primary:disabled, .deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-primary.dropdown-toggle,
.deep-orange a.btn-outline-primary:focus,
.deep-orange a.btn-outline-primary:hover,
.deep-orange a.btn-outline-primary.disabled,
.deep-orange a.btn-outline-primary:disabled,
.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active,
.deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .deep-orange a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #ff5722;
  background-color: #ff5722;
}

.deep-orange .btn-outline-secondary,
.deep-orange a.btn-outline-secondary {
  color: #40C4FF;
  border-color: #40C4FF;
}
.deep-orange .btn-outline-secondary:focus, .deep-orange .btn-outline-secondary:hover, .deep-orange .btn-outline-secondary.disabled, .deep-orange .btn-outline-secondary:disabled, .deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active, .deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .deep-orange .btn-outline-secondary.dropdown-toggle,
.deep-orange a.btn-outline-secondary:focus,
.deep-orange a.btn-outline-secondary:hover,
.deep-orange a.btn-outline-secondary.disabled,
.deep-orange a.btn-outline-secondary:disabled,
.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .deep-orange a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #40C4FF;
  background-color: #40C4FF;
}

.deep-orange a, .deep-orange a.text-primary {
  color: #ff5722;
}
.deep-orange a:focus, .deep-orange a:hover, .deep-orange a.text-primary:focus, .deep-orange a.text-primary:hover {
  color: rgb(238, 57.0769230769, 0);
}
.deep-orange .text-primary {
  color: #ff5722 !important;
}
.deep-orange .page-link {
  color: #ff5722;
}
.deep-orange .page-link:focus, .deep-orange .page-link:hover {
  color: #ff5722;
}
.deep-orange .bg-primary, .deep-orange .badge-primary {
  background-color: #ff5722 !important;
  color: #fff !important;
}
.deep-orange .btn-primary, .deep-orange .jr-btn-primary, .deep-orange a.btn-primary, .deep-orange a.jr-btn-primary {
  background-color: #ff5722;
  border-color: #ff5722;
  color: #fff;
}
.deep-orange .btn-primary:hover, .deep-orange .btn-primary:focus, .deep-orange .btn-primary:not([disabled]):not(.disabled):active, .deep-orange .jr-btn-primary:hover, .deep-orange .jr-btn-primary:focus, .deep-orange .jr-btn-primary:not([disabled]):not(.disabled):active, .deep-orange a.btn-primary:hover, .deep-orange a.btn-primary:focus, .deep-orange a.btn-primary:not([disabled]):not(.disabled):active, .deep-orange a.jr-btn-primary:hover, .deep-orange a.jr-btn-primary:focus, .deep-orange a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(255, 67.6153846154, 8.5) !important;
  border-color: rgb(255, 67.6153846154, 8.5) !important;
  color: #fff !important;
}
.deep-orange .bg-primary.lighten-4 {
  background-color: #ffccbc !important;
}
.deep-orange .bg-primary.lighten-3 {
  background-color: #ffab91 !important;
}
.deep-orange .bg-primary.lighten-2 {
  background-color: #ff8a65 !important;
}
.deep-orange .bg-primary.lighten-1 {
  background-color: #ff7043 !important;
}
.deep-orange .bg-primary.darken-1 {
  background-color: #f4511e !important;
}
.deep-orange .bg-primary.darken-2 {
  background-color: #e64a19 !important;
}
.deep-orange .bg-primary.darken-3 {
  background-color: #d84315 !important;
}
.deep-orange .bg-primary.darken-4 {
  background-color: #bf360c !important;
}
.deep-orange .bg-primary.accent-1 {
  background-color: #ff9e80 !important;
}
.deep-orange .bg-primary.accent-2 {
  background-color: #ff6e40 !important;
}
.deep-orange .bg-primary.accent-3 {
  background-color: #ff3d00 !important;
}
.deep-orange .bg-primary.accent-4 {
  background-color: #dd2c00 !important;
}

.deep-orange a.text-secondary {
  color: #40C4FF;
}
.deep-orange a.text-secondary:focus, .deep-orange a.text-secondary:hover {
  color: rgb(13, 180.2460732984, 255) !important;
}
.deep-orange .text-secondary {
  color: #40C4FF !important;
}
.deep-orange .bg-secondary, .deep-orange .badge-secondary {
  background-color: #40C4FF !important;
  color: #fff !important;
}
.deep-orange .btn-secondary {
  background-color: #40C4FF;
  border-color: #40C4FF;
  color: #fff;
}
.deep-orange .btn-secondary:hover, .deep-orange .btn-secondary:focus, .deep-orange .btn-secondary:active {
  background-color: rgb(38.5, 188.1230366492, 255) !important;
  border-color: rgb(38.5, 188.1230366492, 255) !important;
  color: #fff !important;
}

.deep-orange .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.deep-orange .jr-flat-btn:hover, .deep-orange .jr-flat-btn:focus, .deep-orange .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.deep-orange .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #ff5722 !important;
  border-color: transparent !important;
}
.deep-orange .jr-flat-btn.jr-btn-primary:hover, .deep-orange .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 87, 34, 0.12) !important;
  color: #ff5722 !important;
}

.deep-orange .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:hover, .deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.deep-orange .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #40C4FF !important;
  border-color: transparent !important;
}
.deep-orange .jr-flat-btn.jr-btn-secondary:hover, .deep-orange .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(64, 196, 255, 0.12) !important;
  color: #40C4FF !important;
}

.deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .deep-orange .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.deep-orange .color-theme-header {
  background-color: #ff5722;
}

.deep-orange .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
}
.deep-orange .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.deep-orange .side-nav .user-profile .text-white {
  color: #ff5722 !important;
}
.deep-orange .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.deep-orange .side-nav .user-detail .user-name {
  color: #ff5722;
}

.deep-orange ul.nav-menu li a {
  color: #868e96;
}

.deep-orange ul.nav-menu .nav-header {
  color: #868e96;
}

.deep-orange ul.nav-menu > li.open > a,
.deep-orange ul.nav-menu > li > a:hover,
.deep-orange ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #ff5722;
}

.deep-orange ul.nav-menu li.menu > a:focus:before,
.deep-orange ul.nav-menu li.menu > a:hover:before {
  color: #ff5722;
}

.deep-orange ul.nav-menu li ul {
  background-color: #fff;
}

.deep-orange ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.deep-orange ul.nav-menu li.menu.open > a:before,
.deep-orange ul.nav-menu li.menu > a:focus:before,
.deep-orange ul.nav-menu li.menu li > a:hover:before {
  color: #ff5722;
}

.deep-orange ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.deep-orange ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #ff5722;
}

.deep-orange ul.nav-menu li.menu .sub-menu li > a:hover,
.deep-orange ul.nav-menu li.menu .sub-menu li > a:focus,
.deep-orange ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.deep-orange ul.nav-menu li.menu .sub-menu li > a:focus:before,
.deep-orange ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #ff5722;
}

/*Header top Navbar Styles*/
.deep-orange .navbar-nav li:hover > a, .deep-orange .navbar-nav li:focus > a {
  color: #ff5722;
}
.deep-orange .navbar-nav li a {
  color: #333;
}
.deep-orange .navbar-nav li a:hover, .deep-orange .navbar-nav li a:focus {
  color: #ff5722;
}
.deep-orange .navbar-nav li.nav-item.active > a {
  color: #ff5722;
}
.deep-orange .navbar-nav ul.sub-menu li a.active, .deep-orange .navbar-nav ul.sub-menu li.active > a {
  color: #ff5722;
}
.deep-orange .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.deep-orange .navbar-nav .nav-arrow a:hover:before, .deep-orange .navbar-nav .nav-arrow a:focus:before {
  color: #ff5722;
}
.deep-orange .navbar-nav .nav-arrow:hover > a:before, .deep-orange .navbar-nav .nav-arrow:focus > a:before, .deep-orange .navbar-nav .nav-arrow.active > a:before {
  color: #ff5722;
}

.deep-orange .app-top-nav {
  background-color: #ff5722;
}
.deep-orange .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.deep-orange .app-top-nav .navbar-nav li.nav-item:hover > a, .deep-orange .app-top-nav .navbar-nav li.nav-item:focus > a, .deep-orange .app-top-nav .navbar-nav li.nav-item > a:hover, .deep-orange .app-top-nav .navbar-nav li.nav-item > a:focus, .deep-orange .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #40C4FF;
}

.deep-orange .module-nav li a.active {
  border-color: #ff5722;
}

.deep-orange .rbc-event {
  background-color: #ff5722;
}

.deep-orange .rbc-event.rbc-selected {
  background-color: rgb(238, 57.0769230769, 0);
}

.deep-orange .rbc-slot-selection {
  background-color: rgba(255, 87, 34, 0.7);
}

.deep-orange .rbc-toolbar button:active,
.deep-orange .rbc-toolbar button.rbc-active {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.deep-orange .rbc-toolbar button:active:hover,
.deep-orange .rbc-toolbar button.rbc-active:hover,
.deep-orange .rbc-toolbar button:active:focus,
.deep-orange .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.deep-orange .rbc-toolbar button:focus {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.deep-orange .rbc-toolbar button:hover {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.deep-orange .rbc-day-slot .rbc-event {
  border-color: #ff5722;
}

.deep-orange .chat-sidenav-title {
  color: #ff5722;
}

.deep-orange .chat-user-item.active, .deep-orange .chat-user-item:hover {
  background-color: rgb(255, 242.0769230769, 238);
}

.deep-orange .contact-list i {
  color: #ff5722;
}

.deep-orange .Collapsible__trigger {
  background: #ff5722;
}

.deep-orange .categories-list li a:focus, .deep-orange .categories-list li a:hover, .deep-orange .categories-list li.active a {
  color: #ff5722;
}

.deep-orange .login-content .form-control:focus {
  border-color: #ff5722;
}

.deep-orange .filter-with-bg-color ul li a {
  border-color: #ff5722;
}
.deep-orange .filter-with-bg-color ul li a:hover, .deep-orange .filter-with-bg-color ul li a:focus, .deep-orange .filter-with-bg-color ul li a.active {
  background-color: #ff5722;
}

.deep-orange .profile-intro .icon {
  color: #ff5722;
}

.deep-orange .social-link li.active a, .deep-orange .social-link li a:hover, .deep-orange .social-link li a:focus {
  color: #40C4FF;
}

.deep-orange .actions {
  color: #40C4FF;
}

.deep-orange .table-hover tbody tr:hover {
  background-color: rgba(255, 87, 34, 0.075);
}

.deep-orange .border-primary {
  border-color: #ff5722 !important;
}

.deep-orange .app-logo-content {
  background-color: #ff5722;
}

.deep-orange .app-social-block .social-link button {
  border: solid 1px #ff5722;
  color: #ff5722;
}
.deep-orange .app-social-block .social-link button:hover, .deep-orange .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #ff5722;
}

.deep-orange .btn-group > .jr-btn.active,
.deep-orange .btn-group > .btn-default.active,
.deep-orange .btn-group-vertical > .jr-btn.active,
.deep-orange .btn-group-vertical > .btn-default.active {
  background-color: #ff5722;
  border-color: #ff5722;
}
.deep-orange .btn-group > .jr-flat-btn,
.deep-orange .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.deep-orange .btn-group > .jr-flat-btn.active,
.deep-orange .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #ff5722 !important;
  border-color: transparent !important;
}
.deep-orange .btn-group > .jr-flat-btn.active:hover, .deep-orange .btn-group > .jr-flat-btn.active:focus,
.deep-orange .btn-group-vertical > .jr-flat-btn.active:hover,
.deep-orange .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(255, 87, 34, 0.12) !important;
  color: #ff5722 !important;
}

.deep-orange .nav-pill-sales .nav-link.active {
  background-color: #ff5722;
  border-color: #ff5722;
}

.deep-orange .form-checkbox > input + .check,
.deep-orange .form-checkbox > input.sm + .check {
  color: #ff5722;
}

/*Theme Pink Styles*/
.pink .right-arrow {
  color: #e91e63;
}
.pink .right-arrow:after {
  color: #e91e63;
}

.pink .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.pink .btn-primary:focus, .pink .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.pink .btn-primary.disabled, .pink .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.pink .btn-primary:not(:disabled):not(.disabled):active, .pink .btn-primary:not(:disabled):not(.disabled).active, .show > .pink .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.pink .btn-primary:not(:disabled):not(.disabled):active:focus, .pink .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.pink .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.pink .btn-secondary:focus, .pink .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.pink .btn-secondary.disabled, .pink .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.pink .btn-secondary:not(:disabled):not(.disabled):active, .pink .btn-secondary:not(:disabled):not(.disabled).active, .show > .pink .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.pink .btn-secondary:not(:disabled):not(.disabled):active:focus, .pink .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.pink .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.pink .btn-success:focus, .pink .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.pink .btn-success.disabled, .pink .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.pink .btn-success:not(:disabled):not(.disabled):active, .pink .btn-success:not(:disabled):not(.disabled).active, .show > .pink .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.pink .btn-success:not(:disabled):not(.disabled):active:focus, .pink .btn-success:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.pink .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.pink .btn-info:focus, .pink .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.pink .btn-info.disabled, .pink .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.pink .btn-info:not(:disabled):not(.disabled):active, .pink .btn-info:not(:disabled):not(.disabled).active, .show > .pink .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.pink .btn-info:not(:disabled):not(.disabled):active:focus, .pink .btn-info:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.pink .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.pink .btn-warning:focus, .pink .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.pink .btn-warning.disabled, .pink .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.pink .btn-warning:not(:disabled):not(.disabled):active, .pink .btn-warning:not(:disabled):not(.disabled).active, .show > .pink .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.pink .btn-warning:not(:disabled):not(.disabled):active:focus, .pink .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.pink .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.pink .btn-danger:focus, .pink .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.pink .btn-danger.disabled, .pink .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.pink .btn-danger:not(:disabled):not(.disabled):active, .pink .btn-danger:not(:disabled):not(.disabled).active, .show > .pink .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.pink .btn-danger:not(:disabled):not(.disabled):active:focus, .pink .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.pink .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.pink .btn-light:focus, .pink .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.pink .btn-light.disabled, .pink .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.pink .btn-light:not(:disabled):not(.disabled):active, .pink .btn-light:not(:disabled):not(.disabled).active, .show > .pink .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.pink .btn-light:not(:disabled):not(.disabled):active:focus, .pink .btn-light:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.pink .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.pink .btn-dark:focus, .pink .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.pink .btn-dark.disabled, .pink .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.pink .btn-dark:not(:disabled):not(.disabled):active, .pink .btn-dark:not(:disabled):not(.disabled).active, .show > .pink .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.pink .btn-dark:not(:disabled):not(.disabled):active:focus, .pink .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.pink a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.pink a.btn-primary:focus, .pink a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.pink a.btn-primary.disabled, .pink a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.pink a.btn-primary:not(:disabled):not(.disabled):active, .pink a.btn-primary:not(:disabled):not(.disabled).active, .show > .pink a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.pink a.btn-primary:not(:disabled):not(.disabled):active:focus, .pink a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.pink a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.pink a.btn-secondary:focus, .pink a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.pink a.btn-secondary.disabled, .pink a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.pink a.btn-secondary:not(:disabled):not(.disabled):active, .pink a.btn-secondary:not(:disabled):not(.disabled).active, .show > .pink a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.pink a.btn-secondary:not(:disabled):not(.disabled):active:focus, .pink a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.pink a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.pink a.btn-success:focus, .pink a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.pink a.btn-success.disabled, .pink a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.pink a.btn-success:not(:disabled):not(.disabled):active, .pink a.btn-success:not(:disabled):not(.disabled).active, .show > .pink a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.pink a.btn-success:not(:disabled):not(.disabled):active:focus, .pink a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.pink a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.pink a.btn-info:focus, .pink a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.pink a.btn-info.disabled, .pink a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.pink a.btn-info:not(:disabled):not(.disabled):active, .pink a.btn-info:not(:disabled):not(.disabled).active, .show > .pink a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.pink a.btn-info:not(:disabled):not(.disabled):active:focus, .pink a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.pink a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.pink a.btn-warning:focus, .pink a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.pink a.btn-warning.disabled, .pink a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.pink a.btn-warning:not(:disabled):not(.disabled):active, .pink a.btn-warning:not(:disabled):not(.disabled).active, .show > .pink a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.pink a.btn-warning:not(:disabled):not(.disabled):active:focus, .pink a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.pink a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.pink a.btn-danger:focus, .pink a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.pink a.btn-danger.disabled, .pink a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.pink a.btn-danger:not(:disabled):not(.disabled):active, .pink a.btn-danger:not(:disabled):not(.disabled).active, .show > .pink a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.pink a.btn-danger:not(:disabled):not(.disabled):active:focus, .pink a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.pink a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.pink a.btn-light:focus, .pink a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.pink a.btn-light.disabled, .pink a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.pink a.btn-light:not(:disabled):not(.disabled):active, .pink a.btn-light:not(:disabled):not(.disabled).active, .show > .pink a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.pink a.btn-light:not(:disabled):not(.disabled):active:focus, .pink a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.pink a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.pink a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.pink a.btn-dark:focus, .pink a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.pink a.btn-dark.disabled, .pink a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.pink a.btn-dark:not(:disabled):not(.disabled):active, .pink a.btn-dark:not(:disabled):not(.disabled).active, .show > .pink a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.pink a.btn-dark:not(:disabled):not(.disabled):active:focus, .pink a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.pink .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.pink .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.pink .btn-outline-primary:focus, .pink .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.pink .btn-outline-primary.disabled, .pink .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.pink .btn-outline-primary:not(:disabled):not(.disabled):active, .pink .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.pink .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.pink .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.pink .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.pink .btn-outline-secondary:focus, .pink .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.pink .btn-outline-secondary.disabled, .pink .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.pink .btn-outline-secondary:not(:disabled):not(.disabled):active, .pink .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.pink .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.pink .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.pink .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.pink .btn-outline-success:focus, .pink .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.pink .btn-outline-success.disabled, .pink .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.pink .btn-outline-success:not(:disabled):not(.disabled):active, .pink .btn-outline-success:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.pink .btn-outline-success:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.pink .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.pink .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.pink .btn-outline-info:focus, .pink .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.pink .btn-outline-info.disabled, .pink .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.pink .btn-outline-info:not(:disabled):not(.disabled):active, .pink .btn-outline-info:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.pink .btn-outline-info:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.pink .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.pink .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.pink .btn-outline-warning:focus, .pink .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.pink .btn-outline-warning.disabled, .pink .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.pink .btn-outline-warning:not(:disabled):not(.disabled):active, .pink .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.pink .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.pink .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.pink .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.pink .btn-outline-danger:focus, .pink .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.pink .btn-outline-danger.disabled, .pink .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.pink .btn-outline-danger:not(:disabled):not(.disabled):active, .pink .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.pink .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.pink .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.pink .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.pink .btn-outline-light:focus, .pink .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.pink .btn-outline-light.disabled, .pink .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.pink .btn-outline-light:not(:disabled):not(.disabled):active, .pink .btn-outline-light:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.pink .btn-outline-light:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.pink .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.pink .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.pink .btn-outline-dark:focus, .pink .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.pink .btn-outline-dark.disabled, .pink .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.pink .btn-outline-dark:not(:disabled):not(.disabled):active, .pink .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.pink .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .pink .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .pink .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.pink a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.pink a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.pink a.btn-outline-primary:focus, .pink a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.pink a.btn-outline-primary.disabled, .pink a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.pink a.btn-outline-primary:not(:disabled):not(.disabled):active, .pink a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.pink a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.pink a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.pink a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.pink a.btn-outline-secondary:focus, .pink a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.pink a.btn-outline-secondary.disabled, .pink a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.pink a.btn-outline-secondary:not(:disabled):not(.disabled):active, .pink a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.pink a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.pink a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.pink a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.pink a.btn-outline-success:focus, .pink a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.pink a.btn-outline-success.disabled, .pink a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.pink a.btn-outline-success:not(:disabled):not(.disabled):active, .pink a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.pink a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.pink a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.pink a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.pink a.btn-outline-info:focus, .pink a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.pink a.btn-outline-info.disabled, .pink a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.pink a.btn-outline-info:not(:disabled):not(.disabled):active, .pink a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.pink a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.pink a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.pink a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.pink a.btn-outline-warning:focus, .pink a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.pink a.btn-outline-warning.disabled, .pink a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.pink a.btn-outline-warning:not(:disabled):not(.disabled):active, .pink a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.pink a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.pink a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.pink a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.pink a.btn-outline-danger:focus, .pink a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.pink a.btn-outline-danger.disabled, .pink a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.pink a.btn-outline-danger:not(:disabled):not(.disabled):active, .pink a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.pink a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.pink a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.pink a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.pink a.btn-outline-light:focus, .pink a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.pink a.btn-outline-light.disabled, .pink a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.pink a.btn-outline-light:not(:disabled):not(.disabled):active, .pink a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.pink a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.pink a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.pink a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.pink a.btn-outline-dark:focus, .pink a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.pink a.btn-outline-dark.disabled, .pink a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.pink a.btn-outline-dark:not(:disabled):not(.disabled):active, .pink a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .pink a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.pink a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .pink a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .pink a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.pink .btn-outline-primary,
.pink a.btn-outline-primary {
  color: #e91e63;
  border-color: #e91e63;
}
.pink .btn-outline-primary:focus, .pink .btn-outline-primary:hover, .pink .btn-outline-primary.disabled, .pink .btn-outline-primary:disabled, .pink .btn-outline-primary:not(:disabled):not(.disabled):active, .pink .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-primary.dropdown-toggle,
.pink a.btn-outline-primary:focus,
.pink a.btn-outline-primary:hover,
.pink a.btn-outline-primary.disabled,
.pink a.btn-outline-primary:disabled,
.pink a.btn-outline-primary:not(:disabled):not(.disabled):active,
.pink a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .pink a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #e91e63;
  background-color: #e91e63;
}

.pink .btn-outline-secondary,
.pink a.btn-outline-secondary {
  color: #00BFA5;
  border-color: #00BFA5;
}
.pink .btn-outline-secondary:focus, .pink .btn-outline-secondary:hover, .pink .btn-outline-secondary.disabled, .pink .btn-outline-secondary:disabled, .pink .btn-outline-secondary:not(:disabled):not(.disabled):active, .pink .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .pink .btn-outline-secondary.dropdown-toggle,
.pink a.btn-outline-secondary:focus,
.pink a.btn-outline-secondary:hover,
.pink a.btn-outline-secondary.disabled,
.pink a.btn-outline-secondary:disabled,
.pink a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.pink a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .pink a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #00BFA5;
  background-color: #00BFA5;
}

.pink a, .pink a.text-primary {
  color: #e91e63;
}
.pink a:focus, .pink a:hover, .pink a.text-primary:focus, .pink a.text-primary:hover {
  color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.pink .text-primary {
  color: #e91e63 !important;
}
.pink .page-link {
  color: #e91e63;
}
.pink .page-link:focus, .pink .page-link:hover {
  color: #e91e63;
}
.pink .bg-primary, .pink .badge-primary {
  background-color: #e91e63 !important;
  color: #fff !important;
}
.pink .btn-primary, .pink .jr-btn-primary, .pink a.btn-primary, .pink a.jr-btn-primary {
  background-color: #e91e63;
  border-color: #e91e63;
  color: #fff;
}
.pink .btn-primary:hover, .pink .btn-primary:focus, .pink .btn-primary:not([disabled]):not(.disabled):active, .pink .jr-btn-primary:hover, .pink .jr-btn-primary:focus, .pink .jr-btn-primary:not([disabled]):not(.disabled):active, .pink a.btn-primary:hover, .pink a.btn-primary:focus, .pink a.btn-primary:not([disabled]):not(.disabled):active, .pink a.jr-btn-primary:hover, .pink a.jr-btn-primary:focus, .pink a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(216.3461538462, 21.1538461538, 87.5) !important;
  border-color: rgb(216.3461538462, 21.1538461538, 87.5) !important;
  color: #fff !important;
}
.pink .bg-primary.lighten-4 {
  background-color: #f8bbd0 !important;
}
.pink .bg-primary.lighten-3 {
  background-color: #f48fb1 !important;
}
.pink .bg-primary.lighten-2 {
  background-color: #f06292 !important;
}
.pink .bg-primary.lighten-1 {
  background-color: #ec407a !important;
}
.pink .bg-primary.darken-1 {
  background-color: #d81b60 !important;
}
.pink .bg-primary.darken-2 {
  background-color: #c2185b !important;
}
.pink .bg-primary.darken-3 {
  background-color: #ad1457 !important;
}
.pink .bg-primary.darken-4 {
  background-color: #880e4f !important;
}
.pink .bg-primary.accent-1 {
  background-color: #ff80ab !important;
}
.pink .bg-primary.accent-2 {
  background-color: #ff4081 !important;
}
.pink .bg-primary.accent-3 {
  background-color: #f50057 !important;
}
.pink .bg-primary.accent-4 {
  background-color: #c51162 !important;
}

.pink a.text-secondary {
  color: #00BFA5;
}
.pink a.text-secondary:focus, .pink a.text-secondary:hover {
  color: rgb(0, 140, 120.942408377) !important;
}
.pink .text-secondary {
  color: #00BFA5 !important;
}
.pink .bg-secondary, .pink .badge-secondary {
  background-color: #00BFA5 !important;
  color: #fff !important;
}
.pink .btn-secondary {
  background-color: #00BFA5;
  border-color: #00BFA5;
  color: #fff;
}
.pink .btn-secondary:hover, .pink .btn-secondary:focus, .pink .btn-secondary:active {
  background-color: rgb(0, 165.5, 142.9712041885) !important;
  border-color: rgb(0, 165.5, 142.9712041885) !important;
  color: #fff !important;
}

.pink .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.pink .jr-flat-btn:hover, .pink .jr-flat-btn:focus, .pink .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.pink .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #e91e63 !important;
  border-color: transparent !important;
}
.pink .jr-flat-btn.jr-btn-primary:hover, .pink .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(233, 30, 99, 0.12) !important;
  color: #e91e63 !important;
}

.pink .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.pink .bg-primary .jr-flat-btn.jr-btn-primary:hover, .pink .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.pink .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #00BFA5 !important;
  border-color: transparent !important;
}
.pink .jr-flat-btn.jr-btn-secondary:hover, .pink .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(0, 191, 165, 0.12) !important;
  color: #00BFA5 !important;
}

.pink .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.pink .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .pink .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .pink .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.pink .color-theme-header {
  background-color: #e91e63;
}

.pink .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
  border-inline-end: solid 1px #e9ecef !important;
}
.pink .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.pink .side-nav .user-profile .text-white {
  color: #e91e63 !important;
}
.pink .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.pink .side-nav .user-detail .user-name {
  color: #e91e63;
}

.pink ul.nav-menu li a {
  color: #868e96;
}

.pink ul.nav-menu .nav-header {
  color: #868e96;
}

.pink ul.nav-menu > li.open > a,
.pink ul.nav-menu > li > a:hover,
.pink ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #e91e63;
}

.pink ul.nav-menu li.menu > a:focus:before,
.pink ul.nav-menu li.menu > a:hover:before {
  color: #e91e63;
}

.pink ul.nav-menu li ul {
  background-color: #fff;
}

.pink ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.pink ul.nav-menu li.menu.open > a:before,
.pink ul.nav-menu li.menu > a:focus:before,
.pink ul.nav-menu li.menu li > a:hover:before {
  color: #e91e63;
}

.pink ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.pink ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #e91e63;
}

.pink ul.nav-menu li.menu .sub-menu li > a:hover,
.pink ul.nav-menu li.menu .sub-menu li > a:focus,
.pink ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.pink ul.nav-menu li.menu .sub-menu li > a:focus:before,
.pink ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #e91e63;
}

/*Header top Navbar Styles*/
.pink .navbar-nav li:hover > a, .pink .navbar-nav li:focus > a {
  color: #e91e63;
}
.pink .navbar-nav li a {
  color: #333;
}
.pink .navbar-nav li a:hover, .pink .navbar-nav li a:focus {
  color: #e91e63;
}
.pink .navbar-nav li.nav-item.active > a {
  color: #e91e63;
}
.pink .navbar-nav ul.sub-menu li a.active, .pink .navbar-nav ul.sub-menu li.active > a {
  color: #e91e63;
}
.pink .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.pink .navbar-nav .nav-arrow a:hover:before, .pink .navbar-nav .nav-arrow a:focus:before {
  color: #e91e63;
}
.pink .navbar-nav .nav-arrow:hover > a:before, .pink .navbar-nav .nav-arrow:focus > a:before, .pink .navbar-nav .nav-arrow.active > a:before {
  color: #e91e63;
}

.pink .app-top-nav {
  background-color: #e91e63;
}
.pink .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.pink .app-top-nav .navbar-nav li.nav-item:hover > a, .pink .app-top-nav .navbar-nav li.nav-item:focus > a, .pink .app-top-nav .navbar-nav li.nav-item > a:hover, .pink .app-top-nav .navbar-nav li.nav-item > a:focus, .pink .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #00BFA5;
}

.pink .module-nav li a.active {
  border-color: #e91e63;
}

.pink .rbc-event {
  background-color: #e91e63;
}

.pink .rbc-event.rbc-selected {
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}

.pink .rbc-slot-selection {
  background-color: rgba(233, 30, 99, 0.7);
}

.pink .rbc-toolbar button:active,
.pink .rbc-toolbar button.rbc-active {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.pink .rbc-toolbar button:active:hover,
.pink .rbc-toolbar button.rbc-active:hover,
.pink .rbc-toolbar button:active:focus,
.pink .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.pink .rbc-toolbar button:focus {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.pink .rbc-toolbar button:hover {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.pink .rbc-day-slot .rbc-event {
  border-color: #e91e63;
}

.pink .chat-sidenav-title {
  color: #e91e63;
}

.pink .chat-user-item.active, .pink .chat-user-item:hover {
  background-color: rgb(253.4412955466, 239.0587044534, 243.9473684211);
}

.pink .contact-list i {
  color: #e91e63;
}

.pink .Collapsible__trigger {
  background: #e91e63;
}

.pink .categories-list li a:focus, .pink .categories-list li a:hover, .pink .categories-list li.active a {
  color: #e91e63;
}

.pink .login-content .form-control:focus {
  border-color: #e91e63;
}

.pink .filter-with-bg-color ul li a {
  border-color: #e91e63;
}
.pink .filter-with-bg-color ul li a:hover, .pink .filter-with-bg-color ul li a:focus, .pink .filter-with-bg-color ul li a.active {
  background-color: #e91e63;
}

.pink .profile-intro .icon {
  color: #e91e63;
}

.pink .social-link li.active a, .pink .social-link li a:hover, .pink .social-link li a:focus {
  color: #00BFA5;
}

.pink .actions {
  color: #00BFA5;
}

.pink .table-hover tbody tr:hover {
  background-color: rgba(233, 30, 99, 0.075);
}

.pink .border-primary {
  border-color: #e91e63 !important;
}

.pink .app-logo-content {
  background-color: #e91e63;
}

.pink .app-social-block .social-link button {
  border: solid 1px #e91e63;
  color: #e91e63;
}
.pink .app-social-block .social-link button:hover, .pink .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #e91e63;
}

.pink .btn-group > .jr-btn.active,
.pink .btn-group > .btn-default.active,
.pink .btn-group-vertical > .jr-btn.active,
.pink .btn-group-vertical > .btn-default.active {
  background-color: #e91e63;
  border-color: #e91e63;
}
.pink .btn-group > .jr-flat-btn,
.pink .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.pink .btn-group > .jr-flat-btn.active,
.pink .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #e91e63 !important;
  border-color: transparent !important;
}
.pink .btn-group > .jr-flat-btn.active:hover, .pink .btn-group > .jr-flat-btn.active:focus,
.pink .btn-group-vertical > .jr-flat-btn.active:hover,
.pink .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(233, 30, 99, 0.12) !important;
  color: #e91e63 !important;
}

.pink .nav-pill-sales .nav-link.active {
  background-color: #e91e63;
  border-color: #e91e63;
}

.pink .form-checkbox > input + .check,
.pink .form-checkbox > input.sm + .check {
  color: #e91e63;
}

/*Theme Blue Styles*/
.blue .right-arrow {
  color: #2196F3;
}
.blue .right-arrow:after {
  color: #2196F3;
}

.blue .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.blue .btn-primary:focus, .blue .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.blue .btn-primary.disabled, .blue .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.blue .btn-primary:not(:disabled):not(.disabled):active, .blue .btn-primary:not(:disabled):not(.disabled).active, .show > .blue .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.blue .btn-primary:not(:disabled):not(.disabled):active:focus, .blue .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.blue .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.blue .btn-secondary:focus, .blue .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.blue .btn-secondary.disabled, .blue .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.blue .btn-secondary:not(:disabled):not(.disabled):active, .blue .btn-secondary:not(:disabled):not(.disabled).active, .show > .blue .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.blue .btn-secondary:not(:disabled):not(.disabled):active:focus, .blue .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.blue .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.blue .btn-success:focus, .blue .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.blue .btn-success.disabled, .blue .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.blue .btn-success:not(:disabled):not(.disabled):active, .blue .btn-success:not(:disabled):not(.disabled).active, .show > .blue .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.blue .btn-success:not(:disabled):not(.disabled):active:focus, .blue .btn-success:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.blue .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.blue .btn-info:focus, .blue .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.blue .btn-info.disabled, .blue .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.blue .btn-info:not(:disabled):not(.disabled):active, .blue .btn-info:not(:disabled):not(.disabled).active, .show > .blue .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.blue .btn-info:not(:disabled):not(.disabled):active:focus, .blue .btn-info:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.blue .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.blue .btn-warning:focus, .blue .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.blue .btn-warning.disabled, .blue .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.blue .btn-warning:not(:disabled):not(.disabled):active, .blue .btn-warning:not(:disabled):not(.disabled).active, .show > .blue .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.blue .btn-warning:not(:disabled):not(.disabled):active:focus, .blue .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.blue .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.blue .btn-danger:focus, .blue .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.blue .btn-danger.disabled, .blue .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.blue .btn-danger:not(:disabled):not(.disabled):active, .blue .btn-danger:not(:disabled):not(.disabled).active, .show > .blue .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.blue .btn-danger:not(:disabled):not(.disabled):active:focus, .blue .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.blue .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.blue .btn-light:focus, .blue .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.blue .btn-light.disabled, .blue .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.blue .btn-light:not(:disabled):not(.disabled):active, .blue .btn-light:not(:disabled):not(.disabled).active, .show > .blue .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.blue .btn-light:not(:disabled):not(.disabled):active:focus, .blue .btn-light:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.blue .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.blue .btn-dark:focus, .blue .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.blue .btn-dark.disabled, .blue .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.blue .btn-dark:not(:disabled):not(.disabled):active, .blue .btn-dark:not(:disabled):not(.disabled).active, .show > .blue .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.blue .btn-dark:not(:disabled):not(.disabled):active:focus, .blue .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.blue a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.blue a.btn-primary:focus, .blue a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.blue a.btn-primary.disabled, .blue a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.blue a.btn-primary:not(:disabled):not(.disabled):active, .blue a.btn-primary:not(:disabled):not(.disabled).active, .show > .blue a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.blue a.btn-primary:not(:disabled):not(.disabled):active:focus, .blue a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.blue a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.blue a.btn-secondary:focus, .blue a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.blue a.btn-secondary.disabled, .blue a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.blue a.btn-secondary:not(:disabled):not(.disabled):active, .blue a.btn-secondary:not(:disabled):not(.disabled).active, .show > .blue a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.blue a.btn-secondary:not(:disabled):not(.disabled):active:focus, .blue a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.blue a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.blue a.btn-success:focus, .blue a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.blue a.btn-success.disabled, .blue a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.blue a.btn-success:not(:disabled):not(.disabled):active, .blue a.btn-success:not(:disabled):not(.disabled).active, .show > .blue a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.blue a.btn-success:not(:disabled):not(.disabled):active:focus, .blue a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.blue a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.blue a.btn-info:focus, .blue a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.blue a.btn-info.disabled, .blue a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.blue a.btn-info:not(:disabled):not(.disabled):active, .blue a.btn-info:not(:disabled):not(.disabled).active, .show > .blue a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.blue a.btn-info:not(:disabled):not(.disabled):active:focus, .blue a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.blue a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.blue a.btn-warning:focus, .blue a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.blue a.btn-warning.disabled, .blue a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.blue a.btn-warning:not(:disabled):not(.disabled):active, .blue a.btn-warning:not(:disabled):not(.disabled).active, .show > .blue a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.blue a.btn-warning:not(:disabled):not(.disabled):active:focus, .blue a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.blue a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.blue a.btn-danger:focus, .blue a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.blue a.btn-danger.disabled, .blue a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.blue a.btn-danger:not(:disabled):not(.disabled):active, .blue a.btn-danger:not(:disabled):not(.disabled).active, .show > .blue a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.blue a.btn-danger:not(:disabled):not(.disabled):active:focus, .blue a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.blue a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.blue a.btn-light:focus, .blue a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.blue a.btn-light.disabled, .blue a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.blue a.btn-light:not(:disabled):not(.disabled):active, .blue a.btn-light:not(:disabled):not(.disabled).active, .show > .blue a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.blue a.btn-light:not(:disabled):not(.disabled):active:focus, .blue a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.blue a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.blue a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.blue a.btn-dark:focus, .blue a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.blue a.btn-dark.disabled, .blue a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.blue a.btn-dark:not(:disabled):not(.disabled):active, .blue a.btn-dark:not(:disabled):not(.disabled).active, .show > .blue a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.blue a.btn-dark:not(:disabled):not(.disabled):active:focus, .blue a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.blue .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.blue .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.blue .btn-outline-primary:focus, .blue .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.blue .btn-outline-primary.disabled, .blue .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.blue .btn-outline-primary:not(:disabled):not(.disabled):active, .blue .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.blue .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.blue .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.blue .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.blue .btn-outline-secondary:focus, .blue .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.blue .btn-outline-secondary.disabled, .blue .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.blue .btn-outline-secondary:not(:disabled):not(.disabled):active, .blue .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.blue .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.blue .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.blue .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.blue .btn-outline-success:focus, .blue .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.blue .btn-outline-success.disabled, .blue .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.blue .btn-outline-success:not(:disabled):not(.disabled):active, .blue .btn-outline-success:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.blue .btn-outline-success:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.blue .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.blue .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.blue .btn-outline-info:focus, .blue .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.blue .btn-outline-info.disabled, .blue .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.blue .btn-outline-info:not(:disabled):not(.disabled):active, .blue .btn-outline-info:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.blue .btn-outline-info:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.blue .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.blue .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.blue .btn-outline-warning:focus, .blue .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.blue .btn-outline-warning.disabled, .blue .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.blue .btn-outline-warning:not(:disabled):not(.disabled):active, .blue .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.blue .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.blue .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.blue .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.blue .btn-outline-danger:focus, .blue .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.blue .btn-outline-danger.disabled, .blue .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.blue .btn-outline-danger:not(:disabled):not(.disabled):active, .blue .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.blue .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.blue .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.blue .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.blue .btn-outline-light:focus, .blue .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.blue .btn-outline-light.disabled, .blue .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.blue .btn-outline-light:not(:disabled):not(.disabled):active, .blue .btn-outline-light:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.blue .btn-outline-light:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.blue .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.blue .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.blue .btn-outline-dark:focus, .blue .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.blue .btn-outline-dark.disabled, .blue .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.blue .btn-outline-dark:not(:disabled):not(.disabled):active, .blue .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.blue .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .blue .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .blue .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.blue a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.blue a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.blue a.btn-outline-primary:focus, .blue a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.blue a.btn-outline-primary.disabled, .blue a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.blue a.btn-outline-primary:not(:disabled):not(.disabled):active, .blue a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.blue a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.blue a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.blue a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.blue a.btn-outline-secondary:focus, .blue a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.blue a.btn-outline-secondary.disabled, .blue a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.blue a.btn-outline-secondary:not(:disabled):not(.disabled):active, .blue a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.blue a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.blue a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.blue a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.blue a.btn-outline-success:focus, .blue a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.blue a.btn-outline-success.disabled, .blue a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.blue a.btn-outline-success:not(:disabled):not(.disabled):active, .blue a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.blue a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.blue a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.blue a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.blue a.btn-outline-info:focus, .blue a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.blue a.btn-outline-info.disabled, .blue a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.blue a.btn-outline-info:not(:disabled):not(.disabled):active, .blue a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.blue a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.blue a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.blue a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.blue a.btn-outline-warning:focus, .blue a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.blue a.btn-outline-warning.disabled, .blue a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.blue a.btn-outline-warning:not(:disabled):not(.disabled):active, .blue a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.blue a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.blue a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.blue a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.blue a.btn-outline-danger:focus, .blue a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.blue a.btn-outline-danger.disabled, .blue a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.blue a.btn-outline-danger:not(:disabled):not(.disabled):active, .blue a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.blue a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.blue a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.blue a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.blue a.btn-outline-light:focus, .blue a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.blue a.btn-outline-light.disabled, .blue a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.blue a.btn-outline-light:not(:disabled):not(.disabled):active, .blue a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.blue a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.blue a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.blue a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.blue a.btn-outline-dark:focus, .blue a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.blue a.btn-outline-dark.disabled, .blue a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.blue a.btn-outline-dark:not(:disabled):not(.disabled):active, .blue a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .blue a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.blue a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .blue a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .blue a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.blue .btn-outline-primary,
.blue a.btn-outline-primary {
  color: #2196F3;
  border-color: #2196F3;
}
.blue .btn-outline-primary:focus, .blue .btn-outline-primary:hover, .blue .btn-outline-primary.disabled, .blue .btn-outline-primary:disabled, .blue .btn-outline-primary:not(:disabled):not(.disabled):active, .blue .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-primary.dropdown-toggle,
.blue a.btn-outline-primary:focus,
.blue a.btn-outline-primary:hover,
.blue a.btn-outline-primary.disabled,
.blue a.btn-outline-primary:disabled,
.blue a.btn-outline-primary:not(:disabled):not(.disabled):active,
.blue a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .blue a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #2196F3;
  background-color: #2196F3;
}

.blue .btn-outline-secondary,
.blue a.btn-outline-secondary {
  color: #FF6E40;
  border-color: #FF6E40;
}
.blue .btn-outline-secondary:focus, .blue .btn-outline-secondary:hover, .blue .btn-outline-secondary.disabled, .blue .btn-outline-secondary:disabled, .blue .btn-outline-secondary:not(:disabled):not(.disabled):active, .blue .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .blue .btn-outline-secondary.dropdown-toggle,
.blue a.btn-outline-secondary:focus,
.blue a.btn-outline-secondary:hover,
.blue a.btn-outline-secondary.disabled,
.blue a.btn-outline-secondary:disabled,
.blue a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.blue a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .blue a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF6E40;
  background-color: #FF6E40;
}

.blue a, .blue a.text-primary {
  color: #2196F3;
}
.blue a:focus, .blue a:hover, .blue a.text-primary:focus, .blue a.text-primary:hover {
  color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}
.blue .text-primary {
  color: #2196F3 !important;
}
.blue .page-link {
  color: #2196F3;
}
.blue .page-link:focus, .blue .page-link:hover {
  color: #2196F3;
}
.blue .bg-primary, .blue .badge-primary {
  background-color: #2196F3 !important;
  color: #fff !important;
}
.blue .btn-primary, .blue .jr-btn-primary, .blue a.btn-primary, .blue a.jr-btn-primary {
  background-color: #2196F3;
  border-color: #2196F3;
  color: #fff;
}
.blue .btn-primary:hover, .blue .btn-primary:focus, .blue .btn-primary:not([disabled]):not(.disabled):active, .blue .jr-btn-primary:hover, .blue .jr-btn-primary:focus, .blue .jr-btn-primary:not([disabled]):not(.disabled):active, .blue a.btn-primary:hover, .blue a.btn-primary:focus, .blue a.btn-primary:not([disabled]):not(.disabled):active, .blue a.jr-btn-primary:hover, .blue a.jr-btn-primary:focus, .blue a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(12.8461538462, 138.0961538462, 237.6538461538) !important;
  border-color: rgb(12.8461538462, 138.0961538462, 237.6538461538) !important;
  color: #fff !important;
}
.blue .bg-primary.lighten-4 {
  background-color: #BBDEFB !important;
}
.blue .bg-primary.lighten-3 {
  background-color: #90CAF9 !important;
}
.blue .bg-primary.lighten-2 {
  background-color: #64B5F6 !important;
}
.blue .bg-primary.lighten-1 {
  background-color: #42A5F5 !important;
}
.blue .bg-primary.darken-1 {
  background-color: #1E88E5 !important;
}
.blue .bg-primary.darken-2 {
  background-color: #1976D2 !important;
}
.blue .bg-primary.darken-3 {
  background-color: #1565C0 !important;
}
.blue .bg-primary.darken-4 {
  background-color: #0D47A1 !important;
}
.blue .bg-primary.accent-1 {
  background-color: #82B1FF !important;
}
.blue .bg-primary.accent-2 {
  background-color: #448AFF !important;
}
.blue .bg-primary.accent-3 {
  background-color: #2979FF !important;
}
.blue .bg-primary.accent-4 {
  background-color: #2962FF !important;
}

.blue a.text-secondary {
  color: #FF6E40;
}
.blue a.text-secondary:focus, .blue a.text-secondary:hover {
  color: rgb(255, 71.2827225131, 13) !important;
}
.blue .text-secondary {
  color: #FF6E40 !important;
}
.blue .bg-secondary, .blue .badge-secondary {
  background-color: #FF6E40 !important;
  color: #fff !important;
}
.blue .btn-secondary {
  background-color: #FF6E40;
  border-color: #FF6E40;
  color: #fff;
}
.blue .btn-secondary:hover, .blue .btn-secondary:focus, .blue .btn-secondary:active {
  background-color: rgb(255, 90.6413612565, 38.5) !important;
  border-color: rgb(255, 90.6413612565, 38.5) !important;
  color: #fff !important;
}

.blue .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.blue .jr-flat-btn:hover, .blue .jr-flat-btn:focus, .blue .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.blue .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #2196F3 !important;
  border-color: transparent !important;
}
.blue .jr-flat-btn.jr-btn-primary:hover, .blue .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(33, 150, 243, 0.12) !important;
  color: #2196F3 !important;
}

.blue .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.blue .bg-primary .jr-flat-btn.jr-btn-primary:hover, .blue .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.blue .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF6E40 !important;
  border-color: #FF6E40 !important;
}
.blue .jr-flat-btn.jr-btn-secondary:hover, .blue .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 110, 64, 0.12) !important;
  color: #FF6E40 !important;
}

.blue .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.blue .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .blue .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .blue .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.blue .color-theme-header {
  background-color: #2196F3;
}

.blue .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
}
.blue .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.blue .side-nav .user-profile .text-white {
  color: #2196F3 !important;
}
.blue .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.blue .side-nav .user-detail .user-name {
  color: #2196F3;
}

.blue ul.nav-menu li a {
  color: #868e96;
}

.blue ul.nav-menu .nav-header {
  color: #868e96;
}

.blue ul.nav-menu > li.open > a,
.blue ul.nav-menu > li > a:hover,
.blue ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #2196F3;
}

.blue ul.nav-menu li.menu > a:focus:before,
.blue ul.nav-menu li.menu > a:hover:before {
  color: #2196F3;
}

.blue ul.nav-menu li ul {
  background-color: #fff;
}

.blue ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.blue ul.nav-menu li.menu.open > a:before,
.blue ul.nav-menu li.menu > a:focus:before,
.blue ul.nav-menu li.menu li > a:hover:before {
  color: #2196F3;
}

.blue ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.blue ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #2196F3;
}

.blue ul.nav-menu li.menu .sub-menu li > a:hover,
.blue ul.nav-menu li.menu .sub-menu li > a:focus,
.blue ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.blue ul.nav-menu li.menu .sub-menu li > a:focus:before,
.blue ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #2196F3;
}

/*Header top Navbar Styles*/
.blue .navbar-nav li:hover > a, .blue .navbar-nav li:focus > a {
  color: #2196F3;
}
.blue .navbar-nav li a {
  color: #333;
}
.blue .navbar-nav li a:hover, .blue .navbar-nav li a:focus {
  color: #2196F3;
}
.blue .navbar-nav li.nav-item.active > a {
  color: #2196F3;
}
.blue .navbar-nav ul.sub-menu li a.active, .blue .navbar-nav ul.sub-menu li.active > a {
  color: #2196F3;
}
.blue .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.blue .navbar-nav .nav-arrow a:hover:before, .blue .navbar-nav .nav-arrow a:focus:before {
  color: #2196F3;
}
.blue .navbar-nav .nav-arrow:hover > a:before, .blue .navbar-nav .nav-arrow:focus > a:before, .blue .navbar-nav .nav-arrow.active > a:before {
  color: #2196F3;
}

.blue .app-top-nav {
  background-color: #2196F3;
}
.blue .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.blue .app-top-nav .navbar-nav li.nav-item:hover > a, .blue .app-top-nav .navbar-nav li.nav-item:focus > a, .blue .app-top-nav .navbar-nav li.nav-item > a:hover, .blue .app-top-nav .navbar-nav li.nav-item > a:focus, .blue .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF6E40;
}

.blue .module-nav li a.active {
  border-color: #2196F3;
}

.blue .rbc-event {
  background-color: #2196F3;
}

.blue .rbc-event.rbc-selected {
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}

.blue .rbc-slot-selection {
  background-color: rgba(33, 150, 243, 0.7);
}

.blue .rbc-toolbar button:active,
.blue .rbc-toolbar button.rbc-active {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.blue .rbc-toolbar button:active:hover,
.blue .rbc-toolbar button.rbc-active:hover,
.blue .rbc-toolbar button:active:focus,
.blue .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.blue .rbc-toolbar button:focus {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.blue .rbc-toolbar button:hover {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.blue .rbc-day-slot .rbc-event {
  border-color: #2196F3;
}

.blue .chat-sidenav-title {
  color: #2196F3;
}

.blue .chat-user-item.active, .blue .chat-user-item:hover {
  background-color: rgb(226.5384615385, 241.5384615385, 253.4615384615);
}

.blue .contact-list i {
  color: #2196F3;
}

.blue .Collapsible__trigger {
  background: #2196F3;
}

.blue .categories-list li a:focus, .blue .categories-list li a:hover, .blue .categories-list li.active a {
  color: #2196F3;
}

.blue .login-content .form-control:focus {
  border-color: #2196F3;
}

.blue .filter-with-bg-color ul li a {
  border-color: #2196F3;
}
.blue .filter-with-bg-color ul li a:hover, .blue .filter-with-bg-color ul li a:focus, .blue .filter-with-bg-color ul li a.active {
  background-color: #2196F3;
}

.blue .profile-intro .icon {
  color: #2196F3;
}

.blue .social-link li.active a, .blue .social-link li a:hover, .blue .social-link li a:focus {
  color: #FF6E40;
}

.blue .actions {
  color: #FF6E40;
}

.blue .table-hover tbody tr:hover {
  background-color: rgba(33, 150, 243, 0.075);
}

.blue .border-primary {
  border-color: #2196F3 !important;
}

.blue .app-logo-content {
  background-color: #2196F3;
}

.blue .app-social-block .social-link button {
  border: solid 1px #2196F3;
  color: #2196F3;
}
.blue .app-social-block .social-link button:hover, .blue .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #2196F3;
}

.blue .btn-group > .jr-btn.active,
.blue .btn-group > .btn-default.active,
.blue .btn-group-vertical > .jr-btn.active,
.blue .btn-group-vertical > .btn-default.active {
  background-color: #2196F3;
  border-color: #2196F3;
}
.blue .btn-group > .jr-flat-btn,
.blue .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.blue .btn-group > .jr-flat-btn.active,
.blue .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #2196F3 !important;
  border-color: transparent !important;
}
.blue .btn-group > .jr-flat-btn.active:hover, .blue .btn-group > .jr-flat-btn.active:focus,
.blue .btn-group-vertical > .jr-flat-btn.active:hover,
.blue .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(33, 150, 243, 0.12) !important;
  color: #2196F3 !important;
}

.blue .nav-pill-sales .nav-link.active {
  background-color: #2196F3;
  border-color: #2196F3;
}

.blue .form-checkbox > input + .check,
.blue .form-checkbox > input.sm + .check {
  color: #2196F3;
}

/*Theme Deep Purple Styles*/
.deep-purple .right-arrow {
  color: #673ab7;
}
.deep-purple .right-arrow:after {
  color: #673ab7;
}

.deep-purple .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.deep-purple .btn-primary:focus, .deep-purple .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-purple .btn-primary.disabled, .deep-purple .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-purple .btn-primary:not(:disabled):not(.disabled):active, .deep-purple .btn-primary:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.deep-purple .btn-primary:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-purple .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.deep-purple .btn-secondary:focus, .deep-purple .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-purple .btn-secondary.disabled, .deep-purple .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-purple .btn-secondary:not(:disabled):not(.disabled):active, .deep-purple .btn-secondary:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.deep-purple .btn-secondary:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-purple .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.deep-purple .btn-success:focus, .deep-purple .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-purple .btn-success.disabled, .deep-purple .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-purple .btn-success:not(:disabled):not(.disabled):active, .deep-purple .btn-success:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.deep-purple .btn-success:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-success:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-purple .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.deep-purple .btn-info:focus, .deep-purple .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-purple .btn-info.disabled, .deep-purple .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-purple .btn-info:not(:disabled):not(.disabled):active, .deep-purple .btn-info:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.deep-purple .btn-info:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-info:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-purple .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.deep-purple .btn-warning:focus, .deep-purple .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-purple .btn-warning.disabled, .deep-purple .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-purple .btn-warning:not(:disabled):not(.disabled):active, .deep-purple .btn-warning:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.deep-purple .btn-warning:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-purple .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.deep-purple .btn-danger:focus, .deep-purple .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-purple .btn-danger.disabled, .deep-purple .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-purple .btn-danger:not(:disabled):not(.disabled):active, .deep-purple .btn-danger:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.deep-purple .btn-danger:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-purple .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.deep-purple .btn-light:focus, .deep-purple .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-purple .btn-light.disabled, .deep-purple .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-purple .btn-light:not(:disabled):not(.disabled):active, .deep-purple .btn-light:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.deep-purple .btn-light:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-light:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-purple .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.deep-purple .btn-dark:focus, .deep-purple .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-purple .btn-dark.disabled, .deep-purple .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-purple .btn-dark:not(:disabled):not(.disabled):active, .deep-purple .btn-dark:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.deep-purple .btn-dark:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-purple a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.deep-purple a.btn-primary:focus, .deep-purple a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-purple a.btn-primary.disabled, .deep-purple a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-purple a.btn-primary:not(:disabled):not(.disabled):active, .deep-purple a.btn-primary:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.deep-purple a.btn-primary:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-purple a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.deep-purple a.btn-secondary:focus, .deep-purple a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-purple a.btn-secondary.disabled, .deep-purple a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-purple a.btn-secondary:not(:disabled):not(.disabled):active, .deep-purple a.btn-secondary:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.deep-purple a.btn-secondary:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-purple a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.deep-purple a.btn-success:focus, .deep-purple a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-purple a.btn-success.disabled, .deep-purple a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-purple a.btn-success:not(:disabled):not(.disabled):active, .deep-purple a.btn-success:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.deep-purple a.btn-success:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-purple a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.deep-purple a.btn-info:focus, .deep-purple a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-purple a.btn-info.disabled, .deep-purple a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-purple a.btn-info:not(:disabled):not(.disabled):active, .deep-purple a.btn-info:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.deep-purple a.btn-info:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-purple a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.deep-purple a.btn-warning:focus, .deep-purple a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-purple a.btn-warning.disabled, .deep-purple a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-purple a.btn-warning:not(:disabled):not(.disabled):active, .deep-purple a.btn-warning:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.deep-purple a.btn-warning:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-purple a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.deep-purple a.btn-danger:focus, .deep-purple a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-purple a.btn-danger.disabled, .deep-purple a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-purple a.btn-danger:not(:disabled):not(.disabled):active, .deep-purple a.btn-danger:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.deep-purple a.btn-danger:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-purple a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.deep-purple a.btn-light:focus, .deep-purple a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-purple a.btn-light.disabled, .deep-purple a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-purple a.btn-light:not(:disabled):not(.disabled):active, .deep-purple a.btn-light:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.deep-purple a.btn-light:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-purple a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.deep-purple a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.deep-purple a.btn-dark:focus, .deep-purple a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-purple a.btn-dark.disabled, .deep-purple a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-purple a.btn-dark:not(:disabled):not(.disabled):active, .deep-purple a.btn-dark:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.deep-purple a.btn-dark:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-purple .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.deep-purple .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-purple .btn-outline-primary:focus, .deep-purple .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-purple .btn-outline-primary.disabled, .deep-purple .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-purple .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.deep-purple .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-purple .btn-outline-secondary:focus, .deep-purple .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-purple .btn-outline-secondary.disabled, .deep-purple .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-purple .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.deep-purple .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-purple .btn-outline-success:focus, .deep-purple .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-purple .btn-outline-success.disabled, .deep-purple .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.deep-purple .btn-outline-success:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-success:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-purple .btn-outline-success:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-purple .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.deep-purple .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-purple .btn-outline-info:focus, .deep-purple .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-purple .btn-outline-info.disabled, .deep-purple .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.deep-purple .btn-outline-info:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-info:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-purple .btn-outline-info:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-purple .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.deep-purple .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-purple .btn-outline-warning:focus, .deep-purple .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-purple .btn-outline-warning.disabled, .deep-purple .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-purple .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.deep-purple .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-purple .btn-outline-danger:focus, .deep-purple .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-purple .btn-outline-danger.disabled, .deep-purple .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-purple .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.deep-purple .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-purple .btn-outline-light:focus, .deep-purple .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-purple .btn-outline-light.disabled, .deep-purple .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.deep-purple .btn-outline-light:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-light:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-purple .btn-outline-light:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-purple .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.deep-purple .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-purple .btn-outline-dark:focus, .deep-purple .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-purple .btn-outline-dark.disabled, .deep-purple .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-purple .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-purple a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.deep-purple a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-purple a.btn-outline-primary:focus, .deep-purple a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.deep-purple a.btn-outline-primary.disabled, .deep-purple a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.deep-purple a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.deep-purple a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-purple a.btn-outline-secondary:focus, .deep-purple a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.deep-purple a.btn-outline-secondary.disabled, .deep-purple a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.deep-purple a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.deep-purple a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-purple a.btn-outline-success:focus, .deep-purple a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.deep-purple a.btn-outline-success.disabled, .deep-purple a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.deep-purple a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.deep-purple a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-purple a.btn-outline-info:focus, .deep-purple a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.deep-purple a.btn-outline-info.disabled, .deep-purple a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.deep-purple a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.deep-purple a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-purple a.btn-outline-warning:focus, .deep-purple a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.deep-purple a.btn-outline-warning.disabled, .deep-purple a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.deep-purple a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.deep-purple a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-purple a.btn-outline-danger:focus, .deep-purple a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.deep-purple a.btn-outline-danger.disabled, .deep-purple a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.deep-purple a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.deep-purple a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-purple a.btn-outline-light:focus, .deep-purple a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.deep-purple a.btn-outline-light.disabled, .deep-purple a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.deep-purple a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.deep-purple a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-purple a.btn-outline-dark:focus, .deep-purple a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.deep-purple a.btn-outline-dark.disabled, .deep-purple a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active, .deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .deep-purple a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .deep-purple a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.deep-purple .btn-outline-primary,
.deep-purple a.btn-outline-primary {
  color: #673ab7;
  border-color: #673ab7;
}
.deep-purple .btn-outline-primary:focus, .deep-purple .btn-outline-primary:hover, .deep-purple .btn-outline-primary.disabled, .deep-purple .btn-outline-primary:disabled, .deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-primary.dropdown-toggle,
.deep-purple a.btn-outline-primary:focus,
.deep-purple a.btn-outline-primary:hover,
.deep-purple a.btn-outline-primary.disabled,
.deep-purple a.btn-outline-primary:disabled,
.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active,
.deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .deep-purple a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #673ab7;
  background-color: #673ab7;
}

.deep-purple .btn-outline-secondary,
.deep-purple a.btn-outline-secondary {
  color: #FFAB00;
  border-color: #FFAB00;
}
.deep-purple .btn-outline-secondary:focus, .deep-purple .btn-outline-secondary:hover, .deep-purple .btn-outline-secondary.disabled, .deep-purple .btn-outline-secondary:disabled, .deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active, .deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .deep-purple .btn-outline-secondary.dropdown-toggle,
.deep-purple a.btn-outline-secondary:focus,
.deep-purple a.btn-outline-secondary:hover,
.deep-purple a.btn-outline-secondary.disabled,
.deep-purple a.btn-outline-secondary:disabled,
.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .deep-purple a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FFAB00;
  background-color: #FFAB00;
}

.deep-purple a, .deep-purple a.text-primary {
  color: #673ab7;
}
.deep-purple a:focus, .deep-purple a:hover, .deep-purple a.text-primary:focus, .deep-purple a.text-primary:hover {
  color: rgb(81.2033195021, 45.7261410788, 144.2738589212);
}
.deep-purple .text-primary {
  color: #673ab7 !important;
}
.deep-purple .page-link {
  color: #673ab7;
}
.deep-purple .page-link:focus, .deep-purple .page-link:hover {
  color: #673ab7;
}
.deep-purple .bg-primary, .deep-purple .badge-primary {
  background-color: #673ab7 !important;
  color: #fff !important;
}
.deep-purple .btn-primary, .deep-purple .jr-btn-primary, .deep-purple a.btn-primary, .deep-purple a.jr-btn-primary {
  background-color: #673ab7;
  border-color: #673ab7;
  color: #fff;
}
.deep-purple .btn-primary:hover, .deep-purple .btn-primary:focus, .deep-purple .btn-primary:not([disabled]):not(.disabled):active, .deep-purple .jr-btn-primary:hover, .deep-purple .jr-btn-primary:focus, .deep-purple .jr-btn-primary:not([disabled]):not(.disabled):active, .deep-purple a.btn-primary:hover, .deep-purple a.btn-primary:focus, .deep-purple a.btn-primary:not([disabled]):not(.disabled):active, .deep-purple a.jr-btn-primary:hover, .deep-purple a.jr-btn-primary:focus, .deep-purple a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(92.101659751, 51.8630705394, 163.6369294606) !important;
  border-color: rgb(92.101659751, 51.8630705394, 163.6369294606) !important;
  color: #fff !important;
}
.deep-purple .bg-primary.lighten-4 {
  background-color: #d1c4e9 !important;
}
.deep-purple .bg-primary.lighten-3 {
  background-color: #b39ddb !important;
}
.deep-purple .bg-primary.lighten-2 {
  background-color: #9575cd !important;
}
.deep-purple .bg-primary.lighten-1 {
  background-color: #7e57c2 !important;
}
.deep-purple .bg-primary.darken-1 {
  background-color: #5e35b1 !important;
}
.deep-purple .bg-primary.darken-2 {
  background-color: #512da8 !important;
}
.deep-purple .bg-primary.darken-3 {
  background-color: #4527a0 !important;
}
.deep-purple .bg-primary.darken-4 {
  background-color: #311b92 !important;
}
.deep-purple .bg-primary.accent-1 {
  background-color: #b388ff !important;
}
.deep-purple .bg-primary.accent-2 {
  background-color: #7c4dff !important;
}
.deep-purple .bg-primary.accent-3 {
  background-color: #651fff !important;
}
.deep-purple .bg-primary.accent-4 {
  background-color: #6200ea !important;
}

.deep-purple a.text-secondary {
  color: #FFAB00;
}
.deep-purple a.text-secondary:focus, .deep-purple a.text-secondary:hover {
  color: rgb(204, 136.8, 0) !important;
}
.deep-purple .text-secondary {
  color: #FFAB00 !important;
}
.deep-purple .bg-secondary, .deep-purple .badge-secondary {
  background-color: #FFAB00 !important;
  color: #fff !important;
}
.deep-purple .btn-secondary {
  background-color: #FFAB00;
  border-color: #FFAB00;
  color: #fff;
}
.deep-purple .btn-secondary:hover, .deep-purple .btn-secondary:focus, .deep-purple .btn-secondary:active {
  background-color: rgb(229.5, 153.9, 0) !important;
  border-color: rgb(229.5, 153.9, 0) !important;
  color: #fff !important;
}

.deep-purple .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.deep-purple .jr-flat-btn:hover, .deep-purple .jr-flat-btn:focus, .deep-purple .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.deep-purple .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #673ab7 !important;
  border-color: transparent !important;
}
.deep-purple .jr-flat-btn.jr-btn-primary:hover, .deep-purple .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(103, 58, 183, 0.12) !important;
  color: #673ab7 !important;
}

.deep-purple .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:hover, .deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.deep-purple .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FFAB00 !important;
  border-color: transparent !important;
}
.deep-purple .jr-flat-btn.jr-btn-secondary:hover, .deep-purple .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 171, 0, 0.12) !important;
  color: #FFAB00 !important;
}

.deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .deep-purple .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.deep-purple .color-theme-header {
  background-color: #673ab7;
}

.deep-purple .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
}
.deep-purple .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.deep-purple .side-nav .user-profile .text-white {
  color: #673ab7 !important;
}
.deep-purple .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.deep-purple .side-nav .user-detail .user-name {
  color: #673ab7;
}

.deep-purple ul.nav-menu li a {
  color: #868e96;
}

.deep-purple ul.nav-menu .nav-header {
  color: #868e96;
}

.deep-purple ul.nav-menu > li.open > a,
.deep-purple ul.nav-menu > li > a:hover,
.deep-purple ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #673ab7;
}

.deep-purple ul.nav-menu li.menu > a:focus:before,
.deep-purple ul.nav-menu li.menu > a:hover:before {
  color: #673ab7;
}

.deep-purple ul.nav-menu li ul {
  background-color: #fff;
}

.deep-purple ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.deep-purple ul.nav-menu li.menu.open > a:before,
.deep-purple ul.nav-menu li.menu > a:focus:before,
.deep-purple ul.nav-menu li.menu li > a:hover:before {
  color: #673ab7;
}

.deep-purple ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.deep-purple ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #673ab7;
}

.deep-purple ul.nav-menu li.menu .sub-menu li > a:hover,
.deep-purple ul.nav-menu li.menu .sub-menu li > a:focus,
.deep-purple ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.deep-purple ul.nav-menu li.menu .sub-menu li > a:focus:before,
.deep-purple ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #673ab7;
}

/*Header top Navbar Styles*/
.deep-purple .navbar-nav li:hover > a, .deep-purple .navbar-nav li:focus > a {
  color: #673ab7;
}
.deep-purple .navbar-nav li a {
  color: #333;
}
.deep-purple .navbar-nav li a:hover, .deep-purple .navbar-nav li a:focus {
  color: #673ab7;
}
.deep-purple .navbar-nav li.nav-item.active > a {
  color: #673ab7;
}
.deep-purple .navbar-nav ul.sub-menu li a.active, .deep-purple .navbar-nav ul.sub-menu li.active > a {
  color: #673ab7;
}
.deep-purple .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.deep-purple .navbar-nav .nav-arrow a:hover:before, .deep-purple .navbar-nav .nav-arrow a:focus:before {
  color: #673ab7;
}
.deep-purple .navbar-nav .nav-arrow:hover > a:before, .deep-purple .navbar-nav .nav-arrow:focus > a:before, .deep-purple .navbar-nav .nav-arrow.active > a:before {
  color: #673ab7;
}

.deep-purple .app-top-nav {
  background-color: #673ab7;
}
.deep-purple .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.deep-purple .app-top-nav .navbar-nav li.nav-item:hover > a, .deep-purple .app-top-nav .navbar-nav li.nav-item:focus > a, .deep-purple .app-top-nav .navbar-nav li.nav-item > a:hover, .deep-purple .app-top-nav .navbar-nav li.nav-item > a:focus, .deep-purple .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FFAB00;
}

.deep-purple .module-nav li a.active {
  border-color: #673ab7;
}

.deep-purple .rbc-event {
  background-color: #673ab7;
}

.deep-purple .rbc-event.rbc-selected {
  background-color: rgb(81.2033195021, 45.7261410788, 144.2738589212);
}

.deep-purple .rbc-slot-selection {
  background-color: rgba(103, 58, 183, 0.7);
}

.deep-purple .rbc-toolbar button:active,
.deep-purple .rbc-toolbar button.rbc-active {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.deep-purple .rbc-toolbar button:active:hover,
.deep-purple .rbc-toolbar button.rbc-active:hover,
.deep-purple .rbc-toolbar button:active:focus,
.deep-purple .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.deep-purple .rbc-toolbar button:focus {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.deep-purple .rbc-toolbar button:hover {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.deep-purple .rbc-day-slot .rbc-event {
  border-color: #673ab7;
}

.deep-purple .chat-sidenav-title {
  color: #673ab7;
}

.deep-purple .chat-user-item.active, .deep-purple .chat-user-item:hover {
  background-color: rgb(232.3817427386, 225.0062240664, 245.4937759336);
}

.deep-purple .contact-list i {
  color: #673ab7;
}

.deep-purple .Collapsible__trigger {
  background: #673ab7;
}

.deep-purple .categories-list li a:focus, .deep-purple .categories-list li a:hover, .deep-purple .categories-list li.active a {
  color: #673ab7;
}

.deep-purple .login-content .form-control:focus {
  border-color: #673ab7;
}

.deep-purple .filter-with-bg-color ul li a {
  border-color: #673ab7;
}
.deep-purple .filter-with-bg-color ul li a:hover, .deep-purple .filter-with-bg-color ul li a:focus, .deep-purple .filter-with-bg-color ul li a.active {
  background-color: #673ab7;
}

.deep-purple .profile-intro .icon {
  color: #673ab7;
}

.deep-purple .social-link li.active a, .deep-purple .social-link li a:hover, .deep-purple .social-link li a:focus {
  color: #FFAB00;
}

.deep-purple .actions {
  color: #FFAB00;
}

.deep-purple .table-hover tbody tr:hover {
  background-color: rgba(103, 58, 183, 0.075);
}

.deep-purple .border-primary {
  border-color: #673ab7 !important;
}

.deep-purple .app-logo-content {
  background-color: #673ab7;
}

.deep-purple .app-social-block .social-link button {
  border: solid 1px #673ab7;
  color: #673ab7;
}
.deep-purple .app-social-block .social-link button:hover, .deep-purple .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #673ab7;
}

.deep-purple .btn-group > .jr-btn.active,
.deep-purple .btn-group > .btn-default.active,
.deep-purple .btn-group-vertical > .jr-btn.active,
.deep-purple .btn-group-vertical > .btn-default.active {
  background-color: #673ab7;
  border-color: #673ab7;
}
.deep-purple .btn-group > .jr-flat-btn,
.deep-purple .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.deep-purple .btn-group > .jr-flat-btn.active,
.deep-purple .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #673ab7 !important;
  border-color: transparent !important;
}
.deep-purple .btn-group > .jr-flat-btn.active:hover, .deep-purple .btn-group > .jr-flat-btn.active:focus,
.deep-purple .btn-group-vertical > .jr-flat-btn.active:hover,
.deep-purple .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(103, 58, 183, 0.12) !important;
  color: #673ab7 !important;
}

.deep-purple .nav-pill-sales .nav-link.active {
  background-color: #673ab7;
  border-color: #673ab7;
}

.deep-purple .form-checkbox > input + .check,
.deep-purple .form-checkbox > input.sm + .check {
  color: #673ab7;
}

/*Theme Green Styles*/
.green .right-arrow {
  color: #4CAF50;
}
.green .right-arrow:after {
  color: #4CAF50;
}

.green .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.green .btn-primary:focus, .green .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.green .btn-primary.disabled, .green .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.green .btn-primary:not(:disabled):not(.disabled):active, .green .btn-primary:not(:disabled):not(.disabled).active, .show > .green .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.green .btn-primary:not(:disabled):not(.disabled):active:focus, .green .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .green .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.green .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.green .btn-secondary:focus, .green .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.green .btn-secondary.disabled, .green .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.green .btn-secondary:not(:disabled):not(.disabled):active, .green .btn-secondary:not(:disabled):not(.disabled).active, .show > .green .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.green .btn-secondary:not(:disabled):not(.disabled):active:focus, .green .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .green .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.green .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.green .btn-success:focus, .green .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.green .btn-success.disabled, .green .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.green .btn-success:not(:disabled):not(.disabled):active, .green .btn-success:not(:disabled):not(.disabled).active, .show > .green .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.green .btn-success:not(:disabled):not(.disabled):active:focus, .green .btn-success:not(:disabled):not(.disabled).active:focus, .show > .green .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.green .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.green .btn-info:focus, .green .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.green .btn-info.disabled, .green .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.green .btn-info:not(:disabled):not(.disabled):active, .green .btn-info:not(:disabled):not(.disabled).active, .show > .green .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.green .btn-info:not(:disabled):not(.disabled):active:focus, .green .btn-info:not(:disabled):not(.disabled).active:focus, .show > .green .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.green .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.green .btn-warning:focus, .green .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.green .btn-warning.disabled, .green .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.green .btn-warning:not(:disabled):not(.disabled):active, .green .btn-warning:not(:disabled):not(.disabled).active, .show > .green .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.green .btn-warning:not(:disabled):not(.disabled):active:focus, .green .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .green .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.green .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.green .btn-danger:focus, .green .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.green .btn-danger.disabled, .green .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.green .btn-danger:not(:disabled):not(.disabled):active, .green .btn-danger:not(:disabled):not(.disabled).active, .show > .green .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.green .btn-danger:not(:disabled):not(.disabled):active:focus, .green .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .green .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.green .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.green .btn-light:focus, .green .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.green .btn-light.disabled, .green .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.green .btn-light:not(:disabled):not(.disabled):active, .green .btn-light:not(:disabled):not(.disabled).active, .show > .green .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.green .btn-light:not(:disabled):not(.disabled):active:focus, .green .btn-light:not(:disabled):not(.disabled).active:focus, .show > .green .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.green .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.green .btn-dark:focus, .green .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.green .btn-dark.disabled, .green .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.green .btn-dark:not(:disabled):not(.disabled):active, .green .btn-dark:not(:disabled):not(.disabled).active, .show > .green .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.green .btn-dark:not(:disabled):not(.disabled):active:focus, .green .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .green .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.green a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.green a.btn-primary:focus, .green a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.green a.btn-primary.disabled, .green a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.green a.btn-primary:not(:disabled):not(.disabled):active, .green a.btn-primary:not(:disabled):not(.disabled).active, .show > .green a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.green a.btn-primary:not(:disabled):not(.disabled):active:focus, .green a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.green a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.green a.btn-secondary:focus, .green a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.green a.btn-secondary.disabled, .green a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.green a.btn-secondary:not(:disabled):not(.disabled):active, .green a.btn-secondary:not(:disabled):not(.disabled).active, .show > .green a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.green a.btn-secondary:not(:disabled):not(.disabled):active:focus, .green a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.green a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.green a.btn-success:focus, .green a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.green a.btn-success.disabled, .green a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.green a.btn-success:not(:disabled):not(.disabled):active, .green a.btn-success:not(:disabled):not(.disabled).active, .show > .green a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.green a.btn-success:not(:disabled):not(.disabled):active:focus, .green a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.green a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.green a.btn-info:focus, .green a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.green a.btn-info.disabled, .green a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.green a.btn-info:not(:disabled):not(.disabled):active, .green a.btn-info:not(:disabled):not(.disabled).active, .show > .green a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.green a.btn-info:not(:disabled):not(.disabled):active:focus, .green a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.green a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.green a.btn-warning:focus, .green a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.green a.btn-warning.disabled, .green a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.green a.btn-warning:not(:disabled):not(.disabled):active, .green a.btn-warning:not(:disabled):not(.disabled).active, .show > .green a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.green a.btn-warning:not(:disabled):not(.disabled):active:focus, .green a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.green a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.green a.btn-danger:focus, .green a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.green a.btn-danger.disabled, .green a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.green a.btn-danger:not(:disabled):not(.disabled):active, .green a.btn-danger:not(:disabled):not(.disabled).active, .show > .green a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.green a.btn-danger:not(:disabled):not(.disabled):active:focus, .green a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.green a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.green a.btn-light:focus, .green a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.green a.btn-light.disabled, .green a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.green a.btn-light:not(:disabled):not(.disabled):active, .green a.btn-light:not(:disabled):not(.disabled).active, .show > .green a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.green a.btn-light:not(:disabled):not(.disabled):active:focus, .green a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.green a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.green a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.green a.btn-dark:focus, .green a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.green a.btn-dark.disabled, .green a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.green a.btn-dark:not(:disabled):not(.disabled):active, .green a.btn-dark:not(:disabled):not(.disabled).active, .show > .green a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.green a.btn-dark:not(:disabled):not(.disabled):active:focus, .green a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.green .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.green .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.green .btn-outline-primary:focus, .green .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.green .btn-outline-primary.disabled, .green .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.green .btn-outline-primary:not(:disabled):not(.disabled):active, .green .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .green .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.green .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .green .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.green .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.green .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.green .btn-outline-secondary:focus, .green .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.green .btn-outline-secondary.disabled, .green .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.green .btn-outline-secondary:not(:disabled):not(.disabled):active, .green .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .green .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.green .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .green .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.green .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.green .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.green .btn-outline-success:focus, .green .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.green .btn-outline-success.disabled, .green .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.green .btn-outline-success:not(:disabled):not(.disabled):active, .green .btn-outline-success:not(:disabled):not(.disabled).active, .show > .green .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.green .btn-outline-success:not(:disabled):not(.disabled):active:focus, .green .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.green .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.green .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.green .btn-outline-info:focus, .green .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.green .btn-outline-info.disabled, .green .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.green .btn-outline-info:not(:disabled):not(.disabled):active, .green .btn-outline-info:not(:disabled):not(.disabled).active, .show > .green .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.green .btn-outline-info:not(:disabled):not(.disabled):active:focus, .green .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.green .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.green .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.green .btn-outline-warning:focus, .green .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.green .btn-outline-warning.disabled, .green .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.green .btn-outline-warning:not(:disabled):not(.disabled):active, .green .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .green .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.green .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .green .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.green .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.green .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.green .btn-outline-danger:focus, .green .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.green .btn-outline-danger.disabled, .green .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.green .btn-outline-danger:not(:disabled):not(.disabled):active, .green .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .green .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.green .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .green .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.green .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.green .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.green .btn-outline-light:focus, .green .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.green .btn-outline-light.disabled, .green .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.green .btn-outline-light:not(:disabled):not(.disabled):active, .green .btn-outline-light:not(:disabled):not(.disabled).active, .show > .green .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.green .btn-outline-light:not(:disabled):not(.disabled):active:focus, .green .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.green .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.green .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.green .btn-outline-dark:focus, .green .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.green .btn-outline-dark.disabled, .green .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.green .btn-outline-dark:not(:disabled):not(.disabled):active, .green .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .green .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.green .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .green .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .green .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.green a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.green a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.green a.btn-outline-primary:focus, .green a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.green a.btn-outline-primary.disabled, .green a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.green a.btn-outline-primary:not(:disabled):not(.disabled):active, .green a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.green a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.green a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.green a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.green a.btn-outline-secondary:focus, .green a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.green a.btn-outline-secondary.disabled, .green a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.green a.btn-outline-secondary:not(:disabled):not(.disabled):active, .green a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.green a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.green a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.green a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.green a.btn-outline-success:focus, .green a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.green a.btn-outline-success.disabled, .green a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.green a.btn-outline-success:not(:disabled):not(.disabled):active, .green a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.green a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.green a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.green a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.green a.btn-outline-info:focus, .green a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.green a.btn-outline-info.disabled, .green a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.green a.btn-outline-info:not(:disabled):not(.disabled):active, .green a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.green a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.green a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.green a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.green a.btn-outline-warning:focus, .green a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.green a.btn-outline-warning.disabled, .green a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.green a.btn-outline-warning:not(:disabled):not(.disabled):active, .green a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.green a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.green a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.green a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.green a.btn-outline-danger:focus, .green a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.green a.btn-outline-danger.disabled, .green a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.green a.btn-outline-danger:not(:disabled):not(.disabled):active, .green a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.green a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.green a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.green a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.green a.btn-outline-light:focus, .green a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.green a.btn-outline-light.disabled, .green a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.green a.btn-outline-light:not(:disabled):not(.disabled):active, .green a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.green a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.green a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.green a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.green a.btn-outline-dark:focus, .green a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.green a.btn-outline-dark.disabled, .green a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.green a.btn-outline-dark:not(:disabled):not(.disabled):active, .green a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .green a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.green a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .green a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .green a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.green .btn-outline-primary,
.green a.btn-outline-primary {
  color: #4CAF50;
  border-color: #4CAF50;
}
.green .btn-outline-primary:focus, .green .btn-outline-primary:hover, .green .btn-outline-primary.disabled, .green .btn-outline-primary:disabled, .green .btn-outline-primary:not(:disabled):not(.disabled):active, .green .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .green .btn-outline-primary.dropdown-toggle,
.green a.btn-outline-primary:focus,
.green a.btn-outline-primary:hover,
.green a.btn-outline-primary.disabled,
.green a.btn-outline-primary:disabled,
.green a.btn-outline-primary:not(:disabled):not(.disabled):active,
.green a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .green a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #4CAF50;
  background-color: #4CAF50;
}

.green .btn-outline-secondary,
.green a.btn-outline-secondary {
  color: #FF6D00;
  border-color: #FF6D00;
}
.green .btn-outline-secondary:focus, .green .btn-outline-secondary:hover, .green .btn-outline-secondary.disabled, .green .btn-outline-secondary:disabled, .green .btn-outline-secondary:not(:disabled):not(.disabled):active, .green .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .green .btn-outline-secondary.dropdown-toggle,
.green a.btn-outline-secondary:focus,
.green a.btn-outline-secondary:hover,
.green a.btn-outline-secondary.disabled,
.green a.btn-outline-secondary:disabled,
.green a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.green a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .green a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF6D00;
  background-color: #FF6D00;
}

.green a, .green a.text-primary {
  color: #4CAF50;
}
.green a:focus, .green a:hover, .green a.text-primary:focus, .green a.text-primary:hover {
  color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}
.green .text-primary {
  color: #4CAF50 !important;
}
.green .page-link {
  color: #4CAF50;
}
.green .page-link:focus, .green .page-link:hover {
  color: #4CAF50;
}
.green .bg-primary, .green .badge-primary {
  background-color: #4CAF50 !important;
  color: #fff !important;
}
.green .btn-primary, .green .jr-btn-primary, .green a.btn-primary, .green a.jr-btn-primary {
  background-color: #4CAF50;
  border-color: #4CAF50;
  color: #fff;
}
.green .btn-primary:hover, .green .btn-primary:focus, .green .btn-primary:not([disabled]):not(.disabled):active, .green .jr-btn-primary:hover, .green .jr-btn-primary:focus, .green .jr-btn-primary:not([disabled]):not(.disabled):active, .green a.btn-primary:hover, .green a.btn-primary:focus, .green a.btn-primary:not([disabled]):not(.disabled):active, .green a.jr-btn-primary:hover, .green a.jr-btn-primary:focus, .green a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(68.2788844622, 157.2211155378, 71.8725099602) !important;
  border-color: rgb(68.2788844622, 157.2211155378, 71.8725099602) !important;
  color: #fff !important;
}
.green .bg-primary.lighten-4 {
  background-color: #C8E6C9 !important;
}
.green .bg-primary.lighten-3 {
  background-color: #A5D6A7 !important;
}
.green .bg-primary.lighten-2 {
  background-color: #81C784 !important;
}
.green .bg-primary.lighten-1 {
  background-color: #66BB6A !important;
}
.green .bg-primary.darken-1 {
  background-color: #43A047 !important;
}
.green .bg-primary.darken-2 {
  background-color: #388E3C !important;
}
.green .bg-primary.darken-3 {
  background-color: #2E7D32 !important;
}
.green .bg-primary.darken-4 {
  background-color: #1B5E20 !important;
}
.green .bg-primary.accent-1 {
  background-color: #B9F6CA !important;
}
.green .bg-primary.accent-2 {
  background-color: #69F0AE !important;
}
.green .bg-primary.accent-3 {
  background-color: #00E676 !important;
}
.green .bg-primary.accent-4 {
  background-color: #00C853 !important;
}

.green a.text-secondary {
  color: #FF6D00;
}
.green a.text-secondary:focus, .green a.text-secondary:hover {
  color: rgb(204, 87.2, 0) !important;
}
.green .text-secondary {
  color: #FF6D00 !important;
}
.green .bg-secondary, .green .badge-secondary {
  background-color: #FF6D00 !important;
  color: #fff !important;
}
.green .btn-secondary {
  background-color: #FF6D00;
  border-color: #FF6D00;
  color: #fff;
}
.green .btn-secondary:hover, .green .btn-secondary:focus, .green .btn-secondary:active {
  background-color: rgb(229.5, 98.1, 0) !important;
  border-color: rgb(229.5, 98.1, 0) !important;
  color: #fff !important;
}

.green .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.green .jr-flat-btn:hover, .green .jr-flat-btn:focus, .green .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.green .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #4CAF50 !important;
  border-color: transparent !important;
}
.green .jr-flat-btn.jr-btn-primary:hover, .green .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(76, 175, 80, 0.12) !important;
  color: #4CAF50 !important;
}

.green .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.green .bg-primary .jr-flat-btn.jr-btn-primary:hover, .green .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.green .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF6D00 !important;
  border-color: transparent !important;
}
.green .jr-flat-btn.jr-btn-secondary:hover, .green .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 109, 0, 0.12) !important;
  color: #FF6D00 !important;
}

.green .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.green .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .green .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

@media screen and (max-width: 575px) {
  .green .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.green .color-theme-header {
  background-color: #4CAF50;
}

.green .side-nav {
  background-color: #fff !important;
  color: #868e96 !important;
  border-inline-end: solid 1px #e9ecef !important;
}
.green .side-nav .user-profile {
  background-color: #f8f9fa;
  position: relative;
  z-index: 2;
}
.green .side-nav .user-profile .text-white {
  color: #4CAF50 !important;
}
.green .side-nav .customizer {
  border-bottom: solid 1px rgb(229.5685840708, 231.25, 232.9314159292);
}
.green .side-nav .user-detail .user-name {
  color: #4CAF50;
}

.green ul.nav-menu li a {
  color: #868e96;
}

.green ul.nav-menu .nav-header {
  color: #868e96;
}

.green ul.nav-menu > li.open > a,
.green ul.nav-menu > li > a:hover,
.green ul.nav-menu > li > a:focus {
  background-color: #fff;
  color: #4CAF50;
}

.green ul.nav-menu li.menu > a:focus:before,
.green ul.nav-menu li.menu > a:hover:before {
  color: #4CAF50;
}

.green ul.nav-menu li ul {
  background-color: #fff;
}

.green ul.nav-menu li.menu > a:before {
  color: #868e96;
}

.green ul.nav-menu li.menu.open > a:before,
.green ul.nav-menu li.menu > a:focus:before,
.green ul.nav-menu li.menu li > a:hover:before {
  color: #4CAF50;
}

.green ul.nav-menu li.menu .sub-menu li > a:before {
  color: #868e96;
}

.green ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #4CAF50;
}

.green ul.nav-menu li.menu .sub-menu li > a:hover,
.green ul.nav-menu li.menu .sub-menu li > a:focus,
.green ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.green ul.nav-menu li.menu .sub-menu li > a:focus:before,
.green ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: #fff;
  color: #4CAF50;
}

/*Header top Navbar Styles*/
.green .navbar-nav li:hover > a, .green .navbar-nav li:focus > a {
  color: #4CAF50;
}
.green .navbar-nav li a {
  color: #333;
}
.green .navbar-nav li a:hover, .green .navbar-nav li a:focus {
  color: #4CAF50;
}
.green .navbar-nav li.nav-item.active > a {
  color: #4CAF50;
}
.green .navbar-nav ul.sub-menu li a.active, .green .navbar-nav ul.sub-menu li.active > a {
  color: #4CAF50;
}
.green .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.green .navbar-nav .nav-arrow a:hover:before, .green .navbar-nav .nav-arrow a:focus:before {
  color: #4CAF50;
}
.green .navbar-nav .nav-arrow:hover > a:before, .green .navbar-nav .nav-arrow:focus > a:before, .green .navbar-nav .nav-arrow.active > a:before {
  color: #4CAF50;
}

.green .app-top-nav {
  background-color: #4CAF50;
}
.green .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.green .app-top-nav .navbar-nav li.nav-item:hover > a, .green .app-top-nav .navbar-nav li.nav-item:focus > a, .green .app-top-nav .navbar-nav li.nav-item > a:hover, .green .app-top-nav .navbar-nav li.nav-item > a:focus, .green .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF6D00;
}

.green .module-nav li a.active {
  border-color: #4CAF50;
}

.green .rbc-event {
  background-color: #4CAF50;
}

.green .rbc-event.rbc-selected {
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}

.green .rbc-slot-selection {
  background-color: rgba(76, 175, 80, 0.7);
}

.green .rbc-toolbar button:active,
.green .rbc-toolbar button.rbc-active {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.green .rbc-toolbar button:active:hover,
.green .rbc-toolbar button.rbc-active:hover,
.green .rbc-toolbar button:active:focus,
.green .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.green .rbc-toolbar button:focus {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.green .rbc-toolbar button:hover {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.green .rbc-day-slot .rbc-event {
  border-color: #4CAF50;
}

.green .chat-sidenav-title {
  color: #4CAF50;
}

.green .chat-user-item.active, .green .chat-user-item:hover {
  background-color: rgb(234.4322709163, 246.0677290837, 234.9023904382);
}

.green .contact-list i {
  color: #4CAF50;
}

.green .Collapsible__trigger {
  background: #4CAF50;
}

.green .categories-list li a:focus, .green .categories-list li a:hover, .green .categories-list li.active a {
  color: #4CAF50;
}

.green .login-content .form-control:focus {
  border-color: #4CAF50;
}

.green .filter-with-bg-color ul li a {
  border-color: #4CAF50;
}
.green .filter-with-bg-color ul li a:hover, .green .filter-with-bg-color ul li a:focus, .green .filter-with-bg-color ul li a.active {
  background-color: #4CAF50;
}

.green .profile-intro .icon {
  color: #4CAF50;
}

.green .social-link li.active a, .green .social-link li a:hover, .green .social-link li a:focus {
  color: #FF6D00;
}

.green .actions {
  color: #FF6D00;
}

.green .table-hover tbody tr:hover {
  background-color: rgba(76, 175, 80, 0.075);
}

.green .border-primary {
  border-color: #4CAF50 !important;
}

.green .app-logo-content {
  background-color: #4CAF50;
}

.green .app-social-block .social-link button {
  border: solid 1px #4CAF50;
  color: #4CAF50;
}
.green .app-social-block .social-link button:hover, .green .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #4CAF50;
}

.green .btn-group > .jr-btn.active,
.green .btn-group > .btn-default.active,
.green .btn-group-vertical > .jr-btn.active,
.green .btn-group-vertical > .btn-default.active {
  background-color: #4CAF50;
  border-color: #4CAF50;
}
.green .btn-group > .jr-flat-btn,
.green .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.green .btn-group > .jr-flat-btn.active,
.green .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #4CAF50 !important;
  border-color: transparent !important;
}
.green .btn-group > .jr-flat-btn.active:hover, .green .btn-group > .jr-flat-btn.active:focus,
.green .btn-group-vertical > .jr-flat-btn.active:hover,
.green .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(76, 175, 80, 0.12) !important;
  color: #4CAF50 !important;
}

.green .nav-pill-sales .nav-link.active {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.green .form-checkbox > input + .check,
.green .form-checkbox > input.sm + .check {
  color: #4CAF50;
}

/*Theme Dark Indigo Styles*/
.dark-indigo .right-arrow {
  color: #3f51b5;
}
.dark-indigo .right-arrow:after {
  color: #3f51b5;
}

.dark-indigo .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-indigo .btn-primary:focus, .dark-indigo .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-indigo .btn-primary.disabled, .dark-indigo .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-indigo .btn-primary:not(:disabled):not(.disabled):active, .dark-indigo .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-indigo .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-indigo .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-indigo .btn-secondary:focus, .dark-indigo .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-indigo .btn-secondary.disabled, .dark-indigo .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-indigo .btn-secondary:not(:disabled):not(.disabled):active, .dark-indigo .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-indigo .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-indigo .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-indigo .btn-success:focus, .dark-indigo .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-indigo .btn-success.disabled, .dark-indigo .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-indigo .btn-success:not(:disabled):not(.disabled):active, .dark-indigo .btn-success:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-indigo .btn-success:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-indigo .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-indigo .btn-info:focus, .dark-indigo .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-indigo .btn-info.disabled, .dark-indigo .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-indigo .btn-info:not(:disabled):not(.disabled):active, .dark-indigo .btn-info:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-indigo .btn-info:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-indigo .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-indigo .btn-warning:focus, .dark-indigo .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-indigo .btn-warning.disabled, .dark-indigo .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-indigo .btn-warning:not(:disabled):not(.disabled):active, .dark-indigo .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-indigo .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-indigo .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-indigo .btn-danger:focus, .dark-indigo .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-indigo .btn-danger.disabled, .dark-indigo .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-indigo .btn-danger:not(:disabled):not(.disabled):active, .dark-indigo .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-indigo .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-indigo .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-indigo .btn-light:focus, .dark-indigo .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-indigo .btn-light.disabled, .dark-indigo .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-indigo .btn-light:not(:disabled):not(.disabled):active, .dark-indigo .btn-light:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-indigo .btn-light:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-indigo .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-indigo .btn-dark:focus, .dark-indigo .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-indigo .btn-dark.disabled, .dark-indigo .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-indigo .btn-dark:not(:disabled):not(.disabled):active, .dark-indigo .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-indigo .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-indigo a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-indigo a.btn-primary:focus, .dark-indigo a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-indigo a.btn-primary.disabled, .dark-indigo a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-indigo a.btn-primary:not(:disabled):not(.disabled):active, .dark-indigo a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-indigo a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-indigo a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-indigo a.btn-secondary:focus, .dark-indigo a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-indigo a.btn-secondary.disabled, .dark-indigo a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-indigo a.btn-secondary:not(:disabled):not(.disabled):active, .dark-indigo a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-indigo a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-indigo a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-indigo a.btn-success:focus, .dark-indigo a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-indigo a.btn-success.disabled, .dark-indigo a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-indigo a.btn-success:not(:disabled):not(.disabled):active, .dark-indigo a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-indigo a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-indigo a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-indigo a.btn-info:focus, .dark-indigo a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-indigo a.btn-info.disabled, .dark-indigo a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-indigo a.btn-info:not(:disabled):not(.disabled):active, .dark-indigo a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-indigo a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-indigo a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-indigo a.btn-warning:focus, .dark-indigo a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-indigo a.btn-warning.disabled, .dark-indigo a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-indigo a.btn-warning:not(:disabled):not(.disabled):active, .dark-indigo a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-indigo a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-indigo a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-indigo a.btn-danger:focus, .dark-indigo a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-indigo a.btn-danger.disabled, .dark-indigo a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-indigo a.btn-danger:not(:disabled):not(.disabled):active, .dark-indigo a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-indigo a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-indigo a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-indigo a.btn-light:focus, .dark-indigo a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-indigo a.btn-light.disabled, .dark-indigo a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-indigo a.btn-light:not(:disabled):not(.disabled):active, .dark-indigo a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-indigo a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-indigo a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-indigo a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-indigo a.btn-dark:focus, .dark-indigo a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-indigo a.btn-dark.disabled, .dark-indigo a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-indigo a.btn-dark:not(:disabled):not(.disabled):active, .dark-indigo a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-indigo a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-indigo .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-indigo .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-indigo .btn-outline-primary:focus, .dark-indigo .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-indigo .btn-outline-primary.disabled, .dark-indigo .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-indigo .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-indigo .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-indigo .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-indigo .btn-outline-secondary:focus, .dark-indigo .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-indigo .btn-outline-secondary.disabled, .dark-indigo .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-indigo .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-indigo .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-indigo .btn-outline-success:focus, .dark-indigo .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-indigo .btn-outline-success.disabled, .dark-indigo .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-indigo .btn-outline-success:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-indigo .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-indigo .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-indigo .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-indigo .btn-outline-info:focus, .dark-indigo .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-indigo .btn-outline-info.disabled, .dark-indigo .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-indigo .btn-outline-info:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-indigo .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-indigo .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-indigo .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-indigo .btn-outline-warning:focus, .dark-indigo .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-indigo .btn-outline-warning.disabled, .dark-indigo .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-indigo .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-indigo .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-indigo .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-indigo .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-indigo .btn-outline-danger:focus, .dark-indigo .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-indigo .btn-outline-danger.disabled, .dark-indigo .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-indigo .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-indigo .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-indigo .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-indigo .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-indigo .btn-outline-light:focus, .dark-indigo .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-indigo .btn-outline-light.disabled, .dark-indigo .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-indigo .btn-outline-light:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-indigo .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-indigo .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-indigo .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-indigo .btn-outline-dark:focus, .dark-indigo .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-indigo .btn-outline-dark.disabled, .dark-indigo .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-indigo .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-indigo .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-indigo .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-indigo a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-indigo a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-indigo a.btn-outline-primary:focus, .dark-indigo a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-indigo a.btn-outline-primary.disabled, .dark-indigo a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-indigo a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-indigo a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-indigo a.btn-outline-secondary:focus, .dark-indigo a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-indigo a.btn-outline-secondary.disabled, .dark-indigo a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-indigo a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-indigo a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-indigo a.btn-outline-success:focus, .dark-indigo a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-indigo a.btn-outline-success.disabled, .dark-indigo a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-indigo a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-indigo a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-indigo a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-indigo a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-indigo a.btn-outline-info:focus, .dark-indigo a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-indigo a.btn-outline-info.disabled, .dark-indigo a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-indigo a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-indigo a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-indigo a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-indigo a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-indigo a.btn-outline-warning:focus, .dark-indigo a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-indigo a.btn-outline-warning.disabled, .dark-indigo a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-indigo a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-indigo a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-indigo a.btn-outline-danger:focus, .dark-indigo a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-indigo a.btn-outline-danger.disabled, .dark-indigo a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-indigo a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-indigo a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-indigo a.btn-outline-light:focus, .dark-indigo a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-indigo a.btn-outline-light.disabled, .dark-indigo a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-indigo a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-indigo a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-indigo a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-indigo a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-indigo a.btn-outline-dark:focus, .dark-indigo a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-indigo a.btn-outline-dark.disabled, .dark-indigo a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-indigo a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-indigo a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-indigo a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-indigo .btn-outline-primary,
.dark-indigo a.btn-outline-primary {
  color: #3f51b5;
  border-color: #3f51b5;
}
.dark-indigo .btn-outline-primary:focus, .dark-indigo .btn-outline-primary:hover, .dark-indigo .btn-outline-primary.disabled, .dark-indigo .btn-outline-primary:disabled, .dark-indigo .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-primary.dropdown-toggle,
.dark-indigo a.btn-outline-primary:focus,
.dark-indigo a.btn-outline-primary:hover,
.dark-indigo a.btn-outline-primary.disabled,
.dark-indigo a.btn-outline-primary:disabled,
.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-indigo a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-indigo a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #3f51b5;
  background-color: #3f51b5;
}

.dark-indigo .btn-outline-secondary,
.dark-indigo a.btn-outline-secondary {
  color: #FF4081;
  border-color: #FF4081;
}
.dark-indigo .btn-outline-secondary:focus, .dark-indigo .btn-outline-secondary:hover, .dark-indigo .btn-outline-secondary.disabled, .dark-indigo .btn-outline-secondary:disabled, .dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-indigo .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-indigo .btn-outline-secondary.dropdown-toggle,
.dark-indigo a.btn-outline-secondary:focus,
.dark-indigo a.btn-outline-secondary:hover,
.dark-indigo a.btn-outline-secondary.disabled,
.dark-indigo a.btn-outline-secondary:disabled,
.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-indigo a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-indigo a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF4081;
  background-color: #FF4081;
}

.dark-indigo a, .dark-indigo a.text-primary {
  color: #3f51b5;
}
.dark-indigo a:focus, .dark-indigo a:hover, .dark-indigo a.text-primary:focus, .dark-indigo a.text-primary:hover {
  color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}
.dark-indigo .text-primary {
  color: #3f51b5 !important;
}
.dark-indigo .page-link {
  color: #3f51b5;
}
.dark-indigo .page-link:focus, .dark-indigo .page-link:hover {
  color: #3f51b5;
}
.dark-indigo .bg-primary, .dark-indigo .badge-primary {
  background-color: #3f51b5 !important;
  color: #fff !important;
}
.dark-indigo .btn-primary, .dark-indigo .jr-btn-primary, .dark-indigo a.btn-primary, .dark-indigo a.jr-btn-primary {
  background-color: #3f51b5;
  border-color: #3f51b5;
  color: #fff;
}
.dark-indigo .btn-primary:hover, .dark-indigo .btn-primary:focus, .dark-indigo .btn-primary:not([disabled]):not(.disabled):active, .dark-indigo .jr-btn-primary:hover, .dark-indigo .jr-btn-primary:focus, .dark-indigo .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-indigo a.btn-primary:hover, .dark-indigo a.btn-primary:focus, .dark-indigo a.btn-primary:not([disabled]):not(.disabled):active, .dark-indigo a.jr-btn-primary:hover, .dark-indigo a.jr-btn-primary:focus, .dark-indigo a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(56.4159836066, 72.5348360656, 162.0840163934) !important;
  border-color: rgb(56.4159836066, 72.5348360656, 162.0840163934) !important;
  color: #fff !important;
}
.dark-indigo .bg-primary.lighten-4 {
  background-color: #c5cae9 !important;
}
.dark-indigo .bg-primary.lighten-3 {
  background-color: #9fa8da !important;
}
.dark-indigo .bg-primary.lighten-2 {
  background-color: #7986cb !important;
}
.dark-indigo .bg-primary.lighten-1 {
  background-color: #5c6bc0 !important;
}
.dark-indigo .bg-primary.darken-1 {
  background-color: #3949ab !important;
}
.dark-indigo .bg-primary.darken-2 {
  background-color: #303f9f !important;
}
.dark-indigo .bg-primary.darken-3 {
  background-color: #283593 !important;
}
.dark-indigo .bg-primary.darken-4 {
  background-color: #1a237e !important;
}
.dark-indigo .bg-primary.accent-1 {
  background-color: #8c9eff !important;
}
.dark-indigo .bg-primary.accent-2 {
  background-color: #536dfe !important;
}
.dark-indigo .bg-primary.accent-3 {
  background-color: #3d5afe !important;
}
.dark-indigo .bg-primary.accent-4 {
  background-color: #304ffe !important;
}

.dark-indigo a.text-secondary {
  color: #FF4081;
}
.dark-indigo a.text-secondary:focus, .dark-indigo a.text-secondary:hover {
  color: rgb(255, 13, 95.3560209424) !important;
}
.dark-indigo .text-secondary {
  color: #FF4081 !important;
}
.dark-indigo .bg-secondary, .dark-indigo .badge-secondary {
  background-color: #FF4081 !important;
  color: #fff !important;
}
.dark-indigo .btn-secondary {
  background-color: #FF4081;
  border-color: #FF4081;
  color: #fff;
}
.dark-indigo .btn-secondary:hover, .dark-indigo .btn-secondary:focus, .dark-indigo .btn-secondary:active {
  background-color: rgb(255, 38.5, 112.1780104712) !important;
  border-color: rgb(255, 38.5, 112.1780104712) !important;
  color: #fff !important;
}

.dark-indigo .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-indigo .jr-flat-btn:hover, .dark-indigo .jr-flat-btn:focus, .dark-indigo .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-indigo .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #3f51b5 !important;
  border-color: transparent !important;
}
.dark-indigo .jr-flat-btn.jr-btn-primary:hover, .dark-indigo .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(63, 81, 181, 0.12) !important;
  color: #3f51b5 !important;
}

.dark-indigo .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-indigo .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-indigo .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-indigo .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF4081 !important;
  border-color: transparent !important;
}
.dark-indigo .jr-flat-btn.jr-btn-secondary:hover, .dark-indigo .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 64, 129, 0.12) !important;
  color: #FF4081 !important;
}

.dark-indigo .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-indigo .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-indigo .app-main-header {
  background-color: #3f51b5 !important;
  color: #fff;
  border-color: #3f51b5;
}
.dark-indigo .app-main-header .search-bar input {
  background-color: rgb(76.5963114754, 94.3381147541, 192.9036885246);
}
.dark-indigo .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-indigo .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-indigo .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-indigo .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-indigo .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-indigo .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-indigo .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-indigo .quick-menu .icon-btn {
  color: #fff;
}

.dark-indigo .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-indigo .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-indigo .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-indigo .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-indigo .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-indigo .color-theme-header {
  background-color: #3f51b5;
}

.dark-indigo .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-indigo .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-indigo .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-indigo .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-indigo .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-indigo ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-indigo ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-indigo ul.nav-menu > li.open > a,
.dark-indigo ul.nav-menu > li > a:hover,
.dark-indigo ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-indigo ul.nav-menu li.menu.open > a {
  border-color: #3f51b5;
}

.dark-indigo ul.nav-menu li.menu > a:focus:before,
.dark-indigo ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-indigo ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-indigo ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-indigo ul.nav-menu li.menu.open > a:before,
.dark-indigo ul.nav-menu li.menu > a:focus:before,
.dark-indigo ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-indigo ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-indigo ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #3f51b5;
}

.dark-indigo ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-indigo ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-indigo ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-indigo ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-indigo ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-indigo .navbar-nav li:hover > a, .dark-indigo .navbar-nav li:focus > a {
  color: #3f51b5;
}
.dark-indigo .navbar-nav li a {
  color: #333;
}
.dark-indigo .navbar-nav li a:hover, .dark-indigo .navbar-nav li a:focus {
  color: #3f51b5;
}
.dark-indigo .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-indigo .navbar-nav li.nav-item:hover > a, .dark-indigo .navbar-nav li.nav-item:focus > a, .dark-indigo .navbar-nav li.nav-item > a:hover, .dark-indigo .navbar-nav li.nav-item > a:focus, .dark-indigo .navbar-nav li.nav-item.active > a {
  color: #FF4081;
}
.dark-indigo .navbar-nav ul.sub-menu li a.active, .dark-indigo .navbar-nav ul.sub-menu li.active > a {
  color: #3f51b5;
}
.dark-indigo .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-indigo .navbar-nav .nav-arrow a:hover:before, .dark-indigo .navbar-nav .nav-arrow a:focus:before {
  color: #3f51b5;
}
.dark-indigo .navbar-nav .nav-arrow:hover > a:before, .dark-indigo .navbar-nav .nav-arrow:focus > a:before, .dark-indigo .navbar-nav .nav-arrow.active > a:before {
  color: #3f51b5;
}

.dark-indigo .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-indigo .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-indigo .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-indigo .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-indigo .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-indigo .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-indigo .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF4081;
}

.dark-indigo .module-nav li a.active {
  color: #3f51b5;
}

.dark-indigo .rbc-event {
  background-color: #3f51b5;
}

.dark-indigo .rbc-event.rbc-selected {
  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}

.dark-indigo .rbc-slot-selection {
  background-color: rgba(63, 81, 181, 0.7);
}

.dark-indigo .rbc-toolbar button:active,
.dark-indigo .rbc-toolbar button.rbc-active {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.dark-indigo .rbc-toolbar button:active:hover,
.dark-indigo .rbc-toolbar button.rbc-active:hover,
.dark-indigo .rbc-toolbar button:active:focus,
.dark-indigo .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.dark-indigo .rbc-toolbar button:focus {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.dark-indigo .rbc-toolbar button:hover {
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.dark-indigo .rbc-day-slot .rbc-event {
  border-color: #3f51b5;
}

.dark-indigo .chat-sidenav-title {
  color: #3f51b5;
}

.dark-indigo .chat-user-item.active, .dark-indigo .chat-user-item:hover {
  background-color: rgb(227.9241803279, 230.6168032787, 245.5758196721);
}

.dark-indigo .contact-list i {
  color: #3f51b5;
}

.dark-indigo .Collapsible__trigger {
  background: #3f51b5;
}

.dark-indigo .categories-list li a:focus, .dark-indigo .categories-list li a:hover, .dark-indigo .categories-list li.active a {
  color: #3f51b5;
}

.dark-indigo .login-content .form-control:focus {
  border-color: #3f51b5;
}

.dark-indigo .filter-with-bg-color ul li a {
  border-color: #3f51b5;
}
.dark-indigo .filter-with-bg-color ul li a:hover, .dark-indigo .filter-with-bg-color ul li a:focus, .dark-indigo .filter-with-bg-color ul li a.active {
  background-color: #3f51b5;
}

.dark-indigo .profile-intro .icon {
  color: #3f51b5;
}

.dark-indigo .social-link li.active a, .dark-indigo .social-link li a:hover, .dark-indigo .social-link li a:focus {
  color: #FF4081;
}

.dark-indigo .actions {
  color: #FF4081;
}

.dark-indigo .table-hover tbody tr:hover {
  background-color: rgba(63, 81, 181, 0.075);
}

.dark-indigo .border-primary {
  border-color: #3f51b5 !important;
}

.dark-indigo .app-logo-content {
  background-color: #3f51b5;
}

.dark-indigo .app-social-block .social-link button {
  border: solid 1px #3f51b5;
  color: #3f51b5;
}
.dark-indigo .app-social-block .social-link button:hover, .dark-indigo .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #3f51b5;
}

.dark-indigo .btn-group > .jr-btn.active,
.dark-indigo .btn-group > .btn-default.active,
.dark-indigo .btn-group-vertical > .jr-btn.active,
.dark-indigo .btn-group-vertical > .btn-default.active {
  background-color: #3f51b5;
  border-color: #3f51b5;
}
.dark-indigo .btn-group > .jr-flat-btn,
.dark-indigo .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-indigo .btn-group > .jr-flat-btn.active,
.dark-indigo .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #3f51b5 !important;
  border-color: transparent !important;
}
.dark-indigo .btn-group > .jr-flat-btn.active:hover, .dark-indigo .btn-group > .jr-flat-btn.active:focus,
.dark-indigo .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-indigo .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(63, 81, 181, 0.12) !important;
  color: #3f51b5 !important;
}

.dark-indigo .nav-pill-sales .nav-link.active {
  background-color: #3f51b5;
  border-color: #3f51b5;
}

.dark-indigo .switch.on {
  background: #3f51b5;
}

.dark-indigo .form-checkbox > input + .check,
.dark-indigo .form-checkbox > input.sm + .check {
  color: #3f51b5;
}

/* Input Placeholder Style */
.dark-indigo .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-indigo .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-indigo .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-indigo .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-indigo .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-indigo .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-indigo .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-indigo .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Cyan Styles*/
.dark-cyan .right-arrow {
  color: #00bcd4;
}
.dark-cyan .right-arrow:after {
  color: #00bcd4;
}

.dark-cyan .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-cyan .btn-primary:focus, .dark-cyan .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-cyan .btn-primary.disabled, .dark-cyan .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-cyan .btn-primary:not(:disabled):not(.disabled):active, .dark-cyan .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-cyan .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-cyan .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-cyan .btn-secondary:focus, .dark-cyan .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-cyan .btn-secondary.disabled, .dark-cyan .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-cyan .btn-secondary:not(:disabled):not(.disabled):active, .dark-cyan .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-cyan .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-cyan .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-cyan .btn-success:focus, .dark-cyan .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-cyan .btn-success.disabled, .dark-cyan .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-cyan .btn-success:not(:disabled):not(.disabled):active, .dark-cyan .btn-success:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-cyan .btn-success:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-cyan .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-cyan .btn-info:focus, .dark-cyan .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-cyan .btn-info.disabled, .dark-cyan .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan .btn-info:not(:disabled):not(.disabled):active, .dark-cyan .btn-info:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-cyan .btn-info:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-cyan .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-cyan .btn-warning:focus, .dark-cyan .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-cyan .btn-warning.disabled, .dark-cyan .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-cyan .btn-warning:not(:disabled):not(.disabled):active, .dark-cyan .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-cyan .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-cyan .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-cyan .btn-danger:focus, .dark-cyan .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-cyan .btn-danger.disabled, .dark-cyan .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-cyan .btn-danger:not(:disabled):not(.disabled):active, .dark-cyan .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-cyan .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-cyan .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-cyan .btn-light:focus, .dark-cyan .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-cyan .btn-light.disabled, .dark-cyan .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-cyan .btn-light:not(:disabled):not(.disabled):active, .dark-cyan .btn-light:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-cyan .btn-light:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-cyan .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-cyan .btn-dark:focus, .dark-cyan .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-cyan .btn-dark.disabled, .dark-cyan .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-cyan .btn-dark:not(:disabled):not(.disabled):active, .dark-cyan .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-cyan .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-cyan a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-cyan a.btn-primary:focus, .dark-cyan a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-cyan a.btn-primary.disabled, .dark-cyan a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-cyan a.btn-primary:not(:disabled):not(.disabled):active, .dark-cyan a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-cyan a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-cyan a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-cyan a.btn-secondary:focus, .dark-cyan a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-cyan a.btn-secondary.disabled, .dark-cyan a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-cyan a.btn-secondary:not(:disabled):not(.disabled):active, .dark-cyan a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-cyan a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-cyan a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-cyan a.btn-success:focus, .dark-cyan a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-cyan a.btn-success.disabled, .dark-cyan a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-cyan a.btn-success:not(:disabled):not(.disabled):active, .dark-cyan a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-cyan a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-cyan a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-cyan a.btn-info:focus, .dark-cyan a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-cyan a.btn-info.disabled, .dark-cyan a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan a.btn-info:not(:disabled):not(.disabled):active, .dark-cyan a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-cyan a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-cyan a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-cyan a.btn-warning:focus, .dark-cyan a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-cyan a.btn-warning.disabled, .dark-cyan a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-cyan a.btn-warning:not(:disabled):not(.disabled):active, .dark-cyan a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-cyan a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-cyan a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-cyan a.btn-danger:focus, .dark-cyan a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-cyan a.btn-danger.disabled, .dark-cyan a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-cyan a.btn-danger:not(:disabled):not(.disabled):active, .dark-cyan a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-cyan a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-cyan a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-cyan a.btn-light:focus, .dark-cyan a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-cyan a.btn-light.disabled, .dark-cyan a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-cyan a.btn-light:not(:disabled):not(.disabled):active, .dark-cyan a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-cyan a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-cyan a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-cyan a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-cyan a.btn-dark:focus, .dark-cyan a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-cyan a.btn-dark.disabled, .dark-cyan a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-cyan a.btn-dark:not(:disabled):not(.disabled):active, .dark-cyan a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-cyan a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-cyan .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-cyan .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-cyan .btn-outline-primary:focus, .dark-cyan .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-cyan .btn-outline-primary.disabled, .dark-cyan .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-cyan .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-cyan .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-cyan .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-cyan .btn-outline-secondary:focus, .dark-cyan .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-cyan .btn-outline-secondary.disabled, .dark-cyan .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-cyan .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-cyan .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-cyan .btn-outline-success:focus, .dark-cyan .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-cyan .btn-outline-success.disabled, .dark-cyan .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-cyan .btn-outline-success:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-cyan .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-cyan .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-cyan .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan .btn-outline-info:focus, .dark-cyan .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-cyan .btn-outline-info.disabled, .dark-cyan .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-cyan .btn-outline-info:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-cyan .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-cyan .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-cyan .btn-outline-warning:focus, .dark-cyan .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-cyan .btn-outline-warning.disabled, .dark-cyan .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-cyan .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-cyan .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-cyan .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-cyan .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-cyan .btn-outline-danger:focus, .dark-cyan .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-cyan .btn-outline-danger.disabled, .dark-cyan .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-cyan .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-cyan .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-cyan .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-cyan .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-cyan .btn-outline-light:focus, .dark-cyan .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-cyan .btn-outline-light.disabled, .dark-cyan .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-cyan .btn-outline-light:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-cyan .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-cyan .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-cyan .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-cyan .btn-outline-dark:focus, .dark-cyan .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-cyan .btn-outline-dark.disabled, .dark-cyan .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-cyan .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-cyan .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-cyan .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-cyan a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-cyan a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-cyan a.btn-outline-primary:focus, .dark-cyan a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-cyan a.btn-outline-primary.disabled, .dark-cyan a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-cyan a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-cyan a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-cyan a.btn-outline-secondary:focus, .dark-cyan a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-cyan a.btn-outline-secondary.disabled, .dark-cyan a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-cyan a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-cyan a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-cyan a.btn-outline-success:focus, .dark-cyan a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-cyan a.btn-outline-success.disabled, .dark-cyan a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-cyan a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-cyan a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-cyan a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-cyan a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan a.btn-outline-info:focus, .dark-cyan a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-cyan a.btn-outline-info.disabled, .dark-cyan a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-cyan a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-cyan a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-cyan a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-cyan a.btn-outline-warning:focus, .dark-cyan a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-cyan a.btn-outline-warning.disabled, .dark-cyan a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-cyan a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-cyan a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-cyan a.btn-outline-danger:focus, .dark-cyan a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-cyan a.btn-outline-danger.disabled, .dark-cyan a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-cyan a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-cyan a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-cyan a.btn-outline-light:focus, .dark-cyan a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-cyan a.btn-outline-light.disabled, .dark-cyan a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-cyan a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-cyan a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-cyan a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-cyan a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-cyan a.btn-outline-dark:focus, .dark-cyan a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-cyan a.btn-outline-dark.disabled, .dark-cyan a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-cyan a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-cyan a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-cyan a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-cyan .btn-outline-primary,
.dark-cyan a.btn-outline-primary {
  color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan .btn-outline-primary:focus, .dark-cyan .btn-outline-primary:hover, .dark-cyan .btn-outline-primary.disabled, .dark-cyan .btn-outline-primary:disabled, .dark-cyan .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-primary.dropdown-toggle,
.dark-cyan a.btn-outline-primary:focus,
.dark-cyan a.btn-outline-primary:hover,
.dark-cyan a.btn-outline-primary.disabled,
.dark-cyan a.btn-outline-primary:disabled,
.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-cyan a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-cyan a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #00bcd4;
  background-color: #00bcd4;
}

.dark-cyan .btn-outline-secondary,
.dark-cyan a.btn-outline-secondary {
  color: #69F0AE;
  border-color: #69F0AE;
}
.dark-cyan .btn-outline-secondary:focus, .dark-cyan .btn-outline-secondary:hover, .dark-cyan .btn-outline-secondary.disabled, .dark-cyan .btn-outline-secondary:disabled, .dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-cyan .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-cyan .btn-outline-secondary.dropdown-toggle,
.dark-cyan a.btn-outline-secondary:focus,
.dark-cyan a.btn-outline-secondary:hover,
.dark-cyan a.btn-outline-secondary.disabled,
.dark-cyan a.btn-outline-secondary:disabled,
.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-cyan a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-cyan a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #69F0AE;
  background-color: #69F0AE;
}

.dark-cyan a, .dark-cyan a.text-primary {
  color: #00bcd4;
}
.dark-cyan a:focus, .dark-cyan a:hover, .dark-cyan a.text-primary:focus, .dark-cyan a.text-primary:hover {
  color: rgb(0, 142.7735849057, 161);
}
.dark-cyan .text-primary {
  color: #00bcd4 !important;
}
.dark-cyan .page-link {
  color: #00bcd4;
}
.dark-cyan .page-link:focus, .dark-cyan .page-link:hover {
  color: #00bcd4;
}
.dark-cyan .bg-primary, .dark-cyan .badge-primary {
  background-color: #00bcd4 !important;
  color: #fff !important;
}
.dark-cyan .btn-primary, .dark-cyan .jr-btn-primary, .dark-cyan a.btn-primary, .dark-cyan a.jr-btn-primary {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
}
.dark-cyan .btn-primary:hover, .dark-cyan .btn-primary:focus, .dark-cyan .btn-primary:not([disabled]):not(.disabled):active, .dark-cyan .jr-btn-primary:hover, .dark-cyan .jr-btn-primary:focus, .dark-cyan .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-cyan a.btn-primary:hover, .dark-cyan a.btn-primary:focus, .dark-cyan a.btn-primary:not([disabled]):not(.disabled):active, .dark-cyan a.jr-btn-primary:hover, .dark-cyan a.jr-btn-primary:focus, .dark-cyan a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(0, 165.3867924528, 186.5) !important;
  border-color: rgb(0, 165.3867924528, 186.5) !important;
  color: #fff !important;
}
.dark-cyan .bg-primary.lighten-4 {
  background-color: #b2ebf2 !important;
}
.dark-cyan .bg-primary.lighten-3 {
  background-color: #80deea !important;
}
.dark-cyan .bg-primary.lighten-2 {
  background-color: #4dd0e1 !important;
}
.dark-cyan .bg-primary.lighten-1 {
  background-color: #26c6da !important;
}
.dark-cyan .bg-primary.darken-1 {
  background-color: #00acc1 !important;
}
.dark-cyan .bg-primary.darken-2 {
  background-color: #0097a7 !important;
}
.dark-cyan .bg-primary.darken-3 {
  background-color: #00838f !important;
}
.dark-cyan .bg-primary.darken-4 {
  background-color: #006064 !important;
}
.dark-cyan .bg-primary.accent-1 {
  background-color: #84ffff !important;
}
.dark-cyan .bg-primary.accent-2 {
  background-color: #18ffff !important;
}
.dark-cyan .bg-primary.accent-3 {
  background-color: #00e5ff !important;
}
.dark-cyan .bg-primary.accent-4 {
  background-color: #00b8d4 !important;
}

.dark-cyan a.text-secondary {
  color: #69F0AE;
}
.dark-cyan a.text-secondary:focus, .dark-cyan a.text-secondary:hover {
  color: rgb(58.6363636364, 235.3636363636, 148.9636363636) !important;
}
.dark-cyan .text-secondary {
  color: #69F0AE !important;
}
.dark-cyan .bg-secondary, .dark-cyan .badge-secondary {
  background-color: #69F0AE !important;
  color: #fff !important;
}
.dark-cyan .btn-secondary {
  background-color: #69F0AE;
  border-color: #69F0AE;
  color: #fff;
}
.dark-cyan .btn-secondary:hover, .dark-cyan .btn-secondary:focus, .dark-cyan .btn-secondary:active {
  background-color: rgb(81.8181818182, 237.6818181818, 161.4818181818) !important;
  border-color: rgb(81.8181818182, 237.6818181818, 161.4818181818) !important;
  color: #fff !important;
}

.dark-cyan .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-cyan .jr-flat-btn:hover, .dark-cyan .jr-flat-btn:focus, .dark-cyan .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-cyan .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #00bcd4 !important;
  border-color: transparent !important;
}
.dark-cyan .jr-flat-btn.jr-btn-primary:hover, .dark-cyan .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(0, 188, 212, 0.12) !important;
  color: #00bcd4 !important;
}

.dark-cyan .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-cyan .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-cyan .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-cyan .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #69F0AE !important;
  border-color: transparent !important;
}
.dark-cyan .jr-flat-btn.jr-btn-secondary:hover, .dark-cyan .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(105, 240, 174, 0.12) !important;
  color: #69F0AE !important;
}

.dark-cyan .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-cyan .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-cyan .app-main-header {
  background-color: #00bcd4 !important;
  color: #fff;
  border-color: #00bcd4;
}
.dark-cyan .app-main-header .search-bar input {
  background-color: rgb(0, 210.6132075472, 237.5);
}
.dark-cyan .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-cyan .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-cyan .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-cyan .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-cyan .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-cyan .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-cyan .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-cyan .quick-menu .icon-btn {
  color: #fff;
}

.dark-cyan .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-cyan .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-cyan .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-cyan .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-cyan .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-cyan .color-theme-header {
  background-color: #00bcd4;
}

.dark-cyan .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-cyan .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-cyan .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-cyan .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-cyan .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-cyan ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-cyan ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-cyan ul.nav-menu > li.open > a,
.dark-cyan ul.nav-menu > li > a:hover,
.dark-cyan ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-cyan ul.nav-menu li.menu.open > a {
  border-color: #00bcd4;
}

.dark-cyan ul.nav-menu li.menu > a:focus:before,
.dark-cyan ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-cyan ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-cyan ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-cyan ul.nav-menu li.menu.open > a:before,
.dark-cyan ul.nav-menu li.menu > a:focus:before,
.dark-cyan ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-cyan ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-cyan ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #00bcd4;
}

.dark-cyan ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-cyan ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-cyan ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-cyan ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-cyan ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-cyan .navbar-nav li:hover > a, .dark-cyan .navbar-nav li:focus > a {
  color: #00bcd4;
}
.dark-cyan .navbar-nav li a {
  color: #333;
}
.dark-cyan .navbar-nav li a:hover, .dark-cyan .navbar-nav li a:focus {
  color: #00bcd4;
}
.dark-cyan .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-cyan .navbar-nav li.nav-item:hover > a, .dark-cyan .navbar-nav li.nav-item:focus > a, .dark-cyan .navbar-nav li.nav-item > a:hover, .dark-cyan .navbar-nav li.nav-item > a:focus, .dark-cyan .navbar-nav li.nav-item.active > a {
  color: #69F0AE;
}
.dark-cyan .navbar-nav ul.sub-menu li a.active, .dark-cyan .navbar-nav ul.sub-menu li.active > a {
  color: #00bcd4;
}
.dark-cyan .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-cyan .navbar-nav .nav-arrow a:hover:before, .dark-cyan .navbar-nav .nav-arrow a:focus:before {
  color: #00bcd4;
}
.dark-cyan .navbar-nav .nav-arrow:hover > a:before, .dark-cyan .navbar-nav .nav-arrow:focus > a:before, .dark-cyan .navbar-nav .nav-arrow.active > a:before {
  color: #00bcd4;
}

.dark-cyan .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-cyan .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-cyan .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-cyan .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-cyan .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-cyan .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-cyan .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #69F0AE;
}

.dark-cyan .module-nav li a.active {
  border-color: #00bcd4;
}

.dark-cyan .rbc-event {
  background-color: #00bcd4;
}

.dark-cyan .rbc-event.rbc-selected {
  background-color: rgb(0, 142.7735849057, 161);
}

.dark-cyan .rbc-slot-selection {
  background-color: rgba(0, 188, 212, 0.7);
}

.dark-cyan .rbc-toolbar button:active,
.dark-cyan .rbc-toolbar button.rbc-active {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.dark-cyan .rbc-toolbar button:active:hover,
.dark-cyan .rbc-toolbar button.rbc-active:hover,
.dark-cyan .rbc-toolbar button:active:focus,
.dark-cyan .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.dark-cyan .rbc-toolbar button:focus {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.dark-cyan .rbc-toolbar button:hover {
  background-color: rgba(0, 188, 212, 0.9);
  border-color: #00bcd4;
}

.dark-cyan .rbc-day-slot .rbc-event {
  border-color: #00bcd4;
}

.dark-cyan .chat-sidenav-title {
  color: #00bcd4;
}

.dark-cyan .chat-user-item.active, .dark-cyan .chat-user-item:hover {
  background-color: rgb(186.5, 247.2452830189, 255);
}

.dark-cyan .contact-list i {
  color: #00bcd4;
}

.dark-cyan .Collapsible__trigger {
  background: #00bcd4;
}

.dark-cyan .categories-list li a:focus, .dark-cyan .categories-list li a:hover, .dark-cyan .categories-list li.active a {
  color: #00bcd4;
}

.dark-cyan .login-content .form-control:focus {
  border-color: #00bcd4;
}

.dark-cyan .filter-with-bg-color ul li a {
  border-color: #00bcd4;
}
.dark-cyan .filter-with-bg-color ul li a:hover, .dark-cyan .filter-with-bg-color ul li a:focus, .dark-cyan .filter-with-bg-color ul li a.active {
  background-color: #00bcd4;
}

.dark-cyan .profile-intro .icon {
  color: #00bcd4;
}

.dark-cyan .social-link li.active a, .dark-cyan .social-link li a:hover, .dark-cyan .social-link li a:focus {
  color: #69F0AE;
}

.dark-cyan .actions {
  color: #69F0AE;
}

.dark-cyan .table-hover tbody tr:hover {
  background-color: rgba(0, 188, 212, 0.075);
}

.dark-cyan .border-primary {
  border-color: #00bcd4 !important;
}

.dark-cyan .app-logo-content {
  background-color: #00bcd4;
}

.dark-cyan .app-social-block .social-link button {
  border: solid 1px #00bcd4;
  color: #00bcd4;
}
.dark-cyan .app-social-block .social-link button:hover, .dark-cyan .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #00bcd4;
}

.dark-cyan .btn-group > .jr-btn.active,
.dark-cyan .btn-group > .btn-default.active,
.dark-cyan .btn-group-vertical > .jr-btn.active,
.dark-cyan .btn-group-vertical > .btn-default.active {
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-cyan .btn-group > .jr-flat-btn,
.dark-cyan .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-cyan .btn-group > .jr-flat-btn.active,
.dark-cyan .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #00bcd4 !important;
  border-color: transparent !important;
}
.dark-cyan .btn-group > .jr-flat-btn.active:hover, .dark-cyan .btn-group > .jr-flat-btn.active:focus,
.dark-cyan .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-cyan .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(0, 188, 212, 0.12) !important;
  color: #00bcd4 !important;
}

.dark-cyan .nav-pill-sales .nav-link.active {
  background-color: #00bcd4;
  border-color: #00bcd4;
}

.dark-cyan .form-checkbox > input + .check,
.dark-cyan .form-checkbox > input.sm + .check {
  color: #00bcd4;
}

/* Input Placeholder Style */
.dark-cyan .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-cyan .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-cyan .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-cyan .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-cyan .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-cyan .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-cyan .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-cyan .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Amber Styles*/
.dark-amber .right-arrow {
  color: #ffc107;
}
.dark-amber .right-arrow:after {
  color: #ffc107;
}

.dark-amber .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-amber .btn-primary:focus, .dark-amber .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-amber .btn-primary.disabled, .dark-amber .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-amber .btn-primary:not(:disabled):not(.disabled):active, .dark-amber .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-amber .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-amber .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-amber .btn-secondary:focus, .dark-amber .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-amber .btn-secondary.disabled, .dark-amber .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-amber .btn-secondary:not(:disabled):not(.disabled):active, .dark-amber .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-amber .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-amber .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-amber .btn-success:focus, .dark-amber .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-amber .btn-success.disabled, .dark-amber .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-amber .btn-success:not(:disabled):not(.disabled):active, .dark-amber .btn-success:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-amber .btn-success:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-amber .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-amber .btn-info:focus, .dark-amber .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-amber .btn-info.disabled, .dark-amber .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-amber .btn-info:not(:disabled):not(.disabled):active, .dark-amber .btn-info:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-amber .btn-info:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-amber .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-amber .btn-warning:focus, .dark-amber .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-amber .btn-warning.disabled, .dark-amber .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-amber .btn-warning:not(:disabled):not(.disabled):active, .dark-amber .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-amber .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-amber .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-amber .btn-danger:focus, .dark-amber .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-amber .btn-danger.disabled, .dark-amber .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-amber .btn-danger:not(:disabled):not(.disabled):active, .dark-amber .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-amber .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-amber .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-amber .btn-light:focus, .dark-amber .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-amber .btn-light.disabled, .dark-amber .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-amber .btn-light:not(:disabled):not(.disabled):active, .dark-amber .btn-light:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-amber .btn-light:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-amber .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-amber .btn-dark:focus, .dark-amber .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-amber .btn-dark.disabled, .dark-amber .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-amber .btn-dark:not(:disabled):not(.disabled):active, .dark-amber .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-amber .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-amber a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-amber a.btn-primary:focus, .dark-amber a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-amber a.btn-primary.disabled, .dark-amber a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-amber a.btn-primary:not(:disabled):not(.disabled):active, .dark-amber a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-amber a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-amber a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-amber a.btn-secondary:focus, .dark-amber a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-amber a.btn-secondary.disabled, .dark-amber a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-amber a.btn-secondary:not(:disabled):not(.disabled):active, .dark-amber a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-amber a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-amber a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-amber a.btn-success:focus, .dark-amber a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-amber a.btn-success.disabled, .dark-amber a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-amber a.btn-success:not(:disabled):not(.disabled):active, .dark-amber a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-amber a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-amber a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-amber a.btn-info:focus, .dark-amber a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-amber a.btn-info.disabled, .dark-amber a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-amber a.btn-info:not(:disabled):not(.disabled):active, .dark-amber a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-amber a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-amber a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-amber a.btn-warning:focus, .dark-amber a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-amber a.btn-warning.disabled, .dark-amber a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-amber a.btn-warning:not(:disabled):not(.disabled):active, .dark-amber a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-amber a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-amber a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-amber a.btn-danger:focus, .dark-amber a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-amber a.btn-danger.disabled, .dark-amber a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-amber a.btn-danger:not(:disabled):not(.disabled):active, .dark-amber a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-amber a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-amber a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-amber a.btn-light:focus, .dark-amber a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-amber a.btn-light.disabled, .dark-amber a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-amber a.btn-light:not(:disabled):not(.disabled):active, .dark-amber a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-amber a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-amber a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-amber a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-amber a.btn-dark:focus, .dark-amber a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-amber a.btn-dark.disabled, .dark-amber a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-amber a.btn-dark:not(:disabled):not(.disabled):active, .dark-amber a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-amber a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-amber .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-amber .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-amber .btn-outline-primary:focus, .dark-amber .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-amber .btn-outline-primary.disabled, .dark-amber .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-amber .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-amber .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-amber .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-amber .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-amber .btn-outline-secondary:focus, .dark-amber .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-amber .btn-outline-secondary.disabled, .dark-amber .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-amber .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-amber .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-amber .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-amber .btn-outline-success:focus, .dark-amber .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-amber .btn-outline-success.disabled, .dark-amber .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-amber .btn-outline-success:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-amber .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-amber .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-amber .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-amber .btn-outline-info:focus, .dark-amber .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-amber .btn-outline-info.disabled, .dark-amber .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-amber .btn-outline-info:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-amber .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-amber .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-amber .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-amber .btn-outline-warning:focus, .dark-amber .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-amber .btn-outline-warning.disabled, .dark-amber .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-amber .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-amber .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-amber .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-amber .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-amber .btn-outline-danger:focus, .dark-amber .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-amber .btn-outline-danger.disabled, .dark-amber .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-amber .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-amber .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-amber .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-amber .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-amber .btn-outline-light:focus, .dark-amber .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-amber .btn-outline-light.disabled, .dark-amber .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-amber .btn-outline-light:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-amber .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-amber .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-amber .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-amber .btn-outline-dark:focus, .dark-amber .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-amber .btn-outline-dark.disabled, .dark-amber .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-amber .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-amber .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-amber .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-amber .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-amber a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-amber a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-amber a.btn-outline-primary:focus, .dark-amber a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-amber a.btn-outline-primary.disabled, .dark-amber a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-amber a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-amber a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-amber a.btn-outline-secondary:focus, .dark-amber a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-amber a.btn-outline-secondary.disabled, .dark-amber a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-amber a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-amber a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-amber a.btn-outline-success:focus, .dark-amber a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-amber a.btn-outline-success.disabled, .dark-amber a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-amber a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-amber a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-amber a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-amber a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-amber a.btn-outline-info:focus, .dark-amber a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-amber a.btn-outline-info.disabled, .dark-amber a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-amber a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-amber a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-amber a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-amber a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-amber a.btn-outline-warning:focus, .dark-amber a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-amber a.btn-outline-warning.disabled, .dark-amber a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-amber a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-amber a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-amber a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-amber a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-amber a.btn-outline-danger:focus, .dark-amber a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-amber a.btn-outline-danger.disabled, .dark-amber a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-amber a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-amber a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-amber a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-amber a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-amber a.btn-outline-light:focus, .dark-amber a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-amber a.btn-outline-light.disabled, .dark-amber a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-amber a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-amber a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-amber a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-amber a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-amber a.btn-outline-dark:focus, .dark-amber a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-amber a.btn-outline-dark.disabled, .dark-amber a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-amber a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-amber a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-amber a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-amber a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-amber a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-amber a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-amber .btn-outline-primary,
.dark-amber a.btn-outline-primary {
  color: #ffc107;
  border-color: #ffc107;
}
.dark-amber .btn-outline-primary:focus, .dark-amber .btn-outline-primary:hover, .dark-amber .btn-outline-primary.disabled, .dark-amber .btn-outline-primary:disabled, .dark-amber .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-primary.dropdown-toggle,
.dark-amber a.btn-outline-primary:focus,
.dark-amber a.btn-outline-primary:hover,
.dark-amber a.btn-outline-primary.disabled,
.dark-amber a.btn-outline-primary:disabled,
.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-amber a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-amber a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #ffc107;
  background-color: #ffc107;
}

.dark-amber .btn-outline-secondary,
.dark-amber a.btn-outline-secondary {
  color: #FF3D00;
  border-color: #FF3D00;
}
.dark-amber .btn-outline-secondary:focus, .dark-amber .btn-outline-secondary:hover, .dark-amber .btn-outline-secondary.disabled, .dark-amber .btn-outline-secondary:disabled, .dark-amber .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-amber .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-amber .btn-outline-secondary.dropdown-toggle,
.dark-amber a.btn-outline-secondary:focus,
.dark-amber a.btn-outline-secondary:hover,
.dark-amber a.btn-outline-secondary.disabled,
.dark-amber a.btn-outline-secondary:disabled,
.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-amber a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-amber a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF3D00;
  background-color: #FF3D00;
}

.dark-amber a, .dark-amber a.text-primary {
  color: #ffc107;
}
.dark-amber a:focus, .dark-amber a:hover, .dark-amber a.text-primary:focus, .dark-amber a.text-primary:hover {
  color: rgb(211, 158.25, 0);
}
.dark-amber .text-primary {
  color: #ffc107 !important;
}
.dark-amber .page-link {
  color: #ffc107;
}
.dark-amber .page-link:focus, .dark-amber .page-link:hover {
  color: #ffc107;
}
.dark-amber .bg-primary, .dark-amber .badge-primary {
  background-color: #ffc107 !important;
  color: #fff !important;
}
.dark-amber .btn-primary, .dark-amber .jr-btn-primary, .dark-amber a.btn-primary, .dark-amber a.jr-btn-primary {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #fff;
}
.dark-amber .btn-primary:hover, .dark-amber .btn-primary:focus, .dark-amber .btn-primary:not([disabled]):not(.disabled):active, .dark-amber .jr-btn-primary:hover, .dark-amber .jr-btn-primary:focus, .dark-amber .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-amber a.btn-primary:hover, .dark-amber a.btn-primary:focus, .dark-amber a.btn-primary:not([disabled]):not(.disabled):active, .dark-amber a.jr-btn-primary:hover, .dark-amber a.jr-btn-primary:focus, .dark-amber a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(236.5, 177.375, 0) !important;
  border-color: rgb(236.5, 177.375, 0) !important;
  color: #fff !important;
}
.dark-amber .bg-primary.lighten-4 {
  background-color: #ffecb3 !important;
}
.dark-amber .bg-primary.lighten-3 {
  background-color: #ffe082 !important;
}
.dark-amber .bg-primary.lighten-2 {
  background-color: #ffd54f !important;
}
.dark-amber .bg-primary.lighten-1 {
  background-color: #ffca28 !important;
}
.dark-amber .bg-primary.darken-1 {
  background-color: #ffb300 !important;
}
.dark-amber .bg-primary.darken-2 {
  background-color: #ffa000 !important;
}
.dark-amber .bg-primary.darken-3 {
  background-color: #ff8f00 !important;
}
.dark-amber .bg-primary.darken-4 {
  background-color: #ff6f00 !important;
}
.dark-amber .bg-primary.accent-1 {
  background-color: #ffe57f !important;
}
.dark-amber .bg-primary.accent-2 {
  background-color: #ffd740 !important;
}
.dark-amber .bg-primary.accent-3 {
  background-color: #ffc400 !important;
}
.dark-amber .bg-primary.accent-4 {
  background-color: #ffab00 !important;
}

.dark-amber a.text-secondary {
  color: #FF3D00;
}
.dark-amber a.text-secondary:focus, .dark-amber a.text-secondary:hover {
  color: rgb(204, 48.8, 0) !important;
}
.dark-amber .text-secondary {
  color: #FF3D00 !important;
}
.dark-amber .bg-secondary, .dark-amber .badge-secondary {
  background-color: #FF3D00 !important;
  color: #fff !important;
}
.dark-amber .btn-secondary {
  background-color: #FF3D00;
  border-color: #FF3D00;
  color: #fff;
}
.dark-amber .btn-secondary:hover, .dark-amber .btn-secondary:focus, .dark-amber .btn-secondary:active {
  background-color: rgb(229.5, 54.9, 0) !important;
  border-color: rgb(229.5, 54.9, 0) !important;
  color: #fff !important;
}

.amber .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.amber .jr-flat-btn:hover, .amber .jr-flat-btn:focus, .amber .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.amber .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #FFC107 !important;
  border-color: transparent !important;
}
.amber .jr-flat-btn.jr-btn-primary:hover, .amber .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 193, 7, 0.12) !important;
  color: #FFC107 !important;
}

.amber .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.amber .bg-primary .jr-flat-btn.jr-btn-primary:hover, .amber .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.amber .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF3D00 !important;
  border-color: transparent !important;
}
.amber .jr-flat-btn.jr-btn-secondary:hover, .amber .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 61, 0, 0.12) !important;
  color: #FF3D00 !important;
}

.amber .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.amber .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .amber .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-amber .app-main-header {
  background-color: #ffc107 !important;
  color: #fff;
  border-color: #ffc107;
}
.dark-amber .app-main-header .search-bar input {
  background-color: rgb(255, 199.375, 32.5);
}
.dark-amber .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-amber .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-amber .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-amber .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-amber .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-amber .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-amber .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-amber .quick-menu .icon-btn {
  color: #fff;
}

.dark-amber .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-amber .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-amber .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-amber .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-amber .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-amber .color-theme-header {
  background-color: #ffc107;
}

.dark-amber .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-amber .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-amber .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-amber .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-amber .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-amber ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-amber ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-amber ul.nav-menu > li.open > a,
.dark-amber ul.nav-menu > li > a:hover,
.dark-amber ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-amber ul.nav-menu li.menu.open > a {
  border-color: #ffc107;
}

.dark-amber ul.nav-menu li.menu > a:focus:before,
.dark-amber ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-amber ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-amber ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-amber ul.nav-menu li.menu.open > a:before,
.dark-amber ul.nav-menu li.menu > a:focus:before,
.dark-amber ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-amber ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-amber ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #ffc107;
}

.dark-amber ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-amber ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-amber ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-amber ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-amber ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-amber .navbar-nav li:hover > a, .dark-amber .navbar-nav li:focus > a {
  color: #ffc107;
}
.dark-amber .navbar-nav li a {
  color: #333;
}
.dark-amber .navbar-nav li a:hover, .dark-amber .navbar-nav li a:focus {
  color: #ffc107;
}
.dark-amber .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-amber .navbar-nav li.nav-item:hover > a, .dark-amber .navbar-nav li.nav-item:focus > a, .dark-amber .navbar-nav li.nav-item > a:hover, .dark-amber .navbar-nav li.nav-item > a:focus, .dark-amber .navbar-nav li.nav-item.active > a {
  color: #FF3D00;
}
.dark-amber .navbar-nav ul.sub-menu li a.active, .dark-amber .navbar-nav ul.sub-menu li.active > a {
  color: #ffc107;
}
.dark-amber .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-amber .navbar-nav .nav-arrow a:hover:before, .dark-amber .navbar-nav .nav-arrow a:focus:before {
  color: #ffc107;
}
.dark-amber .navbar-nav .nav-arrow:hover > a:before, .dark-amber .navbar-nav .nav-arrow:focus > a:before, .dark-amber .navbar-nav .nav-arrow.active > a:before {
  color: #ffc107;
}

.dark-amber .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-amber .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-amber .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-amber .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-amber .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-amber .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-amber .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF3D00;
}

.dark-amber .module-nav li a.active {
  border-color: #ffc107;
}

.dark-amber .rbc-event {
  background-color: #ffc107;
}

.dark-amber .rbc-event.rbc-selected {
  background-color: rgb(211, 158.25, 0);
}

.dark-amber .rbc-slot-selection {
  background-color: rgba(255, 193, 7, 0.7);
}

.dark-amber .rbc-toolbar button:active,
.dark-amber .rbc-toolbar button.rbc-active {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #ffc107;
}

.dark-amber .rbc-toolbar button:active:hover,
.dark-amber .rbc-toolbar button.rbc-active:hover,
.dark-amber .rbc-toolbar button:active:focus,
.dark-amber .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #ffc107;
}

.dark-amber .rbc-toolbar button:focus {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #ffc107;
}

.dark-amber .rbc-toolbar button:hover {
  background-color: rgba(255, 193, 7, 0.9);
  border-color: #ffc107;
}

.dark-amber .rbc-day-slot .rbc-event {
  border-color: #ffc107;
}

.dark-amber .chat-sidenav-title {
  color: #ffc107;
}

.dark-amber .chat-user-item.active, .dark-amber .chat-user-item:hover {
  background-color: rgb(255, 250.375, 236.5);
}

.dark-amber .contact-list i {
  color: #ffc107;
}

.dark-amber .Collapsible__trigger {
  background: #ffc107;
}

.dark-amber .categories-list li a:focus, .dark-amber .categories-list li a:hover, .dark-amber .categories-list li.active a {
  color: #ffc107;
}

.dark-amber .login-content .form-control:focus {
  border-color: #ffc107;
}

.dark-amber .filter-with-bg-color ul li a {
  border-color: #ffc107;
}
.dark-amber .filter-with-bg-color ul li a:hover, .dark-amber .filter-with-bg-color ul li a:focus, .dark-amber .filter-with-bg-color ul li a.active {
  background-color: #ffc107;
}

.dark-amber .profile-intro .icon {
  color: #ffc107;
}

.dark-amber .social-link li.active a, .dark-amber .social-link li a:hover, .dark-amber .social-link li a:focus {
  color: #FF3D00;
}

.dark-amber .actions {
  color: #FF3D00;
}

.dark-amber .table-hover tbody tr:hover {
  background-color: rgba(255, 193, 7, 0.075);
}

.dark-amber .border-primary {
  border-color: #ffc107 !important;
}

.dark-amber .app-logo-content {
  background-color: #ffc107;
}

.dark-amber .app-social-block .social-link button {
  border: solid 1px #ffc107;
  color: #ffc107;
}
.dark-amber .app-social-block .social-link button:hover, .dark-amber .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #ffc107;
}

.dark-amber .btn-group > .jr-btn.active,
.dark-amber .btn-group > .btn-default.active,
.dark-amber .btn-group-vertical > .jr-btn.active,
.dark-amber .btn-group-vertical > .btn-default.active {
  background-color: #ffc107;
  border-color: #ffc107;
}
.dark-amber .btn-group > .jr-flat-btn,
.dark-amber .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-amber .btn-group > .jr-flat-btn.active,
.dark-amber .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #ffc107 !important;
  border-color: transparent !important;
}
.dark-amber .btn-group > .jr-flat-btn.active:hover, .dark-amber .btn-group > .jr-flat-btn.active:focus,
.dark-amber .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-amber .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(255, 193, 7, 0.12) !important;
  color: #ffc107 !important;
}

.dark-amber .nav-pill-sales .nav-link.active {
  background-color: #ffc107;
  border-color: #ffc107;
}

.dark-amber .form-checkbox > input + .check,
.dark-amber .form-checkbox > input.sm + .check {
  color: #ffc107;
}

/* Input Placeholder Style */
.dark-amber .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-amber .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-amber .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-amber .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-amber .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-amber .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-amber .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-amber .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Deep Orange Styles*/
.dark-deep-orange .right-arrow {
  color: #ff5722;
}
.dark-deep-orange .right-arrow:after {
  color: #ff5722;
}

.dark-deep-orange .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-deep-orange .btn-primary:focus, .dark-deep-orange .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-orange .btn-primary.disabled, .dark-deep-orange .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-orange .btn-primary:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-deep-orange .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-orange .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-deep-orange .btn-secondary:focus, .dark-deep-orange .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-orange .btn-secondary.disabled, .dark-deep-orange .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-orange .btn-secondary:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-deep-orange .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-orange .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-deep-orange .btn-success:focus, .dark-deep-orange .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-orange .btn-success.disabled, .dark-deep-orange .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-orange .btn-success:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-success:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-deep-orange .btn-success:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-orange .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-deep-orange .btn-info:focus, .dark-deep-orange .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-orange .btn-info.disabled, .dark-deep-orange .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-orange .btn-info:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-info:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-deep-orange .btn-info:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-orange .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-deep-orange .btn-warning:focus, .dark-deep-orange .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-orange .btn-warning.disabled, .dark-deep-orange .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-orange .btn-warning:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-deep-orange .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-orange .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-deep-orange .btn-danger:focus, .dark-deep-orange .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-orange .btn-danger.disabled, .dark-deep-orange .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-orange .btn-danger:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-deep-orange .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-orange .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-deep-orange .btn-light:focus, .dark-deep-orange .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-orange .btn-light.disabled, .dark-deep-orange .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-orange .btn-light:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-light:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-deep-orange .btn-light:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-orange .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-deep-orange .btn-dark:focus, .dark-deep-orange .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-orange .btn-dark.disabled, .dark-deep-orange .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-orange .btn-dark:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-deep-orange .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-orange a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-deep-orange a.btn-primary:focus, .dark-deep-orange a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-orange a.btn-primary.disabled, .dark-deep-orange a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-orange a.btn-primary:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-deep-orange a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-orange a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-deep-orange a.btn-secondary:focus, .dark-deep-orange a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-orange a.btn-secondary.disabled, .dark-deep-orange a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-orange a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-deep-orange a.btn-success:focus, .dark-deep-orange a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-orange a.btn-success.disabled, .dark-deep-orange a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-orange a.btn-success:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-deep-orange a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-orange a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-deep-orange a.btn-info:focus, .dark-deep-orange a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-orange a.btn-info.disabled, .dark-deep-orange a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-orange a.btn-info:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-deep-orange a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-orange a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-deep-orange a.btn-warning:focus, .dark-deep-orange a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-orange a.btn-warning.disabled, .dark-deep-orange a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-orange a.btn-warning:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-deep-orange a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-orange a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-deep-orange a.btn-danger:focus, .dark-deep-orange a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-orange a.btn-danger.disabled, .dark-deep-orange a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-orange a.btn-danger:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-deep-orange a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-orange a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-deep-orange a.btn-light:focus, .dark-deep-orange a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-orange a.btn-light.disabled, .dark-deep-orange a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-orange a.btn-light:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-deep-orange a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-orange a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-orange a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-deep-orange a.btn-dark:focus, .dark-deep-orange a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-orange a.btn-dark.disabled, .dark-deep-orange a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-orange a.btn-dark:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-deep-orange a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-orange .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-deep-orange .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-orange .btn-outline-primary:focus, .dark-deep-orange .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-orange .btn-outline-primary.disabled, .dark-deep-orange .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-orange .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-deep-orange .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-orange .btn-outline-secondary:focus, .dark-deep-orange .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-orange .btn-outline-secondary.disabled, .dark-deep-orange .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-orange .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-deep-orange .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-orange .btn-outline-success:focus, .dark-deep-orange .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-orange .btn-outline-success.disabled, .dark-deep-orange .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-orange .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-deep-orange .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-orange .btn-outline-info:focus, .dark-deep-orange .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-orange .btn-outline-info.disabled, .dark-deep-orange .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-orange .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-deep-orange .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-orange .btn-outline-warning:focus, .dark-deep-orange .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-orange .btn-outline-warning.disabled, .dark-deep-orange .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-orange .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-deep-orange .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-orange .btn-outline-danger:focus, .dark-deep-orange .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-orange .btn-outline-danger.disabled, .dark-deep-orange .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-orange .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-deep-orange .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-orange .btn-outline-light:focus, .dark-deep-orange .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-orange .btn-outline-light.disabled, .dark-deep-orange .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-orange .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-deep-orange .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-orange .btn-outline-dark:focus, .dark-deep-orange .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-orange .btn-outline-dark.disabled, .dark-deep-orange .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-orange .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-orange a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-deep-orange a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-orange a.btn-outline-primary:focus, .dark-deep-orange a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-orange a.btn-outline-primary.disabled, .dark-deep-orange a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-orange a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-deep-orange a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-orange a.btn-outline-secondary:focus, .dark-deep-orange a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-orange a.btn-outline-secondary.disabled, .dark-deep-orange a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-orange a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-deep-orange a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-orange a.btn-outline-success:focus, .dark-deep-orange a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-orange a.btn-outline-success.disabled, .dark-deep-orange a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-orange a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-deep-orange a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-orange a.btn-outline-info:focus, .dark-deep-orange a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-orange a.btn-outline-info.disabled, .dark-deep-orange a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-orange a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-deep-orange a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-orange a.btn-outline-warning:focus, .dark-deep-orange a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-orange a.btn-outline-warning.disabled, .dark-deep-orange a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-orange a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-deep-orange a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-orange a.btn-outline-danger:focus, .dark-deep-orange a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-orange a.btn-outline-danger.disabled, .dark-deep-orange a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-orange a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-deep-orange a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-orange a.btn-outline-light:focus, .dark-deep-orange a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-orange a.btn-outline-light.disabled, .dark-deep-orange a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-orange a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-deep-orange a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-orange a.btn-outline-dark:focus, .dark-deep-orange a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-orange a.btn-outline-dark.disabled, .dark-deep-orange a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-orange a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-orange a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-orange a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-orange .btn-outline-primary,
.dark-deep-orange a.btn-outline-primary {
  color: #ff5722;
  border-color: #ff5722;
}
.dark-deep-orange .btn-outline-primary:focus, .dark-deep-orange .btn-outline-primary:hover, .dark-deep-orange .btn-outline-primary.disabled, .dark-deep-orange .btn-outline-primary:disabled, .dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-primary.dropdown-toggle,
.dark-deep-orange a.btn-outline-primary:focus,
.dark-deep-orange a.btn-outline-primary:hover,
.dark-deep-orange a.btn-outline-primary.disabled,
.dark-deep-orange a.btn-outline-primary:disabled,
.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-deep-orange a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-deep-orange a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #ff5722;
  background-color: #ff5722;
}

.dark-deep-orange .btn-outline-secondary,
.dark-deep-orange a.btn-outline-secondary {
  color: #40C4FF;
  border-color: #40C4FF;
}
.dark-deep-orange .btn-outline-secondary:focus, .dark-deep-orange .btn-outline-secondary:hover, .dark-deep-orange .btn-outline-secondary.disabled, .dark-deep-orange .btn-outline-secondary:disabled, .dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-deep-orange .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-orange .btn-outline-secondary.dropdown-toggle,
.dark-deep-orange a.btn-outline-secondary:focus,
.dark-deep-orange a.btn-outline-secondary:hover,
.dark-deep-orange a.btn-outline-secondary.disabled,
.dark-deep-orange a.btn-outline-secondary:disabled,
.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-deep-orange a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-deep-orange a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #40C4FF;
  background-color: #40C4FF;
}

.dark-deep-orange a, .dark-deep-orange a.text-primary {
  color: #ff5722;
}
.dark-deep-orange a:focus, .dark-deep-orange a:hover, .dark-deep-orange a.text-primary:focus, .dark-deep-orange a.text-primary:hover {
  color: rgb(238, 57.0769230769, 0);
}
.dark-deep-orange .text-primary {
  color: #ff5722 !important;
}
.dark-deep-orange .page-link {
  color: #ff5722;
}
.dark-deep-orange .page-link:focus, .dark-deep-orange .page-link:hover {
  color: #ff5722;
}
.dark-deep-orange .bg-primary, .dark-deep-orange .badge-primary {
  background-color: #ff5722 !important;
  color: #fff !important;
}
.dark-deep-orange .btn-primary, .dark-deep-orange .jr-btn-primary, .dark-deep-orange a.btn-primary, .dark-deep-orange a.jr-btn-primary {
  background-color: #ff5722;
  border-color: #ff5722;
  color: #fff;
}
.dark-deep-orange .btn-primary:hover, .dark-deep-orange .btn-primary:focus, .dark-deep-orange .btn-primary:not([disabled]):not(.disabled):active, .dark-deep-orange .jr-btn-primary:hover, .dark-deep-orange .jr-btn-primary:focus, .dark-deep-orange .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-deep-orange a.btn-primary:hover, .dark-deep-orange a.btn-primary:focus, .dark-deep-orange a.btn-primary:not([disabled]):not(.disabled):active, .dark-deep-orange a.jr-btn-primary:hover, .dark-deep-orange a.jr-btn-primary:focus, .dark-deep-orange a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(255, 67.6153846154, 8.5) !important;
  border-color: rgb(255, 67.6153846154, 8.5) !important;
  color: #fff !important;
}
.dark-deep-orange .bg-primary.lighten-4 {
  background-color: #ffccbc !important;
}
.dark-deep-orange .bg-primary.lighten-3 {
  background-color: #ffab91 !important;
}
.dark-deep-orange .bg-primary.lighten-2 {
  background-color: #ff8a65 !important;
}
.dark-deep-orange .bg-primary.lighten-1 {
  background-color: #ff7043 !important;
}
.dark-deep-orange .bg-primary.darken-1 {
  background-color: #f4511e !important;
}
.dark-deep-orange .bg-primary.darken-2 {
  background-color: #e64a19 !important;
}
.dark-deep-orange .bg-primary.darken-3 {
  background-color: #d84315 !important;
}
.dark-deep-orange .bg-primary.darken-4 {
  background-color: #bf360c !important;
}
.dark-deep-orange .bg-primary.accent-1 {
  background-color: #ff9e80 !important;
}
.dark-deep-orange .bg-primary.accent-2 {
  background-color: #ff6e40 !important;
}
.dark-deep-orange .bg-primary.accent-3 {
  background-color: #ff3d00 !important;
}
.dark-deep-orange .bg-primary.accent-4 {
  background-color: #dd2c00 !important;
}

.dark-deep-orange a.text-secondary {
  color: #40C4FF;
}
.dark-deep-orange a.text-secondary:focus, .dark-deep-orange a.text-secondary:hover {
  color: rgb(13, 180.2460732984, 255) !important;
}
.dark-deep-orange .text-secondary {
  color: #40C4FF !important;
}
.dark-deep-orange .bg-secondary, .dark-deep-orange .badge-secondary {
  background-color: #40C4FF !important;
  color: #fff !important;
}
.dark-deep-orange .btn-secondary {
  background-color: #40C4FF;
  border-color: #40C4FF;
  color: #fff;
}
.dark-deep-orange .btn-secondary:hover, .dark-deep-orange .btn-secondary:focus, .dark-deep-orange .btn-secondary:active {
  background-color: rgb(38.5, 188.1230366492, 255) !important;
  border-color: rgb(38.5, 188.1230366492, 255) !important;
  color: #fff !important;
}

.dark-deep-orange .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-deep-orange .jr-flat-btn:hover, .dark-deep-orange .jr-flat-btn:focus, .dark-deep-orange .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-deep-orange .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #ff5722 !important;
  border-color: transparent !important;
}
.dark-deep-orange .jr-flat-btn.jr-btn-primary:hover, .dark-deep-orange .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 87, 34, 0.12) !important;
  color: #ff5722 !important;
}

.dark-deep-orange .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-deep-orange .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-deep-orange .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #40C4FF !important;
  border-color: transparent !important;
}
.dark-deep-orange .jr-flat-btn.jr-btn-secondary:hover, .dark-deep-orange .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(64, 196, 255, 0.12) !important;
  color: #40C4FF !important;
}

.dark-deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-deep-orange .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-deep-orange .app-main-header {
  background-color: #ff5722 !important;
  color: #fff;
  border-color: #ff5722;
}
.dark-deep-orange .app-main-header .search-bar input {
  background-color: rgb(255, 106.3846153846, 59.5);
}
.dark-deep-orange .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-deep-orange .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-deep-orange .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-deep-orange .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-deep-orange .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-deep-orange .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-deep-orange .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-deep-orange .quick-menu .icon-btn {
  color: #fff;
}

.dark-deep-orange .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-deep-orange .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-deep-orange .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-deep-orange .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-deep-orange .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-deep-orange .color-theme-header {
  background-color: #ff5722;
}

.dark-deep-orange .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-deep-orange .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-deep-orange .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-deep-orange .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-deep-orange .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-deep-orange ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-deep-orange ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-deep-orange ul.nav-menu > li.open > a,
.dark-deep-orange ul.nav-menu > li > a:hover,
.dark-deep-orange ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-deep-orange ul.nav-menu li.menu.open > a {
  border-color: #ff5722;
}

.dark-deep-orange ul.nav-menu li.menu > a:focus:before,
.dark-deep-orange ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-deep-orange ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-deep-orange ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-deep-orange ul.nav-menu li.menu.open > a:before,
.dark-deep-orange ul.nav-menu li.menu > a:focus:before,
.dark-deep-orange ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #ff5722;
}

.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-deep-orange ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-deep-orange .navbar-nav li:hover > a, .dark-deep-orange .navbar-nav li:focus > a {
  color: #ff5722;
}
.dark-deep-orange .navbar-nav li a {
  color: #333;
}
.dark-deep-orange .navbar-nav li a:hover, .dark-deep-orange .navbar-nav li a:focus {
  color: #ff5722;
}
.dark-deep-orange .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-deep-orange .navbar-nav li.nav-item:hover > a, .dark-deep-orange .navbar-nav li.nav-item:focus > a, .dark-deep-orange .navbar-nav li.nav-item > a:hover, .dark-deep-orange .navbar-nav li.nav-item > a:focus, .dark-deep-orange .navbar-nav li.nav-item.active > a {
  color: #40C4FF;
}
.dark-deep-orange .navbar-nav ul.sub-menu li a.active, .dark-deep-orange .navbar-nav ul.sub-menu li.active > a {
  color: #ff5722;
}
.dark-deep-orange .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-deep-orange .navbar-nav .nav-arrow a:hover:before, .dark-deep-orange .navbar-nav .nav-arrow a:focus:before {
  color: #ff5722;
}
.dark-deep-orange .navbar-nav .nav-arrow:hover > a:before, .dark-deep-orange .navbar-nav .nav-arrow:focus > a:before, .dark-deep-orange .navbar-nav .nav-arrow.active > a:before {
  color: #ff5722;
}

.dark-deep-orange .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-deep-orange .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-deep-orange .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-deep-orange .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-deep-orange .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-deep-orange .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-deep-orange .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #40C4FF;
}

.dark-deep-orange .module-nav li a.active {
  border-color: #ff5722;
}

.dark-deep-orange .rbc-event {
  background-color: #ff5722;
}

.dark-deep-orange .rbc-event.rbc-selected {
  background-color: rgb(238, 57.0769230769, 0);
}

.dark-deep-orange .rbc-slot-selection {
  background-color: rgba(255, 87, 34, 0.7);
}

.dark-deep-orange .rbc-toolbar button:active,
.dark-deep-orange .rbc-toolbar button.rbc-active {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.dark-deep-orange .rbc-toolbar button:active:hover,
.dark-deep-orange .rbc-toolbar button.rbc-active:hover,
.dark-deep-orange .rbc-toolbar button:active:focus,
.dark-deep-orange .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.dark-deep-orange .rbc-toolbar button:focus {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.dark-deep-orange .rbc-toolbar button:hover {
  background-color: rgba(255, 87, 34, 0.9);
  border-color: #ff5722;
}

.dark-deep-orange .rbc-day-slot .rbc-event {
  border-color: #ff5722;
}

.dark-deep-orange .chat-sidenav-title {
  color: #ff5722;
}

.dark-deep-orange .chat-user-item.active, .dark-deep-orange .chat-user-item:hover {
  background-color: rgb(255, 242.0769230769, 238);
}

.dark-deep-orange .contact-list i {
  color: #ff5722;
}

.dark-deep-orange .Collapsible__trigger {
  background: #ff5722;
}

.dark-deep-orange .categories-list li a:focus, .dark-deep-orange .categories-list li a:hover, .dark-deep-orange .categories-list li.active a {
  color: #ff5722;
}

.dark-deep-orange .login-content .form-control:focus {
  border-color: #ff5722;
}

.dark-deep-orange .filter-with-bg-color ul li a {
  border-color: #ff5722;
}
.dark-deep-orange .filter-with-bg-color ul li a:hover, .dark-deep-orange .filter-with-bg-color ul li a:focus, .dark-deep-orange .filter-with-bg-color ul li a.active {
  background-color: #ff5722;
}

.dark-deep-orange .profile-intro .icon {
  color: #ff5722;
}

.dark-deep-orange .social-link li.active a, .dark-deep-orange .social-link li a:hover, .dark-deep-orange .social-link li a:focus {
  color: #40C4FF;
}

.dark-deep-orange .actions {
  color: #40C4FF;
}

.dark-deep-orange .table-hover tbody tr:hover {
  background-color: rgba(255, 87, 34, 0.075);
}

.dark-deep-orange .border-primary {
  border-color: #ff5722 !important;
}

.dark-deep-orange .app-logo-content {
  background-color: #ff5722;
}

.dark-deep-orange .app-social-block .social-link button {
  border: solid 1px #ff5722;
  color: #ff5722;
}
.dark-deep-orange .app-social-block .social-link button:hover, .dark-deep-orange .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #ff5722;
}

.dark-deep-orange .btn-group > .jr-btn.active,
.dark-deep-orange .btn-group > .btn-default.active,
.dark-deep-orange .btn-group-vertical > .jr-btn.active,
.dark-deep-orange .btn-group-vertical > .btn-default.active {
  background-color: #ff5722;
  border-color: #ff5722;
}
.dark-deep-orange .btn-group > .jr-flat-btn,
.dark-deep-orange .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-deep-orange .btn-group > .jr-flat-btn.active,
.dark-deep-orange .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #ff5722 !important;
  border-color: transparent !important;
}
.dark-deep-orange .btn-group > .jr-flat-btn.active:hover, .dark-deep-orange .btn-group > .jr-flat-btn.active:focus,
.dark-deep-orange .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-deep-orange .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(255, 87, 34, 0.12) !important;
  color: #ff5722 !important;
}

.dark-deep-orange .nav-pill-sales .nav-link.active {
  background-color: #ff5722;
  border-color: #ff5722;
}

.dark-deep-orange .form-checkbox > input + .check,
.dark-deep-orange .form-checkbox > input.sm + .check {
  color: #ff5722;
}

/* Input Placeholder Style */
.dark-deep-orange .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-orange .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-orange .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-orange .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-orange .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-deep-orange .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-deep-orange .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-deep-orange .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Pink Styles*/
.dark-pink .right-arrow {
  color: #e91e63;
}
.dark-pink .right-arrow:after {
  color: #e91e63;
}

.dark-pink .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-pink .btn-primary:focus, .dark-pink .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-pink .btn-primary.disabled, .dark-pink .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-pink .btn-primary:not(:disabled):not(.disabled):active, .dark-pink .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-pink .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-pink .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-pink .btn-secondary:focus, .dark-pink .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-pink .btn-secondary.disabled, .dark-pink .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-pink .btn-secondary:not(:disabled):not(.disabled):active, .dark-pink .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-pink .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-pink .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-pink .btn-success:focus, .dark-pink .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-pink .btn-success.disabled, .dark-pink .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-pink .btn-success:not(:disabled):not(.disabled):active, .dark-pink .btn-success:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-pink .btn-success:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-pink .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-pink .btn-info:focus, .dark-pink .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-pink .btn-info.disabled, .dark-pink .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-pink .btn-info:not(:disabled):not(.disabled):active, .dark-pink .btn-info:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-pink .btn-info:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-pink .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-pink .btn-warning:focus, .dark-pink .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-pink .btn-warning.disabled, .dark-pink .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-pink .btn-warning:not(:disabled):not(.disabled):active, .dark-pink .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-pink .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-pink .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-pink .btn-danger:focus, .dark-pink .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-pink .btn-danger.disabled, .dark-pink .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-pink .btn-danger:not(:disabled):not(.disabled):active, .dark-pink .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-pink .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-pink .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-pink .btn-light:focus, .dark-pink .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-pink .btn-light.disabled, .dark-pink .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-pink .btn-light:not(:disabled):not(.disabled):active, .dark-pink .btn-light:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-pink .btn-light:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-pink .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-pink .btn-dark:focus, .dark-pink .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-pink .btn-dark.disabled, .dark-pink .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-pink .btn-dark:not(:disabled):not(.disabled):active, .dark-pink .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-pink .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-pink a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-pink a.btn-primary:focus, .dark-pink a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-pink a.btn-primary.disabled, .dark-pink a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-pink a.btn-primary:not(:disabled):not(.disabled):active, .dark-pink a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-pink a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-pink a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-pink a.btn-secondary:focus, .dark-pink a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-pink a.btn-secondary.disabled, .dark-pink a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-pink a.btn-secondary:not(:disabled):not(.disabled):active, .dark-pink a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-pink a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-pink a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-pink a.btn-success:focus, .dark-pink a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-pink a.btn-success.disabled, .dark-pink a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-pink a.btn-success:not(:disabled):not(.disabled):active, .dark-pink a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-pink a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-pink a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-pink a.btn-info:focus, .dark-pink a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-pink a.btn-info.disabled, .dark-pink a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-pink a.btn-info:not(:disabled):not(.disabled):active, .dark-pink a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-pink a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-pink a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-pink a.btn-warning:focus, .dark-pink a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-pink a.btn-warning.disabled, .dark-pink a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-pink a.btn-warning:not(:disabled):not(.disabled):active, .dark-pink a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-pink a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-pink a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-pink a.btn-danger:focus, .dark-pink a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-pink a.btn-danger.disabled, .dark-pink a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-pink a.btn-danger:not(:disabled):not(.disabled):active, .dark-pink a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-pink a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-pink a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-pink a.btn-light:focus, .dark-pink a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-pink a.btn-light.disabled, .dark-pink a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-pink a.btn-light:not(:disabled):not(.disabled):active, .dark-pink a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-pink a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-pink a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-pink a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-pink a.btn-dark:focus, .dark-pink a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-pink a.btn-dark.disabled, .dark-pink a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-pink a.btn-dark:not(:disabled):not(.disabled):active, .dark-pink a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-pink a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-pink .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-pink .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-pink .btn-outline-primary:focus, .dark-pink .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-pink .btn-outline-primary.disabled, .dark-pink .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-pink .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-pink .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-pink .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-pink .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-pink .btn-outline-secondary:focus, .dark-pink .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-pink .btn-outline-secondary.disabled, .dark-pink .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-pink .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-pink .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-pink .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-pink .btn-outline-success:focus, .dark-pink .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-pink .btn-outline-success.disabled, .dark-pink .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-pink .btn-outline-success:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-pink .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-pink .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-pink .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-pink .btn-outline-info:focus, .dark-pink .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-pink .btn-outline-info.disabled, .dark-pink .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-pink .btn-outline-info:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-pink .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-pink .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-pink .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-pink .btn-outline-warning:focus, .dark-pink .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-pink .btn-outline-warning.disabled, .dark-pink .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-pink .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-pink .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-pink .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-pink .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-pink .btn-outline-danger:focus, .dark-pink .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-pink .btn-outline-danger.disabled, .dark-pink .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-pink .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-pink .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-pink .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-pink .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-pink .btn-outline-light:focus, .dark-pink .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-pink .btn-outline-light.disabled, .dark-pink .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-pink .btn-outline-light:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-pink .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-pink .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-pink .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-pink .btn-outline-dark:focus, .dark-pink .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-pink .btn-outline-dark.disabled, .dark-pink .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-pink .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-pink .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-pink .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-pink .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-pink a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-pink a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-pink a.btn-outline-primary:focus, .dark-pink a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-pink a.btn-outline-primary.disabled, .dark-pink a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-pink a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-pink a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-pink a.btn-outline-secondary:focus, .dark-pink a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-pink a.btn-outline-secondary.disabled, .dark-pink a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-pink a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-pink a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-pink a.btn-outline-success:focus, .dark-pink a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-pink a.btn-outline-success.disabled, .dark-pink a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-pink a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-pink a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-pink a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-pink a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-pink a.btn-outline-info:focus, .dark-pink a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-pink a.btn-outline-info.disabled, .dark-pink a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-pink a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-pink a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-pink a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-pink a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-pink a.btn-outline-warning:focus, .dark-pink a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-pink a.btn-outline-warning.disabled, .dark-pink a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-pink a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-pink a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-pink a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-pink a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-pink a.btn-outline-danger:focus, .dark-pink a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-pink a.btn-outline-danger.disabled, .dark-pink a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-pink a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-pink a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-pink a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-pink a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-pink a.btn-outline-light:focus, .dark-pink a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-pink a.btn-outline-light.disabled, .dark-pink a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-pink a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-pink a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-pink a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-pink a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-pink a.btn-outline-dark:focus, .dark-pink a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-pink a.btn-outline-dark.disabled, .dark-pink a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-pink a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-pink a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-pink a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-pink a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-pink a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-pink a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-pink .btn-outline-primary,
.dark-pink a.btn-outline-primary {
  color: #e91e63;
  border-color: #e91e63;
}
.dark-pink .btn-outline-primary:focus, .dark-pink .btn-outline-primary:hover, .dark-pink .btn-outline-primary.disabled, .dark-pink .btn-outline-primary:disabled, .dark-pink .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-primary.dropdown-toggle,
.dark-pink a.btn-outline-primary:focus,
.dark-pink a.btn-outline-primary:hover,
.dark-pink a.btn-outline-primary.disabled,
.dark-pink a.btn-outline-primary:disabled,
.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-pink a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-pink a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #e91e63;
  background-color: #e91e63;
}

.dark-pink .btn-outline-secondary,
.dark-pink a.btn-outline-secondary {
  color: #00BFA5;
  border-color: #00BFA5;
}
.dark-pink .btn-outline-secondary:focus, .dark-pink .btn-outline-secondary:hover, .dark-pink .btn-outline-secondary.disabled, .dark-pink .btn-outline-secondary:disabled, .dark-pink .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-pink .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-pink .btn-outline-secondary.dropdown-toggle,
.dark-pink a.btn-outline-secondary:focus,
.dark-pink a.btn-outline-secondary:hover,
.dark-pink a.btn-outline-secondary.disabled,
.dark-pink a.btn-outline-secondary:disabled,
.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-pink a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-pink a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #00BFA5;
  background-color: #00BFA5;
}

.dark-pink a, .dark-pink a.text-primary {
  color: #e91e63;
}
.dark-pink a:focus, .dark-pink a:hover, .dark-pink a.text-primary:focus, .dark-pink a.text-primary:hover {
  color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-pink .text-primary {
  color: #e91e63 !important;
}
.dark-pink .page-link {
  color: #e91e63;
}
.dark-pink .page-link:focus, .dark-pink .page-link:hover {
  color: #e91e63;
}
.dark-pink .bg-primary, .dark-pink .badge-primary {
  background-color: #e91e63 !important;
  color: #fff !important;
}
.dark-pink .btn-primary, .dark-pink .jr-btn-primary, .dark-pink a.btn-primary, .dark-pink a.jr-btn-primary {
  background-color: #e91e63;
  border-color: #e91e63;
  color: #fff;
}
.dark-pink .btn-primary:hover, .dark-pink .btn-primary:focus, .dark-pink .btn-primary:not([disabled]):not(.disabled):active, .dark-pink .jr-btn-primary:hover, .dark-pink .jr-btn-primary:focus, .dark-pink .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-pink a.btn-primary:hover, .dark-pink a.btn-primary:focus, .dark-pink a.btn-primary:not([disabled]):not(.disabled):active, .dark-pink a.jr-btn-primary:hover, .dark-pink a.jr-btn-primary:focus, .dark-pink a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(216.3461538462, 21.1538461538, 87.5) !important;
  border-color: rgb(216.3461538462, 21.1538461538, 87.5) !important;
  color: #fff !important;
}
.dark-pink .bg-primary.lighten-4 {
  background-color: #f8bbd0 !important;
}
.dark-pink .bg-primary.lighten-3 {
  background-color: #f48fb1 !important;
}
.dark-pink .bg-primary.lighten-2 {
  background-color: #f06292 !important;
}
.dark-pink .bg-primary.lighten-1 {
  background-color: #ec407a !important;
}
.dark-pink .bg-primary.darken-1 {
  background-color: #d81b60 !important;
}
.dark-pink .bg-primary.darken-2 {
  background-color: #c2185b !important;
}
.dark-pink .bg-primary.darken-3 {
  background-color: #ad1457 !important;
}
.dark-pink .bg-primary.darken-4 {
  background-color: #880e4f !important;
}
.dark-pink .bg-primary.accent-1 {
  background-color: #ff80ab !important;
}
.dark-pink .bg-primary.accent-2 {
  background-color: #ff4081 !important;
}
.dark-pink .bg-primary.accent-3 {
  background-color: #f50057 !important;
}
.dark-pink .bg-primary.accent-4 {
  background-color: #c51162 !important;
}

.dark-pink a.text-secondary {
  color: #00BFA5;
}
.dark-pink a.text-secondary:focus, .dark-pink a.text-secondary:hover {
  color: rgb(0, 140, 120.942408377) !important;
}
.dark-pink .text-secondary {
  color: #00BFA5 !important;
}
.dark-pink .bg-secondary, .dark-pink .badge-secondary {
  background-color: #00BFA5 !important;
  color: #fff !important;
}
.dark-pink .btn-secondary {
  background-color: #00BFA5;
  border-color: #00BFA5;
  color: #fff;
}
.dark-pink .btn-secondary:hover, .dark-pink .btn-secondary:focus, .dark-pink .btn-secondary:active {
  background-color: rgb(0, 165.5, 142.9712041885) !important;
  border-color: rgb(0, 165.5, 142.9712041885) !important;
  color: #fff !important;
}

.dark-pink .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-pink .jr-flat-btn:hover, .dark-pink .jr-flat-btn:focus, .dark-pink .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-pink .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #e91e63 !important;
  border-color: transparent !important;
}
.dark-pink .jr-flat-btn.jr-btn-primary:hover, .dark-pink .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(233, 30, 99, 0.12) !important;
  color: #e91e63 !important;
}

.dark-pink .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-pink .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-pink .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-pink .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #00BFA5 !important;
  border-color: transparent !important;
}
.dark-pink .jr-flat-btn.jr-btn-secondary:hover, .dark-pink .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(0, 191, 165, 0.12) !important;
  color: #00BFA5 !important;
}

.dark-pink .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-pink .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-pink .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-pink .app-main-header {
  background-color: #e91e63 !important;
  color: #fff;
  border-color: #e91e63;
}
.dark-pink .app-main-header .search-bar input {
  background-color: rgb(235.2712550607, 53.2287449393, 115.1052631579);
}
.dark-pink .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-pink .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-pink .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-pink .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-pink .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-pink .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-pink .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-pink .quick-menu .icon-btn {
  color: #fff;
}

.dark-pink .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-pink .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-pink .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-pink .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-pink .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-pink .color-theme-header {
  background-color: #e91e63;
}

.dark-pink .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-pink .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-pink .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-pink .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-pink .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-pink ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-pink ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-pink ul.nav-menu > li.open > a,
.dark-pink ul.nav-menu > li > a:hover,
.dark-pink ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-pink ul.nav-menu li.menu.open > a {
  border-color: #e91e63;
}

.dark-pink ul.nav-menu li.menu > a:focus:before,
.dark-pink ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-pink ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-pink ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-pink ul.nav-menu li.menu.open > a:before,
.dark-pink ul.nav-menu li.menu > a:focus:before,
.dark-pink ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-pink ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-pink ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #e91e63;
}

.dark-pink ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-pink ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-pink ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-pink ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-pink ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-pink .navbar-nav li:hover > a, .dark-pink .navbar-nav li:focus > a {
  color: #e91e63;
}
.dark-pink .navbar-nav li a {
  color: #333;
}
.dark-pink .navbar-nav li a:hover, .dark-pink .navbar-nav li a:focus {
  color: #e91e63;
}
.dark-pink .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-pink .navbar-nav li.nav-item:hover > a, .dark-pink .navbar-nav li.nav-item:focus > a, .dark-pink .navbar-nav li.nav-item > a:hover, .dark-pink .navbar-nav li.nav-item > a:focus, .dark-pink .navbar-nav li.nav-item.active > a {
  color: #00BFA5;
}
.dark-pink .navbar-nav ul.sub-menu li a.active, .dark-pink .navbar-nav ul.sub-menu li.active > a {
  color: #e91e63;
}
.dark-pink .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-pink .navbar-nav .nav-arrow a:hover:before, .dark-pink .navbar-nav .nav-arrow a:focus:before {
  color: #e91e63;
}
.dark-pink .navbar-nav .nav-arrow:hover > a:before, .dark-pink .navbar-nav .nav-arrow:focus > a:before, .dark-pink .navbar-nav .nav-arrow.active > a:before {
  color: #e91e63;
}

.dark-pink .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-pink .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-pink .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-pink .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-pink .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-pink .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-pink .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #00BFA5;
}

.dark-pink .module-nav li a.active {
  border-color: #e91e63;
}

.dark-pink .rbc-event {
  background-color: #e91e63;
}

.dark-pink .rbc-event.rbc-selected {
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}

.dark-pink .rbc-slot-selection {
  background-color: rgba(233, 30, 99, 0.7);
}

.dark-pink .rbc-toolbar button:active,
.dark-pink .rbc-toolbar button.rbc-active {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.dark-pink .rbc-toolbar button:active:hover,
.dark-pink .rbc-toolbar button.rbc-active:hover,
.dark-pink .rbc-toolbar button:active:focus,
.dark-pink .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.dark-pink .rbc-toolbar button:focus {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.dark-pink .rbc-toolbar button:hover {
  background-color: rgba(233, 30, 99, 0.9);
  border-color: #e91e63;
}

.dark-pink .rbc-day-slot .rbc-event {
  border-color: #e91e63;
}

.dark-pink .chat-sidenav-title {
  color: #e91e63;
}

.dark-pink .chat-user-item.active, .dark-pink .chat-user-item:hover {
  background-color: rgb(253.4412955466, 239.0587044534, 243.9473684211);
}

.dark-pink .contact-list i {
  color: #e91e63;
}

.dark-pink .Collapsible__trigger {
  background: #e91e63;
}

.dark-pink .categories-list li a:focus, .dark-pink .categories-list li a:hover, .dark-pink .categories-list li.active a {
  color: #e91e63;
}

.dark-pink .login-content .form-control:focus {
  border-color: #e91e63;
}

.dark-pink .filter-with-bg-color ul li a {
  border-color: #e91e63;
}
.dark-pink .filter-with-bg-color ul li a:hover, .dark-pink .filter-with-bg-color ul li a:focus, .dark-pink .filter-with-bg-color ul li a.active {
  background-color: #e91e63;
}

.dark-pink .profile-intro .icon {
  color: #e91e63;
}

.dark-pink .social-link li.active a, .dark-pink .social-link li a:hover, .dark-pink .social-link li a:focus {
  color: #00BFA5;
}

.dark-pink .actions {
  color: #00BFA5;
}

.dark-pink .table-hover tbody tr:hover {
  background-color: rgba(233, 30, 99, 0.075);
}

.dark-pink .border-primary {
  border-color: #e91e63 !important;
}

.dark-pink .app-logo-content {
  background-color: #e91e63;
}

.dark-pink .app-social-block .social-link button {
  border: solid 1px #e91e63;
  color: #e91e63;
}
.dark-pink .app-social-block .social-link button:hover, .dark-pink .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #e91e63;
}

.dark-pink .btn-group > .jr-btn.active,
.dark-pink .btn-group > .btn-default.active,
.dark-pink .btn-group-vertical > .jr-btn.active,
.dark-pink .btn-group-vertical > .btn-default.active {
  background-color: #e91e63;
  border-color: #e91e63;
}
.dark-pink .btn-group > .jr-flat-btn,
.dark-pink .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-pink .btn-group > .jr-flat-btn.active,
.dark-pink .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #e91e63 !important;
  border-color: transparent !important;
}
.dark-pink .btn-group > .jr-flat-btn.active:hover, .dark-pink .btn-group > .jr-flat-btn.active:focus,
.dark-pink .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-pink .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(233, 30, 99, 0.12) !important;
  color: #e91e63 !important;
}

.dark-pink .nav-pill-sales .nav-link.active {
  background-color: #e91e63;
  border-color: #e91e63;
}

.dark-pink .form-checkbox > input + .check,
.dark-pink .form-checkbox > input.sm + .check {
  color: #e91e63;
}

/* Input Placeholder Style */
.dark-pink .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-pink .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-pink .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-pink .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-pink .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-pink .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-pink .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-pink .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Blue Styles*/
.dark-blue .right-arrow {
  color: #2196F3;
}
.dark-blue .right-arrow:after {
  color: #2196F3;
}

.dark-blue .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-blue .btn-primary:focus, .dark-blue .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-blue .btn-primary.disabled, .dark-blue .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-blue .btn-primary:not(:disabled):not(.disabled):active, .dark-blue .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-blue .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-blue .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-blue .btn-secondary:focus, .dark-blue .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-blue .btn-secondary.disabled, .dark-blue .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-blue .btn-secondary:not(:disabled):not(.disabled):active, .dark-blue .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-blue .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-blue .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-blue .btn-success:focus, .dark-blue .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-blue .btn-success.disabled, .dark-blue .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-blue .btn-success:not(:disabled):not(.disabled):active, .dark-blue .btn-success:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-blue .btn-success:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-blue .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-blue .btn-info:focus, .dark-blue .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-blue .btn-info.disabled, .dark-blue .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-blue .btn-info:not(:disabled):not(.disabled):active, .dark-blue .btn-info:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-blue .btn-info:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-blue .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-blue .btn-warning:focus, .dark-blue .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-blue .btn-warning.disabled, .dark-blue .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-blue .btn-warning:not(:disabled):not(.disabled):active, .dark-blue .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-blue .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-blue .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-blue .btn-danger:focus, .dark-blue .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-blue .btn-danger.disabled, .dark-blue .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-blue .btn-danger:not(:disabled):not(.disabled):active, .dark-blue .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-blue .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-blue .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-blue .btn-light:focus, .dark-blue .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-blue .btn-light.disabled, .dark-blue .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-blue .btn-light:not(:disabled):not(.disabled):active, .dark-blue .btn-light:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-blue .btn-light:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-blue .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-blue .btn-dark:focus, .dark-blue .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-blue .btn-dark.disabled, .dark-blue .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-blue .btn-dark:not(:disabled):not(.disabled):active, .dark-blue .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-blue .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-blue a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-blue a.btn-primary:focus, .dark-blue a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-blue a.btn-primary.disabled, .dark-blue a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-blue a.btn-primary:not(:disabled):not(.disabled):active, .dark-blue a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-blue a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-blue a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-blue a.btn-secondary:focus, .dark-blue a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-blue a.btn-secondary.disabled, .dark-blue a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-blue a.btn-secondary:not(:disabled):not(.disabled):active, .dark-blue a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-blue a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-blue a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-blue a.btn-success:focus, .dark-blue a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-blue a.btn-success.disabled, .dark-blue a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-blue a.btn-success:not(:disabled):not(.disabled):active, .dark-blue a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-blue a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-blue a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-blue a.btn-info:focus, .dark-blue a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-blue a.btn-info.disabled, .dark-blue a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-blue a.btn-info:not(:disabled):not(.disabled):active, .dark-blue a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-blue a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-blue a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-blue a.btn-warning:focus, .dark-blue a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-blue a.btn-warning.disabled, .dark-blue a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-blue a.btn-warning:not(:disabled):not(.disabled):active, .dark-blue a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-blue a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-blue a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-blue a.btn-danger:focus, .dark-blue a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-blue a.btn-danger.disabled, .dark-blue a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-blue a.btn-danger:not(:disabled):not(.disabled):active, .dark-blue a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-blue a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-blue a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-blue a.btn-light:focus, .dark-blue a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-blue a.btn-light.disabled, .dark-blue a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-blue a.btn-light:not(:disabled):not(.disabled):active, .dark-blue a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-blue a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-blue a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-blue a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-blue a.btn-dark:focus, .dark-blue a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-blue a.btn-dark.disabled, .dark-blue a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-blue a.btn-dark:not(:disabled):not(.disabled):active, .dark-blue a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-blue a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-blue .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-blue .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-blue .btn-outline-primary:focus, .dark-blue .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-blue .btn-outline-primary.disabled, .dark-blue .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-blue .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-blue .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-blue .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-blue .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-blue .btn-outline-secondary:focus, .dark-blue .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-blue .btn-outline-secondary.disabled, .dark-blue .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-blue .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-blue .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-blue .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-blue .btn-outline-success:focus, .dark-blue .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-blue .btn-outline-success.disabled, .dark-blue .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-blue .btn-outline-success:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-blue .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-blue .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-blue .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-blue .btn-outline-info:focus, .dark-blue .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-blue .btn-outline-info.disabled, .dark-blue .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-blue .btn-outline-info:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-blue .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-blue .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-blue .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-blue .btn-outline-warning:focus, .dark-blue .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-blue .btn-outline-warning.disabled, .dark-blue .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-blue .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-blue .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-blue .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-blue .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-blue .btn-outline-danger:focus, .dark-blue .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-blue .btn-outline-danger.disabled, .dark-blue .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-blue .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-blue .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-blue .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-blue .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-blue .btn-outline-light:focus, .dark-blue .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-blue .btn-outline-light.disabled, .dark-blue .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-blue .btn-outline-light:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-blue .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-blue .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-blue .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-blue .btn-outline-dark:focus, .dark-blue .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-blue .btn-outline-dark.disabled, .dark-blue .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-blue .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-blue .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-blue .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-blue .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-blue a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-blue a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-blue a.btn-outline-primary:focus, .dark-blue a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-blue a.btn-outline-primary.disabled, .dark-blue a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-blue a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-blue a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-blue a.btn-outline-secondary:focus, .dark-blue a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-blue a.btn-outline-secondary.disabled, .dark-blue a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-blue a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-blue a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-blue a.btn-outline-success:focus, .dark-blue a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-blue a.btn-outline-success.disabled, .dark-blue a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-blue a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-blue a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-blue a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-blue a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-blue a.btn-outline-info:focus, .dark-blue a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-blue a.btn-outline-info.disabled, .dark-blue a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-blue a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-blue a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-blue a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-blue a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-blue a.btn-outline-warning:focus, .dark-blue a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-blue a.btn-outline-warning.disabled, .dark-blue a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-blue a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-blue a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-blue a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-blue a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-blue a.btn-outline-danger:focus, .dark-blue a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-blue a.btn-outline-danger.disabled, .dark-blue a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-blue a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-blue a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-blue a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-blue a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-blue a.btn-outline-light:focus, .dark-blue a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-blue a.btn-outline-light.disabled, .dark-blue a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-blue a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-blue a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-blue a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-blue a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-blue a.btn-outline-dark:focus, .dark-blue a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-blue a.btn-outline-dark.disabled, .dark-blue a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-blue a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-blue a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-blue a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-blue a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-blue a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-blue a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-blue .btn-outline-primary,
.dark-blue a.btn-outline-primary {
  color: #2196F3;
  border-color: #2196F3;
}
.dark-blue .btn-outline-primary:focus, .dark-blue .btn-outline-primary:hover, .dark-blue .btn-outline-primary.disabled, .dark-blue .btn-outline-primary:disabled, .dark-blue .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-primary.dropdown-toggle,
.dark-blue a.btn-outline-primary:focus,
.dark-blue a.btn-outline-primary:hover,
.dark-blue a.btn-outline-primary.disabled,
.dark-blue a.btn-outline-primary:disabled,
.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-blue a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-blue a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #2196F3;
  background-color: #2196F3;
}

.dark-blue .btn-outline-secondary,
.dark-blue a.btn-outline-secondary {
  color: #FF6E40;
  border-color: #FF6E40;
}
.dark-blue .btn-outline-secondary:focus, .dark-blue .btn-outline-secondary:hover, .dark-blue .btn-outline-secondary.disabled, .dark-blue .btn-outline-secondary:disabled, .dark-blue .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-blue .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-blue .btn-outline-secondary.dropdown-toggle,
.dark-blue a.btn-outline-secondary:focus,
.dark-blue a.btn-outline-secondary:hover,
.dark-blue a.btn-outline-secondary.disabled,
.dark-blue a.btn-outline-secondary:disabled,
.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-blue a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-blue a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF6E40;
  background-color: #FF6E40;
}

.dark-blue a, .dark-blue a.text-primary {
  color: #2196F3;
}
.dark-blue a:focus, .dark-blue a:hover, .dark-blue a.text-primary:focus, .dark-blue a.text-primary:hover {
  color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}
.dark-blue .text-primary {
  color: #2196F3 !important;
}
.dark-blue .page-link {
  color: #2196F3;
}
.dark-blue .page-link:focus, .dark-blue .page-link:hover {
  color: #2196F3;
}
.dark-blue .bg-primary, .dark-blue .badge-primary {
  background-color: #2196F3 !important;
  color: #fff !important;
}
.dark-blue .btn-primary, .dark-blue .jr-btn-primary, .dark-blue a.btn-primary, .dark-blue a.jr-btn-primary {
  background-color: #2196F3;
  border-color: #2196F3;
  color: #fff;
}
.dark-blue .btn-primary:hover, .dark-blue .btn-primary:focus, .dark-blue .btn-primary:not([disabled]):not(.disabled):active, .dark-blue .jr-btn-primary:hover, .dark-blue .jr-btn-primary:focus, .dark-blue .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-blue a.btn-primary:hover, .dark-blue a.btn-primary:focus, .dark-blue a.btn-primary:not([disabled]):not(.disabled):active, .dark-blue a.jr-btn-primary:hover, .dark-blue a.jr-btn-primary:focus, .dark-blue a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(12.8461538462, 138.0961538462, 237.6538461538) !important;
  border-color: rgb(12.8461538462, 138.0961538462, 237.6538461538) !important;
  color: #fff !important;
}
.dark-blue .bg-primary.lighten-4 {
  background-color: #BBDEFB !important;
}
.dark-blue .bg-primary.lighten-3 {
  background-color: #90CAF9 !important;
}
.dark-blue .bg-primary.lighten-2 {
  background-color: #64B5F6 !important;
}
.dark-blue .bg-primary.lighten-1 {
  background-color: #42A5F5 !important;
}
.dark-blue .bg-primary.darken-1 {
  background-color: #1E88E5 !important;
}
.dark-blue .bg-primary.darken-2 {
  background-color: #1976D2 !important;
}
.dark-blue .bg-primary.darken-3 {
  background-color: #1565C0 !important;
}
.dark-blue .bg-primary.darken-4 {
  background-color: #0D47A1 !important;
}
.dark-blue .bg-primary.accent-1 {
  background-color: #82B1FF !important;
}
.dark-blue .bg-primary.accent-2 {
  background-color: #448AFF !important;
}
.dark-blue .bg-primary.accent-3 {
  background-color: #2979FF !important;
}
.dark-blue .bg-primary.accent-4 {
  background-color: #2962FF !important;
}

.dark-blue a.text-secondary {
  color: #FF6E40;
}
.dark-blue a.text-secondary:focus, .dark-blue a.text-secondary:hover {
  color: rgb(255, 71.2827225131, 13) !important;
}
.dark-blue .text-secondary {
  color: #FF6E40 !important;
}
.dark-blue .bg-secondary, .dark-blue .badge-secondary {
  background-color: #FF6E40 !important;
  color: #fff !important;
}
.dark-blue .btn-secondary {
  background-color: #FF6E40;
  border-color: #FF6E40;
  color: #fff;
}
.dark-blue .btn-secondary:hover, .dark-blue .btn-secondary:focus, .dark-blue .btn-secondary:active {
  background-color: rgb(255, 90.6413612565, 38.5) !important;
  border-color: rgb(255, 90.6413612565, 38.5) !important;
  color: #fff !important;
}

.dark-blue .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-blue .jr-flat-btn:hover, .dark-blue .jr-flat-btn:focus, .dark-blue .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-blue .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #2196F3 !important;
  border-color: transparent !important;
}
.dark-blue .jr-flat-btn.jr-btn-primary:hover, .dark-blue .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(33, 150, 243, 0.12) !important;
  color: #2196F3 !important;
}

.dark-blue .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-blue .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-blue .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-blue .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF6E40 !important;
  border-color: transparent !important;
}
.dark-blue .jr-flat-btn.jr-btn-secondary:hover, .dark-blue .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 110, 64, 0.12) !important;
  color: #FF6E40 !important;
}

.dark-blue .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-blue .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-blue .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-blue .app-main-header {
  background-color: #2196F3 !important;
  color: #fff;
  border-color: #2196F3;
}
.dark-blue .app-main-header .search-bar input {
  background-color: rgb(57.1923076923, 161.4423076923, 244.3076923077);
}
.dark-blue .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-blue .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-blue .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-blue .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-blue .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-blue .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-blue .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-blue .quick-menu .icon-btn {
  color: #fff;
}

.dark-blue .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-blue .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-blue .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-blue .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-blue .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-blue .color-theme-header {
  background-color: #2196F3;
}

.dark-blue .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-blue .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-blue .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-blue .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-blue .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-blue ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-blue ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-blue ul.nav-menu > li.open > a,
.dark-blue ul.nav-menu > li > a:hover,
.dark-blue ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-blue ul.nav-menu li.menu.open > a {
  border-color: #2196F3;
}

.dark-blue ul.nav-menu li.menu > a:focus:before,
.dark-blue ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-blue ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-blue ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-blue ul.nav-menu li.menu.open > a:before,
.dark-blue ul.nav-menu li.menu > a:focus:before,
.dark-blue ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-blue ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-blue ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #2196F3;
}

.dark-blue ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-blue ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-blue ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-blue ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-blue ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-blue .navbar-nav li:hover > a, .dark-blue .navbar-nav li:focus > a {
  color: #2196F3;
}
.dark-blue .navbar-nav li a {
  color: #333;
}
.dark-blue .navbar-nav li a:hover, .dark-blue .navbar-nav li a:focus {
  color: #2196F3;
}
.dark-blue .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-blue .navbar-nav li.nav-item:hover > a, .dark-blue .navbar-nav li.nav-item:focus > a, .dark-blue .navbar-nav li.nav-item > a:hover, .dark-blue .navbar-nav li.nav-item > a:focus, .dark-blue .navbar-nav li.nav-item.active > a {
  color: #FF6E40;
}
.dark-blue .navbar-nav ul.sub-menu li a.active, .dark-blue .navbar-nav ul.sub-menu li.active > a {
  color: #2196F3;
}
.dark-blue .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-blue .navbar-nav .nav-arrow a:hover:before, .dark-blue .navbar-nav .nav-arrow a:focus:before {
  color: #2196F3;
}
.dark-blue .navbar-nav .nav-arrow:hover > a:before, .dark-blue .navbar-nav .nav-arrow:focus > a:before, .dark-blue .navbar-nav .nav-arrow.active > a:before {
  color: #2196F3;
}

.dark-blue .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-blue .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-blue .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-blue .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-blue .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-blue .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-blue .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF6E40;
}

.dark-blue .module-nav li a.active {
  border-color: #2196F3;
}

.dark-blue .rbc-event {
  background-color: #2196F3;
}

.dark-blue .rbc-event.rbc-selected {
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}

.dark-blue .rbc-slot-selection {
  background-color: rgba(33, 150, 243, 0.7);
}

.dark-blue .rbc-toolbar button:active,
.dark-blue .rbc-toolbar button.rbc-active {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.dark-blue .rbc-toolbar button:active:hover,
.dark-blue .rbc-toolbar button.rbc-active:hover,
.dark-blue .rbc-toolbar button:active:focus,
.dark-blue .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.dark-blue .rbc-toolbar button:focus {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.dark-blue .rbc-toolbar button:hover {
  background-color: rgba(33, 150, 243, 0.9);
  border-color: #2196F3;
}

.dark-blue .rbc-day-slot .rbc-event {
  border-color: #2196F3;
}

.dark-blue .chat-sidenav-title {
  color: #2196F3;
}

.dark-blue .chat-user-item.active, .dark-blue .chat-user-item:hover {
  background-color: rgb(226.5384615385, 241.5384615385, 253.4615384615);
}

.dark-blue .contact-list i {
  color: #2196F3;
}

.dark-blue .Collapsible__trigger {
  background: #2196F3;
}

.dark-blue .categories-list li a:focus, .dark-blue .categories-list li a:hover, .dark-blue .categories-list li.active a {
  color: #2196F3;
}

.dark-blue .login-content .form-control:focus {
  border-color: #2196F3;
}

.dark-blue .filter-with-bg-color ul li a {
  border-color: #2196F3;
}
.dark-blue .filter-with-bg-color ul li a:hover, .dark-blue .filter-with-bg-color ul li a:focus, .dark-blue .filter-with-bg-color ul li a.active {
  background-color: #2196F3;
}

.dark-blue .profile-intro .icon {
  color: #2196F3;
}

.dark-blue .social-link li.active a, .dark-blue .social-link li a:hover, .dark-blue .social-link li a:focus {
  color: #FF6E40;
}

.dark-blue .actions {
  color: #FF6E40;
}

.dark-blue .table-hover tbody tr:hover {
  background-color: rgba(33, 150, 243, 0.075);
}

.dark-blue .border-primary {
  border-color: #2196F3 !important;
}

.dark-blue .app-logo-content {
  background-color: #2196F3;
}

.dark-blue .app-social-block .social-link button {
  border: solid 1px #2196F3;
  color: #2196F3;
}
.dark-blue .app-social-block .social-link button:hover, .dark-blue .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #2196F3;
}

.dark-blue .btn-group > .jr-btn.active,
.dark-blue .btn-group > .btn-default.active,
.dark-blue .btn-group-vertical > .jr-btn.active,
.dark-blue .btn-group-vertical > .btn-default.active {
  background-color: #2196F3;
  border-color: #2196F3;
}
.dark-blue .btn-group > .jr-flat-btn,
.dark-blue .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-blue .btn-group > .jr-flat-btn.active,
.dark-blue .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #2196F3 !important;
  border-color: transparent !important;
}
.dark-blue .btn-group > .jr-flat-btn.active:hover, .dark-blue .btn-group > .jr-flat-btn.active:focus,
.dark-blue .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-blue .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(33, 150, 243, 0.12) !important;
  color: #2196F3 !important;
}

.dark-blue .nav-pill-sales .nav-link.active {
  background-color: #2196F3;
  border-color: #2196F3;
}

.dark-blue .form-checkbox > input + .check,
.dark-blue .form-checkbox > input.sm + .check {
  color: #2196F3;
}

/* Input Placeholder Style */
.dark-blue .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-blue .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-blue .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-blue .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-blue .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-blue .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-blue .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-blue .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Deep Purple Styles*/
.dark-deep-purple .right-arrow {
  color: #673ab7;
}
.dark-deep-purple .right-arrow:after {
  color: #673ab7;
}

.dark-deep-purple .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-deep-purple .btn-primary:focus, .dark-deep-purple .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-purple .btn-primary.disabled, .dark-deep-purple .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-purple .btn-primary:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-deep-purple .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-purple .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-deep-purple .btn-secondary:focus, .dark-deep-purple .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-purple .btn-secondary.disabled, .dark-deep-purple .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-purple .btn-secondary:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-deep-purple .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-purple .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-deep-purple .btn-success:focus, .dark-deep-purple .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-purple .btn-success.disabled, .dark-deep-purple .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-purple .btn-success:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-success:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-deep-purple .btn-success:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-purple .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-deep-purple .btn-info:focus, .dark-deep-purple .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-purple .btn-info.disabled, .dark-deep-purple .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-purple .btn-info:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-info:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-deep-purple .btn-info:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-purple .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-deep-purple .btn-warning:focus, .dark-deep-purple .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-purple .btn-warning.disabled, .dark-deep-purple .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-purple .btn-warning:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-deep-purple .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-purple .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-deep-purple .btn-danger:focus, .dark-deep-purple .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-purple .btn-danger.disabled, .dark-deep-purple .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-purple .btn-danger:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-deep-purple .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-purple .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-deep-purple .btn-light:focus, .dark-deep-purple .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-purple .btn-light.disabled, .dark-deep-purple .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-purple .btn-light:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-light:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-deep-purple .btn-light:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-purple .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-deep-purple .btn-dark:focus, .dark-deep-purple .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-purple .btn-dark.disabled, .dark-deep-purple .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-purple .btn-dark:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-deep-purple .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-purple a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-deep-purple a.btn-primary:focus, .dark-deep-purple a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-purple a.btn-primary.disabled, .dark-deep-purple a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-purple a.btn-primary:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-deep-purple a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-purple a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-deep-purple a.btn-secondary:focus, .dark-deep-purple a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-purple a.btn-secondary.disabled, .dark-deep-purple a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-purple a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-deep-purple a.btn-success:focus, .dark-deep-purple a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-purple a.btn-success.disabled, .dark-deep-purple a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-purple a.btn-success:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-deep-purple a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-purple a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-deep-purple a.btn-info:focus, .dark-deep-purple a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-purple a.btn-info.disabled, .dark-deep-purple a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-purple a.btn-info:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-deep-purple a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-purple a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-deep-purple a.btn-warning:focus, .dark-deep-purple a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-purple a.btn-warning.disabled, .dark-deep-purple a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-purple a.btn-warning:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-deep-purple a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-purple a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-deep-purple a.btn-danger:focus, .dark-deep-purple a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-purple a.btn-danger.disabled, .dark-deep-purple a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-purple a.btn-danger:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-deep-purple a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-purple a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-deep-purple a.btn-light:focus, .dark-deep-purple a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-purple a.btn-light.disabled, .dark-deep-purple a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-purple a.btn-light:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-deep-purple a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-purple a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-deep-purple a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-deep-purple a.btn-dark:focus, .dark-deep-purple a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-purple a.btn-dark.disabled, .dark-deep-purple a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-purple a.btn-dark:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-deep-purple a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-purple .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-deep-purple .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-purple .btn-outline-primary:focus, .dark-deep-purple .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-purple .btn-outline-primary.disabled, .dark-deep-purple .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-purple .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-deep-purple .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-purple .btn-outline-secondary:focus, .dark-deep-purple .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-purple .btn-outline-secondary.disabled, .dark-deep-purple .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-purple .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-deep-purple .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-purple .btn-outline-success:focus, .dark-deep-purple .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-purple .btn-outline-success.disabled, .dark-deep-purple .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-purple .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-deep-purple .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-purple .btn-outline-info:focus, .dark-deep-purple .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-purple .btn-outline-info.disabled, .dark-deep-purple .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-purple .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-deep-purple .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-purple .btn-outline-warning:focus, .dark-deep-purple .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-purple .btn-outline-warning.disabled, .dark-deep-purple .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-purple .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-deep-purple .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-purple .btn-outline-danger:focus, .dark-deep-purple .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-purple .btn-outline-danger.disabled, .dark-deep-purple .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-purple .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-deep-purple .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-purple .btn-outline-light:focus, .dark-deep-purple .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-purple .btn-outline-light.disabled, .dark-deep-purple .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-purple .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-deep-purple .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-purple .btn-outline-dark:focus, .dark-deep-purple .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-purple .btn-outline-dark.disabled, .dark-deep-purple .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-purple .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-purple a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-deep-purple a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-purple a.btn-outline-primary:focus, .dark-deep-purple a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-deep-purple a.btn-outline-primary.disabled, .dark-deep-purple a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-deep-purple a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-deep-purple a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-purple a.btn-outline-secondary:focus, .dark-deep-purple a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-deep-purple a.btn-outline-secondary.disabled, .dark-deep-purple a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-deep-purple a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-deep-purple a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-purple a.btn-outline-success:focus, .dark-deep-purple a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-deep-purple a.btn-outline-success.disabled, .dark-deep-purple a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-deep-purple a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-deep-purple a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-purple a.btn-outline-info:focus, .dark-deep-purple a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-deep-purple a.btn-outline-info.disabled, .dark-deep-purple a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-deep-purple a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-deep-purple a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-purple a.btn-outline-warning:focus, .dark-deep-purple a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-deep-purple a.btn-outline-warning.disabled, .dark-deep-purple a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-deep-purple a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-deep-purple a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-purple a.btn-outline-danger:focus, .dark-deep-purple a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-deep-purple a.btn-outline-danger.disabled, .dark-deep-purple a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-deep-purple a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-deep-purple a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-purple a.btn-outline-light:focus, .dark-deep-purple a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-deep-purple a.btn-outline-light.disabled, .dark-deep-purple a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-deep-purple a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-deep-purple a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-purple a.btn-outline-dark:focus, .dark-deep-purple a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-deep-purple a.btn-outline-dark.disabled, .dark-deep-purple a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-deep-purple a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-deep-purple a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-deep-purple a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-deep-purple .btn-outline-primary,
.dark-deep-purple a.btn-outline-primary {
  color: #673ab7;
  border-color: #673ab7;
}
.dark-deep-purple .btn-outline-primary:focus, .dark-deep-purple .btn-outline-primary:hover, .dark-deep-purple .btn-outline-primary.disabled, .dark-deep-purple .btn-outline-primary:disabled, .dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-primary.dropdown-toggle,
.dark-deep-purple a.btn-outline-primary:focus,
.dark-deep-purple a.btn-outline-primary:hover,
.dark-deep-purple a.btn-outline-primary.disabled,
.dark-deep-purple a.btn-outline-primary:disabled,
.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-deep-purple a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-deep-purple a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #673ab7;
  background-color: #673ab7;
}

.dark-deep-purple .btn-outline-secondary,
.dark-deep-purple a.btn-outline-secondary {
  color: #FFAB00;
  border-color: #FFAB00;
}
.dark-deep-purple .btn-outline-secondary:focus, .dark-deep-purple .btn-outline-secondary:hover, .dark-deep-purple .btn-outline-secondary.disabled, .dark-deep-purple .btn-outline-secondary:disabled, .dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-deep-purple .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-deep-purple .btn-outline-secondary.dropdown-toggle,
.dark-deep-purple a.btn-outline-secondary:focus,
.dark-deep-purple a.btn-outline-secondary:hover,
.dark-deep-purple a.btn-outline-secondary.disabled,
.dark-deep-purple a.btn-outline-secondary:disabled,
.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-deep-purple a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-deep-purple a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FFAB00;
  background-color: #FFAB00;
}

.dark-deep-purple a, .dark-deep-purple a.text-primary {
  color: #673ab7;
}
.dark-deep-purple a:focus, .dark-deep-purple a:hover, .dark-deep-purple a.text-primary:focus, .dark-deep-purple a.text-primary:hover {
  color: rgb(81.2033195021, 45.7261410788, 144.2738589212);
}
.dark-deep-purple .text-primary {
  color: #673ab7 !important;
}
.dark-deep-purple .page-link {
  color: #673ab7;
}
.dark-deep-purple .page-link:focus, .dark-deep-purple .page-link:hover {
  color: #673ab7;
}
.dark-deep-purple .bg-primary, .dark-deep-purple .badge-primary {
  background-color: #673ab7 !important;
  color: #fff !important;
}
.dark-deep-purple .btn-primary, .dark-deep-purple .jr-btn-primary, .dark-deep-purple a.btn-primary, .dark-deep-purple a.jr-btn-primary {
  background-color: #673ab7;
  border-color: #673ab7;
  color: #fff;
}
.dark-deep-purple .btn-primary:hover, .dark-deep-purple .btn-primary:focus, .dark-deep-purple .btn-primary:not([disabled]):not(.disabled):active, .dark-deep-purple .jr-btn-primary:hover, .dark-deep-purple .jr-btn-primary:focus, .dark-deep-purple .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-deep-purple a.btn-primary:hover, .dark-deep-purple a.btn-primary:focus, .dark-deep-purple a.btn-primary:not([disabled]):not(.disabled):active, .dark-deep-purple a.jr-btn-primary:hover, .dark-deep-purple a.jr-btn-primary:focus, .dark-deep-purple a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(92.101659751, 51.8630705394, 163.6369294606) !important;
  border-color: rgb(92.101659751, 51.8630705394, 163.6369294606) !important;
  color: #fff !important;
}
.dark-deep-purple .bg-primary.lighten-4 {
  background-color: #d1c4e9 !important;
}
.dark-deep-purple .bg-primary.lighten-3 {
  background-color: #b39ddb !important;
}
.dark-deep-purple .bg-primary.lighten-2 {
  background-color: #9575cd !important;
}
.dark-deep-purple .bg-primary.lighten-1 {
  background-color: #7e57c2 !important;
}
.dark-deep-purple .bg-primary.darken-1 {
  background-color: #5e35b1 !important;
}
.dark-deep-purple .bg-primary.darken-2 {
  background-color: #512da8 !important;
}
.dark-deep-purple .bg-primary.darken-3 {
  background-color: #4527a0 !important;
}
.dark-deep-purple .bg-primary.darken-4 {
  background-color: #311b92 !important;
}
.dark-deep-purple .bg-primary.accent-1 {
  background-color: #b388ff !important;
}
.dark-deep-purple .bg-primary.accent-2 {
  background-color: #7c4dff !important;
}
.dark-deep-purple .bg-primary.accent-3 {
  background-color: #651fff !important;
}
.dark-deep-purple .bg-primary.accent-4 {
  background-color: #6200ea !important;
}

.dark-deep-purple a.text-secondary {
  color: #FFAB00;
}
.dark-deep-purple a.text-secondary:focus, .dark-deep-purple a.text-secondary:hover {
  color: rgb(204, 136.8, 0) !important;
}
.dark-deep-purple .text-secondary {
  color: #FFAB00 !important;
}
.dark-deep-purple .bg-secondary, .dark-deep-purple .badge-secondary {
  background-color: #FFAB00 !important;
  color: #fff !important;
}
.dark-deep-purple .btn-secondary {
  background-color: #FFAB00;
  border-color: #FFAB00;
  color: #fff;
}
.dark-deep-purple .btn-secondary:hover, .dark-deep-purple .btn-secondary:focus, .dark-deep-purple .btn-secondary:active {
  background-color: rgb(229.5, 153.9, 0) !important;
  border-color: rgb(229.5, 153.9, 0) !important;
  color: #fff !important;
}

.dark-deep-purple .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-deep-purple .jr-flat-btn:hover, .dark-deep-purple .jr-flat-btn:focus, .dark-deep-purple .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-deep-purple .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #673ab7 !important;
  border-color: transparent !important;
}
.dark-deep-purple .jr-flat-btn.jr-btn-primary:hover, .dark-deep-purple .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(103, 58, 183, 0.12) !important;
  color: #673ab7 !important;
}

.dark-deep-purple .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-deep-purple .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-deep-purple .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FFAB00 !important;
  border-color: transparent !important;
}
.dark-deep-purple .jr-flat-btn.jr-btn-secondary:hover, .dark-deep-purple .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 171, 0, 0.12) !important;
  color: #FFAB00 !important;
}

.dark-deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-deep-purple .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-deep-purple .app-main-header {
  background-color: #673ab7 !important;
  color: #fff;
  border-color: #673ab7;
}
.dark-deep-purple .app-main-header .search-bar input {
  background-color: rgb(115.5684647303, 70.101659751, 196.398340249);
}
.dark-deep-purple .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-deep-purple .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-deep-purple .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-deep-purple .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-deep-purple .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-deep-purple .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-deep-purple .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-deep-purple .quick-menu .icon-btn {
  color: #fff;
}

.dark-deep-purple .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-deep-purple .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-deep-purple .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-deep-purple .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-deep-purple .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-deep-purple .color-theme-header {
  background-color: #673ab7;
}

.dark-deep-purple .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-deep-purple .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-deep-purple .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-deep-purple .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-deep-purple .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-deep-purple ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-deep-purple ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-deep-purple ul.nav-menu > li.open > a,
.dark-deep-purple ul.nav-menu > li > a:hover,
.dark-deep-purple ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-deep-purple ul.nav-menu li.menu.open > a {
  border-color: #FFAB00;
}

.dark-deep-purple ul.nav-menu li.menu > a:focus:before,
.dark-deep-purple ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-deep-purple ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-deep-purple ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-deep-purple ul.nav-menu li.menu.open > a:before,
.dark-deep-purple ul.nav-menu li.menu > a:focus:before,
.dark-deep-purple ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #673ab7;
}

.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-deep-purple ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-deep-purple .navbar-nav li:hover > a, .dark-deep-purple .navbar-nav li:focus > a {
  color: #673ab7;
}
.dark-deep-purple .navbar-nav li a {
  color: #333;
}
.dark-deep-purple .navbar-nav li a:hover, .dark-deep-purple .navbar-nav li a:focus {
  color: #673ab7;
}
.dark-deep-purple .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-deep-purple .navbar-nav li.nav-item:hover > a, .dark-deep-purple .navbar-nav li.nav-item:focus > a, .dark-deep-purple .navbar-nav li.nav-item > a:hover, .dark-deep-purple .navbar-nav li.nav-item > a:focus, .dark-deep-purple .navbar-nav li.nav-item.active > a {
  color: #FFAB00;
}
.dark-deep-purple .navbar-nav ul.sub-menu li a.active, .dark-deep-purple .navbar-nav ul.sub-menu li.active > a {
  color: #673ab7;
}
.dark-deep-purple .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-deep-purple .navbar-nav .nav-arrow a:hover:before, .dark-deep-purple .navbar-nav .nav-arrow a:focus:before {
  color: #673ab7;
}
.dark-deep-purple .navbar-nav .nav-arrow:hover > a:before, .dark-deep-purple .navbar-nav .nav-arrow:focus > a:before, .dark-deep-purple .navbar-nav .nav-arrow.active > a:before {
  color: #673ab7;
}

.dark-deep-purple .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-deep-purple .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-deep-purple .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-deep-purple .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-deep-purple .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-deep-purple .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-deep-purple .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FFAB00;
}

.dark-deep-purple .module-nav li a.active {
  border-color: #673ab7;
}

.dark-deep-purple .rbc-event {
  background-color: #673ab7;
}

.dark-deep-purple .rbc-event.rbc-selected {
  background-color: rgb(81.2033195021, 45.7261410788, 144.2738589212);
}

.dark-deep-purple .rbc-slot-selection {
  background-color: rgba(103, 58, 183, 0.7);
}

.dark-deep-purple .rbc-toolbar button:active,
.dark-deep-purple .rbc-toolbar button.rbc-active {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.dark-deep-purple .rbc-toolbar button:active:hover,
.dark-deep-purple .rbc-toolbar button.rbc-active:hover,
.dark-deep-purple .rbc-toolbar button:active:focus,
.dark-deep-purple .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.dark-deep-purple .rbc-toolbar button:focus {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.dark-deep-purple .rbc-toolbar button:hover {
  background-color: rgba(103, 58, 183, 0.9);
  border-color: #673ab7;
}

.dark-deep-purple .rbc-day-slot .rbc-event {
  border-color: #673ab7;
}

.dark-deep-purple .chat-sidenav-title {
  color: #673ab7;
}

.dark-deep-purple .chat-user-item.active, .dark-deep-purple .chat-user-item:hover {
  background-color: rgb(232.3817427386, 225.0062240664, 245.4937759336);
}

.dark-deep-purple .contact-list i {
  color: #673ab7;
}

.dark-deep-purple .Collapsible__trigger {
  background: #673ab7;
}

.dark-deep-purple .categories-list li a:focus, .dark-deep-purple .categories-list li a:hover, .dark-deep-purple .categories-list li.active a {
  color: #673ab7;
}

.dark-deep-purple .login-content .form-control:focus {
  border-color: #673ab7;
}

.dark-deep-purple .filter-with-bg-color ul li a {
  border-color: #673ab7;
}
.dark-deep-purple .filter-with-bg-color ul li a:hover, .dark-deep-purple .filter-with-bg-color ul li a:focus, .dark-deep-purple .filter-with-bg-color ul li a.active {
  background-color: #673ab7;
}

.dark-deep-purple .profile-intro .icon {
  color: #673ab7;
}

.dark-deep-purple .social-link li.active a, .dark-deep-purple .social-link li a:hover, .dark-deep-purple .social-link li a:focus {
  color: #FFAB00;
}

.dark-deep-purple .actions {
  color: #FFAB00;
}

.dark-deep-purple .table-hover tbody tr:hover {
  background-color: rgba(103, 58, 183, 0.075);
}

.dark-deep-purple .border-primary {
  border-color: #673ab7 !important;
}

.dark-deep-purple .app-logo-content {
  background-color: #673ab7;
}

.dark-deep-purple .app-social-block .social-link button {
  border: solid 1px #673ab7;
  color: #673ab7;
}
.dark-deep-purple .app-social-block .social-link button:hover, .dark-deep-purple .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #673ab7;
}

.dark-deep-purple .btn-group > .jr-btn.active,
.dark-deep-purple .btn-group > .btn-default.active,
.dark-deep-purple .btn-group-vertical > .jr-btn.active,
.dark-deep-purple .btn-group-vertical > .btn-default.active {
  background-color: #673ab7;
  border-color: #673ab7;
}
.dark-deep-purple .btn-group > .jr-flat-btn,
.dark-deep-purple .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-deep-purple .btn-group > .jr-flat-btn.active,
.dark-deep-purple .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #673ab7 !important;
  border-color: transparent !important;
}
.dark-deep-purple .btn-group > .jr-flat-btn.active:hover, .dark-deep-purple .btn-group > .jr-flat-btn.active:focus,
.dark-deep-purple .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-deep-purple .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(103, 58, 183, 0.12) !important;
  color: #673ab7 !important;
}

.dark-deep-purple .nav-pill-sales .nav-link.active {
  background-color: #673ab7;
  border-color: #673ab7;
}

.dark-deep-purple .form-checkbox > input + .check,
.dark-deep-purple .form-checkbox > input.sm + .check {
  color: #673ab7;
}

/* Input Placeholder Style */
.dark-deep-purple .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-purple .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-purple .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-purple .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-deep-purple .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-deep-purple .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-deep-purple .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-deep-purple .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Green Styles*/
.dark-green .right-arrow {
  color: #4CAF50;
}
.dark-green .right-arrow:after {
  color: #4CAF50;
}

.dark-green .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-green .btn-primary:focus, .dark-green .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-green .btn-primary.disabled, .dark-green .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-green .btn-primary:not(:disabled):not(.disabled):active, .dark-green .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-green .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-green .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-green .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-green .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-green .btn-secondary:focus, .dark-green .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-green .btn-secondary.disabled, .dark-green .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-green .btn-secondary:not(:disabled):not(.disabled):active, .dark-green .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-green .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-green .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-green .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-green .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-green .btn-success:focus, .dark-green .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-green .btn-success.disabled, .dark-green .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-green .btn-success:not(:disabled):not(.disabled):active, .dark-green .btn-success:not(:disabled):not(.disabled).active, .show > .dark-green .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-green .btn-success:not(:disabled):not(.disabled):active:focus, .dark-green .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-green .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-green .btn-info:focus, .dark-green .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-green .btn-info.disabled, .dark-green .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-green .btn-info:not(:disabled):not(.disabled):active, .dark-green .btn-info:not(:disabled):not(.disabled).active, .show > .dark-green .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-green .btn-info:not(:disabled):not(.disabled):active:focus, .dark-green .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-green .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-green .btn-warning:focus, .dark-green .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-green .btn-warning.disabled, .dark-green .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-green .btn-warning:not(:disabled):not(.disabled):active, .dark-green .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-green .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-green .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-green .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-green .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-green .btn-danger:focus, .dark-green .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-green .btn-danger.disabled, .dark-green .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-green .btn-danger:not(:disabled):not(.disabled):active, .dark-green .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-green .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-green .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-green .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-green .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-green .btn-light:focus, .dark-green .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-green .btn-light.disabled, .dark-green .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-green .btn-light:not(:disabled):not(.disabled):active, .dark-green .btn-light:not(:disabled):not(.disabled).active, .show > .dark-green .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-green .btn-light:not(:disabled):not(.disabled):active:focus, .dark-green .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-green .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-green .btn-dark:focus, .dark-green .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-green .btn-dark.disabled, .dark-green .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-green .btn-dark:not(:disabled):not(.disabled):active, .dark-green .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-green .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-green .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-green .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-green a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-green a.btn-primary:focus, .dark-green a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-green a.btn-primary.disabled, .dark-green a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-green a.btn-primary:not(:disabled):not(.disabled):active, .dark-green a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-green a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-green a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-green a.btn-secondary:focus, .dark-green a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-green a.btn-secondary.disabled, .dark-green a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-green a.btn-secondary:not(:disabled):not(.disabled):active, .dark-green a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-green a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-green a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-green a.btn-success:focus, .dark-green a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-green a.btn-success.disabled, .dark-green a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-green a.btn-success:not(:disabled):not(.disabled):active, .dark-green a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-green a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-green a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-green a.btn-info:focus, .dark-green a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-green a.btn-info.disabled, .dark-green a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-green a.btn-info:not(:disabled):not(.disabled):active, .dark-green a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-green a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-green a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-green a.btn-warning:focus, .dark-green a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-green a.btn-warning.disabled, .dark-green a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-green a.btn-warning:not(:disabled):not(.disabled):active, .dark-green a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-green a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-green a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-green a.btn-danger:focus, .dark-green a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-green a.btn-danger.disabled, .dark-green a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-green a.btn-danger:not(:disabled):not(.disabled):active, .dark-green a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-green a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-green a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-green a.btn-light:focus, .dark-green a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-green a.btn-light.disabled, .dark-green a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-green a.btn-light:not(:disabled):not(.disabled):active, .dark-green a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-green a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-green a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-green a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-green a.btn-dark:focus, .dark-green a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-green a.btn-dark.disabled, .dark-green a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-green a.btn-dark:not(:disabled):not(.disabled):active, .dark-green a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-green a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-green .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-green .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-green .btn-outline-primary:focus, .dark-green .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-green .btn-outline-primary.disabled, .dark-green .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-green .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-green .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-green .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-green .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-green .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-green .btn-outline-secondary:focus, .dark-green .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-green .btn-outline-secondary.disabled, .dark-green .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-green .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-green .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-green .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-green .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-green .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-green .btn-outline-success:focus, .dark-green .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-green .btn-outline-success.disabled, .dark-green .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-green .btn-outline-success:not(:disabled):not(.disabled):active, .dark-green .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-green .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-green .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-green .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-green .btn-outline-info:focus, .dark-green .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-green .btn-outline-info.disabled, .dark-green .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-green .btn-outline-info:not(:disabled):not(.disabled):active, .dark-green .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-green .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-green .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-green .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-green .btn-outline-warning:focus, .dark-green .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-green .btn-outline-warning.disabled, .dark-green .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-green .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-green .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-green .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-green .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-green .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-green .btn-outline-danger:focus, .dark-green .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-green .btn-outline-danger.disabled, .dark-green .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-green .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-green .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-green .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-green .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-green .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-green .btn-outline-light:focus, .dark-green .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-green .btn-outline-light.disabled, .dark-green .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-green .btn-outline-light:not(:disabled):not(.disabled):active, .dark-green .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-green .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-green .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-green .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-green .btn-outline-dark:focus, .dark-green .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-green .btn-outline-dark.disabled, .dark-green .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-green .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-green .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-green .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-green .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-green .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-green a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-green a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-green a.btn-outline-primary:focus, .dark-green a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-green a.btn-outline-primary.disabled, .dark-green a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-green a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-green a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-green a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-green a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-green a.btn-outline-secondary:focus, .dark-green a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-green a.btn-outline-secondary.disabled, .dark-green a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-green a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-green a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-green a.btn-outline-success:focus, .dark-green a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-green a.btn-outline-success.disabled, .dark-green a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-green a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-green a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-green a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-green a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-green a.btn-outline-info:focus, .dark-green a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-green a.btn-outline-info.disabled, .dark-green a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-green a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-green a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-green a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-green a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-green a.btn-outline-warning:focus, .dark-green a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-green a.btn-outline-warning.disabled, .dark-green a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-green a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-green a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-green a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-green a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-green a.btn-outline-danger:focus, .dark-green a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-green a.btn-outline-danger.disabled, .dark-green a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-green a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-green a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-green a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-green a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-green a.btn-outline-light:focus, .dark-green a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-green a.btn-outline-light.disabled, .dark-green a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-green a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-green a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-green a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-green a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-green a.btn-outline-dark:focus, .dark-green a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-green a.btn-outline-dark.disabled, .dark-green a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-green a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-green a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-green a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-green a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-green a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-green a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-green .btn-outline-primary,
.dark-green a.btn-outline-primary {
  color: #4CAF50;
  border-color: #4CAF50;
}
.dark-green .btn-outline-primary:focus, .dark-green .btn-outline-primary:hover, .dark-green .btn-outline-primary.disabled, .dark-green .btn-outline-primary:disabled, .dark-green .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-green .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-primary.dropdown-toggle,
.dark-green a.btn-outline-primary:focus,
.dark-green a.btn-outline-primary:hover,
.dark-green a.btn-outline-primary.disabled,
.dark-green a.btn-outline-primary:disabled,
.dark-green a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-green a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-green a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: #4CAF50;
  background-color: #4CAF50;
}

.dark-green .btn-outline-secondary,
.dark-green a.btn-outline-secondary {
  color: #FF6D00;
  border-color: #FF6D00;
}
.dark-green .btn-outline-secondary:focus, .dark-green .btn-outline-secondary:hover, .dark-green .btn-outline-secondary.disabled, .dark-green .btn-outline-secondary:disabled, .dark-green .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-green .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-green .btn-outline-secondary.dropdown-toggle,
.dark-green a.btn-outline-secondary:focus,
.dark-green a.btn-outline-secondary:hover,
.dark-green a.btn-outline-secondary.disabled,
.dark-green a.btn-outline-secondary:disabled,
.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-green a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-green a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: #FF6D00;
  background-color: #FF6D00;
}

.dark-green a, .dark-green a.text-primary {
  color: #4CAF50;
}
.dark-green a:focus, .dark-green a:hover, .dark-green a.text-primary:focus, .dark-green a.text-primary:hover {
  color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}
.dark-green .text-primary {
  color: #4CAF50 !important;
}
.dark-green .page-link {
  color: #4CAF50;
}
.dark-green .page-link:focus, .dark-green .page-link:hover {
  color: #4CAF50;
}
.dark-green .bg-primary, .dark-green .badge-primary {
  background-color: #4CAF50 !important;
  color: #fff !important;
}
.dark-green .btn-primary, .dark-green .jr-btn-primary, .dark-green a.btn-primary, .dark-green a.jr-btn-primary {
  background-color: #4CAF50;
  border-color: #4CAF50;
  color: #fff;
}
.dark-green .btn-primary:hover, .dark-green .btn-primary:focus, .dark-green .btn-primary:not([disabled]):not(.disabled):active, .dark-green .jr-btn-primary:hover, .dark-green .jr-btn-primary:focus, .dark-green .jr-btn-primary:not([disabled]):not(.disabled):active, .dark-green a.btn-primary:hover, .dark-green a.btn-primary:focus, .dark-green a.btn-primary:not([disabled]):not(.disabled):active, .dark-green a.jr-btn-primary:hover, .dark-green a.jr-btn-primary:focus, .dark-green a.jr-btn-primary:not([disabled]):not(.disabled):active {
  background-color: rgb(68.2788844622, 157.2211155378, 71.8725099602) !important;
  border-color: rgb(68.2788844622, 157.2211155378, 71.8725099602) !important;
  color: #fff !important;
}
.dark-green .bg-primary.lighten-4 {
  background-color: #C8E6C9 !important;
}
.dark-green .bg-primary.lighten-3 {
  background-color: #A5D6A7 !important;
}
.dark-green .bg-primary.lighten-2 {
  background-color: #81C784 !important;
}
.dark-green .bg-primary.lighten-1 {
  background-color: #66BB6A !important;
}
.dark-green .bg-primary.darken-1 {
  background-color: #43A047 !important;
}
.dark-green .bg-primary.darken-2 {
  background-color: #388E3C !important;
}
.dark-green .bg-primary.darken-3 {
  background-color: #2E7D32 !important;
}
.dark-green .bg-primary.darken-4 {
  background-color: #1B5E20 !important;
}
.dark-green .bg-primary.accent-1 {
  background-color: #B9F6CA !important;
}
.dark-green .bg-primary.accent-2 {
  background-color: #69F0AE !important;
}
.dark-green .bg-primary.accent-3 {
  background-color: #00E676 !important;
}
.dark-green .bg-primary.accent-4 {
  background-color: #00C853 !important;
}

.dark-green a.text-secondary {
  color: #FF6D00;
}
.dark-green a.text-secondary:focus, .dark-green a.text-secondary:hover {
  color: rgb(204, 87.2, 0) !important;
}
.dark-green .text-secondary {
  color: #FF6D00 !important;
}
.dark-green .bg-secondary, .dark-green .badge-secondary {
  background-color: #FF6D00 !important;
  color: #fff !important;
}
.dark-green .btn-secondary {
  background-color: #FF6D00;
  border-color: #FF6D00;
  color: #fff;
}
.dark-green .btn-secondary:hover, .dark-green .btn-secondary:focus, .dark-green .btn-secondary:active {
  background-color: rgb(229.5, 98.1, 0) !important;
  border-color: rgb(229.5, 98.1, 0) !important;
  color: #fff !important;
}

.dark-green .jr-flat-btn {
  background-color: transparent !important;
  color: #333 !important;
}
.dark-green .jr-flat-btn:hover, .dark-green .jr-flat-btn:focus, .dark-green .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-green .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #4CAF50 !important;
  border-color: transparent !important;
}
.dark-green .jr-flat-btn.jr-btn-primary:hover, .dark-green .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(76, 175, 80, 0.12) !important;
  color: #4CAF50 !important;
}

.dark-green .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-green .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-green .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-green .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #FF6D00 !important;
  border-color: transparent !important;
}
.dark-green .jr-flat-btn.jr-btn-secondary:hover, .dark-green .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 109, 0, 0.12) !important;
  color: #FF6D00 !important;
}

.dark-green .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-green .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-green .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-green .app-main-header {
  background-color: #4CAF50 !important;
  color: #fff;
  border-color: #4CAF50;
}
.dark-green .app-main-header .search-bar input {
  background-color: rgb(92.2011952191, 184.2988047809, 95.922310757);
}
.dark-green .app-main-header .search-bar input + .search-icon i {
  color: #fff;
}
.dark-green .app-main-header .search-bar input:focus {
  background-color: #fff;
}
.dark-green .app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
@media screen and (max-width: 575px) {
  .dark-green .app-main-header .search-dropdown input {
    background-color: #fff;
  }
  .dark-green .app-main-header .search-dropdown input + .search-icon i {
    color: rgba(128, 128, 128, 0.8);
  }
}
.dark-green .app-main-header .jr-menu-icon .menu-icon {
  background-color: #fff !important;
}

.dark-green .app-header .jr-menu-icon .menu-icon {
  background-color: #fff;
}

.dark-green .quick-menu .icon-btn {
  color: #fff;
}

.dark-green .react-logo-white.d-block {
  display: block !important;
}

@media screen and (min-width: 992px) {
  .dark-green .react-logo-white.d-lg-block {
    display: block !important;
  }
  .dark-green .react-logo-white.d-lg-none {
    display: none !important;
  }
}
.dark-green .react-logo-color.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .dark-green .react-logo-color.d-lg-block {
    display: none !important;
  }
}
.dark-green .color-theme-header {
  background-color: #4CAF50;
}

.dark-green .sidebar-header {
  border-bottom: 0 none;
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-green .side-nav {
  background-color: #252525 !important;
  color: #a1a1a1 !important;
  border-inline-end: 0 none !important;
}
.dark-green .side-nav .user-profile {
  background-color: rgb(29.35, 29.35, 29.35);
  position: relative;
  z-index: 2;
}
.dark-green .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-green .side-nav .user-detail .user-name {
  color: #fff;
}

.dark-green ul.nav-menu li a {
  color: #a1a1a1;
}

.dark-green ul.nav-menu .nav-header {
  color: #a1a1a1;
}

.dark-green ul.nav-menu > li.open > a,
.dark-green ul.nav-menu > li > a:hover,
.dark-green ul.nav-menu > li > a:focus {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

.dark-green ul.nav-menu li.menu.open > a {
  border-color: #4CAF50;
}

.dark-green ul.nav-menu li.menu > a:focus:before,
.dark-green ul.nav-menu li.menu > a:hover:before {
  color: #fff;
}

.dark-green ul.nav-menu li ul {
  background-color: rgb(29.35, 29.35, 29.35);
}

.dark-green ul.nav-menu li.menu > a:before {
  color: #a1a1a1;
}

.dark-green ul.nav-menu li.menu.open > a:before,
.dark-green ul.nav-menu li.menu > a:focus:before,
.dark-green ul.nav-menu li.menu li > a:hover:before {
  color: #fff;
}

.dark-green ul.nav-menu li.menu .sub-menu li > a:before {
  color: #a1a1a1;
}

.dark-green ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #4CAF50;
}

.dark-green ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-green ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-green ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-green ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-green ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(29.35, 29.35, 29.35);
  color: #fff;
}

/*Header top Navbar Styles*/
.dark-green .navbar-nav li:hover > a, .dark-green .navbar-nav li:focus > a {
  color: #4CAF50;
}
.dark-green .navbar-nav li a {
  color: #333;
}
.dark-green .navbar-nav li a:hover, .dark-green .navbar-nav li a:focus {
  color: #4CAF50;
}
.dark-green .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-green .navbar-nav li.nav-item:hover > a, .dark-green .navbar-nav li.nav-item:focus > a, .dark-green .navbar-nav li.nav-item > a:hover, .dark-green .navbar-nav li.nav-item > a:focus, .dark-green .navbar-nav li.nav-item.active > a {
  color: #FF6D00;
}
.dark-green .navbar-nav ul.sub-menu li a.active, .dark-green .navbar-nav ul.sub-menu li.active > a {
  color: #4CAF50;
}
.dark-green .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-green .navbar-nav .nav-arrow a:hover:before, .dark-green .navbar-nav .nav-arrow a:focus:before {
  color: #4CAF50;
}
.dark-green .navbar-nav .nav-arrow:hover > a:before, .dark-green .navbar-nav .nav-arrow:focus > a:before, .dark-green .navbar-nav .nav-arrow.active > a:before {
  color: #4CAF50;
}

.dark-green .app-top-nav {
  background-color: #252525 !important;
  border-color: #252525;
}
.dark-green .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-green .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-green .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-green .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-green .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-green .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #FF6D00;
}

.dark-green .module-nav li a.active {
  border-color: #4CAF50;
}

.dark-green .rbc-event {
  background-color: #4CAF50;
}

.dark-green .rbc-event.rbc-selected {
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}

.dark-green .rbc-slot-selection {
  background-color: rgba(76, 175, 80, 0.7);
}

.dark-green .rbc-toolbar button:active,
.dark-green .rbc-toolbar button.rbc-active {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.dark-green .rbc-toolbar button:active:hover,
.dark-green .rbc-toolbar button.rbc-active:hover,
.dark-green .rbc-toolbar button:active:focus,
.dark-green .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.dark-green .rbc-toolbar button:focus {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.dark-green .rbc-toolbar button:hover {
  background-color: rgba(76, 175, 80, 0.9);
  border-color: #4CAF50;
}

.dark-green .rbc-day-slot .rbc-event {
  border-color: #4CAF50;
}

.dark-green .chat-sidenav-title {
  color: #4CAF50;
}

.dark-green .chat-user-item.active, .dark-green .chat-user-item:hover {
  background-color: rgb(234.4322709163, 246.0677290837, 234.9023904382);
}

.dark-green .contact-list i {
  color: #4CAF50;
}

.dark-green .Collapsible__trigger {
  background: #4CAF50;
}

.dark-green .categories-list li a:focus, .dark-green .categories-list li a:hover, .dark-green .categories-list li.active a {
  color: #4CAF50;
}

.dark-green .login-content .form-control:focus {
  border-color: #4CAF50;
}

.dark-green .filter-with-bg-color ul li a {
  border-color: #4CAF50;
}
.dark-green .filter-with-bg-color ul li a:hover, .dark-green .filter-with-bg-color ul li a:focus, .dark-green .filter-with-bg-color ul li a.active {
  background-color: #4CAF50;
}

.dark-green .profile-intro .icon {
  color: #4CAF50;
}

.dark-green .social-link li.active a, .dark-green .social-link li a:hover, .dark-green .social-link li a:focus {
  color: #FF6D00;
}

.dark-green .actions {
  color: #FF6D00;
}

.dark-green .table-hover tbody tr:hover {
  background-color: rgba(76, 175, 80, 0.075);
}

.dark-green .border-primary {
  border-color: #4CAF50 !important;
}

.dark-green .app-logo-content {
  background-color: #4CAF50;
}

.dark-green .app-social-block .social-link button {
  border: solid 1px #4CAF50;
  color: #4CAF50;
}
.dark-green .app-social-block .social-link button:hover, .dark-green .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #4CAF50;
}

.dark-green .btn-group > .jr-btn.active,
.dark-green .btn-group > .btn-default.active,
.dark-green .btn-group-vertical > .jr-btn.active,
.dark-green .btn-group-vertical > .btn-default.active {
  background-color: #4CAF50;
  border-color: #4CAF50;
}
.dark-green .btn-group > .jr-flat-btn,
.dark-green .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-green .btn-group > .jr-flat-btn.active,
.dark-green .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: #4CAF50 !important;
  border-color: transparent !important;
}
.dark-green .btn-group > .jr-flat-btn.active:hover, .dark-green .btn-group > .jr-flat-btn.active:focus,
.dark-green .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-green .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(76, 175, 80, 0.12) !important;
  color: #4CAF50 !important;
}

.dark-green .nav-pill-sales .nav-link.active {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

.dark-green .form-checkbox > input + .check,
.dark-green .form-checkbox > input.sm + .check {
  color: #4CAF50;
}

/* Input Placeholder Style */
.dark-green .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-green .app-main-header ::-moz-placeholder { /* Firefox 19+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-green .app-main-header :-ms-input-placeholder { /* IE 10+ */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-green .app-main-header :-moz-placeholder { /* Firefox 18- */
  color: rgb(234.6, 234.6, 234.6);
}

.dark-green .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-green .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-green .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */
  color: rgb(178.5, 178.5, 178.5);
}

.dark-green .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */
  color: rgb(178.5, 178.5, 178.5);
}

/*Theme Dark Amber Styles*/
body.dark-theme {
  color: #E0E0E0;
  background-color: #38424B;
}

.dark-theme .modal {
  color: #38424B;
}

.dark-theme .project-list .project-name {
  color: #E0E0E0;
}

.dark-theme .list-group-item {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  color: #E0E0E0;
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .list-group-item:hover {
  background-color: rgb(64.720610687, 76.2778625954, 86.679389313);
}

.dark-theme .modal .list-group-item {
  background-color: #fff;
  color: #38424B;
  border-color: #fff;
}
.dark-theme .modal .list-group-item:hover {
  background-color: #fff;
}

.dark-theme .quick-menu .icon-btn {
  color: #E0E0E0;
}

.dark-theme .text-dark {
  color: #E0E0E0 !important;
}

.dark-theme .nav-pill-sales .nav-link {
  background-color: rgb(73.441221374, 86.5557251908, 98.358778626);
  color: #E0E0E0;
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .nav-pill-sales .nav-link.active {
  background-color: #38424B;
  color: #E0E0E0;
  border-color: #38424B;
}
.dark-theme .nav-pill-sales .nav-link.active:hover, .dark-theme .nav-pill-sales .nav-link.active:focus {
  color: #E0E0E0;
}

.dark-theme .nav-tabs {
  border-color: #38424B;
  background-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
}
.dark-theme .nav-tabs .nav-link {
  border-color: transparent;
}
.dark-theme .nav-tabs .nav-link:focus, .dark-theme .nav-tabs .nav-link:hover {
  border-color: transparent;
}
.dark-theme .nav-tabs .nav-link.active,
.dark-theme .nav-tabs .nav-item.show .nav-link {
  color: #E0E0E0;
  background-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
  border-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
  border-bottom-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .bg-grey.lighten-4,
.dark-theme .jr-card-header-color {
  background-color: rgb(73.441221374, 86.5557251908, 98.358778626) !important;
  color: #E0E0E0;
}

.dark-theme .card, .dark-theme .jr-card {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .card-footer {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
  background-color: transparent !important;
}
.dark-theme .sub-heading, .dark-theme .meta-date, .dark-theme .text-muted, .dark-theme .meta-comment, .dark-theme .user-detail .user-description {
  color: #adadad !important;
}
.dark-theme a, .dark-theme a.text-primary {
  color: rgb(211.25, 211.25, 211.25);
}
.dark-theme a:focus, .dark-theme a:hover, .dark-theme a.text-primary:focus, .dark-theme a.text-primary:hover {
  color: rgb(198.5, 198.5, 198.5) !important;
}
.dark-theme a.badge-light {
  color: rgb(96.5, 96.5, 96.5);
}
.dark-theme a.badge-light:focus, .dark-theme a.badge-light:hover {
  color: #474747 !important;
}
.dark-theme .text-primary {
  color: rgb(211.25, 211.25, 211.25) !important;
}
.dark-theme .page-link {
  color: rgb(88.7022900763, 104.5419847328, 118.7977099237);
}
.dark-theme .page-link:focus, .dark-theme .page-link:hover {
  color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
}
.dark-theme .bg-primary, .dark-theme .badge-primary {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588) !important;
  color: #E0E0E0 !important;
}
.dark-theme .btn-primary, .dark-theme .jr-btn-primary, .dark-theme a.btn-primary, .dark-theme a.jr-btn-primary {
  border-color: #38424B;
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588) !important;
  color: #E0E0E0 !important;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.dark-theme .btn-primary:hover, .dark-theme .btn-primary:focus, .dark-theme .btn-primary:active, .dark-theme .btn-primary.disabled, .dark-theme .btn-primary:disabled, .dark-theme .jr-btn-primary:hover, .dark-theme .jr-btn-primary:focus, .dark-theme .jr-btn-primary:active, .dark-theme .jr-btn-primary.disabled, .dark-theme .jr-btn-primary:disabled, .dark-theme a.btn-primary:hover, .dark-theme a.btn-primary:focus, .dark-theme a.btn-primary:active, .dark-theme a.btn-primary.disabled, .dark-theme a.btn-primary:disabled, .dark-theme a.jr-btn-primary:hover, .dark-theme a.jr-btn-primary:focus, .dark-theme a.jr-btn-primary:active, .dark-theme a.jr-btn-primary.disabled, .dark-theme a.jr-btn-primary:disabled {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588) !important;
  border-color: rgb(45.0992366412, 53.1526717557, 60.4007633588) !important;
  color: rgb(211.25, 211.25, 211.25) !important;
}
.dark-theme a.text-secondary {
  color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
}
.dark-theme a.text-secondary:focus, .dark-theme a.text-secondary:hover {
  color: #38424b !important;
}
.dark-theme .text-secondary {
  color: rgb(77.8015267176, 91.6946564885, 104.1984732824) !important;
}
.dark-theme .bg-secondary {
  background-color: rgb(77.8015267176, 91.6946564885, 104.1984732824) !important;
  color: rgb(211.25, 211.25, 211.25) !important;
}
.dark-theme .badge-secondary {
  background-color: #38424b !important;
  color: rgb(211.25, 211.25, 211.25) !important;
}
.dark-theme .btn-secondary {
  background-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
  border-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
  color: rgb(211.25, 211.25, 211.25);
}
.dark-theme .btn-secondary:hover, .dark-theme .btn-secondary:focus, .dark-theme .btn-secondary:active {
  background-color: #38424b !important;
  border-color: #38424b !important;
  color: rgb(211.25, 211.25, 211.25) !important;
}

.dark-theme .right-arrow {
  color: rgb(211.25, 211.25, 211.25);
}
.dark-theme .right-arrow:after {
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme .btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-theme .btn-primary:focus, .dark-theme .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-theme .btn-primary.disabled, .dark-theme .btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-theme .btn-primary:not(:disabled):not(.disabled):active, .dark-theme .btn-primary:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-theme .btn-primary:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-theme .btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-theme .btn-secondary:focus, .dark-theme .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-theme .btn-secondary.disabled, .dark-theme .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-theme .btn-secondary:not(:disabled):not(.disabled):active, .dark-theme .btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-theme .btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-theme .btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-theme .btn-success:focus, .dark-theme .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-theme .btn-success.disabled, .dark-theme .btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-theme .btn-success:not(:disabled):not(.disabled):active, .dark-theme .btn-success:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-theme .btn-success:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-theme .btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-theme .btn-info:focus, .dark-theme .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-theme .btn-info.disabled, .dark-theme .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-theme .btn-info:not(:disabled):not(.disabled):active, .dark-theme .btn-info:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-theme .btn-info:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-theme .btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-theme .btn-warning:focus, .dark-theme .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-theme .btn-warning.disabled, .dark-theme .btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-theme .btn-warning:not(:disabled):not(.disabled):active, .dark-theme .btn-warning:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-theme .btn-warning:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-theme .btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-theme .btn-danger:focus, .dark-theme .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-theme .btn-danger.disabled, .dark-theme .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme .btn-danger:not(:disabled):not(.disabled):active, .dark-theme .btn-danger:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-theme .btn-danger:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-theme .btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-theme .btn-light:focus, .dark-theme .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-theme .btn-light.disabled, .dark-theme .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-theme .btn-light:not(:disabled):not(.disabled):active, .dark-theme .btn-light:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-theme .btn-light:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-theme .btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme .btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-theme .btn-dark:focus, .dark-theme .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-theme .btn-dark.disabled, .dark-theme .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-theme .btn-dark:not(:disabled):not(.disabled):active, .dark-theme .btn-dark:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-theme .btn-dark:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-theme a.btn-primary {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-primary:hover {
  color: #212529;
  background-color: rgb(127.3322368421, 169.8881578947, 192.4177631579);
  border-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
}
.dark-theme a.btn-primary:focus, .dark-theme a.btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-theme a.btn-primary.disabled, .dark-theme a.btn-primary:disabled {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-theme a.btn-primary:not(:disabled):not(.disabled):active, .dark-theme a.btn-primary:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-primary.dropdown-toggle {
  color: #212529;
  background-color: rgb(118.7763157895, 164.1842105263, 188.2236842105);
  border-color: rgb(110.2203947368, 158.4802631579, 184.0296052632);
}
.dark-theme a.btn-primary:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-theme a.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.dark-theme a.btn-secondary:focus, .dark-theme a.btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-theme a.btn-secondary.disabled, .dark-theme a.btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-theme a.btn-secondary:not(:disabled):not(.disabled):active, .dark-theme a.btn-secondary:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.dark-theme a.btn-secondary:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-theme a.btn-success {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-success:hover {
  color: #fff;
  background-color: rgb(83.0040322581, 140.7459677419, 114.5816532258);
  border-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
}
.dark-theme a.btn-success:focus, .dark-theme a.btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-theme a.btn-success.disabled, .dark-theme a.btn-success:disabled {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-theme a.btn-success:not(:disabled):not(.disabled):active, .dark-theme a.btn-success:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(78.2741935484, 132.7258064516, 108.0524193548);
  border-color: rgb(73.5443548387, 124.7056451613, 101.5231854839);
}
.dark-theme a.btn-success:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-success:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-theme a.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.dark-theme a.btn-info:focus, .dark-theme a.btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-theme a.btn-info.disabled, .dark-theme a.btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-theme a.btn-info:not(:disabled):not(.disabled):active, .dark-theme a.btn-info:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.dark-theme a.btn-info:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-info:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-theme a.btn-warning {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-warning:hover {
  color: #fff;
  background-color: rgb(195.7795918367, 105.4846938776, 10.9704081633);
  border-color: rgb(183.706122449, 98.9795918367, 10.293877551);
}
.dark-theme a.btn-warning:focus, .dark-theme a.btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-theme a.btn-warning.disabled, .dark-theme a.btn-warning:disabled {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-theme a.btn-warning:not(:disabled):not(.disabled):active, .dark-theme a.btn-warning:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(183.706122449, 98.9795918367, 10.293877551);
  border-color: rgb(171.6326530612, 92.4744897959, 9.6173469388);
}
.dark-theme a.btn-warning:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-theme a.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.dark-theme a.btn-danger:focus, .dark-theme a.btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-theme a.btn-danger.disabled, .dark-theme a.btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme a.btn-danger:not(:disabled):not(.disabled):active, .dark-theme a.btn-danger:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.dark-theme a.btn-danger:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-theme a.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.dark-theme a.btn-light:focus, .dark-theme a.btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-theme a.btn-light.disabled, .dark-theme a.btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-theme a.btn-light:not(:disabled):not(.disabled):active, .dark-theme a.btn-light:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.dark-theme a.btn-light:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-light:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-theme a.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  -o-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.dark-theme a.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.dark-theme a.btn-dark:focus, .dark-theme a.btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-theme a.btn-dark.disabled, .dark-theme a.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-theme a.btn-dark:not(:disabled):not(.disabled):active, .dark-theme a.btn-dark:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.dark-theme a.btn-dark:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-theme .btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-theme .btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-theme .btn-outline-primary:focus, .dark-theme .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-theme .btn-outline-primary.disabled, .dark-theme .btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-theme .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-theme .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-theme .btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-theme .btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-theme .btn-outline-secondary:focus, .dark-theme .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-theme .btn-outline-secondary.disabled, .dark-theme .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-theme .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-theme .btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-theme .btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-theme .btn-outline-success:focus, .dark-theme .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-theme .btn-outline-success.disabled, .dark-theme .btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-theme .btn-outline-success:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-theme .btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-theme .btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-theme .btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-theme .btn-outline-info:focus, .dark-theme .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-theme .btn-outline-info.disabled, .dark-theme .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-theme .btn-outline-info:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-theme .btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-theme .btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-theme .btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-theme .btn-outline-warning:focus, .dark-theme .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-theme .btn-outline-warning.disabled, .dark-theme .btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-theme .btn-outline-warning:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-theme .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-theme .btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-theme .btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme .btn-outline-danger:focus, .dark-theme .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-theme .btn-outline-danger.disabled, .dark-theme .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-theme .btn-outline-danger:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-theme .btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-theme .btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-theme .btn-outline-light:focus, .dark-theme .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-theme .btn-outline-light.disabled, .dark-theme .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-theme .btn-outline-light:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-theme .btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-theme .btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-theme .btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-theme .btn-outline-dark:focus, .dark-theme .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-theme .btn-outline-dark.disabled, .dark-theme .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-theme .btn-outline-dark:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-theme .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-theme .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-theme .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-theme a.btn-outline-primary {
  color: #99BBCD;
  background-color: transparent;
  background-image: none;
  border-color: #99BBCD;
}
.dark-theme a.btn-outline-primary:hover {
  color: #fff;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-theme a.btn-outline-primary:focus, .dark-theme a.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}
.dark-theme a.btn-outline-primary.disabled, .dark-theme a.btn-outline-primary:disabled {
  color: #99BBCD;
  background-color: transparent;
}
.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-primary.dropdown-toggle {
  color: #212529;
  background-color: #99BBCD;
  border-color: #99BBCD;
}
.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(153, 187, 205, 0.5);
}

.dark-theme a.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.dark-theme a.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-theme a.btn-outline-secondary:focus, .dark-theme a.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.dark-theme a.btn-outline-secondary.disabled, .dark-theme a.btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.dark-theme a.btn-outline-success {
  color: #63a386;
  background-color: transparent;
  background-image: none;
  border-color: #63a386;
}
.dark-theme a.btn-outline-success:hover {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-theme a.btn-outline-success:focus, .dark-theme a.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}
.dark-theme a.btn-outline-success.disabled, .dark-theme a.btn-outline-success:disabled {
  color: #63a386;
  background-color: transparent;
}
.dark-theme a.btn-outline-success:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-success:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #63a386;
  border-color: #63a386;
}
.dark-theme a.btn-outline-success:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 163, 134, 0.5);
}

.dark-theme a.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.dark-theme a.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-theme a.btn-outline-info:focus, .dark-theme a.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.dark-theme a.btn-outline-info.disabled, .dark-theme a.btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.dark-theme a.btn-outline-info:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-info:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.dark-theme a.btn-outline-info:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.dark-theme a.btn-outline-warning {
  color: #e87d0d;
  background-color: transparent;
  background-image: none;
  border-color: #e87d0d;
}
.dark-theme a.btn-outline-warning:hover {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-theme a.btn-outline-warning:focus, .dark-theme a.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}
.dark-theme a.btn-outline-warning.disabled, .dark-theme a.btn-outline-warning:disabled {
  color: #e87d0d;
  background-color: transparent;
}
.dark-theme a.btn-outline-warning:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-warning:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #e87d0d;
  border-color: #e87d0d;
}
.dark-theme a.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 125, 13, 0.5);
}

.dark-theme a.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.dark-theme a.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme a.btn-outline-danger:focus, .dark-theme a.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.dark-theme a.btn-outline-danger.disabled, .dark-theme a.btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.dark-theme a.btn-outline-danger:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-danger:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.dark-theme a.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.dark-theme a.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.dark-theme a.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-theme a.btn-outline-light:focus, .dark-theme a.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.dark-theme a.btn-outline-light.disabled, .dark-theme a.btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.dark-theme a.btn-outline-light:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-light:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.dark-theme a.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.dark-theme a.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.dark-theme a.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-theme a.btn-outline-dark:focus, .dark-theme a.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.dark-theme a.btn-outline-dark.disabled, .dark-theme a.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.dark-theme a.btn-outline-dark:not(:disabled):not(.disabled):active, .dark-theme a.btn-outline-dark:not(:disabled):not(.disabled).active, .show > .dark-theme a.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.dark-theme a.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .dark-theme a.btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .dark-theme a.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.dark-theme .btn-outline-primary,
.dark-theme a.btn-outline-primary {
  color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
  border-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
}
.dark-theme .btn-outline-primary:focus, .dark-theme .btn-outline-primary:hover, .dark-theme .btn-outline-primary.disabled, .dark-theme .btn-outline-primary:disabled, .dark-theme .btn-outline-primary:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-primary.dropdown-toggle,
.dark-theme a.btn-outline-primary:focus,
.dark-theme a.btn-outline-primary:hover,
.dark-theme a.btn-outline-primary.disabled,
.dark-theme a.btn-outline-primary:disabled,
.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled):active,
.dark-theme a.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .dark-theme a.btn-outline-primary.dropdown-toggle {
  color: #fff;
  border-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
}

.dark-theme .btn-outline-secondary,
.dark-theme a.btn-outline-secondary {
  color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
  border-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
}
.dark-theme .btn-outline-secondary:focus, .dark-theme .btn-outline-secondary:hover, .dark-theme .btn-outline-secondary.disabled, .dark-theme .btn-outline-secondary:disabled, .dark-theme .btn-outline-secondary:not(:disabled):not(.disabled):active, .dark-theme .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .dark-theme .btn-outline-secondary.dropdown-toggle,
.dark-theme a.btn-outline-secondary:focus,
.dark-theme a.btn-outline-secondary:hover,
.dark-theme a.btn-outline-secondary.disabled,
.dark-theme a.btn-outline-secondary:disabled,
.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled):active,
.dark-theme a.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .dark-theme a.btn-outline-secondary.dropdown-toggle {
  color: #fff;
  border-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
  background-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
}

.dark-theme .btn-outline-primary {
  color: rgb(211.25, 211.25, 211.25);
  border-color: rgb(211.25, 211.25, 211.25);
}
.dark-theme .btn-outline-primary:hover, .dark-theme .btn-outline-primary:focus, .dark-theme .btn-outline-primary:active {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
  border-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme .jr-flat-btn {
  background-color: transparent !important;
  color: rgb(211.25, 211.25, 211.25) !important;
}
.dark-theme .jr-flat-btn:hover, .dark-theme .jr-flat-btn:focus, .dark-theme .jr-flat-btn:active {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

.dark-theme .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #e0e0e0 !important;
  border-color: transparent !important;
}
.dark-theme .jr-flat-btn.jr-btn-secondary:hover, .dark-theme .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(77.8015267176, 91.6946564885, 104.1984732824, 0.5) !important;
  color: #e0e0e0 !important;
}

.dark-theme .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: rgb(211.25, 211.25, 211.25) !important;
  border-color: transparent !important;
}
.dark-theme .jr-flat-btn.jr-btn-primary:hover, .dark-theme .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(56, 66, 75, 0.5) !important;
  color: rgb(211.25, 211.25, 211.25) !important;
}

.dark-theme .btn-group > .jr-btn.active,
.dark-theme .btn-group > .btn-default.active,
.dark-theme .btn-group-vertical > .jr-btn.active,
.dark-theme .btn-group-vertical > .btn-default.active {
  background-color: #38424B;
  border-color: #38424B;
  color: rgb(211.25, 211.25, 211.25);
}
.dark-theme .btn-group > .jr-flat-btn,
.dark-theme .btn-group-vertical > .jr-flat-btn {
  border-color: transparent;
}
.dark-theme .btn-group > .jr-flat-btn.active,
.dark-theme .btn-group-vertical > .jr-flat-btn.active {
  background-color: transparent;
  color: rgb(12.3969465649, 14.6106870229, 16.6030534351);
}
.dark-theme .btn-group > .jr-flat-btn.active:hover, .dark-theme .btn-group > .jr-flat-btn.active:focus,
.dark-theme .btn-group-vertical > .jr-flat-btn.active:hover,
.dark-theme .btn-group-vertical > .jr-flat-btn.active:focus {
  background-color: rgba(56, 66, 75, 0.5);
  color: rgb(12.3969465649, 14.6106870229, 16.6030534351);
}

.dark-theme .bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-theme .bg-primary .jr-flat-btn.jr-btn-primary:hover, .dark-theme .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-theme .bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent !important;
  color: #fff !important;
  border-color: transparent !important;
}
.dark-theme .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .dark-theme .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.dark-theme .app-main-header {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588) !important;
}
.dark-theme .app-main-header .search-bar input {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
}
.dark-theme .app-main-header .search-bar input:focus {
  background-color: #fff;
}
@media screen and (max-width: 575px) {
  .dark-theme .app-main-header .search-dropdown input {
    background-color: #fff;
  }
}

.dark-theme .jr-card .app-main-header,
.dark-theme .sidebar-header,
.dark-theme .card-header,
.dark-theme .col-with-divider div[class*=col-] {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .app-header .app-main-header {
  border-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
}

.dark-theme .app-header {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.dark-theme .app-footer {
  padding: 0 24px;
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
  background-color: #38424B;
  color: #E0E0E0;
}
.dark-theme .app-footer a.text-secondary {
  color: #E0E0E0 !important;
}
.dark-theme .app-footer a.text-secondary:hover {
  color: rgb(198.5, 198.5, 198.5) !important;
}

.dark-theme .media-list:not(:last-child) {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .app-main-header.bg-white {
  color: #fff !important;
}

.dark-theme .color-theme-header {
  background-color: #38424B;
}

.dark-theme .side-nav {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588) !important;
  color: #E0E0E0 !important;
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626) !important;
}
.dark-theme .side-nav .user-profile {
  background-color: rgb(51.6396946565, 60.8610687023, 69.1603053435);
  position: relative;
  z-index: 2;
}
.dark-theme .side-nav .customizer {
  border-bottom: 0 none;
}
.dark-theme .side-nav .user-detail .user-name {
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme ul.nav-menu li a {
  color: #E0E0E0;
}

.dark-theme ul.nav-menu .nav-header {
  color: #E0E0E0;
}

.dark-theme ul.nav-menu > li.open > a,
.dark-theme ul.nav-menu > li > a:hover,
.dark-theme ul.nav-menu > li > a:focus {
  background-color: rgb(51.6396946565, 60.8610687023, 69.1603053435);
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme ul.nav-menu li.menu.open > a {
  border-color: rgb(211.25, 211.25, 211.25);
}

.dark-theme ul.nav-menu li.menu > a:focus:before,
.dark-theme ul.nav-menu li.menu > a:hover:before {
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme ul.nav-menu li ul {
  background-color: rgb(51.6396946565, 60.8610687023, 69.1603053435);
}

.dark-theme ul.nav-menu li.menu > a:before {
  color: #E0E0E0;
}

.dark-theme ul.nav-menu li.menu.open > a:before,
.dark-theme ul.nav-menu li.menu > a:focus:before,
.dark-theme ul.nav-menu li.menu li > a:hover:before {
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme ul.nav-menu li.menu .sub-menu li > a:before {
  color: #E0E0E0;
}

.dark-theme ul.nav-menu li.menu.open .sub-menu li > a.active {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
  color: #fff;
}

.dark-theme ul.nav-menu li.menu .sub-menu li > a:hover,
.dark-theme ul.nav-menu li.menu .sub-menu li > a:focus,
.dark-theme ul.nav-menu li.menu.open .sub-menu li > a.active:before,
.dark-theme ul.nav-menu li.menu .sub-menu li > a:focus:before,
.dark-theme ul.nav-menu li.menu .sub-menu li > a:hover:before {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
  color: #fff;
}

.dark-theme ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  background-color: #38424B;
}

/*Header top Navbar Styles*/
.dark-theme .navbar-nav li:hover > a, .dark-theme .navbar-nav li:focus > a {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}
.dark-theme .navbar-nav li a {
  color: #333;
}
.dark-theme .navbar-nav li a:hover, .dark-theme .navbar-nav li a:focus {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}
.dark-theme .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-theme .navbar-nav li.nav-item:hover > a, .dark-theme .navbar-nav li.nav-item:focus > a, .dark-theme .navbar-nav li.nav-item > a:hover, .dark-theme .navbar-nav li.nav-item > a:focus, .dark-theme .navbar-nav li.nav-item.active > a {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}
.dark-theme .navbar-nav ul.sub-menu {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(75.6213740458, 89.1251908397, 101.2786259542);
}
.dark-theme .navbar-nav ul.sub-menu li a.active, .dark-theme .navbar-nav ul.sub-menu li.active > a {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}
.dark-theme .navbar-nav .nav-arrow > a:before {
  color: #333;
}
.dark-theme .navbar-nav .nav-arrow a:hover:before, .dark-theme .navbar-nav .nav-arrow a:focus:before {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}
.dark-theme .navbar-nav .nav-arrow:hover > a:before, .dark-theme .navbar-nav .nav-arrow:focus > a:before, .dark-theme .navbar-nav .nav-arrow.active > a:before {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}

.dark-theme .app-top-nav {
  background-color: #252525 !important;
}
.dark-theme .app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
}
.dark-theme .app-top-nav .navbar-nav li.nav-item:hover > a, .dark-theme .app-top-nav .navbar-nav li.nav-item:focus > a, .dark-theme .app-top-nav .navbar-nav li.nav-item > a:hover, .dark-theme .app-top-nav .navbar-nav li.nav-item > a:focus, .dark-theme .app-top-nav .navbar-nav li.nav-item.active > a {
  color: rgb(184.0076335878, 193.4732824427, 201.9923664122);
}

.dark-theme .rbc-event {
  background-color: rgb(125.6106870229, 142.8625954198, 158.3893129771);
}

.dark-theme .rbc-event.rbc-selected {
  background-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
}

.dark-theme .rbc-slot-selection {
  background-color: rgba(56, 66, 75, 0.7);
}

.dark-theme .rbc-toolbar button:active,
.dark-theme .rbc-toolbar button.rbc-active {
  background-color: rgba(56, 66, 75, 0.9);
  border-color: rgb(154.8091603053, 168.1679389313, 180.1908396947);
  color: white;
}

.dark-theme .rbc-toolbar button:active:hover,
.dark-theme .rbc-toolbar button.rbc-active:hover,
.dark-theme .rbc-toolbar button:active:focus,
.dark-theme .rbc-toolbar button.rbc-active:focus {
  background-color: rgba(56, 66, 75, 0.9);
  border-color: rgb(154.8091603053, 168.1679389313, 180.1908396947);
  color: white;
}

.dark-theme .rbc-toolbar button:hover,
.dark-theme .rbc-toolbar button:focus {
  background-color: rgba(56, 66, 75, 0.9);
  border-color: rgb(154.8091603053, 168.1679389313, 180.1908396947);
  color: white;
}

.dark-theme .rbc-toolbar button {
  background-color: rgba(56, 66, 75, 0.9);
  border-color: rgb(154.8091603053, 168.1679389313, 180.1908396947);
  color: rgb(154.8091603053, 168.1679389313, 180.1908396947);
}

.dark-theme .rbc-show-more {
  background-color: rgb(125.6106870229, 142.8625954198, 158.3893129771);
}

.dark-theme .rbc-off-range-bg {
  background-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
}

.dark-theme .rbc-day-slot .rbc-event {
  border-color: #38424B;
}

.dark-theme .chat-sidenav-title {
  color: #38424B;
}

.dark-theme .chat-user-item {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .chat-user-item.active, .dark-theme .chat-user-item:hover {
  background-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
}

.dark-theme .contact-list i {
  color: #38424B;
}

.dark-theme .login-content .form-control:focus {
  border-color: #38424B;
}

.dark-theme .filter-with-bg-color ul li a {
  border-color: #38424B;
}
.dark-theme .filter-with-bg-color ul li a:hover, .dark-theme .filter-with-bg-color ul li a:focus, .dark-theme .filter-with-bg-color ul li a.active {
  background-color: #38424B;
}

.dark-theme .profile-intro .icon {
  color: rgb(99.6030534351, 117.3893129771, 133.3969465649);
}

.dark-theme .social-link li.active a, .dark-theme .social-link li a:hover, .dark-theme .social-link li a:focus {
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme .actions {
  color: rgb(211.25, 211.25, 211.25);
}

.dark-theme .table-hover tbody tr:hover {
  background-color: rgba(56, 66, 75, 0.075);
}

.dark-theme .border-primary {
  border-color: rgb(211.25, 211.25, 211.25) !important;
}

.dark-theme .breadcrumb {
  background-color: #38424B;
}

.dark-theme .desc-list.even-odd li:nth-child(2n) {
  background-color: #38424B;
}

.dark-theme .timeline-item::before {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .timeline-panel {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .timeline-panel:after {
  border-color: transparent rgb(66.9007633588, 78.8473282443, 89.5992366412);
}
.dark-theme .timeline-panel:before {
  border-color: transparent rgb(75.6213740458, 89.1251908397, 101.2786259542);
}

.dark-theme .login-content {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .chat-sidenav-header,
.dark-theme .chat-tabs {
  background-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
}

.dark-theme .module-nav li a {
  color: #adb5bd !important;
}
.dark-theme .module-nav li a:hover, .dark-theme .module-nav li a:focus, .dark-theme .module-nav li a.active {
  color: #fff !important;
}
.dark-theme .module-nav li a.active {
  border-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
}

.dark-theme .module-side {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
}

.dark-theme .module-box-header,
.dark-theme .app-module-sidenav,
.dark-theme .dropdown-menu {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
  color: #E0E0E0;
}

.dark-theme .dropdown-item {
  color: #E0E0E0;
}
.dark-theme .dropdown-item:hover, .dark-theme .dropdown-item:focus {
  background-color: #38424B;
  color: #E0E0E0;
}

.dark-theme .quick-menu .dropdown-menu .jr-card-header {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .quick-menu .dropdown-menu:after {
  border-inline-start: 5px solid transparent;
  border-inline-end: 5px solid transparent;
  border-bottom: 5px solid rgb(66.9007633588, 78.8473282443, 89.5992366412);
}
.dark-theme .quick-menu .dropdown-menu:before {
  border-inline-start: 5px solid transparent;
  border-inline-end: 5px solid transparent;
  border-bottom: 5px solid rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .module-box-header .icon-btn {
  color: #E0E0E0;
}
.dark-theme .module-box-header .search-bar input {
  background-color: #38424B;
}
.dark-theme .module-box-header .search-bar input:focus {
  background-color: #fff;
}

.dark-theme .chat-sidenav-header .search-bar input {
  background-color: #38424B;
}
.dark-theme .chat-sidenav-header .search-bar input:focus {
  background-color: #fff;
}

.dark-theme .module-box-topbar,
.dark-theme .module-list-item,
.dark-theme .module-side-header,
.dark-theme .chat-main-footer,
.dark-theme .messages-list ul li,
.dark-theme hr,
.dark-theme .chat-sidenav,
.dark-theme .chat-main-header,
.dark-theme .modal-header {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .module-logo,
.dark-theme .user-nav .quick-menu .user-profile {
  background-color: #38424B;
  color: #E0E0E0;
}

.dark-theme .messages-list ul li .user-name a {
  color: #E0E0E0;
}

.dark-theme .chat-module-box,
.dark-theme .chat-sidenav-content,
.dark-theme .chat-main-header,
.dark-theme .chat-main-footer,
.dark-theme .chat-textarea,
.dark-theme .module-detail-header,
.dark-theme .module-box-content,
.dark-theme .modal-box-footer {
  background-color: #38424B;
}

.dark-theme .modal-box-content {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
}

.dark-theme .chat-textarea {
  color: #fff;
}

.dark-theme .chat-item {
  padding: 16px;
}
.dark-theme .chat-item .bubble {
  background-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
  border-color: rgb(47.279389313, 55.7221374046, 63.320610687);
}
.dark-theme .chat-item .bubble:before {
  border-inline-end: 9px solid rgb(77.8015267176, 91.6946564885, 104.1984732824);
}
.dark-theme .chat-item .bubble:after {
  border-inline-end: 8px solid rgb(77.8015267176, 91.6946564885, 104.1984732824);
}
.dark-theme .chat-item.flex-row-reverse .bubble {
  margin-inline-end: 16px;
  margin-inline-start: 0;
  background-color: rgb(34.1984732824, 40.3053435115, 45.8015267176);
  border-color: rgb(77.8015267176, 91.6946564885, 104.1984732824);
}
.dark-theme .chat-item.flex-row-reverse .bubble:before {
  inset-inline-start: auto;
  inset-inline-end: -9px;
  border-inline-start: 9px solid rgb(34.1984732824, 40.3053435115, 45.8015267176);
  border-inline-end: 0 none;
}
.dark-theme .chat-item.flex-row-reverse .bubble:after {
  inset-inline-start: auto;
  inset-inline-end: -8px;
  border-inline-start: 8px solid rgb(34.1984732824, 40.3053435115, 45.8015267176);
  border-inline-end: 0 none;
}

.dark-theme .modal-box-footer {
  padding-top: 12px;
}

.dark-theme .app-logo-content {
  background-color: #38424B;
}

.dark-theme .app-social-block .social-link button {
  border: solid 1px #38424B;
  color: #38424B;
}
.dark-theme .app-social-block .social-link button:hover, .dark-theme .app-social-block .social-link button:focus {
  color: #fff;
  background-color: #38424B;
}

.dark-theme .form-checkbox > input + .check,
.dark-theme .form-checkbox > input.sm + .check {
  color: #333;
}

.dark-theme .rc-drawer-sidebar-dark-theme,
.dark-theme .rc-drawer-pin {
  color: #E0E0E0;
  background-color: #38424B;
}

.dark-theme .rc-drawer-left .rc-drawer-sidebar-dark-theme,
.dark-theme .rc-drawer-right .rc-drawer-sidebar-dark-theme {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100vh;
}

.dark-theme .rc-drawer-pin {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  padding: 20px;
}

.dark-theme .rc-drawer-docked .rc-drawer-content {
  border-inline-start: 0 none;
}

.dark-theme .rc-drawer-sidebar {
  background-color: #38424B;
}

.dark-theme .rc-collapse {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .rc-collapse > .rc-collapse-item {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .rc-collapse > .rc-collapse-item > .rc-collapse-header {
  color: #E0E0E0;
}
.dark-theme .rc-collapse > .rc-collapse-item > .rc-collapse-header .arrow {
  border-inline-start-color: #E0E0E0;
}
.dark-theme .rc-collapse .rc-collapse-content {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
  color: #E0E0E0;
}
.dark-theme .rc-collapse .rc-collapse-item-disabled > .rc-collapse-header {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  color: #E0E0E0;
}

.dark-theme .rc-time-picker-panel {
  color: #38424B;
}

.dark-theme .Collapsible__trigger {
  background-color: rgb(45.0992366412, 53.1526717557, 60.4007633588);
}

.dark-theme .Collapsible__contentInner {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .categories-list li a:focus, .dark-theme .categories-list li a:hover, .dark-theme .categories-list li.active a {
  color: rgb(160.25, 160.25, 160.25);
}

.dark-theme .table th, .dark-theme .table td {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}

.dark-theme .table-unbordered .th-border-b th {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626) !important;
}

.dark-theme .ReactTable {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .ReactTable .rt-thead .rt-th, .dark-theme .ReactTable .rt-thead .rt-td {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .ReactTable .rt-thead.-header {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .ReactTable .rt-table .rt-thead.-headerGroups {
  background-color: rgb(66.9007633588, 78.8473282443, 89.5992366412);
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .ReactTable.-striped .rt-tbody .rt-tr-group .rt-tr.-odd, .dark-theme .ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background-color: rgb(73.441221374, 86.5557251908, 98.358778626) !important;
}
.dark-theme .ReactTable .rt-tbody .rt-tr-group, .dark-theme .ReactTable .rt-tbody .rt-td {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .ReactTable .-pagination {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}
.dark-theme .ReactTable .-pagination .-btn:not([disabled]) {
  background-color: rgb(60.3603053435, 71.1389312977, 80.8396946565);
  color: #E0E0E0;
}
.dark-theme .ReactTable .-pagination .-btn:not([disabled]):hover {
  background-color: #38424b;
  color: #E0E0E0;
}
.dark-theme .ReactTable .-pagination .-btn[disabled] {
  color: #E0E0E0;
}

.dark-theme .card-strip,
.dark-theme .contact-item {
  border-color: rgb(73.441221374, 86.5557251908, 98.358778626);
}`, "",{"version":3,"sources":["webpack://./assets/src/jsx/styles/app.scss","webpack://./assets/src/jsx/styles/global/__global-dir.scss","webpack://./assets/src/jsx/styles/global/_place-holder.scss","webpack://./assets/src/jsx/styles/global/_variables.scss","webpack://./assets/src/jsx/styles/global/_mixin.scss","webpack://./assets/src/jsx/styles/bootstrap/_variables.scss","webpack://./assets/src/jsx/styles/global/_sizes.scss","webpack://./assets/src/jsx/styles/global/_color.scss","webpack://./assets/src/jsx/styles/global/_custom-animation.scss","webpack://./assets/src/jsx/styles/design-system/_variables.scss","webpack://./assets/src/jsx/styles/design-system/_typography.scss","webpack://./assets/src/jsx/styles/design-system/_forms.scss","webpack://./assets/src/jsx/styles/design-system/_common.scss","webpack://./assets/src/jsx/styles/design-system/_table.scss","webpack://./assets/src/jsx/styles/design-system/_modals.scss","webpack://./assets/src/jsx/styles/base/__base-dir.scss","webpack://./assets/src/jsx/styles/base/_base.scss","webpack://./assets/src/jsx/styles/base/_typography.scss","webpack://./assets/src/jsx/styles/layout/__layout-dir.scss","webpack://./assets/src/jsx/styles/layout/_app-layout.scss","webpack://./assets/src/jsx/styles/layout/_sidebar.scss","webpack://./assets/src/jsx/styles/layout/_header.scss","webpack://./assets/src/jsx/styles/layout/_navbar.scss","webpack://./assets/src/jsx/styles/layout/_main-content.scss","webpack://./assets/src/jsx/styles/layout/_footer.scss","webpack://./assets/src/jsx/styles/layout/_right-sidebar.scss","webpack://./assets/src/jsx/styles/ui/__ui-dir.scss","webpack://./assets/src/jsx/styles/ui/_alert.scss","webpack://./assets/src/jsx/styles/ui/_avatar.scss","webpack://./assets/src/jsx/styles/ui/_badges.scss","webpack://./assets/src/jsx/styles/ui/_blockquotes.scss","webpack://./assets/src/jsx/styles/ui/_bottom-navigation.scss","webpack://./assets/src/jsx/styles/ui/_breadcrumb.scss","webpack://./assets/src/jsx/styles/ui/_button.scss","webpack://./assets/src/jsx/styles/ui/_button-group.scss","webpack://./assets/src/jsx/styles/ui/_callout.scss","webpack://./assets/src/jsx/styles/ui/_card.scss","webpack://./assets/src/jsx/styles/ui/_charts.scss","webpack://./assets/src/jsx/styles/ui/_chip.scss","webpack://./assets/src/jsx/styles/ui/_carousel.scss","webpack://./assets/src/jsx/styles/ui/_color-picker.scss","webpack://./assets/src/jsx/styles/ui/_drawer.scss","webpack://./assets/src/jsx/styles/ui/_e-commerce.scss","webpack://./assets/src/jsx/styles/ui/_grid-list.scss","webpack://./assets/src/jsx/styles/ui/_icons.scss","webpack://./assets/src/jsx/styles/ui/_label.scss","webpack://./assets/src/jsx/styles/ui/_list.scss","webpack://./assets/src/jsx/styles/ui/_nav.scss","webpack://./assets/src/jsx/styles/ui/_pricing-tables.scss","webpack://./assets/src/jsx/styles/ui/_progressbar.scss","webpack://./assets/src/jsx/styles/ui/_popover.scss","webpack://./assets/src/jsx/styles/ui/_react-joyride.scss","webpack://./assets/src/jsx/styles/ui/_tables.scss","webpack://./assets/src/jsx/styles/ui/_tabs.scss","webpack://./assets/src/jsx/styles/ui/_testimonial.scss","webpack://./assets/src/jsx/styles/ui/_timeline.scss","webpack://./assets/src/jsx/styles/ui/_tour.scss","webpack://./assets/src/jsx/styles/ui/_form.scss","webpack://./assets/src/jsx/styles/ui/_ad-form.scss","webpack://./assets/src/jsx/styles/ui/_input.scss","webpack://./assets/src/jsx/styles/pages/__pages-dir.scss","webpack://./assets/src/jsx/styles/pages/_login.scss","webpack://./assets/src/jsx/styles/pages/_error.scss","webpack://./assets/src/jsx/styles/pages/_editor.scss","webpack://./assets/src/jsx/styles/pages/_contact.scss","webpack://./assets/src/jsx/styles/pages/_portfolio.scss","webpack://./assets/src/jsx/styles/pages/_faq.scss","webpack://./assets/src/jsx/styles/pages/_dashboard.scss","webpack://./assets/src/jsx/styles/pages/_dropzone.scss","webpack://./assets/src/jsx/styles/pages/_home.scss","webpack://./assets/src/jsx/styles/slider/_owl-carousel.scss","webpack://./assets/src/jsx/styles/module/__module-dir.scss","webpack://./assets/src/jsx/styles/module/_app-module.scss","webpack://./assets/src/jsx/styles/module/_chat.scss","webpack://./assets/src/jsx/styles/module/_mail.scss","webpack://./assets/src/jsx/styles/module/_contact.scss","webpack://./assets/src/jsx/styles/module/_calendar.scss","webpack://./assets/src/jsx/styles/colorTheme/__color-theme-dir.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-indigo.scss","webpack://./assets/src/jsx/styles/bootstrap/mixins/_buttons.scss","webpack://./assets/src/jsx/styles/bootstrap/mixins/_gradients.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-cyan.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-amber.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-deep-orange.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-pink.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-blue.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-deep-purple.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-green.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-indigo.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-cyan.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-amber.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-deep-orange.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-pink.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-blue.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-deep-purple.scss","webpack://./assets/src/jsx/styles/colorTheme/_theme-dark-green.scss","webpack://./assets/src/jsx/styles/colorTheme/_dark-theme.scss"],"names":[],"mappings":"AAAA;;;;CAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;gEAAA;ACLA;+EAAA;ACEE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,8BAAA;EACA,cAAA;EACA,yBC+CW;ED9CX,cAAA;EE2BF,iCF1BE;EE2BF,4BF3BE;EE4BF,yBF5BE;EACA,aAAA;EACA,eAAA;AFwFJ;AEtFI;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,0BAAA;EACA,8BAAA;EACA,WAAA;EEaJ,iCFZI;EEaJ,4BFbI;EEcJ,yBFdI;AFyFN;AEtFI;EACE,WAAA;EACA,YAAA;AFwFN;AErFI;EACE,WAAA;EACA,SAAA;AFuFN;AEnFI;EACE,WAAA;AFqFN;AEpFM;EAEE,WAAA;AFqFR;;AE/EA;EACE,uBAAA;EACA,sBAAA;EACA,iBCmGQ;AHjBV;;AE/EA;EACE,uBAAA;EACA,sBAAA;EACA,iBC8FQ;AHZV;;AE/EA;EACE,uBAAA;EACA,sBAAA;EACA,iBCyFQ;AHPV;;AE/EA;EACE,wBAAA;EACA,uBAAA;EACA,kBCoFS;AHFX;;AE/EA;EACE,uBAAA;EACA,sBAAA;EACA,iBCwEQ;AHUV;;AE9EA;EACE,uBAAA;EACA,sBAAA;EACA,iBCkEQ;AHeV;;AE9EA;EACE,uBAAA;EACA,sBAAA;EACA,iBC6DQ;AHoBV;;AE9EA;EACE,wBAAA;EACA,uBAAA;EACA,kBC4DS;AHqBX;;AE9EA;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;AFiFF;;AE9EA;EACE,kBC9BgB;ED+BhB,mBChCe;EDiCf,sBGjGM;EDsFJ,kBD7De;ED0EjB,yBCjCU;EDkCV,kBAAA;AFiFF;;AE9EA,iBAAA;AACA;EACE,kBAAA;EACA,gBAAA;AFiFF;AEhFE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACD,uBAAA;EACC,UAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EE7BA,mBF8BuB;EACvB,sCAAA;EACA,yBAAA;AFkFJ;AE/EE;EACE,6BAAA;AFiFJ;;AE7EA;EACE;IACE,sBAAA;IACA,YAAA;EFgFF;EE9EA;IACE,wBAAA;IACA,YAAA;EFgFF;EE9EA;IACE,UAAA;IACA,0BAAA;EFgFF;AACF;AE7EA;EACE;IACE,sBAAA;IACA,YAAA;EF+EF;EE7EA;IACE,wBAAA;IACA,YAAA;EF+EF;EE7EA;IACE,UAAA;IACA,0BAAA;EF+EF;AACF;AE3EA;EACE,cAAA;EEtKA,gDFuKA;EEtKA,6CFsKA;EErKA,2CFqKA;EEpKA,wCFoKA;EACA,4BAAA;AFgFF;;AE7EA;EACE;IACE,kDAAA;EFgFF;EE9EA;IACE,mDAAA;EFgFF;EE9EA;IACE,gDAAA;EFgFF;AACF;AE7EA;EACE;IACE,+CAAA;IACA,0CAAA;EF+EF;EE7EA;IACE,gDAAA;IACA,2CAAA;EF+EF;EE7EA;IACE,6CAAA;IACA,wCAAA;EF+EF;AACF;AE3EA;EACE,cAAA;EExMA,gDFyMA;EExMA,6CFwMA;EEvMA,2CFuMA;EEtMA,wCFsMA;EACA,6BAAA;AFgFF;;AE7EA;EACE;IACE,kDAAA;EFgFF;EE9EA;IACE,mDAAA;EFgFF;EE9EA;IACE,gDAAA;EFgFF;AACF;AE7EA;EACE;IACE,+CAAA;IACA,0CAAA;EF+EF;EE7EA;IACE,gDAAA;IACA,2CAAA;EF+EF;EE7EA;IACE,6CAAA;IACA,wCAAA;EF+EF;AACF;AE3EA;EACE,cAAA;EE1OA,gDF2OA;EE1OA,6CF0OA;EEzOA,2CFyOA;EExOA,wCFwOA;EACA,2BAAA;AFgFF;;AE7EA;EACE;IACE,kDAAA;EFgFF;EE9EA;IACE,mDAAA;EFgFF;EE9EA;IACE,gDAAA;EFgFF;AACF;AE7EA;EACE;IACE,+CAAA;IACA,0CAAA;EF+EF;EE7EA;IACE,gDAAA;IACA,2CAAA;EF+EF;EE7EA;IACE,6CAAA;IACA,wCAAA;EF+EF;AACF;AE5EA,4DAAA;AACA;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AF8EF;;AE3EA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AF8EF;;AE3EA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AF8EF;;AE1EA;EACE,sBAAA;AF6EF;AE3EE;EAEE,sBAAA;AF4EJ;;AEvEA;EACE,eAAA;AF0EF;;AMtXI;EACE,qBAAA;ANyXN;;AM1XI;EACE,qBAAA;AN6XN;;AM9XI;EACE,qBAAA;ANiYN;;AMlYI;EACE,sBAAA;ANqYN;;AMtYI;EACE,sBAAA;ANyYN;;AM1YI;EACE,sBAAA;AN6YN;;AM9YI;EACE,sBAAA;ANiZN;;AMlZI;EACE,uBAAA;ANqZN;;AMtZI;EACE,yBAAA;ANyZN;;AM1ZI;EACE,yBAAA;AN6ZN;;AM9ZI;EACE,yBAAA;ANiaN;;AMlaI;EACE,0BAAA;ANqaN;;AMtaI;EACE,0BAAA;ANyaN;;AM1aI;EACE,0BAAA;AN6aN;;AM9aI;EACE,0BAAA;ANibN;;AMlbI;EACE,2BAAA;ANqbN;;AO1CM;EACE,oCAAA;AP6CR;;AO3CM;EACE,yBAAA;AP8CR;AO7CQ;EACE,gCAAA;AP+CV;;AO3CM;EACE,oCAAA;AP8CR;;AO5CM;EACE,yBAAA;AP+CR;AO9CQ;EACE,gCAAA;APgDV;;AOtDM;EACE,oCAAA;APyDR;;AOvDM;EACE,yBAAA;AP0DR;AOzDQ;EACE,gCAAA;AP2DV;;AOjEM;EACE,oCAAA;APoER;;AOlEM;EACE,yBAAA;APqER;AOpEQ;EACE,gCAAA;APsEV;;AO5EM;EACE,oCAAA;AP+ER;;AO7EM;EACE,yBAAA;APgFR;AO/EQ;EACE,gCAAA;APiFV;;AOvFM;EACE,oCAAA;AP0FR;;AOxFM;EACE,yBAAA;AP2FR;AO1FQ;EACE,gCAAA;AP4FV;;AOlGM;EACE,oCAAA;APqGR;;AOnGM;EACE,yBAAA;APsGR;AOrGQ;EACE,gCAAA;APuGV;;AO7GM;EACE,oCAAA;APgHR;;AO9GM;EACE,yBAAA;APiHR;AOhHQ;EACE,gCAAA;APkHV;;AOxHM;EACE,oCAAA;AP2HR;;AOzHM;EACE,yBAAA;AP4HR;AO3HQ;EACE,gCAAA;AP6HV;;AOnIM;EACE,oCAAA;APsIR;;AOpIM;EACE,yBAAA;APuIR;AOtIQ;EACE,gCAAA;APwIV;;AO9IM;EACE,oCAAA;APiJR;;AO/IM;EACE,yBAAA;APkJR;AOjJQ;EACE,gCAAA;APmJV;;AOzJM;EACE,oCAAA;AP4JR;;AO1JM;EACE,yBAAA;AP6JR;AO5JQ;EACE,gCAAA;AP8JV;;AOpKM;EACE,oCAAA;APuKR;;AOrKM;EACE,yBAAA;APwKR;AOvKQ;EACE,gCAAA;APyKV;;AO/KM;EACE,oCAAA;APkLR;;AOhLM;EACE,yBAAA;APmLR;AOlLQ;EACE,gCAAA;APoLV;;AOpMM;EACE,oCAAA;APuMR;;AOrMM;EACE,yBAAA;APwMR;AOvMQ;EACE,gCAAA;APyMV;;AOrMM;EACE,oCAAA;APwMR;;AOtMM;EACE,yBAAA;APyMR;AOxMQ;EACE,gCAAA;AP0MV;;AOhNM;EACE,oCAAA;APmNR;;AOjNM;EACE,yBAAA;APoNR;AOnNQ;EACE,gCAAA;APqNV;;AO3NM;EACE,oCAAA;AP8NR;;AO5NM;EACE,yBAAA;AP+NR;AO9NQ;EACE,gCAAA;APgOV;;AOtOM;EACE,oCAAA;APyOR;;AOvOM;EACE,yBAAA;AP0OR;AOzOQ;EACE,gCAAA;AP2OV;;AOjPM;EACE,oCAAA;APoPR;;AOlPM;EACE,yBAAA;APqPR;AOpPQ;EACE,gCAAA;APsPV;;AO5PM;EACE,oCAAA;AP+PR;;AO7PM;EACE,yBAAA;APgQR;AO/PQ;EACE,gCAAA;APiQV;;AOvQM;EACE,oCAAA;AP0QR;;AOxQM;EACE,yBAAA;AP2QR;AO1QQ;EACE,gCAAA;AP4QV;;AOlRM;EACE,oCAAA;APqRR;;AOnRM;EACE,yBAAA;APsRR;AOrRQ;EACE,gCAAA;APuRV;;AO7RM;EACE,oCAAA;APgSR;;AO9RM;EACE,yBAAA;APiSR;AOhSQ;EACE,gCAAA;APkSV;;AOxSM;EACE,oCAAA;AP2SR;;AOzSM;EACE,yBAAA;AP4SR;AO3SQ;EACE,gCAAA;AP6SV;;AOnTM;EACE,oCAAA;APsTR;;AOpTM;EACE,yBAAA;APuTR;AOtTQ;EACE,gCAAA;APwTV;;AO9TM;EACE,oCAAA;APiUR;;AO/TM;EACE,yBAAA;APkUR;AOjUQ;EACE,gCAAA;APmUV;;AOzUM;EACE,oCAAA;AP4UR;;AO1UM;EACE,yBAAA;AP6UR;AO5UQ;EACE,gCAAA;AP8UV;;AO9VM;EACE,oCAAA;APiWR;;AO/VM;EACE,yBAAA;APkWR;AOjWQ;EACE,gCAAA;APmWV;;AO/VM;EACE,oCAAA;APkWR;;AOhWM;EACE,yBAAA;APmWR;AOlWQ;EACE,gCAAA;APoWV;;AO1WM;EACE,oCAAA;AP6WR;;AO3WM;EACE,yBAAA;AP8WR;AO7WQ;EACE,gCAAA;AP+WV;;AOrXM;EACE,oCAAA;APwXR;;AOtXM;EACE,yBAAA;APyXR;AOxXQ;EACE,gCAAA;AP0XV;;AOhYM;EACE,oCAAA;APmYR;;AOjYM;EACE,yBAAA;APoYR;AOnYQ;EACE,gCAAA;APqYV;;AO3YM;EACE,oCAAA;AP8YR;;AO5YM;EACE,yBAAA;AP+YR;AO9YQ;EACE,gCAAA;APgZV;;AOtZM;EACE,oCAAA;APyZR;;AOvZM;EACE,yBAAA;AP0ZR;AOzZQ;EACE,gCAAA;AP2ZV;;AOjaM;EACE,oCAAA;APoaR;;AOlaM;EACE,yBAAA;APqaR;AOpaQ;EACE,gCAAA;APsaV;;AO5aM;EACE,oCAAA;AP+aR;;AO7aM;EACE,yBAAA;APgbR;AO/aQ;EACE,gCAAA;APibV;;AOvbM;EACE,oCAAA;AP0bR;;AOxbM;EACE,yBAAA;AP2bR;AO1bQ;EACE,gCAAA;AP4bV;;AOlcM;EACE,oCAAA;APqcR;;AOncM;EACE,yBAAA;APscR;AOrcQ;EACE,gCAAA;APucV;;AO7cM;EACE,oCAAA;APgdR;;AO9cM;EACE,yBAAA;APidR;AOhdQ;EACE,gCAAA;APkdV;;AOxdM;EACE,oCAAA;AP2dR;;AOzdM;EACE,yBAAA;AP4dR;AO3dQ;EACE,gCAAA;AP6dV;;AOneM;EACE,oCAAA;APseR;;AOpeM;EACE,yBAAA;APueR;AOteQ;EACE,gCAAA;APweV;;AOxfM;EACE,oCAAA;AP2fR;;AOzfM;EACE,yBAAA;AP4fR;AO3fQ;EACE,gCAAA;AP6fV;;AOzfM;EACE,oCAAA;AP4fR;;AO1fM;EACE,yBAAA;AP6fR;AO5fQ;EACE,gCAAA;AP8fV;;AOpgBM;EACE,oCAAA;APugBR;;AOrgBM;EACE,yBAAA;APwgBR;AOvgBQ;EACE,gCAAA;APygBV;;AO/gBM;EACE,oCAAA;APkhBR;;AOhhBM;EACE,yBAAA;APmhBR;AOlhBQ;EACE,gCAAA;APohBV;;AO1hBM;EACE,oCAAA;AP6hBR;;AO3hBM;EACE,yBAAA;AP8hBR;AO7hBQ;EACE,gCAAA;AP+hBV;;AOriBM;EACE,oCAAA;APwiBR;;AOtiBM;EACE,yBAAA;APyiBR;AOxiBQ;EACE,gCAAA;AP0iBV;;AOhjBM;EACE,oCAAA;APmjBR;;AOjjBM;EACE,yBAAA;APojBR;AOnjBQ;EACE,gCAAA;APqjBV;;AO3jBM;EACE,oCAAA;AP8jBR;;AO5jBM;EACE,yBAAA;AP+jBR;AO9jBQ;EACE,gCAAA;APgkBV;;AOtkBM;EACE,oCAAA;APykBR;;AOvkBM;EACE,yBAAA;AP0kBR;AOzkBQ;EACE,gCAAA;AP2kBV;;AOjlBM;EACE,oCAAA;APolBR;;AOllBM;EACE,yBAAA;APqlBR;AOplBQ;EACE,gCAAA;APslBV;;AO5lBM;EACE,oCAAA;AP+lBR;;AO7lBM;EACE,yBAAA;APgmBR;AO/lBQ;EACE,gCAAA;APimBV;;AOvmBM;EACE,oCAAA;AP0mBR;;AOxmBM;EACE,yBAAA;AP2mBR;AO1mBQ;EACE,gCAAA;AP4mBV;;AOlnBM;EACE,oCAAA;APqnBR;;AOnnBM;EACE,yBAAA;APsnBR;AOrnBQ;EACE,gCAAA;APunBV;;AO7nBM;EACE,oCAAA;APgoBR;;AO9nBM;EACE,yBAAA;APioBR;AOhoBQ;EACE,gCAAA;APkoBV;;AOlpBM;EACE,oCAAA;APqpBR;;AOnpBM;EACE,yBAAA;APspBR;AOrpBQ;EACE,gCAAA;APupBV;;AOnpBM;EACE,oCAAA;APspBR;;AOppBM;EACE,yBAAA;APupBR;AOtpBQ;EACE,gCAAA;APwpBV;;AO9pBM;EACE,oCAAA;APiqBR;;AO/pBM;EACE,yBAAA;APkqBR;AOjqBQ;EACE,gCAAA;APmqBV;;AOzqBM;EACE,oCAAA;AP4qBR;;AO1qBM;EACE,yBAAA;AP6qBR;AO5qBQ;EACE,gCAAA;AP8qBV;;AOprBM;EACE,oCAAA;APurBR;;AOrrBM;EACE,yBAAA;APwrBR;AOvrBQ;EACE,gCAAA;APyrBV;;AO/rBM;EACE,oCAAA;APksBR;;AOhsBM;EACE,yBAAA;APmsBR;AOlsBQ;EACE,gCAAA;APosBV;;AO1sBM;EACE,oCAAA;AP6sBR;;AO3sBM;EACE,yBAAA;AP8sBR;AO7sBQ;EACE,gCAAA;AP+sBV;;AOrtBM;EACE,oCAAA;APwtBR;;AOttBM;EACE,yBAAA;APytBR;AOxtBQ;EACE,gCAAA;AP0tBV;;AOhuBM;EACE,oCAAA;APmuBR;;AOjuBM;EACE,yBAAA;APouBR;AOnuBQ;EACE,gCAAA;APquBV;;AO3uBM;EACE,oCAAA;AP8uBR;;AO5uBM;EACE,yBAAA;AP+uBR;AO9uBQ;EACE,gCAAA;APgvBV;;AOtvBM;EACE,oCAAA;APyvBR;;AOvvBM;EACE,yBAAA;AP0vBR;AOzvBQ;EACE,gCAAA;AP2vBV;;AOjwBM;EACE,oCAAA;APowBR;;AOlwBM;EACE,yBAAA;APqwBR;AOpwBQ;EACE,gCAAA;APswBV;;AO5wBM;EACE,oCAAA;AP+wBR;;AO7wBM;EACE,yBAAA;APgxBR;AO/wBQ;EACE,gCAAA;APixBV;;AOvxBM;EACE,oCAAA;AP0xBR;;AOxxBM;EACE,yBAAA;AP2xBR;AO1xBQ;EACE,gCAAA;AP4xBV;;AO5yBM;EACE,oCAAA;AP+yBR;;AO7yBM;EACE,yBAAA;APgzBR;AO/yBQ;EACE,gCAAA;APizBV;;AO7yBM;EACE,oCAAA;APgzBR;;AO9yBM;EACE,yBAAA;APizBR;AOhzBQ;EACE,gCAAA;APkzBV;;AOxzBM;EACE,oCAAA;AP2zBR;;AOzzBM;EACE,yBAAA;AP4zBR;AO3zBQ;EACE,gCAAA;AP6zBV;;AOn0BM;EACE,oCAAA;APs0BR;;AOp0BM;EACE,yBAAA;APu0BR;AOt0BQ;EACE,gCAAA;APw0BV;;AO90BM;EACE,oCAAA;APi1BR;;AO/0BM;EACE,yBAAA;APk1BR;AOj1BQ;EACE,gCAAA;APm1BV;;AOz1BM;EACE,oCAAA;AP41BR;;AO11BM;EACE,yBAAA;AP61BR;AO51BQ;EACE,gCAAA;AP81BV;;AOp2BM;EACE,oCAAA;APu2BR;;AOr2BM;EACE,yBAAA;APw2BR;AOv2BQ;EACE,gCAAA;APy2BV;;AO/2BM;EACE,oCAAA;APk3BR;;AOh3BM;EACE,yBAAA;APm3BR;AOl3BQ;EACE,gCAAA;APo3BV;;AO13BM;EACE,oCAAA;AP63BR;;AO33BM;EACE,yBAAA;AP83BR;AO73BQ;EACE,gCAAA;AP+3BV;;AOr4BM;EACE,oCAAA;APw4BR;;AOt4BM;EACE,yBAAA;APy4BR;AOx4BQ;EACE,gCAAA;AP04BV;;AOh5BM;EACE,oCAAA;APm5BR;;AOj5BM;EACE,yBAAA;APo5BR;AOn5BQ;EACE,gCAAA;APq5BV;;AO35BM;EACE,oCAAA;AP85BR;;AO55BM;EACE,yBAAA;AP+5BR;AO95BQ;EACE,gCAAA;APg6BV;;AOt6BM;EACE,oCAAA;APy6BR;;AOv6BM;EACE,yBAAA;AP06BR;AOz6BQ;EACE,gCAAA;AP26BV;;AOj7BM;EACE,oCAAA;APo7BR;;AOl7BM;EACE,yBAAA;APq7BR;AOp7BQ;EACE,gCAAA;APs7BV;;AOt8BM;EACE,oCAAA;APy8BR;;AOv8BM;EACE,yBAAA;AP08BR;AOz8BQ;EACE,gCAAA;AP28BV;;AOv8BM;EACE,oCAAA;AP08BR;;AOx8BM;EACE,yBAAA;AP28BR;AO18BQ;EACE,gCAAA;AP48BV;;AOl9BM;EACE,oCAAA;APq9BR;;AOn9BM;EACE,yBAAA;APs9BR;AOr9BQ;EACE,gCAAA;APu9BV;;AO79BM;EACE,oCAAA;APg+BR;;AO99BM;EACE,yBAAA;APi+BR;AOh+BQ;EACE,gCAAA;APk+BV;;AOx+BM;EACE,oCAAA;AP2+BR;;AOz+BM;EACE,yBAAA;AP4+BR;AO3+BQ;EACE,gCAAA;AP6+BV;;AOn/BM;EACE,oCAAA;APs/BR;;AOp/BM;EACE,yBAAA;APu/BR;AOt/BQ;EACE,gCAAA;APw/BV;;AO9/BM;EACE,oCAAA;APigCR;;AO//BM;EACE,yBAAA;APkgCR;AOjgCQ;EACE,gCAAA;APmgCV;;AOzgCM;EACE,oCAAA;AP4gCR;;AO1gCM;EACE,yBAAA;AP6gCR;AO5gCQ;EACE,gCAAA;AP8gCV;;AOphCM;EACE,oCAAA;APuhCR;;AOrhCM;EACE,yBAAA;APwhCR;AOvhCQ;EACE,gCAAA;APyhCV;;AO/hCM;EACE,oCAAA;APkiCR;;AOhiCM;EACE,yBAAA;APmiCR;AOliCQ;EACE,gCAAA;APoiCV;;AO1iCM;EACE,oCAAA;AP6iCR;;AO3iCM;EACE,yBAAA;AP8iCR;AO7iCQ;EACE,gCAAA;AP+iCV;;AOrjCM;EACE,oCAAA;APwjCR;;AOtjCM;EACE,yBAAA;APyjCR;AOxjCQ;EACE,gCAAA;AP0jCV;;AOhkCM;EACE,oCAAA;APmkCR;;AOjkCM;EACE,yBAAA;APokCR;AOnkCQ;EACE,gCAAA;APqkCV;;AO3kCM;EACE,oCAAA;AP8kCR;;AO5kCM;EACE,yBAAA;AP+kCR;AO9kCQ;EACE,gCAAA;APglCV;;AOhmCM;EACE,oCAAA;APmmCR;;AOjmCM;EACE,yBAAA;APomCR;AOnmCQ;EACE,gCAAA;APqmCV;;AOjmCM;EACE,oCAAA;APomCR;;AOlmCM;EACE,yBAAA;APqmCR;AOpmCQ;EACE,gCAAA;APsmCV;;AO5mCM;EACE,oCAAA;AP+mCR;;AO7mCM;EACE,yBAAA;APgnCR;AO/mCQ;EACE,gCAAA;APinCV;;AOvnCM;EACE,oCAAA;AP0nCR;;AOxnCM;EACE,yBAAA;AP2nCR;AO1nCQ;EACE,gCAAA;AP4nCV;;AOloCM;EACE,oCAAA;APqoCR;;AOnoCM;EACE,yBAAA;APsoCR;AOroCQ;EACE,gCAAA;APuoCV;;AO7oCM;EACE,oCAAA;APgpCR;;AO9oCM;EACE,yBAAA;APipCR;AOhpCQ;EACE,gCAAA;APkpCV;;AOxpCM;EACE,oCAAA;AP2pCR;;AOzpCM;EACE,yBAAA;AP4pCR;AO3pCQ;EACE,gCAAA;AP6pCV;;AOnqCM;EACE,oCAAA;APsqCR;;AOpqCM;EACE,yBAAA;APuqCR;AOtqCQ;EACE,gCAAA;APwqCV;;AO9qCM;EACE,oCAAA;APirCR;;AO/qCM;EACE,yBAAA;APkrCR;AOjrCQ;EACE,gCAAA;APmrCV;;AOzrCM;EACE,oCAAA;AP4rCR;;AO1rCM;EACE,yBAAA;AP6rCR;AO5rCQ;EACE,gCAAA;AP8rCV;;AOpsCM;EACE,oCAAA;APusCR;;AOrsCM;EACE,yBAAA;APwsCR;AOvsCQ;EACE,gCAAA;APysCV;;AO/sCM;EACE,oCAAA;APktCR;;AOhtCM;EACE,yBAAA;APmtCR;AOltCQ;EACE,gCAAA;APotCV;;AO1tCM;EACE,oCAAA;AP6tCR;;AO3tCM;EACE,yBAAA;AP8tCR;AO7tCQ;EACE,gCAAA;AP+tCV;;AOruCM;EACE,oCAAA;APwuCR;;AOtuCM;EACE,yBAAA;APyuCR;AOxuCQ;EACE,gCAAA;AP0uCV;;AO1vCM;EACE,oCAAA;AP6vCR;;AO3vCM;EACE,yBAAA;AP8vCR;AO7vCQ;EACE,gCAAA;AP+vCV;;AO3vCM;EACE,oCAAA;AP8vCR;;AO5vCM;EACE,yBAAA;AP+vCR;AO9vCQ;EACE,gCAAA;APgwCV;;AOtwCM;EACE,oCAAA;APywCR;;AOvwCM;EACE,yBAAA;AP0wCR;AOzwCQ;EACE,gCAAA;AP2wCV;;AOjxCM;EACE,oCAAA;APoxCR;;AOlxCM;EACE,yBAAA;APqxCR;AOpxCQ;EACE,gCAAA;APsxCV;;AO5xCM;EACE,oCAAA;AP+xCR;;AO7xCM;EACE,yBAAA;APgyCR;AO/xCQ;EACE,gCAAA;APiyCV;;AOvyCM;EACE,oCAAA;AP0yCR;;AOxyCM;EACE,yBAAA;AP2yCR;AO1yCQ;EACE,gCAAA;AP4yCV;;AOlzCM;EACE,oCAAA;APqzCR;;AOnzCM;EACE,yBAAA;APszCR;AOrzCQ;EACE,gCAAA;APuzCV;;AO7zCM;EACE,oCAAA;APg0CR;;AO9zCM;EACE,yBAAA;APi0CR;AOh0CQ;EACE,gCAAA;APk0CV;;AOx0CM;EACE,oCAAA;AP20CR;;AOz0CM;EACE,yBAAA;AP40CR;AO30CQ;EACE,gCAAA;AP60CV;;AOn1CM;EACE,oCAAA;APs1CR;;AOp1CM;EACE,yBAAA;APu1CR;AOt1CQ;EACE,gCAAA;APw1CV;;AO91CM;EACE,oCAAA;APi2CR;;AO/1CM;EACE,yBAAA;APk2CR;AOj2CQ;EACE,gCAAA;APm2CV;;AOz2CM;EACE,oCAAA;AP42CR;;AO12CM;EACE,yBAAA;AP62CR;AO52CQ;EACE,gCAAA;AP82CV;;AOp3CM;EACE,oCAAA;APu3CR;;AOr3CM;EACE,yBAAA;APw3CR;AOv3CQ;EACE,gCAAA;APy3CV;;AO/3CM;EACE,oCAAA;APk4CR;;AOh4CM;EACE,yBAAA;APm4CR;AOl4CQ;EACE,gCAAA;APo4CV;;AOp5CM;EACE,oCAAA;APu5CR;;AOr5CM;EACE,yBAAA;APw5CR;AOv5CQ;EACE,gCAAA;APy5CV;;AOr5CM;EACE,oCAAA;APw5CR;;AOt5CM;EACE,yBAAA;APy5CR;AOx5CQ;EACE,gCAAA;AP05CV;;AOh6CM;EACE,oCAAA;APm6CR;;AOj6CM;EACE,yBAAA;APo6CR;AOn6CQ;EACE,gCAAA;APq6CV;;AO36CM;EACE,oCAAA;AP86CR;;AO56CM;EACE,yBAAA;AP+6CR;AO96CQ;EACE,gCAAA;APg7CV;;AOt7CM;EACE,oCAAA;APy7CR;;AOv7CM;EACE,yBAAA;AP07CR;AOz7CQ;EACE,gCAAA;AP27CV;;AOj8CM;EACE,oCAAA;APo8CR;;AOl8CM;EACE,yBAAA;APq8CR;AOp8CQ;EACE,gCAAA;APs8CV;;AO58CM;EACE,oCAAA;AP+8CR;;AO78CM;EACE,yBAAA;APg9CR;AO/8CQ;EACE,gCAAA;APi9CV;;AOv9CM;EACE,oCAAA;AP09CR;;AOx9CM;EACE,yBAAA;AP29CR;AO19CQ;EACE,gCAAA;AP49CV;;AOl+CM;EACE,oCAAA;APq+CR;;AOn+CM;EACE,yBAAA;APs+CR;AOr+CQ;EACE,gCAAA;APu+CV;;AO7+CM;EACE,oCAAA;APg/CR;;AO9+CM;EACE,yBAAA;APi/CR;AOh/CQ;EACE,gCAAA;APk/CV;;AOx/CM;EACE,oCAAA;AP2/CR;;AOz/CM;EACE,yBAAA;AP4/CR;AO3/CQ;EACE,gCAAA;AP6/CV;;AOngDM;EACE,oCAAA;APsgDR;;AOpgDM;EACE,yBAAA;APugDR;AOtgDQ;EACE,gCAAA;APwgDV;;AO9gDM;EACE,oCAAA;APihDR;;AO/gDM;EACE,yBAAA;APkhDR;AOjhDQ;EACE,gCAAA;APmhDV;;AOzhDM;EACE,oCAAA;AP4hDR;;AO1hDM;EACE,yBAAA;AP6hDR;AO5hDQ;EACE,gCAAA;AP8hDV;;AO9iDM;EACE,oCAAA;APijDR;;AO/iDM;EACE,yBAAA;APkjDR;AOjjDQ;EACE,gCAAA;APmjDV;;AO/iDM;EACE,oCAAA;APkjDR;;AOhjDM;EACE,yBAAA;APmjDR;AOljDQ;EACE,gCAAA;APojDV;;AO1jDM;EACE,oCAAA;AP6jDR;;AO3jDM;EACE,yBAAA;AP8jDR;AO7jDQ;EACE,gCAAA;AP+jDV;;AOrkDM;EACE,oCAAA;APwkDR;;AOtkDM;EACE,yBAAA;APykDR;AOxkDQ;EACE,gCAAA;AP0kDV;;AOhlDM;EACE,oCAAA;APmlDR;;AOjlDM;EACE,yBAAA;APolDR;AOnlDQ;EACE,gCAAA;APqlDV;;AO3lDM;EACE,oCAAA;AP8lDR;;AO5lDM;EACE,yBAAA;AP+lDR;AO9lDQ;EACE,gCAAA;APgmDV;;AOtmDM;EACE,oCAAA;APymDR;;AOvmDM;EACE,yBAAA;AP0mDR;AOzmDQ;EACE,gCAAA;AP2mDV;;AOjnDM;EACE,oCAAA;APonDR;;AOlnDM;EACE,yBAAA;APqnDR;AOpnDQ;EACE,gCAAA;APsnDV;;AO5nDM;EACE,oCAAA;AP+nDR;;AO7nDM;EACE,yBAAA;APgoDR;AO/nDQ;EACE,gCAAA;APioDV;;AOvoDM;EACE,oCAAA;AP0oDR;;AOxoDM;EACE,yBAAA;AP2oDR;AO1oDQ;EACE,gCAAA;AP4oDV;;AOlpDM;EACE,oCAAA;APqpDR;;AOnpDM;EACE,yBAAA;APspDR;AOrpDQ;EACE,gCAAA;APupDV;;AO7pDM;EACE,oCAAA;APgqDR;;AO9pDM;EACE,yBAAA;APiqDR;AOhqDQ;EACE,gCAAA;APkqDV;;AOxqDM;EACE,oCAAA;AP2qDR;;AOzqDM;EACE,yBAAA;AP4qDR;AO3qDQ;EACE,gCAAA;AP6qDV;;AOnrDM;EACE,oCAAA;APsrDR;;AOprDM;EACE,yBAAA;APurDR;AOtrDQ;EACE,gCAAA;APwrDV;;AOxsDM;EACE,oCAAA;AP2sDR;;AOzsDM;EACE,yBAAA;AP4sDR;AO3sDQ;EACE,gCAAA;AP6sDV;;AOzsDM;EACE,oCAAA;AP4sDR;;AO1sDM;EACE,yBAAA;AP6sDR;AO5sDQ;EACE,gCAAA;AP8sDV;;AOptDM;EACE,oCAAA;APutDR;;AOrtDM;EACE,yBAAA;APwtDR;AOvtDQ;EACE,gCAAA;APytDV;;AO/tDM;EACE,oCAAA;APkuDR;;AOhuDM;EACE,yBAAA;APmuDR;AOluDQ;EACE,gCAAA;APouDV;;AO1uDM;EACE,oCAAA;AP6uDR;;AO3uDM;EACE,yBAAA;AP8uDR;AO7uDQ;EACE,gCAAA;AP+uDV;;AOrvDM;EACE,oCAAA;APwvDR;;AOtvDM;EACE,yBAAA;APyvDR;AOxvDQ;EACE,gCAAA;AP0vDV;;AOhwDM;EACE,oCAAA;APmwDR;;AOjwDM;EACE,yBAAA;APowDR;AOnwDQ;EACE,gCAAA;APqwDV;;AO3wDM;EACE,oCAAA;AP8wDR;;AO5wDM;EACE,yBAAA;AP+wDR;AO9wDQ;EACE,gCAAA;APgxDV;;AOtxDM;EACE,oCAAA;APyxDR;;AOvxDM;EACE,yBAAA;AP0xDR;AOzxDQ;EACE,gCAAA;AP2xDV;;AOjyDM;EACE,oCAAA;APoyDR;;AOlyDM;EACE,yBAAA;APqyDR;AOpyDQ;EACE,gCAAA;APsyDV;;AO5yDM;EACE,oCAAA;AP+yDR;;AO7yDM;EACE,yBAAA;APgzDR;AO/yDQ;EACE,gCAAA;APizDV;;AOvzDM;EACE,oCAAA;AP0zDR;;AOxzDM;EACE,yBAAA;AP2zDR;AO1zDQ;EACE,gCAAA;AP4zDV;;AOl0DM;EACE,oCAAA;APq0DR;;AOn0DM;EACE,yBAAA;APs0DR;AOr0DQ;EACE,gCAAA;APu0DV;;AO70DM;EACE,oCAAA;APg1DR;;AO90DM;EACE,yBAAA;APi1DR;AOh1DQ;EACE,gCAAA;APk1DV;;AOl2DM;EACE,oCAAA;APq2DR;;AOn2DM;EACE,yBAAA;APs2DR;AOr2DQ;EACE,gCAAA;APu2DV;;AOn2DM;EACE,oCAAA;APs2DR;;AOp2DM;EACE,yBAAA;APu2DR;AOt2DQ;EACE,gCAAA;APw2DV;;AO92DM;EACE,oCAAA;APi3DR;;AO/2DM;EACE,yBAAA;APk3DR;AOj3DQ;EACE,gCAAA;APm3DV;;AOz3DM;EACE,oCAAA;AP43DR;;AO13DM;EACE,yBAAA;AP63DR;AO53DQ;EACE,gCAAA;AP83DV;;AOp4DM;EACE,oCAAA;APu4DR;;AOr4DM;EACE,yBAAA;APw4DR;AOv4DQ;EACE,gCAAA;APy4DV;;AO/4DM;EACE,oCAAA;APk5DR;;AOh5DM;EACE,yBAAA;APm5DR;AOl5DQ;EACE,gCAAA;APo5DV;;AO15DM;EACE,oCAAA;AP65DR;;AO35DM;EACE,yBAAA;AP85DR;AO75DQ;EACE,gCAAA;AP+5DV;;AOr6DM;EACE,oCAAA;APw6DR;;AOt6DM;EACE,yBAAA;APy6DR;AOx6DQ;EACE,gCAAA;AP06DV;;AOh7DM;EACE,oCAAA;APm7DR;;AOj7DM;EACE,yBAAA;APo7DR;AOn7DQ;EACE,gCAAA;APq7DV;;AO37DM;EACE,oCAAA;AP87DR;;AO57DM;EACE,yBAAA;AP+7DR;AO97DQ;EACE,gCAAA;APg8DV;;AOt8DM;EACE,oCAAA;APy8DR;;AOv8DM;EACE,yBAAA;AP08DR;AOz8DQ;EACE,gCAAA;AP28DV;;AOj9DM;EACE,oCAAA;APo9DR;;AOl9DM;EACE,yBAAA;APq9DR;AOp9DQ;EACE,gCAAA;APs9DV;;AO59DM;EACE,oCAAA;AP+9DR;;AO79DM;EACE,yBAAA;APg+DR;AO/9DQ;EACE,gCAAA;APi+DV;;AOv+DM;EACE,oCAAA;AP0+DR;;AOx+DM;EACE,yBAAA;AP2+DR;AO1+DQ;EACE,gCAAA;AP4+DV;;AO5/DM;EACE,oCAAA;AP+/DR;;AO7/DM;EACE,yBAAA;APggER;AO//DQ;EACE,gCAAA;APigEV;;AO7/DM;EACE,oCAAA;APggER;;AO9/DM;EACE,yBAAA;APigER;AOhgEQ;EACE,gCAAA;APkgEV;;AOxgEM;EACE,oCAAA;AP2gER;;AOzgEM;EACE,yBAAA;AP4gER;AO3gEQ;EACE,gCAAA;AP6gEV;;AOnhEM;EACE,oCAAA;APshER;;AOphEM;EACE,yBAAA;APuhER;AOthEQ;EACE,gCAAA;APwhEV;;AO9hEM;EACE,oCAAA;APiiER;;AO/hEM;EACE,yBAAA;APkiER;AOjiEQ;EACE,gCAAA;APmiEV;;AOziEM;EACE,oCAAA;AP4iER;;AO1iEM;EACE,yBAAA;AP6iER;AO5iEQ;EACE,gCAAA;AP8iEV;;AOpjEM;EACE,oCAAA;APujER;;AOrjEM;EACE,yBAAA;APwjER;AOvjEQ;EACE,gCAAA;APyjEV;;AO/jEM;EACE,oCAAA;APkkER;;AOhkEM;EACE,yBAAA;APmkER;AOlkEQ;EACE,gCAAA;APokEV;;AO1kEM;EACE,oCAAA;AP6kER;;AO3kEM;EACE,yBAAA;AP8kER;AO7kEQ;EACE,gCAAA;AP+kEV;;AOrlEM;EACE,oCAAA;APwlER;;AOtlEM;EACE,yBAAA;APylER;AOxlEQ;EACE,gCAAA;AP0lEV;;AOhmEM;EACE,oCAAA;APmmER;;AOjmEM;EACE,yBAAA;APomER;AOnmEQ;EACE,gCAAA;APqmEV;;AO3mEM;EACE,oCAAA;AP8mER;;AO5mEM;EACE,yBAAA;AP+mER;AO9mEQ;EACE,gCAAA;APgnEV;;AOtnEM;EACE,oCAAA;APynER;;AOvnEM;EACE,yBAAA;AP0nER;AOznEQ;EACE,gCAAA;AP2nEV;;AOjoEM;EACE,oCAAA;APooER;;AOloEM;EACE,yBAAA;APqoER;AOpoEQ;EACE,gCAAA;APsoEV;;AOtpEM;EACE,oCAAA;APypER;;AOvpEM;EACE,yBAAA;AP0pER;AOzpEQ;EACE,gCAAA;AP2pEV;;AOvpEM;EACE,oCAAA;AP0pER;;AOxpEM;EACE,yBAAA;AP2pER;AO1pEQ;EACE,gCAAA;AP4pEV;;AOlqEM;EACE,oCAAA;APqqER;;AOnqEM;EACE,yBAAA;APsqER;AOrqEQ;EACE,gCAAA;APuqEV;;AO7qEM;EACE,oCAAA;APgrER;;AO9qEM;EACE,yBAAA;APirER;AOhrEQ;EACE,gCAAA;APkrEV;;AOxrEM;EACE,oCAAA;AP2rER;;AOzrEM;EACE,yBAAA;AP4rER;AO3rEQ;EACE,gCAAA;AP6rEV;;AOnsEM;EACE,oCAAA;APssER;;AOpsEM;EACE,yBAAA;APusER;AOtsEQ;EACE,gCAAA;APwsEV;;AO9sEM;EACE,oCAAA;APitER;;AO/sEM;EACE,yBAAA;APktER;AOjtEQ;EACE,gCAAA;APmtEV;;AOztEM;EACE,oCAAA;AP4tER;;AO1tEM;EACE,yBAAA;AP6tER;AO5tEQ;EACE,gCAAA;AP8tEV;;AOpuEM;EACE,oCAAA;APuuER;;AOruEM;EACE,yBAAA;APwuER;AOvuEQ;EACE,gCAAA;APyuEV;;AO/uEM;EACE,oCAAA;APkvER;;AOhvEM;EACE,yBAAA;APmvER;AOlvEQ;EACE,gCAAA;APovEV;;AO1vEM;EACE,oCAAA;AP6vER;;AO3vEM;EACE,yBAAA;AP8vER;AO7vEQ;EACE,gCAAA;AP+vEV;;AOrwEM;EACE,oCAAA;APwwER;;AOtwEM;EACE,yBAAA;APywER;AOxwEQ;EACE,gCAAA;AP0wEV;;AOhxEM;EACE,oCAAA;APmxER;;AOjxEM;EACE,yBAAA;APoxER;AOnxEQ;EACE,gCAAA;APqxEV;;AO3xEM;EACE,oCAAA;AP8xER;;AO5xEM;EACE,yBAAA;AP+xER;AO9xEQ;EACE,gCAAA;APgyEV;;AOhzEM;EACE,oCAAA;APmzER;;AOjzEM;EACE,yBAAA;APozER;AOnzEQ;EACE,gCAAA;APqzEV;;AOjzEM;EACE,oCAAA;APozER;;AOlzEM;EACE,yBAAA;APqzER;AOpzEQ;EACE,gCAAA;APszEV;;AO5zEM;EACE,oCAAA;AP+zER;;AO7zEM;EACE,yBAAA;APg0ER;AO/zEQ;EACE,gCAAA;APi0EV;;AOv0EM;EACE,oCAAA;AP00ER;;AOx0EM;EACE,yBAAA;AP20ER;AO10EQ;EACE,gCAAA;AP40EV;;AOl1EM;EACE,oCAAA;APq1ER;;AOn1EM;EACE,yBAAA;APs1ER;AOr1EQ;EACE,gCAAA;APu1EV;;AO71EM;EACE,oCAAA;APg2ER;;AO91EM;EACE,yBAAA;APi2ER;AOh2EQ;EACE,gCAAA;APk2EV;;AOx2EM;EACE,oCAAA;AP22ER;;AOz2EM;EACE,yBAAA;AP42ER;AO32EQ;EACE,gCAAA;AP62EV;;AOn3EM;EACE,oCAAA;APs3ER;;AOp3EM;EACE,yBAAA;APu3ER;AOt3EQ;EACE,gCAAA;APw3EV;;AO93EM;EACE,oCAAA;APi4ER;;AO/3EM;EACE,yBAAA;APk4ER;AOj4EQ;EACE,gCAAA;APm4EV;;AOz4EM;EACE,oCAAA;AP44ER;;AO14EM;EACE,yBAAA;AP64ER;AO54EQ;EACE,gCAAA;AP84EV;;AOp5EM;EACE,oCAAA;APu5ER;;AOr5EM;EACE,yBAAA;APw5ER;AOv5EQ;EACE,gCAAA;APy5EV;;AO/5EM;EACE,oCAAA;APk6ER;;AOh6EM;EACE,yBAAA;APm6ER;AOl6EQ;EACE,gCAAA;APo6EV;;AO16EM;EACE,oCAAA;AP66ER;;AO36EM;EACE,yBAAA;AP86ER;AO76EQ;EACE,gCAAA;AP+6EV;;AOr7EM;EACE,oCAAA;APw7ER;;AOt7EM;EACE,yBAAA;APy7ER;AOx7EQ;EACE,gCAAA;AP07EV;;AO18EM;EACE,oCAAA;AP68ER;;AO38EM;EACE,yBAAA;AP88ER;AO78EQ;EACE,gCAAA;AP+8EV;;AO38EM;EACE,oCAAA;AP88ER;;AO58EM;EACE,yBAAA;AP+8ER;AO98EQ;EACE,gCAAA;APg9EV;;AOt9EM;EACE,oCAAA;APy9ER;;AOv9EM;EACE,yBAAA;AP09ER;AOz9EQ;EACE,gCAAA;AP29EV;;AOj+EM;EACE,oCAAA;APo+ER;;AOl+EM;EACE,yBAAA;APq+ER;AOp+EQ;EACE,gCAAA;APs+EV;;AO5+EM;EACE,oCAAA;AP++ER;;AO7+EM;EACE,yBAAA;APg/ER;AO/+EQ;EACE,gCAAA;APi/EV;;AOv/EM;EACE,oCAAA;AP0/ER;;AOx/EM;EACE,yBAAA;AP2/ER;AO1/EQ;EACE,gCAAA;AP4/EV;;AOlgFM;EACE,oCAAA;APqgFR;;AOngFM;EACE,yBAAA;APsgFR;AOrgFQ;EACE,gCAAA;APugFV;;AO7gFM;EACE,oCAAA;APghFR;;AO9gFM;EACE,yBAAA;APihFR;AOhhFQ;EACE,gCAAA;APkhFV;;AOxhFM;EACE,oCAAA;AP2hFR;;AOzhFM;EACE,yBAAA;AP4hFR;AO3hFQ;EACE,gCAAA;AP6hFV;;AOniFM;EACE,oCAAA;APsiFR;;AOpiFM;EACE,yBAAA;APuiFR;AOtiFQ;EACE,gCAAA;APwiFV;;AO9iFM;EACE,oCAAA;APijFR;;AO/iFM;EACE,yBAAA;APkjFR;AOjjFQ;EACE,gCAAA;APmjFV;;AOzjFM;EACE,oCAAA;AP4jFR;;AO1jFM;EACE,yBAAA;AP6jFR;AO5jFQ;EACE,gCAAA;AP8jFV;;AOpkFM;EACE,oCAAA;APukFR;;AOrkFM;EACE,yBAAA;APwkFR;AOvkFQ;EACE,gCAAA;APykFV;;AO/kFM;EACE,oCAAA;APklFR;;AOhlFM;EACE,yBAAA;APmlFR;AOllFQ;EACE,gCAAA;APolFV;;AOpmFM;EACE,oCAAA;APumFR;;AOrmFM;EACE,yBAAA;APwmFR;AOvmFQ;EACE,gCAAA;APymFV;;AOrmFM;EACE,oCAAA;APwmFR;;AOtmFM;EACE,yBAAA;APymFR;AOxmFQ;EACE,gCAAA;AP0mFV;;AOhnFM;EACE,oCAAA;APmnFR;;AOjnFM;EACE,yBAAA;APonFR;AOnnFQ;EACE,gCAAA;APqnFV;;AO3nFM;EACE,oCAAA;AP8nFR;;AO5nFM;EACE,yBAAA;AP+nFR;AO9nFQ;EACE,gCAAA;APgoFV;;AOtoFM;EACE,oCAAA;APyoFR;;AOvoFM;EACE,yBAAA;AP0oFR;AOzoFQ;EACE,gCAAA;AP2oFV;;AOjpFM;EACE,oCAAA;APopFR;;AOlpFM;EACE,yBAAA;APqpFR;AOppFQ;EACE,gCAAA;APspFV;;AO5pFM;EACE,oCAAA;AP+pFR;;AO7pFM;EACE,yBAAA;APgqFR;AO/pFQ;EACE,gCAAA;APiqFV;;AOvqFM;EACE,oCAAA;AP0qFR;;AOxqFM;EACE,yBAAA;AP2qFR;AO1qFQ;EACE,gCAAA;AP4qFV;;AOlrFM;EACE,oCAAA;APqrFR;;AOnrFM;EACE,yBAAA;APsrFR;AOrrFQ;EACE,gCAAA;APurFV;;AO7rFM;EACE,oCAAA;APgsFR;;AO9rFM;EACE,yBAAA;APisFR;AOhsFQ;EACE,gCAAA;APksFV;;AOltFM;EACE,oCAAA;APqtFR;;AOntFM;EACE,yBAAA;APstFR;AOrtFQ;EACE,gCAAA;APutFV;;AOntFM;EACE,oCAAA;APstFR;;AOptFM;EACE,yBAAA;APutFR;AOttFQ;EACE,gCAAA;APwtFV;;AO9tFM;EACE,oCAAA;APiuFR;;AO/tFM;EACE,yBAAA;APkuFR;AOjuFQ;EACE,gCAAA;APmuFV;;AOzuFM;EACE,oCAAA;AP4uFR;;AO1uFM;EACE,yBAAA;AP6uFR;AO5uFQ;EACE,gCAAA;AP8uFV;;AOpvFM;EACE,oCAAA;APuvFR;;AOrvFM;EACE,yBAAA;APwvFR;AOvvFQ;EACE,gCAAA;APyvFV;;AO/vFM;EACE,oCAAA;APkwFR;;AOhwFM;EACE,yBAAA;APmwFR;AOlwFQ;EACE,gCAAA;APowFV;;AO1wFM;EACE,oCAAA;AP6wFR;;AO3wFM;EACE,yBAAA;AP8wFR;AO7wFQ;EACE,gCAAA;AP+wFV;;AOrxFM;EACE,oCAAA;APwxFR;;AOtxFM;EACE,yBAAA;APyxFR;AOxxFQ;EACE,gCAAA;AP0xFV;;AOhyFM;EACE,oCAAA;APmyFR;;AOjyFM;EACE,yBAAA;APoyFR;AOnyFQ;EACE,gCAAA;APqyFV;;AO3yFM;EACE,oCAAA;AP8yFR;;AO5yFM;EACE,yBAAA;AP+yFR;AO9yFQ;EACE,gCAAA;APgzFV;;AOh0FM;EACE,oCAAA;APm0FR;;AOj0FM;EACE,yBAAA;APo0FR;AOn0FQ;EACE,gCAAA;APq0FV;;AOj0FM;EACE,oCAAA;APo0FR;;AOl0FM;EACE,yBAAA;APq0FR;AOp0FQ;EACE,gCAAA;APs0FV;;AO50FM;EACE,oCAAA;AP+0FR;;AO70FM;EACE,yBAAA;APg1FR;AO/0FQ;EACE,gCAAA;APi1FV;;AOv1FM;EACE,oCAAA;AP01FR;;AOx1FM;EACE,yBAAA;AP21FR;AO11FQ;EACE,gCAAA;AP41FV;;AOl2FM;EACE,oCAAA;APq2FR;;AOn2FM;EACE,yBAAA;APs2FR;AOr2FQ;EACE,gCAAA;APu2FV;;AO72FM;EACE,oCAAA;APg3FR;;AO92FM;EACE,yBAAA;APi3FR;AOh3FQ;EACE,gCAAA;APk3FV;;AOx3FM;EACE,oCAAA;AP23FR;;AOz3FM;EACE,yBAAA;AP43FR;AO33FQ;EACE,gCAAA;AP63FV;;AOn4FM;EACE,oCAAA;APs4FR;;AOp4FM;EACE,yBAAA;APu4FR;AOt4FQ;EACE,gCAAA;APw4FV;;AO94FM;EACE,oCAAA;APi5FR;;AO/4FM;EACE,yBAAA;APk5FR;AOj5FQ;EACE,gCAAA;APm5FV;;AOz5FM;EACE,oCAAA;AP45FR;;AO15FM;EACE,yBAAA;AP65FR;AO55FQ;EACE,gCAAA;AP85FV;;AOp6FM;EACE,oCAAA;APu6FR;;AOr6FM;EACE,yBAAA;APw6FR;AOv6FQ;EACE,gCAAA;APy6FV;;AO/6FM;EACE,oCAAA;APk7FR;;AOh7FM;EACE,yBAAA;APm7FR;AOl7FQ;EACE,gCAAA;APo7FV;;AO17FM;EACE,oCAAA;AP67FR;;AO37FM;EACE,yBAAA;AP87FR;AO77FQ;EACE,gCAAA;AP+7FV;;AOr8FM;EACE,8CAAA;APw8FR;;AOt8FM;EACE,mCAAA;APy8FR;AOx8FQ;EACE,0CAAA;AP08FV;;AOh9FM;EACE,qDAAA;APm9FR;;AOj9FM;EACE,0CAAA;APo9FR;AOn9FQ;EACE,iDAAA;APq9FV;;AO39FM;EACE,oDAAA;AP89FR;;AO59FM;EACE,yCAAA;AP+9FR;AO99FQ;EACE,gDAAA;APg+FV;;AOt+FM;EACE,oDAAA;APy+FR;;AOv+FM;EACE,yCAAA;AP0+FR;AOz+FQ;EACE,gDAAA;AP2+FV;;AOj/FM;EACE,8CAAA;APo/FR;;AOl/FM;EACE,mCAAA;APq/FR;AOp/FQ;EACE,0CAAA;APs/FV;;AO5/FM;EACE,oCAAA;AP+/FR;;AO7/FM;EACE,yBAAA;APggGR;AO//FQ;EACE,gCAAA;APigGV;;AOvgGM;EACE,oDAAA;AP0gGR;;AOxgGM;EACE,yCAAA;AP2gGR;AO1gGQ;EACE,gDAAA;AP4gGV;;AOlhGM;EACE,oCAAA;APqhGR;;AOnhGM;EACE,yBAAA;APshGR;AOrhGQ;EACE,gCAAA;APuhGV;;AO7hGM;EACE,qDAAA;APgiGR;;AO9hGM;EACE,0CAAA;APiiGR;AOhiGQ;EACE,iDAAA;APkiGV;;AOxiGM;EACE,qDAAA;AP2iGR;;AOziGM;EACE,0CAAA;AP4iGR;AO3iGQ;EACE,iDAAA;AP6iGV;;AOnjGM;EACE,oDAAA;APsjGR;;AOpjGM;EACE,yCAAA;APujGR;AOtjGQ;EACE,gDAAA;APwjGV;;AO9jGM;EACE,oDAAA;APikGR;;AO/jGM;EACE,yCAAA;APkkGR;AOjkGQ;EACE,gDAAA;APmkGV;;AOzkGM;EACE,oCAAA;AP4kGR;;AO1kGM;EACE,yBAAA;AP6kGR;AO5kGQ;EACE,gCAAA;AP8kGV;;AOplGM;EACE,oCAAA;APulGR;;AOrlGM;EACE,yBAAA;APwlGR;AOvlGQ;EACE,gCAAA;APylGV;;AO/lGM;EACE,4CAAA;APkmGR;;AOhmGM;EACE,iCAAA;APmmGR;AOlmGQ;EACE,wCAAA;APomGV;;AO1mGM;EACE,kDAAA;AP6mGR;;AO3mGM;EACE,uCAAA;AP8mGR;AO7mGQ;EACE,8CAAA;AP+mGV;;AOrnGM;EACE,kDAAA;APwnGR;;AOtnGM;EACE,uCAAA;APynGR;AOxnGQ;EACE,8CAAA;AP0nGV;;AOhoGM;EACE,gDAAA;APmoGR;;AOjoGM;EACE,qCAAA;APooGR;AOnoGQ;EACE,4CAAA;APqoGV;;AO3oGM;EACE,+CAAA;AP8oGR;;AO5oGM;EACE,oCAAA;AP+oGR;AO9oGQ;EACE,2CAAA;APgpGV;;AOtpGM;EACE,gDAAA;APypGR;;AOvpGM;EACE,qCAAA;AP0pGR;AOzpGQ;EACE,4CAAA;AP2pGV;;AOjqGM;EACE,oCAAA;APoqGR;;AOlqGM;EACE,yBAAA;APqqGR;AOpqGQ;EACE,gCAAA;APsqGV;;AO5qGM;EACE,mDAAA;AP+qGR;;AO7qGM;EACE,wCAAA;APgrGR;AO/qGQ;EACE,+CAAA;APirGV;;AOxqGE;EACE,oCAAA;AP2qGJ;;AOzqGE;EACE,yBAAA;AP4qGJ;AO3qGI;EACE,gCAAA;AP6qGN;;AOnrGE;EACE,oCAAA;APsrGJ;;AOprGE;EACE,yBAAA;APurGJ;AOtrGI;EACE,gCAAA;APwrGN;;AO9rGE;EACE,wCAAA;APisGJ;;AO/rGE;EACE,6BAAA;APksGJ;AOjsGI;EACE,oCAAA;APmsGN;;AQlnHA,mBAAA;AAEA;EACE;IACE,kCAAA;IACA,UAAA;IACA,yDAAA;ERonHF;EQlnHA;IACE,kCAAA;IACA,wDAAA;ERonHF;EQlnHA;IACE,UAAA;IACA,wDAAA;ERonHF;EQlnHA;IACE,wDAAA;ERonHF;EQlnHA;IACE,gCAAA;ERonHF;AACF;AQjnHA;EACE;IACE,kCAAA;IACA,UAAA;IACA,yDAAA;ERmnHF;EQjnHA;IACE,kCAAA;IACA,wDAAA;ERmnHF;EQjnHA;IACE,UAAA;IACA,wDAAA;ERmnHF;EQjnHA;IACE,wDAAA;ERmnHF;EQjnHA;IACE,gCAAA;ERmnHF;AACF;AQhnHA;EACE,0BAAA;EACA,4BAAA;ARknHF;;AQ/mHA;EACE;IACE,oBAAA;IACA,8BAAA;ERknHF;EQhnHA;IACE,UAAA;IACA,oBAAA;IACA,8BAAA;ERknHF;AACF;AQ/mHA;EACE;IACE,oBAAA;IACA,8BAAA;ERinHF;EQ/mHA;IACE,UAAA;IACA,oBAAA;IACA,8BAAA;ERinHF;AACF;AQ9mHA;EACE,2BAAA;EACA,4BAAA;ARgnHF;;AQ7mHA;EACE;IACE,UAAA;IACA,qCAAA;ERgnHF;EQ9mHA;IACE,UAAA;IACA,eAAA;ERgnHF;AACF;AQ7mHA;EACE;IACE,UAAA;IACA,qCAAA;ER+mHF;EQ7mHA;IACE,UAAA;IACA,eAAA;ER+mHF;AACF;AQ5mHA;EACE,+BAAA;AR8mHF;;AQ3mHA;EACE;IACE,UAAA;IACA,sCAAA;ER8mHF;EQ5mHA;IACE,UAAA;IACA,eAAA;ER8mHF;AACF;AQ3mHA;EACE;IACE,UAAA;IACA,sCAAA;ER6mHF;EQ3mHA;IACE,UAAA;IACA,eAAA;ER6mHF;AACF;AQ1mHA;EACE,8BAAA;AR4mHF;;AQzmHA;EACE;IACE,qCAAA;ER4mHF;EQ1mHA;IACE,eAAA;ER4mHF;AACF;AQzmHA;EACE;IACE,qCAAA;ER2mHF;EQzmHA;IACE,eAAA;ER2mHF;AACF;AQxmHA;EACE,gCAAA;AR0mHF;;AQvmHA;EACE;IACE,sCAAA;ER0mHF;EQxmHA;IACE,eAAA;ER0mHF;AACF;AQvmHA;EACE;IACE,sCAAA;ERymHF;EQvmHA;IACE,eAAA;ERymHF;AACF;AQtmHA;EACE,+BAAA;ARwmHF;;AQrmHA;EACE;IACE,oCAAA;ERwmHF;EQtmHA;IACE,eAAA;ERwmHF;AACF;AQrmHA;EACE;IACE,oCAAA;ERumHF;EQrmHA;IACE,eAAA;ERumHF;AACF;AQpmHA;EACE,6BAAA;ARsmHF;;AQnmHA,sBAAA;AACA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,sBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,sBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,sBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,wBAAA;ARsmHF;;AQnmHA;EACE,sBAAA;ARsmHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,mBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,mBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,mBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,mBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,qBAAA;ARomHF;;AQjmHA;EACE,mBAAA;ARomHF;;AS1nHE,eAAA;AAYF;EACE,yBAAA;EAEA,sBAAA;EACA,6BAAA;EACA,0BAAA;EACA,+DAAA;EACA,yBAAA;EACA,2BAAA;EACA,gDAAA;EACA,mCAAA;EACA,yCAAA;EAEA,kCAAA;ATgnHF;;AUnmIE,eAAA;AA/BI;EAhBF,kDAAA;EAEF,uBAAA;AVspIF;;AUxoIM;EAhBF,kDAAA;EAEF,uBAAA;AV2pIF;;AU7oIM;EAhBF,kDAAA;EAEF,uBAAA;AVgqIF;;AUlpIM;EAhBF,kDAAA;EAEF,uBAAA;AVqqIF;;AUvpIM;EAhBF,gDAAA;EAEF,uBAAA;AV0qIF;;AU5pIM;EAhBF,gDAAA;EAEF,uBAAA;AV+qIF;;AUjqIM;EAhBF,gDAAA;EAEF,uBAAA;AVorIF;;AUtqIM;EAhBF,gDAAA;EAEF,uBAAA;AVyrIF;;AU3qIM;EAhBF,gDAAA;EAEF,uBAAA;AV8rIF;;AUhrIM;EAhBF,gDAAA;EAEF,uBAAA;AVmsIF;;AUrrIM;EAhBF,gDAAA;EAEF,uBAAA;AVwsIF;;AU1rIM;EAhBF,gDAAA;EAEF,uBAAA;AV6sIF;;AU/rIM;EAhBF,gDAAA;EAEF,uBAAA;AVktIF;;AUpsIM;EAhBF,gDAAA;EAEF,uBAAA;AVutIF;;AUzsIM;EAhBF,gDAAA;EAEF,uBAAA;AV4tIF;;AU9sIM;EAhBF,gDAAA;EAEF,uBAAA;AViuIF;;AUntIM;EAhBF,gDAAA;EAEF,uBAAA;AVsuIF;;AUxtIM;EAhBF,gDAAA;EAEF,uBAAA;AV2uIF;;AU7tIM;EAhBF,gDAAA;EAEF,uBAAA;AVgvIF;;AUluIM;EAhBF,gDAAA;EAEF,uBAAA;AVqvIF;;AUvuIM;EAhBF,gDAAA;EAEF,uBAAA;AV0vIF;;AU5uIM;EAhBF,gDAAA;EAEF,uBAAA;AV+vIF;;AUjvIM;EAhBF,gDAAA;EAEF,uBAAA;AVowIF;;AUtvIM;EAhBF,gDAAA;EAEF,uBAAA;AVywIF;;AU3vIM;EAhBF,gDAAA;EAEF,uBAAA;AV8wIF;;AUhwIM;EAhBF,gDAAA;EAEF,uBAAA;AVmxIF;;AUrwIM;EAhBF,gDAAA;EAEF,uBAAA;AVwxIF;;AU1wIM;EAhBF,gDAAA;EAEF,uBAAA;AV6xIF;;AU/wIM;EAhBF,gDAAA;AVmyIJ;;AUnxIM;EAhBF,gDAAA;AVuyIJ;;AUvxIM;EAhBF,gDAAA;AV2yIJ;;AU3xIM;EAhBF,gDAAA;AV+yIJ;;AU/xIM;EAhBF,gDAAA;EAEF,wBAAA;AVkzIF;;AUpyIM;EAhBF,gDAAA;EAEF,wBAAA;AVuzIF;;AUzyIM;EAhBF,gDAAA;EAEF,wBAAA;AV4zIF;;AU9yIM;EAhBF,gDAAA;EAEF,wBAAA;AVi0IF;;AUnzIM;EAhBF,gDAAA;EAEF,wBAAA;AVs0IF;;AUxzIM;EAhBF,gDAAA;EAEF,wBAAA;AV20IF;;AU7zIM;EAhBF,gDAAA;EAEF,wBAAA;AVg1IF;;AUl0IM;EAhBF,gDAAA;EAEF,wBAAA;AVq1IF;;AUv0IM;EAhBF,gDAAA;AV21IJ;;AU30IM;EAhBF,gDAAA;AV+1IJ;;AU/0IM;EAhBF,gDAAA;AVm2IJ;;AUn1IM;EAhBF,gDAAA;AVu2IJ;;AUv1IM;EAhBF,gDAAA;AV22IJ;;AU31IM;EAhBF,gDAAA;AV+2IJ;;AU/1IM;EAhBF,gDAAA;AVm3IJ;;AUn2IM;EAhBF,gDAAA;AVu3IJ;;AUv2IM;EAhBF,gDAAA;AV23IJ;;AU32IM;EAhBF,gDAAA;AV+3IJ;;AU/2IM;EAhBF,gDAAA;AVm4IJ;;AUn3IM;EAhBF,gDAAA;AVu4IJ;;AUv3IM;EAhBF,gDAAA;AV24IJ;;AU33IM;EAhBF,gDAAA;AV+4IJ;;AU/3IM;EAhBF,gDAAA;AVm5IJ;;AUn4IM;EAhBF,gDAAA;AVu5IJ;;AUv4IM;EAhBF,gDAAA;EAEF,uBAAA;AV05IF;;AU54IM;EAhBF,gDAAA;EAEF,uBAAA;AV+5IF;;AUj5IM;EAhBF,gDAAA;EAEF,uBAAA;AVo6IF;;AUt5IM;EAhBF,gDAAA;EAEF,uBAAA;AVy6IF;;AU35IM;EAhBF,gDAAA;AV+6IJ;;AU/5IM;EAhBF,gDAAA;AVm7IJ;;AUn6IM;EAhBF,gDAAA;AVu7IJ;;AUv6IM;EAhBF,gDAAA;AV27IJ;;AU36IM;EAhBF,gDAAA;EAEF,uBAAA;AV87IF;;AUh7IM;EAhBF,gDAAA;EAEF,uBAAA;AVm8IF;;AUr7IM;EAhBF,gDAAA;EAEF,uBAAA;AVw8IF;;AU17IM;EAhBF,gDAAA;EAEF,uBAAA;AV68IF;;AU/7IM;EAhBF,gDAAA;EAEF,uBAAA;AVk9IF;;AUp8IM;EAhBF,gDAAA;EAEF,uBAAA;AVu9IF;;AUz8IM;EAhBF,gDAAA;EAEF,uBAAA;AV49IF;;AU98IM;EAhBF,gDAAA;EAEF,uBAAA;AVi+IF;;AUn9IM;EAhBF,gDAAA;EAEF,uBAAA;AVs+IF;;AUx9IM;EAhBF,gDAAA;EAEF,uBAAA;AV2+IF;;AU79IM;EAhBF,gDAAA;EAEF,uBAAA;AVg/IF;;AUl+IM;EAhBF,gDAAA;EAEF,uBAAA;AVq/IF;;AUv+IM;EAhBF,gDAAA;EAEF,uBAAA;AV0/IF;;AU5+IM;EAhBF,gDAAA;EAEF,uBAAA;AV+/IF;;AUj/IM;EAhBF,gDAAA;EAEF,uBAAA;AVogJF;;AUt/IM;EAhBF,gDAAA;EAEF,uBAAA;AVygJF;;AUn9IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8EAAA;EAEA,mHAAA;AVq9IF;AUl9IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8EAAA;EAEA,yKAAA;AVm9IF;AUh9IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qFAAA;EAEA,mHAAA;AVi9IF;AU98IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qFAAA;EAEA,yKAAA;AV+8IF;AU58IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uFAAA;EAEA,mHAAA;AV68IF;AU18IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uFAAA;EAEA,yKAAA;AV28IF;AUx8IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mFAAA;EAEA,mHAAA;AVy8IF;AUt8IA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mFAAA;EAEA,yKAAA;AVu8IF;AUn8IA,2BAAA;AACA,cAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gJAAA;AVq8IF;AUn8IA,UAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4DAAA;EACA,iMAAA;AVq8IF;AUl8IA,0BAAA;AACA,cAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gJAAA;AVo8IF;AUl8IA,UAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;EACA,iMAAA;AVo8IF;AUj8IA,4BAAA;AACA,cAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gJAAA;AVm8IF;AUj8IA,UAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;EACA,iMAAA;AVm8IF;AUh8IA,wBAAA;AACA,cAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gJAAA;AVk8IF;AUh8IA,UAAA;AACA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;EACA,iMAAA;AVk8IF;AU/7IA;EACE,2CAAA;EACA,wBAAA;EAnOE,gDAAA;AVqqJJ;;AU/7IA;EACE,iFAAA;AVk8IF;;AWrrJA;EACE,4BAAA;EACA,0EAAA;EACA,yBAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8CAAA;EACA,qFAAA;EACA,qCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AXwrJF;AWtrJE;EACE,qBAAA;EACA,6BAAA;EDPA,gDAAA;EAEF,uBAAA;ECOE,YAAA;EACA,YAAA;EACA,UAAA;EACA,wFAAA;EACA,iDAAA;EACA,eAAA;AXyrJJ;AWvrJI;EACE,wBAAA;EDjBF,gDAAA;EAEF,uBAAA;AV0sJF;AWxrJI;EACE,aAAA;AX0rJN;AWxrJI;EACE,oCAAA;EACA,qDAAA;AX0rJN;AWvrJE;EACE,uEAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AXyrJJ;AWvrJE;EACE,iCAAA;EACA,YAAA;EACA,wCAAA;EACA,yCAAA;EACA,gDAAA;AXyrJJ;AWvrJI;EACE,+GAAA;EACA,0GAAA;AXyrJN;AWprJE;EACE,uBAAA;EACA,8BAAA;AXsrJJ;AWprJI;;;;EDrDA,gDAAA;EAEF,uBAAA;AV8uJF;AWprJM;ED5DF,gDAAA;EAEF,uBAAA;AVkvJF;AWprJI;EDhEA,gDAAA;EAEF,uBAAA;AVsvJF;AWnrJE;EACE,uBAAA;EACA,8BAAA;AXqrJJ;AWnrJI;;;;EDzEA,gDAAA;EAEF,uBAAA;AViwJF;AWnrJM;EDhFF,gDAAA;EAEF,uBAAA;AVqwJF;AWnrJI;EDpFA,gDAAA;EAEF,uBAAA;AVywJF;AWlrJE;EACE,uBAAA;EACA,8BAAA;AXorJJ;AWlrJI;;;;ED7FA,gDAAA;EAEF,uBAAA;AVoxJF;AWlrJM;EDpGF,gDAAA;EAEF,uBAAA;AVwxJF;AWlrJI;EDxGA,gDAAA;EAEF,uBAAA;AV4xJF;AWjrJE;EACE,oBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,8BAAA;AXmrJJ;AWjrJI;EDpHA,gDAAA;EAEF,uBAAA;AVuyJF;AWjrJM;EDxHF,gDAAA;EAEF,uBAAA;AV2yJF;AWhrJI;EACE,uBAAA;EACA,8BAAA;AXkrJN;AWhrJM;;;;EDjIF,gDAAA;EAEF,uBAAA;AVszJF;AWhrJQ;EDxIJ,gDAAA;EAEF,uBAAA;AV0zJF;AWhrJM;ED5IF,gDAAA;EAEF,uBAAA;AV8zJF;AW/qJI;EACE,uBAAA;EACA,8BAAA;AXirJN;AW/qJM;;;;EDrJF,gDAAA;EAEF,uBAAA;AVy0JF;AW/qJQ;ED5JJ,gDAAA;EAEF,uBAAA;AV60JF;AW/qJM;EDhKF,gDAAA;EAEF,uBAAA;AVi1JF;AW9qJI;EACE,uBAAA;EACA,8BAAA;AXgrJN;AW9qJM;;;;EDzKF,gDAAA;EAEF,uBAAA;AV41JF;AW9qJQ;EDhLJ,gDAAA;EAEF,uBAAA;AVg2JF;AW9qJM;EDpLF,gDAAA;EAEF,uBAAA;AVo2JF;AW5qJE;EACE,oBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,8BAAA;AX8qJJ;AW5qJI;;;;EDjMA,gDAAA;EAEF,uBAAA;AVk3JF;AW5qJM;EDxMF,gDAAA;EAEF,uBAAA;AVs3JF;AW5qJI;ED5MA,gDAAA;EAEF,uBAAA;AV03JF;AW5qJI;EACE,uBAAA;EACA,8BAAA;AX8qJN;AW5qJM;;;;EDpNF,gDAAA;EAEF,uBAAA;AVq4JF;AW5qJQ;ED3NJ,gDAAA;EAEF,uBAAA;AVy4JF;AW5qJM;ED/NF,gDAAA;EAEF,uBAAA;AV64JF;AW3qJI;EACE,uBAAA;EACA,8BAAA;AX6qJN;AW3qJM;;;;EDxOF,gDAAA;EAEF,uBAAA;AVw5JF;AW3qJQ;ED/OJ,gDAAA;EAEF,uBAAA;AV45JF;AW3qJM;EDnPF,gDAAA;EAEF,uBAAA;AVg6JF;AW1qJI;EACE,uBAAA;EACA,8BAAA;AX4qJN;AW1qJM;;;;ED5PF,gDAAA;EAEF,uBAAA;AV26JF;AW1qJQ;EDnQJ,gDAAA;EAEF,uBAAA;AV+6JF;AW1qJM;EDvQF,gDAAA;EAEF,uBAAA;AVm7JF;AWxqJE;EACE,oBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,8BAAA;AX0qJJ;AWxqJI;;;;EDpRA,gDAAA;EAEF,uBAAA;AVi8JF;AWxqJM;ED3RF,gDAAA;EAEF,uBAAA;AVq8JF;AWxqJI;ED/RA,gDAAA;EAEF,uBAAA;AVy8JF;AWxqJI;EACE,uBAAA;EACA,8BAAA;AX0qJN;AWxqJM;;;;EDvSF,gDAAA;EAEF,uBAAA;AVo9JF;AWxqJQ;ED9SJ,gDAAA;EAEF,uBAAA;AVw9JF;AWxqJM;EDlTF,gDAAA;EAEF,uBAAA;AV49JF;AWvqJI;EACE,uBAAA;EACA,8BAAA;AXyqJN;AWvqJM;;;;ED3TF,gDAAA;EAEF,uBAAA;AVu+JF;AWvqJQ;EDlUJ,gDAAA;EAEF,uBAAA;AV2+JF;AWvqJM;EDtUF,gDAAA;EAEF,uBAAA;AV++JF;AWtqJI;EACE,uBAAA;EACA,8BAAA;AXwqJN;AWtqJM;;;;ED/UF,gDAAA;AV2/JJ;AWrqJQ;EDtVJ,gDAAA;AV8/JJ;AWpqJM;ED1VF,gDAAA;AVigKJ;AWjqJE;EACE,sCAAA;AXmqJJ;AWjqJE;EACE,wCAAA;AXmqJJ;AWhqJE;EACE,wCAAA;EACA,gDAAA;AXkqJJ;AWhqJE;EACE,wCAAA;EACA,oCAAA;AXkqJJ;AWhqJI;EACE,yBAAA;AXkqJN;AW9pJI;EACE,sCAAA;AXgqJN;AW9pJI;EACE,cAAA;EACA,uBAAA;EDzXF,gDAAA;EAEF,uBAAA;AVyhKF;AW7pJE;EACE,yBAAA;AX+pJJ;AW3pJE;EACE,+BAAA;EACA,eAAA;EACA,0DAAA;AX6pJJ;AW3pJI;EACE,gBAAA;EACA,6BAAA;EACA,wHAAA;EACA,yFAAA;EACA,mHAAA;EACA,6BAAA;EACA,qEAAA;EACA,6BAAA;EACA,6BAAA;EACA,UAAA;AX6pJN;AW3pJM;EACE,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;AX6pJR;AW1pJI;EACE,qEAAA;EACA,0DAAA;EACA,UAAA;AX4pJN;AW1pJM;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,yFAAA;EACA,sBAAA;AX4pJR;AW1pJM;EACE,qEAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;AX4pJR;AW1pJM;;EAEE,YAAA;EACA,YAAA;EACA,qEAAA;AX4pJR;AW1pJM;EACE,eAAA;EACA,YAAA;AX4pJR;AW1pJM;EACE,aAAA;AX4pJR;AW1pJM;EACE,mGAAA;EACA,YAAA;AX4pJR;AW1pJM;EACE,QAAA;EACA,yBAAA;AX4pJR;AW1pJQ;EACE,YAAA;EACA,SAAA;EACA,UAAA;AX4pJV;AW1pJQ;EACE,kBAAA;AX4pJV;AW1pJU;EACE,YAAA;EACA,oCAAA;AX4pJZ;AW1pJU;EACE,kBAAA;AX4pJZ;AWzpJQ;EACE,aAAA;EACA,QAAA;AX2pJV;AWzpJU;EACE,oCAAA;EACA,qBAAA;EACA,eAAA;AX2pJZ;AWvpJM;EACE,kFAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AXypJR;AWvpJQ;EACE,UAAA;AXypJV;AWtpJM;EACE,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,qBAAA;EACA,sBAAA;AXwpJR;AWrpJQ;EACE,kBAAA;EACA,+CAAA;AXupJV;AWrpJU;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,oDAAA;EACA,SAAA;EACA,oCAAA;AXupJZ;AWrpJU;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,oDAAA;EACA,oBAAA;EACA,6BAAA;EACA,mCAAA;EACA,gCAAA;EACA,6BAAA;EACA,wBAAA;AXupJZ;AWppJY;EACE,UAAA;EACA,yBAAA;AXspJd;AWlpJY;EACE,uBAAA;AXopJd;AWhpJgB;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;AXkpJlB;AW5oJY;EACE,wCAAA;AX8oJd;AWxoJY;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qCAAA;EACA,UAAA;AX0oJd;AWvoJU;EACE,kBAAA;EACA,yBAAA;AXyoJZ;AWtoJc;EACE,wBAAA;AXwoJhB;AWloJc;EACE,wBAAA;AXooJhB;AW9nJM;;EAEE,oCAAA;AXgoJR;AW9nJM;EDllBF,gDAAA;EAEF,uBAAA;AVktKF;AW/nJM;EACE,aAAA;EACA,mBAAA;EACA,8FAAA;AXioJR;AW9nJI;EACE,YAAA;EACA,+BAAA;AXgoJN;AW7nJQ;EACE,YAAA;AX+nJV;AW7nJQ;EACE,wCAAA;EACA,QAAA;AX+nJV;AW7nJQ;EACE,oCAAA;AX+nJV;AW3nJI;EACE,sCAAA;AX6nJN;AWxnJE;EACE,kBAAA;EACA,2BAAA;EACA,0BAAA;EACA,gBAAA;AX0nJJ;AWxnJI;EACE,iBAAA;AX0nJN;AWxnJM;EACE,YAAA;EACA,kBAAA;EACA,wFAAA;AX0nJR;AWxnJM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;AX0nJR;AWxnJQ;EACE,mBAAA;AX0nJV;AWxnJQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AX0nJV;AWxnJU;EACE,oCAAA;AX0nJZ;AWpnJU;EACE,aAAA;AXsnJZ;AWjnJI;EACE,SAAA;EACA,+CAAA;EACA,YAAA;EACA,yCAAA;AXmnJN;AWjnJM;EACE,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,SAAA;AXmnJR;AWjnJQ;EACE,aAAA;AXmnJV;AWjnJU;EACE,+CAAA;AXmnJZ;AWjnJU;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AXmnJZ;AWjnJY;EACE,oCAAA;EACA,0BAAA;AXmnJd;AW9mJM;EACE,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AXgnJR;AW9mJM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;AXgnJR;AW9mJQ;EACE,oCAAA;EACA,0BAAA;EACA,gBAAA;AXgnJV;AW9mJU;EACE,aAAA;AXgnJZ;AW7mJQ;EACE,qCAAA;EACA,wBAAA;AX+mJV;AW7mJQ;EACE,gBAAA;EACA,yBAAA;AX+mJV;AW7mJQ;EACE,0BAAA;EACA,oCAAA;EACA,qBAAA;AX+mJV;AW7mJU;EACE,gBAAA;AX+mJZ;AW7mJU;EACE,0BAAA;AX+mJZ;AW3mJM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;AX6mJR;AW3mJQ;EACE,oCAAA;AX6mJV;AW1mJM;EACE,mBAAA;AX4mJR;AW1mJM;EACE,WAAA;EACA,YAAA;AX4mJR;AW1mJQ;EACE,YAAA;AX4mJV;AWxmJI;EACE,yBAAA;EACA,kBAAA;AX0mJN;AWxmJM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;AX0mJR;AWxmJM;EACE,oCAAA;EACA,0BAAA;AX0mJR;AWvmJI;EACE,WAAA;EACA,aAAA;AXymJN;AWvmJI;EACE,OAAA;EACA,eAAA;AXymJN;AWvmJM;EACE,YAAA;EACA,kBAAA;AXymJR;AWvmJQ;EACE,oCAAA;EACA,0BAAA;AXymJV;AWtmJM;EACE,YAAA;EACA,qBAAA;AXwmJR;AWrmJI;EACE,qBAAA;AXumJN;AWrmJI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AXumJN;AWrmJM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AXumJR;AWrmJQ;EACE,oCAAA;AXumJV;AWnmJI;EACE,aAAA;AXqmJN;AWnmJI;EACE,QAAA;AXqmJN;AWnmJM;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;AXqmJR;AWnmJQ;EACE,wBAAA;AXqmJV;AWhmJM;EACE,yBAAA;AXkmJR;AW5lJE;EACE,eAAA;EACA,iDAAA;EACA,qBAAA;EACA,sBAAA;AX8lJJ;AW5lJE;EACE,oBAAA;EACA,8BAAA;AX8lJJ;AW5lJI;EACE,6BAAA;AX8lJN;AW5lJM;EACE,YAAA;EACA,qBAAA;EACA,eAAA;AX8lJR;AWxlJE;EACE,oBAAA;AX0lJJ;AWtlJE;EACE,kBAAA;AXwlJJ;AWtlJI;EACE,SAAA;EACA,WAAA;AXwlJN;AWtlJI;EACE,UAAA;EACA,oCAAA;EACA,kFAAA;AXwlJN;AWtlJI;EDl4BA,gDAAA;EAEF,uBAAA;ECk4BI,iBAAA;EACA,qBAAA;AXylJN;AWvlJM;EACE,oCAAA;AXylJR;AWnlJE;EACE,cAAA;AXqlJJ;AWnlJE;EDj5BE,gDAAA;EAEF,uBAAA;ECi5BE,qBAAA;EACA,YAAA;EACA,oCAAA;AXslJJ;AWplJE;EACE,iBAAA;EACA,YAAA;AXslJJ;AWllJE;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,QAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;AXolJJ;AWllJI;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;AXolJN;AWllJM;EACE,aAAA;AXolJR;AWjlJI;EACE,sBAAA;AXmlJN;AWhlJE;EACE,QAAA;AXklJJ;AW7kJE;EACE,YAAA;EACA,sCAAA;EACA,qEAAA;AX+kJJ;AW7kJI;EACE,6BAAA;AX+kJN;AW5kJE;EACE,6FAAA;EACA,+CAAA;EACA,6BAAA;AX8kJJ;AW5kJI;EACE,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,sDAAA;AX8kJN;AW3kJE;EACE,YAAA;EACA,+BAAA;AX6kJJ;AW3kJI;EACE,qEAAA;AX6kJN;AW1kJE;EACE,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;AX4kJJ;AW1kJI;EACE,YAAA;EACA,SAAA;AX4kJN;AW1kJI;EACE,gBAAA;AX4kJN;AW1kJI;EACE,yBAAA;EACA,uBAAA;AX4kJN;AW1kJI;EACE,uBAAA;AX4kJN;AWzkJE;EACE,YAAA;EACA,0BAAA;EACA,6BAAA;EACA,QAAA;EACA,4CAAA;EACA,8BAAA;AX2kJJ;AWzkJI;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,qBAAA;ED3/BF,gDAAA;EAEF,uBAAA;EC2/BI,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,SAAA;EACA,QAAA;AX4kJN;AW1kJI;EACE,qBAAA;AX4kJN;AW1kJI;EACE,iBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AX4kJN;AW1kJM;EACE,+CAAA;AX4kJR;AWzkJI;EACE,gBAAA;EACA,gBAAA;AX2kJN;AWzkJM;EACE,gBAAA;AX2kJR;AWtkJI;EACE,aAAA;AXwkJN;AWrkJE;EACE,UAAA;EACA,4CAAA;AXukJJ;AWrkJI;EACE,iCAAA;EF1hBJ,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EEshBI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AX6kJN;AW3kJI;EACE,gCAAA;AX6kJN;AW1kJE;EACE,wBAAA;AX4kJJ;AWxkJE;EACE,YAAA;EACA,YAAA;EACA,WAAA;AX0kJJ;AWxkJE;EACE,YAAA;AX0kJJ;AWtkJE;EACE,kBAAA;EACA,eAAA;AXwkJJ;AWtkJI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,8CAAA;AXukJN;AWrkJI;EACE,QAAA;EACA,mCAAA;AXukJN;AWrkJI;EACE,UAAA;EACA,oCAAA;AXukJN;AWjkJI;EACE,wBAAA;AXmkJN;AWjkJM;EACE,eAAA;AXmkJR;AWjkJQ;EACE,6DAAA;AXmkJV;AWhkJU;EACE,uEAAA;AXkkJZ;AWhkJU;EACE,6DAAA;AXkkJZ;AW9jJM;EACE,4DAAA;AXgkJR;;AW3jJA;EDlnCI,gDAAA;EAEF,uBAAA;ECknCA,qBAAA;EACA,aAAA;EACA,iFAAA;EACA,QAAA;AX+jJF;AW7jJE;EACE,oBAAA;AX+jJJ;AW7jJE;EACE,kBAAA;AX+jJJ;AW5jJI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;AX8jJN;;AW1jJA;EACE,gBAAA;AX6jJF;;AW3jJA;EACE,kBAAA;AX8jJF;;AW3jJA;EACE,mCAAA;EACA,kCAAA;EACA,8EAAA;EACA,kDAAA;EDtpCE,gDAAA;EAEF,uBAAA;ECspCA,kCAAA;EACA,YAAA;EACA,+CAAA;EACA,kDAAA;EACA,gBAAA;EACA,oBAAA;EACA,iDAAA;EACA,SAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;AX+jJF;AW7jJE;EACE,wEAAA;EACA,uBAAA;AX+jJJ;AW7jJE;EACE,sCAAA;AX+jJJ;AW7jJE;EACE,2GAAA;AX+jJJ;AW7jJE;EACE,sCAAA;EACA,0GAAA;AX+jJJ;AW7jJE;EACE,qCAAA;EACA,oBAAA;EACA,iBAAA;AX+jJJ;AW7jJE;EACE,8BAAA;EACA,yDAAA;EACA,8GAAA;AX+jJJ;AW7jJI;EACE,qCAAA;AX+jJN;AW7jJI;EACE,qCAAA;AX+jJN;AW7jJI;EACE,yCAAA;EACA,uCAAA;AX+jJN;AW7jJI;EACE,uCAAA;EACA,yCAAA;AX+jJN;AW7jJM;EACE,qCAAA;AX+jJR;AW7jJM;EACE,mCAAA;EACA,yCAAA;AX+jJR;AW7jJM;EACE,8BAAA;EACA,mCAAA;AX+jJR;AW7jJM;EACE,yCAAA;EACA,uCAAA;AX+jJR;AW5jJI;EACE,qCAAA;EACA,uCAAA;AX8jJN;AW5jJM;EACE,mCAAA;AX8jJR;AW3jJI;EACE,8BAAA;EACA,mCAAA;EACA,yCAAA;AX6jJN;AW1jJE;EACE,8BAAA;EACA,yDAAA;AX4jJJ;AW1jJI;EACE,qCAAA;AX4jJN;AW1jJI;EACE,8BAAA;EACA,wCAAA;AX4jJN;AW1jJI;EACE,8BAAA;EACA,uCAAA;AX4jJN;AW1jJI;EACE,uCAAA;AX4jJN;AW1jJM;EACE,qCAAA;AX4jJR;AW1jJM;EACE,mCAAA;AX4jJR;AW1jJM;EACE,mCAAA;AX4jJR;AW1jJM;EACE,uCAAA;AX4jJR;AWzjJI;EACE,qCAAA;AX2jJN;AWzjJM;EACE,mCAAA;AX2jJR;AWvjJE;EACE,4BAAA;EACA,yDAAA;EACA,8BAAA;EACA,qBAAA;AXyjJJ;AWvjJI;EACE,wCAAA;EACA,8BAAA;AXyjJN;AWvjJI;EACE,yDAAA;EACA,4BAAA;AXyjJN;AWvjJI;EACE,4BAAA;EACA,8BAAA;EACA,wCAAA;AXyjJN;AWvjJI;EACE,8BAAA;EACA,uCAAA;AXyjJN;AWvjJI;EACE,4BAAA;EACA,qBAAA;AXyjJN;AWvjJI;EACE,uCAAA;AXyjJN;AWvjJM;EACE,8BAAA;EACA,uCAAA;AXyjJR;AWvjJM;EACE,uCAAA;EACA,4BAAA;AXyjJR;AWvjJM;EACE,uCAAA;EACA,4BAAA;AXyjJR;AWvjJM;EACE,uCAAA;AXyjJR;AWrjJE;EACE,wCAAA;EACA,YAAA;EACA,+CAAA;EACA,gDAAA;AXujJJ;AWrjJE;EACE,WAAA;AXujJJ;AWrjJE;EACE,0BAAA;EACA,0BAAA;AXujJJ;AWnjJE;EACE,qBAAA;EACA,2BAAA;EACA,6BAAA;AXqjJJ;AWnjJI;EACE,wBAAA;AXqjJN;AWnjJI;EACE,6BAAA;AXqjJN;AWnjJI;EACE,6BAAA;AXqjJN;AWnjJI;EACE,6BAAA;AXqjJN;AWnjJI;EACE,8BAAA;AXqjJN;AWljJE;EACE,qBAAA;EACA,2BAAA;EACA,6BAAA;AXojJJ;AWljJI;EACE,wBAAA;AXojJN;AWljJI;EACE,6BAAA;AXojJN;AWljJI;EACE,6BAAA;AXojJN;AWljJI;EACE,6BAAA;AXojJN;AWljJI;EACE,+BAAA;AXojJN;AWjjJE;EACE,qBAAA;EACA,2BAAA;EACA,6BAAA;ED13CA,gDAAA;EAEF,uBAAA;AV66LF;AWljJI;EACE,wBAAA;AXojJN;AWljJI;EACE,6BAAA;AXojJN;AWljJI;EACE,6BAAA;AXojJN;AWljJI;EACE,6BAAA;AXojJN;AWljJI;EACE,+BAAA;AXojJN;AWjjJE;EACE,qBAAA;EACA,2BAAA;EACA,6BAAA;EDh5CA,gDAAA;AVo8LJ;AWjjJI;EACE,wBAAA;AXmjJN;AWjjJI;EACE,6BAAA;AXmjJN;AWjjJI;EACE,6BAAA;AXmjJN;AWjjJI;EACE,6BAAA;AXmjJN;AWjjJI;EACE,+BAAA;AXmjJN;AW7iJI;EACE,wBAAA;AX+iJN;AW3iJI;EACE,wBAAA;AX6iJN;AWziJI;EACE,wBAAA;AX2iJN;AWviJI;EACE,wBAAA;AXyiJN;AWpiJE;EACE,qCAAA;AXsiJJ;AWpiJI;EACE,mCAAA;AXsiJN;AWpiJI;EACE,uCAAA;AXsiJN;AWniJE;EACE,qCAAA;AXqiJJ;AWniJE;EACE,qCAAA;AXqiJJ;AWliJE;EACE,0BAAA;EACA,+BAAA;EACA,uBAAA;AXoiJJ;AWliJE;EACE,iCAAA;AXoiJJ;AWliJI;EACE,YAAA;AXoiJN;AWliJI;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AXoiJN;AW/hJE;EACE,+BAAA;EACA,2BAAA;EACA,6DAAA;EACA,0DAAA;AXiiJJ;;AW9hJA;EACE,oCAAA;EACA,kBAAA;AXiiJF;AW/hJE;EACE,uCAAA;AXiiJJ;AW/hJI;EACE,uCAAA;EACA,qCAAA;AXiiJN;AW/hJI;EACE,4BAAA;EACA,+BAAA;AXiiJN;AW/hJI;EACE,2BAAA;EACA,8BAAA;AXiiJN;AW/hJI;EACE,kBAAA;AXiiJN;;AW3hJE;EACE,oFAAA;AX8hJJ;;AW3hJA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;AX8hJF;AW5hJE;EACE,gBAAA;EACA,iBAAA;ED/gDA,gDAAA;EAEF,uBAAA;EC+gDE,eAAA;EACA,gBAAA;AX+hJJ;AW7hJI;EACE,oCAAA;AX+hJN;AW7hJI;EACE,oCAAA;AX+hJN;;AW3hJA;EACE,YAAA;AX8hJF;;AW5hJA;EACE,iBAAA;AX+hJF;AW7hJE;EACE,WAAA;EACA,kBAAA;AX+hJJ;;AWxhJM;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AX2hJR;AWzhJQ;EACE,oCAAA;AX2hJV;AWzhJQ;EACE,aAAA;AX2hJV;AWxhJM;ED7jDF,gDAAA;EAEF,uBAAA;EC6jDM,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AX2hJR;;AWrhJA;EACE,+CAAA;EACA,sCAAA;EACA,+BAAA;AXwhJF;AWthJE;EACE,uCAAA;AXwhJJ;;AWrhJA;EACE,oBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AXwhJF;AWthJE;EACE,eAAA;AXwhJJ;AWthJE;ED1lDE,gDAAA;EAEF,uBAAA;EC0lDE,qBAAA;AXyhJJ;AWthJI;EACE,yBAAA;AXwhJN;AWrhJE;EACE,0BAAA;AXuhJJ;AWrhJE;EACE,mBAAA;EACA,YAAA;AXuhJJ;AWrhJI;EACE,eAAA;AXuhJN;;AWnhJA;EACE,0BAAA;AXshJF;AWphJE;EACE,+BAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;AXshJJ;AWphJE;EACE,yBAAA;AXshJJ;AWphJE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;AXshJJ;AWphJE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sCAAA;AXshJJ;AWnhJI;EACE,8BAAA;AXqhJN;AWnhJI;EACE,6BAAA;AXqhJN;AWjhJI;EACE,8BAAA;EACA,qCAAA;AXmhJN;AWjhJI;EACE,8BAAA;EACA,2BAAA;AXmhJN;AWhhJM;EACE,8BAAA;AXkhJR;;AW5gJA;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;AX+gJF;AW7gJE;EACE,QAAA;AX+gJJ;AW7gJE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AX+gJJ;AW7gJI;EACE,qCAAA;EACA,mBAAA;AX+gJN;AW7gJI;EACE,SAAA;EACA,+CAAA;EACA,8BAAA;EACA,yDAAA;EACA,8GAAA;AX+gJN;AW7gJM;EACE,aAAA;AX+gJR;AW7gJM;EACE,aAAA;AX+gJR;AW7gJM;EACE,sCAAA;EACA,qCAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;AX+gJR;AW7gJM;EACE,uDAAA;EACA,sCAAA;EACA,YAAA;AX+gJR;;AWzgJA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AX4gJF;AW1gJE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;AX4gJJ;AW1gJE;EACE,yBAAA;AX4gJJ;AW1gJE;EACE,iCAAA;EFnuCF,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EE+tCE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;AXkhJJ;AW/gJI;EACE,gBAAA;EACA,oCAAA;EACA,iCAAA;EACA,wBAAA;AXihJN;AW7gJI;EACE,gCAAA;AX+gJN;;AWzgJA;EACE;IACE,aAAA;EX4gJF;AACF;AYzyMA;EACE,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,2CAAA;AZ2yMF;;AYzyMA;EACE,oCAAA;AZ4yMF;;AY1yMA;EACE,oCAAA;EACA,wCAAA;AZ6yMF;AY3yME;EACE,8BAAA;EACA,iFAAA;EACA,oCAAA;AZ6yMJ;AY3yMI;EACE,oCAAA;EACA,wCAAA;AZ6yMN;AYvyMY;EACE,sDAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EFnBV,gDAAA;EAEF,uBAAA;EEmBY,yBAAA;EACA,mCAAA;EACA,iFAAA;AZ0yMd;AYxyMc;EACE,qCAAA;AZ0yMhB;AYtyMc;EACE,qCAAA;AZwyMhB;AYjyMI;EACE,qBAAA;EACA,oBAAA;EACA,gBAAA;EFzCF,gDAAA;EE2CE,iBAAA;AZmyMN;AYhyMM;EACE,iDAAA;AZkyMR;AY9xME;EACE,gBAAA;AZgyMJ;AY9xMI;EACE,6DAAA;AZgyMN;AY5xMI;EACE,kBAAA;EACA,qCAAA;AZ8xMN;AY3xMM;EACE,iBAAA;AZ6xMR;AY1xMU;EACE,4BAAA;AZ4xMZ;AY1xMU;EACE,kCAAA;AZ4xMZ;;AYrxMA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,iFAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AZwxMF;AYtxME;EACE,oCAAA;AZwxMJ;AYtxME;EACE,qCAAA;EACA,mBAAA;AZwxMJ;;AYrxMA;EFtGI,gDAAA;EEwGF,2CAAA;EACA,mBAAA;EACA,iBAAA;EACA,sDAAA;AZwxMF;;AYrxME;EACE,oCAAA;EACA,gBAAA;AZwxMJ;;AYrxMA;EACE,oCAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AZwxMF;AYtxME;EACE,qCAAA;AZwxMJ;;AYlxME;EACE,mBAAA;EACA,gBAAA;AZqxMJ;AYnxMI;EACE,aAAA;AZqxMN;AYlxME;EACE,eAAA;EACA,6FAAA;EACA,+CAAA;EACA,6BAAA;AZoxMJ;;AYhxME;EACE,yBAAA;EACA,0BAAA;AZmxMJ;;AYhxMA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EFjKE,gDAAA;EAEF,uBAAA;EEiKA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,qCAAA;AZoxMF;AYlxME;EACE,yBAAA;AZoxMJ;AYlxME;EACE,0BAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AZoxMJ;;AY9wME;EACE,0CAAA;AZixMJ;AY/wMI;EACE,uBAAA;AZixMN;AY9wME;EF5LE,gDAAA;EAEF,uBAAA;EE4LE,qBAAA;AZixMJ;AY/wME;EFhME,gDAAA;EAEF,uBAAA;EEgME,yBAAA;AZkxMJ;;AY/wMA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AZkxMF;AYhxME;EACE,eAAA;EACA,eAAA;AZkxMJ;AYhxMI;EACE,cAAA;EACA,sBAAA;AZkxMN;AY/wME;EFtNE,gDAAA;EEwNA,uBAAA;AZixMJ;AY9wME;EACE,yBAAA;AZgxMJ;;AY5wME;EACE,gBAAA;EACA,QAAA;EACA,uBAAA;EACA,+BAAA;AZ+wMJ;AY7wME;EACE,YAAA;AZ+wMJ;AY7wME;EACE,kCAAA;AZ+wMJ;AY7wMI;EACE,8BAAA;AZ+wMN;AY7wMI;EACE,8BAAA;AZ+wMN;;AY3wMA;EFpPI,gDAAA;EAEF,uBAAA;EEoPA,gBAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;AZ+wMF;;AY7wMA;EACE,+BAAA;AZgxMF;;AY3wMA;EACE,mBAAA;EACA,cAAA;EACA,gDAAA;EACA,gBAAA;EFrQE,gDAAA;EEuQF,kBAAA;AZ8wMF;AY5wME;EACE,mBAAA;EACA,aAAA;AZ8wMJ;;AY3wMA;EF9QI,gDAAA;EEgRF,qBAAA;AZ8wMF;AY5wME;EACE,oBAAA;EACA,mBAAA;AZ8wMJ;AY5wMI;EACE,kBAAA;AZ8wMN;;AY1wMA;EACE,uBAAA;AZ6wMF;;AY3wMA;EACE,QAAA;AZ8wMF;;AY5wMA,eAAA;AACA;EACE,mCAAA;EACA,iFAAA;EACA,mBAAA;EAuBA,8BAAA;AZyvMF;AY9wME;EACE,2CAAA;EACA,kBAAA;AZgxMJ;AY9wMI;EACE,mBAAA;AZgxMN;AY9wMI;EACE,wCAAA;AZgxMN;AY7wME;EFlTE,gDAAA;EAEF,wBAAA;EEkTE,qBAAA;AZgxMJ;AY9wME;EACE,yEAAA;AZgxMJ;AY9wME;EACE,gBAAA;AZgxMJ;AY5wMI;EACE,SAAA;AZ8wMN;AY5wMM;EACE,kBAAA;AZ8wMR;AY3wMI;EACE,uBAAA;AZ6wMN;AY3wMI;EACE,SAAA;EACA,UAAA;AZ6wMN;AY3wMI;EACE,sBAAA;EACA,uBAAA;AZ6wMN;AY3wMI;EACE,aAAA;EACA,uBAAA;EFlVF,gDAAA;EAEF,uBAAA;EEkVI,qBAAA;EACA,SAAA;EACA,eAAA;AZ8wMN;AY5wMI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,QAAA;AZ8wMN;AY3wMQ;EACE,UAAA;AZ6wMV;AYzwMI;EACE,UAAA;EACA,eAAA;AZ2wMN;AYxwMQ;EACE,gDAAA;AZ0wMV;AYtwMQ;EACE,6CAAA;AZwwMV;AYpwMQ;EACE,gDAAA;AZswMV;AYpwMQ;EACE,6CAAA;AZswMV;AYlwMQ;EACE,gDAAA;AZowMV;AYlwMQ;EACE,6CAAA;AZowMV;AYhwMQ;EACE,gDAAA;AZkwMV;AYhwMQ;EACE,6CAAA;AZkwMV;AY9vMQ;EACE,4CAAA;AZgwMV;AY7vMM;EACE,gBAAA;AZ+vMR;AY5vMI;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;AZ8vMN;AY5vMI;EACE,gBAAA;EACA,gBAAA;AZ8vMN;AY5vMI;EACE,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AZ8vMN;AY5vMI;EACE,UAAA;AZ8vMN;AY5vMI;EACE,UAAA;AZ8vMN;AY5vMI;EACE,0BAAA;EACA,SAAA;AZ8vMN;AY5vMI;EACE,yBAAA;EACA,gBAAA;AZ8vMN;AY5vMI;EACE,eAAA;AZ8vMN;AY5vMI;EACE,kBAAA;AZ8vMN;AY5vMM;EACE,oCAAA;AZ8vMR;AY5vMM;EACE,oCAAA;AZ8vMR;AY1vMU;EACE,oCAAA;AZ4vMZ;AYvvMI;EACE,OAAA;EACA,oCAAA;EACA,gCAAA;AZyvMN;AYtvMM;EACE,uBAAA;AZwvMR;AYrvMI;EACE,mCAAA;EACA,iFAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AZuvMN;AYpvMM;EACE,oBAAA;AZsvMR;AYpvMM;EACE,aAAA;AZsvMR;AYpvMM;EACE,6BAAA;AZsvMR;AYnvMI;EACE,uBAAA;EACA,kBAAA;EACA,sCAAA;EACA,eAAA;AZqvMN;AYlvMM;EACE,gBAAA;AZovMR;;AY9uME;EACE,0BAAA;EACA,YAAA;AZivMJ;AY/uME;EACE,QAAA;AZivMJ;AY9uMI;EACE,sBAAA;AZgvMN;AY9uMI;EACE,OAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AZgvMN;AY7uME;EACE,SAAA;AZ+uMJ;AY7uME;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AZ+uMJ;AY7uMI;EACE,kBAAA;AZ+uMN;AY7uMI;EACE,aAAA;AZ+uMN;AY5uME;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AZ8uMJ;AY5uME;EACE,4BAAA;AZ8uMJ;AY5uME;EACE,mBAAA;AZ8uMJ;AY5uMI;EACE,kBAAA;EACA,gBAAA;AZ8uMN;AY5uMM;EACE,yBAAA;EACA,oCAAA;AZ8uMR;AY5uMM;EACE,oCAAA;EACA,aAAA;AZ8uMR;AY5uMM;EF/iBF,2DAAA;EAKF,uBAAA;EE4iBM,gCAAA;EACA,6BAAA;EACA,qDAAA;EACA,gBAAA;EACA,yBAAA;AZ+uMR;AY1uMI;EACE,mBAAA;EACA,aAAA;AZ4uMN;AYvuMM;EACE,uCAAA;EACA,WAAA;AZyuMR;AYvuMM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AZyuMR;AYruME;EACE,aAAA;EACA,aAAA;AZuuMJ;AYruMI;EACE,aAAA;AZuuMN;AYruMI;EACE,YAAA;AZuuMN;AYpuME;EACE,4BAAA;EACA,kBAAA;AZsuMJ;AYpuME;EACE,oCAAA;EACA,mBAAA;EACA,iFAAA;AZsuMJ;AYpuMI;EACE,YAAA;EACA,WAAA;AZsuMN;AYnuME;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AZquMJ;AYnuMI;EACE,UAAA;AZquMN;AYnuMI;EACE,4BAAA;AZquMN;AYnuMI;EACE,UAAA;AZquMN;AYluMM;EACE,OAFS;AZsuMjB;AYruMM;EACE,OAFS;AZyuMjB;AYxuMM;EACE,OAFS;AZ4uMjB;AY3uMM;EACE,OAFS;AZ+uMjB;AY9uMM;EACE,OAFS;AZkvMjB;AYjvMM;EACE,OAFS;AZqvMjB;AYpvMM;EACE,OAFS;AZwvMjB;AYvvMM;EACE,OAFS;AZ2vMjB;AY1vMM;EACE,OAFS;AZ8vMjB;AY7vMM;EACE,QAFS;AZiwMjB;AYhwMM;EACE,QAFS;AZowMjB;AYnwMM;EACE,QAFS;AZuwMjB;AYjwME;EACE,oCAAA;AZmwMJ;AYhwME;EACE,mCAAA;EACA,uBAAA;EACA,mBAAA;EACA,iFAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AZkwMJ;AYhwMI;EACE,YAAA;AZkwMN;AYhwMI;EACE,yBAAA;AZkwMN;AY9vMQ;EACE,gBAAA;AZgwMV;AY5vMQ;EACE,mBAAA;AZ8vMV;AY1vMQ;EACE,aAAA;AZ4vMV;AY1vMQ;EACE,uBAAA;AZ4vMV;AYxvMI;EACE,WAAA;AZ0vMN;AYvvME;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;AZyvMJ;AYvvME;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AZyvMJ;AYtvMI;EACE,kBAAA;EACA,UAAA;AZwvMN;AYpvMI;EACE,yBAAA;AZsvMN;AYpvMI;EACE,uBAAA;EACA,WAAA;AZsvMN;AYnvME;EACE,gBAAA;AZqvMJ;;AYlvMA;EACE,mCAAA;AZqvMF;;AYjvMA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AZovMF;AYlvME;EACE,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AZovMJ;AYlvMI;EACE,YAAA;AZovMN;AYlvMM;EACE,aAAA;AZovMR;AYhvMM;EACE,aAAA;AZkvMR;AYhvMM;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;AZkvMR;AY9uME;EACE,iBAAA;EACA,gBAAA;EACA,OAAA;AZgvMJ;AY9uMI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AZgvMN;AY9uMM;EACE,uBAAA;AZgvMR;AY7uMQ;EACE,gBAAA;AZ+uMV;;AYzuMA;EFlwBI,2DAAA;EAKF,uBAAA;EE+vBA,wBAAA;EACA,6BAAA;EACA,wCAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;AZ6uMF;AY3uME;EACE,gCAAA;AZ6uMJ;;AY1uMA;EACE,0BAAA;AZ6uMF;;AY3uMA;EFlxBI,2DAAA;EAKF,uBAAA;EE+wBA,gCAAA;AZ+uMF;;AY7uMA;EACE,iEAAA;EACA,8BAAA;AZgvMF;;AY9uMA;EACE,6BAAA;AZivMF;AY/uME;EACE,mBAAA;AZivMJ;;AY7uME;EACE,kBAAA;AZgvMJ;AY9uME;EFlyBE,gDAAA;EAEF,uBAAA;EEkyBE,qBAAA;EACA,YAAA;EACA,0BAAA;EACA,wBAAA;EACA,+BAAA;EACA,uDAAA;EACA,oBAAA;EACA,mBAAA;EACA,wCAAA;AZivMJ;AY/uMI;EACE,wDAAA;AZivMN;;AYzuME;EACE,qCAAA;EACA,mCAAA;AZ4uMJ;;AYvuMA;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;AZ0uMF;;AYruME;EACE,kBAAA;AZwuMJ;;AYnuMA;EACE,aAAA;EACA,kBAAA;AZsuMF;;AYpuMA;EACE,iFAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,iCAAA;EACA,mCAAA;EACA,QAAA;AZuuMF;;AYruMA;EACE,yBAAA;AZwuMF;AYtuME;EHnVA,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EG+UE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AZ8uMJ;;AY1uME;EACE,yBAAA;AZ6uMJ;;AY1uMA;EACE,oCAAA;AZ6uMF;;AY3uMA;EACE,mCAAA;AZ8uMF;;AY5uMA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,mCAAA;AZ+uMF;;AY7uMA;EF73BI,gDAAA;EAEF,uBAAA;EE63BA,cAAA;AZivMF;;AY/uMA;EACE,yBAAA;AZkvMF;;AYhvMA;EACE,mBAAA;AZmvMF;;AYjvMA;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,2CAAA;EACA,wEAAA;EACA,+BAAA;EACA,0BAAA;AZovMF;AYlvME;EACE,yBAAA;EACA,oCAAA;EACA,uBAAA;AZovMJ;AYlvME;EACE,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iCAAA;AZovMJ;;AYjvMA;EACE,oBAAA;EACA,mBAAA;EACA,2CAAA;AZovMF;AYlvME;EACE,yBAAA;EACA,oCAAA;AZovMJ;AYlvME;EACE,+BAAA;EACA,kBAAA;EACA,wCAAA;AZovMJ;;AYjvMA;EACE,aAAA;EACA,SAAA;EFp7BE,gDAAA;EAEF,uBAAA;EEo7BA,wBAAA;EACA,eAAA;AZqvMF;;AYnvMA;EACE,kBAAA;AZsvMF;AYpvME;EACE,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;AZsvMJ;;AYnvMA;EFn8BI,gDAAA;EAEF,uBAAA;EEm8BA,uBAAA;AZuvMF;;AYrvMA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AZwvMF;;AYtvMA;EACE,OAAA;EACA,cAAA;AZyvMF;;AYvvMA;EACE,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,mCAAA;EACA,UAAA;EACA,iBAAA;AZ0vMF;;AYxvMA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AZ2vMF;;AYzvMA;EACE,wBAAA;AZ4vMF;AY1vME;EACE,wBAAA;AZ4vMJ;;AYtvME;EACE,mHAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AZyvMJ;AYtvMI;EACE,wBAAA;AZwvMN;AYpvMI;EACE,wBAAA;AZsvMN;;AYjvME;EACE,sCAAA;EACA,sBAAA;EACA,kBAAA;AZovMJ;;AYjvMA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AZovMF;;AYjvME;EACE,oCAAA;EACA,wBAAA;AZovMJ;;AYjvMA;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AZovMF;AYlvME;EACE,eAAA;AZovMJ;;AY/uMA;EACE,UAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,yBAAA;AZkvMF;AYhvME;EACE,uBAAA;AZkvMJ;AYhvME;EACE,yBAAA;AZkvMJ;;AY/uMA;EF/iCI,gDAAA;AVkyOJ;;AYhvMA;EACE,qBAAA;EACA,qBAAA;EFpjCE,gDAAA;EEsjCF,kBAAA;AZmvMF;;AYjvMA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AZovMF;;AYlvMA;EACE,kBAAA;AZqvMF;AYnvME;EACE,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EFpkCA,gDAAA;EEskCA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AZqvMJ;AYnvMI;EACE,gBAAA;AZqvMN;;AY/uMA;EACE,aAAA;AZkvMF;;AYhvMA;EACE,iBAAA;EACA,SAAA;AZmvMF;;AY/uMA;EF7lCI,gDAAA;EAEF,uBAAA;EE6lCA,wBAAA;EACA,oCAAA;AZmvMF;AYjvME;EFlmCE,gDAAA;EAEF,uBAAA;EEkmCE,gBAAA;EACA,kBAAA;AZovMJ;AYlvME;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AZovMJ;AYlvME;EACE,mCAAA;EACA,kCAAA;AZovMJ;AYlvME;EFrnCE,2DAAA;EAKF,uBAAA;EEknCE,WAAA;EACA,YAAA;EACA,mBAAA;AZqvMJ;;AYlvMA;;EAEE,kBAAA;EACA,gBAAA;AZqvMF;;AYnvMA;EACE,oCAAA;AZsvMF;AYpvME;EFjoCE,gDAAA;EAEF,uBAAA;EEioCE,wBAAA;AZuvMJ;;AYpvMA;EACE,gCAAA;AZuvMF;;AYrvMA;EFzoCI,gDAAA;EAEF,uBAAA;EEyoCA,wBAAA;EACA,oCAAA;EACA,oBAAA;EACA,kBAAA;AZyvMF;;AYtvMA;EFjpCI,gDAAA;EAEF,uBAAA;EEipCA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AZ0vMF;AYxvME;EACE,eAAA;AZ0vMJ;;AYpvME;EACE,0BAAA;AZuvMJ;AYrvME;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AZuvMJ;AYrvME;EACE,mBAAA;AZuvMJ;AYrvMI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AZuvMN;AYnvMI;EACE,mDAAA;EACA,WAAA;AZqvMN;AYjvMI;EACE,mDAAA;EACA,QAAA;AZmvMN;AYhvME;EACE,kBAAA;EACA,oBAAA;AZkvMJ;AYhvMI;EACE,UAAA;EACA,YAAA;AZkvMN;AY9uMI;EACE,oDAAA;EACA,qBAAA;AZgvMN;AY5uMI;EACE,mDAAA;EACA,uBAAA;AZ8uMN;;AYxuMA;EACE,mBAAA;EACA,kFAAA;AZ2uMF;AYzuME;EF7tCE,gDAAA;AVy8OJ;AYzuME;EACE,wBAAA;AZ2uMJ;AYzuMI;EACE,+BAAA;AZ2uMN;;AYruMA;EACE,oFAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AZwuMF;AYpuMM;EFpvCF,gDAAA;EEsvCI,kBAAA;AZsuMR;AYpuMM;EFxvCF,gDAAA;AV+9OJ;AYnuMI;EACE,aAAA;AZquMN;AYluME;EACE,aAAA;AZouMJ;AYjuMI;EACE,gBAAA;AZmuMN;AYjuMI;EACE,yBAAA;AZmuMN;AYjuMM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AZmuMR;AYjuMM;EACE,eAAA;AZmuMR;AY/tME;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AZiuMJ;AY/tME;EACE,mBAAA;EACA,+CAAA;AZiuMJ;AY/tME;EACE,eAAA;AZiuMJ;AY/tME;EACE,gBAAA;EACA,cAAA;AZiuMJ;AY/tME;EACE,gBAAA;EACA,cAAA;AZiuMJ;AY/tME;;EAEE,gBAAA;EACA,cAAA;AZiuMJ;AY/tME;;;;;;EAME,gBAAA;EACA,cAAA;AZiuMJ;AY/tME;EACE,gBAAA;EACA,eAAA;AZiuMJ;AY/tME;EACE,aAAA;AZiuMJ;AY/tMI;EACE,cAAA;AZiuMN;AY/tMI;EACE,cAAA;EACA,cAAA;AZiuMN;AY7tME;EACE,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AZ+tMJ;AY7tMI;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;AZ+tMN;AY5tME;EACE,yBAAA;EACA,oBAAA;EACA,QAAA;EACA,qBAAA;EACA,gBAAA;AZ8tMJ;AY5tME;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AZ8tMJ;;AYvtMI;EACE,mBAAA;AZ0tMN;AYxtMM;EACE,iBAAA;AZ0tMR;;AYrtMA;EACE,yBAAA;AZwtMF;;AYttMA;EFt3CI,gDAAA;EAEF,uBAAA;AV+kPF;AYvtMI;EACE,2BAAA;AZytMN;AYrtMI;EACE,6BAAA;AZutMN;AYptME;EACE,qBAAA;AZstMJ;AYptMI;EACE,gBAAA;EACA,cAAA;AZstMN;AYptMI;EACE,gBAAA;EACA,cAAA;AZstMN;AYptMI;EACE,0BAAA;AZstMN;;AYltMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AZqtMF;;AYntMA;EACE,aAAA;EACA,gBAAA;EACA,oBAAA;AZstMF;;AYptMA;EACE,gBAAA;EACA,oCAAA;AZutMF;AYrtME;EACE,oCAAA;EACA,0BAAA;AZutMJ;AYrtME;EACE,iBAAA;EACA,gBAAA;AZutMJ;AYptMI;EACE,mBAAA;EACA,8BAAA;AZstMN;AYptMM;EACE,oCAAA;AZstMR;AYltMM;EACE,oCAAA;AZotMR;AYhtME;EACE,aAAA;EACA,iBAAA;EACA,SAAA;AZktMJ;;AYzsMU;EACE,iCAAA;AZ4sMZ;AYxsMM;EACE,8BAAA;AZ0sMR;AYxsMQ;EACE,8BAAA;AZ0sMV;AYxsMU;EACE,8BAAA;AZ0sMZ;AYxsMY;EACE,8BAAA;AZ0sMd;;AY/rMA;EACE,oBAAA;AZksMF;AY9rMM;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AZgsMR;AY9rMM;EACE,4GAAA;AZgsMR;AY9rMM;EACE,sBAAA;EACA,kBAAA;EACA,QAAA;AZgsMR;AY9rMQ;EACE,kBAAA;EACA,WAAA;EACA,oCAAA;EFn/CN,gDAAA;EAEF,uBAAA;EEm/CQ,mBAAA;AZisMV;AY9rMU;EACE,oCAAA;AZgsMZ;AY9rMU;EACE,aAAA;AZgsMZ;AY7rMY;EACE,+BAAA;EACA,gCAAA;AZ+rMd;AYxrMU;EACE,aAAA;AZ0rMZ;AYrrMQ;EACE,uBAAA;AZurMV;AYnrMc;EACE,4GAAA;AZqrMhB;AYnrMc;EACE,qGAAA;AZqrMhB;AY9qMQ;EACE,uBAAA;AZgrMV;AY9qMU;EACE,qGAAA;AZgrMZ;AYzqMQ;EACE,mCAAA;EACA,iFAAA;EACA,mBAAA;AZ2qMV;AYzqMU;EACE,gBAAA;AZ2qMZ;AYvqMM;EACE,mCAAA;EACA,iFAAA;EACA,mBAAA;AZyqMR;AYpqMI;EACE,2CAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;AZsqMN;AYpqMI;EACE,qGAAA;EACA,uBAAA;EACA,kBAAA;EACA,2CAAA;AZsqMN;AYnqME;EFxkDE,gDAAA;EAEF,uBAAA;AV6uPF;AYpqME;EACE,iBAAA;EACA,cAAA;EACA,wDAAA;AZsqMJ;AYpqME;EACE,gBAAA;EACA,OAAA;EACA,uBAAA;AZsqMJ;AYpqME;EACE,kBAAA;AZsqMJ;AYpqME;EACE,0BAAA;AZsqMJ;AYlqMM;EACE,aAAA;EACA,8BAAA;AZoqMR;AY5pMU;EACE,gBAAA;AZ8pMZ;AY5pMU;EACE,mBAAA;AZ8pMZ;AY5pMU;EACE,yBAAA;AZ8pMZ;AYvpMI;EACE,uBAAA;AZypMN;AYtpMM;EACE,yBAAA;AZwpMR;AYtpMM;EACE,wBAAA;AZwpMR;AYrpMQ;EACE,kCAAA;AZupMV;AYrpMQ;EACE,wCAAA;AZupMV;AYlpME;EACE,6BAAA;AZopMJ;AYlpMI;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;AZopMN;AY/oMM;EACE,aAAA;AZipMR;AY/oMQ;EACE,kCAAA;AZipMV;AY/oMQ;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;AZipMV;AY3oMQ;EACE,sBAAA;AZ6oMV;AY1oMY;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AZ4oMd;AY1oMc;EACE,eAAA;AZ4oMhB;AYtoMM;EACE,wBAAA;AZwoMR;AYtoMM;EACE,QAAA;AZwoMR;AYroMI;EACE,gBAAA;EACA,kBAAA;EACA,oGAAA;AZuoMN;AYpoMM;EACE,uBAAA;AZsoMR;;AY9nME;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;AZioMJ;AY/nMI;EAEE,iCAAA;EHrsCJ,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EGisCI,gBAAA;EACA,eAAA;EACA,0BAAA;AZsoMN;AYpoMI;EACE,YAAA;AZsoMN;AYpoMI;EACE,YAAA;AZsoMN;AYpoMI;EACE,iCAAA;AZsoMN;AYnoME;EACE,oCAAA;AZqoMJ;;AYloMA;EACE,YAAA;AZqoMF;AYnoME;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;AZqoMJ;AYnoMI;EACE,OAAA;AZqoMN;AYnoMM;EACE,YAAA;AZqoMR;;AYhoMA;EFtvDI,gDAAA;EEwvDF,yBAAA;AZmoMF;;AY5nME;EACE,wBAAA;EACA,6BAAA;AZ+nMJ;AY7nME;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,wBAAA;EACA,oBAAA;EACA,iFAAA;AZ+nMJ;AY7nMI;EACE,iBAAA;AZ+nMN;AY5nME;EACE,YAAA;EACA,mCAAA;EACA,uDAAA;EACA,uBAAA;AZ8nMJ;AY5nMI;EACE,8BAAA;AZ8nMN;AY3nME;EACE,YAAA;EACA,6BAAA;EACA,oBAAA;EACA,oBAAA;EACA,iFAAA;AZ6nMJ;AY3nMI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EFzyDF,gDAAA;AVu6PJ;AY1nMQ;EACE,wBAAA;AZ4nMV;AYvnME;EACE,mBAAA;EACA,0BAAA;AZynMJ;AYvnME;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AZynMJ;AYvnMI;EACE,mBAAA;EACA,iFAAA;EACA,aAAA;EACA,mCAAA;EACA,kBAAA;AZynMN;AYvnMM;EACE,aAAA;EACA,QAAA;EACA,qBAAA;AZynMR;AYtnMI;EACE,mBAAA;EACA,mBAAA;AZwnMN;AYrnME;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AZunMJ;AYpnMI;EACE,gBAAA;AZsnMN;AYpnMI;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AZsnMN;AYnnME;EACE,gBAAA;AZqnMJ;AYnnMI;EACE,oCAAA;EACA,iFAAA;AZqnMN;AYnnMI;EACE,gBAAA;AZqnMN;AYlnME;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AZonMJ;AYlnMI;EFr3DA,gDAAA;EAEF,uBAAA;EEq3DI,yBAAA;AZqnMN;AYnnMI;EACE,eAAA;EACA,iBAAA;AZqnMN;AYlnME;EF93DE,gDAAA;EAEF,uBAAA;EE83DE,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AZqnMJ;AYjnMM;EACE,aAAA;AZmnMR;AYjnMM;EACE,gBAAA;AZmnMR;;AY7mMA;EACE,aAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AZgnMF;AY9mME;EACE,gBAAA;EACA,iBAAA;AZgnMJ;AY9mME;EACE,aAAA;AZgnMJ;;AY7mMA;EFj6DI,gDAAA;EAEF,uBAAA;EEi6DA,yBAAA;AZinMF;;AY/mMA;EFr6DI,gDAAA;EAEF,uBAAA;EEq6DA,qBAAA;AZmnMF;;AYjnMA;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;AZonMF;;AYlnMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AZqnMF;;AYlnME;EACE,oBAAA;EACA,eAAA;AZqnMJ;;AYlnMA;EACE,QAAA;EACA,aAAA;EACA,eAAA;AZqnMF;;AYnnMA;EACE,qBAAA;EACA,gBAAA;AZsnMF;;AYpnMA;EACE,wBAAA;AZunMF;;AYrnMA;EACE,YAAA;AZwnMF;;AYtnMA;EACE,OAAA;AZynMF;;AYvnMA;EACE,eAAA;EACA,kBAAA;AZ0nMF;AYxnME;EACE,SAAA;AZ0nMJ;;AYvnMA;EACE,qCAAA;EACA,WAAA;AZ0nMF;;AYxnMA;EACE,qCAAA;AZ2nMF;;AYznMA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AZ4nMF;;AY1nMA;EACE,aAAA;EACA,yBAAA;AZ6nMF;;AY3nMA;EACE,kBAAA;AZ8nMF;;AY5nMA;EACE,eAAA;AZ+nMF;AY7nME;EACE,mCAAA;AZ+nMJ;;AY1nMA;EF/+DI,gDAAA;EAEF,uBAAA;EE++DA,oCAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;AZ8nMF;AY5nME;EACE,gBAAA;AZ8nMJ;;AY3nMA;EACE,0BAAA;EACA,aAAA;EACA,iHAAA;EACA,SAAA;AZ8nMF;;AY5nMA;EACE,2BAAA;EACA,aAAA;EACA,SAAA;EACA,sKAAA;AZ+nMF;;AY5nME;EACE,kBAAA;AZ+nMJ;;AY5nMA;EACE,kBAAA;AZ+nMF;AY7nME;EACE,oCAAA;AZ+nMJ;;AY5nMA;EFnhEI,gDAAA;EAEF,uBAAA;AVkpQF;AY9nME;EACE,oCAAA;AZgoMJ;;AY7nMA;EF1hEI,gDAAA;EAEF,uBAAA;EE0hEA,qBAAA;EACA,eAAA;AZioMF;AY/nME;EACE,0BAAA;AZioMJ;AY/nME;EFliEE,4CAAA;EAEF,uBAAA;AVmqQF;AYhoME;EACE,oCAAA;AZkoMJ;AYhoME;EACE,oCAAA;AZkoMJ;;AY9nME;EACE,mBAAA;EACA,YAAA;AZioMJ;AY/nME;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;AZioMJ;AY/nMI;EACE,oCAAA;AZioMN;AY9nME;EF7jEE,gDAAA;EAEF,uBAAA;EE6jEE,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AZioMJ;AY/nMI;EACE,gCAAA;EFzkEF,gDAAA;EAEF,uBAAA;EEykEI,YAAA;EACA,2CAAA;EACA,wBAAA;AZkoMN;;AY9nMA;EACE,aAAA;EACA,yBAAA;AZioMF;;AY/nMA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AZkoMF;AYhoME;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AZkoMJ;AYhoMI;EACE,oCAAA;AZkoMN;AY/nME;EACE,iBAAA;AZioMJ;AY/nMI;EACE,cAAA;EACA,eAAA;AZioMN;AY9nME;EACE,WAAA;EACA,kBAAA;AZgoMJ;;AY7nMA;EACE,kBAAA;AZgoMF;;AY7nME;EACE,cAAA;AZgoMJ;AY9nMI;EACE,cAAA;AZgoMN;AY9nMM;EACE,cAAA;AZgoMR;AY9nMQ;EACE,cAAA;AZgoMV;;AYxnMI;EACE,cAAA;AZ2nMN;AYznMM;EACE,cAAA;AZ2nMR;AYznMQ;EACE,eAAA;AZ2nMV;AYznMU;EACE,eAAA;AZ2nMZ;;AYpnMA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AZunMF;AYrnME;;EAEE,aAAA;EACA,qBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AZunMJ;AYrnME;EACE,UAAA;AZunMJ;AYrnME;EACE,YAAA;EACA,gBAAA;AZunMJ;AYrnMI;EACE,oBAAA;AZunMN;AYnnMI;EACE,gBAAA;AZqnMN;AYnnMI;EACE,qCAAA;AZqnMN;AYlnME;EACE,gCAAA;AZonMJ;AYlnMI;EACE,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AZonMN;AYjnME;EFpsEE,gDAAA;EEssEA,mBAAA;EACA,eAAA;AZmnMJ;;AYhnMA;EACE,gBAAA;AZmnMF;;AYjnMA;EACE,UAAA;EACA,eAAA;AZonMF;;AYlnMA;EACE,YAAA;EACA,YAAA;AZqnMF;AYnnME;EACE,gBAAA;AZqnMJ;;AYjnME;EACE,uBAAA;AZonMJ;;AYjnMA;EACE,aAAA;EACA,mBAAA;AZonMF;;AYjnME;EACE,mCAAA;EACA,kBAAA;EACA,2CAAA;EACA,sCAAA;AZonMJ;;AYjnMA;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;AZonMF;AYlnME;EACE,2BAAA;AZonMJ;;AYjnMA;EACE,kBAAA;AZonMF;AYlnME;EACE,kBAAA;AZonMJ;;AYjnMA;EACE,iBAAA;AZonMF;;AY7mMQ;EACE,oCAAA;AZgnMV;AY7mMM;EACE,wBAAA;AZ+mMR;AY3mMU;EACE,oCAAA;AZ6mMZ;AYzmMM;EACE,sBAAA;AZ2mMR;;AYpmMA;EACE,WAAA;AZumMF;AYrmME;EACE,mBAAA;AZumMJ;AYrmME;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,qCAAA;AZumMJ;AYrmMI;EFxyEA,gDAAA;EAEF,uBAAA;EEwyEI,qBAAA;AZwmMN;AYtmMI;EACE,oBAAA;EACA,kBAAA;AZwmMN;AYrmME;EACE,gBAAA;AZumMJ;AYrmME;EACE,eAAA;AZumMJ;AYrmME;EACE,wBAAA;EACA,YAAA;EACA,UAAA;AZumMJ;AYrmMI;EACE,sCAAA;AZumMN;;AYnmMA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;AZsmMF;;AYnmMA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;AZsmMF;AYpmME;EACE,kBAAA;EACA,mCAAA;EACA,iFAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AZsmMJ;AYrmMI;EACE,aAAA;EACA,sBAAA;AZumMN;;AYlmME;EACE,mCAAA;AZqmMJ;AYnmMI;EACE,mCAAA;EACA,mCAAA;EACA,wBAAA;AZqmMN;AYnmMM;EACE,wBAAA;AZqmMR;AYnmMM;EAEE,aAAA;AZomMR;AYhmME;EACE,uBAAA;EACA,gBAAA;AZkmMJ;AYhmMI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;AZkmMN;AYhmMI;EACE,iBAAA;EACA,+BAAA;AZkmMN;;AY7lME;EACE,iBAAA;EACA,gBAAA;AZgmMJ;;AY7lMA;EACE,uBAAA;EACA,wCAAA;AZgmMF;AY9lME;EACE,oCAAA;AZgmMJ;;AY3lMA;EFr5EI,gDAAA;AVo/QJ;;AY1lMA;EACE,gCAAA;EACA,kBAAA;EACA,mCAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EAEA,2EAAA;EACQ,mEAAA;AZ4lMV;;AY1lMA;EACE;IACE,gCAAA;IACQ,wBAAA;EZ6lMV;EY3lMA;IACE,oCAAA;IACQ,4BAAA;EZ6lMV;AACF;AY3lMA;EACE;IACE,gCAAA;IACQ,wBAAA;EZ6lMV;EY3lMA;IACE,oCAAA;IACQ,4BAAA;EZ6lMV;AACF;AYzlMA;EACE,kBAAA;AZ2lMF;;AYzlMA;EACE,iBAAA;AZ4lMF;;AY1lMA;EACE,+CAAA;AZ6lMF;;AY3lMA;EACE,kCAAA;AZ8lMF;;AY5lMA;EACE,aAAA;EACA,8DAAA;AZ+lMF;;AY7lMA;EACE,gCAAA;AZgmMF;;AY9lMA;EACE,oCAAA;EACA,kBAAA;EACA,aAAA;AZimMF;;AY5lMI;EACE,uCAAA;AZ+lMN;AY7lMI;EACE,sCAAA;AZ+lMN;AY7lMI;EACE,oCAAA;AZ+lMN;AY7lMI;EACE,sCAAA;AZ+lMN;AY7lMI;EACE,oCAAA;AZ+lMN;AY7lMI;EACE,oCAAA;AZ+lMN;;AYzlMI;EACE,qCAAA;AZ4lMN;AY1lMI;EACE,oCAAA;AZ4lMN;AY1lMI;EACE,kCAAA;AZ4lMN;AY1lMI;EACE,oCAAA;AZ4lMN;AY1lMI;EACE,kCAAA;AZ4lMN;AY1lMI;EACE,kCAAA;AZ4lMN;;AYtlMA;EACE,UAAA;EACA,WAAA;AZylMF;;AYvlMA;EACE,yCAAA;AZ0lMF;;AYxlMA;EACE,kBAAA;EACA,8BAAA;AZ2lMF;;AYzlMA;EACE,8BAAA;AZ4lMF;;Aa5nRA;EHeI,gDAAA;EAEF,uBAAA;EGfA,qBAAA;EACA,mBAAA;EACA,2BAAA;AbgoRF;Aa9nRE;EACE,wBAAA;AbgoRJ;Aa7nRI;EACE,aAAA;EACA,0BAAA;EACA,0BAAA;Ab+nRN;;AaznRI;EACE,iDAAA;EACA,yBAAA;EACA,wBAAA;Ab4nRN;AaznRM;EACE,6CAAA;Ab2nRR;;AatnRA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AbynRF;;AatnRE;EACE,gBAAA;AbynRJ;;AatnRA;EACE,kBAAA;EACA,WAAA;AbynRF;AavnRE;EACE,kBAAA;EACA,4BAAA;AbynRJ;AavnRI;EACE,yBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;AbynRN;AavnRI;EACE,WAAA;EACA,eAAA;EACA,uBAAA;AbynRN;AatnRM;EACE,wBAAA;AbwnRR;AarnRQ;EACE,aAAA;AbunRV;AapnRM;EACE,WAAA;EACA,eAAA;AbsnRR;AalnRM;EACE,uBAAA;EACA,UAAA;AbonRR;AajnRI;EACE,YAAA;AbmnRN;AajnRI;EACE,UAAA;AbmnRN;AajnRM;EACE,4BAAA;AbmnRR;AahnRI;EACE,UAAA;AbknRN;AahnRI;EACE,UAAA;EACA,gBAAA;AbknRN;Aa9mRQ;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,qCAAA;EACA,0BAAA;AbgnRV;Aa9mRU;EACE,oCAAA;AbgnRZ;Aa9mRY;EACE,mCAAA;AbgnRd;Aa1mRI;EACE,YAAA;Ab4mRN;Aa1mRI;EACE,UAAA;EACA,gBAAA;Ab4mRN;Aa1mRI;EACE,WAAA;Ab4mRN;;AavmRE;EACE,oCAAA;EHtHA,gDAAA;EAEF,uBAAA;EGsHE,qBAAA;EACA,oBAAA;EACA,mBAAA;Ab2mRJ;AazmRE;EACE,sBAAA;EACA,oBAAA;Ab2mRJ;;AatmRE;;EACE,qBAAA;Ab0mRJ;;AatmRA;EACE,mBAAA;AbymRF;;Ac9vRA;EACE,eAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AdiwRF;Ac/vRE;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AdiwRJ;Ac/vRE;EACE,0BAAA;EACA,gBAAA;EACA,oCAAA;AdiwRJ;Ac/vRE;EACE,eAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;AdiwRJ;Ac/vRI;EACE,aAAA;AdiwRN;Ac9vRE;EACE,kBAAA;AdgwRJ;Ac9vRE;EACE,sBAAA;AdgwRJ;;Ac7vRA;EACE,aAAA;EACA,UAAA;AdgwRF;;Ac9vRA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AdiwRF;Ac/vRE;EACE,oCAAA;EACA,iFAAA;EACA,8CAAA;EACA,mBAAA;EACA,UAAA;AdiwRJ;Ac/vRI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;AdiwRN;Ac/vRM;EACE,aAAA;AdiwRR;Ac/vRM;EACE,oCAAA;AdiwRR;Ac/vRM;EACE,gBAAA;AdiwRR;Ac/vRM;EAEE,aAAA;EACA,oCAAA;AdgwRR;Ac7vRI;EACE,qBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;Ad+vRN;Ac7vRM;EACE,oCAAA;Ad+vRR;Ac7vRM;EAEE,aAAA;EACA,oCAAA;Ad8vRR;Ac5vRM;EACE,iCAAA;ELwaN,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EK5aM,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AdowRR;AchwRE;EJhHE,gDAAA;AVm3RJ;;Ac/vRA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;EACA,YAAA;EACA,eAAA;AdkwRF;AchwRE;EACE,oCAAA;AdkwRJ;AchwRE;EAEE,aAAA;EACA,oCAAA;AdiwRJ;;Ac9vRA;EACE,mBAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,iCAAA;EACA,4BAAA;AdiwRF;;Ac/vRA;EACE,0BAAA;AdkwRF;Ac9vRM;EACE,UAAA;EACA,iCAAA;EACA,4BAAA;EACA,yBAAA;AdgwRR;Ac1vRI;EACE,wBAAA;EACA,uBAAA;Ad4vRN;;AcxvRA;EACE,mBAAA;Ad2vRF;AczvRE;EACE,uBAAA;Ad2vRJ;;AcvvRA;EACE,eAAA;Ad0vRF;;ActvRA;EACE,YAAA;AdyvRF;AcvvRE;EACI,aAAA;AdyvRN;ActvRU;EACI,SAAA;EACA,UAAA;AdwvRd;AcpvRsB;EACI,aAAA;AdsvR1B;AcpvR0B;EACI,yBAAA;EACA,qBAAA;AdsvR9B;;Ac5uRE;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBTnOE;ESoOF,oBAAA;EACA,4DAAA;Ad+uRN;Ac7uRM;EACI,aAAA;Ad+uRV;Ac3uRkB;EACI,aAAA;Ad6uRtB;Ac3uRsB;EACI,WAAA;EACA,cAAA;EACA,eAAA;Ad6uR1B;ActuRE;EACI,mBAAA;EACA,gBAAA;AdwuRN;;AcruRA;EACE,YAAA;EACA,0BAAA;EACA,6BAAA;AdwuRF;;ActuRA;EACE,gBAAA;AdyuRF;AcvuRE;EACI,uBAAA;AdyuRN;;Ae1/RA;+EAAA;ACAA,cAAA;AAEA;EACE,YAAA;AhB8/RF;;AgB3/RA;EAEI,sCbGqB;EaFrB,ebMa;EaLb,gBX8NiB;EW5NnB,Wb8EW;Ea7EX,yBb4EQ;Ea3ER,YAAA;EACA,gBAAA;AhB4/RF;AgB1/RE;EACE,oCAAA;AhB4/RJ;;AgBx/RA;EACE,uBAAA;EACA,4BAAA;AhB2/RF;;AgBx/RA;EACE,wBAAA;EACA,8BAAA;AhB2/RF;;AgBx/RA;EZ9BE,gEY+BA;EZ9BA,6DY8BA;EZ7BA,2DY6BA;EZ5BA,wDY4BA;AhB8/RF;;AgB3/RA;EACE,wBAAA;AhB8/RF;;AgB3/RA;EACE,oCAAA;EACA,6CAAA;AhB8/RF;;AgBv/RA;EACE,oBAAA;AhB0/RF;;AgBv/RA;EACE,gCAAA;AhB0/RF;;AgBv/RA;EACE,2BAAA;AhB0/RF;;AgBv/RA;EACE,WAAA;AhB0/RF;;AgBv9RA;EACE,gCAAA;AhB09RF;;AgBv9RA;EACE,sCAAA;AhB09RF;AgBz9RE;EACE,cAAA;AhB29RJ;;AgBv9RA;EACE,wBAAA;AhB09RF;;AgBv9RA;EACE,wBAAA;AhB09RF;;AgBv9RA;EACE,wBAAA;AhB09RF;;AgBv9RA;EACE,wBAAA;AhB09RF;;AgBv9RA;EACE,2BAAA;AhB09RF;;AgBv9RA;EACE,4BAAA;AhB09RF;;AgBv9RA;EACE,qBAAA;EACA,cbjFY;EakFZ,0BAAA;AhB09RF;AgBz9RE;EACE,gBAAA;EACA,0CAAA;EACA,cbtFU;EauFV,wBAAA;EACA,eAAA;EACA,sBAAA;AhB29RJ;AgBx9RE;EAEE,qBAAA;AhBy9RJ;;AgBr9RA;EACE,mBb3BoB;AHm/RtB;;AgBr9RA;EACE,mBb9BkB;AHs/RpB;;AgBr9RA;EACE,mBbjCkB;AHy/RpB;;AgBr9RA;EACE,cAAA;AhBw9RF;;AgBt9RA;EACE,mBAAA;AhBy9RF;AgBv9RE;EACE,0BAAA;EACA,gBAAA;AhBy9RJ;AgBv9RI;EACE,aAAA;EACA,mBAAA;AhBy9RN;AgBt9RQ;EACE,cAAA;AhBw9RV;AgBp9RQ;EACE,gBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AhBs9RV;AgBp9RU;EACE,iBAAA;EACA,yBAAA;AhBs9RZ;AgBj9RQ;EACE,SAAA;AhBm9RV;AgB78RE;EACE,UAAA;EACA,6BAAA;EACA,gBAAA;AhB+8RJ;AgB58RE;EA7CF;IA8CI,mBAAA;EhB+8RF;AACF;;AgB58RA;EACE,eb1Me;Ea2Mf,cX3MS;EW4MT,gBAAA;AhB+8RF;AgB98RE;EACE,8BAAA;AhBg9RJ;;AgB58RA;EACE,gBAAA;AhB+8RF;AgB98RE;EACE,kBAAA;AhBg9RJ;AgB/8RI;EACE,uBAAA;AhBi9RN;;AgB38RA;EZ1OE,mCY2OA;EZ1OA,gCY0OA;EZzOA,8BYyOA;EZxOA,2BYwOA;AhBi9RF;;AgB98RA;EZ9OE,mDY+OA;EZ9OA,gDY8OA;EZ7OA,8CY6OA;EZ5OA,2CY4OA;AhBo9RF;;AgBj9RA;EZlPE,mDYmPA;EZlPA,gDYkPA;EZjPA,8CYiPA;EZhPA,2CYgPA;AhBu9RF;;AgBp9RA;EZtPE,qDYuPA;EZtPA,kDYsPA;EZrPA,gDYqPA;EZpPA,6CYoPA;AhB09RF;;AgBv9RA;EZ1PE,mDY2PA;EZ1PA,gDY0PA;EZzPA,8CYyPA;EZxPA,2CYwPA;AhB69RF;;AgB19RA;EZ9PE,kDY+PA;EZ9PA,+CY8PA;EZ7PA,6CY6PA;EZ5PA,0CY4PA;AhBg+RF;;AgB59RE;EACE,cAAA;AhB+9RJ;;AgB19RA;EACE,mBAAA;AhB69RF;AgB59RE;EACE,gCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AhB89RJ;;AgB19RA;EACE,oCAAA;AhB69RF;;AgB19RA;EACE,iBAAA;AhB69RF;;AgBr9RM;EACE,gCAAA;AhBw9RR;;AgBz9RM;EACE,gCAAA;AhB49RR;;AgB79RM;EACE,gCAAA;AhBg+RR;;AgBj+RM;EACE,gCAAA;AhBo+RR;;AgBr+RM;EACE,gCAAA;AhBw+RR;;AgBz+RM;EACE,gCAAA;AhB4+RR;;AgB7+RM;EACE,gCAAA;AhBg/RR;;AgBj/RM;EACE,gCAAA;AhBo/RR;;AgBr/RM;EACE,gCAAA;AhBw/RR;;AgBz/RM;EACE,gCAAA;AhB4/RR;;AgB7/RM;EACE,gCAAA;AhBggSR;;AgBjgSM;EACE,gCAAA;AhBogSR;;AgBrgSM;EACE,gCAAA;AhBwgSR;;AgBzgSM;EACE,gCAAA;AhB4gSR;;AgB7gSM;EACE,gCAAA;AhBghSR;;AgBjhSM;EACE,gCAAA;AhBohSR;;AgBrhSM;EACE,gCAAA;AhBwhSR;;AgBzhSM;EACE,gCAAA;AhB4hSR;;AgB7hSM;EACE,gCAAA;AhBgiSR;;AgBjiSM;EACE,gCAAA;AhBoiSR;;AgB5hSA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AhB+hSF;AgB7hSE;EACE,kBAAA;EACD,uBAAA;EACC,QAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,oCAAA;EACA,gCAAA;AhB+hSJ;AgB5hSE;EACE,WAAA;EACA,YAAA;AhB8hSJ;;AgB7+RA;EACE,eAAA;AhBg/RF;;AgB7+RA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cX3WS;AL21SX;AgB9+RE;EACE,cAAA;AhBg/RJ;;AgB5+RA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AhB++RF;;AgB5+RA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AhB++RF;;AgB5+RA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AhB++RF;;AgB7+RA;EACE,4CAAA;EACA,oCAAA;AhBg/RF;;AgB7+RA;EACE,gBAAA;AhBg/RF;;AgB7+RA;EACE,eAAA;EACA,iBAAA;EZnUE,kBD9DY;EamYd,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AhBg/RF;;AgB7+RA;EACE,gCAAA;AhBg/RF;;AgB7+RA;EACE,yBAAA;EACA,uBAAA;AhBg/RF;AgB9+RE;EACE,yBAAA;EACA,uBAAA;AhBg/RJ;;AgB5+RA;EACE,0BAAA;AhB++RF;;AiBz6SA,oBAAA;AACA;;EAEE,gBdyBqB;EcxBrB,kBAAA;EACA,cdyBe;AHm5SjB;;AiBz6SA;EACE,edUa;AHk6Sf;;AiBz6SA;EACE,edOa;AHq6Sf;;AiBz6SA;EACE,edIa;AHw6Sf;;AiBz6SA;EACE,edCa;AH26Sf;;AiBz6SA;EACE,edFa;AH86Sf;;AiBz6SA;EACE,edLa;AHi7Sf;;AiBz6SA;EACE,wCAAA;AjB46SF;;AiBz6SA;EACE;IACE,edlBW;EH87Sb;EiBz6SA;IACE,edrBW;EHg8Sb;EiBx6SA;IACE,edxBW;EHk8Sb;AACF;AiBv6SA;EACE,gBAAA;AjBy6SF;AiBx6SE;EACE,kBdsBc;EcrBd,gCAAA;EACA,0BAAA;EACA,wBAAA;AjB06SJ;AiBx6SI;EACE,qBAAA;AjB06SN;AiBv6SI;EACE,kBAAA;AjBy6SN;AiBn6SI;EACE,qBAAA;AjBq6SN;AiBn6SM;EACE,yBZ5DG;ALi+SX;;AkB9+SA;+EAAA;ACAA,oBAAA;AACA;EACE,2CAAA;AnBm/SF;;AmBh/SA;;EAEE,aAAA;EACA,WAAA;EACA,YAAA;AnBm/SF;;AmBh/SA;EfiDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aepDsB;EfqDtB,2BerD4B;EfsD5B,uBetD4B;EfuD5B,mBevD4B;EfwD5B,yBexDiC;EfyDjC,qBezDiC;Ef0DjC,iBe1DiC;EACjC,WAAA;AnB6/SF;;AmB1/SA;EACE;;;8BAAA;AnBggTF;;AmB1/SA;EfqCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aexCsB;EfyCtB,8BezC4B;Ef0C5B,0Be1C4B;Ef2C5B,sBe3C4B;Ef4C5B,yBe5CoC;Ef6CpC,qBe7CoC;Ef8CpC,iBe9CoC;EACpC,WAAA;EACA,gBAAA;EACA,kBAAA;AnBugTF;;AmBpgTA;EACE,gBhBuFe;EgBtFf,WAAA;EACA,kBAAA;AnBugTF;;AmBpgTA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AnBugTF;AmBrgTE;EACE,gBAAA;EACA,gBAAA;AnBugTJ;AmBrgTE;EACE,eAAA;EACA,cAAA;AnBugTJ;AmBrgTE;EACE,YAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AnBugTJ;AmBrgTI;EACE,cAAA;EACA,UAAA;AnBugTN;AmBpgTE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AnBsgTJ;AmBngTI;EACE,YAAA;AnBqgTN;AmBngTM;EACE,UAAA;AnBqgTR;AmBhgTI;EACC,qBAAA;AnBkgTL;AmBhgTI;EACE,qBAAA;EACA,UAAA;AnBkgTN;AmB//SM;EACE,YAAA;AnBigTR;AmB//SQ;EACE,UAAA;AnBigTV;;AmB1/SA;EACE,OAAA;Ef1CA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aeuCsB;EftCtB,8BesC4B;EfrC5B,0BeqC4B;EfpC5B,sBeoC4B;EfnC5B,yBemCoC;EflCpC,qBekCoC;EfjCpC,iBeiCoC;EACpC,WAAA;EACA,kBAAA;EACA,gBAAA;AnBugTF;AmBrgTE;EACE,oCAAA;AnBugTJ;;AmBjgTI;EACE,sBAAA;EfhFJ,kEeiFI;EfhFJ,6DegFI;Ef/EJ,0De+EI;AnBsgTN;AmBjgTI;EACE,sBAAA;EfvFJ,kEewFI;EfvFJ,6DeuFI;EftFJ,0DesFI;AnBqgTN;AmBlgTI;EACE,kBAAA;AnBogTN;AmB//SI;EACE,sBAAA;EflGJ,kEemGI;EflGJ,6DekGI;EfjGJ,0DeiGI;AnBmgTN;AmBhgTI;EACE,WhBxBc;EgByBd,ehBzBc;EgB0Bd,ehB1Bc;AH4hTpB;;AmB7/SA;EACE,aAAA;AnBggTF;;AmB9/SA;EACE,iCAAA;AnBigTF;;AmB//SA;EACE,uBAAA;EACA,gBAAA;AnBkgTF;;AmBhgTA;EACE,kBAAA;AnBmgTF;;AmBjgTA;EACE,mBAAA;AnBogTF;;AmBlgTA;EACE,UAAA;AnBqgTF;;AmBngTA;EACE,yCAAA;AnBsgTF;;AmBngTE;EACE,gBAAA;AnBsgTJ;;AmBjgTI;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,qCAAA;AnBogTN;AmBjgTQ;EACE,yBAAA;AnBmgTV;AmBjgTU;EACE,gBAAA;AnBmgTZ;;AmBz/SM;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AnB4/SR;AmBt/SQ;EACE,oCAAA;AnBw/SV;;AmBj/SA,iCAAA;AACA;EACE,kCAAA;EACA,yBAAA;EACA,YAAA;AnBo/SF;AmBl/SE;EACE,YAAA;AnBo/SJ;AmBl/SE;EACE,YAAA;AnBo/SJ;AmBl/SE;EACE,iBAAA;AnBo/SJ;AmBl/SE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iFAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,gBAAA;EACA,MAAA;AnBo/SJ;AmBl/SI;EACE,0BAAA;EACA,wBAAA;EACA,aAAA;AnBo/SN;AmBl/SM;EACE,UAAA;EACA,oCAAA;ET5OJ,gDAAA;EAEF,uBAAA;ES4OM,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnBq/SR;AmBn/SQ;EACE,qBAAA;ETvPN,gDAAA;EAEF,uBAAA;ESuPQ,2CAAA;AnBs/SV;AmBl/SI;EACE,0BAAA;EACA,wBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AnBo/SN;AmBj/SQ;EACE,oCAAA;EACA,wBAAA;AnBm/SV;AmB/+SI;EACE,gBAAA;EACA,oBAAA;AnBi/SN;AmB/+SM;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AnBi/SR;AmB5+SI;EACE,iFAAA;EACA,aAAA;EACA,kEAAA;AnB8+SN;AmB3+SQ;EACE,0BAAA;AnB6+SV;AmB3+SQ;EACE,0BAAA;AnB6+SV;AmBx+SM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AnB0+SR;AmBx+SQ;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;AnB0+SV;AmBx+SQ;EACE,iBAAA;AnB0+SV;AmBt+SI;EACE,oBAAA;AnBw+SN;AmBt+SI;EACE,eAAA;EACA,iBAAA;AnBw+SN;AmBt+SM;EACE,kBAAA;EACA,qCAAA;AnBw+SR;AmBr+SQ;EACE,qCAAA;AnBu+SV;AmBp+SM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AnBs+SR;AmBp+SQ;EACE,qCAAA;AnBs+SV;AmBn+SM;EACE,eAAA;AnBq+SR;AmBn+SM;EACE,qBAAA;ET9VJ,gDAAA;EAEF,uBAAA;ES8VM,aAAA;EACA,SAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;AnBs+SR;AmBp+SM;EACE,qBAAA;ETvWJ,gDAAA;EAEF,uBAAA;ESuWM,aAAA;EACA,gBAAA;EACA,mBAAA;AnBu+SR;AmBp+SQ;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AnBs+SV;AmBn+SY;EACE,0CAAA;AnBq+Sd;AmBl+SU;EACE,YAAA;AnBo+SZ;AmBj+SQ;EACE,WAAA;EACA,sBAAA;AnBm+SV;AmBh+SM;EACE,aAAA;EACA,YAAA;EACA,wBAAA;EACA,2CAAA;EACA,yBAAA;ETzYJ,gDAAA;EAEF,uBAAA;ESyYM,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;AnBm+SR;AmBj+SQ;EAEE,yBAAA;EACA,2CAAA;AnBk+SV;AmB99SI;EACE,mBAAA;AnBg+SN;AmB79SQ;EACE,mBAAA;AnB+9SV;AmBz9SI;EACE,iBAAA;AnB29SN;AmBx9SE;EACE,0BAAA;EACA,uBAAA;AnB09SJ;AmBx9SE;EACE,oCAAA;AnB09SJ;AmBx9SE;EACE,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AnB09SJ;AmBx9SI;EACE,0BAAA;AnB09SN;AmBx9SI;EACE,yBAAA;EACA,0BAAA;AnB09SN;AmBv9SE;EACE,qBAAA;ET5bA,gDAAA;EAEF,uBAAA;AVq5TF;AmBx9SE;EACE,yBAAA;EACA,0BAAA;EACA,qBAAA;ETlcA,gDAAA;EAEF,uBAAA;AV45TF;AmBz9SI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AnB29SN;AmBx9SE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ET/cA,gDAAA;EAEF,uBAAA;AVy6TF;AmBz9SI;EACE,oCAAA;AnB29SN;AmBz9SM;EACE,2CAAA;AnB29SR;AmBz9SM;EACE,yBAAA;AnB29SR;AmBv9SE;EACE,cAAA;AnBy9SJ;AmBv9SE;EACE,qBAAA;AnBy9SJ;AmBv9SE;EACE,yBAAA;ETpeA,gDAAA;EAEF,uBAAA;AV67TF;AmBx9SE;EACE,kBAAA;EACA,mCAAA;AnB09SJ;AmBx9SE;EACE,WAAA;AnB09SJ;AmBx9SI;EACE,WAAA;AnB09SN;AmBx9SM;EACE,kBAAA;AnB09SR;AmBv9SI;EACE,2CAAA;EACA,aAAA;EACA,sBAAA;ETxfF,gDAAA;EAEF,uBAAA;ESwfI,qBAAA;AnB09SN;AmBt9SQ;EACE,mBAAA;AnBw9SV;AmBp9SI;ETngBA,gDAAA;EAEF,uBAAA;ESmgBI,qBAAA;AnBu9SN;AmBr9SI;ETvgBA,gDAAA;EAEF,uBAAA;ESugBI,wBAAA;AnBw9SN;;AmBp9SA;EACE,0BAAA;EACA,UAAA;EACA,iCAAA;EACA,iCAAA;EACA,2DAAA;EACA,gEAAA;EACA,2DAAA;EACA,gEAAA;EACA,yDAAA;AnBu9SF;AmBp9SI;EACE,mBAAA;EACA,aAAA;AnBs9SN;;AmBj9SE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;AnBo9SJ;AmBl9SI;ETziBA,gDAAA;EAEF,uBAAA;ESyiBI,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AnBq9SN;AmBn9SM;EACE,qBAAA;ETrjBJ,gDAAA;EAEF,uBAAA;ESqjBM,2CAAA;AnBs9SR;;AmBj9SA;EACE,aAAA;EACA,gCAAA;AnBo9SF;;AmBl9SA;;EAEE,qBAAA;ETlkBE,gDAAA;EAEF,uBAAA;ESkkBA,mBAAA;EACA,oCAAA;AnBs9SF;;AmBp9SA;EACE,oBAAA;AnBu9SF;AmBr9SE;EACE,2BAAA;AnBu9SJ;AmBr9SE;EACE,4BAAA;AnBu9SJ;;AmBp9SA;EACE,kBAAA;EACA,mCAAA;AnBu9SF;AmBr9SE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AnBu9SJ;;AmBp9SA;EACE,2CAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;AnBu9SF;AmBr9SE;EACE,yBAAA;EACA,sBAAA;AnBu9SJ;AmBr9SE;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;AnBu9SJ;;AmBn9SE;EACE,2BAAA;AnBs9SJ;AmBj9SQ;EACE,cAAA;AnBm9SV;AmBh9SM;EACE,cAAA;AnBk9SR;AmBh9SQ;EACE,cAAA;AnBk9SV;AmB78SM;EACE,qEAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AnB+8SR;AmB78SM;EACE,oCAAA;AnB+8SR;AmB78SQ;EACE,aAAA;EACA,mBAAA;ET/oBN,gDAAA;EAEF,uBAAA;ES+oBQ,qBAAA;AnBg9SV;AmB58SQ;EACE,6BAAA;AnB88SV;AmB58SU;EACE,gBAAA;AnB88SZ;AmB58SU;EACE,yBAAA;AnB88SZ;AmB58SU;EACE,aAAA;EACA,mBAAA;AnB88SZ;AmB38Sc;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AnB68ShB;AmB38SgB;EACE,YAAA;AnB68SlB;AmB18Sc;EACE,WAAA;EACA,sBAAA;AnB48ShB;AmBz8SY;ETprBR,gDAAA;EAEF,uBAAA;ESorBY,qBAAA;AnB48Sd;AmBz8SU;EACE,mBAAA;EACA,SAAA;AnB28SZ;AmBv8SgB;;EAEE,WAAA;EACA,eAAA;AnBy8SlB;AmBv8SgB;EACE,uBAAA;AnBy8SlB;AmBp8SkB;EACE,qBAAA;AnBs8SpB;AmBh8SsB;EACE,uBAAA;AnBk8SxB;AmB37SY;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AnB67Sd;AmB37Sc;EACE,mBAAA;AnB67ShB;AmBz7SU;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AnB27SZ;AmBz7SY;EACE,uBAAA;AnB27Sd;AmBz7SY;;EAEE,YAAA;EACA,YAAA;AnB27Sd;AmBz7Sc;;EACE,UAAA;AnB47ShB;AmBz7SY;EACE,gBAAA;AnB27Sd;AmBv7SgB;EACE,yBAAA;AnBy7SlB;AmBj7SQ;EACE,0BAAA;AnBm7SV;;AmB56SA;EACE,qBAAA;EACA,iBAAA;AnB+6SF;;AoB5sUA,iBAAA;AAEA;EACE,WAAA;EACA,iCAAA;EACA,sBAAA;EACA,+CAAA;EACA,wBAAA;ApB8sUF;AoB5sUE;EACE,6CjBkDgB;EiBjDhB,6BAAA;ApB8sUJ;AoB3sUE;EACE,oBAAA;EACA,kCAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;ApB6sUJ;AoBzsUI;EACE,cjB6BQ;EiB5BR,eAAA;EACA,ejBXW;EiBYX,gBAAA;EACA,mBAAA;ApB2sUN;;AoBrsUE;EACE,eAAA;ApBwsUJ;;AoBpsUA,gBAAA;AACA;EACE,kBAAA;EACA,ejB3Be;EiB4Bf,6BAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;ApBusUF;;AoBpsUA;EACE,kBAAA;EACA,sBAAA;ApBusUF;;AoBnsUE;EACE,gBAAA;ApBssUJ;AoBpsUE;EACE,aAAA;ApBssUJ;AoBpsUE;EACE,cAAA;ApBssUJ;AoBlsUI;EACE,cAAA;ApBosUN;AoBjsUE;EACE,oBAAA;ApBmsUJ;;AoB/rUA;EACE,WjBlBmB;EiBmBnB,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EhBcE,gBgBbqB;ApBksUzB;AoBhsUE;EACE,gBAAA;EACA,oBAAA;ApBksUJ;;AoB7rUE;EACE,WjBlCiB;EiBmCjB,iBAAA;EACA,eAAA;EACA,yBAAA;ApBgsUJ;AoB9rUI;EACE,gBAAA;ApBgsUN;;AoB3rUA;EACE,cjBpDY;AHkvUd;;AoB3rUA;EACE,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;ApB8rUF;;AoB3rUA;EACE,kBAAA;EACA,wBAAA;EACA,0BAAA;ApB8rUF;;AoB3rUA;EACE,0BAAA;ApB8rUF;;AoB3rUA;EACE,0BAAA;ApB8rUF;;AoB3rUA;EACE,2BAAA;ApB8rUF;;AoB3rUA;EACE,gBAAA;EACA,yBAAA;EAEA,cjBrFY;EC2CV,kBD9DY;EiB0Gd,qBAAA;ApB6rUF;;AoB1rUA;;;EAGE,cjB7FY;AH0xUd;;AoBzrUE;EhBjHA,wCgBkHE;EhBjHF,mCgBiHE;EhBhHF,gCgBgHE;EACA,WjBpCgB;AHkuUpB;AoB5rUI;EAEE,aAAA;ApB6rUN;AoB1rUI;EACE,wBAAA;ApB4rUN;AoBzrUI;EACE,wBAAA;ApB2rUN;AoBxrUI;EACE,kBAAA;ApB0rUN;AoBzrUM;EACE,oBAAA;ApB2rUR;AoBxrUM;EACE,gBAAA;ApB0rUR;AoBrrUM;EACE,aAAA;ApBurUR;AoBnrUI;EACE,aAAA;ApBqrUN;;AoB/qUE;EACE,YjB7Ea;AH+vUjB;AoBhrUI;EACE,gCAAA;ApBkrUN;AoB/qUI;EACE,wBAAA;ApBirUN;AoB9qUI;EACE,yBAAA;ApBgrUN;AoB7qUI;EACE,wBAAA;ApB+qUN;AoB3qUM;EACE,gBAAA;ApB6qUR;AoB5qUQ;EACE,uBAAA;ApB8qUV;AoB3qUQ;EACE,iBAAA;ApB6qUV;AoBzqUM;EACE,kBAAA;EACA,wBAAA;EACA,0BAAA;ApB2qUR;AoBxqUM;EACE,0BAAA;ApB0qUR;AoBvqUM;EACE,0BAAA;ApByqUR;AoBtqUM;EACE,2BAAA;ApBwqUR;AoBnqUM;EACE,cAAA;ApBqqUR;AoBjqUI;EACE,aAAA;ApBmqUN;AoBhqUI;EACE,cAAA;ApBkqUN;;AoB7pUA;EACE,kBAAA;ApBgqUF;AoB/pUE;EACE,YAAA;EACA,eAAA;ApBiqUJ;;AoB3pUI;EACE,eAAA;ApB8pUN;;AoBxpUE;EAEE,aAAA;ApB0pUJ;;AoBtpUA;EACE,eAAA;EACA,2CAAA;EACA,mCAAA;ApBypUF;AoBvpUE;EACC,qBAAA;EACC,oCAAA;EACA,4BAAA;EACA,YAAA;ApBypUJ;AoBtpUE;EACC,mBAAA;EACC,mCAAA;EACA,2BAAA;EACA,YAAA;ApBwpUJ;AoBrpUE;EACE,YAAA;ApBupUJ;AoBppUE;EACE,YAAA;ApBspUJ;AoBxoU0B;EACE,gBAAA;ApB0oU5B;AoBhoUsB;EACE,gBAAA;ApBkoUxB;;AoBpnUA;EACE,kBAAA;ApBunUF;AoBtnUE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;ApBwnUJ;;AoBpnUA;EACE,YAAA;EACA,eAAA;EACA,MAAA;EACD,qBAAA;EACA,mBAAA;EACC,SAAA;EACA,UAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,aAAA;EACA,0BAAA;ApBunUF;;AoBnnUE;EACE,kBAAA;ApBsnUJ;AoBpnUE;EACE,kBAAA;ApBsnUJ;AoBhnUU;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;ApBknUZ;AoB/mUQ;EACE,UAAA;EACA,yBAAA;ApBinUV;AoB/mUQ;EACE,UAAA;EACA,yBAAA;ApBinUV;AoB9mUU;EACE,0BAAA;EACA,UAAA;EACA,yBAAA;ApBgnUZ;AoB7mUY;EACE,sBAAA;EACA,UAAA;ApB+mUd;AoB5mUU;EACE,0BAAA;EACA,UAAA;EACA,yBAAA;ApB8mUZ;AoB3mUY;EACE,sBAAA;EACA,UAAA;ApB6mUd;AoBvmUI;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;ApBymUN;;AqBphVA,gBAAA;AACA;EACE,wBAAA;EjB+EA,8CiB9EyB;EjB+EzB,sCiB/EyB;EAEzB,yBAAA;EAEA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;ArBshVF;;AqBnhVA;EACE,sBhBLM;EgBMN,clBwCa;EkBvCb,gBAAA;EACA,kBAAA;EACA,mBAAA;ArBshVF;AqBphVE;EjBgBA,wCiBfE;EjBgBF,mCiBhBE;EjBiBF,gCiBjBE;EACA,6BAAA;EACA,clBgCW;AHw/Uf;AqBvhVI;EACE,MAAA;ArByhVN;AqBxhVM;EACE,+BAAA;ArB0hVR;AqBthVI;EACE,yBlBwDI;EkBvDJ,clBsBS;AHkgVf;AqBthVQ;EACE,+BAAA;ArBwhVV;AqBlhVE;EACE,gCAAA;ArBohVJ;AqBjhVE;EACE,yBAAA;EjBgDA,kBD7De;AHiiVnB;;AqB/gVA;EACE,uBAAA;ArBkhVF;AqBhhVE;EACE,YAAA;ArBkhVJ;AqBhhVI;EAHF;IAII,YAAA;ErBmhVJ;AACF;AqBhhVE;EACE,uBAAA;ArBkhVJ;AqBhhVI;EAHF;IAII,uBAAA;ErBmhVJ;AACF;;AqB9gVA;EACE,wBAAA;ArBihVF;;AqB9gVA;EACE;IACE,wBAAA;ErBihVF;AACF;AqB9gVA;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;ArBghVF;;AqB7gVA;EACE,gBlB4Be;EkB3Bf,eAAA;ArBghVF;AqB9gVE;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;ArBghVJ;AqB9gVI;EALF;IAMI,YAAA;ErBihVJ;AACF;AqB/gVI;EATF;IAUI,YAAA;ErBkhVJ;AACF;AqBhhVI;EAbF;IAcI,yBAAA;IACA,YAAA;ErBmhVJ;AACF;AqBhhVE;EAvBF;IAwBI,eAAA;ErBmhVF;AACF;AqBjhVE;EACE,gBAAA;ArBmhVJ;;AqB7gVI;EADF;IAEI,uBAAA;ErBihVJ;AACF;;AqB5gVE;EACE,YAAA;ArB+gVJ;AqB7gVI;EAHF;IAII,YAAA;ErBghVJ;AACF;AqB9gVI;EAPF;IAQI,YAAA;ErBihVJ;AACF;;AqB3gVI;EACE,sBAAA;EACA,WAAA;ArB8gVN;AqB3gVI;EjBlHF,wCiBmHI;EjBlHJ,mCiBkHI;EjBjHJ,gCiBiHI;EACA,sBhB/IE;EgBgJF,WlBhEO;AH+kVb;AqB7gVQ;EACE,4BAAA;ArB+gVV;AqB3gVM;EACE,6BAAA;EACA,WlBzEK;AHslVb;AqB3gVU;EACE,4BAAA;ArB6gVZ;;AqBrgVA;EACE,gBAAA;ArBwgVF;AqBtgVE;EACE,sBAAA;ArBwgVJ;AqBrgVM;EACE,aAAA;ArBugVR;AqBrgVQ;EACE,eAAA;EACA,gBAAA;ArBugVV;AqB//UM;EACE,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ArBigVR;AqB3/UI;EADF;IAEI,oBAAA;ErB8/UJ;AACF;AqB3/UE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;ArB6/UJ;AqB3/UI;EACE,cAAA;ArB6/UN;;AqBx/UA;EjB3NE,wBiB4NA;EjB3NA,qBiB2NA;EjB1NA,mBiB0NA;EjBzNA,gBiByNA;ArB8/UF;;AqBv/UI;EACE,sBAAA;EACA,aAAA;EACA,0BAAA;EACA,gCAAA;EACA,WAAA;ArB0/UN;AqBv/UI;EACE,0CAAA;EACA,wCAAA;EACA,6BAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACD,qBAAA;EACC,WAAA;ArBy/UN;AqBt/UI;EACE,0CAAA;EACA,wCAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACD,qBAAA;EACC,WAAA;ArBw/UN;AqBr/UI;EAlCF;IAmCI,YAAA;ErBw/UJ;AACF;AqBt/UI;EAtCF;IAuCI,YAAA;ErBy/UJ;AACF;AqBt/UE;EACE,kBAAA;ArBw/UJ;AqBr/UE;EACE,kBAAA;EACD,wBAAA;EACC,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;ArBu/UJ;;AqBl/UE;EACE,YAAA;EACD,gCAAA;EACA,iCAAA;ArBq/UH;AqBl/UE;EACC,sBAAA;EACA,uBAAA;ArBo/UH;AqBj/UE;EACC,sBAAA;EACA,uBAAA;ArBm/UH;AqBh/UE;EAjBF;IAkBI,aAAA;ErBm/UF;AACF;;AqBh/UA;EACE;IACE,YAAA;ErBm/UF;AACF;AqBh/UA;EACE;IACE,YAAA;ErBk/UF;AACF;AqB/+UA;EACE,yBAAA;ArBi/UF;;AqB9+UA;EACE,oBAAA;ArBi/UF;;AqB9+UA;EACE,kBAAA;EACA,uBAAA;EACA,gCAAA;ArBi/UF;AqB/+UE;EACE,clBzRU;AH0wVd;AqB9+UE;EACE,eAAA;EACA,6BAAA;ArBg/UJ;AqB9+UI;EACE,2BAAA;ArBg/UN;AqB5+UE;EACE,qBAAA;ArB8+UJ;AqB3+UE;EACE,+BAAA;ArB6+UJ;AqB1+UE;EACE,0BAAA;EACA,uBAAA;ArB4+UJ;;AqBv+UE;EACE,clBlTW;AH4xVf;AqBv+UE;EACE,kBAAA;ArBy+UJ;AqBv+UI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACD,mBAAA;EACC,MAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBlBnSG;ECUL,kBiB0RyB;ArBy+U7B;AqBp+UE;EACE,kCAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;ArBs+UJ;;AqBl+UA;EjB1UE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BiBmTqB;EjBlTrB,mBiBkTqB;ArBg/UvB;;AqB7+UA;EACE,kBAAA;EACA,aAAA;ArBg/UF;;AsB93VA,gBAAA;AAEE;ElB2DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJi1VnE;;AsBt4VA;EACE,kBAAA;AtBy4VF;AsBv4VE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,sBjBRI;EiBSJ,kBAAA;ElB6EA,kBkB5EuB;ElBiBzB,wCkBhBE;ElBiBF,mCkBjBE;ElBkBF,gCkBlBE;AtB24VJ;;AsBv4VA;EACE,2BAAA;AtB04VF;;AsBv4VA;EACE,yBnBuBY;AHm3Vd;AsBv4VI;EACE,eAAA;AtBy4VN;AsBt4VI;EACE,WjB5BE;EiB6BF,eAAA;AtBw4VN;AsBr4VI;EAKE,cnBQM;AH23VZ;AsBh4VI;EACE,aAAA;AtBk4VN;;AuBr7VA,sBAAA;AACA;EACE,OAAA;EACA,WAAA;AvBw7VF;;AuBr7VA;EACE,eAAA;AvBw7VF;AuBt7VE;EACE,0BAAA;EACA,aAAA;AvBw7VJ;AuBt7VI;EACE,kBAAA;EACA,UAAA;AvBw7VN;AuBr7VE;EACE,0BAAA;AvBu7VJ;AuBr7VI;EACE,oCAAA;AvBu7VN;AuBp7VE;EACE,WAAA;AvBs7VJ;;AuBn7VA;EACE,wBAAA;EACA,oBAAA;EACA,WAAA;AvBs7VF;AuBp7VE;EALF;IAMI,oBAAA;IACA,oBAAA;EvBu7VF;AACF;;AwB59VA,gBAAA;AAEA;EACE,eAAA;EACA,WrBuDmB;EqBtDnB,iBrBqHc;EqBpHd,gBrBoHc;EqBnHd,yBAAA;EACA,gBAAA;EACA,cAAA;AxB89VF;AwB59VE;EACE,WrB+CiB;AH+6VrB;AwB79VI;EACE,crBuCQ;AHw7Vd;AwB39VE;EAhBF;IAiBI,aAAA;ExB89VF;AACF;;AyBl/VA,uBAAA;AACA;ErB4DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqB/DsB;ErBgEtB,8BqBhE4B;ErBiE5B,0BqBjE4B;ErBkE5B,sBqBlE4B;ErBmE5B,yBqBnEoC;ErBoEpC,qBqBpEoC;ErBqEpC,iBqBrEoC;EACpC,gBAAA;EACA,YAAA;AzB+/VF;AyB7/VE;EALF;IAMI,gBAAA;EzBggWF;AACF;;AyB7/VA;EACE,yBtByCY;EsBxCZ,WpBHM;EoBIN,uBAAA;EACA,yBAAA;ErB8CA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BqBrEqB;ErBsErB,mBqBtEqB;ErBgErB,sCqB/DyB;ErBgEzB,8BqBhEyB;AzB4gW3B;AyB1gWE;EACE,gBAAA;AzB4gWJ;;AyBxgWA;EACE,kBAAA;AzB2gWF;AyBzgWE;EACE,mBAAA;AzB2gWJ;AyBxgWE;EAPF;IAQI,kBAAA;EzB2gWF;AACF;;AyBxgWA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzB2gWF;AyBzgWE;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AzB2gWJ;AyBxgWE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;AzB0gWJ;AyBxgWI;EACE,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACD,qBAAA;EACC,WpBzDE;EoB0DF,kBAAA;EACA,aAAA;EACA,UAAA;AzB0gWN;AyBrgWI;EACE,cAAA;AzBugWN;;AyBhgWI;EACE,WAAA;EACA,kBAAA;EACD,qBAAA;EACC,MAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;AzBmgWN;;AyB7/VA;EACE,eAAA;EACA,QAAA;EACD,mBAAA;EACC,aAAA;EACA,yBAAA;ErBqBE,2BDzFY;EC0FZ,8BD1FY;EChCd,kDqBsGA;ErBrGA,+CqBqGA;ErBpGA,6CqBoGA;ErBnGA,0CqBmGA;EACA,WpB/FM;ALmmWR;AyBlgWE;EACE,kBAAA;EACA,aAAA;AzBogWJ;;AyBhgWA;EACE,aAAA;EACA,WtBzBW;EsB0BX,sBpB1GM;AL6mWR;;AyB//VA;EACE,mBAAA;AzBkgWF;AyBhgWE;EACE,aAAA;AzBkgWJ;AyB//VE;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AzBigWJ;AyB//VI;EACE,wBAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AzBigWN;AyB9/VI;EACE,8BAAA;EACA,mBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;EACD,wBAAA;EACC,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AzBggWN;AyB5/VE;EACE,gBpB9II;EoB+IJ,YAAA;AzB8/VJ;AyB3/VE;EACE,mBpBtJO;EoBuJR,wBAAA;AzB6/VH;;AyBz/VA;EACE;IACE,6BAAA;EzB4/VF;AACF;A0B3qWA;+EAAA;ACAA,eAAA;AACA;EACE,cAAA;EACA,kBAAA;EvB6FE,kBD7De;EwB9BjB,kBAAA;A3B+qWF;A2B7qWE;EACE,oBAAA;EACA,gBtB8NgB;ALi9VpB;A2B5qWE;EACE,WxB2IM;EwB1IN,oCAAA;EvB+CF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,auBlDwB;EvBmDxB,8BuBnD8B;EvBoD9B,0BuBpD8B;EvBqD9B,sBuBrD8B;EvBsD9B,yBuBtDsC;EvBuDtC,qBuBvDsC;EvBwDtC,iBuBxDsC;EvBkEtC,+BuBjE2B;EvBkE3B,uBuBlE2B;EvBsE3B,2BuBrEuB;EvBsEvB,mBuBtEuB;EACrB,kBAAA;EACD,qBAAA;EACC,MAAA;EACA,SAAA;EACA,UAAA;A3B0rWJ;;A2BtrWA;EACE,wBxB6HQ;AH4jWV;;A2BtrWA;EACE,0BxB0HQ;AH+jWV;;A4BxtWA,gBAAA;AACA;EAEE,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ExBoEA,+BwBnEyB;ExBoEzB,uBwBpEyB;ExBwEzB,2BwBvEqB;ExBwErB,mBwBxEqB;EACrB,sBAAA;EACA,cAAA;ExB+EE,kBwB9EqB;EACvB,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBzBsDU;AHsqWZ;A4B1tWE;EACE,cAAA;A5B4tWJ;;A4BxtWA;ExBgCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,+BwBvDqB;ExBwDrB,uBwBxDqB;A5BsuWvB;A4BpuWE;EACE,eAAA;EACA,OAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;A5BsuWJ;;A4BjuWE;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;A5BouWJ;A4BluWE;EACE,eAAA;EACA,gBAAA;EACA,cvBpCO;ALwwWX;;A4BhuWA;EACE,kBAAA;A5BmuWF;A4BjuWE;EACE,sBAAA;A5BmuWJ;;A6B9xWA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EzB2FE,kBD/De;AHswWnB;A6B/xWE;EACE,uBAAA;A7BiyWJ;A6B9xWE;EACE,gBAAA;A7BgyWJ;;A6B5xWA;EzB+EI,mByB9EqB;A7B+xWzB;;A6B5xWA;EACE,4BAAA;A7B+xWF;;A6B5xWA;EACE,6BAAA;EACA,yB1BiDU;AH8uWZ;;A8B1zWA,qBAAA;AACA;EACE,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;A9B6zWF;A8B3zWE;EACE,0BAAA;A9B6zWJ;;A8BzzWA;EACE,sCAAA;A9B4zWF;;A8BzzWA;EACE,2BAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;A9B4zWF;;A+Bj1WA,2BAAA;AAEE;EACE,0BAAA;A/Bm1WJ;;AgCt1WA,oBAAA;AACA;E5B+FI,kBD/De;AH0zWnB;;AgCt1WA;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,cAAA;EACA,sBAAA;AhCu1WF;;AiCn2WA,gBAAA;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,e9BUe;E8BTf,gB5BkOmB;E4BjOnB,0BAAA;EACA,gB9BwIgB;EChDd,kBD9DY;E8BxBd,mBAAA;EACA,eAAA;EACA,kBAAA;AjCq2WF;AiCn2WE;EAGE,eAAA;EACA,qBAAA;E7BhBF,mC6BiBE;E7BhBF,gC6BgBE;E7BfF,8B6BeE;E7BdF,2B6BcE;AjCs2WJ;AiCn2WE;EACE,kBAAA;AjCq2WJ;;AiC/1WA;;;EAGE,kBAAA;EACA,0BAAA;AjCk2WF;AiCh2WE;;;EACE,uBAAA;AjCo2WJ;AiCj2WE;;;EACE,gBAAA;EACA,gBAAA;AjCq2WJ;AiCl2WE;;;EACE,gBAAA;AjCs2WJ;;AiCh2WA;EACE,kBAAA;EACA,oBAAA;E7B2CE,kBD3DmB;EC4CrB,+B6BzByB;E7B0BzB,uB6B1ByB;E7B8BzB,2B6B7BqB;E7B8BrB,mB6B9BqB;EACrB,yBAAA;EACA,gBAAA;AjCo2WF;AiCl2WE;EAEE,eAAA;EACA,qBAAA;AjCm2WJ;;AiC/1WA;;EAEE,kB9BkEY;AHgyWd;AiCh2WE;;;EAEE,wBAAA;AjCm2WJ;;AiC/1WA;EACE,6BAAA;EACA,W9BUW;AHw1Wb;AiCj2WE;EAGE,yBAAA;EACA,W9BKS;AH41Wb;;AiC71WA;EACE,cAAA;AjCg2WF;AiC91WE;EACE,mBAAA;AjCg2WJ;AiC71WE;EAEE,kBAAA;AjC81WJ;;AiC11WA;E7BNI,8B6BOqB;AjC61WzB;;AiC11WA;EACE,kB9B4Be;AHi0WjB;;AiC11WA;EACE,iB9B0Be;AHm0WjB;;AiC11WA;EACE,iB9BuBe;AHs0WjB;;AiC70WA;;;EAEE,e9BrHa;AHs8Wf;AiCh1WE;;;EACE,eAAA;AjCo1WJ;;AiCh1WA;;;EAEE,eAAA;AjCo1WF;AiCn1WE;;;EACE,eAAA;AjCu1WJ;;AiCn1WA;;EAEE,e9BhBiB;AHs2WnB;AiCr1WE;;EACE,e9BlBe;AH02WnB;;AiCp1WA;E7B9FE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6B2FsB;E7B1FtB,2B6B0F4B;E7BzF5B,uB6ByF4B;E7BxF5B,mB6BwF4B;E7BvF5B,uB6BuFiC;E7BtFjC,mB6BsFiC;E7BrFjC,e6BqFiC;EACjC,gBAAA;EACA,WAAA;AjCi2WF;;AiC91WA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AjCi2WF;AiC/1WE;EAPF;IAQI,WAAA;IACA,aAAA;EjCk2WF;AACF;AiCj2WE;EACE,UAAA;AjCm2WJ;AiCl2WI;EACE,aAAA;AjCo2WN;AiCj2WI;EACE,UAAA;AjCm2WN;AiCh2WI;EACE,8BAAA;AjCk2WN;AiC91WE;EACE,kBAAA;EACD,qBAAA;EACA,mBAAA;EACC,MAAA;EACA,SAAA;EACA,aAAA;E7B3GF,2B6B4GuB;E7B3GvB,mB6B2GuB;E7BjHvB,+B6BkH2B;E7BjH3B,uB6BiH2B;EACzB,W5B1LI;AL4hXR;AiCh2WE;EACE,kBAAA;EACD,qBAAA;EACA,mBAAA;EACC,MAAA;EACA,SAAA;EACA,sBAAA;EACA,+BAAA;AjCk2WJ;AiC/1WE;EACE,kBAAA;EACD,qBAAA;EACA,mBAAA;EACC,MAAA;EACA,SAAA;EACA,gB5BlMI;E4BmMJ,YAAA;E7BlLF,yD6BmLE;E7BlLF,oD6BkLE;E7BjLF,iD6BiLE;AjCm2WJ;AiCh2WE;EACE,kBAAA;EACA,uBAAA;AjCk2WJ;AiCh2WE;EACE,WAAA;EACA,WAAA;EACA,gB5BxNI;E4ByNJ,kBAAA;EACA,YAAA;EACD,mCAAA;E7BhMD,yD6BiME;E7BhMF,oD6BgME;E7B/LF,iD6B+LE;AjCo2WJ;;AiCh2WA;EACE,cAAA;AjCm2WF;AiCj2WE;EAEE,iBAAA;AjCk2WJ;;AiC51WA;EACE,0CAAA;EACA,W9BjGQ;E8BkGR,YAAA;EACA,iBAAA;EACA,kBAAA;AjC+1WF;;AiC51WA;EACE,kBAAA;EACA,MAAA;EACD,qBAAA;EACC,SAAA;EACA,UAAA;AjC+1WF;;AiC51WA;EACE,kBAAA;EACA,MAAA;EACD,mBAAA;EACC,SAAA;EACA,UAAA;AjC+1WF;;AiC51WA;EACE,yB9BzHQ;AHw9WV;;AiC51WA;EACE,uB9B7HQ;E8B8HR,sBAAA;AjC+1WF;;AiC51WA;EACE,iBAAA;AjC+1WF;;AiC51WA;EACE,iBAAA;AjC+1WF;;AiC51WA;EACE,iBAAA;EACA,W9B3IQ;AH0+WV;;AiCx1WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL0nXR;AiC11WQ;EAEE,qEAAA;EACA,W5BnSF;AL8nXR;;AiCj2WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALmoXR;AiCn2WQ;EAEE,mEAAA;EACA,W5BnSF;ALuoXR;;AiC12WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL4oXR;AiC52WQ;EAEE,0DAAA;EACA,W5BnSF;ALgpXR;;AiCn3WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALqpXR;AiCr3WQ;EAEE,oEAAA;EACA,W5BnSF;ALypXR;;AiC53WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL8pXR;AiC93WQ;EAEE,kEAAA;EACA,W5BnSF;ALkqXR;;AiCr4WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALuqXR;AiCv4WQ;EAEE,qEAAA;EACA,W5BnSF;AL2qXR;;AiC94WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALgrXR;AiCh5WQ;EAEE,oEAAA;EACA,W5BnSF;ALorXR;;AiCv5WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALyrXR;AiCz5WQ;EAEE,mEAAA;EACA,W5BnSF;AL6rXR;;AiCh6WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALksXR;AiCl6WQ;EAEE,+CAAA;EACA,W5BnSF;ALssXR;;AiCz6WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL2sXR;AiC36WQ;EAEE,uCAAA;EACA,W5BnSF;AL+sXR;;AiCl7WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALotXR;AiCp7WQ;EAEE,mEAAA;EACA,W5BnSF;ALwtXR;;AiC37WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL6tXR;AiC77WQ;EAEE,kEAAA;EACA,W5BnSF;ALiuXR;;AiCp8WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALsuXR;AiCt8WQ;EAEE,oEAAA;EACA,W5BnSF;AL0uXR;;AiC78WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL+uXR;AiC/8WQ;EAEE,gDAAA;EACA,W5BnSF;ALmvXR;;AiCt9WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALwvXR;AiCx9WQ;EAEE,wCAAA;EACA,W5BnSF;AL4vXR;;AiC/9WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALiwXR;AiCj+WQ;EAEE,sCAAA;EACA,W5BnSF;ALqwXR;;AiCx+WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL0wXR;AiC1+WQ;EAEE,8CAAA;EACA,W5BnSF;AL8wXR;;AiCj/WM;EACE,yB1B0ES;E0BzET,W5B/RA;ALmxXR;AiCn/WQ;EAEE,mEAAA;EACA,W5BnSF;ALuxXR;;AiC1/WM;EACE,yB1B0ES;E0BzET,W5B/RA;AL4xXR;AiC5/WQ;EAEE,oEAAA;EACA,W5BnSF;ALgyXR;;AiCngXM;EACE,yB1B0ES;E0BzET,W5B/RA;ALqyXR;AiCrgXQ;EAEE,6CAAA;EACA,W5BnSF;ALyyXR;;AiC//WA;E7BlTE,kI6BmTA;E7BlTA,+H6BkTA;E7BjTA,6H6BiTA;E7BhTA,0H6BgTA;AjCqgXF;AiCpgXE;E7BpTA,kI6BsTE;E7BrTF,+H6BqTE;E7BpTF,6H6BoTE;E7BnTF,0H6BmTE;AjCwgXJ;AiCrgXE;E7BzTA,mC6B0TE;E7BzTF,gC6ByTE;E7BxTF,8B6BwTE;E7BvTF,2B6BuTE;AjC0gXJ;;AiCtgXA;;EAEE,oBAAA;EACA,aAAA;AjCygXF;;AiCtgXA;EACE,sB5B7TM;E4B8TN,W9B9OW;E8B+OX,yBAAA;AjCygXF;AiCxgXE;EAEE,6CAAA;EACA,W9BnPS;AH4vXb;;AiCrgXA;EACE,yB9B3RU;E8B4RV,W5BzUM;ALi1XR;AiCvgXE;EAEE,0DAAA;EACA,W5B7UI;ALq1XR;;AiCpgXA;EACE,6BAAA;EACA,c9BxSY;AH+yXd;AiCrgXE;EAEE,2CAAA;EACA,c9B7SU;AHmzXd;;AiCjgXE;EACE,6BAAA;EACA,W5B/VI;ALm2XR;AiClgXI;EAEE,2CAAA;EACA,W5BpWE;ALu2XR;;AiC9/WA;EACE,6BAAA;EACA,c9B9TU;AH+zXZ;AiC//WE;EAEE,yCAAA;EACA,c9BnUQ;AHm0XZ;;AiC3/WE;EACE,6BAAA;EACA,W5BvXI;ALq3XR;AiC5/WI;EAEE,2CAAA;EACA,W5B5XE;ALy3XR;;AiCx/WA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACD,qBAAA;EACA,mBAAA;EACC,UAAA;EACA,qBAAA;EACA,qCAAA;AjC2/WF;;AiCx/WA;EACE,6BAAA;EACA,+BAAA;AjC2/WF;;AiCx/WA;EACE,Y9BvQQ;E8BwQR,W9BxQQ;E8ByQR,4BAAA;EACA,2BAAA;EACA,oBAAA;E7B3UA,2B6B4UqB;E7B3UrB,mB6B2UqB;E7BjVrB,+B6BkVyB;E7BjVzB,uB6BiVyB;EACzB,eAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;AjC6/WF;AiC3/WE;EAGE,qBAAA;EACA,0BAAA;AjC2/WJ;AiCx/WE;EACE,YAAA;EACA,WAAA;EACA,eAAA;AjC0/WJ;AiCv/WE;EACE,W5B7aI;ALs6XR;;AiCr/WA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;AjCw/WF;;AiCp/WA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AjCu/WF;AiCr/WE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;AjCu/WJ;AiCp/WE;EACE,yBAAA;AjCs/WJ;AiCp/WI;EACE,yBAAA;EACA,uBAAA;AjCs/WN;AiCh/WI;EACE,WAAA;AjCk/WN;;AiC7+WA;EACE,2BAAA;EACA,gBAAA;EACA,yBAAA;AjCg/WF;AiC9+WE;EACE,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AjCg/WJ;AiC9+WE;EACE,4BAAA;EACA,yBAAA;AjCg/WJ;AiC9+WI;EACE,oBAAA;EACA,UAAA;AjCg/WN;;AiC3+WA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AjC8+WF;AiC5+WE;EACE,uBAAA;EACA,cAAA;EACA,YAAA;AjC8+WJ;;AiC3+WA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AjC8+WF;AiC5+WE;EACE,cAAA;AjC8+WJ;;AiCv+WE;EACE,mDAAA;EACA,0CAAA;EACA,uDAAA;EACA,2BAAA;EACA,uCAAA;EACA,qDAAA;EACA,2BAAA;AjC0+WJ;AiCx+WI;EACE,yBAAA;EACA,wBAAA;AjC0+WN;AiCx+WI;EACE,wCAAA;EACA,+BAAA;AjC0+WN;AiCx+WI;EACE,oBAAA;AjC0+WN;AiCx+WI;EACE,2BAAA;EACA,oCAAA;AjC0+WN;;AiCt+WA;EACE,yBAAA;AjCy+WF;;AiCt+WE;EACE,uBAAA;AjCy+WJ;;AiCt+WA;EACE,eAAA;AjCy+WF;;AkCtiYA,sBAAA;AAKA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AlCqiYF;AkCniYE;;EACE,kBAAA;EACA,cAAA;EACA,qB7BDO;ALuiYX;AIv6XE;;E8B1HI,UAAA;AlCqiYN;AkCniYI;;;;EAGE,UAAA;AlCsiYN;AkCniYI;;EACE,yB/ByBQ;E+BxBR,W7BnBE;E6BoBF,qB/BuBQ;AH+gYd;AkCniYI;;EACE,yBAAA;AlCsiYN;AkCriYM;;EACE,6BAAA;EACA,c/BgBM;AHwhYd;AkCtiYQ;;;EAEE,2CAAA;EACA,c/BWI;AH8hYd;AkCjiYE;;;;;;;;EAIE,yBAAA;AlCuiYJ;;AkChiYE;;;;EAGE,yBAAA;AlCoiYJ;;AkC/hYA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AlCkiYF;AkChiYE;EACE,WAAA;AlCkiYJ;;AkC9hYA;EACE,gBAAA;AlCiiYF;;AkC5hYA;EACE,sBAAA;AlC+hYF;AkC7hYE;E9BqBE,0B8BpB6B;E9BqB7B,6B8BrB6B;AlCgiYjC;;AkC1hYA;;E9B4BI,yB8B1B0B;E9B2B1B,4B8B3B0B;AlC8hY9B;;AkCzhYA;EACE,mBAAA;AlC4hYF;;AkCzhYA;EACE,gBAAA;AlC4hYF;;AkCxhYE;;E9BFE,0B8BI6B;E9BH7B,6B8BG6B;AlC4hYjC;;AkCxhYA;E9BMI,yB8BL0B;E9BM1B,4B8BN0B;AlC4hY9B;;AkC5gYA;EACE,6BAAA;EACA,+BAAA;AlC+gYF;AkC7gYE;EACE,sBAAA;AlC+gYJ;;AkC3gYA;EACE,4BAAA;EACA,8BAAA;AlC8gYF;;AkC3gYA;EACE,2BAAA;EACA,6BAAA;AlC8gYF;;AkCzgYA;E9BzJE,wD8B0JA;E9BzJA,qD8ByJA;E9BxJA,mD8BwJA;E9BvJA,gD8BuJA;AlC+gYF;AkC5gYE;E9B7JA,wB8B8JE;E9B7JF,qB8B6JE;E9B5JF,mB8B4JE;E9B3JF,gB8B2JE;AlCihYJ;;AkCxgYA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AlC2gYF;AkCzgYE;;EAEE,WAAA;AlC2gYJ;AkCxgYE;;;;EAIE,gBAAA;EACA,sBAAA;AlC0gYJ;AkCtgYI;EACE,gBAAA;AlCwgYN;AkCrgYI;E9B5EA,6B8B6EgC;E9B5EhC,4B8B4EgC;AlCwgYpC;AkCrgYI;E9B9FA,yB8B+F6B;E9B9F7B,0B8B8F6B;AlCwgYjC;AkCpgYE;EACE,gBAAA;AlCsgYJ;AkClgYI;;E9B1FA,6B8B4FgC;E9B3FhC,4B8B2FgC;AlCqgYpC;AkCjgYE;E9B9GE,yB8B+G2B;E9B9G3B,0B8B8G2B;AlCogY/B;;AkC3/XI;;;;EAEE,kBAAA;EACA,sBAAA;AlCggYN;;AkCr/XE;;;;EAEE,oBAAA;EACA,gBAAA;AlC0/XJ;;AmCzuYA,iBAAA;AAKE;EACE,mBAAA;AnCwuYJ;;AmC5tYA,6BAAA;AAEA;EACE,kBAAA;EACA,gBAAA;E/BuCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+B9DqB;E/B+DrB,mB+B/DqB;E/ByDrB,+B+BxDyB;E/ByDzB,uB+BzDyB;EACzB,iBAAA;AnC0uYF;AmCxuYE;EACE,gBAAA;AnC0uYJ;;AmCtuYA;EACE,QAAA;EACA,UAAA;AnCyuYF;;AmCtuYA;EACE,QAAA;AnCyuYF;;AmCtuYA;EACE,kBAAA;AnCyuYF;;AmCtuYA;EACE,mBAAA;AnCyuYF;;AmCtuYA;EACE,WAAA;AnCyuYF;;AmCtuYA;EACE,mBAAA;AnCyuYF;;AmCtuYA;EACE;IACE,mBAAA;EnCyuYF;AACF;AmCtuYA;EACE;IACE,mBAAA;EnCwuYF;EmCtuYA;IACE,kBAAA;EnCwuYF;EmCtuYA;IACE,mBAAA;EnCwuYF;AACF;AmCruYA;EAEI;IACE,oBAAA;EnCsuYJ;AACF;AmCluYA;EACE;I/BxBA,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,a+BqBwB;I/BpBxB,8B+BoB8B;I/BnB9B,0B+BmB8B;I/BlB9B,sB+BkB8B;I/BjB9B,uBATiE;IAUjE,mBAViE;IAWjE,eAXiE;I+B2B/D,kBAAA;EnC8uYF;EmC5uYE;IACE,kBAAA;EnC8uYJ;EmC1uYA;IACE,eAAA;EnC4uYF;EmCzuYA;;IAEE,QAAA;IACA,WAAA;EnC2uYF;EmCzuYA;IACE,mBAAA;EnC2uYF;EmCvuYE;IACE,mBAAA;EnCyuYJ;AACF;AoCv1YA,eAAA;AACA;EACE,sB/BQM;EDsFJ,kBD7De;EiC/BjB,gBAAA;ApCy1YF;AoCv1YE;EACE,qBAAA;EhCyFA,kBgCvFuB;EhCPzB,mDgCQE;EhCPF,gDgCOE;EhCNF,8CgCME;EhCLF,2CgCKE;EACA,kBAAA;EACA,cAAA;EACA,mCAAA;EACA,+BAAA;EACA,2BAAA;EhCsBF,wCgCrBE;EhCsBF,mCgCtBE;EhCuBF,gCgCvBE;EACA,UAAA;ApC61YJ;AoCz1YI;EhCgBF,gDgCfI;EhCgBJ,2CgChBI;EhCiBJ,wCgCjBI;EhC0EF,kBgCzEyB;ApC61Y7B;;AoCv1YE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ApC01YJ;AoCx1YE;EACE,uBAAA;ApC01YJ;AoCv1YE;EACE,oBAAA;ApCy1YJ;AoCv1YE;EACE,qBAAA;EhCLF,oCgCME;EhCLF,+BgCKE;EhCJF,4BgCIE;EACA,cAAA;ApC21YJ;AoCz1YI;EAGE,6BAAA;EACA,yBAAA;EACA,qBAAA;ApCy1YN;AoCr1YE;EACE,uBAAA;ApCu1YJ;;AoCl1YE;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACD,qBAAA;EACA,mBAAA;EACC,YAAA;EACA,WAAA;EACA,UAAA;ApCq1YJ;;AoCj1YA;;EAEE,yBAAA;ApCo1YF;AoCl1YE;EAJF;;IAKI,YAAA;EpCs1YF;AACF;;AoCh1YE;EACE,eAAA;ApCm1YJ;AoCh1YE;EACE,aAAA;ApCk1YJ;AoC/0YE;EACE,qBAAA;ApCi1YJ;AoC/0YI;EhCHA,0BgCIyB;ApCi1Y7B;AoC70YE;EAnBF;IAoBI,mBAAA;EpCg1YF;AACF;;AoC70YA;EACE,mBAAA;ApCg1YF;AoC90YE;EACE,kBAAA;ApCg1YJ;AoC70YE;EACE,gBAAA;ApC+0YJ;AoC70YI;EACE,yBAAA;ApC+0YN;AoC30YE;EAfF;IAgBI,mBAAA;EpC80YF;AACF;;AoC30YA;EACE,mBAAA;ApC80YF;AoC50YE;EACE,kBAAA;ApC80YJ;AoC30YE;EACE,gBAAA;EACA,eAAA;EACA,c/B3HO;ALw8YX;AoC10YE;EAbF;IAcI,mBAAA;EpC60YF;AACF;;AoC10YA;EACE,mBjC1Ee;AHu5YjB;AoC30YE;EAHF;IAII,mBAAA;EpC80YF;AACF;;AoC30YA;EACE,eAAA;ApC80YF;AoC50YE;EACE,gBAAA;ApC80YJ;AoC50YI;EACE,yBAAA;ApC80YN;;AoCz0YA;EACE,ejCnJa;EiCoJb,0BAAA;ApC40YF;;AoCz0YA;EACE,eAAA;EACA,c/B7JS;ALy+YX;AoC10YE;EACE,mBjC5JW;AHw+Yf;;AoCx0YA;EACE,oBAAA;EACA,iBAAA;ApC20YF;;AoCx0YA;EACE,eAAA;EACA,iBAAA;ApC20YF;;AoCx0YA;EACE,gBAAA;EACA,uBAAA;EhCpIA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BgC6GqB;EhC5GrB,mBgC4GqB;EACrB,mBAAA;ApCs1YF;AoCp1YE;EACE,cAAA;EACA,kBAAA;ApCs1YJ;AoCn1YE;EACE,WjClHS;AHu8Yb;AoCl1YE;EAGE,cjC3JQ;AH6+YZ;AoC/0YE;EACE,gBAAA;EhCrIF,qCgCsI2B;EhCrI3B,6BgCqI2B;ApCk1Y7B;;AoC90YA;EhC9JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BgCuIqB;EhCtIrB,mBgCsIqB;EhC5IrB,qCgC6IyB;EhC5IzB,6BgC4IyB;EACzB,kBAAA;EACD,qBAAA;EACC,MAAA;EACD,mBAAA;EACC,SAAA;EACA,UAAA;EACA,W/B3NM;E+B4NN,ejCjNa;AH8iZf;AoC31YE;EACE,sBAAA;EACA,eAAA;ApC61YJ;;AoCz1YA;EhC9II,kBD7De;EiC6MjB,mBjCtKe;AHkgZjB;AoC11YE;EACE;IACE,iBAAA;EpC41YJ;AACF;AoCz1YE;EACE;IACE,iBAAA;EpC21YJ;AACF;AoCx1YE;EAhBF;IAiBI,mBAAA;EpC21YF;AACF;;AqC3lZA,gBAAA;AAEA;EACE,kBAAA;ArC6lZF;AqC3lZI;EACE,WhCIE;EgCHF,kBAAA;ArC6lZN;AqCzlZE;EACE,kBAAA;ArC2lZJ;AqCzlZE;EACE,kBAAA;ArC2lZJ;;AsC1mZA,eAAA;AACA;EACE,wCAAA;EACA,oCAAA;AtC6mZF;;AuChnZA,kBAAA;AAGE;EACE,epCgBW;AHimZf;;AwCrnZA,sBAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AxCunZF;;AwCpnZA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EpCTA,gDoCUA;EpCTA,6CoCSA;EpCRA,2CoCQA;EpCPA,wCoCOA;EACA,qBAAA;EACA,eAAA;AxC0nZF;;AwCvnZA;EACE,kBAAA;EACA,UAAA;AxC0nZF;;AwCvnZA;EACE,eAAA;EACA,MAAA;EACD,mBAAA;EACC,SAAA;EACD,qBAAA;AxC0nZD;;AwCvnZA;;;;EAIE,sBAAA;AxC0nZF;;AwCvnZA;EACE,sBAAA;EACA,uBAAA;AxC0nZF;;AwCvnZA;EACE,uBAAA;AxC0nZF;;AwCvnZA;EACE,qBAAA;EACA,mBAAA;AxC0nZF;;AyC1qZA,gBAAA;AAEA;EACE,YAAA;AzC4qZF;;AyCzqZA;EACE,WAAA;AzC4qZF;;A0CnrZA,oBAAA;AAEA;EACE,gBAAA;A1CqrZF;;A0C/qZE;EACE,oBAAA;A1CkrZJ;A0ChrZI;EAHF;IAII,mBAAA;E1CmrZJ;AACF;A0CjrZI;EAPF;IAQI,oBAAA;E1CorZJ;AACF;A0ClrZI;EAXF;IAYI,oBAAA;E1CqrZJ;AACF;A0CnrZI;EAfF;IAgBI,mBAAA;E1CsrZJ;AACF;;A2ChtZA,oBAAA;AAEA;;;;EvC2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EAqBjE,qCuC1EyB;EvC2EzB,6BuC3EyB;EACzB,gBAAA;A3C6tZF;;A2C1tZA;EACE,eAAA;EACA,iBAAA;EAEA,wBAAA;A3C4tZF;A2C1tZE;EACE,cAAA;A3C4tZJ;A2C1tZI;EAEE,uBAAA;EACA,yBAAA;EACA,kBAAA;A3C2tZN;;A2CrtZE;EACE,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;A3CwtZJ;;A2CptZA;EACE,+HAAA;EACA,0HAAA;EACA,uHAAA;A3CutZF;;A2CptZA;EACE,4HAAA;EACA,uHAAA;EACA,oHAAA;A3CutZF;;A2CptZA;EACC,qBAAA;EACA,mBAAA;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;A3CutZF;;A2CptZA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;A3CutZF;A2CrtZE;EACE,QAAA;EACD,uBAAA;EACC,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;A3CutZJ;;A2CntZA;EACE,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;A3CstZF;;A2CntZA;EACE,uDAAA;EACA,eAAA;EACA,YAAA;A3CstZF;;A2CntZA;EACE,aAAA;EACA,SAAA;EACD,qBAAA;EACA,mBAAA;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;EACA,+GAAA;EACA,iHAAA;EACA,uGAAA;A3CstZF;;A2CntZA;EACE,aAAA;EACA,MAAA;EACD,qBAAA;EACA,mBAAA;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;EAEA,iHAAA;EACA,oHAAA;EACA,yGAAA;A3CqtZF;;A2CltZA;EACE,iBAAA;A3CqtZF;;A2CltZA;EACE,kBAAA;A3CqtZF;;A4Cx1ZA,eAAA;AAEA;EACE,qBAAA;EAEA,kBAAA;A5Cy1ZF;;A4Ct1ZA;EACE,qBAAA;A5Cy1ZF;A4Cx1ZE;EACE,yBAAA;A5C01ZJ;;A6Cr2ZA,eAAA;AACA;EACE,gBAAA;A7Cw2ZF;;A8C12ZA,cAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;A9C42ZF;;A8Cz2ZA;EACE,WAAA;EACA,uBAAA;A9C42ZF;A8C12ZE;EACE,0BAAA;A9C42ZJ;A8C12ZI;EAHF;IAII,0BAAA;E9C62ZJ;AACF;A8C12ZE;EACE,uBAAA;EACA,mBAAA;A9C42ZJ;A8Cx2ZE;EACE,gBAAA;EACA,kBAAA;A9C02ZJ;A8Cv2ZE;EACE,sBAAA;A9Cy2ZJ;A8Ct2ZE;EACE,qBAAA;A9Cw2ZJ;A8Cr2ZE;EACE,qBAAA;EACA,W3CgDS;E2C/CT,e3C5Ba;E2C6Bb,gBAAA;A9Cu2ZJ;;A8Cl2ZE;EACE,YAAA;A9Cq2ZJ;A8Cp2ZI;EAFF;IAGI,WAAA;E9Cu2ZJ;AACF;A8Cp2ZE;EACE,yBAAA;A9Cs2ZJ;A8Cr2ZI;EAFF;IAGI,WAAA;E9Cw2ZJ;AACF;A8Cp2ZI;EACE,uBAAA;A9Cs2ZN;A8Cn2ZI;EACE,6CAAA;EACA,yCAAA;EACA,W3CmBO;E2ClBP,gBAAA;A9Cq2ZN;A8Cn2ZM;EAGE,0CAAA;EACA,sCAAA;A9Cm2ZR;A8C91ZM;EACE,oBAAA;A9Cg2ZR;;A8C11ZA;EACE,yBAAA;EACA,uBAAA;A9C61ZF;A8C51ZE;EACE,cAAA;EACA,qBAAA;A9C81ZJ;A8C51ZI;EACE,aAAA;A9C81ZN;;A8Cz1ZA;EACE,gCAAA;EACA,mBAAA;A9C41ZF;;A8Cz1ZA;EACE,0BAAA;A9C41ZF;;A8Cz1ZA;EACE,eAAA;EACA,YAAA;A9C41ZF;;A8Cz1ZA;EACE,YAAA;EACA,gBAAA;A9C41ZF;A8C11ZE;EACE,qBAAA;EACA,2CAAA;EACA,iBAAA;EACA,gBAAA;A9C41ZJ;A8C11ZI;EACE,gBAAA;EpCjHF,4CAAA;EoCmHE,qBAAA;A9C41ZN;A8C11ZM;EACE,yBAAA;EpCtHJ,gDAAA;EAEF,uBAAA;EoCsHM,eAAA;A9C61ZR;A8C31ZM;EpC1HF,4CAAA;EoC4HI,qBAAA;EACA,eAAA;A9C61ZR;A8C31ZM;EpC/HF,gDAAA;EAEF,uBAAA;EoC+HM,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;A9C81ZR;A8C51ZM;EpCzIF,4CAAA;EoC2II,qBAAA;EACA,gBAAA;A9C81ZR;A8C51ZM;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;A9C81ZR;A8C51ZQ;EACE,8BAAA;A9C81ZV;A8C11ZI;EACE,yBAAA;A9C41ZN;A8C11ZI;EACE,mBAAA;EACA,uBAAA;A9C41ZN;A8Cz1ZE;EACE,mBAAA;A9C21ZJ;A8Cz1ZE;EACE,aAAA;A9C21ZJ;A8Cz1ZE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;A9C21ZJ;;A+CnhaA;EACE,eAAA;EACA,eAAA;A/CshaF;;A+ClhaE;EACE,W1CEI;ALmhaR;A+CnhaI;EAGE,W1COE;E0CNF,sB1CJE;ALuhaR;A+ChhaI;EACE,c1CPK;ALyhaX;A+C/gaI;EACE,c1CHK;ALohaX;;AgDviaA,iBAAA;AAME;;;;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;E5CuFA,mB4CtFuB;E5C2BzB,wC4C1BE;E5C2BF,mC4C3BE;E5C4BF,gC4C5BE;AhD0iaJ;AgDxiaI;;;;;;;;;;EAGE,8BAAA;EACA,0BAAA;EACA,sBAAA;AhDijaN;AgD/iaI;;;;EACE,8BAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;AhDojaN;AgDjjaE;;;;EACE,aAAA;EACA,kBAAA;AhDsjaJ;AgDpjaI;;;;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AhDyjaN;AgDxjaM;;;;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;AhD6jaR;AgDzjaI;;;;EACE,cAAA;AhD8jaN;AgD1jaE;;;;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;AhD+jaJ;AgD7jaI;;;;EACE,mBAAA;EAEA,oBAAA;AhDikaN;AInmaE;;;;;;;EAEE,YAAA;EACA,cAAA;AJ0maJ;AIxmaE;;;;EACE,WAAA;AJ6maJ;AgDhlaM;;;;EACE,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;AhDqlaR;AgDllaM;;;;EACE,cAAA;EACA,gBAAA;AhDulaR;AgDllaE;;;;EACE,SAAA;EACD,qBAAA;EACC,kBAAA;EACD,mBAAA;EACC,kBAAA;EACA,kBAAA;AhDulaJ;AgDrlaI;;;;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AhD0laN;;AgDrlaA;EACE,cAAA;E5CKE,gB4CJqB;AhDwlazB;;AgDnlaI;E5CDA,mB4CEyB;AhDsla7B;;AgDhlaE;E5CRE,kB4CSuB;EACvB,aAAA;EACA,YAAA;EACA,mBAAA;E5CtBF,2B4CuBuB;E5CtBvB,mB4CsBuB;AhDolazB;AgDllaI;EACE,gBAAA;AhDolaN;;AgD/kaA;EAKI;;;;IACE,kBAAA;EhDilaJ;EgD/kaE;;;;IACE,wBAAA;EhDolaJ;EgD/kaE;IACE,aAAA;IACA,YAAA;EhDilaJ;AACF;AgD7kaA;EAMM;;;;;;;;;;;;;IAIE,2BAAA;IACA,uBAAA;IACA,mBAAA;EhDmlaN;AACF;AiD1uaA,qBAAA;AAEA;EACE,aAAA;EACA,mBAAA;AjD2uaF;;AiDxuaA;EACE,WAAA;EACA,kBAAA;AjD2uaF;AiD1uaE;EACE,yBAAA;AjD4uaJ;AiD3uaI;EACE,yBAAA;AjD6uaN;;AiDxuaA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACD,wBAAA;EACC,UAAA;AjD2uaF;;AiDxuaA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACD,uBAAA;EACC,iBAAA;EACA,0BAAA;AjD2uaF;;AkD3waA,iBAAA;AACA;EACE,aAAA;AlD8waF;;AkD3waA;EACE,6BAAA;EACA,qBAAA;EACA,W7CYM;E6CXN,e/CWa;E+CVb,oBAAA;AlD8waF;;AkD3waA;EACE,kBAAA;AlD8waF;;AmD5xaA,uBAAA;AAiFE;EAfA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EAYE,YA5EkB;EA6ElB,kBAAA;EACA,WA9EkB;EA+ElB,aAnFa;AnDuyajB;AmDjuaE;EAGE,aAAA;AnDiuaJ;AmDrtaI;EACE,yDAAA;EACA,sBAxFU;EAyFV,kBAAA;EACA,cAAA;EACA,WAAA;EACD,uBAAA;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;AnDutaN;AmDptaI;EACE,yDAAA;EACA,uCAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACD,qBAAA;EACC,YAAA;EACA,kBAAA;EACA,MAAA;EACA,2BAAA;EACA,wBAAA;EACA,WAAA;AnDstaN;AmDltaE;EACE,SAAA;EACD,qBAAA;EACC,kBAAA;EACD,mBAAA;EACC,MAAA;EACA,aA3Ha;AnD+0ajB;AmDjtaE;EACE,kBAzHyB;EA0HzB,wEAAA;EACA,kBAAA;AnDmtaJ;AmDjtaI;EACE,4EAAA;AnDmtaN;AmD/saE;EACE,sBA5HuB;EA6HvB,kBA5H4B;EA6H5B,WA5HoB;EA6HpB,eAAA;EACA,iGAAA;EACA,UAAA;EACA,aA9HsB;EAgItB,+BAAA;EACA,YAAA;EACA,aAAA;AnDgtaJ;AmD9saI;EACE,wCA7IsB;EA8ItB,4DA7I6B;AnD61anC;AmD7saI;EACE,4BAAA;EAEA,kBAAA;AnD8saN;AmD3saI;EAGE,gBA9HyB;AnDy0a/B;AmDzsaM;EACE,0DAAA;EACA,YAlIuB;EAmIxB,uBAAA;EACC,UAAA;EACA,2BAAA;EACA,WA/JqB;AnD02a7B;AmDvsaI;EAGE,mBA7IyB;AnDo1a/B;AmDrsaM;EACE,0DAAA;EACA,aAAA;EACA,YAlJuB;EAmJxB,uBAAA;EACC,2BAAA;EACA,WA9KqB;AnDq3a7B;AmDjsaM;EACC,sBAAA;EACC,wBAAA;AnDmsaR;AmDjsaQ;EAJF;IAKG,sBAAA;EnDosaP;AACF;AmD9raM;EACC,wBAAA;EACA,oBAAA;EACC,wBAAA;AnDgsaR;AmD9raQ;EALF;IAMG,oBAAA;EnDisaP;AACF;AmD7raI;EACE,uBAnLyB;AnDk3a/B;AmD7raM;EACE,0DAAA;EACA,YAhNqB;EAiNtB,uBAAA;EACC,WAzLuB;AnDw3a/B;AmD3raI;EACE,yBA9LyB;AnD23a/B;AmD3raM;EACE,0DAAA;EACA,YA3NqB;EA4NtB,yBAAA;EACC,WApMuB;AnDi4a/B;AmDzraI;EA9KF,6BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EA2KI,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EAEA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EAcE,cAAA;AnDkraR;AmDl3aE;EAGE,aAAA;AnDk3aJ;AmDjsaM;EAEE,kCAAA;EACA,aAAA;AnDksaR;AmD/raM;EACC,sBAhPmB;EAiPlB,SAjPkB;AnDk7a1B;AmDvraI;EACE,6BAAA;EACA,WA/PkB;EAgQlB,eArPqB;EAsPrB,mBAAA;EACA,wBAAA;EACA,kBAAA;AnDyraN;AmDvraM;EACE,oBAAA;AnDyraR;AmDrraI;EACE,eA1QsB;EA2QtB,oBAAA;EACA,wBAAA;AnDuraN;AmDpraI;EACE,iBAAA;AnDsraN;AmDnraI;EApOF,6BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;AnD05aF;AmDx5aE;EAGE,aAAA;AnDw5aJ;AmD3raM;EACE,sBAxSQ;EAySR,kBAxQuB;EAyQvB,WA1Qe;EA2Qf,iBAAA;EACA,6CAAA;AnD6raR;AmD3raQ;EAGE,uCAAA;EACA,WAlRa;AnD68avB;AmDvraM;EACE,WAvTQ;EAwTR,uBAAA;AnDyraR;AmDtraM;EACE,WAxRoB;EAyRpB,mBAAA;EACA,uBAAA;AnDwraR;AmDnraM;EACE,iBAAA;AnDqraR;AmDlraM;EACE,aAAA;AnDoraR;AmDhraI;EAnMF;IAoMI,YAAA;EnDmraJ;AACF;AmDjraI;EAvMF;IAwMI,YAAA;EnDoraJ;AACF;;AmDhraA;EACE;IACE,qBAAA;EnDmraF;EmDhraA;IACE,UAAA;IACA,oCAAA;EnDkraF;AACF;AmD/qaA;EACE;IACE,YAAA;EnDiraF;EmD9qaA;IACE,YAAA;EnDgraF;AACF;AmD7qaA;EACE;IACE,mBAAA;EnD+qaF;EmD5qaA;IACE,YAAA;IACA,sBAAA;EnD8qaF;EmD3qaA;IACE,YAAA;IACA,mBAAA;EnD6qaF;AACF;AoDvibA,gBAAA;AAEA;EACE,8CAAA;EACA,4CAAA;EACA,2DAAA;ApDwibF;;AoDribA;EACE,kCAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;ApDwibF;AoDtibE;EACE,cAAA;EACA,yBAAA;ApDwibJ;AoDtibE;EACE,W/CTI;E+CUJ,yBAAA;ApDwibJ;;AoDpibA;EhDmDE,sBAAA;EACA,kBAAA;EACA,cAAA;AJq/aF;;AoDtibA;EACE,cAAA;ApDyibF;;AoDtibA;EhD2CE,sBAAA;EACA,kBAAA;EACA,cAAA;AJ+/aF;;AoDxibA;EACE,4CAAA;ApD2ibF;;AoDxibA;EACE,sBAAA;EACA,0BAAA;EACA,wCAAA;ApD2ibF;AoDzibE;;EAEE,2BAAA;EACA,8BAAA;EACA,wCAAA;ApD2ibJ;AoDxibE;EACE,iCAAA;EACA,2CAAA;ApD0ibJ;AoDvibE;EACE,wCAAA;ApDyibJ;AoDtibE;EACE,oCAAA;ApDwibJ;;AoDpibA;EhDoBE,4BgDnBqB;EhDoBrB,oBgDpBqB;EACrB,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ApDwibF;;AoDribA;EACE,gBAAA;ApDwibF;AoDvibE;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;ApDyibJ;AoDvibE;EACE,sBAAA;EACA,mEAAA;ApDyibJ;;AoDpibE;EAEE,yBAAA;ApDsibJ;AoDnibE;EACE,2CAAA;ApDqibJ;;AoDlibA;EACE,kBAAA;ApDqibF;;AoDnibA;EACE,iBAAA;EACA,gBAAA;ApDsibF;;AoD9hbQ;EACE,0BAAA;ApDiibV;AoD1hbU;EACE,0BAAA;EACA,UAAA;ApD4hbZ;AoD1hbY;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,YAAA;ApD4hbd;AoD1hbc;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACD,wBAAA;EACC,gBAAA;EACA,+BAAA;EACA,oBAAA;EACA,sBAAA;ApD4hbhB;AoD1hbgB;EACE,0BAAA;ApD4hblB;AoD1hbgB;EACE,yBAAA;ApD4hblB;AoD1hbgB;EACE,mBAAA;EACA,kBAAA;EACA,qBAAA;ApD4hblB;AoDphbgB;EACC,mBAAA;ApDshbjB;;AoDxgbM;EACE,SAAA;EACA,mBAAA;EACA,mBAAA;ApD2gbR;AoDtgbc;EACE,YAAA;EACA,6BAAA;E1C5KZ,gDAAA;AVqrbJ;AoDtgbgB;EACE,qBAAA;ApDwgblB;AoD//aE;EACE,SAAA;EACA,UAAA;ApDigbJ;AoD//aE;EACE,SAAA;ApDigbJ;AoD//aE;EACE,aAAA;EACA,sBAAA;ApDigbJ;AoD//aE;EACE,iBAAA;ApDigbJ;;AoD5/aE;EACE,+BAAA;EACA,2BAAA;EACA,kBAAA;ApD+/aJ;AoD7/aI;EACE,iBAAA;ApD+/aN;AoD7/aM;EACE,yBAAA;ApD+/aR;AoD5/aI;EACE,iBAAA;ApD8/aN;AoD5/aM;EACE,gBAAA;ApD8/aR;AoD5/aQ;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iDAAA;EACA,uBAAA;EACA,gBAAA;ApD8/aV;AoD5/aU;EACE,gBAAA;EACA,kBAAA;ApD8/aZ;AoD5/aU;EACE,0BAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,iDAAA;EACA,qBAAA;ApD8/aZ;AoD3/aY;EACE,oCAAA;ApD6/ad;AoD3/aY;EACE,kCAAA;ApD6/ad;AoD1/aU;EACE,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;ApD4/aZ;AoD1/aU;EACE,iDAAA;ApD4/aZ;AoD1/aU;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;ApD4/aZ;AoDp/aU;EACE,gBAAA;ApDs/aZ;AoDn/aY;E1CtRR,gDAAA;EAEF,uBAAA;AV2wbF;AoDp/ac;EACE,uBAAA;ApDs/ahB;AoDj/aQ;EACE,oCAAA;E1ChSN,gDAAA;EAEF,uBAAA;E0CgSQ,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mDAAA;ApDo/aV;AoDl/aU;EACE,0BAAA;EACA,0BAAA;EACA,sBAAA;ApDo/aZ;AoDl/aY;EACE,aAAA;EACA,uBAAA;ApDo/ad;AoDh/aY;EACE,oBAAA;EACA,mBAAA;ApDk/ad;AoD/+aU;EACE,oCAAA;ApDi/aZ;AoD/+aU;EACE,gBAAA;ApDi/aZ;AoD/+aY;EAEE,oCAAA;ApDg/ad;AoD7+aU;E1CpUN,gDAAA;EAEF,uBAAA;E0CoUU,uBAAA;EACA,OAAA;ApDg/aZ;AoD9+aY;EACE,0DAAA;ApDg/ad;AoD7+aU;EACE,iDAAA;ApD++aZ;AoD7+aU;EACE,eAAA;ApD++aZ;AoD7+aU;EACE,cAAA;ApD++aZ;AoD7+aU;EACE,yBAAA;ApD++aZ;AoD3+aU;EACE,2CAAA;ApD6+aZ;AoD3+aY;EACE,2CAAA;ApD6+ad;AoDz+aY;EACE,uBAAA;ApD2+ad;AoDv+aQ;EACE,0KAAA;ApDy+aV;AoDv+aU;EACE,aAAA;EACA,UAAA;ApDy+aZ;AoDv+aY;EACE,yBAAA;ApDy+ad;AoDp+aU;EACE,2CAAA;ApDs+aZ;AoDp+aY;EACE,+CAAA;ApDs+ad;AoD/9aM;EACE,0BAAA;E1CjYJ,gDAAA;EAEF,uBAAA;AVk2bF;AoD/9aQ;EACE,6DAAA;ApDi+aV;AoD39aQ;EACE,oCAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;E1ChZN,gDAAA;EAEF,uBAAA;AV62bF;AoD59aU;EACE,0BAAA;EACA,0BAAA;EACA,sBAAA;ApD89aZ;AoD59aY;EACE,aAAA;EACA,uBAAA;ApD89ad;AoDx9aI;EACE,oCAAA;ApD09aN;AoDv9aE;EACE,oBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ApDy9aJ;AoDv9aI;EACE,uBAAA;ApDy9aN;AoDv9aM;EACE,kBAAA;EACA,eAAA;ApDy9aR;AoDv9aQ;EACE,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ApDy9aV;AoDv9aU;EAEE,aAAA;EACA,yCAAA;EACA,0CAAA;ApDw9aZ;AoDr9aQ;EACE,kBAAA;EACA,UAAA;EACD,sBAAA;EACC,YAAA;EACA,oBAAA;EACA,eAAA;ApDu9aV;AoDn9aI;EACE,aAAA;EACA,mBAAA;ApDq9aN;AoDn9aM;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ApDq9aR;AoDn9aQ;EACE,kBAAA;ApDq9aV;AoDn9aU;EAEE,wBAAA;EACA,SAAA;ApDo9aZ;AoD78aI;EACE,sBAAA;ApD+8aN;AoD78aM;EACE,sBAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;ApD+8aR;AoD78aQ;EACE,qCAAA;EACA,qBAAA;ApD+8aV;AoDz8aI;EACE,+BAAA;ApD28aN;AoDz8aI;EACE,yBAAA;ApD28aN;AoDv8aI;EACE,+BAAA;EACA,2BAAA;ApDy8aN;AoDp8aY;EACE,2BAAA;EACA,uBAAA;ApDs8ad;AoD37aU;EACE,2BAAA;EACA,uBAAA;ApD67aZ;AoDn7aU;EACE,4BAAA;ApDq7aZ;AoD36aQ;;;;EAEE,kBAAA;EACA,2DAAA;ApD+6aV;AoD76aU;;;;EACE,kBAAA;EACA,uBAAA;ApDk7aZ;AoDv6aY;;;;EACE,gBAAA;ApD46ad;AoDt6aI;E1C5kBA,gDAAA;AVq/bJ;AoDj6aU;EACE,uBAAA;EACA,OAAA;ApDm6aZ;AoD55aE;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;ApD85aJ;AoD35aE;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;ApD65aJ;AoD15aE;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;ApD45aJ;AoDz5aE;EACE,UAAA;EACA,iBAAA;ApD25aJ;AoDz5aI;EACE,aAAA;ApD25aN;AoDr5aQ;EACE,+BAAA;ApDu5aV;AoDh5aM;EACE,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;ApDk5aR;AoD/4aU;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;ApDi5aZ;AoD/4aY;EACE,oBAAA;ApDi5ad;AoD94ac;EACE,uBAAA;EACA,YAAA;EACA,qBAAA;E1C/qBZ,gDAAA;E0CirBY,4BAAA;EACA,SAAA;EACA,yBAAA;ApDg5ahB;AoD94agB;EAEE,2CAAA;ApD+4alB;AoD74agB;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;ApD+4alB;AoD74akB;EACE,aAAA;ApD+4apB;AoDx4aQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,yCAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ApD04aV;AoDx4aU;EACE,wBAAA;EACA,eAAA;ApD04aZ;AoDv4aQ;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ApDy4aV;AoDv4aU;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;ApDy4aZ;AoDv4aU;EACE,4BAAA;ApDy4aZ;;AoDj4aE;EACE,eAAA;ApDo4aJ;AoDj4aI;EACE,8BAAA;ApDm4aN;;AoD/3aA;EACE,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,iFAAA;EACA,SAAA;EACA,eAAA;ApDk4aF;AoDh4aE;EACE,6BAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;ApDk4aJ;AoDh4aI;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;ApDk4aN;AoD93aU;EACE,aAAA;ApDg4aZ;AoDz3aY;EACE,6BAAA;ApD23ad;AoDz3ac;EACE,cAAA;ApD23ahB;AoDl3aY;EACE,cAAA;ApDo3ad;AoD/2aM;EACE,YAAA;EACA,UAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;ApDi3aR;AoD92aI;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ApDg3aN;AoD92aM;EACE,eAAA;ApDg3aR;AoD92aM;EACE,yBAAA;ApDg3aR;AoD72aI;EAlEF;IAmEI,cAAA;IACA,kBAAA;EpDg3aJ;EoD92aI;IACE,aAAA;EpDg3aN;EoD92aM;IACE,aAAA;EpDg3aR;EoD92aM;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,uBAAA;IACA,aAAA;IACA,kBAAA;IACA,0CAAA;IACA,SAAA;EpDg3aR;EoD92aQ;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;EpDg3aV;EoD92aU;IACE,WAAA;IACA,iCAAA;EpDg3aZ;EoD92aY;;IAEE,WAAA;IACA,iCAAA;EpDg3ad;EoD52aQ;IACE,+DAAA;EpD82aV;EoD52aQ;IACE,0BAAA;IACA,oBAAA;IACA,uDAAA;IACA,WAAA;EpD82aV;AACF;AoDv2aM;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;ApDy2aR;AoDv2aQ;EACE,iCAAA;ApDy2aV;AoDv2aQ;EACE,yCAAA;ApDy2aV;AoDv2aU;EACE,iCAAA;ApDy2aZ;AoDt2aQ;EACE,0CAAA;EACA,mCAAA;ApDw2aV;AoDt2aU;EACE,mCAAA;ApDw2aZ;AoDt2aU;EACE,mCAAA;EACA,yBAAA;ApDw2aZ;AoDt2aY;EACE,yBAAA;ApDw2ad;;AoD/1aE;EACE,gBAAA;ApDk2aJ;AoD/1aM;E1Ct6BF,gDAAA;EAEF,uBAAA;AVuwcF;AoDh2aQ;E1Cz6BJ,gDAAA;EAEF,uBAAA;AV2wcF;AoD/1aI;EACE,kBAAA;ApDi2aN;AoD91aE;EACE,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ApDg2aJ;AoD91aI;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;ApDg2aN;AoD91aI;EACE,4BAAA;ApDg2aN;AoD71aE;EACE,wDAAA;ApD+1aJ;;AoD11aI;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;ApD61aN;AoD31aM;EACE,yBAAA;ApD61aR;AoDz1aM;EACE,yBAAA;ApD21aR;;AoDt1aA;EACE,WAAA;EACA,mBAAA;ApDy1aF;AoDv1aE;EACE,kBAAA;EACA,mHAAA;EACA,YAAA;EACA,sBAAA;ApDy1aJ;AoDv1aI;E1Cr+BA,gDAAA;E0Cu+BE,qBAAA;EACA,0BAAA;ApDy1aN;AoDv1aI;E1C1+BA,gDAAA;E0C4+BE,qBAAA;EACA,wBAAA;ApDy1aN;AoDp1aM;EACE,wBAAA;ApDs1aR;;AoDj1aA;E1Cx/BI,gDAAA;E0C0/BF,QAAA;EACA,kBAAA;ApDo1aF;AoDl1aE;EACE,gBAAA;ApDo1aJ;AoDl1aE;EACE,gBAAA;ApDo1aJ;AoDl1aE;EACE,mBAAA;ApDo1aJ;;AoDj1aA;E1CvgCI,gDAAA;AV41cJ;;AoDl1aA;;EAEE,gBAAA;EACA,kBAAA;ApDq1aF;;AoDn1aA;EACE,kCAAA;ApDs1aF;;AoDp1aA;EACE,oCAAA;EACA,oBAAA;ApDu1aF;AoDr1aE;EACE,6BAAA;ApDu1aJ;;AoDn1aE;EACE,6BAAA;EACA,oFAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;ApDs1aJ;AoDp1aE;E1CliCE,gDAAA;EAEF,uBAAA;AVw3cF;AoDr1aI;EACE,WAAA;ApDu1aN;AoDr1aM;EACE,mBAAA;ApDu1aR;;AoDl1aA;EACE,WAAA;ApDq1aF;;AoDn1aA;EACE,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;ApDs1aF;AoDp1aE;EACE,cAAA;EACA,YAAA;ApDs1aJ;;AoDj1aA;EACE;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,4CAAA;IACA,sBAAA;EpDo1aF;EoDl1aA;IACE,gBAAA;EpDo1aF;EoDl1aA;IACE,mBAAA;EpDo1aF;EoDl1aA;IACE,SAAA;EpDo1aF;EoDl1aA;IACE,sBAAA;EpDo1aF;EoDl1aA;IACE,oBAAA;EpDo1aF;EoDl1aA;IACE,gBAAA;EpDo1aF;AACF;AoDh1aE;EACE,kBAAA;ApDk1aJ;;AqD97cA,cAAA;AAEA;EACE,0BAAA;ArDg8cF;;AqD77cA;EjDuDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJq5cnE;;AsDj9cA,qBAAA;AAEA;EACE,oCAAA;EACA,2CAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AtDm9cF;AsDj9cE;EARF;IASI,2BAAA;EtDo9cF;AACF;AsDl9cE;EACE,qBAAA;EACA,WnDyIM;EmDxIN,YnDwIM;ECzDN,kBkD9EuB;EACvB,gBAAA;EACA,kBAAA;EACA,SAAA;EACD,wBAAA;EACC,yBAAA;AtDo9cJ;AsDl9cI;EAXF;IAYI,WnD6HI;ImD5HJ,YnD4HI;EHy1cR;AACF;AsDn9cE;EACE,WAAA;EACA,YAAA;AtDq9cJ;AsDn9cE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AtDq9cJ;AsDn9cI;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,0BAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACD,yBAAA;AtDm9cL;AsDh9cE;EACE,cAAA;EACA,kBAAA;AtDk9cJ;;AsD78cA;EACE,kBAAA;AtDg9cF;AsD98cE;EACE,cAAA;EACA,mBAAA;EACA,YnDsFO;EmDrFP,anDqFO;AH23cX;AsD98cI;EANF;IAOI,WnDgFI;ImD/EJ,YnD+EI;EHk4cR;AACF;AsD/8cE;EACE,WAAA;EACA,YAAA;AtDi9cJ;;AuDhidA,mBAAA;AAEA;EACE,mBAAA;EACA,uBAAA;AvDkidF;;AuD/hdA;EACE,iBAAA;EACA,yBAAA;AvDkidF;;AuD/hdA;EnDoFI,kBmDnFqB;AvDkidzB;;AuD/hdA;EACE,mBAAA;AvDkidF;;AuD/hdA;EACE,oBAAA;EACA,0BAAA;EACA,kBAAA;AvDkidF;AuDhidE;EACE,sCAAA;EACA,WAAA;EACD,wBAAA;EACC,kBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AvDkidJ;AuDhidE;EACE,iCAAA;AvDkidJ;AuDhidE;EACE,iCAAA;EACA,YAAA;AvDkidJ;;AuD9hdA;EAGE,kBAAA;EACD,qBAAA;EACC,SAAA;EACA,UAAA;EACA,eAAA;EACA,WlD1CM;EkD2CN,kBAAA;EnD2CE,kBD3DmB;AHgjdvB;AuD7hdE;EACE,6BAAA;AvD+hdJ;AuD7hdE;EACE,iCAAA;AvD+hdJ;;AuD1hdE;EACE,aAAA;AvD6hdJ;AuD1hdE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EnDqBA,kBD3DmB;EoDwCpB,uBAAA;EACC,QAAA;EACA,UAAA;AvD4hdJ;;AuDxhdA;;EAEE,qBAAA;EACA,eAAA;EACA,YAAA;AvD2hdF;;AuDxhdA;EACE,kBAAA;EACA,kBAAA;EACA,sBlDnFM;EDsFJ,kBD7De;EoD4DjB,yBAAA;AvD2hdF;AuDzhdE;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AvD0hdJ;AuDvhdE;EACE,iCAAA;EACA,8BAAA;EACD,yBAAA;EACC,SAAA;AvDyhdJ;AuDthdE;EACE,8BAAA;EACA,8BAAA;EACD,yBAAA;EACC,SAAA;AvDwhdJ;;AuDphdA;EACE,UAAA;AvDuhdF;;AuDphdA;EnD1HE,wBmD2HA;EnD1HA,qBmD0HA;EnDzHA,mBmDyHA;EnDxHA,gBmDwHA;AvD0hdF;AuDzhdE;EAEE,aAAA;AvD0hdJ;;AuDthdA;EACE,mBAAA;AvDyhdF;;AuDrhdE;EACE,iBAAA;EACA,oBAAA;EACA,yBAAA;AvDwhdJ;;AuDphdA;EACE,gBAAA;EACA,mBAAA;AvDuhdF;;AuDphdA;EACE,WAAA;AvDuhdF;;AuDphdA,oBAAA;AAEE;EACE,WAAA;EACA,iBAAA;EACA,UAAA;EACA,0BAAA;AvDshdJ;AuDphdI;EACC,qBAAA;AvDshdL;;AuDhhdE;EACC,yBAAA;EACA,sBAAA;AvDmhdH;AuDhhdE;EACE,kBAAA;EACA,SAAA;EACD,0BAAA;EACA,sBAAA;EACC,UAAA;AvDkhdJ;AuD/gdE;EACE,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;AvDihdJ;AuD/gdI;EACE,2BAAA;EACA,oCAAA;EACD,wBAAA;EACA,sBAAA;AvDihdL;AuD/gdI;EACC,wBAAA;EACA,uBAAA;AvDihdL;AuD7gdM;EACE,8BAAA;EACD,wBAAA;EACA,uBAAA;AvD+gdP;AuD5gdM;EACE,8BAAA;EACD,wBAAA;EACA,uBAAA;AvD8gdP;AuD1gdI;EACE,kBAAA;EACA,SAAA;EACD,wBAAA;EACA,wBAAA;EACC,UAAA;AvD4gdN;;AuDvgdA,oBAAA;AAEE;EACE,2BAAA;AvDygdJ;AuDvgdI;EACE,iBAAA;AvDygdN;AuDrgdE;EACE,WAAA;EACA,YAAA;EACD,uBAAA;AvDugdH;AuDtgdI;EACE,WAAA;AvDwgdN;AuDpgdE;EACC,gCAAA;AvDsgdH;AuDngdE;EnD1MA,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EmDyME,SAAA;EACA,YAAA;AvDwgdJ;AuDrgdE;EACE,uBAAA;EACA,yBAAA;AvDugdJ;AuDtgdI;EnDnNF,iCAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;AJ4tdF;AuDvgdE;EACE,gCAAA;AvDygdJ;AuDtgdE;EACE,aAAA;AvDwgdJ;;AuDpgdA;EACE,YAAA;AvDugdF;;AuDpgdA;EACE;IACE,iBAAA;EvDugdF;EuDpgdA;IACE,SAAA;EvDsgdF;EuDlgdE;IACE,2BAAA;EvDogdJ;EuDjgdE;IACE,yBAAA;IACA,uBAAA;EvDmgdJ;AACF;AuD//cA;EAEI;IACE,WAAA;IACA,0BAAA;IACA,WAAA;EvDggdJ;EuD//cI;IACC,wBAAA;EvDigdL;EuD7/cE;IACC,qBAAA;EvD+/cH;EuD5/cE;IACE,WAAA;IACA,gBAAA;IACA,qBAAA;EvD8/cJ;EuD5/cI;IACE,sCAAA;IACA,yBAAA;IACD,wBAAA;IACA,sBAAA;EvD8/cL;EuD5/cI;IACC,sBAAA;IACA,qBAAA;EvD8/cL;EuD1/cM;IACE,8BAAA;IACD,yBAAA;IACA,sBAAA;EvD4/cP;EuD1/cM;IACE,8BAAA;IACD,yBAAA;IACA,sBAAA;EvD4/cP;EuDr/cE;IACE,WAAA;EvDu/cJ;EuDp/cE;IACE,mBAAA;IACA,sBAAA;IACA,uBAAA;EvDs/cJ;EuDj/cE;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EvDm/cJ;EuDh/cE;IACE,2BAAA;EvDk/cJ;EuDj/cI;IACE,aAAA;EvDm/cN;EuDh/cI;IACE,eAAA;IACA,SAAA;IACA,aAAA;IACD,wBAAA;EvDk/cL;EuD/+cI;IACE,SAAA;EvDi/cN;EuD9+cE;IACE,eAAA;EvDg/cJ;EuD3+cE;IAEE,kBAAA;IACA,SAAA;IACD,wBAAA;IACA,sBAAA;IACC,kBAAA;EvD4+cJ;EuDz+cE;IACE,SAAA;EvD2+cJ;EuDx+cE;IACE,SAAA;EvD0+cJ;AACF;AuDt+cA;EACE;IACE,WAAA;IACA,oBAAA;EvDw+cF;EuDr+cA;IACE,WAAA;IACA,sBAAA;EvDu+cF;EuDn+cE;IACE,WAAA;IACA,oBAAA;EvDq+cJ;AACF;AmDp4dA,uBAAA;AAiFE;EAfA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EAYE,YA5EkB;EA6ElB,kBAAA;EACA,WA9EkB;EA+ElB,aAnFa;AnD84djB;AmDx0dE;EAGE,aAAA;AnDw0dJ;AmD5zdI;EACE,yDAAA;EACA,sBAxFU;EAyFV,kBAAA;EACA,cAAA;EACA,WAAA;EACD,uBAAA;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;AnD8zdN;AmD3zdI;EACE,yDAAA;EACA,uCAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACD,qBAAA;EACC,YAAA;EACA,kBAAA;EACA,MAAA;EACA,2BAAA;EACA,wBAAA;EACA,WAAA;AnD6zdN;AmDzzdE;EACE,SAAA;EACD,qBAAA;EACC,kBAAA;EACD,mBAAA;EACC,MAAA;EACA,aA3Ha;AnDs7djB;AmDxzdE;EACE,kBAzHyB;EA0HzB,wEAAA;EACA,kBAAA;AnD0zdJ;AmDxzdI;EACE,4EAAA;AnD0zdN;AmDtzdE;EACE,sBA5HuB;EA6HvB,kBA5H4B;EA6H5B,WA5HoB;EA6HpB,eAAA;EACA,iGAAA;EACA,UAAA;EACA,aA9HsB;EAgItB,+BAAA;EACA,YAAA;EACA,aAAA;AnDuzdJ;AmDrzdI;EACE,wCA7IsB;EA8ItB,4DA7I6B;AnDo8dnC;AmDpzdI;EACE,4BAAA;EAEA,kBAAA;AnDqzdN;AmDlzdI;EAGE,gBA9HyB;AnDg7d/B;AmDhzdM;EACE,0DAAA;EACA,YAlIuB;EAmIxB,uBAAA;EACC,UAAA;EACA,2BAAA;EACA,WA/JqB;AnDi9d7B;AmD9ydI;EAGE,mBA7IyB;AnD27d/B;AmD5ydM;EACE,0DAAA;EACA,aAAA;EACA,YAlJuB;EAmJxB,uBAAA;EACC,2BAAA;EACA,WA9KqB;AnD49d7B;AmDxydM;EACC,sBAAA;EACC,wBAAA;AnD0ydR;AmDxydQ;EAJF;IAKG,sBAAA;EnD2ydP;AACF;AmDrydM;EACC,wBAAA;EACA,oBAAA;EACC,wBAAA;AnDuydR;AmDrydQ;EALF;IAMG,oBAAA;EnDwydP;AACF;AmDpydI;EACE,uBAnLyB;AnDy9d/B;AmDpydM;EACE,0DAAA;EACA,YAhNqB;EAiNtB,uBAAA;EACC,WAzLuB;AnD+9d/B;AmDlydI;EACE,yBA9LyB;AnDk+d/B;AmDlydM;EACE,0DAAA;EACA,YA3NqB;EA4NtB,yBAAA;EACC,WApMuB;AnDw+d/B;AmDhydI;EA9KF,6BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EA2KI,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EAEA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EAcE,cAAA;AnDyxdR;AmDz9dE;EAGE,aAAA;AnDy9dJ;AmDxydM;EAEE,kCAAA;EACA,aAAA;AnDyydR;AmDtydM;EACC,sBAhPmB;EAiPlB,SAjPkB;AnDyhe1B;AmD9xdI;EACE,6BAAA;EACA,WA/PkB;EAgQlB,eArPqB;EAsPrB,mBAAA;EACA,wBAAA;EACA,kBAAA;AnDgydN;AmD9xdM;EACE,oBAAA;AnDgydR;AmD5xdI;EACE,eA1QsB;EA2QtB,oBAAA;EACA,wBAAA;AnD8xdN;AmD3xdI;EACE,iBAAA;AnD6xdN;AmD1xdI;EApOF,6BAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;AnDigeF;AmD//dE;EAGE,aAAA;AnD+/dJ;AmDlydM;EACE,sBAxSQ;EAySR,kBAxQuB;EAyQvB,WA1Qe;EA2Qf,iBAAA;EACA,6CAAA;AnDoydR;AmDlydQ;EAGE,uCAAA;EACA,WAlRa;AnDojevB;AmD9xdM;EACE,WAvTQ;EAwTR,uBAAA;AnDgydR;AmD7xdM;EACE,WAxRoB;EAyRpB,mBAAA;EACA,uBAAA;AnD+xdR;AmD1xdM;EACE,iBAAA;AnD4xdR;AmDzxdM;EACE,aAAA;AnD2xdR;AmDvxdI;EAnMF;IAoMI,YAAA;EnD0xdJ;AACF;AmDxxdI;EAvMF;IAwMI,YAAA;EnD2xdJ;AACF;;AmDvxdA;EACE;IACE,qBAAA;EnD0xdF;EmDvxdA;IACE,UAAA;IACA,oCAAA;EnDyxdF;AACF;AmDtxdA;EACE;IACE,YAAA;EnDwxdF;EmDrxdA;IACE,YAAA;EnDuxdF;AACF;AmDpxdA;EACE;IACE,mBAAA;EnDsxdF;EmDnxdA;IACE,YAAA;IACA,sBAAA;EnDqxdF;EmDlxdA;IACE,YAAA;IACA,mBAAA;EnDoxdF;AACF;AwD7oeA,sBAAA;ACDA,cAAA;AACA;EAEI;IAEE,UAAA;IACA,kBAAA;IACA,eAAA;EzD+oeJ;EyD3oeI;IAEE,UAAA;IACA,mBAAA;EzD4oeN;EyDxoeE;IrD2CF,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,aqD7C0B;IrD8C1B,8BqD9CgC;IrD+ChC,0BqD/CgC;IrDgDhC,sBqDhDgC;IrDiDhC,yBqDjDwC;IrDkDxC,qBqDlDwC;IrDmDxC,iBqDnDwC;EzDmpexC;EyDhpeE;IAIE,UAAA;IACA,mBAAA;EzD+oeJ;EyD3oeA;IACE,kCAAA;IACA,gCAAA;EzD6oeF;AACF;A0DhreA;EACE,kBAAA;EACA,UAAA;A1DkreF;;A0D/qeA;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;A1DkreF;;A0D/qeA;EACE,YAAA;EACA,WAAA;A1DkreF;;A0D/qeA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;A1DkreF;;A0D/qeA;EACE,sBAAA;EACA,kBAAA;EACA,cvDqBY;EuDpBZ,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;A1DkreF;;A0D/qeA;EACE,sBAAA;EACA,kBAAA;EACA,cvDSY;EuDRZ,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;A1DkreF;;A0D/qeA;EACE,aAAA;EACD,uBAAA;EACC,UAAA;EACA,kBAAA;EACA,QAAA;A1DkreF;;A0D/qeA;EACE,aAAA;EACD,uBAAA;EACC,UAAA;EACA,kBAAA;EACA,QAAA;A1DkreF;;A0D/qeA;EACE,cAAA;EACA,UAAA;A1DkreF;;A0D/qeA,4BAAA;AAEA;EACE,0BAAA;A1DireF;;A0D9qeA;;EAEE,0BAAA;EACA,kBAAA;A1DireF;;A0D9qeA;EACE,yBAAA;A1DireF;;A0D9qeA;;EAEE,uBAAA;A1DireF;;A0D9qeA;EACE,oBAAA;A1DireF;;A0D9qeA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;A1DireF;;A0D9qeA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACD,qBAAA;EACC,MAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBrD7GM;ED2BN,qEsDmFA;EtDlFA,gEsDkFA;EtDjFA,6DsDiFA;A1DmreF;;A0DhreA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACD,uBAAA;EACC,QAAA;EACA,0BAAA;EACA,eAAA;EACA,crDnHS;ALsyeX;;A0DhreA;EACE,UAAA;EACA,UAAA;EACA,eAAA;A1DmreF;;A0DhreA;EACE,eAAA;A1DmreF;;A0DhreA;EACE,yBrDpIS;EqDqIT,WAAA;A1DmreF;;A0DhreA;EACE,aAAA;A1DmreF;;A0DhreA;EACE,sBrDjJM;EqDkJN,mBAAA;A1DmreF;;A0DhreA;EACE,aAAA;A1DmreF;;A0DhreA;EACE,qBvD/GY;AHkyed;;A0DhreA;EACE,yBvDnHY;AHsyed;;A0DhreA;EACE,qBvDrHU;AHwyeZ;;A0DhreA;EACE,qBvDzHU;AH4yeZ;;A0DhreA;EACE,qBvDhGK;AHmxeP;;A0DhreA;EACE,qBvDpGK;AHuxeP;;A0DhreA;EACE,qBvDvGQ;AH0xeV;;A0DhreA;EACE,qBvD3GQ;AH8xeV;;A0DhreA;EACE,qBvDjHQ;AHoyeV;;A0DhreA;EACE,qBvDrHQ;AHwyeV;;A0DhreA;EACE,0BAAA;A1DmreF;;A0DhreA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;A1DmreF;;A0DhreA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACD,qBAAA;EACC,MAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBrDxNM;ED2BN,4CsD8LA;EtD7LA,uCsD6LA;EtD5LA,oCsD4LA;A1DqreF;;A0DlreA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACD,uBAAA;EACC,QAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBrDlOS;ED6BT,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;EATA,sEsD6MA;EtD5MA,iEsD4MA;EtD3MA,8DsD2MA;A1D0reF;;A0DvreA;EACE,UAAA;EACA,UAAA;EACA,eAAA;A1D0reF;;A0DvreA;EACE,eAAA;A1D0reF;;A0DvreA;EtDpNE,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;AJ+4eF;;A0DzreA;EACE,aAAA;A1D4reF;;A0DzreA;EACE,mBAAA;A1D4reF;;A0DzreA;EACE,aAAA;A1D4reF;;A0DzreA;EACE,yBvD5NY;AHw5ed;;A0DzreA;EACE,qBvDhOY;AH45ed;;A0DzreA;EACE,yBvDpOY;AHg6ed;;A0DzreA;EACE,yBvDtOU;AHk6eZ;;A0DzreA;EACE,qBvD1OU;AHs6eZ;;A0DzreA;EACE,yBvD9OU;AH06eZ;;A0DzreA;EACE,yBvDrNK;AHi5eP;;A0DzreA;EACE,qBvDzNK;AHq5eP;;A0DzreA;EACE,yBvD7NK;AHy5eP;;A0DzreA;EACE,yBvDhOQ;AH45eV;;A0DzreA;EACE,qBvDpOQ;AHg6eV;;A0DzreA;EACE,yBvDxOQ;AHo6eV;;A0DzreA;EACE,yBvD9OQ;AH06eV;;A0DzreA;EACE,qBvDlPQ;AH86eV;;A0DzreA;EACE,yBvDtPQ;AHk7eV;;A0DzreA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;A1D4reF;;A0DzreA;;;;EAIE,cAAA;A1D4reF;;A0DzreA;EACE,gBAAA;A1D4reF;;A0DzreA;EACE,sBAAA;A1D4reF;;A0DzreA;EACE,wBAAA;A1D4reF;;A0DzreA;EACE,sBAAA;A1D4reF;;A0DzreA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,mBAAA;A1D4reF;;A0DzreA;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;A1D4reF;;A0DzreA;EACE,WvDhUmB;EuDiUnB,kBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;A1D4reF;;A0DzreA;EACE,yBrDvXS;EqDwXT,kBAAA;EAEA,crDvXS;EqDwXT,cAAA;EACA,YAAA;EACD,uBAAA;EACC,iBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EtDzWA,4CsD0WA;EtDzWA,uCsDyWA;EtDxWA,oCsDwWA;EACA,WAAA;EACA,UAAA;A1D6reF;;A0D1reA;EACE,yBvDhWY;EuDiWZ,WrD5YM;ALykfR;;A0D1reA;EACE,yBvDnWU;EuDoWV,WrDjZM;AL8kfR;;A0D1reA;;EAEE,crDhZS;AL6kfX;;A0D1reA;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBrD7ZS;EqD8ZT,UAAA;EACD,qBAAA;A1D6reD;;A0D1reA;EACC,wBAAA;EACA,mBAAA;A1D6reD;;A0D1reA;;EAEE,yBvD9XU;AH2jfZ;;A0D1reA;;EAEE,yBvDrYY;AHkkfd;;A0D1reA;EACE,cAAA;EACA,cvDzWO;EuD0WP,gBAAA;EACA,aAAA;A1D6reF;;A0D1reA;EACE;IACE,kBAAA;E1D6reF;E0D1reA;IACE,mBAAA;E1D4reF;AACF;A0DzreA;EtDjZE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BsD0XqB;EtDzXrB,mBsDyXqB;EACrB,mBAAA;A1DsseF;;A0DnseA;EACE,uBAAA;A1DsseF;;A0DnseA;EACE,sBAAA;EACA,wBAAA;A1DsseF;;A2DhqfA,eAAA;AACA,8BAAA,wBAAA;EACE,eAAA;EACA,+BAAA;A3DmqfF;;A2DhqfA,qBAAA,gBAAA;EACE,eAAA;EACA,+BAAA;A3DmqfF;;A2DhqfA,yBAAA,WAAA;EACE,eAAA;EACA,+BAAA;A3DmqfF;;A2DhqfA,oBAAA,gBAAA;EACE,eAAA;EACA,+BAAA;A3DmqfF;;A2DhqfA,iDAAA,wBAAA;EACE,eAAA;A3DmqfF;;A2DhqfA,wCAAA,gBAAA;EACE,eAAA;A3DmqfF;;A2DhqfA,4CAAA,WAAA;EACE,eAAA;A3DmqfF;;A2DhqfA,uCAAA,gBAAA;EACE,eAAA;A3DmqfF;;A2D/pfA;EACE,sBtD7BM;EsD8BN,kBAAA;A3DkqfF;A2DjqfE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;A3DmqfJ;A2DjqfE;EACE,wBAAA;A3DmqfJ;A2DhqfE;EACE,6BAAA;EACA,cAAA;EACA,0DAAA;EACA,YAAA;EACA,WAAA;A3DkqfJ;A2D/pfE;EACE,gBAAA;A3DiqfJ;A2DhqfI;EACE,kBAAA;EACD,sBAAA;EACC,QAAA;A3DkqfN;A2D9pfE;EACE,kBAAA;EACD,sBAAA;EACC,QAAA;A3DgqfJ;A2D5pfI;EACE,wBAAA;EACA,0BAAA;A3D8pfN;A2D3pfI;EACE,kBAAA;EACD,wBAAA;EACC,QAAA;A3D6pfN;A2D1pfI;EACE,gBAAA;A3D4pfN;A2D3pfM;EACE,kBAAA;EACD,wBAAA;EACC,QAAA;A3D6pfR;;A2DrpfI;EACE,4BAAA;A3DwpfN;;A2DnpfA;EAEI;IACE,YAAA;E3DqpfJ;AACF;A4DjwfA;+EAAA;ACAA,eAAA;AACA,eAAA;AAEA;EACE,kBAAA;EACA,YAAA;A7DowfF;;A6DjwfA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sBxDFM;EDsFJ,kBD7De;E0DrBjB,yBAAA;EACA,eAAA;EACA,cAAA;A7DowfF;;A6DjwfA;EACE,mBAAA;A7DowfF;;A6DjwfA;EACE,yBAAA;A7DowfF;A6DlwfE;EACE,gBAAA;EACA,qB1DyBU;AH2ufd;;A6DhwfA;EACE,6BAAA;A7DmwfF;;A6DhwfA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;A7DmwfF;A6DjwfE;EACE,kBAAA;EACD,qBAAA;EACA,mBAAA;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;A7DmwfJ;;A6D/vfA;EzDQE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EyDLjE,sBxD7CM;EDRN,mDyDsDA;EzDrDA,gDyDqDA;EzDpDA,8CyDoDA;EzDnDA,2CyDmDA;EzDwCE,mByDvCqB;EACvB,eAAA;EACA,gBAAA;A7D+wfF;;A6D5wfA;EACE,uBAAA;EACA,UAAA;EACA,QAAA;A7D+wfF;A6D7wfE;EALF;IAMI,WAAA;IACA,QAAA;E7DgxfF;AACF;;A6D7wfA;EACE,mBAAA;A7DgxfF;;A6D7wfA;EACE,yBAAA;A7DgxfF;A6D9wfE;EACE,gBAAA;EACA,qB1D7BU;AH6yfd;;A6D5wfA;EACE,6BAAA;A7D+wfF;;A6D5wfA;EACE,yB1DtCY;E0DuCZ,uBAAA;EACA,UAAA;EACA,QAAA;A7D+wfF;A6D7wfE;EANF;IAOI,WAAA;IACA,QAAA;E7DgxfF;AACF;;A6D7wfA;EzDzCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2ByDkBqB;EzDjBrB,mByDiBqB;EzDvBrB,sCyDwByB;EzDvBzB,8ByDuByB;A7D4xf3B;A6D1xfE;EAEE,SAAA;A7D2xfJ;A6DxxfE;EACE,yBAAA;EzDjBA,kByDkBuB;EACvB,c1D9DU;AHw1fd;A6DxxfI;EAEE,WxD7GE;EwD8GF,yB1DnEQ;AH41fd;A6DrxfE;EACE,gBAAA;A7DuxfJ;;A8Dp5fA,eAAA;AAEA;EACE,eAAA;EACA,kBAAA;A9Ds5fF;A8Dp5fE;EAJF;IAKI,eAAA;E9Du5fF;AACF;;A8Dp5fA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;A9Du5fF;A8Dr5fE;EANF;IAOI,eAAA;E9Dw5fF;AACF;A8Dt5fE;EAVF;IAWI,UAAA;E9Dy5fF;AACF;;A8Dt5fA;EACE,czDRS;EyDST,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kDAAA;A9Dy5fF;A8Dv5fE;EARF;IASI,gBAAA;E9D05fF;AACF;A8Dx5fE;EAZF;IAaI,gBAAA;E9D25fF;AACF;A8Dz5fE;EAhBF;IAiBI,eAAA;E9D45fF;AACF;;A8Dz5fA;EACE,mB3DuGQ;AHqzfV;A8D15fE;EAHF;IAII,mBAAA;E9D65fF;AACF;;A+Dj9fA,gBAAA;AACA;E3D4DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJo6fnE;;A+D39fA;EACE,kBAAA;A/D89fF;;AgEp+fA,sBAAA;AAEA;EACE,aAAA;AhEs+fF;;AgEl+fE;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;E5DmDF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4D1EuB;E5D2EvB,mB4D3EuB;EACrB,8BAAA;EACA,uBAAA;EACA,sBAAA;AhEg/fJ;AgE9+fI;E5D0DF,mBAAA;EACA,eAAA;EACA,WAAA;E4D1DI,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;AhEk/fN;AgEh/fM;EACE,cAAA;AhEk/fR;AgE/+fM;EACE,mBAAA;EACA,eAAA;EACA,sBAAA;AhEi/fR;AgE9+fM;EACE,gBAAA;AhEg/fR;AgE/+fQ;EACE,gBAAA;EACA,sBAAA;AhEi/fV;AgE9+fQ;EACE,yBAAA;EACA,W3DjCF;EDsFJ,kB4DpD6B;EACvB,sBAAA;EACA,kBAAA;AhEg/fV;AgE/+fU;EACE,oBAAA;AhEi/fZ;AgE7+fQ;EACE,yBAAA;AhE++fV;AgE5+fQ;EACE,yBAAA;AhE8+fV;AgE3+fQ;EACE,yBAAA;AhE6+fV;AgEx+fI;EACE,cAAA;EACA,gBAAA;AhE0+fN;AgEz+fM;EACE,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AhE2+fR;AgEz+fQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AhE2+fV;;AgEn+fA;EACE;IACE,aAAA;EhEs+fF;EgEl+fE;IACE,cAAA;IACA,gBAAA;EhEo+fJ;EgEn+fI;IACE,iBAAA;IACA,yBAAA;IACA,6BAAA;IACA,mBAAA;EhEq+fN;EgEn+fM;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EhEq+fR;EgE/9fA;IACE,oBAAA;IACA,kBAAA;EhEi+fF;EgEh+fE;IACE,eAAA;EhEk+fJ;EgEh+fE;IACE,eAAA;EhEk+fJ;AACF;AiExlgBA,mBAAA;AAGE;EACE,mBAAA;AjEwlgBJ;AiEvlgBI;EACE,WAAA;E7D+BJ,mC6D9BI;E7D+BJ,8B6D/BI;E7DgCJ,2B6DhCI;AjE2lgBN;AiExlgBM;EACE,8BAAA;EACA,0BAAA;EACA,sBAAA;AjE0lgBR;;AiEnlgBE;EACE,uBAAA;EACA,oBAAA;AjEslgBJ;AiErlgBI;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;AjEulgBN;AiEplgBI;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AjEslgBN;AiEnlgBI;EAGE,eAAA;EACA,yB9DWQ;E8DVR,qB9DUQ;E8DTR,W5DlCE;ALqngBR;AiEhlgBI;EA3BF;IA4BI,mBAAA;EjEmlgBJ;AACF;;AkEpogBA,cAAA;AAEA;EACE,mBAAA;AlEsogBF;;AkElogBA;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;AlEqogBF;AkEnogBE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AlEqogBJ;AkEnogBI;EACE,gBAAA;AlEqogBN;;AkE/ngBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;E9DiEE,kB8DhEqB;EACvB,mBAAA;EACA,W7DxBM;AL0pgBR;AkEhogBE;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,kBAAA;EACD,sBAAA;EACC,SAAA;EACA,cAAA;EACA,2BAAA;AlEgogBJ;AkE7ngBE;E9D+CE,0B8D9CuB;AlE+ngB3B;AkE9ngBI;EACE,0BAAA;AlEgogBN;;AkE1ngBA;EACE,gBAAA;AlE6ngBF;AkE5ngBE;EACE,mBAAA;AlE8ngBJ;AkE7ngBI;EACE,gBAAA;AlE+ngBN;AkE5ngBE;EACE,c/DdU;AH4ogBd;AkE5ngBE;EACE,cAAA;AlE8ngBJ;;AkEzngBE;EACE,mBAAA;AlE4ngBJ;AkE3ngBI;EACE,gBAAA;AlE6ngBN;;AkExngBA;EACE,cAAA;EACA,mBAAA;AlE2ngBF;AkE1ngBE;E9DUE,kB8DTuB;EACvB,WAAA;AlE4ngBJ;;AkEvngBE;EACE,gBAAA;EACA,kBAAA;AlE0ngBJ;;AkEtngBA;EACE,mBAAA;AlEyngBF;;AkEtngBA;;EAEE,eAAA;EACA,c7D3FS;E6D4FT,qBAAA;AlEyngBF;AkExngBE;;EACE,qBAAA;EACA,sBAAA;AlE2ngBJ;;AkEtngBE;EACE,yBAAA;AlEyngBJ;;AmE7ugBA,mBAAA;AACA;EACE,kBAAA;AnEgvgBF;AmE9ugBE;;EAEE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gB9DqPc;AL2/flB;AmE/ugBI;;EACE,eAAA;EACA,wBAAA;AnEkvgBN;AmEhvgBI;;EACE,eAAA;EACA,iBAAA;AnEmvgBN;AmE/ugBE;EACE,yCAAA;AnEivgBJ;AmE9ugBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AnEgvgBJ;AmE9ugBI;EACE,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sB9D7BE;E8D8BF,qCAAA;EACA,eAAA;EACA,c9D1BK;E8D2BL,kBAAA;AnEgvgBN;AmE/ugBM;EACE,iBAAA;EACA,eAAA;AnEivgBR;;AmE3ugBA;EACE,mBAAA;AnE8ugBF;AmE5ugBE;EACE,uBAAA;EACA,cAAA;AnE8ugBJ;AmE3ugBE;EACE,mBAAA;AnE6ugBJ;;AmEvugBE;;EAEE,eAAA;AnE0ugBJ;;AmErugBE;EACE,oCAAA;AnEwugBJ;AmEtugBE;EACE,iBAAA;EACA,oBAAA;AnEwugBJ;;AmEpugBA;EACE,gBAAA;EACA,gBAAA;EACA,mCAAA;AnEuugBF;AmEtugBE;EACE,eAAA;AnEwugBJ;;AmEpugBA;EACE,gBAAA;AnEuugBF;AmEtugBE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AnEwugBJ;AmEtugBI;EANF;IAOI,UAAA;EnEyugBJ;AACF;AmEvugBI;EAVF;IAWI,cAAA;EnE0ugBJ;AACF;;AmErugBE;EACE,oBAAA;AnEwugBJ;;AmEpugBA,6BAAA;AACA;EACE,eAAA;AnEuugBF;AmErugBE;EAHF;IAII,eAAA;EnEwugBF;AACF;;AmErugBA;EACE,eAAA;AnEwugBF;AmEtugBE;EAHF;IAII,eAAA;EnEyugBF;AACF;;AmErugBE;EACE,QAAA;EACA,kBAAA;AnEwugBJ;AmEtugBI;EAJF;IAKI,QAAA;EnEyugBJ;AACF;AmEtugBE;EACE,QAAA;AnEwugBJ;AmEtugBI;EAHF;IAII,QAAA;EnEyugBJ;AACF;;AmErugBA;EACE,0BAAA;EACA,wBAAA;EACA,gCAAA;AnEwugBF;AmEtugBE;EACE;;IAEE,0BAAA;EnEwugBJ;AACF;;AmEnugBE;EACE,eAAA;EACA,kBAAA;AnEsugBJ;;AmElugBA;EACE,WAAA;AnEqugBF;;AmEjugBE;EACE,kBAAA;AnEougBJ;;AmEhugBA,4BAAA;AACA;EACE,0BAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;E/D/HA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+DwGqB;E/DvGrB,mB+DuGqB;AnE8ugBvB;AmE5ugBE;EACE,SAAA;EACA,WhE3CM;EgE4CN,YhE5CM;EgE6CN,W9D1LI;E8D2LJ,eAAA;E/DrGA,kBD3DmB;ECwBrB,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a+DsIwB;E/DrIxB,8B+DqI8B;E/DpI9B,0B+DoI8B;E/DnI9B,sB+DmI8B;E/DlI9B,yB+DkIsC;E/DjItC,qB+DiIsC;E/DhItC,iB+DgIsC;E/DtHtC,+B+DuH2B;E/DtH3B,uB+DsH2B;E/DlH3B,2B+DmHuB;E/DlHvB,mB+DkHuB;E/DpKvB,kC+DqKE;E/DpKF,6B+DoKE;E/DnKF,0B+DmKE;EACA,kBAAA;EACD,wBAAA;AnE4vgBH;AmEzvgBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;E/DlHA,gB+DmHuB;EACvB,kBAAA;EACD,qBAAA;AnE2vgBH;;AmEvvgBA;E/D5JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+DqIqB;E/DpIrB,mB+DoIqB;EACrB,iBhEjES;EgEkET,uBAAA;EACA,gBAAA;AnEqwgBF;AmEnwgBE;EACE,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AnEqwgBJ;AmElwgBE;EACE,oBAAA;AnEowgBJ;AmEjwgBE;EACE,yBAAA;AnEmwgBJ;;AmE/vgBA;EACE,eAAA;AnEkwgBF;;AmE/vgBA;EACE,iBhE1FS;AH41gBX;;AmE/vgBA;E/D3LE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+DoKqB;E/DnKrB,mB+DmKqB;EACrB,wBAAA;AnE6wgBF;;AmE1wgBA;EACE,uBAAA;EACA,wBAAA;AnE6wgBF;;AmExwgBI;EACE,kBAAA;AnE2wgBN;;AmEtwgBA;EACE,kBAAA;AnEywgBF;AmEvwgBE;EACE,sCAAA;EACA,WAAA;EACD,wBAAA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AnEywgBJ;;AmEpwgBA;EACE,kBAAA;EACA,0BAAA;AnEuwgBF;AmErwgBE;EACE,sCAAA;EACA,WAAA;EACD,wBAAA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AnEuwgBJ;;AmEnwgBA;EACE,kBAAA;EACD,wBAAA;EACC,SAAA;EACA,UAAA;E/D/ME,kB+DgNqB;EACvB,YAAA;EACA,WAAA;EACA,yB9DpSS;AL0ihBX;;AmEnwgBA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;E/DzNE,kBD3DmB;AH2hhBvB;;AmEnwgBA;EACE,cAAA;AnEswgBF;AmEpwgBE;EACE,mBAAA;AnEswgBJ;AmEnwgBE;EACE,eAAA;EACA,uBAAA;AnEqwgBJ;AmElwgBE;EACE,cAAA;EACA,kBAAA;EACA,WhElPS;AHs/gBb;AmElwgBI;EAEE,chE3RQ;EgE4RR,qBAAA;AnEmwgBN;;AmE7vgBE;EACE,uBAAA;AnEgwgBJ;AmE9vgBE;EACE,yB9D/UO;E8DgVP,gBAAA;EACA,iBAAA;EACA,c9D9UO;E8D+UP,eAAA;EACA,yBhEpRQ;AHohhBZ;AmE9vgBI;EACE,yBhE9SQ;EgE+SR,W9D1VE;E8D2VF,qBhEhTQ;AHgjhBd;AmE9vgBM;EAEE,W9D/VA;AL8lhBR;AmE1vgBE;E/DnPE,2BDzFY;EC0FZ,8BD1FY;AH0khBhB;AmE1vgBE;E/DrQE,4BD3EY;EC4EZ,+BD5EY;AH8khBhB;;AmEzvgBA;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0DAAA;AnE4vgBF;AmE1vgBE;EACE,mBAAA;AnE4vgBJ;AmE3vgBI;EAFF;IAGI,mBAAA;EnE8vgBJ;AACF;AmE3vgBE;EACE,WAAA;EACA,YAAA;AnE6vgBJ;AmE1vgBE;EACE,qBAAA;AnE4vgBJ;AmE1vgBI;EACE,cAAA;AnE4vgBN;AmE1vgBM;EAHF;IAII,cAAA;EnE6vgBN;AACF;AmE3vgBM;EAPF;IAQI,aAAA;EnE8vgBN;AACF;AmE5vgBM;EAXF;IAYI,cAAA;EnE+vgBN;AACF;;AmExvgBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AnE2vgBJ;AmEzvgBI;EAEE,cAAA;AnE0vgBN;;AoEjqhBA,kBAAA;AACA;EACE,kBAAA;ApEoqhBF;;AoEjqhBA;EACE,mBAAA;ApEoqhBF;AoElqhBE;EACE,cAAA;EACA,aAAA;EhEmDF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,agEtDwB;EhEuDxB,8BgEvD8B;EhEwD9B,0BgExD8B;EhEyD9B,sBgEzD8B;EhE0D9B,yBgE1DsC;EhE2DtC,qBgE3DsC;EhE4DtC,iBgE5DsC;EhEsEtC,+BgErE2B;EhEsE3B,uBgEtE2B;ApE+qhB7B;AoE7qhBI;EACE,gBAAA;ApE+qhBN;AoE3qhBE;EACE,gBAAA;ApE6qhBJ;;AoEzqhBA;EACE,gBAAA;EACA,uBAAA;ApE4qhBF;AoE1qhBE;EACE,kBAAA;ApE4qhBJ;;AoEvqhBE;EACE,kBAAA;ApE0qhBJ;AoEvqhBE;EACE,gBAAA;EACA,cAAA;ApEyqhBJ;;AqEhthBA;EACI,gBAAA;EACA,cAAA;EACA,aAAA;ArEmthBJ;;AqEhthBA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;ArEmthBJ;AqEjthBI;EAAU,SAAA;ArEothBd;AqEnthBI;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;ArEythBlE;AqExthBI;EAAc,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;ArE+thBvF;AqE9thBI;EAAa,aAAA;EAAe,SAAA;EAAW,eAAA;ArEmuhB3C;AqEluhBI;EAAe,qBAAA;ArEquhBnB;AqEpuhBI;EAA8B,sBAAA;ArEuuhBlC;AqEtuhBI;EAAS,OAAA;EAAS,aAAA;EAAe,yBAAA;ArE2uhBrC;AqE1uhBI;EAAa,eAAA;EAAiB,YAAA;ArE8uhBlC;;AqE3uhBA;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;ArE8uhBJ;AqE5uhBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ArE8uhBR;AqE5uhBQ;EAAI,cAAA;EAAgB,oBAAA;EAAsB,iBAAA;EAAmB,gBAAA;ArEkvhBrE;;AqE7uhBI;EAAU,aAAA;EAAe,sBAAA;ArEkvhB7B;AqEjvhBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;ArEmvhBR;AqEjvhBQ;EAAU,mBAAA;EAAqB,qBAAA;ArEqvhBvC;AqEpvhBQ;EAAkB,0BAAA;EAA4B,oBAAA;EAAsB,mBAAA;ArEyvhB5E;AqExvhBQ;EAAe,mBAAA;ArE2vhBvB;AqEzvhBI;EAAY,UAAA;EAAY,YAAA;EAAc,kBAAA;EAAoB,UAAA;ArE+vhB9D;AqE9vhBI;EAAU,eAAA;EAAiB,cAAA;EAAgB,gBAAA;EAAkB,OAAA;ArEowhBjE;AqEnwhBI;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;ArEqwhBR;AqEnwhBI;EAAU,eAAA;EAAiB,cAAA;EAAgB,mBAAA;ArEwwhB/C;AqEvwhBI;EAAU,cAAA;EAAgB,eAAA;ArE2whB9B;;AqExwhBA;EACI,mBAAA;ArE2whBJ;AqEzwhBI;EAAyB,uBAAA;EAAyB,mBAAA;ArE6whBtD;AqE5whBI;EAAU,aAAA;EAAe,SAAA;ArEgxhB7B;;AqE7whBA;EACI,OAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;ArEgxhBJ;AqE9whBI;EAAU,eAAA;EAAiB,cAAA;EAAgB,kBAAA;EAAoB,cAAA;ArEoxhBnE;AqEnxhBI;EAAI,cAAA;EAAgB,cAAA;EAAgB,eAAA;EAAiB,kBAAA;ArEyxhBzD;;AqEtxhBA;EACI;IAAiB,sBAAA;IAAwB,kBAAA;ErE2xhB3C;EqE1xhBE;IAAsB,uBAAA;ErE6xhBxB;EqE5xhBE;IAA2B,sBAAA;ErE+xhB7B;AACF;AsEp4hBA;+EAAA;AAEA;EAEE,yBAAA;EACA,sBjEKM;EDsFJ,kBD7De;EmE5BjB,mBAAA;EACA,mBAAA;AtEq4hBF;AsEn4hBE;EAEE,kBAAA;AtEo4hBJ;AsEl4hBI;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;AtEo4hBN;AsEj4hBI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;AtEm4hBN;AsE/3hBE;ElEMA,6CkELE;ElEMF,wCkENE;ElEOF,qCkEPE;EACA,6CAAA;AtEm4hBJ;AsEh4hBE;EAlCF;IAmCI,mBAAA;EtEm4hBF;AACF;;AsE/3hBE;EACE,qBAAA;EACA,WAAA;AtEk4hBJ;;AsE73hBE;EACE,eAAA;AtEg4hBJ;;AuEl7hBA;+EAAA;ACAA,qBAAA;AAEA;EpE2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoE9DsB;EpE+DtB,8BoE/D4B;EpEgE5B,0BoEhE4B;EpEiE5B,sBoEjE4B;EpEkE5B,yBoElEoC;EpEmEpC,qBoEnEoC;EpEoEpC,iBoEpEoC;EpEmFpC,4BoElFqB;EpEmFrB,oBoEnFqB;EACrB,YAAA;AxEi8hBF;;AwE97hBA;EACE,kBAAA;EpEoDA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEvDsB;EpEwDtB,2BoExD4B;EpEyD5B,uBoEzD4B;EpE0D5B,mBoE1D4B;EpE2D5B,yBoE3DiC;EpE4DjC,qBoE5DiC;EpE6DjC,iBoE7DiC;EACjC,iBAAA;EACA,gBAAA;EACA,oBAAA;AxE28hBF;AwEz8hBE;EAPF;IAQI,aAAA;ExE48hBF;AACF;;AwEz8hBA;EACE,kBAAA;EACA,UAAA;EpEuCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoE1CsB;EpE2CtB,8BoE3C4B;EpE4C5B,0BoE5C4B;EpE6C5B,sBoE7C4B;EpE8C5B,yBoE9CoC;EpE+CpC,qBoE/CoC;EpEgDpC,iBoEhDoC;EpEoDpC,uBAAA;EACA,mBAAA;EACA,eAAA;EoEpDA,gBAAA;EACA,gBAAA;AxEw9hBF;;AwEr9hBA;EACE,gCAAA;EpE+BA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoElCsB;EpEmCtB,8BoEnC4B;EpEoC5B,0BoEpC4B;EpEqC5B,sBoErC4B;EpEsC5B,yBoEtCoC;EpEuCpC,qBoEvCoC;EpEwCpC,iBoExCoC;AxEk+hBtC;AwEh+hBE;EACE,kBAAA;EACA,kBAAA;AxEk+hBJ;;AwE99hBA;EACE,aAAA;EpEqBA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BoE5CqB;EpE6CrB,mBoE7CqB;EpEuCrB,+BoEtCyB;EpEuCzB,uBoEvCyB;EACzB,gBAAA;EACA,eAAA;EACA,kDAAA;EACA,8CAAA;AxE6+hBF;AwE5+hBE;EACE,eAAA;AxE8+hBJ;;AwE1+hBA;EpEQE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEXsB;EpEYtB,8BoEZ4B;EpEa5B,0BoEb4B;EpEc5B,sBoEd4B;EpEe5B,yBoEfoC;EpEgBpC,qBoEhBoC;EpEiBpC,iBoEjBoC;AxEu/hBtC;;AwEp/hBA;EACE,eAAA;AxEu/hBF;;AwEh/hBA;EpEJE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EoEOjE,aAAA;AxE6/hBF;;AwE1/hBA;EACE,gBAAA;EACA,uBAAA;EpEXA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEQsB;EpEPtB,8BoEO4B;EpEN5B,0BoEM4B;EpEL5B,sBoEK4B;EpEJ5B,yBoEIoC;EpEHpC,qBoEGoC;EpEFpC,iBoEEoC;EpEQpC,+BoEPyB;EpEQzB,uBoERyB;AxEwgiB3B;AwEtgiBE;EpEfA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEYwB;EpEXxB,8BoEW8B;EpEV9B,0BoEU8B;EpET9B,sBoES8B;EpER9B,yBoEQsC;EpEPtC,qBoEOsC;EpENtC,iBoEMsC;AxEkhiBxC;AwE/giBE;EACE,kBAAA;EACA,cAAA;EpErBF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BoEFuB;EpEGvB,mBoEHuB;EACrB,qBAAA;AxE4hiBJ;AwE1hiBI;EAEE,WrECO;AH0hiBb;AwExhiBI;EACE,crExCQ;AHkkiBd;AwEthiBE;EACE,uBAAA;EACA,eAAA;AxEwhiBJ;AwErhiBE;EACE,qBAAA;EACA,sBAAA;AxEuhiBJ;AwEphiBE;EACE,kBAAA;AxEshiBJ;;AwElhiBA;EACE,kBAAA;EACA,UAAA;EpErDA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEkDsB;EpEjDtB,8BoEiD4B;EpEhD5B,0BoEgD4B;EpE/C5B,sBoE+C4B;EpE9C5B,yBoE8CoC;EpE7CpC,qBoE6CoC;EpE5CpC,iBoE4CoC;EpExCpC,sBAAA;EACA,kBAAA;EACA,cAAA;EoEwCA,6BAAA;AxEiiiBF;;AwE9hiBA;EACE,kBAAA;EACA,gBAAA;EpE7DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoE0DsB;EpEzDtB,8BoEyD4B;EpExD5B,0BoEwD4B;EpEvD5B,sBoEuD4B;EpEtD5B,yBoEsDoC;EpErDpC,qBoEqDoC;EpEpDpC,iBoEoDoC;EpE1CpC,+BoE2CyB;EpE1CzB,uBoE0CyB;EACzB,sBnEnHM;EmEoHN,gCAAA;AxE4iiBF;AwE1iiBE;EACE,gBAAA;AxE4iiBJ;AwE1iiBI;EpEnCA,gBoEoCyB;EACvB,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,0BAAA;AxE4iiBN;AwE1iiBM;EACE,yBnEhIG;AL4qiBX;AwExiiBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACD,wBAAA;EACC,MAAA;EACA,UAAA;AxE0iiBN;;AwEriiBA;EpE7FE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BoEsEqB;EpErErB,mBoEqEqB;EpE3ErB,sCoE4EyB;EpE3EzB,8BoE2EyB;AxEojiB3B;;AwEjjiBA;EACE,sBnEvJM;EDmDN,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEiGsB;EpEhGtB,8BoEgG4B;EpE/F5B,0BoE+F4B;EpE9F5B,sBoE8F4B;EpE7F5B,yBoE6FoC;EpE5FpC,qBoE4FoC;EpE3FpC,iBoE2FoC;AxE8jiBtC;;AwE3jiBA;EACE,iBAAA;EpEzGA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EoE4GjE,gCAAA;AxEwkiBF;AwEtkiBE;EpE1EE,gBoE2EuB;AxEwkiB3B;;AwEpkiBA;EACE,0BAAA;AxEukiBF;AwErkiBE;EAHF;IAII,0BAAA;ExEwkiBF;AACF;;AwErkiBA;EpE1HE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BoEmGqB;EpElGrB,mBoEkGqB;EACrB,wBAAA;AxEmliBF;;AwEhliBA;EACE,uBAAA;AxEmliBF;;AwEhliBA;EACE,yBAAA;AxEmliBF;;AwEhliBA;EpExIE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEqIsB;EpEpItB,8BoEoI4B;EpEnI5B,0BoEmI4B;EpElI5B,sBoEkI4B;EpEjI5B,yBoEiIoC;EpEhIpC,qBoEgIoC;EpE/HpC,iBoE+HoC;EpErHpC,+BoEsHyB;EpErHzB,uBoEqHyB;AxE8liB3B;;AwE3liBA;EpE7IE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BoEsHqB;EpErHrB,mBoEqHqB;EACrB,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AxEymiBF;AwEvmiBE;EACE,sBAAA;EACA,gBAAA;AxEymiBJ;AwEtmiBE;EACE,0BAAA;EpEnIF,0BoEoIuB;EpEnIvB,kBoEmIuB;AxEymiBzB;;AwErmiBA;EACE,mBAAA;AxEwmiBF;AwEtmiBE;EACE,uBAAA;AxEwmiBJ;;AwEpmiBA;EpE3JE,mBAAA;EACA,eAAA;EACA,WAAA;EAhBA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEuKsB;EpEtKtB,8BoEsK4B;EpErK5B,0BoEqK4B;EpEpK5B,sBoEoK4B;EpEnK5B,yBoEmKoC;EpElKpC,qBoEkKoC;EpEjKpC,iBoEiKoC;EACpC,6BAAA;AxEmniBF;;AwEhniBA;EACE,kBAAA;AxEmniBF;AwEjniBE;EACE,kBAAA;AxEmniBJ;;AwE/miBA;EACE,iBAAA;AxEkniBF;;AwE/miBA;EACE,sBnE/OM;EmEgPN,oCAAA;EACA,kBAAA;EACA,UAAA;AxEkniBF;AwEhniBE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AxEkniBJ;;AwE9miBA;EACE,gBAAA;AxEiniBF;AwE/miBE;EACE,aAAA;AxEiniBJ;;AwE7miBA;EACE,kBAAA;AxEgniBF;;AwE7miBA;EACE,eAAA;AxEgniBF;;AwE7miBA;EACE,uBAAA;AxEgniBF;;AwE7miBA;EpE5NE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EAqBjE,sCoE0MyB;EpEzMzB,8BoEyMyB;EpErMzB,2BoEsMqB;EpErMrB,mBoEqMqB;EACrB,WAAA;EACA,eAAA;AxE4niBF;;AwEzniBA;EpEpOE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aoEiOsB;EpEhOtB,8BoEgO4B;EpE/N5B,0BoE+N4B;EpE9N5B,sBoE8N4B;EpE7N5B,yBoE6NoC;EpE5NpC,qBoE4NoC;EpE3NpC,iBoE2NoC;EpEjNpC,+BoEkNyB;EpEjNzB,uBoEiNyB;EpE7MzB,2BoE8MqB;EpE7MrB,mBoE6MqB;AxEwoiBvB;;AwEhoiBA;EpEtNE,2BoEuNqB;EpEtNrB,mBoEsNqB;AxEooiBvB;;AwEjoiBA;EACE;IpEpPA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;IACA,coEiPwB;IpEhPxB,2BoEgP+B;IpE/O/B,uBoE+O+B;IpE9O/B,mBoE8O+B;IpE7O/B,yBoE6OoC;IpE5OpC,qBoE4OoC;IpE3OpC,iBoE2OoC;IpEvOpC,sBAAA;IACA,kBAAA;IACA,cAAA;IoEuOE,gBrEjMa;IqEkMb,gBrElMa;IqEmMb,sBnE5SI;EL47iBN;EwE7oiBA;IACE,kBAAA;IACA,gBAAA;IACA,kBAAA;IACA,wBAAA;IACA,0BAAA;ExE+oiBF;EwE7oiBE;IACE,kBAAA;IACD,qBAAA;IACC,MAAA;IACA,UAAA;IACA,oCAAA;IACA,YAAA;IACA,WAAA;IpEvOF,gBoEwOyB;IACvB,eAAA;ExE+oiBJ;EwE5oiBE;IACE,YAAA;IACA,kBAAA;IACA,wBAAA;IACA,0BAAA;ExE8oiBJ;EwE3oiBE;IACE,YAAA;ExE6oiBJ;EwEzoiBA;IACE,2BAAA;ExE2oiBF;EwExoiBA;IACE,eAAA;ExE0oiBF;AACF;AwEvoiBA;EACE;IACE,gBAAA;ExEyoiBF;AACF;AwEtoiBA;EACE;IACE,cAAA;ExEwoiBF;AACF;AwEroiBA;EACE;IACE,sBAAA;IACA,eAAA;ExEuoiBF;EwEroiBE;IACE,gBAAA;ExEuoiBJ;AACF;AwEnoiBA;EACE;IACE,kBAAA;ExEqoiBF;EwEloiBA;IACE,eAAA;ExEooiBF;EwEhoiBE;IACC,iCAAA;IACA,gCAAA;ExEkoiBH;EwE/niBE;IACE,gBAAA;ExEioiBJ;EwE/niBI;IpE1SF,sBoE2S2B;ExEioiB7B;EwE5niBI;IACC,sBAAA;IACA,uBAAA;ExE8niBL;EwE3niBI;IACC,sBAAA;IACA,uBAAA;ExE6niBL;EwEzniBE;IACE,uBAAA;ExE2niBJ;AACF;AwEvniBA;EAEI;IACE,gBAAA;ExEwniBJ;AACF;AwEpniBA;EACE;IACE,wBAAA;ExEsniBF;AACF;AyElijBA,qBAAA;AAEA;ErEyEE,sBAAA;EACA,kBAAA;EACA,cAAA;AJ29iBF;AyEnijBE;EACC,yBAAA;AzEqijBH;;AyEjijBA;ErEmDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEtDsB;ErEuDtB,2BqEvD4B;ErEwD5B,uBqExD4B;ErEyD5B,mBqEzD4B;ErE0D5B,yBqE1DiC;ErE2DjC,qBqE3DiC;ErE4DjC,iBqE5DiC;ErEgEjC,sBAAA;EACA,kBAAA;EACA,cAAA;EqEhEA,yBpEFS;EoEGT,kBAAA;EACA,WAAA;AzEgjjBF;;AyE7ijBA;ErE2CE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqE9CsB;ErE+CtB,8BqE/C4B;ErEgD5B,0BqEhD4B;ErEiD5B,sBqEjD4B;ErEkD5B,yBqElDoC;ErEmDpC,qBqEnDoC;ErEoDpC,iBqEpDoC;ErEwDpC,uBAAA;EACA,mBAAA;EACA,eAAA;EqExDA,gBAAA;EACA,oCAAA;AzE4jjBF;;AyEzjjBA;ErEoCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEvCsB;ErEwCtB,8BqExC4B;ErEyC5B,0BqEzC4B;ErE0C5B,sBqE1C4B;ErE2C5B,yBqE3CoC;ErE4CpC,qBqE5CoC;ErE6CpC,iBqE7CoC;ErEiDpC,sBAAA;EACA,kBAAA;EACA,cAAA;EqEjDA,eAAA;EACA,kBAAA;EACA,UAAA;AzEwkjBF;;AyErkjBA;ErE4BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqE/BsB;ErEgCtB,8BqEhC4B;ErEiC5B,0BqEjC4B;ErEkC5B,sBqElC4B;ErEmC5B,yBqEnCoC;ErEoCpC,qBqEpCoC;ErEqCpC,iBqErCoC;EACpC,uBAAA;EACA,kDAAA;AzEkljBF;;AyE/kjBA;ErEsBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EqEnBjE,mBAAA;AzE4ljBF;;AyEzljBA;ErEiBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEpBsB;ErEqBtB,8BqErB4B;ErEsB5B,0BqEtB4B;ErEuB5B,sBqEvB4B;ErEwB5B,yBqExBoC;ErEyBpC,qBqEzBoC;ErE0BpC,iBqE1BoC;EACpC,gBAAA;AzEsmjBF;AyEpmjBE;ErE2BA,sBAAA;EACA,kBAAA;EACA,cAAA;AJ4kjBF;AyEtmjBI;ErEjDF,wBqEkDI;ErEjDJ,qBqEiDI;ErEhDJ,mBqEgDI;ErE/CJ,gBqE+CI;ErE4CF,gBqE3CyB;EACvB,0BAAA;EACA,YAAA;AzE2mjBN;AyExmjBI;EACC,wBAAA;EACC,MAAA;EACA,YAAA;EACA,UAAA;AzE0mjBN;;AyErmjBA;EACE,etEmFQ;AHqhjBV;AyEtmjBE;EACE,cAAA;EACA,eAAA;AzEwmjBJ;AyErmjBE;EACE,eAAA;AzEumjBJ;;AyEnmjBA;EACE,kBAAA;EACA,etEqEQ;AHiijBV;AyEpmjBE;EACE,cAAA;EACA,kBAAA;EACD,qBAAA;EACC,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AzEsmjBJ;AyEpmjBI;EACE,UAAA;EACA,WAAA;AzEsmjBN;AyEnmjBI;EACE,yBAAA;AzEqmjBN;AyEjmjBI;EACE,sBpE/FE;EoEgGF,yBAAA;AzEmmjBN;AyE/ljBI;EACE,yBAAA;AzEimjBN;AyE5ljBE;EACE,etEmCM;AH2jjBV;;AyE1ljBA;EACE,sBpEhHM;AL6sjBR;;AyE1ljBA;EACE,kBAAA;EACA,etEhHe;EsEiHf,ctE5CK;ECvBL,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEgEsB;ErE/DtB,8BqE+D4B;ErE9D5B,0BqE8D4B;ErE7D5B,sBqE6D4B;ErE5D5B,yBqE4DoC;ErE3DpC,qBqE2DoC;ErE1DpC,iBqE0DoC;ErEhDpC,+BqEiDyB;ErEhDzB,uBqEgDyB;AzEwmjB3B;;AyErmjBA;EACE,6DAAA;AzEwmjBF;;AyErmjBA;ErE5EE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEyEsB;ErExEtB,8BqEwE4B;ErEvE5B,0BqEuE4B;ErEtE5B,sBqEsE4B;ErErE5B,yBqEqEoC;ErEpEpC,qBqEoEoC;ErEnEpC,iBqEmEoC;AzEknjBtC;AyEhnjBE;ErE3DA,+BqE4D2B;ErE3D3B,uBqE2D2B;ErEvD3B,2BqEwDuB;ErEvDvB,mBqEuDuB;AzEonjBzB;AyElnjBI;EACE,yBAAA;AzEonjBN;;AyE/mjBA;EACE,gCAAA;EACA,aAAA;ErE3FA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEwFsB;ErEvFtB,8BqEuF4B;ErEtF5B,0BqEsF4B;ErErF5B,sBqEqF4B;ErEpF5B,yBqEoFoC;ErEnFpC,qBqEmFoC;ErElFpC,iBqEkFoC;ErExEpC,+BqEyEyB;ErExEzB,uBqEwEyB;EACzB,eAAA;EACA,gBAAA;AzE6njBF;AyE3njBE;EAEE,uBAAA;AzE4njBJ;;AyExnjBA;EACE,cAAA;ErE/EA,2BqEgFqB;ErE/ErB,mBqE+EqB;AzE4njBvB;;AyEznjBA;EACE,cAAA;AzE4njBF;AyE1njBE;EACE,gBAAA;AzE4njBJ;AyEznjBE;EACE,cAAA;EACA,kBAAA;AzE2njBJ;;AyEvnjBA;EACE,cpEvKS;EoEwKT,eAAA;AzE0njBF;;AyEvnjBA;EACE,cAAA;EACA,iBAAA;AzE0njBF;;AyEnnjBA;ErEvIE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEoIsB;ErEnItB,8BqEmI4B;ErElI5B,0BqEkI4B;ErEjI5B,sBqEiI4B;ErEhI5B,yBqEgIoC;ErE/HpC,qBqE+HoC;ErE9HpC,iBqE8HoC;ErEpHpC,+BqEqHyB;ErEpHzB,uBqEoHyB;EACzB,YAAA;AzEiojBF;;AyE9njBA;ErE7IE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqE0IsB;ErEzItB,8BqEyI4B;ErExI5B,0BqEwI4B;ErEvI5B,sBqEuI4B;ErEtI5B,yBqEsIoC;ErErIpC,qBqEqIoC;ErEpIpC,iBqEoIoC;ErE1HpC,+BqE2HyB;ErE1HzB,uBqE0HyB;ErEtHzB,2BqEuHqB;ErEtHrB,mBqEsHqB;EACrB,YAAA;EACA,aAAA;AzE6ojBF;;AyE1ojBA;EACE,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,mBAAA;AzE6ojBF;;AyE1ojBA;ErE7JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqE0JsB;ErEzJtB,8BqEyJ4B;ErExJ5B,0BqEwJ4B;ErEvJ5B,sBqEuJ4B;ErEtJ5B,yBqEsJoC;ErErJpC,qBqEqJoC;ErEpJpC,iBqEoJoC;AzEupjBtC;;AyEppjBA;ErEjKE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BqE0IqB;ErEzIrB,mBqEyIqB;EACrB,gCAAA;EACA,aAAA;EACA,sBpEzNM;EoE0NN,WAAA;AzEkqjBF;;AyE/pjBA;ErE1KE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BqEmJqB;ErElJrB,mBqEkJqB;EACrB,uBAAA;AzE6qjBF;;AyE1qjBA;EACE,eAAA;EACA,gBAAA;AzE6qjBF;;AyE1qjBA;ErErLE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aqEkLsB;ErEjLtB,8BqEiL4B;ErEhL5B,0BqEgL4B;ErE/K5B,sBqE+K4B;ErE9K5B,yBqE8KoC;ErE7KpC,qBqE6KoC;ErE5KpC,iBqE4KoC;EACpC,6BAAA;EACA,aAAA;EACA,sBpE5OM;EoE6ON,WAAA;AzEurjBF;AyErrjBE;EACE,gBAAA;AzEurjBJ;;AyEnrjBA;EACE,iBAAA;AzEsrjBF;;AyEnrjBA;EACE,aAAA;AzEsrjBF;AyEprjBE;EACE,iBAAA;EACA,sBpE7PI;EDsFJ,iCqEwKuB;EACvB,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AzEsrjBJ;AyElrjBI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;ErEnLF,+BqEoLyB;AzEorjB7B;;AyE/qjBA;EACE,0BAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;AzEkrjBF;;AyE/qjBA;EACE,YAAA;ErE/RA,wBqEgSA;ErE/RA,qBqE+RA;ErE9RA,mBqE8RA;ErE7RA,gBqE6RA;ErElME,gBqEmMqB;AzEqrjBzB;;AyElrjBA;EACE,eAAA;EACA,cpEzRS;AL88jBX;;AyElrjBA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;EzEqrjBF;AACF;AyElrjBA;EACE;IACE,yBAAA;IACA,cAAA;EzEorjBF;EyEjrjBA;IACE,iBAAA;EzEmrjBF;EyEjrjBE;IACE,uBAAA;IACA,sBAAA;IACA,iBAAA;EzEmrjBJ;EyEhrjBE;IACE,gBAAA;EzEkrjBJ;EyE7qjBE;IACE,eAAA;EzE+qjBJ;EyE3qjBA;;IAEE,eAAA;EzE6qjBF;EyE1qjBA;IACE,iBAAA;EzE4qjBF;EyEzqjBA;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;EzE2qjBF;AACF;AyExqjBA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;IACA,mBAAA;EzE0qjBF;AACF;AyEvqjBA;EACE;;IAEE,eAAA;EzEyqjBF;EyEtqjBA;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;EzEwqjBF;AACF;AyErqjBA;EAEI;IACE,eAAA;EzEsqjBJ;EyEnqjBA;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;EzEqqjBF;AACF;A0EvikBA,sBAAA;AAEA;EtE2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EsExDjE,WAAA;A1EkjkBF;;A0E/ikBA;EtEsDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,asEzDsB;EtE0DtB,8BsE1D4B;EtE2D5B,0BsE3D4B;EtE4D5B,sBsE5D4B;EtE6D5B,yBsE7DoC;EtE8DpC,qBsE9DoC;EtE+DpC,iBsE/DoC;EACpC,WAAA;A1E4jkBF;;A0EzjkBA;EtEiDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BsExEqB;EtEyErB,mBsEzEqB;A1EukkBvB;A0ErkkBE;EACE,uBAAA;A1EukkBJ;A0EpkkBE;EAEE,yBAAA;A1EqkkBJ;A0ElkkBE;EACE,gBAAA;A1EokkBJ;;A0EhkkBA;EtE+BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJgjkBnE;;A0E1kkBA;EACE,wBAAA;A1E6kkBF;;A0E1kkBA;EtEuBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BsE9CqB;EtE+CrB,mBsE/CqB;A1EwlkBvB;;A0ErlkBA;EtEkBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,asErBsB;EtEsBtB,8BsEtB4B;EtEuB5B,0BsEvB4B;EtEwB5B,sBsExB4B;EtEyB5B,yBsEzBoC;EtE0BpC,qBsE1BoC;EtE2BpC,iBsE3BoC;A1EkmkBtC;A0EhmkBE;EACE,kBAAA;A1EkmkBJ;;A0E9lkBA;EACE,eAAA;A1EimkBF;;A0E9lkBA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A1EimkBF;;A0EzlkBE;EtENA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,asEGwB;EtEFxB,8BsEE8B;EtED9B,0BsEC8B;EtEA9B,sBAAA;EACA,yBsEDsC;EtEEtC,qBsEFsC;EtEGtC,iBsEHsC;EACpC,iDAAA;EACA,eAAA;A1EsmkBJ;A0EpmkBI;EAEE,kBAAA;A1EqmkBN;;A0EhmkBA;EACE,aAAA;A1EmmkBF;;A0EhmkBA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;A1EmmkBF;;A0EhmkBA;EACE,iBAAA;EACA,gBAAA;EtE9BA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJ6okBnE;A0E3mkBE;EACE,sBAAA;A1E6mkBJ;;A0EzmkBA;EACE;IACE,wBAAA;E1E4mkBF;AACF;A0EzmkBA;EACE;ItE/BA,sBAAA;IACA,kBAAA;IACA,cAAA;IsE+BE,eAAA;IACA,yBAAA;E1E6mkBF;E0E1mkBA;ItErCA,sBAAA;IACA,kBAAA;IACA,cAAA;IsEqCE,eAAA;E1E8mkBF;E0E5mkBE;IACE,aAAA;E1E8mkBJ;AACF;A0E1mkBA;EACE;IACE,cAAA;ItEtCF,+BsEuCuB;ItEtCvB,uBsEsCuB;IACrB,2BAAA;IACA,uBAAA;IACA,mBAAA;IACA,yBAAA;IACA,qBAAA;IACA,iBAAA;E1E6mkBF;E0E1mkBA;IACE,gBAAA;IACA,eAAA;E1E4mkBF;E0EzmkBA;IACE,2BAAA;E1E2mkBF;AACF;A2ExvkBA,wBAAA;AAEA;EvEoFE,2BuEnFqB;EvEoFrB,mBuEpFqB;EvE0DrB,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EuEvDjE,gCAAA;EACA,iBAAA;A3EowkBF;;A2EjwkBA;EACE,eAAA;A3EowkBF;;A2EjwkBA;EACE,kBAAA;A3EowkBF;;A2EjwkBA;EACE,gBAAA;EACA,gBAAA;A3EowkBF;A2ElwkBE;EACE,gBAAA;A3EowkBJ;;A2EhwkBA;EACE,WtEjBM;ED4FJ,2BuE1EyB;EvE2EzB,4BuE3EyB;A3EowkB7B;;A2EjwkBA;EACE,WtEtBM;EsEuBN,kBAAA;A3EowkBF;A2ElwkBE;EACE,kBAAA;EACD,mBAAA;EACC,UAAA;EACA,UAAA;EACA,WtE9BI;ALkykBR;;A2EhwkBA;EACE,aAAA;A3EmwkBF;A2EjwkBE;EACE,cAAA;A3EmwkBJ;;A2E/vkBA;EACE,oBAAA;A3EkwkBF;A2EhwkBE;EvEMA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BuE7BuB;EvE8BvB,mBuE9BuB;EACrB,mBAAA;A3E6wkBJ;;A2EzwkBA;EACE,0BAAA;EACD,sBAAA;EACC,YAAA;EACA,YAAA;A3E4wkBF;;A2EzwkBA;EACE,kBAAA;EACA,ctEvDS;ALm0kBX;A2E1wkBE;EAGE,kBAAA;EACA,ctE1DO;ALo0kBX;;A2EtwkBA;EACE,eAAA;A3EywkBF;;A2EtwkBA;EAEI;IACE,gBAAA;E3EwwkBJ;E2EpwkBA;IACE,eAAA;E3EswkBF;AACF;A2EnwkBA;EACE;IACE,gBAAA;E3EqwkBF;E2EnwkBE;IACE,gBAAA;E3EqwkBJ;E2EjwkBA;IACE,eAAA;E3EmwkBF;AACF;A2EhwkBA;EACE;IACE,gBAAA;E3EkwkBF;E2EhwkBE;IACE,gBAAA;E3EkwkBJ;AACF;A2E9vkBA;EACE;IACE,0BAAA;E3EgwkBF;AACF;A4E53kBA,0BAAA;AAGE;ExE0DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,awE7DwB;ExE8DxB,8BwE9D8B;ExE+D9B,0BwE/D8B;ExEgE9B,sBwEhE8B;ExEiE9B,yBwEjEsC;ExEkEtC,qBwElEsC;ExEmEtC,iBwEnEsC;ExEuEtC,sBAAA;EACA,kBAAA;EACA,cAAA;EwEvEE,+BAAA;A5Ew4kBJ;A4Er4kBE;EACE,+BAAA;A5Eu4kBJ;;A4En4kBA;EACE,yBzEsCY;AHg2kBd;;A4En4kBA;EACE,qEAAA;A5Es4kBF;;A4En4kBA;EACE,0CAAA;A5Es4kBF;;A4En4kBA;;EAEE,WvElBM;EuEmBN,sBAAA;ExE3BA,wBwE4BA;ExE3BA,qBwE2BA;ExE1BA,mBwE0BA;ExEzBA,gBwEyBA;EACA,0CAAA;EACA,qBzEqBY;AHo3kBd;;A4Et4kBA;;;;EAIE,WvE7BM;EuE8BN,0CAAA;EACA,qBzEYY;AH63kBd;;A4Et4kBA;EACE,WvEnCM;EuEoCN,0CAAA;EACA,qBzEMY;AHm4kBd;;A4Et4kBA;EACE,WvEzCM;EuE0CN,0CAAA;EACA,qBAAA;A5Ey4kBF;;A4Et4kBA;EACE,iBAAA;A5Ey4kBF;;A4Et4kBA;EACE,gBAAA;A5Ey4kBF;;A4Et4kBA;EACE;IxEJA,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,awECwB;IxEAxB,8BAAA;IACA,0BwED8B;IxEE9B,sBwEF8B;IxEG9B,yBwEHsC;IxEItC,qBwEJsC;IxEKtC,iBwELsC;IxEoBtC,+BwEnBuB;IxEoBvB,uBwEpBuB;E5Eo5kBvB;E4Ej5kBA;IACE,aAAA;E5Em5kBF;AACF;A4Eh5kBA;EAEI;IACE,iBAAA;E5Ei5kBJ;E4E94kBE;IACE,iBAAA;E5Eg5kBJ;AACF;A4E54kBA;EACE;IACE,eAAA;E5E84kBF;E4E34kBA;IACE,iBAAA;E5E64kBF;AACF;A6E3+kBA;+EAAA;ACAA,sBAAA;AAQA;EACE,cARmB;A9Eg/kBrB;A8Ev+kBE;EACE,cAViB;A9Em/kBrB;;A8Ej+kBE;ECbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq/kBF;AIj3kBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E8/kBzG;A+El/kBE;EAII,0HAAA;A/Ei/kBN;A+E1+kBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+6kBf;A+Ex+kBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E2glB7L;A+En+kBI;EAGI,uFAAA;A/Em+kBR;;A8EhglBE;ECbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EohlBF;AIh5kBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E6hlBzG;A+EjhlBE;EAII,wHAAA;A/EghlBN;A+EzglBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH88kBf;A+EvglBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E0ilB7L;A+ElglBI;EAGI,qFAAA;A/EkglBR;;A8E/hlBE;ECbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmjlBF;AI/6kBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E4jlBzG;A+EhjlBE;EAII,yHAAA;A/E+ilBN;A+ExilBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6+kBf;A+EtilBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EyklB7L;A+EjilBI;EAGI,sFAAA;A/EiilBR;;A8E9jlBE;ECbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EkllBF;AI98kBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E2llBzG;A+E/klBE;EAII,wHAAA;A/E8klBN;A+EvklBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4glBf;A+ErklBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EwmlB7L;A+EhklBI;EAGI,qFAAA;A/EgklBR;;A8E7llBE;ECbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EinlBF;AI7+kBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E0nlBzG;A+E9mlBE;EAII,yHAAA;A/E6mlBN;A+EtmlBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2ilBf;A+EpmlBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EuolB7L;A+E/llBI;EAGI,sFAAA;A/E+llBR;;A8E5nlBE;ECbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgplBF;AI5glBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EyplBzG;A+E7olBE;EAII,wHAAA;A/E4olBN;A+ErolBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0klBf;A+EnolBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EsqlB7L;A+E9nlBI;EAGI,qFAAA;A/E8nlBR;;A8E3plBE;ECbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+qlBF;AI3ilBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EwrlBzG;A+E5qlBE;EAII,0HAAA;A/E2qlBN;A+EpqlBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHymlBf;A+ElqlBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EqslB7L;A+E7plBI;EAGI,uFAAA;A/E6plBR;;A8E1rlBE;ECbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8slBF;AI1klBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EutlBzG;A+E3slBE;EAII,uHAAA;A/E0slBN;A+EnslBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwolBf;A+EjslBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EoulB7L;A+E5rlBI;EAGI,oFAAA;A/E4rlBR;;A8EntlBE;ECnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6ulBF;AIzmlBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EsvlBzG;A+E1ulBE;EAII,0HAAA;A/EyulBN;A+ElulBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuqlBf;A+EhulBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EmwlB7L;A+E3tlBI;EAGI,uFAAA;A/E2tlBR;;A8ElvlBE;ECnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4wlBF;AIxolBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EqxlBzG;A+EzwlBE;EAII,wHAAA;A/EwwlBN;A+EjwlBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsslBf;A+E/vlBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EkylB7L;A+E1vlBI;EAGI,qFAAA;A/E0vlBR;;A8EjxlBE;ECnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2ylBF;AIvqlBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EozlBzG;A+ExylBE;EAII,yHAAA;A/EuylBN;A+EhylBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqulBf;A+E9xlBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Ei0lB7L;A+EzxlBI;EAGI,sFAAA;A/EyxlBR;;A8EhzlBE;ECnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E00lBF;AItslBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Em1lBzG;A+Ev0lBE;EAII,wHAAA;A/Es0lBN;A+E/zlBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHowlBf;A+E7zlBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Eg2lB7L;A+ExzlBI;EAGI,qFAAA;A/EwzlBR;;A8E/0lBE;ECnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey2lBF;AIrulBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Ek3lBzG;A+Et2lBE;EAII,yHAAA;A/Eq2lBN;A+E91lBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmylBf;A+E51lBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E+3lB7L;A+Ev1lBI;EAGI,sFAAA;A/Eu1lBR;;A8E92lBE;ECnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ew4lBF;AIpwlBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ei5lBzG;A+Er4lBE;EAII,wHAAA;A/Eo4lBN;A+E73lBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHk0lBf;A+E33lBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E85lB7L;A+Et3lBI;EAGI,qFAAA;A/Es3lBR;;A8E74lBE;ECnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu6lBF;AInylBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eg7lBzG;A+Ep6lBE;EAII,0HAAA;A/Em6lBN;A+E55lBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi2lBf;A+E15lBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E67lB7L;A+Er5lBI;EAGI,uFAAA;A/Eq5lBR;;A8E56lBE;ECnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es8lBF;AIl0lBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E+8lBzG;A+En8lBE;EAII,uHAAA;A/Ek8lBN;A+E37lBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHg4lBf;A+Ez7lBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E49lB7L;A+Ep7lBI;EAGI,oFAAA;A/Eo7lBR;;A8Er8lBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+4lBf;A+E76lBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHo5lBf;A+E56lBE;EAEE,iDAAA;A/E66lBJ;A+E16lBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E26lBJ;A+Ex6lBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHg6lBf;A+Et6lBI;EAGI,uFAAA;A/Es6lBR;;A8Eh+lBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH06lBf;A+Ex8lBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+6lBf;A+Ev8lBE;EAEE,+CAAA;A/Ew8lBJ;A+Er8lBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es8lBJ;A+En8lBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH27lBf;A+Ej8lBI;EAGI,qFAAA;A/Ei8lBR;;A8E3/lBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHq8lBf;A+En+lBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH08lBf;A+El+lBE;EAEE,gDAAA;A/Em+lBJ;A+Eh+lBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ei+lBJ;A+E99lBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHs9lBf;A+E59lBI;EAGI,sFAAA;A/E49lBR;;A8EthmBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHg+lBf;A+E9/lBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHq+lBf;A+E7/lBE;EAEE,+CAAA;A/E8/lBJ;A+E3/lBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4/lBJ;A+Ez/lBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHi/lBf;A+Ev/lBI;EAGI,qFAAA;A/Eu/lBR;;A8EjjmBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2/lBf;A+EzhmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHggmBf;A+ExhmBE;EAEE,gDAAA;A/EyhmBJ;A+EthmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EuhmBJ;A+EphmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4gmBf;A+ElhmBI;EAGI,sFAAA;A/EkhmBR;;A8E5kmBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHshmBf;A+EpjmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2hmBf;A+EnjmBE;EAEE,+CAAA;A/EojmBJ;A+EjjmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkjmBJ;A+E/imBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuimBf;A+E7imBI;EAGI,qFAAA;A/E6imBR;;A8EvmmBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHijmBf;A+E/kmBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHsjmBf;A+E9kmBE;EAEE,iDAAA;A/E+kmBJ;A+E5kmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6kmBJ;A+E1kmBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkkmBf;A+ExkmBI;EAGI,uFAAA;A/EwkmBR;;A8ElomBE;EC0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4kmBf;A+E1mmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHilmBf;A+EzmmBE;EAEE,8CAAA;A/E0mmBJ;A+EvmmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwmmBJ;A+ErmmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6lmBf;A+EnmmBI;EAGI,oFAAA;A/EmmmBR;;A8EnpmBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHummBf;A+EromBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4mmBf;A+EpomBE;EAEE,iDAAA;A/EqomBJ;A+ElomBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmomBJ;A+EhomBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwnmBf;A+E9nmBI;EAGI,uFAAA;A/E8nmBR;;A8E9qmBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkomBf;A+EhqmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHuomBf;A+E/pmBE;EAEE,+CAAA;A/EgqmBJ;A+E7pmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8pmBJ;A+E3pmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmpmBf;A+EzpmBI;EAGI,qFAAA;A/EypmBR;;A8EzsmBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6pmBf;A+E3rmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHkqmBf;A+E1rmBE;EAEE,gDAAA;A/E2rmBJ;A+ExrmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EyrmBJ;A+EtrmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8qmBf;A+EprmBI;EAGI,sFAAA;A/EormBR;;A8EpumBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwrmBf;A+EttmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6rmBf;A+ErtmBE;EAEE,+CAAA;A/EstmBJ;A+EntmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EotmBJ;A+EjtmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHysmBf;A+E/smBI;EAGI,qFAAA;A/E+smBR;;A8E/vmBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmtmBf;A+EjvmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwtmBf;A+EhvmBE;EAEE,gDAAA;A/EivmBJ;A+E9umBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+umBJ;A+E5umBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHoumBf;A+E1umBI;EAGI,sFAAA;A/E0umBR;;A8E1xmBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8umBf;A+E5wmBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmvmBf;A+E3wmBE;EAEE,+CAAA;A/E4wmBJ;A+EzwmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0wmBJ;A+EvwmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+vmBf;A+ErwmBI;EAGI,qFAAA;A/EqwmBR;;A8ErzmBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHywmBf;A+EvymBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH8wmBf;A+EtymBE;EAEE,iDAAA;A/EuymBJ;A+EpymBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqymBJ;A+ElymBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0xmBf;A+EhymBI;EAGI,uFAAA;A/EgymBR;;A8Eh1mBE;ECgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHoymBf;A+El0mBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHyymBf;A+Ej0mBE;EAEE,8CAAA;A/Ek0mBJ;A+E/zmBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg0mBJ;A+E7zmBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqzmBf;A+E3zmBI;EAGI,oFAAA;A/E2zmBR;;A8El2mBA;;EAEE,cAnDmB;EAoDnB,qBApDmB;A9Ey5mBrB;A8En2mBE;;;;;;;;EAOE,WzEpDI;EyEqDJ,qBA9DiB;EA+DjB,yBA/DiB;A9Eq6mBrB;;A8El2mBA;;EAEE,cApEiB;EAqEjB,qBArEiB;A9E06mBnB;A8En2mBE;;;;;;;;EAOE,WzEtEI;EyEuEJ,qBA/Ee;EAgFf,yBAhFe;A9Es7mBnB;;A8E/1mBE;EAEE,cA1FiB;A9E27mBrB;A8Eh2mBI;EAEE,wDAAA;A9Ei2mBN;A8E71mBE;EACE,yBAAA;A9E+1mBJ;A8E51mBE;EACE,cAtGiB;A9Eo8mBrB;A8E71mBI;EAEE,cAzGe;A9Eu8mBrB;A8E11mBE;EAEE,oCAAA;EACA,sBAAA;A9E21mBJ;A8Ex1mBE;EAIE,yBAvHiB;EAwHjB,qBAxHiB;EAyHjB,WzEhHI;ALu8mBR;A8Er1mBI;EAGE,8EAAA;EACA,0EAAA;EACA,sBAAA;A9Eq1mBN;A8Eh1mBI;EACE,oCAAA;A9Ek1mBN;A8E/0mBI;EACE,oCAAA;A9Ei1mBN;A8E90mBI;EACE,oCAAA;A9Eg1mBN;A8E70mBI;EACE,oCAAA;A9E+0mBN;A8E50mBI;EACE,oCAAA;A9E80mBN;A8E30mBI;EACE,oCAAA;A9E60mBN;A8E10mBI;EACE,oCAAA;A9E40mBN;A8Ez0mBI;EACE,oCAAA;A9E20mBN;A8Ex0mBI;EACE,oCAAA;A9E00mBN;A8Ev0mBI;EACE,oCAAA;A9Ey0mBN;A8Et0mBI;EACE,oCAAA;A9Ew0mBN;A8Er0mBI;EACE,oCAAA;A9Eu0mBN;;A8Eh0mBE;EACE,cAzLe;A9E4/mBnB;A8El0mBI;EAEE,6CAAA;A9Em0mBN;A8E/zmBE;EACE,yBAAA;A9Ei0mBJ;A8E9zmBE;EAEE,oCAAA;EACA,sBAAA;A9E+zmBJ;A8E5zmBE;EACE,yBA3Me;EA4Mf,qBA5Me;EA6Mf,WzErMI;ALmgnBR;A8E5zmBI;EAGE,2DAAA;EACA,uDAAA;EACA,sBAAA;A9E4zmBN;;A8EtzmBA;EACE,wCAAA;EACA,sBAAA;A9EyzmBF;A8ExzmBE;EAGE,oCAAA;EACA,sBAAA;A9EwzmBJ;;A8EpzmBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A9EuzmBF;A8ErzmBE;EAEE,oDAAA;EACA,yBAAA;A9EszmBJ;;A8EjzmBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A9EozmBJ;A8ElzmBI;EAEE,sDAAA;EACA,sBAAA;A9EmzmBN;;A8E9ymBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A9EizmBF;A8E/ymBE;EAEE,qDAAA;EACA,yBAAA;A9EgzmBJ;;A8E3ymBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A9E8ymBJ;A8E5ymBI;EAEE,sDAAA;EACA,sBAAA;A9E6ymBN;;A8EpymBI;EADF;IAEI,sBzEtRE;EL8jnBN;AACF;;A8EnymBA;EACE,yBAtSmB;A9E4knBrB;;A8EjymBA;EACE,iCAAA;EACA,yBAAA;A9EoymBF;A8ElymBE;EACE,yBzEtSO;EyEuSP,kBAAA;EACA,UAAA;A9EoymBJ;A8ElymBI;EACE,yBAAA;A9EoymBN;A8EhymBE;EACE,oEAAA;A9EkymBJ;A8E9xmBI;EACE,cA/Te;A9E+lnBrB;;A8E3xmBA;EACE,cAjUoB;A9E+lnBtB;;A8E1xmBE;EACE,cAtUkB;A9EmmnBtB;;A8EzxmBA;;;EAGE,sBzExUM;EyEyUN,cAlVmB;A9E8mnBrB;;A8EzxmBA;;EAEE,cAvVmB;A9EmnnBrB;;A8EzxmBA;EACE,sBzElVM;AL8mnBR;;A8EzxmBA;EACE,cA3VoB;A9EunnBtB;;A8EzxmBA;;;EAGE,cArWmB;A9EionBrB;;A8EzxmBA;EACE,cArWoB;A9EionBtB;;A8EzxmBA;EACE,yBA7WmB;A9EyonBrB;;A8EzxmBA;;;;;EAKE,sBzE5WM;EyE6WN,cAtXmB;A9EkpnBrB;;A8EzxmBA,2BAAA;AAGI;EAEE,cA9Xe;A9EupnBrB;A8EtxmBI;EACE,W3ExUe;AHgmnBrB;A8ErxmBI;EAEE,cAvYe;A9E6pnBrB;A8ElxmBE;EACE,cA5YiB;A9EgqnBrB;A8EhxmBI;EAEE,cAlZe;A9EmqnBrB;A8E5wmBI;EACE,W3E9Ve;AH4mnBrB;A8EzwmBM;EACE,cA9Za;A9EyqnBrB;A8EvwmBI;EAGE,cArae;A9E4qnBrB;;A8ElwmBA;EACE,yBA3amB;A9EgrnBrB;A8ElwmBI;EACE,WzEtaE;AL0qnBR;A8EjwmBI;EAKE,cAtba;A9EqrnBnB;;A8EvvmBI;EACE,qBAhce;A9E0rnBrB;;A8EpvmBA;EACE,yBAvcmB;A9E8rnBrB;;A8EpvmBA;EACE,mEAAA;A9EuvmBF;;A8EpvmBA;EACE,wCAAA;A9EuvmBF;;A8EpvmBA;;EAEE,wCAAA;EACA,qBArdmB;A9E4snBrB;;A8EpvmBA;;;;EAIE,wCAAA;EACA,qBA7dmB;A9EotnBrB;;A8EpvmBA;EACE,wCAAA;EACA,qBAlemB;A9EytnBrB;;A8EpvmBA;EACE,wCAAA;EACA,qBAvemB;A9E8tnBrB;;A8EpvmBA;EACE,qBA3emB;A9EkunBrB;;A8EnvmBA;EACE,cAhfmB;A9EsunBrB;;A8ElvmBE;EAEE,qEAAA;A9EovmBJ;;A8E9umBE;EACE,cA7fiB;A9E8unBrB;;A8E5umBA;EACE,mBAngBmB;A9EkvnBrB;;A8E3umBE;EAGE,cA1gBiB;A9EsvnBrB;;A8ErumBE;EACE,qBAlhBiB;A9E0vnBrB;;A8ElumBE;EACE,qBAzhBiB;A9E8vnBrB;A8EnumBI;EAGE,yBA9hBe;A9EiwnBrB;;A8E5tmBE;EACE,cAtiBiB;A9EqwnBrB;;A8E1tmBE;EAGE,cA7iBe;A9EwwnBnB;;A8EttmBA;EACE,cAnjBiB;A9E4wnBnB;;A8EttmBA;EACE,0CAAA;A9EytmBF;;A8EptmBA;EACE,gCAAA;A9EutmBF;;A8EltmBA;EACE,yBApkBmB;A9EyxnBrB;;A8EjtmBE;EACE,yBAAA;EACA,cA1kBiB;A9E8xnBrB;A8EltmBI;EAEE,WzErkBE;EyEskBF,yBA/kBe;A9EkynBrB;;A8E1smBI;;;;EACE,yBAzlBe;EA0lBf,qBA1lBe;A9E0ynBrB;A8E3smBE;;EACE,yBAAA;A9E8smBJ;A8E7smBI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A9EgtmBN;A8E9smBM;;;EAEE,oDAAA;EACA,yBAAA;A9EitmBR;;A8E1smBE;EACE,yBAjnBiB;EAknBjB,qBAlnBiB;A9E+znBrB;;A8EzsmBA;;EAEE,cAxnBmB;A9Eo0nBrB;;AiFr0nBA,oBAAA;AAYA;EACE,cAZiB;AjFy0nBnB;AiF5znBE;EACE,cAde;AjF40nBnB;;AiFtznBE;EFjBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E80nBF;AI1snBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Eu1nBzG;A+E30nBE;EAII,0HAAA;A/E00nBN;A+En0nBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwwnBf;A+Ej0nBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Eo2nB7L;A+E5znBI;EAGI,uFAAA;A/E4znBR;;AiFr1nBE;EFjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E62nBF;AIzunBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Es3nBzG;A+E12nBE;EAII,wHAAA;A/Ey2nBN;A+El2nBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuynBf;A+Eh2nBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Em4nB7L;A+E31nBI;EAGI,qFAAA;A/E21nBR;;AiFp3nBE;EFjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E44nBF;AIxwnBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Eq5nBzG;A+Ez4nBE;EAII,yHAAA;A/Ew4nBN;A+Ej4nBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHs0nBf;A+E/3nBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Ek6nB7L;A+E13nBI;EAGI,sFAAA;A/E03nBR;;AiFn5nBE;EFjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E26nBF;AIvynBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Eo7nBzG;A+Ex6nBE;EAII,wHAAA;A/Eu6nBN;A+Eh6nBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHq2nBf;A+E95nBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Ei8nB7L;A+Ez5nBI;EAGI,qFAAA;A/Ey5nBR;;AiFl7nBE;EFjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E08nBF;AIt0nBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Em9nBzG;A+Ev8nBE;EAII,yHAAA;A/Es8nBN;A+E/7nBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHo4nBf;A+E77nBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Eg+nB7L;A+Ex7nBI;EAGI,sFAAA;A/Ew7nBR;;AiFj9nBE;EFjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey+nBF;AIr2nBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ek/nBzG;A+Et+nBE;EAII,wHAAA;A/Eq+nBN;A+E99nBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm6nBf;A+E59nBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E+/nB7L;A+Ev9nBI;EAGI,qFAAA;A/Eu9nBR;;AiFh/nBE;EFjBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwgoBF;AIp4nBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EihoBzG;A+ErgoBE;EAII,0HAAA;A/EogoBN;A+E7/nBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHk8nBf;A+E3/nBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E8hoB7L;A+Et/nBI;EAGI,uFAAA;A/Es/nBR;;AiF/goBE;EFjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EuioBF;AIn6nBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EgjoBzG;A+EpioBE;EAII,uHAAA;A/EmioBN;A+E5hoBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi+nBf;A+E1hoBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E6joB7L;A+ErhoBI;EAGI,oFAAA;A/EqhoBR;;AiFxioBE;EFvBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EskoBF;AIl8nBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E+koBzG;A+EnkoBE;EAII,0HAAA;A/EkkoBN;A+E3joBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHggoBf;A+EzjoBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E4loB7L;A+EpjoBI;EAGI,uFAAA;A/EojoBR;;AiFvkoBE;EFvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqmoBF;AIj+nBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E8moBzG;A+ElmoBE;EAII,wHAAA;A/EimoBN;A+E1loBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+hoBf;A+ExloBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E2noB7L;A+EnloBI;EAGI,qFAAA;A/EmloBR;;AiFtmoBE;EFvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EoooBF;AIhgoBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E6ooBzG;A+EjooBE;EAII,yHAAA;A/EgooBN;A+EznoBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8joBf;A+EvnoBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E0poB7L;A+ElnoBI;EAGI,sFAAA;A/EknoBR;;AiFrooBE;EFvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmqoBF;AI/hoBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E4qoBzG;A+EhqoBE;EAII,wHAAA;A/E+poBN;A+ExpoBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6loBf;A+EtpoBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EyroB7L;A+EjpoBI;EAGI,qFAAA;A/EipoBR;;AiFpqoBE;EFvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EksoBF;AI9joBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E2soBzG;A+E/roBE;EAII,yHAAA;A/E8roBN;A+EvroBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4noBf;A+ErroBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EwtoB7L;A+EhroBI;EAGI,sFAAA;A/EgroBR;;AiFnsoBE;EFvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EiuoBF;AI7loBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E0uoBzG;A+E9toBE;EAII,wHAAA;A/E6toBN;A+EttoBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2poBf;A+EptoBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EuvoB7L;A+E/soBI;EAGI,qFAAA;A/E+soBR;;AiFluoBE;EFvBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgwoBF;AI5noBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EywoBzG;A+E7voBE;EAII,0HAAA;A/E4voBN;A+ErvoBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0roBf;A+EnvoBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EsxoB7L;A+E9uoBI;EAGI,uFAAA;A/E8uoBR;;AiFjwoBE;EFvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+xoBF;AI3poBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EwyoBzG;A+E5xoBE;EAII,uHAAA;A/E2xoBN;A+EpxoBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHytoBf;A+ElxoBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EqzoB7L;A+E7woBI;EAGI,oFAAA;A/E6woBR;;AiF1xoBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwuoBf;A+EtwoBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6uoBf;A+ErwoBE;EAEE,iDAAA;A/EswoBJ;A+EnwoBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EowoBJ;A+EjwoBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHyvoBf;A+E/voBI;EAGI,uFAAA;A/E+voBR;;AiFrzoBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmwoBf;A+EjyoBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwwoBf;A+EhyoBE;EAEE,+CAAA;A/EiyoBJ;A+E9xoBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+xoBJ;A+E5xoBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHoxoBf;A+E1xoBI;EAGI,qFAAA;A/E0xoBR;;AiFh1oBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8xoBf;A+E5zoBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmyoBf;A+E3zoBE;EAEE,gDAAA;A/E4zoBJ;A+EzzoBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0zoBJ;A+EvzoBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+yoBf;A+ErzoBI;EAGI,sFAAA;A/EqzoBR;;AiF32oBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHyzoBf;A+Ev1oBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8zoBf;A+Et1oBE;EAEE,+CAAA;A/Eu1oBJ;A+Ep1oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq1oBJ;A+El1oBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH00oBf;A+Eh1oBI;EAGI,qFAAA;A/Eg1oBR;;AiFt4oBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo1oBf;A+El3oBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy1oBf;A+Ej3oBE;EAEE,gDAAA;A/Ek3oBJ;A+E/2oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg3oBJ;A+E72oBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq2oBf;A+E32oBI;EAGI,sFAAA;A/E22oBR;;AiFj6oBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+2oBf;A+E74oBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHo3oBf;A+E54oBE;EAEE,+CAAA;A/E64oBJ;A+E14oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E24oBJ;A+Ex4oBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHg4oBf;A+Et4oBI;EAGI,qFAAA;A/Es4oBR;;AiF57oBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH04oBf;A+Ex6oBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH+4oBf;A+Ev6oBE;EAEE,iDAAA;A/Ew6oBJ;A+Er6oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es6oBJ;A+En6oBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH25oBf;A+Ej6oBI;EAGI,uFAAA;A/Ei6oBR;;AiFv9oBE;EFsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHq6oBf;A+En8oBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH06oBf;A+El8oBE;EAEE,8CAAA;A/Em8oBJ;A+Eh8oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ei8oBJ;A+E97oBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHs7oBf;A+E57oBI;EAGI,oFAAA;A/E47oBR;;AiFx+oBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHg8oBf;A+E99oBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHq8oBf;A+E79oBE;EAEE,iDAAA;A/E89oBJ;A+E39oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E49oBJ;A+Ez9oBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHi9oBf;A+Ev9oBI;EAGI,uFAAA;A/Eu9oBR;;AiFngpBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH29oBf;A+Ez/oBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHg+oBf;A+Ex/oBE;EAEE,+CAAA;A/Ey/oBJ;A+Et/oBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eu/oBJ;A+Ep/oBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4+oBf;A+El/oBI;EAGI,qFAAA;A/Ek/oBR;;AiF9hpBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHs/oBf;A+EphpBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2/oBf;A+EnhpBE;EAEE,gDAAA;A/EohpBJ;A+EjhpBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkhpBJ;A+E/gpBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHugpBf;A+E7gpBI;EAGI,sFAAA;A/E6gpBR;;AiFzjpBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHihpBf;A+E/ipBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHshpBf;A+E9ipBE;EAEE,+CAAA;A/E+ipBJ;A+E5ipBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6ipBJ;A+E1ipBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkipBf;A+ExipBI;EAGI,qFAAA;A/EwipBR;;AiFplpBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4ipBf;A+E1kpBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHijpBf;A+EzkpBE;EAEE,gDAAA;A/E0kpBJ;A+EvkpBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwkpBJ;A+ErkpBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6jpBf;A+EnkpBI;EAGI,sFAAA;A/EmkpBR;;AiF/mpBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHukpBf;A+ErmpBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4kpBf;A+EpmpBE;EAEE,+CAAA;A/EqmpBJ;A+ElmpBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmmpBJ;A+EhmpBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwlpBf;A+E9lpBI;EAGI,qFAAA;A/E8lpBR;;AiF1opBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkmpBf;A+EhopBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHumpBf;A+E/npBE;EAEE,iDAAA;A/EgopBJ;A+E7npBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8npBJ;A+E3npBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmnpBf;A+EznpBI;EAGI,uFAAA;A/EynpBR;;AiFrqpBE;EFYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6npBf;A+E3ppBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHkopBf;A+E1ppBE;EAEE,8CAAA;A/E2ppBJ;A+ExppBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EyppBJ;A+EtppBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8opBf;A+EpppBI;EAGI,oFAAA;A/EoppBR;;AiFvrpBA;;EAEE,cAvDiB;EAwDjB,qBAxDiB;AjFkvpBnB;AiFxrpBE;;;;;;;;EAOE,W5ExDI;E4EyDJ,qBAlEe;EAmEf,yBAnEe;AjF8vpBnB;;AiFvrpBA;;EAEE,cAxEe;EAyEf,qBAzEe;AjFmwpBjB;AiFxrpBE;;;;;;;;EAOE,W5E1EI;E4E2EJ,qBAnFa;EAoFb,yBApFa;AjF+wpBjB;;AiFrrpBE;EAEE,cA7Fe;AjFoxpBnB;AiFtrpBI;EAEE,kCAAA;AjFurpBN;AiFnrpBE;EACE,yBAAA;AjFqrpBJ;AiFlrpBE;EACE,cAzGe;AjF6xpBnB;AiFnrpBI;EAEE,cA5Ga;AjFgypBnB;AiFhrpBE;EAEE,oCAAA;EACA,sBAAA;AjFirpBJ;AiF9qpBE;EAIE,yBA1He;EA2Hf,qBA3He;EA4Hf,W5EnHI;ALgypBR;AiF3qpBI;EAGE,0DAAA;EACA,sDAAA;EACA,sBAAA;AjF2qpBN;AiFtqpBI;EACE,oCAAA;AjFwqpBN;AiFrqpBI;EACE,oCAAA;AjFuqpBN;AiFpqpBI;EACE,oCAAA;AjFsqpBN;AiFnqpBI;EACE,oCAAA;AjFqqpBN;AiFlqpBI;EACE,oCAAA;AjFoqpBN;AiFjqpBI;EACE,oCAAA;AjFmqpBN;AiFhqpBI;EACE,oCAAA;AjFkqpBN;AiF/ppBI;EACE,oCAAA;AjFiqpBN;AiF9ppBI;EACE,oCAAA;AjFgqpBN;AiF7ppBI;EACE,oCAAA;AjF+ppBN;AiF5ppBI;EACE,oCAAA;AjF8ppBN;AiF3ppBI;EACE,oCAAA;AjF6ppBN;;AiFtppBE;EACE,cA5La;AjFq1pBjB;AiFxppBI;EAEE,oEAAA;AjFyppBN;AiFrppBE;EACE,yBAAA;AjFuppBJ;AiFpppBE;EAEE,oCAAA;EACA,sBAAA;AjFqppBJ;AiFlppBE;EACE,yBA9Ma;EA+Mb,qBA/Ma;EAgNb,W5ExMI;AL41pBR;AiFlppBI;EAGE,+EAAA;EACA,2EAAA;EACA,sBAAA;AjFkppBN;;AiF5opBA;EACE,wCAAA;EACA,sBAAA;AjF+opBF;AiF9opBE;EAGE,oCAAA;EACA,sBAAA;AjF8opBJ;;AiF1opBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AjF6opBF;AiF3opBE;EAEE,oDAAA;EACA,yBAAA;AjF4opBJ;;AiFvopBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AjF0opBJ;AiFxopBI;EAEE,sDAAA;EACA,sBAAA;AjFyopBN;;AiFpopBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AjFuopBF;AiFropBE;EAEE,sDAAA;EACA,yBAAA;AjFsopBJ;;AiFjopBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AjFoopBJ;AiFlopBI;EAEE,sDAAA;EACA,sBAAA;AjFmopBN;;AiF1npBI;EADF;IAEI,sB5EzRE;ELu5pBN;AACF;;AiFznpBA;EACE,yBAzSiB;AjFq6pBnB;;AiFxnpBA;EACE,iCAAA;EACA,yBAAA;AjF2npBF;AiFznpBE;EACE,yB5ExSO;E4EySP,kBAAA;EACA,UAAA;AjF2npBJ;AiFznpBI;EACE,yBAAA;AjF2npBN;AiFvnpBE;EACE,oEAAA;AjFynpBJ;AiFrnpBI;EACE,cAjUa;AjFw7pBnB;;AiFlnpBA;EACE,cAnUkB;AjFw7pBpB;;AiFjnpBE;EACE,cAxUgB;AjF47pBpB;;AiFhnpBA;;;EAGE,sB5E1UM;E4E2UN,cApViB;AjFu8pBnB;;AiFhnpBA;;EAEE,cAzViB;AjF48pBnB;;AiFhnpBA;EACE,sB5EpVM;ALu8pBR;;AiFhnpBA;EACE,cA7VkB;AjFg9pBpB;;AiFhnpBA;;;EAGE,cAvWiB;AjF09pBnB;;AiFhnpBA;EACE,cAvWkB;AjF09pBpB;;AiFhnpBA;EACE,yBA/WiB;AjFk+pBnB;;AiFhnpBA;;;;;EAKE,sB5E9WM;E4E+WN,cAxXiB;AjF2+pBnB;;AiFhnpBA,2BAAA;AAGI;EAEE,cAhYa;AjFg/pBnB;AiF7mpBI;EACE,W9E1Ue;AHy7pBrB;AiF5mpBI;EAEE,cAzYa;AjFs/pBnB;AiFzmpBE;EACE,cA9Ye;AjFy/pBnB;AiFvmpBI;EAEE,cApZa;AjF4/pBnB;AiFnmpBI;EACE,W9EhWe;AHq8pBrB;AiFhmpBM;EACE,cAhaW;AjFkgqBnB;AiF9lpBI;EAGE,cAvaa;AjFqgqBnB;;AiFzlpBA;EACE,yBA7aiB;AjFygqBnB;AiFzlpBI;EACE,W5ExaE;ALmgqBR;AiFxlpBI;EAKE,cAxbW;AjF8gqBjB;;AiF9kpBI;EACE,qBAlca;AjFmhqBnB;;AiF3kpBA;EACE,yBAzciB;AjFuhqBnB;;AiF3kpBA;EACE,6CAAA;AjF8kpBF;;AiF3kpBA;EACE,wCAAA;AjF8kpBF;;AiF3kpBA;;EAEE,wCAAA;EACA,qBAvdiB;AjFqiqBnB;;AiF3kpBA;;;;EAIE,wCAAA;EACA,qBA/diB;AjF6iqBnB;;AiF3kpBA;EACE,wCAAA;EACA,qBApeiB;AjFkjqBnB;;AiF3kpBA;EACE,wCAAA;EACA,qBAzeiB;AjFujqBnB;;AiF3kpBA;EACE,qBA7eiB;AjF2jqBnB;;AiF1kpBA;EACE,cAlfiB;AjF+jqBnB;;AiFzkpBE;EAEE,iDAAA;AjF2kpBJ;;AiFrkpBE;EACE,cA/fe;AjFukqBnB;;AiFnkpBA;EACE,mBArgBiB;AjF2kqBnB;;AiFlkpBE;EAGE,cA5gBe;AjF+kqBnB;;AiF7jpBE;EACE,qBAnhBe;AjFmlqBnB;;AiF1jpBE;EACE,qBA1hBe;AjFulqBnB;AiF3jpBI;EAGE,yBA/hBa;AjF0lqBnB;;AiFpjpBE;EACE,cAviBe;AjF8lqBnB;;AiFljpBE;EAGE,cA9iBa;AjFimqBjB;;AiF9ipBA;EACE,cApjBe;AjFqmqBjB;;AiF9ipBA;EACE,0CAAA;AjFijpBF;;AiF5ipBA;EACE,gCAAA;AjF+ipBF;;AiF1ipBA;EACE,yBArkBiB;AjFknqBnB;;AiFzipBE;EACE,yBAAA;EACA,cA3kBe;AjFunqBnB;AiF1ipBI;EAEE,W5EtkBE;E4EukBF,yBAhlBa;AjF2nqBnB;;AiFlipBI;;;;EACE,yBA1lBa;EA2lBb,qBA3lBa;AjFmoqBnB;AiFnipBE;;EACE,yBAAA;AjFsipBJ;AiFripBI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AjFwipBN;AiFtipBM;;;EAEE,oDAAA;EACA,yBAAA;AjFyipBR;;AiFlipBE;EACE,yBAlnBe;EAmnBf,qBAnnBe;AjFwpqBnB;;AiFjipBA;;EAEE,cAznBiB;AjF6pqBnB;;AkF9pqBA,qBAAA;AAOA;EACE,qBAPkB;AlFkqqBpB;;AkFvpqBA;EACE,cAZkB;AlFsqqBpB;AkFzpqBE;EACE,cAdgB;AlFyqqBpB;;AkFnpqBE;EHjBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2qqBF;AIviqBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EorqBzG;A+ExqqBE;EAII,0HAAA;A/EuqqBN;A+EhqqBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqmqBf;A+E9pqBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EisqB7L;A+EzpqBI;EAGI,uFAAA;A/EypqBR;;AkFlrqBE;EHjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0sqBF;AItkqBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EmtqBzG;A+EvsqBE;EAII,wHAAA;A/EssqBN;A+E/rqBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHooqBf;A+E7rqBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EguqB7L;A+ExrqBI;EAGI,qFAAA;A/EwrqBR;;AkFjtqBE;EHjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EyuqBF;AIrmqBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EkvqBzG;A+EtuqBE;EAII,yHAAA;A/EquqBN;A+E9tqBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmqqBf;A+E5tqBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E+vqB7L;A+EvtqBI;EAGI,sFAAA;A/EutqBR;;AkFhvqBE;EHjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwwqBF;AIpoqBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EixqBzG;A+ErwqBE;EAII,wHAAA;A/EowqBN;A+E7vqBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHksqBf;A+E3vqBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E8xqB7L;A+EtvqBI;EAGI,qFAAA;A/EsvqBR;;AkF/wqBE;EHjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EuyqBF;AInqqBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EgzqBzG;A+EpyqBE;EAII,yHAAA;A/EmyqBN;A+E5xqBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHiuqBf;A+E1xqBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E6zqB7L;A+ErxqBI;EAGI,sFAAA;A/EqxqBR;;AkF9yqBE;EHjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es0qBF;AIlsqBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E+0qBzG;A+En0qBE;EAII,wHAAA;A/Ek0qBN;A+E3zqBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgwqBf;A+EzzqBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E41qB7L;A+EpzqBI;EAGI,qFAAA;A/EozqBR;;AkF70qBE;EHjBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq2qBF;AIjuqBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E82qBzG;A+El2qBE;EAII,0HAAA;A/Ei2qBN;A+E11qBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+xqBf;A+Ex1qBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E23qB7L;A+En1qBI;EAGI,uFAAA;A/Em1qBR;;AkF52qBE;EHjBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo4qBF;AIhwqBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E64qBzG;A+Ej4qBE;EAII,uHAAA;A/Eg4qBN;A+Ez3qBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8zqBf;A+Ev3qBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E05qB7L;A+El3qBI;EAGI,oFAAA;A/Ek3qBR;;AkFr4qBE;EHvBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em6qBF;AI/xqBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E46qBzG;A+Eh6qBE;EAII,0HAAA;A/E+5qBN;A+Ex5qBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH61qBf;A+Et5qBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Ey7qB7L;A+Ej5qBI;EAGI,uFAAA;A/Ei5qBR;;AkFp6qBE;EHvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ek8qBF;AI9zqBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E28qBzG;A+E/7qBE;EAII,wHAAA;A/E87qBN;A+Ev7qBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH43qBf;A+Er7qBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ew9qB7L;A+Eh7qBI;EAGI,qFAAA;A/Eg7qBR;;AkFn8qBE;EHvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ei+qBF;AI71qBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E0+qBzG;A+E99qBE;EAII,yHAAA;A/E69qBN;A+Et9qBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH25qBf;A+Ep9qBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Eu/qB7L;A+E/8qBI;EAGI,sFAAA;A/E+8qBR;;AkFl+qBE;EHvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EggrBF;AI53qBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EygrBzG;A+E7/qBE;EAII,wHAAA;A/E4/qBN;A+Er/qBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH07qBf;A+En/qBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EshrB7L;A+E9+qBI;EAGI,qFAAA;A/E8+qBR;;AkFjgrBE;EHvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+hrBF;AI35qBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EwirBzG;A+E5hrBE;EAII,yHAAA;A/E2hrBN;A+EphrBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHy9qBf;A+ElhrBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EqjrB7L;A+E7grBI;EAGI,sFAAA;A/E6grBR;;AkFhirBE;EHvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8jrBF;AI17qBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EukrBzG;A+E3jrBE;EAII,wHAAA;A/E0jrBN;A+EnjrBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHw/qBf;A+EjjrBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EolrB7L;A+E5irBI;EAGI,qFAAA;A/E4irBR;;AkF/jrBE;EHvBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6lrBF;AIz9qBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EsmrBzG;A+E1lrBE;EAII,0HAAA;A/EylrBN;A+EllrBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuhrBf;A+EhlrBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EmnrB7L;A+E3krBI;EAGI,uFAAA;A/E2krBR;;AkF9lrBE;EHvBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4nrBF;AIx/qBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EqorBzG;A+EznrBE;EAII,uHAAA;A/EwnrBN;A+EjnrBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsjrBf;A+E/mrBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EkprB7L;A+E1mrBI;EAGI,oFAAA;A/E0mrBR;;AkFvnrBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqkrBf;A+EnmrBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0krBf;A+ElmrBE;EAEE,iDAAA;A/EmmrBJ;A+EhmrBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EimrBJ;A+E9lrBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHslrBf;A+E5lrBI;EAGI,uFAAA;A/E4lrBR;;AkFlprBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgmrBf;A+E9nrBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqmrBf;A+E7nrBE;EAEE,+CAAA;A/E8nrBJ;A+E3nrBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4nrBJ;A+EznrBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHinrBf;A+EvnrBI;EAGI,qFAAA;A/EunrBR;;AkF7qrBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2nrBf;A+EzprBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgorBf;A+ExprBE;EAEE,gDAAA;A/EyprBJ;A+EtprBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EuprBJ;A+EpprBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4orBf;A+ElprBI;EAGI,sFAAA;A/EkprBR;;AkFxsrBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsprBf;A+EprrBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2prBf;A+EnrrBE;EAEE,+CAAA;A/EorrBJ;A+EjrrBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkrrBJ;A+E/qrBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuqrBf;A+E7qrBI;EAGI,qFAAA;A/E6qrBR;;AkFnurBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHirrBf;A+E/srBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHsrrBf;A+E9srBE;EAEE,gDAAA;A/E+srBJ;A+E5srBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6srBJ;A+E1srBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHksrBf;A+ExsrBI;EAGI,sFAAA;A/EwsrBR;;AkF9vrBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4srBf;A+E1urBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHitrBf;A+EzurBE;EAEE,+CAAA;A/E0urBJ;A+EvurBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwurBJ;A+ErurBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6trBf;A+EnurBI;EAGI,qFAAA;A/EmurBR;;AkFzxrBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHuurBf;A+ErwrBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH4urBf;A+EpwrBE;EAEE,iDAAA;A/EqwrBJ;A+ElwrBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmwrBJ;A+EhwrBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwvrBf;A+E9vrBI;EAGI,uFAAA;A/E8vrBR;;AkFpzrBE;EHsBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkwrBf;A+EhyrBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHuwrBf;A+E/xrBE;EAEE,8CAAA;A/EgyrBJ;A+E7xrBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8xrBJ;A+E3xrBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmxrBf;A+EzxrBI;EAGI,oFAAA;A/EyxrBR;;AkFr0rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6xrBf;A+E3zrBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHkyrBf;A+E1zrBE;EAEE,iDAAA;A/E2zrBJ;A+ExzrBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EyzrBJ;A+EtzrBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8yrBf;A+EpzrBI;EAGI,uFAAA;A/EozrBR;;AkFh2rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwzrBf;A+Et1rBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6zrBf;A+Er1rBE;EAEE,+CAAA;A/Es1rBJ;A+En1rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eo1rBJ;A+Ej1rBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy0rBf;A+E/0rBI;EAGI,qFAAA;A/E+0rBR;;AkF33rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm1rBf;A+Ej3rBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHw1rBf;A+Eh3rBE;EAEE,gDAAA;A/Ei3rBJ;A+E92rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+2rBJ;A+E52rBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo2rBf;A+E12rBI;EAGI,sFAAA;A/E02rBR;;AkFt5rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH82rBf;A+E54rBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm3rBf;A+E34rBE;EAEE,+CAAA;A/E44rBJ;A+Ez4rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E04rBJ;A+Ev4rBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+3rBf;A+Er4rBI;EAGI,qFAAA;A/Eq4rBR;;AkFj7rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy4rBf;A+Ev6rBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH84rBf;A+Et6rBE;EAEE,gDAAA;A/Eu6rBJ;A+Ep6rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq6rBJ;A+El6rBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH05rBf;A+Eh6rBI;EAGI,sFAAA;A/Eg6rBR;;AkF58rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo6rBf;A+El8rBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy6rBf;A+Ej8rBE;EAEE,+CAAA;A/Ek8rBJ;A+E/7rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg8rBJ;A+E77rBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq7rBf;A+E37rBI;EAGI,qFAAA;A/E27rBR;;AkFv+rBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+7rBf;A+E79rBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHo8rBf;A+E59rBE;EAEE,iDAAA;A/E69rBJ;A+E19rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E29rBJ;A+Ex9rBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHg9rBf;A+Et9rBI;EAGI,uFAAA;A/Es9rBR;;AkFlgsBE;EHYA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH09rBf;A+Ex/rBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+9rBf;A+Ev/rBE;EAEE,8CAAA;A/Ew/rBJ;A+Er/rBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es/rBJ;A+En/rBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2+rBf;A+Ej/rBI;EAGI,oFAAA;A/Ei/rBR;;AkFphsBA;;EAEE,cAvDkB;EAwDlB,qBAxDkB;AlF+ksBpB;AkFrhsBE;;;;;;;;EAOE,W7ExDI;E6EyDJ,qBAlEgB;EAmEhB,yBAnEgB;AlF2lsBpB;;AkFphsBA;;EAEE,cAxEgB;EAyEhB,qBAzEgB;AlFgmsBlB;AkFrhsBE;;;;;;;;EAOE,W7E1EI;E6E2EJ,qBAnFc;EAoFd,yBApFc;AlF4msBlB;;AkFlhsBE;EAEE,cA7FgB;AlFinsBpB;AkFnhsBI;EAEE,0BAAA;AlFohsBN;AkFhhsBE;EACE,yBAAA;AlFkhsBJ;AkF/gsBE;EACE,cAzGgB;AlF0nsBpB;AkFhhsBI;EAEE,cA5Gc;AlF6nsBpB;AkF7gsBE;EAEE,oCAAA;EACA,sBAAA;AlF8gsBJ;AkF3gsBE;EAIE,yBA1HgB;EA2HhB,qBA3HgB;EA4HhB,W7EnHI;AL6nsBR;AkFxgsBI;EAGE,mDAAA;EACA,+CAAA;EACA,sBAAA;AlFwgsBN;AkFngsBI;EACE,oCAAA;AlFqgsBN;AkFlgsBI;EACE,oCAAA;AlFogsBN;AkFjgsBI;EACE,oCAAA;AlFmgsBN;AkFhgsBI;EACE,oCAAA;AlFkgsBN;AkF//rBI;EACE,oCAAA;AlFigsBN;AkF9/rBI;EACE,oCAAA;AlFggsBN;AkF7/rBI;EACE,oCAAA;AlF+/rBN;AkF5/rBI;EACE,oCAAA;AlF8/rBN;AkF3/rBI;EACE,oCAAA;AlF6/rBN;AkF1/rBI;EACE,oCAAA;AlF4/rBN;AkFz/rBI;EACE,oCAAA;AlF2/rBN;AkFx/rBI;EACE,oCAAA;AlF0/rBN;;AkFn/rBE;EACE,cA5Lc;AlFkrsBlB;AkFr/rBI;EAEE,mCAAA;AlFs/rBN;AkFl/rBE;EACE,yBAAA;AlFo/rBJ;AkFj/rBE;EAEE,oCAAA;EACA,sBAAA;AlFk/rBJ;AkF/+rBE;EACE,yBA9Mc;EA+Md,qBA/Mc;EAgNd,W7ExMI;ALyrsBR;AkF/+rBI;EAGE,gDAAA;EACA,4CAAA;EACA,sBAAA;AlF++rBN;;AkFz+rBA;EACE,wCAAA;EACA,sBAAA;AlF4+rBF;AkF3+rBE;EAGE,oCAAA;EACA,sBAAA;AlF2+rBJ;;AkFv+rBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AlF0+rBF;AkFx+rBE;EAEE,oDAAA;EACA,yBAAA;AlFy+rBJ;;AkFp+rBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AlFu+rBJ;AkFr+rBI;EAEE,sDAAA;EACA,sBAAA;AlFs+rBN;;AkFj+rBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AlFo+rBF;AkFl+rBE;EAEE,mDAAA;EACA,yBAAA;AlFm+rBJ;;AkF99rBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AlFi+rBJ;AkF/9rBI;EAEE,sDAAA;EACA,sBAAA;AlFg+rBN;;AkFv9rBI;EADF;IAEI,sB7EzRE;ELovsBN;AACF;;AkFt9rBA;EACE,yBAzSkB;AlFkwsBpB;;AkFp9rBA;EACE,iCAAA;EACA,yBAAA;AlFu9rBF;AkFr9rBE;EACE,yB7EzSO;ALgwsBX;AkFr9rBI;EACE,yBAAA;AlFu9rBN;AkFl9rBI;EACE,cA5Tc;AlFgxsBpB;AkFh9rBE;EACE,oEAAA;AlFk9rBJ;;AkF98rBA;EACE,cAlUyB;AlFmxsB3B;;AkF78rBE;EACE,cAvUuB;AlFuxsB3B;;AkF58rBA;;;EAGE,sB7EzUM;E6E0UN,cAnVkB;AlFkysBpB;;AkF58rBA;;EAEE,cAxVkB;AlFuysBpB;;AkF58rBA;EACE,sB7EnVM;ALkysBR;;AkF58rBA;EACE,W/EtSmB;AHqvsBrB;;AkF58rBA;;;EAGE,cAtWkB;AlFqzsBpB;;AkF58rBA;EACE,cAtWyB;AlFqzsB3B;;AkF58rBA;EACE,yBA9WkB;AlF6zsBpB;;AkF58rBA;;;;;EAKE,sB7E7WM;E6E8WN,cAvXkB;AlFs0sBpB;;AkF58rBA,2BAAA;AAGI;EAEE,cA/Xc;AlF20sBpB;AkFz8rBI;EACE,W/EzUe;AHoxsBrB;AkFx8rBI;EAEE,cAxYc;AlFi1sBpB;AkFr8rBE;EACE,cA7YgB;AlFo1sBpB;AkFn8rBI;EAEE,cAnZc;AlFu1sBpB;AkF/7rBI;EACE,W/E/Ve;AHgysBrB;AkF57rBM;EACE,cA/ZY;AlF61sBpB;AkF17rBI;EAGE,cAtac;AlFg2sBpB;;AkFr7rBA;EACE,yBA5akB;AlFo2sBpB;AkFr7rBI;EACE,W7EvaE;AL81sBR;AkFp7rBI;EAKE,cAvbY;AlFy2sBlB;;AkF16rBI;EACE,qBAjcc;AlF82sBpB;;AkFv6rBA;EACE,yBAxckB;AlFk3sBpB;;AkFv6rBA;EACE,qCAAA;AlF06rBF;;AkFv6rBA;EACE,wCAAA;AlF06rBF;;AkFv6rBA;;EAEE,wCAAA;EACA,qBAtdkB;AlFg4sBpB;;AkFv6rBA;;;;EAIE,wCAAA;EACA,qBA9dkB;AlFw4sBpB;;AkFv6rBA;EACE,wCAAA;EACA,qBAnekB;AlF64sBpB;;AkFv6rBA;EACE,wCAAA;EACA,qBAxekB;AlFk5sBpB;;AkFv6rBA;EACE,qBA5ekB;AlFs5sBpB;;AkFt6rBA;EACE,cAjfkB;AlF05sBpB;;AkFr6rBE;EAEE,0CAAA;AlFu6rBJ;;AkFj6rBE;EACE,cA9fgB;AlFk6sBpB;;AkF/5rBA;EACE,mBApgBkB;AlFs6sBpB;;AkF95rBE;EAGE,cA3gBgB;AlF06sBpB;;AkFz5rBE;EACE,qBAlhBgB;AlF86sBpB;;AkFt5rBE;EACE,qBAzhBgB;AlFk7sBpB;AkFv5rBI;EAGE,yBA9hBc;AlFq7sBpB;;AkFh5rBE;EACE,cAtiBgB;AlFy7sBpB;;AkF94rBE;EAGE,cA7iBc;AlF47sBlB;;AkF14rBA;EACE,cAnjBgB;AlFg8sBlB;;AkF14rBA;EACE,0CAAA;AlF64rBF;;AkFx4rBA;EACE,gCAAA;AlF24rBF;;AkFt4rBA;EACE,yBApkBkB;AlF68sBpB;;AkFr4rBE;EACE,yBAAA;EACA,cA1kBgB;AlFk9sBpB;AkFt4rBI;EAEE,W7ErkBE;E6EskBF,yBA/kBc;AlFs9sBpB;;AkF93rBI;;;;EACE,yBAzlBc;EA0lBd,qBA1lBc;AlF89sBpB;AkF/3rBE;;EACE,yBAAA;AlFk4rBJ;AkFj4rBI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AlFo4rBN;AkFl4rBM;;;EAEE,oDAAA;EACA,yBAAA;AlFq4rBR;;AkF93rBE;EACE,yBAjnBgB;EAknBhB,qBAlnBgB;AlFm/sBpB;;AkF73rBA;;EAEE,cAxnBkB;AlFw/sBpB;;AmFz/sBA,2BAAA;AAQA;EACE,cARwB;AnF6/sB1B;AmFp/sBE;EACE,cAVsB;AnFggtB1B;;AmF9+sBE;EJbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EkgtBF;AI93sBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E2gtBzG;A+E//sBE;EAII,0HAAA;A/E8/sBN;A+Ev/sBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH47sBf;A+Er/sBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EwhtB7L;A+Eh/sBI;EAGI,uFAAA;A/Eg/sBR;;AmF7gtBE;EJbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EiitBF;AI75sBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E0itBzG;A+E9htBE;EAII,wHAAA;A/E6htBN;A+EthtBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH29sBf;A+EphtBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EujtB7L;A+E/gtBI;EAGI,qFAAA;A/E+gtBR;;AmF5itBE;EJbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgktBF;AI57sBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EyktBzG;A+E7jtBE;EAII,yHAAA;A/E4jtBN;A+ErjtBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0/sBf;A+EnjtBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EsltB7L;A+E9itBI;EAGI,sFAAA;A/E8itBR;;AmF3ktBE;EJbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+ltBF;AI39sBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EwmtBzG;A+E5ltBE;EAII,wHAAA;A/E2ltBN;A+EpltBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyhtBf;A+ElltBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EqntB7L;A+E7ktBI;EAGI,qFAAA;A/E6ktBR;;AmF1mtBE;EJbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8ntBF;AI1/sBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EuotBzG;A+E3ntBE;EAII,yHAAA;A/E0ntBN;A+EnntBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwjtBf;A+EjntBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EoptB7L;A+E5mtBI;EAGI,sFAAA;A/E4mtBR;;AmFzotBE;EJbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6ptBF;AIzhtBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EsqtBzG;A+E1ptBE;EAII,wHAAA;A/EyptBN;A+ElptBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHultBf;A+EhptBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EmrtB7L;A+E3otBI;EAGI,qFAAA;A/E2otBR;;AmFxqtBE;EJbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4rtBF;AIxjtBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EqstBzG;A+EzrtBE;EAII,0HAAA;A/EwrtBN;A+EjrtBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsntBf;A+E/qtBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EkttB7L;A+E1qtBI;EAGI,uFAAA;A/E0qtBR;;AmFvstBE;EJbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2ttBF;AIvltBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EoutBzG;A+ExttBE;EAII,uHAAA;A/EuttBN;A+EhttBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqptBf;A+E9stBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EivtB7L;A+EzstBI;EAGI,oFAAA;A/EystBR;;AmFhutBE;EJnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0vtBF;AItntBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EmwtBzG;A+EvvtBE;EAII,0HAAA;A/EsvtBN;A+E/utBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHortBf;A+E7utBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EgxtB7L;A+ExutBI;EAGI,uFAAA;A/EwutBR;;AmF/vtBE;EJnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EyxtBF;AIrptBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EkytBzG;A+EtxtBE;EAII,wHAAA;A/EqxtBN;A+E9wtBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmttBf;A+E5wtBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E+ytB7L;A+EvwtBI;EAGI,qFAAA;A/EuwtBR;;AmF9xtBE;EJnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwztBF;AIprtBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Ei0tBzG;A+ErztBE;EAII,yHAAA;A/EoztBN;A+E7ytBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkvtBf;A+E3ytBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E80tB7L;A+EtytBI;EAGI,sFAAA;A/EsytBR;;AmF7ztBE;EJnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu1tBF;AInttBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Eg2tBzG;A+Ep1tBE;EAII,wHAAA;A/Em1tBN;A+E50tBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHixtBf;A+E10tBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E62tB7L;A+Er0tBI;EAGI,qFAAA;A/Eq0tBR;;AmF51tBE;EJnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es3tBF;AIlvtBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E+3tBzG;A+En3tBE;EAII,yHAAA;A/Ek3tBN;A+E32tBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgztBf;A+Ez2tBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E44tB7L;A+Ep2tBI;EAGI,sFAAA;A/Eo2tBR;;AmF33tBE;EJnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq5tBF;AIjxtBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E85tBzG;A+El5tBE;EAII,wHAAA;A/Ei5tBN;A+E14tBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+0tBf;A+Ex4tBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E26tB7L;A+En4tBI;EAGI,qFAAA;A/Em4tBR;;AmF15tBE;EJnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo7tBF;AIhztBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E67tBzG;A+Ej7tBE;EAII,0HAAA;A/Eg7tBN;A+Ez6tBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH82tBf;A+Ev6tBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E08tB7L;A+El6tBI;EAGI,uFAAA;A/Ek6tBR;;AmFz7tBE;EJnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em9tBF;AI/0tBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E49tBzG;A+Eh9tBE;EAII,uHAAA;A/E+8tBN;A+Ex8tBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH64tBf;A+Et8tBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Ey+tB7L;A+Ej8tBI;EAGI,oFAAA;A/Ei8tBR;;AmFl9tBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH45tBf;A+E17tBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHi6tBf;A+Ez7tBE;EAEE,iDAAA;A/E07tBJ;A+Ev7tBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ew7tBJ;A+Er7tBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH66tBf;A+En7tBI;EAGI,uFAAA;A/Em7tBR;;AmF7+tBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHu7tBf;A+Er9tBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH47tBf;A+Ep9tBE;EAEE,+CAAA;A/Eq9tBJ;A+El9tBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em9tBJ;A+Eh9tBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHw8tBf;A+E98tBI;EAGI,qFAAA;A/E88tBR;;AmFxguBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk9tBf;A+Eh/tBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHu9tBf;A+E/+tBE;EAEE,gDAAA;A/Eg/tBJ;A+E7+tBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8+tBJ;A+E3+tBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm+tBf;A+Ez+tBI;EAGI,sFAAA;A/Ey+tBR;;AmFniuBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6+tBf;A+E3guBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk/tBf;A+E1guBE;EAEE,+CAAA;A/E2guBJ;A+ExguBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EyguBJ;A+EtguBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8/tBf;A+EpguBI;EAGI,qFAAA;A/EoguBR;;AmF9juBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwguBf;A+EtiuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6guBf;A+EriuBE;EAEE,gDAAA;A/EsiuBJ;A+EniuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EoiuBJ;A+EjiuBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHyhuBf;A+E/huBI;EAGI,sFAAA;A/E+huBR;;AmFzluBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmiuBf;A+EjkuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwiuBf;A+EhkuBE;EAEE,+CAAA;A/EikuBJ;A+E9juBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+juBJ;A+E5juBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHojuBf;A+E1juBI;EAGI,qFAAA;A/E0juBR;;AmFpnuBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8juBf;A+E5luBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHmkuBf;A+E3luBE;EAEE,iDAAA;A/E4luBJ;A+EzluBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0luBJ;A+EvluBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+kuBf;A+ErluBI;EAGI,uFAAA;A/EqluBR;;AmF/ouBE;EJ0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHyluBf;A+EvnuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8luBf;A+EtnuBE;EAEE,8CAAA;A/EunuBJ;A+EpnuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqnuBJ;A+ElnuBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0muBf;A+EhnuBI;EAGI,oFAAA;A/EgnuBR;;AmFhquBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHonuBf;A+ElpuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHynuBf;A+EjpuBE;EAEE,iDAAA;A/EkpuBJ;A+E/ouBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EgpuBJ;A+E7ouBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqouBf;A+E3ouBI;EAGI,uFAAA;A/E2ouBR;;AmF3ruBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+ouBf;A+E7quBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHopuBf;A+E5quBE;EAEE,+CAAA;A/E6quBJ;A+E1quBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2quBJ;A+ExquBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgquBf;A+EtquBI;EAGI,qFAAA;A/EsquBR;;AmFttuBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0quBf;A+ExsuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+quBf;A+EvsuBE;EAEE,gDAAA;A/EwsuBJ;A+ErsuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EssuBJ;A+EnsuBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2ruBf;A+EjsuBI;EAGI,sFAAA;A/EisuBR;;AmFjvuBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqsuBf;A+EnuuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0suBf;A+EluuBE;EAEE,+CAAA;A/EmuuBJ;A+EhuuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EiuuBJ;A+E9tuBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHstuBf;A+E5tuBI;EAGI,qFAAA;A/E4tuBR;;AmF5wuBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHguuBf;A+E9vuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHquuBf;A+E7vuBE;EAEE,gDAAA;A/E8vuBJ;A+E3vuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4vuBJ;A+EzvuBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHivuBf;A+EvvuBI;EAGI,sFAAA;A/EuvuBR;;AmFvyuBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2vuBf;A+EzxuBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgwuBf;A+ExxuBE;EAEE,+CAAA;A/EyxuBJ;A+EtxuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EuxuBJ;A+EpxuBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4wuBf;A+ElxuBI;EAGI,qFAAA;A/EkxuBR;;AmFl0uBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsxuBf;A+EpzuBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH2xuBf;A+EnzuBE;EAEE,iDAAA;A/EozuBJ;A+EjzuBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkzuBJ;A+E/yuBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuyuBf;A+E7yuBI;EAGI,uFAAA;A/E6yuBR;;AmF71uBE;EJgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHizuBf;A+E/0uBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHszuBf;A+E90uBE;EAEE,8CAAA;A/E+0uBJ;A+E50uBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E60uBJ;A+E10uBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHk0uBf;A+Ex0uBI;EAGI,oFAAA;A/Ew0uBR;;AmF/2uBA;;EAEE,cAnDwB;EAoDxB,qBApDwB;AnFs6uB1B;AmFh3uBE;;;;;;;;EAOE,W9EpDI;E8EqDJ,qBA9DsB;EA+DtB,yBA/DsB;AnFk7uB1B;;AmF/2uBA;;EAEE,cApEsB;EAqEtB,qBArEsB;AnFu7uBxB;AmFh3uBE;;;;;;;;EAOE,W9EtEI;E8EuEJ,qBA/EoB;EAgFpB,yBAhFoB;AnFm8uBxB;;AmF72uBE;EAEE,cAzFsB;AnFw8uB1B;AmF92uBI;EAEE,iCAAA;AnF+2uBN;AmF32uBE;EACE,yBAAA;AnF62uBJ;AmF12uBE;EACE,cArGsB;AnFi9uB1B;AmF32uBI;EAEE,cAxGoB;AnFo9uB1B;AmFx2uBE;EAEE,oCAAA;EACA,sBAAA;AnFy2uBJ;AmFt2uBE;EAIE,yBAtHsB;EAuHtB,qBAvHsB;EAwHtB,W9E/GI;ALo9uBR;AmFn2uBI;EAGE,yDAAA;EACA,qDAAA;EACA,sBAAA;AnFm2uBN;AmF91uBI;EACE,oCAAA;AnFg2uBN;AmF71uBI;EACE,oCAAA;AnF+1uBN;AmF51uBI;EACE,oCAAA;AnF81uBN;AmF31uBI;EACE,oCAAA;AnF61uBN;AmF11uBI;EACE,oCAAA;AnF41uBN;AmFz1uBI;EACE,oCAAA;AnF21uBN;AmFx1uBI;EACE,oCAAA;AnF01uBN;AmFv1uBI;EACE,oCAAA;AnFy1uBN;AmFt1uBI;EACE,oCAAA;AnFw1uBN;AmFr1uBI;EACE,oCAAA;AnFu1uBN;AmFp1uBI;EACE,oCAAA;AnFs1uBN;AmFn1uBI;EACE,oCAAA;AnFq1uBN;;AmF90uBE;EACE,cAxLoB;AnFygvBxB;AmFh1uBI;EAEE,8CAAA;AnFi1uBN;AmF70uBE;EACE,yBAAA;AnF+0uBJ;AmF50uBE;EAEE,oCAAA;EACA,sBAAA;AnF60uBJ;AmF10uBE;EACE,yBA1MoB;EA2MpB,qBA3MoB;EA4MpB,W9EpMI;ALghvBR;AmF10uBI;EAGE,2DAAA;EACA,uDAAA;EACA,sBAAA;AnF00uBN;;AmFp0uBA;EACE,wCAAA;EACA,sBAAA;AnFu0uBF;AmFt0uBE;EAGE,oCAAA;EACA,sBAAA;AnFs0uBJ;;AmFl0uBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AnFq0uBF;AmFn0uBE;EAEE,oDAAA;EACA,yBAAA;AnFo0uBJ;;AmF/zuBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AnFk0uBJ;AmFh0uBI;EAEE,sDAAA;EACA,sBAAA;AnFi0uBN;;AmF5zuBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AnF+zuBF;AmF7zuBE;EAEE,qDAAA;EACA,yBAAA;AnF8zuBJ;;AmFzzuBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AnF4zuBJ;AmF1zuBI;EAEE,sDAAA;EACA,sBAAA;AnF2zuBN;;AmFlzuBI;EADF;IAEI,sB9ErRE;EL2kvBN;AACF;;AmFjzuBA;EACE,yBArSwB;AnFylvB1B;;AmF/yuBA;EACE,iCAAA;EACA,yBAAA;AnFkzuBF;AmFhzuBE;EACE,yB9ErSO;E8EsSP,kBAAA;EACA,UAAA;AnFkzuBJ;AmFhzuBI;EACE,yBAAA;AnFkzuBN;AmF9yuBE;EACE,oEAAA;AnFgzuBJ;AmF5yuBI;EACE,cA9ToB;AnF4mvB1B;;AmFzyuBA;EACE,cAhUyB;AnF4mvB3B;;AmFxyuBE;EACE,cArUuB;AnFgnvB3B;;AmFvyuBA;;;EAGE,sB9EvUM;E8EwUN,cAjVwB;AnF2nvB1B;;AmFvyuBA;;EAEE,cAtVwB;AnFgovB1B;;AmFvyuBA;EACE,sB9EjVM;AL2nvBR;;AmFvyuBA;EACE,cA1VyB;AnFoovB3B;;AmFvyuBA;;;EAGE,cApWwB;AnF8ovB1B;;AmFvyuBA;EACE,cApWyB;AnF8ovB3B;;AmFvyuBA;EACE,yBA5WwB;AnFspvB1B;;AmFvyuBA;;;;;EAKE,sB9E3WM;E8E4WN,cArXwB;AnF+pvB1B;;AmFvyuBA,2BAAA;AAGI;EAEE,cA7XoB;AnFoqvB1B;AmFpyuBI;EACE,WhFvUe;AH6mvBrB;AmFnyuBI;EAEE,cAtYoB;AnF0qvB1B;AmFhyuBE;EACE,cA3YsB;AnF6qvB1B;AmF9xuBI;EAEE,cAjZoB;AnFgrvB1B;AmF1xuBI;EACE,WhF7Ve;AHynvBrB;AmFvxuBM;EACE,cA7ZkB;AnFsrvB1B;AmFrxuBI;EAGE,cApaoB;AnFyrvB1B;;AmFhxuBA;EACE,yBA1awB;AnF6rvB1B;AmFhxuBI;EACE,W9EraE;ALurvBR;AmF/wuBI;EAKE,cArbkB;AnFksvBxB;;AmFrwuBI;EACE,qBA/boB;AnFusvB1B;;AmFlwuBA;EACE,yBAtcwB;AnF2svB1B;;AmFlwuBA;EACE,4CAAA;AnFqwuBF;;AmFlwuBA;EACE,wCAAA;AnFqwuBF;;AmFlwuBA;;EAEE,wCAAA;EACA,qBApdwB;AnFytvB1B;;AmFlwuBA;;;;EAIE,wCAAA;EACA,qBA5dwB;AnFiuvB1B;;AmFlwuBA;EACE,wCAAA;EACA,qBAjewB;AnFsuvB1B;;AmFlwuBA;EACE,wCAAA;EACA,qBAtewB;AnF2uvB1B;;AmFlwuBA;EACE,qBA1ewB;AnF+uvB1B;;AmFjwuBA;EACE,cA/ewB;AnFmvvB1B;;AmFhwuBE;EAEE,+CAAA;AnFkwuBJ;;AmF5vuBE;EACE,cA5fsB;AnF2vvB1B;;AmF1vuBA;EACE,mBAlgBwB;AnF+vvB1B;;AmFzvuBE;EAGE,cAzgBsB;AnFmwvB1B;;AmFpvuBE;EACE,qBAhhBsB;AnFuwvB1B;;AmFjvuBE;EACE,qBAvhBsB;AnF2wvB1B;AmFlvuBI;EAGE,yBA5hBoB;AnF8wvB1B;;AmF3uuBE;EACE,cApiBsB;AnFkxvB1B;;AmFzuuBE;EAGE,cA3iBoB;AnFqxvBxB;;AmFruuBA;EACE,cAjjBsB;AnFyxvBxB;;AmFruuBA;EACE,0CAAA;AnFwuuBF;;AmFnuuBA;EACE,gCAAA;AnFsuuBF;;AmFjuuBA;EACE,yBAlkBwB;AnFsyvB1B;;AmFhuuBE;EACE,yBAAA;EACA,cAxkBsB;AnF2yvB1B;AmFjuuBI;EAEE,W9EnkBE;E8EokBF,yBA7kBoB;AnF+yvB1B;;AmFztuBI;;;;EACE,yBAvlBoB;EAwlBpB,qBAxlBoB;AnFuzvB1B;AmF1tuBE;;EACE,yBAAA;AnF6tuBJ;AmF5tuBI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AnF+tuBN;AmF7tuBM;;;EAEE,oDAAA;EACA,yBAAA;AnFguuBR;;AmFztuBE;EACE,yBA/mBsB;EAgnBtB,qBAhnBsB;AnF40vB1B;;AmFxtuBA;;EAEE,cAtnBwB;AnFi1vB1B;;AoFl1vBA,oBAAA;AAQA;EACE,cARiB;ApFs1vBnB;AoF70vBE;EACE,cAVe;ApFy1vBnB;;AoFv0vBE;ELbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E21vBF;AIvtvBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Eo2vBzG;A+Ex1vBE;EAII,0HAAA;A/Eu1vBN;A+Eh1vBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqxvBf;A+E90vBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Ei3vB7L;A+Ez0vBI;EAGI,uFAAA;A/Ey0vBR;;AoFt2vBE;ELbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E03vBF;AItvvBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Em4vBzG;A+Ev3vBE;EAII,wHAAA;A/Es3vBN;A+E/2vBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHozvBf;A+E72vBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eg5vB7L;A+Ex2vBI;EAGI,qFAAA;A/Ew2vBR;;AoFr4vBE;ELbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey5vBF;AIrxvBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Ek6vBzG;A+Et5vBE;EAII,yHAAA;A/Eq5vBN;A+E94vBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm1vBf;A+E54vBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E+6vB7L;A+Ev4vBI;EAGI,sFAAA;A/Eu4vBR;;AoFp6vBE;ELbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ew7vBF;AIpzvBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Ei8vBzG;A+Er7vBE;EAII,wHAAA;A/Eo7vBN;A+E76vBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHk3vBf;A+E36vBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E88vB7L;A+Et6vBI;EAGI,qFAAA;A/Es6vBR;;AoFn8vBE;ELbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu9vBF;AIn1vBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Eg+vBzG;A+Ep9vBE;EAII,yHAAA;A/Em9vBN;A+E58vBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi5vBf;A+E18vBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E6+vB7L;A+Er8vBI;EAGI,sFAAA;A/Eq8vBR;;AoFl+vBE;ELbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es/vBF;AIl3vBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E+/vBzG;A+En/vBE;EAII,wHAAA;A/Ek/vBN;A+E3+vBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHg7vBf;A+Ez+vBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E4gwB7L;A+Ep+vBI;EAGI,qFAAA;A/Eo+vBR;;AoFjgwBE;ELbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqhwBF;AIj5vBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E8hwBzG;A+ElhwBE;EAII,0HAAA;A/EihwBN;A+E1gwBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+8vBf;A+ExgwBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E2iwB7L;A+EngwBI;EAGI,uFAAA;A/EmgwBR;;AoFhiwBE;ELbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EojwBF;AIh7vBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E6jwBzG;A+EjjwBE;EAII,uHAAA;A/EgjwBN;A+EziwBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8+vBf;A+EviwBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E0kwB7L;A+EliwBI;EAGI,oFAAA;A/EkiwBR;;AoFzjwBE;ELnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmlwBF;AI/8vBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E4lwBzG;A+EhlwBE;EAII,0HAAA;A/E+kwBN;A+ExkwBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6gwBf;A+EtkwBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EymwB7L;A+EjkwBI;EAGI,uFAAA;A/EikwBR;;AoFxlwBE;ELnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EknwBF;AI9+vBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E2nwBzG;A+E/mwBE;EAII,wHAAA;A/E8mwBN;A+EvmwBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4iwBf;A+ErmwBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EwowB7L;A+EhmwBI;EAGI,qFAAA;A/EgmwBR;;AoFvnwBE;ELnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EipwBF;AI7gwBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E0pwBzG;A+E9owBE;EAII,yHAAA;A/E6owBN;A+EtowBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2kwBf;A+EpowBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EuqwB7L;A+E/nwBI;EAGI,sFAAA;A/E+nwBR;;AoFtpwBE;ELnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgrwBF;AI5iwBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EyrwBzG;A+E7qwBE;EAII,wHAAA;A/E4qwBN;A+ErqwBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0mwBf;A+EnqwBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EsswB7L;A+E9pwBI;EAGI,qFAAA;A/E8pwBR;;AoFrrwBE;ELnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+swBF;AI3kwBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EwtwBzG;A+E5swBE;EAII,yHAAA;A/E2swBN;A+EpswBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyowBf;A+ElswBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EquwB7L;A+E7rwBI;EAGI,sFAAA;A/E6rwBR;;AoFptwBE;ELnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8uwBF;AI1mwBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EuvwBzG;A+E3uwBE;EAII,wHAAA;A/E0uwBN;A+EnuwBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwqwBf;A+EjuwBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EowwB7L;A+E5twBI;EAGI,qFAAA;A/E4twBR;;AoFnvwBE;ELnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6wwBF;AIzowBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EsxwBzG;A+E1wwBE;EAII,0HAAA;A/EywwBN;A+ElwwBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuswBf;A+EhwwBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EmywB7L;A+E3vwBI;EAGI,uFAAA;A/E2vwBR;;AoFlxwBE;ELnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4ywBF;AIxqwBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EqzwBzG;A+EzywBE;EAII,uHAAA;A/EwywBN;A+EjywBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsuwBf;A+E/xwBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Ek0wB7L;A+E1xwBI;EAGI,oFAAA;A/E0xwBR;;AoF3ywBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqvwBf;A+EnxwBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0vwBf;A+ElxwBE;EAEE,iDAAA;A/EmxwBJ;A+EhxwBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EixwBJ;A+E9wwBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHswwBf;A+E5wwBI;EAGI,uFAAA;A/E4wwBR;;AoFt0wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgxwBf;A+E9ywBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqxwBf;A+E7ywBE;EAEE,+CAAA;A/E8ywBJ;A+E3ywBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4ywBJ;A+EzywBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHiywBf;A+EvywBI;EAGI,qFAAA;A/EuywBR;;AoFj2wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2ywBf;A+Ez0wBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgzwBf;A+Ex0wBE;EAEE,gDAAA;A/Ey0wBJ;A+Et0wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eu0wBJ;A+Ep0wBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4zwBf;A+El0wBI;EAGI,sFAAA;A/Ek0wBR;;AoF53wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHs0wBf;A+Ep2wBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH20wBf;A+En2wBE;EAEE,+CAAA;A/Eo2wBJ;A+Ej2wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ek2wBJ;A+E/1wBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHu1wBf;A+E71wBI;EAGI,qFAAA;A/E61wBR;;AoFv5wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHi2wBf;A+E/3wBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHs2wBf;A+E93wBE;EAEE,gDAAA;A/E+3wBJ;A+E53wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E63wBJ;A+E13wBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHk3wBf;A+Ex3wBI;EAGI,sFAAA;A/Ew3wBR;;AoFl7wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH43wBf;A+E15wBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHi4wBf;A+Ez5wBE;EAEE,+CAAA;A/E05wBJ;A+Ev5wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ew5wBJ;A+Er5wBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH64wBf;A+En5wBI;EAGI,qFAAA;A/Em5wBR;;AoF78wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHu5wBf;A+Er7wBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH45wBf;A+Ep7wBE;EAEE,iDAAA;A/Eq7wBJ;A+El7wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em7wBJ;A+Eh7wBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHw6wBf;A+E96wBI;EAGI,uFAAA;A/E86wBR;;AoFx+wBE;EL0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk7wBf;A+Eh9wBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHu7wBf;A+E/8wBE;EAEE,8CAAA;A/Eg9wBJ;A+E78wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E88wBJ;A+E38wBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm8wBf;A+Ez8wBI;EAGI,oFAAA;A/Ey8wBR;;AoFz/wBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH68wBf;A+E3+wBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk9wBf;A+E1+wBE;EAEE,iDAAA;A/E2+wBJ;A+Ex+wBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey+wBJ;A+Et+wBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH89wBf;A+Ep+wBI;EAGI,uFAAA;A/Eo+wBR;;AoFphxBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw+wBf;A+EtgxBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6+wBf;A+ErgxBE;EAEE,+CAAA;A/EsgxBJ;A+EngxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EogxBJ;A+EjgxBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy/wBf;A+E//wBI;EAGI,qFAAA;A/E+/wBR;;AoF/ixBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmgxBf;A+EjixBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwgxBf;A+EhixBE;EAEE,gDAAA;A/EiixBJ;A+E9hxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+hxBJ;A+E5hxBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHohxBf;A+E1hxBI;EAGI,sFAAA;A/E0hxBR;;AoF1kxBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8hxBf;A+E5jxBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmixBf;A+E3jxBE;EAEE,+CAAA;A/E4jxBJ;A+EzjxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0jxBJ;A+EvjxBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+ixBf;A+ErjxBI;EAGI,qFAAA;A/EqjxBR;;AoFrmxBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHyjxBf;A+EvlxBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8jxBf;A+EtlxBE;EAEE,gDAAA;A/EulxBJ;A+EplxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqlxBJ;A+EllxBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0kxBf;A+EhlxBI;EAGI,sFAAA;A/EglxBR;;AoFhoxBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHolxBf;A+ElnxBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHylxBf;A+EjnxBE;EAEE,+CAAA;A/EknxBJ;A+E/mxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EgnxBJ;A+E7mxBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqmxBf;A+E3mxBI;EAGI,qFAAA;A/E2mxBR;;AoF3pxBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+mxBf;A+E7oxBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHonxBf;A+E5oxBE;EAEE,iDAAA;A/E6oxBJ;A+E1oxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2oxBJ;A+ExoxBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgoxBf;A+EtoxBI;EAGI,uFAAA;A/EsoxBR;;AoFtrxBE;ELgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0oxBf;A+ExqxBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+oxBf;A+EvqxBE;EAEE,8CAAA;A/EwqxBJ;A+ErqxBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EsqxBJ;A+EnqxBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2pxBf;A+EjqxBI;EAGI,oFAAA;A/EiqxBR;;AoFxsxBA;;EAEE,cAnDiB;EAoDjB,qBApDiB;ApF+vxBnB;AoFzsxBE;;;;;;;;EAOE,W/EpDI;E+EqDJ,qBA9De;EA+Df,yBA/De;ApF2wxBnB;;AoFxsxBA;;EAEE,cApEe;EAqEf,qBArEe;ApFgxxBjB;AoFzsxBE;;;;;;;;EAOE,W/EtEI;E+EuEJ,qBA/Ea;EAgFb,yBAhFa;ApF4xxBjB;;AoFrsxBE;EAEE,cA1Fe;ApFiyxBnB;AoFtsxBI;EAEE,wDAAA;ApFusxBN;AoFnsxBE;EACE,yBAAA;ApFqsxBJ;AoFlsxBE;EACE,cAtGe;ApF0yxBnB;AoFnsxBI;EAEE,cAzGa;ApF6yxBnB;AoFhsxBE;EAEE,oCAAA;EACA,sBAAA;ApFisxBJ;AoF7rxBE;EAIE,yBAxHe;EAyHf,qBAzHe;EA0Hf,W/EjHI;AL6yxBR;AoF1rxBI;EAGE,qEAAA;EACA,iEAAA;EACA,sBAAA;ApF0rxBN;AoFprxBI;EACE,oCAAA;ApFsrxBN;AoFnrxBI;EACE,oCAAA;ApFqrxBN;AoFlrxBI;EACE,oCAAA;ApForxBN;AoFjrxBI;EACE,oCAAA;ApFmrxBN;AoFhrxBI;EACE,oCAAA;ApFkrxBN;AoF/qxBI;EACE,oCAAA;ApFirxBN;AoF9qxBI;EACE,oCAAA;ApFgrxBN;AoF7qxBI;EACE,oCAAA;ApF+qxBN;AoF5qxBI;EACE,oCAAA;ApF8qxBN;AoF3qxBI;EACE,oCAAA;ApF6qxBN;AoF1qxBI;EACE,oCAAA;ApF4qxBN;AoFzqxBI;EACE,oCAAA;ApF2qxBN;;AoFpqxBE;EACE,cA3La;ApFk2xBjB;AoFtqxBI;EAEE,4CAAA;ApFuqxBN;AoFnqxBE;EACE,yBAAA;ApFqqxBJ;AoFlqxBE;EAEE,oCAAA;EACA,sBAAA;ApFmqxBJ;AoFhqxBE;EACE,yBA7Ma;EA8Mb,qBA9Ma;EA+Mb,W/EvMI;ALy2xBR;AoFhqxBI;EAGE,0DAAA;EACA,sDAAA;EACA,sBAAA;ApFgqxBN;;AoF1pxBA;EACE,wCAAA;EACA,sBAAA;ApF6pxBF;AoF5pxBE;EAGE,oCAAA;EACA,sBAAA;ApF4pxBJ;;AoFxpxBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;ApF2pxBF;AoFzpxBE;EAEE,oDAAA;EACA,yBAAA;ApF0pxBJ;;AoFrpxBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;ApFwpxBJ;AoFtpxBI;EAEE,sDAAA;EACA,sBAAA;ApFupxBN;;AoFlpxBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;ApFqpxBF;AoFnpxBE;EAEE,oDAAA;EACA,yBAAA;ApFopxBJ;;AoF/oxBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;ApFkpxBJ;AoFhpxBI;EAEE,sDAAA;EACA,sBAAA;ApFipxBN;;AoFxoxBI;EADF;IAEI,sB/ExRE;ELo6xBN;AACF;;AoFvoxBA;EACE,yBAxSiB;ApFk7xBnB;;AoFroxBA;EACE,iCAAA;EACA,yBAAA;EACA,+CAAA;ApFwoxBF;AoFtoxBE;EACE,yB/EzSO;E+E0SP,kBAAA;EACA,UAAA;ApFwoxBJ;AoFtoxBI;EACE,yBAAA;ApFwoxBN;AoFpoxBE;EACE,oEAAA;ApFsoxBJ;AoFloxBI;EACE,cAlUa;ApFs8xBnB;;AoF/nxBA;EACE,cApUkB;ApFs8xBpB;;AoF9nxBE;EACE,cAzUgB;ApF08xBpB;;AoF7nxBA;;;EAGE,sB/E3UM;E+E4UN,cArViB;ApFq9xBnB;;AoF7nxBA;;EAEE,cA1ViB;ApF09xBnB;;AoF7nxBA;EACE,sB/ErVM;ALq9xBR;;AoF7nxBA;EACE,cA9VkB;ApF89xBpB;;AoF7nxBA;;;EAGE,cAxWiB;ApFw+xBnB;;AoF7nxBA;EACE,cAxWkB;ApFw+xBpB;;AoF7nxBA;EACE,yBAhXiB;ApFg/xBnB;;AoF7nxBA;;;;;EAKE,sB/E/WM;E+EgXN,cAzXiB;ApFy/xBnB;;AoF7nxBA,2BAAA;AAGI;EAEE,cAjYa;ApF8/xBnB;AoF1nxBI;EACE,WjF3Ue;AHu8xBrB;AoFznxBI;EAEE,cA1Ya;ApFogyBnB;AoFtnxBE;EACE,cA/Ye;ApFugyBnB;AoFpnxBI;EAEE,cArZa;ApF0gyBnB;AoFhnxBI;EACE,WjFjWe;AHm9xBrB;AoF7mxBM;EACE,cAjaW;ApFghyBnB;AoF3mxBI;EAGE,cAxaa;ApFmhyBnB;;AoFtmxBA;EACE,yBA9aiB;ApFuhyBnB;AoFtmxBI;EACE,W/EzaE;ALihyBR;AoFrmxBI;EAKE,cAzbW;ApF4hyBjB;;AoF3lxBI;EACE,qBAnca;ApFiiyBnB;;AoFxlxBA;EACE,yBA1ciB;ApFqiyBnB;;AoFxlxBA;EACE,mEAAA;ApF2lxBF;;AoFxlxBA;EACE,wCAAA;ApF2lxBF;;AoFxlxBA;;EAEE,wCAAA;EACA,qBAxdiB;ApFmjyBnB;;AoFxlxBA;;;;EAIE,wCAAA;EACA,qBAheiB;ApF2jyBnB;;AoFxlxBA;EACE,wCAAA;EACA,qBAreiB;ApFgkyBnB;;AoFxlxBA;EACE,wCAAA;EACA,qBA1eiB;ApFqkyBnB;;AoFxlxBA;EACE,qBA9eiB;ApFykyBnB;;AoFvlxBA;EACE,cAnfiB;ApF6kyBnB;;AoFtlxBE;EAEE,qEAAA;ApFwlxBJ;;AoFllxBE;EACE,cAhgBe;ApFqlyBnB;;AoFhlxBA;EACE,mBAtgBiB;ApFylyBnB;;AoF/kxBE;EAGE,cA7gBe;ApF6lyBnB;;AoF1kxBE;EACE,qBAphBe;ApFimyBnB;;AoFvkxBE;EACE,qBA3hBe;ApFqmyBnB;AoFxkxBI;EAGE,yBAhiBa;ApFwmyBnB;;AoFjkxBE;EACE,cAxiBe;ApF4myBnB;;AoF/jxBE;EAGE,cA/iBa;ApF+myBjB;;AoF3jxBA;EACE,cArjBe;ApFmnyBjB;;AoF3jxBA;EACE,0CAAA;ApF8jxBF;;AoFzjxBA;EACE,gCAAA;ApF4jxBF;;AoFvjxBA;EACE,yBAtkBiB;ApFgoyBnB;;AoFtjxBE;EACE,yBAAA;EACA,cA5kBe;ApFqoyBnB;AoFvjxBI;EAEE,W/EvkBE;E+EwkBF,yBAjlBa;ApFyoyBnB;;AoF/ixBI;;;;EACE,yBA3lBa;EA4lBb,qBA5lBa;ApFipyBnB;AoFljxBE;;EACE,yBAAA;ApFqjxBJ;AoFpjxBI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;ApFujxBN;AoFrjxBM;;;EAEE,oDAAA;EACA,yBAAA;ApFwjxBR;;AoFjjxBE;EACE,yBAjnBe;EAknBf,qBAlnBe;ApFsqyBnB;;AoFhjxBA;;EAEE,cAxnBiB;ApF2qyBnB;;AqF5qyBA,oBAAA;AAQA;EACE,cARiB;ArFgryBnB;AqFvqyBE;EACE,cAVe;ArFmryBnB;;AqFjqyBE;ENbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqryBF;AIjjyBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E8ryBzG;A+ElryBE;EAII,0HAAA;A/EiryBN;A+E1qyBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+myBf;A+ExqyBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E2syB7L;A+EnqyBI;EAGI,uFAAA;A/EmqyBR;;AqFhsyBE;ENbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EotyBF;AIhlyBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E6tyBzG;A+EjtyBE;EAII,wHAAA;A/EgtyBN;A+EzsyBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8oyBf;A+EvsyBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E0uyB7L;A+ElsyBI;EAGI,qFAAA;A/EksyBR;;AqF/tyBE;ENbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmvyBF;AI/myBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E4vyBzG;A+EhvyBE;EAII,yHAAA;A/E+uyBN;A+ExuyBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6qyBf;A+EtuyBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EywyB7L;A+EjuyBI;EAGI,sFAAA;A/EiuyBR;;AqF9vyBE;ENbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EkxyBF;AI9oyBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E2xyBzG;A+E/wyBE;EAII,wHAAA;A/E8wyBN;A+EvwyBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4syBf;A+ErwyBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EwyyB7L;A+EhwyBI;EAGI,qFAAA;A/EgwyBR;;AqF7xyBE;ENbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EizyBF;AI7qyBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E0zyBzG;A+E9yyBE;EAII,yHAAA;A/E6yyBN;A+EtyyBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2uyBf;A+EpyyBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Eu0yB7L;A+E/xyBI;EAGI,sFAAA;A/E+xyBR;;AqF5zyBE;ENbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eg1yBF;AI5syBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ey1yBzG;A+E70yBE;EAII,wHAAA;A/E40yBN;A+Er0yBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0wyBf;A+En0yBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Es2yB7L;A+E9zyBI;EAGI,qFAAA;A/E8zyBR;;AqF31yBE;ENbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+2yBF;AI3uyBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Ew3yBzG;A+E52yBE;EAII,0HAAA;A/E22yBN;A+Ep2yBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyyyBf;A+El2yBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Eq4yB7L;A+E71yBI;EAGI,uFAAA;A/E61yBR;;AqF13yBE;ENbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E84yBF;AI1wyBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Eu5yBzG;A+E34yBE;EAII,uHAAA;A/E04yBN;A+En4yBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHw0yBf;A+Ej4yBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Eo6yB7L;A+E53yBI;EAGI,oFAAA;A/E43yBR;;AqFn5yBE;ENnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E66yBF;AIzyyBE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Es7yBzG;A+E16yBE;EAII,0HAAA;A/Ey6yBN;A+El6yBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHu2yBf;A+Eh6yBE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Em8yB7L;A+E35yBI;EAGI,uFAAA;A/E25yBR;;AqFl7yBE;ENnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E48yBF;AIx0yBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eq9yBzG;A+Ez8yBE;EAII,wHAAA;A/Ew8yBN;A+Ej8yBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHs4yBf;A+E/7yBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ek+yB7L;A+E17yBI;EAGI,qFAAA;A/E07yBR;;AqFj9yBE;ENnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2+yBF;AIv2yBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Eo/yBzG;A+Ex+yBE;EAII,yHAAA;A/Eu+yBN;A+Eh+yBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHq6yBf;A+E99yBE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EigzB7L;A+Ez9yBI;EAGI,sFAAA;A/Ey9yBR;;AqFh/yBE;ENnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0gzBF;AIt4yBE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EmhzBzG;A+EvgzBE;EAII,wHAAA;A/EsgzBN;A+E//yBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHo8yBf;A+E7/yBE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EgizB7L;A+Ex/yBI;EAGI,qFAAA;A/Ew/yBR;;AqF/gzBE;ENnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EyizBF;AIr6yBE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EkjzBzG;A+EtizBE;EAII,yHAAA;A/EqizBN;A+E9hzBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm+yBf;A+E5hzBE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E+jzB7L;A+EvhzBI;EAGI,sFAAA;A/EuhzBR;;AqF9izBE;ENnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwkzBF;AIp8yBE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EilzBzG;A+ErkzBE;EAII,wHAAA;A/EokzBN;A+E7jzBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkgzBf;A+E3jzBE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E8lzB7L;A+EtjzBI;EAGI,qFAAA;A/EsjzBR;;AqF7kzBE;ENnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EumzBF;AIn+yBE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EgnzBzG;A+EpmzBE;EAII,0HAAA;A/EmmzBN;A+E5lzBE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHiizBf;A+E1lzBE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E6nzB7L;A+ErlzBI;EAGI,uFAAA;A/EqlzBR;;AqF5mzBE;ENnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EsozBF;AIlgzBE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E+ozBzG;A+EnozBE;EAII,uHAAA;A/EkozBN;A+E3nzBE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgkzBf;A+EznzBE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E4pzB7L;A+EpnzBI;EAGI,oFAAA;A/EonzBR;;AqFrozBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+kzBf;A+E7mzBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHolzBf;A+E5mzBE;EAEE,iDAAA;A/E6mzBJ;A+E1mzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2mzBJ;A+ExmzBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgmzBf;A+EtmzBI;EAGI,uFAAA;A/EsmzBR;;AqFhqzBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0mzBf;A+ExozBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+mzBf;A+EvozBE;EAEE,+CAAA;A/EwozBJ;A+ErozBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EsozBJ;A+EnozBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2nzBf;A+EjozBI;EAGI,qFAAA;A/EiozBR;;AqF3rzBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqozBf;A+EnqzBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0ozBf;A+ElqzBE;EAEE,gDAAA;A/EmqzBJ;A+EhqzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EiqzBJ;A+E9pzBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHspzBf;A+E5pzBI;EAGI,sFAAA;A/E4pzBR;;AqFttzBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgqzBf;A+E9rzBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqqzBf;A+E7rzBE;EAEE,+CAAA;A/E8rzBJ;A+E3rzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4rzBJ;A+EzrzBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHirzBf;A+EvrzBI;EAGI,qFAAA;A/EurzBR;;AqFjvzBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2rzBf;A+EztzBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgszBf;A+ExtzBE;EAEE,gDAAA;A/EytzBJ;A+EttzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EutzBJ;A+EptzBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4szBf;A+EltzBI;EAGI,sFAAA;A/EktzBR;;AqF5wzBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHstzBf;A+EpvzBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2tzBf;A+EnvzBE;EAEE,+CAAA;A/EovzBJ;A+EjvzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkvzBJ;A+E/uzBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuuzBf;A+E7uzBI;EAGI,qFAAA;A/E6uzBR;;AqFvyzBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHivzBf;A+E/wzBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHsvzBf;A+E9wzBE;EAEE,iDAAA;A/E+wzBJ;A+E5wzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6wzBJ;A+E1wzBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkwzBf;A+ExwzBI;EAGI,uFAAA;A/EwwzBR;;AqFl0zBE;EN0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4wzBf;A+E1yzBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHixzBf;A+EzyzBE;EAEE,8CAAA;A/E0yzBJ;A+EvyzBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwyzBJ;A+EryzBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6xzBf;A+EnyzBI;EAGI,oFAAA;A/EmyzBR;;AqFn1zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHuyzBf;A+Er0zBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4yzBf;A+Ep0zBE;EAEE,iDAAA;A/Eq0zBJ;A+El0zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em0zBJ;A+Eh0zBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwzzBf;A+E9zzBI;EAGI,uFAAA;A/E8zzBR;;AqF92zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk0zBf;A+Eh2zBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHu0zBf;A+E/1zBE;EAEE,+CAAA;A/Eg2zBJ;A+E71zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E81zBJ;A+E31zBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm1zBf;A+Ez1zBI;EAGI,qFAAA;A/Ey1zBR;;AqFz4zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH61zBf;A+E33zBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk2zBf;A+E13zBE;EAEE,gDAAA;A/E23zBJ;A+Ex3zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey3zBJ;A+Et3zBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH82zBf;A+Ep3zBI;EAGI,sFAAA;A/Eo3zBR;;AqFp6zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw3zBf;A+Et5zBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH63zBf;A+Er5zBE;EAEE,+CAAA;A/Es5zBJ;A+En5zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eo5zBJ;A+Ej5zBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy4zBf;A+E/4zBI;EAGI,qFAAA;A/E+4zBR;;AqF/7zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm5zBf;A+Ej7zBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHw5zBf;A+Eh7zBE;EAEE,gDAAA;A/Ei7zBJ;A+E96zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+6zBJ;A+E56zBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo6zBf;A+E16zBI;EAGI,sFAAA;A/E06zBR;;AqF19zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH86zBf;A+E58zBE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm7zBf;A+E38zBE;EAEE,+CAAA;A/E48zBJ;A+Ez8zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E08zBJ;A+Ev8zBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+7zBf;A+Er8zBI;EAGI,qFAAA;A/Eq8zBR;;AqFr/zBE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy8zBf;A+Ev+zBE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH88zBf;A+Et+zBE;EAEE,iDAAA;A/Eu+zBJ;A+Ep+zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq+zBJ;A+El+zBE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH09zBf;A+Eh+zBI;EAGI,uFAAA;A/Eg+zBR;;AqFhh0BE;ENgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo+zBf;A+Elg0BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy+zBf;A+Ejg0BE;EAEE,8CAAA;A/Ekg0BJ;A+E//zBE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Egg0BJ;A+E7/zBE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq/zBf;A+E3/zBI;EAGI,oFAAA;A/E2/zBR;;AqFli0BA;;EAEE,cAnDiB;EAoDjB,qBApDiB;ArFyl0BnB;AqFni0BE;;;;;;;;EAOE,WhFpDI;EgFqDJ,qBA9De;EA+Df,yBA/De;ArFqm0BnB;;AqFli0BA;;EAEE,cApEe;EAqEf,qBArEe;ArF0m0BjB;AqFni0BE;;;;;;;;EAOE,WhFtEI;EgFuEJ,qBA/Ea;EAgFb,yBAhFa;ArFsn0BjB;;AqFhi0BE;EAEE,cAzFe;ArF2n0BnB;AqFji0BI;EAEE,yDAAA;ArFki0BN;AqF9h0BE;EACE,yBAAA;ArFgi0BJ;AqF7h0BE;EACE,cArGe;ArFoo0BnB;AqF9h0BI;EAEE,cAxGa;ArFuo0BnB;AqF3h0BE;EAEE,oCAAA;EACA,sBAAA;ArF4h0BJ;AqFzh0BE;EAIE,yBAtHe;EAuHf,qBAvHe;EAwHf,WhF/GI;ALuo0BR;AqFth0BI;EAGE,+EAAA;EACA,2EAAA;EACA,sBAAA;ArFsh0BN;AqFjh0BI;EACE,oCAAA;ArFmh0BN;AqFhh0BI;EACE,oCAAA;ArFkh0BN;AqF/g0BI;EACE,oCAAA;ArFih0BN;AqF9g0BI;EACE,oCAAA;ArFgh0BN;AqF7g0BI;EACE,oCAAA;ArF+g0BN;AqF5g0BI;EACE,oCAAA;ArF8g0BN;AqF3g0BI;EACE,oCAAA;ArF6g0BN;AqF1g0BI;EACE,oCAAA;ArF4g0BN;AqFzg0BI;EACE,oCAAA;ArF2g0BN;AqFxg0BI;EACE,oCAAA;ArF0g0BN;AqFvg0BI;EACE,oCAAA;ArFyg0BN;AqFtg0BI;EACE,oCAAA;ArFwg0BN;;AqFjg0BE;EACE,cAxLa;ArF4r0BjB;AqFng0BI;EAEE,6CAAA;ArFog0BN;AqFhg0BE;EACE,yBAAA;ArFkg0BJ;AqF//zBE;EAEE,oCAAA;EACA,sBAAA;ArFgg0BJ;AqF7/zBE;EACE,yBA1Ma;EA2Mb,qBA3Ma;EA4Mb,WhFpMI;ALms0BR;AqF7/zBI;EAGE,0DAAA;EACA,sDAAA;EACA,sBAAA;ArF6/zBN;;AqFv/zBA;EACE,wCAAA;EACA,sBAAA;ArF0/zBF;AqFz/zBE;EAGE,oCAAA;EACA,sBAAA;ArFy/zBJ;;AqFr/zBA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;ArFw/zBF;AqFt/zBE;EAEE,qDAAA;EACA,yBAAA;ArFu/zBJ;;AqFl/zBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;ArFq/zBJ;AqFn/zBI;EAEE,sDAAA;EACA,sBAAA;ArFo/zBN;;AqF/+zBA;EACE,wCAAA;EACA,yBAAA;EACA,gCAAA;ArFk/zBF;AqFh/zBE;EAEE,qDAAA;EACA,yBAAA;ArFi/zBJ;;AqF5+zBE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;ArF++zBJ;AqF7+zBI;EAEE,sDAAA;EACA,sBAAA;ArF8+zBN;;AqFr+zBI;EADF;IAEI,sBhFrRE;EL8v0BN;AACF;;AqFp+zBA;EACE,yBArSiB;ArF4w0BnB;;AqFl+zBA;EACE,iCAAA;EACA,yBAAA;ArFq+zBF;AqFn+zBE;EACE,yBhFrSO;EgFsSP,kBAAA;EACA,UAAA;ArFq+zBJ;AqFn+zBI;EACE,yBAAA;ArFq+zBN;AqFj+zBE;EACE,oEAAA;ArFm+zBJ;AqF/9zBI;EACE,cA9Ta;ArF+x0BnB;;AqF59zBA;EACE,cAhUkB;ArF+x0BpB;;AqF39zBE;EACE,cArUgB;ArFmy0BpB;;AqF19zBA;;;EAGE,sBhFvUM;EgFwUN,cAjViB;ArF8y0BnB;;AqF19zBA;;EAEE,cAtViB;ArFmz0BnB;;AqF19zBA;EACE,sBhFjVM;AL8y0BR;;AqF19zBA;EACE,cA1VkB;ArFuz0BpB;;AqF19zBA;;;EAGE,cApWiB;ArFi00BnB;;AqF19zBA;EACE,cApWkB;ArFi00BpB;;AqF19zBA;EACE,yBA5WiB;ArFy00BnB;;AqF19zBA;;;;;EAKE,sBhF3WM;EgF4WN,cArXiB;ArFk10BnB;;AqF19zBA,2BAAA;AAGI;EAEE,cA7Xa;ArFu10BnB;AqFv9zBI;EACE,WlFvUe;AHgy0BrB;AqFt9zBI;EAEE,cAtYa;ArF610BnB;AqFn9zBE;EACE,cA3Ye;ArFg20BnB;AqFj9zBI;EAEE,cAjZa;ArFm20BnB;AqF78zBI;EACE,WlF7Ve;AH4y0BrB;AqF18zBM;EACE,cA7ZW;ArFy20BnB;AqFx8zBI;EAGE,cApaa;ArF420BnB;;AqFn8zBA;EACE,yBA1aiB;ArFg30BnB;AqFn8zBI;EACE,WhFraE;AL020BR;AqFl8zBI;EAKE,cArbW;ArFq30BjB;;AqFx7zBI;EACE,qBA/ba;ArF030BnB;;AqFr7zBA;EACE,yBAtciB;ArF830BnB;;AqFr7zBA;EACE,oEAAA;ArFw7zBF;;AqFr7zBA;EACE,yCAAA;ArFw7zBF;;AqFr7zBA;;EAEE,yCAAA;EACA,qBApdiB;ArF440BnB;;AqFr7zBA;;;;EAIE,yCAAA;EACA,qBA5diB;ArFo50BnB;;AqFr7zBA;EACE,yCAAA;EACA,qBAjeiB;ArFy50BnB;;AqFr7zBA;EACE,yCAAA;EACA,qBAteiB;ArF850BnB;;AqFr7zBA;EACE,qBA1eiB;ArFk60BnB;;AqFp7zBA;EACE,cA/eiB;ArFs60BnB;;AqFn7zBE;EAEE,qEAAA;ArFq7zBJ;;AqF/6zBE;EACE,cA5fe;ArF860BnB;;AqF76zBA;EACE,mBAlgBiB;ArFk70BnB;;AqF56zBE;EAGE,cAzgBe;ArFs70BnB;;AqFv6zBE;EACE,qBAhhBe;ArF070BnB;;AqFp6zBE;EACE,qBAvhBe;ArF870BnB;AqFr6zBI;EAGE,yBA5hBa;ArFi80BnB;;AqF95zBE;EACE,cApiBe;ArFq80BnB;;AqF55zBE;EAGE,cA3iBa;ArFw80BjB;;AqFx5zBA;EACE,cAjjBe;ArF480BjB;;AqFx5zBA;EACE,2CAAA;ArF25zBF;;AqFt5zBA;EACE,gCAAA;ArFy5zBF;;AqFp5zBA;EACE,yBAlkBiB;ArFy90BnB;;AqFn5zBE;EACE,yBAAA;EACA,cAxkBe;ArF890BnB;AqFp5zBI;EAEE,WhFnkBE;EgFokBF,yBA7kBa;ArFk+0BnB;;AqF54zBI;;;;EACE,yBAvlBa;EAwlBb,qBAxlBa;ArF0+0BnB;AqF74zBE;;EACE,yBAAA;ArFg5zBJ;AqF/4zBI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;ArFk5zBN;AqFh5zBM;;;EAEE,qDAAA;EACA,yBAAA;ArFm5zBR;;AqF54zBE;EACE,yBA/mBe;EAgnBf,qBAhnBe;ArF+/0BnB;;AqF34zBA;;EAEE,cAtnBiB;ArFog1BnB;;AsFrg1BA,2BAAA;AAQA;EACE,cARwB;AtFyg1B1B;AsFhg1BE;EACE,cAVsB;AtF4g1B1B;;AsF1/0BE;EPbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8g1BF;AI140BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Euh1BzG;A+E3g1BE;EAII,0HAAA;A/E0g1BN;A+Eng1BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHw80Bf;A+Ejg1BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Eoi1B7L;A+E5/0BI;EAGI,uFAAA;A/E4/0BR;;AsFzh1BE;EPbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6i1BF;AIz60BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Esj1BzG;A+E1i1BE;EAII,wHAAA;A/Eyi1BN;A+Eli1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHu+0Bf;A+Ehi1BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Emk1B7L;A+E3h1BI;EAGI,qFAAA;A/E2h1BR;;AsFxj1BE;EPbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4k1BF;AIx80BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Eql1BzG;A+Ezk1BE;EAII,yHAAA;A/Ewk1BN;A+Ejk1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsg1Bf;A+E/j1BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Ekm1B7L;A+E1j1BI;EAGI,sFAAA;A/E0j1BR;;AsFvl1BE;EPbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2m1BF;AIv+0BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Eon1BzG;A+Exm1BE;EAII,wHAAA;A/Eum1BN;A+Ehm1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqi1Bf;A+E9l1BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Eio1B7L;A+Ezl1BI;EAGI,qFAAA;A/Eyl1BR;;AsFtn1BE;EPbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0o1BF;AItg1BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Emp1BzG;A+Evo1BE;EAII,yHAAA;A/Eso1BN;A+E/n1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHok1Bf;A+E7n1BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Egq1B7L;A+Exn1BI;EAGI,sFAAA;A/Ewn1BR;;AsFrp1BE;EPbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eyq1BF;AIri1BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ekr1BzG;A+Etq1BE;EAII,wHAAA;A/Eqq1BN;A+E9p1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmm1Bf;A+E5p1BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E+r1B7L;A+Evp1BI;EAGI,qFAAA;A/Eup1BR;;AsFpr1BE;EPbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ews1BF;AIpk1BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eit1BzG;A+Ers1BE;EAII,0HAAA;A/Eos1BN;A+E7r1BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHko1Bf;A+E3r1BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E8t1B7L;A+Etr1BI;EAGI,uFAAA;A/Esr1BR;;AsFnt1BE;EPbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Euu1BF;AInm1BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Egv1BzG;A+Epu1BE;EAII,uHAAA;A/Emu1BN;A+E5t1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHiq1Bf;A+E1t1BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E6v1B7L;A+Ert1BI;EAGI,oFAAA;A/Eqt1BR;;AsF5u1BE;EPnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Esw1BF;AIlo1BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E+w1BzG;A+Enw1BE;EAII,0HAAA;A/Ekw1BN;A+E3v1BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgs1Bf;A+Ezv1BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E4x1B7L;A+Epv1BI;EAGI,uFAAA;A/Eov1BR;;AsF3w1BE;EPnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eqy1BF;AIjq1BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E8y1BzG;A+Ely1BE;EAII,wHAAA;A/Eiy1BN;A+E1x1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+t1Bf;A+Exx1BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E2z1B7L;A+Enx1BI;EAGI,qFAAA;A/Emx1BR;;AsF1y1BE;EPnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo01BF;AIhs1BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E601BzG;A+Ej01BE;EAII,yHAAA;A/Eg01BN;A+Ezz1BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8v1Bf;A+Evz1BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E011B7L;A+Elz1BI;EAGI,sFAAA;A/Ekz1BR;;AsFz01BE;EPnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em21BF;AI/t1BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E421BzG;A+Eh21BE;EAII,wHAAA;A/E+11BN;A+Ex11BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6x1Bf;A+Et11BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Ey31B7L;A+Ej11BI;EAGI,qFAAA;A/Ei11BR;;AsFx21BE;EPnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ek41BF;AI9v1BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E241BzG;A+E/31BE;EAII,yHAAA;A/E831BN;A+Ev31BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4z1Bf;A+Er31BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Ew51B7L;A+Eh31BI;EAGI,sFAAA;A/Eg31BR;;AsFv41BE;EPnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ei61BF;AI7x1BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E061BzG;A+E951BE;EAII,wHAAA;A/E651BN;A+Et51BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH211Bf;A+Ep51BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eu71B7L;A+E/41BI;EAGI,qFAAA;A/E+41BR;;AsFt61BE;EPnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eg81BF;AI5z1BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Ey81BzG;A+E771BE;EAII,0HAAA;A/E471BN;A+Er71BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH031Bf;A+En71BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Es91B7L;A+E961BI;EAGI,uFAAA;A/E861BR;;AsFr81BE;EPnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+91BF;AI311BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Ew+1BzG;A+E591BE;EAII,uHAAA;A/E291BN;A+Ep91BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHy51Bf;A+El91BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Eq/1B7L;A+E781BI;EAGI,oFAAA;A/E681BR;;AsF991BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw61Bf;A+Et81BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH661Bf;A+Er81BE;EAEE,iDAAA;A/Es81BJ;A+En81BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eo81BJ;A+Ej81BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy71Bf;A+E/71BI;EAGI,uFAAA;A/E+71BR;;AsFz/1BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm81Bf;A+Ej+1BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHw81Bf;A+Eh+1BE;EAEE,+CAAA;A/Ei+1BJ;A+E991BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+91BJ;A+E591BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo91Bf;A+E191BI;EAGI,qFAAA;A/E091BR;;AsFph2BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH891Bf;A+E5/1BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm+1Bf;A+E3/1BE;EAEE,gDAAA;A/E4/1BJ;A+Ez/1BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0/1BJ;A+Ev/1BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH++1Bf;A+Er/1BI;EAGI,sFAAA;A/Eq/1BR;;AsF/i2BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy/1Bf;A+Evh2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8/1Bf;A+Eth2BE;EAEE,+CAAA;A/Euh2BJ;A+Eph2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eqh2BJ;A+Elh2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0g2Bf;A+Ehh2BI;EAGI,qFAAA;A/Egh2BR;;AsF1k2BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHoh2Bf;A+Elj2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHyh2Bf;A+Ejj2BE;EAEE,gDAAA;A/Ekj2BJ;A+E/i2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Egj2BJ;A+E7i2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqi2Bf;A+E3i2BI;EAGI,sFAAA;A/E2i2BR;;AsFrm2BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+i2Bf;A+E7k2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHoj2Bf;A+E5k2BE;EAEE,+CAAA;A/E6k2BJ;A+E1k2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2k2BJ;A+Exk2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgk2Bf;A+Etk2BI;EAGI,qFAAA;A/Esk2BR;;AsFho2BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0k2Bf;A+Exm2BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH+k2Bf;A+Evm2BE;EAEE,iDAAA;A/Ewm2BJ;A+Erm2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Esm2BJ;A+Enm2BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2l2Bf;A+Ejm2BI;EAGI,uFAAA;A/Eim2BR;;AsF3p2BE;EP0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqm2Bf;A+Eno2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0m2Bf;A+Elo2BE;EAEE,8CAAA;A/Emo2BJ;A+Eho2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eio2BJ;A+E9n2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHsn2Bf;A+E5n2BI;EAGI,oFAAA;A/E4n2BR;;AsF5q2BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgo2Bf;A+E9p2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqo2Bf;A+E7p2BE;EAEE,iDAAA;A/E8p2BJ;A+E3p2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4p2BJ;A+Ezp2BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHip2Bf;A+Evp2BI;EAGI,uFAAA;A/Eup2BR;;AsFvs2BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2p2Bf;A+Ezr2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgq2Bf;A+Exr2BE;EAEE,+CAAA;A/Eyr2BJ;A+Etr2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eur2BJ;A+Epr2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4q2Bf;A+Elr2BI;EAGI,qFAAA;A/Ekr2BR;;AsFlu2BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsr2Bf;A+Ept2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2r2Bf;A+Ent2BE;EAEE,gDAAA;A/Eot2BJ;A+Ejt2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ekt2BJ;A+E/s2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHus2Bf;A+E7s2BI;EAGI,sFAAA;A/E6s2BR;;AsF7v2BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHit2Bf;A+E/u2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHst2Bf;A+E9u2BE;EAEE,+CAAA;A/E+u2BJ;A+E5u2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6u2BJ;A+E1u2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHku2Bf;A+Exu2BI;EAGI,qFAAA;A/Ewu2BR;;AsFxx2BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4u2Bf;A+E1w2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHiv2Bf;A+Ezw2BE;EAEE,gDAAA;A/E0w2BJ;A+Evw2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eww2BJ;A+Erw2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6v2Bf;A+Enw2BI;EAGI,sFAAA;A/Emw2BR;;AsFnz2BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHuw2Bf;A+Ery2BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4w2Bf;A+Epy2BE;EAEE,+CAAA;A/Eqy2BJ;A+Ely2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Emy2BJ;A+Ehy2BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwx2Bf;A+E9x2BI;EAGI,qFAAA;A/E8x2BR;;AsF902BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHky2Bf;A+Eh02BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHuy2Bf;A+E/z2BE;EAEE,iDAAA;A/Eg02BJ;A+E7z2BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8z2BJ;A+E3z2BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmz2Bf;A+Ezz2BI;EAGI,uFAAA;A/Eyz2BR;;AsFz22BE;EPgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6z2Bf;A+E312BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk02Bf;A+E112BE;EAEE,8CAAA;A/E212BJ;A+Ex12BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey12BJ;A+Et12BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH802Bf;A+Ep12BI;EAGI,oFAAA;A/Eo12BR;;AsF332BA;;EAEE,cAnDwB;EAoDxB,qBApDwB;AtFk72B1B;AsF532BE;;;;;;;;EAOE,WjFpDI;EiFqDJ,qBA9DsB;EA+DtB,yBA/DsB;AtF872B1B;;AsF332BA;;EAEE,cApEsB;EAqEtB,qBArEsB;AtFm82BxB;AsF532BE;;;;;;;;EAOE,WjFtEI;EiFuEJ,qBA/EoB;EAgFpB,yBAhFoB;AtF+82BxB;;AsFz32BE;EAEE,cAzFsB;AtFo92B1B;AsF132BI;EAEE,wDAAA;AtF232BN;AsFv32BE;EACE,yBAAA;AtFy32BJ;AsFt32BE;EACE,cArGsB;AtF692B1B;AsFv32BI;EAEE,cAxGoB;AtFg+2B1B;AsFp32BE;EAEE,oCAAA;EACA,sBAAA;AtFq32BJ;AsFl32BE;EAIE,yBAtHsB;EAuHtB,qBAvHsB;EAwHtB,WjF/GI;ALg+2BR;AsF/22BI;EAGE,6EAAA;EACA,yEAAA;EACA,sBAAA;AtF+22BN;AsF122BI;EACE,oCAAA;AtF422BN;AsFz22BI;EACE,oCAAA;AtF222BN;AsFx22BI;EACE,oCAAA;AtF022BN;AsFv22BI;EACE,oCAAA;AtFy22BN;AsFt22BI;EACE,oCAAA;AtFw22BN;AsFr22BI;EACE,oCAAA;AtFu22BN;AsFp22BI;EACE,oCAAA;AtFs22BN;AsFn22BI;EACE,oCAAA;AtFq22BN;AsFl22BI;EACE,oCAAA;AtFo22BN;AsFj22BI;EACE,oCAAA;AtFm22BN;AsFh22BI;EACE,oCAAA;AtFk22BN;AsF/12BI;EACE,oCAAA;AtFi22BN;;AsF112BE;EACE,cAxLoB;AtFqh3BxB;AsF512BI;EAEE,oCAAA;AtF612BN;AsFz12BE;EACE,yBAAA;AtF212BJ;AsFx12BE;EAEE,oCAAA;EACA,sBAAA;AtFy12BJ;AsFt12BE;EACE,yBA1MoB;EA2MpB,qBA3MoB;EA4MpB,WjFpMI;AL4h3BR;AsFt12BI;EAGE,iDAAA;EACA,6CAAA;EACA,sBAAA;AtFs12BN;;AsFh12BA;EACE,wCAAA;EACA,sBAAA;AtFm12BF;AsFl12BE;EAGE,oCAAA;EACA,sBAAA;AtFk12BJ;;AsF902BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AtFi12BF;AsF/02BE;EAEE,qDAAA;EACA,yBAAA;AtFg12BJ;;AsF302BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AtF802BJ;AsF502BI;EAEE,sDAAA;EACA,sBAAA;AtF602BN;;AsFx02BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AtF202BF;AsFz02BE;EAEE,oDAAA;EACA,yBAAA;AtF002BJ;;AsFr02BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AtFw02BJ;AsFt02BI;EAEE,sDAAA;EACA,sBAAA;AtFu02BN;;AsF/z2BI;EADF;IAEI,sBjFpRE;ELul3BN;AACF;;AsF9z2BA;EACE,yBApSwB;AtFqm3B1B;;AsF5z2BA;EACE,iCAAA;EACA,yBAAA;AtF+z2BF;AsF7z2BE;EACE,yBjFpSO;EiFqSP,kBAAA;EACA,UAAA;AtF+z2BJ;AsF7z2BI;EACE,yBAAA;AtF+z2BN;AsF3z2BE;EACE,oEAAA;AtF6z2BJ;AsFzz2BI;EACE,cA7ToB;AtFwn3B1B;;AsFtz2BA;EACE,cA/TyB;AtFwn3B3B;;AsFrz2BE;EACE,cApUuB;AtF4n3B3B;;AsFpz2BA;;;EAGE,sBjFtUM;EiFuUN,cAhVwB;AtFuo3B1B;;AsFpz2BA;;EAEE,cArVwB;AtF4o3B1B;;AsFpz2BA;EACE,sBjFhVM;ALuo3BR;;AsFpz2BA;EACE,cAzVyB;AtFgp3B3B;;AsFpz2BA;;;EAGE,cAnWwB;AtF0p3B1B;;AsFpz2BA;EACE,cAnWyB;AtF0p3B3B;;AsFpz2BA;EACE,yBA3WwB;AtFkq3B1B;;AsFpz2BA;;;;;EAKE,sBjF1WM;EiF2WN,cApXwB;AtF2q3B1B;;AsFpz2BA,2BAAA;AAGI;EAEE,cA5XoB;AtFgr3B1B;AsFjz2BI;EACE,WnFtUe;AHyn3BrB;AsFhz2BI;EAEE,cArYoB;AtFsr3B1B;AsF7y2BE;EACE,cA1YsB;AtFyr3B1B;AsF3y2BI;EAEE,cAhZoB;AtF4r3B1B;AsFvy2BI;EACE,WnF5Ve;AHqo3BrB;AsFpy2BM;EACE,cA5ZkB;AtFks3B1B;AsFly2BI;EAGE,cAnaoB;AtFqs3B1B;;AsF7x2BA;EACE,yBAzawB;AtFys3B1B;AsF7x2BI;EACE,WjFpaE;ALms3BR;AsF5x2BI;EAKE,cApbkB;AtF8s3BxB;;AsFlx2BI;EACE,qBA9boB;AtFmt3B1B;;AsF/w2BA;EACE,yBArcwB;AtFut3B1B;;AsF/w2BA;EACE,mEAAA;AtFkx2BF;;AsF/w2BA;EACE,yCAAA;AtFkx2BF;;AsF/w2BA;;EAEE,yCAAA;EACA,qBAndwB;AtFqu3B1B;;AsF/w2BA;;;;EAIE,yCAAA;EACA,qBA3dwB;AtF6u3B1B;;AsF/w2BA;EACE,yCAAA;EACA,qBAhewB;AtFkv3B1B;;AsF/w2BA;EACE,yCAAA;EACA,qBArewB;AtFuv3B1B;;AsF/w2BA;EACE,qBAzewB;AtF2v3B1B;;AsF9w2BA;EACE,cA9ewB;AtF+v3B1B;;AsF7w2BE;EAEE,qEAAA;AtF+w2BJ;;AsFzw2BE;EACE,cA3fsB;AtFuw3B1B;;AsFvw2BA;EACE,mBAjgBwB;AtF2w3B1B;;AsFtw2BE;EAGE,cAxgBsB;AtF+w3B1B;;AsFjw2BE;EACE,qBA/gBsB;AtFmx3B1B;;AsF9v2BE;EACE,qBAthBsB;AtFux3B1B;AsF/v2BI;EAGE,yBA3hBoB;AtF0x3B1B;;AsFxv2BE;EACE,cAniBsB;AtF8x3B1B;;AsFtv2BE;EAGE,cA1iBoB;AtFiy3BxB;;AsFlv2BA;EACE,cAhjBsB;AtFqy3BxB;;AsFlv2BA;EACE,2CAAA;AtFqv2BF;;AsFhv2BA;EACE,gCAAA;AtFmv2BF;;AsF9u2BA;EACE,yBAjkBwB;AtFkz3B1B;;AsF7u2BE;EACE,yBAAA;EACA,cAvkBsB;AtFuz3B1B;AsF9u2BI;EAEE,WjFlkBE;EiFmkBF,yBA5kBoB;AtF2z3B1B;;AsFtu2BI;;;;EACE,yBAtlBoB;EAulBpB,qBAvlBoB;AtFm03B1B;AsFvu2BE;;EACE,yBAAA;AtF0u2BJ;AsFzu2BI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AtF4u2BN;AsF1u2BM;;;EAEE,qDAAA;EACA,yBAAA;AtF6u2BR;;AsFru2BE;EACE,yBA/mBsB;EAgnBtB,qBAhnBsB;AtFw13B1B;;AsFpu2BA;;EAEE,cAtnBwB;AtF613B1B;;AuF913BA,qBAAA;AAQA;EACE,cARkB;AvFk23BpB;AuFz13BE;EACE,cAVgB;AvFq23BpB;;AuFn13BE;ERbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu23BF;AInu3BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Eg33BzG;A+Ep23BE;EAII,0HAAA;A/Em23BN;A+E513BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHiy3Bf;A+E113BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E633B7L;A+Er13BI;EAGI,uFAAA;A/Eq13BR;;AuFl33BE;ERbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es43BF;AIlw3BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E+43BzG;A+En43BE;EAII,wHAAA;A/Ek43BN;A+E333BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHg03Bf;A+Ez33BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E453B7L;A+Ep33BI;EAGI,qFAAA;A/Eo33BR;;AuFj53BE;ERbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq63BF;AIjy3BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E863BzG;A+El63BE;EAII,yHAAA;A/Ei63BN;A+E153BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+13Bf;A+Ex53BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E273B7L;A+En53BI;EAGI,sFAAA;A/Em53BR;;AuFh73BE;ERbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo83BF;AIh03BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E683BzG;A+Ej83BE;EAII,wHAAA;A/Eg83BN;A+Ez73BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH833Bf;A+Ev73BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E093B7L;A+El73BI;EAGI,qFAAA;A/Ek73BR;;AuF/83BE;ERbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em+3BF;AI/13BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E4+3BzG;A+Eh+3BE;EAII,yHAAA;A/E+93BN;A+Ex93BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH653Bf;A+Et93BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Ey/3B7L;A+Ej93BI;EAGI,sFAAA;A/Ei93BR;;AuF9+3BE;ERbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ekg4BF;AI933BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E2g4BzG;A+E//3BE;EAII,wHAAA;A/E8/3BN;A+Ev/3BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH473Bf;A+Er/3BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ewh4B7L;A+Eh/3BI;EAGI,qFAAA;A/Eg/3BR;;AuF7g4BE;ERbA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eii4BF;AI753BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E0i4BzG;A+E9h4BE;EAII,0HAAA;A/E6h4BN;A+Eth4BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH293Bf;A+Eph4BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Euj4B7L;A+E/g4BI;EAGI,uFAAA;A/E+g4BR;;AuF5i4BE;ERbA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Egk4BF;AI573BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Eyk4BzG;A+E7j4BE;EAII,uHAAA;A/E4j4BN;A+Erj4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0/3Bf;A+Enj4BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Esl4B7L;A+E9i4BI;EAGI,oFAAA;A/E8i4BR;;AuFrk4BE;ERnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+l4BF;AI393BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Ewm4BzG;A+E5l4BE;EAII,0HAAA;A/E2l4BN;A+Epl4BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyh4Bf;A+Ell4BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Eqn4B7L;A+E7k4BI;EAGI,uFAAA;A/E6k4BR;;AuFpm4BE;ERnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8n4BF;AI1/3BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Euo4BzG;A+E3n4BE;EAII,wHAAA;A/E0n4BN;A+Enn4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwj4Bf;A+Ejn4BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eop4B7L;A+E5m4BI;EAGI,qFAAA;A/E4m4BR;;AuFno4BE;ERnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6p4BF;AIzh4BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Esq4BzG;A+E1p4BE;EAII,yHAAA;A/Eyp4BN;A+Elp4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHul4Bf;A+Ehp4BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Emr4B7L;A+E3o4BI;EAGI,sFAAA;A/E2o4BR;;AuFlq4BE;ERnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4r4BF;AIxj4BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Eqs4BzG;A+Ezr4BE;EAII,wHAAA;A/Ewr4BN;A+Ejr4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsn4Bf;A+E/q4BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Ekt4B7L;A+E1q4BI;EAGI,qFAAA;A/E0q4BR;;AuFjs4BE;ERnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2t4BF;AIvl4BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Eou4BzG;A+Ext4BE;EAII,yHAAA;A/Eut4BN;A+Eht4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqp4Bf;A+E9s4BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Eiv4B7L;A+Ezs4BI;EAGI,sFAAA;A/Eys4BR;;AuFhu4BE;ERnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0v4BF;AItn4BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Emw4BzG;A+Evv4BE;EAII,wHAAA;A/Esv4BN;A+E/u4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHor4Bf;A+E7u4BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Egx4B7L;A+Exu4BI;EAGI,qFAAA;A/Ewu4BR;;AuF/v4BE;ERnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eyx4BF;AIrp4BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eky4BzG;A+Etx4BE;EAII,0HAAA;A/Eqx4BN;A+E9w4BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmt4Bf;A+E5w4BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E+y4B7L;A+Evw4BI;EAGI,uFAAA;A/Euw4BR;;AuF9x4BE;ERnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ewz4BF;AIpr4BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Ei04BzG;A+Erz4BE;EAII,uHAAA;A/Eoz4BN;A+E7y4BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkv4Bf;A+E3y4BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E804B7L;A+Ety4BI;EAGI,oFAAA;A/Esy4BR;;AuFvz4BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHiw4Bf;A+E/x4BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHsw4Bf;A+E9x4BE;EAEE,iDAAA;A/E+x4BJ;A+E5x4BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6x4BJ;A+E1x4BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkx4Bf;A+Exx4BI;EAGI,uFAAA;A/Ewx4BR;;AuFl14BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4x4Bf;A+E1z4BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHiy4Bf;A+Ezz4BE;EAEE,+CAAA;A/E0z4BJ;A+Evz4BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ewz4BJ;A+Erz4BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6y4Bf;A+Enz4BI;EAGI,qFAAA;A/Emz4BR;;AuF724BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHuz4Bf;A+Er14BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4z4Bf;A+Ep14BE;EAEE,gDAAA;A/Eq14BJ;A+El14BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em14BJ;A+Eh14BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHw04Bf;A+E904BI;EAGI,sFAAA;A/E804BR;;AuFx44BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk14Bf;A+Eh34BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHu14Bf;A+E/24BE;EAEE,+CAAA;A/Eg34BJ;A+E724BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E824BJ;A+E324BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm24Bf;A+Ez24BI;EAGI,qFAAA;A/Ey24BR;;AuFn64BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH624Bf;A+E344BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk34Bf;A+E144BE;EAEE,gDAAA;A/E244BJ;A+Ex44BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey44BJ;A+Et44BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH834Bf;A+Ep44BI;EAGI,sFAAA;A/Eo44BR;;AuF974BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw44Bf;A+Et64BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH644Bf;A+Er64BE;EAEE,+CAAA;A/Es64BJ;A+En64BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eo64BJ;A+Ej64BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy54Bf;A+E/54BI;EAGI,qFAAA;A/E+54BR;;AuFz94BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm64Bf;A+Ej84BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHw64Bf;A+Eh84BE;EAEE,iDAAA;A/Ei84BJ;A+E974BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+74BJ;A+E574BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo74Bf;A+E174BI;EAGI,uFAAA;A/E074BR;;AuFp/4BE;ER0BA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH874Bf;A+E594BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm84Bf;A+E394BE;EAEE,8CAAA;A/E494BJ;A+Ez94BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E094BJ;A+Ev94BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+84Bf;A+Er94BI;EAGI,oFAAA;A/Eq94BR;;AuFrg5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy94Bf;A+Ev/4BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH894Bf;A+Et/4BE;EAEE,iDAAA;A/Eu/4BJ;A+Ep/4BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq/4BJ;A+El/4BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0+4Bf;A+Eh/4BI;EAGI,uFAAA;A/Eg/4BR;;AuFhi5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo/4Bf;A+Elh5BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy/4Bf;A+Ejh5BE;EAEE,+CAAA;A/Ekh5BJ;A+E/g5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Egh5BJ;A+E7g5BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqg5Bf;A+E3g5BI;EAGI,qFAAA;A/E2g5BR;;AuF3j5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+g5Bf;A+E7i5BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHoh5Bf;A+E5i5BE;EAEE,gDAAA;A/E6i5BJ;A+E1i5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2i5BJ;A+Exi5BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgi5Bf;A+Eti5BI;EAGI,sFAAA;A/Esi5BR;;AuFtl5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0i5Bf;A+Exk5BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+i5Bf;A+Evk5BE;EAEE,+CAAA;A/Ewk5BJ;A+Erk5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Esk5BJ;A+Enk5BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2j5Bf;A+Ejk5BI;EAGI,qFAAA;A/Eik5BR;;AuFjn5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqk5Bf;A+Enm5BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0k5Bf;A+Elm5BE;EAEE,gDAAA;A/Emm5BJ;A+Ehm5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eim5BJ;A+E9l5BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHsl5Bf;A+E5l5BI;EAGI,sFAAA;A/E4l5BR;;AuF5o5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgm5Bf;A+E9n5BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqm5Bf;A+E7n5BE;EAEE,+CAAA;A/E8n5BJ;A+E3n5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4n5BJ;A+Ezn5BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHin5Bf;A+Evn5BI;EAGI,qFAAA;A/Eun5BR;;AuFvq5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2n5Bf;A+Ezp5BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHgo5Bf;A+Exp5BE;EAEE,iDAAA;A/Eyp5BJ;A+Etp5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eup5BJ;A+Epp5BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4o5Bf;A+Elp5BI;EAGI,uFAAA;A/Ekp5BR;;AuFls5BE;ERgBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsp5Bf;A+Epr5BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2p5Bf;A+Enr5BE;EAEE,8CAAA;A/Eor5BJ;A+Ejr5BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ekr5BJ;A+E/q5BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuq5Bf;A+E7q5BI;EAGI,oFAAA;A/E6q5BR;;AuFpt5BA;;EAEE,cAnDkB;EAoDlB,qBApDkB;AvF2w5BpB;AuFrt5BE;;;;;;;;EAOE,WlFpDI;EkFqDJ,qBA9DgB;EA+DhB,yBA/DgB;AvFux5BpB;;AuFpt5BA;;EAEE,cApEgB;EAqEhB,qBArEgB;AvF4x5BlB;AuFrt5BE;;;;;;;;EAOE,WlFtEI;EkFuEJ,qBA/Ec;EAgFd,yBAhFc;AvFwy5BlB;;AuFlt5BE;EAEE,cAzFgB;AvF6y5BpB;AuFnt5BI;EAEE,wDAAA;AvFot5BN;AuFht5BE;EACE,yBAAA;AvFkt5BJ;AuF/s5BE;EACE,cArGgB;AvFsz5BpB;AuFht5BI;EAEE,cAxGc;AvFyz5BpB;AuF7s5BE;EAEE,oCAAA;EACA,sBAAA;AvF8s5BJ;AuF3s5BE;EAIE,yBAtHgB;EAuHhB,qBAvHgB;EAwHhB,WlF/GI;ALyz5BR;AuFxs5BI;EAGE,8EAAA;EACA,0EAAA;EACA,sBAAA;AvFws5BN;AuFps5BI;EACE,oCAAA;AvFss5BN;AuFns5BI;EACE,oCAAA;AvFqs5BN;AuFls5BI;EACE,oCAAA;AvFos5BN;AuFjs5BI;EACE,oCAAA;AvFms5BN;AuFhs5BI;EACE,oCAAA;AvFks5BN;AuF/r5BI;EACE,oCAAA;AvFis5BN;AuF9r5BI;EACE,oCAAA;AvFgs5BN;AuF7r5BI;EACE,oCAAA;AvF+r5BN;AuF5r5BI;EACE,oCAAA;AvF8r5BN;AuF3r5BI;EACE,oCAAA;AvF6r5BN;AuF1r5BI;EACE,oCAAA;AvF4r5BN;AuFzr5BI;EACE,oCAAA;AvF2r5BN;;AuFpr5BE;EACE,cAvLc;AvF825BlB;AuFtr5BI;EAEE,mCAAA;AvFur5BN;AuFnr5BE;EACE,yBAAA;AvFqr5BJ;AuFlr5BE;EAEE,oCAAA;EACA,sBAAA;AvFmr5BJ;AuFhr5BE;EACE,yBAzMc;EA0Md,qBA1Mc;EA2Md,WlFnMI;ALq35BR;AuFhr5BI;EAGE,gDAAA;EACA,4CAAA;EACA,sBAAA;AvFgr5BN;;AuF1q5BA;EACE,wCAAA;EACA,sBAAA;AvF6q5BF;AuF5q5BE;EAGE,oCAAA;EACA,sBAAA;AvF4q5BJ;;AuFxq5BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AvF2q5BF;AuFzq5BE;EAEE,oDAAA;EACA,yBAAA;AvF0q5BJ;;AuFrq5BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AvFwq5BJ;AuFtq5BI;EAEE,sDAAA;EACA,sBAAA;AvFuq5BN;;AuFlq5BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AvFqq5BF;AuFnq5BE;EAEE,oDAAA;EACA,yBAAA;AvFoq5BJ;;AuF/p5BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AvFkq5BJ;AuFhq5BI;EAEE,sDAAA;EACA,sBAAA;AvFiq5BN;;AuFxp5BI;EADF;IAEI,sBlFpRE;ELg75BN;AACF;;AuFvp5BA;EACE,yBApSkB;AvF875BpB;;AuFrp5BA;EACE,iCAAA;EACA,yBAAA;EACA,+CAAA;AvFwp5BF;AuFtp5BE;EACE,yBlFrSO;EkFsSP,kBAAA;EACA,UAAA;AvFwp5BJ;AuFtp5BI;EACE,yBAAA;AvFwp5BN;AuFpp5BE;EACE,oEAAA;AvFsp5BJ;AuFlp5BI;EACE,cA9Tc;AvFk95BpB;;AuF/o5BA;EACE,cAhUmB;AvFk95BrB;;AuF9o5BE;EACE,cArUiB;AvFs95BrB;;AuF7o5BA;;;EAGE,sBlFvUM;EkFwUN,cAjVkB;AvFi+5BpB;;AuF7o5BA;;EAEE,cAtVkB;AvFs+5BpB;;AuF7o5BA;EACE,sBlFjVM;ALi+5BR;;AuF7o5BA;EACE,cA1VmB;AvF0+5BrB;;AuF7o5BA;;;EAGE,cApWkB;AvFo/5BpB;;AuF7o5BA;EACE,cApWmB;AvFo/5BrB;;AuF7o5BA;EACE,yBA5WkB;AvF4/5BpB;;AuF7o5BA;;;;;EAKE,sBlF3WM;EkF4WN,cArXkB;AvFqg6BpB;;AuF7o5BA,2BAAA;AAGI;EAEE,cA7Xc;AvF0g6BpB;AuF1o5BI;EACE,WpFvUe;AHm95BrB;AuFzo5BI;EAEE,cAtYc;AvFgh6BpB;AuFto5BE;EACE,cA3YgB;AvFmh6BpB;AuFpo5BI;EAEE,cAjZc;AvFsh6BpB;AuFho5BI;EACE,WpF7Ve;AH+95BrB;AuF7n5BM;EACE,cA7ZY;AvF4h6BpB;AuF3n5BI;EAGE,cApac;AvF+h6BpB;;AuFtn5BA;EACE,yBA1akB;AvFmi6BpB;AuFtn5BI;EACE,WlFraE;AL6h6BR;AuFrn5BI;EAKE,cArbY;AvFwi6BlB;;AuF3m5BI;EACE,qBA/bc;AvF6i6BpB;;AuFxm5BA;EACE,yBAtckB;AvFij6BpB;;AuFxm5BA;EACE,mEAAA;AvF2m5BF;;AuFxm5BA;EACE,wCAAA;AvF2m5BF;;AuFxm5BA;;EAEE,wCAAA;EACA,qBApdkB;AvF+j6BpB;;AuFxm5BA;;;;EAIE,wCAAA;EACA,qBA5dkB;AvFuk6BpB;;AuFxm5BA;EACE,wCAAA;EACA,qBAjekB;AvF4k6BpB;;AuFxm5BA;EACE,wCAAA;EACA,qBAtekB;AvFil6BpB;;AuFxm5BA;EACE,qBA1ekB;AvFql6BpB;;AuFvm5BA;EACE,cA/ekB;AvFyl6BpB;;AuFtm5BE;EAEE,qEAAA;AvFwm5BJ;;AuFlm5BE;EACE,cA5fgB;AvFim6BpB;;AuFhm5BA;EACE,mBAlgBkB;AvFqm6BpB;;AuF/l5BE;EAGE,cAzgBgB;AvFym6BpB;;AuF1l5BE;EACE,qBAhhBgB;AvF6m6BpB;;AuFvl5BE;EACE,qBAvhBgB;AvFin6BpB;AuFxl5BI;EAGE,yBA5hBc;AvFon6BpB;;AuFjl5BE;EACE,cApiBgB;AvFwn6BpB;;AuF/k5BE;EAGE,cA3iBc;AvF2n6BlB;;AuF3k5BA;EACE,cAjjBgB;AvF+n6BlB;;AuF3k5BA;EACE,0CAAA;AvF8k5BF;;AuFzk5BA;EACE,gCAAA;AvF4k5BF;;AuFvk5BA;EACE,yBAlkBkB;AvF4o6BpB;;AuFtk5BE;EACE,yBAAA;EACA,cAxkBgB;AvFip6BpB;AuFvk5BI;EAEE,WlFnkBE;EkFokBF,yBA7kBc;AvFqp6BpB;;AuF/j5BI;;;;EACE,yBAvlBc;EAwlBd,qBAxlBc;AvF6p6BpB;AuFlk5BE;;EACE,yBAAA;AvFqk5BJ;AuFpk5BI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AvFuk5BN;AuFrk5BM;;;EAEE,oDAAA;EACA,yBAAA;AvFwk5BR;;AuFhk5BE;EACE,yBA9mBgB;EA+mBhB,qBA/mBgB;AvFkr6BpB;;AuF/j5BA;;EAEE,cArnBkB;AvFur6BpB;;AwFxr6BA,2BAAA;AAcA;EACE,cAdwB;AxF4r6B1B;AwF7q6BE;EACE,cAhBsB;AxF+r6B1B;;AwFvq6BE;ETnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eis6BF;AI7j6BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E0s6BzG;A+E9r6BE;EAII,0HAAA;A/E6r6BN;A+Etr6BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2n6Bf;A+Epr6BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Eut6B7L;A+E/q6BI;EAGI,uFAAA;A/E+q6BR;;AwFts6BE;ETnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Egu6BF;AI5l6BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eyu6BzG;A+E7t6BE;EAII,wHAAA;A/E4t6BN;A+Ert6BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0p6Bf;A+Ent6BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Esv6B7L;A+E9s6BI;EAGI,qFAAA;A/E8s6BR;;AwFru6BE;ETnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+v6BF;AI3n6BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Eww6BzG;A+E5v6BE;EAII,yHAAA;A/E2v6BN;A+Epv6BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyr6Bf;A+Elv6BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Eqx6B7L;A+E7u6BI;EAGI,sFAAA;A/E6u6BR;;AwFpw6BE;ETnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8x6BF;AI1p6BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Euy6BzG;A+E3x6BE;EAII,wHAAA;A/E0x6BN;A+Enx6BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwt6Bf;A+Ejx6BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Eoz6B7L;A+E5w6BI;EAGI,qFAAA;A/E4w6BR;;AwFny6BE;ETnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6z6BF;AIzr6BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Es06BzG;A+E1z6BE;EAII,yHAAA;A/Eyz6BN;A+Elz6BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuv6Bf;A+Ehz6BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Em16B7L;A+E3y6BI;EAGI,sFAAA;A/E2y6BR;;AwFl06BE;ETnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E416BF;AIxt6BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eq26BzG;A+Ez16BE;EAII,wHAAA;A/Ew16BN;A+Ej16BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsx6Bf;A+E/06BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ek36B7L;A+E106BI;EAGI,qFAAA;A/E006BR;;AwFj26BE;ETnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E236BF;AIvv6BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eo46BzG;A+Ex36BE;EAII,0HAAA;A/Eu36BN;A+Eh36BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqz6Bf;A+E926BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Ei56B7L;A+Ez26BI;EAGI,uFAAA;A/Ey26BR;;AwFh46BE;ETnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E056BF;AItx6BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Em66BzG;A+Ev56BE;EAII,uHAAA;A/Es56BN;A+E/46BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHo16Bf;A+E746BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Eg76B7L;A+Ex46BI;EAGI,oFAAA;A/Ew46BR;;AwFz56BE;ETzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey76BF;AIrz6BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Ek86BzG;A+Et76BE;EAII,0HAAA;A/Eq76BN;A+E966BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm36Bf;A+E566BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E+86B7L;A+Ev66BI;EAGI,uFAAA;A/Eu66BR;;AwFx76BE;ETzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ew96BF;AIp16BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ei+6BzG;A+Er96BE;EAII,wHAAA;A/Eo96BN;A+E786BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHk56Bf;A+E386BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E8+6B7L;A+Et86BI;EAGI,qFAAA;A/Es86BR;;AwFv96BE;ETzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu/6BF;AIn36BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Egg7BzG;A+Ep/6BE;EAII,yHAAA;A/Em/6BN;A+E5+6BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi76Bf;A+E1+6BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E6g7B7L;A+Er+6BI;EAGI,sFAAA;A/Eq+6BR;;AwFt/6BE;ETzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Esh7BF;AIl56BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E+h7BzG;A+Enh7BE;EAII,wHAAA;A/Ekh7BN;A+E3g7BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHg96Bf;A+Ezg7BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E4i7B7L;A+Epg7BI;EAGI,qFAAA;A/Eog7BR;;AwFrh7BE;ETzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eqj7BF;AIj76BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E8j7BzG;A+Elj7BE;EAII,yHAAA;A/Eij7BN;A+E1i7BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH++6Bf;A+Exi7BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E2k7B7L;A+Eni7BI;EAGI,sFAAA;A/Emi7BR;;AwFpj7BE;ETzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eol7BF;AIh96BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E6l7BzG;A+Ejl7BE;EAII,wHAAA;A/Egl7BN;A+Ezk7BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8g7Bf;A+Evk7BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E0m7B7L;A+Elk7BI;EAGI,qFAAA;A/Ekk7BR;;AwFnl7BE;ETzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Emn7BF;AI/+6BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E4n7BzG;A+Ehn7BE;EAII,0HAAA;A/E+m7BN;A+Exm7BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6i7Bf;A+Etm7BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Eyo7B7L;A+Ejm7BI;EAGI,uFAAA;A/Eim7BR;;AwFln7BE;ETzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ekp7BF;AI9g7BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E2p7BzG;A+E/o7BE;EAII,uHAAA;A/E8o7BN;A+Evo7BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4k7Bf;A+Ero7BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Ewq7B7L;A+Eho7BI;EAGI,oFAAA;A/Ego7BR;;AwF3o7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2l7Bf;A+Ezn7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgm7Bf;A+Exn7BE;EAEE,iDAAA;A/Eyn7BJ;A+Etn7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eun7BJ;A+Epn7BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4m7Bf;A+Eln7BI;EAGI,uFAAA;A/Ekn7BR;;AwFtq7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsn7Bf;A+Epp7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2n7Bf;A+Enp7BE;EAEE,+CAAA;A/Eop7BJ;A+Ejp7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ekp7BJ;A+E/o7BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuo7Bf;A+E7o7BI;EAGI,qFAAA;A/E6o7BR;;AwFjs7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHip7Bf;A+E/q7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHsp7Bf;A+E9q7BE;EAEE,gDAAA;A/E+q7BJ;A+E5q7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6q7BJ;A+E1q7BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkq7Bf;A+Exq7BI;EAGI,sFAAA;A/Ewq7BR;;AwF5t7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4q7Bf;A+E1s7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHir7Bf;A+Ezs7BE;EAEE,+CAAA;A/E0s7BJ;A+Evs7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ews7BJ;A+Ers7BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6r7Bf;A+Ens7BI;EAGI,qFAAA;A/Ems7BR;;AwFvv7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHus7Bf;A+Eru7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4s7Bf;A+Epu7BE;EAEE,gDAAA;A/Equ7BJ;A+Elu7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Emu7BJ;A+Ehu7BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwt7Bf;A+E9t7BI;EAGI,sFAAA;A/E8t7BR;;AwFlx7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHku7Bf;A+Ehw7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHuu7Bf;A+E/v7BE;EAEE,+CAAA;A/Egw7BJ;A+E7v7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8v7BJ;A+E3v7BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmv7Bf;A+Ezv7BI;EAGI,qFAAA;A/Eyv7BR;;AwF7y7BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6v7Bf;A+E3x7BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHkw7Bf;A+E1x7BE;EAEE,iDAAA;A/E2x7BJ;A+Exx7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eyx7BJ;A+Etx7BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8w7Bf;A+Epx7BI;EAGI,uFAAA;A/Eox7BR;;AwFx07BE;EToBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwx7Bf;A+Etz7BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6x7Bf;A+Erz7BE;EAEE,8CAAA;A/Esz7BJ;A+Enz7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eoz7BJ;A+Ejz7BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHyy7Bf;A+E/y7BI;EAGI,oFAAA;A/E+y7BR;;AwFz17BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmz7Bf;A+Ej17BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwz7Bf;A+Eh17BE;EAEE,iDAAA;A/Ei17BJ;A+E907BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+07BJ;A+E507BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo07Bf;A+E107BI;EAGI,uFAAA;A/E007BR;;AwFp37BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH807Bf;A+E527BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm17Bf;A+E327BE;EAEE,+CAAA;A/E427BJ;A+Ez27BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E027BJ;A+Ev27BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+17Bf;A+Er27BI;EAGI,qFAAA;A/Eq27BR;;AwF/47BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy27Bf;A+Ev47BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH827Bf;A+Et47BE;EAEE,gDAAA;A/Eu47BJ;A+Ep47BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq47BJ;A+El47BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH037Bf;A+Eh47BI;EAGI,sFAAA;A/Eg47BR;;AwF167BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo47Bf;A+El67BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy47Bf;A+Ej67BE;EAEE,+CAAA;A/Ek67BJ;A+E/57BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg67BJ;A+E757BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq57Bf;A+E357BI;EAGI,qFAAA;A/E257BR;;AwFr87BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+57Bf;A+E777BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHo67Bf;A+E577BE;EAEE,gDAAA;A/E677BJ;A+E177BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E277BJ;A+Ex77BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHg77Bf;A+Et77BI;EAGI,sFAAA;A/Es77BR;;AwFh+7BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH077Bf;A+Ex97BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+77Bf;A+Ev97BE;EAEE,+CAAA;A/Ew97BJ;A+Er97BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es97BJ;A+En97BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH287Bf;A+Ej97BI;EAGI,qFAAA;A/Ei97BR;;AwF3/7BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHq97Bf;A+En/7BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH097Bf;A+El/7BE;EAEE,iDAAA;A/Em/7BJ;A+Eh/7BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ei/7BJ;A+E9+7BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHs+7Bf;A+E5+7BI;EAGI,uFAAA;A/E4+7BR;;AwFth8BE;ETUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHg/7Bf;A+E9g8BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHq/7Bf;A+E7g8BE;EAEE,8CAAA;A/E8g8BJ;A+E3g8BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4g8BJ;A+Ezg8BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHig8Bf;A+Evg8BI;EAGI,oFAAA;A/Eug8BR;;AwFxi8BA;;EAEE,cAzDwB;EA0DxB,qBA1DwB;AxFqm8B1B;AwFzi8BE;;;;;;;;EAOE,WnF1DI;EmF2DJ,qBApEsB;EAqEtB,yBArEsB;AxFin8B1B;;AwFxi8BA;;EAEE,cA1EsB;EA2EtB,qBA3EsB;AxFsn8BxB;AwFzi8BE;;;;;;;;EAOE,WnF5EI;EmF6EJ,qBArFoB;EAsFpB,yBAtFoB;AxFko8BxB;;AwFti8BE;EAEE,cA/FsB;AxFuo8B1B;AwFvi8BI;EAEE,wDAAA;AxFwi8BN;AwFpi8BE;EACE,yBAAA;AxFsi8BJ;AwFni8BE;EACE,cA3GsB;AxFgp8B1B;AwFpi8BI;EAEE,cA9GoB;AxFmp8B1B;AwFji8BE;EAEE,oCAAA;EACA,sBAAA;AxFki8BJ;AwF/h8BE;EAIE,yBA5HsB;EA6HtB,qBA7HsB;EA8HtB,WnFrHI;ALmp8BR;AwF5h8BI;EAGE,8EAAA;EACA,0EAAA;EACA,sBAAA;AxF4h8BN;AwFvh8BI;EACE,oCAAA;AxFyh8BN;AwFth8BI;EACE,oCAAA;AxFwh8BN;AwFrh8BI;EACE,oCAAA;AxFuh8BN;AwFph8BI;EACE,oCAAA;AxFsh8BN;AwFnh8BI;EACE,oCAAA;AxFqh8BN;AwFlh8BI;EACE,oCAAA;AxFoh8BN;AwFjh8BI;EACE,oCAAA;AxFmh8BN;AwFhh8BI;EACE,oCAAA;AxFkh8BN;AwF/g8BI;EACE,oCAAA;AxFih8BN;AwF9g8BI;EACE,oCAAA;AxFgh8BN;AwF7g8BI;EACE,oCAAA;AxF+g8BN;AwF5g8BI;EACE,oCAAA;AxF8g8BN;;AwFvg8BE;EACE,cA9LoB;AxFws8BxB;AwFzg8BI;EAEE,6CAAA;AxF0g8BN;AwFtg8BE;EACE,yBAAA;AxFwg8BJ;AwFrg8BE;EAEE,oCAAA;EACA,sBAAA;AxFsg8BJ;AwFng8BE;EACE,yBAhNoB;EAiNpB,qBAjNoB;EAkNpB,WnF1MI;AL+s8BR;AwFng8BI;EAGE,2DAAA;EACA,uDAAA;EACA,sBAAA;AxFmg8BN;;AwF7/7BA;EACE,wCAAA;EACA,sBAAA;AxFgg8BF;AwF//7BE;EAGE,oCAAA;EACA,sBAAA;AxF+/7BJ;;AwF3/7BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AxF8/7BF;AwF5/7BE;EAEE,oDAAA;EACA,yBAAA;AxF6/7BJ;;AwFx/7BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AxF2/7BJ;AwFz/7BI;EAEE,sDAAA;EACA,sBAAA;AxF0/7BN;;AwFr/7BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AxFw/7BF;AwFt/7BE;EAEE,qDAAA;EACA,yBAAA;AxFu/7BJ;;AwFl/7BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AxFq/7BJ;AwFn/7BI;EAEE,sDAAA;EACA,sBAAA;AxFo/7BN;;AwF/+7BA;EACE,oCAAA;EACA,WnFxRM;EmFyRN,qBAlSwB;AxFox8B1B;AwFh/7BE;EACE,mEAAA;AxFk/7BJ;AwFh/7BI;EACE,WnF/RE;ALix8BR;AwF/+7BI;EACE,sBnFnSE;ALox8BR;AwF/+7BM;EACE,+BAAA;AxFi/7BR;AwF3+7BI;EADF;IAEI,sBnF7SE;EL2x8BN;EwF5+7BI;IACE,+BAAA;ExF8+7BN;AACF;AwF1+7BE;EACE,iCAAA;AxF4+7BJ;;AwFx+7BA;EACE,sBnF3TM;ALsy8BR;;AwFx+7BA;EACE,WnF/TM;AL0y8BR;;AwFv+7BA;EACE,yBAAA;AxF0+7BF;;AwFv+7BA;EACE;IACE,yBAAA;ExF0+7BF;EwFv+7BA;IACE,wBAAA;ExFy+7BF;AACF;AwFt+7BA;EACE,wBAAA;AxFw+7BF;;AwFr+7BA;EACE;IACE,wBAAA;ExFw+7BF;AACF;AwFp+7BA;EACE,yBAtWwB;AxF408B1B;;AwFj+7BA;EACE,qBAAA;EACA,0CAxWsB;AxF408BxB;;AwFj+7BA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AxFo+7BF;AwFl+7BE;EACE,0CAjXoB;EAkXpB,kBAAA;EACA,UAAA;AxFo+7BJ;AwFj+7BE;EACE,qBAAA;AxFm+7BJ;AwF/97BI;EACE,WnFxXE;ALy18BR;;AwF597BA;EACE,cAnYyB;AxFk28B3B;;AwF397BE;EACE,cAxYuB;AxFs28B3B;;AwF197BA;;;EAGE,0CA9YsB;EA+YtB,WnF3YM;ALw28BR;;AwF197BA;EACE,qBAxZwB;AxFq38B1B;;AwF197BA;;EAEE,WnFpZM;ALi38BR;;AwF197BA;EACE,0CA5ZsB;AxFy38BxB;;AwF197BA;EACE,cAjayB;AxF838B3B;;AwF197BA;;;EAGE,WnFlaM;AL+38BR;;AwF197BA;EACE,cA3ayB;AxFw48B3B;;AwF197BA;EACE,yBAnbwB;AxFg58B1B;;AwF197BA;;;;;EAKE,0CAtbsB;EAubtB,WnFnbM;ALg58BR;;AwF197BA,2BAAA;AAGI;EAEE,cApcoB;AxF858B1B;AwFv97BI;EACE,WrF9Ye;AHu28BrB;AwFt97BI;EAEE,cA7coB;AxFo68B1B;AwFn97BE;EACE,WnFzcI;AL858BR;AwFl97BE;EAKE,cAzdoB;AxFy68BxB;AwF587BI;EAEE,cAheoB;AxF668B1B;AwFx87BI;EACE,WrF5ae;AHs38BrB;AwFr87BM;EACE,cA5ekB;AxFm78B1B;AwFn87BI;EAGE,cAnfoB;AxFs78B1B;;AwF977BA;EACE,oCAAA;EACA,qBAvfoB;AxFw78BtB;AwF/77BI;EACE,WnFpfE;ALq78BR;AwF977BI;EAKE,cApgBkB;AxFg88BxB;;AwFp77BI;EACE,cA9gBoB;AxFq88B1B;;AwFj77BA;EACE,yBArhBwB;AxFy88B1B;;AwFj77BA;EACE,mEAAA;AxFo77BF;;AwFj77BA;EACE,wCAAA;AxFo77BF;;AwFj77BA;;EAEE,wCAAA;EACA,qBAniBwB;AxFu98B1B;;AwFj77BA;;;;EAIE,wCAAA;EACA,qBA3iBwB;AxF+98B1B;;AwFj77BA;EACE,wCAAA;EACA,qBAhjBwB;AxFo+8B1B;;AwFj77BA;EACE,wCAAA;EACA,qBArjBwB;AxFy+8B1B;;AwFj77BA;EACE,qBAzjBwB;AxF6+8B1B;;AwFh77BA;EACE,cA9jBwB;AxFi/8B1B;;AwF/67BE;EAEE,qEAAA;AxFi77BJ;;AwF367BE;EACE,cA3kBsB;AxFy/8B1B;;AwFz67BA;EACE,mBAjlBwB;AxF6/8B1B;;AwFx67BE;EAGE,cAxlBsB;AxFig9B1B;;AwFl67BE;EACE,qBAhmBsB;AxFqg9B1B;;AwF/57BE;EACE,qBAvmBsB;AxFyg9B1B;AwFh67BI;EAGE,yBA5mBoB;AxF4g9B1B;;AwFz57BE;EACE,cApnBsB;AxFgh9B1B;;AwFv57BE;EAGE,cA3nBoB;AxFmh9BxB;;AwFn57BA;EACE,cAjoBsB;AxFuh9BxB;;AwFn57BA;EACE,0CAAA;AxFs57BF;;AwFj57BA;EACE,gCAAA;AxFo57BF;;AwF/47BA;EACE,yBAlpBwB;AxFoi9B1B;;AwF947BE;EACE,yBAAA;EACA,cAxpBsB;AxFyi9B1B;AwF/47BI;EAEE,WnFnpBE;EmFopBF,yBA7pBoB;AxF6i9B1B;;AwFv47BI;;;;EACE,yBAvqBoB;EAwqBpB,qBAxqBoB;AxFqj9B1B;AwFx47BE;;EACE,yBAAA;AxF247BJ;AwF147BI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AxF647BN;AwF347BM;;;EAEE,oDAAA;EACA,yBAAA;AxF847BR;;AwFv47BE;EACE,yBA/rBsB;EAgsBtB,qBAhsBsB;AxF0k9B1B;;AwFt47BA;EACE,mBArsBwB;AxF8k9B1B;;AwFt47BA;;EAEE,cA1sBwB;AxFml9B1B;;AwFt47BA,4BAAA;AACA,4DAAA,wBAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,mDAAA,gBAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,uDAAA,WAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,kDAAA,gBAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,uEAAA,wBAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,8DAAA,gBAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,kEAAA,WAAA;EACE,+BAAA;AxFy47BF;;AwFt47BA,6DAAA,gBAAA;EACE,+BAAA;AxFy47BF;;AyFrn9BA,yBAAA;AAcA;EACE,cAdsB;AzFyn9BxB;AyF1m9BE;EACE,cAhBoB;AzF4n9BxB;;AyFpm9BE;EVnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8n9BF;AI1/8BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Euo9BzG;A+E3n9BE;EAII,0HAAA;A/E0n9BN;A+Enn9BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwj9Bf;A+Ejn9BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Eop9B7L;A+E5m9BI;EAGI,uFAAA;A/E4m9BR;;AyFno9BE;EVnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6p9BF;AIzh9BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Esq9BzG;A+E1p9BE;EAII,wHAAA;A/Eyp9BN;A+Elp9BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHul9Bf;A+Ehp9BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Emr9B7L;A+E3o9BI;EAGI,qFAAA;A/E2o9BR;;AyFlq9BE;EVnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4r9BF;AIxj9BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Eqs9BzG;A+Ezr9BE;EAII,yHAAA;A/Ewr9BN;A+Ejr9BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsn9Bf;A+E/q9BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Ekt9B7L;A+E1q9BI;EAGI,sFAAA;A/E0q9BR;;AyFjs9BE;EVnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2t9BF;AIvl9BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Eou9BzG;A+Ext9BE;EAII,wHAAA;A/Eut9BN;A+Eht9BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqp9Bf;A+E9s9BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Eiv9B7L;A+Ezs9BI;EAGI,qFAAA;A/Eys9BR;;AyFhu9BE;EVnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0v9BF;AItn9BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Emw9BzG;A+Evv9BE;EAII,yHAAA;A/Esv9BN;A+E/u9BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHor9Bf;A+E7u9BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Egx9B7L;A+Exu9BI;EAGI,sFAAA;A/Ewu9BR;;AyF/v9BE;EVnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eyx9BF;AIrp9BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eky9BzG;A+Etx9BE;EAII,wHAAA;A/Eqx9BN;A+E9w9BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmt9Bf;A+E5w9BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E+y9B7L;A+Evw9BI;EAGI,qFAAA;A/Euw9BR;;AyF9x9BE;EVnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ewz9BF;AIpr9BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Ei09BzG;A+Erz9BE;EAII,0HAAA;A/Eoz9BN;A+E7y9BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkv9Bf;A+E3y9BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E809B7L;A+Ety9BI;EAGI,uFAAA;A/Esy9BR;;AyF7z9BE;EVnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu19BF;AInt9BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Eg29BzG;A+Ep19BE;EAII,uHAAA;A/Em19BN;A+E509BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHix9Bf;A+E109BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E629B7L;A+Er09BI;EAGI,oFAAA;A/Eq09BR;;AyFt19BE;EVzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es39BF;AIlv9BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E+39BzG;A+En39BE;EAII,0HAAA;A/Ek39BN;A+E329BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgz9Bf;A+Ez29BE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E449B7L;A+Ep29BI;EAGI,uFAAA;A/Eo29BR;;AyFr39BE;EVzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq59BF;AIjx9BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E859BzG;A+El59BE;EAII,wHAAA;A/Ei59BN;A+E149BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+09Bf;A+Ex49BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E269B7L;A+En49BI;EAGI,qFAAA;A/Em49BR;;AyFp59BE;EVzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo79BF;AIhz9BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E679BzG;A+Ej79BE;EAII,yHAAA;A/Eg79BN;A+Ez69BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH829Bf;A+Ev69BE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E089B7L;A+El69BI;EAGI,sFAAA;A/Ek69BR;;AyFn79BE;EVzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em99BF;AI/09BE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E499BzG;A+Eh99BE;EAII,wHAAA;A/E+89BN;A+Ex89BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH649Bf;A+Et89BE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Ey+9B7L;A+Ej89BI;EAGI,qFAAA;A/Ei89BR;;AyFl99BE;EVzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ek/9BF;AI929BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E2/9BzG;A+E/+9BE;EAII,yHAAA;A/E8+9BN;A+Ev+9BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH469Bf;A+Er+9BE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Ewg+B7L;A+Eh+9BI;EAGI,sFAAA;A/Eg+9BR;;AyFj/9BE;EVzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eih+BF;AI749BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E0h+BzG;A+E9g+BE;EAII,wHAAA;A/E6g+BN;A+Etg+BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH289Bf;A+Epg+BE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eui+B7L;A+E//9BI;EAGI,qFAAA;A/E+/9BR;;AyFhh+BE;EVzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Egj+BF;AI569BE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eyj+BzG;A+E7i+BE;EAII,0HAAA;A/E4i+BN;A+Eri+BE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0+9Bf;A+Eni+BE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Esk+B7L;A+E9h+BI;EAGI,uFAAA;A/E8h+BR;;AyF/i+BE;EVzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+k+BF;AI389BE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Ewl+BzG;A+E5k+BE;EAII,uHAAA;A/E2k+BN;A+Epk+BE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyg+Bf;A+Elk+BE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Eqm+B7L;A+E7j+BI;EAGI,oFAAA;A/E6j+BR;;AyFxk+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwh+Bf;A+Etj+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6h+Bf;A+Erj+BE;EAEE,iDAAA;A/Esj+BJ;A+Enj+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eoj+BJ;A+Ejj+BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHyi+Bf;A+E/i+BI;EAGI,uFAAA;A/E+i+BR;;AyFnm+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmj+Bf;A+Ejl+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwj+Bf;A+Ehl+BE;EAEE,+CAAA;A/Eil+BJ;A+E9k+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+k+BJ;A+E5k+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHok+Bf;A+E1k+BI;EAGI,qFAAA;A/E0k+BR;;AyF9n+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8k+Bf;A+E5m+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHml+Bf;A+E3m+BE;EAEE,gDAAA;A/E4m+BJ;A+Ezm+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0m+BJ;A+Evm+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+l+Bf;A+Erm+BI;EAGI,sFAAA;A/Eqm+BR;;AyFzp+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHym+Bf;A+Evo+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8m+Bf;A+Eto+BE;EAEE,+CAAA;A/Euo+BJ;A+Epo+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eqo+BJ;A+Elo+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0n+Bf;A+Eho+BI;EAGI,qFAAA;A/Ego+BR;;AyFpr+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHoo+Bf;A+Elq+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHyo+Bf;A+Ejq+BE;EAEE,gDAAA;A/Ekq+BJ;A+E/p+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Egq+BJ;A+E7p+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqp+Bf;A+E3p+BI;EAGI,sFAAA;A/E2p+BR;;AyF/s+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+p+Bf;A+E7r+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHoq+Bf;A+E5r+BE;EAEE,+CAAA;A/E6r+BJ;A+E1r+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2r+BJ;A+Exr+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgr+Bf;A+Etr+BI;EAGI,qFAAA;A/Esr+BR;;AyF1u+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0r+Bf;A+Ext+BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH+r+Bf;A+Evt+BE;EAEE,iDAAA;A/Ewt+BJ;A+Ert+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Est+BJ;A+Ent+BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2s+Bf;A+Ejt+BI;EAGI,uFAAA;A/Eit+BR;;AyFrw+BE;EVoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqt+Bf;A+Env+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0t+Bf;A+Elv+BE;EAEE,8CAAA;A/Emv+BJ;A+Ehv+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eiv+BJ;A+E9u+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHsu+Bf;A+E5u+BI;EAGI,oFAAA;A/E4u+BR;;AyFtx+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgv+Bf;A+E9w+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqv+Bf;A+E7w+BE;EAEE,iDAAA;A/E8w+BJ;A+E3w+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4w+BJ;A+Ezw+BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHiw+Bf;A+Evw+BI;EAGI,uFAAA;A/Euw+BR;;AyFjz+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2w+Bf;A+Ezy+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgx+Bf;A+Exy+BE;EAEE,+CAAA;A/Eyy+BJ;A+Ety+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Euy+BJ;A+Epy+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4x+Bf;A+Ely+BI;EAGI,qFAAA;A/Eky+BR;;AyF50+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsy+Bf;A+Ep0+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2y+Bf;A+En0+BE;EAEE,gDAAA;A/Eo0+BJ;A+Ej0+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ek0+BJ;A+E/z+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuz+Bf;A+E7z+BI;EAGI,sFAAA;A/E6z+BR;;AyFv2+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHi0+Bf;A+E/1+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHs0+Bf;A+E91+BE;EAEE,+CAAA;A/E+1+BJ;A+E51+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E61+BJ;A+E11+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHk1+Bf;A+Ex1+BI;EAGI,qFAAA;A/Ew1+BR;;AyFl4+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH41+Bf;A+E13+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHi2+Bf;A+Ez3+BE;EAEE,gDAAA;A/E03+BJ;A+Ev3+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ew3+BJ;A+Er3+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH62+Bf;A+En3+BI;EAGI,sFAAA;A/Em3+BR;;AyF75+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHu3+Bf;A+Er5+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH43+Bf;A+Ep5+BE;EAEE,+CAAA;A/Eq5+BJ;A+El5+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em5+BJ;A+Eh5+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHw4+Bf;A+E94+BI;EAGI,qFAAA;A/E84+BR;;AyFx7+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk5+Bf;A+Eh7+BE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHu5+Bf;A+E/6+BE;EAEE,iDAAA;A/Eg7+BJ;A+E76+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E86+BJ;A+E36+BE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm6+Bf;A+Ez6+BI;EAGI,uFAAA;A/Ey6+BR;;AyFn9+BE;EVUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH66+Bf;A+E38+BE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk7+Bf;A+E18+BE;EAEE,8CAAA;A/E28+BJ;A+Ex8+BE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey8+BJ;A+Et8+BE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH87+Bf;A+Ep8+BI;EAGI,oFAAA;A/Eo8+BR;;AyFr++BA;;EAEE,cAzDsB;EA0DtB,qBA1DsB;AzFki/BxB;AyFt++BE;;;;;;;;EAOE,WpF1DI;EoF2DJ,qBApEoB;EAqEpB,yBArEoB;AzF8i/BxB;;AyFr++BA;;EAEE,cA1EoB;EA2EpB,qBA3EoB;AzFmj/BtB;AyFt++BE;;;;;;;;EAOE,WpF5EI;EoF6EJ,qBArFkB;EAsFlB,yBAtFkB;AzF+j/BtB;;AyFl++BE;EAEE,cAhGoB;AzFok/BxB;AyFn++BI;EAEE,kCAAA;AzFo++BN;AyFh++BE;EACE,yBAAA;AzFk++BJ;AyF/9+BE;EACE,cA5GoB;AzF6k/BxB;AyFh++BI;EAEE,cA/GkB;AzFgl/BxB;AyF79+BE;EAEE,oCAAA;EACA,sBAAA;AzF89+BJ;AyF39+BE;EAIE,yBA7HoB;EA8HpB,qBA9HoB;EA+HpB,WpFtHI;ALgl/BR;AyFx9+BI;EAGE,0DAAA;EACA,sDAAA;EACA,sBAAA;AzFw9+BN;AyFn9+BI;EACE,oCAAA;AzFq9+BN;AyFl9+BI;EACE,oCAAA;AzFo9+BN;AyFj9+BI;EACE,oCAAA;AzFm9+BN;AyFh9+BI;EACE,oCAAA;AzFk9+BN;AyF/8+BI;EACE,oCAAA;AzFi9+BN;AyF98+BI;EACE,oCAAA;AzFg9+BN;AyF78+BI;EACE,oCAAA;AzF+8+BN;AyF58+BI;EACE,oCAAA;AzF88+BN;AyF38+BI;EACE,oCAAA;AzF68+BN;AyF18+BI;EACE,oCAAA;AzF48+BN;AyFz8+BI;EACE,oCAAA;AzF28+BN;AyFx8+BI;EACE,oCAAA;AzF08+BN;;AyFl8+BE;EACE,cAhMkB;AzFqo/BtB;AyFp8+BI;EAEE,oEAAA;AzFq8+BN;AyFj8+BE;EACE,yBAAA;AzFm8+BJ;AyFh8+BE;EAEE,oCAAA;EACA,sBAAA;AzFi8+BJ;AyF97+BE;EACE,yBAlNkB;EAmNlB,qBAnNkB;EAoNlB,WpF5MI;AL4o/BR;AyF97+BI;EAGE,+EAAA;EACA,2EAAA;EACA,sBAAA;AzF87+BN;;AyFx7+BA;EACE,wCAAA;EACA,sBAAA;AzF27+BF;AyF17+BE;EAGE,oCAAA;EACA,sBAAA;AzF07+BJ;;AyFt7+BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AzFy7+BF;AyFv7+BE;EAEE,oDAAA;EACA,yBAAA;AzFw7+BJ;;AyFn7+BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AzFs7+BJ;AyFp7+BI;EAEE,sDAAA;EACA,sBAAA;AzFq7+BN;;AyFh7+BA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AzFm7+BF;AyFj7+BE;EAEE,sDAAA;EACA,yBAAA;AzFk7+BJ;;AyF76+BE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AzFg7+BJ;AyF96+BI;EAEE,sDAAA;EACA,sBAAA;AzF+6+BN;;AyF16+BA;EACE,oCAAA;EACA,WpF1RM;EoF2RN,qBApSsB;AzFit/BxB;AyF36+BE;EACE,+CAAA;AzF66+BJ;AyF36+BI;EACE,WpFjSE;AL8s/BR;AyF16+BI;EACE,sBpFrSE;ALit/BR;AyF16+BM;EACE,+BAAA;AzF46+BR;AyFt6+BI;EADF;IAEI,sBpF/SE;ELwt/BN;EyFv6+BI;IACE,+BAAA;EzFy6+BN;AACF;AyFr6+BE;EACE,iCAAA;AzFu6+BJ;;AyFn6+BA;EACE,sBpF7TM;ALmu/BR;;AyFn6+BA;EACE,WpFjUM;ALuu/BR;;AyFl6+BA;EACE,yBAAA;AzFq6+BF;;AyFl6+BA;EACE;IACE,yBAAA;EzFq6+BF;EyFl6+BA;IACE,wBAAA;EzFo6+BF;AACF;AyFj6+BA;EACE,wBAAA;AzFm6+BF;;AyFh6+BA;EACE;IACE,wBAAA;EzFm6+BF;AACF;AyF/5+BA;EACE,yBAxWsB;AzFyw/BxB;;AyF55+BA;EACE,qBAAA;EACA,0CA1WoB;AzFyw/BtB;;AyF55+BA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AzF+5+BF;AyF75+BE;EACE,0CAnXkB;EAoXlB,kBAAA;EACA,UAAA;AzF+5+BJ;AyF55+BE;EACE,qBAAA;AzF85+BJ;AyF15+BI;EACE,WpF1XE;ALsx/BR;;AyFv5+BA;EACE,cArYuB;AzF+x/BzB;;AyFt5+BE;EACE,cA1YqB;AzFmy/BzB;;AyFr5+BA;;;EAGE,0CAhZoB;EAiZpB,WpF7YM;ALqy/BR;;AyFr5+BA;EACE,qBA1ZsB;AzFkz/BxB;;AyFr5+BA;;EAEE,WpFtZM;AL8y/BR;;AyFr5+BA;EACE,0CA9ZoB;AzFsz/BtB;;AyFr5+BA;EACE,cAnauB;AzF2z/BzB;;AyFr5+BA;;;EAGE,WpFpaM;AL4z/BR;;AyFr5+BA;EACE,cA7auB;AzFq0/BzB;;AyFr5+BA;EACE,yBArbsB;AzF60/BxB;;AyFr5+BA;;;;;EAKE,0CAxboB;EAybpB,WpFrbM;AL60/BR;;AyFr5+BA,2BAAA;AAGI;EAEE,cAtckB;AzF21/BxB;AyFl5+BI;EACE,WtFhZe;AHoy/BrB;AyFj5+BI;EAEE,cA/ckB;AzFi2/BxB;AyF94+BE;EACE,WpF3cI;AL21/BR;AyF74+BE;EAKE,cA3dkB;AzFs2/BtB;AyFv4+BI;EAEE,cAlekB;AzF02/BxB;AyFn4+BI;EACE,WtF9ae;AHmz/BrB;AyFh4+BM;EACE,cA9egB;AzFg3/BxB;AyF93+BI;EAGE,cArfkB;AzFm3/BxB;;AyFz3+BA;EACE,oCAAA;EACA,qBAzfkB;AzFq3/BpB;AyF13+BI;EACE,WpFtfE;ALk3/BR;AyFz3+BI;EAKE,cAtgBgB;AzF63/BtB;;AyF/2+BI;EACE,qBAhhBkB;AzFk4/BxB;;AyF52+BA;EACE,yBAvhBsB;AzFs4/BxB;;AyF52+BA;EACE,6CAAA;AzF+2+BF;;AyF52+BA;EACE,wCAAA;AzF+2+BF;;AyF52+BA;;EAEE,wCAAA;EACA,qBAriBsB;AzFo5/BxB;;AyF52+BA;;;;EAIE,wCAAA;EACA,qBA7iBsB;AzF45/BxB;;AyF52+BA;EACE,wCAAA;EACA,qBAljBsB;AzFi6/BxB;;AyF52+BA;EACE,wCAAA;EACA,qBAvjBsB;AzFs6/BxB;;AyF52+BA;EACE,qBA3jBsB;AzF06/BxB;;AyF32+BA;EACE,cAhkBsB;AzF86/BxB;;AyF12+BE;EAEE,iDAAA;AzF42+BJ;;AyFt2+BE;EACE,cA7kBoB;AzFs7/BxB;;AyFp2+BA;EACE,mBAnlBsB;AzF07/BxB;;AyFn2+BE;EAGE,cA1lBoB;AzF87/BxB;;AyF91+BE;EACE,qBAjmBoB;AzFk8/BxB;;AyF31+BE;EACE,qBAxmBoB;AzFs8/BxB;AyF51+BI;EAGE,yBA7mBkB;AzFy8/BxB;;AyFr1+BE;EACE,cArnBoB;AzF68/BxB;;AyFn1+BE;EAGE,cA5nBkB;AzFg9/BtB;;AyF/0+BA;EACE,cAloBoB;AzFo9/BtB;;AyF/0+BA;EACE,0CAAA;AzFk1+BF;;AyF70+BA;EACE,gCAAA;AzFg1+BF;;AyF30+BA;EACE,yBAnpBsB;AzFi+/BxB;;AyF10+BE;EACE,yBAAA;EACA,cAzpBoB;AzFs+/BxB;AyF30+BI;EAEE,WpFppBE;EoFqpBF,yBA9pBkB;AzF0+/BxB;;AyFn0+BI;;;;EACE,yBAxqBkB;EAyqBlB,qBAzqBkB;AzFk//BxB;AyFp0+BE;;EACE,yBAAA;AzFu0+BJ;AyFt0+BI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;AzFy0+BN;AyFv0+BM;;;EAEE,oDAAA;EACA,yBAAA;AzF00+BR;;AyFn0+BE;EACE,yBAhsBoB;EAisBpB,qBAjsBoB;AzFuggCxB;;AyFl0+BA;;EAEE,cAvsBsB;AzF4ggCxB;;AyFl0+BA,4BAAA;AACA,0DAAA,wBAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,iDAAA,gBAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,qDAAA,WAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,gDAAA,gBAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,qEAAA,wBAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,4DAAA,gBAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,gEAAA,WAAA;EACE,+BAAA;AzFq0+BF;;AyFl0+BA,2DAAA,gBAAA;EACE,+BAAA;AzFq0+BF;;A0F9igCA,0BAAA;AAcA;EACE,cAduB;A1FkjgCzB;A0FnigCE;EACE,cAhBqB;A1FqjgCzB;;A0F7hgCE;EXnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EujgCF;AIn7/BE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EgkgCzG;A+EpjgCE;EAII,0HAAA;A/EmjgCN;A+E5igCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi//Bf;A+E1igCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E6kgC7L;A+ErigCI;EAGI,uFAAA;A/EqigCR;;A0F5jgCE;EXnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EslgCF;AIl9/BE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E+lgCzG;A+EnlgCE;EAII,wHAAA;A/EklgCN;A+E3kgCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHghgCf;A+EzkgCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E4mgC7L;A+EpkgCI;EAGI,qFAAA;A/EokgCR;;A0F3lgCE;EXnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqngCF;AIj//BE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E8ngCzG;A+ElngCE;EAII,yHAAA;A/EingCN;A+E1mgCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+igCf;A+ExmgCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E2ogC7L;A+EnmgCI;EAGI,sFAAA;A/EmmgCR;;A0F1ngCE;EXnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EopgCF;AIhhgCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E6pgCzG;A+EjpgCE;EAII,wHAAA;A/EgpgCN;A+EzogCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8kgCf;A+EvogCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E0qgC7L;A+ElogCI;EAGI,qFAAA;A/EkogCR;;A0FzpgCE;EXnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmrgCF;AI/igCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E4rgCzG;A+EhrgCE;EAII,yHAAA;A/E+qgCN;A+ExqgCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6mgCf;A+EtqgCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EysgC7L;A+EjqgCI;EAGI,sFAAA;A/EiqgCR;;A0FxrgCE;EXnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EktgCF;AI9kgCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E2tgCzG;A+E/sgCE;EAII,wHAAA;A/E8sgCN;A+EvsgCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4ogCf;A+ErsgCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EwugC7L;A+EhsgCI;EAGI,qFAAA;A/EgsgCR;;A0FvtgCE;EXnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EivgCF;AI7mgCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E0vgCzG;A+E9ugCE;EAII,0HAAA;A/E6ugCN;A+EtugCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2qgCf;A+EpugCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EuwgC7L;A+E/tgCI;EAGI,uFAAA;A/E+tgCR;;A0FtvgCE;EXnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgxgCF;AI5ogCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EyxgCzG;A+E7wgCE;EAII,uHAAA;A/E4wgCN;A+ErwgCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0sgCf;A+EnwgCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EsygC7L;A+E9vgCI;EAGI,oFAAA;A/E8vgCR;;A0F/wgCE;EXzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+ygCF;AI3qgCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EwzgCzG;A+E5ygCE;EAII,0HAAA;A/E2ygCN;A+EpygCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyugCf;A+ElygCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Eq0gC7L;A+E7xgCI;EAGI,uFAAA;A/E6xgCR;;A0F9ygCE;EXzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E80gCF;AI1sgCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eu1gCzG;A+E30gCE;EAII,wHAAA;A/E00gCN;A+En0gCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwwgCf;A+Ej0gCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eo2gC7L;A+E5zgCI;EAGI,qFAAA;A/E4zgCR;;A0F70gCE;EXzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E62gCF;AIzugCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Es3gCzG;A+E12gCE;EAII,yHAAA;A/Ey2gCN;A+El2gCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuygCf;A+Eh2gCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Em4gC7L;A+E31gCI;EAGI,sFAAA;A/E21gCR;;A0F52gCE;EXzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E44gCF;AIxwgCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Eq5gCzG;A+Ez4gCE;EAII,wHAAA;A/Ew4gCN;A+Ej4gCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHs0gCf;A+E/3gCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Ek6gC7L;A+E13gCI;EAGI,qFAAA;A/E03gCR;;A0F34gCE;EXzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E26gCF;AIvygCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Eo7gCzG;A+Ex6gCE;EAII,yHAAA;A/Eu6gCN;A+Eh6gCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHq2gCf;A+E95gCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Ei8gC7L;A+Ez5gCI;EAGI,sFAAA;A/Ey5gCR;;A0F16gCE;EXzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E08gCF;AIt0gCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Em9gCzG;A+Ev8gCE;EAII,wHAAA;A/Es8gCN;A+E/7gCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHo4gCf;A+E77gCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eg+gC7L;A+Ex7gCI;EAGI,qFAAA;A/Ew7gCR;;A0Fz8gCE;EXzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey+gCF;AIr2gCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Ek/gCzG;A+Et+gCE;EAII,0HAAA;A/Eq+gCN;A+E99gCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm6gCf;A+E59gCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E+/gC7L;A+Ev9gCI;EAGI,uFAAA;A/Eu9gCR;;A0Fx+gCE;EXzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwghCF;AIp4gCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EihhCzG;A+ErghCE;EAII,uHAAA;A/EoghCN;A+E7/gCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHk8gCf;A+E3/gCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E8hhC7L;A+Et/gCI;EAGI,oFAAA;A/Es/gCR;;A0FjghCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHi9gCf;A+E/+gCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHs9gCf;A+E9+gCE;EAEE,iDAAA;A/E++gCJ;A+E5+gCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6+gCJ;A+E1+gCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHk+gCf;A+Ex+gCI;EAGI,uFAAA;A/Ew+gCR;;A0F5hhCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4+gCf;A+E1ghCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHi/gCf;A+EzghCE;EAEE,+CAAA;A/E0ghCJ;A+EvghCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwghCJ;A+ErghCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6/gCf;A+EnghCI;EAGI,qFAAA;A/EmghCR;;A0FvjhCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHughCf;A+ErihCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4ghCf;A+EpihCE;EAEE,gDAAA;A/EqihCJ;A+ElihCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmihCJ;A+EhihCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwhhCf;A+E9hhCI;EAGI,sFAAA;A/E8hhCR;;A0FllhCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkihCf;A+EhkhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHuihCf;A+E/jhCE;EAEE,+CAAA;A/EgkhCJ;A+E7jhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8jhCJ;A+E3jhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmjhCf;A+EzjhCI;EAGI,qFAAA;A/EyjhCR;;A0F7mhCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6jhCf;A+E3lhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHkkhCf;A+E1lhCE;EAEE,gDAAA;A/E2lhCJ;A+ExlhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EylhCJ;A+EtlhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8khCf;A+EplhCI;EAGI,sFAAA;A/EolhCR;;A0FxohCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwlhCf;A+EtnhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6lhCf;A+ErnhCE;EAEE,+CAAA;A/EsnhCJ;A+EnnhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EonhCJ;A+EjnhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHymhCf;A+E/mhCI;EAGI,qFAAA;A/E+mhCR;;A0FnqhCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmnhCf;A+EjphCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHwnhCf;A+EhphCE;EAEE,iDAAA;A/EiphCJ;A+E9ohCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+ohCJ;A+E5ohCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHoohCf;A+E1ohCI;EAGI,uFAAA;A/E0ohCR;;A0F9rhCE;EXoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8ohCf;A+E5qhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmphCf;A+E3qhCE;EAEE,8CAAA;A/E4qhCJ;A+EzqhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0qhCJ;A+EvqhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+phCf;A+ErqhCI;EAGI,oFAAA;A/EqqhCR;;A0F/shCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHyqhCf;A+EvshCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8qhCf;A+EtshCE;EAEE,iDAAA;A/EushCJ;A+EpshCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqshCJ;A+ElshCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0rhCf;A+EhshCI;EAGI,uFAAA;A/EgshCR;;A0F1uhCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHoshCf;A+EluhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHyshCf;A+EjuhCE;EAEE,+CAAA;A/EkuhCJ;A+E/thCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EguhCJ;A+E7thCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqthCf;A+E3thCI;EAGI,qFAAA;A/E2thCR;;A0FrwhCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+thCf;A+E7vhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHouhCf;A+E5vhCE;EAEE,gDAAA;A/E6vhCJ;A+E1vhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2vhCJ;A+ExvhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgvhCf;A+EtvhCI;EAGI,sFAAA;A/EsvhCR;;A0FhyhCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0vhCf;A+ExxhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+vhCf;A+EvxhCE;EAEE,+CAAA;A/EwxhCJ;A+ErxhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EsxhCJ;A+EnxhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2whCf;A+EjxhCI;EAGI,qFAAA;A/EixhCR;;A0F3zhCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqxhCf;A+EnzhCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0xhCf;A+ElzhCE;EAEE,gDAAA;A/EmzhCJ;A+EhzhCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EizhCJ;A+E9yhCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHsyhCf;A+E5yhCI;EAGI,sFAAA;A/E4yhCR;;A0Ft1hCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgzhCf;A+E90hCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqzhCf;A+E70hCE;EAEE,+CAAA;A/E80hCJ;A+E30hCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E40hCJ;A+Ez0hCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHi0hCf;A+Ev0hCI;EAGI,qFAAA;A/Eu0hCR;;A0Fj3hCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH20hCf;A+Ez2hCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHg1hCf;A+Ex2hCE;EAEE,iDAAA;A/Ey2hCJ;A+Et2hCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eu2hCJ;A+Ep2hCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH41hCf;A+El2hCI;EAGI,uFAAA;A/Ek2hCR;;A0F54hCE;EXUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHs2hCf;A+Ep4hCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH22hCf;A+En4hCE;EAEE,8CAAA;A/Eo4hCJ;A+Ej4hCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ek4hCJ;A+E/3hCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHu3hCf;A+E73hCI;EAGI,oFAAA;A/E63hCR;;A0F95hCA;;EAEE,cAzDuB;EA0DvB,qBA1DuB;A1F29hCzB;A0F/5hCE;;;;;;;;EAOE,WrF1DI;EqF2DJ,qBApEqB;EAqErB,yBArEqB;A1Fu+hCzB;;A0F95hCA;;EAEE,cA1EqB;EA2ErB,qBA3EqB;A1F4+hCvB;A0F/5hCE;;;;;;;;EAOE,WrF5EI;EqF6EJ,qBArFmB;EAsFnB,yBAtFmB;A1Fw/hCvB;;A0F35hCE;EAEE,cAhGqB;A1F6/hCzB;A0F55hCI;EAEE,0BAAA;A1F65hCN;A0Fz5hCE;EACE,yBAAA;A1F25hCJ;A0Fx5hCE;EACE,cA5GqB;A1FsgiCzB;A0Fz5hCI;EAEE,cA/GmB;A1FygiCzB;A0Ft5hCE;EAEE,oCAAA;EACA,sBAAA;A1Fu5hCJ;A0Fp5hCE;EAIE,yBA7HqB;EA8HrB,qBA9HqB;EA+HrB,WrFtHI;ALygiCR;A0Fj5hCI;EAGE,mDAAA;EACA,+CAAA;EACA,sBAAA;A1Fi5hCN;A0F54hCI;EACE,oCAAA;A1F84hCN;A0F34hCI;EACE,oCAAA;A1F64hCN;A0F14hCI;EACE,oCAAA;A1F44hCN;A0Fz4hCI;EACE,oCAAA;A1F24hCN;A0Fx4hCI;EACE,oCAAA;A1F04hCN;A0Fv4hCI;EACE,oCAAA;A1Fy4hCN;A0Ft4hCI;EACE,oCAAA;A1Fw4hCN;A0Fr4hCI;EACE,oCAAA;A1Fu4hCN;A0Fp4hCI;EACE,oCAAA;A1Fs4hCN;A0Fn4hCI;EACE,oCAAA;A1Fq4hCN;A0Fl4hCI;EACE,oCAAA;A1Fo4hCN;A0Fj4hCI;EACE,oCAAA;A1Fm4hCN;;A0F53hCE;EACE,cA/LmB;A1F8jiCvB;A0F93hCI;EAEE,mCAAA;A1F+3hCN;A0F33hCE;EACE,yBAAA;A1F63hCJ;A0F13hCE;EAEE,oCAAA;EACA,sBAAA;A1F23hCJ;A0Fx3hCE;EACE,yBAjNmB;EAkNnB,qBAlNmB;EAmNnB,WrF3MI;ALqkiCR;A0Fx3hCI;EAGE,gDAAA;EACA,4CAAA;EACA,sBAAA;A1Fw3hCN;;A0Fl3hCA;EACE,wCAAA;EACA,sBAAA;A1Fq3hCF;A0Fp3hCE;EAGE,oCAAA;EACA,sBAAA;A1Fo3hCJ;;A0Fh3hCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A1Fm3hCF;A0Fj3hCE;EAEE,oDAAA;EACA,yBAAA;A1Fk3hCJ;;A0F72hCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A1Fg3hCJ;A0F92hCI;EAEE,sDAAA;EACA,sBAAA;A1F+2hCN;;A0F12hCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A1F62hCF;A0F32hCE;EAEE,mDAAA;EACA,yBAAA;A1F42hCJ;;A0Fv2hCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A1F02hCJ;A0Fx2hCI;EAEE,sDAAA;EACA,sBAAA;A1Fy2hCN;;A0Fp2hCA;EACE,oCAAA;EACA,WrFzRM;EqF0RN,qBAnSuB;A1F0oiCzB;A0Fr2hCE;EACE,yCAAA;A1Fu2hCJ;A0Fr2hCI;EACE,WrFhSE;ALuoiCR;A0Fp2hCI;EACE,sBrFpSE;AL0oiCR;A0Fp2hCM;EACE,+BAAA;A1Fs2hCR;A0Fh2hCI;EADF;IAEI,sBrF9SE;ELipiCN;E0Fj2hCI;IACE,+BAAA;E1Fm2hCN;AACF;A0F/1hCE;EACE,iCAAA;A1Fi2hCJ;;A0F71hCA;EACE,sBrF5TM;AL4piCR;;A0F71hCA;EACE,WrFhUM;ALgqiCR;;A0F51hCA;EACE,yBAAA;A1F+1hCF;;A0F51hCA;EACE;IACE,yBAAA;E1F+1hCF;E0F51hCA;IACE,wBAAA;E1F81hCF;AACF;A0F31hCA;EACE,wBAAA;A1F61hCF;;A0F11hCA;EACE;IACE,wBAAA;E1F61hCF;AACF;A0Fz1hCA;EACE,yBAvWuB;A1FksiCzB;;A0Ft1hCA;EACE,qBAAA;EACA,0CAzWqB;A1FksiCvB;;A0Ft1hCA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;A1Fy1hCF;A0Fv1hCE;EACE,0CAlXmB;EAmXnB,kBAAA;EACA,UAAA;A1Fy1hCJ;A0Ft1hCE;EACE,qBAAA;A1Fw1hCJ;A0Fp1hCI;EACE,WrFzXE;AL+siCR;;A0Fj1hCA;EACE,cApYwB;A1FwtiC1B;;A0Fh1hCE;EACE,cAzYsB;A1F4tiC1B;;A0F/0hCA;;;EAGE,0CA/YqB;EAgZrB,WrF5YM;AL8tiCR;;A0F/0hCA;EACE,qBAzZuB;A1F2uiCzB;;A0F/0hCA;;EAEE,WrFrZM;ALuuiCR;;A0F/0hCA;EACE,0CA7ZqB;A1F+uiCvB;;A0F/0hCA;EACE,cAlawB;A1FoviC1B;;A0F/0hCA;;;EAGE,WrFnaM;ALqviCR;;A0F/0hCA;EACE,cA5awB;A1F8viC1B;;A0F/0hCA;EACE,yBApbuB;A1FswiCzB;;A0F/0hCA;;;;;EAKE,0CAvbqB;EAwbrB,WrFpbM;ALswiCR;;A0F/0hCA,2BAAA;AAGI;EAEE,cArcmB;A1FoxiCzB;A0F50hCI;EACE,WvF/Ye;AH6tiCrB;A0F30hCI;EAEE,cA9cmB;A1F0xiCzB;A0Fx0hCE;EACE,WrF1cI;ALoxiCR;A0Fv0hCE;EAKE,cA1dmB;A1F+xiCvB;A0Fj0hCI;EAEE,cAjemB;A1FmyiCzB;A0F7zhCI;EACE,WvF7ae;AH4uiCrB;A0F1zhCM;EACE,cA7eiB;A1FyyiCzB;A0FxzhCI;EAGE,cApfmB;A1F4yiCzB;;A0FnzhCA;EACE,oCAAA;EACA,qBAxfmB;A1F8yiCrB;A0FnzhCI;EACE,WrFtfE;AL2yiCR;A0FlzhCI;EAKE,cAtgBiB;A1FsziCvB;;A0FxyhCI;EACE,qBAhhBmB;A1F2ziCzB;;A0FryhCA;EACE,yBAvhBuB;A1F+ziCzB;;A0FryhCA;EACE,qCAAA;A1FwyhCF;;A0FryhCA;EACE,wCAAA;A1FwyhCF;;A0FryhCA;;EAEE,wCAAA;EACA,qBAriBuB;A1F60iCzB;;A0FryhCA;;;;EAIE,wCAAA;EACA,qBA7iBuB;A1Fq1iCzB;;A0FryhCA;EACE,wCAAA;EACA,qBAljBuB;A1F01iCzB;;A0FryhCA;EACE,wCAAA;EACA,qBAvjBuB;A1F+1iCzB;;A0FryhCA;EACE,qBA3jBuB;A1Fm2iCzB;;A0FpyhCA;EACE,cAhkBuB;A1Fu2iCzB;;A0FnyhCE;EAEE,0CAAA;A1FqyhCJ;;A0F/xhCE;EACE,cA7kBqB;A1F+2iCzB;;A0F7xhCA;EACE,mBAnlBuB;A1Fm3iCzB;;A0F5xhCE;EAGE,cA1lBqB;A1Fu3iCzB;;A0FtxhCE;EACE,qBAlmBqB;A1F23iCzB;;A0FnxhCE;EACE,qBAzmBqB;A1F+3iCzB;A0FpxhCI;EAGE,yBA9mBmB;A1Fk4iCzB;;A0F7whCE;EACE,cAtnBqB;A1Fs4iCzB;;A0F3whCE;EAGE,cA7nBmB;A1Fy4iCvB;;A0FvwhCA;EACE,cAnoBqB;A1F64iCvB;;A0FvwhCA;EACE,0CAAA;A1F0whCF;;A0FrwhCA;EACE,gCAAA;A1FwwhCF;;A0FnwhCA;EACE,yBAppBuB;A1F05iCzB;;A0FlwhCE;EACE,yBAAA;EACA,cA1pBqB;A1F+5iCzB;A0FnwhCI;EAEE,WrFrpBE;EqFspBF,yBA/pBmB;A1Fm6iCzB;;A0F3vhCI;;;;EACE,yBAzqBmB;EA0qBnB,qBA1qBmB;A1F26iCzB;A0F5vhCE;;EACE,yBAAA;A1F+vhCJ;A0F9vhCI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A1FiwhCN;A0F/vhCM;;;EAEE,oDAAA;EACA,yBAAA;A1FkwhCR;;A0F3vhCE;EACE,yBAjsBqB;EAksBrB,qBAlsBqB;A1Fg8iCzB;;A0F1vhCA;;EAEE,cAxsBuB;A1Fq8iCzB;;A0F1vhCA,4BAAA;AACA,2DAAA,wBAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,kDAAA,gBAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,sDAAA,WAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,iDAAA,gBAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,sEAAA,wBAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,6DAAA,gBAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,iEAAA,WAAA;EACE,+BAAA;A1F6vhCF;;A0F1vhCA,4DAAA,gBAAA;EACE,+BAAA;A1F6vhCF;;A2Fv+iCA,gCAAA;AAcA;EACE,cAd6B;A3F2+iC/B;A2F59iCE;EACE,cAhB2B;A3F8+iC/B;;A2Ft9iCE;EZnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eg/iCF;AI52iCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Ey/iCzG;A+E7+iCE;EAII,0HAAA;A/E4+iCN;A+Er+iCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH06iCf;A+En+iCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EsgjC7L;A+E99iCI;EAGI,uFAAA;A/E89iCR;;A2Fr/iCE;EZnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+gjCF;AI34iCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EwhjCzG;A+E5gjCE;EAII,wHAAA;A/E2gjCN;A+EpgjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHy8iCf;A+ElgjCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EqijC7L;A+E7/iCI;EAGI,qFAAA;A/E6/iCR;;A2FphjCE;EZnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8ijCF;AI16iCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EujjCzG;A+E3ijCE;EAII,yHAAA;A/E0ijCN;A+EnijCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHw+iCf;A+EjijCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EokjC7L;A+E5hjCI;EAGI,sFAAA;A/E4hjCR;;A2FnjjCE;EZnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6kjCF;AIz8iCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EsljCzG;A+E1kjCE;EAII,wHAAA;A/EykjCN;A+ElkjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHugjCf;A+EhkjCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EmmjC7L;A+E3jjCI;EAGI,qFAAA;A/E2jjCR;;A2FlljCE;EZnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4mjCF;AIx+iCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EqnjCzG;A+EzmjCE;EAII,yHAAA;A/EwmjCN;A+EjmjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsijCf;A+E/ljCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EkojC7L;A+E1ljCI;EAGI,sFAAA;A/E0ljCR;;A2FjnjCE;EZnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2ojCF;AIvgjCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EopjCzG;A+ExojCE;EAII,wHAAA;A/EuojCN;A+EhojCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqkjCf;A+E9njCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EiqjC7L;A+EznjCI;EAGI,qFAAA;A/EynjCR;;A2FhpjCE;EZnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0qjCF;AItijCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EmrjCzG;A+EvqjCE;EAII,0HAAA;A/EsqjCN;A+E/pjCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHomjCf;A+E7pjCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EgsjC7L;A+ExpjCI;EAGI,uFAAA;A/EwpjCR;;A2F/qjCE;EZnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EysjCF;AIrkjCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EktjCzG;A+EtsjCE;EAII,uHAAA;A/EqsjCN;A+E9rjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmojCf;A+E5rjCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E+tjC7L;A+EvrjCI;EAGI,oFAAA;A/EurjCR;;A2FxsjCE;EZzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwujCF;AIpmjCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EivjCzG;A+ErujCE;EAII,0HAAA;A/EoujCN;A+E7tjCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkqjCf;A+E3tjCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E8vjC7L;A+EttjCI;EAGI,uFAAA;A/EstjCR;;A2FvujCE;EZzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EuwjCF;AInojCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EgxjCzG;A+EpwjCE;EAII,wHAAA;A/EmwjCN;A+E5vjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHisjCf;A+E1vjCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E6xjC7L;A+ErvjCI;EAGI,qFAAA;A/EqvjCR;;A2FtwjCE;EZzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EsyjCF;AIlqjCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E+yjCzG;A+EnyjCE;EAII,yHAAA;A/EkyjCN;A+E3xjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgujCf;A+EzxjCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E4zjC7L;A+EpxjCI;EAGI,sFAAA;A/EoxjCR;;A2FryjCE;EZzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq0jCF;AIjsjCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E80jCzG;A+El0jCE;EAII,wHAAA;A/Ei0jCN;A+E1zjCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+vjCf;A+ExzjCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E21jC7L;A+EnzjCI;EAGI,qFAAA;A/EmzjCR;;A2Fp0jCE;EZzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo2jCF;AIhujCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E62jCzG;A+Ej2jCE;EAII,yHAAA;A/Eg2jCN;A+Ez1jCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8xjCf;A+Ev1jCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E03jC7L;A+El1jCI;EAGI,sFAAA;A/Ek1jCR;;A2Fn2jCE;EZzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em4jCF;AI/vjCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E44jCzG;A+Eh4jCE;EAII,wHAAA;A/E+3jCN;A+Ex3jCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6zjCf;A+Et3jCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ey5jC7L;A+Ej3jCI;EAGI,qFAAA;A/Ei3jCR;;A2Fl4jCE;EZzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ek6jCF;AI9xjCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E26jCzG;A+E/5jCE;EAII,0HAAA;A/E85jCN;A+Ev5jCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH41jCf;A+Er5jCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Ew7jC7L;A+Eh5jCI;EAGI,uFAAA;A/Eg5jCR;;A2Fj6jCE;EZzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ei8jCF;AI7zjCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E08jCzG;A+E97jCE;EAII,uHAAA;A/E67jCN;A+Et7jCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH23jCf;A+Ep7jCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Eu9jC7L;A+E/6jCI;EAGI,oFAAA;A/E+6jCR;;A2F17jCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH04jCf;A+Ex6jCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+4jCf;A+Ev6jCE;EAEE,iDAAA;A/Ew6jCJ;A+Er6jCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es6jCJ;A+En6jCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH25jCf;A+Ej6jCI;EAGI,uFAAA;A/Ei6jCR;;A2Fr9jCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHq6jCf;A+En8jCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH06jCf;A+El8jCE;EAEE,+CAAA;A/Em8jCJ;A+Eh8jCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ei8jCJ;A+E97jCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHs7jCf;A+E57jCI;EAGI,qFAAA;A/E47jCR;;A2Fh/jCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHg8jCf;A+E99jCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHq8jCf;A+E79jCE;EAEE,gDAAA;A/E89jCJ;A+E39jCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E49jCJ;A+Ez9jCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHi9jCf;A+Ev9jCI;EAGI,sFAAA;A/Eu9jCR;;A2F3gkCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH29jCf;A+Ez/jCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHg+jCf;A+Ex/jCE;EAEE,+CAAA;A/Ey/jCJ;A+Et/jCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eu/jCJ;A+Ep/jCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4+jCf;A+El/jCI;EAGI,qFAAA;A/Ek/jCR;;A2FtikCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHs/jCf;A+EphkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2/jCf;A+EnhkCE;EAEE,gDAAA;A/EohkCJ;A+EjhkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkhkCJ;A+E/gkCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHugkCf;A+E7gkCI;EAGI,sFAAA;A/E6gkCR;;A2FjkkCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHihkCf;A+E/ikCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHshkCf;A+E9ikCE;EAEE,+CAAA;A/E+ikCJ;A+E5ikCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6ikCJ;A+E1ikCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkikCf;A+ExikCI;EAGI,qFAAA;A/EwikCR;;A2F5lkCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4ikCf;A+E1kkCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHijkCf;A+EzkkCE;EAEE,iDAAA;A/E0kkCJ;A+EvkkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwkkCJ;A+ErkkCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6jkCf;A+EnkkCI;EAGI,uFAAA;A/EmkkCR;;A2FvnkCE;EZoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHukkCf;A+ErmkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4kkCf;A+EpmkCE;EAEE,8CAAA;A/EqmkCJ;A+ElmkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmmkCJ;A+EhmkCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwlkCf;A+E9lkCI;EAGI,oFAAA;A/E8lkCR;;A2FxokCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkmkCf;A+EhokCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHumkCf;A+E/nkCE;EAEE,iDAAA;A/EgokCJ;A+E7nkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8nkCJ;A+E3nkCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmnkCf;A+EznkCI;EAGI,uFAAA;A/EynkCR;;A2FnqkCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6nkCf;A+E3pkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHkokCf;A+E1pkCE;EAEE,+CAAA;A/E2pkCJ;A+ExpkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EypkCJ;A+EtpkCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8okCf;A+EppkCI;EAGI,qFAAA;A/EopkCR;;A2F9rkCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwpkCf;A+EtrkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6pkCf;A+ErrkCE;EAEE,gDAAA;A/EsrkCJ;A+EnrkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EorkCJ;A+EjrkCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHyqkCf;A+E/qkCI;EAGI,sFAAA;A/E+qkCR;;A2FztkCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmrkCf;A+EjtkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwrkCf;A+EhtkCE;EAEE,+CAAA;A/EitkCJ;A+E9skCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+skCJ;A+E5skCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHoskCf;A+E1skCI;EAGI,qFAAA;A/E0skCR;;A2FpvkCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8skCf;A+E5ukCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmtkCf;A+E3ukCE;EAEE,gDAAA;A/E4ukCJ;A+EzukCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0ukCJ;A+EvukCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+tkCf;A+ErukCI;EAGI,sFAAA;A/EqukCR;;A2F/wkCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHyukCf;A+EvwkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8ukCf;A+EtwkCE;EAEE,+CAAA;A/EuwkCJ;A+EpwkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqwkCJ;A+ElwkCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0vkCf;A+EhwkCI;EAGI,qFAAA;A/EgwkCR;;A2F1ykCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHowkCf;A+ElykCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHywkCf;A+EjykCE;EAEE,iDAAA;A/EkykCJ;A+E/xkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EgykCJ;A+E7xkCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqxkCf;A+E3xkCI;EAGI,uFAAA;A/E2xkCR;;A2Fr0kCE;EZUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+xkCf;A+E7zkCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHoykCf;A+E5zkCE;EAEE,8CAAA;A/E6zkCJ;A+E1zkCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2zkCJ;A+ExzkCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgzkCf;A+EtzkCI;EAGI,oFAAA;A/EszkCR;;A2Fv1kCA;;EAEE,cAzD6B;EA0D7B,qBA1D6B;A3Fo5kC/B;A2Fx1kCE;;;;;;;;EAOE,WtF1DI;EsF2DJ,qBApE2B;EAqE3B,yBArE2B;A3Fg6kC/B;;A2Fv1kCA;;EAEE,cA1E2B;EA2E3B,qBA3E2B;A3Fq6kC7B;A2Fx1kCE;;;;;;;;EAOE,WtF5EI;EsF6EJ,qBArFyB;EAsFzB,yBAtFyB;A3Fi7kC7B;;A2Fr1kCE;EAEE,cA/F2B;A3Fs7kC/B;A2Ft1kCI;EAEE,iCAAA;A3Fu1kCN;A2Fn1kCE;EACE,yBAAA;A3Fq1kCJ;A2Fl1kCE;EACE,cA3G2B;A3F+7kC/B;A2Fn1kCI;EAEE,cA9GyB;A3Fk8kC/B;A2Fh1kCE;EAEE,oCAAA;EACA,sBAAA;A3Fi1kCJ;A2F90kCE;EAIE,yBA5H2B;EA6H3B,qBA7H2B;EA8H3B,WtFrHI;ALk8kCR;A2F30kCI;EAGE,yDAAA;EACA,qDAAA;EACA,sBAAA;A3F20kCN;A2Ft0kCI;EACE,oCAAA;A3Fw0kCN;A2Fr0kCI;EACE,oCAAA;A3Fu0kCN;A2Fp0kCI;EACE,oCAAA;A3Fs0kCN;A2Fn0kCI;EACE,oCAAA;A3Fq0kCN;A2Fl0kCI;EACE,oCAAA;A3Fo0kCN;A2Fj0kCI;EACE,oCAAA;A3Fm0kCN;A2Fh0kCI;EACE,oCAAA;A3Fk0kCN;A2F/zkCI;EACE,oCAAA;A3Fi0kCN;A2F9zkCI;EACE,oCAAA;A3Fg0kCN;A2F7zkCI;EACE,oCAAA;A3F+zkCN;A2F5zkCI;EACE,oCAAA;A3F8zkCN;A2F3zkCI;EACE,oCAAA;A3F6zkCN;;A2FtzkCE;EACE,cA9LyB;A3Fu/kC7B;A2FxzkCI;EAEE,8CAAA;A3FyzkCN;A2FrzkCE;EACE,yBAAA;A3FuzkCJ;A2FpzkCE;EAEE,oCAAA;EACA,sBAAA;A3FqzkCJ;A2FlzkCE;EACE,yBAhNyB;EAiNzB,qBAjNyB;EAkNzB,WtF1MI;AL8/kCR;A2FlzkCI;EAGE,2DAAA;EACA,uDAAA;EACA,sBAAA;A3FkzkCN;;A2F5ykCA;EACE,wCAAA;EACA,sBAAA;A3F+ykCF;A2F9ykCE;EAGE,oCAAA;EACA,sBAAA;A3F8ykCJ;;A2F1ykCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A3F6ykCF;A2F3ykCE;EAEE,oDAAA;EACA,yBAAA;A3F4ykCJ;;A2FvykCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A3F0ykCJ;A2FxykCI;EAEE,sDAAA;EACA,sBAAA;A3FyykCN;;A2FpykCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A3FuykCF;A2FrykCE;EAEE,qDAAA;EACA,yBAAA;A3FsykCJ;;A2FjykCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A3FoykCJ;A2FlykCI;EAEE,sDAAA;EACA,sBAAA;A3FmykCN;;A2F9xkCA;EACE,oCAAA;EACA,WtFxRM;EsFyRN,qBAlS6B;A3FmklC/B;A2F/xkCE;EACE,gDAAA;A3FiykCJ;A2F/xkCI;EACE,WtF/RE;ALgklCR;A2F7xkCI;EACE,sBtFpSE;ALmklCR;A2F7xkCM;EACE,+BAAA;A3F+xkCR;A2FzxkCI;EADF;IAEI,sBtF9SE;EL0klCN;E2F1xkCI;IACE,+BAAA;E3F4xkCN;AACF;A2FxxkCE;EACE,iCAAA;A3F0xkCJ;;A2FtxkCA;EACE,sBtF5TM;ALqllCR;;A2FtxkCA;EACE,WtFhUM;ALyllCR;;A2FrxkCA;EACE,yBAAA;A3FwxkCF;;A2FrxkCA;EACE;IACE,yBAAA;E3FwxkCF;E2FrxkCA;IACE,wBAAA;E3FuxkCF;AACF;A2FpxkCA;EACE,wBAAA;A3FsxkCF;;A2FnxkCA;EACE;IACE,wBAAA;E3FsxkCF;AACF;A2FlxkCA;EACE,yBAvW6B;A3F2nlC/B;;A2F/wkCA;EACE,qBAAA;EACA,0CAzW2B;A3F2nlC7B;;A2F/wkCA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;A3FkxkCF;A2FhxkCE;EACE,0CAlXyB;EAmXzB,kBAAA;EACA,UAAA;A3FkxkCJ;A2F/wkCE;EACE,qBAAA;A3FixkCJ;A2F7wkCI;EACE,WtFzXE;ALwolCR;;A2F1wkCA;EACE,cApY8B;A3FiplChC;;A2FzwkCE;EACE,cAzY4B;A3FqplChC;;A2FxwkCA;;;EAGE,0CA/Y2B;EAgZ3B,WtF5YM;ALuplCR;;A2FxwkCA;EACE,qBAzZ6B;A3FoqlC/B;;A2FxwkCA;;EAEE,WtFrZM;ALgqlCR;;A2FxwkCA;EACE,0CA7Z2B;A3FwqlC7B;;A2FxwkCA;EACE,cAla8B;A3F6qlChC;;A2FxwkCA;;;EAGE,WtFnaM;AL8qlCR;;A2FxwkCA;EACE,cA5a8B;A3FurlChC;;A2FxwkCA;EACE,yBApb6B;A3F+rlC/B;;A2FxwkCA;;;;;EAKE,0CAvb2B;EAwb3B,WtFpbM;AL+rlCR;;A2FxwkCA,2BAAA;AAGI;EAEE,cArcyB;A3F6slC/B;A2FrwkCI;EACE,WxF/Ye;AHsplCrB;A2FpwkCI;EAEE,cA9cyB;A3FmtlC/B;A2FjwkCE;EACE,WtF1cI;AL6slCR;A2FhwkCE;EAKE,cA1dyB;A3FwtlC7B;A2F1vkCI;EAEE,cAjeyB;A3F4tlC/B;A2FtvkCI;EACE,WxF7ae;AHqqlCrB;A2FnvkCM;EACE,cA7euB;A3FkulC/B;A2FjvkCI;EAGE,cApfyB;A3FqulC/B;;A2F5ukCA;EACE,oCAAA;EACA,qBAxfyB;A3FuulC3B;A2F7ukCI;EACE,WtFrfE;ALoulCR;A2F5ukCI;EAKE,cArgBuB;A3F+ulC7B;;A2FlukCI;EACE,qBA/gByB;A3FovlC/B;;A2F/tkCA;EACE,yBAthB6B;A3FwvlC/B;;A2F/tkCA;EACE,4CAAA;A3FkukCF;;A2F/tkCA;EACE,wCAAA;A3FkukCF;;A2F/tkCA;;EAEE,wCAAA;EACA,qBApiB6B;A3FswlC/B;;A2F/tkCA;;;;EAIE,wCAAA;EACA,qBA5iB6B;A3F8wlC/B;;A2F/tkCA;EACE,wCAAA;EACA,qBAjjB6B;A3FmxlC/B;;A2F/tkCA;EACE,wCAAA;EACA,qBAtjB6B;A3FwxlC/B;;A2F/tkCA;EACE,qBA1jB6B;A3F4xlC/B;;A2F9tkCA;EACE,cA/jB6B;A3FgylC/B;;A2F7tkCE;EAEE,+CAAA;A3F+tkCJ;;A2FztkCE;EACE,cA5kB2B;A3FwylC/B;;A2FvtkCA;EACE,mBAllB6B;A3F4ylC/B;;A2FttkCE;EAGE,cAzlB2B;A3FgzlC/B;;A2FjtkCE;EACE,qBAhmB2B;A3FozlC/B;;A2F9skCE;EACE,qBAvmB2B;A3FwzlC/B;A2F/skCI;EAGE,yBA5mByB;A3F2zlC/B;;A2FxskCE;EACE,cApnB2B;A3F+zlC/B;;A2FtskCE;EAGE,cA3nByB;A3Fk0lC7B;;A2FlskCA;EACE,cAjoB2B;A3Fs0lC7B;;A2FlskCA;EACE,0CAAA;A3FqskCF;;A2FhskCA;EACE,gCAAA;A3FmskCF;;A2F9rkCA;EACE,yBAlpB6B;A3Fm1lC/B;;A2F7rkCE;EACE,yBAAA;EACA,cAxpB2B;A3Fw1lC/B;A2F9rkCI;EAEE,WtFnpBE;EsFopBF,yBA7pByB;A3F41lC/B;;A2FtrkCI;;;;EACE,yBAvqByB;EAwqBzB,qBAxqByB;A3Fo2lC/B;A2FvrkCE;;EACE,yBAAA;A3F0rkCJ;A2FzrkCI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A3F4rkCN;A2F1rkCM;;;EAEE,oDAAA;EACA,yBAAA;A3F6rkCR;;A2FtrkCE;EACE,yBA/rB2B;EAgsB3B,qBAhsB2B;A3Fy3lC/B;;A2FrrkCA;;EAEE,cAtsB6B;A3F83lC/B;;A2FrrkCA,4BAAA;AACA,iEAAA,wBAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,wDAAA,gBAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,4DAAA,WAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,uDAAA,gBAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,4EAAA,wBAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,mEAAA,gBAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,uEAAA,WAAA;EACE,+BAAA;A3FwrkCF;;A2FrrkCA,kEAAA,gBAAA;EACE,+BAAA;A3FwrkCF;;A4Fh6lCA,yBAAA;AAcA;EACE,cAdsB;A5Fo6lCxB;A4Fr5lCE;EACE,cAhBoB;A5Fu6lCxB;;A4F/4lCE;EbnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey6lCF;AIrylCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Ek7lCzG;A+Et6lCE;EAII,0HAAA;A/Eq6lCN;A+E95lCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm2lCf;A+E55lCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E+7lC7L;A+Ev5lCI;EAGI,uFAAA;A/Eu5lCR;;A4F96lCE;EbnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ew8lCF;AIp0lCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ei9lCzG;A+Er8lCE;EAII,wHAAA;A/Eo8lCN;A+E77lCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHk4lCf;A+E37lCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E89lC7L;A+Et7lCI;EAGI,qFAAA;A/Es7lCR;;A4F78lCE;EbnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu+lCF;AIn2lCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Eg/lCzG;A+Ep+lCE;EAII,yHAAA;A/Em+lCN;A+E59lCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi6lCf;A+E19lCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E6/lC7L;A+Er9lCI;EAGI,sFAAA;A/Eq9lCR;;A4F5+lCE;EbnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EsgmCF;AIl4lCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E+gmCzG;A+EngmCE;EAII,wHAAA;A/EkgmCN;A+E3/lCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHg8lCf;A+Ez/lCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E4hmC7L;A+Ep/lCI;EAGI,qFAAA;A/Eo/lCR;;A4F3gmCE;EbnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqimCF;AIj6lCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E8imCzG;A+ElimCE;EAII,yHAAA;A/EiimCN;A+E1hmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+9lCf;A+ExhmCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E2jmC7L;A+EnhmCI;EAGI,sFAAA;A/EmhmCR;;A4F1imCE;EbnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EokmCF;AIh8lCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E6kmCzG;A+EjkmCE;EAII,wHAAA;A/EgkmCN;A+EzjmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8/lCf;A+EvjmCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E0lmC7L;A+EljmCI;EAGI,qFAAA;A/EkjmCR;;A4FzkmCE;EbnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmmmCF;AI/9lCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E4mmCzG;A+EhmmCE;EAII,0HAAA;A/E+lmCN;A+ExlmCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6hmCf;A+EtlmCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EynmC7L;A+EjlmCI;EAGI,uFAAA;A/EilmCR;;A4FxmmCE;EbnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EkomCF;AI9/lCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E2omCzG;A+E/nmCE;EAII,uHAAA;A/E8nmCN;A+EvnmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4jmCf;A+ErnmCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EwpmC7L;A+EhnmCI;EAGI,oFAAA;A/EgnmCR;;A4FjomCE;EbzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EiqmCF;AI7hmCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E0qmCzG;A+E9pmCE;EAII,0HAAA;A/E6pmCN;A+EtpmCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2lmCf;A+EppmCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EurmC7L;A+E/omCI;EAGI,uFAAA;A/E+omCR;;A4FhqmCE;EbzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgsmCF;AI5jmCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EysmCzG;A+E7rmCE;EAII,wHAAA;A/E4rmCN;A+ErrmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0nmCf;A+EnrmCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EstmC7L;A+E9qmCI;EAGI,qFAAA;A/E8qmCR;;A4F/rmCE;EbzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+tmCF;AI3lmCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EwumCzG;A+E5tmCE;EAII,yHAAA;A/E2tmCN;A+EptmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHypmCf;A+EltmCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EqvmC7L;A+E7smCI;EAGI,sFAAA;A/E6smCR;;A4F9tmCE;EbzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8vmCF;AI1nmCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EuwmCzG;A+E3vmCE;EAII,wHAAA;A/E0vmCN;A+EnvmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwrmCf;A+EjvmCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EoxmC7L;A+E5umCI;EAGI,qFAAA;A/E4umCR;;A4F7vmCE;EbzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6xmCF;AIzpmCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EsymCzG;A+E1xmCE;EAII,yHAAA;A/EyxmCN;A+ElxmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHutmCf;A+EhxmCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EmzmC7L;A+E3wmCI;EAGI,sFAAA;A/E2wmCR;;A4F5xmCE;EbzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4zmCF;AIxrmCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eq0mCzG;A+EzzmCE;EAII,wHAAA;A/EwzmCN;A+EjzmCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsvmCf;A+E/ymCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ek1mC7L;A+E1ymCI;EAGI,qFAAA;A/E0ymCR;;A4F3zmCE;EbzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E21mCF;AIvtmCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eo2mCzG;A+Ex1mCE;EAII,0HAAA;A/Eu1mCN;A+Eh1mCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqxmCf;A+E90mCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Ei3mC7L;A+Ez0mCI;EAGI,uFAAA;A/Ey0mCR;;A4F11mCE;EbzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E03mCF;AItvmCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Em4mCzG;A+Ev3mCE;EAII,uHAAA;A/Es3mCN;A+E/2mCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHozmCf;A+E72mCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Eg5mC7L;A+Ex2mCI;EAGI,oFAAA;A/Ew2mCR;;A4Fn3mCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm0mCf;A+Ej2mCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHw0mCf;A+Eh2mCE;EAEE,iDAAA;A/Ei2mCJ;A+E91mCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+1mCJ;A+E51mCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo1mCf;A+E11mCI;EAGI,uFAAA;A/E01mCR;;A4F94mCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH81mCf;A+E53mCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm2mCf;A+E33mCE;EAEE,+CAAA;A/E43mCJ;A+Ez3mCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E03mCJ;A+Ev3mCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+2mCf;A+Er3mCI;EAGI,qFAAA;A/Eq3mCR;;A4Fz6mCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy3mCf;A+Ev5mCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH83mCf;A+Et5mCE;EAEE,gDAAA;A/Eu5mCJ;A+Ep5mCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq5mCJ;A+El5mCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH04mCf;A+Eh5mCI;EAGI,sFAAA;A/Eg5mCR;;A4Fp8mCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo5mCf;A+El7mCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy5mCf;A+Ej7mCE;EAEE,+CAAA;A/Ek7mCJ;A+E/6mCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg7mCJ;A+E76mCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq6mCf;A+E36mCI;EAGI,qFAAA;A/E26mCR;;A4F/9mCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+6mCf;A+E78mCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHo7mCf;A+E58mCE;EAEE,gDAAA;A/E68mCJ;A+E18mCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E28mCJ;A+Ex8mCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHg8mCf;A+Et8mCI;EAGI,sFAAA;A/Es8mCR;;A4F1/mCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH08mCf;A+Ex+mCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+8mCf;A+Ev+mCE;EAEE,+CAAA;A/Ew+mCJ;A+Er+mCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es+mCJ;A+En+mCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH29mCf;A+Ej+mCI;EAGI,qFAAA;A/Ei+mCR;;A4FrhnCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHq+mCf;A+EngnCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH0+mCf;A+ElgnCE;EAEE,iDAAA;A/EmgnCJ;A+EhgnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EignCJ;A+E9/mCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHs/mCf;A+E5/mCI;EAGI,uFAAA;A/E4/mCR;;A4FhjnCE;EboBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHggnCf;A+E9hnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqgnCf;A+E7hnCE;EAEE,8CAAA;A/E8hnCJ;A+E3hnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4hnCJ;A+EzhnCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHihnCf;A+EvhnCI;EAGI,oFAAA;A/EuhnCR;;A4FjknCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2hnCf;A+EzjnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHginCf;A+ExjnCE;EAEE,iDAAA;A/EyjnCJ;A+EtjnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EujnCJ;A+EpjnCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4inCf;A+EljnCI;EAGI,uFAAA;A/EkjnCR;;A4F5lnCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsjnCf;A+EplnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2jnCf;A+EnlnCE;EAEE,+CAAA;A/EolnCJ;A+EjlnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EklnCJ;A+E/knCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuknCf;A+E7knCI;EAGI,qFAAA;A/E6knCR;;A4FvnnCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHilnCf;A+E/mnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHslnCf;A+E9mnCE;EAEE,gDAAA;A/E+mnCJ;A+E5mnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6mnCJ;A+E1mnCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkmnCf;A+ExmnCI;EAGI,sFAAA;A/EwmnCR;;A4FlpnCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4mnCf;A+E1onCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHinnCf;A+EzonCE;EAEE,+CAAA;A/E0onCJ;A+EvonCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwonCJ;A+EronCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6nnCf;A+EnonCI;EAGI,qFAAA;A/EmonCR;;A4F7qnCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHuonCf;A+ErqnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4onCf;A+EpqnCE;EAEE,gDAAA;A/EqqnCJ;A+ElqnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmqnCJ;A+EhqnCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwpnCf;A+E9pnCI;EAGI,sFAAA;A/E8pnCR;;A4FxsnCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkqnCf;A+EhsnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHuqnCf;A+E/rnCE;EAEE,+CAAA;A/EgsnCJ;A+E7rnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8rnCJ;A+E3rnCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmrnCf;A+EzrnCI;EAGI,qFAAA;A/EyrnCR;;A4FnunCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6rnCf;A+E3tnCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHksnCf;A+E1tnCE;EAEE,iDAAA;A/E2tnCJ;A+ExtnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EytnCJ;A+EttnCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8snCf;A+EptnCI;EAGI,uFAAA;A/EotnCR;;A4F9vnCE;EbUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwtnCf;A+EtvnCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6tnCf;A+ErvnCE;EAEE,8CAAA;A/EsvnCJ;A+EnvnCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EovnCJ;A+EjvnCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHyunCf;A+E/unCI;EAGI,oFAAA;A/E+unCR;;A4FhxnCA;;EAEE,cAzDsB;EA0DtB,qBA1DsB;A5F60nCxB;A4FjxnCE;;;;;;;;EAOE,WvF1DI;EuF2DJ,qBApEoB;EAqEpB,yBArEoB;A5Fy1nCxB;;A4FhxnCA;;EAEE,cA1EoB;EA2EpB,qBA3EoB;A5F81nCtB;A4FjxnCE;;;;;;;;EAOE,WvF5EI;EuF6EJ,qBArFkB;EAsFlB,yBAtFkB;A5F02nCtB;;A4F9wnCE;EAEE,cA/FoB;A5F+2nCxB;A4F/wnCI;EAEE,wDAAA;A5FgxnCN;A4F5wnCE;EACE,yBAAA;A5F8wnCJ;A4F3wnCE;EACE,cA3GoB;A5Fw3nCxB;A4F5wnCI;EAEE,cA9GkB;A5F23nCxB;A4FzwnCE;EAEE,oCAAA;EACA,sBAAA;A5F0wnCJ;A4FvwnCE;EAIE,yBA5HoB;EA6HpB,qBA7HoB;EA8HpB,WvFrHI;AL23nCR;A4FpwnCI;EAGE,qEAAA;EACA,iEAAA;EACA,sBAAA;A5FownCN;A4F/vnCI;EACE,oCAAA;A5FiwnCN;A4F9vnCI;EACE,oCAAA;A5FgwnCN;A4F7vnCI;EACE,oCAAA;A5F+vnCN;A4F5vnCI;EACE,oCAAA;A5F8vnCN;A4F3vnCI;EACE,oCAAA;A5F6vnCN;A4F1vnCI;EACE,oCAAA;A5F4vnCN;A4FzvnCI;EACE,oCAAA;A5F2vnCN;A4FxvnCI;EACE,oCAAA;A5F0vnCN;A4FvvnCI;EACE,oCAAA;A5FyvnCN;A4FtvnCI;EACE,oCAAA;A5FwvnCN;A4FrvnCI;EACE,oCAAA;A5FuvnCN;A4FpvnCI;EACE,oCAAA;A5FsvnCN;;A4F/unCE;EACE,cA9LkB;A5Fg7nCtB;A4FjvnCI;EAEE,4CAAA;A5FkvnCN;A4F9unCE;EACE,yBAAA;A5FgvnCJ;A4F7unCE;EAEE,oCAAA;EACA,sBAAA;A5F8unCJ;A4F3unCE;EACE,yBAhNkB;EAiNlB,qBAjNkB;EAkNlB,WvF1MI;ALu7nCR;A4F3unCI;EAGE,0DAAA;EACA,sDAAA;EACA,sBAAA;A5F2unCN;;A4FrunCA;EACE,wCAAA;EACA,sBAAA;A5FwunCF;A4FvunCE;EAGE,oCAAA;EACA,sBAAA;A5FuunCJ;;A4FnunCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A5FsunCF;A4FpunCE;EAEE,oDAAA;EACA,yBAAA;A5FqunCJ;;A4FhunCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A5FmunCJ;A4FjunCI;EAEE,sDAAA;EACA,sBAAA;A5FkunCN;;A4F7tnCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A5FgunCF;A4F9tnCE;EAEE,oDAAA;EACA,yBAAA;A5F+tnCJ;;A4F1tnCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A5F6tnCJ;A4F3tnCI;EAEE,sDAAA;EACA,sBAAA;A5F4tnCN;;A4FttnCA;EACE,oCAAA;EACA,WvFzRM;EuF0RN,qBAnSsB;A5F4/nCxB;A4FvtnCE;EACE,oEAAA;A5FytnCJ;A4FvtnCI;EACE,WvFhSE;ALy/nCR;A4FttnCI;EACE,sBvFpSE;AL4/nCR;A4FttnCM;EACE,+BAAA;A5FwtnCR;A4FltnCI;EADF;IAEI,sBvF9SE;ELmgoCN;E4FntnCI;IACE,+BAAA;E5FqtnCN;AACF;A4FjtnCE;EACE,iCAAA;A5FmtnCJ;;A4F/snCA;EACE,sBvF5TM;AL8goCR;;A4F/snCA;EACE,WvFhUM;ALkhoCR;;A4F9snCA;EACE,yBAAA;A5FitnCF;;A4F9snCA;EACE;IACE,yBAAA;E5FitnCF;E4F9snCA;IACE,wBAAA;E5FgtnCF;AACF;A4F7snCA;EACE,wBAAA;A5F+snCF;;A4F5snCA;EACE;IACE,wBAAA;E5F+snCF;AACF;A4F3snCA;EACE,yBAvWsB;A5FojoCxB;;A4FzsnCA;EACE,qBAAA;EACA,0CAxWoB;A5FojoCtB;;A4FzsnCA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;A5F4snCF;A4F1snCE;EACE,0CAjXkB;EAkXlB,kBAAA;EACA,UAAA;A5F4snCJ;A4FzsnCE;EACE,qBAAA;A5F2snCJ;A4FvsnCI;EACE,WvFxXE;ALikoCR;;A4FpsnCA;EACE,cAnYuB;A5F0koCzB;;A4FnsnCE;EACE,cAxYqB;A5F8koCzB;;A4FlsnCA;;;EAGE,0CA9YoB;EA+YpB,WvF3YM;ALgloCR;;A4FlsnCA;EACE,qBAxZsB;A5F6loCxB;;A4FlsnCA;;EAEE,WvFpZM;ALyloCR;;A4FlsnCA;EACE,0CA5ZoB;A5FimoCtB;;A4FlsnCA;EACE,cAjauB;A5FsmoCzB;;A4FlsnCA;;;EAGE,WvFlaM;ALumoCR;;A4FlsnCA;EACE,cA3auB;A5FgnoCzB;;A4FlsnCA;EACE,yBAnbsB;A5FwnoCxB;;A4FlsnCA;;;;;EAKE,0CAtboB;EAubpB,WvFnbM;ALwnoCR;;A4FlsnCA,2BAAA;AAGI;EAEE,cApckB;A5FsooCxB;A4F/rnCI;EACE,WzF9Ye;AH+koCrB;A4F9rnCI;EAEE,cA7ckB;A5F4ooCxB;A4F3rnCE;EACE,WvFzcI;ALsooCR;A4F1rnCE;EAKE,cAzdkB;A5FipoCtB;A4FprnCI;EAEE,cAhekB;A5FqpoCxB;A4FhrnCI;EACE,WzF5ae;AH8loCrB;A4F7qnCM;EACE,cA5egB;A5F2poCxB;A4F3qnCI;EAGE,cAnfkB;A5F8poCxB;;A4FtqnCA;EACE,oCAAA;EACA,qBAvfkB;A5FgqoCpB;A4FvqnCI;EACE,WvFpfE;AL6poCR;A4FtqnCI;EAKE,cApgBgB;A5FwqoCtB;;A4F5pnCI;EACE,qBA9gBkB;A5F6qoCxB;;A4FzpnCA;EACE,yBArhBsB;A5FiroCxB;;A4FzpnCA;EACE,mEAAA;A5F4pnCF;;A4FzpnCA;EACE,wCAAA;A5F4pnCF;;A4FzpnCA;;EAEE,wCAAA;EACA,qBAniBsB;A5F+roCxB;;A4FzpnCA;;;;EAIE,wCAAA;EACA,qBA3iBsB;A5FusoCxB;;A4FzpnCA;EACE,wCAAA;EACA,qBAhjBsB;A5F4soCxB;;A4FzpnCA;EACE,wCAAA;EACA,qBArjBsB;A5FitoCxB;;A4FzpnCA;EACE,qBAzjBsB;A5FqtoCxB;;A4FxpnCA;EACE,cA9jBsB;A5FytoCxB;;A4FvpnCE;EAEE,qEAAA;A5FypnCJ;;A4FnpnCE;EACE,cA3kBoB;A5FiuoCxB;;A4FjpnCA;EACE,mBAjlBsB;A5FquoCxB;;A4FhpnCE;EAGE,cAxlBoB;A5FyuoCxB;;A4F3onCE;EACE,qBA/lBoB;A5F6uoCxB;;A4FxonCE;EACE,qBAtmBoB;A5FivoCxB;A4FzonCI;EAGE,yBA3mBkB;A5FovoCxB;;A4FlonCE;EACE,cAnnBoB;A5FwvoCxB;;A4FhonCE;EAGE,cA1nBkB;A5F2voCtB;;A4F5nnCA;EACE,cAhoBoB;A5F+voCtB;;A4F5nnCA;EACE,0CAAA;A5F+nnCF;;A4F1nnCA;EACE,gCAAA;A5F6nnCF;;A4FxnnCA;EACE,yBAjpBsB;A5F4woCxB;;A4FvnnCE;EACE,yBAAA;EACA,cAvpBoB;A5FixoCxB;A4FxnnCI;EAEE,WvFlpBE;EuFmpBF,yBA5pBkB;A5FqxoCxB;;A4FhnnCI;;;;EACE,yBAtqBkB;EAuqBlB,qBAvqBkB;A5F6xoCxB;A4FjnnCE;;EACE,yBAAA;A5FonnCJ;A4FnnnCI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A5FsnnCN;A4FpnnCM;;;EAEE,oDAAA;EACA,yBAAA;A5FunnCR;;A4FhnnCE;EACE,yBA9rBoB;EA+rBpB,qBA/rBoB;A5FkzoCxB;;A4F/mnCA;;EAEE,cArsBsB;A5FuzoCxB;;A4F/mnCA,4BAAA;AACA,0DAAA,wBAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,iDAAA,gBAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,qDAAA,WAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,gDAAA,gBAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,qEAAA,wBAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,4DAAA,gBAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,gEAAA,WAAA;EACE,+BAAA;A5FknnCF;;A4F/mnCA,2DAAA,gBAAA;EACE,+BAAA;A5FknnCF;;A6Fz1oCA,yBAAA;AAcA;EACE,cAdsB;A7F61oCxB;A6F90oCE;EACE,cAhBoB;A7Fg2oCxB;;A6Fx0oCE;EdnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ek2oCF;AI9toCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E22oCzG;A+E/1oCE;EAII,0HAAA;A/E81oCN;A+Ev1oCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4xoCf;A+Er1oCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Ew3oC7L;A+Eh1oCI;EAGI,uFAAA;A/Eg1oCR;;A6Fv2oCE;EdnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ei4oCF;AI7voCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E04oCzG;A+E93oCE;EAII,wHAAA;A/E63oCN;A+Et3oCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2zoCf;A+Ep3oCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eu5oC7L;A+E/2oCI;EAGI,qFAAA;A/E+2oCR;;A6Ft4oCE;EdnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eg6oCF;AI5xoCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Ey6oCzG;A+E75oCE;EAII,yHAAA;A/E45oCN;A+Er5oCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH01oCf;A+En5oCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/Es7oC7L;A+E94oCI;EAGI,sFAAA;A/E84oCR;;A6Fr6oCE;EdnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+7oCF;AI3zoCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Ew8oCzG;A+E57oCE;EAII,wHAAA;A/E27oCN;A+Ep7oCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHy3oCf;A+El7oCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Eq9oC7L;A+E76oCI;EAGI,qFAAA;A/E66oCR;;A6Fp8oCE;EdnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E89oCF;AI11oCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Eu+oCzG;A+E39oCE;EAII,yHAAA;A/E09oCN;A+En9oCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHw5oCf;A+Ej9oCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Eo/oC7L;A+E58oCI;EAGI,sFAAA;A/E48oCR;;A6Fn+oCE;EdnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6/oCF;AIz3oCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EsgpCzG;A+E1/oCE;EAII,wHAAA;A/Ey/oCN;A+El/oCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHu7oCf;A+Eh/oCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EmhpC7L;A+E3+oCI;EAGI,qFAAA;A/E2+oCR;;A6FlgpCE;EdnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4hpCF;AIx5oCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EqipCzG;A+EzhpCE;EAII,0HAAA;A/EwhpCN;A+EjhpCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHs9oCf;A+E/gpCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EkjpC7L;A+E1gpCI;EAGI,uFAAA;A/E0gpCR;;A6FjipCE;EdnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2jpCF;AIv7oCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EokpCzG;A+ExjpCE;EAII,uHAAA;A/EujpCN;A+EhjpCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHq/oCf;A+E9ipCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EilpC7L;A+EzipCI;EAGI,oFAAA;A/EyipCR;;A6F1jpCE;EdzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0lpCF;AIt9oCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EmmpCzG;A+EvlpCE;EAII,0HAAA;A/EslpCN;A+E/kpCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHohpCf;A+E7kpCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EgnpC7L;A+ExkpCI;EAGI,uFAAA;A/EwkpCR;;A6FzlpCE;EdzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EynpCF;AIr/oCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EkopCzG;A+EtnpCE;EAII,wHAAA;A/EqnpCN;A+E9mpCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmjpCf;A+E5mpCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E+opC7L;A+EvmpCI;EAGI,qFAAA;A/EumpCR;;A6FxnpCE;EdzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwppCF;AIphpCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EiqpCzG;A+ErppCE;EAII,yHAAA;A/EoppCN;A+E7opCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHklpCf;A+E3opCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E8qpC7L;A+EtopCI;EAGI,sFAAA;A/EsopCR;;A6FvppCE;EdzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EurpCF;AInjpCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EgspCzG;A+EprpCE;EAII,wHAAA;A/EmrpCN;A+E5qpCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHinpCf;A+E1qpCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E6spC7L;A+ErqpCI;EAGI,qFAAA;A/EqqpCR;;A6FtrpCE;EdzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EstpCF;AIllpCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E+tpCzG;A+EntpCE;EAII,yHAAA;A/EktpCN;A+E3spCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgppCf;A+EzspCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E4upC7L;A+EpspCI;EAGI,sFAAA;A/EospCR;;A6FrtpCE;EdzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqvpCF;AIjnpCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E8vpCzG;A+ElvpCE;EAII,wHAAA;A/EivpCN;A+E1upCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+qpCf;A+ExupCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E2wpC7L;A+EnupCI;EAGI,qFAAA;A/EmupCR;;A6FpvpCE;EdzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EoxpCF;AIhppCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E6xpCzG;A+EjxpCE;EAII,0HAAA;A/EgxpCN;A+EzwpCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8spCf;A+EvwpCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E0ypC7L;A+ElwpCI;EAGI,uFAAA;A/EkwpCR;;A6FnxpCE;EdzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmzpCF;AI/qpCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E4zpCzG;A+EhzpCE;EAII,uHAAA;A/E+ypCN;A+ExypCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6upCf;A+EtypCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Ey0pC7L;A+EjypCI;EAGI,oFAAA;A/EiypCR;;A6F5ypCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4vpCf;A+E1xpCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHiwpCf;A+EzxpCE;EAEE,iDAAA;A/E0xpCJ;A+EvxpCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwxpCJ;A+ErxpCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6wpCf;A+EnxpCI;EAGI,uFAAA;A/EmxpCR;;A6Fv0pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHuxpCf;A+ErzpCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4xpCf;A+EpzpCE;EAEE,+CAAA;A/EqzpCJ;A+ElzpCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmzpCJ;A+EhzpCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwypCf;A+E9ypCI;EAGI,qFAAA;A/E8ypCR;;A6Fl2pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHkzpCf;A+Eh1pCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHuzpCf;A+E/0pCE;EAEE,gDAAA;A/Eg1pCJ;A+E70pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E80pCJ;A+E30pCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm0pCf;A+Ez0pCI;EAGI,sFAAA;A/Ey0pCR;;A6F73pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH60pCf;A+E32pCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk1pCf;A+E12pCE;EAEE,+CAAA;A/E22pCJ;A+Ex2pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey2pCJ;A+Et2pCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH81pCf;A+Ep2pCI;EAGI,qFAAA;A/Eo2pCR;;A6Fx5pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw2pCf;A+Et4pCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH62pCf;A+Er4pCE;EAEE,gDAAA;A/Es4pCJ;A+En4pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eo4pCJ;A+Ej4pCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy3pCf;A+E/3pCI;EAGI,sFAAA;A/E+3pCR;;A6Fn7pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm4pCf;A+Ej6pCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHw4pCf;A+Eh6pCE;EAEE,+CAAA;A/Ei6pCJ;A+E95pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+5pCJ;A+E55pCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo5pCf;A+E15pCI;EAGI,qFAAA;A/E05pCR;;A6F98pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH85pCf;A+E57pCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHm6pCf;A+E37pCE;EAEE,iDAAA;A/E47pCJ;A+Ez7pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E07pCJ;A+Ev7pCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+6pCf;A+Er7pCI;EAGI,uFAAA;A/Eq7pCR;;A6Fz+pCE;EdoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy7pCf;A+Ev9pCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH87pCf;A+Et9pCE;EAEE,8CAAA;A/Eu9pCJ;A+Ep9pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq9pCJ;A+El9pCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH08pCf;A+Eh9pCI;EAGI,oFAAA;A/Eg9pCR;;A6F1/pCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo9pCf;A+El/pCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHy9pCf;A+Ej/pCE;EAEE,iDAAA;A/Ek/pCJ;A+E/+pCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg/pCJ;A+E7+pCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq+pCf;A+E3+pCI;EAGI,uFAAA;A/E2+pCR;;A6FrhqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH++pCf;A+E7gqCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHo/pCf;A+E5gqCE;EAEE,+CAAA;A/E6gqCJ;A+E1gqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2gqCJ;A+ExgqCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHggqCf;A+EtgqCI;EAGI,qFAAA;A/EsgqCR;;A6FhjqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0gqCf;A+ExiqCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+gqCf;A+EviqCE;EAEE,gDAAA;A/EwiqCJ;A+EriqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EsiqCJ;A+EniqCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2hqCf;A+EjiqCI;EAGI,sFAAA;A/EiiqCR;;A6F3kqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqiqCf;A+EnkqCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0iqCf;A+ElkqCE;EAEE,+CAAA;A/EmkqCJ;A+EhkqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EikqCJ;A+E9jqCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHsjqCf;A+E5jqCI;EAGI,qFAAA;A/E4jqCR;;A6FtmqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgkqCf;A+E9lqCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqkqCf;A+E7lqCE;EAEE,gDAAA;A/E8lqCJ;A+E3lqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4lqCJ;A+EzlqCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHilqCf;A+EvlqCI;EAGI,sFAAA;A/EulqCR;;A6FjoqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2lqCf;A+EznqCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgmqCf;A+ExnqCE;EAEE,+CAAA;A/EynqCJ;A+EtnqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EunqCJ;A+EpnqCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4mqCf;A+ElnqCI;EAGI,qFAAA;A/EknqCR;;A6F5pqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsnqCf;A+EppqCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH2nqCf;A+EnpqCE;EAEE,iDAAA;A/EopqCJ;A+EjpqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkpqCJ;A+E/oqCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuoqCf;A+E7oqCI;EAGI,uFAAA;A/E6oqCR;;A6FvrqCE;EdUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHipqCf;A+E/qqCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHspqCf;A+E9qqCE;EAEE,8CAAA;A/E+qqCJ;A+E5qqCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6qqCJ;A+E1qqCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkqqCf;A+ExqqCI;EAGI,oFAAA;A/EwqqCR;;A6FzsqCA;;EAEE,cAzDsB;EA0DtB,qBA1DsB;A7FswqCxB;A6F1sqCE;;;;;;;;EAOE,WxF1DI;EwF2DJ,qBApEoB;EAqEpB,yBArEoB;A7FkxqCxB;;A6FzsqCA;;EAEE,cA1EoB;EA2EpB,qBA3EoB;A7FuxqCtB;A6F1sqCE;;;;;;;;EAOE,WxF5EI;EwF6EJ,qBArFkB;EAsFlB,yBAtFkB;A7FmyqCtB;;A6FvsqCE;EAEE,cA/FoB;A7FwyqCxB;A6FxsqCI;EAEE,yDAAA;A7FysqCN;A6FrsqCE;EACE,yBAAA;A7FusqCJ;A6FpsqCE;EACE,cA3GoB;A7FizqCxB;A6FrsqCI;EAEE,cA9GkB;A7FozqCxB;A6FlsqCE;EAEE,oCAAA;EACA,sBAAA;A7FmsqCJ;A6FhsqCE;EAIE,yBA5HoB;EA6HpB,qBA7HoB;EA8HpB,WxFrHI;ALozqCR;A6F7rqCI;EAGE,+EAAA;EACA,2EAAA;EACA,sBAAA;A7F6rqCN;A6FxrqCI;EACE,oCAAA;A7F0rqCN;A6FvrqCI;EACE,oCAAA;A7FyrqCN;A6FtrqCI;EACE,oCAAA;A7FwrqCN;A6FrrqCI;EACE,oCAAA;A7FurqCN;A6FprqCI;EACE,oCAAA;A7FsrqCN;A6FnrqCI;EACE,oCAAA;A7FqrqCN;A6FlrqCI;EACE,oCAAA;A7ForqCN;A6FjrqCI;EACE,oCAAA;A7FmrqCN;A6FhrqCI;EACE,oCAAA;A7FkrqCN;A6F/qqCI;EACE,oCAAA;A7FirqCN;A6F9qqCI;EACE,oCAAA;A7FgrqCN;A6F7qqCI;EACE,oCAAA;A7F+qqCN;;A6FxqqCE;EACE,cA9LkB;A7Fy2qCtB;A6F1qqCI;EAEE,6CAAA;A7F2qqCN;A6FvqqCE;EACE,yBAAA;A7FyqqCJ;A6FtqqCE;EAEE,oCAAA;EACA,sBAAA;A7FuqqCJ;A6FpqqCE;EACE,yBAhNkB;EAiNlB,qBAjNkB;EAkNlB,WxF1MI;ALg3qCR;A6FpqqCI;EAGE,0DAAA;EACA,sDAAA;EACA,sBAAA;A7FoqqCN;;A6F9pqCA;EACE,wCAAA;EACA,sBAAA;A7FiqqCF;A6FhqqCE;EAGE,oCAAA;EACA,sBAAA;A7FgqqCJ;;A6F5pqCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A7F+pqCF;A6F7pqCE;EAEE,qDAAA;EACA,yBAAA;A7F8pqCJ;;A6FzpqCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A7F4pqCJ;A6F1pqCI;EAEE,sDAAA;EACA,sBAAA;A7F2pqCN;;A6FtpqCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A7FypqCF;A6FvpqCE;EAEE,qDAAA;EACA,yBAAA;A7FwpqCJ;;A6FnpqCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A7FspqCJ;A6FppqCI;EAEE,sDAAA;EACA,sBAAA;A7FqpqCN;;A6F/oqCA;EACE,oCAAA;EACA,WxFzRM;EwF0RN,qBAnSsB;A7Fq7qCxB;A6FhpqCE;EACE,oEAAA;A7FkpqCJ;A6FhpqCI;EACI,WxFhSA;ALk7qCR;A6F/oqCI;EACE,sBxFpSE;ALq7qCR;A6F/oqCM;EACE,+BAAA;A7FipqCR;A6F3oqCI;EADF;IAEI,sBxF9SE;EL47qCN;E6F5oqCI;IACE,+BAAA;E7F8oqCN;AACF;A6F1oqCE;EACE,iCAAA;A7F4oqCJ;;A6FxoqCA;EACE,sBxF5TM;ALu8qCR;;A6FxoqCA;EACE,WxFhUM;AL28qCR;;A6FvoqCA;EACE,yBAAA;A7F0oqCF;;A6FvoqCA;EACE;IACE,yBAAA;E7F0oqCF;E6FvoqCA;IACE,wBAAA;E7FyoqCF;AACF;A6FtoqCA;EACE,wBAAA;A7FwoqCF;;A6FroqCA;EACE;IACE,wBAAA;E7FwoqCF;AACF;A6FpoqCA;EACE,yBAvWsB;A7F6+qCxB;;A6FjoqCA;EACE,qBAAA;EACA,0CAzWoB;A7F6+qCtB;;A6FjoqCA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;A7FooqCF;A6FloqCE;EACE,0CAlXkB;EAmXlB,kBAAA;EACA,UAAA;A7FooqCJ;A6FjoqCE;EACE,qBAAA;A7FmoqCJ;A6F/nqCI;EACE,WxFzXE;AL0/qCR;;A6F5nqCA;EACE,cApYuB;A7FmgrCzB;;A6F3nqCE;EACE,cAzYqB;A7FugrCzB;;A6F1nqCA;;;EAGE,0CA/YoB;EAgZpB,WxF5YM;ALygrCR;;A6F1nqCA;EACE,qBAzZsB;A7FshrCxB;;A6F1nqCA;;EAEE,WxFrZM;ALkhrCR;;A6F1nqCA;EACE,0CA7ZoB;A7F0hrCtB;;A6F1nqCA;EACE,cAlauB;A7F+hrCzB;;A6F1nqCA;;;EAGE,WxFnaM;ALgirCR;;A6F1nqCA;EACE,cA5auB;A7FyirCzB;;A6F1nqCA;EACE,yBApbsB;A7FijrCxB;;A6F1nqCA;;;;;EAKE,0CAvboB;EAwbpB,WxFpbM;ALijrCR;;A6F1nqCA,2BAAA;AAGI;EAEE,cArckB;A7F+jrCxB;A6FvnqCI;EACE,W1F/Ye;AHwgrCrB;A6FtnqCI;EAEE,cA9ckB;A7FqkrCxB;A6FnnqCE;EACE,WxF1cI;AL+jrCR;A6FlnqCE;EAKE,cA1dkB;A7F0krCtB;A6F5mqCI;EAEE,cAjekB;A7F8krCxB;A6FxmqCI;EACE,W1F7ae;AHuhrCrB;A6FrmqCM;EACE,cA7egB;A7FolrCxB;A6FnmqCI;EAGE,cApfkB;A7FulrCxB;;A6F9lqCA;EACE,oCAAA;EACA,qBAxfkB;A7FylrCpB;A6F/lqCI;EACE,WxFrfE;ALslrCR;A6F9lqCI;EAKE,cArgBgB;A7FimrCtB;;A6FplqCI;EACE,qBA/gBkB;A7FsmrCxB;;A6FjlqCA;EACE,yBAthBsB;A7F0mrCxB;;A6FjlqCA;EACE,oEAAA;A7FolqCF;;A6FjlqCA;EACE,yCAAA;A7FolqCF;;A6FjlqCA;;EAEE,yCAAA;EACA,qBApiBsB;A7FwnrCxB;;A6FjlqCA;;;;EAIE,yCAAA;EACA,qBA5iBsB;A7FgorCxB;;A6FjlqCA;EACE,yCAAA;EACA,qBAjjBsB;A7FqorCxB;;A6FjlqCA;EACE,yCAAA;EACA,qBAtjBsB;A7F0orCxB;;A6FjlqCA;EACE,qBA1jBsB;A7F8orCxB;;A6FhlqCA;EACE,cA/jBsB;A7FkprCxB;;A6F/kqCE;EAEE,qEAAA;A7FilqCJ;;A6F3kqCE;EACE,cA5kBoB;A7F0prCxB;;A6FzkqCA;EACE,mBAllBsB;A7F8prCxB;;A6FxkqCE;EAGE,cAzlBoB;A7FkqrCxB;;A6FlkqCE;EACE,qBAjmBoB;A7FsqrCxB;;A6F/jqCE;EACE,qBAxmBoB;A7F0qrCxB;A6FhkqCI;EAGE,yBA7mBkB;A7F6qrCxB;;A6FzjqCE;EACE,cArnBoB;A7FirrCxB;;A6FvjqCE;EAGE,cA5nBkB;A7ForrCtB;;A6FnjqCA;EACE,cAloBoB;A7FwrrCtB;;A6FnjqCA;EACE,2CAAA;A7FsjqCF;;A6FjjqCA;EACE,gCAAA;A7FojqCF;;A6F/iqCA;EACE,yBAnpBsB;A7FqsrCxB;;A6F9iqCE;EACE,yBAAA;EACA,cAzpBoB;A7F0srCxB;A6F/iqCI;EAEE,WxFppBE;EwFqpBF,yBA9pBkB;A7F8srCxB;;A6FviqCI;;;;EACE,yBAxqBkB;EAyqBlB,qBAzqBkB;A7FstrCxB;A6FxiqCE;;EACE,yBAAA;A7F2iqCJ;A6F1iqCI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A7F6iqCN;A6F3iqCM;;;EAEE,qDAAA;EACA,yBAAA;A7F8iqCR;;A6FviqCE;EACE,yBAhsBoB;EAisBpB,qBAjsBoB;A7F2urCxB;;A6FtiqCA;;EAEE,cAvsBsB;A7FgvrCxB;;A6FtiqCA,4BAAA;AACA,0DAAA,wBAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,iDAAA,gBAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,qDAAA,WAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,gDAAA,gBAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,qEAAA,wBAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,4DAAA,gBAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,gEAAA,WAAA;EACE,+BAAA;A7FyiqCF;;A6FtiqCA,2DAAA,gBAAA;EACE,+BAAA;A7FyiqCF;;A8FlxrCA,gCAAA;AAcA;EACE,cAd6B;A9FsxrC/B;A8FvwrCE;EACE,cAhB2B;A9FyxrC/B;;A8FjwrCE;EfnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2xrCF;AIvprCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EoyrCzG;A+ExxrCE;EAII,0HAAA;A/EuxrCN;A+EhxrCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqtrCf;A+E9wrCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EizrC7L;A+EzwrCI;EAGI,uFAAA;A/EywrCR;;A8FhyrCE;EfnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0zrCF;AItrrCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Em0rCzG;A+EvzrCE;EAII,wHAAA;A/EszrCN;A+E/yrCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHovrCf;A+E7yrCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eg1rC7L;A+ExyrCI;EAGI,qFAAA;A/EwyrCR;;A8F/zrCE;EfnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ey1rCF;AIrtrCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/Ek2rCzG;A+Et1rCE;EAII,yHAAA;A/Eq1rCN;A+E90rCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmxrCf;A+E50rCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E+2rC7L;A+Ev0rCI;EAGI,sFAAA;A/Eu0rCR;;A8F91rCE;EfnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ew3rCF;AIpvrCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/Ei4rCzG;A+Er3rCE;EAII,wHAAA;A/Eo3rCN;A+E72rCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkzrCf;A+E32rCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E84rC7L;A+Et2rCI;EAGI,qFAAA;A/Es2rCR;;A8F73rCE;EfnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu5rCF;AInxrCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Eg6rCzG;A+Ep5rCE;EAII,yHAAA;A/Em5rCN;A+E54rCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHi1rCf;A+E14rCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E66rC7L;A+Er4rCI;EAGI,sFAAA;A/Eq4rCR;;A8F55rCE;EfnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es7rCF;AIlzrCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E+7rCzG;A+En7rCE;EAII,wHAAA;A/Ek7rCN;A+E36rCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHg3rCf;A+Ez6rCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E48rC7L;A+Ep6rCI;EAGI,qFAAA;A/Eo6rCR;;A8F37rCE;EfnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq9rCF;AIj1rCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E89rCzG;A+El9rCE;EAII,0HAAA;A/Ei9rCN;A+E18rCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+4rCf;A+Ex8rCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E2+rC7L;A+En8rCI;EAGI,uFAAA;A/Em8rCR;;A8F19rCE;EfnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo/rCF;AIh3rCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E6/rCzG;A+Ej/rCE;EAII,uHAAA;A/Eg/rCN;A+Ez+rCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH86rCf;A+Ev+rCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E0gsC7L;A+El+rCI;EAGI,oFAAA;A/Ek+rCR;;A8Fn/rCE;EfzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmhsCF;AI/4rCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E4hsCzG;A+EhhsCE;EAII,0HAAA;A/E+gsCN;A+ExgsCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH68rCf;A+EtgsCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EyisC7L;A+EjgsCI;EAGI,uFAAA;A/EigsCR;;A8FlhsCE;EfzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EkjsCF;AI96rCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E2jsCzG;A+E/isCE;EAII,wHAAA;A/E8isCN;A+EvisCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4+rCf;A+ErisCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EwksC7L;A+EhisCI;EAGI,qFAAA;A/EgisCR;;A8FjjsCE;EfzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EilsCF;AI78rCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E0lsCzG;A+E9ksCE;EAII,yHAAA;A/E6ksCN;A+EtksCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2gsCf;A+EpksCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EumsC7L;A+E/jsCI;EAGI,sFAAA;A/E+jsCR;;A8FhlsCE;EfzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgnsCF;AI5+rCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EynsCzG;A+E7msCE;EAII,wHAAA;A/E4msCN;A+ErmsCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0isCf;A+EnmsCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EsosC7L;A+E9lsCI;EAGI,qFAAA;A/E8lsCR;;A8F/msCE;EfzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+osCF;AI3gsCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EwpsCzG;A+E5osCE;EAII,yHAAA;A/E2osCN;A+EposCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyksCf;A+ElosCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EqqsC7L;A+E7nsCI;EAGI,sFAAA;A/E6nsCR;;A8F9osCE;EfzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8qsCF;AI1isCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EursCzG;A+E3qsCE;EAII,wHAAA;A/E0qsCN;A+EnqsCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwmsCf;A+EjqsCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EossC7L;A+E5psCI;EAGI,qFAAA;A/E4psCR;;A8F7qsCE;EfzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6ssCF;AIzksCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EstsCzG;A+E1ssCE;EAII,0HAAA;A/EyssCN;A+ElssCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHuosCf;A+EhssCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EmusC7L;A+E3rsCI;EAGI,uFAAA;A/E2rsCR;;A8F5ssCE;EfzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4usCF;AIxmsCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EqvsCzG;A+EzusCE;EAII,uHAAA;A/EwusCN;A+EjusCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHsqsCf;A+E/tsCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EkwsC7L;A+E1tsCI;EAGI,oFAAA;A/E0tsCR;;A8FrusCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqrsCf;A+EntsCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0rsCf;A+EltsCE;EAEE,iDAAA;A/EmtsCJ;A+EhtsCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EitsCJ;A+E9ssCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHsssCf;A+E5ssCI;EAGI,uFAAA;A/E4ssCR;;A8FhwsCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgtsCf;A+E9usCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHqtsCf;A+E7usCE;EAEE,+CAAA;A/E8usCJ;A+E3usCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4usCJ;A+EzusCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHiusCf;A+EvusCI;EAGI,qFAAA;A/EuusCR;;A8F3xsCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2usCf;A+EzwsCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgvsCf;A+ExwsCE;EAEE,gDAAA;A/EywsCJ;A+EtwsCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EuwsCJ;A+EpwsCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4vsCf;A+ElwsCI;EAGI,sFAAA;A/EkwsCR;;A8FtzsCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHswsCf;A+EpysCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2wsCf;A+EnysCE;EAEE,+CAAA;A/EoysCJ;A+EjysCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkysCJ;A+E/xsCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuxsCf;A+E7xsCI;EAGI,qFAAA;A/E6xsCR;;A8Fj1sCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHiysCf;A+E/zsCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHsysCf;A+E9zsCE;EAEE,gDAAA;A/E+zsCJ;A+E5zsCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6zsCJ;A+E1zsCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkzsCf;A+ExzsCI;EAGI,sFAAA;A/EwzsCR;;A8F52sCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4zsCf;A+E11sCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHi0sCf;A+Ez1sCE;EAEE,+CAAA;A/E01sCJ;A+Ev1sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ew1sCJ;A+Er1sCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH60sCf;A+En1sCI;EAGI,qFAAA;A/Em1sCR;;A8Fv4sCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHu1sCf;A+Er3sCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH41sCf;A+Ep3sCE;EAEE,iDAAA;A/Eq3sCJ;A+El3sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em3sCJ;A+Eh3sCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHw2sCf;A+E92sCI;EAGI,uFAAA;A/E82sCR;;A8Fl6sCE;EfoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk3sCf;A+Eh5sCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHu3sCf;A+E/4sCE;EAEE,8CAAA;A/Eg5sCJ;A+E74sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E84sCJ;A+E34sCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm4sCf;A+Ez4sCI;EAGI,oFAAA;A/Ey4sCR;;A8Fn7sCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH64sCf;A+E36sCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk5sCf;A+E16sCE;EAEE,iDAAA;A/E26sCJ;A+Ex6sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey6sCJ;A+Et6sCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH85sCf;A+Ep6sCI;EAGI,uFAAA;A/Eo6sCR;;A8F98sCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw6sCf;A+Et8sCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH66sCf;A+Er8sCE;EAEE,+CAAA;A/Es8sCJ;A+En8sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eo8sCJ;A+Ej8sCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy7sCf;A+E/7sCI;EAGI,qFAAA;A/E+7sCR;;A8Fz+sCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHm8sCf;A+Ej+sCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHw8sCf;A+Eh+sCE;EAEE,gDAAA;A/Ei+sCJ;A+E99sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+9sCJ;A+E59sCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHo9sCf;A+E19sCI;EAGI,sFAAA;A/E09sCR;;A8FpgtCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH89sCf;A+E5/sCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHm+sCf;A+E3/sCE;EAEE,+CAAA;A/E4/sCJ;A+Ez/sCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0/sCJ;A+Ev/sCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH++sCf;A+Er/sCI;EAGI,qFAAA;A/Eq/sCR;;A8F/htCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy/sCf;A+EvhtCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8/sCf;A+EthtCE;EAEE,gDAAA;A/EuhtCJ;A+EphtCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqhtCJ;A+ElhtCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0gtCf;A+EhhtCI;EAGI,sFAAA;A/EghtCR;;A8F1jtCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHohtCf;A+EljtCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHyhtCf;A+EjjtCE;EAEE,+CAAA;A/EkjtCJ;A+E/itCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EgjtCJ;A+E7itCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqitCf;A+E3itCI;EAGI,qFAAA;A/E2itCR;;A8FrltCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+itCf;A+E7ktCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHojtCf;A+E5ktCE;EAEE,iDAAA;A/E6ktCJ;A+E1ktCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2ktCJ;A+ExktCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgktCf;A+EtktCI;EAGI,uFAAA;A/EsktCR;;A8FhntCE;EfUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0ktCf;A+ExmtCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+ktCf;A+EvmtCE;EAEE,8CAAA;A/EwmtCJ;A+ErmtCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EsmtCJ;A+EnmtCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2ltCf;A+EjmtCI;EAGI,oFAAA;A/EimtCR;;A8FlotCA;;EAEE,cAzD6B;EA0D7B,qBA1D6B;A9F+rtC/B;A8FnotCE;;;;;;;;EAOE,WzF1DI;EyF2DJ,qBApE2B;EAqE3B,yBArE2B;A9F2stC/B;;A8FlotCA;;EAEE,cA1E2B;EA2E3B,qBA3E2B;A9FgttC7B;A8FnotCE;;;;;;;;EAOE,WzF5EI;EyF6EJ,qBArFyB;EAsFzB,yBAtFyB;A9F4ttC7B;;A8FhotCE;EAEE,cA/F2B;A9FiutC/B;A8FjotCI;EAEE,wDAAA;A9FkotCN;A8F9ntCE;EACE,yBAAA;A9FgotCJ;A8F7ntCE;EACE,cA3G2B;A9F0utC/B;A8F9ntCI;EAEE,cA9GyB;A9F6utC/B;A8F3ntCE;EAEE,oCAAA;EACA,sBAAA;A9F4ntCJ;A8FzntCE;EAIE,yBA5H2B;EA6H3B,qBA7H2B;EA8H3B,WzFrHI;AL6utCR;A8FtntCI;EAGE,6EAAA;EACA,yEAAA;EACA,sBAAA;A9FsntCN;A8FlntCI;EACE,oCAAA;A9FontCN;A8FjntCI;EACE,oCAAA;A9FmntCN;A8FhntCI;EACE,oCAAA;A9FkntCN;A8F/mtCI;EACE,oCAAA;A9FintCN;A8F9mtCI;EACE,oCAAA;A9FgntCN;A8F7mtCI;EACE,oCAAA;A9F+mtCN;A8F5mtCI;EACE,oCAAA;A9F8mtCN;A8F3mtCI;EACE,oCAAA;A9F6mtCN;A8F1mtCI;EACE,oCAAA;A9F4mtCN;A8FzmtCI;EACE,oCAAA;A9F2mtCN;A8FxmtCI;EACE,oCAAA;A9F0mtCN;A8FvmtCI;EACE,oCAAA;A9FymtCN;;A8FlmtCE;EACE,cA7LyB;A9FkytC7B;A8FpmtCI;EAEE,oCAAA;A9FqmtCN;A8FjmtCE;EACE,yBAAA;A9FmmtCJ;A8FhmtCE;EAEE,oCAAA;EACA,sBAAA;A9FimtCJ;A8F9ltCE;EACE,yBA/MyB;EAgNzB,qBAhNyB;EAiNzB,WzFzMI;ALyytCR;A8F9ltCI;EAGE,iDAAA;EACA,6CAAA;EACA,sBAAA;A9F8ltCN;;A8FxltCA;EACE,wCAAA;EACA,sBAAA;A9F2ltCF;A8F1ltCE;EAGE,oCAAA;EACA,sBAAA;A9F0ltCJ;;A8FtltCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A9FyltCF;A8FvltCE;EAEE,qDAAA;EACA,yBAAA;A9FwltCJ;;A8FnltCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A9FsltCJ;A8FpltCI;EAEE,sDAAA;EACA,sBAAA;A9FqltCN;;A8FhltCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A9FmltCF;A8FjltCE;EAEE,oDAAA;EACA,yBAAA;A9FkltCJ;;A8F7ktCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A9FgltCJ;A8F9ktCI;EAEE,sDAAA;EACA,sBAAA;A9F+ktCN;;A8F1ktCA;EACE,oCAAA;EACA,WzFvRM;EyFwRN,qBAjS6B;A9F82tC/B;A8F3ktCE;EACE,kEAAA;A9F6ktCJ;A8F3ktCI;EACE,WzF9RE;AL22tCR;A8F1ktCI;EACE,sBzFlSE;AL82tCR;A8F3ktCM;EACE,+BAAA;A9F6ktCR;A8FvktCI;EADF;IAEI,sBzF3SE;ELq3tCN;E8FxktCI;IACE,+BAAA;E9F0ktCN;AACF;A8FtktCE;EACE,iCAAA;A9FwktCJ;;A8FpktCA;EACE,sBzFzTM;ALg4tCR;;A8FpktCA;EACE,WzF7TM;ALo4tCR;;A8FnktCA;EACE,yBAAA;A9FsktCF;;A8FnktCA;EACE;IACE,yBAAA;E9FsktCF;E8FnktCA;IACE,wBAAA;E9FqktCF;AACF;A8FlktCA;EACE,wBAAA;A9FoktCF;;A8FjktCA;EACE;IACE,wBAAA;E9FoktCF;AACF;A8FhktCA;EACE,yBApW6B;A9Fs6tC/B;;A8F7jtCA;EACE,qBAAA;EACA,0CAtW2B;A9Fs6tC7B;;A8F7jtCA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;A9FgktCF;A8F9jtCE;EACE,0CA/WyB;EAgXzB,kBAAA;EACA,UAAA;A9FgktCJ;A8F7jtCE;EACE,qBAAA;A9F+jtCJ;A8F3jtCI;EACE,WzFtXE;ALm7tCR;;A8FxjtCA;EACE,cAjY8B;A9F47tChC;;A8FvjtCE;EACE,cAtY4B;A9Fg8tChC;;A8FtjtCA;;;EAGE,0CA5Y2B;EA6Y3B,WzFzYM;ALk8tCR;;A8FtjtCA;EACE,qBArZ2B;A9F88tC7B;;A8FtjtCA;;EAEE,WzFlZM;AL28tCR;;A8FtjtCA;EACE,0CA1Z2B;A9Fm9tC7B;;A8FtjtCA;EACE,cA/Z8B;A9Fw9tChC;;A8FtjtCA;;;EAGE,WzFhaM;ALy9tCR;;A8FtjtCA;EACE,cAza8B;A9Fk+tChC;;A8FtjtCA;EACE,yBAjb6B;A9F0+tC/B;;A8FtjtCA;;;;;EAKE,0CApb2B;EAqb3B,WzFjbM;AL0+tCR;;A8FtjtCA,2BAAA;AAGI;EAEE,cAlcyB;A9Fw/tC/B;A8FnjtCI;EACE,W3F5Ye;AHi8tCrB;A8FljtCI;EAEE,cA3cyB;A9F8/tC/B;A8F/itCE;EACE,WzFvcI;ALw/tCR;A8F9itCE;EAKE,cAvdyB;A9FmguC7B;A8FxitCI;EAEE,cA9dyB;A9FuguC/B;A8FpitCI;EACE,W3F1ae;AHg9tCrB;A8FjitCM;EACE,cA1euB;A9F6guC/B;A8F/htCI;EAGE,cAjfyB;A9FghuC/B;;A8F1htCA;EACE,oCAAA;EACA,qBAjf4B;A9F8guC9B;A8F3htCI;EACE,WzFlfE;AL+guCR;A8F1htCI;EAKE,cAlgBuB;A9F0huC7B;;A8FhhtCI;EACE,qBA5gByB;A9F+huC/B;;A8F7gtCA;EACE,yBAnhB6B;A9FmiuC/B;;A8F7gtCA;EACE,mEAAA;A9FghtCF;;A8F7gtCA;EACE,yCAAA;A9FghtCF;;A8F7gtCA;;EAEE,yCAAA;EACA,qBAjiB6B;A9FijuC/B;;A8F7gtCA;;;;EAIE,yCAAA;EACA,qBAziB6B;A9FyjuC/B;;A8F7gtCA;EACE,yCAAA;EACA,qBA9iB6B;A9F8juC/B;;A8F7gtCA;EACE,yCAAA;EACA,qBAnjB6B;A9FmkuC/B;;A8F7gtCA;EACE,qBAvjB6B;A9FukuC/B;;A8F5gtCA;EACE,cA5jB6B;A9F2kuC/B;;A8F3gtCE;EAEE,qEAAA;A9F6gtCJ;;A8FvgtCE;EACE,cAzkB2B;A9FmluC/B;;A8FrgtCA;EACE,mBA/kB6B;A9FuluC/B;;A8FpgtCE;EAGE,cAtlB2B;A9F2luC/B;;A8F//sCE;EACE,qBA7lB2B;A9F+luC/B;;A8F5/sCE;EACE,qBApmB2B;A9FmmuC/B;A8F7/sCI;EAGE,yBAzmByB;A9FsmuC/B;;A8Ft/sCE;EACE,cAjnB2B;A9F0muC/B;;A8Fp/sCE;EAGE,cAxnByB;A9F6muC7B;;A8Fh/sCA;EACE,cA9nB2B;A9FinuC7B;;A8Fh/sCA;EACE,2CAAA;A9Fm/sCF;;A8F9+sCA;EACE,gCAAA;A9Fi/sCF;;A8F5+sCA;EACE,yBA/oB6B;A9F8nuC/B;;A8F3+sCE;EACE,yBAAA;EACA,cArpB2B;A9FmouC/B;A8F5+sCI;EAEE,WzFhpBE;EyFipBF,yBA1pByB;A9FuouC/B;;A8Fp+sCI;;;;EACE,yBApqByB;EAqqBzB,qBArqByB;A9F+ouC/B;A8Fr+sCE;;EACE,yBAAA;A9Fw+sCJ;A8Fv+sCI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A9F0+sCN;A8Fx+sCM;;;EAEE,qDAAA;EACA,yBAAA;A9F2+sCR;;A8Fp+sCE;EACE,yBA5rB2B;EA6rB3B,qBA7rB2B;A9FoquC/B;;A8Fn+sCA;;EAEE,cAnsB6B;A9FyquC/B;;A8Fn+sCA,4BAAA;AACA,iEAAA,wBAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,wDAAA,gBAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,4DAAA,WAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,uDAAA,gBAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,4EAAA,wBAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,mEAAA,gBAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,uEAAA,WAAA;EACE,+BAAA;A9Fs+sCF;;A8Fn+sCA,kEAAA,gBAAA;EACE,+BAAA;A9Fs+sCF;;A+F3suCA,0BAAA;AAcA;EACE,cAduB;A/F+suCzB;A+FhsuCE;EACE,cAhBqB;A/FktuCzB;;A+F1ruCE;EhBnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EotuCF;AIhluCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/E6tuCzG;A+EjtuCE;EAII,0HAAA;A/EgtuCN;A+EzsuCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH8ouCf;A+EvsuCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E0uuC7L;A+ElsuCI;EAGI,uFAAA;A/EksuCR;;A+FztuCE;EhBnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EmvuCF;AI/muCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E4vuCzG;A+EhvuCE;EAII,wHAAA;A/E+uuCN;A+ExuuCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH6quCf;A+EtuuCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EywuC7L;A+EjuuCI;EAGI,qFAAA;A/EiuuCR;;A+FxvuCE;EhBnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EkxuCF;AI9ouCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E2xuCzG;A+E/wuCE;EAII,yHAAA;A/E8wuCN;A+EvwuCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH4suCf;A+ErwuCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EwyuC7L;A+EhwuCI;EAGI,sFAAA;A/EgwuCR;;A+FvxuCE;EhBnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EizuCF;AI7quCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E0zuCzG;A+E9yuCE;EAII,wHAAA;A/E6yuCN;A+EtyuCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH2uuCf;A+EpyuCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/Eu0uC7L;A+E/xuCI;EAGI,qFAAA;A/E+xuCR;;A+FtzuCE;EhBnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eg1uCF;AI5suCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/Ey1uCzG;A+E70uCE;EAII,yHAAA;A/E40uCN;A+Er0uCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH0wuCf;A+En0uCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/Es2uC7L;A+E9zuCI;EAGI,sFAAA;A/E8zuCR;;A+Fr1uCE;EhBnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+2uCF;AI3uuCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Ew3uCzG;A+E52uCE;EAII,wHAAA;A/E22uCN;A+Ep2uCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHyyuCf;A+El2uCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Eq4uC7L;A+E71uCI;EAGI,qFAAA;A/E61uCR;;A+Fp3uCE;EhBnBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E84uCF;AI1wuCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/Eu5uCzG;A+E34uCE;EAII,0HAAA;A/E04uCN;A+En4uCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHw0uCf;A+Ej4uCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Eo6uC7L;A+E53uCI;EAGI,uFAAA;A/E43uCR;;A+Fn5uCE;EhBnBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E66uCF;AIzyuCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/Es7uCzG;A+E16uCE;EAII,uHAAA;A/Ey6uCN;A+El6uCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHu2uCf;A+Eh6uCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/Em8uC7L;A+E35uCI;EAGI,oFAAA;A/E25uCR;;A+F56uCE;EhBzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E48uCF;AIx0uCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/Eq9uCzG;A+Ez8uCE;EAII,0HAAA;A/Ew8uCN;A+Ej8uCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHs4uCf;A+E/7uCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/Ek+uC7L;A+E17uCI;EAGI,uFAAA;A/E07uCR;;A+F38uCE;EhBzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2+uCF;AIv2uCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eo/uCzG;A+Ex+uCE;EAII,wHAAA;A/Eu+uCN;A+Eh+uCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHq6uCf;A+E99uCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EigvC7L;A+Ez9uCI;EAGI,qFAAA;A/Ey9uCR;;A+F1+uCE;EhBzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0gvCF;AIt4uCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EmhvCzG;A+EvgvCE;EAII,yHAAA;A/EsgvCN;A+E//uCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHo8uCf;A+E7/uCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EgivC7L;A+Ex/uCI;EAGI,sFAAA;A/Ew/uCR;;A+FzgvCE;EhBzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EyivCF;AIr6uCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EkjvCzG;A+EtivCE;EAII,wHAAA;A/EqivCN;A+E9hvCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHm+uCf;A+E5hvCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E+jvC7L;A+EvhvCI;EAGI,qFAAA;A/EuhvCR;;A+FxivCE;EhBzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwkvCF;AIp8uCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EilvCzG;A+ErkvCE;EAII,yHAAA;A/EokvCN;A+E7jvCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkgvCf;A+E3jvCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E8lvC7L;A+EtjvCI;EAGI,sFAAA;A/EsjvCR;;A+FvkvCE;EhBzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EumvCF;AIn+uCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EgnvCzG;A+EpmvCE;EAII,wHAAA;A/EmmvCN;A+E5lvCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHiivCf;A+E1lvCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E6nvC7L;A+ErlvCI;EAGI,qFAAA;A/EqlvCR;;A+FtmvCE;EhBzBA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EsovCF;AIlgvCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E+ovCzG;A+EnovCE;EAII,0HAAA;A/EkovCN;A+E3nvCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgkvCf;A+EznvCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/E4pvC7L;A+EpnvCI;EAGI,uFAAA;A/EonvCR;;A+FrovCE;EhBzBA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EqqvCF;AIjivCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E8qvCzG;A+ElqvCE;EAII,uHAAA;A/EiqvCN;A+E1pvCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+lvCf;A+ExpvCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E2rvC7L;A+EnpvCI;EAGI,oFAAA;A/EmpvCR;;A+F9pvCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8mvCf;A+E5ovCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmnvCf;A+E3ovCE;EAEE,iDAAA;A/E4ovCJ;A+EzovCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E0ovCJ;A+EvovCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+nvCf;A+ErovCI;EAGI,uFAAA;A/EqovCR;;A+FzrvCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHyovCf;A+EvqvCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH8ovCf;A+EtqvCE;EAEE,+CAAA;A/EuqvCJ;A+EpqvCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EqqvCJ;A+ElqvCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH0pvCf;A+EhqvCI;EAGI,qFAAA;A/EgqvCR;;A+FptvCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHoqvCf;A+ElsvCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHyqvCf;A+EjsvCE;EAEE,gDAAA;A/EksvCJ;A+E/rvCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EgsvCJ;A+E7rvCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHqrvCf;A+E3rvCI;EAGI,sFAAA;A/E2rvCR;;A+F/uvCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+rvCf;A+E7tvCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHosvCf;A+E5tvCE;EAEE,+CAAA;A/E6tvCJ;A+E1tvCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E2tvCJ;A+ExtvCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHgtvCf;A+EttvCI;EAGI,qFAAA;A/EstvCR;;A+F1wvCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH0tvCf;A+ExvvCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+tvCf;A+EvvvCE;EAEE,gDAAA;A/EwvvCJ;A+ErvvCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EsvvCJ;A+EnvvCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH2uvCf;A+EjvvCI;EAGI,sFAAA;A/EivvCR;;A+FryvCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHqvvCf;A+EnxvCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH0vvCf;A+ElxvCE;EAEE,+CAAA;A/EmxvCJ;A+EhxvCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EixvCJ;A+E9wvCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHswvCf;A+E5wvCI;EAGI,qFAAA;A/E4wvCR;;A+Fh0vCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHgxvCf;A+E9yvCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHqxvCf;A+E7yvCE;EAEE,iDAAA;A/E8yvCJ;A+E3yvCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4yvCJ;A+EzyvCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHiyvCf;A+EvyvCI;EAGI,uFAAA;A/EuyvCR;;A+F31vCE;EhBoBA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2yvCf;A+Ez0vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHgzvCf;A+Ex0vCE;EAEE,8CAAA;A/Ey0vCJ;A+Et0vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eu0vCJ;A+Ep0vCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4zvCf;A+El0vCI;EAGI,oFAAA;A/Ek0vCR;;A+F52vCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHs0vCf;A+Ep2vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH20vCf;A+En2vCE;EAEE,iDAAA;A/Eo2vCJ;A+Ej2vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ek2vCJ;A+E/1vCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHu1vCf;A+E71vCI;EAGI,uFAAA;A/E61vCR;;A+Fv4vCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHi2vCf;A+E/3vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHs2vCf;A+E93vCE;EAEE,+CAAA;A/E+3vCJ;A+E53vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E63vCJ;A+E13vCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHk3vCf;A+Ex3vCI;EAGI,qFAAA;A/Ew3vCR;;A+Fl6vCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH43vCf;A+E15vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHi4vCf;A+Ez5vCE;EAEE,gDAAA;A/E05vCJ;A+Ev5vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ew5vCJ;A+Er5vCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH64vCf;A+En5vCI;EAGI,sFAAA;A/Em5vCR;;A+F77vCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHu5vCf;A+Er7vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH45vCf;A+Ep7vCE;EAEE,+CAAA;A/Eq7vCJ;A+El7vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Em7vCJ;A+Eh7vCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHw6vCf;A+E96vCI;EAGI,qFAAA;A/E86vCR;;A+Fx9vCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHk7vCf;A+Eh9vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHu7vCf;A+E/8vCE;EAEE,gDAAA;A/Eg9vCJ;A+E78vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E88vCJ;A+E38vCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHm8vCf;A+Ez8vCI;EAGI,sFAAA;A/Ey8vCR;;A+Fn/vCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH68vCf;A+E3+vCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHk9vCf;A+E1+vCE;EAEE,+CAAA;A/E2+vCJ;A+Ex+vCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ey+vCJ;A+Et+vCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH89vCf;A+Ep+vCI;EAGI,qFAAA;A/Eo+vCR;;A+F9gwCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHw+vCf;A+EtgwCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AH6+vCf;A+ErgwCE;EAEE,iDAAA;A/EsgwCJ;A+EngwCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EogwCJ;A+EjgwCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHy/vCf;A+E//vCI;EAGI,uFAAA;A/E+/vCR;;A+FziwCE;EhBUA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmgwCf;A+EjiwCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwgwCf;A+EhiwCE;EAEE,8CAAA;A/EiiwCJ;A+E9hwCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+hwCJ;A+E5hwCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHohwCf;A+E1hwCI;EAGI,oFAAA;A/E0hwCR;;A+F3jwCA;;EAEE,cAzDuB;EA0DvB,qBA1DuB;A/FwnwCzB;A+F5jwCE;;;;;;;;EAOE,W1F1DI;E0F2DJ,qBApEqB;EAqErB,yBArEqB;A/FoowCzB;;A+F3jwCA;;EAEE,cA1EqB;EA2ErB,qBA3EqB;A/FyowCvB;A+F5jwCE;;;;;;;;EAOE,W1F5EI;E0F6EJ,qBArFmB;EAsFnB,yBAtFmB;A/FqpwCvB;;A+FzjwCE;EAEE,cA/FqB;A/F0pwCzB;A+F1jwCI;EAEE,wDAAA;A/F2jwCN;A+FvjwCE;EACE,yBAAA;A/FyjwCJ;A+FtjwCE;EACE,cA3GqB;A/FmqwCzB;A+FvjwCI;EAEE,cA9GmB;A/FsqwCzB;A+FpjwCE;EAEE,oCAAA;EACA,sBAAA;A/FqjwCJ;A+FljwCE;EAIE,yBA5HqB;EA6HrB,qBA7HqB;EA8HrB,W1FrHI;ALsqwCR;A+F/iwCI;EAGE,8EAAA;EACA,0EAAA;EACA,sBAAA;A/F+iwCN;A+F1iwCI;EACE,oCAAA;A/F4iwCN;A+FziwCI;EACE,oCAAA;A/F2iwCN;A+FxiwCI;EACE,oCAAA;A/F0iwCN;A+FviwCI;EACE,oCAAA;A/FyiwCN;A+FtiwCI;EACE,oCAAA;A/FwiwCN;A+FriwCI;EACE,oCAAA;A/FuiwCN;A+FpiwCI;EACE,oCAAA;A/FsiwCN;A+FniwCI;EACE,oCAAA;A/FqiwCN;A+FliwCI;EACE,oCAAA;A/FoiwCN;A+FjiwCI;EACE,oCAAA;A/FmiwCN;A+FhiwCI;EACE,oCAAA;A/FkiwCN;A+F/hwCI;EACE,oCAAA;A/FiiwCN;;A+F1hwCE;EACE,cA9LmB;A/F2twCvB;A+F5hwCI;EAEE,mCAAA;A/F6hwCN;A+FzhwCE;EACE,yBAAA;A/F2hwCJ;A+FxhwCE;EAEE,oCAAA;EACA,sBAAA;A/FyhwCJ;A+FthwCE;EACE,yBAhNmB;EAiNnB,qBAjNmB;EAkNnB,W1F1MI;ALkuwCR;A+FthwCI;EAGE,gDAAA;EACA,4CAAA;EACA,sBAAA;A/FshwCN;;A+FhhwCA;EACE,wCAAA;EACA,sBAAA;A/FmhwCF;A+FlhwCE;EAGE,oCAAA;EACA,sBAAA;A/FkhwCJ;;A+F9gwCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A/FihwCF;A+F/gwCE;EAEE,oDAAA;EACA,yBAAA;A/FghwCJ;;A+F3gwCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A/F8gwCJ;A+F5gwCI;EAEE,sDAAA;EACA,sBAAA;A/F6gwCN;;A+FxgwCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;A/F2gwCF;A+FzgwCE;EAEE,oDAAA;EACA,yBAAA;A/F0gwCJ;;A+FrgwCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;A/FwgwCJ;A+FtgwCI;EAEE,sDAAA;EACA,sBAAA;A/FugwCN;;A+FlgwCA;EACE,oCAAA;EACA,W1FxRM;E0FyRN,qBAlSuB;A/FuywCzB;A+FngwCE;EACE,kEAAA;A/FqgwCJ;A+FngwCI;EACE,W1F/RE;ALoywCR;A+FlgwCI;EACE,sB1FnSE;ALuywCR;A+FlgwCM;EACE,+BAAA;A/FogwCR;A+F9/vCI;EADF;IAEI,sB1F7SE;EL8ywCN;E+F//vCI;IACE,+BAAA;E/FigwCN;AACF;A+F7/vCE;EACE,iCAAA;A/F+/vCJ;;A+F3/vCA;EACE,sB1F3TM;ALyzwCR;;A+F3/vCA;EACE,W1F/TM;AL6zwCR;;A+F1/vCA;EACE,yBAAA;A/F6/vCF;;A+F1/vCA;EACE;IACE,yBAAA;E/F6/vCF;E+F1/vCA;IACE,wBAAA;E/F4/vCF;AACF;A+Fz/vCA;EACE,wBAAA;A/F2/vCF;;A+Fx/vCA;EACE;IACE,wBAAA;E/F2/vCF;AACF;A+Fv/vCA;EACE,yBAtWuB;A/F+1wCzB;;A+Fp/vCA;EACE,qBAAA;EACA,0CAxWqB;A/F+1wCvB;;A+Fp/vCA;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;A/Fu/vCF;A+Fr/vCE;EACE,0CAjXmB;EAkXnB,kBAAA;EACA,UAAA;A/Fu/vCJ;A+Fp/vCE;EACE,qBAAA;A/Fs/vCJ;A+Fl/vCI;EACE,W1FxXE;AL42wCR;;A+F/+vCA;EACE,cAnYwB;A/Fq3wC1B;;A+F9+vCE;EACE,cAxYsB;A/Fy3wC1B;;A+F7+vCA;;;EAGE,0CA9YqB;EA+YrB,W1F3YM;AL23wCR;;A+F7+vCA;EACE,qBAxZuB;A/Fw4wCzB;;A+F7+vCA;;EAEE,W1FpZM;ALo4wCR;;A+F7+vCA;EACE,0CA5ZqB;A/F44wCvB;;A+F7+vCA;EACE,cAjawB;A/Fi5wC1B;;A+F7+vCA;;;EAGE,W1FlaM;ALk5wCR;;A+F7+vCA;EACE,cA3awB;A/F25wC1B;;A+F7+vCA;EACE,yBAnbuB;A/Fm6wCzB;;A+F7+vCA;;;;;EAKE,0CAtbqB;EAubrB,W1FnbM;ALm6wCR;;A+F7+vCA,2BAAA;AAGI;EAEE,cApcmB;A/Fi7wCzB;A+F1+vCI;EACE,W5F9Ye;AH03wCrB;A+Fz+vCI;EAEE,cA7cmB;A/Fu7wCzB;A+Ft+vCE;EACE,W1FzcI;ALi7wCR;A+Fr+vCE;EAKE,cAzdmB;A/F47wCvB;A+F/9vCI;EAEE,cAhemB;A/Fg8wCzB;A+F39vCI;EACE,W5F5ae;AHy4wCrB;A+Fx9vCM;EACE,cA5eiB;A/Fs8wCzB;A+Ft9vCI;EAGE,cAnfmB;A/Fy8wCzB;;A+Fj9vCA;EACE,oCAAA;EACA,qBAvfmB;A/F28wCrB;A+Fj9vCI;EACE,W1FrfE;ALw8wCR;A+Fh9vCI;EAKE,cArgBiB;A/Fm9wCvB;;A+Ft8vCI;EACE,qBA/gBmB;A/Fw9wCzB;;A+Fn8vCA;EACE,yBAthBuB;A/F49wCzB;;A+Fn8vCA;EACE,mEAAA;A/Fs8vCF;;A+Fn8vCA;EACE,wCAAA;A/Fs8vCF;;A+Fn8vCA;;EAEE,wCAAA;EACA,qBApiBuB;A/F0+wCzB;;A+Fn8vCA;;;;EAIE,wCAAA;EACA,qBA5iBuB;A/Fk/wCzB;;A+Fn8vCA;EACE,wCAAA;EACA,qBAjjBuB;A/Fu/wCzB;;A+Fn8vCA;EACE,wCAAA;EACA,qBAtjBuB;A/F4/wCzB;;A+Fn8vCA;EACE,qBA1jBuB;A/FggxCzB;;A+Fl8vCA;EACE,cA/jBuB;A/FogxCzB;;A+Fj8vCE;EAEE,qEAAA;A/Fm8vCJ;;A+F77vCE;EACE,cA5kBqB;A/F4gxCzB;;A+F37vCA;EACE,mBAllBuB;A/FghxCzB;;A+F17vCE;EAGE,cAzlBqB;A/FohxCzB;;A+Fr7vCE;EACE,qBAhmBqB;A/FwhxCzB;;A+Fl7vCE;EACE,qBAvmBqB;A/F4hxCzB;A+Fn7vCI;EAGE,yBA5mBmB;A/F+hxCzB;;A+F56vCE;EACE,cApnBqB;A/FmixCzB;;A+F16vCE;EAGE,cA3nBmB;A/FsixCvB;;A+Ft6vCA;EACE,cAjoBqB;A/F0ixCvB;;A+Ft6vCA;EACE,0CAAA;A/Fy6vCF;;A+Fp6vCA;EACE,gCAAA;A/Fu6vCF;;A+Fl6vCA;EACE,yBAlpBuB;A/FujxCzB;;A+Fj6vCE;EACE,yBAAA;EACA,cAxpBqB;A/F4jxCzB;A+Fl6vCI;EAEE,W1FnpBE;E0FopBF,yBA7pBmB;A/FgkxCzB;;A+F15vCI;;;;EACE,yBAvqBmB;EAwqBnB,qBAxqBmB;A/FwkxCzB;A+F35vCE;;EACE,yBAAA;A/F85vCJ;A+F75vCI;;EACE,6BAAA;EACA,yBAAA;EACA,oCAAA;A/Fg6vCN;A+F95vCM;;;EAEE,oDAAA;EACA,yBAAA;A/Fi6vCR;;A+F15vCE;EACE,yBA/rBqB;EAgsBrB,qBAhsBqB;A/F6lxCzB;;A+Fz5vCA;;EAEE,cAtsBuB;A/FkmxCzB;;A+Fz5vCA,4BAAA;AACA,2DAAA,wBAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,kDAAA,gBAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,sDAAA,WAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,iDAAA,gBAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,sEAAA,wBAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,6DAAA,gBAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,iEAAA,WAAA;EACE,+BAAA;A/F45vCF;;A+Fz5vCA,4DAAA,gBAAA;EACE,+BAAA;A/F45vCF;;AgGpoxCA,0BAAA;AAeA;EACE,cAbgB;EAchB,yBAhBmB;AhGyoxCrB;;AgGtnxCA;EACE,cApBmB;AhG6oxCrB;;AgGtnxCA;EACE,cAtBgB;AhG+oxClB;;AgGtnxCA;EACE,kEAAA;EACA,cA3BgB;EA4BhB,4DAAA;AhGynxCF;AgGvnxCE;EACE,gEAAA;AhGynxCJ;;AgGrnxCA;EACE,sB3F7BM;E2F8BN,cAvCmB;EAwCnB,kB3F/BM;ALupxCR;AgGtnxCE;EACE,sB3FlCI;AL0pxCR;;AgGpnxCA;EACE,cA9CgB;AhGqqxClB;;AgGpnxCA;EACE,yBAAA;AhGunxCF;;AgGnnxCE;EACE,gEAAA;EACA,cAxDc;EAyDd,4DAAA;AhGsnxCJ;AgGpnxCI;EACE,yBA9De;EA+Df,cA7DY;EA8DZ,qBAhEe;AhGsrxCrB;AgGpnxCM;EAEE,cAlEU;AhGurxClB;;AgG/mxCA;EACE,qBA3EmB;EA4EnB,kEAAA;AhGknxCF;AgGhnxCE;EACE,yBAAA;AhGknxCJ;AItixCI;E4FzEE,yBAAA;AhGknxCN;AgG9mxCE;;EAEE,cAtFc;EAuFd,kEAAA;EACA,8DAAA;EACA,mEAAA;AhGgnxCJ;;AgG5mxCA;;EAEE,2EAAA;EACA,cAhGgB;AhG+sxClB;;AgG1mxCE;EAEE,kEAAA;EACA,4DAAA;AhG4mxCJ;AgGzmxCE;EACE,4DAAA;EACA,wCAAA;AhG2mxCJ;AgGxmxCE;EAKE,yBAAA;AhGsmxCJ;AgGlmxCE;EAEE,kCAAA;AhGmmxCJ;AgGlmxCI;EAEE,0CAAA;AhGmmxCN;AgG/lxCE;EACE,4BAAA;AhGimxCJ;AgGhmxCI;EAEE,yBAAA;AhGimxCN;AgG7lxCE;EACE,6CAAA;AhG+lxCJ;AgG5lxCE;EACE,yDAAA;AhG8lxCJ;AgG7lxCI;EAEE,wDAAA;AhG8lxCN;AgG1lxCE;EAEE,6EAAA;EACA,yBAAA;AhG2lxCJ;AgGxlxCE;EAIE,qBAlKiB;EAmKjB,6EAAA;EACA,yBAAA;E5FnKF,wB4FoKE;E5FnKF,qB4FmKE;E5FlKF,mB4FkKE;E5FjKF,gB4FiKE;AhG0lxCJ;AgGxlxCI;EAKE,6EAAA;EACA,yEAAA;EACA,6CAAA;AhGslxCN;AgGjlxCE;EACE,wDAnLmB;AhGswxCvB;AgGllxCI;EAEE,yBAAA;AhGmlxCN;AgG/kxCE;EACE,mEAAA;AhGilxCJ;AgG9kxCE;EACE,8EAAA;EACA,6CAAA;AhGglxCJ;AgG7kxCE;EACE,oCAAA;EACA,6CAAA;AhG+kxCJ;AgG5kxCE;EACE,mEAzMmB;EA0MnB,+DA1MmB;EA2MnB,kCAjMoB;AhG+wxCxB;AgG5kxCI;EAGE,oCAAA;EACA,gCAAA;EACA,6CAAA;AhG4kxCN;;AgGtkxCA;EACE,kCAAA;AhGykxCF;AgGxkxCE;EACE,kCAAA;AhG0kxCJ;;AgGlkxCE;EjB/NA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EwyxCF;AIpqxCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EizxCzG;A+EryxCE;EAII,0HAAA;A/EoyxCN;A+E7xxCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHkuxCf;A+E3xxCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/E8zxC7L;A+EtxxCI;EAGI,uFAAA;A/EsxxCR;;AgGjmxCE;EjB/NA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eu0xCF;AInsxCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/Eg1xCzG;A+Ep0xCE;EAII,wHAAA;A/Em0xCN;A+E5zxCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHiwxCf;A+E1zxCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/E61xC7L;A+ErzxCI;EAGI,qFAAA;A/EqzxCR;;AgGhoxCE;EjB/NA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Es2xCF;AIluxCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/E+2xCzG;A+En2xCE;EAII,yHAAA;A/Ek2xCN;A+E31xCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHgyxCf;A+Ez1xCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/E43xC7L;A+Ep1xCI;EAGI,sFAAA;A/Eo1xCR;;AgG/pxCE;EjB/NA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eq4xCF;AIjwxCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/E84xCzG;A+El4xCE;EAII,wHAAA;A/Ei4xCN;A+E13xCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH+zxCf;A+Ex3xCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/E25xC7L;A+En3xCI;EAGI,qFAAA;A/Em3xCR;;AgG9rxCE;EjB/NA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Eo6xCF;AIhyxCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/E66xCzG;A+Ej6xCE;EAII,yHAAA;A/Eg6xCN;A+Ez5xCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH81xCf;A+Ev5xCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/E07xC7L;A+El5xCI;EAGI,sFAAA;A/Ek5xCR;;AgG7txCE;EjB/NA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Em8xCF;AI/zxCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/E48xCzG;A+Eh8xCE;EAII,wHAAA;A/E+7xCN;A+Ex7xCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH63xCf;A+Et7xCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/Ey9xC7L;A+Ej7xCI;EAGI,qFAAA;A/Ei7xCR;;AgG5vxCE;EjB/NA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/Ek+xCF;AI91xCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/E2+xCzG;A+E/9xCE;EAII,0HAAA;A/E89xCN;A+Ev9xCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH45xCf;A+Er9xCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/Ew/xC7L;A+Eh9xCI;EAGI,uFAAA;A/Eg9xCR;;AgG3xxCE;EjB/NA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EigyCF;AI73xCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/E0gyCzG;A+E9/xCE;EAII,uHAAA;A/E6/xCN;A+Et/xCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH27xCf;A+Ep/xCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/EuhyC7L;A+E/+xCI;EAGI,oFAAA;A/E++xCR;;AgGpzxCE;EjBrOA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EgiyCF;AI55xCE;E2EjIE,cAAA;ECNA,qEDD2D;EAS3D,iEATqG;A/EyiyCzG;A+E7hyCE;EAII,0HAAA;A/E4hyCN;A+ErhyCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AH09xCf;A+EnhyCE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;A/EsjyC7L;A+E9gyCI;EAGI,uFAAA;A/E8gyCR;;AgGn1xCE;EjBrOA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E+jyCF;AI37xCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EwkyCzG;A+E5jyCE;EAII,wHAAA;A/E2jyCN;A+EpjyCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHy/xCf;A+EljyCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EqlyC7L;A+E7iyCI;EAGI,qFAAA;A/E6iyCR;;AgGl3xCE;EjBrOA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E8lyCF;AI19xCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,gEATqG;A/EumyCzG;A+E3lyCE;EAII,yHAAA;A/E0lyCN;A+EnlyCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHwhyCf;A+EjlyCE;EAGE,WAAA;EACA,oEAlC+I;EAsC/I,gEAtCyL;A/EonyC7L;A+E5kyCI;EAGI,sFAAA;A/E4kyCR;;AgGj5xCE;EjBrOA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E6nyCF;AIz/xCE;E2EjIE,WAAA;ECNA,gDDD2D;EAS3D,yCATqG;A/EsoyCzG;A+E1nyCE;EAII,wHAAA;A/EynyCN;A+ElnyCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHujyCf;A+EhnyCE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;A/EmpyC7L;A+E3myCI;EAGI,qFAAA;A/E2myCR;;AgGh7xCE;EjBrOA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E4pyCF;AIxhyCE;E2EjIE,WAAA;ECNA,oEDD2D;EAS3D,6DATqG;A/EqqyCzG;A+EzpyCE;EAII,yHAAA;A/EwpyCN;A+EjpyCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHslyCf;A+E/oyCE;EAGE,WAAA;EACA,iEAlC+I;EAsC/I,8DAtCyL;A/EkryC7L;A+E1oyCI;EAGI,sFAAA;A/E0oyCR;;AgG/8xCE;EjBrOA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E2ryCF;AIvjyCE;E2EjIE,WAAA;ECNA,mEDD2D;EAS3D,+DATqG;A/EosyCzG;A+ExryCE;EAII,wHAAA;A/EuryCN;A+EhryCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHqnyCf;A+E9qyCE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;A/EityC7L;A+EzqyCI;EAGI,qFAAA;A/EyqyCR;;AgG9+xCE;EjBrOA,cAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/E0tyCF;AItlyCE;E2EjIE,cAAA;ECNA,4DDD2D;EAS3D,kDATqG;A/EmuyCzG;A+EvtyCE;EAII,0HAAA;A/EstyCN;A+E/syCE;EAEE,cAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHopyCf;A+E7syCE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;A/EgvyC7L;A+ExsyCI;EAGI,uFAAA;A/EwsyCR;;AgG7gyCE;EjBrOA,WAAA;ECAE,yB7EsFW;E4EpFb,qB5EoFa;EC1Fb,2F2EOA;E3ENA,wF2EMA;E3ELA,sF2EKA;E3EJA,mF2EIA;A/EyvyCF;AIrnyCE;E2EjIE,WAAA;ECNA,2DDD2D;EAS3D,qDATqG;A/EkwyCzG;A+EtvyCE;EAII,uHAAA;A/EqvyCN;A+E9uyCE;EAEE,WAAA;EACA,yB5E6DW;E4E5DX,qB5E4DW;AHmryCf;A+E5uyCE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;A/E+wyC7L;A+EvuyCI;EAGI,oFAAA;A/EuuyCR;;AgGtiyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHksyCf;A+EhuyCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHusyCf;A+E/tyCE;EAEE,iDAAA;A/EguyCJ;A+E7tyCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E8tyCJ;A+E3tyCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHmtyCf;A+EztyCI;EAGI,uFAAA;A/EytyCR;;AgGjkyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH6tyCf;A+E3vyCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHkuyCf;A+E1vyCE;EAEE,+CAAA;A/E2vyCJ;A+ExvyCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EyvyCJ;A+EtvyCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH8uyCf;A+EpvyCI;EAGI,qFAAA;A/EovyCR;;AgG5lyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHwvyCf;A+EtxyCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH6vyCf;A+ErxyCE;EAEE,gDAAA;A/EsxyCJ;A+EnxyCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EoxyCJ;A+EjxyCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHywyCf;A+E/wyCI;EAGI,sFAAA;A/E+wyCR;;AgGvnyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHmxyCf;A+EjzyCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHwxyCf;A+EhzyCE;EAEE,+CAAA;A/EizyCJ;A+E9yyCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E+yyCJ;A+E5yyCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHoyyCf;A+E1yyCI;EAGI,qFAAA;A/E0yyCR;;AgGlpyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH8yyCf;A+E50yCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHmzyCf;A+E30yCE;EAEE,gDAAA;A/E40yCJ;A+Ez0yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E00yCJ;A+Ev0yCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH+zyCf;A+Er0yCI;EAGI,sFAAA;A/Eq0yCR;;AgG7qyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHy0yCf;A+Ev2yCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH80yCf;A+Et2yCE;EAEE,+CAAA;A/Eu2yCJ;A+Ep2yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eq2yCJ;A+El2yCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH01yCf;A+Eh2yCI;EAGI,qFAAA;A/Eg2yCR;;AgGxsyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHo2yCf;A+El4yCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHy2yCf;A+Ej4yCE;EAEE,iDAAA;A/Ek4yCJ;A+E/3yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Eg4yCJ;A+E73yCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHq3yCf;A+E33yCI;EAGI,uFAAA;A/E23yCR;;AgGnuyCE;EjBxLA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH+3yCf;A+E75yCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHo4yCf;A+E55yCE;EAEE,8CAAA;A/E65yCJ;A+E15yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E25yCJ;A+Ex5yCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHg5yCf;A+Et5yCI;EAGI,oFAAA;A/Es5yCR;;AgGpvyCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH05yCf;A+Ex7yCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH+5yCf;A+Ev7yCE;EAEE,iDAAA;A/Ew7yCJ;A+Er7yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Es7yCJ;A+En7yCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH26yCf;A+Ej7yCI;EAGI,uFAAA;A/Ei7yCR;;AgG/wyCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHq7yCf;A+En9yCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH07yCf;A+El9yCE;EAEE,+CAAA;A/Em9yCJ;A+Eh9yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/Ei9yCJ;A+E98yCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHs8yCf;A+E58yCI;EAGI,qFAAA;A/E48yCR;;AgG1yyCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHg9yCf;A+E9+yCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHq9yCf;A+E7+yCE;EAEE,gDAAA;A/E8+yCJ;A+E3+yCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E4+yCJ;A+Ez+yCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHi+yCf;A+Ev+yCI;EAGI,sFAAA;A/Eu+yCR;;AgGr0yCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH2+yCf;A+EzgzCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHg/yCf;A+ExgzCE;EAEE,+CAAA;A/EygzCJ;A+EtgzCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EugzCJ;A+EpgzCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH4/yCf;A+ElgzCI;EAGI,qFAAA;A/EkgzCR;;AgGh2yCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHsgzCf;A+EpizCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH2gzCf;A+EnizCE;EAEE,gDAAA;A/EoizCJ;A+EjizCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EkizCJ;A+E/hzCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHuhzCf;A+E7hzCI;EAGI,sFAAA;A/E6hzCR;;AgG33yCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHiizCf;A+E/jzCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AHsizCf;A+E9jzCE;EAEE,+CAAA;A/E+jzCJ;A+E5jzCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/E6jzCJ;A+E1jzCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHkjzCf;A+ExjzCI;EAGI,qFAAA;A/EwjzCR;;AgGt5yCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AH4jzCf;A+E1lzCE;EACE,c1E5CO;E0E6CP,yB5E4BW;E4E3BX,qB5E2BW;AHikzCf;A+EzlzCE;EAEE,iDAAA;A/E0lzCJ;A+EvlzCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EwlzCJ;A+ErlzCE;EAGE,cAAA;EACA,yB5ESW;E4ERX,qB5EQW;AH6kzCf;A+EnlzCI;EAGI,uFAAA;A/EmlzCR;;AgGj7yCE;EjBlMA,c5EmCa;E4ElCb,6BAAA;EACA,sBAAA;EACA,qB5EgCa;AHulzCf;A+ErnzCE;EACE,W1ErDI;E0EsDJ,yB5E4BW;E4E3BX,qB5E2BW;AH4lzCf;A+EpnzCE;EAEE,8CAAA;A/EqnzCJ;A+ElnzCE;EAEE,c5EiBW;E4EhBX,6BAAA;A/EmnzCJ;A+EhnzCE;EAGE,WAAA;EACA,yB5ESW;E4ERX,qB5EQW;AHwmzCf;A+E9mzCI;EAGI,oFAAA;A/E8mzCR;;AgGn8yCA;;EAEE,uDAAA;EACA,8DAAA;AhGs8yCF;AgGp8yCE;;;;;;;;EAOE,W3FtQI;E2FuQJ,8DAAA;EACA,kEAAA;AhGu8yCJ;;AgGn8yCA;;EAEE,wDAtRqB;EAuRrB,+DAvRqB;AhG6tzCvB;AgGp8yCE;;;;;;;;EAOE,W3FxRI;E2FyRJ,+DAjSmB;EAkSnB,mEAlSmB;AhGyuzCvB;;AgGn8yCA;EACE,kCA7RsB;EA8RtB,yCA9RsB;AhGouzCxB;AgGp8yCE;EAGE,kEAAA;EACA,8DAAA;EACA,kCArSoB;AhGyuzCxB;;AgGh8yCA;EACE,wCAAA;EACA,6CAAA;AhGm8yCF;AgGj8yCE;EAGE,oCAAA;EACA,sBAAA;AhGi8yCJ;;AgG77yCA;EACE,wCAAA;EACA,yBAAA;EACA,oCAAA;AhGg8yCF;AgG97yCE;EAEE,oFAAA;EACA,yBAAA;AhG+7yCJ;;AgG37yCA;EACE,wCAAA;EACA,6CAAA;EACA,oCAAA;AhG87yCF;AgG57yCE;EAEE,kDAAA;EACA,6CAAA;AhG67yCJ;;AgGr7yCI;;;;EACE,yBA7Ve;EA8Vf,qBA9Ve;EA+Vf,kCApVkB;AhG+wzCxB;AgGt7yCE;;EACE,yBAAA;AhGy7yCJ;AgGx7yCI;;EACE,6BAAA;EACA,uDAAA;AhG27yCN;AgGz7yCM;;;EAEE,uCAAA;EACA,uDAAA;AhG47yCR;;AgGr7yCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AhGw7yCJ;AgGt7yCI;EAEE,sDAAA;EACA,sBAAA;AhGu7yCN;;AgGj7yCE;EACE,wCAAA;EACA,sBAAA;EACA,oCAAA;AhGo7yCJ;AgGl7yCI;EAEE,sDAAA;EACA,sBAAA;AhGm7yCN;;AgG76yCA;EACE,6EAAA;AhGg7yCF;AgG96yCE;EACE,kEAAA;AhGg7yCJ;AgG96yCI;EACE,sB3F9YE;AL8zzCR;AgG36yCI;EADF;IAEI,sB3FpZE;ELk0zCN;AACF;;AgG16yCA;;;;EAIE,4DAAA;AhG66yCF;;AgG16yCA;EACE,8DAAA;AhG66yCF;;AgG16yCA;E5F5aE,wB4F6aA;E5F5aA,qB4F4aA;E5F3aA,mB4F2aA;E5F1aA,gB4F0aA;AhGg7yCF;;AgG56yCA;EACE,eAAA;EACA,4DAAA;EACA,yBArbmB;EAsbnB,cApbgB;AhGm2zClB;AgG76yCE;EACE,yBAAA;AhG+6yCJ;AgG96yCI;EACE,0CAAA;AhGg7yCN;;AgG36yCA;EACE,4DAAA;AhG86yCF;;AgG36yCA;EACE,sBAAA;AhG86yCF;;AgG16yCA;EACE,yBA1cmB;AhGu3zCrB;;AgGz6yCA;EACE,6EAAA;EACA,yBAAA;EACA,uEAAA;AhG46yCF;AgG16yCE;EACE,kEA9cwB;EA+cxB,kBAAA;EACA,UAAA;AhG46yCJ;AgGz6yCE;EACE,qBAAA;AhG26yCJ;AgGv6yCI;EACE,kCApdkB;AhG63zCxB;;AgGp6yCA;EACE,cAnegB;AhG04zClB;;AgGn6yCE;EACE,cAxec;AhG84zClB;;AgGl6yCA;;;EAGE,kEA3e0B;EA4e1B,kCAvesB;AhG44zCxB;;AgGl6yCA;EACE,yCA3esB;AhGg5zCxB;;AgGl6yCA;;EAEE,kCAhfsB;AhGq5zCxB;;AgGl6yCA;EACE,kEAzf0B;AhG85zC5B;;AgGl6yCA;EACE,cAjgBgB;AhGs6zClB;;AgGl6yCA;;;EAGE,kCA9fsB;AhGm6zCxB;;AgGl6yCA;EACE,cA3gBgB;AhGg7zClB;;AgGl6yCA;EACE,kEAAA;EACA,W3FzgBM;AL86zCR;;AgGl6yCA;;;;;EAKE,kEAAA;EACA,W3FlhBM;ALu7zCR;;AgGl6yCA;EACE,yBA/hBmB;AhGo8zCrB;;AgGl6yCA,2BAAA;AAGI;EAEE,0DAAA;AhGk6yCN;AgG/5yCI;EACE,W7Fjfe;AHk5zCrB;AgG95yCI;EAEE,0DAAA;AhG+5yCN;AgG35yCE;EACE,W3F5iBI;ALy8zCR;AgG15yCE;EAKE,0DAAA;AhGw5yCJ;AgGr5yCE;EACE,kEAAA;EACA,+DAAA;AhGu5yCJ;AgGr5yCI;EAEE,0DAAA;AhGs5yCN;AgGj5yCI;EACE,W7FlhBe;AHq6zCrB;AgG94yCM;EACE,0DAAA;AhGg5yCR;AgG54yCI;EAGE,0DAAA;AhG44yCN;;AgGv4yCA;EACE,oCAAA;AhG04yCF;AgGv4yCI;EACE,W3F1lBE;ALm+zCR;AgGt4yCI;EAKE,0DAAA;AhGo4yCN;;AgG93yCA;EACE,qEAAA;AhGi4yCF;;AgG93yCA;EACE,kEAAA;AhGi4yCF;;AgG93yCA;EACE,uCAAA;AhGi4yCF;;AgG93yCA;;EAEE,uCAAA;EACA,iEAAA;EACA,YAAA;AhGi4yCF;;AgG93yCA;;;;EAIE,uCAAA;EACA,iEAAA;EACA,YAAA;AhGi4yCF;;AgG93yCA;;EAEE,uCAAA;EACA,iEAAA;EACA,YAAA;AhGi4yCF;;AgG93yCA;EACE,uCAAA;EACA,iEAAA;EACA,0DAAA;AhGi4yCF;;AgG93yCA;EACE,qEAAA;AhGi4yCF;;AgG93yCA;EACE,mEAAA;AhGi4yCF;;AgG93yCA;EACE,qBAnqBmB;AhGoi0CrB;;AgG73yCA;EACE,cAxqBmB;AhGwi0CrB;;AgG73yCA;EACE,4DAAA;AhGg4yCF;AgG93yCE;EAEE,kEAAA;AhG+3yCJ;;AgGz3yCE;EACE,cAvrBiB;AhGmj0CrB;;AgGr3yCE;EACE,qBA/rBiB;AhGuj0CrB;;AgGl3yCE;EACE,qBAtsBiB;AhG2j0CrB;AgGn3yCI;EAGE,yBA3sBe;AhG8j0CrB;;AgG52yCE;EACE,yDAAA;AhG+2yCJ;;AgG12yCE;EAGE,kCAAA;AhG22yCJ;;AgGt2yCA;EACE,kCAAA;AhGy2yCF;;AgGt2yCA;EACE,yCAAA;AhGy2yCF;;AgGp2yCA;EACE,oDAAA;AhGu2yCF;;AgGn2yCA;EACE,yBAhvBmB;AhGsl0CrB;;AgGl2yCA;EACE,yBArvBmB;AhG0l0CrB;;AgGj2yCA;EACE,4DAAA;AhGo2yCF;;AgGj2yCA;EACE,kEAAA;EACA,4DAAA;AhGo2yCF;AgGl2yCE;EACE,0EAAA;AhGo2yCJ;AgGj2yCE;EACE,2EAAA;AhGm2yCJ;;AgG91yCA;EACE,kEAAA;EACA,4DAAA;AhGi2yCF;;AgG71yCA;;EAEE,kEAAA;AhGg2yCF;;AgG51yCE;EACE,yBAAA;AhG+1yCJ;AgG71yCI;EAGE,sBAAA;AhG61yCN;AgG11yCI;EACE,8DAAA;AhG41yCN;;AgGt1yCA;EACE,kEAAA;AhGy1yCF;;AgGt1yCA;;;EAGE,kEAAA;EACA,4DAAA;EACA,cA9yBgB;AhGuo0ClB;;AgGt1yCA;EACE,cAlzBgB;AhG2o0ClB;AgGv1yCE;EAEE,yBAxzBiB;EAyzBjB,cAvzBc;AhG+o0ClB;;AgGn1yCE;E5F7zBA,wB4F8zBE;E5F7zBF,qB4F6zBE;E5F5zBF,mB4F4zBE;E5F3zBF,gB4F2zBE;EACA,4DAAA;AhGy1yCJ;AgGt1yCE;EACE,0CAAA;EACA,wCAAA;EACA,yEAAA;AhGw1yCJ;AgGr1yCE;EACE,0CAAA;EACA,wCAAA;EACA,uEAAA;AhGu1yCJ;;AgGl1yCE;EACE,cAh1Bc;AhGqq0ClB;AgGl1yCE;EACE,yBAt1BiB;AhG0q0CrB;AgGl1yCI;EACE,sB3Fh1BE;ALoq0CR;;AgG/0yCA;EACE,yBA/1BmB;AhGir0CrB;AgGh1yCE;EACE,sB3Fz1BI;AL2q0CR;;AgG90yCA;;;;;;;;;EASE,4DAAA;AhGi1yCF;;AgG90yCA;;EAEE,yBAp3BmB;EAq3BnB,cAn3BgB;AhGos0ClB;;AgG90yCA;EACE,cAv3BgB;AhGws0ClB;;AgG50yCA;;;;;;;;EAQE,yBAt4BmB;AhGqt0CrB;;AgG50yCA;EACE,kEAAA;AhG+0yCF;;AgG50yCA;EACE,W3Fr4BM;ALot0CR;;AgG50yCA;EACE,aAAA;AhG+0yCF;AgG70yCE;EACE,mEAAA;EACA,4DAAA;AhG+0yCJ;AgG70yCI;EACE,8EAAA;AhG+0yCN;AgG50yCI;EACE,8EAAA;AhG80yCN;AgGz0yCI;EACE,uBAAA;EACA,sBAAA;EACA,kEAAA;EACA,+DAAA;AhG20yCN;AgGz0yCM;EACC,wBAAA;EACA,sBAAA;EACC,+EAAA;EACA,yBAAA;AhG20yCR;AgGx0yCM;EACC,wBAAA;EACA,sBAAA;EACC,+EAAA;EACA,yBAAA;AhG00yCR;;AgGp0yCA;EACE,iBAAA;AhGu0yCF;;AgGl0yCA;EACE,yBAh8BmB;AhGqw0CrB;;AgGj0yCE;EACE,yBAAA;EACA,cAt8BiB;AhG0w0CrB;AgGl0yCI;EAEE,W3Fj8BE;E2Fk8BF,yBA38Be;AhG8w0CrB;;AgG9zyCA;;EAEE,W7Fx5BmB;AHyt0CrB;;AgG9zyCA;;EAEE,cAr9BgB;EAs9BhB,yBAx9BmB;AhGyx0CrB;;AgG9zyCA;;E5F/5BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4F65BsB;E5F55BtB,8B4F45B4B;E5F35B5B,0B4F25B4B;E5F15B5B,sB4F05B4B;E5Fz5B5B,yB4Fy5BoC;E5Fx5BpC,qB4Fw5BoC;E5Fv5BpC,iB4Fu5BoC;EACpC,aAAA;AhG20yCF;;AgGx0yCA;E5Fr6BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4Fk6BsB;E5Fj6BtB,8B4Fi6B4B;E5Fh6B5B,0B4Fg6B4B;E5F/5B5B,sB4F+5B4B;E5F95B5B,yB4F85BoC;E5F75BpC,qB4F65BoC;E5F55BpC,iB4F45BoC;EACpC,YAAA;EACA,aAAA;AhGq1yCF;;AgGl1yCA;EACE,2BAAA;AhGq1yCF;;AgGl1yCA;EACE,yBA5+BmB;AhGi00CrB;;AgGl1yCA;EACE,kEAAA;EACA,4DAAA;AhGq1yCF;AgGn1yCE;EACE,4DAAA;AhGq1yCJ;AgGn1yCI;EACE,cAr/BY;AhG000ClB;AgGl1yCI;EACE,kCAz/BY;AhG600ClB;AgGh1yCE;EACE,kEAAA;EACA,4DAAA;EACA,cAhgCc;AhGk10ClB;AgG/0yCE;EACE,kEAAA;EACA,cArgCc;AhGs10ClB;;AgG70yCA;EACE,cA5gCmB;AhG410CrB;;AgG50yCA;EACE,kEAAA;AhG+0yCF;;AgG50yCA;EACE,kEAAA;EACA,4DAAA;AhG+0yCF;;AgG30yCE;EAGE,kCAAA;AhG40yCJ;;AgGv0yCE;EAEE,4DAAA;AhGy0yCJ;;AgGr0yCA;EACE,uEAAA;AhGw0yCF;;AgGr0yCA;EACE,4DAAA;AhGw0yCF;AgGr0yCI;EAEE,4DAAA;AhGs0yCN;AgGn0yCI;EACE,4DAAA;AhGq0yCN;AgGj0yCE;EACE,kEAAA;EACA,4DAAA;AhGm0yCJ;AgGh0yCE;EAEE,2EAAA;AhGi0yCJ;AgG7zyCI;EAEE,4DAAA;AhG8zyCN;AgG1zyCE;EACE,4DAAA;AhG4zyCJ;AgG1zyCI;EACE,kEAAA;EACA,cA9kCY;AhG040ClB;AgG1zyCM;EACE,yBAAA;EACA,cAllCU;AhG840ClB;AgGxzyCI;EACE,cAvlCY;AhGi50ClB;;AgGrzyCA;;EAEE,4DAAA;AhGwzyCF","sourcesContent":["/*\nAuthor         : G-axon\nTemplate Name  : Jumbo React - Admin Template\nVersion        : 1.0\n*/\n/*=============================================================\n    Table of Contents:\n    =============================\n    A. Globals\n        01. Custom Animation\n    B. Base\n        01. Base Styles\n        02. Typography Styles\n    C. Layouts\n        01. App Layout Styles\n        02. Sidebar Styles\n        03. Header Styles\n        04. Main Content Styles\n        05. Footer Styles\n        06. Right Sidebar Styles\n    D. UI Components\n        01. Alert Styles\n        02. Avatar Styles\n        03. Badges Styles\n        04. Blockquotes Styles\n        05. Bottom Navigation Styles\n        06. Breadcrumb Styles\n        07. Button Styles\n        08. Button Group Styles\n        09. Callout Styles\n        10. Cards Styles\n        11. Charts Styles\n        12. Chips Styles\n        13. Carousel Styles\n        14. Color Picker Styles\n        15. Drawer Styles\n        16. E-commerce Styles\n        17. Grids List Styles\n        18. Icons Styles\n        19. Label Styles\n        20. List Styles\n        21. Nav Style\n        22. Pricing Styles\n        23. Progressbar Styles\n        24. Popover Styles\n        25. React Joyride Styles\n        26. Tables Styles\n        27. Tabs Styles\n        28. Testimonial Styles\n        29. Time Lines Style\n        30. Joyride Tour Styles\n        31. Form Styles\n    E. Pages\n        01. Login Styles\n        02. Error Styles\n        03. Editor Styles\n        04. Contact Page Styles\n        05. Portfolio Styles\n        06. Faqs Styles\n        07. Dashboard Styles\n    F. Slider\n    G. Modules\n        01. App Module Style\n        02. Chat Module Styles\n        03. Mails Module Styles\n        04. Contact Module Styles\n        05. Calendar Module Style\n    H. Color Theme\n        01. Theme Indigo Styles\n        02. Theme Cyan Styles\n        03. Theme Amber Styles\n        04. Theme Deep Orange Styles\n        05. Theme Pink Styles\n        06. Theme Blue Styles\n        07. Theme Deep Purple Styles\n        08. Theme Green Styles\n        09. Theme Dark Indigo Styles\n        10. Theme Dark Cyan Styles\n        11. Theme Dark Amber Styles\n        12. Theme Dark Deep Orange Styles\n        13. Theme Dark Pink Styles\n        14. Theme Dark Blue Styles\n        15. Theme Dark Deep Purple Styles\n        16. Theme Dark Green Styles\n  =============================================================*/\n//Custom Variables\n@import \"global/_global-dir\";\n//Custom Files\n@import \"design-system/index\";\n@import \"base/_base-dir\";\n@import \"layout/_layout-dir\";\n@import \"ui/_ui-dir\";\n@import \"pages/_pages-dir\";\n@import \"pages/home\";\n@import \"slider/owl-carousel\";\n@import \"module/_module-dir\";\n@import \"colorTheme/_color-theme-dir\";","/* Globals\n   ========================================================================== */\n@import \"variables\";\n@import \"mixin\";\n@import \"place-holder\";\n@import \"sizes\";\n@import \"color\";\n@import \"custom-animation\";\n","//Place Holders\n%jr-menu-icon {\n  .menu-icon {\n    --bars-height: 2px;\n    position: relative;\n    width: 70%;\n    height: var(--bars-height);\n    min-height: var(--bars-height);\n    color: inherit;\n    background-color: $gray-default;\n    display: block;\n    @include transition(all 0.4s ease);\n    margin: 6px 0;\n    cursor: pointer;\n\n    &:after,\n    &:before {\n      position: absolute;\n      display: block;\n      color: inherit;\n      background-color: inherit;\n      inset-inline-start: 0;\n      height: var(--bars-height);\n      min-height: var(--bars-height);\n      content: \"\";\n      @include transition(all 0.4s ease);\n    }\n\n    &:after {\n      width: 120%;\n      bottom: -6px;\n    }\n\n    &:before {\n      width: 130%;\n      top: -6px;\n    }\n  }\n  &:hover {\n    & .menu-icon {\n      width: 100%;\n      &:after,\n      &:before {\n        width: 100%;\n      }\n    }\n  }\n}\n\n%size-50 {\n  height: $size-50 !important;\n  width: $size-50 !important;\n  line-height: $size-50;\n}\n\n%size-60 {\n  height: $size-60 !important;\n  width: $size-60 !important;\n  line-height: $size-60;\n}\n\n%size-80 {\n  height: $size-80 !important;\n  width: $size-80 !important;\n  line-height: $size-80;\n}\n\n%size-100 {\n  height: $size-100 !important;\n  width: $size-100 !important;\n  line-height: $size-100;\n}\n\n%size-20 {\n  height: $size-20 !important;\n  width: $size-20 !important;\n  line-height: $size-20;\n}\n\n\n%size-30 {\n  height: $size-30 !important;\n  width: $size-30 !important;\n  line-height: $size-30;\n}\n\n%size-40 {\n  height: $size-40 !important;\n  width: $size-40 !important;\n  line-height: $size-40;\n}\n\n%size-120 {\n  height: $size-120 !important;\n  width: $size-120 !important;\n  line-height: $size-120;\n}\n\n%icon-addon {\n  display: inline-block;\n  text-align: center;\n  background-color: inherit;\n}\n\n%jr-card-style {\n  padding: $jr-card-padding;\n  margin-bottom: $jr-card-margin;\n  background-color: $white;\n  @include border-radius($border-radius-lg);\n  border: $jr-border;\n  position: relative;\n}\n\n/* Ripple magic */\n%ripple-effect {\n  position: relative;\n  overflow: hidden;\n  &:after {\n    content: '';\n    position: absolute;\n    top: 50%;\n   inset-inline-start:50%;\n    width: 5px;\n    height: 5px;\n    background: rgba($white, 0.5);\n    opacity: 0;\n    @include border-radius(100%);\n    transform: scale(1, 1) translate(-50%);\n    transform-origin: 50% 50%;\n  }\n\n  &:hover:after {\n    animation: ripple 1s ease-out;\n  }\n}\n\n@keyframes ripple {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  20% {\n    transform: scale(60, 60);\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(100, 100);\n  }\n}\n\n@-webkit-keyframes ripple {\n  0% {\n    transform: scale(0, 0);\n    opacity: 0.5;\n  }\n  20% {\n    transform: scale(60, 60);\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(100, 100);\n  }\n}\n\n//Pulse Effect\n%pulse-effect {\n  display: block;\n  @include box-shadow (0 0 0 rgba($danger, 0.4));\n  animation: pulse 2s infinite;\n}\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba($danger, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0.4);\n    box-shadow: 0 0 0 0 rgba($danger, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba($danger, 0);\n    box-shadow: 0 0 0 10px rgba($danger, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0);\n    box-shadow: 0 0 0 0 rgba($danger, 0);\n  }\n}\n\n//Online Effect\n%online-effect {\n  display: block;\n  @include box-shadow (0 0 0 rgba($green, 0.4));\n  animation: online 2s infinite;\n}\n\n@-webkit-keyframes online {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba($green, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0);\n  }\n}\n\n@keyframes online {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0.4);\n    box-shadow: 0 0 0 0 rgba($green, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba($green, 0);\n    box-shadow: 0 0 0 10px rgba($green, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0);\n    box-shadow: 0 0 0 0 rgba($green, 0);\n  }\n}\n\n//Away Effect\n%away-effect {\n  display: block;\n  @include box-shadow (0 0 0 rgba($yellow, 0.4));\n  animation: away 2s infinite;\n}\n\n@-webkit-keyframes away {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba($yellow, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0);\n  }\n}\n\n@keyframes away {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\n    box-shadow: 0 0 0 0 rgba($yellow, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba($yellow, 0);\n    box-shadow: 0 0 0 10px rgba($yellow, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0);\n    box-shadow: 0 0 0 0 rgba($yellow, 0);\n  }\n}\n\n/*Different size images set in Equal block height and width*/\n%thumb-equal {\n  position: relative;\n  padding-bottom: 68%;\n  height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n%thumb-cover {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n%thumb-cover-img {\n  height: auto;\n  max-width: 100%;\n  min-height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n// Hover Effect On Bootstrap Components\n%link-hover {\n  color: $white !important;\n\n  &:hover,\n  &:focus {\n    color: $white !important;\n  }\n}\n\n// Pointer\n%pointer {\n  cursor: pointer;\n}\n\n//Remove Botton Shadow\n\n%btn-no-shadow {\n  &:not([disabled]):not(.disabled):active,\n  &:not([disabled]):not(.disabled).active {\n    background-image: none;\n    @include box-shadow(none);\n\n    &:focus {\n      @include box-shadow(none);\n    }\n  }\n}","@import \"../bootstrap/functions\";\r\n@import \"../bootstrap/variables\";\r\n@import \"../bootstrap/mixins\";\r\n\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n//# sourceMappingURL=roboto.css.map\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Nunito Sans', sans-serif;\r\n$font-family-base: $font-family-sans-serif;\r\n\r\n// stylelint-enable value-keyword-case\r\n$font-size-base: 14px; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base + 4);\r\n$font-size-sm: $font-size-base;\r\n\r\n$h1-font-size: 25px;\r\n$h2-font-size: 19px;\r\n$h3-font-size: 17px;\r\n$h4-font-size: 15px;\r\n$h5-font-size: 14px;\r\n$h6-font-size: 13px;\r\n\r\n$headings-margin-bottom: ($h1-font-size / 2);\r\n$headings-font-family: inherit;\r\n$headings-font-weight: 400;\r\n$headings-line-height: 1.2;\r\n$headings-color: inherit;\r\n\r\n//Border Radius\r\n$border-radius-sm: 2px;\r\n$border-radius: 4px;\r\n$border-radius-lg: 8px;\r\n$border-radius-xl: 10px !default;\r\n$border-radius-circle: 50% !default;\r\n\r\n//Bootstrap Card Variables\r\n$card-spacer-y: 24px;\r\n$card-spacer-x: 30px;\r\n$card-border-color: $border-color;\r\n$card-border-radius: $border-radius-lg;\r\n$card-inner-border-radius: $border-radius-lg;\r\n$list-group-border-radius: $border-radius-lg;\r\n\r\n//Grid Gutter Space Between\r\n$grid-gutter-width: 34px;\r\n\r\n//Mixin Values True and False\r\n$enable-shadows: true;\r\n\r\n$app-primary: #99BBCD !default;\r\n$primary: $app-primary;\r\n$secondary: #E91E63;\r\n$gray-default: #808080 !default;\r\n\r\n$sidebar-bg: $white !default;\r\n$sidebar-text-color: #333 !default;\r\n$sidebar-bg-darken: darken($sidebar-bg, 3%);\r\n$sidebar-hover-color: $app-primary;\r\n\r\n$top-nav-bg: $app-primary !default;\r\n\r\n//Default shadow\r\n$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\r\n$shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\r\n$shadow-lg: 0 1px 8px -1px rgba(0, 0, 0, 0.20);\r\n$shadow-xl: 0 0 16px 0px rgba(0, 0, 0, 0.20);\r\n$avatar-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.50);\r\n\r\n//Custom Card Variables\r\n$jr-card-shadow: $shadow !default;\r\n$jr-card-margin: 34px !default;\r\n$jr-card-padding: 24px 30px !default;\r\n$jr-border: 1px solid $gray-400 !default;\r\n\r\n// Links\r\n$link-color: $app-primary;\r\n$link-hover-color: darken($app-primary, 10%);\r\n\r\n//Color Variables\r\n$success: #63a386;\r\n$info: #00bcd4;\r\n$warning: #e87d0d;\r\n$danger: #f44336;\r\n$light: #e8eaf6;\r\n$dark: $gray-800;\r\n$body-bg: #ffffff;\r\n$body-color: #333;\r\n\r\n$theme-colors: (\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n);\r\n\r\n//Default Image Location\r\n$image_path: \"../assets/images\" !default;\r\n\r\n// Motion\r\n// https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves\r\n$transition-bezier: .05, .74, .27, .99 !default; // for nav, quickview\r\n\r\n$transition-ease: cubic-bezier(0.4, 0.0, 0.2, 1) !default;\r\n$transition-ease-out: cubic-bezier(0.0, 0.0, 0.2, 1) !default;\r\n$transition-ease-in: cubic-bezier(0.4, 0.0, 1, 1) !default;\r\n\r\n//Side Nav Width\r\n$side-nav-width: 280px !default;\r\n$mini-drawer-width: 80px !default;\r\n\r\n//App Bar Height\r\n$app-bar-height: 70px !default;\r\n\r\n//Footer Height\r\n$footer-height: 30px !default;\r\n\r\n//latter Spacing variables\r\n$letter-spacing-base: 3px !default;\r\n$letter-spacing-lg: 6px !default;\r\n$letter-spacing-xl: 8px !default;\r\n\r\n//Button Variables\r\n$btn-font-size-lg: $font-size-lg !default;\r\n$btn-font-size: $font-size-base !default;\r\n$btn-font-size-sm: $font-size-sm !default;\r\n$btn-font-size-xs: 10px !default;\r\n\r\n$btn-padding-lg: 16px 24px !default;\r\n$btn-padding: 12px 20px !default;\r\n$btn-padding-sm: 8px 15px !default;\r\n$btn-padding-xs: 6px 10px !default;\r\n\r\n$btn-fab-size-lg: 70px !default;\r\n$btn-fab-size-sm: 46px !default;\r\n$btn-fab-size-xs: 40px !default;\r\n\r\n$btn-line-height: 1.2;\r\n\r\n//Sizes Variables\r\n\r\n$size-20: 20px !default;\r\n$size-30: 30px !default;\r\n$size-40: 40px !default;\r\n$size-50: 50px !default;\r\n$size-60: 60px !default;\r\n$size-80: 80px !default;\r\n$size-100: 100px !default;\r\n$size-120: 120px !default;\r\n\r\n// New styles variables overrides\r\n$newstyle-input-border-color: rgba(74, 98, 136, 0.2);// color(\"celia\", \"gray-light-a\") !default;\r\n$input-border-radius-sm: 6px;","// Box Shadow\n@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow;\n  -moz-box-shadow: $shadow;\n  -o-box-shadow: $shadow;\n  box-shadow: $shadow;\n}\n\n// Single side border-radius\n@mixin border-radius($radius...) {\n  -webkit-border-radius: $radius;\n  -moz-border-radius: $radius;\n  border-radius: $radius;\n}\n\n// Single side box-sizing\n@mixin box-sizing($box-sizing) {\n  -webkit-box-sizing: $box-sizing;\n  -moz-box-sizing: $box-sizing;\n  box-sizing: $box-sizing;\n}\n\n// Clearfix\n\n@mixin clearfix() {\n  &:before,\n  &:after {\n    content: \" \"; // 1\n    display: table; // 2\n  }\n  &:after {\n    clear: both;\n  }\n}\n\n// Transitions\n@mixin transition($transition...) {\n  -webkit-transition: $transition;\n  -o-transition: $transition;\n  transition: $transition;\n}\n\n@mixin rotate($degrees) {\n  -webkit-transform: rotate($degrees);\n  -ms-transform: rotate($degrees); // IE9 only\n  -o-transform: rotate($degrees);\n  transform: rotate($degrees);\n}\n\n//Background Image\n@mixin background($imgpath,$position:0 0,$repeat: no-repeat,$size: cover) {\n  background: {\n    image: url($imgpath);\n    position: $position;\n    repeat: $repeat;\n    size: $size;\n  }\n}\n\n// Flex\n@mixin display-flex($flex: flex, $flex-direction: row, $flex-wrap: wrap) {\n  display: #{'-webkit'}-#{$flex};\n  display: #{'-moz'}-#{$flex};\n  display: #{'-ms'}-#{$flex};\n  display: #{'-o'}-#{$flex};\n  display: $flex;\n  -webkit-flex-direction: $flex-direction;\n  -ms-flex-direction: $flex-direction;\n  flex-direction: $flex-direction;\n  -webkit-flex-wrap: $flex-wrap;\n  -ms-flex-wrap: $flex-wrap;\n  flex-wrap: $flex-wrap;\n}\n\n@mixin flex($flex-grow: 1, $flex-shrink: 1, $flex-basis: auto) {\n  -webkit-flex: $flex-grow $flex-shrink $flex-basis;\n  -ms-flex: $flex-grow $flex-shrink $flex-basis;\n  flex: $flex-grow $flex-shrink $flex-basis;\n}\n\n@mixin justify-content($justify-content) {\n  -webkit-justify-content: $justify-content;\n  justify-content: $justify-content;\n}\n\n@mixin align-items($align-items) {\n  -webkit-align-items: $align-items;\n  align-items: $align-items;\n}\n\n//Border Radius\n\n// Single side border-radius\n\n@mixin border-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-radius: $radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-top-right-radius: $radius;\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: $radius;\n    border-bottom-right-radius: $radius;\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: $radius;\n    border-bottom-left-radius: $radius;\n  }\n}\n\n//Mixin Hover\n\n// stylelint-disable indentation\n@mixin hover {\n  // TODO: re-enable along with mq4-hover-shim\n  //  @if $enable-hover-media-query {\n  //    // See Media Queries Level 4: https://drafts.csswg.org/mediaqueries/#hover\n  //    // Currently shimmed by https://github.com/twbs/mq4-hover-shim\n  //    @media (hover: hover) {\n  //      &:hover { @content }\n  //    }\n  //  }\n  //  @else {\n  &:hover {\n    @content;\n  }\n  //  }\n}\n\n@mixin hover-focus {\n  @if $enable-hover-media-query {\n    &:focus {\n      @content;\n    }\n    @include hover {\n      @content;\n    }\n  } @else {\n    &:focus,\n    &:hover {\n      @content;\n    }\n  }\n}\n\n@mixin plain-hover-focus {\n  @if $enable-hover-media-query {\n    &,\n    &:focus {\n      @content;\n    }\n    @include hover {\n      @content;\n    }\n  } @else {\n    &,\n    &:focus,\n    &:hover {\n      @content;\n    }\n  }\n}\n\n@mixin hover-focus-active {\n  @if $enable-hover-media-query {\n    &:focus,\n    &:active {\n      @content;\n    }\n    @include hover {\n      @content;\n    }\n  } @else {\n    &:focus,\n    &:active,\n    &:hover {\n      @content;\n    }\n  }\n}","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n//\n// Color system\n//\n\n// stylelint-disable\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$grays: () !default;\n$grays: map-merge((\n        \"100\": $gray-100,\n        \"200\": $gray-200,\n        \"300\": $gray-300,\n        \"400\": $gray-400,\n        \"500\": $gray-500,\n        \"600\": $gray-600,\n        \"700\": $gray-700,\n        \"800\": $gray-800,\n        \"900\": $gray-900\n), $grays);\n\n$blue: #007bff !default;\n$indigo: #6610f2 !default;\n$purple: #6f42c1 !default;\n$pink: #e83e8c !default;\n$red: #dc3545 !default;\n$orange: #fd7e14 !default;\n$yellow: #ffc107 !default;\n$green: #28a745 !default;\n$teal: #20c997 !default;\n$cyan: #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge((\n        \"blue\": $blue,\n        \"indigo\": $indigo,\n        \"purple\": $purple,\n        \"pink\": $pink,\n        \"red\": $red,\n        \"orange\": $orange,\n        \"yellow\": $yellow,\n        \"green\": $green,\n        \"teal\": $teal,\n        \"cyan\": $cyan,\n        \"white\": $white,\n        \"gray\": $gray-600,\n        \"gray-dark\": $gray-800\n), $colors);\n\n$primary: $blue !default;\n$secondary: $gray-600 !default;\n$success: $green !default;\n$info: $cyan !default;\n$warning: $yellow !default;\n$danger: $red !default;\n$light: $gray-100 !default;\n$dark: $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge((\n        \"primary\": $primary,\n        \"secondary\": $secondary,\n        \"success\": $success,\n        \"info\": $info,\n        \"warning\": $warning,\n        \"danger\": $danger,\n        \"light\": $light,\n        \"dark\": $dark\n), $theme-colors);\n// stylelint-enable\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval: 8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold: 150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark: $gray-900 !default;\n$yiq-text-light: $white !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret: true !default;\n$enable-rounded: true !default;\n$enable-shadows: false !default;\n$enable-gradients: false !default;\n$enable-transitions: true !default;\n$enable-hover-media-query: false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes: true !default;\n$enable-print-styles: true !default;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// stylelint-disable\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge((\n        0: 0,\n        1: ($spacer * .25),\n        2: ($spacer * .5),\n        3: $spacer,\n        4: ($spacer * 1.5),\n        5: ($spacer * 3)\n), $spacers);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge((\n        25: 25%,\n        50: 50%,\n        75: 75%,\n        100: 100%\n), $sizes);\n// stylelint-enable\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg: $white !default;\n$body-color: $gray-900 !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: theme-color(\"primary\") !default;\n$link-decoration: none !default;\n$link-hover-color: darken($link-color, 15%) !default;\n$link-hover-decoration: underline !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom: 1rem !default;\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n        xs: 0,\n        sm: 576px,\n        md: 768px,\n        lg: 992px,\n        xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n        sm: 540px,\n        md: 720px,\n        lg: 960px,\n        xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns: 12 !default;\n$grid-gutter-width: 30px !default;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg: 1.5 !default;\n$line-height-sm: 1.5 !default;\n\n$border-width: 1px !default;\n$border-color: $gray-300 !default;\n\n$border-radius: .25rem !default;\n$border-radius-lg: .3rem !default;\n$border-radius-sm: .2rem !default;\n\n$component-active-color: $white !default;\n$component-active-bg: theme-color(\"primary\") !default;\n\n$caret-width: .3em !default;\n\n$transition-base: all .2s ease-in-out !default;\n$transition-fade: opacity .15s linear !default;\n$transition-collapse: height .35s ease !default;\n\n// Fonts\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !default;\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base: $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base: 1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg: ($font-size-base * 1.25) !default;\n$font-size-sm: ($font-size-base * .875) !default;\n\n$font-weight-light: 300 !default;\n$font-weight-normal: 400 !default;\n$font-weight-bold: 700 !default;\n\n$font-weight-base: $font-weight-normal !default;\n$line-height-base: 1.5 !default;\n\n$h1-font-size: $font-size-base * 2.5 !default;\n$h2-font-size: $font-size-base * 2 !default;\n$h3-font-size: $font-size-base * 1.75 !default;\n$h4-font-size: $font-size-base * 1.5 !default;\n$h5-font-size: $font-size-base * 1.25 !default;\n$h6-font-size: $font-size-base !default;\n\n$headings-margin-bottom: ($spacer / 2) !default;\n$headings-font-family: inherit !default;\n$headings-font-weight: 500 !default;\n$headings-line-height: 1.2 !default;\n$headings-color: inherit !default;\n\n$display1-size: 6rem !default;\n$display2-size: 5.5rem !default;\n$display3-size: 4.5rem !default;\n$display4-size: 3.5rem !default;\n\n$display1-weight: 300 !default;\n$display2-weight: 300 !default;\n$display3-weight: 300 !default;\n$display4-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n\n$lead-font-size: ($font-size-base * 1.25) !default;\n$lead-font-weight: 300 !default;\n\n$small-font-size: 80% !default;\n\n$text-muted: $gray-600 !default;\n\n$blockquote-small-color: $gray-600 !default;\n$blockquote-font-size: ($font-size-base * 1.25) !default;\n\n$hr-border-color: rgba($black, .1) !default;\n$hr-border-width: $border-width !default;\n\n$mark-padding: .2em !default;\n\n$dt-font-weight: $font-weight-bold !default;\n\n$kbd-box-shadow: inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight: $font-weight-bold !default;\n\n$list-inline-padding: .5rem !default;\n\n$mark-bg: #fcf8e3 !default;\n\n$hr-margin-y: $spacer !default;\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding: .75rem !default;\n$table-cell-padding-sm: .3rem !default;\n\n$table-bg: transparent !default;\n$table-accent-bg: rgba($black, .05) !default;\n$table-hover-bg: rgba($black, .075) !default;\n$table-active-bg: $table-hover-bg !default;\n\n$table-border-width: $border-width !default;\n$table-border-color: $gray-300 !default;\n\n$table-head-bg: $gray-200 !default;\n$table-head-color: $gray-700 !default;\n\n$table-dark-bg: $gray-900 !default;\n$table-dark-accent-bg: rgba($white, .05) !default;\n$table-dark-hover-bg: rgba($white, .075) !default;\n$table-dark-border-color: lighten($gray-900, 7.5%) !default;\n$table-dark-color: $body-bg !default;\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y: .375rem !default;\n$input-btn-padding-x: .75rem !default;\n$input-btn-line-height: $line-height-base !default;\n\n$input-btn-focus-width: .2rem !default;\n$input-btn-focus-color: rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm: .25rem !default;\n$input-btn-padding-x-sm: .5rem !default;\n$input-btn-line-height-sm: $line-height-sm !default;\n\n$input-btn-padding-y-lg: .5rem !default;\n$input-btn-padding-x-lg: 1rem !default;\n$input-btn-line-height-lg: $line-height-lg !default;\n\n$input-btn-border-width: $border-width !default;\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y: $input-btn-padding-y !default;\n$btn-padding-x: $input-btn-padding-x !default;\n$btn-line-height: $input-btn-line-height !default;\n\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\n$btn-line-height-sm: $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\n$btn-line-height-lg: $input-btn-line-height-lg !default;\n\n$btn-border-width: $input-btn-border-width !default;\n\n$btn-font-weight: $font-weight-normal !default;\n$btn-box-shadow: inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width: $input-btn-focus-width !default;\n$btn-focus-box-shadow: $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity: .65 !default;\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color: $gray-600 !default;\n\n$btn-block-spacing-y: .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius: $border-radius !default;\n$btn-border-radius-lg: $border-radius-lg !default;\n$btn-border-radius-sm: $border-radius-sm !default;\n\n$btn-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n// Forms\n\n$input-padding-y: $input-btn-padding-y !default;\n$input-padding-x: $input-btn-padding-x !default;\n$input-line-height: $input-btn-line-height !default;\n\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\n$input-line-height-sm: $input-btn-line-height-sm !default;\n\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\n$input-line-height-lg: $input-btn-line-height-lg !default;\n\n$input-bg: $white !default;\n$input-disabled-bg: $gray-200 !default;\n\n$input-color: $gray-700 !default;\n$input-border-color: $gray-400 !default;\n$input-border-width: $input-btn-border-width !default;\n$input-box-shadow: inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius: $border-radius !default;\n$input-border-radius-lg: $border-radius-lg !default;\n$input-border-radius-sm: $border-radius-sm !default;\n\n$input-focus-bg: $input-bg !default;\n$input-focus-border-color: lighten($component-active-bg, 25%) !default;\n$input-focus-color: $input-color !default;\n$input-focus-width: $input-btn-focus-width !default;\n$input-focus-box-shadow: $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color: $gray-600 !default;\n\n$input-height-border: $input-border-width * 2 !default;\n\n$input-height-inner: ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\n$input-height: calc(#{$input-height-inner} + #{$input-height-border}) !default;\n\n$input-height-inner-sm: ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\n$input-height-sm: calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\n\n$input-height-inner-lg: ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\n$input-height-lg: calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\n\n$input-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top: .25rem !default;\n\n$form-check-input-gutter: 1.25rem !default;\n$form-check-input-margin-y: .3rem !default;\n$form-check-input-margin-x: .25rem !default;\n\n$form-check-inline-margin-x: .75rem !default;\n$form-check-inline-input-margin-x: .3125rem !default;\n\n$form-group-margin-bottom: 1rem !default;\n\n$input-group-addon-color: $input-color !default;\n$input-group-addon-bg: $gray-200 !default;\n$input-group-addon-border-color: $input-border-color !default;\n\n$custom-control-gutter: 1.5rem !default;\n$custom-control-spacer-x: 1rem !default;\n\n$custom-control-indicator-size: 1rem !default;\n$custom-control-indicator-bg: $gray-300 !default;\n$custom-control-indicator-bg-size: 50% 50% !default;\n$custom-control-indicator-box-shadow: inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-control-indicator-disabled-bg: $gray-200 !default;\n$custom-control-label-disabled-color: $gray-600 !default;\n\n$custom-control-indicator-checked-color: $component-active-color !default;\n$custom-control-indicator-checked-bg: $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow: none !default;\n\n$custom-control-indicator-focus-box-shadow: 0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\n\n$custom-control-indicator-active-color: $component-active-color !default;\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow: none !default;\n\n$custom-checkbox-indicator-border-radius: $border-radius !default;\n$custom-checkbox-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color: $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow: none !default;\n\n$custom-radio-indicator-border-radius: 50% !default;\n$custom-radio-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$custom-select-padding-y: .375rem !default;\n$custom-select-padding-x: .75rem !default;\n$custom-select-height: $input-height !default;\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-line-height: $input-btn-line-height !default;\n$custom-select-color: $input-color !default;\n$custom-select-disabled-color: $gray-600 !default;\n$custom-select-bg: $white !default;\n$custom-select-disabled-bg: $gray-200 !default;\n$custom-select-bg-size: 8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color: $gray-800 !default;\n$custom-select-indicator: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$custom-select-border-width: $input-btn-border-width !default;\n$custom-select-border-color: $input-border-color !default;\n$custom-select-border-radius: $border-radius !default;\n\n$custom-select-focus-border-color: $input-focus-border-color !default;\n$custom-select-focus-box-shadow: inset 0 1px 2px rgba($black, .075), 0 0 5px rgba($custom-select-focus-border-color, .5) !default;\n\n$custom-select-font-size-sm: 75% !default;\n$custom-select-height-sm: $input-height-sm !default;\n\n$custom-select-font-size-lg: 125% !default;\n$custom-select-height-lg: $input-height-lg !default;\n\n$custom-file-height: $input-height !default;\n$custom-file-focus-border-color: $input-focus-border-color !default;\n$custom-file-focus-box-shadow: $input-btn-focus-box-shadow !default;\n\n$custom-file-padding-y: $input-btn-padding-y !default;\n$custom-file-padding-x: $input-btn-padding-x !default;\n$custom-file-line-height: $input-btn-line-height !default;\n$custom-file-color: $input-color !default;\n$custom-file-bg: $input-bg !default;\n$custom-file-border-width: $input-btn-border-width !default;\n$custom-file-border-color: $input-border-color !default;\n$custom-file-border-radius: $input-border-radius !default;\n$custom-file-box-shadow: $input-box-shadow !default;\n$custom-file-button-color: $custom-file-color !default;\n$custom-file-button-bg: $input-group-addon-bg !default;\n$custom-file-text: (\n        en: \"Browse\"\n) !default;\n\n// Form validation\n$form-feedback-margin-top: $form-text-margin-top !default;\n$form-feedback-font-size: $small-font-size !default;\n$form-feedback-valid-color: theme-color(\"success\") !default;\n$form-feedback-invalid-color: theme-color(\"danger\") !default;\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width: 10rem !default;\n$dropdown-padding-y: .5rem !default;\n$dropdown-spacer: .125rem !default;\n$dropdown-bg: $white !default;\n$dropdown-border-color: rgba($black, .15) !default;\n$dropdown-border-radius: $border-radius !default;\n$dropdown-border-width: $border-width !default;\n$dropdown-divider-bg: $gray-200 !default;\n$dropdown-box-shadow: 0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color: $gray-900 !default;\n$dropdown-link-hover-color: darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg: $gray-100 !default;\n\n$dropdown-link-active-color: $component-active-color !default;\n$dropdown-link-active-bg: $component-active-bg !default;\n\n$dropdown-link-disabled-color: $gray-600 !default;\n\n$dropdown-item-padding-y: .25rem !default;\n$dropdown-item-padding-x: 1.5rem !default;\n\n$dropdown-header-color: $gray-600 !default;\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown: 1000 !default;\n$zindex-sticky: 1020 !default;\n$zindex-fixed: 1030 !default;\n$zindex-modal-backdrop: 1040 !default;\n$zindex-modal: 1050 !default;\n$zindex-popover: 1060 !default;\n$zindex-tooltip: 1070 !default;\n\n// Navs\n\n$nav-link-padding-y: .5rem !default;\n$nav-link-padding-x: 1rem !default;\n$nav-link-disabled-color: $gray-600 !default;\n\n$nav-tabs-border-color: $gray-300 !default;\n$nav-tabs-border-width: $border-width !default;\n$nav-tabs-border-radius: $border-radius !default;\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color: $gray-700 !default;\n$nav-tabs-link-active-bg: $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius: $border-radius !default;\n$nav-pills-link-active-color: $component-active-color !default;\n$nav-pills-link-active-bg: $component-active-bg !default;\n\n// Navbar\n\n$navbar-padding-y: ($spacer / 2) !default;\n$navbar-padding-x: $spacer !default;\n\n$navbar-nav-link-padding-x: .5rem !default;\n\n$navbar-brand-font-size: $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height: ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n$navbar-toggler-padding-y: .25rem !default;\n$navbar-toggler-padding-x: .75rem !default;\n$navbar-toggler-font-size: $font-size-lg !default;\n$navbar-toggler-border-radius: $btn-border-radius !default;\n\n$navbar-dark-color: rgba($white, .5) !default;\n$navbar-dark-hover-color: rgba($white, .75) !default;\n$navbar-dark-active-color: $white !default;\n$navbar-dark-disabled-color: rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$navbar-dark-toggler-border-color: rgba($white, .1) !default;\n\n$navbar-light-color: rgba($black, .5) !default;\n$navbar-light-hover-color: rgba($black, .7) !default;\n$navbar-light-active-color: rgba($black, .9) !default;\n$navbar-light-disabled-color: rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n// Pagination\n\n$pagination-padding-y: .5rem !default;\n$pagination-padding-x: .75rem !default;\n$pagination-padding-y-sm: .25rem !default;\n$pagination-padding-x-sm: .5rem !default;\n$pagination-padding-y-lg: .75rem !default;\n$pagination-padding-x-lg: 1.5rem !default;\n$pagination-line-height: 1.25 !default;\n\n$pagination-color: $link-color !default;\n$pagination-bg: $white !default;\n$pagination-border-width: $border-width !default;\n$pagination-border-color: $gray-300 !default;\n\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow !default;\n\n$pagination-hover-color: $link-hover-color !default;\n$pagination-hover-bg: $gray-200 !default;\n$pagination-hover-border-color: $gray-300 !default;\n\n$pagination-active-color: $component-active-color !default;\n$pagination-active-bg: $component-active-bg !default;\n$pagination-active-border-color: $pagination-active-bg !default;\n\n$pagination-disabled-color: $gray-600 !default;\n$pagination-disabled-bg: $white !default;\n$pagination-disabled-border-color: $gray-300 !default;\n\n// Jumbotron\n\n$jumbotron-padding: 2rem !default;\n$jumbotron-bg: $gray-200 !default;\n\n// Cards\n\n$card-spacer-y: .75rem !default;\n$card-spacer-x: 1.25rem !default;\n$card-border-width: $border-width !default;\n$card-border-radius: $border-radius !default;\n$card-border-color: rgba($black, .125) !default;\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width}) !default;\n$card-cap-bg: rgba($black, .03) !default;\n$card-bg: $white !default;\n\n$card-img-overlay-padding: 1.25rem !default;\n\n$card-group-margin: ($grid-gutter-width / 2) !default;\n$card-deck-margin: $card-group-margin !default;\n\n$card-columns-count: 3 !default;\n$card-columns-gap: 1.25rem !default;\n$card-columns-margin: $card-spacer-y !default;\n\n// Tooltips\n\n$tooltip-font-size: $font-size-sm !default;\n$tooltip-max-width: 200px !default;\n$tooltip-color: $white !default;\n$tooltip-bg: $black !default;\n$tooltip-border-radius: $border-radius !default;\n$tooltip-opacity: .9 !default;\n$tooltip-padding-y: .25rem !default;\n$tooltip-padding-x: .5rem !default;\n$tooltip-margin: 0 !default;\n\n$tooltip-arrow-width: .8rem !default;\n$tooltip-arrow-height: .4rem !default;\n$tooltip-arrow-color: $tooltip-bg !default;\n\n// Popovers\n\n$popover-font-size: $font-size-sm !default;\n$popover-bg: $white !default;\n$popover-max-width: 276px !default;\n$popover-border-width: $border-width !default;\n$popover-border-color: rgba($black, .2) !default;\n$popover-border-radius: $border-radius-lg !default;\n$popover-box-shadow: 0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg: darken($popover-bg, 3%) !default;\n$popover-header-color: $headings-color !default;\n$popover-header-padding-y: .5rem !default;\n$popover-header-padding-x: .75rem !default;\n\n$popover-body-color: $body-color !default;\n$popover-body-padding-y: $popover-header-padding-y !default;\n$popover-body-padding-x: $popover-header-padding-x !default;\n\n$popover-arrow-width: 1rem !default;\n$popover-arrow-height: .5rem !default;\n$popover-arrow-color: $popover-bg !default;\n\n$popover-arrow-outer-color: fade-in($popover-border-color, .05) !default;\n\n// Badges\n\n$badge-font-size: 75% !default;\n$badge-font-weight: $font-weight-bold !default;\n$badge-padding-y: .25em !default;\n$badge-padding-x: .4em !default;\n$badge-border-radius: $border-radius !default;\n\n$badge-pill-padding-x: .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius: 10rem !default;\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding: 1rem !default;\n\n$modal-dialog-margin: .5rem !default;\n$modal-dialog-margin-y-sm-up: 1.75rem !default;\n\n$modal-title-line-height: $line-height-base !default;\n\n$modal-content-bg: $white !default;\n$modal-content-border-color: rgba($black, .2) !default;\n$modal-content-border-width: $border-width !default;\n$modal-content-box-shadow-xs: 0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up: 0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg: $black !default;\n$modal-backdrop-opacity: .5 !default;\n$modal-header-border-color: $gray-200 !default;\n$modal-footer-border-color: $modal-header-border-color !default;\n$modal-header-border-width: $modal-content-border-width !default;\n$modal-footer-border-width: $modal-header-border-width !default;\n$modal-header-padding: 1rem !default;\n\n$modal-lg: 800px !default;\n$modal-md: 500px !default;\n$modal-sm: 300px !default;\n\n$modal-transition: transform .3s ease-out !default;\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y: .75rem !default;\n$alert-padding-x: 1.25rem !default;\n$alert-margin-bottom: 1rem !default;\n$alert-border-radius: $border-radius !default;\n$alert-link-font-weight: $font-weight-bold !default;\n$alert-border-width: $border-width !default;\n\n$alert-bg-level: -10 !default;\n$alert-border-level: -9 !default;\n$alert-color-level: 6 !default;\n\n// Progress bars\n\n$progress-height: 1rem !default;\n$progress-font-size: ($font-size-base * .75) !default;\n$progress-bg: $gray-200 !default;\n$progress-border-radius: $border-radius !default;\n$progress-box-shadow: inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color: $white !default;\n$progress-bar-bg: theme-color(\"primary\") !default;\n$progress-bar-animation-timing: 1s linear infinite !default;\n$progress-bar-transition: width .6s ease !default;\n\n// List group\n\n$list-group-bg: $white !default;\n$list-group-border-color: rgba($black, .125) !default;\n$list-group-border-width: $border-width !default;\n$list-group-border-radius: $border-radius !default;\n\n$list-group-item-padding-y: .75rem !default;\n$list-group-item-padding-x: 1.25rem !default;\n\n$list-group-hover-bg: $gray-100 !default;\n$list-group-active-color: $component-active-color !default;\n$list-group-active-bg: $component-active-bg !default;\n$list-group-active-border-color: $list-group-active-bg !default;\n\n$list-group-disabled-color: $gray-600 !default;\n$list-group-disabled-bg: $list-group-bg !default;\n\n$list-group-action-color: $gray-700 !default;\n$list-group-action-hover-color: $list-group-action-color !default;\n\n$list-group-action-active-color: $body-color !default;\n$list-group-action-active-bg: $gray-200 !default;\n\n// Image thumbnails\n\n$thumbnail-padding: .25rem !default;\n$thumbnail-bg: $body-bg !default;\n$thumbnail-border-width: $border-width !default;\n$thumbnail-border-color: $gray-300 !default;\n$thumbnail-border-radius: $border-radius !default;\n$thumbnail-box-shadow: 0 1px 2px rgba($black, .075) !default;\n\n// Figures\n\n$figure-caption-font-size: 90% !default;\n$figure-caption-color: $gray-600 !default;\n\n// Breadcrumbs\n\n$breadcrumb-padding-y: .75rem !default;\n$breadcrumb-padding-x: 1rem !default;\n$breadcrumb-item-padding: .5rem !default;\n\n$breadcrumb-margin-bottom: 1rem !default;\n\n$breadcrumb-bg: $gray-200 !default;\n$breadcrumb-divider-color: $gray-600 !default;\n$breadcrumb-active-color: $gray-600 !default;\n$breadcrumb-divider: \"/\" !default;\n\n// Carousel\n\n$carousel-control-color: $white !default;\n$carousel-control-width: 15% !default;\n$carousel-control-opacity: .5 !default;\n\n$carousel-indicator-width: 30px !default;\n$carousel-indicator-height: 3px !default;\n$carousel-indicator-spacer: 3px !default;\n$carousel-indicator-active-bg: $white !default;\n\n$carousel-caption-width: 70% !default;\n$carousel-caption-color: $white !default;\n\n$carousel-control-icon-width: 20px !default;\n\n$carousel-control-prev-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$carousel-control-next-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$carousel-transition: transform .6s ease !default;\n\n// Close\n\n$close-font-size: $font-size-base * 1.5 !default;\n$close-font-weight: $font-weight-bold !default;\n$close-color: $black !default;\n$close-text-shadow: 0 1px 0 $white !default;\n\n// Code\n\n$code-font-size: 87.5% !default;\n$code-color: $pink !default;\n\n$kbd-padding-y: .2rem !default;\n$kbd-padding-x: .4rem !default;\n$kbd-font-size: $code-font-size !default;\n$kbd-color: $white !default;\n$kbd-bg: $gray-900 !default;\n\n$pre-color: $gray-900 !default;\n$pre-scrollable-max-height: 340px !default;\n\n// Printing\n$print-page-size: a3 !default;\n$print-body-min-width: map-get($grid-breakpoints, \"lg\") !default;\n","// Width and height Styles\n\n@each $prop, $abbrev in (width: w, height: h, max-width: mw, max-height: mh) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} {\n      #{$prop}: $length !important;\n    }\n  }\n}\n","// Utility Color Classes\r\n\r\n//.success {\r\n//\r\n//}\r\n\r\n// Google Color Palette defined: http://www.google.com/design/spec/style/color.html\r\n\r\n$primary: (\r\n        \"base\": #99BBCD,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$red: (\r\n        \"base\": #F44336,\r\n        \"lighten-5\": #FFEBEE,\r\n        \"lighten-4\": #FFCDD2,\r\n        \"lighten-3\": #EF9A9A,\r\n        \"lighten-2\": #E57373,\r\n        \"lighten-1\": #EF5350,\r\n        \"darken-1\": #E53935,\r\n        \"darken-2\": #D32F2F,\r\n        \"darken-3\": #C62828,\r\n        \"darken-4\": #B71C1C,\r\n        \"accent-1\": #FF8A80,\r\n        \"accent-2\": #FF5252,\r\n        \"accent-3\": #FF1744,\r\n        \"accent-4\": #D50000\r\n);\r\n\r\n$pink: (\r\n        \"base\": #e91e63,\r\n        \"lighten-5\": #fce4ec,\r\n        \"lighten-4\": #f8bbd0,\r\n        \"lighten-3\": #f48fb1,\r\n        \"lighten-2\": #f06292,\r\n        \"lighten-1\": #ec407a,\r\n        \"darken-1\": #d81b60,\r\n        \"darken-2\": #c2185b,\r\n        \"darken-3\": #ad1457,\r\n        \"darken-4\": #880e4f,\r\n        \"accent-1\": #ff80ab,\r\n        \"accent-2\": #ff4081,\r\n        \"accent-3\": #f50057,\r\n        \"accent-4\": #c51162\r\n);\r\n\r\n$purple: (\r\n        \"base\": #9C27B0,\r\n        \"lighten-5\": #f3e5f5,\r\n        \"lighten-4\": #e1bee7,\r\n        \"lighten-3\": #ce93d8,\r\n        \"lighten-2\": #ba68c8,\r\n        \"lighten-1\": #ab47bc,\r\n        \"darken-1\": #8e24aa,\r\n        \"darken-2\": #7b1fa2,\r\n        \"darken-3\": #6a1b9a,\r\n        \"darken-4\": #4a148c,\r\n        \"accent-1\": #ea80fc,\r\n        \"accent-2\": #e040fb,\r\n        \"accent-3\": #d500f9,\r\n        \"accent-4\": #aa00ff\r\n);\r\n\r\n$deep-purple: (\r\n        \"base\": #673ab7,\r\n        \"lighten-5\": #ede7f6,\r\n        \"lighten-4\": #d1c4e9,\r\n        \"lighten-3\": #b39ddb,\r\n        \"lighten-2\": #9575cd,\r\n        \"lighten-1\": #7e57c2,\r\n        \"darken-1\": #5e35b1,\r\n        \"darken-2\": #512da8,\r\n        \"darken-3\": #4527a0,\r\n        \"darken-4\": #311b92,\r\n        \"accent-1\": #b388ff,\r\n        \"accent-2\": #7c4dff,\r\n        \"accent-3\": #651fff,\r\n        \"accent-4\": #6200ea\r\n);\r\n\r\n$indigo: (\r\n        \"base\": #99BBCD,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$blue: (\r\n        \"base\": #2196F3,\r\n        \"lighten-5\": #E3F2FD,\r\n        \"lighten-4\": #BBDEFB,\r\n        \"lighten-3\": #90CAF9,\r\n        \"lighten-2\": #64B5F6,\r\n        \"lighten-1\": #42A5F5,\r\n        \"darken-1\": #1E88E5,\r\n        \"darken-2\": #1976D2,\r\n        \"darken-3\": #1565C0,\r\n        \"darken-4\": #0D47A1,\r\n        \"accent-1\": #82B1FF,\r\n        \"accent-2\": #448AFF,\r\n        \"accent-3\": #2979FF,\r\n        \"accent-4\": #2962FF\r\n);\r\n\r\n$light-blue: (\r\n        \"base\": #03a9f4,\r\n        \"lighten-5\": #e1f5fe,\r\n        \"lighten-4\": #b3e5fc,\r\n        \"lighten-3\": #81d4fa,\r\n        \"lighten-2\": #4fc3f7,\r\n        \"lighten-1\": #29b6f6,\r\n        \"darken-1\": #039be5,\r\n        \"darken-2\": #0288d1,\r\n        \"darken-3\": #0277bd,\r\n        \"darken-4\": #01579b,\r\n        \"accent-1\": #80d8ff,\r\n        \"accent-2\": #40c4ff,\r\n        \"accent-3\": #00b0ff,\r\n        \"accent-4\": #0091ea\r\n);\r\n\r\n$cyan: (\r\n        \"base\": #00bcd4,\r\n        \"lighten-5\": #e0f7fa,\r\n        \"lighten-4\": #b2ebf2,\r\n        \"lighten-3\": #80deea,\r\n        \"lighten-2\": #4dd0e1,\r\n        \"lighten-1\": #26c6da,\r\n        \"darken-1\": #00acc1,\r\n        \"darken-2\": #0097a7,\r\n        \"darken-3\": #00838f,\r\n        \"darken-4\": #006064,\r\n        \"accent-1\": #84ffff,\r\n        \"accent-2\": #18ffff,\r\n        \"accent-3\": #00e5ff,\r\n        \"accent-4\": #00b8d4\r\n);\r\n\r\n$teal: (\r\n        \"base\": #009688,\r\n        \"lighten-5\": #e0f2f1,\r\n        \"lighten-4\": #b2dfdb,\r\n        \"lighten-3\": #80cbc4,\r\n        \"lighten-2\": #4db6ac,\r\n        \"lighten-1\": #26a69a,\r\n        \"darken-1\": #00897b,\r\n        \"darken-2\": #00796b,\r\n        \"darken-3\": #00695c,\r\n        \"darken-4\": #004d40,\r\n        \"accent-1\": #a7ffeb,\r\n        \"accent-2\": #64ffda,\r\n        \"accent-3\": #1de9b6,\r\n        \"accent-4\": #00bfa5\r\n);\r\n\r\n$green: (\r\n        \"base\": #4CAF50,\r\n        \"lighten-5\": #E8F5E9,\r\n        \"lighten-4\": #C8E6C9,\r\n        \"lighten-3\": #A5D6A7,\r\n        \"lighten-2\": #81C784,\r\n        \"lighten-1\": #66BB6A,\r\n        \"darken-1\": #43A047,\r\n        \"darken-2\": #388E3C,\r\n        \"darken-3\": #2E7D32,\r\n        \"darken-4\": #1B5E20,\r\n        \"accent-1\": #B9F6CA,\r\n        \"accent-2\": #69F0AE,\r\n        \"accent-3\": #00E676,\r\n        \"accent-4\": #00C853\r\n);\r\n\r\n$light-green: (\r\n        \"base\": #8bc34a,\r\n        \"lighten-5\": #f1f8e9,\r\n        \"lighten-4\": #dcedc8,\r\n        \"lighten-3\": #c5e1a5,\r\n        \"lighten-2\": #aed581,\r\n        \"lighten-1\": #9ccc65,\r\n        \"darken-1\": #7cb342,\r\n        \"darken-2\": #689f38,\r\n        \"darken-3\": #558b2f,\r\n        \"darken-4\": #33691e,\r\n        \"accent-1\": #ccff90,\r\n        \"accent-2\": #b2ff59,\r\n        \"accent-3\": #76ff03,\r\n        \"accent-4\": #64dd17\r\n);\r\n\r\n$lime: (\r\n        \"base\": #cddc39,\r\n        \"lighten-5\": #f9fbe7,\r\n        \"lighten-4\": #f0f4c3,\r\n        \"lighten-3\": #e6ee9c,\r\n        \"lighten-2\": #dce775,\r\n        \"lighten-1\": #d4e157,\r\n        \"darken-1\": #c0ca33,\r\n        \"darken-2\": #afb42b,\r\n        \"darken-3\": #9e9d24,\r\n        \"darken-4\": #827717,\r\n        \"accent-1\": #f4ff81,\r\n        \"accent-2\": #eeff41,\r\n        \"accent-3\": #c6ff00,\r\n        \"accent-4\": #aeea00\r\n);\r\n\r\n$yellow: (\r\n        \"base\": #ffeb3b,\r\n        \"lighten-5\": #fffde7,\r\n        \"lighten-4\": #fff9c4,\r\n        \"lighten-3\": #fff59d,\r\n        \"lighten-2\": #fff176,\r\n        \"lighten-1\": #ffee58,\r\n        \"darken-1\": #fdd835,\r\n        \"darken-2\": #fbc02d,\r\n        \"darken-3\": #f9a825,\r\n        \"darken-4\": #f57f17,\r\n        \"accent-1\": #ffff8d,\r\n        \"accent-2\": #ffff00,\r\n        \"accent-3\": #ffea00,\r\n        \"accent-4\": #ffd600\r\n);\r\n\r\n$amber: (\r\n        \"base\": #ffc107,\r\n        \"lighten-5\": #fff8e1,\r\n        \"lighten-4\": #ffecb3,\r\n        \"lighten-3\": #ffe082,\r\n        \"lighten-2\": #ffd54f,\r\n        \"lighten-1\": #ffca28,\r\n        \"darken-1\": #ffb300,\r\n        \"darken-2\": #ffa000,\r\n        \"darken-3\": #ff8f00,\r\n        \"darken-4\": #ff6f00,\r\n        \"accent-1\": #ffe57f,\r\n        \"accent-2\": #ffd740,\r\n        \"accent-3\": #ffc400,\r\n        \"accent-4\": #ffab00\r\n);\r\n\r\n$orange: (\r\n        \"base\": #ff9800,\r\n        \"lighten-5\": #fff3e0,\r\n        \"lighten-4\": #ffe0b2,\r\n        \"lighten-3\": #ffcc80,\r\n        \"lighten-2\": #ffb74d,\r\n        \"lighten-1\": #ffa726,\r\n        \"darken-1\": #fb8c00,\r\n        \"darken-2\": #f57c00,\r\n        \"darken-3\": #ef6c00,\r\n        \"darken-4\": #e65100,\r\n        \"accent-1\": #ffd180,\r\n        \"accent-2\": #ffab40,\r\n        \"accent-3\": #ff9100,\r\n        \"accent-4\": #ff6d00\r\n);\r\n\r\n$deep-orange: (\r\n        \"base\": #ff5722,\r\n        \"lighten-5\": #fbe9e7,\r\n        \"lighten-4\": #ffccbc,\r\n        \"lighten-3\": #ffab91,\r\n        \"lighten-2\": #ff8a65,\r\n        \"lighten-1\": #ff7043,\r\n        \"darken-1\": #f4511e,\r\n        \"darken-2\": #e64a19,\r\n        \"darken-3\": #d84315,\r\n        \"darken-4\": #bf360c,\r\n        \"accent-1\": #ff9e80,\r\n        \"accent-2\": #ff6e40,\r\n        \"accent-3\": #ff3d00,\r\n        \"accent-4\": #dd2c00\r\n);\r\n\r\n$brown: (\r\n        \"base\": #795548,\r\n        \"lighten-5\": #efebe9,\r\n        \"lighten-4\": #d7ccc8,\r\n        \"lighten-3\": #bcaaa4,\r\n        \"lighten-2\": #a1887f,\r\n        \"lighten-1\": #8d6e63,\r\n        \"darken-1\": #6d4c41,\r\n        \"darken-2\": #5d4037,\r\n        \"darken-3\": #4e342e,\r\n        \"darken-4\": #3e2723\r\n);\r\n\r\n$blue-gray: (\r\n        \"base\": #607d8b,\r\n        \"lighten-5\": #eceff1,\r\n        \"lighten-4\": #cfd8dc,\r\n        \"lighten-3\": #b0bec5,\r\n        \"lighten-2\": #90a4ae,\r\n        \"lighten-1\": #78909c,\r\n        \"darken-1\": #546e7a,\r\n        \"darken-2\": #455a64,\r\n        \"darken-3\": #37474f,\r\n        \"darken-4\": #263238\r\n);\r\n\r\n$gray: (\r\n        \"base\": #9e9e9e,\r\n        \"lighten-5\": #fafafa,\r\n        \"lighten-4\": #f5f5f5,\r\n        \"lighten-3\": #eeeeee,\r\n        \"lighten-2\": #e0e0e0,\r\n        \"lighten-1\": #bdbdbd,\r\n        \"darken-1\": #757575,\r\n        \"darken-2\": #616161,\r\n        \"darken-3\": #424242,\r\n        \"darken-4\": #212121\r\n);\r\n\r\n$celia_palette: (\r\n        \"gray\": #f2f3f5,\r\n        \"white\": #FFFFFF,\r\n        \"online-green\": #5FB98F,\r\n        \"orange\": rgba(255, 137, 93, 1),\r\n        \"orange-25\": rgba(255, 137, 93, 0.25),\r\n        \"orange-50\": rgba(255, 137, 93, 0.5),\r\n        \"orange-80\": rgba(255, 137, 93, 0.8),\r\n        \"gray-blue\": rgba(70, 120, 170, 1),\r\n        \"gray-blue-5\": #EAEDF2,\r\n        \"gray-blue-10\": rgba(70, 120, 170, 0.1),\r\n        \"gray-blue-20\": #DAE4EE,\r\n        \"gray-blue-25\": rgba(70, 120, 170, 0.25),\r\n        \"gray-blue-35\": rgba(70, 120, 170, 0.35),\r\n        \"gray-blue-40\": rgba(70, 120, 170, 0.4),\r\n        \"gray-blue-50\": rgba(70, 120, 170, 0.5),\r\n        \"sharp-border\": #A3ADC5,\r\n        \"black-text\": #222222,\r\n        \"dark-text\": rgba(27, 37, 95, 1),\r\n        \"dark-text-80\": rgba(27, 37, 95, 0.8),\r\n        \"dark-text-30\": rgba(27, 37, 95, 0.3),\r\n        \"black-transparent-5\": rgba(0, 0, 0, 0.05),\r\n        \"black-transparent-10\": rgba(0, 0, 0, 0.10),\r\n        \"black-transparent-17\": rgba(0, 0, 0, 0.17),\r\n        \"gray-light\": #BEC7D5,\r\n        \"gray-light-a\": rgba(74, 98, 136, 0.2)\r\n);\r\n\r\n$shades: (\r\n        \"black\": #000000,\r\n        \"white\": #FFFFFF,\r\n        \"transparent\": transparent\r\n);\r\n\r\n$colors_palette: (\r\n        \"primary\": $primary,\r\n        \"red\": $red,\r\n        \"pink\": $pink,\r\n        \"purple\": $purple,\r\n        \"deep-purple\": $deep-purple,\r\n        \"indigo\": $indigo,\r\n        \"blue\": $blue,\r\n        \"light-blue\": $light-blue,\r\n        \"cyan\": $cyan,\r\n        \"teal\": $teal,\r\n        \"green\": $green,\r\n        \"light-green\": $light-green,\r\n        \"lime\": $lime,\r\n        \"yellow\": $yellow,\r\n        \"amber\": $amber,\r\n        \"orange\": $orange,\r\n        \"deep-orange\": $deep-orange,\r\n        \"brown\": $brown,\r\n        \"blue-grey\": $blue-gray,\r\n        \"grey\": $gray,\r\n        \"shades\": $shades,\r\n        \"celia\": $celia_palette\r\n) !default;\r\n\r\n// Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .bg-#{$color_name} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    } @else if $color_name != \"shades\" {\r\n      .bg-#{$color_name}.#{$color_type} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name}.text-#{$color_type} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Shade classes\r\n@each $color, $color_value in $shades {\r\n  .bg-#{$color} {\r\n    background-color: $color_value !important;\r\n  }\r\n  .text-#{$color} {\r\n    color: $color_value !important;\r\n    &.icon-outline {\r\n      border-color: $color_value !important;\r\n    }\r\n  }\r\n}\r\n\r\n// usage: color(\"name_of_color\", \"type_of_color\")\r\n// to avoid to repeating map-get($colors, ...)\r\n\r\n@function color($color, $type) {\r\n  @if map-has-key($colors_palette, $color) {\r\n    $curr_color: map-get($colors_palette, $color);\r\n    @if map-has-key($curr_color, $type) {\r\n      @return map-get($curr_color, $type);\r\n    }\r\n  }\r\n  @warn \"Unknown `#{$color}` - `#{$type}` in $colors.\";\r\n  @return null;\r\n}\r\n\r\n\r\n","/*Custom Animation*/\n\n@keyframes flipCenter {\n  0% {\n    animation-timing-function: ease-in;\n    opacity: 0;\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\n  }\n  40% {\n    animation-timing-function: ease-in;\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\n  }\n  60% {\n    opacity: 1;\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\n  }\n  80% {\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\n  }\n  100% {\n    transform: perspective(100000px);\n  }\n}\n\n@-webkit-keyframes flipCenter {\n  0% {\n    animation-timing-function: ease-in;\n    opacity: 0;\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\n  }\n  40% {\n    animation-timing-function: ease-in;\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\n  }\n  60% {\n    opacity: 1;\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\n  }\n  80% {\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\n  }\n  100% {\n    transform: perspective(100000px);\n  }\n}\n\n.flipCenter {\n  animation-name: flipCenter;\n  backface-visibility: visible;\n}\n\n@keyframes desployDown {\n  0% {\n    transform: scaleY(0);\n    transform-origin: center top 0;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: center top 0;\n  }\n}\n\n@-webkit-keyframes desployDown {\n  0% {\n    transform: scaleY(0);\n    transform-origin: center top 0;\n  }\n  100% {\n    opacity: 1;\n    transform: scaleY(1);\n    transform-origin: center top 0;\n  }\n}\n\n.desployDown {\n  animation-name: desployDown;\n  backface-visibility: visible;\n}\n\n@keyframes fadeInRightTiny {\n  0% {\n    opacity: 0;\n    transform: translate3d(30%, 0px, 0px);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@-webkit-keyframes fadeInRightTiny {\n  0% {\n    opacity: 0;\n    transform: translate3d(30%, 0px, 0px);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.fadeInRightTiny {\n  animation-name: fadeInRightTiny;\n}\n\n@keyframes fadeInLeftTiny {\n  0% {\n    opacity: 0;\n    transform: translate3d(-30%, 0px, 0px);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@-webkit-keyframes fadeInLeftTiny {\n  0% {\n    opacity: 0;\n    transform: translate3d(-30%, 0px, 0px);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.fadeInLeftTiny {\n  animation-name: fadeInLeftTiny;\n}\n\n@keyframes slideInRightTiny {\n  0% {\n    transform: translate3d(30%, 0px, 0px);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n@-webkit-keyframes slideInRightTiny {\n  0% {\n    transform: translate3d(30%, 0px, 0px);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n.slideInRightTiny {\n  animation-name: slideInRightTiny;\n}\n\n@keyframes slideInLeftTiny {\n  0% {\n    transform: translate3d(-30%, 0px, 0px);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n@-webkit-keyframes slideInLeftTiny {\n  0% {\n    transform: translate3d(-30%, 0px, 0px);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n.slideInLeftTiny {\n  animation-name: slideInLeftTiny;\n}\n\n@keyframes slideInUpTiny {\n  0% {\n    transform: translate3d(0px, 5%, 0px);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n@-webkit-keyframes slideInUpTiny {\n  0% {\n    transform: translate3d(0px, 5%, 0px);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n.slideInUpTiny {\n  animation-name: slideInUpTiny;\n}\n\n/*Animation Durations*/\n.animation-duration-1 {\n  animation-duration: 0.1s;\n}\n\n.animation-duration-2 {\n  animation-duration: 0.2s;\n}\n\n.animation-duration-3 {\n  animation-duration: 0.3s;\n}\n\n.animation-duration-4 {\n  animation-duration: 0.4s;\n}\n\n.animation-duration-5 {\n  animation-duration: 0.5s;\n}\n\n.animation-duration-6 {\n  animation-duration: 0.6s;\n}\n\n.animation-duration-7 {\n  animation-duration: 0.7s;\n}\n\n.animation-duration-8 {\n  animation-duration: 0.8s;\n}\n\n.animation-duration-9 {\n  animation-duration: 0.9s;\n}\n\n.animation-duration-10 {\n  animation-duration: 1s;\n}\n\n.animation-duration-11 {\n  animation-duration: 1.1s;\n}\n\n.animation-duration-12 {\n  animation-duration: 1.2s;\n}\n\n.animation-duration-13 {\n  animation-duration: 1.3s;\n}\n\n.animation-duration-14 {\n  animation-duration: 1.4s;\n}\n\n.animation-duration-15 {\n  animation-duration: 1.5s;\n}\n\n.animation-duration-16 {\n  animation-duration: 1.6s;\n}\n\n.animation-duration-17 {\n  animation-duration: 1.7s;\n}\n\n.animation-duration-18 {\n  animation-duration: 1.8s;\n}\n\n.animation-duration-19 {\n  animation-duration: 1.9s;\n}\n\n.animation-duration-20 {\n  animation-duration: 2s;\n}\n\n.animation-duration-21 {\n  animation-duration: 2.1s;\n}\n\n.animation-duration-22 {\n  animation-duration: 2.2s;\n}\n\n.animation-duration-23 {\n  animation-duration: 2.3s;\n}\n\n.animation-duration-24 {\n  animation-duration: 2.4s;\n}\n\n.animation-duration-25 {\n  animation-duration: 2.5s;\n}\n\n.animation-duration-26 {\n  animation-duration: 2.6s;\n}\n\n.animation-duration-27 {\n  animation-duration: 2.7s;\n}\n\n.animation-duration-28 {\n  animation-duration: 2.8s;\n}\n\n.animation-duration-29 {\n  animation-duration: 2.9s;\n}\n\n.animation-duration-30 {\n  animation-duration: 3s;\n}\n\n.animation-duration-31 {\n  animation-duration: 3.1s;\n}\n\n.animation-duration-32 {\n  animation-duration: 3.2s;\n}\n\n.animation-duration-33 {\n  animation-duration: 3.3s;\n}\n\n.animation-duration-34 {\n  animation-duration: 3.4s;\n}\n\n.animation-duration-35 {\n  animation-duration: 3.5s;\n}\n\n.animation-duration-36 {\n  animation-duration: 3.6s;\n}\n\n.animation-duration-37 {\n  animation-duration: 3.7s;\n}\n\n.animation-duration-38 {\n  animation-duration: 3.8s;\n}\n\n.animation-duration-39 {\n  animation-duration: 3.9s;\n}\n\n.animation-duration-40 {\n  animation-duration: 4s;\n}\n\n//Animation Delay\n\n.animation-delay-1 {\n  animation-delay: 0.1s;\n}\n\n.animation-delay-2 {\n  animation-delay: 0.2s;\n}\n\n.animation-delay-3 {\n  animation-delay: 0.3s;\n}\n\n.animation-delay-4 {\n  animation-delay: 0.4s;\n}\n\n.animation-delay-5 {\n  animation-delay: 0.5s;\n}\n\n.animation-delay-6 {\n  animation-delay: 0.6s;\n}\n\n.animation-delay-7 {\n  animation-delay: 0.7s;\n}\n\n.animation-delay-8 {\n  animation-delay: 0.8s;\n}\n\n.animation-delay-9 {\n  animation-delay: 0.9s;\n}\n\n.animation-delay-10 {\n  animation-delay: 1s;\n}\n\n.animation-delay-11 {\n  animation-delay: 1.1s;\n}\n\n.animation-delay-12 {\n  animation-delay: 1.2s;\n}\n\n.animation-delay-13 {\n  animation-delay: 1.3s;\n}\n\n.animation-delay-14 {\n  animation-delay: 1.4s;\n}\n\n.animation-delay-15 {\n  animation-delay: 1.5s;\n}\n\n.animation-delay-16 {\n  animation-delay: 1.6s;\n}\n\n.animation-delay-17 {\n  animation-delay: 1.7s;\n}\n\n.animation-delay-18 {\n  animation-delay: 1.8s;\n}\n\n.animation-delay-19 {\n  animation-delay: 1.9s;\n}\n\n.animation-delay-20 {\n  animation-delay: 2s;\n}\n\n.animation-delay-21 {\n  animation-delay: 2.1s;\n}\n\n.animation-delay-22 {\n  animation-delay: 2.2s;\n}\n\n.animation-delay-23 {\n  animation-delay: 2.3s;\n}\n\n.animation-delay-24 {\n  animation-delay: 2.4s;\n}\n\n.animation-delay-25 {\n  animation-delay: 2.5s;\n}\n\n.animation-delay-26 {\n  animation-delay: 2.6s;\n}\n\n.animation-delay-27 {\n  animation-delay: 2.6s;\n}\n\n.animation-delay-28 {\n  animation-delay: 2.8s;\n}\n\n.animation-delay-29 {\n  animation-delay: 2.9s;\n}\n\n.animation-delay-30 {\n  animation-delay: 3s;\n}\n\n.animation-delay-31 {\n  animation-delay: 3.1s;\n}\n\n.animation-delay-32 {\n  animation-delay: 3.2s;\n}\n\n.animation-delay-33 {\n  animation-delay: 3.3s;\n}\n\n.animation-delay-34 {\n  animation-delay: 3.4s;\n}\n\n.animation-delay-35 {\n  animation-delay: 3.5s;\n}\n\n.animation-delay-36 {\n  animation-delay: 3.6s;\n}\n\n.animation-delay-37 {\n  animation-delay: 3.7s;\n}\n\n.animation-delay-38 {\n  animation-delay: 3.8s;\n}\n\n.animation-delay-39 {\n  animation-delay: 3.9s;\n}\n\n.animation-delay-40 {\n  animation-delay: 4s;\n}\n\n.animation-delay-41 {\n  animation-delay: 4.1s;\n}\n\n.animation-delay-42 {\n  animation-delay: 4.2s;\n}\n\n.animation-delay-43 {\n  animation-delay: 4.3s;\n}\n\n.animation-delay-44 {\n  animation-delay: 4.4s;\n}\n\n.animation-delay-45 {\n  animation-delay: 4.5s;\n}\n\n.animation-delay-46 {\n  animation-delay: 4.6s;\n}\n\n.animation-delay-47 {\n  animation-delay: 4.7s;\n}\n\n.animation-delay-48 {\n  animation-delay: 4.8s;\n}\n\n.animation-delay-49 {\n  animation-delay: 4.9s;\n}\n\n.animation-delay-50 {\n  animation-delay: 5s;\n}","@use 'sass:map';\r\n@use \"sass:string\";\r\n\r\n// SASS String functions from: https://github.com/solovets/str.scss\r\n\r\n@function _return($correct, $result, $error) {\r\n  @if $correct {\r\n      @return $result;\r\n  } @else if not $str-scss-strong-type-check and not $correct {\r\n      @warn $error;\r\n      @return $result;\r\n  } @else {\r\n      @error $error;\r\n  }\r\n}\r\n\r\n@function _error($func, $args...) {\r\n  $description: '';\r\n\r\n  @each $arg in $args {\r\n      $arg-value: nth($arg, 1);\r\n      $arg-expected-type: nth($arg, 2);\r\n      $argument-is-correct: _check-type($arg-value, $arg-expected-type);\r\n\r\n      @if $argument-is-correct == false {\r\n          @if type-of($arg-value) == list {\r\n              $description: $description + ' One or more items of `#{$arg-value}` have wrong type. Expected types: `#{$arg-expected-type}`.';\r\n          } @else {\r\n              $description: $description + ' `#{$arg-value}` must be of type `#{$arg-expected-type}`, got `#{type-of($arg-value)}`.';\r\n          }\r\n      }\r\n\r\n\r\n  }\r\n\r\n  @return '[str.scss] [#{$func}]' + $description;\r\n}\r\n\r\n@function _check-type($input, $type: string, $check-if-list: false) {\r\n\r\n  $inputs: ();\r\n  $types: ();\r\n\r\n  $inputs: if(type-of($input) != list, append($inputs, $input), $input);\r\n  $types:  if(type-of($type) != list,  append($types, $type),   $type);\r\n\r\n  @if $check-if-list and type-of($input) != list {\r\n      @if index($types, type-of($input)) == null {\r\n          @return false;\r\n      }\r\n  }\r\n\r\n  @each $item in $inputs {\r\n      @if index($types, type-of($item)) == null {\r\n          @return false;\r\n      }\r\n  }\r\n\r\n  @return true;\r\n\r\n}\r\n\r\n@function str-join($input-list, $separator: '') {\r\n\r\n  $result: '';\r\n  $error: '';\r\n  $argument-is-correct: _check-type($input-list, (string, number), true) and _check-type($separator);\r\n\r\n  @if $argument-is-correct {\r\n\r\n      @each $item in $input-list {\r\n          $result: $result + if(index($input-list, $item) != 1, $separator, '') + $item;\r\n      }\r\n  } @else {\r\n      $error: _error('str-join', ($input-list, (string, number)), ($separator, string));\r\n  }\r\n\r\n  @return _return($argument-is-correct, $result, $error);\r\n};\r\n\r\n@function str-split($input-string, $separator: ' ') {\r\n\r\n  $result: ();\r\n  $error: '';\r\n  $argument-is-correct: _check-type($input-string) and _check-type($separator);\r\n\r\n  @if $argument-is-correct {\r\n      $index: str-index($input-string, $separator);\r\n      $indent: str-length($separator);\r\n\r\n      @while ($index != null) {\r\n          $item: str-slice($input-string, 1, $index - 1);\r\n          $input-string: str-slice($input-string, $index + $indent);\r\n          $index: str-index($input-string, $separator);\r\n\r\n          @if (str-length($item) != 0) {\r\n              $result: append($result, $item);\r\n          }\r\n      }\r\n\r\n      $result: append($result, $input-string);\r\n  } @else {\r\n      $error: _error('str-split', ($input-string, string), ($separator, string));\r\n  }\r\n\r\n  @return _return($argument-is-correct, $result, $error);\r\n}\r\n\r\n// Configuration map and functions\r\n\r\n// Split strings to abstract map getter\r\n@function ns($map, $path) {\r\n  $keys: ();\r\n  $separator: '.';\r\n  $index : str-index($path, $separator);\r\n\r\n  @while $index != null {\r\n    $item: str-slice($path, 1, $index - 1);\r\n    $keys: append($keys, $item);\r\n    $path: str-slice($path, $index + 1);\r\n    $index : str-index($path, $separator);\r\n  }\r\n\r\n  $keys: append($keys, $path);\r\n\r\n  @each $key in $keys {\r\n    $map: map-get($map, $key);\r\n  }\r\n\r\n  @return $map;\r\n}\r\n// Get a configuration entry\r\n@function config($path) {\r\n  @return ns($config, $path);\r\n}\r\n\r\n$config: (/* #region */\r\n  \"color\": (/* #region */\r\n    \"primary\": (/* #region */\r\n      \"100\": hsla(223deg, 37%, 93%, 1),\r\n      \"200\": hsla(223deg, 38%, 85%, 1),\r\n      \"300\": hsla(223deg, 39%, 71%, 1),\r\n      \"400\": hsla(222deg, 38%, 57%, 1),\r\n      \"500\": hsla(223deg, 53%, 42%, 1),\r\n      \"600\": hsla(222deg, 100%, 28%, 1),\r\n      \"700\": hsla(223deg, 100%, 22%, 1),\r\n      \"800\": hsla(222deg, 100%, 17%, 1),\r\n      \"900\": hsla(223deg, 100%, 11%, 1),\r\n      \"1000\": hsla(223deg, 100%, 5%, 1)\r\n    ),/* #endregion */\r\n    \"secondary\": (/* #region */\r\n      \"50\": hsla(221, 100%, 96%, 1),\r\n      \"100\": hsla(222, 100%, 92%, 1),\r\n      \"200\": hsla(222, 100%, 83%, 1),\r\n      \"300\": hsla(222, 100%, 75%, 1),\r\n      \"400\": hsla(222, 100%, 66%, 1),\r\n      \"500\": hsla(222, 100%, 57%, 1),\r\n      \"600\": hsla(222, 100%, 46%, 1),\r\n      \"700\": hsla(222, 100%, 35%, 1),\r\n      \"800\": hsla(222, 100%, 23%, 1),\r\n      \"900\": hsla(222, 100%, 12%, 1)\r\n    ),/* #endregion */\r\n    \"gray\": (/* #region */\r\n      \"50\": hsla(210, 20%, 98%, 1),\r\n      \"75\": hsla(220, 14%, 96%, 1),\r\n      \"100\": hsla(225, 13%, 94%, 1),\r\n      \"200\": hsla(220, 13%, 91%, 1),\r\n      \"300\": hsla(216, 12%, 84%, 1),\r\n      \"400\": hsla(218, 11%, 65%, 1),\r\n      \"500\": hsla(220, 9%, 46%, 1),\r\n      \"600\": hsla(215, 14%, 34%, 1),\r\n      \"700\": hsla(217, 19%, 27%, 1),\r\n      \"800\": hsla(215, 28%, 17%, 1),\r\n      \"900\": hsla(221, 39%, 11%, 1)\r\n    ),/* #endregion */\r\n    \"info\": (/* #region */\r\n      \"50\": hsla(229, 85%, 97%, 1),\r\n      \"100\": hsla(227, 85%, 95%, 1),\r\n      \"200\": hsla(224, 86%, 89%, 1),\r\n      \"300\": hsla(224, 89%, 82%, 1),\r\n      \"400\": hsla(222, 90%, 73%, 1),\r\n      \"500\": hsla(217, 91%, 60%, 1),\r\n      \"600\": hsla(217, 70%, 54%, 1),\r\n      \"700\": hsla(217, 61%, 46%, 1),\r\n      \"800\": hsla(217, 62%, 38%, 1),\r\n      \"900\": hsla(217, 62%, 27%, 1)\r\n    ),/* #endregion */\r\n    \"success\": (/* #region */\r\n      \"50\": hsla(156, 48%, 94%, 1),\r\n      \"100\": hsla(156, 50%, 88%, 1),\r\n      \"200\": hsla(156, 50%, 76%, 1),\r\n      \"300\": hsla(157, 50%, 65%, 1),\r\n      \"400\": hsla(156, 50%, 53%, 1),\r\n      \"500\": hsla(156, 50%, 53%, 1),\r\n      \"600\": hsla(156, 71%, 33%, 1),\r\n      \"700\": hsla(157, 71%, 25%, 1),\r\n      \"800\": hsla(156, 71%, 16%, 1),\r\n      \"900\": hsla(156, 71%, 8%, 1)\r\n    ),/* #endregion */\r\n    \"warning\": (/* #region */\r\n      \"50\": hsla(55, 92%, 95%, 1),\r\n      \"100\": hsla(55, 97%, 88%, 1),\r\n      \"200\": hsla(53, 98%, 77%, 1),\r\n      \"300\": hsla(50, 98%, 64%, 1),\r\n      \"400\": hsla(48, 96%, 53%, 1),\r\n      \"500\": hsla(48, 96%, 53%, 1),\r\n      \"600\": hsla(41, 96%, 40%, 1),\r\n      \"700\": hsla(35, 92%, 33%, 1),\r\n      \"800\": hsla(32, 81%, 29%, 1),\r\n      \"900\": hsla(28, 73%, 26%, 1)\r\n    ),/* #endregion */\r\n    \"error\": (/* #region */\r\n      \"50\": hsla(0, 86%, 97%, 1),\r\n      \"100\": hsla(0, 93%, 94%, 1),\r\n      \"200\": hsla(0, 96%, 89%, 1),\r\n      \"300\": hsla(0, 94%, 82%, 1),\r\n      \"400\": hsla(0, 91%, 71%, 1),\r\n      \"500\": hsla(0, 84%, 60%, 1),\r\n      \"600\": hsla(0, 72%, 51%, 1),\r\n      \"700\": hsla(0, 74%, 42%, 1),\r\n      \"800\": hsla(0, 70%, 35%, 1),\r\n      \"900\": hsla(0, 63%, 31%, 1)\r\n    ),/* #endregion */\r\n    \"basic\": (/* #region */\r\n      \"black\": hsla(0, 0%, 7%, 1),\r\n      \"white\": hsla(0, 50%, 100%, 1)\r\n    ),/* #endregion */\r\n    \"blue\": (/* #region */\r\n      \"50\": hsla(214, 100%, 97%, 1),\r\n      \"100\": hsla(214, 95%, 93%, 1),\r\n      \"200\": hsla(213, 97%, 87%, 1),\r\n      \"300\": hsla(212, 96%, 78%, 1),\r\n      \"400\": hsla(213, 94%, 68%, 1),\r\n      \"500\": hsla(217, 91%, 60%, 1),\r\n      \"600\": hsla(221, 83%, 53%, 1),\r\n      \"700\": hsla(224, 76%, 48%, 1),\r\n      \"800\": hsla(226, 71%, 40%, 1),\r\n      \"900\": hsla(224, 64%, 33%, 1)\r\n    ),/* #endregion */\r\n    \"gold\": (/* #region */\r\n      \"50\": #fdf8f3,\r\n      \"100\": #fbf0e6,\r\n      \"200\": #f7e1cc,\r\n      \"300\": #f3d2b3,\r\n      \"400\": #efc399,\r\n      \"500\": #D5B78B,\r\n      \"600\": #b37e3d,\r\n      \"700\": #a67135,\r\n      \"800\": #99642e,\r\n      \"900\": #8c5726\r\n    ),/* #endregion */\r\n  ),/* #endregion */\r\n  \"font\": (/* #region */\r\n    \"family\": #{string.quote(\"Open Sans\"), sans-serif},\r\n    \"weight\": (/* #region */\r\n      \"regular\": 400,\r\n      \"medium\": 500,\r\n      \"semibold\": 600,\r\n      \"bold\": 700\r\n    ),/* #endregion */\r\n    \"style\": (/* #region */\r\n      \"display\": (/* #region */\r\n        \"112\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 112px,\r\n          \"lineHeight\": 116px,\r\n          \"letterSpacing\": -0.02em\r\n        ),/* #endregion */\r\n        \"80\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 80px,\r\n          \"lineHeight\": 84px,\r\n          \"letterSpacing\": -0.02em\r\n        ),/* #endregion */\r\n        \"60\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 60px,\r\n          \"lineHeight\": 68px,\r\n          \"letterSpacing\": -0.02em\r\n        ),/* #endregion */\r\n      ),/* #endregion */\r\n      \"headline\": (/* #region */\r\n        \"48\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 48px,\r\n          \"lineHeight\": 56px,\r\n          \"letterSpacing\": -0.01em\r\n        ),/* #endregion */\r\n        \"36\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 36px,\r\n          \"lineHeight\": 44px,\r\n          \"letterSpacing\": -0.01em\r\n        ),/* #endregion */\r\n        \"28\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 28px,\r\n          \"lineHeight\": 36px,\r\n          \"letterSpacing\": -0.01em\r\n        ),/* #endregion */\r\n        \"24\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 24px,\r\n          \"lineHeight\": 32px,\r\n          \"letterSpacing\": -0.01em\r\n        )/* #endregion */\r\n      ),/* #endregion */\r\n      \"title\": (/* #region */\r\n        \"22\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 22px,\r\n          \"lineHeight\": 28px\r\n        ),/* #endregion */\r\n        \"16\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 16px,\r\n          \"lineHeight\": 20px,\r\n          \"letterSpacing\": -0.002em\r\n        ),/* #endregion */\r\n        \"12\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 12px,\r\n          \"lineHeight\": 16px,\r\n          \"letterSpacing\": -0.005em\r\n        ),/* #endregion */\r\n      ),/* #endregion */\r\n      \"body\": (/* #region */\r\n        \"20\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 20px,\r\n          \"lineHeight\": 32px\r\n        ),/* #endregion */\r\n        \"18\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 18px,\r\n          \"lineHeight\": 28px\r\n        ),/* #endregion */\r\n        \"16\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 16px,\r\n          \"lineHeight\": 24px\r\n        ),/* #endregion */\r\n        \"14\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 14px,\r\n          \"lineHeight\": 20px\r\n        ),/* #endregion */\r\n        \"12\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 12px,\r\n          \"lineHeight\": 16px,\r\n          \"letterSpacing\": 0.005em\r\n        ),/* #endregion */\r\n      ),/* #endregion */\r\n      \"label\": (/* #region */\r\n        \"18\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 18px,\r\n          \"lineHeight\": 28px\r\n        ),/* #endregion */\r\n        \"16\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 16px,\r\n          \"lineHeight\": 24px,\r\n          \"letterSpacing\": 0.002em\r\n        ),/* #endregion */\r\n        \"14\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 14px,\r\n          \"lineHeight\": 20px,\r\n          \"letterSpacing\": 0.005em\r\n        ),/* #endregion */\r\n        \"12\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 12px,\r\n          \"lineHeight\": 16px,\r\n          \"letterSpacing\": 0.005em\r\n        ),/* #endregion */\r\n        \"10\": (/* #region */\r\n          \"variant\": normal,\r\n          \"size\": 10px,\r\n          \"lineHeight\": 10px,\r\n          \"letterSpacing\": 0.005em\r\n        )/* #endregion */\r\n      )/* #endregion */\r\n    ),/* #endregion */\r\n    \"icons\": (\r\n      \"family\": string.quote(\"Font Awesome 6 Pro\")\r\n    ),\r\n    \"code\": (\r\n      \"family\": #{string.quote(\"SFMono-Regular\"), Consolas, string.quote(\"Liberation Mono\"), Menlo, Courier, monospace}\r\n    )\r\n  ),/* #endregion */\r\n  \"field\": (/* #region */\r\n    \"borderWidth\": 1px,\r\n    \"small\": (/* #region */\r\n      \"height\": 36px,\r\n      \"rbtItemHeight\": 40px,\r\n      \"cornerRadius\": 4px,\r\n      \"value\": (/* #region */\r\n        \"small\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 16px,\r\n            \"squareSize\": 20px\r\n          )\r\n        ),/* #endregion */\r\n        \"medium\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 16px,\r\n            \"squareSize\": 20px\r\n          )\r\n        ),/* #endregion */\r\n        \"large\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 20px,\r\n            \"squareSize\": 24px\r\n          )\r\n        )/* #endregion */\r\n      )/* #endregion */\r\n    ),/* #endregion */\r\n    \"medium\": (/* #region */\r\n      \"height\": 40px,\r\n      \"rbtItemHeight\": 42px,\r\n      \"cornerRadius\": 4px,\r\n      \"value\": (/* #region */\r\n        \"small\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 16px,\r\n            \"squareSize\": 20px\r\n          )\r\n        ),/* #endregion */\r\n        \"medium\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 16px,\r\n            \"squareSize\": 20px\r\n          )\r\n        ),/* #endregion */\r\n        \"large\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 20px,\r\n            \"squareSize\": 24px\r\n          )\r\n        )/* #endregion */\r\n      )/* #endregion */\r\n    ),/* #endregion */\r\n    \"large\": (/* #region */\r\n      \"height\": 48px,\r\n      \"rbtItemHeight\": 48px,\r\n      \"cornerRadius\": 6px,\r\n      \"value\": (/* #region */\r\n        \"small\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 20px,\r\n            \"squareSize\": 24px\r\n          )\r\n        ),/* #endregion */\r\n        \"medium\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 20px,\r\n            \"squareSize\": 24px\r\n          )\r\n        ),/* #endregion */\r\n        \"large\": (/* #region */\r\n          \"icon\": (\r\n            \"fontSize\": 20px,\r\n            \"squareSize\": 24px\r\n          )\r\n        )/* #endregion */\r\n      )/* #endregion */\r\n    )/* #endregion */\r\n  ),/* #endregion */\r\n  \"button\": (/* #region */\r\n    \"small\": (/* #region */\r\n      \"height\": 36px,\r\n      \"cornerRadius\": 4px,\r\n      \"inlinePadding\": 16px,\r\n      \"icon\": (\r\n        \"fontSize\": 13px,\r\n        \"squareSize\": 16px\r\n      )\r\n    ),/* #endregion */\r\n    \"medium\": (/* #region */\r\n      \"height\": 40px,\r\n      \"cornerRadius\": 4px,\r\n      \"inlinePadding\": 16px,\r\n      \"icon\": (\r\n        \"fontSize\": 13px,\r\n        \"squareSize\": 16px\r\n      )\r\n    ),/* #endregion */\r\n    \"large\": (/* #region */\r\n      \"height\": 48px,\r\n      \"cornerRadius\": 6px,\r\n      \"inlinePadding\": 18px,\r\n      \"icon\": (\r\n        \"fontSize\": 16px,\r\n        \"squareSize\": 20px\r\n      )\r\n    ),/* #endregion */\r\n    \"xlarge\": (/* #region */\r\n      \"height\": 60px,\r\n      \"cornerRadius\": 6px,\r\n      \"inlinePadding\": 24px,\r\n      \"icon\": (\r\n        \"fontSize\": 20px,\r\n        \"squareSize\": 24px\r\n      )\r\n    )/* #endregion */\r\n  ),/* #endregion */\r\n  \"shadow\": (/* #region */\r\n    \"light\": (/* #region */\r\n      \"100\": #{0px 0px 1px rgba(48, 49, 51, 0.05), 0px 1px 1px rgba(48, 49, 51, 0.1)},\r\n      \"200\": #{0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1)},\r\n      \"300\": #{0px 0px 1px rgba(48, 49, 51, 0.05), 0px 4px 8px rgba(48, 49, 51, 0.1)},\r\n      \"400\": #{0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1)},\r\n      \"500\": #{0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.09)},\r\n      \"600\": #{0px 0px 1px rgba(48, 49, 51, 0.05), 0px 24px 40px rgba(48, 49, 51, 0.08)}\r\n    ),/* #endregion */\r\n    \"primary\": (/* #region */\r\n      \"100\": #{0px 0px 1px rgba(59, 40, 204, 0.05), 0px 1px 1px rgba(59, 40, 204, 0.1)},\r\n      \"200\": #{0px 0px 1px rgba(59, 40, 204, 0.05), 0px 2px 4px rgba(59, 40, 204, 0.1)},\r\n      \"300\": #{0px 0px 1px rgba(59, 40, 204, 0.05), 0px 4px 8px rgba(59, 40, 204, 0.1)},\r\n      \"400\": #{0px 0px 1px rgba(59, 40, 204, 0.05), 0px 8px 16px rgba(59, 40, 204, 0.1)},\r\n      \"500\": #{0px 0px 1px rgba(59, 40, 204, 0.05), 0px 16px 24px rgba(59, 40, 204, 0.09)},\r\n      \"600\": #{0px 0px 1px rgba(59, 40, 204, 0.05), 0px 24px 40px rgba(59, 40, 204, 0.08)}\r\n    )/* #endregion */\r\n  ),/* #endregion */\r\n  \"layout\": (\r\n    \"cornerRadius\": (\r\n      \"xsmall\": 2px,\r\n      \"small\": 4px,\r\n      \"medium\": 6px,\r\n      \"large\": 8px,\r\n      \"big\": 10px,\r\n    )\r\n  )\r\n);/* #endregion */\r\n\r\n@mixin faIcon() {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  display: var(--fa-display, inline-block);\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  line-height: 1;\r\n  text-rendering: auto;\r\n}\r\n\r\n:root {\r\n  --app-header-height: 80px;\r\n\r\n  --jdv-row-offset: 30px;\r\n  --jdv-toggler-header-gap: 8px;\r\n  --jdv-row-min-height: 48px;\r\n  --jdv-row-base-inline-padding: var(--page-panel-inline-padding);\r\n  --jdv-border-style: solid;\r\n  --jdv-border-top-width: 1px;\r\n  --jdv-border-top-color: config(\"color.gray.200\");\r\n  --jdv-base-item-start-padding: 20px;\r\n  --jdv-base-parent-item-start-padding: 8px;\r\n\r\n  --ck-border-radius: 8px !important;\r\n}","@use \"sass:list\";\r\n@use \"sass:string\";\r\n@use \"sass:meta\";\r\n\r\n@mixin FontStyle($styleKey, $weight, $important: false) {\r\n  $entry: config(\"font.style.\" + $styleKey);\r\n  $weightValue: $weight;\r\n  @if meta.type-of($weight) == string {\r\n    $weightValue: config(\"font.weight.\" + $weight);\r\n  }\r\n  $fontFamily: config(\"font.family\");\r\n  @if ($important) {\r\n    font: map-get($entry, \"variant\") $weightValue #{map-get($entry, \"size\")}/#{map-get($entry, \"lineHeight\")} $fontFamily !important;\r\n  }\r\n  @else {\r\n    font: map-get($entry, \"variant\") $weightValue #{map-get($entry, \"size\")}/#{map-get($entry, \"lineHeight\")} $fontFamily;\r\n  }\r\n  letter-spacing: map-get($entry, \"letterSpacing\");\r\n}\r\n\r\n@mixin createFontStylesClasses() {\r\n\r\n  $weights: config(\"font.weight\");\r\n\r\n  @each $fontStyleItem in $fontStylesList {\r\n\r\n    $readyList: str-split($fontStyleItem, \"-\");\r\n    $styleItemMapIndex: str-join($readyList, \".\");\r\n\r\n    @each $weightIndex, $weightVal in $weights {\r\n\r\n      .#{$fontStyleItem + '-' + $weightIndex} {\r\n        @include FontStyle($styleItemMapIndex, $weightVal);\r\n      }\r\n\r\n    }\r\n\r\n  }\r\n}\r\n\r\n// Font styles list\r\n$fontStylesList: (/* #region */\r\n  \"display-112\",\r\n  \"display-80\",\r\n  \"display-60\",\r\n  \"headline-48\",\r\n  \"headline-36\",\r\n  \"headline-28\",\r\n  \"headline-24\",\r\n  \"title-22\",\r\n  \"title-16\",\r\n  \"title-12\",\r\n  \"body-20\",\r\n  \"body-18\",\r\n  \"body-16\",\r\n  \"body-14\",\r\n  \"body-12\",\r\n  \"label-18\",\r\n  \"label-16\",\r\n  \"label-14\",\r\n  \"label-12\",\r\n  \"label-10\"\r\n);/* #endregion */\r\n\r\n// Display styles classes\r\n@include createFontStylesClasses();\r\n\r\n/// Fonts\r\n//// Family Figtree 400 500 600 700 (import/declare)\r\n$figtree: \"../../fonts/figtree\";\r\n// Regular latin-ext\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local('Figtree'),\r\n       url('#{$figtree}/figtree-regular-latin-ext.woff2') format('woff2');\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n// Regular latin\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local('Figtree'),\r\n       url('#{$figtree}/figtree-regular-latin.woff2') format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n// Medium latin-ext\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local('Figtree Medium'),\r\n       url('#{$figtree}/figtree-medium-latin-ext.woff2') format('woff2');\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n// Medium latin\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local('Figtree Medium'),\r\n       url('#{$figtree}/figtree-medium-latin.woff2') format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n// Semibold latin-ext\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-display: swap;\r\n  src: local('Figtree SemiBold'),\r\n       url('#{$figtree}/figtree-semibold-latin-ext.woff2') format('woff2');\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n// Semibold latin\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-display: swap;\r\n  src: local('Figtree SemiBold'),\r\n       url('#{$figtree}/figtree-semibold-latin-ext.woff2') format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n// Bold latin-ext\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local('Figtree Bold'),\r\n       url('#{$figtree}/figtree-bold-latin-ext.woff2') format('woff2');\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n// Bold latin\r\n@font-face {\r\n  font-family: 'Figtree';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local('Figtree Bold'),\r\n       url('#{$figtree}/figtree-bold-latin.woff2') format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n//// Family Open Sans 400 500 600 700 (import/declare)\r\n$opensans: \"../../fonts/opensans\";\r\n/**************** Regular */\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-regular-latin-ext.woff2\") format('woff2');\r\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n/* latin */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-regular-latin.woff2\") format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n\r\n/**************** Medium */\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-medium-latin-ext.woff2\") format('woff2');\r\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n/* latin */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-medium-latin.woff2\") format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n\r\n/**************** SemiBold */\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-semibold-latin-ext.woff2\") format('woff2');\r\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n/* latin */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-semibold-latin.woff2\") format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n\r\n/**************** Bold */\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-bold-latin-ext.woff2\") format('woff2');\r\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n/* latin */\r\n@font-face {\r\n  font-family: 'Open Sans';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-stretch: 100%;\r\n  font-display: swap;\r\n  src: url(\"#{$opensans}/open-sans-bold-latin.woff2\") format('woff2');\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\r\n}\r\n\r\n.text-link {\r\n  color: var(--system-primary-color, #002b8f);\r\n  border-bottom: solid 1px;\r\n  @include FontStyle(\"body.14\", \"medium\");\r\n}\r\n.code-text {\r\n  font-family: config(\"font.code.family\");\r\n}","@use \"sass:string\";\r\n\r\n// Input fields\r\n.system-input-container {\r\n  --input-inline-padding: 16px;\r\n  --input-inline-end-padding-select: calc(var(--input-inline-padding) - 4px);\r\n  --field-border-width: #{config(\"field.borderWidth\")};\r\n  --field-gap: 10px;\r\n  --field-icon-square-size: #{config(\"field.medium.value.medium.icon.squareSize\")};\r\n  --field-icon-size: #{config(\"field.medium.value.medium.icon.fontSize\")};\r\n  --rbt-item-height: #{config(\"field.medium.rbtItemHeight\")};\r\n  --textarea-block-padding: 0px;\r\n  border-radius: var(--field-border-radius, config(\"field.medium.cornerRadius\"));\r\n  border: solid var(--field-border-width) var(--field-border-color, config(\"color.gray.300\"));\r\n  min-height: var(--field-height, config(\"field.medium.height\"));\r\n  background-color: config(\"color.basic.white\");\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--field-gap);\r\n\r\n  :is(input, select, textarea, .rbt-input, .ant-input, .react-select__single-value, .react-select__placeholder) {\r\n    color: config(\"color.basic.black\");\r\n    background-color: transparent;\r\n    @include FontStyle(\"label.14\", \"regular\");\r\n    border: none;\r\n    height: 100%;\r\n    flex: auto;\r\n    padding-inline: calc(var(--input-inline-padding) - var(--select-container-padding, 0px));\r\n    padding-block: var(--textarea-block-padding, 0px);\r\n    min-width: 50px;\r\n\r\n    &::placeholder {\r\n      color: config(\"color.gray.500\");\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n    }\r\n    &:where(:focus, :focus-visible) {\r\n      outline: none;\r\n    }\r\n    &:disabled {\r\n      background-color: config(\"color.gray.100\");\r\n      border-radius: calc(var(--field-border-radius) - 1px);\r\n    }\r\n  }\r\n  input[type=\"color\"] {\r\n    height: calc(var(--field-height, config(\"field.medium.height\")) - var(--field-border-width) * 2);\r\n    flex: 1;\r\n    padding: 0 2px;\r\n    width: 100%;\r\n    cursor: pointer;\r\n  }\r\n  i.input-icon {\r\n    font-size: var(--field-icon-size);\r\n    padding: 2px;\r\n    min-width: var(--field-icon-square-size);\r\n    min-height: var(--field-icon-square-size);\r\n    margin-inline-start: var(--input-inline-padding);\r\n\r\n    & + input {\r\n      margin-inline-start: calc(0px - var(--input-inline-padding) - var(--field-icon-square-size) - var(--field-gap));\r\n      padding-inline-start: calc(var(--input-inline-padding) + var(--field-icon-square-size) + var(--field-gap));\r\n    }\r\n  }\r\n  // Default field, no size specified, values sizes\r\n  /// Value small\r\n  &.value-s {\r\n    --field-icon-size: #{config(\"field.medium.value.small.icon.fontSize\")};\r\n    --field-icon-square-size: #{config(\"field.medium.value.small.icon.squareSize\")};\r\n\r\n    :is(input, select, textarea, .rbt-input, .ant-input),\r\n    .rbt-menu .dropdown-item,\r\n    .react-select__option,\r\n    .react-select__single-value {\r\n      @include FontStyle(\"label.12\", \"regular\");\r\n    }\r\n    &.bolder {\r\n      :is(input, select, textarea, .rbt-input, .ant-input) {\r\n        @include FontStyle(\"label.12\", \"semibold\");\r\n      }\r\n    }\r\n    .rbt-highlight-text {\r\n      @include FontStyle(\"label.12\", \"semibold\");\r\n    }\r\n  }\r\n  /// Value medium\r\n  &.value-m {\r\n    --field-icon-size: #{config(\"field.medium.value.medium.icon.fontSize\")};\r\n    --field-icon-square-size: #{config(\"field.medium.value.medium.icon.squareSize\")};\r\n\r\n    :is(input, select, textarea, .rbt-input, .ant-input),\r\n    .rbt-menu .dropdown-item,\r\n    .react-select__option,\r\n    .react-select__single-value {\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n    }\r\n    &.bolder {\r\n      :is(input, select, textarea, .rbt-input, .ant-input) {\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n      }\r\n    }\r\n    .rbt-highlight-text {\r\n      @include FontStyle(\"label.14\", \"semibold\");\r\n    }\r\n  }\r\n  /// Value large\r\n  &.value-l {\r\n    --field-icon-size: #{config(\"field.medium.value.large.icon.fontSize\")};\r\n    --field-icon-square-size: #{config(\"field.medium.value.large.icon.squareSize\")};\r\n    \r\n    :is(input, select, textarea, .rbt-input, .ant-input),\r\n    .rbt-menu .dropdown-item,\r\n    .react-select__option,\r\n    .react-select__single-value {\r\n      @include FontStyle(\"label.16\", \"regular\");\r\n    }\r\n    &.bolder {\r\n      :is(input, select, textarea, .rbt-input, .ant-input) {\r\n        @include FontStyle(\"label.16\", \"semibold\");\r\n      }\r\n    }\r\n    .rbt-highlight-text {\r\n      @include FontStyle(\"label.16\", \"semibold\");\r\n    }\r\n  }\r\n  // Field size Small (S)\r\n  &.size-s {\r\n    --field-height: #{config(\"field.small.height\")};\r\n    --rbt-item-height: #{config(\"field.small.rbtItemHeight\")};\r\n    --field-border-radius: #{config(\"field.small.cornerRadius\")};\r\n    --field-icon-size: #{config(\"field.small.value.medium.icon.fontSize\")};\r\n    --field-icon-square-size: #{config(\"field.small.value.medium.icon.squareSize\")};\r\n\r\n    :is(input, select, textarea, .rbt-input, .ant-input) {\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n    }\r\n    &.bolder {\r\n      :is(input, select, textarea, .rbt-input, .ant-input) {\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n      }\r\n    }\r\n    /// Small field, value small\r\n    &.value-s {\r\n      --field-icon-size: #{config(\"field.small.value.small.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.small.value.small.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.12\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.12\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.12\", \"semibold\");\r\n      }\r\n    }\r\n    /// Small field, value medium\r\n    &.value-m {\r\n      --field-icon-size: #{config(\"field.small.value.medium.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.small.value.medium.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.14\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n      }\r\n    }\r\n    /// Small field, value large\r\n    &.value-l {\r\n      --field-icon-size: #{config(\"field.small.value.large.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.small.value.large.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.16\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.16\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.16\", \"semibold\");\r\n      }\r\n    }\r\n  }\r\n  // Field size Medium (M)\r\n  &.size-m {\r\n    --field-height: #{config(\"field.medium.height\")};\r\n    --rbt-item-height: #{config(\"field.medium.rbtItemHeight\")};\r\n    --field-border-radius: #{config(\"field.medium.cornerRadius\")};\r\n    --field-icon-size: #{config(\"field.medium.value.medium.icon.fontSize\")};\r\n    --field-icon-square-size: #{config(\"field.medium.value.medium.icon.squareSize\")};\r\n\r\n    :is(input, select, textarea, .rbt-input, .ant-input),\r\n    .rbt-menu .dropdown-item,\r\n    .react-select__option,\r\n    .react-select__single-value {\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n    }\r\n    &.bolder {\r\n      :is(input, select, textarea, .rbt-input, .ant-input) {\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n      }\r\n    }\r\n    .rbt-highlight-text {\r\n      @include FontStyle(\"label.14\", \"semibold\");\r\n    }\r\n    /// Medium field, value small\r\n    &.value-s {\r\n      --field-icon-size: #{config(\"field.medium.value.small.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.medium.value.small.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.12\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.12\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.12\", \"semibold\");\r\n      }\r\n    }\r\n    /// Medium field, value small\r\n    &.value-m {\r\n      --field-icon-size: #{config(\"field.medium.value.medium.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.medium.value.medium.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.14\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n      }\r\n    }\r\n    /// Medium field, value small\r\n    &.value-l {\r\n      --field-icon-size: #{config(\"field.medium.value.large.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.medium.value.large.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.16\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.16\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.16\", \"semibold\");\r\n      }\r\n    }\r\n  }\r\n  // Field size Large (L)\r\n  &.size-l {\r\n    --field-height: #{config(\"field.large.height\")};\r\n    --rbt-item-height: #{config(\"field.large.rbtItemHeight\")};\r\n    --field-border-radius: #{config(\"field.large.cornerRadius\")};\r\n    --field-icon-size: #{config(\"field.large.value.medium.icon.fontSize\")};\r\n    --field-icon-square-size: #{config(\"field.large.value.medium.icon.squareSize\")};\r\n\r\n    :is(input, select, textarea, .rbt-input, .ant-input),\r\n    .rbt-menu .dropdown-item,\r\n    .react-select__option,\r\n    .react-select__single-value {\r\n      @include FontStyle(\"label.16\", \"regular\");\r\n    }\r\n    &.bolder {\r\n      :is(input, select, textarea, .rbt-input, .ant-input) {\r\n        @include FontStyle(\"label.16\", \"semibold\");\r\n      }\r\n    }\r\n    .rbt-highlight-text {\r\n      @include FontStyle(\"label.16\", \"semibold\");\r\n    }\r\n    /// Large field, value small\r\n    &.value-s {\r\n      --field-icon-size: #{config(\"field.large.value.small.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.large.value.small.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.14\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n      }\r\n    }\r\n    /// Large field, value small\r\n    &.value-m {\r\n      --field-icon-size: #{config(\"field.large.value.medium.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.large.value.medium.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.16\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.16\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.16\", \"semibold\");\r\n      }\r\n    }\r\n    /// Large field, value small\r\n    &.value-l {\r\n      --field-icon-size: #{config(\"field.large.value.large.icon.fontSize\")};\r\n      --field-icon-square-size: #{config(\"field.large.value.large.icon.squareSize\")};\r\n      \r\n      :is(input, select, textarea, .rbt-input, .ant-input),\r\n      .rbt-menu .dropdown-item,\r\n      .react-select__option,\r\n      .react-select__single-value {\r\n        @include FontStyle(\"label.18\", \"regular\");\r\n      }\r\n      &.bolder {\r\n        :is(input, select, textarea, .rbt-input, .ant-input) {\r\n          @include FontStyle(\"label.18\", \"semibold\");\r\n        }\r\n      }\r\n      .rbt-highlight-text {\r\n        @include FontStyle(\"label.18\", \"semibold\");\r\n      }\r\n    }\r\n  }\r\n  // Field state colors\r\n  &.state-error {\r\n    --field-border-color: #{config(\"color.error.400\")};\r\n  }\r\n  &.state-success {\r\n    --field-border-color: #{config(\"color.success.400\")};\r\n  }\r\n  // Field statuses\r\n  &:focus-within {\r\n    --field-border-color: #{config(\"color.info.300\")};\r\n    outline: solid 3px config(\"color.info.200\") !important;\r\n  }\r\n  &.disabled {\r\n    --field-border-color: #{config(\"color.gray.300\")};\r\n    background-color: config(\"color.gray.100\");\r\n\r\n    :is(input, select, textarea, .rbt-input, .ant-input) {\r\n      color: config(\"color.gray.400\");\r\n    }\r\n  }\r\n  &.required {\r\n    &:has(.is-invalid) {\r\n      --field-border-color: #{config(\"color.error.400\")};\r\n    }\r\n    & + .invalid-feedback {\r\n      display: block;\r\n      color: config(\"color.error.500\");\r\n      @include FontStyle(\"label.12\", \"regular\");\r\n    }\r\n  }\r\n  // Field style\r\n  &.minimal {\r\n    --field-border-width: 0px;\r\n  }\r\n\r\n  // Select fields\r\n  &.select {\r\n    --select-container-padding: 6px;\r\n    cursor: pointer;\r\n    padding-inline-end: var(--input-inline-end-padding-select);\r\n\r\n    select {\r\n      appearance: none;\r\n      background-color: transparent;\r\n      margin-inline-end: calc(0px - var(--input-inline-end-padding-select) - var(--field-gap) - var(--field-icon-square-size));\r\n      padding-inline-start: calc(var(--input-inline-padding) - var(--select-container-padding));\r\n      padding-inline-end: calc(var(--input-inline-end-padding-select) + var(--field-gap) + var(--field-icon-square-size));\r\n      padding-block: 0px !important;\r\n      min-height: calc(var(--field-height) - var(--field-border-width) * 2);\r\n      min-width: initial !important;\r\n      max-width: initial !important;\r\n      z-index: 9;\r\n  \r\n      & + i.input-icon {\r\n        --field-icon-size: 14px;\r\n        margin-inline-start: 0;\r\n        display: grid;\r\n        place-content: center;\r\n      }\r\n    }\r\n    .type-select-style {\r\n      margin-inline-end: calc(0px - var(--input-inline-end-padding-select));\r\n      width: calc(100% + var(--input-inline-end-padding-select));\r\n      flex: auto;\r\n\r\n      .react-select__single-value {\r\n        margin-inline: 0px;\r\n        align-items: center;\r\n        display: flex;\r\n        padding-inline-start: calc(var(--input-inline-padding) - var(--select-container-padding));\r\n        min-width: max-content;\r\n      }\r\n      .react-select__control {\r\n        min-height: calc(var(--field-height) - var(--field-border-width) * 2);\r\n        padding: 0;\r\n        align-items: center;\r\n        border: none;\r\n        outline: none;\r\n        box-shadow: none;\r\n        border-radius: var(--field-border-radius);\r\n        flex-wrap: nowrap;\r\n      }\r\n      .react-select__value-container,\r\n      .react-select__indicators {\r\n        height: 100%;\r\n        padding: 0px;\r\n        min-height: calc(var(--field-height) - var(--field-border-width) * 2);\r\n      }\r\n      .react-select__indicator {\r\n        cursor: pointer;\r\n        padding: 7px;\r\n      }\r\n      .react-select__indicator-separator {\r\n        display: none;\r\n      }\r\n      .react-select__input {\r\n        margin-inline-start: calc(var(--input-inline-padding) - var(--select-container-padding)) !important;\r\n        height: 100%;\r\n      }\r\n      .react-select__value-container {\r\n        gap: 8px;\r\n        padding-inline-start: 8px;\r\n\r\n        > div:not(.react-select__single-value) {\r\n          height: 100%;\r\n          margin: 0;\r\n          padding: 0;\r\n        }\r\n        &.react-select__value-container--is-multi.react-select__value-container--has-value {\r\n          padding-block: 6px;\r\n\r\n          > .react-select__multi-value {\r\n            height: auto;\r\n            background-color: config(\"color.gray.200\");\r\n          }\r\n          & + .react-select__indicators {\r\n            align-self: center;\r\n          }\r\n        }\r\n        .react-select__multi-value__label:has(.count) > span {\r\n          display: flex;\r\n          gap: 6px;\r\n\r\n          .count {\r\n            background-color: config(\"color.gray.300\");\r\n            color: config(\"color.basic.black\");\r\n            font-size: 11px;\r\n          }\r\n        }\r\n      }\r\n      .react-select__menu {\r\n        box-shadow: config(\"shadow.light.400\");\r\n        border: 1px solid config(\"color.gray.200\");\r\n        border-radius: config(\"layout.cornerRadius.small\");\r\n        overflow: hidden;\r\n\r\n        > div {\r\n          padding: 0;\r\n        }\r\n      }\r\n      .react-select__option {\r\n        min-height: var(--rbt-item-height);\r\n        align-items: center;\r\n        display: flex;\r\n        padding-inline: var(--input-inline-padding);\r\n        color: config(\"color.basic.black\");\r\n        word-break: break-word;\r\n\r\n        // Nested feature styles\r\n        .nested-item {\r\n          position: relative;\r\n          padding-inline-start: calc(var(--level) * 15px);\r\n\r\n          &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            width: 1px;\r\n            height: calc(19px + 100%);\r\n            inset-inline-start: calc(10px * var(--level) - 14px);\r\n            top: -9px;\r\n            background-color: config(\"color.gray.300\");\r\n          }\r\n          &::after {\r\n            position: absolute;\r\n            content: \"\";\r\n            width: 8px;\r\n            height: 10px;\r\n            inset-inline-start: calc(10px * var(--level) - 14px);\r\n            top: calc(50% - 8px);\r\n            background-color: transparent;\r\n            border-style: none none solid solid;\r\n            border-color: config(\"color.gray.300\");\r\n            border-width: 0px 0px 1px 1px;\r\n            border-radius: 0 0 0 4px;\r\n          }\r\n          &.first-item {\r\n            &::before {\r\n              top: -28px;\r\n              height: calc(38px + 100%);\r\n            }\r\n          }\r\n          &.last-item {\r\n            &::before {\r\n              height: calc(9px + 50%);\r\n            }\r\n            &:not([style=\"--level: 1;\"]) {\r\n              > span {\r\n                &::after {\r\n                  content: \"\";\r\n                  position: absolute;\r\n                  width: 1px;\r\n                  height: calc(100% + 1px);\r\n                  background-color: config(\"color.gray.300\");\r\n                  top: calc(50% - 2px);\r\n                  inset-inline-start: -4px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n          &:not([style=\"--level: 1;\"]) {\r\n            &::before {\r\n              box-shadow: -10px 0px config(\"color.gray.300\");\r\n            }\r\n          }\r\n        }\r\n        .parent-item {\r\n          > span {\r\n            &::before {\r\n              content: \"\";\r\n              position: absolute;\r\n              width: 7px;\r\n              height: 7px;\r\n              background-color: white;\r\n              border-radius: 5px;\r\n              top: calc(50% - 2px);\r\n              inset-inline-start: 3px;\r\n              outline: solid 1px config(\"color.gray.300\");\r\n              z-index: 9;\r\n            }\r\n          }\r\n          &[style*=\"--level: 0\"] {\r\n            position: relative;\r\n            padding-inline-start: 5px;\r\n\r\n            > span {\r\n              &::before {\r\n                inset-inline-start: -7px;\r\n              }\r\n            }\r\n          }\r\n          &[style=\"--level: 2;\"] {\r\n            > span {\r\n              &::before {\r\n                inset-inline-start: 13px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .react-select__option--is-selected,\r\n      .react-select__option--is-focused {\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n      .react-select__multi-value__label {\r\n        @include FontStyle(\"body.12\", \"regular\");\r\n      }\r\n      .react-select__placeholder {\r\n        display: flex;\r\n        align-items: center;\r\n        padding-inline: calc(var(--input-inline-padding) - var(--select-container-padding)) !important;\r\n      }\r\n    }\r\n    &.multiple {\r\n      height: auto;\r\n      min-height: var(--field-height);\r\n\r\n      .type-select-style {\r\n        .react-select__control {\r\n          height: auto;\r\n        }\r\n        .react-select__value-container {\r\n          padding: var(--select-container-padding);\r\n          gap: 6px;\r\n        }\r\n        .react-select__multi-value {\r\n          background-color: config(\"color.gray.200\");\r\n        }\r\n      }\r\n    }\r\n    &:has(.type-select-style) {\r\n      --input-inline-end-padding-select: 0px;\r\n    }\r\n  }\r\n\r\n  // Datetime\r\n  &.datetime {\r\n    position: relative;\r\n    container-type: inline-size;\r\n    container-name: date-input;\r\n    min-width: 138px;\r\n\r\n    .rdt {\r\n      display: contents;\r\n\r\n      > div.form-control {\r\n        border: none;\r\n        padding-block: 0px;\r\n        padding-inline: calc(var(--input-inline-padding) - var(--select-container-padding, 0px));\r\n      }\r\n      .item.mustache {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 5px;\r\n        justify-content: space-between;\r\n\r\n        > span {\r\n          white-space: nowrap;\r\n        }\r\n        [role=\"button\"] {\r\n          font-size: 9px;\r\n          width: 15px;\r\n          height: 15px;\r\n          justify-content: center;\r\n          display: flex;\r\n          align-items: center;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n\r\n          &:hover {\r\n            background-color: config(\"color.gray.100\");\r\n          }\r\n        }\r\n      }\r\n      &.rdtOpen {\r\n        .item.mustache {\r\n          [role=\"button\"] {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .rdtPicker {\r\n      top: 100%;\r\n      inset-inline-end: var(--picker-inline-end, 0px);\r\n      padding: 0px;\r\n      box-shadow: 0 1px 28px rgba(0, 0, 0, 0.1);\r\n\r\n      > .row {\r\n        margin-inline: 0;\r\n        display: grid;\r\n        grid-template-columns: 130px 1fr;\r\n        gap: 12px;\r\n\r\n        > .col {\r\n          padding: 12px;\r\n\r\n          &:first-child {\r\n            border-inline-end: solid 1px config(\"color.gray.200\");\r\n          }\r\n          > button {\r\n            padding: 0px 14px;\r\n            min-height: 32px;\r\n            border-radius: 4px;\r\n            width: 100%;\r\n            text-align: start;\r\n            color: config(\"color.gray.400\");\r\n            line-height: 1;\r\n\r\n            &:hover {\r\n              background-color: config(\"color.primary.100\");\r\n              color: config(\"color.primary.600\");\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .dow {\r\n        color: config(\"color.gray.400\");\r\n        font-weight: 400;\r\n        text-transform: uppercase;\r\n        font-size: 10px;\r\n      }\r\n      .rdtDay {\r\n        padding: 8px 10.4px;\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n        text-align: center !important;\r\n        border-radius: config(\"layout.cornerRadius.medium\");\r\n        line-height: 1;\r\n        \r\n        &.rdtToday {\r\n          background-color: config(\"color.primary.100\");\r\n          color: config(\"color.primary.600\");\r\n          font-weight: 500;\r\n\r\n          &::before {\r\n            display: none;\r\n          }\r\n        }\r\n        &.rdtActive {\r\n          background-color: config(\"color.primary.600\");\r\n          color: config(\"color.basic.white\");\r\n        }\r\n        &:is(.rdtOld, .rdtNew) {\r\n          font-weight: 400;\r\n          color: config(\"color.gray.400\");\r\n        }\r\n        &.selected-range-day {\r\n          border-radius: config(\"layout.cornerRadius.medium\") 0 0 config(\"layout.cornerRadius.medium\");\r\n          background-color: config(\"color.gray.100\");\r\n          color: config(\"color.basic.black\");\r\n\r\n          & ~ .selected-range-day {\r\n            border-radius: 0;\r\n          }\r\n          &:last-child {\r\n            border-radius: 0 config(\"layout.cornerRadius.medium\") config(\"layout.cornerRadius.medium\") 0;\r\n          }\r\n        }\r\n      }\r\n      :is(.rdtMonth, .rdtYear) {\r\n        width: 50px;\r\n        height: 50px;\r\n        padding: 0px 14px;\r\n        border-radius: 4px;\r\n        color: config(\"color.primary.600\");\r\n\r\n        &:is(:hover, .rdtActive) {\r\n          background-color: config(\"color.primary.100\");\r\n        }\r\n      }\r\n      .rdtSwitch {\r\n        white-space: nowrap;\r\n      }\r\n      :is(th, td) {\r\n        width: 38px;\r\n        height: 38px;\r\n\r\n        &.dow {\r\n          height: 20px;\r\n        }\r\n      }\r\n    }\r\n    :is(.rdtNext, .rdtPrev, .rdtSwitch, .rdtTimeToggle) {\r\n      color: config(\"color.primary.500\");\r\n      border-radius: 6px;\r\n\r\n      > span {\r\n        line-height: 26px;\r\n        font-size: 34px;\r\n        font-weight: 400;\r\n        vertical-align: baseline;\r\n        display: inline-block;\r\n        padding-bottom: 8px;\r\n      }\r\n      &:hover {\r\n        background-color: config(\"color.primary.100\");\r\n        color: config(\"color.primary.600\");\r\n      }\r\n    }\r\n    .rdtCounters {\r\n      width: 100%;\r\n      display: flex;\r\n    }\r\n    .rdtCounter {\r\n      flex: 1;\r\n      height: initial;\r\n\r\n      .rdtBtn {\r\n        height: 40px;\r\n        border-radius: 6px;\r\n\r\n        &:hover {\r\n          background-color: config(\"color.primary.100\");\r\n          color: config(\"color.primary.600\");\r\n        }\r\n      }\r\n      .rdtCount {\r\n        height: 36px;\r\n        place-content: center;\r\n      }\r\n    }\r\n    .rdtCounterSeparator {\r\n      place-content: center;\r\n    }\r\n    .close-dtpk {\r\n      display: none;\r\n      align-items: center;\r\n      height: 100%;\r\n      position: absolute;\r\n      inset-inline-end: 0;\r\n\r\n      > span {\r\n        display: flex;\r\n        align-items: center;\r\n        height: 100%;\r\n        padding-inline: 10px;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n          background-color: config(\"color.gray.100\");\r\n        }\r\n      }\r\n    }\r\n    .rdtOpen + .close-dtpk {\r\n      display: flex;\r\n    }\r\n    &.contains-select {\r\n      gap: 0px;\r\n\r\n      .system-input-container.select {\r\n        width: 100%;\r\n        border-inline: none;\r\n        border-top-left-radius: 0;\r\n        border-bottom-left-radius: 0;\r\n\r\n        &:focus-within {\r\n          outline: none !important;\r\n        }\r\n      }\r\n    }\r\n    &.opens-right {\r\n      .rdtPicker {\r\n        --picker-inline-end: auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Textarea\r\n  textarea {\r\n    height: initial;\r\n    padding-block: var(--textarea-block-padding, 0px);\r\n    field-sizing: content;\r\n    word-break: break-word;\r\n  }\r\n  &.textarea {\r\n    --field-height: auto;\r\n    --textarea-block-padding: 16px;\r\n\r\n    &.like-field {\r\n      --textarea-block-padding: 7px;\r\n\r\n      textarea {\r\n        resize: none;\r\n        field-sizing: content;\r\n        max-width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Inline field\r\n  &.field-inline {\r\n    display: inline-flex;\r\n  }\r\n\r\n  // Autocomplete component\r\n  &.autocomplete {\r\n    position: relative;\r\n\r\n    .react-autosuggest__suggestions-container {\r\n      top: 100%;\r\n      width: 100%;\r\n    }\r\n    .react-autosuggest__suggestions-container--open {\r\n      z-index: 9;\r\n      border: solid 1px config(\"color.gray.200\");\r\n      box-shadow: config(\"shadow.light.400\");\r\n    }\r\n    .react-autosuggest__suggestion {\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n      padding: 8px 16px;\r\n      color: config(\"color.basic.black\");\r\n\r\n      &:is(:hover, .react-autosuggest__suggestion--highlighted) {\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n    }\r\n  }\r\n\r\n  // Prefix - Suffix\r\n  &.input-group {\r\n    --field-gap: 0;\r\n  }\r\n  .input-group-text {\r\n    @include FontStyle(\"label.14\", \"medium\");\r\n    color: config(\"color.basic.black\");\r\n    border: none;\r\n    background-color: config(\"color.gray.100\");\r\n  }\r\n  .input-group-prepend {\r\n    margin-right: 0px;\r\n    height: 100%;\r\n  }\r\n\r\n  // Formulas\r\n  .data-expression-view {\r\n    white-space: nowrap;\r\n    display: flex;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    gap: 8px;\r\n    padding-inline-end: 5px;\r\n    padding-inline-start: 12px;\r\n    flex: auto;\r\n\r\n    > div {\r\n      text-overflow: ellipsis;\r\n      overflow: hidden;\r\n      display: block;\r\n\r\n      &:has(.data-expression-view) {\r\n        display: flex;\r\n      }\r\n    }\r\n    .operator {\r\n      margin-inline-end: 5px;\r\n    }\r\n  }\r\n  &:has(.formula-button) {\r\n    gap: 0px;\r\n  }\r\n\r\n  // Search selector (RBT component)\r\n  // Overriding props\r\n  .rbt-input.form-control {\r\n    border: none;\r\n    padding: 0 var(--input-inline-padding);\r\n    min-height: calc(var(--field-height) - var(--field-border-width) * 2);\r\n\r\n    &:focus {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  .rbt-menu {\r\n    box-shadow: config(\"shadow.light.400\") !important;\r\n    border: 1px solid config(\"color.gray.200\") !important;\r\n    border-radius: config(\"layout.cornerRadius.small\") !important;\r\n\r\n    .dropdown-item {\r\n      min-height: var(--rbt-item-height);\r\n      align-items: center;\r\n      display: flex;\r\n      padding-inline: var(--input-inline-padding) !important;\r\n    }\r\n  }\r\n  &.rbt {\r\n    height: auto;\r\n    min-height: var(--field-height);\r\n\r\n    > div:not(.rbt-menu, .rbt-input) {\r\n      min-height: calc(var(--field-height) - var(--field-border-width) * 2);\r\n    }\r\n  }\r\n  .rbt-input-multi.form-control {\r\n    height: 100%;\r\n    padding-inline-start: 8px; // Fix\r\n    padding-inline-end: 34px; // Fix\r\n    padding-block: 5px;\r\n    min-height: 34px; // Fix\r\n\r\n    .rbt-input-main {\r\n      height: 100%;\r\n      margin: 0;\r\n    }\r\n    &.focus {\r\n      box-shadow: none;\r\n    }\r\n    .rbt-token-removeable {\r\n      padding-inline-start: 6px;\r\n      padding-inline-end: 0px;\r\n    }\r\n    &:last-child {\r\n      padding-inline-end: 8px;\r\n    }\r\n  }\r\n  .rbt-input-wrapper {\r\n    height: 100%;\r\n    margin-top: 0px !important;\r\n    margin-bottom: 0px !important;\r\n    gap: 6px;\r\n    min-height: calc(var(--field-height) - 12px);\r\n    align-items: center !important;\r\n\r\n    .rbt-token {\r\n      min-height: 24px;\r\n      align-items: center;\r\n      display: inline-flex;\r\n      border-radius: config(\"layout.cornerRadius.xsmall\");\r\n      background-color: config(\"color.gray.200\");\r\n      color: config(\"color.basic.black\");\r\n      @include FontStyle(\"body.12\", \"regular\");\r\n      padding-block: 0;\r\n      padding-inline-start: 16px;\r\n      padding-inline-end: 6px;\r\n      margin: 0;\r\n      gap: 6px;\r\n    }\r\n    .rbt-token-label {\r\n      padding: 0 !important;\r\n    }\r\n    .rbt-token-remove-button {\r\n      position: initial;\r\n      height: 100%;\r\n      font-size: 19px;\r\n      line-height: 20px;\r\n      width: 20px;\r\n      padding-inline: 0px;\r\n      padding-block: 0px;\r\n\r\n      &:hover {\r\n        background-color: config(\"color.gray.300\") !important;\r\n      }\r\n    }\r\n    div:last-child {\r\n      min-width: 110px;\r\n      min-height: 24px;\r\n\r\n      input {\r\n        min-height: 24px;\r\n      }\r\n    }\r\n  }\r\n  .rbt-aux {\r\n    .rbt-close {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n  .rbt-close {\r\n    opacity: 1;\r\n    color: var(--icon-color, #{config(\"color.gray.400\")});\r\n\r\n    &::before {\r\n      font-family: string.quote(config(\"font.icons.family\"));\r\n      @include faIcon;\r\n      content: \"\\F00D\";\r\n      font-weight: 400;\r\n      font-size: 14px;\r\n      width: 24px;\r\n      --fa-display: grid;\r\n      height: 24px;\r\n      place-content: center;\r\n    }\r\n    &:hover {\r\n      --icon-color: #{config(\"color.gray.600\")};\r\n    }\r\n  }\r\n  .rbt-close-content {\r\n    display: none !important;\r\n  }\r\n\r\n  // Rewrites for Ant Number Input\r\n  .ant-input-number {\r\n    border: none;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n  .ant-input-number-input-wrap {\r\n    height: 100%;\r\n  }\r\n\r\n  // Color field\r\n  .color-field {\r\n    position: relative;\r\n    cursor: pointer;\r\n\r\n    &::before,\r\n    &::after {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      border-radius: var(--field-border-radius, config(\"field.medium.cornerRadius\"));\r\n    }\r\n    &::before {\r\n      inset: 0;\r\n      background-color: config(\"color.basic.white\");\r\n    }\r\n    &::after {\r\n      inset: 6px;\r\n      background-color: var(--color-value);\r\n    }\r\n  }\r\n\r\n  // Scroll-contained overflow on focus\r\n  &.overflow-focus {\r\n    &:focus-within {\r\n      margin-inline-start: 3px;\r\n      \r\n      &.select {\r\n        margin-top: 3px;\r\n\r\n        .react-select__single-value {\r\n          padding-inline-start: calc(var(--input-inline-padding) - 3px);\r\n        }\r\n        .type-select-style {\r\n          .react-select__input {\r\n            margin-inline-start: calc(var(--input-inline-padding) - 3px) !important;\r\n          }\r\n          .react-select__option {\r\n            padding-inline-start: calc(var(--input-inline-padding) - 3px);\r\n          }\r\n        }\r\n      }\r\n      i.input-icon {\r\n        margin-inline-start: calc(var(--input-inline-padding) - 3px);\r\n      }\r\n    }\r\n  }\r\n}\r\n.system-label {\r\n  @include FontStyle(\"label.14\", \"medium\");\r\n  color: config(\"color.basic.black\");\r\n  display: flex;\r\n  margin-bottom: var(--label-bottom-margin, var(--system-label-bottom-margin, 6px));\r\n  gap: 6px;\r\n\r\n  &.label-inline {\r\n    display: inline-flex;\r\n  }\r\n  .help-icon {\r\n    align-self: center;\r\n  }\r\n  &.required {\r\n    &::after {\r\n      display: block;\r\n      min-width: 6px;\r\n      min-height: 6px;\r\n      content: \"\";\r\n      border-radius: 6px;\r\n      background-color: config(\"color.error.600\");\r\n      align-self: center;\r\n    }\r\n  }\r\n}\r\n.label-space {\r\n  margin-top: 26px; // 20px line height + 6px margin bottom\r\n}\r\n.form-group {\r\n  margin-bottom: 0px;\r\n}\r\n// Buttons\r\n.system-button {\r\n  --focused-outline-border-width: 1px;\r\n  --active-outline-border-width: 1px;\r\n  background-color: var(--button-bg-color, var(--system-primary-color, #002b8f));\r\n  color: var(--button-text-color, #{config(\"color.basic.white\")});\r\n  @include FontStyle(\"label.14\", \"medium\");\r\n  height: var(--button-height, #{config(\"button.medium.height\")});\r\n  border: none;\r\n  border-radius: var(--button-border-radius, #{config(\"button.medium.cornerRadius\")});\r\n  padding-inline: var(--button-inline-padding, #{config(\"button.medium.inlinePadding\")});\r\n  padding-block: 0;\r\n  display: inline-flex;\r\n  align-items: var(--button-vertical-align, center);\r\n  gap: 10px;\r\n  transition: background-color 0.15s ease;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n\r\n  &.padding-block {\r\n    padding-block: calc(var(--button-inline-padding, #{config(\"button.medium.inlinePadding\")}) - 4px) !important;\r\n    height: auto !important;\r\n  }\r\n  &:hover {\r\n    --button-bg-color: #{config(\"color.primary.700\")};\r\n  }\r\n  &:where(:focus, :focus-visible, .focused) {\r\n    outline: solid var(--focused-outline-border-width, 2px) var(--outline-color, #{config(\"color.primary.300\")}) !important;\r\n  }\r\n  &:where(:active, .active) {\r\n    --button-bg-color: #{config(\"color.primary.700\")};\r\n    outline: solid var(--active-outline-border-width, 2px) var(--outline-color, #{config(\"color.blue.200\")}) !important;\r\n  }\r\n  &:where(.disabled, :disabled, [disabled]) {\r\n    --button-bg-color: #{config(\"color.primary.200\")};\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n  &.outline {\r\n    --button-bg-color: transparent;\r\n    --button-text-color: var(--system-primary-color, #002b8f);\r\n    border: solid var(--button-border-width, 1px) var(--button-border-color, var(--system-primary-color, #002b8f));\r\n\r\n    &:hover {\r\n      --button-bg-color: #{config(\"color.primary.100\")};\r\n    }\r\n    &:where(:active, .active) {\r\n      --button-bg-color: #{config(\"color.primary.100\")};\r\n    }\r\n    &:where(.disabled, :disabled, [disabled]) {\r\n      --button-border-color: #{config(\"color.primary.200\")};\r\n      --button-text-color: #{config(\"color.primary.200\")};\r\n    }\r\n    &.grayscale {\r\n      --button-text-color: #{config(\"color.gray.700\")};\r\n      --button-border-color: #{config(\"color.gray.700\")};\r\n\r\n      &:hover {\r\n        --button-bg-color: #{config(\"color.gray.100\")};\r\n      }\r\n      &:where(:focus, :focus-visible, .focused) {\r\n        --outline-color: #{config(\"color.blue.200\")};\r\n        --button-border-color: #{config(\"color.blue.300\")};\r\n      }\r\n      &:active {\r\n        --button-bg-color: transparent;\r\n        --outline-color: #{config(\"color.gray.400\")};\r\n      }\r\n      &:where(.disabled, :disabled, [disabled]) {\r\n        --button-border-color: #{config(\"color.gray.300\")};\r\n        --button-text-color: #{config(\"color.gray.300\")};\r\n      }\r\n    }\r\n    &.color-error {\r\n      --button-text-color: #{config(\"color.error.600\")};\r\n      --button-border-color: #{config(\"color.error.600\")};\r\n\r\n      &:hover {\r\n        --button-bg-color: #{config(\"color.error.100\")};\r\n      }\r\n    }\r\n    &.color-info {\r\n      --button-bg-color: transparent;\r\n      --outline-color: #{config(\"color.blue.200\")};\r\n      --button-border-color: #{config(\"color.blue.300\")};\r\n    }\r\n  }\r\n  &.minimal {\r\n    --button-bg-color: transparent;\r\n    --button-text-color: var(--system-primary-color, #002b8f);\r\n\r\n    &:hover {\r\n      --button-bg-color: #{config(\"color.primary.100\")};\r\n    }\r\n    &:active {\r\n      --button-bg-color: transparent;\r\n      --button-text-color: #{config(\"color.primary.800\")};\r\n    }\r\n    &:where(.disabled, :disabled, [disabled]) {\r\n      --button-bg-color: transparent;\r\n      --button-text-color: #{config(\"color.primary.200\")};\r\n    }\r\n    &.grayscale {\r\n      --button-text-color: #{config(\"color.gray.700\")};\r\n\r\n      &:hover {\r\n        --button-bg-color: #{config(\"color.gray.100\")};\r\n      }\r\n      &:where(:focus, :focus-visible) {\r\n        --outline-color: #{config(\"color.gray.300\")};\r\n      }\r\n      &:active {\r\n        --outline-color: #{config(\"color.gray.400\")};\r\n      }\r\n      &:where(.disabled, :disabled, [disabled]) {\r\n        --button-text-color: #{config(\"color.gray.300\")};\r\n      }\r\n    }\r\n    &.color-error {\r\n      --button-text-color: #{config(\"color.error.600\")};\r\n\r\n      &:hover {\r\n        --button-bg-color: #{config(\"color.error.100\")};\r\n      }\r\n    }\r\n  }\r\n  &.text {\r\n    --button-inline-padding: 0px;\r\n    --button-text-color: var(--system-primary-color, #002b8f);\r\n    --button-bg-color: transparent;\r\n    --button-height: auto;\r\n\r\n    &:hover {\r\n      --button-text-color: #{config(\"color.primary.700\")};\r\n      --button-bg-color: transparent;\r\n    }\r\n    &:where(:focus, :focus-visible) {\r\n      --button-text-color: var(--system-primary-color, #002b8f);\r\n      --outline-color: transparent;\r\n    }\r\n    &:active {\r\n      --outline-color: transparent;\r\n      --button-bg-color: transparent;\r\n      --button-text-color: #{config(\"color.primary.800\")};\r\n    }\r\n    &:where(.disabled, :disabled, [disabled]) {\r\n      --button-bg-color: transparent;\r\n      --button-text-color: #{config(\"color.primary.200\")};\r\n    }\r\n    &:is(.size-s, .size-m, .size-l, .size-xl) {\r\n      --button-inline-padding: 0px;\r\n      --button-height: auto;\r\n    }\r\n    &.grayscale {\r\n      --button-text-color: #{config(\"color.gray.700\")};\r\n\r\n      &:hover {\r\n        --button-bg-color: transparent;\r\n        --button-text-color: #{config(\"color.gray.700\")};\r\n      }\r\n      &:where(:focus, :focus-visible) {\r\n        --button-text-color: #{config(\"color.gray.600\")};\r\n        --outline-color: transparent;\r\n      }\r\n      &:active {\r\n        --button-text-color: #{config(\"color.gray.800\")};\r\n        --outline-color: transparent;\r\n      }\r\n      &:where(.disabled, :disabled, [disabled]) {\r\n        --button-text-color: #{config(\"color.gray.300\")};\r\n      }\r\n    }\r\n  }\r\n  .button-icon {\r\n    font-size: var(--button-icon-size, #{config(\"button.medium.icon.fontSize\")});\r\n    padding: 2px;\r\n    min-width: var(--button-icon-square-size, #{config(\"button.medium.icon.squareSize\")});\r\n    min-height: var(--button-icon-square-size, #{config(\"button.medium.icon.squareSize\")});\r\n  }\r\n  &.block {\r\n    width: 100%;\r\n  }\r\n  &.underline {\r\n    text-decoration: underline;\r\n    text-underline-offset: 5px;\r\n  }\r\n\r\n  // Button sizes\r\n  &.size-s {\r\n    --button-height: #{config(\"button.small.height\")};\r\n    --button-border-radius: #{config(\"button.small.cornerRadius\")};\r\n    --button-inline-padding: #{config(\"button.small.inlinePadding\")};\r\n\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.small.icon.fontSize\")};\r\n    }\r\n    &.icon-size-s {\r\n      --button-inline-padding: 10px;\r\n    }\r\n    &.icon-size-m {\r\n      --button-inline-padding: 10px;\r\n    }\r\n    &.icon-size-l {\r\n      --button-inline-padding: 10px;\r\n    }\r\n    &.icon-size-xl {\r\n      --button-inline-padding: 8.5px;\r\n    }\r\n  }\r\n  &.size-m {\r\n    --button-height: #{config(\"button.medium.height\")};\r\n    --button-border-radius: #{config(\"button.medium.cornerRadius\")};\r\n    --button-inline-padding: #{config(\"button.medium.inlinePadding\")};\r\n\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.medium.icon.fontSize\")};\r\n    }\r\n    &.icon-size-s {\r\n      --button-inline-padding: 12px;\r\n    }\r\n    &.icon-size-m {\r\n      --button-inline-padding: 12px;\r\n    }\r\n    &.icon-size-l {\r\n      --button-inline-padding: 12px;\r\n    }\r\n    &.icon-size-xl {\r\n      --button-inline-padding: 10.5px;\r\n    }\r\n  }\r\n  &.size-l {\r\n    --button-height: #{config(\"button.large.height\")};\r\n    --button-border-radius: #{config(\"button.large.cornerRadius\")};\r\n    --button-inline-padding: #{config(\"button.large.inlinePadding\")};\r\n    @include FontStyle(\"label.16\", \"medium\");\r\n\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.large.icon.fontSize\")};\r\n    }\r\n    &.icon-size-s {\r\n      --button-inline-padding: 16px;\r\n    }\r\n    &.icon-size-m {\r\n      --button-inline-padding: 16px;\r\n    }\r\n    &.icon-size-l {\r\n      --button-inline-padding: 16px;\r\n    }\r\n    &.icon-size-xl {\r\n      --button-inline-padding: 14.5px;\r\n    }\r\n  }\r\n  &.size-xl {\r\n    --button-height: #{config(\"button.xlarge.height\")};\r\n    --button-border-radius: #{config(\"button.xlarge.cornerRadius\")};\r\n    --button-inline-padding: #{config(\"button.xlarge.inlinePadding\")};\r\n    @include FontStyle(\"label.18\", \"medium\");\r\n\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.xlarge.icon.fontSize\")};\r\n    }\r\n    &.icon-size-s {\r\n      --button-inline-padding: 16px;\r\n    }\r\n    &.icon-size-m {\r\n      --button-inline-padding: 16px;\r\n    }\r\n    &.icon-size-l {\r\n      --button-inline-padding: 16px;\r\n    }\r\n    &.icon-size-xl {\r\n      --button-inline-padding: 20.5px;\r\n    }\r\n  }\r\n\r\n  // Button separated icon sizes\r\n  &.icon-size-s {\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.small.icon.fontSize\")};\r\n    }\r\n  }\r\n  &.icon-size-m {\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.medium.icon.fontSize\")};\r\n    }\r\n  }\r\n  &.icon-size-l {\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.large.icon.fontSize\")};\r\n    }\r\n  }\r\n  &.icon-size-xl {\r\n    .button-icon {\r\n      --button-icon-size: #{config(\"button.xlarge.icon.fontSize\")};\r\n    }\r\n  }\r\n\r\n  // Color\r\n  &.trash-button {\r\n    --button-text-color: #{config(\"color.error.400\")};\r\n    \r\n    &:hover {\r\n      --button-bg-color: #{config(\"color.error.100\")};\r\n    }\r\n    &.outline {\r\n      --button-border-color: #{config(\"color.error.400\")};\r\n    }\r\n  }\r\n  &.color-success {\r\n    --button-bg-color: #{config(\"color.success.600\")};\r\n  }\r\n  &.color-info {\r\n    --button-bg-color: #{config(\"color.info.600\")};\r\n  }\r\n\r\n  &.icon-button {\r\n    --button-inline-padding: 0;\r\n    min-width: var(--button-height);\r\n    justify-content: center;\r\n  }\r\n  &.icon-text-align {\r\n    --button-vertical-align: baseline;\r\n\r\n    .button-icon {\r\n      height: 100%;\r\n    }\r\n    span {\r\n      height: 100%;\r\n      align-items: center;\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  // <a> overrides\r\n  &:is(a) {\r\n    display: inline-flex !important;\r\n    padding-block: 0 !important;\r\n    padding-inline: var(--button-inline-padding, #{config(\"button.medium.inlinePadding\")}) !important;\r\n    border-radius: var(--button-border-radius, #{config(\"button.medium.cornerRadius\")}) !important;\r\n  }\r\n}\r\n.buttons-group {\r\n  border: solid 1px config(\"color.primary.100\");\r\n  border-radius: config(\"button.medium.cornerRadius\");\r\n\r\n  .system-button {\r\n    --button-text-color: #{config(\"color.gray.400\")};\r\n\r\n    &.selected {\r\n      --button-text-color: #{config(\"color.gray.900\")};\r\n      --button-bg-color: #{config(\"color.primary.100\")};\r\n    }\r\n    &:first-child {\r\n      border-top-right-radius: 0px;\r\n      border-bottom-right-radius: 0px;\r\n    }\r\n    &:last-child {\r\n      border-top-left-radius: 0px;\r\n      border-bottom-left-radius: 0px;\r\n    }\r\n    &:not(:first-child, :last-child) {\r\n      border-radius: 0px;\r\n    }\r\n  }\r\n}\r\n// Dropdowns\r\n.dropdown {\r\n  .dropdown-menu {\r\n    box-shadow: config(\"shadow.light.500\");\r\n  }\r\n}\r\n.dropdown-menu {\r\n  overflow-y: auto;\r\n  max-height: 90vh;\r\n  max-width: 90vw;\r\n  background-color: config(\"color.basic.white\");\r\n  border: solid 1px config(\"color.gray.200\");\r\n  border-radius: config(\"layout.cornerRadius.small\");\r\n  padding: 0;\r\n\r\n  .dropdown-item {\r\n    border-radius: 0;\r\n    padding: 8px 16px;\r\n    @include FontStyle(\"label.14\", \"regular\");\r\n    cursor: pointer;\r\n    line-break: auto;\r\n\r\n    &:hover {\r\n      background-color: config(\"color.gray.50\");\r\n    }\r\n    &:active {\r\n      background-color: config(\"color.gray.100\");\r\n    }\r\n  }\r\n}\r\n.user-main-menu {\r\n  width: 200px;\r\n}\r\n.user-info-menu {\r\n  text-align: start;\r\n\r\n  i {\r\n    width: 18px;\r\n    text-align: center;\r\n  }\r\n}\r\n// Custom dropdowns\r\n.nestable-item-name {\r\n  &.type-object {\r\n    .dropdown {\r\n      .dropdown-toggle {\r\n        height: #{config(\"button.small.height\")};\r\n        border-radius: #{config(\"button.small.cornerRadius\")};\r\n        padding-inline: 0;\r\n        min-width: #{config(\"button.small.height\")};\r\n        justify-content: center;\r\n        background-color: transparent;\r\n        color: #{config(\"color.gray.700\")};\r\n        border: none;\r\n        box-shadow: none;\r\n\r\n        &:hover {\r\n          background-color: #{config(\"color.gray.100\")};\r\n        }\r\n        &::after {\r\n          display: none;\r\n        }\r\n      }\r\n      .dropdown-item {\r\n        @include FontStyle(\"label.12\", \"regular\");\r\n        min-height: 40px;\r\n        align-items: center;\r\n        display: flex;\r\n        padding-inline: 16px;\r\n      }\r\n    }\r\n  }\r\n}\r\n// Toggle\r\n.toggle-icon {\r\n  font-size: var(--toggle-button-icon-size, 20px);\r\n  --toggle-icon-color: #{config(\"color.gray.500\")};\r\n  color: var(--toggle-icon-color);\r\n\r\n  &.on {\r\n    --toggle-icon-color: #{config(\"color.success.400\")};\r\n  }\r\n}\r\n.toggle-button {\r\n  display: inline-flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  \r\n  i {\r\n    cursor: pointer;\r\n  }\r\n  span {\r\n    @include FontStyle(\"label.14\", \"regular\");\r\n    color: config(\"color.basic.black\");\r\n  }\r\n  &:hover {\r\n    span {\r\n      color: config(\"color.gray.700\");\r\n    }\r\n  }\r\n  .tooltip-icon {\r\n    color: config(\"color.primary.600\");\r\n  }\r\n  &.disabled {\r\n    cursor: not-allowed;\r\n    opacity: 0.5;\r\n\r\n    * {\r\n      cursor: inherit;\r\n    }\r\n  }\r\n}\r\n.form-switch {\r\n  padding-inline-start: 32px;\r\n\r\n  .form-check-input {\r\n    pointer-events: auto !important;\r\n    appearance: none;\r\n    display: block;\r\n    margin: 0;\r\n    inset: 0;\r\n    cursor: pointer;\r\n    z-index: 9;\r\n  }\r\n  label {\r\n    margin-inline-start: 10px;\r\n  }\r\n  &::before {\r\n    content: \"\";\r\n    display: block;\r\n    width: 32px;\r\n    height: 20px;\r\n    position: absolute;\r\n    inset-inline-start: 0px;\r\n    background: config(\"color.gray.200\");\r\n    border-radius: 20px;\r\n    outline: solid 1px config(\"color.gray.300\");\r\n  }\r\n  &::after {\r\n    content: \"\";\r\n    display: block;\r\n    width: 16px;\r\n    height: 16px;\r\n    position: absolute;\r\n    top: 2px;\r\n    inset-inline-start: 2px;\r\n    background: config(\"color.gray.400\");\r\n    border-radius: 20px;\r\n    transition: transform 0.2s ease-in-out;\r\n  }\r\n  &:hover {\r\n    &::before {\r\n      background: config(\"color.gray.300\");\r\n    }\r\n    &::after {\r\n      background: config(\"color.gray.500\");\r\n    }\r\n  }\r\n  &:has(:checked) {\r\n    &::before {\r\n      background: config(\"color.success.100\");\r\n      outline: solid 1px config(\"color.success.300\");\r\n    }\r\n    &::after {\r\n      background: config(\"color.success.500\");\r\n      transform: translateX(12px);\r\n    }\r\n    &:hover {\r\n      &::after {\r\n        background: config(\"color.success.400\");\r\n      }\r\n    }\r\n  }\r\n}\r\n// Radio\r\n.system-radio-group {\r\n  display: inline-flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n\r\n  &:has(.system-button) {\r\n    gap: 8px;\r\n  }\r\n  .radio-item {\r\n    display: flex;\r\n    gap: 6px;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    border-radius: 2px;\r\n\r\n    &:hover {\r\n      outline: solid 2px config(\"color.primary.100\");\r\n      outline-offset: 3px;\r\n    }\r\n    &.system-button {\r\n      gap: 10px;\r\n      border-radius: var(--button-border-radius, #{config(\"button.medium.cornerRadius\")});\r\n      --button-bg-color: transparent;\r\n      --button-text-color: var(--system-primary-color, #002b8f);\r\n      border: solid var(--button-border-width, 1px) var(--button-border-color, var(--system-primary-color, #002b8f));\r\n  \r\n      &:hover {\r\n        outline: none;\r\n      }\r\n      input {\r\n        display: none;\r\n      }\r\n      &:has(:disabled) {\r\n        --button-text-color: #{config(\"color.basic.white\")};\r\n        --button-bg-color: #{config(\"color.primary.200\")};\r\n        border: none;\r\n        pointer-events: none;\r\n        user-select: none;\r\n      }\r\n      &:has(:checked) {\r\n        --button-bg-color: var(--system-primary-color, #002b8f);\r\n        --button-text-color: #{config(\"color.basic.white\")};\r\n        border: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n// Checkbox\r\n.system-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n\r\n  input {\r\n    appearance: none;\r\n    display: block;\r\n    margin: 0;\r\n    inset: 0;\r\n    cursor: pointer;\r\n    z-index: 9;\r\n  }\r\n  span {\r\n    margin-inline-start: 10px;\r\n  }\r\n  &::before {\r\n    font-family: string.quote(config(\"font.icons.family\"));\r\n    @include faIcon;\r\n    content: \"\";\r\n    display: grid;\r\n    place-content: center;\r\n    width: 16px;\r\n    height: 16px;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    background-color: config(\"color.basic.white\");\r\n    border-radius: 3px;\r\n    border: solid 1px config(\"color.gray.300\");\r\n    transform: translateY(-1px);\r\n  }\r\n  &:has(:checked) {\r\n    &::before {\r\n      content: \"\\f00c\";\r\n      background-color: config(\"color.primary.500\");\r\n      border-color: config(\"color.primary.700\");\r\n      color: config(\"color.basic.white\");\r\n    }\r\n  }\r\n  &:hover {\r\n    &::before {\r\n      border-color: config(\"color.primary.400\");\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@container date-input (max-width: 160px) {\r\n  .close-dtpk > span > span {\r\n    display: none;\r\n  }\r\n}","@use \"sass:string\";\r\n\r\n:root {\r\n  --page-panel-block-padding: 28px;\r\n  --page-panel-inline-padding: 20px;\r\n  --system-label-bottom-margin: 6px;\r\n  --system-primary-color: #{config(\"color.primary.600\")};\r\n}\r\nbody {\r\n  background-color: config(\"color.gray.50\");\r\n}\r\n.app-header {\r\n  min-height: var(--app-header-height);\r\n  transition: min-height 0.15s ease-in-out;\r\n\r\n  .app-main-header {\r\n    border-bottom: none !important;\r\n    box-shadow: config(\"shadow.light.200\");\r\n    max-height: var(--app-header-height);\r\n\r\n    .app-toolbar {\r\n      min-height: var(--app-header-height);\r\n      transition: margin-top 0.15s ease-in-out;\r\n    }\r\n    .header-notifications {\r\n      li {\r\n        &.user-nav {\r\n          .quick-menu {\r\n            .user-initials-menu-toggler {\r\n              background-color: var(--system-primary-color, #002b8f);\r\n              padding: 6px;\r\n              width: 40px;\r\n              height: 40px;\r\n              border-radius: 20px;\r\n              color: config(\"color.basic.white\");\r\n              @include FontStyle(\"body.12\", \"medium\");\r\n              transition-duration: 0.3s;\r\n              border: solid 2px config(\"color.basic.white\");\r\n              box-shadow: config(\"shadow.light.100\");\r\n          \r\n              &:hover {\r\n                background-color: config(\"color.primary.800\");\r\n              }\r\n            }\r\n            &.show {\r\n              .user-initials-menu-toggler {\r\n                background-color: config(\"color.primary.700\");\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    :where(.db-name, .db-group-name) {\r\n      color: config(\"color.basic.black\");\r\n      display: inline-flex;\r\n      max-width: 340px;\r\n      @include FontStyle(\"label.18\", \"semibold\");\r\n      text-align: start;\r\n    }\r\n    &.appbar--collapsed {\r\n      .app-toolbar {\r\n        margin-top: calc(12px - var(--app-header-height));\r\n      }\r\n    }\r\n  }\r\n  &:has(.appbar--collapsed) {\r\n    min-height: 12px;\r\n\r\n    & + .app-main-content-wrapper .data-list-container {\r\n      height: calc(100vh - 135px - 12px + var(--app-header-height));\r\n    }\r\n  }\r\n  &:has(.app-main-header[style*=\"padding-inline-end\"]) {\r\n    & + .app-main-content-wrapper {\r\n      position: absolute;\r\n      padding-top: var(--app-header-height);\r\n    }\r\n    &:has(.appbar--collapsed) {\r\n      & + .app-main-content-wrapper {\r\n        padding-top: 12px;\r\n\r\n        .reports-drawer-open {\r\n          .Pane2 {\r\n            transform: translateY(calc(0px - 37px));\r\n          }\r\n          .Resizer {\r\n            --custom-resizer-top-margin: -37px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.appbar-collapse {\r\n  position: absolute;\r\n  bottom: -12px;\r\n  translate: -50%;\r\n  inset-inline-start: 50%;\r\n  border: none;\r\n  background-color: white;\r\n  border-radius: 50px;\r\n  box-shadow: 0px 3px 1px rgba(48, 49, 51, 0.05), 0px 4px 4px rgba(48, 49, 51, 0.1);\r\n  width: 24px;\r\n  height: 24px;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  font-size: 12px;\r\n\r\n  &:hover {\r\n    background-color: config(\"color.gray.100\");\r\n  }\r\n  &:is(:focus, :focus-visible) {\r\n    outline: solid 1px config(\"color.gray.200\");\r\n    outline-offset: 0px;\r\n  }\r\n}\r\n.db-logo {\r\n  @include FontStyle(\"body.18\", \"semibold\");\r\n  color: var(--system-primary-color, #002b8f);\r\n  border-radius: 16px;\r\n  padding: 3px 20px;\r\n  border: 1px solid var(--system-primary-color, #002b8f);\r\n}\r\n.app-main-content-wrapper {\r\n  .app-main-content {\r\n    background-color: config(\"color.gray.50\");\r\n    box-shadow: none;\r\n  }\r\n}\r\n.user-initials-menu-toggler {\r\n  background-color: config(\"color.primary.500\");\r\n  padding: 6px;\r\n  display: inline-flex;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 15px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: config(\"color.basic.white\");\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition-duration: 0.3s;\r\n\r\n  &:hover {\r\n    background-color: config(\"color.primary.700\");\r\n  }\r\n}\r\n\r\n// Database version\r\n.version-selector {\r\n  .dropdown-item {\r\n    white-space: nowrap;\r\n    min-height: 36px;\r\n\r\n    span:empty {\r\n      display: none;\r\n    }\r\n  }\r\n  .dropdown-menu {\r\n    min-width: 100%;\r\n    box-shadow: config(\"shadow.light.400\") !important;\r\n    border: 1px solid config(\"color.gray.200\") !important;\r\n    border-radius: config(\"layout.cornerRadius.small\") !important;\r\n  }\r\n}\r\n.version-dropdown {\r\n  i {\r\n    color: config(\"color.gray.400\");\r\n    font-size: 14px !important;\r\n  }\r\n}\r\n.database-version-label {\r\n  --labels-color: #1b255f;\r\n  display: flex;\r\n  align-items: center;\r\n  @include FontStyle(\"label.14\", \"regular\");\r\n  gap: 3px;\r\n  height: 18px;\r\n  align-items: baseline;\r\n  color: var(--labels-color) !important;\r\n\r\n  span:not(.version-warning) {\r\n    color: inherit !important;\r\n  }\r\n  .version-warning {\r\n    font-size: 16px !important;\r\n    line-height: 10px !important;\r\n    color: config(\"color.error.500\") !important;\r\n    margin-inline-start: 6px;\r\n  }\r\n}\r\n\r\n// Services\r\n.manage-version-drawer {\r\n  .card-header {\r\n    --card-header-bg-color: #{config(\"color.primary.100\")};\r\n\r\n    .trash-button {\r\n      margin-inline-end: -6px;\r\n    }\r\n  }\r\n  .service-name {\r\n    @include FontStyle(\"label.14\", \"semibold\");\r\n    color: config(\"color.basic.black\");\r\n  }\r\n  .service-date {\r\n    @include FontStyle(\"label.14\", \"regular\");\r\n    color: config(\"color.gray.400\");\r\n  }\r\n}\r\n.x-road {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  height: 100%;\r\n  min-height: 32px;\r\n  padding-inline-start: 10px;\r\n  white-space: nowrap;\r\n\r\n  i {\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n\r\n    &.toggle-icon {\r\n      color: #3fac82;\r\n      margin-inline-end: 4px;\r\n    }\r\n  }\r\n  span {\r\n    @include FontStyle(\"body.14\", \"regular\");\r\n    margin-inline-end: 10px;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: #f6f8fb;\r\n  }\r\n}\r\n.api-list-delete-warning-table {\r\n  thead {\r\n    position: sticky;\r\n    top: 0px;\r\n    background-color: white;\r\n    box-shadow: 0px -16px 0px white;\r\n  }\r\n  :is(td, th) {\r\n    padding: 6px;\r\n  }\r\n  tr.warning td {\r\n    background-color: config(\"color.error.100\");\r\n\r\n    &:first-child {\r\n      border-radius: 4px 0px 0px 4px;\r\n    }\r\n    &:last-child {\r\n      border-radius: 0px 4px 4px 0px;\r\n    }\r\n  }\r\n}\r\n.apis-delete-warning-message {\r\n  @include FontStyle(\"label.14\", \"medium\");\r\n  margin-top: 1rem;\r\n  border: solid 1px config(\"color.error.400\");\r\n  padding: 16px;\r\n  border-radius: 6px;\r\n}\r\n.apis-delete-warning-message-modal-body {\r\n  max-height: calc(100vh - 190px);\r\n}\r\n\r\n\r\n// Page\r\n.page-name-bar {\r\n  align-items: center;\r\n  line-height: 1;\r\n  margin-bottom: var(--custom-bottom-margin, 10px);\r\n  min-height: 32px;\r\n  @include FontStyle(\"title.22\", \"medium\");\r\n  margin-inline: 0px;\r\n\r\n  > .col {\r\n    align-items: center;\r\n    display: flex;\r\n  }\r\n}\r\n.page-name {\r\n  @include FontStyle(\"title.22\", \"medium\");\r\n  color: config(\"color.basic.black\");\r\n\r\n  .badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n\r\n    span {\r\n      padding-block: 4px;\r\n    }\r\n  }\r\n}\r\n.backbutton {\r\n  margin-inline-end: 12px;\r\n}\r\n.heading-buttons {\r\n  gap: 8px;\r\n}\r\n/* Page panel */\r\n.page-panel {\r\n  background-color: config(\"color.basic.white\");\r\n  box-shadow: config(\"shadow.light.200\");\r\n  border-radius: config(\"layout.cornerRadius.big\");\r\n\r\n  .page-panel-heading {\r\n    border-bottom: solid 1px config(\"color.gray.200\");\r\n    padding: 22px 20px;\r\n\r\n    &.closed {\r\n      border-bottom: none;\r\n    }\r\n    i {\r\n      font-size: var(--custom-icon-size, 16px);\r\n    }\r\n  }\r\n  .panel-heading-title {\r\n    @include FontStyle(\"title.16\", \"semibold\");\r\n    color: config(\"color.basic.black\");\r\n  }\r\n  .page-panel-body {\r\n    padding: var(--page-panel-block-padding) var(--page-panel-inline-padding);\r\n  }\r\n  & + .page-panel {\r\n    margin-top: 20px;\r\n  }\r\n  /* Json Schema Editor Visual */\r\n  .json-schema-react-editor {\r\n    .schema-editor-header {\r\n      gap: 20px;\r\n\r\n      button {\r\n        margin-block: -8px;\r\n      }\r\n    }\r\n    .panel-heading-title {\r\n      margin-inline-end: auto;\r\n    }\r\n    .object-style {\r\n      margin: 0;\r\n      padding: 0;\r\n    }\r\n    .schema-content {\r\n      padding-right: initial;\r\n      padding-inline-end: 0px;\r\n    }\r\n    .simple-view-toggle-container {\r\n      display: flex;\r\n      align-items: flex-start;\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n      color: config(\"color.basic.black\");\r\n      gap: 10px;\r\n      cursor: pointer;\r\n    }\r\n    .schema-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-items: flex-end;\r\n      justify-content: flex-end;\r\n      padding: 4px 0px;\r\n      gap: 4px;\r\n\r\n      &:hover {\r\n        :where(.add-item-button, .duplicate-item-button, .delete-item, .adv-set) {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n    .schema-item-name {\r\n      flex: auto;\r\n      --reserved: 0px;\r\n\r\n      &:has(.field-badge) {\r\n        .system-input-container input {\r\n          padding-inline-end: calc(32px + var(--reserved));\r\n        }\r\n      }\r\n      &:has(.field-badge:nth-last-child(1)) {\r\n        .reserved-key-alert {\r\n          --icon-position: calc(30px + var(--reserved));\r\n        }\r\n      }\r\n      &:has(.field-badge:nth-last-child(2)) {\r\n        .system-input-container input {\r\n          padding-inline-end: calc(50px + var(--reserved));\r\n        }\r\n        .reserved-key-alert {\r\n          --icon-position: calc(47px + var(--reserved));\r\n        }\r\n      }\r\n      &:has(.field-badge:nth-last-child(3)) {\r\n        .system-input-container input {\r\n          padding-inline-end: calc(66px + var(--reserved));\r\n        }\r\n        .reserved-key-alert {\r\n          --icon-position: calc(64px + var(--reserved));\r\n        }\r\n      }\r\n      &:has(.field-badge:nth-last-child(4)) {\r\n        .system-input-container input {\r\n          padding-inline-end: calc(82px + var(--reserved));\r\n        }\r\n        .reserved-key-alert {\r\n          --icon-position: calc(81px + var(--reserved));\r\n        }\r\n      }\r\n      &:not(:has(.field-badge)) {\r\n        .reserved-key-alert {\r\n          --icon-position: calc(9px + var(--reserved));\r\n        }\r\n      }\r\n      &:has(.field-reserved) {\r\n        --reserved: 14px;\r\n      }\r\n    }\r\n    .field-reserved {\r\n      position: absolute;\r\n      inset-inline-end: 6px;\r\n      top: 10px;\r\n      font-size: 13px;\r\n      color: config(\"color.info.400\");\r\n    }\r\n    .entry-type {\r\n      min-width: 156px;\r\n      max-width: 156px;\r\n    }\r\n    .schema-item-actions {\r\n      display: grid;\r\n      grid-auto-flow: column;\r\n      grid-template-columns: repeat(4, 1fr);\r\n      grid-gap: 4px;\r\n      width: initial;\r\n      flex: initial;\r\n    }\r\n    :where(.add-item-button, .duplicate-item-button, .delete-item, .adv-set) {\r\n      opacity: 0;\r\n    }\r\n    .add-item-button {\r\n      opacity: 1;\r\n    }\r\n    .nestable-list {\r\n      padding-inline-start: 40px; // Fix (button-icon width 36 + 4 gap)\r\n      margin: 0;\r\n    }\r\n    .nestable-group {\r\n      padding-inline-start: 0px;\r\n      margin-top: 16px;\r\n    }\r\n    .nestable-item {\r\n      margin: 2px 0 0;\r\n    }\r\n    .nestable-item-name {\r\n      border-radius: config(\"layout.cornerRadius.small\");\r\n\r\n      &.type-object {\r\n        background-color: config(\"color.primary.100\");\r\n      }\r\n      &.type-array {\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n      &:hover {\r\n        &:not(.type-object, .type-array) {\r\n          .schema-item {\r\n            background-color: config(\"color.gray.50\");\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .nestable-item.is-dragging:before {\r\n      left: 0;\r\n      background-color: config(\"color.primary.100\");\r\n      border-color: config(\"color.primary.200\");\r\n    }\r\n    .nestable-drag-layer {\r\n      > .nestable-list {\r\n        padding-inline-start: 0;\r\n      }\r\n    }\r\n    .nestable-item-copy {\r\n      background-color: config(\"color.basic.white\");\r\n      box-shadow: config(\"shadow.light.200\");\r\n      border-radius: config(\"layout.cornerRadius.small\");\r\n      transform: scale(0.95);\r\n      opacity: 0.8;\r\n    }\r\n    .simple-view {\r\n      input {\r\n        pointer-events: none;\r\n      }\r\n      :where(.entry-type, .schema-item-actions) {\r\n        display: none;\r\n      }\r\n      .system-input-container {\r\n        background-color: transparent;\r\n      }\r\n    }\r\n    .reserved-key-alert {\r\n      color: config(\"color.error.400\");\r\n      position: absolute;\r\n      inset-inline-end: var(--icon-position);\r\n      font-size: 16px;\r\n    }\r\n    > .page-panel-body {\r\n      > .row {\r\n        margin-inline: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n.json-schema-react-editor-adv-modal {\r\n  &.modal-dialog.layer {\r\n    height: calc(100vh - 80px);\r\n    top: initial;\r\n  }\r\n  .advanced-toggle-row {\r\n    gap: 8px;\r\n  }\r\n  .advanced-toggler {\r\n    .ant-switch {\r\n      margin-inline-end: 0px;\r\n    }\r\n    .other-label {\r\n      flex: 0;\r\n      white-space: nowrap;\r\n      padding: 0;\r\n      min-width: fit-content;\r\n    }\r\n  }\r\n  .ant-row {\r\n    gap: 12px;\r\n  }\r\n  .toggle-field-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n\r\n    .system-label {\r\n      margin-bottom: 0px;\r\n    }\r\n    i {\r\n      display: none;\r\n    }\r\n  }\r\n  .modal-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n  }\r\n  .tab-content {\r\n    padding: 28px 0 0 !important;\r\n  }\r\n  .nav-tabs {\r\n    border-bottom: none;\r\n\r\n    .nav-link {\r\n      padding: 12px 32px;\r\n      border-radius: 0;\r\n\r\n      &:hover {\r\n        border-color: transparent;\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n      &:is(:focus-visible, :focus) {\r\n        background-color: config(\"color.gray.100\");\r\n        outline: none;\r\n      }\r\n      &.active {\r\n        @include FontStyle(\"label.14\", \"semibold\", true);\r\n        color: config(\"color.basic.black\") !important;\r\n        background-color: transparent;\r\n        box-shadow: inset 0px -3px 0px 0px config(\"color.primary.500\");\r\n        border-radius: 0;\r\n        border-color: transparent;\r\n      }\r\n    }\r\n  }\r\n  .system-label {\r\n    .anticon {\r\n      align-items: center;\r\n      display: grid;\r\n    }\r\n  }\r\n  .advanced-property {\r\n    &.has-warning {\r\n      .system-input-container {\r\n        width: calc(100% - var(--field-height));\r\n        float: left;\r\n      }\r\n      .duplicated-id-alert {\r\n        min-height: 36px;\r\n        display: flex;\r\n        align-items: center;\r\n        width: 36px;\r\n        justify-content: center;\r\n      }\r\n    }\r\n  }\r\n  .fk-fields-list {\r\n    display: grid;\r\n    grid-gap: 6px;\r\n\r\n    &:empty {\r\n      display: none;\r\n    }\r\n    > .row-flex {\r\n      padding: 0px;\r\n    }\r\n  }\r\n  .fk-settings-container {\r\n    border-radius: 0 0 config(\"layout.cornerRadius.big\") config(\"layout.cornerRadius.big\");\r\n    padding: 18px 24px;\r\n  }\r\n  .advanced-settings-rows {\r\n    background-color: config(\"color.gray.100\");\r\n    border-radius: config(\"layout.cornerRadius.big\");\r\n    box-shadow: config(\"shadow.light.200\");\r\n    \r\n    &::after {\r\n      height: 50px;\r\n      content: \"\";\r\n    }\r\n  }\r\n  :is(.other-row, .row-flex) {\r\n    display: flex;\r\n    padding: 18px 24px;\r\n    margin-bottom: 2px;\r\n    gap: 12px;\r\n\r\n    .other-row {\r\n      padding: 0;\r\n    }\r\n    &:first-child {\r\n      border-radius: config(\"layout.cornerRadius.big\") config(\"layout.cornerRadius.big\") 0 0;\r\n    }\r\n    [class*=\"col-\"] {\r\n      padding: 0;\r\n    }\r\n    @for $i from 1 through 12 {\r\n      .col-#{$i} {\r\n        flex: $i;\r\n      }\r\n    }\r\n  }\r\n  .ant-switch-checked {\r\n    background-color: config(\"color.success.500\");\r\n  }\r\n  // Trigger\r\n  .trigger-item {\r\n    background-color: config(\"color.basic.white\");\r\n    padding: 16px 16px 26px;\r\n    border-radius: config(\"layout.cornerRadius.big\");\r\n    box-shadow: config(\"shadow.light.200\");\r\n    margin-bottom: 20px;\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    grid-template-rows: auto auto;\r\n    grid-column-gap: 12px;\r\n    grid-row-gap: 24px;\r\n    z-index: 9;\r\n\r\n    td {\r\n      padding: 5px;\r\n    }\r\n    .trigger-condition-gate {\r\n      padding-inline-start: 0px;\r\n    }\r\n    tr {\r\n      &:first-child {\r\n        td {\r\n          padding-top: 0px;\r\n        }\r\n      }\r\n      &:last-child {\r\n        td {\r\n          padding-bottom: 0px;\r\n        }\r\n      }\r\n      &:only-child {\r\n        .trigger-condition-gate {\r\n          display: none;\r\n        }\r\n        .trigger-condition-logic {\r\n          padding-inline-start: 0;\r\n        }\r\n      }\r\n    }\r\n    &:has(.react-select__control--menu-is-open) {\r\n      z-index: 10;\r\n    }\r\n  }\r\n  .remove-item-container {\r\n    grid-area: 1 / 2 / 3 / 3;\r\n    display: grid;\r\n    place-content: center;\r\n  }\r\n  .schema-trigger-condition {\r\n    grid-area: 1 / 1 / 2 / 2;\r\n    position: relative;\r\n    z-index: 9;\r\n  }\r\n  :is(.schema-trigger-condition, .schema-trigger-action) {\r\n    tr:has(.react-select__control--menu-is-open) {\r\n      position: relative;\r\n      z-index: 9;\r\n    }\r\n  }\r\n  td {\r\n    &.trigger-action-field-option {\r\n      padding-inline-start: 0px;\r\n    }\r\n    &:is(.trigger-action-actions, .trigger-condition-actions) {\r\n      padding-inline-end: 0px;\r\n      width: 77px; // 36px (button width) * 2 + 5px (start padding)\r\n    }\r\n  }\r\n  .bottom-space {\r\n    min-height: 50px;\r\n  }\r\n}\r\n:where(.other-row, .fk-settings-container) {\r\n  background-color: config(\"color.basic.white\");\r\n}\r\n\r\n// Tabs\r\n.ant-tabs {\r\n  overflow: initial;\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 100%;\r\n  height: 100%;\r\n\r\n  .ant-tabs-bar {\r\n    background-color: transparent;\r\n    padding: 20px 28px 0px;\r\n    border-bottom: none;\r\n    margin-bottom: 0px;\r\n\r\n    .ant-tabs-nav-container {\r\n      height: 36px;\r\n\r\n      &::before {\r\n        display: none;\r\n      }\r\n    }\r\n    .ant-tabs-tab {\r\n      &::before {\r\n        display: none;\r\n      }\r\n      &.ant-tabs-tab-active {\r\n        background-color: white;\r\n        color: #262626;\r\n        font-weight: 700;\r\n      }\r\n    }\r\n  }\r\n  .ant-tabs-content {\r\n    padding: 0px 28px;\r\n    overflow-y: auto;\r\n    flex: 1;\r\n\r\n    .ant-tabs-tabpane-active {\r\n      height: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n      padding-top: 28px;\r\n\r\n      :is(.ace_editor, .ace_layer, ace_content) {\r\n        height: 100% !important;\r\n      }\r\n      > .ant-row {\r\n        .ant-col {\r\n          font-weight: 600;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.ant-tabs-tab {\r\n  @include FontStyle(\"label.14\", \"medium\", true);\r\n  color: config(\"color.gray.500\");\r\n  padding: 12px 32px !important;\r\n  background-color: transparent !important;\r\n  border: none !important;\r\n  border-radius: 0px !important;\r\n  height: initial !important;\r\n\r\n  &:hover {\r\n    color: config(\"color.basic.black\") !important;\r\n  }\r\n}\r\n.ant-tabs-nav-container {\r\n  height: initial !important;\r\n}\r\n.ant-tabs-tab-active {\r\n  @include FontStyle(\"label.14\", \"semibold\", true);\r\n  color: config(\"color.basic.black\") !important;\r\n}\r\n.ant-tabs-ink-bar {\r\n  background-color: var(--system-primary-color, #002b8f) !important;\r\n  visibility: visible !important;\r\n}\r\n.system-tabs {\r\n  background-color: transparent;\r\n\r\n  .nav-tabs {\r\n    border-bottom: none;\r\n  }\r\n}\r\n.tab-header {\r\n  .nav-item {\r\n    margin-bottom: 0px\r\n  }\r\n  .nav-link {\r\n    @include FontStyle(\"label.14\", \"semibold\");\r\n    color: config(\"color.basic.black\");\r\n    border: none;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 2px;\r\n    --tab-border-color: transparent;\r\n    border-bottom-color: var(--tab-border-color) !important;\r\n    padding-inline: 34px;\r\n    padding-block: 14px;\r\n    background-color: transparent !important;\r\n\r\n    &.active {\r\n      --tab-border-color: var(--system-primary-color, #002b8f);\r\n    }\r\n  }\r\n}\r\n\r\n// Forms components\r\n// Buttons\r\n.trash-button {\r\n  .system-button:hover {\r\n    --button-text-color: #{config(\"color.error.400\")};\r\n    --button-bg-color: #{config(\"color.error.100\")};\r\n  }\r\n}\r\n\r\n// Database modify\r\n.database-logo {\r\n  max-width: 200px;\r\n  max-height: 128px;\r\n  display: inline-block;\r\n  border: dashed 1px config(\"color.gray.300\");\r\n  border-radius: config(\"layout.cornerRadius.small\");\r\n  padding: 5px;\r\n}\r\n\r\n// Database comparison\r\n.comparison-field-list {\r\n  p:last-child {\r\n    margin-bottom: 0px;\r\n  }\r\n}\r\n\r\n// DB Sidebar Menu\r\n.sidebar-header {\r\n  z-index: 1255;\r\n  position: relative;\r\n}\r\n.action-buttons {\r\n  box-shadow: config(\"shadow.light.100\");\r\n  border-radius: config(\"layout.cornerRadius.medium\");\r\n  width: auto !important;  // fill the side-nav so the row is responsive to the drawer width\r\n  padding: 6px 8px !important;\r\n  margin: 16px 16px 12px !important;\r\n  background-color: config(\"color.basic.white\");\r\n  gap: 7px;\r\n}\r\n.add-db {\r\n  background-color: inherit;\r\n\r\n  &::after {\r\n    @include faIcon;\r\n    content: \"\\2b\";\r\n    font-weight: 600;\r\n    position: absolute;\r\n    transform: translate(-5px, 5px);\r\n    background: config(\"color.basic.white\");\r\n    font-size: 9px;\r\n    padding: 1px;\r\n    border-radius: 20px;\r\n  }\r\n}\r\n.add-db-button:hover {\r\n  .add-db::after {\r\n    background-color: inherit;\r\n  }\r\n}\r\n.sidebar-menu-content-container {\r\n  background-color: config(\"color.gray.50\");\r\n}\r\n.drawer-dbs-groups {\r\n  background-color: config(\"color.basic.white\");\r\n}\r\n.db-lists-search {\r\n  padding: 12px 16px;\r\n  position: sticky;\r\n  z-index: 1;\r\n  top: 0;\r\n  background-color: config(\"color.basic.white\");\r\n}\r\n.db-list-group-name {\r\n  @include FontStyle(\"label.16\", \"regular\");\r\n  color: inherit;\r\n}\r\n.db-list-menu {\r\n  height: calc(100% - 30px);\r\n}\r\nul.nav-menu.db-list-submenu {\r\n  height: max-content;\r\n}\r\n.database-group-link {\r\n  --group-color: transparent;\r\n  --start-line-width: 4px;\r\n  padding-inline-start: 16px;\r\n  padding-inline-end: 16px;\r\n  padding-block: 12px;\r\n  color: config(\"color.basic.black\");\r\n  display: flex !important;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px; \r\n  border-bottom: solid 1px config(\"color.gray.200\");\r\n  box-shadow: inset var(--start-line-width) 0px 0px 0px var(--group-color);\r\n  transition-property: box-shadow;\r\n  transition-duration: 0.15s;\r\n\r\n  &:is(.group-open, :hover) {\r\n    color: config(\"color.primary.500\");\r\n    background-color: config(\"color.primary.100\");\r\n    --start-line-width: 8px;\r\n  }\r\n  &.dragging-over {\r\n    outline: dashed;\r\n    outline-offset: -2px;\r\n    outline-width: 2px;\r\n    outline-color: config(\"color.info.400\");\r\n  }\r\n}\r\n.db-link-item {\r\n  padding-inline: 16px;\r\n  padding-block: 12px;\r\n  border-bottom: solid 1px config(\"color.gray.200\");\r\n\r\n  &:hover {\r\n    color: config(\"color.primary.500\");\r\n    background-color: config(\"color.primary.100\");\r\n  }\r\n  &[data-rbd-drag-handle-draggable-id][style*=\"position\"] {\r\n    background: rgba(0, 0, 0, 0.05);\r\n    border-radius: 8px;\r\n    transition-property: background, opacity;\r\n  }\r\n}\r\n.version-date-user-container {\r\n  display: flex;\r\n  gap: 12px;\r\n  @include FontStyle(\"label.12\", \"regular\");\r\n  color: config(\"color.gray.500\");\r\n  margin-top: 4px;\r\n}\r\n.database-list-item {\r\n  position: relative;\r\n\r\n  .system-badge {\r\n    position: absolute;\r\n    inset-inline-end: 0;\r\n    top: 0;\r\n    margin-top: 3px;\r\n  }\r\n}\r\n.database-list-item-name {\r\n  @include FontStyle(\"label.14\", \"regular\");\r\n  margin-inline-end: 50px;\r\n}\r\n.version-date,\r\n.version-user {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  overflow: hidden;\r\n  min-width: 1px;\r\n}\r\n.version-user {\r\n  flex: 1;\r\n  min-width: 50%;\r\n}\r\n.db-group-options {\r\n  padding: 12px 16px;\r\n  position: sticky;\r\n  top: 0px;\r\n  background-color: config(\"color.basic.white\");\r\n  z-index: 9;\r\n  text-align: start;\r\n}\r\n.ellipsis {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n.close-databases-drawer {\r\n  margin-inline-end: -12px;\r\n\r\n  .button-icon {\r\n    --button-icon-size: 20px;\r\n  }\r\n}\r\n\r\n// DB Settings slider\r\n:where(.db-heading-settings, .logo-settings-element-drag-drop) {\r\n  .config-item {\r\n    border-top: var(--border-top-style, solid) var(--border-top-width, 1px) var(--border-top-color, config(\"color.gray.100\"));\r\n    min-height: 48px;\r\n    padding-inline: 20px;\r\n    color: config(\"color.basic.black\");\r\n  }\r\n  [draggable]:first-child {\r\n    .config-item {\r\n      --border-top-style: none;\r\n    }\r\n  }\r\n  .accordion {\r\n    .toggle-icon {\r\n      --custom-icon-size: 20px;\r\n    }\r\n  }\r\n}\r\n.logo-settings-element-drag-drop {\r\n  .config-item {\r\n    outline: dashed 2px config(\"color.gray.300\");\r\n    transform: scale(0.95);\r\n    border-radius: config(\"layout.cornerRadius.medium\");\r\n  }\r\n}\r\n.multiple-control-badge {\r\n  position: absolute;\r\n  inset-inline-end: 0;\r\n  width: 14px;\r\n  height: 13px !important;\r\n  display: grid;\r\n  place-content: center;\r\n  background-color: config(\"color.gray.100\");\r\n  border-radius: 3px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n:is(.type-array-of-catalog, .type-array-of-file) {\r\n  .multiple-control-badge {\r\n    background-color: config(\"color.success.400\");\r\n    color: config(\"color.basic.white\");\r\n  }\r\n}\r\n.column-filter-container {\r\n  min-width: 50px;\r\n  flex: 0 0 100%;\r\n  display: flex;\r\n  gap: 12px;\r\n\r\n  .system-input-container {\r\n    min-width: 50px;\r\n  }\r\n}\r\n\r\n// DB entry row viewer drawer\r\n.layer-actions {\r\n  flex: auto;\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-inline-end: 16px;\r\n  margin-inline-start: 12px;\r\n\r\n  .delete-row {\r\n    margin-inline-end: auto;\r\n  }\r\n  .cancel-edit {\r\n    margin-inline-start: auto;\r\n  }\r\n}\r\n.item-field-cell {\r\n  @include FontStyle(\"body.14\", \"semibold\");\r\n}\r\n.rendered-value {\r\n  white-space: pre-wrap;\r\n  word-break: break-all;\r\n  @include FontStyle(\"body.14\", \"regular\");\r\n  align-self: center;\r\n}\r\nspan:has(.listing-value) {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n.listing-value {\r\n  margin-bottom: 6px;\r\n  \r\n  > .item {\r\n    align-items: center;\r\n    display: inline-flex;\r\n    background-color: #e5e7eb;\r\n    color: #121212;\r\n    @include FontStyle(\"body.14\", \"medium\");\r\n    letter-spacing: 0.005em;\r\n    padding-block: 0;\r\n    padding-inline-start: 5px;\r\n    padding-inline-end: 5px;\r\n    margin: 0;\r\n    border-radius: config(\"layout.cornerRadius.small\");\r\n\r\n    + .item {\r\n      margin-left: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n// Filters dropdown\r\n.filters-container {\r\n  padding: 16px;\r\n}\r\n.filters-rows-action {\r\n  padding-top: 16px;\r\n  gap: 10px;\r\n}\r\n\r\n// Badges\r\n.system-badge {\r\n  @include FontStyle(\"label.10\", \"bold\");\r\n  color: config(\"color.basic.white\");\r\n  background-color: config(\"color.primary.200\");\r\n\r\n  &.size-l {\r\n    @include FontStyle(\"label.14\", \"medium\");\r\n    padding: 3px 6px;\r\n    border-radius: config(\"layout.cornerRadius.small\");\r\n  }\r\n  &.round {\r\n    border-radius: 50px;\r\n    display: inline-flex;\r\n    padding: 0;\r\n    width: 20px;\r\n    justify-content: center;\r\n  }\r\n  &.red {\r\n    color: config(\"color.basic.white\") !important;\r\n    background-color: config(\"color.error.400\");\r\n  }\r\n  &.small {\r\n    @include FontStyle(\"label.10\", \"medium\", true);\r\n    width: 16px;\r\n    height: 16px;\r\n    align-items: center;\r\n  }\r\n}\r\n.system-badge,\r\n.badge {\r\n  border-radius: config(\"layout.cornerRadius.xsmall\");\r\n  padding: 2px 3px;\r\n}\r\n.badge {\r\n  background-color: config(\"color.primary.300\");\r\n\r\n  span {\r\n    @include FontStyle(\"label.10\", \"bold\");\r\n    color: config(\"color.basic.white\");\r\n  }\r\n}\r\n.badge-dark {\r\n  background-color: config(\"color.basic.black\");\r\n}\r\n.fk-badge {\r\n  @include FontStyle(\"label.10\", \"bold\");\r\n  color: config(\"color.basic.white\");\r\n  background-color: config(\"color.primary.400\");\r\n  padding: 2px 4px 3px;\r\n  border-radius: 4px;\r\n}\r\n// TOBE-17991: mirror-managed catalog indicator\r\n.mirror-badge {\r\n  @include FontStyle(\"label.10\", \"bold\");\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  color: config(\"color.basic.white\");\r\n  background-color: config(\"color.gold.500\");\r\n  padding: 2px 4px 3px;\r\n  border-radius: 4px;\r\n\r\n  i {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n// Tooltips\r\n.tooltip {\r\n  .tooltip-arrow {\r\n    background: config(\"color.basic.black\");\r\n  }\r\n  .tooltip-inner {\r\n    padding: 10px 16px;\r\n    text-align: center;\r\n    background-color: config(\"color.basic.black\");\r\n    border-radius: config(\"layout.cornerRadius.small\");\r\n  }\r\n  &:is(.bs-tooltip-top, .bs-tooltip-bottom) {\r\n    padding-block: 10px;\r\n\r\n    .tooltip-arrow {\r\n      left: initial;\r\n      inset-inline-start: 50%;\r\n      width: 14px;\r\n      height: 8px;\r\n    }\r\n  }\r\n  &.bs-tooltip-top {\r\n    .tooltip-arrow {\r\n      clip-path: polygon(0 0, 100% 0, 54% 100%, 46% 100%);\r\n      bottom: 2px;\r\n    }\r\n  }\r\n  &.bs-tooltip-bottom {\r\n    .tooltip-arrow {\r\n      clip-path: polygon(46% 0, 54% 0, 100% 100%, 0 100%);\r\n      top: 2px;\r\n    }\r\n  }\r\n  &:is(.bs-tooltip-start, .bs-tooltip-end) {\r\n    padding-block: 0px;\r\n    padding-inline: 10px;\r\n\r\n    .tooltip-arrow {\r\n      width: 8px;\r\n      height: 14px;\r\n    }\r\n  }\r\n  &.bs-tooltip-start {\r\n    .tooltip-arrow {\r\n      clip-path: polygon(0 0, 100% 44%, 100% 54%, 0% 100%);\r\n      inset-inline-end: 2px;\r\n    }\r\n  }\r\n  &.bs-tooltip-end {\r\n    .tooltip-arrow {\r\n      clip-path: polygon(0 46%, 100% 0, 100% 100%, 0 54%);\r\n      inset-inline-start: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n// Modals\r\n.modal-content {\r\n  border-radius: config(\"layout.cornerRadius.big\");\r\n  box-shadow: config(\"shadow.light.400\");\r\n\r\n  .modal-title {\r\n    @include FontStyle(\"title.22\", \"medium\");\r\n  }\r\n  .modal-body {\r\n    padding: 1rem !important;\r\n\r\n    &.with-footer {\r\n      max-height: calc(100vh - 140px);\r\n    }\r\n  }\r\n}\r\n\r\n// Data read value page\r\n.data-read-value-page-container {\r\n  box-shadow: config(\"shadow.light.500\");\r\n  border-radius: config(\"layout.cornerRadius.medium\");\r\n  background-color: config(\"color.basic.white\");\r\n  padding: 1.5rem;\r\n  margin: 0 auto 20px;\r\n  overflow-x: auto;\r\n\r\n  .database-metadata {\r\n    .general-info {\r\n      &.institution {\r\n        @include FontStyle(\"title.22\", \"medium\");\r\n        margin-bottom: 8px;\r\n      }\r\n      &.description {\r\n        @include FontStyle(\"body.16\", \"regular\");\r\n      }\r\n    }\r\n    &:has(.institution:empty):has(.description:empty) {\r\n      display: none;\r\n    }\r\n  }\r\n  .field-tree-list:empty {\r\n    display: none;\r\n  }\r\n  .field-tree {\r\n    &:not(:first-child) {\r\n      margin-top: 1rem;\r\n    }\r\n    .data-read-value-field {\r\n      margin-inline-start: 16px;\r\n\r\n      .field-value {\r\n        font-size: 24px;\r\n        line-height: 1.2;\r\n        font-weight: 500;\r\n      }\r\n      .field-description {\r\n        margin-top: 6px;\r\n      }\r\n    }\r\n  }\r\n  .file-list-item {\r\n    display: flex;\r\n    padding-block: 8px;\r\n    gap: 10px;\r\n    border-radius: 6px;\r\n    align-items: center;\r\n  }\r\n  li:where(.active, :hover) .file-list-item {\r\n    background: #ebf1f7;\r\n    box-shadow: -14px 0 0 #ebf1f7, 14px 0 0 #ebf1f7;\r\n  }\r\n  .file-icon {\r\n    font-size: 30px;\r\n  }\r\n  .file-icon::after {\r\n    content: \"\\f15b\";\r\n    color: #363030;\r\n  }\r\n  .file-ext-pdf::after {\r\n    content: \"\\f1c1\";\r\n    color: #FE4534;\r\n  }\r\n  .file-ext-doc::after,\r\n  .file-ext-docx::after {\r\n    content: \"\\f1c2\";\r\n    color: #2C589B;\r\n  }\r\n  .file-ext-jpg::after,\r\n  .file-ext-gif::after,\r\n  .file-ext-bmp::after,\r\n  .file-ext-jpeg::after,\r\n  .file-ext-tiff::after,\r\n  .file-ext-png::after {\r\n    content: \"\\f1c5\";\r\n    color: #4DABE6;\r\n  }\r\n  .file-list-item-icon {\r\n    padding-top: 3px;\r\n    min-width: 30px;\r\n  }\r\n  .file-list-item-info {\r\n    display: grid;\r\n    \r\n    .file-name {\r\n      color: #4678AA;\r\n    }\r\n    .file-size {\r\n      color: #363030;\r\n      line-height: 1;\r\n    }\r\n  }\r\n\r\n  .file-preview {\r\n    padding-top: 16px !important;\r\n    margin-top: 28px;\r\n    position: relative;\r\n    isolation: isolate;\r\n\r\n    &::before {\r\n      content: \"\";\r\n      height: 1px;\r\n      display: block;\r\n      background-color: #E4E4E4;\r\n      width: calc(100% + 3rem);\r\n      position: absolute;\r\n      left: -1.5rem;\r\n      top: 0;\r\n    }\r\n  }\r\n  .file-viewer-button {\r\n    margin-inline-start: auto;\r\n    display: inline-flex;\r\n    gap: 6px;\r\n    align-items: baseline;\r\n    font-weight: 600;\r\n  }\r\n  .file-viewer-container {\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    border: solid 1px #EBEBEB;\r\n  }\r\n}\r\n\r\n// Field History\r\n.json-data-view-object-item {\r\n  tr:not(.field-type-object) {\r\n    .item-value-cell {\r\n      align-items: center;\r\n\r\n      .system-input-container.textarea.like-field {\r\n        margin-block: 6px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.history-icon {\r\n  color: config(\"color.primary.300\");\r\n}\r\n.field-history {\r\n  @include FontStyle(\"label.14\", \"regular\");\r\n\r\n  .db-audit-field-log-list-table {\r\n    .rt-table {\r\n      overflow-x: auto !important;\r\n    }\r\n  }\r\n  &-modal {\r\n    .modal-content > div > div {\r\n      min-width: initial !important;\r\n    }\r\n  }\r\n  &-info {\r\n    margin-bottom: 1.5rem;\r\n  \r\n    .info-heading {\r\n      font-weight: 400;\r\n      color: #4B4B4B;\r\n    }\r\n    .info-value {\r\n      font-weight: 600;\r\n      color: #222222;\r\n    }\r\n    :where(th, td) + :where(th, td) {\r\n      padding-inline-start: 16px;\r\n    }\r\n  }\r\n}\r\n.block-history {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n.history-entries {\r\n  display: flex;\r\n  overflow-x: auto;\r\n  padding-bottom: 16px;\r\n}\r\n.history-item {\r\n  min-width: 150px;\r\n  border: solid 1px config(\"color.gray.100\");\r\n\r\n  &.selected {\r\n    background-color: config(\"color.primary.100\");\r\n    transition-duration: 0.15s;\r\n  }\r\n  &-date {\r\n    padding: 6px 10px;\r\n    font-weight: 600;\r\n  }\r\n  &-field {\r\n    .pointer {\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      \r\n      &:hover {\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n    }\r\n    &.selected {\r\n      .pointer {\r\n        background-color: config(\"color.primary.200\");\r\n      }\r\n    }\r\n  }\r\n  .item-field-name {\r\n    display: flex;\r\n    padding: 6px 10px;\r\n    gap: 10px;\r\n  }\r\n}\r\n// Row history\r\n.row-history {\r\n  .json-data-view-object-item {\r\n    tbody {\r\n      tr {\r\n        &:hover {\r\n          > td {\r\n            background-color: var(--hover-bg);\r\n          }\r\n        }\r\n      }\r\n      td {\r\n        --hover-bg: #{config(\"color.gray.50\")};\r\n\r\n        td {\r\n          --hover-bg: #{config(\"color.gray.100\")};\r\n\r\n          td {\r\n            --hover-bg: #{config(\"color.gray.200\")};\r\n\r\n            td {\r\n              --hover-bg: #{config(\"color.gray.300\")};\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n// End Field history\r\n\r\n// JSON Data View\r\n.json-data-view {\r\n  padding-bottom: 10px;\r\n\r\n  section {\r\n    article {\r\n      &:not(.object-parent-item) {\r\n        display: flex;\r\n        gap: 10px;\r\n        padding-block: 5px;\r\n      }\r\n      & + article:not(.object-parent-item) {\r\n        border-top: var(--jdv-border-style, solid) var(--jdv-border-top-width, 1px) var(--border-top-color, #e5e7eb);\r\n      }\r\n      &:is(.field-type-object, .field-type-array) {\r\n        flex-direction: column;\r\n        padding-block: 0px;\r\n        gap: 0px;\r\n\r\n        > .item-fieldname-cell {\r\n          padding-block: 5px;\r\n          width: auto;\r\n          background-color: config(\"color.gray.75\");\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n          flex-basis: initial;\r\n        }\r\n        &.collapsed {\r\n          > .item-fieldname-cell {\r\n            background-color: config(\"color.gray.50\");\r\n          }\r\n          > .item-value-cell {\r\n            display: none;\r\n          }\r\n          &:last-child {\r\n            > .item-fieldname-cell {\r\n              border-bottom-left-radius: 10px;\r\n              border-bottom-right-radius: 10px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &.object-parent-item:not(.field-type-catalog) {\r\n        &.collapsed {\r\n          > section {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n      &.field-type-object {\r\n        > .item-value-cell {\r\n          padding-inline-end: 0px;\r\n\r\n          > :is(.json-data-view-object-item, .json-data-view-array) {\r\n            > article {\r\n              &:first-child {\r\n                border-top: var(--jdv-border-style, solid) var(--jdv-border-top-width, 1px) var(--border-top-color, #e5e7eb);\r\n              }\r\n              > .item-fieldname-cell {\r\n                padding-inline-start: calc(var(--jdv-base-item-start-padding) + (var(--level) * var(--jdv-row-offset)));\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &.field-type-array {\r\n        > .item-value-cell {\r\n          padding-inline-end: 0px;\r\n\r\n          .item-fieldname-cell {\r\n            padding-inline-start: calc(var(--jdv-base-item-start-padding) + (var(--level) * var(--jdv-row-offset)));\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &.root-item {\r\n      &.json-data-view-array {\r\n        > article {\r\n          background-color: config(\"color.basic.white\");\r\n          box-shadow: config(\"shadow.light.200\");\r\n          border-radius: config(\"layout.cornerRadius.big\");\r\n\r\n          & + article {\r\n            margin-top: 24px;\r\n          }\r\n        }\r\n      }\r\n      &.json-data-view-object-item {\r\n        background-color: config(\"color.basic.white\");\r\n        box-shadow: config(\"shadow.light.200\");\r\n        border-radius: config(\"layout.cornerRadius.big\");\r\n      }\r\n    }\r\n  }\r\n  .array-header-collapsible {\r\n    &.level-0 {\r\n      border-bottom: solid 1px config(\"color.gray.100\");\r\n      min-height: 65px;\r\n      padding-inline-end: 6px;\r\n      padding-inline-start: 20px;\r\n    }\r\n    &:not(.level-0) {\r\n      padding-inline-start: calc(var(--jdv-base-item-start-padding) + (var(--level) * var(--jdv-row-offset)));\r\n      padding-inline-end: 6px;\r\n      padding-block: 6px;\r\n      border-bottom: solid 1px config(\"color.gray.100\");\r\n    }\r\n  }\r\n  .sub-detail-title {\r\n    @include FontStyle(\"label.16\", \"bold\");\r\n  }\r\n  .item-fieldname-cell {\r\n    flex-basis: 240px;\r\n    min-width: 25%;\r\n    padding-inline-start: var(--jdv-base-item-start-padding);\r\n  }\r\n  .item-value-cell {\r\n    min-width: 200px;\r\n    flex: 1;\r\n    padding-inline-end: 6px;\r\n  }\r\n  :is(.rendered-value, .item-fieldname-cell) {\r\n    padding-block: 8px;\r\n  }\r\n  .toggle-entry {\r\n    margin-inline-start: -12px;\r\n  }\r\n  .field-type-array_of_file {\r\n    .item-value-cell {\r\n      > div {\r\n        display: flex;\r\n        justify-content: space-between;\r\n      }\r\n    }\r\n  }\r\n  .field-type-catalog {\r\n    > .item-value-cell {\r\n      > .json-data-view-object-item {\r\n        > article {\r\n          &:first-child {\r\n            padding-top: 0px;\r\n          }\r\n          &:last-child {\r\n            padding-bottom: 0px;\r\n          }\r\n          > .item-fieldname-cell {\r\n            padding-inline-start: 0px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .field-type-array_of_catalog {\r\n    > .item-value-cell {\r\n      padding-inline-end: 0px;\r\n    }\r\n    > .item-value-cell {\r\n      .item-fieldname-cell {\r\n        padding-inline-start: 0px;\r\n      }\r\n      .file-multiple-add {\r\n        margin-inline-start: 0px;\r\n      }\r\n      .field-type-catalog {\r\n        &:has(> .can-remove-item button:hover) {\r\n          background-color: config(\"color.error.100\");\r\n        }\r\n        & + .field-type-catalog {\r\n          border-top: solid 1px config(\"color.gray.400\");\r\n        }\r\n      }\r\n    }\r\n  }\r\n  :is(.field-type-date, .field-type-datetime) .rdtPicker {\r\n    position: absolute !important;\r\n\r\n    &::after {\r\n      content: \"\";\r\n      display: block;\r\n      height: 36px;\r\n      margin-bottom: -36px;\r\n    }\r\n  }\r\n  &.editor-mode {\r\n    .field-type-array {\r\n      .field-type-object.object-parent-item {\r\n        display: flex;\r\n        \r\n        &:has(> .can-remove-item button:hover) {\r\n          background-color: config(\"color.error.100\");\r\n        }\r\n        > .can-remove-item {\r\n          position: absolute;\r\n          inset-inline-end: 62px;\r\n          margin-top: 6px;\r\n        }\r\n      }\r\n    }\r\n    .field-type-array_of_file {\r\n      .item-value-cell {\r\n        > div {\r\n          flex-direction: column;\r\n\r\n          .json-data-view-array {\r\n            .field-type-file {\r\n              display: flex;\r\n              justify-content: space-between;\r\n              gap: 8px;\r\n\r\n              & + .field-type-file {\r\n                margin-top: 8px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .file-multiple-add {\r\n        margin-inline-start: 0px;\r\n      }\r\n      .upload-component-container {\r\n        gap: 8px;\r\n      }\r\n    }\r\n    .file-multiple-add {\r\n      margin-top: 10px;\r\n      margin-bottom: 8px;\r\n      margin-inline-start: calc(var(--jdv-base-item-start-padding) + (var(--level) * var(--jdv-row-offset)));\r\n    }\r\n    :is(.field-type-catalog, .field-type-array_of_catalog) {\r\n      > .item-value-cell {\r\n        padding-inline-end: 0px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Reminders\r\n.ck {\r\n  .ck-widget.mustache-placeholder {\r\n    cursor: grab;\r\n    border-radius: config(\"layout.cornerRadius.medium\");\r\n    padding-inline: 2px;\r\n\r\n    &::before,\r\n    &::after {\r\n      font-family: string.quote(config(\"font.icons.family\"));\r\n      @include faIcon;\r\n      font-weight: 400;\r\n      font-size: 115%;\r\n      transform: translateY(1px);\r\n    }\r\n    &::before {\r\n      content: \"\\7b\";\r\n    }\r\n    &::after {\r\n      content: \"\\7d\";\r\n    }\r\n    &:hover {\r\n      outline-color: config(\"color.info.400\");\r\n    }\r\n  }\r\n  &.ck-editor__top .ck-sticky-panel .ck-toolbar {\r\n    background-color: config(\"color.gray.50\");\r\n  }\r\n}\r\n.reminder-message-editor {\r\n  height: 100%;\r\n\r\n  .ck-editor {\r\n    height: 100% !important;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .ck-editor__main {\r\n      flex: 1;\r\n\r\n      .ck-content {\r\n        height: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n.reminder-pane-title {\r\n  @include FontStyle(\"title.22\", \"semibold\");\r\n  color: config(\"color.gray.900\");\r\n}\r\n\r\n// TODO: Remove reports?\r\n// Reports\r\n// New reports drawer\r\n.reports-drawer-open {\r\n  > .Pane1 {\r\n    padding-inline-end: 24px;\r\n    max-width: calc(100% - 340px);\r\n  }\r\n  .Pane2 {\r\n    z-index: 100;\r\n    background: #F1F5FF;\r\n    height: 100vh;\r\n    transform: translateY(calc(0px - 105px));\r\n    margin-inline-end: -40px;\r\n    padding-inline: 20px;\r\n    box-shadow: config(\"shadow.light.200\");\r\n\r\n    .Pane.vertical {\r\n      overflow: visible;\r\n    }\r\n  }\r\n  .Resizer {\r\n    z-index: 101;\r\n    --custom-resizer-top-margin: -105px;\r\n    margin-top: var(--custom-resizer-top-margin) !important;\r\n    background: transparent;\r\n\r\n    &:hover {\r\n      background: config(\"color.gray.300\");\r\n    }\r\n  }\r\n  .wrapper-header {\r\n    height: 80px;\r\n    background: config(\"color.basic.white\");\r\n    margin-inline: -20px;\r\n    padding-inline: 24px;\r\n    box-shadow: config(\"shadow.light.200\");\r\n\r\n    .modal-title {\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      width: 100%;\r\n      gap: 0 0.5rem;\r\n      height: 100%;\r\n      @include FontStyle(\"title.22\", \"medium\");\r\n\r\n      .layer-actions {\r\n        .system-button:last-child {\r\n          margin-inline-end: -10px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .wrapper-body {\r\n    padding-block: 24px;\r\n    height: calc(100vh - 80px);\r\n  }\r\n  .view-report-settings {\r\n    max-height: 100%;\r\n    min-height: 100%;\r\n    overflow-y: auto;\r\n\r\n    .field-item {\r\n      border-radius: config(\"layout.cornerRadius.big\");\r\n      box-shadow: config(\"shadow.light.200\");\r\n      padding: 24px;\r\n      background-color: config(\"color.basic.white\");\r\n      position: relative;\r\n\r\n      .system-input-container.select .type-select-style .react-select__option > span:has(.count) {\r\n        display: flex;\r\n        gap: 6px;\r\n        align-items: baseline;\r\n      }\r\n    }\r\n    > .view-fields {\r\n      padding-inline: 4px;\r\n      padding-bottom: 4px;\r\n    }\r\n  }\r\n  .drag-handle {\r\n    position: absolute;\r\n    top: 8px;\r\n    inset-inline-end: 8px;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    width: 20px;\r\n    height: 20px;\r\n    display: grid;\r\n    place-content: center;\r\n    color: config(\"color.gray.400\");    \r\n  }\r\n  .view-fields {\r\n    > div + div {\r\n      margin-top: 16px;\r\n    }\r\n    [data-rbd-draggable-context-id][style*=\"left\"] {\r\n      left: initial !important;\r\n      scale: 0.98;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n  .view-sub-fields {\r\n    margin-top: 12px;\r\n\r\n    .field-item {\r\n      border: solid 1px config(\"color.gray.100\");\r\n      box-shadow: config(\"shadow.light.100\");\r\n    }\r\n    > div + div {\r\n      margin-top: 16px;\r\n    }\r\n  }\r\n  .group-by-toggle {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-top: 10px;\r\n\r\n    span {\r\n      @include FontStyle(\"label.12\", \"medium\");\r\n      color: config(\"color.gray.400\");\r\n    }\r\n    i {\r\n      font-size: 24px;\r\n      line-height: 18px;\r\n    }\r\n  }\r\n  .count {\r\n    @include FontStyle(\"label.12\", \"medium\");\r\n    color: config(\"color.gray.400\");\r\n    background-color: config(\"color.gray.100\");\r\n    padding: 0px 5px;\r\n    border-radius: 4px;\r\n  }\r\n  .field-item {\r\n    &.item-collapsed {\r\n      .view-sub-fields {\r\n        display: none;\r\n      }\r\n      > .system-label {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n// End new reports drawer\r\n.report-detail {\r\n  display: grid;\r\n  height: 100%;\r\n  grid-template-rows: min-content auto 50px;\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n  grid-gap: 10px;\r\n\r\n  .filters-block {\r\n    margin-top: 1rem;\r\n    text-align: start;\r\n  }\r\n  .report-general-info:empty + .filters-block {\r\n    margin-top: 0;\r\n  }\r\n}\r\n.report-info-label {\r\n  @include FontStyle(\"label.14\", \"regular\");\r\n  color: config(\"color.gray.400\");\r\n}\r\n.report-info-value {\r\n  @include FontStyle(\"label.16\", \"medium\");\r\n  color: config(\"color.basic.black\");\r\n}\r\n.report-filter-entry-group {\r\n  padding: 4px;\r\n  border: solid 1px config(\"color.gray.300\");\r\n  border-radius: config(\"layout.cornerRadius.small\");\r\n}\r\n:where(.report-filter-entry-group, .report-filter-entry) {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.report-filter-entry {\r\n  .system-badge {\r\n    display: inline-flex;\r\n    column-gap: 6px;\r\n  }\r\n}\r\n.report-applied-filters {\r\n  gap: 6px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n.filter-logic {\r\n  color: config(\"color.basic.black\");\r\n  font-weight: config(\"font.weight.bold\");\r\n}\r\n.filters-rows-action .addReport {\r\n  display: none !important;\r\n}\r\n.add-report-form-container {\r\n  width: 500px;\r\n}\r\n.flex-one {\r\n  flex: 1;\r\n}\r\n.report-table {\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n\r\n  .type-array_of_file {\r\n    gap: 12px;\r\n  }\r\n}\r\n.report-table .table-scrollbar {\r\n  background-color: rgba(0, 0, 0, 0.02);\r\n  height: 9px;\r\n}\r\n.report-table .table-scrollbar:hover {\r\n  background-color: rgba(0, 0, 0, 0.06);\r\n}\r\n.report-export {\r\n  justify-content: flex-end;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.report-options {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.add-sort-field {\r\n  margin-block: -8px;\r\n}\r\n.report-columns-toggler {\r\n  flex-wrap: wrap;\r\n\r\n  .system-badge {\r\n    color: config(\"color.basic.white\") !important;\r\n  }\r\n}\r\n\r\n// Views\r\n:where(.views-source-table-header, .views-target-table-header) {\r\n  @include FontStyle(\"label.12\", \"bold\");\r\n  background-color: config(\"color.gray.100\");\r\n  color: config(\"color.basic.black\");\r\n  border-radius: config(\"layout.cornerRadius.medium\");\r\n  position: sticky;\r\n  top: 0;\r\n\r\n  & + .tree-items {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n.views-source-table-grid {\r\n  --rw: (100% - 36px) - 20px; // remaining width ... 20px because 3 columns and 2 gaps of 10px\r\n  --offset: 0px; // nesting offset\r\n  grid-template-columns: calc(36px + var(--offset)) calc(((var(--rw)) * 0.7) - var(--offset)) calc((var(--rw)) * 0.3);\r\n  gap: 10px;\r\n}\r\n.views-target-table-grid {\r\n  --rw: (100% - 144px) - 50px; // remaining width ... 50px because 6 columns and 5 gaps of 10px\r\n  --offset: 0px; // nesting offset\r\n  gap: 10px;\r\n  grid-template-columns: calc(72px + var(--offset)) calc(((var(--rw)) * 0.3) - var(--offset)) calc((var(--rw)) * 0.3) calc((var(--rw)) * 0.2) calc((var(--rw)) * 0.2) 72px;\r\n}\r\n:where(.views-source-table-header, .views-source-table-entry, .views-target-table-header) {\r\n  > div {\r\n    padding-block: 8px;\r\n  }\r\n}\r\n:where(.views-source-table-entry, .views-target-table-entry) {\r\n  border-radius: config(\"layout.cornerRadius.small\");\r\n\r\n  &:hover {\r\n    background-color: config(\"color.gray.50\");\r\n  }\r\n}\r\n.views-source-table-entry {\r\n  @include FontStyle(\"label.14\", \"regular\");\r\n\r\n  &:has(.toggle-entry) {\r\n    background-color: config(\"color.gray.50\");\r\n  }\r\n}\r\n.views-target-table-entry {\r\n  @include FontStyle(\"label.14\", \"regular\");\r\n  align-items: baseline;\r\n  margin-top: 2px;\r\n\r\n  .entry-toggler {\r\n    border-radius: config(\"layout.cornerRadius.small\") 0 0 config(\"layout.cornerRadius.small\");\r\n  }\r\n  &:is(.field-type-object, .field-type-array) {\r\n    @include FontStyle(\"label.14\", \"normal\");\r\n  }\r\n  &.field-type-array {\r\n    background-color: config(\"color.gray.100\");\r\n  }\r\n  &.field-type-object {\r\n    background-color: config(\"color.primary.100\");\r\n  }\r\n}\r\n.views-source-fields-pane {\r\n  .nav-tabs {\r\n    margin-bottom: 10px;\r\n    border: none;\r\n  }\r\n  .toggle-entry {\r\n    width: 36px;\r\n    display: grid;\r\n    place-content: center;\r\n    border-radius: config(\"layout.cornerRadius.small\") 0 0 config(\"layout.cornerRadius.small\");\r\n    height: calc(100% + 16px);\r\n    margin-top: -8px;\r\n\r\n    &:hover {\r\n      background-color: config(\"color.gray.100\");\r\n    }\r\n  }\r\n  .nav-link {\r\n    @include FontStyle(\"label.14\", \"medium\");\r\n    color: config(\"color.gray.500\");\r\n    padding-block: 12px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex: 1;\r\n\r\n    &:where(:hover, .active) {\r\n      color: config(\"color.basic.black\") !important;\r\n      @include FontStyle(\"label.14\", \"semibold\");\r\n      border: none;\r\n      border-color: config(\"color.primary.400\") !important;\r\n      border-bottom: solid 2px;\r\n    }\r\n  }\r\n}\r\n.source-entry-toggler {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.entry-handler {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  font-size: 14px;\r\n\r\n  span {\r\n    display: grid;\r\n    width: 36px;\r\n    height: 36px;\r\n    place-content: center;\r\n\r\n    &:hover {\r\n      background-color: config(\"color.gray.100\");\r\n    }\r\n  }\r\n  & + div:not(.entry-column):last-child {\r\n    display: contents;\r\n\r\n    .entry-actions {\r\n      grid-column: 6;\r\n      text-align: end;\r\n    }\r\n  }\r\n  .view-deleted-field-notification-dot {\r\n    width: 36px;\r\n    text-align: center;\r\n  }\r\n}\r\n.entry-column {\r\n  padding-block: 5px;\r\n}\r\n.tree-items .views-source-table-grid + .tree-items {\r\n  .views-source-table-entry {\r\n    --offset: 36px;\r\n\r\n    & + .tree-items .views-source-table-grid {\r\n      --offset: 48px;\r\n\r\n      & + .tree-items .views-source-table-grid {\r\n        --offset: 72px;\r\n\r\n        & + .tree-items .views-source-table-grid {\r\n          --offset: 96px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.tree-item > .tree-items {\r\n  > .tree-item {\r\n    .views-target-table-grid {\r\n      --offset: 36px;\r\n\r\n      & + .tree-items .views-target-table-grid {\r\n        --offset: 72px;\r\n\r\n        & + .tree-items .views-target-table-grid {\r\n          --offset: 108px;\r\n\r\n          & + .tree-items .views-target-table-grid {\r\n            --offset: 144px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.views-target-fields-pane {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: fit-content;\r\n\r\n  :not(.empty-items) .placeholder,\r\n  .empty-items {\r\n    display: grid;\r\n    place-content: center;\r\n    border: dashed 2px config(\"color.gray.200\");\r\n    text-align: center;\r\n    border-radius: 6px;\r\n    min-height: 300px;\r\n  }\r\n  .empty-items {\r\n    flex: auto;\r\n  }\r\n  :not(.empty-items) .placeholder {\r\n    height: auto;\r\n    margin-top: 10px;\r\n\r\n    button {\r\n      justify-self: center;\r\n    }\r\n  }\r\n  .tree-item {\r\n    .empty-items {\r\n      min-height: 50px;\r\n    }\r\n    .tree-items.item-dragging-over {\r\n      border: dashed 2px config(\"color.info.400\");\r\n    }\r\n  }\r\n  .item-dragging-over {\r\n    border-color: config(\"color.info.400\");\r\n\r\n    > div:not([class]) {\r\n      background-color: config(\"color.gray.50\");\r\n      border-radius: 6px;\r\n      max-width: 98%;\r\n      margin: 0 auto !important;\r\n    }\r\n  }\r\n  h4 {\r\n    @include FontStyle(\"title.22\", \"semibold\");\r\n    margin-bottom: 22px;\r\n    margin-top: 4px;\r\n  }\r\n}\r\n.drop-drag-fields-view:has(.views-source-fields-pane > .nav-tabs) .views-target-table-header {\r\n  margin-top: 55px;\r\n}\r\n.data-view-field-list-table.target-table {\r\n  flex: auto;\r\n  height: initial;\r\n}\r\n.SplitPane {\r\n  padding: 5px;\r\n  margin: -5px;\r\n\r\n  .Pane2 .Pane {\r\n    overflow-y: auto;\r\n  }\r\n}\r\n.tree-items {\r\n  &.item-dragging-over {\r\n    background: transparent;\r\n  }\r\n}\r\n.tree-item-name {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.tree-dnd-item {\r\n  .tree-item {\r\n    background-color: config(\"color.basic.white\");\r\n    border-radius: 6px;\r\n    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.08);\r\n    outline: dashed 1px config(\"color.gray.100\");\r\n  }\r\n}\r\n.view-deleted-field-notification-dot {\r\n  color: config(\"color.error.400\");\r\n  position: sticky;\r\n  inset-inline-end: 0px;\r\n  margin-inline-start: 0px;\r\n\r\n  i {\r\n    transform: translateX(13px);\r\n  }\r\n}\r\n.views-source-group-selector {\r\n  margin-bottom: 8px;\r\n\r\n  &:focus-within {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n.join-databases {\r\n  text-align: start;\r\n}\r\n// Views Reports\r\n.applied-reports.system-data-table.data-list-container.data-view-list-container {\r\n  .react-table {\r\n    .rt-table {\r\n      :is(.rt-thead, .rt-tfoot) {\r\n        .tr {\r\n          background-color: config(\"color.gray.100\");\r\n        }\r\n      }\r\n      :is(.th, .td) {\r\n        flex: initial !important;\r\n      }\r\n      .rt-tbody {\r\n        .tr {\r\n          &:hover {\r\n            background-color: config(\"color.gray.50\");\r\n          }\r\n        }\r\n      }\r\n      .rt-tfoot {\r\n        min-width: fit-content;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Views Groups\r\n.view-groups {\r\n  margin: 8px;\r\n\r\n  &:has(button:only-child) {\r\n    padding-block: 10px;\r\n  }\r\n  &.empty {\r\n    display: grid;\r\n    place-content: center;\r\n    height: calc(100% - 24px);\r\n    gap: 16px;\r\n    background: config(\"color.basic.white\");\r\n    border-radius: config(\"layout.cornerRadius.large\");\r\n    border: dashed 2px config(\"color.gray.200\");\r\n\r\n    .empty-message {\r\n      @include FontStyle(\"label.16\", \"medium\");\r\n      color: config(\"color.basic.black\");\r\n    }\r\n    button {\r\n      justify-self: center;\r\n      width: fit-content;\r\n    }\r\n  }\r\n  > button:not(:only-child):last-child {\r\n    margin-top: 32px;\r\n  }\r\n  > div + div {\r\n    margin-top: 4px;\r\n  }\r\n  > div[style*=\"position: fixed;\"] {\r\n    left: initial !important;\r\n    opacity: 0.5;\r\n    zoom: 0.98;\r\n\r\n    .data-view-list-group-item {\r\n      outline: dashed 1px config(\"color.gray.400\");\r\n    }\r\n  }\r\n}\r\n.data-view-list-group-item {\r\n  gap: 12px;\r\n  padding: 4px;\r\n  align-items: center;\r\n  justify-content: start;\r\n  display: flex;\r\n  background-color: config(\"color.gray.75\");\r\n  border-radius: config(\"layout.cornerRadius.medium\");\r\n}\r\n// Databases Driagrams\r\n.diagram-menu {\r\n  position: absolute;\r\n  top: calc(50vh - 212px);\r\n  inset-inline-end: 12px;\r\n\r\n  ul {\r\n    border-radius: config(\"layout.cornerRadius.large\");\r\n    background-color: config(\"color.basic.white\");\r\n    box-shadow: config(\"shadow.light.100\");\r\n    padding: 8px;\r\n    width: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    height: auto;\r\n    gap: 12px;\r\n    list-style: none;\r\n    li {\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n.entity-relationship-node {\r\n  .node-header {\r\n    background-color: var(--node-color);\r\n\r\n    &.summarised {\r\n      background-color: config(\"color.basic.white\");\r\n      border: solid 1px var(--node-color);\r\n      color: var(--node-color);\r\n\r\n      .toggle-icon {\r\n        color: var(--node-color);\r\n      }\r\n      & ~ .node-reduced-toggler,\r\n      & ~ .nodes-list .expand-collapse-all {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n  &.view-minimal {\r\n    background: transparent;\r\n    box-shadow: none;\r\n    \r\n    .node-description {\r\n      display: block;\r\n      position: absolute;\r\n      top: -110px;\r\n      inset-inline-start: 50%;\r\n      transform: translateX(-50%);\r\n    }\r\n    .nodes-list {\r\n      background: white;\r\n      border-bottom-left-radius: 10px;\r\n    }\r\n  }\r\n}\r\n.rows-reduced-collapsed {\r\n  .nodes-list {\r\n    max-height: 314px;\r\n    overflow: hidden\r\n  }\r\n}\r\n.node-reduced-toggler {\r\n  padding: 10px 20px 18px;\r\n  border-top: solid 1px config(\"color.gray.300\");\r\n\r\n  &:hover {\r\n    background-color: config(\"color.gray.50\");\r\n  }\r\n}\r\n\r\n// Data import\r\n.data-import-container {\r\n  @include FontStyle(\"body.14\", \"regular\");\r\n}\r\n\r\n// Data export\r\n.system-button:where(.btn, .btn-secondary) span.export-progress {\r\n  background-color: config(\"color.basic.black\");\r\n  border-radius: config(\"layout.cornerRadius.small\");\r\n  color: config(\"color.basic.white\") !important;\r\n  display: block !important;\r\n  font-size: 12px !important;\r\n  opacity: 0.88;\r\n  padding: 5px 10px;\r\n  position: absolute;\r\n  top: 0;\r\n  \r\n  -webkit-animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\r\n          animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\r\n}\r\n@-webkit-keyframes slide-top {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n            transform: translateY(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: translateY(-28px);\r\n            transform: translateY(-28px);\r\n  }\r\n}\r\n@keyframes slide-top {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n            transform: translateY(0);\r\n  }\r\n  100% {\r\n    -webkit-transform: translateY(-28px);\r\n            transform: translateY(-28px);\r\n  }\r\n}\r\n\r\n// Helpers\r\n.flow-root {\r\n  display: flow-root;\r\n}\r\n.display-contents {\r\n  display: contents;\r\n}\r\n.translate-y {\r\n  transform: translateY(var(--translate-y-value));\r\n}\r\n.column-gap {\r\n  column-gap: var(--column-gap, 0px);\r\n}\r\n.row-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(var(--columns-count, auto), 1fr);\r\n}\r\n.grid-span-column {\r\n  grid-column: var(--columns-span);\r\n}\r\n.bordered-columns {\r\n  border: solid 1px config(\"color.gray.200\");\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n}\r\n// ANCHOR Logical properties margins\r\n.mx {\r\n  &-start {\r\n    &-1 {\r\n      margin-inline-start: 0.25rem !important;\r\n    }\r\n    &-2 {\r\n      margin-inline-start: 0.5rem !important;\r\n    }\r\n    &-3 {\r\n      margin-inline-start: 1rem !important;\r\n    }\r\n    &-4 {\r\n      margin-inline-start: 1.5rem !important;\r\n    }\r\n    &-5 {\r\n      margin-inline-start: 3rem !important;\r\n    }\r\n    &-auto {\r\n      margin-inline-start: auto !important;\r\n    }\r\n  }\r\n}\r\n.mx {\r\n  &-end {\r\n    &-1 {\r\n      margin-inline-end: 0.25rem !important;\r\n    }\r\n    &-2 {\r\n      margin-inline-end: 0.5rem !important;\r\n    }\r\n    &-3 {\r\n      margin-inline-end: 1rem !important;\r\n    }\r\n    &-4 {\r\n      margin-inline-end: 1.5rem !important;\r\n    }\r\n    &-5 {\r\n      margin-inline-end: 3rem !important;\r\n    }\r\n    &-auto {\r\n      margin-inline-end: auto !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Scroll\r\n::-webkit-scrollbar {\r\n  width: 9px;\r\n  height: 9px;\r\n}\r\n::-webkit-scrollbar-track {\r\n  background: config(\"color.gray.100\") !important;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n  border-radius: 4px;\r\n  background: config(\"color.gray.400\");\r\n}\r\n::-webkit-scrollbar-thumb:window-inactive {\r\n  background: config(\"color.gray.200\");\r\n}",".react-table .rt-table .rt-tbody .tr .td {\r\n  @include FontStyle(\"label.12\", \"regular\");\r\n  color: config(\"color.basic.black\");\r\n  align-items: center;\r\n  place-content: center start;\r\n\r\n  span {\r\n    vertical-align: baseline;\r\n  }\r\n  &.link-cell {\r\n    .system-button {\r\n      font: inherit;\r\n      text-decoration: underline;\r\n      text-underline-offset: 2px;\r\n    }\r\n  }\r\n}\r\n.td {\r\n  &.type-array_of_catalog {\r\n    .item + .item {\r\n      border-inline-start: solid 1px config(\"color.gray.300\");\r\n      padding-inline-start: 6px;\r\n      margin-inline-start: 6px;\r\n    }\r\n    &:hover {\r\n      .item + .item {\r\n        border-inline-start-color: config(\"color.gray.600\");\r\n      }\r\n    }\r\n  }\r\n}\r\n.table-row-actions-cell {\r\n  display: flex;\r\n  justify-content: center;\r\n  height: 100%;\r\n  align-items: center;\r\n  opacity: 0;\r\n}\r\n.filters-table-container {\r\n  &:not(:empty) {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n:is(.data-filter-table, .data-aggregate-table) {\r\n  table-layout: auto;\r\n  width: 100%;\r\n\r\n  tr {\r\n    position: relative;\r\n    z-index: var(--filter-index);\r\n\r\n    td {\r\n      padding-inline-start: 0px;\r\n      padding-inline-end: 12px;\r\n      padding-block-start: 12px;\r\n      padding-block-end: 0px;\r\n    }\r\n    .options-buttons-column {\r\n      width: 72px;\r\n      min-width: 72px;\r\n      padding-inline-end: 0px;\r\n    }\r\n    &:first-child {\r\n      td {\r\n        padding-block-start: 0px;\r\n      }\r\n      .logic-operator {\r\n        .system-input-container {\r\n          display: none;\r\n        }\r\n      }\r\n      .options-buttons-column {\r\n        width: 72px;\r\n        min-width: 72px;\r\n      }\r\n    }\r\n    &:only-child {\r\n      .logic-operator {\r\n        padding-inline-end: 0px;\r\n        width: 0px;\r\n      }\r\n    }\r\n    .logic-operator {\r\n      width: 150px;\r\n    }\r\n    .filter-value-column {\r\n      width: 40%;\r\n\r\n      > .select .type-select-style {\r\n        z-index: var(--filter-index);\r\n      }\r\n    }\r\n    .filter-operator-column {\r\n      width: 20%;\r\n    }\r\n    .filter-field-column {\r\n      width: 40%;\r\n      min-width: 200px;\r\n    }\r\n    &.filter-group-row {\r\n      .data-filter-table {\r\n        tbody {\r\n          padding: 10px;\r\n          display: block;\r\n          border-radius: 6px;\r\n          border: solid 1px config(\"color.gray.300\");\r\n          transition-property: background-color;\r\n          transition-duration: 0.15s;\r\n\r\n          &:hover {\r\n            background-color: config(\"color.gray.50\");\r\n\r\n            tbody {\r\n              background-color: config(\"color.basic.white\");\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .expression-operand {\r\n      width: 240px;\r\n    }\r\n    .function-column {\r\n      width: 20%;\r\n      min-width: 200px;\r\n    }\r\n    &:has(.react-select__control--menu-is-open) {\r\n      z-index: 99;\r\n    }\r\n  }\r\n}\r\n.imported-table {\r\n  th {\r\n    background-color: config(\"color.gray.100\");\r\n    @include FontStyle(\"label.14\", \"medium\");\r\n    color: config(\"color.basic.black\");\r\n    padding-inline: 16px;\r\n    padding-block: 10px;\r\n  }\r\n  td {\r\n    --inline-padding: 16px;\r\n    --block-padding: 6px;\r\n  }\r\n}\r\n.imported-file-table,\r\n.imported-db-table {\r\n  td {\r\n    --block-padding: 16px;\r\n  }\r\n}\r\n\r\n.header-vertical-align-middle {\r\n  align-items: center;\r\n}","@use \"sass:string\";\r\n\r\n// Drawers\r\n.modal-dialog.layer {\r\n  position: fixed;\r\n  top: 0;\r\n  inset-inline-end: 0;\r\n  bottom: 0;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  height: 100vh;\r\n\r\n  .modal-content {\r\n    border: none;\r\n    border-radius: 0;\r\n    height: 100%;\r\n  }\r\n  .modal-body {\r\n    height: calc(100vh - 70px);\r\n    overflow-y: auto;\r\n    background-color: config(\"color.gray.50\");\r\n  }\r\n  .modal-footer {\r\n    position: fixed;\r\n    bottom: 1px;\r\n    inset-inline-end: 1px;\r\n    inset-inline-start: 1px;\r\n\r\n    &:empty {\r\n      display: none;\r\n    }\r\n  }\r\n  .table-responsive-material {\r\n    position: relative;\r\n  }\r\n  &.modal-align-left {\r\n    inset-inline-end: auto;\r\n  }\r\n}\r\n.modal-wrapper-container {\r\n  display: flex;\r\n  flex: auto;\r\n}\r\n.drawer-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 100px;\r\n  max-width: 99vw;\r\n\r\n  .modal-header {\r\n    min-height: var(--app-header-height);\r\n    box-shadow: config(\"shadow.light.200\");\r\n    background-color: config(\"color.basic.white\") !important;\r\n    align-items: center;\r\n    z-index: 1;\r\n\r\n    .close {\r\n      width: 48px;\r\n      height: 48px;\r\n      min-width: 48px;\r\n      appearance: none;\r\n      font-family: \"Font Awesome 6 Pro\";\r\n      font-weight: 400;\r\n      -moz-osx-font-smoothing: grayscale;\r\n      -webkit-font-smoothing: antialiased;\r\n      display: var(--fa-display, inline-block);\r\n      font-style: normal;\r\n      font-variant: normal;\r\n      line-height: 1;\r\n      text-rendering: auto;\r\n      opacity: 1;\r\n      font-size: 20px;\r\n      color: config(\"color.basic.black\");\r\n      margin-inline: -10px;\r\n      border-radius: config(\"layout.cornerRadius.medium\");\r\n      transition-duration: 0.15s;\r\n      transition-property: background-color;\r\n\r\n      span {\r\n        display: none\r\n      }\r\n      &:hover {\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n      &::before {\r\n        content: \"\\F00D\";\r\n      }\r\n      &:focus,\r\n      &:focus-visible {\r\n        outline: none;\r\n        background-color: config(\"color.gray.200\");\r\n      }\r\n    }\r\n    button[class=\"btn-close\"] {\r\n      color: config(\"color.basic.black\");\r\n      border: none;\r\n      padding: 0;\r\n      width: 48px;\r\n      height: 48px;\r\n      cursor: pointer;\r\n      display: grid;\r\n      place-content: center;\r\n      border-radius: config(\"layout.cornerRadius.medium\");\r\n      transition-duration: 0.15s;\r\n      transition-property: background-color;\r\n\r\n      &:hover {\r\n        background-color: config(\"color.gray.100\");\r\n      }\r\n      &:focus,\r\n      &:focus-visible {\r\n        outline: none;\r\n        background-color: config(\"color.gray.200\");\r\n      }\r\n      &::after {\r\n        font-family: string.quote(config(\"font.icons.family\"));\r\n        @include faIcon;\r\n        content: \"\\F00D\";\r\n        font-weight: 400;\r\n        font-size: 20px;\r\n        width: 24px;\r\n        height: 24px;\r\n        --fa-display: grid;\r\n        place-content: center;\r\n      }\r\n    }\r\n  }\r\n  .modal-title {\r\n    @include FontStyle(\"title.22\", \"medium\");\r\n  }\r\n}\r\n.sub-drawer-close {\r\n  width: 48px;\r\n  height: 48px;\r\n  min-width: 48px;\r\n  appearance: none;\r\n  font-size: 20px;\r\n  color: config(\"color.basic.black\");\r\n  margin-inline: -10px;\r\n  border-radius: config(\"layout.cornerRadius.medium\");\r\n  transition-duration: 0.15s;\r\n  transition-property: background-color;\r\n  border: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background-color: config(\"color.gray.100\");\r\n  }\r\n  &:focus,\r\n  &:focus-visible {\r\n    outline: none;\r\n    background-color: config(\"color.gray.200\");\r\n  }\r\n}\r\n.resizer {\r\n  background: #efefef;\r\n  bottom: 0;\r\n  top: 0;\r\n  cursor: col-resize;\r\n  display: block;\r\n  font-size: 1rem;\r\n  inset-inline-start: -12px;\r\n  line-height: 100vh;\r\n  opacity: 0;\r\n  padding: 0 3px;\r\n  position: absolute;\r\n  z-index: 1234;\r\n  transition: all .3s ease;\r\n  -webkit-transition: all .3s ease;\r\n  -o-transition: all .3s ease;\r\n}\r\n.modal-sizable {\r\n  max-width: 100% !important;\r\n\r\n  .modal-content {\r\n    &:hover {\r\n      .resizer {\r\n        opacity: 1;\r\n        -webkit-transition: all .3s ease;\r\n        -o-transition: all .3s ease;\r\n        transition: all .3s ease;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.modal-align-left {\r\n    .resizer {\r\n      inset-inline-start: auto;\r\n      inset-inline-end: -12px;\r\n    }\r\n  }\r\n}\r\n.modal-header-buttons {\r\n  gap: 8px !important;\r\n\r\n  .ok-btn {\r\n    margin-inline-end: 11px;\r\n  }\r\n}\r\n// Custom drawers\r\n.visualize-data .drawer-container {\r\n  min-width: 40vw;\r\n}\r\n\r\n// Modals\r\n.modal-header {\r\n  border: none;\r\n\r\n  .modal-title {\r\n      gap: 0 0.5rem;\r\n      \r\n      .page-name-bar {\r\n          &.json-schema-editor-page {\r\n              margin: 0;\r\n              flex: auto;\r\n              \r\n              .col-md-6 {\r\n                  &:first-child {\r\n                      &:empty {\r\n                          display: none;\r\n\r\n                          & + .col-md-6 {\r\n                              margin-inline-start: auto;\r\n                              padding-inline-end: 0;\r\n                          }\r\n                      }\r\n                  }\r\n              }\r\n          }\r\n      }\r\n  }\r\n}\r\n.modal-body {\r\n  .page-name-bar {\r\n      position: sticky;\r\n      top: 0;\r\n      z-index: 99;\r\n      background-color: $white;\r\n      padding-bottom: 16px;\r\n      box-shadow: 0 -16px 0 $white, 0px 0px 20px rgba(0, 0, 0, 0.05);\r\n\r\n      &.json-schema-editor-page {\r\n          margin-top: 0;\r\n          \r\n          > .col-md-6 {\r\n              &:first-child {\r\n                  &:empty {\r\n                      display: none;\r\n\r\n                      & + .col-md-6 {\r\n                          width: 100%;\r\n                          flex: 0 0 auto;\r\n                          max-width: 100%;\r\n                      }\r\n                  }\r\n              }\r\n          }\r\n      }\r\n  }\r\n  &.new-language-modal-body {\r\n      overflow-y: visible;\r\n      overflow-x: clip;\r\n  }\r\n}\r\n.modal-footer {\r\n  border: none;\r\n  border-radius: 0 0 6px 6px;\r\n  background: config(\"color.basic.white\");\r\n}\r\n.modal-warning-red {\r\n  max-width: 500px;\r\n\r\n  .danger-text {\r\n      color: config(\"color.error.500\");\r\n  }\r\n}","/* Base\n   ========================================================================== */\n@import \"base\";\n@import \"typography\";","/*Base Styles*/\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  font: {\n    family: $font-family-base;\n    size: $font-size-base;\n    weight: $font-weight-base;\n  }\n  color: $body-color;\n  background-color: $body-bg;\n  height: 100%;\n  overflow: hidden;\n  \n  &::-webkit-scrollbar-thumb {\n    background-color: config(\"color.gray.400\");\n  }\n}\n\nbody.ios-mobile-view-height {\n  height: auto !important;\n  overflow: visible !important;\n}\n\n#nprogress .bar {\n  z-index: 5000 !important;\n  background: $success !important;\n}\n\n#nprogress .peg {\n  @include box-shadow(0 0 10px $success, 0 0 5px $success !important);\n}\n\n#nprogress .spinner {\n  z-index: 5000 !important;\n}\n\n#nprogress .spinner-icon {\n  border-top-color: $success !important;\n  border-inline-start-color: $success !important;\n}\n\n.ripple-effect {\n  @extend %ripple-effect;\n}\n\n.text-transform-none {\n  text-transform: none;\n}\n\n.br-break {\n  word-break: break-all !important;\n}\n\n.font-weight-semibold {\n  font-weight: 500 !important;\n}\n\n.z-index-20 {\n  z-index: 20;\n}\n\n.size-120 {\n  @extend %size-120;\n}\n\n.size-100 {\n  @extend %size-100;\n}\n\n.size-80 {\n  @extend %size-80;\n}\n\n.size-60 {\n  @extend %size-60;\n}\n\n.size-50 {\n  @extend %size-50;\n}\n\n.size-40 {\n  @extend %size-40;\n}\n\n.size-30 {\n  @extend %size-30;\n}\n\n.size-20 {\n  @extend %size-20;\n}\n\n.border-bottom {\n  border-bottom: solid 1px $gray-300;\n}\n\n.col-with-divider div[class*=\"col-\"] {\n  border-inline-start: solid 1px $gray-300;\n  &:first-child {\n    border: 0 none;\n  }\n}\n\n.height-100 {\n  height: 100px !important;\n}\n\n.height-150 {\n  height: 150px !important;\n}\n\n.height-130 {\n  height: 130px !important;\n}\n\n.height-200 {\n  height: 200px !important;\n}\n\n.max-width-100 {\n  max-width: 100px !important;\n}\n\n.max-height-120 {\n  max-height: 120px !important;\n}\n\n.right-arrow {\n  display: inline-block;\n  color: $app-primary;\n  text-transform: capitalize;\n  &:after {\n    content: \"\\f30f\";\n    font-family: \"Material-Design-Iconic-Font\";\n    color: $app-primary;\n    margin-inline-start: 8px;\n    font-size: 20px;\n    vertical-align: middle;\n  }\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n}\n\n.letter-spacing-base {\n  letter-spacing: $letter-spacing-base;\n}\n\n.letter-spacing-lg {\n  letter-spacing: $letter-spacing-lg;\n}\n\n.letter-spacing-xl {\n  letter-spacing: $letter-spacing-xl;\n}\n\n.blue-text {\n  color: #5b98d5;\n}\n.page-heading {\n  margin-bottom: $jr-card-margin + 4px;\n\n  .title {\n    text-transform: capitalize;\n    font-weight: 500;\n\n    span {\n      display: flex;\n      align-items: center;\n\n      span + span {\n        &.badge {\n          margin: 0 1rem;\n        }\n      }\n      > button {\n        &:not(.btn-success) {\n          margin-bottom: 0;\n          width: 30px;\n          padding: 0;\n          height: 30px;\n          margin-inline-start:1rem;\n          border-radius: 25px;\n\n          &:hover {\n            background: white;\n            border: solid 1px #e0e3e7;\n          }\n        }\n      }\n      .dropdown {\n        button {\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .breadcrumb {\n    padding: 0;\n    background-color: transparent;\n    margin-bottom: 0;\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 18px;\n  }\n}\n\n.sub-heading {\n  font-size: $font-size-base;\n  color: $gray-500;\n  margin-bottom: 0;\n  &:not(:last-child) {\n    margin-bottom: 16px !important;\n  }\n}\n\n.manage-margin {\n  margin-bottom: 0;\n  & > * {\n    margin-bottom: 6px;\n    &:not(:last-child) {\n      margin-inline-end: 16px;\n    }\n  }\n}\n\n//Shadow\n.no-shadow {\n  @include box-shadow(none !important);\n}\n\n.shadow-sm {\n  @include box-shadow($shadow-sm);\n}\n\n.shadow {\n  @include box-shadow($shadow);\n}\n\n.shadow-lg {\n  @include box-shadow($shadow-lg);\n}\n\n.shadow-xl {\n  @include box-shadow($shadow-xl);\n}\n\n.avatar-shadow {\n  @include box-shadow($avatar-shadow);\n}\n\n.remove-table-border {\n  td, th {\n    border: 0 none;\n  }\n}\n\n//Media Object list\n.media-list {\n  margin-bottom: 10px;\n  &:not(:last-child) {\n    border-bottom: solid 1px $gray-200;\n    padding-bottom: 15px;\n    margin-bottom: 20px;\n    position: relative;\n  }\n}\n\n.border-2 {\n  border: 2px solid $gray-400 !important;\n}\n\n.border-w2 {\n  border-width: 2px;\n}\n\n// Border Color Classes\n\n@each $color_name, $color in $colors_palette {\n  @each $color_type, $color_value in $color {\n    @if $color_type == \"base\" {\n      .border-#{$color_name} {\n        border-color: $color_value !important;\n      }\n    }\n  }\n}\n\n//Center Crop image\n\n.center-crop-img {\n  position: relative;\n  width: 100%;\n  min-height: 120px;\n  overflow: hidden;\n\n  & img {\n    position: absolute;\n   inset-inline-start:50%;\n    top: 50%;\n    height: 100%;\n    width: auto;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n  }\n\n  & img.portrait {\n    width: 100%;\n    height: auto;\n  }\n}\n\n//Bootstrap Components Override\n\n//Buttons\n\na.btn-info {\n  @extend %link-hover;\n}\n\na.btn-danger {\n  @extend %link-hover;\n}\n\na.btn-warning {\n  @extend %link-hover;\n}\n\na.btn-success {\n  @extend %link-hover;\n}\n\na.btn-dark {\n  @extend %link-hover;\n}\n\n//Badges\na.badge-success {\n  @extend %link-hover;\n}\n\na.badge-danger {\n  @extend %link-hover;\n}\n\na.badge-warning {\n  @extend %link-hover;\n}\n\na.badge-info {\n  @extend %link-hover;\n}\n\na.badge-dark {\n  @extend %link-hover;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.icon-btn {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  width: 48px;\n  justify-content: center;\n  font-size: 20px;\n  cursor: pointer;\n  color: $gray-600;\n\n  .header-notifications & {\n    padding: 0 4px;\n  }\n}\n\n.avatar {\n  width: 60px;\n  height: 60px;\n  text-align: center;\n  line-height: 60px;\n  color: #fafafa;\n}\n\n.avatar-lg {\n  width: 80px;\n  height: 80px;\n  line-height: 80px;\n  text-align: center;\n  color: #fafafa;\n}\n\n.avatar-sm {\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  color: #fafafa;\n}\n.animated {\n  -webkit-animation-fill-mode: none !important;\n  animation-fill-mode: none !important\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.icons-showcase > div {\n  cursor: pointer;\n  padding: 7px 15px;\n  @include border-radius($border-radius);\n  overflow: hidden;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-decoration {\n  text-decoration: none !important;\n}\n\n.row-5 {\n  margin-inline-start: -5px;\n  margin-inline-end: -5px;\n\n  & > [class*='col-'] {\n    padding-inline-start: 5px;\n    padding-inline-end: 5px;\n  }\n}\n\n.font-size-16 {\n  font-size: 16px !important;\n}","/*Typography Styles*/\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-weight: $headings-font-weight;\n  margin: 0 0 $headings-margin-bottom;\n  color: $headings-color;\n}\n\nh1, .h1 {\n  font-size: $h1-font-size;\n}\n\nh2, .h2 {\n  font-size: $h2-font-size;\n}\n\nh3, .h3 {\n  font-size: $h3-font-size;\n}\n\nh4, .h4 {\n  font-size: $h4-font-size;\n}\n\nh5, .h5 {\n  font-size: $h5-font-size;\n}\n\nh6, .h6 {\n  font-size: $h6-font-size;\n}\n\n.text-strikethrough {\n  text-decoration: line-through !important;\n}\n\n@media screen and (max-width: 991px) {\n  h1, .h1 {\n    font-size: $h2-font-size;\n  }\n\n  h2, .h2 {\n    font-size: $h3-font-size;\n  }\n\n  h3, .h3 {\n    font-size: $h4-font-size;\n  }\n}\n\n.desc-list {\n  margin-bottom: 0;\n  li {\n    padding: $jr-card-padding;\n    border-bottom: 1px solid $gray-400;\n    margin-inline-start: -$jr-card-margin + 4px;\n    margin-inline-end: -$jr-card-margin + 4px;\n\n    &:last-child {\n      border-bottom: 0 none;\n    }\n\n    & .card-title {\n      margin-bottom: 6px;\n    }\n\n  }\n\n  &.even-odd {\n    li {\n      border-bottom: 0 none;\n\n      &:nth-child(2n) {\n        background-color: $gray-300;\n      }\n    }\n  }\n}","/* Layouts\n   ========================================================================== */\n@import \"app-layout\";\n@import \"sidebar\";\n@import \"header\";\n@import \"navbar\";\n@import \"main-content\";\n@import \"footer\";\n@import \"right-sidebar\";","/*App Layout Styles*/\r\n:root {\r\n  --permissions-resources-column-width: 368px;\r\n}\r\n\r\n#app-site,\r\n.app-main {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.app-container {\r\n  @include display-flex(flex, row, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.app-sidebar {\r\n  /*@include display-flex(flex, column, nowrap);\r\n  width: $side-nav-width;\r\n  min-width: $side-nav-width;\r\n  max-width: $side-nav-width;*/\r\n}\r\n\r\n.app-main-container {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.app-header {\r\n  min-height: $app-bar-height;\r\n  z-index: 99;\r\n  position: relative;\r\n}\r\n\r\n.instance-logo-container {\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n  .instance-logo {\r\n    max-height: 48px;\r\n    max-width: 200px;\r\n  }\r\n  .default-instance-logo {\r\n    font-size: 2rem;\r\n    color: #9cbdce;\r\n  }\r\n  .config-instance-logo {\r\n    padding: 5px;\r\n    color: #666666;\r\n    opacity: 0;\r\n    transition-duration: 0.2s;\r\n    cursor: pointer;\r\n    border-radius: 20px;\r\n    background-color: white;\r\n\r\n    &:hover {\r\n      color: #9cbdce;\r\n      opacity: 1;\r\n    }\r\n  }\r\n  .remove-instance-logo {\r\n    color: #f44336;\r\n    padding: 5px 7px;\r\n    border-radius: 20px;\r\n    background-color: white;\r\n    transition-duration: 0.2s;\r\n    cursor: pointer;\r\n    display: none;\r\n  }\r\n  &:hover {\r\n    .config-instance-logo {\r\n      opacity: 0.5;\r\n\r\n      &:hover {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n  &.has-logo {\r\n    .config-instance-logo {\r\n     inset-inline-end:9px;\r\n    }\r\n    .remove-instance-logo {\r\n      display: inline-block;\r\n      opacity: 0;\r\n    }\r\n    &:hover {\r\n      .remove-instance-logo {\r\n        opacity: 0.5;\r\n\r\n        &:hover {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.app-main-content-wrapper {\r\n  flex: 1;\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: config(\"color.gray.400\");\r\n  }\r\n}\r\n\r\n.app-container {\r\n  &.fixed-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n  }\r\n\r\n  &.collapsible-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    & .app-main-container {\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  &.mini-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    .app-sidebar {\r\n      width: $mini-drawer-width;\r\n      min-width: $mini-drawer-width;\r\n      max-width: $mini-drawer-width;\r\n    }\r\n  }\r\n}\r\n\r\n.d-grid {\r\n  display: grid;\r\n}\r\n.v-align-middle {\r\n  vertical-align: middle !important;\r\n}\r\n.hide-button-overflow {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n.mt-04 {\r\n  margin-top: 0.4rem;\r\n}\r\n.white-border {\r\n  border-color: white;\r\n}\r\n.flex-auto {\r\n  flex: auto;\r\n}\r\n.tableshadow {\r\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);\r\n}\r\n.tableoptions--closed {\r\n  .ReactTable.limited-height .rt-table {\r\n    max-height: 70vh;\r\n  }\r\n}\r\n.dropdown-columns {\r\n  .dropdown-menu {\r\n    &.show {\r\n      transition-duration: 0.2s;\r\n      width: auto;\r\n      display: grid;\r\n      padding: 10px;\r\n      grid-template-columns: repeat(4, 1fr);\r\n\r\n      .dropdown-item {\r\n        &.column-type-object {\r\n          background-color: #f4f4f4;\r\n\r\n          span {\r\n            font-weight: 700;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.dropdown-filters {\r\n  &.show {\r\n    .dropdown-menu {\r\n      &.show {\r\n        transition-duration: 0.2s;\r\n        width: max-content;\r\n        overflow: visible;\r\n        margin-top: 2px;\r\n        border-radius: 4px;\r\n      }\r\n    }\r\n\r\n    & + .dropdown-columns {\r\n      .dropdown-menu {\r\n        &.show {\r\n          inset-inline-start: 224px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* User roles rights management */\r\n.user-roles-rights-management {\r\n  padding-inline-start: 0 !important;\r\n  padding-top: 0 !important;\r\n  height: 100%;\r\n\r\n  .dashboard {\r\n    height: 100%;\r\n  }\r\n  .rights-management-container {\r\n    height: 100%;\r\n  }\r\n  :where(.users-roles-part, .permissions-part) {\r\n    padding-top: 36px;\r\n  }\r\n  .users-roles-part {\r\n    flex: 0 0 320px;\r\n    max-width: 320px;\r\n    min-width: 320px;\r\n    background: white;\r\n    box-shadow: config(\"shadow.light.200\");\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: calc(100vh - 100px);\r\n    position: sticky;\r\n    top: 0;\r\n\r\n    .tabs-container {\r\n      padding-inline-start: 32px;\r\n      padding-inline-end: 32px;\r\n      display: flex;\r\n\r\n      .tab-link {\r\n        flex: auto;\r\n        border-bottom: solid 2px transparent;\r\n        @include FontStyle(\"label.14\", \"medium\");\r\n        color: config(\"color.gray.500\");\r\n        padding-bottom: 12px;\r\n        text-align: center;\r\n        text-decoration: none;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        &:where(:hover, .active) {\r\n          color: config(\"color.basic.black\");\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n          border-bottom: solid 2px config(\"color.primary.400\");\r\n        }\r\n      }\r\n    }\r\n    .users-roles-search {\r\n      padding-inline-start: 32px;\r\n      padding-inline-end: 32px;\r\n      padding-bottom: 16px;\r\n      display: flex;\r\n      align-items: center;\r\n      position: relative;\r\n\r\n      &.cas-search-active {\r\n        .import-users-btn {\r\n          background-color: config(\"color.primary.500\");\r\n          color: config(\"color.basic.white\");\r\n        }\r\n      }\r\n    }\r\n    .users-roles-list {\r\n      overflow-y: auto;\r\n      padding-inline: 32px;\r\n\r\n      p.auth-name {\r\n        padding: 3px 40px;\r\n        display: block;\r\n        width: 100%;\r\n        text-align: left;\r\n        font-size: 12px;\r\n        border: none;\r\n        margin: 0;\r\n        font-style: italic;\r\n        color: #909090;\r\n      }\r\n    }\r\n  }\r\n  .permissions-table {\r\n    :is(.filters-columns, .permissions-columns .permission-row) {\r\n      --percent: calc((100% - var(--permissions-resources-column-width) - 130px) * 0.1);\r\n      display: grid;\r\n      grid-template-columns: 368px 130px repeat(4, 1fr) repeat(2, 1.5fr);\r\n\r\n      > div {\r\n        &:nth-child(7) {\r\n          padding-inline-start: 53px;\r\n        }\r\n        &:nth-child(8) {\r\n          padding-inline-start: 27px;\r\n        }\r\n      }\r\n    }\r\n    .filters-columns {\r\n      > div {\r\n        display: flex;\r\n        align-items: center;\r\n        padding-top: 10px;\r\n        padding-bottom: 10px;\r\n        overflow: hidden;\r\n        align-items: flex-end;\r\n\r\n        > span {\r\n          text-overflow: ellipsis;\r\n          overflow: hidden;\r\n          margin-bottom: 8px;\r\n        }\r\n        &.permissions-item-filter {\r\n          overflow: initial;\r\n        }\r\n      }\r\n    }\r\n    .permissions-columns {\r\n      padding-bottom: 20px;\r\n    }\r\n    .permission-row {\r\n      margin-top: 0px;\r\n      text-align: start;\r\n      \r\n      > div {\r\n        padding-block: 6px;\r\n        background-color: var(--group-row-bg);\r\n      }\r\n      &:hover {\r\n        > div {\r\n          background-color: var(--group-row-bg);\r\n        }\r\n      }\r\n      &.group-row {\r\n        margin-top: 16px;\r\n        margin-bottom: 4px;\r\n        position: sticky;\r\n        top: 56px;\r\n        z-index: 9;\r\n\r\n        > div {\r\n          background-color: var(--group-row-bg);\r\n        }\r\n      }\r\n      &.database-row {\r\n        margin-top: 2px;\r\n      }\r\n      .permission-group-name {\r\n        color: config(\"color.basic.black\");\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n        display: flex;\r\n        gap: 10px;\r\n        padding-inline-end: 16px;\r\n        padding-top: 6px;\r\n        align-items: baseline;\r\n      }\r\n      .permission-db-name {\r\n        color: config(\"color.basic.black\");\r\n        @include FontStyle(\"label.14\", \"medium\");\r\n        display: flex;\r\n        min-height: 40px;\r\n        align-items: center;\r\n      }\r\n      .permission-status {\r\n        i {\r\n          display: flex;\r\n          height: 30px;\r\n          align-items: center;\r\n          cursor: pointer;\r\n          font-size: 28px;\r\n          transition-duration: 0.2s;\r\n\r\n          &.on {\r\n            &.yellow {\r\n              --toggle-icon-color: hsla(48, 96%, 53%, 1);\r\n            }\r\n          }\r\n          &:hover {\r\n            opacity: 0.7;\r\n          }\r\n        }\r\n        .loader {\r\n          width: 30px;\r\n          margin-inline-start:0;\r\n        }\r\n      }\r\n      .db-records {\r\n        display: flex;\r\n        border: none;\r\n        color: config(\"color.gray.500\");\r\n        border-bottom: solid 1px config(\"color.gray.600\");\r\n        text-transform: uppercase;\r\n        @include FontStyle(\"label.12\", \"medium\");\r\n        align-items: center;\r\n        transition-duration: 0.2s;\r\n        padding: 0;\r\n        cursor: pointer;\r\n\r\n        &:hover,\r\n        &.active {\r\n          color: config(\"color.gray.700\");\r\n          border-bottom: solid 1px config(\"color.gray.800\");\r\n        }\r\n      }\r\n    }\r\n    .all-rows {\r\n      margin-bottom: 16px;\r\n\r\n      .permission-row {\r\n        > div {\r\n          padding-bottom: 6px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .tabbed-permissions {\r\n    .tab-content {\r\n      padding-top: 24px;\r\n    }\r\n  }\r\n  .permission-db-name-col {\r\n    padding-inline-start: 16px;\r\n    margin-inline-end: 16px;\r\n  }\r\n  :where(.permission-filter-element-column, .permissions-item-filter, .permission-filter-column-heading) {\r\n    background-color: config(\"color.gray.100\");\r\n  }\r\n  .permissions-item-filter {\r\n    padding-inline: 16px;\r\n    margin-inline-end: 16px;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n\r\n    select {\r\n      min-width: 10px !important;\r\n    }\r\n    & + div {\r\n      margin-inline-start: 16px;\r\n      padding-inline-start: 16px;\r\n    }\r\n  }\r\n  .permission-filter-column-heading {\r\n    color: config(\"color.basic.black\");\r\n    @include FontStyle(\"label.14\", \"medium\");\r\n  }\r\n  .permission-element {\r\n    margin-inline-start: 16px;\r\n    padding-inline-start: 16px;\r\n    color: config(\"color.basic.black\");\r\n    @include FontStyle(\"label.14\", \"regular\");\r\n\r\n    span {\r\n      display: flex;\r\n      height: 40px;\r\n      align-items: center;\r\n    }\r\n  }\r\n  .user-role-list-item {\r\n    padding: 8px 16px;\r\n    list-style: none;\r\n    border-radius: config(\"layout.cornerRadius.small\");\r\n    cursor: pointer;\r\n    @include FontStyle(\"label.14\", \"regular\");\r\n\r\n    &:where(.active, :hover) {\r\n      background-color: config(\"color.primary.100\");\r\n\r\n      .user-full-name {\r\n        color: var(--system-primary-color, #002b8f);\r\n      }\r\n      .user-username {\r\n        color: config(\"color.primary.400\");\r\n      }\r\n    }\r\n  }\r\n  :where(.user-full-name, .user-username) {\r\n    display: block;\r\n  }\r\n  .user-full-name {\r\n    color: config(\"color.basic.black\");\r\n  }\r\n  .user-username {\r\n    color: config(\"color.gray.400\");\r\n    @include FontStyle(\"body.12\", \"regular\");\r\n  }\r\n  .roles-rights-management-container {\r\n    border-radius: config(\"layout.cornerRadius.medium\");\r\n    background-color: config(\"color.basic.white\");\r\n  }\r\n  .role-users-management-table {\r\n    width: 100%;\r\n  \r\n    .toggler-column {\r\n      width: 32px;\r\n\r\n      .toggle-icon {\r\n        --fa-display: flex;\r\n      }\r\n    }\r\n    td {\r\n      border-bottom: solid 4px config(\"color.gray.50\");\r\n      padding: 16px;\r\n      vertical-align: middle;\r\n      @include FontStyle(\"label.14\", \"regular\");\r\n      color: config(\"color.basic.black\");\r\n    }\r\n    tr {\r\n      &:last-child {\r\n        td {\r\n          border-bottom: none;\r\n        }\r\n      }\r\n    }\r\n    .user-full-name {\r\n      @include FontStyle(\"label.14\", \"medium\");\r\n      color: config(\"color.basic.black\");\r\n    }\r\n    .user-username {\r\n      @include FontStyle(\"label.12\", \"regular\");\r\n      color: config(\"color.gray.500\");\r\n    }\r\n  }\r\n}\r\n.permissions-part {\r\n  padding-inline-start: 40px;\r\n  flex: auto;\r\n  --group-row-bg: #{config(\"color.basic.white\")};\r\n  --permissions-blue-color: #5b98d5;\r\n  --permissions-left-shadow: -2px 0px 1px rgba(0, 0, 0, 0.07);\r\n  --permissions-left-last-shadow: -2px 2px 4px rgba(0, 0, 0, 0.07);\r\n  --permissions-right-shadow: 2px 0px 1px rgba(0, 0, 0, 0.07);\r\n  --permissions-right-last-shadow: 2px 2px 4px rgba(0, 0, 0, 0.07);\r\n  --permissinos-allrows-inset-shadow: inset 0 -16px 0 white;\r\n\r\n  &.tabbed-permissions {\r\n    .page-name-section {\r\n      align-items: center;\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n.permissions-tabs {\r\n  ul {\r\n    list-style: none;\r\n    display: flex;\r\n    margin-bottom: 0px;\r\n    height: 100%;\r\n    align-items: center;\r\n    padding-inline-start: 0;\r\n    width: var(--permissions-resources-column-width);\r\n\r\n    li {\r\n      @include FontStyle(\"label.14\", \"medium\");\r\n      color: config(\"color.gray.500\");\r\n      padding-block: 12px;\r\n      cursor: pointer;\r\n      text-decoration: none;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      flex: 1;\r\n\r\n      &:where(:hover, .active) {\r\n        color: config(\"color.basic.black\");\r\n        @include FontStyle(\"label.14\", \"semibold\");\r\n        border-bottom: solid 2px config(\"color.primary.400\");\r\n      }\r\n    }\r\n  }\r\n}\r\n.permissions-sections-headers {\r\n  display: grid;\r\n  grid-template-columns: 368px 1fr;\r\n}\r\n.permission-sections-header-column,\r\n.rights-management-roles-table thead th {\r\n  color: config(\"color.basic.black\");\r\n  @include FontStyle(\"label.14\", \"semibold\");\r\n  padding-block: 10px;\r\n  background-color: config(\"color.gray.100\");\r\n}\r\n.rights-management-roles-table thead th {\r\n  padding-inline: 16px;\r\n\r\n  &:first-child {\r\n    border-top-left-radius: config(\"layout.cornerRadius.medium\");\r\n  }\r\n  &:last-child {\r\n    border-top-right-radius: config(\"layout.cornerRadius.medium\");\r\n  }\r\n}\r\n.rights-management-roles-table tbody td {\r\n  padding: 10px 16px;\r\n  background-color: config(\"color.basic.white\");\r\n\r\n  i {\r\n    display: flex;\r\n    height: 30px;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    font-size: 28px;\r\n    transition-duration: 0.2s;\r\n  }\r\n}\r\n.permission-sections-header-column {\r\n  border-bottom: solid 1px config(\"color.gray.50\");\r\n  padding-inline-start: 16px;\r\n  margin-inline-end: 16px;\r\n  border-radius: config(\"layout.cornerRadius.medium\") config(\"layout.cornerRadius.medium\") 0 0;\r\n  text-align: start;\r\n  overflow: hidden;\r\n\r\n  &:last-child {\r\n    margin-inline-start: 16px;\r\n    margin-inline-end: 0px;\r\n  }\r\n  > span {\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    display: block;\r\n  }\r\n}\r\n.records-fields-drawer {\r\n  .modal-title {\r\n    justify-content: flex-start;\r\n  }\r\n  & + .modal-body {\r\n    .records-fields-section-title {\r\n      i {\r\n        &:hover {\r\n          color: #999999;\r\n        }\r\n      }\r\n      .add-record-filter {\r\n        color: #5b98d5;\r\n\r\n        &:hover {\r\n          color: #0b65bf;\r\n        }\r\n      }\r\n    }\r\n    .records-filters-permission-table {\r\n      :where(.permission-table-header, .permission-table-row) {\r\n        grid-template-columns: var(--record-field-column, 50%) repeat(4, 1fr);\r\n        grid-gap: 10px;\r\n        padding-inline: 16px;\r\n        padding-block: 10px;\r\n      }\r\n      .permission-table-header {\r\n        background-color: config(\"color.gray.100\");\r\n\r\n        > div {\r\n          display: flex;\r\n          align-items: center;\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n          color: config(\"color.basic.black\");\r\n        }\r\n      }\r\n      .permission-table-body {\r\n        .permission-table-row {\r\n          border-top: solid 1px #f3f3f3;\r\n\r\n          &:first-of-type {\r\n            border-top: none;\r\n          }\r\n          &:hover {\r\n            background-color: #FAFAFA;\r\n          }\r\n          > div {\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            &.permission-status {\r\n              i {\r\n                display: flex;\r\n                height: 30px;\r\n                align-items: center;\r\n                cursor: pointer;\r\n                font-size: 28px;\r\n                transition-duration: 0.2s;\r\n                \r\n                &:hover {\r\n                  opacity: 0.7;\r\n                }\r\n              }\r\n              .loader {\r\n                width: 30px;\r\n                margin-inline-start:0;\r\n              }\r\n            }\r\n            &.permission-field-name {\r\n              @include FontStyle(\"label.14\", \"semibold\");\r\n              color: config(\"color.basic.black\");\r\n            }\r\n          }\r\n          .data-filter-table {\r\n            table-layout: fixed;\r\n            margin: 0;\r\n            \r\n            tr {\r\n              td {\r\n                select,\r\n                input {\r\n                  width: 100%;\r\n                  min-width: auto;\r\n                }\r\n                &:first-of-type {\r\n                  padding-inline-start: 0;\r\n                }\r\n              }\r\n              &:first-of-type {\r\n                td {\r\n                  &:first-of-type {\r\n                    padding-inline-end: 0;\r\n                  }\r\n                }\r\n                &:last-of-type {\r\n                  td {\r\n                    &:first-of-type {\r\n                      & + td {\r\n                        padding-inline-start: 0;\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n            & ~ button {\r\n              margin-bottom: 0;\r\n              font-size: 12px;\r\n              padding: 0 16px;\r\n              margin-inline-end:5px;\r\n              margin-top: 5px;\r\n\r\n              &.btn-outline-default {\r\n                background: #efefef;\r\n              }\r\n            }\r\n          }\r\n          .record-filter-read-mode {\r\n            display: flex;\r\n            align-items: center;\r\n            width: 100%;\r\n\r\n            .remove-icon {\r\n              color: rgb(251, 69, 80);\r\n            }\r\n            .remove-icon,\r\n            .edit-icon {\r\n              padding: 5px;\r\n              opacity: 0.8;\r\n\r\n              &:hover {\r\n                opacity: 1;\r\n              }\r\n            }\r\n            span.badge {\r\n              margin-bottom: 0;\r\n            }\r\n            > div {\r\n              > span {\r\n                > span:not(.badge) {\r\n                  text-transform: lowercase;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &:has(.record-filter-edit-mode) {\r\n        :is(.permission-table-header, .permission-table-row) {\r\n          --record-field-column: 70%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.db-name-container {\r\n  color: config(\"color.basic.black\");\r\n  text-align: start;\r\n}","/*Sidebar Styles*/\n\n.side-nav {\n  width: 100%;  // fill the DrawerModal so content tracks its (resizable) width\n  background-color: $sidebar-bg !important;\n  color: $sidebar-text-color !important;\n  border-inline-end: solid 1px $gray-200 !important;\n  z-index: 1250 !important;\n\n  & .user-profile {\n    background-color: $sidebar-bg-darken;\n    padding: 13px 20px !important;\n  }\n\n  & .user-avatar {\n    margin: 0 !important;\n    margin-inline-end: 15px !important;\n    height: 44px !important;\n    width: 44px !important;\n    line-height: 44px;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $sidebar-hover-color;\n      cursor: pointer;\n      font-size: $font-size-base;\n      font-weight: 400;\n      white-space: nowrap;\n    }\n  }\n}\n\n.user-detail {\n  & .user-name {\n    cursor: pointer;\n  }\n}\n\n/*Navbar Styles*/\nul.nav-menu {\n  position: relative;\n  font-size: $font-size-base;\n  list-style: outside none none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nul.nav-menu li {\n  position: relative;\n  /*margin-bottom: 1px;*/\n}\n\nul.nav-menu li.menu {\n  & + .nav-header {\n    margin-top: 40px;\n  }\n  & .sub-menu {\n    display: none;\n  }\n  &.open > .sub-menu {\n    display: block;\n  }\n\n  &.open {\n    & .menu.active > .sub-menu {\n      display: block;\n    }\n  }\n  > a[role=\"button\"] {\n    text-transform: none;\n  }\n}\n\nul.nav-menu li a {\n  color: $sidebar-text-color;\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n  text-decoration: none;\n  @include border-radius(0);\n\n  & .badge {\n    margin-bottom: 0;\n    padding: 3px 8px 2px;\n  }\n}\n\nul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-color;\n    padding: 4px 22px;\n    font-size: 11px;\n    text-transform: uppercase;\n\n    &:first-child {\n      margin-top: 30px;\n    }\n  }\n}\n\nul.nav-menu li.menu > a:hover:before {\n  color: $sidebar-hover-color;\n}\n\nul.nav-menu li ul {\n  list-style: outside none none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n}\n\nul.nav-menu li ul.sub-menu li > a {\n  padding-block: 7px;\n  padding-inline-end: 20px;\n  padding-inline-start: 30px;\n}\n\nul.nav-menu li ul.sub-menu > li > ul > li > a {\n  padding-inline-start: 76px;\n}\n\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {\n  padding-inline-start: 96px;\n}\n\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {\n  padding-inline-start: 116px;\n}\n\nul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  padding: 3px 7px;\n  margin-inline-start:-7px;\n  //background-color: $sidebar-hover-color;\n  color: $sidebar-hover-color;\n  @include border-radius($border-radius);\n  display: inline-block;\n}\n\nul.nav-menu li.menu .sub-menu li > a:hover,\nul.nav-menu li.menu.open .sub-menu li > a.active:before,\nul.nav-menu li.menu .sub-menu li > a:hover:before {\n  color: $sidebar-hover-color;\n}\n\n.app-container.mini-drawer {\n  & .side-nav {\n    @include transition($transition-base);\n    width: $mini-drawer-width;\n\n    & .nav-menu li span.nav-text,\n    & .customizer {\n      display: none;\n    }\n\n    & .user-profile .user-detail {\n      display: none !important;\n    }\n\n    & .nav-menu .menu.open > .sub-menu {\n      display: none !important;\n    }\n\n    & .nav-menu li {\n      text-align: center;\n      i {\n        margin-inline-end:0;\n      }\n\n      &.nav-header {\n        padding: 4px 5px;\n      }\n    }\n\n    & ul.nav-menu > li > a {\n      &:before {\n        display: none;\n      }\n    }\n\n    & .mini-logo-img-hover {\n      display: none;\n    }\n  }\n}\n\n.app-container.mini-drawer {\n  & .side-nav:hover {\n    width: $side-nav-width;\n\n    & .nav-menu li span.nav-text {\n      display: inline-block !important;\n    }\n\n    & .user-profile .user-detail {\n      display: flex !important;\n    }\n\n    & .nav-menu .menu.open > .sub-menu {\n      display: block !important;\n    }\n\n    & .customizer {\n      display: flex !important;\n    }\n\n    & ul.nav-menu {\n      & li {\n        text-align: left;\n        & i {\n          margin-inline-end:16px;\n        }\n\n        &.nav-header {\n          padding: 4px 22px;\n        }\n      }\n\n      & ul.sub-menu li a {\n        padding-block: 7px;\n        padding-inline-end: 20px;\n        padding-inline-start: 56px;\n      }\n\n      & ul.sub-menu > li > ul > li > a {\n        padding-inline-start: 76px;\n      }\n\n      & ul.sub-menu > li > ul > li > ul > li > a {\n        padding-inline-start: 96px;\n      }\n\n      & ul.sub-menu > li > ul > li > ul > li > ul > li > a {\n        padding-inline-start: 116px;\n      }\n    }\n\n    & ul.nav-menu > li > a {\n      &:before {\n        display: block;\n      }\n    }\n\n    & .mini-logo-img {\n      display: none;\n    }\n\n    & .mini-logo-img-hover {\n      display: block;\n    }\n  }\n}\n\n.customizer {\n  padding: 20px 35px;\n  & img {\n    padding: 5px;\n    cursor: pointer;\n  }\n}\n\n.user-info {\n  & ul {\n    & li {\n      font-size: 15px;\n    }\n  }\n}\n\n.rc-drawer {\n  &-left &-sidebar,\n  &-right &-sidebar {\n    height: 100vh;\n  }\n}\n\n.rc-drawer-sidebar {\n  position: fixed;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n\n  .rc-drawer.rc-drawer-left & {\n   inset-inline-start:0;\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n    z-index: 903;\n  }\n\n  .rc-drawer.rc-drawer-right & {\n   inset-inline-end:0;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    z-index: 903;\n  }\n\n  .rc-drawer.rc-drawer-top & {\n    z-index: 903;\n  }\n\n  .rc-drawer.rc-drawer-bottom & {\n    z-index: 903;\n  }\n  .sidebar-draggable-area {\n    > div {\n      ul {\n        &.nav-menu {\n          li {\n            &.menu {\n              &[style^=\"position: fixed\"] {\n                & ~ li {\n                  &.menu {\n                    &:not(.no-arrow) {\n                      & + li {\n                        &.menu {\n                          &.no-arrow {\n                            margin-top: 100%;\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n                &:not(.no-arrow) {\n                  & + li {\n                    &.menu {\n                      &.no-arrow {\n                        margin-top: 100%;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.drawer-container {\n  position: relative;\n  & .main {\n    position: relative;\n    padding: 10px;\n    box-sizing: border-box;\n  }\n}\n\n.rc-drawer-overlay {\n  z-index: 902;\n  position: fixed;\n  top: 0;\n inset-inline-start:0;\n inset-inline-end:0;\n  bottom: 0;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease-out;\n  background-color: rgba(0, 0, 0, 0.3);\n  height: 100vh;\n  min-width: 100% !important;\n}\n\n.app-sidebar {\n  > .rc-drawer-sidebar {\n    overflow-x: hidden;\n  }\n  &.rc-drawer.rc-drawer-docked {\n    position: relative;\n  }\n  ul.nav-menu {\n    li.menu {\n      a {\n        span.nav-text {\n          span.db-code {\n            font-weight: 700;\n            color: #777777;\n            text-transform: uppercase;\n            font-size: 82%;\n          }\n        }\n        .fa-star {\n          opacity: 0;\n          transition-duration: 0.2s;\n        }\n        &:hover .fa-star {\n          opacity: 1;\n          transition-duration: 0.2s;\n        }\n        &[role=\"button\"] {\n          .group-config-icon {\n            margin-inline-start:-27px;\n            opacity: 0;\n            transition-duration: 0.2s;\n          }\n          &:hover {\n            .group-config-icon {\n              margin-inline-start:0;\n              opacity: 1;\n            }\n          }\n          .group-diagram-icon {\n            margin-inline-start:-27px;\n            opacity: 0;\n            transition-duration: 0.2s;\n          }\n          &:hover {\n            .group-diagram-icon {\n              margin-inline-start:0;\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n    &.action-buttons {\n      position: sticky;\n      bottom: 0;\n      display: flex;\n      flex-wrap: wrap;\n      margin-top: 1rem;\n      justify-content: space-between;  // spread icons across the (responsive) drawer width\n      height: auto;\n    }\n  }\n}","/*Header Styles*/\r\n.jr-menu-icon {\r\n  outline: none !important;\r\n  @include justify-content(flex-start !important);\r\n  @extend %size-30;\r\n  padding: 0 5px !important;\r\n  @extend %jr-menu-icon;\r\n  margin-inline-end: 15px;\r\n  display: flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  min-width: 24px;\r\n}\r\n\r\n.app-main-header {\r\n  background-color: $white;\r\n  color: $gray-default;\r\n  max-height: 70px;\r\n  position: relative;\r\n  border-bottom: none;\r\n\r\n  & .search-bar input {\r\n    @include transition($transition-base);\r\n    background-color: transparent;\r\n    color: $gray-default;\r\n    & + .search-icon {\r\n      top: 0;\r\n      & i {\r\n        color: rgba($gray-default, 0.8);\r\n      }\r\n    }\r\n\r\n    &:focus {\r\n      background-color: $body-bg;\r\n      color: $gray-default;\r\n      + .search-icon {\r\n        & i {\r\n          color: rgba($gray-default, 0.8);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    border-bottom: 1px solid $border-color;\r\n  }\r\n\r\n  .jr-card & {\r\n    border: 1px solid $gray-400;\r\n    @include border-radius($border-radius-lg);\r\n  }\r\n}\r\n\r\n.app-logo {\r\n  margin-inline-end: 12px;\r\n\r\n  & img {\r\n    height: 35px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      height: 28px;\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    margin-inline-end:20px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      margin-inline-end:auto;\r\n    }\r\n  }\r\n}\r\n\r\n//Logo disable condition\r\n.react-logo-white.d-block {\r\n  display: none !important;\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .react-logo-white.d-lg-block {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.sidebar-header {\r\n  min-height: 70px;\r\n  padding: 10px 22px;\r\n  border-bottom: 1px solid $border-color;\r\n}\r\n\r\n.app-toolbar {\r\n  min-height: $app-bar-height;\r\n  padding: 0 40px;\r\n\r\n  & .search-bar {\r\n    margin-inline-end:auto;\r\n    max-width: 320px;\r\n    width: 300px;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      width: 240px;\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 200px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      margin-inline-start:40px;\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0 20px;\r\n  }\r\n\r\n  .app-top-nav & {\r\n    min-height: 40px;\r\n  }\r\n}\r\n\r\n.app-header-horizontal {\r\n  & .app-toolbar .search-bar {\r\n    @media screen and (max-width: 1199px) {\r\n      margin-inline-end:10px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar-special {\r\n  & .search-bar {\r\n    width: 200px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      width: 280px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 200px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar {\r\n  & .nav-searchbox {\r\n    & .search-bar {\r\n      margin-inline-start:0;\r\n      width: 100%;\r\n    }\r\n\r\n    & .search-bar input {\r\n      @include transition($transition-base);\r\n      background-color: $white;\r\n      color: $body-color;\r\n      & + .search-icon {\r\n        & i {\r\n          color: rgba($body-color, 0.8);\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        background-color: transparent;\r\n        color: $body-color;\r\n        + .search-icon {\r\n          & i {\r\n            color: rgba($body-color, 0.8);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header-notifications {\r\n  margin-bottom: 0;\r\n\r\n  & li {\r\n    vertical-align: middle;\r\n\r\n    &.lang-nav {\r\n      .quick-menu {\r\n        display: flex;\r\n        \r\n        span {\r\n          font-size: 13px;\r\n          font-weight: 700;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .health-traffic-light {\r\n    span {\r\n      &.monitor-status {\r\n        border: solid 2px;\r\n        display: inline-flex;\r\n        width: 14px;\r\n        height: 14px;\r\n        border-radius: 8px;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .list-inline-item:not(:last-child) {\r\n    @media screen and (max-width: 449px) {\r\n      margin-inline-end:0;\r\n    }\r\n  }\r\n\r\n  .general-cog-icon {\r\n    color: #5b98d5;\r\n    font-size: 1.7rem;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      color: #1874d0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  @include box-shadow(none);\r\n}\r\n\r\n.quick-menu {\r\n\r\n  & .dropdown-menu {\r\n\r\n    & .jr-card-header {\r\n      margin: -5px -10px 5px;\r\n      padding: 10px;\r\n      padding-inline-start: 20px;\r\n      border-bottom: 1px solid $gray-300;\r\n      z-index: 10;\r\n    }\r\n\r\n    &:after {\r\n      border-inline-start: 5px solid transparent;\r\n      border-inline-end: 5px solid transparent;\r\n      border-bottom: 5px solid $white;\r\n      top: -9px;\r\n      content: \"\";\r\n      height: 9px;\r\n      position: absolute;\r\n     inset-inline-end:8px;\r\n      width: 10px;\r\n    }\r\n\r\n    &:before {\r\n      border-inline-start: 5px solid transparent;\r\n      border-inline-end: 5px solid transparent;\r\n      border-bottom: 5px solid $black;\r\n      top: -10px;\r\n      content: \"\";\r\n      height: 10px;\r\n      position: absolute;\r\n     inset-inline-end:8px;\r\n      width: 10px;\r\n    }\r\n\r\n    @media screen and (max-width: 449px) {\r\n      width: 230px;\r\n    }\r\n\r\n    @media screen and (max-width: 359px) {\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  & .messages-list .user-avatar {\r\n    position: relative;\r\n  }\r\n\r\n  & .messages-list .badge {\r\n    position: absolute;\r\n   inset-inline-start:-4px;\r\n    top: -4px;\r\n    height: 16px;\r\n    width: 16px;\r\n    line-height: 16px;\r\n    text-align: center;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-header .nav-searchbox.quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n   inset-inline-start:0 !important;\r\n   inset-inline-end:auto !important;\r\n  }\r\n\r\n  & .dropdown-menu:after {\r\n   inset-inline-end:auto;\r\n   inset-inline-start:8px;\r\n  }\r\n\r\n  & .dropdown-menu:before {\r\n   inset-inline-end:auto;\r\n   inset-inline-start:8px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 200px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 100px;\r\n  }\r\n}\r\n\r\n.language-list li {\r\n  display: block !important;\r\n}\r\n\r\n.messages-list.language-list ul li {\r\n  padding: 7px 6px 6px;\r\n}\r\n\r\n.messages-list ul li {\r\n  position: relative;\r\n  padding: 20px 10px 14px;\r\n  border-bottom: 1px solid $gray-300;\r\n\r\n  & .user-name a {\r\n    color: $app-primary;\r\n  }\r\n\r\n  & .sub-heading {\r\n    font-size: 11px;\r\n    margin-bottom: 6px !important;\r\n\r\n    &.mb-0 {\r\n      margin-bottom: 0 !important;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    border-bottom: 0 none;\r\n  }\r\n\r\n  & .jr-btn {\r\n    margin-inline-end:0 !important;\r\n  }\r\n\r\n  & .jr-btn-xs {\r\n    font-size: 11px !important;\r\n    padding: 5px !important;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .icon-btn {\r\n    color: $gray-default;\r\n  }\r\n\r\n  & .icon-alert {\r\n    position: relative;\r\n\r\n    &:after {\r\n      display: block;\r\n      position: absolute;\r\n      content: \"\";\r\n     inset-inline-end:0;\r\n      top: 0;\r\n      z-index: 10;\r\n      width: 8px;\r\n      height: 8px;\r\n      background-color: $danger;\r\n      @include border-radius(50%);\r\n      @extend %pulse-effect;\r\n    }\r\n  }\r\n\r\n  & i.animated.infinite {\r\n    -moz-animation-iteration-count: 25;\r\n    -webkit-animation-iteration-count: 25;\r\n    -o-animation-iteration-count: 25;\r\n    animation-iteration-count: 25;\r\n  }\r\n}\r\n\r\n.module-box-header-right {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.app-top-header {\r\n  position: relative;\r\n  z-index: 9999;\r\n}\r\n","/*Navbar Styles*/\n.app-main-menu {\n  & .navbar-nav {\n    @include display-flex();\n  }\n}\n\n.navbar-nav {\n  position: relative;\n\n  ul.sub-menu {\n    list-style: none;\n    border: solid 1px $gray-400;\n    position: absolute;\n    inset-inline-start:0;\n    top: 100px;\n    opacity: 0;\n    padding: 10px 0;\n    background-color: $white;\n    visibility: hidden;\n    @include border-radius(4px);\n    @include transition(all 0.5s ease-in-out);\n  }\n}\n\n.navbar-nav-mega {\n  position: static !important;\n}\n\n.app-top-nav {\n  background-color: $top-nav-bg;\n\n  & .navbar-nav {\n    & li.nav-item {\n      padding: 0 30px;\n    }\n\n    & li.nav-item > a {\n      color: $white;\n      padding: 13px 0;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary;\n    }\n\n    & ul.sub-menu {\n      margin-top: 0;\n    }\n  }\n}","/*Main Content Styles*/\r\n.app-main-content {\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.table-scrollbar {\r\n  min-height: 9px;\r\n\r\n  &[id*=\"Top\"] {\r\n    border-radius: 6px 6px 0 0;\r\n    display: none;\r\n\r\n    &::-webkit-scrollbar {\r\n      border-radius: 6px;\r\n      width: 9px;\r\n    }\r\n  }\r\n  &[id*=\"Bottom\"] {\r\n    border-radius: 0 0 6px 6px;\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background-color: config(\"color.gray.400\");\r\n    }\r\n  }\r\n  > div {\r\n    height: 8px;\r\n  }\r\n}\r\n.app-wrapper {\r\n  padding-block: 25px 30px;\r\n  padding-inline: 40px;\r\n  width: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding-inline: 20px;\r\n    padding-bottom: 20px;\r\n  }\r\n}","/*Footer Styles*/\r\n\r\n.app-footer {\r\n  padding: 0 40px;\r\n  color: $sidebar-text-color;\r\n  line-height: $footer-height;\r\n  min-height: $footer-height;\r\n  background-color: color(\"celia\", \"white\");\r\n  border-top: none;\r\n  font-size: 9px;\r\n\r\n  & a {\r\n    color: $sidebar-text-color;\r\n    &:hover {\r\n      color: $sidebar-hover-color;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n}","/*Right Sidebar Styles*/\n.color-theme {\n  @include display-flex(flex, column, nowrap);\n  max-width: 300px;\n  height: 100%;\n\n  @media screen and (max-width: 499px) {\n    max-width: 250px;\n  }\n}\n\n.color-theme-header {\n  background-color: $app-primary;\n  color: $white;\n  padding: 19px 25px 20px;\n  text-transform: uppercase;\n  @include display-flex();\n  @include align-items(center);\n  @include justify-content(space-between);\n\n  & .color-theme-title {\n    margin-bottom: 0;\n  }\n}\n\n.color-theme-body {\n  padding: 28px 25px;\n\n  & h3 {\n    margin-bottom: 20px;\n  }\n\n  @media screen and (max-width: 499px) {\n    padding: 25px 15px;\n  }\n}\n\n.color-option {\n  list-style: none;\n  padding-inline-start: 0;\n  margin: 0 -7px 10px;\n\n  & li {\n    position: relative;\n    display: inline-block;\n    padding: 0 7px;\n    margin-bottom: 10px;\n  }\n\n  & li a {\n    height: 45px;\n    width: 45px;\n    line-height: 45px;\n    display: inline-block;\n    color: transparent !important;\n    position: relative;\n\n    &:before {\n      content: \"\\f26b\";\n      font-family: \"Material-Design-Iconic-Font\";\n      font-size: 20px;\n      height: 45px;\n      width: 45px;\n      line-height: 45px;\n      position: absolute;\n      top: 0;\n     inset-inline-start:0;\n      color: $white;\n      text-align: center;\n      display: none;\n      z-index: 2;\n    }\n  }\n\n  & li a.active {\n    &:before {\n      display: block;\n    }\n  }\n}\n\n.cr-op-dark-sidebar {\n  & li a {\n    &:after {\n      content: '';\n      position: absolute;\n     inset-inline-start:0;\n      top: 0;\n      bottom: 0;\n      z-index: 1;\n      background-color: $body-color;\n      width: 8px;\n    }\n  }\n}\n\n//Coustomizer css\n.theme-option {\n  position: fixed;\n  top: 30%;\n inset-inline-end:0;\n  z-index: 1500;\n  background-color: map-get($purple, base);\n  @include border-left-radius($border-radius);\n  @include box-shadow(1px 1px 4px rgba($black, 0.5));\n  color: $white;\n\n  & span.icon-btn {\n    position: relative;\n    z-index: 1505;\n  }\n}\n\n.app-sidebar-content.right-sidebar .rc-drawer-sidebar {\n  z-index: 1506;\n  color: $body-color;\n  background-color: $white;\n}\n\n//Switch button\n.material-switch {\n  margin-bottom: 24px;\n\n  & > input[type=\"checkbox\"] {\n    display: none;\n  }\n\n  & > label {\n    cursor: pointer;\n    height: 0;\n    position: relative;\n    width: 40px;\n\n    &:before {\n      background: rgb(0, 0, 0);\n      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);\n      border-radius: 8px;\n      content: '';\n      height: 16px;\n      margin-top: -8px;\n      position: absolute;\n      opacity: 0.3;\n      transition: all 0.4s ease-in-out;\n      width: 40px;\n    }\n\n    &:after {\n      background: rgb(255, 255, 255);\n      border-radius: 16px;\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n      content: '';\n      height: 24px;\n     inset-inline-start:-4px;\n      margin-top: -8px;\n      position: absolute;\n      top: -4px;\n      transition: all 0.3s ease-in-out;\n      width: 24px;\n    }\n  }\n\n  & > input[type=\"checkbox\"]:checked + label::before {\n    background: $black;\n    opacity: 0.5;\n  }\n\n  & > input[type=\"checkbox\"]:checked + label::after {\n    background: $gray-700;\n   inset-inline-start:20px;\n  }\n}\n\n@media screen and (max-width: 499px) {\n  .color-theme .jr-btn {\n    padding: 10px 15px !important;\n  }\n}\n","/* UI Components\n   ========================================================================== */\n@import \"alert\";\n@import \"avatar\";\n@import \"badges\";\n@import \"blockquotes\";\n@import \"bottom-navigation\";\n@import \"breadcrumb\";\n@import \"button\";\n@import \"button-group\";\n@import \"callout\";\n@import \"card\";\n@import \"charts\";\n@import \"chip\";\n@import \"carousel\";\n@import \"color-picker\";\n@import \"drawer\";\n@import \"e-commerce\";\n@import \"grid-list\";\n@import \"icons\";\n@import \"label\";\n@import \"list\";\n@import \"nav\";\n@import \"pricing-tables\";\n@import \"progressbar\";\n@import \"popover\";\n@import \"react-joyride\";\n@import \"tables\";\n@import \"tabs\";\n@import \"testimonial\";\n@import \"timeline\";\n@import \"tour\";\n@import \"form\";\n@import \"ad-form\";\n@import \"input\";","/*Alert Styles*/\n.alert {\n  border: 0 none;\n  padding: 20px 24px;\n  @include border-radius($border-radius-lg);\n  position: relative;\n\n  & .close {\n    line-height: inherit;\n    font-weight: $font-weight-light;\n  }\n\n  & .alert-addon {\n    width: $size-60;\n    background-color: rgba($black, 0.2);\n    @include display-flex(flex, column, nowrap);\n    @include justify-content(center);\n    @include align-items(center);\n    position: absolute;\n   inset-inline-start:0;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n  }\n}\n\n.alert-dismissible {\n  padding-inline-end: $size-60;\n}\n\n.alert-addon-card {\n  padding-inline-start: $size-80;\n}","/*Avatar Styles*/\n.user-avatar {\n  @extend %size-50;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex-wrap: nowrap;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  position: relative;\n  overflow: hidden;\n  @include justify-content(center);\n  @include align-items(center);\n  -webkit-flex-shrink: 0;\n  flex-shrink: 0;\n  @include border-radius(50%);\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  border: $jr-border;\n\n  &.avatar-shadow {\n    border: 0 none;\n  }\n}\n\n.user-profile {\n  @include display-flex();\n  @include align-items(flex-start);\n\n  & .user-detail {\n    -webkit-flex: 1;\n    flex: 1;\n    -ms-flex-align: center;\n    -webkit-align-self: center;\n    align-self: center;\n  }\n}\n\n.user-detail {\n  & .user-name {\n    margin-bottom: 2px;\n    font-weight: 400;\n    text-transform: capitalize;\n  }\n  & .user-description {\n    font-size: 12px;\n    margin-bottom: 0;\n    color: $gray-500;\n  }\n}\n\n.user-thumb {\n  position: relative;\n\n  .messages-list & {\n    margin-inline-end:8px;\n  }\n}\n","/*Badges Styles*/\n.badge {\n  font-weight: 400;\n  padding: 3px 8px;\n  line-height: inherit;\n  margin-bottom: 6px;\n  @include border-radius($border-radius-sm);\n\n  &:not(:last-child) {\n    margin-inline-end: 15px;\n  }\n\n  table & {\n    margin-bottom: 0;\n  }\n}\n\n.badge-pill {\n  @include border-radius(20px);\n}\n\n.badge-border {\n  border: 2px solid !important;\n}\n\n.badge-outline {\n  background-color: transparent;\n  border: $jr-border;\n}","/*Blockquotes Styles*/\nblockquote {\n  padding-block: 10px;\n  padding-inline-end: 0;\n  padding-inline-start: 20px;\n  font-size: $font-size-base !important;\n\n  .blockquote-footer {\n    font-size: $font-size-base !important;\n  }\n}\n\n.blockquote {\n  border-inline-start: 5px solid $gray-200;\n}\n\n.blockquote-reverse {\n  border-inline-start: 0 none;\n  border-inline-end: 5px solid $gray-200;\n  text-align: right;\n  padding-inline-start: 0;\n  padding-inline-end: 20px;\n}","/*Bottom Navigation Styles*/\n.bottom-navigation {\n  button {\n    min-width: 10px !important;\n  }\n}","/*Breadcrumb Styles*/\n.breadcrumb {\n  @include border-radius($border-radius-sm);\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  content: '\\F2FB';\n  font: {\n    family: 'Material-Design-Iconic-Font';\n    size: 16px;\n  }\n  line-height: 1;\n  vertical-align: middle;\n}","/*Button Styles*/\n\n.jr-btn {\n  position: relative;\n  display: inline-block;\n  font-size: $btn-font-size;\n  font-weight: $btn-font-weight;\n  text-transform: capitalize;\n  line-height: $btn-line-height;\n  @include border-radius($border-radius);\n  vertical-align: top;\n  cursor: pointer;\n  text-align: center;\n\n  &:hover,\n  &:focus,\n  &:active {\n    outline: 0 none;\n    text-decoration: none;\n    @include box-shadow(none !important);\n  }\n\n  .login-content & {\n    padding: 10px 35px;\n  }\n}\n\n\n\n.jr-btn,\n.jr-fab-btn,\n.jr-flat-btn {\n  margin-bottom: 6px;\n  text-transform: capitalize;\n\n  &:not(:last-child) {\n    margin-inline-end: 15px;\n  }\n\n  .form-inline & {\n    margin-bottom: 0;\n    min-height: 35px;\n  }\n\n  .navbar & {\n    margin-bottom: 0;\n  }\n}\n\n\n\n.jr-fab-btn {\n  position: relative;\n  display: inline-flex;\n  @extend %size-50;\n  @include border-radius($border-radius-circle);\n  @include justify-content(center);\n  @include align-items(center);\n  background-color: map_get($gray, lighten-3);\n  overflow: hidden;\n\n  &:hover,\n  &:focus {\n    outline: 0 none;\n    text-decoration: none;\n  }\n}\n\n.jr-btn,\n.jr-flat-btn {\n  padding: $btn-padding;\n\n  & i + span,\n  & span + i {\n    margin-inline-start:6px;\n  }\n}\n\n.jr-flat-btn {\n  background-color: transparent;\n  color: $body-color;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4);\n    color: $body-color;\n  }\n}\n\n.jr-btn-group {\n  margin: 0 -8px;\n\n  &:not(:last-child) {\n    margin-bottom: 16px;\n  }\n\n  & .jr-btn,\n  & .jr-fab-btn {\n    margin: 0 8px 18px;\n  }\n}\n\n.jr-btn-rounded {\n  @include border-radius(50px !important);\n}\n\n.jr-btn-lg {\n  padding: $btn-padding-lg;\n}\n\n.jr-btn-sm {\n  padding: $btn-padding-sm;\n}\n\n.jr-btn-xs {\n  padding: $btn-padding-xs;\n}\n\n// Fab Button\n.jr-btn-fab-lg {\n  @extend %size-60;\n}\n\n.jr-btn-fab-sm {\n  @extend %size-40;\n}\n\n.jr-btn-fab-xs {\n  @extend %size-30;\n}\n\n.jr-btn-fab-lg,\n.jr-btn-lg {\n  font-size: $btn-font-size-lg;\n  & i {\n    font-size: ($btn-font-size-lg + 2px);\n  }\n}\n\n.jr-btn-fab-sm,\n.jr-btn-sm {\n  font-size: ($btn-font-size-sm - 2px);\n  & i {\n    font-size: ($btn-font-size-sm - 2px);\n  }\n}\n\n.jr-btn-fab-xs,\n.jr-btn-xs {\n  font-size: $btn-font-size-xs;\n  & i {\n    font-size: $btn-font-size-xs;\n  }\n}\n\n.complex-btn-wrapper {\n  @include display-flex(flex, row, wrap);\n  min-width: 200px;\n  width: 100%;\n}\n\n.complex-btn {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n  width: 33.333%;\n  border: 0 none;\n\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    height: 100px;\n  }\n  &:hover {\n    z-index: 1;\n    & .img-btn-overlay {\n      opacity: 0.15;\n    }\n\n    & .img-marked {\n      opacity: 0;\n    }\n\n    & .img-title {\n      border: 4px solid currentColor;\n    }\n  }\n\n  .img-btn {\n    position: absolute;\n   inset-inline-start:0;\n   inset-inline-end:0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    @include align-items(center);\n    @include justify-content(center);\n    color: $white;\n  }\n  .img-src {\n    position: absolute;\n   inset-inline-start:0;\n   inset-inline-end:0;\n    top: 0;\n    bottom: 0;\n    background-size: cover;\n    background-position: center 40%;\n  }\n\n  .img-btn-overlay {\n    position: absolute;\n   inset-inline-start:0;\n   inset-inline-end:0;\n    top: 0;\n    bottom: 0;\n    background: $black;\n    opacity: 0.4;\n    @include transition(all 0.5s $transition-ease);\n  }\n\n  .img-title {\n    position: relative;\n    padding: 16px 32px 14px;\n  }\n  .img-marked {\n    height: 3px;\n    width: 18px;\n    background: $white;\n    position: absolute;\n    bottom: -2px;\n   inset-inline-start:calc(50% - 9px);\n    @include transition(all 0.5s $transition-ease);\n  }\n}\n\n.btn-group-mins {\n  margin: 0 -5px;\n\n  & .btn,\n  & .jr-btn {\n    margin: 0 5px 5px;\n  }\n}\n\n//buttons in label\n\n.jr-btn.jr-btn-label i {\n  background-color: rgba($white, 0.2);\n  width: $size-40;\n  height: 100%;\n  line-height: 42px;\n  text-align: center;\n}\n\n.jr-btn.jr-btn-label.left i {\n  position: absolute;\n  top: 0;\n inset-inline-start:0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.jr-btn.jr-btn-label.right i {\n  position: absolute;\n  top: 0;\n inset-inline-end:0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.jr-btn.jr-btn-label.left i + span {\n  margin-inline-start:$size-30;\n}\n\n.jr-btn.jr-btn-label.right i + span {\n  margin-inline-end:$size-30;\n  margin-inline-start:0;\n}\n\n.jr-btn.jr-btn-label.jr-btn-lg i {\n  line-height: 54px;\n}\n\n.jr-btn.jr-btn-label.jr-btn-sm i {\n  line-height: 32px;\n}\n\n.jr-btn.jr-btn-label.jr-btn-xs i {\n  line-height: 24px;\n  width: $size-30;\n}\n\n//Button function\n@each $color_name, $color in $colors_palette {\n  @each $color_type, $color_value in $color {\n    @if $color_type == \"base\" {\n      .btn-#{$color_name} {\n        background-color: $color_value;\n        color: $white;\n        &:hover,\n        &:focus {\n          background-color: darken($color_value, 5%);\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\n.jr-btn-shadow {\n  @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\n  &:hover,\n  &:focus {\n    @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\n  }\n\n  &:active {\n    @include box-shadow(none !important);\n  }\n}\n\n.jr-btn.disabled,\n.jr-btn.disabled {\n  pointer-events: none;\n  opacity: 0.65;\n}\n\n.jr-btn-default {\n  background-color: $white;\n  color: $body-color;\n  border: 1px solid $gray-300;\n  &:hover,\n  &:focus {\n    background-color: darken($white, 5%);\n    color: $body-color;\n  }\n}\n\n.jr-btn-secondary {\n  background-color: $secondary;\n  color: $white;\n  &:hover,\n  &:focus {\n    background-color: darken($secondary, 5%);\n    color: $white;\n  }\n}\n\n.jr-flat-btn.jr-btn-primary {\n  background-color: transparent;\n  color: $app-primary;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary, 0.12);\n    color: $app-primary;\n  }\n}\n\n.bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent;\n    color: $white;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12);\n      color: $white;\n    }\n  }\n}\n\n.jr-flat-btn.jr-btn-secondary {\n  background-color: transparent;\n  color: $secondary;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary, 0.12);\n    color: $secondary;\n  }\n}\n\n.bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent;\n    color: $white;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12);\n      color: $white;\n    }\n  }\n}\n\n.jr-btn-hover:hover:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n inset-inline-start:0;\n inset-inline-end:0;\n  z-index: 1;\n  display: inline-block;\n  background-color: rgba($black, 0.06);\n}\n\n.dropdown-toggle-split {\n  padding-inline-end: 0.5625rem;\n  padding-inline-start: 0.5625rem;\n}\n\n.action-btn {\n  height: $size-40;\n  width: $size-40;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  @include align-items(center);\n  @include justify-content(center);\n  font-size: 24px;\n  cursor: pointer;\n  vertical-align: middle;\n  color: rgba($black, 0.54);\n\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n    color: rgba($black, 0.64);\n  }\n\n  .circle-check & {\n    height: 24px;\n    width: 24px;\n    font-size: 16px;\n  }\n\n  .chat-main-header & {\n    color: $white;\n  }\n}\n\n.action-replay .jr-btn-default {\n  font-size: 14px;\n  padding: 5px 10px;\n  border-color: $gray-600 !important;\n}\n\n\n.toggler-btn {\n  width: 29px;\n  height: 18px;\n  background-color: #D4D9DF;\n  border-radius: 18px;\n  display: inline-flex;\n  cursor: pointer;\n  align-items: center;\n\n  &::after {\n    display: block;\n    content: \"\";\n    width: 14px;\n    height: 14px;\n    background-color: #F4F4F4;\n    border-radius: 12px;\n    margin-inline-start:2px;\n    margin-inline-end:2px;\n    transition-duration: 0.2s;\n  }\n\n  &:not(.false) {\n    background-color: #99bbcd;\n\n    &::after {\n      margin-inline-start:13px;\n      background-color: white;\n    }\n  }\n\n  &:active,\n  &:focus {\n    &::after {\n      width: 17px;\n    }\n  }\n}\n\n.goback {\n  padding: 3px 5px !important;\n  overflow: hidden;\n  transition-duration: 0.2s;\n\n  span {\n    display: inline-block;\n    margin-inline-end:-40px;\n    font-weight: 700;\n    opacity: 0;\n    transition-duration: 0.2s;\n  }\n  &:hover {\n    padding: 3px 16px !important;\n    transition-duration: 0.2s;\n\n    span {\n      margin-inline-end:0;\n      opacity: 1;\n    }\n  }\n}\n\n.add-data-entry {\n  width: 26px;\n  height: 26px;\n  border-radius: 24px;\n  color: white;\n  cursor: pointer;\n\n  &:hover {\n    background-color: white;\n    color: #99bbcd;\n    border: none;\n  }\n}\n.group-delete-btn {\n  color: #EA3D2F;\n  font-size: 16px;\n  padding: 5px;\n  cursor: pointer;\n\n  &:hover {\n    color: #ba3023;\n  }\n}\n\n// New design (with design system)\n.system-button {\n  // Button styles overwrite\n  &:where(.btn, .btn-secondary) {\n    background-color: var(--button-bg-color) !important;\n    color: var(--button-text-color) !important;\n    padding-inline: var(--button-inline-padding) !important;\n    padding-block: 0 !important;\n    height: var(--button-height) !important;\n    border-radius: var(--button-border-radius) !important;\n    box-shadow: none !important;\n\n    span {\n      color: inherit !important;\n      font: inherit !important;\n    }\n    &:hover {\n      background-color: var(--button-bg-color);\n      color: var(--button-text-color);\n    }\n    &:not(:last-child) {\n      margin-inline-end: 0;\n    }\n    &:active {\n      box-shadow: none !important;\n      border-color: transparent !important;\n    }\n  }\n}\n.db-structure-button {\n  margin-inline-start: 20px;\n}\n.db-trash-button {\n  &:hover .button-icon {\n    color: #{config(\"color.error.500\")};\n  }\n}\n.btn-link {\n  cursor: pointer;\n}","/*Button Group Styles*/\n\n// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .jr-btn {\n    position: relative;\n    flex: 0 1 auto;\n    border-color: $border-color;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover {\n      z-index: 2;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 2;\n    }\n\n    &.active {\n      background-color: $app-primary;\n      color: $white;\n      border-color: $app-primary;\n    }\n\n    &.jr-flat-btn {\n      border-color: transparent;\n      &.active {\n        background-color: transparent;\n        color: $app-primary;\n\n        &:hover,\n        &:focus {\n          background-color: rgba($app-primary, 0.12);\n          color: $app-primary;\n        }\n      }\n    }\n  }\n\n\n  // Prevent double borders when buttons are next to each other\n  .jr-btn + .jr-btn,\n  .jr-btn + .btn-group,\n  .btn-group + .jr-btn,\n  .btn-group + .btn-group {\n    margin-inline-start:-$input-btn-border-width;\n  }\n}\n\n.btn-group,\n.btn-group-vertical {\n\n  &.no-border > .btn-group > .jr-btn,\n  &.no-border > .btn-group-vertical > .jr-btn,\n  &.no-border > .jr-btn {\n    border-color: transparent;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n\n// Set corners individual because sometimes a single button can be in a .btn-group\n// and we need :first-child and :last-child to both match\n.btn-group > .jr-btn:first-child {\n  margin-inline-start:0;\n\n  &:not(:last-child):not(.dropdown-toggle) {\n    @include border-right-radius(0);\n  }\n}\n\n// Need .dropdown-toggle since :last-child doesn't apply given a .dropdown-menu\n// immediately after it\n.btn-group > .jr-btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  @include border-left-radius(0);\n}\n\n// Custom edits for including btn-groups within btn-groups (useful for including\n// dropdown buttons within a btn-group)\n.btn-group > .btn-group {\n  float: inline-start;\n}\n\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\n  border-radius: 0;\n}\n\n.btn-group > .btn-group:first-child:not(:last-child) {\n  > .jr-btn:last-child,\n  > .dropdown-toggle {\n    @include border-right-radius(0);\n  }\n}\n\n.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\n  @include border-left-radius(0);\n}\n\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .jr-btn { @extend .jr-btn-sm; }\n.btn-group-lg > .jr-btn { @extend .jr-btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.jr-btn + .dropdown-toggle-split {\n  padding-inline-end: $input-btn-padding-x * .75;\n  padding-inline-start: $input-btn-padding-x * .75;\n\n  &::after {\n    margin-inline-start:0;\n  }\n}\n\n.jr-btn-sm + .dropdown-toggle-split {\n  padding-inline-end: $input-btn-padding-x-sm * .75;\n  padding-inline-start: $input-btn-padding-x-sm * .75;\n}\n\n.jr-btn-lg + .dropdown-toggle-split {\n  padding-inline-end: $input-btn-padding-x-lg * .75;\n  padding-inline-start: $input-btn-padding-x-lg * .75;\n}\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  .jr-btn,\n  .btn-group {\n    width: 100%;\n  }\n\n  > .jr-btn + .jr-btn,\n  > .jr-btn + .btn-group,\n  > .btn-group + .jr-btn,\n  > .btn-group + .btn-group {\n    margin-top: -$input-btn-border-width;\n    margin-inline-start:0;\n  }\n\n  > .jr-btn {\n    &:not(:first-child):not(:last-child) {\n      border-radius: 0;\n    }\n\n    &:first-child:not(:last-child) {\n      @include border-bottom-radius(0);\n    }\n\n    &:last-child:not(:first-child) {\n      @include border-top-radius(0);\n    }\n  }\n\n  > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\n    border-radius: 0;\n  }\n\n  > .btn-group:first-child:not(:last-child) {\n    > .jr-btn:last-child,\n    > .dropdown-toggle {\n      @include border-bottom-radius(0);\n    }\n  }\n\n  > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\n    @include border-top-radius(0);\n  }\n}\n\n\n\n[data-toggle=\"buttons\"] {\n  > .jr-btn,\n  > .btn-group > .jr-btn {\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0,0,0,0);\n      //pointer-events: none;\n    }\n  }\n}\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n\n  // Over Write To jr btn Margin\n  > .jr-btn,\n  > .btn {\n    margin-inline-end:0;\n    margin-bottom: 0;\n  }\n}\n","/*Callout Styles*/\n\n.grid-thumb-equal {\n  @extend %thumb-equal;\n\n  .card-image & {\n    padding-bottom: 82%;\n  }\n}\n\n.grid-thumb-cover {\n  @extend %thumb-cover;\n}\n\n.grid-thumb-cover img {\n  @extend %thumb-cover-img;\n}\n\n/*Product listing page style*/\n\n.product-row {\n  position: relative;\n  overflow: hidden;\n  @include display-flex();\n  @include align-items(center);\n  @include justify-content(center);\n  text-align: right;\n\n  &.even {\n    text-align: left;\n  }\n}\n\n.product-col {\n  order: 1;\n  width: 50%;\n}\n\n.odd .product-thumb {\n  order: 2;\n}\n\n.product-content {\n  padding: 20px 55px;\n}\n\n.product-row .grid-thumb-equal {\n  padding-bottom: 69%;\n}\n\n.product-thumb img {\n  width: 100%;\n}\n\n.product-content h4 {\n  margin-bottom: 25px;\n}\n\n@media screen and (max-width: 1230px) {\n  .product-row .grid-thumb-equal {\n    padding-bottom: 71%;\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .product-content h4 {\n    margin-bottom: 10px;\n  }\n  .product-content {\n    padding: 20px 35px;\n  }\n  .product-row .grid-thumb-equal {\n    padding-bottom: 85%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .grid-thumb-equal {\n    .card-image & {\n      padding-bottom: 120%;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .product-row {\n    @include display-flex(flex, column);\n    text-align: center;\n\n    &.even {\n      text-align: center;\n    }\n  }\n\n  .product-content {\n    padding: 20px 0;\n  }\n\n  .product-col,\n  .odd .product-thumb {\n    order: 1;\n    width: 100%;\n  }\n  .product-row .grid-thumb-equal {\n    padding-bottom: 44%;\n  }\n\n  .grid-thumb-equal {\n    .card-image & {\n      padding-bottom: 44%;\n    }\n  }\n}","/*Cards Styles*/\n.profile-intro {\n  background-color: $white;\n  @include border-radius($border-radius-lg);\n  overflow: hidden;\n\n  img.avatar-circle {\n    display: inline-block;\n    @extend %size-120;\n    @include border-radius(50%);\n    @include box-shadow($shadow);\n    position: relative;\n    margin: 0 auto;\n    -webkit-transform: translateY(50px);\n    -ms-transform: translateY(50px);\n    transform: translateY(50px);\n    @include transition(all 0.4s ease-in-out);\n    z-index: 1;\n  }\n\n  &:hover {\n    & .avatar-circle {\n      @include transition(border-radius 0.4s ease 0.1s);\n      @include border-radius(25%);\n    }\n  }\n}\n\n.profile-intro {\n  & .card-image {\n    position: relative;\n    width: 100%;\n    min-height: 100%;\n  }\n  & .pi-content {\n    padding: 70px 40px 24px;\n  }\n\n  & .pi-footer {\n    padding: 0 40px 24px;\n  }\n  & .icon {\n    display: inline-block;\n    @include transition(all 0.2s ease 0s);\n    color: theme-color(\"primary\");\n\n    &:hover,\n    &:focus,\n    &:active {\n      -webkit-transform: scale(1.2);\n      -ms-transform: scale(1.2);\n      transform: scale(1.2);\n    }\n  }\n\n  & .icon:not(:last-child) {\n    margin-inline-end:10px;\n  }\n}\n\n.layer {\n  &:before {\n    display: block;\n    content: \"\";\n    background-color: rgba($black, 0.3);\n    position: absolute;\n    top: 0;\n    bottom: 0;\n   inset-inline-start:0;\n   inset-inline-end:0;\n    height: 100%;\n    width: 100%;\n    z-index: 0;\n  }\n}\n\n.card.jr-card-full-height,\n.jr-card.jr-card-full-height {\n  height: calc(100% - #{$jr-card-margin});\n\n  @media screen and (max-width: 575px) {\n    height: auto;\n  }\n}\n\n.jr-card {\n  @extend %jr-card-style;\n\n  & > .jr-card-body:first-child {\n    margin-top: 6px;\n  }\n\n  &.p-0 > .jr-card-body:first-child {\n    margin-top: 0;\n  }\n\n  & .jr-card-thumb {\n    margin: -24px -30px 0;\n\n    & .card-img {\n      @include border-radius($border-radius-lg $border-radius-lg 0 0);\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 18px;\n  }\n}\n\n.jr-card-header {\n  margin-bottom: 24px;\n\n  .card-heading {\n    margin-bottom: (24px / 6);\n  }\n\n  & .badge {\n    margin-bottom: 0;\n\n    &:last-child {\n      margin-inline-start:10px;\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 18px;\n  }\n}\n\n.jr-entry-header {\n  margin-bottom: 24px;\n\n  .entry-heading {\n    margin-bottom: (24px / 6);\n  }\n\n  .entry-description {\n    margin-bottom: 0;\n    font-size: 13px;\n    color: $gray-600;\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 18px;\n  }\n}\n\n.card {\n  margin-bottom: $jr-card-margin;\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 18px;\n  }\n}\n\n.card-header {\n  font-size: 16px;\n\n  & .badge {\n    margin-bottom: 0;\n\n    &:last-child {\n      margin-inline-start:10px;\n    }\n  }\n}\n\n.card-title {\n  font-size: $h3-font-size;\n  text-transform: capitalize;\n}\n\n.card-subtitle {\n  font-size: 14px;\n  color: $gray-700;\n\n  &:not(:last-child) {\n    margin-bottom: $h3-font-size;\n  }\n}\n\n.card-mt-footer {\n  padding: 0 15px 20px;\n  margin-top: -10px;\n}\n\n.jr-card-social {\n  font-size: 22px;\n  padding-top: 26px;\n}\n\n.social-link {\n  list-style: none;\n  padding-inline-start: 0;\n  @include display-flex();\n  @include align-items(center);\n  margin: 0 -5px 10px;\n\n  & li {\n    padding: 0 5px;\n    margin-bottom: 5px;\n  }\n\n  & li a {\n    color: $body-color;\n  }\n\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary;\n  }\n\n  .jr-card-social & {\n    margin-bottom: 0;\n    @include justify-content(space-around);\n  }\n}\n\n.jr-cart-ab {\n  @include display-flex();\n  @include align-items(center);\n  @include justify-content(space-around);\n  position: absolute;\n inset-inline-start:0;\n  top: 0;\n inset-inline-end:0;\n  bottom: 0;\n  z-index: 1;\n  color: $white;\n  font-size: $h3-font-size;\n\n  & i {\n    vertical-align: middle;\n    font-size: 25px;\n  }\n}\n\n.img-overlay-card {\n  @include border-radius($border-radius-lg);\n  margin-bottom: $jr-card-margin;\n\n  @media screen and (max-width: 1199px) {\n    & .center-crop-img {\n      min-height: 135px;\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    & .center-crop-img {\n      min-height: 160px;\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 18px;\n  }\n}","/*Charts Styles*/\n\n.chart-header {\n  padding: 15px 18px;\n  & .card-title {\n    h4 {\n      color: $white;\n      margin-bottom: 4px;\n    }\n  }\n\n  & .title h4 {\n    margin-bottom: 4px;\n  }\n  & p {\n    margin-bottom: 4px;\n  }\n}","/*Chips Styles*/\n.chip-outline {\n  background-color: transparent !important;\n  border: 1px solid $gray-500 !important;\n}\n","/*Carousel Styles*/\n\n.carousel-caption {\n  & h3 {\n    font-size: $h2-font-size;\n  }\n}\n\n.carousel-control-prev {\n  @extend %pointer;\n}\n\n.carousel-control-next {\n  @extend %pointer;\n}\n","/*Color Picker Styles*/\n\n.cp-color {\n  width: 36px;\n  height: 14px;\n  border-radius: 2px;\n}\n\n.cp-swatch {\n  padding: 5px;\n  background: $white;\n  border-radius: 1px;\n  @include box-shadow(0 0 0 1px rgba($black, .1));\n  display: inline-block;\n  cursor: pointer;\n}\n\n.cp-popover {\n  position: absolute;\n  z-index: 2;\n}\n\n.cp-cover {\n  position: fixed;\n  top: 0;\n inset-inline-end:0;\n  bottom: 0;\n inset-inline-start:0;\n}\n\n.photoshop-picker,\n.swatches-picker,\n.alpha-picker,\n.hue-picker {\n  width: 100% !important;\n}\n\n.material-picker {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.rc-time-picker-input {\n  height: 31px !important;\n}\n\n.date-btn {\n  display: inline-block;\n  vertical-align: top;\n}","/*Drawer Styles*/\n\n.drawer {\n  width: 250px;\n}\n\n.full-drawer {\n  width: 100%;\n}","/*E-commerce Styles*/\n\n.product-item {\n  overflow: hidden;\n}\n\n.product-item-vertical {\n  @extend .product-item;\n\n  & .card-image .grid-thumb-equal {\n    padding-bottom: 110%;\n\n    @media screen and (max-width: 1199px) {\n      padding-bottom: 74%;\n    }\n\n    @media screen and (max-width: 991px) {\n      padding-bottom: 110%;\n    }\n\n    @media screen and (max-width: 829px) {\n      padding-bottom: 120%;\n    }\n\n    @media screen and (max-width: 767px) {\n      padding-bottom: 44%;\n    }\n  }\n}\n\n\n\n","/*Grids List Styles*/\n\n.gl-image,\n.gl-list,\n.gl-advanced,\n.gl-single-line {\n  @include display-flex();\n  @include justify-content(space-around);\n  overflow: hidden;\n}\n\n.gl {\n  max-width: 100%;\n  max-height: 360px;\n  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.\n  transform: translateZ(0);\n\n  &.row.no-gutters {\n    margin: 0 -2px;\n\n    & .col,\n    & > [class*=\"col-\"] {\n      padding-inline-end: 2px;\n      padding-inline-start: 2px;\n      margin-bottom: 4px;\n    }\n  }\n}\n\n.gl-single-line {\n  & .slg {\n    -ms-flex-wrap: nowrap;\n    -webkit-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n    max-width: 100%;\n  }\n}\n\n.title-gradient {\n  background: -webkit-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\n  background: -o-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\n  background: linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\n}\n\n.title-gradient-bottom {\n  background: -webkit-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\n  background: -o-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\n  background: linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\n}\n\n.g-title {\n inset-inline-start:0;\n inset-inline-end:0;\n  height: 48px;\n  display: flex;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.4);\n  align-items: center;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\n.grid {\n  height: 100%;\n  display: block;\n  position: relative;\n  overflow: hidden;\n\n  & > img {\n    top: 50%;\n   inset-inline-start:50%;\n    position: relative;\n    transform: translate(-50%, -50%);\n    display: flex;\n    padding: 0;\n    flex-wrap: wrap;\n  }\n}\n\n.g-ul {\n  display: flex;\n  padding: 0;\n  flex-wrap: wrap;\n  overflow-y: auto;\n  list-style: none;\n  -webkit-overflow-scrolling: touch;\n}\n\n.gradient-text {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 20px;\n  color: white;\n}\n\n.title-gradient-bottom {\n  padding: 20px;\n  bottom: 0;\n inset-inline-start:0;\n inset-inline-end:0;\n  height: 48px;\n  display: flex;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.4);\n  align-items: center;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\n  background: -o-linear-gradient(to top, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\n  background: linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\n}\n\n.title-gradient-top {\n  padding: 10px;\n  top: 0;\n inset-inline-start:0;\n inset-inline-end:0;\n  height: 48px;\n  display: flex;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.4);\n  align-items: center;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n\n  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\n  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\n  background: linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\n}\n\n.grid-thumb img {\n  max-height: 185px;\n}\n\n.gl-advanced-grid {\n  position: relative;\n}\n","/*Icons Styles*/\n\n.icon {\n  display: inline-block;\n  @extend %size-30;\n  text-align: center;\n}\n\n.icons-wrapper {\n  display: inline-block;\n  & + .icons-wrapper {\n    margin-inline-start:25px;\n  }\n}\n\n.icon-addon {\n  @extend %icon-addon;\n}","/*Label Styles*/\nlabel {\n  margin-bottom: 0;\n}\n","/*List Styles*/\n\n.pinned-list {\n  position: relative;\n  height: 370px;\n  overflow: auto;\n  width: auto;\n}\n\n.user-list {\n  width: 100%;\n  padding: 20px 15px 10px;\n\n  &.card {\n    padding-inline-start: 30px;\n\n    @media screen and (max-width: 575px) {\n      padding-inline-start: 15px;\n    }\n  }\n\n  & .user-avatar {\n    margin-inline-end:20px;\n    margin-bottom: 10px;\n    @extend %size-50;\n  }\n\n  & h3 {\n    font-weight: 700;\n    margin-bottom: 8px;\n  }\n\n  & a[class*=\"meta-\"] i {\n    margin-inline-end:6px;\n  }\n\n  & a[class*=\"meta-\"]:hover {\n    text-decoration: none;\n  }\n\n  & a[class*=\"meta-\"] {\n    display: inline-block;\n    color: $body-color;\n    font-size: $font-size-sm;\n    font-weight: 700;\n  }\n}\n\n.user-list {\n  & .img-section {\n    width: 230px;\n    @media screen and (max-width: 649px) {\n      width: 100%;\n    }\n  }\n\n  & .description {\n    width: calc(100% - 300px);\n    @media screen and (max-width: 649px) {\n      width: 100%;\n    }\n  }\n\n  & .jr-btn-list {\n    & li:not(:last-child) {\n      margin-inline-end:10px;\n    }\n\n    & .btn-light {\n      background-color: darken(map_get($gray, lighten-2), 5%);\n      border-color: darken(map_get($gray, lighten-2), 5%);\n      color: $body-color;\n      font-weight: 600;\n\n      &:hover,\n      &:focus,\n      &:active {\n        background-color: darken(map_get($gray, lighten-2), 10%);\n        border-color: darken(map_get($gray, lighten-2), 10%);\n      }\n    }\n\n    &.badge-list {\n      & li:not(:last-child) {\n        margin-inline-end:0;\n      }\n    }\n  }\n}\n\n.list-inline {\n  margin-inline-start:-5px;\n  margin-inline-end:-5px;\n  & li {\n    padding: 0 5px;\n    display: inline-block;\n\n    &.media {\n      display: flex;\n    }\n  }\n}\n\n.card-strip {\n  border-bottom: solid 1px $gray-300;\n  margin-bottom: 10px;\n}\n\n.jr-mbtn-list {\n  margin-inline-start:-20px;\n}\n\n.img-res {\n  max-width: 100%;\n  height: auto;\n}\n\n.publication-page {\n  height: 100%;\n  overflow-y: auto;\n\n  .item {\n    padding-block: 1.8rem;\n    border-bottom: solid 2px config(\"color.gray.100\");\n    text-align: start;\n    max-width: 760px;\n\n    .item-value-cell {\n      margin-top: 12px;\n      @include FontStyle(\"body.16\", \"normal\");\n      color: config(\"color.basic.black\");\n\n      &:nth-child(1) {\n        color: config(\"color.gray.400\");\n        @include FontStyle(\"label.12\", \"semibold\");\n        margin-top: 0px;\n      }\n      &:nth-child(2) {\n        @include FontStyle(\"title.22\", \"normal\");\n        color: config(\"color.basic.black\");\n        margin-top: 0px;\n      }\n      &:nth-child(3) {\n        @include FontStyle(\"label.10\", \"bold\");\n        background-color: config(\"color.gold.500\");\n        color: config(\"color.basic.white\");\n        margin-top: 10px;\n        display: inline-block;\n        padding: 4px 8px;\n        border-radius: 10px;\n        min-width: initial;\n      }\n      &:nth-child(4) {\n        @include FontStyle(\"body.16\", \"normal\");\n        color: config(\"color.basic.black\");\n        margin-top: 18px;\n      }\n      .system-button:has([class*=\"fa-file\"]) {\n        font-size: 20px;\n        min-width: auto;\n        height: auto;\n        color: #315a4e;\n\n        &:hover {\n          --button-bg-color: transparent;\n        }\n      }\n    }\n    &:first-child {\n      padding-block-start: 1rem;\n    }\n    &:last-child {\n      border-bottom: none;\n      padding-block-end: 0rem;\n    }\n  }\n  .pagination {\n    align-items: center;\n  }\n  .pagination-controls {\n    display: flex;\n  }\n  .page-summary {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n}","// Nav Style\n.nav-link {\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.card-header.bg-primary {\n  & .nav-link {\n    color: $white;\n\n    &.active,\n    &:hover,\n    &:focus {\n      color: $black;\n      background-color: $white;\n    }\n\n    &.disabled {\n      color: $gray-100;\n    }\n\n    &.disabled:hover {\n      color: $gray-900;\n    }\n  }\n}","/*Pricing Styles*/\n.pt-classic,\n.pt-default,\n.pt-dark,\n.pt-circle {\n\n  & .package {\n    position: relative;\n    padding: 0;\n    overflow: hidden;\n    @include border-radius(10px);\n    @include transition(all 0.5s ease-in-out);\n\n    &:hover,\n    &:focus,\n    &:active {\n      -webkit-transform: scale(1.05);\n      -ms-transform: scale(1.05);\n      transform: scale(1.05);\n    }\n    &.highlight {\n      -webkit-transform: scale(1.05);\n      -ms-transform: scale(1.05); // IE9 only\n      -o-transform: scale(1.05);\n      transform: scale(1.05);\n      z-index: 2;\n    }\n  }\n  & .package-header {\n    padding: 35px;\n    text-align: center;\n\n    & > .price {\n      display: inline-block;\n      font-size: 36px;\n      font-weight: 700;\n      margin-inline-start:0;\n      margin-bottom: 12px;\n      & > i {\n        display: inline-block;\n        margin-inline-end:6px;\n        font-weight: bold;\n      }\n    }\n\n    & h5 {\n      color: inherit;\n    }\n  }\n\n  & .package-items {\n    list-style: none;\n    font-size: 14px;\n    margin: 0;\n    padding: 50px 50px 120px;\n\n    & li {\n      margin-bottom: 16px;\n      @include clearfix();\n      line-height: inherit;\n      & i {\n        float: inline-start;\n        min-width: 20px;\n        margin-inline-end:16px;\n        line-height: inherit;\n      }\n\n      & span {\n        display: block;\n        overflow: hidden;\n      }\n    }\n  }\n\n  & .package-footer {\n    bottom: 0;\n   inset-inline-start:0;\n    position: absolute;\n   inset-inline-end:0;\n    padding: 40px 50px;\n    text-align: center;\n\n    & .btn {\n      color: inherit;\n      padding: 10px 30px;\n      border: 0 none;\n    }\n  }\n}\n\n.pt-classic .package {\n  border: 0 none;\n  @include border-radius(0);\n}\n\n.pt-dark {\n  & .package {\n    &:hover {\n      @include border-radius(20px);\n    }\n  }\n}\n\n.pt-circle {\n  & .package-header {\n    @include border-radius(50%);\n    height: 224px;\n    width: 224px;\n    margin: 40px auto 0;\n    @include align-items(center);\n\n    & .price {\n      margin-top: 30px;\n    }\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .pt-classic,\n  .pt-default,\n  .pt-dark,\n  .pt-circle {\n    & .package-header {\n      padding: 30px 20px;\n    }\n    & .package-items {\n      padding: 30px 20px 120px;\n    }\n  }\n\n  .pt-circle {\n    & .package-header {\n      height: 204px;\n      width: 204px;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .pt-classic,\n  .pt-default,\n  .pt-dark,\n  .pt-circle {\n    & .package {\n      &:hover,\n      &:focus,\n      &:active,\n      &.highlight {\n        -webkit-transform: scale(1);\n        -ms-transform: scale(1);\n        transform: scale(1);\n      }\n    }\n  }\n}\n","/*Progressbar Styles*/\n\n.pb-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.pb-btn-wrapper {\n  margin: 8px;\n  position: relative;\n  .btn-success {\n    background-color: map_get($green, base);\n    &:hover {\n      background-color: map_get($green, darken-2);\n    }\n  }\n}\n\n.fab-progress {\n  color: map_get($green, base);\n  position: absolute;\n  top: -6px;\n inset-inline-start:-6px;\n  z-index: 1;\n}\n\n.btn-progress {\n  color: map_get($green, base);\n  position: absolute;\n  top: 50%;\n inset-inline-start:50%;\n  margin-top: -12px;\n  margin-inline-start:-12px;\n}","/*Popover Styles*/\n.popover {\n  z-index: 1510;\n}\n\n.popover-header {\n  background-color: transparent;\n  border-bottom: 0 none;\n  color: $black;\n  font-size: $h2-font-size;\n  padding: 15px 20px 0;\n}\n\n.popover-body {\n  padding: 15px 20px;\n}\n\n\n","/*React Joyride Styles*/\n\n$joyride-color: #f04 !default;\n$joyride-zindex: 1500 !default;\n$joyride-overlay-color: rgba(#000, 0.5) !default;\n\n$joyride-beacon-color: $joyride-color !default;\n$joyride-beacon-size: 36px !default;\n\n$joyride-hole-border-radius: 4px !default;\n$joyride-hole-shadow: 0 0 15px rgba(#000, 0.5) !default;\n\n$joyride-tooltip-animation: joyride-tooltip 0.4s forwards;\n$joyride-tooltip-animation-timing: cubic-bezier(0, 1.05, 0.55, 1.18);\n\n$joyride-tooltip-arrow-size: 36px !default;\n$joyride-tooltip-bg-color: #fff !default;\n$joyride-tooltip-border-radius: 4px !default;\n$joyride-tooltip-color: #555 !default;\n$joyride-tooltip-font-size: 14px !default;\n$joyride-tooltip-padding: 20px !default;\n$joyride-tooltip-shadow: (x: 1px, y: 2px, blur: 3px, color: rgba(#000, 0.3)) !default;\n$joyride-tooltip-width: (290px, 360px, 450px) !default;\n\n$joyride-close: (color: rgba($joyride-tooltip-color, 0.5), size: 12px, top: 10px,inset-inline-end:10px) !default;\n$joyride-close-visible: true !default;\n$joyride-close-image: 'data:image/svg+xml,%3Csvg%20width%3D%22#{map-get($joyride-close, 'size')}%22%20height%3D%22#{map-get($joyride-close, 'size')}%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14.117.323l-6.073%206.075-5.449-6.075c-.431-.431-1.131-.431-1.562%200-.431.431-.431%201.131%200%201.562l5.449%206.075-6.159%206.159c-.431.431-.431%201.134%200%201.562.431.431%201.131.431%201.562%200l6.075-6.073%205.449%206.073c.429.431%201.131.431%201.56%200%20.431-.429.431-1.131%200-1.562l-5.452-6.073%206.159-6.161c.431-.431.431-1.131%200-1.562-.431-.431-1.129-.431-1.56%200z%22%20fill%3D%22#{map-get($joyride-close, 'color')}%22%2F%3E%3C%2Fsvg%3E';\n\n$joyride-header-color: $joyride-tooltip-color !default;\n$joyride-header-font-size: 16px !default;\n$joyride-header-border-color: $joyride-color !default;\n$joyride-header-border-width: 1px !default;\n\n$joyride-button-bg-color: $joyride-color !default;\n$joyride-button-color: #fff !default;\n$joyride-button-border-radius: 4px !default;\n\n$joyride-back-button-color: $joyride-color !default;\n$joyride-skip-button-color: #ccc !default;\n\n$joyride-tooltip-arrow-height: $joyride-tooltip-arrow-size / 2;\n$joyride-tooltip-arrow-scale: ($joyride-tooltip-arrow-size / ($joyride-tooltip-arrow-size * 0 + 1)) / 16; // strip-units crazy hack\n\n@function joyride-arrow($location: top, $bg-color: $joyride-tooltip-bg-color) {\n  $height: $joyride-tooltip-arrow-height;\n  $width: $joyride-tooltip-arrow-size;\n  $rotate: '0';\n  $arrow-color: $white;\n\n  @if $location == bottom {\n    $rotate: '180 8 4';\n  } @else if $location == left {\n    $height: $joyride-tooltip-arrow-size;\n    $width: $joyride-tooltip-arrow-height;\n    $rotate: '270 8 8';\n  } @else if $location == right {\n    $height: $joyride-tooltip-arrow-size;\n    $width: $joyride-tooltip-arrow-height;\n    $rotate: '90 4 4';\n  }\n\n  @return 'data:image/svg+xml,%3Csvg%20width%3D%22#{$width}%22%20height%3D%22#{$height}%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20points%3D%220%2C%200%208%2C%208%2016%2C0%22%20fill%3D%22#{$arrow-color}%22%20transform%3D%22scale%28#{$joyride-tooltip-arrow-scale}%29%20rotate%28#{$rotate}%29%22%3E%3C%2Fpolygon%3E%3C%2Fsvg%3E';\n}\n\n@mixin reset-button() {\n  //appearance: none;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1;\n  padding: 0;\n\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n}\n\n.joyride {\n  &-beacon {\n    @include reset-button();\n    height: $joyride-beacon-size;\n    position: relative;\n    width: $joyride-beacon-size;\n    z-index: $joyride-zindex;\n\n    &__inner {\n      animation: joyride-beacon-inner 1.2s infinite ease-in-out;\n      background-color: $joyride-beacon-color;\n      border-radius: 50%;\n      display: block;\n      height: 50%;\n     inset-inline-start:50%;\n      opacity: 0.7;\n      position: absolute;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 50%;\n    }\n\n    &__outer {\n      animation: joyride-beacon-outer 1.2s infinite ease-in-out;\n      background-color: rgba($joyride-beacon-color, 0.2);\n      border: ($joyride-beacon-size / 18) solid $joyride-beacon-color;\n      border-radius: 50%;\n      box-sizing: border-box;\n      display: block;\n      height: 100%;\n     inset-inline-start:0;\n      opacity: 0.9;\n      position: absolute;\n      top: 0;\n      transform: translateY(-50%);\n      transform-origin: center;\n      width: 100%;\n    }\n  }\n\n  &-overlay {\n    bottom: 0;\n   inset-inline-start:0;\n    position: absolute;\n   inset-inline-end:0;\n    top: 0;\n    z-index: $joyride-zindex;\n  }\n\n  &-hole {\n    border-radius: $joyride-hole-border-radius;\n    box-shadow: 0 0 0 9999px $joyride-overlay-color, $joyride-hole-shadow;\n    position: absolute;\n\n    &.safari {\n      box-shadow: 0 0 999px 9999px $joyride-overlay-color, $joyride-hole-shadow;\n    }\n  }\n\n  &-tooltip {\n    background-color: $joyride-tooltip-bg-color;\n    border-radius: $joyride-tooltip-border-radius;\n    color: $joyride-tooltip-color;\n    cursor: default;\n    filter: drop-shadow(#{-(map-get($joyride-tooltip-shadow, 'x'))} #{-(map-get($joyride-tooltip-shadow, 'y'))} #{map-get($joyride-tooltip-shadow, 'blur')} #{map-get($joyride-tooltip-shadow, 'color')}) drop-shadow(#{map-get($joyride-tooltip-shadow, 'x')} #{map-get($joyride-tooltip-shadow, 'y')} #{map-get($joyride-tooltip-shadow, 'blur')} #{map-get($joyride-tooltip-shadow, 'color')});\n    opacity: 0;\n    padding: $joyride-tooltip-padding;\n    //pointer-events: auto;\n    transform: translate3d(0, 0, 0);\n    width: nth($joyride-tooltip-width, 1);\n    z-index: $joyride-zindex + 10;\n\n    &--animate {\n      animation: $joyride-tooltip-animation;\n      animation-timing-function: $joyride-tooltip-animation-timing;\n    }\n\n    &__triangle {\n      background-repeat: no-repeat;\n      // overflow: hidden;\n      position: absolute;\n    }\n\n    &.bottom,\n    &.bottom-left,\n    &.bottom-right {\n      margin-top: $joyride-tooltip-arrow-height;\n\n      .joyride-tooltip__triangle {\n        background-image: url('#{joyride-arrow(bottom)}');\n        height: $joyride-tooltip-arrow-height;\n       inset-inline-start:50%;\n        top: -($joyride-tooltip-arrow-height - 2);\n        transform: translateX(-50%);\n        width: $joyride-tooltip-arrow-size;\n      }\n    }\n\n    &.top,\n    &.top-left,\n    &.top-right {\n      margin-bottom: $joyride-tooltip-arrow-height;\n\n      .joyride-tooltip__triangle {\n        background-image: url('#{joyride-arrow(top)}');\n        bottom: -($joyride-tooltip-arrow-height - 2);\n        height: $joyride-tooltip-arrow-height;\n       inset-inline-start:50%;\n        transform: translateX(-50%);\n        width: $joyride-tooltip-arrow-size;\n      }\n    }\n\n    &.bottom-left,\n    &.top-left {\n      .joyride-tooltip__triangle {\n       inset-inline-start:3%;\n        transform: translateX(0);\n\n        @media screen and (min-width: 480px) {\n         inset-inline-start:2%;\n        }\n      }\n    }\n\n    &.bottom-right,\n    &.top-right {\n      .joyride-tooltip__triangle {\n       inset-inline-start:auto;\n       inset-inline-end:3%;\n        transform: translateX(0);\n\n        @media screen and (min-width: 480px) {\n         inset-inline-end:2%;\n        }\n      }\n    }\n\n    &.left {\n      margin-inline-end:$joyride-tooltip-arrow-height;\n\n      .joyride-tooltip__triangle {\n        background-image: url('#{joyride-arrow(left)}');\n        height: $joyride-tooltip-arrow-size;\n       inset-inline-end:-($joyride-tooltip-arrow-height - 2);\n        width: $joyride-tooltip-arrow-height;\n      }\n    }\n\n    &.right {\n      margin-inline-start:$joyride-tooltip-arrow-height;\n\n      .joyride-tooltip__triangle {\n        background-image: url('#{joyride-arrow(right)}');\n        height: $joyride-tooltip-arrow-size;\n       inset-inline-start:-($joyride-tooltip-arrow-height - 2);\n        width: $joyride-tooltip-arrow-height;\n      }\n    }\n\n    &__close {\n      @include reset-button();\n      background-image: url($joyride-close-image);\n      background-repeat: no-repeat;\n      background-size: contain;\n      height: map-get($joyride-close, 'size');\n      position: absolute;\n     inset-inline-end:map-get($joyride-close, 'right');\n      text-decoration: none;\n      top: map-get($joyride-close, 'top');\n      width: map-get($joyride-close, 'size');\n      z-index: 10;\n\n      &:hover,\n      &:focus {\n        color: darken(map-get($joyride-close, 'color'), 10);\n        outline: none;\n      }\n\n      &--header {\n       inset-inline-end:$joyride-tooltip-padding;\n        top: $joyride-tooltip-padding;\n      }\n\n      @if $joyride-close-visible {\n        display: block;\n      } @else {\n        display: none;\n      }\n    }\n\n    &__header {\n      border-bottom: $joyride-header-border-width solid $joyride-header-border-color;\n      color: $joyride-header-color;\n      font-size: $joyride-header-font-size;\n      padding-bottom: 6px;\n      padding-inline-end: 18px;\n      position: relative;\n\n      ~ .joyride-tooltip__main {\n        padding: 12px 0 18px;\n      }\n    }\n\n    &__main {\n      font-size: $joyride-tooltip-font-size;\n      padding-bottom: 18px;\n      padding-inline-end: 18px;\n    }\n\n    &__footer {\n      text-align: right;\n    }\n\n    &__button {\n      @include reset-button();\n\n      &--primary {\n        background-color: $joyride-button-bg-color;\n        border-radius: $joyride-button-border-radius;\n        color: $joyride-button-color;\n        padding: 6px 12px;\n        transition: background-color 0.2s ease-in-out;\n\n        &:active,\n        &:focus,\n        &:hover {\n          background-color: lighten($joyride-button-bg-color, 6);\n          color: $joyride-button-color;\n        }\n      }\n\n      &--secondary {\n        color: $joyride-back-button-color;\n        margin-inline-end:10px;\n      }\n\n      &--skip {\n        color: $joyride-skip-button-color;\n        float: inline-start;\n        margin-inline-end:10px;\n      }\n    }\n\n    &--standalone {\n      .joyride-tooltip__main {\n        padding-bottom: 0;\n      }\n\n      .joyride-tooltip__footer {\n        display: none;\n      }\n    }\n\n    @media screen and (min-width: 480px) {\n      width: nth($joyride-tooltip-width, 2);\n    }\n\n    @media screen and (min-width: 960px) {\n      width: nth($joyride-tooltip-width, 3);\n    }\n  }\n}\n\n@keyframes joyride-tooltip {\n  0% {\n    transform: scale(0.1);\n  }\n\n  100% {\n    opacity: 1;\n    transform: perspective(1px) scale(1);\n  }\n}\n\n@keyframes joyride-beacon-inner {\n  20% {\n    opacity: 0.9;\n  }\n\n  90% {\n    opacity: 0.7;\n  }\n}\n\n@keyframes joyride-beacon-outer {\n  0% {\n    transform: scale(1);\n  }\n\n  45% {\n    opacity: 0.7;\n    transform: scale(0.75);\n  }\n\n  100% {\n    opacity: 0.9;\n    transform: scale(1);\n  }\n}\n","/*Tables Styles*/\r\n\r\n:root {\r\n  --table-heading-horizontal-border-style: solid;\r\n  --table-heading-horizontal-border-width: 1px;\r\n  --table-heading-horizontal-border-color: #{config(\"color.gray.50\")};\r\n}\r\n\r\n.table-header {\r\n  padding-inline-end: 2px !important;\r\n  min-height: 64px;\r\n  padding-inline-start: 24px;\r\n  align-items: center;\r\n\r\n  &.highlight-light {\r\n    color: map_get($gray, darken-2);\r\n    background-color: map_get($gray, lighten-2);\r\n  }\r\n  &.highlight-dark {\r\n    color: $white;\r\n    background-color: map_get($gray, darken-2);\r\n  }\r\n}\r\n\r\n.spacer {\r\n  @include flex(1, 1, 100%);\r\n}\r\n\r\n.actions {\r\n  color: map_get($red, base);\r\n}\r\n\r\n.title {\r\n  @include flex(0, 0, auto);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: rgba($app-primary, 0.075);\r\n}\r\n\r\n.table-material {\r\n  width: 100% !important;\r\n  max-width: 100% !important;\r\n  background-color: $table-bg !important; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding !important;\r\n    vertical-align: top !important;\r\n    border-top: $table-border-width solid $table-border-color !important;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom !important;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  .table-material {\r\n    background-color: $body-bg !important;\r\n  }\r\n}\r\n\r\n.d-flex-stretch {\r\n  @include align-items(stretch);\r\n  display: -webkit-flex;\r\n  display: -webkit-box;\r\n  display: -moz-flex;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.default-table {\r\n  margin-bottom: 0;\r\n  & thead th {\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    color: color(\"celia\", \"dark-text\");\r\n  }\r\n  & td {\r\n    vertical-align: middle;\r\n    padding: var(--block-padding, 0.7rem) var(--inline-padding, 0.3rem);\r\n  }\r\n}\r\n\r\n.table-unbordered {\r\n  & th,\r\n  & td {\r\n    border: 0 none !important;\r\n  }\r\n\r\n  & .th-border-b th {\r\n    border-bottom: 2px solid $gray-400 !important;\r\n  }\r\n}\r\n.json-data-view-array {\r\n  margin-bottom: 0px;\r\n}\r\n.table-responsive-material {\r\n  min-height: .01%;\r\n  overflow-x: auto;\r\n}\r\n\r\n\r\n.services-table-list {\r\n  .rt-table {\r\n    .rt-thead {\r\n      .rt-tr {\r\n        .rt-th:last-of-type {\r\n          flex: 10 0 auto !important;\r\n        }\r\n      }\r\n    }\r\n    .rt-tbody {\r\n      .rt-tr-group {\r\n        .rt-tr {\r\n          .rt-td:last-of-type {\r\n            flex: 10 0 auto !important;\r\n            padding: 0;\r\n\r\n            .row-actions-container {\r\n              overflow: hidden;\r\n              display: flex;\r\n              align-items: center;\r\n              justify-content: flex-end;\r\n              padding-inline-end: 10px;\r\n              height: 100%;\r\n\r\n              button {\r\n                transition-duration: 0.2s;\r\n                transition-delay: 0.1s;\r\n                position: relative;\r\n               inset-inline-end:-200px;\r\n                padding: 3px 7px;\r\n                margin-inline-end:0 !important;\r\n                display: inline-flex;\r\n                margin-inline-start:0;\r\n\r\n                &:nth-of-type(2) {\r\n                  transition-duration: 0.25s;\r\n                }\r\n                &:nth-of-type(3) {\r\n                  transition-duration: 0.30s;\r\n                }\r\n                &:hover {\r\n                  background: #dbdbdb;\r\n                  border-radius: 2px;\r\n                  text-decoration: none;\r\n                }\r\n              }\r\n            }\r\n          }\r\n          &:hover {\r\n            .rt-td:last-of-type {  \r\n              .row-actions-container {  \r\n                button {\r\n                 inset-inline-end:0;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.system-data-table {\r\n  ul {\r\n    &.nav {\r\n      &.nav-tabs {\r\n        gap: 16px;\r\n        border-bottom: none;\r\n        padding-inline: 0px;\r\n\r\n        li {\r\n          &.nav-item {\r\n            a {\r\n              &.nav-link {\r\n                border: none;\r\n                background-color: transparent;\r\n                @include FontStyle(\"title.22\", \"medium\");\r\n\r\n                &.active {\r\n                  color: config(\"color.basic.black\");\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .nav-pages {\r\n    gap: 20px;\r\n    flex: auto;\r\n  }\r\n  .nav-tools {\r\n    gap: 16px;\r\n  }\r\n  .data-list-table {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  .pagination {\r\n    position: initial;\r\n  }\r\n}\r\n\r\n.react-table {\r\n  .rt-table {\r\n    max-height: calc(100vh - 270px);\r\n    border-top: none !important;\r\n    border-radius: 6px;\r\n\r\n    :is(.th, .td) {\r\n      text-align: start;\r\n      \r\n      &.the-first:first-child {\r\n        border-inline-start: none;\r\n      }\r\n    }\r\n    .rt-tbody {\r\n      min-height: 771px;\r\n\r\n      .tr {\r\n        min-height: 38px;\r\n        \r\n        .td {\r\n          box-shadow: none;\r\n          padding-inline: 16px;\r\n          padding-block: 10px;\r\n          text-overflow: ellipsis;\r\n          overflow-x: hidden;\r\n          white-space: nowrap;\r\n          box-shadow: inset 0px -1px 0px config(\"color.gray.50\");\r\n          border-inline-end: none;\r\n          min-height: 40px;\r\n\r\n          .btn-link {\r\n            margin-bottom: 0;\r\n            padding: 0 0.75rem;\r\n          }\r\n          &[data-sticky-first-right-td=\"true\"] {\r\n            flex: 70 0 auto !important;\r\n            min-width: 70px !important;\r\n            width: 70px !important;\r\n            padding: 0 !important;\r\n            border-inline-start: solid 1px config(\"color.gray.100\");\r\n            padding: 0 !important;\r\n          }\r\n          &[data-sticky-td=\"true\"] {\r\n            &.parent-first-field {\r\n              border-inline-start: none !important;\r\n            }\r\n            &.parent-last-field {\r\n              border-inline-end: none !important;\r\n            }\r\n          }\r\n          &[data-sticky-last-left-td=\"true\"] {\r\n            border-inline-end: none;\r\n            white-space: break-spaces;\r\n            overflow-wrap: anywhere;\r\n            display: flex;\r\n          }\r\n          &.parent-first-field:not(:first-child) {\r\n            border-inline-start: solid 5px config(\"color.gray.50\");\r\n          }\r\n          &.actions-cell {\r\n            padding: 0;\r\n            align-items: center;\r\n            display: flex;\r\n            justify-content: end;\r\n            border-inline-start: none;\r\n            overflow-x: visible;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .rt-thead {\r\n      .tr {\r\n        &:first-of-type {\r\n          .th {\r\n            box-shadow: none;\r\n          }\r\n          &:not(:only-child) {\r\n            .th {\r\n              @include FontStyle(\"label.14\", \"semibold\");\r\n\r\n              &:nth-last-child(2) {\r\n                border-inline-end: none;\r\n              }\r\n            }\r\n          }\r\n        }\r\n        .th {\r\n          background-color: config(\"color.gray.100\");\r\n          @include FontStyle(\"label.14\", \"medium\");\r\n          color: config(\"color.basic.black\");\r\n          padding-inline: 16px;\r\n          padding-block: 10px;\r\n          transition-duration: 0.3s;\r\n          box-shadow: none;\r\n          position: var(--cell-position, relative) !important;\r\n\r\n          &[data-sticky-first-right-td=\"true\"] {\r\n            flex: 70 0 auto !important;\r\n            min-width: 70px !important;\r\n            width: 70px !important;\r\n\r\n            > div {\r\n              display: flex;\r\n              justify-content: center;\r\n            }\r\n          }\r\n          > span {\r\n            &:first-child {\r\n              display: inline-flex;\r\n              align-items: center;\r\n            }\r\n          }\r\n          &:hover {\r\n            background-color: config(\"color.gray.200\");\r\n          }\r\n          &[data-sticky-td=\"true\"] {\r\n            box-shadow: none;\r\n\r\n            &.type-object,\r\n            &.parent-first-field {\r\n              border-inline-start: none !important;\r\n            }\r\n          }\r\n          &.type-object {\r\n            @include FontStyle(\"label.14\", \"semibold\");\r\n            --cell-position: sticky;\r\n            left: 0;\r\n\r\n            &:last-child {\r\n              border-inline-end: solid 1px config(\"color.gray.100\") !important;\r\n            }\r\n          }\r\n          &:where(.parent-first-field, .block-cell):not(:first-child) {\r\n            border-inline-start: solid 5px config(\"color.gray.50\");\r\n          }\r\n          &.has-filter-field {\r\n            flex-wrap: wrap;\r\n          }\r\n          .filter-container {\r\n            flex: 0 0 100%;\r\n          }\r\n          &.block-cell.the-first {\r\n            --cell-position: relative;\r\n          }\r\n        }\r\n        &:first-child {\r\n          .th {\r\n            border-bottom: solid 1px config(\"color.gray.100\");\r\n            \r\n            &:not([colspan=\"1\"]) {\r\n              border-bottom: solid 1px config(\"color.gray.100\");\r\n            }\r\n          }\r\n          &:not(:last-child) {\r\n            .th {\r\n              border-inline-end: none;\r\n            }\r\n          }\r\n        }\r\n        & + .tr {\r\n          border-top: var(--table-heading-horizontal-border-style, none) var(--table-heading-horizontal-border-width, 0px) var(--table-heading-horizontal-border-color, transparent);\r\n\r\n          .th {\r\n            display: flex;\r\n            z-index: 9;\r\n\r\n            .sorted-arrow {\r\n              margin-inline-start:auto;\r\n            }\r\n          }\r\n        }\r\n        &:last-child {\r\n          .th {\r\n            border-bottom: solid 1px config(\"color.gray.100\");\r\n\r\n            &[data-sticky-last-left-td=\"true\"] {\r\n              border-inline-end: solid 1px config(\"color.gray.100\");\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .th {\r\n      .system-label {\r\n        --label-bottom-margin: 0px;\r\n        @include FontStyle(\"label.12\", \"bold\");\r\n      }\r\n      &.has-filter-field {\r\n        .system-label {\r\n          --label-bottom-margin: var(--system-label-bottom-margin, 6px);\r\n        }\r\n      }\r\n    }\r\n    .rt-tfoot {\r\n      .tr {\r\n        .td {\r\n          background-color: config(\"color.gray.100\");\r\n          padding-inline: 16px;\r\n          padding-block: 10px;\r\n          color: config(\"color.gray.500\");\r\n          @include FontStyle(\"body.12\", \"regular\");\r\n\r\n          &[data-sticky-first-right-td=\"true\"] {\r\n            flex: 70 0 auto !important;\r\n            min-width: 70px !important;\r\n            width: 70px !important;\r\n\r\n            > div {\r\n              display: flex;\r\n              justify-content: center;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &::-webkit-scrollbar-thumb {\r\n      background-color: config(\"color.gray.400\");\r\n    }\r\n  }\r\n  .pagination {\r\n    margin-block: 0.5rem;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0;\r\n\r\n    .page-info {\r\n      margin-inline-end:3rem;\r\n\r\n      .-pageSizeOptions {\r\n        position: relative;\r\n        cursor: pointer;\r\n\r\n        select {\r\n          appearance: none;\r\n          border: none;\r\n          background: transparent;\r\n          padding-top: 5px;\r\n          padding-bottom: 7px;\r\n          padding-inline-end: 2rem;\r\n          padding-inline-start: 12px;\r\n          border-radius: 6px;\r\n          margin-inline-end: 12px;\r\n          position: relative;\r\n          z-index: 1;\r\n          font-size: 11px;\r\n          font-weight: 500;\r\n          cursor: pointer;\r\n\r\n          &:focus,\r\n          &:hover {\r\n            outline: none;\r\n            background-color: color(\"celia\", \"gray-blue-10\");\r\n            box-shadow: 0 -1px 3px color(\"celia\", \"black-transparent-5\");\r\n          }\r\n        }\r\n        i {\r\n          position: absolute;\r\n          z-index: 0;\r\n         inset-inline-end:24px;\r\n          height: 12px;\r\n          top: calc(50% - 6px);\r\n          font-size: 11px;\r\n        }\r\n      }\r\n    }\r\n    .pagination-controls {\r\n      display: flex;\r\n      align-items: center;\r\n\r\n      .page-summary {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n        margin-inline: 6px;\r\n\r\n        input {\r\n          text-align: center;\r\n\r\n          &::-webkit-outer-spin-button,\r\n          &::-webkit-inner-spin-button {\r\n            -webkit-appearance: none;\r\n            margin: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.service-list-table {\r\n    .table-heading-actions {\r\n      margin-inline-end: 0px;\r\n\r\n      button.btn-link {\r\n        margin: 0px !important;\r\n        margin-inline-end: 0px !important;\r\n        width: 38px;\r\n        height: 28px;\r\n        align-items: center;\r\n        justify-content: center;\r\n        display: flex;\r\n        font-size: 12px;\r\n\r\n        &:hover {\r\n          background-color: rgba(0, 0, 0, 0.05);\r\n          text-decoration: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.data-list-report-table {\r\n    .rt-table {\r\n      max-height: calc(100vh - 390px);\r\n    }\r\n    .pagination {\r\n      background-color: #F4F4F4;\r\n    }\r\n  }\r\n  &.db-audit-log-list-table {\r\n    .rt-table {\r\n      max-height: calc(100vh - 306px);\r\n      overflow-x: auto !important;\r\n\r\n      .rt-thead {\r\n        .tr {\r\n          .th {\r\n            &:last-of-type {\r\n              flex: 150 0 auto !important;\r\n              width: 150px !important;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &:where(.data-view-list-table, .data-view-field-list-table) {\r\n    .rt-thead {\r\n      .tr {\r\n        .th {\r\n          &:last-of-type {\r\n            flex: 150 0 auto !important;\r\n            width: 150px !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.data-view-list-table {\r\n    :is(.rt-thead, .rt-tbody) {\r\n      .tr {\r\n        :is(.th, .td) {\r\n          &:is(.name-column, .user-column) {\r\n            flex: 3000 0 auto !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.data-view-field-list-table {\r\n    .rt-thead,\r\n    .rt-tbody {\r\n      .tr {\r\n        .th,\r\n        .td {\r\n          flex: 1 !important;\r\n          border-inline-end: 1px solid rgba(0, 0, 0, 0.05) !important;\r\n\r\n          &:last-of-type {\r\n            flex: 1 !important;\r\n            border-inline-end: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &.pane-2 {\r\n      .rt-thead,\r\n      .rt-tbody {\r\n        .tr {\r\n          .th,\r\n          .td {\r\n            &[data-sticky-td=\"true\"] {\r\n              max-width: 100px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .drop-placeholder {\r\n      @include FontStyle(\"body.14\", \"bold\");\r\n    }\r\n  }\r\n  &.data-list-table {\r\n    .rt-thead {\r\n      .tr {\r\n        .th:not(.parent-first-field) {\r\n          &:first-child {\r\n            --cell-position: sticky;\r\n            left: 0;\r\n            //z-index: 100;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .row-actions-container {\r\n    text-align: end;\r\n    align-items: center;\r\n    display: flex;\r\n    padding-inline-end: 16px;\r\n  }\r\n\r\n  .fk-badge {\r\n    background: #749abf;\r\n    line-height: 1;\r\n    display: inline-flex;\r\n    height: 16px;\r\n    width: 16px;\r\n    border-radius: 3px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    color: white;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-inline-start: 5px;\r\n    transform: scale(0.88);\r\n  }\r\n\r\n  .group-badge {\r\n    background: #4678aa;\r\n    line-height: 1;\r\n    display: inline-flex;\r\n    margin-left: 0 !important;\r\n    height: 16px;\r\n    padding-left: 1px;\r\n    padding-right: 1px;\r\n    border-radius: 3px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    color: white;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-inline-start: 5px;\r\n    transform: scale(0.88);\r\n  }\r\n\r\n  &.audit-table {\r\n    padding: 0;\r\n    margin-top: -10px;\r\n\r\n    &:empty {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n  &:not(.tableoptions--closed) {\r\n    .react-table {\r\n      &.data-list-table {\r\n        .rt-table {\r\n          max-height: calc(100vh - 270px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n  ul {\r\n    &.nav {\r\n      &.nav-tabs {\r\n        background-color: transparent;\r\n        box-shadow: none;\r\n        border: none;\r\n        align-items: center;\r\n        padding-top: 0;\r\n\r\n        li {\r\n          &.nav-item {\r\n            position: relative;\r\n            z-index: 2;\r\n            background: transparent;\r\n            box-shadow: none;\r\n            margin-inline-end:2rem;\r\n\r\n            &:last-of-type {\r\n              margin-inline-end:0;\r\n            }\r\n            a {\r\n              &.nav-link {\r\n                background: transparent;\r\n                border: none;\r\n                color: config(\"color.basic.black\");\r\n                @include FontStyle(\"title.22\", \"medium\");\r\n                padding: 0.5rem 0 !important;\r\n                margin: 0;\r\n                transition-duration: 0.3s;\r\n\r\n                &:hover,\r\n                &.active {\r\n                  color: var(--system-primary-color, #002b8f);\r\n                }\r\n                .bd-total-records {\r\n                  font-size: 13px;\r\n                  font-weight: 500;\r\n                  background: config(\"color.basic.white\");\r\n                  padding: 2px 5px;\r\n                  border-radius: 20px;\r\n                  margin-inline-start:10px;\r\n                  display: inline-flex;\r\n                  align-items: center;\r\n                  justify-content: center;\r\n\r\n                  &:empty {\r\n                    display: none;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n        .add-data-entry {\r\n          position: relative;\r\n          z-index: 3;\r\n          width: 32px;\r\n          height: 32px;\r\n          min-width: 32px;\r\n          border-radius: 32px;\r\n          color: color(\"celia\", \"gray-blue\");\r\n          background-color: color(\"celia\", \"gray-blue-10\");\r\n          padding: 0;\r\n          font-weight: 500;\r\n          font-size: 13px;\r\n          line-height: 12px;\r\n\r\n          i {\r\n            color: color(\"celia\", \"gray-blue\");\r\n            font-size: 16px;\r\n          }\r\n        }\r\n        .search--table {\r\n          height: 32px;\r\n          background-color: #EAEDF2;//color(\"celia\", \"white\");\r\n          border-radius: 6px;\r\n          padding: 0 12px;\r\n\r\n          input {\r\n            color: color(\"celia\", \"dark-text-80\");\r\n            font-size: 13px;\r\n            font-weight: 500;\r\n          }\r\n          i {\r\n            color: color(\"celia\", \"dark-text-80\");\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.table-row-click {\r\n  .tr {\r\n    cursor: pointer;\r\n  }\r\n  .tr:hover {\r\n    .td {\r\n      background: config(\"color.gray.50\");\r\n    }\r\n  }\r\n}\r\n.db-options-bar {\r\n  padding-block: 6px;\r\n  padding-inline: 8px;\r\n  background-color: config(\"color.basic.white\");\r\n  border-radius: config(\"layout.cornerRadius.medium\");\r\n  box-shadow: config(\"shadow.light.100\");\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n\r\n  .filters-row {\r\n    background-color: transparent;\r\n    padding: 0;\r\n    gap: 10px 20px;\r\n    justify-content: flex-end;\r\n\r\n    .responsive-dropdown-container {\r\n      display: flex;\r\n      gap: 10px 0px;\r\n      margin-inline-end: auto;\r\n      flex-wrap: wrap;\r\n\r\n      button {\r\n        &.system-button {\r\n          span {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n      .export-button {\r\n        button {\r\n          &.system-button {\r\n            &.exporting {\r\n              --button-inline-padding: 16px;\r\n              \r\n              span {\r\n                display: block;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .filters-rows-action {\r\n        button {\r\n          &.system-button {\r\n            span {\r\n              display: block;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .toolbar-separator {\r\n        height: 14px;\r\n        width: 1px;\r\n        background-color: config(\"color.gray.300\");\r\n        margin: 0 8px;\r\n        align-self: center;\r\n      }\r\n    }\r\n    .responsive-menu-toggler {\r\n      display: none;\r\n      align-items: center;\r\n      padding: 0;\r\n      width: 32px;\r\n      border-radius: 6px;\r\n      color: color(\"celia\", \"dark-text\");\r\n      justify-content: center;\r\n      margin-inline-end: -4px;\r\n\r\n      i {\r\n        font-size: 24px;\r\n      }\r\n      &:hover {\r\n        background-color: color(\"celia\", \"gray-blue-5\");\r\n      }\r\n    }\r\n    @media screen and (max-width: 768px) {\r\n      flex: 0 0 100%;\r\n      position: relative;\r\n\r\n      .responsive-menu-toggler {\r\n        display: flex;\r\n\r\n        & + .responsive-dropdown-container {\r\n          display: none;\r\n        }\r\n        &.open + .responsive-dropdown-container {\r\n          display: block;\r\n          position: absolute;\r\n          z-index: 100;\r\n          background-color: white;\r\n          padding: 10px;\r\n          border-radius: 6px;\r\n          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.09);\r\n          top: 32px;\r\n\r\n          > div {\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: flex-start;\r\n\r\n            > * {\r\n              width: 100%;\r\n              justify-content: start !important;\r\n\r\n              > button,\r\n              > div > button {\r\n                width: 100%;\r\n                justify-content: start !important;\r\n              }\r\n            }\r\n          }\r\n          :where(.reports-dropdown, .columns-toggler).show .dropdown-menu.show {\r\n            transform: translate3d(calc(-100% - 1px), -2px, 0px) !important;\r\n          }\r\n          .dropdown-filters.show .dropdown-menu.show {\r\n            transform: none !important;\r\n            top: 32px !important;\r\n            inset-inline-start: calc(100% - 90vw + 10px) !important;\r\n            width: 90vw;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .options-buttons {\r\n    button {\r\n      &.btn {\r\n        border-radius: 6px;\r\n        height: 30px;\r\n        border: none;\r\n        font-size: 12px;\r\n        font-weight: 500;\r\n        color: color(\"celia\", \"dark-text\") !important;\r\n        padding: 0 1rem;\r\n\r\n        span {\r\n          color: color(\"celia\", \"dark-text\") !important;\r\n        }\r\n        &:hover {\r\n          background-color: color(\"celia\", \"gray-blue-10\");\r\n\r\n          span {\r\n            color: color(\"celia\", \"dark-text\") !important;\r\n          }\r\n        }\r\n        &.btn-warning {\r\n          background-color: color(\"celia\", \"orange-25\");\r\n          color: color(\"celia\", \"orange\") !important;\r\n\r\n          span {\r\n            color: color(\"celia\", \"orange\") !important;\r\n          }\r\n          &:hover {\r\n            background-color: color(\"celia\", \"orange\");\r\n            color: color(\"celia\", \"white\") !important;\r\n\r\n            span {\r\n              color: color(\"celia\", \"white\") !important;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.columns-toggler {\r\n  .dropdown-menu {\r\n    max-width: 320px;\r\n\r\n    button {\r\n      &.dropdown-item {\r\n        @include FontStyle(\"label.14\", \"regular\");\r\n\r\n        &.column-type-object  {\r\n          @include FontStyle(\"label.14\", \"semibold\");\r\n        }\r\n      }\r\n    }\r\n    &.show {\r\n      width: max-content;\r\n    }\r\n  }\r\n  .search--table {\r\n    --custom-height: 32px;\r\n    background-color: #EAEDF2;\r\n    border-radius: 6px;\r\n    padding: 0 12px;\r\n\r\n    input {\r\n      color: color(\"celia\", \"dark-text-80\");\r\n      font-size: 13px;\r\n      font-weight: 500;\r\n    }\r\n    i {\r\n      color: color(\"celia\", \"dark-text-80\");\r\n    }\r\n  }\r\n  .col-status-icon {\r\n    --check-icon-color: var(--system-primary-color, #002b8f);\r\n  }\r\n}\r\n.audit-log-table-toolbar {\r\n  .dropdown {\r\n    > button {\r\n      border-radius: 6px !important;\r\n      padding: 0 0.6rem;\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      color: color(\"celia\", \"dark-text\");\r\n      height: 32px;\r\n      transition-duration: 0.3s;\r\n\r\n      &:hover {\r\n        background-color: color(\"celia\", \"gray-blue-5\");\r\n      }\r\n    }\r\n    &.show {\r\n      > button {  \r\n        background-color: color(\"celia\", \"gray-blue-5\");\r\n      }\r\n    }\r\n  }\r\n}\r\n.log-audit-detail-table {\r\n  width: 100%;\r\n  table-layout: fixed;\r\n\r\n  td {\r\n    padding-block: 6px;\r\n    border-top: var(--border-top-style, solid) var(--border-top-width, 1px) var(--border-top-color, config(\"color.gray.200\"));\r\n    height: 48px;\r\n    vertical-align: middle;\r\n\r\n    &:first-child {\r\n      @include FontStyle(\"body.14\", \"medium\");\r\n      color: config(\"color.basic.black\");\r\n      padding-inline-start: 20px;\r\n    }\r\n    &:last-child {\r\n      @include FontStyle(\"body.14\", \"regular\");\r\n      color: config(\"color.basic.black\");\r\n      padding-inline-end: 20px;\r\n    }\r\n  }\r\n  tr {\r\n    &:first-child {\r\n      td {\r\n        --border-top-style: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n.diff-item {\r\n  @include FontStyle(\"body.14\", \"regular\");\r\n  gap: 8px;\r\n  padding-block: 6px;\r\n\r\n  .rendered-value {\r\n    padding-top: 0px;\r\n  }\r\n  &:first-child {\r\n    padding-top: 0px;\r\n  }\r\n  &:last-child {\r\n    padding-bottom: 0px;\r\n  }\r\n}\r\n.diff-path {\r\n  @include FontStyle(\"body.14\", \"medium\");\r\n}\r\n.diff-old-value,\r\n.diff-new-value {\r\n  padding: 4px 6px;\r\n  border-radius: config(\"layout.cornerRadius.small\");\r\n}\r\n.diff-old-value {\r\n  background-color: config(\"color.error.200\");\r\n}\r\n.diff-new-value {\r\n  background-color: config(\"color.success.200\");\r\n  line-break: anywhere;\r\n\r\n  .table .table {\r\n    background-color: transparent;\r\n  }\r\n}\r\n.table-row-drag-drop {\r\n  .tr {\r\n    background: config(\"color.basic.white\");\r\n    box-shadow: config(\"shadow.light.500\");\r\n    align-items: center;\r\n    padding: 14px;\r\n    border-radius: config(\"layout.cornerRadius.small\");\r\n  }\r\n  .td {\r\n    @include FontStyle(\"body.12\", \"bold\");\r\n\r\n    &.actions-cell {\r\n      width: auto;\r\n\r\n      .row-actions-container {\r\n        white-space: nowrap;\r\n      }\r\n    }\r\n  }\r\n}\r\n.service-param-cell {\r\n  width: 60px;\r\n}\r\n.empty-row-msg {\r\n  position: sticky;\r\n  display: grid;\r\n  place-content: center;\r\n  z-index: 9;\r\n  bottom: calc(50% - 115px);\r\n\r\n  img {\r\n    display: block;\r\n    margin: auto;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 767px) {\r\n  .table-responsive-material {\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n    overflow-y: hidden;\r\n    -ms-overflow-style: -ms-autohiding-scrollbar;\r\n    border: 1px solid #ddd;\r\n  }\r\n  .table-responsive-material > .table {\r\n    margin-bottom: 0;\r\n  }\r\n  .table-responsive-material > .table > :where(thead, tbody, tfoot) > tr > :where(th, td) {\r\n    white-space: nowrap;\r\n  }\r\n  .table-responsive-material > .table-bordered {\r\n    border: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > :where(thead, tbody, tfoot) > tr > :where(th, td):first-child {\r\n    border-inline-start: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > :where(thead, tbody, tfoot) > tr > :where(th, td):last-child {\r\n    border-inline-end: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > :where(tbody, tfoot) > tr:last-child > :where(th, td) {\r\n    border-bottom: 0;\r\n  }\r\n}\r\n\r\n.fst-td-br-tp-0 tr:first-child {\r\n  & td {\r\n    border-top: 0 none;\r\n  }\r\n}","/*Tabs Styles*/\n\n.tab {\n  min-width: 10px !important;\n}\n\n.tab-icon > span {\n  @include display-flex();\n}","/*Testimonial Styles*/\n\n.testimonial-in-bg {\n  background-color: rgba($black, 0.8);\n  box-shadow: 5px 5px 6px rgba($black, 0.06);\n  padding: 30px;\n  padding-inline-start: 150px;\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (max-width: 450px) {\n    padding-inline-start: 100px;\n  }\n\n  & .pic {\n    display: inline-block;\n    width: $size-80;\n    height: $size-80;\n    @include border-radius(50%);\n    overflow: hidden;\n    position: absolute;\n    top: 30px;\n   inset-inline-start:20px;\n    border: 4px solid map_get($amber, darken-2);\n\n    @media screen and (max-width: 450px) {\n      width: $size-50;\n      height: $size-50;\n    }\n  }\n  & .pic img {\n    width: 100%;\n    height: auto;\n  }\n  & .description {\n    color: map_get($gray, lighten-1);\n    font-style: italic;\n    font-weight: 400;\n    line-height: 25px;\n    margin-bottom: 15px;\n    position: relative;\n\n    &:before {\n      content: \"\\f1b2\";\n      font: {\n        family: 'Material-Design-Iconic-Font';\n        size: 24px;\n      }\n      -moz-transform: scaleX(-1);\n      -webkit-transform: scaleX(-1);\n      -o-transform: scaleX(-1);\n      transform: scaleX(-1);\n      position: absolute;\n     inset-inline-start:-24px;\n    }\n  }\n  & .title {\n    color: map_get($amber, darken-2);\n    margin-bottom: 2px;\n  }\n}\n\n// Testimonials Simple\n.classic-testimonial {\n  text-align: center;\n\n  & .pic {\n    margin: 0 auto;\n    margin-bottom: 30px;\n    width: $size-120;\n    height: $size-120;\n\n    @media screen and (max-width: 500px) {\n      width: $size-80;\n      height: $size-80;\n    }\n  }\n  & .pic img {\n    width: 100%;\n    height: 100%;\n  }\n}\n","/*Time Lines Style*/\n\n.timeline-left {\n  float: inline-start;\n  margin-inline-end:20px;\n}\n\n.timeline-right {\n  float: inline-end;\n  margin-inline-start:20px;\n}\n\n.timeline-circle {\n  @include border-radius(50%);\n}\n\n.timeline-section {\n  margin-bottom: 25px;\n}\n\n.timeline-item {\n  padding-bottom: 25px;\n  padding-inline-start: 80px;\n  position: relative;\n\n  &:before {\n    border-inline-start: solid 2px $gray-300;\n    content: \"\";\n   inset-inline-start:25px;\n    position: absolute;\n    top: 25px;\n    bottom: -20px;\n    width: 2px;\n    z-index: 1;\n  }\n  &:first-child:before {\n    border-inline-start-style: dashed;\n  }\n  &:last-child:before {\n    border-inline-start-style: dashed;\n    bottom: 25px;\n  }\n}\n\n.timeline-badge {\n  //background-color: $gray-300;\n  @extend %size-50;\n  position: absolute;\n inset-inline-start:0;\n  top: 16px;\n  z-index: 2;\n  font-size: 16px;\n  color: $white;\n  text-align: center;\n  @include border-radius($border-radius-circle);\n\n  &.timeline-img {\n    background-color: transparent;\n  }\n  & svg {\n    vertical-align: calc(100% - 56px);\n  }\n}\n\n.timeline-badge {\n  &.timeline-img:after {\n    display: none;\n  }\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 42px;\n    height: 42px;\n    background-color: transparent;\n    border: 4px solid $body-bg;\n    @include border-radius($border-radius-circle);\n   inset-inline-start:4px;\n    top: 4px;\n    z-index: 1;\n  }\n}\n\n.timeline-img > img,\n.timeline-header-img > img {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n\n.timeline-panel {\n  padding: 20px 30px;\n  position: relative;\n  background-color: $white;\n  @include border-radius($border-radius-lg);\n  border: solid 1px $gray-200;\n\n  &:after,\n  &:before {\n    content: \"\";\n    position: absolute;\n    border-style: solid;\n    display: inline-block;\n  }\n\n  &:before {\n    border-color: transparent $gray-300;\n    border-width: 10px 17px 10px 0;\n   inset-inline-start:-17px;\n    top: 30px;\n  }\n\n  &:after {\n    border-color: transparent $white;\n    border-width: 10px 16px 10px 0;\n   inset-inline-start:-16px;\n    top: 30px;\n  }\n}\n\n.timeline-no-padding {\n  padding: 0;\n}\n\n.timeline-no-shadow {\n  @include box-shadow(none);\n  &:before,\n  &:after {\n    display: none;\n  }\n}\n\n.timeline-panel-header, .timeline-header-img {\n  margin-bottom: 10px;\n}\n\n.timeline-inverted {\n  & .timeline-left {\n    float: inline-end;\n    margin-inline-end:0;\n    margin-inline-start:20px;\n  }\n}\n\n.timeline-heading {\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.timeline-body {\n  clear: both;\n}\n\n/*Gxtl Center Style*/\n.timeline-center {\n  & .timeline-item {\n    clear: both;\n    float: inline-end;\n    width: 50%;\n    padding-inline-start: 55px;\n\n    &:before {\n     inset-inline-start:0;\n    }\n  }\n}\n\n.timeline-center {\n  & .timeline-badge {\n   inset-inline-start:-25px;\n   inset-inline-end:auto;\n  }\n\n  & .timeline-time {\n    position: absolute;\n    top: 32px;\n   inset-inline-start:-150px;\n   inset-inline-end:auto;\n    z-index: 2;\n  }\n\n  & .timeline-inverted {\n    float: inline-start;\n    text-align: right;\n    padding-inline-start: 0;\n    padding-inline-end: 55px;\n\n    &:before {\n      border-inline-start: 0 none;\n      border-inline-end: solid 2px $gray-300;\n     inset-inline-start:auto;\n     inset-inline-end:-2px;\n    }\n    & .timeline-badge {\n     inset-inline-start:auto;\n     inset-inline-end:-25px;\n    }\n\n    & .timeline-panel {\n      &:before {\n        border-width: 10px 0 10px 17px;\n       inset-inline-start:auto;\n       inset-inline-end:-17px;\n      }\n\n      &:after {\n        border-width: 10px 0 10px 16px;\n       inset-inline-start:auto;\n       inset-inline-end:-16px;\n      }\n    }\n\n    & .timeline-time {\n      position: absolute;\n      top: 32px;\n     inset-inline-end:-150px;\n     inset-inline-start:auto;\n      z-index: 2;\n    }\n  }\n}\n\n/*Gxtl Zigzag Style*/\n.timeline-zigzag {\n  & .timeline-item {\n    padding-inline-start: 150px;\n\n    & + .timeline-item {\n      margin-top: -80px;\n    }\n  }\n\n  & .timeline-img {\n    width: 90px;\n    height: 90px;\n   inset-inline-start:5px;\n    & > img {\n      width: 100%;\n    }\n  }\n\n  & .timeline-inverted .timeline-img {\n   inset-inline-end:5px !important;\n  }\n\n  & .timeline-item:before {\n    @include rotate(35deg);\n    top: 20px;\n    bottom: 20px;\n  }\n\n  & .timeline-inverted {\n    padding-inline-start: 0;\n    padding-inline-end: 150px;\n    &:before {\n      @include rotate(-35deg);\n    }\n  }\n\n  & .timeline-item:first-child:before {\n    border-inline-start-style: solid;\n  }\n\n  & .timeline-item:last-child:before {\n    display: none;\n  }\n}\n\n.timeline-item:last-child:before {\n  bottom: 25px;\n}\n\n@media screen and (max-width: 991px) {\n  .timeline-zigzag .timeline-item + .timeline-item {\n    margin-top: -60px;\n  }\n\n  .timeline-zigzag .timeline-item:before {\n    bottom: 0;\n  }\n\n  .timeline-zigzag {\n    & .timeline-item {\n      padding-inline-start: 120px;\n    }\n\n    & .timeline-inverted {\n      padding-inline-end: 120px;\n      padding-inline-start: 0;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .timeline-center {\n    & .timeline-item {\n      float: none;\n      padding-inline-start: 80px;\n      width: auto;\n      &:before {\n       inset-inline-start:25px;\n      }\n    }\n\n    & .timeline-badge {\n     inset-inline-start:0;\n    }\n\n    & .timeline-inverted {\n      float: none;\n      text-align: left;\n      padding-inline-end: 0;\n\n      &:before {\n        border-inline-start: solid 2px $gray-300;\n        border-inline-end: 0 none;\n       inset-inline-start:24px;\n       inset-inline-end:auto;\n      }\n      & .timeline-badge {\n       inset-inline-end:auto;\n       inset-inline-start:0;\n      }\n\n      & .timeline-panel {\n        &:before {\n          border-width: 10px 17px 10px 0;\n         inset-inline-start:-17px;\n         inset-inline-end:auto;\n        }\n        &:after {\n          border-width: 10px 16px 10px 0;\n         inset-inline-start:-16px;\n         inset-inline-end:auto;\n        }\n      }\n    }\n  }\n\n  .timeline-inverted {\n    & .timeline-panel-header {\n      float: none;\n    }\n\n    & .timeline-left {\n      float: inline-start;\n      margin-inline-start:0;\n      margin-inline-end:20px;\n    }\n  }\n\n  .timeline-zigzag {\n    & .timeline-panel {\n      max-height: none;\n      min-height: 10px;\n      overflow-y: visible;\n    }\n\n    & .timeline-item {\n      padding-inline-start: 100px;\n      & + .timeline-item {\n        margin-top: 0;\n      }\n\n      &:before {\n        transform: none;\n        top: 25px;\n        bottom: -25px;\n       inset-inline-start:45px;\n      }\n\n      &:last-child:before {\n        bottom: 0;\n      }\n    }\n    & .timeline-inverted:before {\n      transform: none;\n    }\n  }\n\n  .timeline-center {\n    & .timeline-time,\n    & .timeline-inverted .timeline-time {\n      position: relative;\n      top: auto;\n     inset-inline-start:auto;\n     inset-inline-end:auto;\n      margin-bottom: 6px;\n    }\n\n    .timeline-time-item .timeline-panel::before {\n      top: 10px;\n    }\n\n    .timeline-time-item .timeline-panel::after {\n      top: 11px;\n    }\n  }\n}\n\n@media screen and (max-width: 399px) {\n  .timeline-left {\n    float: none;\n    margin-inline-end:0;\n  }\n\n  .timeline-right {\n    float: none;\n    margin-inline-start:0;\n  }\n\n  .timeline-inverted {\n    & .timeline-left {\n      float: none;\n      margin-inline-end:0;\n    }\n  }\n}","@import 'react-joyride';\n/*Joyride Tour Styles*/\n\n@mixin viewport-unit($property, $value) {\n  #{$property}: $value;\n\n  $unit: unit($value);\n\n  @if (index((vw, vh, vmin, vmax), $unit) != null) {\n    $devices: (\n                    (768px, 1024px), // iPad (all versions)\n                    (320px, 480px), // iPhone 4\n                    (320px, 568px) // iPhone 5, 5C, 5S\n    );\n\n    @each $device in $devices {\n      $device-width: nth($device, 1);\n      $device-height: nth($device, 2);\n\n      $device-query: 'only screen and (-webkit-min-device-pixel-ratio: 1)';\n      $device-query: '#{$device-query} and (device-width: #{$device-width})';\n      $device-query: '#{$device-query} and (device-height: #{$device-height})';\n\n      $percent: $value / ($value * 0 + 1); // see https://github.com/sass/sass/issues/533\n\n      $percent-width: $device-width * $percent / 100;\n      $percent-height: $device-height * $percent / 100;\n\n      @if ($unit == vmin or $unit == vmax) {\n        @media #{$device-query} {\n          #{$property}: if($unit == vmin, $percent-width, $percent-height);\n        }\n      } @else {\n        @media #{$device-query} and (orientation: portrait) {\n          #{$property}: if($unit == vw, $percent-width, $percent-height);\n        }\n\n        @media #{$device-query} and (orientation: landscape) {\n          #{$property}: if($unit == vw, $percent-height, $percent-width);\n        }\n      }\n    }\n  }\n}","/*Form Styles*/\n@media screen and (max-width: 575px) {\n  .horizontal-stepper {\n    & p,\n    & span {\n      opacity: 0;\n      visibility: hidden;\n      font-size: 12px;\n    }\n\n    &.active {\n      & p,\n      & span {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n\n    & > *,\n    & > button > * {\n      @include display-flex(flex, column, nowrap);\n    }\n\n    & .stepperlabel,\n    & .stepperbutton,\n    & .stepperlabel span:first-child,\n    & .stepperbutton span:first-child {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n  .horizontal-stepper-linear {\n    padding-inline-start: 0 !important;\n    padding-inline-end: 0 !important;\n  }\n}",".form-checkbox {\n  position: relative;\n  z-index: 1;\n}\n\n.form-checkbox > input {\n  height: 18px;\n  opacity: 0;\n  position: absolute;\n  padding: 10px;\n  top: 0;\n  width: 18px;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.form-control-checkbox .form-checkbox > input {\n  height: 48px;\n  width: 48px;\n}\n\n.form-control-checkbox .form-checkbox {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  width: 48px;\n  justify-content: center;\n}\n\n.form-checkbox > input + .check {\n  border: 1px solid $sidebar-text-color;\n  border-radius: 2px;\n  color: $app-primary;\n  cursor: pointer;\n  display: inline-block;\n  height: 18px;\n  position: relative;\n  width: 18px;\n  z-index: -1;\n}\n\n.form-checkbox > input.sm + .check {\n  border: 1px solid $sidebar-text-color;\n  border-radius: 2px;\n  color: $app-primary;\n  cursor: pointer;\n  display: inline-block;\n  height: 14px;\n  position: relative;\n  top: 3px;\n  width: 14px;\n  z-index: -1;\n}\n\n.form-checkbox > input + .check i {\n  display: none;\n inset-inline-start:1px;\n  opacity: 0;\n  position: absolute;\n  top: 2px;\n}\n\n.form-checkbox > input.sm + .check i {\n  display: none;\n inset-inline-start:1px;\n  opacity: 0;\n  position: absolute;\n  top: 2px;\n}\n\n.form-checkbox > input:checked + span i {\n  display: block;\n  opacity: 1;\n}\n\n/*Radio and Checkbox styles*/\n\n.checkbox-replace {\n  padding-inline-start: 20px;\n}\n\n.checkbox-replace input[type=\"checkbox\"],\n.radio-replace input[type=\"radio\"] {\n  margin-inline-start:-20px;\n  position: absolute;\n}\n\n.form-inline .checkbox-replace label {\n  padding-inline-start: 5px;\n}\n\n.form-inline .checkbox-replace,\n.form-inline .radio-replace {\n  margin-inline-end:20px;\n}\n\n.form-inline .checkbox-replace:last-child {\n  margin-inline-end:0;\n}\n\n.checkbox-replace label {\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  padding-inline-start: 5px;\n}\n\n.checkbox-replace label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 18px;\n  height: 18px;\n inset-inline-start:0;\n  top: 0;\n  margin-inline-start:-20px;\n  margin-top: 2px;\n  border: 1px solid $sidebar-text-color;\n  border-radius: 3px;\n  background-color: $white;\n  @include transition (border 0.15s ease-in-out, color 0.15s ease-in-out);\n}\n\n.checkbox-replace label::after {\n  display: inline-block;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n inset-inline-start:3px;\n  top: 5px;\n  margin-inline-start:-20px;\n  font-size: 11px;\n  color: $gray-700;\n}\n\n.checkbox-replace input[type=\"checkbox\"] {\n  opacity: 0;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.checkbox-replace input[type=\"checkbox\"]:focus + label::before {\n  outline: 0 none;\n}\n\n.checkbox-replace input[type=\"checkbox\"]:checked + label::after {\n  background-color: $gray-400;\n  content: \"\";\n}\n\n.checkbox-replace input[type=\"checkbox\"]:disabled + label {\n  opacity: 0.65;\n}\n\n.checkbox-replace input[type=\"checkbox\"]:disabled + label::before {\n  background-color: $white;\n  cursor: not-allowed;\n}\n\n.checkbox-replace.checkbox-inline {\n  margin-top: 0;\n}\n\n.checkbox-primary label::before {\n  border-color: $app-primary;\n}\n\n.checkbox-primary input[type=\"checkbox\"]:checked + label::after {\n  background-color: $app-primary;\n}\n\n.checkbox-danger label::before {\n  border-color: $secondary;\n}\n\n.checkbox-danger input[type=\"checkbox\"]:checked + label::after {\n  border-color: $secondary;\n}\n\n.checkbox-info label::before {\n  border-color: $info;\n}\n\n.checkbox-info input[type=\"checkbox\"]:checked + label::after {\n  border-color: $info;\n}\n\n.checkbox-warning label::before {\n  border-color: $warning;\n}\n\n.checkbox-warning input[type=\"checkbox\"]:checked + label::after {\n  border-color: $warning;\n}\n\n.checkbox-success label::before {\n  border-color: $success;\n}\n\n.checkbox-success input[type=\"checkbox\"]:checked + label::after {\n  border-color: $success;\n}\n\n.radio-replace {\n  padding-inline-start: 20px;\n}\n\n.radio-replace label {\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  padding-inline-start: 5px;\n}\n\n.radio-replace label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 18px;\n  height: 18px;\n inset-inline-start:0;\n  top: 0;\n  margin-inline-start:-20px;\n  margin-top: 2px;\n  border: 1px solid $gray-400;\n  border-radius: 50%;\n  background-color: $white;\n  @include transition(border 0.15s ease-in-out);\n}\n\n.radio-replace label::after {\n  display: inline-block;\n  position: absolute;\n  content: \" \";\n  width: 12px;\n  height: 12px;\n inset-inline-start:3px;\n  top: 5px;\n  margin-inline-start:-20px;\n  border-radius: 50%;\n  background-color: $gray-400;\n  @include rotate (scale(0, 0));\n  @include transition (transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33))\n}\n\n.radio-replace input[type=\"radio\"] {\n  opacity: 0;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.radio-replace input[type=\"radio\"]:focus + label::before {\n  outline: 0 none;\n}\n\n.radio-replace input[type=\"radio\"]:checked + label::after {\n  @include rotate (scale(1, 1));\n\n}\n\n.radio-replace input[type=\"radio\"]:disabled + label {\n  opacity: 0.65;\n}\n\n.radio-replace input[type=\"radio\"]:disabled + label::before {\n  cursor: not-allowed;\n}\n\n.radio-replace.radio-inline {\n  margin-top: 0;\n}\n\n.radio-primary input[type=\"radio\"] + label::after {\n  background-color: $app-primary;\n}\n\n.radio-primary input[type=\"radio\"]:checked + label::before {\n  border-color: $app-primary;\n}\n\n.radio-primary input[type=\"radio\"]:checked + label::after {\n  background-color: $app-primary;\n}\n\n.radio-danger input[type=\"radio\"] + label::after {\n  background-color: $secondary;\n}\n\n.radio-danger input[type=\"radio\"]:checked + label::before {\n  border-color: $secondary;\n}\n\n.radio-danger input[type=\"radio\"]:checked + label::after {\n  background-color: $secondary;\n}\n\n.radio-info input[type=\"radio\"] + label::after {\n  background-color: $info;\n}\n\n.radio-info input[type=\"radio\"]:checked + label::before {\n  border-color: $info;\n}\n\n.radio-info input[type=\"radio\"]:checked + label::after {\n  background-color: $info;\n}\n\n.radio-warning input[type=\"radio\"] + label::after {\n  background-color: $warning;\n}\n\n.radio-warning input[type=\"radio\"]:checked + label::before {\n  border-color: $warning;\n}\n\n.radio-warning input[type=\"radio\"]:checked + label::after {\n  background-color: $warning;\n}\n\n.radio-success input[type=\"radio\"] + label::after {\n  background-color: $success;\n}\n\n.radio-success input[type=\"radio\"]:checked + label::before {\n  border-color: $success;\n}\n\n.radio-success input[type=\"radio\"]:checked + label::after {\n  background-color: $success;\n}\n\n.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {\n  padding-top: 7px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.form-horizontal .form-inline .checkbox,\n.form-horizontal .form-inline .checkbox-inline,\n.form-horizontal .form-inline .radio,\n.form-horizontal .form-inline .radio-inline {\n  padding-top: 0;\n}\n\n.form-horizontal .checkbox, .form-horizontal .radio {\n  min-height: 27px;\n}\n\n.form-wizard .tab-content .pager.wizard .first a {\n  margin-inline-end:8px;\n}\n\n.form-wizard .tab-content .pager.wizard .last a {\n  margin-inline-start:8px;\n}\n\n.wizard-navbar {\n  margin: 60px auto 20px;\n}\n\n.wizard-navbar > ul {\n  display: table;\n  width: 100%;\n  text-align: center;\n  margin: 0;\n  font-weight: 600;\n  padding: 0;\n  list-style: none outside none;\n  table-layout: fixed;\n}\n\n.wizard-navbar > ul li {\n  display: table-cell;\n  width: 1%;\n  position: relative;\n}\n\n.wizard-navbar > ul li a {\n  color: $sidebar-text-color;\n  position: relative;\n  padding: 0 10px;\n  display: block;\n  text-decoration: none;\n}\n\n.wizard-navbar > ul li a span.wz-number {\n  background-color: $gray-200;\n  border-radius: 50%;\n\n  color: $gray-500;\n  display: block;\n  height: 40px;\n inset-inline-start:50%;\n  line-height: 40px;\n  margin-inline-start:-20px;\n  margin-top: -50px;\n  position: absolute;\n  text-align: center;\n  @include transition(all 300ms ease-in-out 0s);\n  width: 40px;\n  z-index: 5;\n}\n\n.wizard-navbar > ul li.completed a span.wz-number {\n  background-color: $app-primary;\n  color: $white;\n}\n\n.wizard-navbar > ul li a.active span.wz-number {\n  background-color: $secondary;\n  color: $white;\n}\n\n.wizard-navbar > ul li a.active,\n.wizard-navbar > ul li.completed a {\n  color: $gray-600;\n}\n\n.wizard-navbar > ul li a:before,\n.wizard-navbar > ul li a:after {\n  content: '';\n  position: absolute;\n  height: 4px;\n  width: 50%;\n  background-color: $gray-200;\n  top: -32px;\n inset-inline-start:0;\n}\n\n.wizard-navbar > ul li a:after {\n inset-inline-start:auto;\n inset-inline-end:0;\n}\n\n.wizard-navbar > ul li a.active:before,\n.wizard-navbar > ul li a.active:after {\n  background-color: $secondary;\n}\n\n.wizard-navbar > ul li.completed a:before,\n.wizard-navbar > ul li.completed a:after {\n  background-color: $app-primary;\n}\n\nlabel.error {\n  display: block;\n  color: $danger;\n  font-weight: 400;\n  margin: 5px 0;\n}\n\n@media screen and (max-width: 479px) {\n  .wizard-navbar > ul li a span.wz-label {\n    visibility: hidden;\n  }\n\n  .wizard-navbar > ul li a.active span.wz-label {\n    visibility: visible;\n  }\n}\n\n.form-checkbox-custom {\n  @include display-flex();\n  @include align-items(center);\n  margin-bottom: 12px;\n}\n\n.form-checkbox-custom .check {\n  margin-inline-end:10px;\n}\n\n.react-switch {\n  vertical-align: middle;\n  margin-inline-start:4px;\n}\n","/*Input Styles*/\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  font-size: 12px;\n  color: lighten($body-color, 50%);\n}\n\n::-moz-placeholder { /* Firefox 19+ */\n  font-size: 12px;\n  color: lighten($body-color, 50%);\n}\n\n:-ms-input-placeholder { /* IE 10+ */\n  font-size: 12px;\n  color: lighten($body-color, 50%);\n}\n\n:-moz-placeholder { /* Firefox 18- */\n  font-size: 12px;\n  color: lighten($body-color, 50%);\n}\n\n.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  font-size: 14px;\n}\n\n.module-box-header ::-moz-placeholder { /* Firefox 19+ */\n  font-size: 14px;\n}\n\n.module-box-header :-ms-input-placeholder { /* IE 10+ */\n  font-size: 14px;\n}\n\n.module-box-header :-moz-placeholder { /* Firefox 18- */\n  font-size: 14px;\n}\n\n// Search Bar Style\n.search-bar {\n  background-color: $white;\n  position: relative;\n  & .form-group {\n    width: 100%;\n    height: 100%;\n    margin-bottom: 0;\n  }\n  & input[type=\"search\"] {\n    padding-inline-end: 50px;\n  }\n\n  & .search-icon {\n    background-color: transparent;\n    border: 0 none;\n    color: lighten($gray-600, 10%);\n    height: 36px;\n    width: 30px;\n  }\n\n  & .form-control {\n    box-shadow: none;\n    &.form-control-lg + .search-icon {\n      position: absolute;\n     inset-inline-end:14px;\n      top: 6px;\n    }\n  }\n\n  & .search-icon {\n    position: absolute;\n   inset-inline-end:14px;\n    top: 3px;\n  }\n\n  &.right-side-icon {\n    & input[type=\"search\"] {\n      padding-inline-end: 16px;\n      padding-inline-start: 50px;\n    }\n\n    & .search-icon {\n      position: absolute;\n     inset-inline-start:14px;\n      top: 2px;\n    }\n\n    & .form-control {\n      box-shadow: none;\n      &.form-control-lg + .search-icon {\n        position: absolute;\n       inset-inline-start:14px;\n        top: 6px;\n      }\n    }\n  }\n}\n\n.nav-searchbox .search-bar input {\n  & + .search-icon {\n    & i {\n      color: rgba($body-color, 0.8);\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .jr-card .app-main-header {\n    & .search-bar {\n      width: 150px;\n    }\n  }\n}","/* Pages\n   ========================================================================== */\n@import \"login\";\n@import \"error\";\n@import \"editor\";\n@import \"contact\";\n@import \"portfolio\";\n@import \"faq\";\n@import \"dashboard\";\n@import \"dropzone\";","/*Login Styles*/\n/*Login Styles*/\n\n.login-container {\n  position: relative;\n  height: 100%;\n}\n\n.login-content {\n  width: 420px;\n  margin: auto;\n  padding: 35px 35px 20px;\n  background-color: $white;\n  @include border-radius($border-radius-lg);\n  border: solid 1px $gray-400;\n  font-size: 14px;\n  max-width: 94%;\n}\n\n.login-header {\n  margin-bottom: 30px;\n}\n\n.login-content .form-control {\n  background-color: map_get($gray, lighten-4);\n\n  &:focus {\n    box-shadow: none;\n    border-color: $app-primary;\n  }\n}\n\n.login-content .btn, .login-content .jr-btn {\n  padding: 10px 35px !important;\n}\n\n.app-login-container {\n  position: relative;\n  max-width: 680px;\n  width: 94%;\n  margin: 0 auto;\n\n  & .loader-view {\n    position: absolute;\n   inset-inline-start:0;\n   inset-inline-end:0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    z-index: 2;\n  }\n}\n\n.app-login-main-content {\n  @include display-flex();\n  background-color: $white;\n  @include box-shadow($shadow);\n  @include border-radius(10px);\n  font-size: 14px;\n  overflow: hidden;\n}\n\n.app-login-content {\n  padding: 35px 35px 20px;\n  width: 60%;\n  order: 1;\n\n  @media screen and (max-width: 575px) {\n    width: 100%;\n    order: 2;\n  }\n}\n\n.app-login-header {\n  margin-bottom: 30px;\n}\n\n.app-login-content .form-control {\n  background-color: map_get($gray, lighten-4);\n\n  &:focus {\n    box-shadow: none;\n    border-color: $app-primary;\n  }\n}\n\n.app-login-content .btn, .login-content .jr-btn {\n  padding: 10px 35px !important;\n}\n\n.app-logo-content {\n  background-color: $app-primary;\n  padding: 35px 35px 20px;\n  width: 40%;\n  order: 2;\n\n  @media screen and (max-width: 575px) {\n    width: 100%;\n    order: 1;\n  }\n}\n\n.app-social-block {\n  @include display-flex();\n  @include align-items(center);\n  @include justify-content(space-between);\n\n  & .social-link,\n  & .social-link li {\n    margin: 0;\n  }\n\n  & .social-link span {\n    border: solid 1px $app-primary;\n    @include border-radius(50%);\n    color: $app-primary;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary;\n    }\n  }\n\n  & p {\n    margin-bottom: 0;\n  }\n}\n","/*Error Styles*/\n\n.page-error-container {\n  padding: 30px 0;\n  position: relative;\n\n  @media screen and (max-width: 575px) {\n    padding: 15px 0;\n  }\n}\n\n.page-error-content {\n  margin: 0 auto;\n  padding: 40px 0;\n  width: 380px;\n  max-width: 94%;\n\n  @media screen and (max-width: 767px) {\n    padding: 15px 0;\n  }\n\n  @media screen and (max-width: 575px) {\n    padding: 0;\n  }\n}\n\n.error-code {\n  color: $gray-900;\n  font-size: 160px;\n  text-align: center;\n  line-height: 1;\n  font-weight: 600;\n  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);\n\n  @media screen and (max-width: 991px) {\n    font-size: 130px;\n  }\n\n  @media screen and (max-width: 767px) {\n    font-size: 100px;\n  }\n\n  @media screen and (max-width: 575px) {\n    font-size: 80px;\n  }\n}\n\n.page-error-content h2 {\n  margin-bottom: $size-50;\n\n  @media screen and (max-width: 767px) {\n    margin-bottom: 20px;\n  }\n}\n","/*Editor Styles*/\n.rdw-inline-wrapper {\n  @include display-flex();\n}\n\n.rdw-option-wrapper {\n  margin-bottom: 6px;\n}\n","/*Contact Page Styles*/\n\n.contact-form {\n  padding: 60px;\n}\n\n.contact-block {\n  & .contact-info {\n    list-style: none;\n    padding-inline-start: 0;\n    margin-bottom: 0;\n    @include display-flex();\n    @include align-items(center);\n    -webkit-align-content: stretch;\n    -ms-flex-align: stretch;\n    align-content: stretch;\n\n    & li {\n      @include flex(1, 1, 0);\n      overflow: hidden;\n      padding: 10px 40px;\n      border-inline-end: 2px solid $body-color;\n      word-wrap: break-word;\n\n      &:last-child {\n        border: 0 none;\n      }\n\n      & > i {\n        float: inline-start;\n        font-size: 16px;\n        margin-inline-end:5px;\n      }\n\n      & .contact-body {\n        overflow: hidden;\n        & .icons-wrapper {\n          margin-top: 15px;\n          margin-inline-start:0;\n        }\n\n        & .icon {\n          background-color: map_get($indigo, 'lighten-1');\n          color: $white;\n          @include border-radius(50%);\n          margin-inline-end:6px;\n          margin-bottom: 6px;\n          &:last-child {\n            margin-inline-end:0;\n          }\n        }\n\n        & .twitter-icon {\n          background-color: map_get($light-blue, accent-2);\n        }\n\n        & .google-icon {\n          background-color: map_get($red, lighten-1);\n        }\n\n        & .linkedin-icon {\n          background-color: map_get($light-blue, darken-3);\n        }\n      }\n    }\n\n    &.vertical {\n      display: block;\n      margin-bottom: 0;\n      & li {\n        padding: 0 0 24px;\n        border-inline-end: 0 none;\n        border-bottom: 2px solid $body-color;\n        margin-bottom: 24px;\n\n        &:last-child {\n          border: 0 none;\n          margin-bottom: 0;\n          padding-bottom: 0;\n        }\n      }\n    }\n\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .contact-form {\n    padding: 30px;\n  }\n\n  .contact-block {\n    & .contact-info {\n      display: block;\n      margin-bottom: 0;\n      & li {\n        padding: 0 0 24px;\n        border-inline-end: 0 none;\n        border-bottom: 2px solid $body-color;\n        margin-bottom: 24px;\n\n        &:last-child {\n          border: 0 none;\n          margin-bottom: 0;\n          padding-bottom: 0;\n        }\n      }\n    }\n  }\n\n  .content-section {\n    padding: 20px 10px 0;\n    text-align: center;\n    & h2 {\n      font-size: 28px;\n    }\n    & p {\n      font-size: 18px;\n    }\n  }\n}\n","/*Portfolio Styles*/\n\n.portfolio-section {\n  & .card-image {\n    margin-bottom: 20px;\n    & img {\n      width: 100%;\n      @include transition(all 1200ms ease);\n    }\n    &:hover {\n      & img {\n        -webkit-transform: scale(1.08);\n        -ms-transform: scale(1.08);\n        transform: scale(1.08);\n      }\n    }\n  }\n}\n\n.filter-with-bg-color {\n  & ul {\n    padding-inline-start: 0;\n    margin: 0 -10px 45px;\n    & li {\n      display: inline-block;\n      margin-bottom: 10px;\n      padding: 0 10px;\n    }\n\n    & li a {\n      text-transform: uppercase;\n      font-size: 12px;\n      padding: 10px 24px;\n      border: 1px solid $app-primary;\n      display: block;\n      text-decoration: none;\n    }\n\n    & li a:hover,\n    & li a:focus,\n    & li a.active {\n      cursor: pointer;\n      background-color: $app-primary;\n      border-color: $app-primary;\n      color: $white;\n    }\n\n    @media screen and (max-width: 575px) {\n      margin-bottom: 15px;\n    }\n  }\n}","/*Faqs Styles*/\n\n.Collapsible {\n  margin-bottom: 15px;\n}\n\n//The content within the collaspable ChatUserList\n.Collapsible__contentInner {\n  padding: 20px;\n  border: 1px solid $gray-200;\n  background-color: $white;\n  border-top: 0;\n\n  p {\n    margin-bottom: 10px;\n    font-size: 14px;\n    line-height: 20px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.Collapsible__trigger {\n  display: block;\n  cursor: pointer;\n  font-weight: 400;\n  text-decoration: none;\n  position: relative;\n  padding: 18px 20px;\n  @include border-radius(8px);\n  background: theme-color(\"primary\");\n  color: $white;\n\n  &:after {\n    content: '\\f2f9';\n    font: {\n      family: 'Material-Design-Iconic-Font';\n      size: 20px;\n    }\n    position: absolute;\n   inset-inline-end:24px;\n    top: 16px;\n    display: block;\n    transition: transform 300ms;\n  }\n\n  &.is-open {\n    @include border-radius(8px 8px 0 0);\n    &:after {\n      transform: rotateZ(180deg);\n    }\n  }\n}\n\n//SideNav\n.categories-list {\n  margin-bottom: 0;\n  & li {\n    margin-bottom: 10px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  & li.active a {\n    color: $app-primary;\n  }\n  & .badge {\n    font-size: 9px;\n  }\n}\n\n.articles-section {\n  & .articles {\n    margin-bottom: 26px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.article-image {\n  display: block;\n  margin-bottom: 12px;\n  & > img {\n    @include border-radius(8px);\n    width: 100%;\n  }\n}\n\n.article-description {\n  & p {\n    font-weight: 500;\n    margin-bottom: 2px;\n  }\n}\n\n.meta-wrapper {\n  margin-bottom: 10px;\n}\n\n.meta-date,\n.meta-comment {\n  font-size: 14px;\n  color: $gray-500;\n  display: inline-block;\n  & i {\n    display: inline-block;\n    margin-inline-end:6px;\n  }\n}\n\n.meta-date {\n  & + .meta-comment {\n    margin-inline-start:10px;\n  }\n}\n\n\n","/*Dashboard Styles*/\n.box {\n  position: relative;\n\n  .box-top,\n  .box-bottom {\n    height: 100px;\n    padding: 32px 15px;\n    font-size: 40px;\n    line-height: 40px;\n    text-align: center;\n    font-weight: $display1-weight;\n    .size-h5 {\n      font-size: 24px;\n      margin-inline-start:2px;\n    }\n    .material-icons {\n      font-size: 40px;\n      line-height: 40px;\n    }\n  }\n\n  .box-bottom {\n    border-top: 1px solid rgba($black, .15);\n  }\n\n  .box-info {\n    position: absolute;\n    width: 100%;\n    top: 50%;\n    margin-top: -12px;\n    text-align: center;\n\n    span {\n      height: 24px;\n      display: inline-block;\n      padding: 4px 10px;\n      text-transform: uppercase;\n      line-height: 14px;\n      background-color: $white;\n      border: 1px solid rgba($black, .15);\n      font-size: 12px;\n      color: $text-muted;\n      border-radius: 1em;\n      .material-icons {\n        line-height: 14px;\n        font-size: 11px;\n      }\n    }\n  }\n}\n\n.contact-list {\n  margin-bottom: 14px;\n\n  & i {\n    margin-inline-end:14px;\n    color: theme-color(\"primary\");\n  }\n\n  & .media {\n    margin-bottom: 10px;\n  }\n}\n\n.temp-section {\n\n  .temp-point,\n  .detail-icon {\n    font-size: 54px;\n  }\n}\n\n.assignment-table {\n  & tbody tr:nth-child(odd) {\n    background-color: $gray-300 !important;\n  }\n  & td {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n}\n\n.status-cell {\n  min-width: 100px;\n  max-width: 120px;\n  padding-inline-end: 24px !important;\n  & .badge {\n    min-width: 70px;\n  }\n}\n\n.thumbnail-list {\n  margin-bottom: 0;\n  & .thumbnail-item {\n    padding: 0 2.5px;\n    display: inline-block;\n    width: 33.333%;\n    margin-bottom: 5px;\n\n    @media screen and (max-width: 767px) {\n      width: 50%;\n    }\n\n    @media screen and (max-width: 575px) {\n      width: 33.333%;\n    }\n  }\n}\n\n.post-list {\n  & .post-image .grid-thumb-equal {\n    padding-bottom: 100%;\n  }\n}\n\n/*Ecommerce Dashboard Styles*/\n.chart-f30 {\n  font-size: 30px;\n\n  @media screen and (max-width: 1099px) {\n    font-size: 20px;\n  }\n}\n\n.chart-f20 {\n  font-size: 20px;\n\n  @media screen and (max-width: 1099px) {\n    font-size: 16px;\n  }\n}\n\n.chart-order {\n  & .col-5 {\n    order: 2;\n    text-align: center;\n\n    @media screen and (max-width: 575px) {\n      order: 1;\n    }\n  }\n\n  & .col-7 {\n    order: 1;\n\n    @media screen and (max-width: 575px) {\n      order: 2;\n    }\n  }\n}\n\n.tab-notifications {\n  margin-inline-start:-$jr-card-margin + 4px;\n  margin-inline-end:-$jr-card-margin + 4px;\n  border-bottom: 1px solid $gray-500;\n\n  @media screen and (max-width: 567px) {\n    button,\n    button * {\n      font-size: 12px !important;\n    }\n  }\n}\n\n.chart-title {\n  & h2 {\n    font-size: 22px;\n    margin-bottom: 5px;\n  }\n}\n\n.img-fluid {\n  width: 100%;\n}\n\n.comment-footer {\n  & button {\n    margin-bottom: 6px;\n  }\n}\n\n/*Intranet Dashboard Styles*/\n.net-chart {\n  padding-inline-start: 80px;\n  padding-inline-end: 15px;\n  min-height: 100px;\n  position: relative;\n  overflow: hidden;\n  @include display-flex();\n  @include align-items(center);\n\n  & .jr-card-thumb {\n    margin: 0;\n    width: $size-50;\n    height: $size-50;\n    color: $white;\n    font-size: 20px;\n    @include border-radius($border-radius-circle);\n    @include display-flex(flex, column, nowrap);\n    @include justify-content(center);\n    @include align-items(center);\n    @include transition(all 100ms ease);\n    position: absolute;\n   inset-inline-start:15px;\n  }\n\n  &:hover .jr-card-thumb {\n    width: 70px;\n    height: 100%;\n    font-size: 30px;\n    @include border-radius(0);\n    position: absolute;\n   inset-inline-start:0;\n  }\n}\n\n.net-chart-hr {\n  @include display-flex();\n  @include align-items(center);\n  min-height: $size-120;\n  padding-inline-end: 8px;\n  overflow: hidden;\n\n  & .jr-card-thumb {\n    margin-block: -30px;\n    margin-inline-end: 12px;\n    margin-inline-start: -30px;\n    min-width: $size-100 + 5px;\n  }\n\n  & .grid-thumb-equal {\n    padding-bottom: 130%;\n  }\n\n  & .jr-card-body {\n    width: calc(100% - #{$size-100});\n  }\n}\n\n.user-profile {\n  padding: 10px 0;\n}\n\n.mh-120 {\n  min-height: $size-120;\n}\n\n.jr-card-header-top {\n  @include display-flex();\n  @include align-items(center);\n  margin-inline-end:-16px;\n}\n\n.jr-card-header-color {\n  padding: 10px 20px 20px;\n  margin: -24px -30px 25px;\n}\n\n.todo-cell-group {\n  & .todo-cell {\n    &:not(:last-child) {\n      margin-bottom: 8px;\n    }\n  }\n}\n\n.social-list-line {\n  position: relative;\n\n  &:not(:last-child):before {\n    border-inline-start: solid 1px $gray-500;\n    content: \"\";\n   inset-inline-start:20px;\n    position: absolute;\n    top: 5px;\n    bottom: 0;\n    width: 1px;\n    z-index: 1;\n  }\n}\n\n\n.list-line-item {\n  position: relative;\n  padding-inline-start: 40px;\n\n  &:not(:last-child):before {\n    border-inline-start: solid 1px $gray-500;\n    content: \"\";\n   inset-inline-start:20px;\n    position: absolute;\n    top: -25px;\n    bottom: -25px;\n    width: 1px;\n    z-index: 1;\n  }\n}\n\n.list-line-badge {\n  position: absolute;\n inset-inline-start:16px;\n  top: 15px;\n  z-index: 2;\n  @include border-radius(50%);\n  height: 10px;\n  width: 10px;\n  background-color: $gray-500;\n}\n\n.circle-shape {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  @include border-radius($border-radius-circle);\n}\n\n.project-list {\n  line-height: 1;\n\n  &:not(:last-child) {\n    margin-bottom: 20px;\n  }\n\n  & .circle-shape {\n    margin-top: 4px;\n    margin-inline-end:16px;\n  }\n\n  & .project-name {\n    display: block;\n    margin-bottom: 4px;\n    color: $body-color;\n\n    &:hover,\n    &:focus {\n      color: $app-primary;\n      text-decoration: none;\n    }\n  }\n}\n\n.nav-pill-sales {\n  & li + li {\n    margin-inline-end:-1px;\n  }\n  & .nav-link {\n    background-color: $gray-200;\n    border-radius: 0;\n    padding: 6px 15px;\n    color: $gray-600;\n    font-size: 13px;\n    border: $jr-border;\n\n    &.active {\n      background-color: $app-primary;\n      color: $white;\n      border-color: $app-primary;\n\n      &:hover,\n      &:focus {\n        color: $white;\n      }\n    }\n  }\n\n  & li:first-child .nav-link {\n    @include border-left-radius($border-radius);\n  }\n\n  & li:last-child .nav-link {\n    @include border-right-radius($border-radius);\n  }\n}\n\n.temp-week-list {\n  list-style: none;\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  color: lighten($gray-600, 8%);\n\n  & li:not(:last-child) {\n    margin-bottom: 10px;\n    @media screen and (max-width: 340px) {\n      margin-bottom: 20px;\n    }\n  }\n\n  & img {\n    width: 24px;\n    height: 24px;\n  }\n\n  & span {\n    display: inline-block;\n\n    &.temp-point {\n      margin: 0 20px;\n\n      @media screen and (max-width: 1199px) {\n        margin: 0 10px;\n      }\n\n      @media screen and (max-width: 1050px) {\n        margin: 0 5px;\n      }\n\n      @media screen and (max-width: 340px) {\n        margin: 0 20px;\n      }\n    }\n  }\n}\n\n.temp-section {\n\n  .temp-point {\n    font-size: 36px;\n    font-weight: 700;\n    margin-bottom: 0;\n\n    & sub,\n    & sup {\n      font-size: 70%;\n    }\n  }\n}\n\n\n","/*Dropzone Styles*/\n.dropzone-card {\n  position: relative;\n}\n\n.dropzone {\n  margin-bottom: 20px;\n\n  & > div {\n    margin: 0 auto;\n    padding: 15px;\n    @include display-flex(flex, column, nowrap);\n    @include justify-content(center);\n\n    & :last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  & .btn {\n    margin-top: 20px;\n  }\n}\n\n.upload-file-list {\n  list-style: none;\n  padding-inline-start: 0;\n\n  & li {\n    margin-bottom: 5px;\n  }\n}\n\n.form-group-dropzone {\n  & label {\n    margin-bottom: 6px;\n  }\n\n  & .form-control {\n    max-width: 200px;\n    margin: 0 auto;\n  }\n}\n","// assets/src/jsx/styles/pages/_home.scss\n.gdb-home {\n    max-width: 980px;\n    margin: 0 auto;\n    padding: 24px;\n}\n\n.gdb-home-hero {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    background: #fff;\n    border: 1px solid #e6e9ed;\n    border-radius: 10px;\n    padding: 28px;\n    padding-inline-start: 96px;  // extra breathing room on the leading edge (RTL-safe)\n\n    &__text { flex: 1.1; }\n    &__title { font-size: 22px; font-weight: 700; color: #1f2733; margin: 0 0 8px; }\n    &__subtitle { color: #69707a; font-size: 14px; line-height: 1.5; max-width: 360px; margin: 0 0 18px; }\n    &__actions { display: flex; gap: 10px; flex-wrap: wrap; }\n    &__actions a { text-decoration: none; }\n    &__actions .system-button i { margin-inline-end: 6px; }  // tight icon-to-label spacing\n    &__art { flex: 1; display: flex; justify-content: flex-end; }\n    &__art img { max-width: 100%; height: auto; }\n}\n\n.gdb-home-panel {\n    background: #fff;\n    border: 1px solid #e6e9ed;\n    border-radius: 10px;\n    padding: 16px 18px;\n    margin-top: 14px;\n\n    &__label {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 10px;\n        letter-spacing: .08em;\n        text-transform: uppercase;\n        color: #9aa1ab;\n        font-weight: 600;\n        margin-bottom: 8px;\n\n        a { color: #1b3a8b; text-transform: none; letter-spacing: 0; font-weight: 600; }\n    }\n}\n\n.gdb-home-recent {\n    &__list { display: flex; flex-direction: column; }\n    &__row {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 10px 8px;\n        border-bottom: 1px solid #f0f2f5;\n        border-radius: 6px;\n        color: inherit;\n        text-decoration: none;\n\n        &:hover { background: #f7f9fc; text-decoration: none; }\n        &:focus-visible { outline: 2px solid #1b3a8b; outline-offset: -2px; background: #f7f9fc; }\n        &:last-child { border-bottom: none; }\n    }\n    &__swatch { width: 8px; height: 26px; border-radius: 3px; flex: none; }\n    &__name { font-size: 13px; color: #1f2733; font-weight: 600; flex: 1; }\n    &__pill {\n        font-size: 9px;\n        font-weight: 700;\n        color: #a06a00;\n        background: #fff4e0;\n        border-radius: 10px;\n        padding: 1px 7px;\n        margin-inline-start: 8px;\n    }\n    &__when { font-size: 11px; color: #8a909a; white-space: nowrap; }\n    &__chev { color: #c2c8d0; font-size: 13px; }\n}\n\n.gdb-home-features {\n    background: #fbfcfd;\n\n    .gdb-home-panel__label { justify-content: center; margin-bottom: 14px; }\n    &__grid { display: flex; gap: 18px; }\n}\n\n.gdb-home-feature {\n    flex: 1;\n    text-align: center;\n    font-size: 11px;\n    color: #69707a;\n\n    &__icon { font-size: 18px; color: #9fb0d6; margin-bottom: 4px; display: block; }\n    b { color: #3a4250; display: block; font-size: 12px; margin-bottom: 2px; }\n}\n\n@media (max-width: 767px) {\n    .gdb-home-hero { flex-direction: column; text-align: center; }\n    .gdb-home-hero__art { justify-content: center; }\n    .gdb-home-features__grid { flex-direction: column; }\n}\n","/* Slider\n   ========================================================================== */\n.brand-logo {\n  @extend %thumb-equal;\n  border: 1px solid $gray-300;\n  background-color: $white;\n  @include border-radius($border-radius-lg);\n  margin-bottom: 20px;\n  padding-bottom: 75%;\n\n  & .brand-logo-inner {\n    @extend %thumb-cover;\n    text-align: center;\n\n    &:before {\n      content: \"\";\n      display: inline-block;\n      height: 100%;\n      vertical-align: middle;\n    }\n\n    & img {\n      height: auto;\n      max-height: 100%;\n      max-width: 100%;\n      display: inline-block;\n      vertical-align: middle;\n      width: auto !important;\n    }\n  }\n\n  &:hover {\n    @include transition(all 0.4s ease-in-out 0.1s);\n    background-color: darken($white, 5%);\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 15px;\n  }\n}\n\n.owl-app-frame {\n  &.owl-carousel .owl-item img {\n    display: inline-block;\n    width: auto;\n  }\n}\n\n.carousel-item {\n  & img {\n    max-width: 100%;\n  }\n}","/* Modules\n   ========================================================================== */\n@import \"app-module\";\n@import \"chat\";\n@import \"mail\";\n@import \"contact\";\n@import \"calendar\";","/* App Module Style */\n\n.app-wrapper-module {\n  @include display-flex(flex, column, nowrap);\n  @include align-items(stretch);\n  height: 100%;\n}\n\n.app-module {\n  position: relative;\n  @include display-flex(flex, row, nowrap);\n  margin-top: -36px;\n  margin-bottom: 0;\n  margin-inline: -40px;\n\n  @media screen and (max-width: 575px) {\n    margin: -20px;\n  }\n}\n\n.module-side {\n  position: relative;\n  z-index: 2;\n  @include display-flex(flex, column, nowrap);\n  @include flex(0, 1, 230px);\n  max-width: 230px;\n  min-width: 230px;\n}\n\n.module-side-header {\n  border-bottom: solid 1px $gray-200;\n  @include display-flex(flex, column, nowrap);\n\n  & .user-detail {\n    padding: 15px 10px;\n    text-align: center;\n  }\n}\n\n.module-logo {\n  padding: 10px;\n  @include display-flex();\n  @include align-items(center);\n  @include justify-content(center);\n  min-height: 78px;\n  font-size: 20px;\n  background-color: lighten($gray-100, 0.5%);\n  color: darken($gray-800, 2%);\n  & .zmdi {\n    font-size: 28px;\n  }\n}\n\n.module-user-info {\n  @include display-flex(flex, column, nowrap);\n}\n\n.module-user-detail {\n  font-size: 12px;\n}\n\n.module-side-content {\n  @extend .module-user-info;\n}\n\n.module-add-task {\n  @include display-flex();\n  padding: 24px;\n}\n\n.module-nav {\n  list-style: none;\n  padding-inline-start: 0;\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n\n  & li {\n    @include display-flex(flex, column, nowrap);\n  }\n\n  & li a {\n    padding: 12px 29px;\n    color: lighten($body-color, 20%);\n    @include display-flex();\n    @include align-items(center);\n    text-decoration: none;\n\n    &:hover,\n    &:focus {\n      color: $body-color;\n    }\n\n    &.active {\n      color: $app-primary;\n    }\n  }\n\n  & li i {\n    margin-inline-end:16px;\n    font-size: 16px;\n  }\n\n  & li span {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  & li.module-nav-label {\n    padding: 12px 29px;\n  }\n}\n\n.module-box {\n  position: relative;\n  z-index: 2;\n  @include display-flex(flex, column, nowrap);\n  @include flex(1, 1, auto);\n  max-width: calc(100% - 231px);\n}\n\n.module-box-header {\n  padding: 10px 26px;\n  min-height: 79px;\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n  background-color: $white;\n  border-bottom: solid 1px $gray-200;\n\n  & .search-bar.right-side-icon {\n    min-width: 350px;\n\n    & .form-control {\n      @include border-radius(0);\n      height: 46px;\n      padding-block: 10px;\n      padding-inline-end: 18px;\n      padding-inline-start: 40px;\n\n      &:focus {\n        background-color: $gray-100;\n      }\n    }\n\n    & .search-icon {\n      width: 25px;\n      height: 46px;\n      font-size: 16px;\n     inset-inline-start:10px;\n      top: 0;\n      padding: 0;\n    }\n  }\n}\n\n.module-box-header-inner {\n  @include display-flex();\n  @include align-items(center);\n  @include justify-content(space-between);\n}\n\n.module-box-content {\n  background-color: $white;\n  @include display-flex(flex, column, nowrap);\n}\n\n.module-box-topbar {\n  padding: 8px 12px;\n  @include display-flex();\n  border-bottom: solid 1px $gray-200;\n\n  & button + button {\n    @include border-radius(0);\n  }\n}\n\n.module-box-topbar-todo {\n  padding-inline-start: 64px;\n\n  @media screen and (max-width: 575px) {\n    padding-inline-start: 27px;\n  }\n}\n\n.module-list-icon {\n  @include display-flex();\n  @include align-items(center);\n  padding-inline-end: 10px;\n}\n\n.bar-icon {\n  margin-inline-end: 15px;\n}\n\n.toolbar-left {\n  margin-inline-start:auto;\n}\n\n.module-list {\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n}\n\n.module-list-item {\n  @include display-flex();\n  @include align-items(center);\n  padding: 15px 28px;\n  border-bottom: solid 1px $gray-200;\n  z-index: 5;\n  position: relative;\n  cursor: pointer;\n\n  & > .check-label {\n    margin-inline-start:0;\n    margin-bottom: 0;\n  }\n\n  &.mail-cell {\n    padding-inline-start: 12px;\n    @include align-items(start);\n  }\n}\n\n.module-detail-header {\n  margin-bottom: 10px;\n\n  & > .check-label {\n    margin-inline-end:auto;\n  }\n}\n\n.module-list-info {\n  @include flex(1, 1, 0);\n  @include display-flex(flex, column, nowrap);\n  max-width: calc(100% - 169px);\n}\n\n.module-todo-content {\n  position: relative;\n\n  & .subject {\n    margin-bottom: 5px;\n  }\n}\n\n.module-list-actions {\n  text-align: right;\n}\n\n.app-module-sidenav {\n  background-color: $white;\n  border-inline-end: solid 1px $gray-200;\n  position: relative;\n  z-index: 9;\n\n  & .chat-sidenav-main {\n    max-width: 300px;\n    min-width: 300px;\n    width: 90%;\n  }\n}\n\n.module-date {\n  max-width: 160px;\n\n  & > div:before {\n    display: none;\n  }\n}\n\n.module-detail-item {\n  padding: 10px 28px;\n}\n\n.task-title {\n  font-size: 18px;\n}\n\n.chat-todo-avatar {\n  margin-inline-end: 15px;\n}\n\n.modal-title {\n  @include display-flex();\n  @include justify-content(space-between);\n  @include align-items(center);\n  width: 100%;\n  font-size: 18px;\n}\n\n.loader-view-block {\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n  @include align-items(center);\n\n}\n\n.loader-view {\n  @extend .loader-view-block;\n}\n\n.module-date > div {\n  @include align-items(center);\n}\n\n@media screen and (max-width: 1199px) {\n  .module-side {\n    @include display-flex(block, row, nowrap);\n    @include flex(1);\n    max-width: $side-nav-width;\n    min-width: $side-nav-width;\n    background-color: $white;\n  }\n\n  .module-box-header {\n    position: relative;\n    min-height: 58px;\n    padding-block: 5px;\n    padding-inline-end: 26px;\n    padding-inline-start: 75px;\n\n    & .drawer-btn {\n      position: absolute;\n     inset-inline-start:0;\n      top: 0;\n      z-index: 1;\n      border-inline-end: solid 1px $gray-200;\n      height: 58px;\n      width: 56px;\n      @include border-radius(0);\n      font-size: 22px;\n    }\n\n    & .search-bar.right-side-icon .form-control {\n      height: 38px;\n      padding-block: 5px;\n      padding-inline-end: 18px;\n      padding-inline-start: 40px;\n    }\n\n    & .search-bar.right-side-icon .search-icon {\n      height: 38px;\n    }\n  }\n\n  .chat-loader-view {\n    height: calc(100vh - 120px);\n  }\n\n  .module-box {\n    max-width: 100%;\n  }\n}\n\n@media screen and (min-width: 991px) {\n  .modal-dialog {\n    max-width: 750px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .app-module {\n    padding-top: 0;\n  }\n}\n\n@media screen and (max-width: 599px) {\n  .module-box-header .search-bar {\n    margin-inline-start:0;\n    max-width: none;\n\n    &.right-side-icon {\n      min-width: 250px;\n    }\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .module-list-item {\n    padding: 10px 12px;\n  }\n\n  .module-list-info {\n    max-width: 100%;\n  }\n\n  .module-box-header {\n    & .nav-searchbox.quick-menu .dropdown-menu {\n     inset-inline-end:auto !important;\n     inset-inline-start:0 !important;\n    }\n\n    & .search-bar.right-side-icon {\n      min-width: 200px;\n\n      & .form-control {\n        @include border-radius(0.25rem);\n      }\n    }\n\n    & .nav-searchbox.quick-menu .dropdown-menu {\n      &:after {\n       inset-inline-end:auto;\n       inset-inline-start:9px;\n      }\n\n      &:before {\n       inset-inline-end:auto;\n       inset-inline-start:9px;\n      }\n    }\n\n    & .search-bar {\n      padding-inline-end: 2px;\n    }\n  }\n}\n\n@media screen and (max-width: 399px) {\n  .module-box-header {\n    & .search-bar.right-side-icon {\n      min-width: 100px;\n    }\n  }\n}\n\n@media screen and (min-width: 399px) {\n  .d-xs-flex {\n    display: flex !important;\n  }\n}\n","/*Chat Module Styles*/\n\n.chat-module {\n  @include flex();\n\n  &:before {\n   inset-inline-start:-29px;\n  }\n}\n\n.chat-module-box {\n  @include display-flex(flex, row, nowrap);\n  @include flex(1);\n  background-color: $gray-100;\n  position: relative;\n  width: 100%;\n}\n\n.chat-sidenav {\n  @include display-flex(flex, column, nowrap);\n  @include flex(0, 1, 315px);\n  min-width: 315px;\n  border-inline-end: solid 1px $gray-200;\n}\n\n.chat-box {\n  @include display-flex(flex, column, nowrap);\n  @include flex(1);\n  max-width: 100%;\n  position: relative;\n  z-index: 2;\n}\n\n.chat-sidenav-header {\n  @include display-flex(flex, column, nowrap);\n  padding: 25px 20px 12px;\n  background-color: lighten($gray-100, 0.5%);\n}\n\n.chat-user-hd {\n  @include display-flex();\n  margin-bottom: 25px;\n}\n\n.chat-sidenav-header .search-wrapper {\n  @include display-flex(flex, column, nowrap);\n  margin-bottom: 0;\n\n  & .search-bar.right-side-icon {\n    @include flex();\n\n    & .form-control {\n      @include box-shadow(none);\n      @include border-radius(0);\n      padding-inline-start: 42px;\n      height: 42px;\n    }\n\n    & .search-icon {\n     inset-inline-start:10px;\n      top: 0;\n      height: 42px;\n      padding: 0;\n    }\n  }\n}\n\n.chat-avatar {\n  min-width: $size-50;\n\n  .chat-user-item & {\n    padding: 0 5px;\n    min-width: 10px;\n  }\n\n  .chat-user-hd & {\n    cursor: pointer;\n  }\n}\n\n.chat-avatar-mode {\n  position: relative;\n  max-width: $size-50;\n\n  & .chat-mode {\n    display: block;\n    position: absolute;\n   inset-inline-start:0;\n    top: 2px;\n    z-index: 1;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n\n    &.small {\n      width: 8px;\n      height: 8px;\n    }\n\n    &.online {\n      background-color: map_get($green, base);\n      @extend %online-effect;\n    }\n\n    &.offline {\n      background-color: $white;\n      border: solid 1px map_get($green, base);\n      @extend %online-effect;\n    }\n\n    &.away {\n      background-color: map_get($yellow, darken-1);\n      @extend %away-effect;\n    }\n  }\n\n  .chat-main-header-info & {\n    max-width: $size-60;\n  }\n}\n\n.chat-sidenav-content {\n  background-color: $white;\n}\n\n.chat-sidenav-title {\n  padding: 10px 16px;\n  font-size: $font-size-base;\n  color: $info;\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n}\n\n.chat-tabs-header {\n  background-color: lighten($gray-100, 0.5%) !important;\n}\n\n.chat-user {\n  @include display-flex(flex, column, nowrap);\n\n  &.chat-user-center {\n    @include justify-content(center);\n    @include align-items(center);\n\n    & .chat-avatar {\n      margin-inline-start:auto;\n    }\n  }\n}\n\n.chat-user-item {\n  border-bottom: solid 1px $gray-200;\n  padding: 16px;\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n  cursor: pointer;\n  max-height: 96px;\n\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary, 45%);\n  }\n}\n\n.chat-user-row {\n  margin: 0 -5px;\n  @include align-items(center);\n}\n\n.chat-info {\n  padding: 0 5px;\n\n  & p {\n    margin-bottom: 0;\n  }\n\n  & .h4 {\n    display: block;\n    margin-bottom: 3px;\n  }\n}\n\n.chat-info-des {\n  color: $gray-600;\n  font-size: 13px;\n}\n\n.chat-date {\n  padding: 0 5px;\n  text-align: right;\n}\n\n.chat-contact-col {\n  @extend .chat-info;\n}\n\n.chat-box-main {\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n  height: 100%;\n}\n\n.module-default {\n  @include display-flex(flex, column, nowrap);\n  @include justify-content(center);\n  @include align-items(center);\n  height: 100%;\n  padding: 15px;\n}\n\n.s-128 {\n  font-size: 128px !important;\n  width: 128px !important;\n  height: 128px !important;\n  line-height: 128px !important;\n  margin-bottom: 12px;\n}\n\n.chat-main {\n  @include display-flex(flex, column, nowrap);\n}\n\n.chat-main-header {\n  @include display-flex();\n  @include align-items(center);\n  border-bottom: solid 1px $gray-200;\n  padding: 16px;\n  background-color: $white;\n  width: 100%;\n}\n\n.chat-main-header-info {\n  @include display-flex();\n  @include align-items(center);\n  margin-inline-end:auto;\n}\n\n.chat-contact-name {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.chat-main-footer {\n  @include display-flex(flex, column, nowrap);\n  border-top: solid 1px $gray-200;\n  padding: 16px;\n  background-color: $white;\n  width: 100%;\n\n  & .form-group {\n    margin-bottom: 0;\n  }\n}\n\n.todo-main-footer {\n  padding: 6px 16px;\n}\n\n.chat-item {\n  padding: 16px;\n\n  & .bubble {\n    padding: 8px 12px;\n    background-color: $white;\n    @include border-radius(20px 20px 20px 0px);\n    position: relative;\n    margin-inline-start:16px;\n    max-width: 600px;\n    border: solid 1px $gray-400;\n  }\n\n  &.flex-row-reverse {\n    & .bubble {\n      margin-inline-end:16px;\n      margin-inline-start:0;\n      background-color: lighten($app-primary, 45%);\n      @include border-radius(20px 20px 0 20px);\n    }\n  }\n}\n\n.chat-btn {\n  font-size: 38px !important;\n  margin-block: 0;\n  margin-inline-end: 10px;\n  margin-inline-start: -8px;\n}\n\n.chat-textarea {\n  height: 40px;\n  @include box-shadow(none);\n  @include border-radius(0);\n}\n\n.last-message-time {\n  font-size: 11px;\n  color: $gray-500;\n}\n\n@media screen and (max-width: 1399px) {\n  .s-128 {\n    font-size: 100px !important;\n    width: 100px !important;\n    height: 100px !important;\n    line-height: 100px !important;\n  }\n}\n\n@media screen and (max-width: 1199px) {\n  .chat-module {\n    margin: -24px -29px -23px;\n    padding-top: 0;\n  }\n\n  .chat-main-header {\n    padding: 8px 24px;\n\n    & .size-60 {\n      height: 50px !important;\n      width: 50px !important;\n      line-height: 50px;\n    }\n\n    & button {\n      margin-bottom: 0;\n    }\n  }\n\n  .chat-main-header-info {\n    & .chat-avatar-mode {\n      max-width: 50px;\n    }\n  }\n\n  .chat-contact-name,\n  .chat-sidenav-title {\n    font-size: 16px;\n  }\n\n  .chat-main-footer {\n    padding: 8px 16px;\n  }\n\n  .s-128 {\n    font-size: 128px !important;\n    width: 128px !important;\n    height: 128px !important;\n    line-height: 128px !important;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .s-128 {\n    font-size: 100px !important;\n    width: 100px !important;\n    height: 100px !important;\n    line-height: 100px !important;\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .chat-sidenav-title,\n  .chat-contact-name {\n    font-size: 15px;\n  }\n\n  .s-128 {\n    font-size: 80px !important;\n    width: 80px !important;\n    height: 80px !important;\n    line-height: 80px !important;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .module-default {\n    h1 {\n      font-size: 17px;\n    }\n  }\n  .s-128 {\n    font-size: 40px !important;\n    width: 40px !important;\n    height: 40px !important;\n    line-height: 40px !important;\n  }\n}\n\n","/*Mails Module Styles*/\n\n.module-box-row {\n  @include display-flex();\n  width: 100%;\n}\n\n.module-box-column {\n  @include display-flex(flex, column, nowrap);\n  width: 100%;\n}\n\n.mail-user-info {\n  @include display-flex();\n  @include align-items(center);\n\n  & .avatar {\n    margin-inline-end:10px;\n  }\n\n  & .time,\n  & button {\n    margin-inline-start:auto;\n  }\n\n  & .badge {\n    margin-bottom: 0;\n  }\n}\n\n.module-list-item.mail-cell {\n  @include display-flex();\n}\n\n.mail-detail {\n  padding: 24px !important;\n}\n\n.mail-header {\n  @include display-flex();\n  @include align-items(center);\n}\n\n.mail-header-content {\n  @include display-flex(flex, column, nowrap);\n\n  & .subject {\n    margin-bottom: 5px;\n  }\n}\n\n.show-detail {\n  cursor: pointer;\n}\n\n.text-truncate {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.module-list-content {\n  & .subject {\n    @extend .text-truncate;\n  }\n\n  & .message {\n    @include display-flex(flex, column, nowrap);\n    color: darken($gray-500, 10%);\n    font-size: 13px;\n\n    p {\n      @extend .text-truncate;\n      margin-bottom: 8px;\n    }\n  }\n}\n\n.size {\n  margin: 5px 0;\n}\n\n.sender-name {\n  margin-inline-end:0;\n  font-weight: 500;\n  font-size: 15px;\n}\n\n.mail-header-actions {\n  text-align: right;\n  min-width: 100px;\n  @include display-flex();\n\n  & .icon-btn:not(:last-child) {\n    margin-inline-end:3px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .module-list-item.mail-cell {\n    padding-inline-end: 20px;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .mail-list {\n    @include flex(1, 1, auto);\n    max-width: 100%;\n    border-inline-end: 0 none;\n  }\n\n  .mail-detail {\n    @include flex(1, 1, auto);\n    max-width: 100%;\n\n    & .module-list-scroll {\n      padding: 24px;\n    }\n  }\n}\n\n@media screen and (max-width: 499px) {\n  .mail-header {\n    display: block;\n    @include align-items(flex-start);\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n\n  .mail-header-actions {\n    text-align: left;\n    min-width: 10px;\n  }\n\n  .MuiDialog-paperWidthSm-99 {\n    max-width: 250px !important;\n  }\n}","/*Contact Module Styles*/\n\n.contact-item {\n  @include align-items(center);\n  @include display-flex();\n  border-bottom: solid 1px $gray-200;\n  padding: 8px 12px;\n}\n\n.contact-name {\n  font-size: 15px;\n}\n\n.modal-box {\n  position: relative;\n}\n\n.modal-w {\n  max-width: 400px;\n  min-width: 350px;\n\n  .modal-box-mail & {\n    min-width: 600px;\n  }\n}\n\n.modal-box-header {\n  color: $white;\n  @include border-top-radius(4px);\n}\n\n.modal-box-header h2 {\n  color: $white;\n  position: relative;\n\n  & button {\n    position: absolute;\n   inset-inline-end:0;\n    top: -10px;\n    z-index: 1;\n    color: $white;\n  }\n}\n\n.modal-box-content {\n  padding: 24px;\n\n  & .avatar {\n    margin: 0 auto;\n  }\n}\n\n.modal-box-footer {\n  padding: 0 24px 24px;\n\n  & .attach-file {\n    @include display-flex();\n    @include align-items(center);\n    margin-bottom: 15px;\n  }\n}\n\n.btn-fixed {\n  position: fixed !important;\n inset-inline-end:40px;\n  bottom: 60px;\n  z-index: 100;\n}\n\n.draggable-icon {\n  cursor: all-scroll;\n  color: $gray-600;\n\n  &:hover,\n  &:focus,\n  &:active {\n    cursor: all-scroll;\n    color: $gray-900;\n  }\n}\n\n.module-side-nav {\n  padding: 20px 0;\n}\n\n@media screen and (max-width: 767px) {\n  .modal-w {\n    .modal-box-mail & {\n      min-width: 500px;\n    }\n  }\n\n  .modal-box-header h2 {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .modal-w {\n    min-width: 300px;\n\n    .modal-box-mail & {\n      min-width: 400px;\n    }\n  }\n\n  .modal-box-header h2 {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 419px) {\n  .modal-w {\n    min-width: 250px;\n\n    .modal-box-mail & {\n      min-width: 250px;\n    }\n  }\n}\n\n@media screen and (max-width: 399px) {\n  .con-inf-mw-100 {\n    min-width: 100% !important;\n  }\n}\n","/* Calendar Module Style */\n\n.rbc-calendar {\n  .app-calendar & {\n    @include display-flex(flex, column, nowrap);\n    @include flex(1);\n    min-height: calc(100vh - 160px);\n  }\n\n  .app-cul-calendar & {\n    min-height: calc(100vh - 200px);\n  }\n}\n\n.rbc-event {\n  background-color: $app-primary;\n}\n\n.rbc-event.rbc-selected {\n  background-color: darken($app-primary, 10%);\n}\n\n.rbc-slot-selection {\n  background-color: rgba($app-primary, 0.7);\n}\n\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  color: $white;\n  background-image: none;\n  @include box-shadow(none);\n  background-color: rgba($app-primary, 0.9);\n  border-color: $app-primary;\n}\n\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:focus {\n  color: $white;\n  background-color: rgba($app-primary, 0.9);\n  border-color: $app-primary;\n}\n\n.rbc-toolbar button:focus {\n  color: $white;\n  background-color: rgba($app-primary, 0.9);\n  border-color: $app-primary;\n}\n\n.rbc-toolbar button:hover {\n  color: $white;\n  background-color: rgba($app-primary, 0.9);\n  border-color: $app-primary;\n}\n\n.rbc-month-row {\n  min-height: 100px;\n}\n\n.rbc-event {\n  min-height: 50px;\n}\n\n@media screen and (max-width: 867px) {\n  .rbc-toolbar {\n    @include display-flex(flex, column, nowrap);\n    @include align-items(flex-start);\n  }\n\n  .rbc-toolbar .rbc-toolbar-label {\n    margin: 8px 0;\n  }\n}\n\n@media screen and (max-height: 600px) {\n  .rbc-calendar {\n    .app-calendar & {\n      min-height: 400px;\n    }\n\n    .app-cul-calendar & {\n      min-height: 400px;\n    }\n  }\n}\n\n@media screen and (max-width: 467px) {\n  .rbc-toolbar {\n    font-size: 12px;\n  }\n\n  .rbc-toolbar button {\n    padding: 5px 10px;\n  }\n}\n\n","/* Color Theme\n   ========================================================================== */\n@import \"theme-indigo\";\n@import \"theme-cyan\";\n@import \"theme-amber\";\n@import \"theme-deep-orange\";\n@import \"theme-pink\";\n@import \"theme-blue\";\n@import \"theme-deep-purple\";\n@import \"theme-green\";\n@import \"theme-dark-indigo\";\n@import \"theme-dark-cyan\";\n@import \"theme-dark-amber\";\n@import \"theme-dark-deep-orange\";\n@import \"theme-dark-pink\";\n@import \"theme-dark-blue\";\n@import \"theme-dark-deep-purple\";\n@import \"theme-dark-green\";\n@import \"dark-theme\";","/*Theme Indigo Styles*/\n$app-primary-indigo: #3f51b5 !default;\n$secondary-indigo: #FF4081;\n\n$sidebar-indigo: $white !default;\n$sidebar-text-indigo: #868e96 !default;\n\n//-Base-scss\n.indigo .right-arrow {\n  color: $app-primary-indigo;\n  &:after {\n    color: $app-primary-indigo;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .indigo .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .indigo a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .indigo .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-indigo);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .indigo a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-indigo);\n    }\n  }\n}\n\n.indigo .btn-outline-primary,\n.indigo a.btn-outline-primary {\n  color: $app-primary-indigo;\n  border-color: $app-primary-indigo;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-indigo;\n    background-color: $app-primary-indigo;\n  }\n}\n\n.indigo .btn-outline-secondary,\n.indigo a.btn-outline-secondary {\n  color: $secondary-indigo;\n  border-color: $secondary-indigo;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-indigo;\n    background-color: $secondary-indigo;\n  }\n}\n\n\n//Bootstrap file Style\n.indigo {\n  & a,\n  & a.text-primary {\n    color: $app-primary-indigo;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-indigo, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-indigo !important;\n  }\n\n  & .page-link {\n    color: $app-primary-indigo;\n    &:focus,\n    &:hover {\n      color: $app-primary-indigo;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-indigo !important;\n    color: $sidebar-indigo !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-indigo;\n    border-color: $app-primary-indigo;\n    color: $sidebar-indigo;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-indigo, 5%) !important;\n      border-color: darken($app-primary-indigo, 5%) !important;\n      color: $sidebar-indigo !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #c5cae9 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #9fa8da !important;\n    }\n\n    &.lighten-2 {\n      background-color: #7986cb !important;\n    }\n\n    &.lighten-1 {\n      background-color: #5c6bc0 !important;\n    }\n\n    &.darken-1 {\n      background-color: #3949ab !important;\n    }\n\n    &.darken-2 {\n      background-color: #303f9f !important;\n    }\n\n    &.darken-3 {\n      background-color: #283593 !important;\n    }\n\n    &.darken-4 {\n      background-color: #1a237e !important;\n    }\n\n    &.accent-1 {\n      background-color: #8c9eff !important;\n    }\n\n    &.accent-2 {\n      background-color: #536dfe !important;\n    }\n\n    &.accent-3 {\n      background-color: #3d5afe !important;\n    }\n\n    &.accent-4 {\n      background-color: #304ffe !important;\n    }\n  }\n}\n\n//Secondary\n.indigo {\n  & a.text-secondary {\n    color: $secondary-indigo;\n    &:focus,\n    &:hover {\n      color: darken($secondary-indigo, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-indigo !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-indigo !important;\n    color: $sidebar-indigo !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-indigo;\n    border-color: $secondary-indigo;\n    color: $sidebar-indigo;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-indigo, 5%) !important;\n      border-color: darken($secondary-indigo, 5%) !important;\n      color: $sidebar-indigo !important;\n    }\n  }\n}\n\n//flat-btn\n.indigo .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.indigo .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-indigo !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-indigo, 0.12) !important;\n    color: $app-primary-indigo !important;\n  }\n}\n\n.indigo .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.indigo .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-indigo !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-indigo, 0.12) !important;\n    color: $secondary-indigo !important;\n  }\n}\n\n.indigo .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.indigo .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.indigo .color-theme-header {\n  background-color: $app-primary-indigo;\n\n}\n\n//_sidebar.scss\n.indigo .side-nav {\n  background-color: $sidebar-indigo !important;\n  color: $sidebar-text-indigo !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-indigo !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-indigo, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-indigo;\n    }\n  }\n}\n\n.indigo ul.nav-menu li a {\n  color: $sidebar-text-indigo;\n}\n\n.indigo ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-indigo;\n  }\n}\n\n.indigo ul.nav-menu > li.open > a,\n.indigo ul.nav-menu > li > a:hover,\n.indigo ul.nav-menu > li > a:focus {\n  background-color: $sidebar-indigo;\n  color: $app-primary-indigo;\n}\n\n.indigo ul.nav-menu li.menu > a:focus:before,\n.indigo ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-indigo;\n}\n\n.indigo ul.nav-menu li ul {\n  background-color: $sidebar-indigo;\n}\n\n.indigo ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-indigo;\n}\n\n.indigo ul.nav-menu li.menu.open > a:before,\n.indigo ul.nav-menu li.menu > a:focus:before,\n.indigo ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-indigo;\n}\n\n.indigo ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-indigo;\n}\n\n.indigo ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-indigo;\n}\n\n.indigo ul.nav-menu li.menu .sub-menu li > a:hover,\n.indigo ul.nav-menu li.menu .sub-menu li > a:focus,\n.indigo ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.indigo ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.indigo ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-indigo;\n  color: $app-primary-indigo;\n}\n\n/*Header top Navbar Styles*/\n.indigo .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-indigo;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-indigo;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-indigo;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-indigo;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-indigo;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-indigo;\n    }\n  }\n}\n\n.indigo .app-top-nav {\n  background-color: $app-primary-indigo;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-indigo;\n    }\n  }\n}\n\n//_app-module.scss\n.indigo .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-indigo;\n    }\n  }\n}\n\n//_calendar.scss\n.indigo .rbc-event {\n  background-color: $app-primary-indigo;\n}\n\n.indigo .rbc-event.rbc-selected {\n  background-color: darken($app-primary-indigo, 10%);\n}\n\n.indigo .rbc-slot-selection {\n  background-color: rgba($app-primary-indigo, 0.7);\n}\n\n.indigo .rbc-toolbar button:active,\n.indigo .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-indigo, 0.9);\n  border-color: $app-primary-indigo;\n}\n\n.indigo .rbc-toolbar button:active:hover,\n.indigo .rbc-toolbar button.rbc-active:hover,\n.indigo .rbc-toolbar button:active:focus,\n.indigo .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-indigo, 0.9);\n  border-color: $app-primary-indigo;\n}\n\n.indigo .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-indigo, 0.9);\n  border-color: $app-primary-indigo;\n}\n\n.indigo .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-indigo, 0.9);\n  border-color: $app-primary-indigo;\n}\n\n.indigo .rbc-day-slot .rbc-event {\n  border-color: $app-primary-indigo;\n}\n\n//_chat.scss\n.indigo .chat-sidenav-title {\n  color: $app-primary-indigo;\n}\n\n.indigo .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-indigo, 45%);\n  }\n}\n\n//_dashboard.scss\n.indigo .contact-list {\n  & i {\n    color: $app-primary-indigo;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.indigo .Collapsible__trigger {\n  background: $app-primary-indigo;\n}\n\n.indigo .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-indigo;\n  }\n}\n\n//_login.scss\n\n.indigo .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-indigo;\n  }\n}\n\n//_portfolio.scss\n.indigo .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-indigo;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-indigo;\n    }\n  }\n}\n\n//_card.scss\n.indigo .profile-intro {\n  & .icon {\n    color: $app-primary-indigo;\n  }\n}\n\n.indigo .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-indigo;\n  }\n}\n\n//_tables.scss\n.indigo .actions {\n  color: $secondary-indigo;\n}\n\n.indigo .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-indigo, 0.075);\n}\n\n//Border Color\n\n.indigo .border-primary {\n  border-color: $app-primary-indigo !important;\n}\n\n// login page content\n\n.indigo .app-logo-content {\n  background-color: $app-primary-indigo;\n}\n\n.indigo .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-indigo;\n    color: $app-primary-indigo;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-indigo;\n    }\n  }\n}\n\n.indigo .btn-group,\n.indigo .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-indigo;\n      border-color: $app-primary-indigo;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-indigo !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-indigo, 0.12) !important;\n        color: $app-primary-indigo !important;\n      }\n    }\n  }\n}\n\n.indigo .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-indigo;\n    border-color: $app-primary-indigo;\n  }\n}\n\n.indigo .form-checkbox > input + .check,\n.indigo .form-checkbox > input.sm + .check {\n  color: $app-primary-indigo;\n}\n\n\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n    } @else {\n      box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  background-color: transparent;\n  background-image: none;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  font-size: $font-size;\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @if $enable-rounded {\n    border-radius: $border-radius;\n  } @else {\n    border-radius: 0;\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: #555, $end-color: #333, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: #555, $end-color: #333, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: #555, $end-color: #333, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-x-three-colors($start-color: #00b3ee, $mid-color: #7a43b6, $color-stop: 50%, $end-color: #c3325f) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n\n@mixin gradient-y-three-colors($start-color: #00b3ee, $mid-color: #7a43b6, $color-stop: 50%, $end-color: #c3325f) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n\n@mixin gradient-radial($inner-color: #555, $outer-color: #333) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n\n@mixin gradient-striped($color: rgba(255,255,255,.15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","/*Theme Cyan Styles*/\n$app-primary-cyan: #00bcd4 !default;\n$secondary-cyan: #69F0AE;\n\n$sidebar-cyan: $white !default;\n$sidebar-text-cyan: #868e96 !default;\n\n// Links\n$link-color: $sidebar-text-color;\n$link-hover-color: $app-primary;\n\n//-Base-scss\n.cyan .right-arrow {\n  color: $app-primary-cyan;\n  &:after {\n    color: $app-primary-cyan;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .cyan .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .cyan a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .cyan .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-cyan);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .cyan a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-cyan);\n    }\n  }\n}\n\n.cyan .btn-outline-primary,\n.cyan a.btn-outline-primary {\n  color: $app-primary-cyan;\n  border-color: $app-primary-cyan;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-cyan;\n    background-color: $app-primary-cyan;\n  }\n}\n\n.cyan .btn-outline-secondary,\n.cyan a.btn-outline-secondary {\n  color: $secondary-cyan;\n  border-color: $secondary-cyan;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-cyan;\n    background-color: $secondary-cyan;\n  }\n}\n\n//Bootstrap file Style\n.cyan {\n  & a,\n  & a.text-primary {\n    color: $app-primary-cyan;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-cyan, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-cyan !important;\n  }\n\n  & .page-link {\n    color: $app-primary-cyan;\n    &:focus,\n    &:hover {\n      color: $app-primary-cyan;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-cyan !important;\n    color: $sidebar-cyan !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-cyan;\n    border-color: $app-primary-cyan;\n    color: $sidebar-cyan;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-cyan, 5%) !important;\n      border-color: darken($app-primary-cyan, 5%) !important;\n      color: $sidebar-cyan !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #b2ebf2 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #80deea !important;\n    }\n\n    &.lighten-2 {\n      background-color: #4dd0e1 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #26c6da !important;\n    }\n\n    &.darken-1 {\n      background-color: #00acc1 !important;\n    }\n\n    &.darken-2 {\n      background-color: #0097a7 !important;\n    }\n\n    &.darken-3 {\n      background-color: #00838f !important;\n    }\n\n    &.darken-4 {\n      background-color: #006064 !important;\n    }\n\n    &.accent-1 {\n      background-color: #84ffff !important;\n    }\n\n    &.accent-2 {\n      background-color: #18ffff !important;\n    }\n\n    &.accent-3 {\n      background-color: #00e5ff !important;\n    }\n\n    &.accent-4 {\n      background-color: #00b8d4 !important;\n    }\n  }\n}\n\n//Secondary\n.cyan {\n  & a.text-secondary {\n    color: $secondary-cyan;\n    &:focus,\n    &:hover {\n      color: darken($secondary-cyan, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-cyan !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-cyan !important;\n    color: $sidebar-cyan !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-cyan;\n    border-color: $secondary-cyan;\n    color: $sidebar-cyan;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-cyan, 5%) !important;\n      border-color: darken($secondary-cyan, 5%) !important;\n      color: $sidebar-cyan !important;\n    }\n  }\n}\n\n//flat-btn\n.cyan .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.cyan .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-cyan !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-cyan, 0.12) !important;\n    color: $app-primary-cyan !important;\n  }\n}\n\n.cyan .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.cyan .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-cyan !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-cyan, 0.12) !important;\n    color: $secondary-cyan !important;\n  }\n}\n\n.cyan .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.cyan .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.cyan .color-theme-header {\n  background-color: $app-primary-cyan;\n}\n\n//_sidebar.scss\n.cyan .side-nav {\n  background-color: $sidebar-cyan !important;\n  color: $sidebar-text-cyan !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-cyan !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-cyan, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-cyan;\n    }\n  }\n}\n\n.cyan ul.nav-menu li a {\n  color: $sidebar-text-cyan;\n}\n\n.cyan ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-cyan;\n  }\n}\n\n.cyan ul.nav-menu > li.open > a,\n.cyan ul.nav-menu > li > a:hover,\n.cyan ul.nav-menu > li > a:focus {\n  background-color: $sidebar-cyan;\n  color: $app-primary-cyan;\n}\n\n.cyan ul.nav-menu li.menu > a:focus:before,\n.cyan ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-cyan;\n}\n\n.cyan ul.nav-menu li ul {\n  background-color: $sidebar-cyan;\n}\n\n.cyan ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-cyan;\n}\n\n.cyan ul.nav-menu li.menu.open > a:before,\n.cyan ul.nav-menu li.menu > a:focus:before,\n.cyan ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-cyan;\n}\n\n.cyan ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-cyan;\n}\n\n.cyan ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-cyan;\n}\n\n.cyan ul.nav-menu li.menu .sub-menu li > a:hover,\n.cyan ul.nav-menu li.menu .sub-menu li > a:focus,\n.cyan ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.cyan ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.cyan ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-cyan;\n  color: $app-primary-cyan;\n}\n\n/*Header top Navbar Styles*/\n.cyan .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-cyan;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-cyan;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-cyan;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-cyan;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-cyan;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-cyan;\n    }\n  }\n}\n\n.cyan .app-top-nav {\n  background-color: $app-primary-cyan;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-cyan;\n    }\n  }\n}\n\n//_app-module.scss\n.cyan .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-cyan;\n    }\n  }\n}\n\n//_calendar.scss\n.cyan .rbc-event {\n  background-color: $app-primary-cyan;\n}\n\n.cyan .rbc-event.rbc-selected {\n  background-color: darken($app-primary-cyan, 10%);\n}\n\n.cyan .rbc-slot-selection {\n  background-color: rgba($app-primary-cyan, 0.7);\n}\n\n.cyan .rbc-toolbar button:active,\n.cyan .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-cyan, 0.9);\n  border-color: $app-primary-cyan;\n}\n\n.cyan .rbc-toolbar button:active:hover,\n.cyan .rbc-toolbar button.rbc-active:hover,\n.cyan .rbc-toolbar button:active:focus,\n.cyan .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-cyan, 0.9);\n  border-color: $app-primary-cyan;\n}\n\n.cyan .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-cyan, 0.9);\n  border-color: $app-primary-cyan;\n}\n\n.cyan .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-cyan, 0.9);\n  border-color: $app-primary-cyan;\n}\n\n.cyan .rbc-day-slot .rbc-event {\n  border-color: $app-primary-cyan;\n}\n\n//_chat.scss\n.cyan .chat-sidenav-title {\n  color: $app-primary-cyan;\n}\n\n.cyan .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-cyan, 45%);\n  }\n}\n\n//_dashboard.scss\n.cyan .contact-list {\n  & i {\n    color: $app-primary-cyan;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.cyan .Collapsible__trigger {\n  background: $app-primary-cyan;\n}\n\n.cyan .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-cyan;\n  }\n}\n\n//_login.scss\n.cyan .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-cyan;\n  }\n}\n\n//_portfolio.scss\n.cyan .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-cyan;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-cyan;\n    }\n  }\n}\n\n//_card.scss\n.cyan .profile-intro {\n  & .icon {\n    color: $app-primary-cyan;\n  }\n}\n\n.cyan .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-cyan;\n  }\n}\n\n//_tables.scss\n.cyan .actions {\n  color: $secondary-cyan;\n}\n\n.cyan .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-cyan, 0.075);\n}\n\n//Border Color\n\n.cyan .border-primary {\n  border-color: $app-primary-cyan !important;\n}\n\n// login page content\n\n.cyan .app-logo-content {\n  background-color: $app-primary-cyan;\n}\n\n.cyan .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-cyan;\n    color: $app-primary-cyan;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-cyan;\n    }\n  }\n}\n\n.cyan .btn-group,\n.cyan .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-cyan;\n      border-color: $app-primary-cyan;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-cyan !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-cyan, 0.12) !important;\n        color: $app-primary-cyan !important;\n      }\n    }\n  }\n}\n\n.cyan .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-cyan;\n    border-color: $app-primary-cyan;\n  }\n}\n\n.cyan .form-checkbox > input + .check,\n.cyan .form-checkbox > input.sm + .check {\n  color: $app-primary-cyan;\n}","/*Theme Amber Styles*/\n$app-primary-amber: #FFC107 !default;\n$secondary-amber: #FF3D00;\n\n$sidebar-amber: $white !default;\n$sidebar-text-color-amber: #868e96 !default;\n\n.amber ul.nav-menu li.open > a {\n  border-color: $app-primary-amber;\n}\n\n//-Base-scss\n.amber .right-arrow {\n  color: $app-primary-amber;\n  &:after {\n    color: $app-primary-amber;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .amber .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .amber a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .amber .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-amber);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .amber a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-amber);\n    }\n  }\n}\n\n.amber .btn-outline-primary,\n.amber a.btn-outline-primary {\n  color: $app-primary-amber;\n  border-color: $app-primary-amber;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-amber;\n    background-color: $app-primary-amber;\n  }\n}\n\n.amber .btn-outline-secondary,\n.amber a.btn-outline-secondary {\n  color: $secondary-amber;\n  border-color: $secondary-amber;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-amber;\n    background-color: $secondary-amber;\n  }\n}\n\n//Bootstrap file Style\n.amber {\n  & a,\n  & a.text-primary {\n    color: $app-primary-amber;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-amber, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-amber !important;\n  }\n\n  & .page-link {\n    color: $app-primary-amber;\n    &:focus,\n    &:hover {\n      color: $app-primary-amber;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-amber !important;\n    color: $sidebar-amber !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-amber;\n    border-color: $app-primary-amber;\n    color: $sidebar-amber;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-amber, 5%) !important;\n      border-color: darken($app-primary-amber, 5%) !important;\n      color: $sidebar-amber !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #ffecb3 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #ffe082 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #ffd54f !important;\n    }\n\n    &.lighten-1 {\n      background-color: #ffca28 !important;\n    }\n\n    &.darken-1 {\n      background-color: #ffb300 !important;\n    }\n\n    &.darken-2 {\n      background-color: #ffa000 !important;\n    }\n\n    &.darken-3 {\n      background-color: #ff8f00 !important;\n    }\n\n    &.darken-4 {\n      background-color: #ff6f00 !important;\n    }\n\n    &.accent-1 {\n      background-color: #ffe57f !important;\n    }\n\n    &.accent-2 {\n      background-color: #ffd740 !important;\n    }\n\n    &.accent-3 {\n      background-color: #ffc400 !important;\n    }\n\n    &.accent-4 {\n      background-color: #ffab00 !important;\n    }\n  }\n}\n\n//Secondary\n.amber {\n  & a.text-secondary {\n    color: $secondary-amber;\n    &:focus,\n    &:hover {\n      color: darken($secondary-amber, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-amber !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-amber !important;\n    color: $sidebar-amber !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-amber;\n    border-color: $secondary-amber;\n    color: $sidebar-amber;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-amber, 5%) !important;\n      border-color: darken($secondary-amber, 5%) !important;\n      color: $sidebar-amber !important;\n    }\n  }\n}\n\n//flat-btn\n.amber .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.amber .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-amber !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-amber, 0.12) !important;\n    color: $app-primary-amber !important;\n  }\n}\n\n.amber .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.amber .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-amber !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-amber, 0.12) !important;\n    color: $secondary-amber !important;\n  }\n}\n\n.amber .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.amber .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.amber .color-theme-header {\n  background-color: $app-primary-amber;\n\n}\n\n//_sidebar.scss\n.amber .side-nav {\n  background-color: $sidebar-amber !important;\n  color: $sidebar-text-color-amber !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n\n    & .text-white {\n      color: $app-primary-amber !important;\n    }\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-amber;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-color-amber, 35%);\n  }\n}\n\n.amber ul.nav-menu li a {\n  color: $sidebar-text-color-amber;\n}\n\n.amber ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-color-amber;\n  }\n}\n\n.amber ul.nav-menu > li.open > a,\n.amber ul.nav-menu > li > a:hover,\n.amber ul.nav-menu > li > a:focus {\n  background-color: $sidebar-amber;\n  color: $app-primary-amber;\n}\n\n.amber ul.nav-menu li.menu > a:focus:before,\n.amber ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-amber;\n}\n\n.amber ul.nav-menu li ul {\n  background-color: $sidebar-amber;\n}\n\n.amber ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-color;\n}\n\n.amber ul.nav-menu li.menu.open > a:before,\n.amber ul.nav-menu li.menu > a:focus:before,\n.amber ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-amber;\n}\n\n.amber ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-color-amber;\n}\n\n.amber ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-amber;\n}\n\n.amber ul.nav-menu li.menu .sub-menu li > a:hover,\n.amber ul.nav-menu li.menu .sub-menu li > a:focus,\n.amber ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.amber ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.amber ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-amber;\n  color: $app-primary-amber;\n}\n\n/*Header top Navbar Styles*/\n.amber .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-amber;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-amber;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-amber;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-amber;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-amber;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-amber;\n    }\n  }\n}\n\n.amber .app-top-nav {\n  background-color: $app-primary-amber;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-amber;\n    }\n  }\n}\n\n//_app-module.scss\n.amber .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-amber;\n    }\n  }\n}\n\n//_calendar.scss\n.amber .rbc-event {\n  background-color: $app-primary-amber;\n}\n\n.amber .rbc-event.rbc-selected {\n  background-color: darken($app-primary-amber, 10%);\n}\n\n.amber .rbc-slot-selection {\n  background-color: rgba($app-primary-amber, 0.7);\n}\n\n.amber .rbc-toolbar button:active,\n.amber .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-amber, 0.9);\n  border-color: $app-primary-amber;\n}\n\n.amber .rbc-toolbar button:active:hover,\n.amber .rbc-toolbar button.rbc-active:hover,\n.amber .rbc-toolbar button:active:focus,\n.amber .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-amber, 0.9);\n  border-color: $app-primary-amber;\n}\n\n.amber .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-amber, 0.9);\n  border-color: $app-primary-amber;\n}\n\n.amber .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-amber, 0.9);\n  border-color: $app-primary-amber;\n}\n\n.amber .rbc-day-slot .rbc-event {\n  border-color: $app-primary-amber;\n}\n\n//_chat.scss\n.amber .chat-sidenav-title {\n  color: $app-primary-amber;\n}\n\n.amber .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-amber, 45%);\n  }\n}\n\n//_dashboard.scss\n.amber .contact-list {\n  & i {\n    color: $app-primary-amber;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.amber .Collapsible__trigger {\n  background: $app-primary-amber;\n}\n\n.amber .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-amber;\n  }\n}\n\n//_login.scss\n.amber .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-amber;\n  }\n}\n\n//_portfolio.scss\n.amber .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-amber;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-amber;\n    }\n  }\n}\n\n//_card.scss\n.amber .profile-intro {\n  & .icon {\n    color: $app-primary-amber;\n  }\n}\n\n.amber .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-amber;\n  }\n}\n\n//_tables.scss\n.amber .actions {\n  color: $secondary-amber;\n}\n\n.amber .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-amber, 0.075);\n}\n\n//Border Color\n\n.amber .border-primary {\n  border-color: $app-primary-amber !important;\n}\n\n// login page content\n\n.amber .app-logo-content {\n  background-color: $app-primary-amber;\n}\n\n.amber .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-amber;\n    color: $app-primary-amber;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-amber;\n    }\n  }\n}\n\n.amber .btn-group,\n.amber .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-amber;\n      border-color: $app-primary-amber;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-amber !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-amber, 0.12) !important;\n        color: $app-primary-amber !important;\n      }\n    }\n  }\n}\n\n.amber .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-amber;\n    border-color: $app-primary-amber;\n  }\n}\n\n.amber .form-checkbox > input + .check,\n.amber .form-checkbox > input.sm + .check {\n  color: $app-primary-amber;\n}","/*Theme Deep Orange Styles*/\n$app-primary-deep-orange: #ff5722 !default;\n$secondary-deep-orange: #40C4FF;\n\n$sidebar-deep-orange: $white !default;\n$sidebar-text-deep-orange: #868e96 !default;\n\n//-Base-scss\n.deep-orange .right-arrow {\n  color: $app-primary-deep-orange;\n  &:after {\n    color: $app-primary-deep-orange;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .deep-orange .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .deep-orange a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .deep-orange .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-deep-orange);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .deep-orange a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-deep-orange);\n    }\n  }\n}\n\n.deep-orange .btn-outline-primary,\n.deep-orange a.btn-outline-primary {\n  color: $app-primary-deep-orange;\n  border-color: $app-primary-deep-orange;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-deep-orange;\n    background-color: $app-primary-deep-orange;\n  }\n}\n\n.deep-orange .btn-outline-secondary,\n.deep-orange a.btn-outline-secondary {\n  color: $secondary-deep-orange;\n  border-color: $secondary-deep-orange;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-deep-orange;\n    background-color: $secondary-deep-orange;\n  }\n}\n\n//- Bootstrap file Style\n.deep-orange {\n  & a,\n  & a.text-primary {\n    color: $app-primary-deep-orange;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-deep-orange, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-deep-orange !important;\n  }\n\n  & .page-link {\n    color: $app-primary-deep-orange;\n    &:focus,\n    &:hover {\n      color: $app-primary-deep-orange;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-deep-orange !important;\n    color: $sidebar-deep-orange !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-deep-orange;\n    border-color: $app-primary-deep-orange;\n    color: $sidebar-deep-orange;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-deep-orange, 5%) !important;\n      border-color: darken($app-primary-deep-orange, 5%) !important;\n      color: $sidebar-deep-orange !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #ffccbc !important;\n    }\n\n    &.lighten-3 {\n      background-color: #ffab91 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #ff8a65 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #ff7043 !important;\n    }\n\n    &.darken-1 {\n      background-color: #f4511e !important;\n    }\n\n    &.darken-2 {\n      background-color: #e64a19 !important;\n    }\n\n    &.darken-3 {\n      background-color: #d84315 !important;\n    }\n\n    &.darken-4 {\n      background-color: #bf360c !important;\n    }\n\n    &.accent-1 {\n      background-color: #ff9e80 !important;\n    }\n\n    &.accent-2 {\n      background-color: #ff6e40 !important;\n    }\n\n    &.accent-3 {\n      background-color: #ff3d00 !important;\n    }\n\n    &.accent-4 {\n      background-color: #dd2c00 !important;\n    }\n  }\n}\n\n//Secondary\n.deep-orange {\n  & a.text-secondary {\n    color: $secondary-deep-orange;\n    &:focus,\n    &:hover {\n      color: darken($secondary-deep-orange, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-deep-orange !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-deep-orange !important;\n    color: $sidebar-deep-orange !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-deep-orange;\n    border-color: $secondary-deep-orange;\n    color: $sidebar-deep-orange;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-deep-orange, 5%) !important;\n      border-color: darken($secondary-deep-orange, 5%) !important;\n      color: $sidebar-deep-orange !important;\n    }\n  }\n}\n\n//flat-btn\n.deep-orange .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.deep-orange .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-deep-orange !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-deep-orange, 0.12) !important;\n    color: $app-primary-deep-orange !important;\n  }\n}\n\n.deep-orange .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.deep-orange .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-deep-orange !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-deep-orange, 0.12) !important;\n    color: $secondary-deep-orange !important;\n  }\n}\n\n.deep-orange .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.deep-orange .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.deep-orange .color-theme-header {\n  background-color: $app-primary-deep-orange;\n\n}\n\n//_sidebar.scss\n.deep-orange .side-nav {\n  background-color: $sidebar-deep-orange !important;\n  color: $sidebar-text-deep-orange !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-deep-orange !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-deep-orange, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-deep-orange;\n    }\n  }\n}\n\n.deep-orange ul.nav-menu li a {\n  color: $sidebar-text-deep-orange;\n}\n\n.deep-orange ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-deep-orange;\n  }\n}\n\n.deep-orange ul.nav-menu > li.open > a,\n.deep-orange ul.nav-menu > li > a:hover,\n.deep-orange ul.nav-menu > li > a:focus {\n  background-color: $sidebar-deep-orange;\n  color: $app-primary-deep-orange;\n}\n\n.deep-orange ul.nav-menu li.menu > a:focus:before,\n.deep-orange ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-deep-orange;\n}\n\n.deep-orange ul.nav-menu li ul {\n  background-color: $sidebar-deep-orange;\n}\n\n.deep-orange ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-deep-orange;\n}\n\n.deep-orange ul.nav-menu li.menu.open > a:before,\n.deep-orange ul.nav-menu li.menu > a:focus:before,\n.deep-orange ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-deep-orange;\n}\n\n.deep-orange ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-deep-orange;\n}\n\n.deep-orange ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-deep-orange;\n}\n\n.deep-orange ul.nav-menu li.menu .sub-menu li > a:hover,\n.deep-orange ul.nav-menu li.menu .sub-menu li > a:focus,\n.deep-orange ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.deep-orange ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.deep-orange ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-deep-orange;\n  color: $app-primary-deep-orange;\n}\n\n/*Header top Navbar Styles*/\n.deep-orange .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-deep-orange;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-deep-orange;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-deep-orange;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-deep-orange;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-deep-orange;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-deep-orange;\n    }\n  }\n}\n\n.deep-orange .app-top-nav {\n  background-color: $app-primary-deep-orange;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-deep-orange;\n    }\n  }\n}\n\n//_app-module.scss\n.deep-orange .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-deep-orange;\n    }\n  }\n}\n\n//_calendar.scss\n.deep-orange .rbc-event {\n  background-color: $app-primary-deep-orange;\n}\n\n.deep-orange .rbc-event.rbc-selected {\n  background-color: darken($app-primary-deep-orange, 10%);\n}\n\n.deep-orange .rbc-slot-selection {\n  background-color: rgba($app-primary-deep-orange, 0.7);\n}\n\n.deep-orange .rbc-toolbar button:active,\n.deep-orange .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-deep-orange, 0.9);\n  border-color: $app-primary-deep-orange;\n}\n\n.deep-orange .rbc-toolbar button:active:hover,\n.deep-orange .rbc-toolbar button.rbc-active:hover,\n.deep-orange .rbc-toolbar button:active:focus,\n.deep-orange .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-deep-orange, 0.9);\n  border-color: $app-primary-deep-orange;\n}\n\n.deep-orange .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-deep-orange, 0.9);\n  border-color: $app-primary-deep-orange;\n}\n\n.deep-orange .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-deep-orange, 0.9);\n  border-color: $app-primary-deep-orange;\n}\n\n.deep-orange .rbc-day-slot .rbc-event {\n  border-color: $app-primary-deep-orange;\n}\n\n//_chat.scss\n.deep-orange .chat-sidenav-title {\n  color: $app-primary-deep-orange;\n}\n\n.deep-orange .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-deep-orange, 40%);\n  }\n}\n\n//_dashboard.scss\n.deep-orange .contact-list {\n  & i {\n    color: $app-primary-deep-orange;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.deep-orange .Collapsible__trigger {\n  background: $app-primary-deep-orange;\n}\n\n.deep-orange .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-deep-orange;\n  }\n}\n\n//_login.scss\n.deep-orange .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-deep-orange;\n  }\n}\n\n//_portfolio.scss\n.deep-orange .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-deep-orange;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-deep-orange;\n    }\n  }\n}\n\n//_card.scss\n.deep-orange .profile-intro {\n  & .icon {\n    color: $app-primary-deep-orange;\n  }\n}\n\n.deep-orange .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-deep-orange;\n  }\n}\n\n//_tables.scss\n.deep-orange .actions {\n  color: $secondary-deep-orange;\n}\n\n.deep-orange .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-deep-orange, 0.075);\n}\n\n//Border Color\n\n.deep-orange .border-primary {\n  border-color: $app-primary-deep-orange !important;\n}\n\n// login page content\n\n.deep-orange .app-logo-content {\n  background-color: $app-primary-deep-orange;\n}\n\n.deep-orange .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-deep-orange;\n    color: $app-primary-deep-orange;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-deep-orange;\n    }\n  }\n}\n\n.deep-orange .btn-group,\n.deep-orange .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-deep-orange;\n      border-color: $app-primary-deep-orange;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-deep-orange !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-deep-orange, 0.12) !important;\n        color: $app-primary-deep-orange !important;\n      }\n    }\n  }\n}\n\n.deep-orange .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-deep-orange;\n    border-color: $app-primary-deep-orange;\n  }\n}\n\n.deep-orange .form-checkbox > input + .check,\n.deep-orange .form-checkbox > input.sm + .check {\n  color: $app-primary-deep-orange;\n}\n","/*Theme Pink Styles*/\n$app-primary-pink: #e91e63 !default;\n$secondary-pink: #00BFA5;\n\n$sidebar-pink: $white !default;\n$sidebar-text-pink: #868e96 !default;\n\n//-Base-scss\n.pink .right-arrow {\n  color: $app-primary-pink;\n  &:after {\n    color: $app-primary-pink;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .pink .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .pink a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .pink .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-pink);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .pink a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-pink);\n    }\n  }\n}\n\n.pink .btn-outline-primary,\n.pink a.btn-outline-primary {\n  color: $app-primary-pink;\n  border-color: $app-primary-pink;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-pink;\n    background-color: $app-primary-pink;\n  }\n}\n\n.pink .btn-outline-secondary,\n.pink a.btn-outline-secondary {\n  color: $secondary-pink;\n  border-color: $secondary-pink;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-pink;\n    background-color: $secondary-pink;\n  }\n}\n\n\n//- Bootstrap file Style\n.pink {\n  & a,\n  & a.text-primary {\n    color: $app-primary-pink;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-pink, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-pink !important;\n  }\n\n  & .page-link {\n    color: $app-primary-pink;\n    &:focus,\n    &:hover {\n      color: $app-primary-pink;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-pink !important;\n    color: $sidebar-pink !important;\n  }\n\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-pink;\n    border-color: $app-primary-pink;\n    color: $sidebar-pink;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-pink, 5%) !important;\n      border-color: darken($app-primary-pink, 5%) !important;\n      color: $sidebar-pink !important;\n    }\n  }\n\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #f8bbd0 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #f48fb1 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #f06292 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #ec407a !important;\n    }\n\n    &.darken-1 {\n      background-color: #d81b60 !important;\n    }\n\n    &.darken-2 {\n      background-color: #c2185b !important;\n    }\n\n    &.darken-3 {\n      background-color: #ad1457 !important;\n    }\n\n    &.darken-4 {\n      background-color: #880e4f !important;\n    }\n\n    &.accent-1 {\n      background-color: #ff80ab !important;\n    }\n\n    &.accent-2 {\n      background-color: #ff4081 !important;\n    }\n\n    &.accent-3 {\n      background-color: #f50057 !important;\n    }\n\n    &.accent-4 {\n      background-color: #c51162 !important;\n    }\n  }\n}\n\n//Secondary\n.pink {\n  & a.text-secondary {\n    color: $secondary-pink;\n    &:focus,\n    &:hover {\n      color: darken($secondary-pink, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-pink !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-pink !important;\n    color: $sidebar-pink !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-pink;\n    border-color: $secondary-pink;\n    color: $sidebar-pink;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-pink, 5%) !important;\n      border-color: darken($secondary-pink, 5%) !important;\n      color: $sidebar-pink !important;\n    }\n  }\n}\n\n//flat-btn\n.pink .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.pink .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-pink !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-pink, 0.12) !important;\n    color: $app-primary-pink !important;\n  }\n}\n\n.pink .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.pink .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-pink !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-pink, 0.12) !important;\n    color: $secondary-pink !important;\n  }\n}\n\n.pink .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.pink .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.pink .color-theme-header {\n  background-color: $app-primary-pink;\n\n}\n\n//_sidebar.scss\n.pink .side-nav {\n  background-color: $sidebar-pink !important;\n  color: $sidebar-text-pink !important;\n  border-inline-end: solid 1px $gray-200 !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-pink !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-pink, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-pink;\n    }\n  }\n}\n\n.pink ul.nav-menu li a {\n  color: $sidebar-text-pink;\n}\n\n.pink ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-pink;\n  }\n}\n\n.pink ul.nav-menu > li.open > a,\n.pink ul.nav-menu > li > a:hover,\n.pink ul.nav-menu > li > a:focus {\n  background-color: $sidebar-pink;\n  color: $app-primary-pink;\n}\n\n.pink ul.nav-menu li.menu > a:focus:before,\n.pink ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-pink;\n}\n\n.pink ul.nav-menu li ul {\n  background-color: $sidebar-pink;\n}\n\n.pink ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-pink;\n}\n\n.pink ul.nav-menu li.menu.open > a:before,\n.pink ul.nav-menu li.menu > a:focus:before,\n.pink ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-pink;\n}\n\n.pink ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-pink;\n}\n\n.pink ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-pink;\n}\n\n.pink ul.nav-menu li.menu .sub-menu li > a:hover,\n.pink ul.nav-menu li.menu .sub-menu li > a:focus,\n.pink ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.pink ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.pink ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-pink;\n  color: $app-primary-pink;\n}\n\n/*Header top Navbar Styles*/\n.pink .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-pink;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-pink;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-pink;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-pink;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-pink;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-pink;\n    }\n  }\n}\n\n.pink .app-top-nav {\n  background-color: $app-primary-pink;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-pink;\n    }\n  }\n}\n\n//_app-module.scss\n.pink .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-pink;\n    }\n  }\n}\n\n//_calendar.scss\n.pink .rbc-event {\n  background-color: $app-primary-pink;\n}\n\n.pink .rbc-event.rbc-selected {\n  background-color: darken($app-primary-pink, 10%);\n}\n\n.pink .rbc-slot-selection {\n  background-color: rgba($app-primary-pink, 0.7);\n}\n\n.pink .rbc-toolbar button:active,\n.pink .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-pink, 0.9);\n  border-color: $app-primary-pink;\n}\n\n.pink .rbc-toolbar button:active:hover,\n.pink .rbc-toolbar button.rbc-active:hover,\n.pink .rbc-toolbar button:active:focus,\n.pink .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-pink, 0.9);\n  border-color: $app-primary-pink;\n}\n\n.pink .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-pink, 0.9);\n  border-color: $app-primary-pink;\n}\n\n.pink .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-pink, 0.9);\n  border-color: $app-primary-pink;\n}\n\n.pink .rbc-day-slot .rbc-event {\n  border-color: $app-primary-pink;\n}\n\n//_chat.scss\n.pink .chat-sidenav-title {\n  color: $app-primary-pink;\n}\n\n.pink .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-pink, 45%);\n  }\n}\n\n//_dashboard.scss\n.pink .contact-list {\n  & i {\n    color: $app-primary-pink;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.pink .Collapsible__trigger {\n  background: $app-primary-pink;\n}\n\n.pink .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-pink;\n  }\n}\n\n//_login.scss\n.pink .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-pink;\n  }\n}\n\n//_portfolio.scss\n.pink .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-pink;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-pink;\n    }\n  }\n}\n\n//_card.scss\n.pink .profile-intro {\n  & .icon {\n    color: $app-primary-pink;\n  }\n}\n\n.pink .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-pink;\n  }\n}\n\n//_tables.scss\n.pink .actions {\n  color: $secondary-pink;\n}\n\n.pink .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-pink, 0.075);\n}\n\n//Border Color\n\n.pink .border-primary {\n  border-color: $app-primary-pink !important;\n}\n\n// login page content\n\n.pink .app-logo-content {\n  background-color: $app-primary-pink;\n}\n\n.pink .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-pink;\n    color: $app-primary-pink;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-pink;\n    }\n  }\n}\n\n.pink .btn-group,\n.pink .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-pink;\n      border-color: $app-primary-pink;\n    }\n  }\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-pink !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-pink, 0.12) !important;\n        color: $app-primary-pink !important;\n      }\n    }\n  }\n}\n\n.pink .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-pink;\n    border-color: $app-primary-pink;\n  }\n}\n\n.pink .form-checkbox > input + .check,\n.pink .form-checkbox > input.sm + .check {\n  color: $app-primary-pink;\n}\n\n\n","/*Theme Blue Styles*/\n$app-primary-blue: #2196F3 !default;\n$secondary-blue: #FF6E40;\n\n$sidebar-blue: $white !default;\n$sidebar-text-blue: #868e96 !default;\n\n//-Base-scss\n.blue .right-arrow {\n  color: $app-primary-blue;\n  &:after {\n    color: $app-primary-blue;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .blue .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .blue a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .blue .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-blue);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .blue a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-blue);\n    }\n  }\n}\n\n.blue .btn-outline-primary,\n.blue a.btn-outline-primary {\n  color: $app-primary-blue;\n  border-color: $app-primary-blue;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-blue;\n    background-color: $app-primary-blue;\n  }\n}\n\n.blue .btn-outline-secondary,\n.blue a.btn-outline-secondary {\n  color: $secondary-blue;\n  border-color: $secondary-blue;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-blue;\n    background-color: $secondary-blue;\n  }\n}\n\n//- Bootstrap file Style\n.blue {\n  & a,\n  & a.text-primary {\n    color: $app-primary-blue;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-blue, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-blue !important;\n  }\n\n  & .page-link {\n    color: $app-primary-blue;\n    &:focus,\n    &:hover {\n      color: $app-primary-blue;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-blue !important;\n    color: $sidebar-blue !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-blue;\n    border-color: $app-primary-blue;\n    color: $sidebar-blue;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-blue, 5%) !important;\n      border-color: darken($app-primary-blue, 5%) !important;\n      color: $sidebar-blue !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #BBDEFB !important;\n    }\n\n    &.lighten-3 {\n      background-color: #90CAF9 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #64B5F6 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #42A5F5 !important;\n    }\n\n    &.darken-1 {\n      background-color: #1E88E5 !important;\n    }\n\n    &.darken-2 {\n      background-color: #1976D2 !important;\n    }\n\n    &.darken-3 {\n      background-color: #1565C0 !important;\n    }\n\n    &.darken-4 {\n      background-color: #0D47A1 !important;\n    }\n\n    &.accent-1 {\n      background-color: #82B1FF !important;\n    }\n\n    &.accent-2 {\n      background-color: #448AFF !important;\n    }\n\n    &.accent-3 {\n      background-color: #2979FF !important;\n    }\n\n    &.accent-4 {\n      background-color: #2962FF !important;\n    }\n  }\n}\n\n//Secondary\n.blue {\n  & a.text-secondary {\n    color: $secondary-blue;\n    &:focus,\n    &:hover {\n      color: darken($secondary-blue, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-blue !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-blue !important;\n    color: $sidebar-blue !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-blue;\n    border-color: $secondary-blue;\n    color: $sidebar-blue;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-blue, 5%) !important;\n      border-color: darken($secondary-blue, 5%) !important;\n      color: $sidebar-blue !important;\n    }\n  }\n}\n\n//flat-btn\n.blue .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.blue .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-blue !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-blue, 0.12) !important;\n    color: $app-primary-blue !important;\n  }\n}\n\n.blue .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.blue .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-blue !important;\n  border-color: $secondary-blue !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-blue, 0.12) !important;\n    color: $secondary-blue !important;\n  }\n}\n\n.blue .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.blue .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.blue .color-theme-header {\n  background-color: $app-primary-blue;\n\n}\n\n//_sidebar.scss\n.blue .side-nav {\n  background-color: $sidebar-blue !important;\n  color: $sidebar-text-blue !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-blue !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-blue, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-blue;\n    }\n  }\n}\n\n.blue ul.nav-menu li a {\n  color: $sidebar-text-blue;\n}\n\n.blue ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-blue;\n  }\n}\n\n.blue ul.nav-menu > li.open > a,\n.blue ul.nav-menu > li > a:hover,\n.blue ul.nav-menu > li > a:focus {\n  background-color: $sidebar-blue;\n  color: $app-primary-blue;\n}\n\n.blue ul.nav-menu li.menu > a:focus:before,\n.blue ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-blue;\n}\n\n.blue ul.nav-menu li ul {\n  background-color: $sidebar-blue;\n}\n\n.blue ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-blue;\n}\n\n.blue ul.nav-menu li.menu.open > a:before,\n.blue ul.nav-menu li.menu > a:focus:before,\n.blue ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-blue;\n}\n\n.blue ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-blue;\n}\n\n.blue ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-blue;\n}\n\n.blue ul.nav-menu li.menu .sub-menu li > a:hover,\n.blue ul.nav-menu li.menu .sub-menu li > a:focus,\n.blue ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.blue ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.blue ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-blue;\n  color: $app-primary-blue;\n}\n\n/*Header top Navbar Styles*/\n.blue .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-blue;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-blue;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-blue;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-blue;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-blue;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-blue;\n    }\n  }\n}\n\n.blue .app-top-nav {\n  background-color: $app-primary-blue;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-blue;\n    }\n  }\n}\n\n//_app-module.scss\n.blue .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-blue;\n    }\n  }\n}\n\n//_calendar.scss\n.blue .rbc-event {\n  background-color: $app-primary-blue;\n}\n\n.blue .rbc-event.rbc-selected {\n  background-color: darken($app-primary-blue, 10%);\n}\n\n.blue .rbc-slot-selection {\n  background-color: rgba($app-primary-blue, 0.7);\n}\n\n.blue .rbc-toolbar button:active,\n.blue .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-blue, 0.9);\n  border-color: $app-primary-blue;\n}\n\n.blue .rbc-toolbar button:active:hover,\n.blue .rbc-toolbar button.rbc-active:hover,\n.blue .rbc-toolbar button:active:focus,\n.blue .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-blue, 0.9);\n  border-color: $app-primary-blue;\n}\n\n.blue .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-blue, 0.9);\n  border-color: $app-primary-blue;\n}\n\n.blue .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-blue, 0.9);\n  border-color: $app-primary-blue;\n}\n\n.blue .rbc-day-slot .rbc-event {\n  border-color: $app-primary-blue;\n}\n\n//_chat.scss\n.blue .chat-sidenav-title {\n  color: $app-primary-blue;\n}\n\n.blue .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-blue, 40%);\n  }\n}\n\n//_dashboard.scss\n.blue .contact-list {\n  & i {\n    color: $app-primary-blue;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.blue .Collapsible__trigger {\n  background: $app-primary-blue;\n}\n\n.blue .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-blue;\n  }\n}\n\n//_login.scss\n.blue .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-blue;\n  }\n}\n\n//_portfolio.scss\n.blue .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-blue;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-blue;\n    }\n  }\n}\n\n//_card.scss\n.blue .profile-intro {\n  & .icon {\n    color: $app-primary-blue;\n  }\n}\n\n.blue .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-blue;\n  }\n}\n\n//_tables.scss\n.blue .actions {\n  color: $secondary-blue;\n}\n\n.blue .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-blue, 0.075);\n}\n\n//Border Color\n\n.blue .border-primary {\n  border-color: $app-primary-blue !important;\n}\n\n// login page content\n\n.blue .app-logo-content {\n  background-color: $app-primary-blue;\n}\n\n.blue .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-blue;\n    color: $app-primary-blue;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-blue;\n    }\n  }\n}\n\n.blue .btn-group,\n.blue .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-blue;\n      border-color: $app-primary-blue;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-blue !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-blue, 0.12) !important;\n        color: $app-primary-blue !important;\n      }\n    }\n  }\n}\n\n.blue .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-blue;\n    border-color: $app-primary-blue;\n  }\n}\n\n.blue .form-checkbox > input + .check,\n.blue .form-checkbox > input.sm + .check {\n  color: $app-primary-blue;\n}","/*Theme Deep Purple Styles*/\n$app-primary-deep-purple: #673ab7 !default;\n$secondary-deep-purple: #FFAB00;\n\n$sidebar-deep-purple: $white !default;\n$sidebar-text-deep-purple: #868e96 !default;\n\n//-Base-scss\n.deep-purple .right-arrow {\n  color: $app-primary-deep-purple;\n  &:after {\n    color: $app-primary-deep-purple;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .deep-purple .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .deep-purple a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .deep-purple .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-deep-purple);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .deep-purple a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-deep-purple);\n    }\n  }\n}\n\n.deep-purple .btn-outline-primary,\n.deep-purple a.btn-outline-primary {\n  color: $app-primary-deep-purple;\n  border-color: $app-primary-deep-purple;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-deep-purple;\n    background-color: $app-primary-deep-purple;\n  }\n}\n\n.deep-purple .btn-outline-secondary,\n.deep-purple a.btn-outline-secondary {\n  color: $secondary-deep-purple;\n  border-color: $secondary-deep-purple;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-deep-purple;\n    background-color: $secondary-deep-purple;\n  }\n}\n\n//- Bootstrap file Style\n.deep-purple {\n  & a,\n  & a.text-primary {\n    color: $app-primary-deep-purple;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-deep-purple, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-deep-purple !important;\n  }\n\n  & .page-link {\n    color: $app-primary-deep-purple;\n    &:focus,\n    &:hover {\n      color: $app-primary-deep-purple;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-deep-purple !important;\n    color: $sidebar-deep-purple !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-deep-purple;\n    border-color: $app-primary-deep-purple;\n    color: $sidebar-deep-purple;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-deep-purple, 5%) !important;\n      border-color: darken($app-primary-deep-purple, 5%) !important;\n      color: $sidebar-deep-purple !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #d1c4e9 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #b39ddb !important;\n    }\n\n    &.lighten-2 {\n      background-color: #9575cd !important;\n    }\n\n    &.lighten-1 {\n      background-color: #7e57c2 !important;\n    }\n\n    &.darken-1 {\n      background-color: #5e35b1 !important;\n    }\n\n    &.darken-2 {\n      background-color: #512da8 !important;\n    }\n\n    &.darken-3 {\n      background-color: #4527a0 !important;\n    }\n\n    &.darken-4 {\n      background-color: #311b92 !important;\n    }\n\n    &.accent-1 {\n      background-color: #b388ff !important;\n    }\n\n    &.accent-2 {\n      background-color: #7c4dff !important;\n    }\n\n    &.accent-3 {\n      background-color: #651fff !important;\n    }\n\n    &.accent-4 {\n      background-color: #6200ea !important;\n    }\n  }\n}\n\n//Secondary\n.deep-purple {\n  & a.text-secondary {\n    color: $secondary-deep-purple;\n    &:focus,\n    &:hover {\n      color: darken($secondary-deep-purple, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-deep-purple !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-deep-purple !important;\n    color: $sidebar-deep-purple !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-deep-purple;\n    border-color: $secondary-deep-purple;\n    color: $sidebar-deep-purple;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-deep-purple, 5%) !important;\n      border-color: darken($secondary-deep-purple, 5%) !important;\n      color: $sidebar-deep-purple !important;\n    }\n  }\n}\n\n//flat-btn\n.deep-purple .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.deep-purple .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-deep-purple !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-deep-purple, 0.12) !important;\n    color: $app-primary-deep-purple !important;\n  }\n}\n\n.deep-purple .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.deep-purple .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-deep-purple !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-deep-purple, 0.12) !important;\n    color: $secondary-deep-purple !important;\n  }\n}\n\n.deep-purple .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.deep-purple .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.deep-purple .color-theme-header {\n  background-color: $app-primary-deep-purple;\n\n}\n\n//_sidebar.scss\n.deep-purple .side-nav {\n  background-color: $sidebar-deep-purple !important;\n  color: $sidebar-text-deep-purple !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-deep-purple !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-deep-purple, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-deep-purple;\n    }\n  }\n}\n\n.deep-purple ul.nav-menu li a {\n  color: $sidebar-text-deep-purple;\n}\n\n.deep-purple ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-deep-purple;\n  }\n}\n\n.deep-purple ul.nav-menu > li.open > a,\n.deep-purple ul.nav-menu > li > a:hover,\n.deep-purple ul.nav-menu > li > a:focus {\n  background-color: $sidebar-deep-purple;\n  color: $app-primary-deep-purple;\n}\n\n.deep-purple ul.nav-menu li.menu > a:focus:before,\n.deep-purple ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-deep-purple;\n}\n\n.deep-purple ul.nav-menu li ul {\n  background-color: $sidebar-deep-purple;\n}\n\n.deep-purple ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-deep-purple;\n}\n\n.deep-purple ul.nav-menu li.menu.open > a:before,\n.deep-purple ul.nav-menu li.menu > a:focus:before,\n.deep-purple ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-deep-purple;\n}\n\n.deep-purple ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-deep-purple;\n}\n\n.deep-purple ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-deep-purple;\n}\n\n.deep-purple ul.nav-menu li.menu .sub-menu li > a:hover,\n.deep-purple ul.nav-menu li.menu .sub-menu li > a:focus,\n.deep-purple ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.deep-purple ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.deep-purple ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-deep-purple;\n  color: $app-primary-deep-purple;\n}\n\n/*Header top Navbar Styles*/\n.deep-purple .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-deep-purple;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-deep-purple;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-deep-purple;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-deep-purple;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-deep-purple;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-deep-purple;\n    }\n  }\n}\n\n.deep-purple .app-top-nav {\n  background-color: $app-primary-deep-purple;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-deep-purple;\n    }\n  }\n}\n\n//_app-module.scss\n.deep-purple .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-deep-purple;\n    }\n  }\n}\n\n//_calendar.scss\n.deep-purple .rbc-event {\n  background-color: $app-primary-deep-purple;\n}\n\n.deep-purple .rbc-event.rbc-selected {\n  background-color: darken($app-primary-deep-purple, 10%);\n}\n\n.deep-purple .rbc-slot-selection {\n  background-color: rgba($app-primary-deep-purple, 0.7);\n}\n\n.deep-purple .rbc-toolbar button:active,\n.deep-purple .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-deep-purple, 0.9);\n  border-color: $app-primary-deep-purple;\n}\n\n.deep-purple .rbc-toolbar button:active:hover,\n.deep-purple .rbc-toolbar button.rbc-active:hover,\n.deep-purple .rbc-toolbar button:active:focus,\n.deep-purple .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-deep-purple, 0.9);\n  border-color: $app-primary-deep-purple;\n}\n\n.deep-purple .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-deep-purple, 0.9);\n  border-color: $app-primary-deep-purple;\n}\n\n.deep-purple .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-deep-purple, 0.9);\n  border-color: $app-primary-deep-purple;\n}\n\n.deep-purple .rbc-day-slot .rbc-event {\n  border-color: $app-primary-deep-purple;\n}\n\n//_chat.scss\n.deep-purple .chat-sidenav-title {\n  color: $app-primary-deep-purple;\n}\n\n.deep-purple .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-deep-purple, 45%);\n  }\n}\n\n//_dashboard.scss\n.deep-purple .contact-list {\n  & i {\n    color: $app-primary-deep-purple;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.deep-purple .Collapsible__trigger {\n  background: $app-primary-deep-purple;\n}\n\n.deep-purple .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-deep-purple;\n  }\n}\n\n//_login.scss\n.deep-purple .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-deep-purple;\n  }\n}\n\n//_portfolio.scss\n.deep-purple .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-deep-purple;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-deep-purple;\n    }\n  }\n}\n\n//_card.scss\n.deep-purple .profile-intro {\n  & .icon {\n    color: $app-primary-deep-purple;\n  }\n}\n\n.deep-purple .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-deep-purple;\n  }\n}\n\n//_tables.scss\n.deep-purple .actions {\n  color: $secondary-deep-purple;\n}\n\n.deep-purple .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-deep-purple, 0.075);\n}\n\n//Border Color\n\n.deep-purple .border-primary {\n  border-color: $app-primary-deep-purple !important;\n}\n\n// login page content\n\n.deep-purple .app-logo-content {\n  background-color: $app-primary-deep-purple;\n}\n\n.deep-purple .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-deep-purple;\n    color: $app-primary-deep-purple;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-deep-purple;\n    }\n  }\n}\n\n.deep-purple .btn-group,\n.deep-purple .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-deep-purple;\n      border-color: $app-primary-deep-purple;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-deep-purple !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-deep-purple, 0.12) !important;\n        color: $app-primary-deep-purple !important;\n      }\n    }\n  }\n}\n\n\n.deep-purple .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-deep-purple;\n    border-color: $app-primary-deep-purple;\n  }\n}\n\n.deep-purple .form-checkbox > input + .check,\n.deep-purple .form-checkbox > input.sm + .check {\n  color: $app-primary-deep-purple;\n}\n\n","/*Theme Green Styles*/\n$app-primary-green: #4CAF50 !default;\n$secondary-green: #FF6D00;\n\n$sidebar-green: $white !default;\n$sidebar-text-green: #868e96 !default;\n\n//-Base-scss\n.green .right-arrow {\n  color: $app-primary-green;\n  &:after {\n    color: $app-primary-green;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .green .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .green a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .green .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-green);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .green a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $sidebar-green);\n    }\n  }\n}\n\n.green .btn-outline-primary,\n.green a.btn-outline-primary {\n  color: $app-primary-green;\n  border-color: $app-primary-green;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-green;\n    background-color: $app-primary-green;\n  }\n}\n\n.green .btn-outline-secondary,\n.green a.btn-outline-secondary {\n  color: $secondary-green;\n  border-color: $secondary-green;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-green;\n    background-color: $secondary-green;\n  }\n}\n\n//- Bootstrap file Style\n.green {\n  & a,\n  & a.text-primary {\n    color: $app-primary-green;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-green, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-green !important;\n  }\n\n  & .page-link {\n    color: $app-primary-green;\n    &:focus,\n    &:hover {\n      color: $app-primary-green;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-green !important;\n    color: $sidebar-green !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-green;\n    border-color: $app-primary-green;\n    color: $sidebar-green;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-green, 5%) !important;\n      border-color: darken($app-primary-green, 5%) !important;\n      color: $sidebar-green !important;\n    }\n  }\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #C8E6C9 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #A5D6A7 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #81C784 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #66BB6A !important;\n    }\n\n    &.darken-1 {\n      background-color: #43A047 !important;\n    }\n\n    &.darken-2 {\n      background-color: #388E3C !important;\n    }\n\n    &.darken-3 {\n      background-color: #2E7D32 !important;\n    }\n\n    &.darken-4 {\n      background-color: #1B5E20 !important;\n    }\n\n    &.accent-1 {\n      background-color: #B9F6CA !important;\n    }\n\n    &.accent-2 {\n      background-color: #69F0AE !important;\n    }\n\n    &.accent-3 {\n      background-color: #00E676 !important;\n    }\n\n    &.accent-4 {\n      background-color: #00C853 !important;\n    }\n  }\n}\n\n//Secondary\n.green {\n  & a.text-secondary {\n    color: $secondary-green;\n    &:focus,\n    &:hover {\n      color: darken($secondary-green, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-green !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-green !important;\n    color: $sidebar-green !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-green;\n    border-color: $secondary-green;\n    color: $sidebar-green;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-green, 5%) !important;\n      border-color: darken($secondary-green, 5%) !important;\n      color: $sidebar-green !important;\n    }\n  }\n}\n\n//flat-btn\n.green .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.green .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-green !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-green, 0.12) !important;\n    color: $app-primary-green !important;\n  }\n}\n\n.green .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.green .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-green !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-green, 0.12) !important;\n    color: $secondary-green !important;\n  }\n}\n\n.green .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.green .app-main-header {\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n//_right-sidebar.scss\n.green .color-theme-header {\n  background-color: $app-primary-green;\n\n}\n\n//_sidebar.scss\n.green .side-nav {\n  background-color: $sidebar-green !important;\n  color: $sidebar-text-green !important;\n  border-inline-end: solid 1px $gray-200 !important;\n\n  & .user-profile {\n    background-color: $gray-100;\n    position: relative;\n    z-index: 2;\n\n    & .text-white {\n      color: $app-primary-green !important;\n    }\n  }\n\n  & .customizer {\n    border-bottom: solid 1px lighten($sidebar-text-green, 35%);\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $app-primary-green;\n    }\n  }\n}\n\n.green ul.nav-menu li a {\n  color: $sidebar-text-green;\n}\n\n.green ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-green;\n  }\n}\n\n.green ul.nav-menu > li.open > a,\n.green ul.nav-menu > li > a:hover,\n.green ul.nav-menu > li > a:focus {\n  background-color: $sidebar-green;\n  color: $app-primary-green;\n}\n\n.green ul.nav-menu li.menu > a:focus:before,\n.green ul.nav-menu li.menu > a:hover:before {\n  color: $app-primary-green;\n}\n\n.green ul.nav-menu li ul {\n  background-color: $sidebar-green;\n}\n\n.green ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-green;\n}\n\n.green ul.nav-menu li.menu.open > a:before,\n.green ul.nav-menu li.menu > a:focus:before,\n.green ul.nav-menu li.menu li > a:hover:before {\n  color: $app-primary-green;\n}\n\n.green ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-green;\n}\n\n.green ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-green;\n}\n\n.green ul.nav-menu li.menu .sub-menu li > a:hover,\n.green ul.nav-menu li.menu .sub-menu li > a:focus,\n.green ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.green ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.green ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-green;\n  color: $app-primary-green;\n}\n\n/*Header top Navbar Styles*/\n.green .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-green;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-green;\n    }\n  }\n\n  & li.nav-item.active > a {\n    color: $app-primary-green;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-green;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-green;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-green;\n    }\n  }\n}\n\n.green .app-top-nav {\n  background-color: $app-primary-green;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-green;\n    }\n  }\n}\n\n//_app-module.scss\n.green .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-green;\n    }\n  }\n}\n\n//_calendar.scss\n.green .rbc-event {\n  background-color: $app-primary-green;\n}\n\n.green .rbc-event.rbc-selected {\n  background-color: darken($app-primary-green, 10%);\n}\n\n.green .rbc-slot-selection {\n  background-color: rgba($app-primary-green, 0.7);\n}\n\n.green .rbc-toolbar button:active,\n.green .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-green, 0.9);\n  border-color: $app-primary-green;\n}\n\n.green .rbc-toolbar button:active:hover,\n.green .rbc-toolbar button.rbc-active:hover,\n.green .rbc-toolbar button:active:focus,\n.green .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-green, 0.9);\n  border-color: $app-primary-green;\n}\n\n.green .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-green, 0.9);\n  border-color: $app-primary-green;\n}\n\n.green .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-green, 0.9);\n  border-color: $app-primary-green;\n}\n\n.green .rbc-day-slot .rbc-event {\n  border-color: $app-primary-green;\n}\n\n//_chat.scss\n.green .chat-sidenav-title {\n  color: $app-primary-green;\n}\n\n.green .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-green, 45%);\n  }\n}\n\n//_dashboard.scss\n.green .contact-list {\n  & i {\n    color: $app-primary-green;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.green .Collapsible__trigger {\n  background: $app-primary-green;\n}\n\n.green .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-green;\n  }\n}\n\n//_login.scss\n.green .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-green;\n  }\n}\n\n//_portfolio.scss\n.green .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-green;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-green;\n    }\n  }\n}\n\n//_card.scss\n.green .profile-intro {\n  & .icon {\n    color: $app-primary-green;\n  }\n}\n\n.green .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-green;\n  }\n}\n\n//_tables.scss\n.green .actions {\n  color: $secondary-green;\n}\n\n.green .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-green, 0.075);\n}\n\n//Border Color\n\n.green .border-primary {\n  border-color: $app-primary-green !important;\n}\n\n// login page content\n\n.green .app-logo-content {\n  background-color: $app-primary-green;\n}\n\n.green .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-green;\n    color: $app-primary-green;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-green;\n    }\n  }\n}\n\n.green .btn-group,\n.green .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-green;\n      border-color: $app-primary-green;\n    }\n  }\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-green !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-green, 0.12) !important;\n        color: $app-primary-green !important;\n      }\n    }\n  }\n}\n\n\n.green .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-green;\n    border-color: $app-primary-green;\n  }\n}\n\n.green .form-checkbox > input + .check,\n.green .form-checkbox > input.sm + .check {\n  color: $app-primary-green;\n}\n\n\n","/*Theme Dark Indigo Styles*/\n$app-primary-dark-indigo: #3f51b5 !default;\n$secondary-dark-indigo: #FF4081;\n\n$sidebar-dark-indigo: #252525 !default;\n$sidebar-text-dark-indigo: #a1a1a1 !default;\n$sidebar-darken-indigo: darken($sidebar-dark-indigo, 3%);\n\n$top-nav-bg-dark-indigo: $sidebar-dark-indigo !default;\n\n// Links\n$link-hover-dark-indigo: $white;\n\n//-Base-scss\n.dark-indigo .right-arrow {\n  color: $app-primary-dark-indigo;\n  &:after {\n    color: $app-primary-dark-indigo;\n  }\n}\n\n\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-indigo .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-indigo a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-indigo .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-indigo a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-indigo .btn-outline-primary,\n.dark-indigo a.btn-outline-primary {\n  color: $app-primary-dark-indigo;\n  border-color: $app-primary-dark-indigo;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-indigo;\n    background-color: $app-primary-dark-indigo;\n  }\n}\n\n.dark-indigo .btn-outline-secondary,\n.dark-indigo a.btn-outline-secondary {\n  color: $secondary-dark-indigo;\n  border-color: $secondary-dark-indigo;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-indigo;\n    background-color: $secondary-dark-indigo;\n  }\n}\n\n//- Bootstrap file Style\n.dark-indigo {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-indigo;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-indigo, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-indigo !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-indigo;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-indigo;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-indigo !important;\n    color: $link-hover-dark-indigo !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-indigo;\n    border-color: $app-primary-dark-indigo;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-indigo, 5%) !important;\n      border-color: darken($app-primary-dark-indigo, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #c5cae9 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #9fa8da !important;\n    }\n\n    &.lighten-2 {\n      background-color: #7986cb !important;\n    }\n\n    &.lighten-1 {\n      background-color: #5c6bc0 !important;\n    }\n\n    &.darken-1 {\n      background-color: #3949ab !important;\n    }\n\n    &.darken-2 {\n      background-color: #303f9f !important;\n    }\n\n    &.darken-3 {\n      background-color: #283593 !important;\n    }\n\n    &.darken-4 {\n      background-color: #1a237e !important;\n    }\n\n    &.accent-1 {\n      background-color: #8c9eff !important;\n    }\n\n    &.accent-2 {\n      background-color: #536dfe !important;\n    }\n\n    &.accent-3 {\n      background-color: #3d5afe !important;\n    }\n\n    &.accent-4 {\n      background-color: #304ffe !important;\n    }\n  }\n}\n\n//Secondary\n.dark-indigo {\n  & a.text-secondary {\n    color: $secondary-dark-indigo;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-indigo, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-indigo !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-indigo !important;\n    color: $link-hover-dark-indigo !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-indigo;\n    border-color: $secondary-dark-indigo;\n    color: $link-hover-dark-indigo;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-indigo, 5%) !important;\n      border-color: darken($secondary-dark-indigo, 5%) !important;\n      color: $link-hover-dark-indigo !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-indigo .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-indigo .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-indigo !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-indigo, 0.12) !important;\n    color: $app-primary-dark-indigo !important;\n  }\n}\n\n.dark-indigo .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-indigo .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-indigo !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-indigo, 0.12) !important;\n    color: $secondary-dark-indigo !important;\n  }\n}\n\n.dark-indigo .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.dark-indigo .app-main-header {\n  background-color: $app-primary-dark-indigo !important;\n  color: $white;\n  border-color: $app-primary-dark-indigo;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-indigo, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-indigo .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-indigo .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-indigo .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-indigo .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-indigo .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-indigo .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-indigo .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-indigo .color-theme-header {\n  background-color: $app-primary-dark-indigo;\n\n}\n\n//_sidebar.scss\n.dark-indigo .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-indigo;\n}\n\n.dark-indigo .side-nav {\n  background-color: $sidebar-dark-indigo !important;\n  color: $sidebar-text-dark-indigo !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-indigo;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-indigo;\n    }\n  }\n}\n\n.dark-indigo ul.nav-menu li a {\n  color: $sidebar-text-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-indigo;\n  }\n}\n\n.dark-indigo ul.nav-menu > li.open > a,\n.dark-indigo ul.nav-menu > li > a:hover,\n.dark-indigo ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-indigo;\n  color: $link-hover-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu > a:focus:before,\n.dark-indigo ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li ul {\n  background-color: $sidebar-darken-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu.open > a:before,\n.dark-indigo ul.nav-menu li.menu > a:focus:before,\n.dark-indigo ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-indigo ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-indigo ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-indigo ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-indigo ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-indigo;\n  color: $link-hover-dark-indigo;\n}\n\n/*Header top Navbar Styles*/\n.dark-indigo .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-indigo;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-indigo;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-indigo;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-indigo;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-indigo;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-indigo;\n    }\n  }\n}\n\n.dark-indigo .app-top-nav {\n  background-color: $top-nav-bg-dark-indigo !important;\n  border-color: $top-nav-bg-dark-indigo;\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-indigo;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-indigo .module-nav {\n  & li a {\n    &.active {\n      color: $app-primary-dark-indigo;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-indigo .rbc-event {\n  background-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-indigo, 10%);\n}\n\n.dark-indigo .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-indigo, 0.7);\n}\n\n.dark-indigo .rbc-toolbar button:active,\n.dark-indigo .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-indigo, 0.9);\n  border-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .rbc-toolbar button:active:hover,\n.dark-indigo .rbc-toolbar button.rbc-active:hover,\n.dark-indigo .rbc-toolbar button:active:focus,\n.dark-indigo .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-indigo, 0.9);\n  border-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-indigo, 0.9);\n  border-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-indigo, 0.9);\n  border-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-indigo;\n}\n\n//_chat.scss\n.dark-indigo .chat-sidenav-title {\n  color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-indigo, 45%);\n  }\n}\n\n//_dashboard.scss\n.dark-indigo .contact-list {\n  & i {\n    color: $app-primary-dark-indigo;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-indigo .Collapsible__trigger {\n  background: $app-primary-dark-indigo;\n}\n\n.dark-indigo .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-indigo;\n  }\n}\n\n//_login.scss\n\n.dark-indigo .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-indigo;\n  }\n}\n\n//_portfolio.scss\n.dark-indigo .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-indigo;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-indigo;\n    }\n  }\n}\n\n//_card.scss\n.dark-indigo .profile-intro {\n  & .icon {\n    color: $app-primary-dark-indigo;\n  }\n}\n\n.dark-indigo .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-indigo;\n  }\n}\n\n//_tables.scss\n.dark-indigo .actions {\n  color: $secondary-dark-indigo;\n}\n\n.dark-indigo .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-indigo, 0.075);\n}\n\n//Border Color\n\n.dark-indigo .border-primary {\n  border-color: $app-primary-dark-indigo !important;\n}\n\n// login page content\n\n.dark-indigo .app-logo-content {\n  background-color: $app-primary-dark-indigo;\n}\n\n.dark-indigo .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-indigo;\n    color: $app-primary-dark-indigo;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-indigo;\n    }\n  }\n}\n\n.dark-indigo .btn-group,\n.dark-indigo .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-indigo;\n      border-color: $app-primary-dark-indigo;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-indigo !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-indigo, 0.12) !important;\n        color: $app-primary-dark-indigo !important;\n      }\n    }\n  }\n}\n\n.dark-indigo .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-indigo;\n    border-color: $app-primary-dark-indigo;\n  }\n}\n\n.dark-indigo .switch.on {\n  background: $app-primary-dark-indigo;\n}\n\n.dark-indigo .form-checkbox > input + .check,\n.dark-indigo .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-indigo;\n}\n\n/* Input Placeholder Style */\n.dark-indigo .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-indigo .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-indigo .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-indigo .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-indigo .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-indigo .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-indigo .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-indigo .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n","/*Theme Dark Cyan Styles*/\n$app-primary-dark-cyan: #00bcd4 !default;\n$secondary-dark-cyan: #69F0AE;\n\n$sidebar-dark-cyan: #252525 !default;\n$sidebar-text-dark-cyan: #a1a1a1 !default;\n$sidebar-darken-cyan: darken($sidebar-dark-cyan, 3%);\n\n$top-nav-bg-dark-cyan: $sidebar-dark-cyan !default;\n\n// Links\n$link-hover-dark-cyan: $white;\n\n//-Base-scss\n.dark-cyan .right-arrow {\n  color: $app-primary-dark-cyan;\n  &:after {\n    color: $app-primary-dark-cyan;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-cyan .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-cyan a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-cyan .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-cyan a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-cyan .btn-outline-primary,\n.dark-cyan a.btn-outline-primary {\n  color: $app-primary-dark-cyan;\n  border-color: $app-primary-dark-cyan;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-cyan;\n    background-color: $app-primary-dark-cyan;\n  }\n}\n\n.dark-cyan .btn-outline-secondary,\n.dark-cyan a.btn-outline-secondary {\n  color: $secondary-dark-cyan;\n  border-color: $secondary-dark-cyan;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-cyan;\n    background-color: $secondary-dark-cyan;\n  }\n}\n\n\n//- Bootstrap file Style\n.dark-cyan {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-cyan;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-cyan, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-cyan !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-cyan;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-cyan;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-cyan !important;\n    color: $white !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-cyan;\n    border-color: $app-primary-dark-cyan;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-cyan, 5%) !important;\n      border-color: darken($app-primary-dark-cyan, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #b2ebf2 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #80deea !important;\n    }\n\n    &.lighten-2 {\n      background-color: #4dd0e1 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #26c6da !important;\n    }\n\n    &.darken-1 {\n      background-color: #00acc1 !important;\n    }\n\n    &.darken-2 {\n      background-color: #0097a7 !important;\n    }\n\n    &.darken-3 {\n      background-color: #00838f !important;\n    }\n\n    &.darken-4 {\n      background-color: #006064 !important;\n    }\n\n    &.accent-1 {\n      background-color: #84ffff !important;\n    }\n\n    &.accent-2 {\n      background-color: #18ffff !important;\n    }\n\n    &.accent-3 {\n      background-color: #00e5ff !important;\n    }\n\n    &.accent-4 {\n      background-color: #00b8d4 !important;\n    }\n  }\n}\n\n\n//Secondary\n.dark-cyan {\n  & a.text-secondary {\n    color: $secondary-dark-cyan;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-cyan, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-cyan !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-cyan !important;\n    color: $link-hover-dark-cyan !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-cyan;\n    border-color: $secondary-dark-cyan;\n    color: $link-hover-dark-cyan;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-cyan, 5%) !important;\n      border-color: darken($secondary-dark-cyan, 5%) !important;\n      color: $link-hover-dark-cyan !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-cyan .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-cyan .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-cyan !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-cyan, 0.12) !important;\n    color: $app-primary-dark-cyan !important;\n  }\n}\n\n.dark-cyan .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-cyan .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-cyan !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-cyan, 0.12) !important;\n    color: $secondary-dark-cyan !important;\n  }\n}\n\n.dark-cyan .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.dark-cyan .app-main-header {\n  background-color: $app-primary-dark-cyan !important;\n  color: $white;\n  border-color: $app-primary-dark-cyan;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-cyan, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-cyan .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-cyan .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-cyan .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-cyan .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-cyan .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-cyan .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-cyan .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-cyan .color-theme-header {\n  background-color: $app-primary-dark-cyan;\n\n}\n\n//_sidebar.scss\n.dark-cyan .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-cyan;\n}\n\n.dark-cyan .side-nav {\n  background-color: $sidebar-dark-cyan !important;\n  color: $sidebar-text-dark-cyan !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-cyan;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-cyan;\n    }\n  }\n}\n\n.dark-cyan ul.nav-menu li a {\n  color: $sidebar-text-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-cyan;\n  }\n}\n\n.dark-cyan ul.nav-menu > li.open > a,\n.dark-cyan ul.nav-menu > li > a:hover,\n.dark-cyan ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-cyan;\n  color: $link-hover-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu > a:focus:before,\n.dark-cyan ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li ul {\n  background-color: $sidebar-darken-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu.open > a:before,\n.dark-cyan ul.nav-menu li.menu > a:focus:before,\n.dark-cyan ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-cyan ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-cyan ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-cyan ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-cyan ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-cyan;\n  color: $link-hover-dark-cyan;\n}\n\n/*Header top Navbar Styles*/\n.dark-cyan .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-cyan;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-cyan;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-cyan;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-cyan;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-cyan;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-cyan;\n    }\n  }\n}\n\n.dark-cyan .app-top-nav {\n  background-color: $top-nav-bg-dark-cyan !important;\n  border-color: $top-nav-bg-dark-cyan;\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-cyan;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-cyan .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-cyan;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-cyan .rbc-event {\n  background-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-cyan, 10%);\n}\n\n.dark-cyan .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-cyan, 0.7);\n}\n\n.dark-cyan .rbc-toolbar button:active,\n.dark-cyan .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-cyan, 0.9);\n  border-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .rbc-toolbar button:active:hover,\n.dark-cyan .rbc-toolbar button.rbc-active:hover,\n.dark-cyan .rbc-toolbar button:active:focus,\n.dark-cyan .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-cyan, 0.9);\n  border-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-cyan, 0.9);\n  border-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-cyan, 0.9);\n  border-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-cyan;\n}\n\n//_chat.scss\n.dark-cyan .chat-sidenav-title {\n  color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-cyan, 45%);\n  }\n}\n\n//_dashboard.scss\n.dark-cyan .contact-list {\n  & i {\n    color: $app-primary-dark-cyan;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-cyan .Collapsible__trigger {\n  background: $app-primary-dark-cyan;\n}\n\n.dark-cyan .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-cyan;\n  }\n}\n\n//_login.scss\n.dark-cyan .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-cyan;\n  }\n}\n\n//_portfolio.scss\n.dark-cyan .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-cyan;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-cyan;\n    }\n  }\n}\n\n//_card.scss\n.dark-cyan .profile-intro {\n  & .icon {\n    color: $app-primary-dark-cyan;\n  }\n}\n\n.dark-cyan .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-cyan;\n  }\n}\n\n//_tables.scss\n.dark-cyan .actions {\n  color: $secondary-dark-cyan;\n}\n\n.dark-cyan .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-cyan, 0.075);\n}\n\n//Border Color\n\n.dark-cyan .border-primary {\n  border-color: $app-primary-dark-cyan !important;\n}\n\n// login page content\n\n.dark-cyan .app-logo-content {\n  background-color: $app-primary-dark-cyan;\n}\n\n.dark-cyan .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-cyan;\n    color: $app-primary-dark-cyan;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-cyan;\n    }\n  }\n}\n\n.dark-cyan .btn-group,\n.dark-cyan .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-cyan;\n      border-color: $app-primary-dark-cyan;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-cyan !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-cyan, 0.12) !important;\n        color: $app-primary-dark-cyan !important;\n      }\n    }\n  }\n}\n\n.dark-cyan .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-cyan;\n    border-color: $app-primary-dark-cyan;\n  }\n}\n\n.dark-cyan .form-checkbox > input + .check,\n.dark-cyan .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-cyan;\n}\n\n/* Input Placeholder Style */\n.dark-cyan .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-cyan .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-cyan .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-cyan .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-cyan .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-cyan .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-cyan .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-cyan .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n\n\n","/*Theme Dark Amber Styles*/\n$app-primary-dark-amber: #ffc107 !default;\n$secondary-dark-amber: #FF3D00;\n\n$sidebar-dark-amber: #252525 !default;\n$sidebar-text-dark-amber: #a1a1a1 !default;\n$sidebar-darken-amber: darken($sidebar-dark-amber, 3%);\n\n$top-nav-bg-dark-amber: $sidebar-dark-amber !default;\n\n// Links\n$link-hover-dark-amber: $white;\n\n//-Base-scss\n.dark-amber .right-arrow {\n  color: $app-primary-dark-amber;\n  &:after {\n    color: $app-primary-dark-amber;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-amber .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-amber a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-amber .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-amber a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-amber .btn-outline-primary,\n.dark-amber a.btn-outline-primary {\n  color: $app-primary-dark-amber;\n  border-color: $app-primary-dark-amber;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-amber;\n    background-color: $app-primary-dark-amber;\n  }\n}\n\n.dark-amber .btn-outline-secondary,\n.dark-amber a.btn-outline-secondary {\n  color: $secondary-dark-amber;\n  border-color: $secondary-dark-amber;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-amber;\n    background-color: $secondary-dark-amber;\n  }\n}\n\n\n//- Bootstrap file Style\n.dark-amber {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-amber;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-amber, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-amber !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-amber;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-amber;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-amber !important;\n    color: $link-hover-dark-amber !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-amber;\n    border-color: $app-primary-dark-amber;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-amber, 5%) !important;\n      border-color: darken($app-primary-dark-amber, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #ffecb3 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #ffe082 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #ffd54f !important;\n    }\n\n    &.lighten-1 {\n      background-color: #ffca28 !important;\n    }\n\n    &.darken-1 {\n      background-color: #ffb300 !important;\n    }\n\n    &.darken-2 {\n      background-color: #ffa000 !important;\n    }\n\n    &.darken-3 {\n      background-color: #ff8f00 !important;\n    }\n\n    &.darken-4 {\n      background-color: #ff6f00 !important;\n    }\n\n    &.accent-1 {\n      background-color: #ffe57f !important;\n    }\n\n    &.accent-2 {\n      background-color: #ffd740 !important;\n    }\n\n    &.accent-3 {\n      background-color: #ffc400 !important;\n    }\n\n    &.accent-4 {\n      background-color: #ffab00 !important;\n    }\n  }\n}\n\n//Secondary\n.dark-amber {\n  & a.text-secondary {\n    color: $secondary-dark-amber;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-amber, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-amber !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-amber !important;\n    color: $link-hover-dark-amber !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-amber;\n    border-color: $secondary-dark-amber;\n    color: $link-hover-dark-amber;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-amber, 5%) !important;\n      border-color: darken($secondary-dark-amber, 5%) !important;\n      color: $link-hover-dark-amber !important;\n    }\n  }\n}\n\n//flat-btn\n.amber .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.amber .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-amber !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-amber, 0.12) !important;\n    color: $app-primary-amber !important;\n  }\n}\n\n.amber .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.amber .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-amber !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-amber, 0.12) !important;\n    color: $secondary-amber !important;\n  }\n}\n\n.amber .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.dark-amber .app-main-header {\n  background-color: $app-primary-dark-amber !important;\n  color: $white;\n  border-color: $app-primary-dark-amber;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-amber, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-amber .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-amber .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-amber .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-amber .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-amber .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-amber .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-amber .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-amber .color-theme-header {\n  background-color: $app-primary-dark-amber;\n\n}\n\n//_sidebar.scss\n.dark-amber .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-amber;\n}\n\n.dark-amber .side-nav {\n  background-color: $sidebar-dark-amber !important;\n  color: $sidebar-text-dark-amber !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-amber;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-amber;\n    }\n  }\n}\n\n.dark-amber ul.nav-menu li a {\n  color: $sidebar-text-dark-amber;\n}\n\n.dark-amber ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-amber;\n  }\n}\n\n.dark-amber ul.nav-menu > li.open > a,\n.dark-amber ul.nav-menu > li > a:hover,\n.dark-amber ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-amber;\n  color: $link-hover-dark-amber;\n}\n\n.dark-amber ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-amber;\n}\n\n.dark-amber ul.nav-menu li.menu > a:focus:before,\n.dark-amber ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-amber;\n}\n\n.dark-amber ul.nav-menu li ul {\n  background-color: $sidebar-darken-amber;\n}\n\n.dark-amber ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-amber;\n}\n\n.dark-amber ul.nav-menu li.menu.open > a:before,\n.dark-amber ul.nav-menu li.menu > a:focus:before,\n.dark-amber ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-amber;\n}\n\n.dark-amber ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-amber;\n}\n\n.dark-amber ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-amber;\n}\n\n.dark-amber ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-amber ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-amber ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-amber ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-amber ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-amber;\n  color: $link-hover-dark-amber;\n}\n\n/*Header top Navbar Styles*/\n.dark-amber .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-amber;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-amber;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-amber;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-amber;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-amber;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-amber;\n    }\n  }\n}\n\n.dark-amber .app-top-nav {\n  background-color: $top-nav-bg-dark-amber !important;\n  border-color: $top-nav-bg-dark-amber;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-amber;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-amber .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-amber;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-amber .rbc-event {\n  background-color: $app-primary-dark-amber;\n}\n\n.dark-amber .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-amber, 10%);\n}\n\n.dark-amber .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-amber, 0.7);\n}\n\n.dark-amber .rbc-toolbar button:active,\n.dark-amber .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-amber, 0.9);\n  border-color: $app-primary-dark-amber;\n}\n\n.dark-amber .rbc-toolbar button:active:hover,\n.dark-amber .rbc-toolbar button.rbc-active:hover,\n.dark-amber .rbc-toolbar button:active:focus,\n.dark-amber .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-amber, 0.9);\n  border-color: $app-primary-dark-amber;\n}\n\n.dark-amber .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-amber, 0.9);\n  border-color: $app-primary-dark-amber;\n}\n\n.dark-amber .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-amber, 0.9);\n  border-color: $app-primary-dark-amber;\n}\n\n.dark-amber .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-amber;\n}\n\n//_chat.scss\n.dark-amber .chat-sidenav-title {\n  color: $app-primary-dark-amber;\n}\n\n.dark-amber .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-amber, 45%);\n  }\n}\n\n//_dashboard.scss\n.dark-amber .contact-list {\n  & i {\n    color: $app-primary-dark-amber;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-amber .Collapsible__trigger {\n  background: $app-primary-dark-amber;\n}\n\n.dark-amber .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-amber;\n  }\n}\n\n//_login.scss\n\n.dark-amber .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-amber;\n  }\n}\n\n//_portfolio.scss\n.dark-amber .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-amber;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-amber;\n    }\n  }\n}\n\n//_card.scss\n.dark-amber .profile-intro {\n  & .icon {\n    color: $app-primary-dark-amber;\n  }\n}\n\n.dark-amber .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-amber;\n  }\n}\n\n//_tables.scss\n.dark-amber .actions {\n  color: $secondary-dark-amber;\n}\n\n.dark-amber .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-amber, 0.075);\n}\n\n//Border Color\n\n.dark-amber .border-primary {\n  border-color: $app-primary-dark-amber !important;\n}\n\n// login page content\n\n.dark-amber .app-logo-content {\n  background-color: $app-primary-dark-amber;\n}\n\n.dark-amber .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-amber;\n    color: $app-primary-dark-amber;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-amber;\n    }\n  }\n}\n\n.dark-amber .btn-group,\n.dark-amber .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-amber;\n      border-color: $app-primary-dark-amber;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-amber !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-amber, 0.12) !important;\n        color: $app-primary-dark-amber !important;\n      }\n    }\n  }\n}\n\n.dark-amber .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-amber;\n    border-color: $app-primary-dark-amber;\n  }\n}\n\n.dark-amber .form-checkbox > input + .check,\n.dark-amber .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-amber;\n}\n\n/* Input Placeholder Style */\n.dark-amber .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-amber .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-amber .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-amber .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-amber .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-amber .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-amber .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-amber .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n","/*Theme Dark Deep Orange Styles*/\n$app-primary-dark-deep-orange: #ff5722 !default;\n$secondary-dark-deep-orange: #40C4FF;\n\n$sidebar-dark-deep-orange: #252525 !default;\n$sidebar-text-dark-deep-orange: #a1a1a1 !default;\n$sidebar-darken-deep-orange: darken($sidebar-dark-deep-orange, 3%);\n\n$top-nav-bg-deep-orange: $sidebar-dark-deep-orange !default;\n\n// Links\n$link-hover-dark-deep-orange: $white;\n\n//-Base-scss\n.dark-deep-orange .right-arrow {\n  color: $app-primary-dark-deep-orange;\n  &:after {\n    color: $app-primary-dark-deep-orange;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-deep-orange .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-deep-orange a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-deep-orange .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-deep-orange a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-deep-orange .btn-outline-primary,\n.dark-deep-orange a.btn-outline-primary {\n  color: $app-primary-dark-deep-orange;\n  border-color: $app-primary-dark-deep-orange;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-deep-orange;\n    background-color: $app-primary-dark-deep-orange;\n  }\n}\n\n.dark-deep-orange .btn-outline-secondary,\n.dark-deep-orange a.btn-outline-secondary {\n  color: $secondary-dark-deep-orange;\n  border-color: $secondary-dark-deep-orange;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-deep-orange;\n    background-color: $secondary-dark-deep-orange;\n  }\n}\n\n//- Bootstrap file Style\n.dark-deep-orange {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-deep-orange;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-deep-orange, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-deep-orange !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-deep-orange;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-deep-orange;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-deep-orange !important;\n    color: $link-hover-dark-deep-orange !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-deep-orange;\n    border-color: $app-primary-dark-deep-orange;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-deep-orange, 5%) !important;\n      border-color: darken($app-primary-dark-deep-orange, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #ffccbc !important;\n    }\n\n    &.lighten-3 {\n      background-color: #ffab91 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #ff8a65 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #ff7043 !important;\n    }\n\n    &.darken-1 {\n      background-color: #f4511e !important;\n    }\n\n    &.darken-2 {\n      background-color: #e64a19 !important;\n    }\n\n    &.darken-3 {\n      background-color: #d84315 !important;\n    }\n\n    &.darken-4 {\n      background-color: #bf360c !important;\n    }\n\n    &.accent-1 {\n      background-color: #ff9e80 !important;\n    }\n\n    &.accent-2 {\n      background-color: #ff6e40 !important;\n    }\n\n    &.accent-3 {\n      background-color: #ff3d00 !important;\n    }\n\n    &.accent-4 {\n      background-color: #dd2c00 !important;\n    }\n  }\n}\n\n//Secondary\n.dark-deep-orange {\n  & a.text-secondary {\n    color: $secondary-dark-deep-orange;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-deep-orange, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-deep-orange !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-deep-orange !important;\n    color: $link-hover-dark-deep-orange !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-deep-orange;\n    border-color: $secondary-dark-deep-orange;\n    color: $link-hover-dark-deep-orange;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-deep-orange, 5%) !important;\n      border-color: darken($secondary-dark-deep-orange, 5%) !important;\n      color: $link-hover-dark-deep-orange !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-deep-orange .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-deep-orange .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-deep-orange !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-deep-orange, 0.12) !important;\n    color: $app-primary-dark-deep-orange !important;\n  }\n}\n\n.dark-deep-orange .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-deep-orange .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-deep-orange !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-deep-orange, 0.12) !important;\n    color: $secondary-dark-deep-orange !important;\n  }\n}\n\n.dark-deep-orange .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.dark-deep-orange .app-main-header {\n  background-color: $app-primary-dark-deep-orange !important;\n  color: $white;\n  border-color: $app-primary-dark-deep-orange;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-deep-orange, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-deep-orange .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-deep-orange .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-deep-orange .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-deep-orange .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-deep-orange .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-deep-orange .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-deep-orange .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-deep-orange .color-theme-header {\n  background-color: $app-primary-dark-deep-orange;\n\n}\n\n//_sidebar.scss\n.dark-deep-orange .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-deep-orange;\n}\n\n.dark-deep-orange .side-nav {\n  background-color: $sidebar-dark-deep-orange !important;\n  color: $sidebar-text-dark-deep-orange !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-deep-orange;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-deep-orange;\n    }\n  }\n}\n\n.dark-deep-orange ul.nav-menu li a {\n  color: $sidebar-text-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-deep-orange;\n  }\n}\n\n.dark-deep-orange ul.nav-menu > li.open > a,\n.dark-deep-orange ul.nav-menu > li > a:hover,\n.dark-deep-orange ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-deep-orange;\n  color: $link-hover-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu > a:focus:before,\n.dark-deep-orange ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li ul {\n  background-color: $sidebar-darken-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu.open > a:before,\n.dark-deep-orange ul.nav-menu li.menu > a:focus:before,\n.dark-deep-orange ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-deep-orange ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-deep-orange ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-deep-orange;\n  color: $link-hover-dark-deep-orange;\n}\n\n/*Header top Navbar Styles*/\n.dark-deep-orange .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-deep-orange;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-deep-orange;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-deep-orange;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-deep-orange;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-deep-orange;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-deep-orange;\n    }\n  }\n}\n\n.dark-deep-orange .app-top-nav {\n  background-color: $top-nav-bg-deep-orange !important;\n  border-color: $top-nav-bg-deep-orange;\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-deep-orange;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-deep-orange .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-deep-orange;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-deep-orange .rbc-event {\n  background-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-deep-orange, 10%);\n}\n\n.dark-deep-orange .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-deep-orange, 0.7);\n}\n\n.dark-deep-orange .rbc-toolbar button:active,\n.dark-deep-orange .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-deep-orange, 0.9);\n  border-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .rbc-toolbar button:active:hover,\n.dark-deep-orange .rbc-toolbar button.rbc-active:hover,\n.dark-deep-orange .rbc-toolbar button:active:focus,\n.dark-deep-orange .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-deep-orange, 0.9);\n  border-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-deep-orange, 0.9);\n  border-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-deep-orange, 0.9);\n  border-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-deep-orange;\n}\n\n//_chat.scss\n.dark-deep-orange .chat-sidenav-title {\n  color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-deep-orange, 40%);\n  }\n}\n\n//_dashboard.scss\n.dark-deep-orange .contact-list {\n  & i {\n    color: $app-primary-dark-deep-orange;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-deep-orange .Collapsible__trigger {\n  background: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-deep-orange;\n  }\n}\n\n//_login.scss\n.dark-deep-orange .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-deep-orange;\n  }\n}\n\n//_portfolio.scss\n.dark-deep-orange .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-deep-orange;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-deep-orange;\n    }\n  }\n}\n\n//_card.scss\n.dark-deep-orange .profile-intro {\n  & .icon {\n    color: $app-primary-dark-deep-orange;\n  }\n}\n\n.dark-deep-orange .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-deep-orange;\n  }\n}\n\n//_tables.scss\n.dark-deep-orange .actions {\n  color: $secondary-dark-deep-orange;\n}\n\n.dark-deep-orange .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-deep-orange, 0.075);\n}\n\n//Border Color\n\n.dark-deep-orange .border-primary {\n  border-color: $app-primary-dark-deep-orange !important;\n}\n\n// login page content\n\n.dark-deep-orange .app-logo-content {\n  background-color: $app-primary-dark-deep-orange;\n}\n\n.dark-deep-orange .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-deep-orange;\n    color: $app-primary-dark-deep-orange;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-deep-orange;\n    }\n  }\n}\n\n.dark-deep-orange .btn-group,\n.dark-deep-orange .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-deep-orange;\n      border-color: $app-primary-dark-deep-orange;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-deep-orange !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-deep-orange, 0.12) !important;\n        color: $app-primary-dark-deep-orange !important;\n      }\n    }\n  }\n}\n\n.dark-deep-orange .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-deep-orange;\n    border-color: $app-primary-dark-deep-orange;\n  }\n}\n\n.dark-deep-orange .form-checkbox > input + .check,\n.dark-deep-orange .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-deep-orange;\n}\n\n/* Input Placeholder Style */\n.dark-deep-orange .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-deep-orange .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-deep-orange .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-deep-orange .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-deep-orange .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-deep-orange .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-deep-orange .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-deep-orange .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n\n\n","/*Theme Dark Pink Styles*/\n$app-primary-dark-pink: #e91e63 !default;\n$secondary-dark-pink: #00BFA5;\n\n$sidebar-dark-pink: #252525 !default;\n$sidebar-text-dark-pink: #a1a1a1 !default;\n$sidebar-darken-pink: darken($sidebar-dark-pink, 3%);\n\n$top-nav-bg-dark-pink: $sidebar-dark-pink !default;\n\n// Links\n$link-hover-dark-pink: $white;\n\n//-Base-scss\n.dark-pink .right-arrow {\n  color: $app-primary-dark-pink;\n  &:after {\n    color: $app-primary-dark-pink;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-pink .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-pink a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-pink .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-pink a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-pink .btn-outline-primary,\n.dark-pink a.btn-outline-primary {\n  color: $app-primary-dark-pink;\n  border-color: $app-primary-dark-pink;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-pink;\n    background-color: $app-primary-dark-pink;\n  }\n}\n\n.dark-pink .btn-outline-secondary,\n.dark-pink a.btn-outline-secondary {\n  color: $secondary-dark-pink;\n  border-color: $secondary-dark-pink;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-pink;\n    background-color: $secondary-dark-pink;\n  }\n}\n\n//- Bootstrap file Style\n.dark-pink {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-pink;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-pink, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-pink !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-pink;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-pink;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-pink !important;\n    color: $link-hover-dark-pink !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-pink;\n    border-color: $app-primary-dark-pink;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-pink, 5%) !important;\n      border-color: darken($app-primary-dark-pink, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #f8bbd0 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #f48fb1 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #f06292 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #ec407a !important;\n    }\n\n    &.darken-1 {\n      background-color: #d81b60 !important;\n    }\n\n    &.darken-2 {\n      background-color: #c2185b !important;\n    }\n\n    &.darken-3 {\n      background-color: #ad1457 !important;\n    }\n\n    &.darken-4 {\n      background-color: #880e4f !important;\n    }\n\n    &.accent-1 {\n      background-color: #ff80ab !important;\n    }\n\n    &.accent-2 {\n      background-color: #ff4081 !important;\n    }\n\n    &.accent-3 {\n      background-color: #f50057 !important;\n    }\n\n    &.accent-4 {\n      background-color: #c51162 !important;\n    }\n  }\n}\n\n//Secondary\n.dark-pink {\n  & a.text-secondary {\n    color: $secondary-dark-pink;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-pink, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-pink !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-pink !important;\n    color: $link-hover-dark-pink !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-pink;\n    border-color: $secondary-dark-pink;\n    color: $link-hover-dark-pink;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-pink, 5%) !important;\n      border-color: darken($secondary-dark-pink, 5%) !important;\n      color: $link-hover-dark-pink !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-pink .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-pink .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-pink !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-pink, 0.12) !important;\n    color: $app-primary-dark-pink !important;\n  }\n}\n\n.dark-pink .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-pink .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-pink !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-pink, 0.12) !important;\n    color: $secondary-dark-pink !important;\n  }\n}\n\n.dark-pink .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.dark-pink .app-main-header {\n  background-color: $app-primary-dark-pink !important;\n  color: $white;\n  border-color: $app-primary-dark-pink;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-pink, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-pink .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-pink .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-pink .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-pink .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-pink .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-pink .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-pink .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-pink .color-theme-header {\n  background-color: $app-primary-dark-pink;\n}\n\n//_sidebar.scss\n.dark-pink .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-pink;\n}\n\n.dark-pink .side-nav {\n  background-color: $sidebar-dark-pink !important;\n  color: $sidebar-text-dark-pink !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-pink;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-pink;\n    }\n  }\n}\n\n.dark-pink ul.nav-menu li a {\n  color: $sidebar-text-dark-pink;\n}\n\n.dark-pink ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-pink;\n  }\n}\n\n.dark-pink ul.nav-menu > li.open > a,\n.dark-pink ul.nav-menu > li > a:hover,\n.dark-pink ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-pink;\n  color: $link-hover-dark-pink;\n}\n\n.dark-pink ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-pink;\n}\n\n.dark-pink ul.nav-menu li.menu > a:focus:before,\n.dark-pink ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-pink;\n}\n\n.dark-pink ul.nav-menu li ul {\n  background-color: $sidebar-darken-pink;\n}\n\n.dark-pink ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-pink;\n}\n\n.dark-pink ul.nav-menu li.menu.open > a:before,\n.dark-pink ul.nav-menu li.menu > a:focus:before,\n.dark-pink ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-pink;\n}\n\n.dark-pink ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-pink;\n}\n\n.dark-pink ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-pink;\n}\n\n.dark-pink ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-pink ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-pink ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-pink ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-pink ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-pink;\n  color: $link-hover-dark-pink;\n}\n\n/*Header top Navbar Styles*/\n.dark-pink .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-pink;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-pink;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-pink;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-pink;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-pink;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-pink;\n    }\n  }\n}\n\n.dark-pink .app-top-nav {\n  background-color: $top-nav-bg-dark-pink !important;\n  border-color: $top-nav-bg-dark-pink;\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-pink;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-pink .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-pink;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-pink .rbc-event {\n  background-color: $app-primary-dark-pink;\n}\n\n.dark-pink .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-pink, 10%);\n}\n\n.dark-pink .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-pink, 0.7);\n}\n\n.dark-pink .rbc-toolbar button:active,\n.dark-pink .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-pink, 0.9);\n  border-color: $app-primary-dark-pink;\n}\n\n.dark-pink .rbc-toolbar button:active:hover,\n.dark-pink .rbc-toolbar button.rbc-active:hover,\n.dark-pink .rbc-toolbar button:active:focus,\n.dark-pink .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-pink, 0.9);\n  border-color: $app-primary-dark-pink;\n}\n\n.dark-pink .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-pink, 0.9);\n  border-color: $app-primary-dark-pink;\n}\n\n.dark-pink .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-pink, 0.9);\n  border-color: $app-primary-dark-pink;\n}\n\n.dark-pink .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-pink;\n}\n\n//_chat.scss\n.dark-pink .chat-sidenav-title {\n  color: $app-primary-dark-pink;\n}\n\n.dark-pink .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-pink, 45%);\n  }\n}\n\n//_dashboard.scss\n.dark-pink .contact-list {\n  & i {\n    color: $app-primary-dark-pink;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-pink .Collapsible__trigger {\n  background: $app-primary-dark-pink;\n}\n\n.dark-pink .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-pink;\n  }\n}\n\n//_login.scss\n.dark-pink .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-pink;\n  }\n}\n\n//_portfolio.scss\n.dark-pink .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-pink;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-pink;\n    }\n  }\n}\n\n//_card.scss\n.dark-pink .profile-intro {\n  & .icon {\n    color: $app-primary-dark-pink;\n  }\n}\n\n.dark-pink .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-pink;\n  }\n}\n\n//_tables.scss\n.dark-pink .actions {\n  color: $secondary-dark-pink;\n}\n\n.dark-pink .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-pink, 0.075);\n}\n\n//Border Color\n\n.dark-pink .border-primary {\n  border-color: $app-primary-dark-pink !important;\n}\n\n// login page content\n\n.dark-pink .app-logo-content {\n  background-color: $app-primary-dark-pink;\n}\n\n.dark-pink .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-pink;\n    color: $app-primary-dark-pink;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-pink;\n    }\n  }\n}\n\n.dark-pink .btn-group,\n.dark-pink .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-pink;\n      border-color: $app-primary-dark-pink;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-pink !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-pink, 0.12) !important;\n        color: $app-primary-dark-pink !important;\n      }\n    }\n  }\n}\n\n.dark-pink .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-pink;\n    border-color: $app-primary-dark-pink;\n  }\n}\n\n.dark-pink .form-checkbox > input + .check,\n.dark-pink .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-pink;\n}\n\n/* Input Placeholder Style */\n.dark-pink .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-pink .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-pink .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-pink .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-pink .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-pink .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-pink .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-pink .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n\n\n","/*Theme Dark Blue Styles*/\n$app-primary-dark-blue: #2196F3 !default;\n$secondary-dark-blue: #FF6E40;\n\n$sidebar-dark-blue: #252525 !default;\n$sidebar-text-dark-blue: #a1a1a1 !default;\n$sidebar-darken-blue: darken($sidebar-dark-blue, 3%);\n\n$top-nav-bg-dark-blue: $sidebar-dark-blue !default;\n\n// Links\n$link-hover-dark-blue: $white;\n\n//-Base-scss\n.dark-blue .right-arrow {\n  color: $app-primary-dark-blue;\n  &:after {\n    color: $app-primary-dark-blue;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-blue .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-blue a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-blue .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-blue a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-blue .btn-outline-primary,\n.dark-blue a.btn-outline-primary {\n  color: $app-primary-dark-blue;\n  border-color: $app-primary-dark-blue;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-blue;\n    background-color: $app-primary-dark-blue;\n  }\n}\n\n.dark-blue .btn-outline-secondary,\n.dark-blue a.btn-outline-secondary {\n  color: $secondary-dark-blue;\n  border-color: $secondary-dark-blue;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-blue;\n    background-color: $secondary-dark-blue;\n  }\n}\n\n//- Bootstrap file Style\n.dark-blue {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-blue;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-blue, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-blue !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-blue;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-blue;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-blue !important;\n    color: $link-hover-dark-blue !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-blue;\n    border-color: $app-primary-dark-blue;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-blue, 5%) !important;\n      border-color: darken($app-primary-dark-blue, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #BBDEFB !important;\n    }\n\n    &.lighten-3 {\n      background-color: #90CAF9 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #64B5F6 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #42A5F5 !important;\n    }\n\n    &.darken-1 {\n      background-color: #1E88E5 !important;\n    }\n\n    &.darken-2 {\n      background-color: #1976D2 !important;\n    }\n\n    &.darken-3 {\n      background-color: #1565C0 !important;\n    }\n\n    &.darken-4 {\n      background-color: #0D47A1 !important;\n    }\n\n    &.accent-1 {\n      background-color: #82B1FF !important;\n    }\n\n    &.accent-2 {\n      background-color: #448AFF !important;\n    }\n\n    &.accent-3 {\n      background-color: #2979FF !important;\n    }\n\n    &.accent-4 {\n      background-color: #2962FF !important;\n    }\n  }\n}\n\n//Secondary\n.dark-blue {\n  & a.text-secondary {\n    color: $secondary-dark-blue;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-blue, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-blue !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-blue !important;\n    color: $link-hover-dark-blue !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-blue;\n    border-color: $secondary-dark-blue;\n    color: $link-hover-dark-blue;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-blue, 5%) !important;\n      border-color: darken($secondary-dark-blue, 5%) !important;\n      color: $link-hover-dark-blue !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-blue .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-blue .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-blue !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-blue, 0.12) !important;\n    color: $app-primary-dark-blue !important;\n  }\n}\n\n.dark-blue .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-blue .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-blue !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-blue, 0.12) !important;\n    color: $secondary-dark-blue !important;\n  }\n}\n\n.dark-blue .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.dark-blue .app-main-header {\n  background-color: $app-primary-dark-blue !important;\n  color: $white;\n  border-color: $app-primary-dark-blue;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-blue, 5%);\n\n    & + .search-icon i {\n        color: $white;\n      }\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-blue .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-blue .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-blue .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-blue .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-blue .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-blue .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-blue .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-blue .color-theme-header {\n  background-color: $app-primary-dark-blue;\n\n}\n\n//_sidebar.scss\n.dark-blue .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-blue;\n}\n\n.dark-blue .side-nav {\n  background-color: $sidebar-dark-blue !important;\n  color: $sidebar-text-dark-blue !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-blue;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-blue;\n    }\n  }\n}\n\n.dark-blue ul.nav-menu li a {\n  color: $sidebar-text-dark-blue;\n}\n\n.dark-blue ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-blue;\n  }\n}\n\n.dark-blue ul.nav-menu > li.open > a,\n.dark-blue ul.nav-menu > li > a:hover,\n.dark-blue ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-blue;\n  color: $link-hover-dark-blue;\n}\n\n.dark-blue ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-blue;\n}\n\n.dark-blue ul.nav-menu li.menu > a:focus:before,\n.dark-blue ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-blue;\n}\n\n.dark-blue ul.nav-menu li ul {\n  background-color: $sidebar-darken-blue;\n}\n\n.dark-blue ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-blue;\n}\n\n.dark-blue ul.nav-menu li.menu.open > a:before,\n.dark-blue ul.nav-menu li.menu > a:focus:before,\n.dark-blue ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-blue;\n}\n\n.dark-blue ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-blue;\n}\n\n.dark-blue ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-blue;\n}\n\n.dark-blue ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-blue ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-blue ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-blue ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-blue ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-blue;\n  color: $link-hover-dark-blue;\n}\n\n/*Header top Navbar Styles*/\n.dark-blue .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-blue;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-blue;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-blue;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-blue;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-blue;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-blue;\n    }\n  }\n}\n\n.dark-blue .app-top-nav {\n  background-color: $top-nav-bg-dark-blue !important;\n  border-color: $top-nav-bg-dark-blue;\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-blue;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-blue .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-blue;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-blue .rbc-event {\n  background-color: $app-primary-dark-blue;\n}\n\n.dark-blue .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-blue, 10%);\n}\n\n.dark-blue .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-blue, 0.7);\n}\n\n.dark-blue .rbc-toolbar button:active,\n.dark-blue .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-blue, 0.9);\n  border-color: $app-primary-dark-blue;\n}\n\n.dark-blue .rbc-toolbar button:active:hover,\n.dark-blue .rbc-toolbar button.rbc-active:hover,\n.dark-blue .rbc-toolbar button:active:focus,\n.dark-blue .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-blue, 0.9);\n  border-color: $app-primary-dark-blue;\n}\n\n.dark-blue .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-blue, 0.9);\n  border-color: $app-primary-dark-blue;\n}\n\n.dark-blue .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-blue, 0.9);\n  border-color: $app-primary-dark-blue;\n}\n\n.dark-blue .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-blue;\n}\n\n//_chat.scss\n.dark-blue .chat-sidenav-title {\n  color: $app-primary-dark-blue;\n}\n\n.dark-blue .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-blue, 40%);\n  }\n}\n\n//_dashboard.scss\n.dark-blue .contact-list {\n  & i {\n    color: $app-primary-dark-blue;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-blue .Collapsible__trigger {\n  background: $app-primary-dark-blue;\n}\n\n.dark-blue .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-blue;\n  }\n}\n\n//_login.scss\n\n.dark-blue .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-blue;\n  }\n}\n\n//_portfolio.scss\n.dark-blue .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-blue;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-blue;\n    }\n  }\n}\n\n//_card.scss\n.dark-blue .profile-intro {\n  & .icon {\n    color: $app-primary-dark-blue;\n  }\n}\n\n.dark-blue .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-blue;\n  }\n}\n\n//_tables.scss\n.dark-blue .actions {\n  color: $secondary-dark-blue;\n}\n\n.dark-blue .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-blue, 0.075);\n}\n\n//Border Color\n\n.dark-blue .border-primary {\n  border-color: $app-primary-dark-blue !important;\n}\n\n// login page content\n\n.dark-blue .app-logo-content {\n  background-color: $app-primary-dark-blue;\n}\n\n.dark-blue .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-blue;\n    color: $app-primary-dark-blue;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-blue;\n    }\n  }\n}\n\n.dark-blue .btn-group,\n.dark-blue .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-blue;\n      border-color: $app-primary-dark-blue;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-blue !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-blue, 0.12) !important;\n        color: $app-primary-dark-blue !important;\n      }\n    }\n  }\n}\n\n.dark-blue .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-blue;\n    border-color: $app-primary-dark-blue;\n  }\n}\n\n.dark-blue .form-checkbox > input + .check,\n.dark-blue .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-blue;\n}\n\n/* Input Placeholder Style */\n.dark-blue .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-blue .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-blue .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-blue .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-blue .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-blue .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-blue .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-blue .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n\n\n","/*Theme Dark Deep Purple Styles*/\n$app-primary-dark-deep-purple: #673ab7 !default;\n$secondary-dark-deep-purple: #FFAB00;\n\n$sidebar-dark-deep-purple: #252525 !default;\n$sidebar-text-dark-deep-purple: #a1a1a1 !default;\n$sidebar-darken-deep-purple: darken($sidebar-dark-deep-purple, 3%);\n\n$top-nav-bg-dark-deep-purple: #252525 !default;\n\n// Links\n$link-hover-dark-deep-purple: $white;\n\n//-Base-scss\n.dark-deep-purple .right-arrow {\n  color: $app-primary-dark-deep-purple;\n  &:after {\n    color: $app-primary-dark-deep-purple;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-deep-purple .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-deep-purple a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-deep-purple .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-deep-purple a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-deep-purple .btn-outline-primary,\n.dark-deep-purple a.btn-outline-primary {\n  color: $app-primary-dark-deep-purple;\n  border-color: $app-primary-dark-deep-purple;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-deep-purple;\n    background-color: $app-primary-dark-deep-purple;\n  }\n}\n\n.dark-deep-purple .btn-outline-secondary,\n.dark-deep-purple a.btn-outline-secondary {\n  color: $secondary-dark-deep-purple;\n  border-color: $secondary-dark-deep-purple;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-deep-purple;\n    background-color: $secondary-dark-deep-purple;\n  }\n}\n\n//- Bootstrap file Style\n.dark-deep-purple {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-deep-purple;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-deep-purple, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-deep-purple !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-deep-purple;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-deep-purple;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-deep-purple !important;\n    color: $link-hover-dark-deep-purple !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-deep-purple;\n    border-color: $app-primary-dark-deep-purple;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-deep-purple, 5%) !important;\n      border-color: darken($app-primary-dark-deep-purple, 5%) !important;\n      color: $white !important;\n    }\n  }\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #d1c4e9 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #b39ddb !important;\n    }\n\n    &.lighten-2 {\n      background-color: #9575cd !important;\n    }\n\n    &.lighten-1 {\n      background-color: #7e57c2 !important;\n    }\n\n    &.darken-1 {\n      background-color: #5e35b1 !important;\n    }\n\n    &.darken-2 {\n      background-color: #512da8 !important;\n    }\n\n    &.darken-3 {\n      background-color: #4527a0 !important;\n    }\n\n    &.darken-4 {\n      background-color: #311b92 !important;\n    }\n\n    &.accent-1 {\n      background-color: #b388ff !important;\n    }\n\n    &.accent-2 {\n      background-color: #7c4dff !important;\n    }\n\n    &.accent-3 {\n      background-color: #651fff !important;\n    }\n\n    &.accent-4 {\n      background-color: #6200ea !important;\n    }\n  }\n}\n\n//Secondary\n.dark-deep-purple {\n  & a.text-secondary {\n    color: $secondary-dark-deep-purple;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-deep-purple, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-deep-purple !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-deep-purple !important;\n    color: $link-hover-dark-deep-purple !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-deep-purple;\n    border-color: $secondary-dark-deep-purple;\n    color: $link-hover-dark-deep-purple;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-deep-purple, 5%) !important;\n      border-color: darken($secondary-dark-deep-purple, 5%) !important;\n      color: $link-hover-dark-deep-purple !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-deep-purple .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-deep-purple .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-deep-purple !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-deep-purple, 0.12) !important;\n    color: $app-primary-dark-deep-purple !important;\n  }\n}\n\n.dark-deep-purple .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-deep-purple .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-deep-purple !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-deep-purple, 0.12) !important;\n    color: $secondary-dark-deep-purple !important;\n  }\n}\n\n.dark-deep-purple .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.dark-deep-purple .app-main-header {\n  background-color: $app-primary-dark-deep-purple !important;\n  color: $white;\n  border-color: $app-primary-dark-deep-purple;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-deep-purple, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n    &:focus {\n      background-color: $white;\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-deep-purple .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-deep-purple .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-deep-purple .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-deep-purple .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-deep-purple .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-deep-purple .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-deep-purple .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-deep-purple .color-theme-header {\n  background-color: $app-primary-dark-deep-purple;\n\n}\n\n//_sidebar.scss\n.dark-deep-purple .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-deep-purple;\n}\n\n.dark-deep-purple .side-nav {\n  background-color: $sidebar-dark-deep-purple !important;\n  color: $sidebar-text-dark-deep-purple !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-deep-purple;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-deep-purple;\n    }\n  }\n}\n\n.dark-deep-purple ul.nav-menu li a {\n  color: $sidebar-text-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-deep-purple;\n  }\n}\n\n.dark-deep-purple ul.nav-menu > li.open > a,\n.dark-deep-purple ul.nav-menu > li > a:hover,\n.dark-deep-purple ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-deep-purple;\n  color: $link-hover-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu.open > a {\n  border-color: $secondary-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu > a:focus:before,\n.dark-deep-purple ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li ul {\n  background-color: $sidebar-darken-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu.open > a:before,\n.dark-deep-purple ul.nav-menu li.menu > a:focus:before,\n.dark-deep-purple ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-deep-purple ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-deep-purple ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-deep-purple;\n  color: $link-hover-dark-deep-purple;\n}\n\n/*Header top Navbar Styles*/\n.dark-deep-purple .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-deep-purple;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-deep-purple;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-deep-purple;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-deep-purple;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-deep-purple;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-deep-purple;\n    }\n  }\n}\n\n.dark-deep-purple .app-top-nav {\n  background-color: $top-nav-bg-dark-deep-purple !important;\n  border-color: $top-nav-bg-dark-deep-purple;\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-deep-purple;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-deep-purple .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-deep-purple;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-deep-purple .rbc-event {\n  background-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-deep-purple, 10%);\n}\n\n.dark-deep-purple .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-deep-purple, 0.7);\n}\n\n.dark-deep-purple .rbc-toolbar button:active,\n.dark-deep-purple .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-deep-purple, 0.9);\n  border-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .rbc-toolbar button:active:hover,\n.dark-deep-purple .rbc-toolbar button.rbc-active:hover,\n.dark-deep-purple .rbc-toolbar button:active:focus,\n.dark-deep-purple .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-deep-purple, 0.9);\n  border-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-deep-purple, 0.9);\n  border-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-deep-purple, 0.9);\n  border-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-deep-purple;\n}\n\n//_chat.scss\n.dark-deep-purple .chat-sidenav-title {\n  color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-deep-purple, 45%);\n  }\n}\n\n//_dashboard.scss\n.dark-deep-purple .contact-list {\n  & i {\n    color: $app-primary-dark-deep-purple;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-deep-purple .Collapsible__trigger {\n  background: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-deep-purple;\n  }\n}\n\n//_login.scss\n.dark-deep-purple .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-deep-purple;\n  }\n}\n\n//_portfolio.scss\n.dark-deep-purple .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-deep-purple;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-deep-purple;\n    }\n  }\n}\n\n//_card.scss\n.dark-deep-purple .profile-intro {\n  & .icon {\n    color: $app-primary-dark-deep-purple;\n  }\n}\n\n.dark-deep-purple .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-deep-purple;\n  }\n}\n\n//_tables.scss\n.dark-deep-purple .actions {\n  color: $secondary-dark-deep-purple;\n}\n\n.dark-deep-purple .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-deep-purple, 0.075);\n}\n\n//Border Color\n\n.dark-deep-purple .border-primary {\n  border-color: $app-primary-dark-deep-purple !important;\n}\n\n// login page content\n\n.dark-deep-purple .app-logo-content {\n  background-color: $app-primary-dark-deep-purple;\n}\n\n.dark-deep-purple .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-deep-purple;\n    color: $app-primary-dark-deep-purple;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-deep-purple;\n    }\n  }\n}\n\n.dark-deep-purple .btn-group,\n.dark-deep-purple .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-deep-purple;\n      border-color: $app-primary-dark-deep-purple;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-deep-purple !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-deep-purple, 0.12) !important;\n        color: $app-primary-dark-deep-purple !important;\n      }\n    }\n  }\n}\n\n.dark-deep-purple .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-deep-purple;\n    border-color: $app-primary-dark-deep-purple;\n  }\n}\n\n.dark-deep-purple .form-checkbox > input + .check,\n.dark-deep-purple .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-deep-purple;\n}\n\n/* Input Placeholder Style */\n.dark-deep-purple .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-deep-purple .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-deep-purple .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-deep-purple .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-deep-purple .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-deep-purple .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-deep-purple .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-deep-purple .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n\n","/*Theme Dark Green Styles*/\n$app-primary-dark-green: #4CAF50 !default;\n$secondary-dark-green: #FF6D00;\n\n$sidebar-dark-green: #252525 !default;\n$sidebar-text-dark-green: #a1a1a1 !default;\n$sidebar-darken-green: darken($sidebar-dark-green, 3%);\n\n$top-nav-bg-dark-green: $sidebar-dark-green !default;\n\n// Links\n$link-hover-dark-green: $white;\n\n//-Base-scss\n.dark-green .right-arrow {\n  color: $app-primary-dark-green;\n  &:after {\n    color: $app-primary-dark-green;\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-green .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-green a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-green .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-green a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-green .btn-outline-primary,\n.dark-green a.btn-outline-primary {\n  color: $app-primary-dark-green;\n  border-color: $app-primary-dark-green;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $app-primary-dark-green;\n    background-color: $app-primary-dark-green;\n  }\n}\n\n.dark-green .btn-outline-secondary,\n.dark-green a.btn-outline-secondary {\n  color: $secondary-dark-green;\n  border-color: $secondary-dark-green;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-green;\n    background-color: $secondary-dark-green;\n  }\n}\n\n//- Bootstrap file Style\n.dark-green {\n  & a,\n  & a.text-primary {\n    color: $app-primary-dark-green;\n    &:focus,\n    &:hover {\n      color: darken($app-primary-dark-green, 10%);\n    }\n  }\n\n  & .text-primary {\n    color: $app-primary-dark-green !important;\n  }\n\n  & .page-link {\n    color: $app-primary-dark-green;\n    &:focus,\n    &:hover {\n      color: $app-primary-dark-green;\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: $app-primary-dark-green !important;\n    color: $link-hover-dark-green !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    background-color: $app-primary-dark-green;\n    border-color: $app-primary-dark-green;\n    color: $white;\n\n    &:hover,\n    &:focus,\n    &:not([disabled]):not(.disabled):active {\n      background-color: darken($app-primary-dark-green, 5%) !important;\n      border-color: darken($app-primary-dark-green, 5%) !important;\n      color: $white !important;\n    }\n  }\n\n  & .bg-primary {\n    &.lighten-4 {\n      background-color: #C8E6C9 !important;\n    }\n\n    &.lighten-3 {\n      background-color: #A5D6A7 !important;\n    }\n\n    &.lighten-2 {\n      background-color: #81C784 !important;\n    }\n\n    &.lighten-1 {\n      background-color: #66BB6A !important;\n    }\n\n    &.darken-1 {\n      background-color: #43A047 !important;\n    }\n\n    &.darken-2 {\n      background-color: #388E3C !important;\n    }\n\n    &.darken-3 {\n      background-color: #2E7D32 !important;\n    }\n\n    &.darken-4 {\n      background-color: #1B5E20 !important;\n    }\n\n    &.accent-1 {\n      background-color: #B9F6CA !important;\n    }\n\n    &.accent-2 {\n      background-color: #69F0AE !important;\n    }\n\n    &.accent-3 {\n      background-color: #00E676 !important;\n    }\n\n    &.accent-4 {\n      background-color: #00C853 !important;\n    }\n  }\n}\n\n//Secondary\n.dark-green {\n  & a.text-secondary {\n    color: $secondary-dark-green;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-green, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-green !important;\n  }\n\n  & .bg-secondary,\n  & .badge-secondary {\n    background-color: $secondary-dark-green !important;\n    color: $link-hover-dark-green !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-green;\n    border-color: $secondary-dark-green;\n    color: $link-hover-dark-green;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-green, 5%) !important;\n      border-color: darken($secondary-dark-green, 5%) !important;\n      color: $link-hover-dark-green !important;\n    }\n  }\n}\n\n//flat-btn\n.dark-green .jr-flat-btn {\n  background-color: transparent !important;\n  color: $body-color !important;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-green .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $app-primary-dark-green !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($app-primary-dark-green, 0.12) !important;\n    color: $app-primary-dark-green !important;\n  }\n}\n\n.dark-green .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-green .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: $secondary-dark-green !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-green, 0.12) !important;\n    color: $secondary-dark-green !important;\n  }\n}\n\n.dark-green .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n//_header.scss\n.dark-green .app-main-header {\n  background-color: $app-primary-dark-green !important;\n  color: $white;\n  border-color: $app-primary-dark-green;\n\n  & .search-bar input {\n    background-color: lighten($app-primary-dark-green, 5%);\n\n    & + .search-icon i {\n      color: $white;\n    }\n\n    &:focus {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n\n      & + .search-icon i {\n        color: rgba($gray-default, 0.8);\n      }\n    }\n  }\n\n  & .jr-menu-icon .menu-icon {\n    background-color: $white !important;\n  }\n}\n\n.dark-green .app-header .jr-menu-icon .menu-icon {\n  background-color: $white;\n}\n\n.dark-green .quick-menu .icon-btn {\n  color: $white;\n}\n\n//Logo disable condition\n.dark-green .react-logo-white.d-block {\n  display: block !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-green .react-logo-white.d-lg-block {\n    display: block !important;\n  }\n\n  .dark-green .react-logo-white.d-lg-none {\n    display: none !important;\n  }\n}\n\n.dark-green .react-logo-color.d-block {\n  display: none !important;\n}\n\n@media screen and (min-width: 992px) {\n  .dark-green .react-logo-color.d-lg-block {\n    display: none !important;\n  }\n}\n\n//_right-sidebar.scss\n.dark-green .color-theme-header {\n  background-color: $app-primary-dark-green;\n\n}\n\n//_sidebar.scss\n.dark-green .sidebar-header {\n  border-bottom: 0 none;\n  background-color: $sidebar-darken-green;\n}\n\n.dark-green .side-nav {\n  background-color: $sidebar-dark-green !important;\n  color: $sidebar-text-dark-green !important;\n  border-inline-end: 0 none !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-green;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-green;\n    }\n  }\n}\n\n.dark-green ul.nav-menu li a {\n  color: $sidebar-text-dark-green;\n}\n\n.dark-green ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-green;\n  }\n}\n\n.dark-green ul.nav-menu > li.open > a,\n.dark-green ul.nav-menu > li > a:hover,\n.dark-green ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-green;\n  color: $link-hover-dark-green;\n}\n\n.dark-green ul.nav-menu li.menu.open > a {\n  border-color: $app-primary-dark-green;\n}\n\n.dark-green ul.nav-menu li.menu > a:focus:before,\n.dark-green ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-green;\n}\n\n.dark-green ul.nav-menu li ul {\n  background-color: $sidebar-darken-green;\n}\n\n.dark-green ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-green;\n}\n\n.dark-green ul.nav-menu li.menu.open > a:before,\n.dark-green ul.nav-menu li.menu > a:focus:before,\n.dark-green ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-green;\n}\n\n.dark-green ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-green;\n}\n\n.dark-green ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $app-primary-dark-green;\n}\n\n.dark-green ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-green ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-green ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-green ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-green ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: $sidebar-darken-green;\n  color: $link-hover-dark-green;\n}\n\n/*Header top Navbar Styles*/\n.dark-green .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: $app-primary-dark-green;\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: $app-primary-dark-green;\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: $secondary-dark-green;\n  }\n\n  ul.sub-menu {\n    & li a.active,\n    & li.active > a {\n      color: $app-primary-dark-green;\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: $app-primary-dark-green;\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: $app-primary-dark-green;\n    }\n  }\n}\n\n.dark-green .app-top-nav {\n  background-color: $top-nav-bg-dark-green !important;\n  border-color: $top-nav-bg-dark-green;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: $secondary-dark-green;\n    }\n  }\n}\n\n//_app-module.scss\n.dark-green .module-nav {\n  & li a {\n    &.active {\n      border-color: $app-primary-dark-green;\n    }\n  }\n}\n\n//_calendar.scss\n.dark-green .rbc-event {\n  background-color: $app-primary-dark-green;\n}\n\n.dark-green .rbc-event.rbc-selected {\n  background-color: darken($app-primary-dark-green, 10%);\n}\n\n.dark-green .rbc-slot-selection {\n  background-color: rgba($app-primary-dark-green, 0.7);\n}\n\n.dark-green .rbc-toolbar button:active,\n.dark-green .rbc-toolbar button.rbc-active {\n  background-color: rgba($app-primary-dark-green, 0.9);\n  border-color: $app-primary-dark-green;\n}\n\n.dark-green .rbc-toolbar button:active:hover,\n.dark-green .rbc-toolbar button.rbc-active:hover,\n.dark-green .rbc-toolbar button:active:focus,\n.dark-green .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($app-primary-dark-green, 0.9);\n  border-color: $app-primary-dark-green;\n}\n\n.dark-green .rbc-toolbar button:focus {\n  background-color: rgba($app-primary-dark-green, 0.9);\n  border-color: $app-primary-dark-green;\n}\n\n.dark-green .rbc-toolbar button:hover {\n  background-color: rgba($app-primary-dark-green, 0.9);\n  border-color: $app-primary-dark-green;\n}\n\n.dark-green .rbc-day-slot .rbc-event {\n  border-color: $app-primary-dark-green;\n}\n\n//_chat.scss\n.dark-green .chat-sidenav-title {\n  color: $app-primary-dark-green;\n}\n\n.dark-green .chat-user-item {\n  &.active,\n  &:hover {\n    background-color: lighten($app-primary-dark-green, 45%);\n  }\n}\n\n//_dashboard.scss\n.dark-green .contact-list {\n  & i {\n    color: $app-primary-dark-green;\n  }\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-green .Collapsible__trigger {\n  background: $app-primary-dark-green;\n}\n\n.dark-green .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: $app-primary-dark-green;\n  }\n}\n\n//_login.scss\n.dark-green .login-content .form-control {\n  &:focus {\n    border-color: $app-primary-dark-green;\n  }\n}\n\n//_portfolio.scss\n.dark-green .filter-with-bg-color ul li {\n  & a {\n    border-color: $app-primary-dark-green;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $app-primary-dark-green;\n    }\n  }\n}\n\n//_card.scss\n.dark-green .profile-intro {\n  & .icon {\n    color: $app-primary-dark-green;\n  }\n}\n\n.dark-green .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: $secondary-dark-green;\n  }\n}\n\n//_tables.scss\n.dark-green .actions {\n  color: $secondary-dark-green;\n}\n\n.dark-green .table-hover tbody tr:hover {\n  background-color: rgba($app-primary-dark-green, 0.075);\n}\n\n//Border Color\n\n.dark-green .border-primary {\n  border-color: $app-primary-dark-green !important;\n}\n\n// login page content\n\n.dark-green .app-logo-content {\n  background-color: $app-primary-dark-green;\n}\n\n.dark-green .app-social-block {\n  & .social-link button {\n    border: solid 1px $app-primary-dark-green;\n    color: $app-primary-dark-green;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $app-primary-dark-green;\n    }\n  }\n}\n\n.dark-green .btn-group,\n.dark-green .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $app-primary-dark-green;\n      border-color: $app-primary-dark-green;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: $app-primary-dark-green !important;\n      border-color: transparent !important;\n\n      &:hover,\n      &:focus {\n        background-color: rgba($app-primary-dark-green, 0.12) !important;\n        color: $app-primary-dark-green !important;\n      }\n    }\n  }\n}\n\n.dark-green .nav-pill-sales {\n  & .nav-link.active {\n    background-color: $app-primary-dark-green;\n    border-color: $app-primary-dark-green;\n  }\n}\n\n.dark-green .form-checkbox > input + .check,\n.dark-green .form-checkbox > input.sm + .check {\n  color: $app-primary-dark-green;\n}\n\n/* Input Placeholder Style */\n.dark-green .app-main-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: darken($white, 8%);\n}\n\n.dark-green .app-main-header ::-moz-placeholder { /* Firefox 19+ */\n  color: darken($white, 8%);\n}\n\n.dark-green .app-main-header :-ms-input-placeholder { /* IE 10+ */\n  color: darken($white, 8%);\n}\n\n.dark-green .app-main-header :-moz-placeholder { /* Firefox 18- */\n  color: darken($white, 8%);\n}\n\n.dark-green .app-main-header input:focus::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: lighten($body-color, 50%);\n}\n\n.dark-green .app-main-header input:focus::-moz-placeholder { /* Firefox 19+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-green .app-main-header input:focus:-ms-input-placeholder { /* IE 10+ */\n  color: lighten($body-color, 50%);\n}\n\n.dark-green .app-main-header input:focus:-moz-placeholder { /* Firefox 18- */\n  color: lighten($body-color, 50%);\n}\n\n\n","/*Theme Dark Amber Styles*/\n$primary-dark-theme: #38424B !default;\n$secondary-dark-theme: lighten($primary-dark-theme, 10%);\n$dark-theme-text: #E0E0E0 !default;\n\n$sidebar-dark-theme: $primary-dark-theme !default;\n$sidebar-text-dark-theme: $dark-theme-text !default;\n$sidebar-darken-dark-theme: darken($primary-dark-theme, 2%);\n\n$top-nav-bg-dark-theme: #252525 !default;\n\n// Links\n$link-hover-dark-theme: darken($dark-theme-text, 5%);\n\n//Default Body Style\nbody.dark-theme {\n  color: $dark-theme-text;\n  background-color: $primary-dark-theme;\n}\n\n.dark-theme .modal {\n  color: $primary-dark-theme;\n}\n\n.dark-theme .project-list .project-name {\n  color: $dark-theme-text;\n}\n\n.dark-theme .list-group-item {\n  background-color: darken($secondary-dark-theme, 5%);\n  color: $dark-theme-text;\n  border-color: darken($secondary-dark-theme, 2%);\n\n  &:hover {\n    background-color: darken($secondary-dark-theme, 6%);\n  }\n}\n\n.dark-theme .modal .list-group-item {\n  background-color: $white;\n  color: $primary-dark-theme;\n  border-color: $white;\n\n  &:hover {\n    background-color: $white;\n  }\n}\n\n.dark-theme .quick-menu .icon-btn {\n  color: $dark-theme-text;\n}\n\n.dark-theme .text-dark {\n  color: $dark-theme-text !important;\n}\n\n.dark-theme .nav-pill-sales {\n  & .nav-link {\n    background-color: darken($secondary-dark-theme, 2%);\n    color: $dark-theme-text;\n    border-color: darken($secondary-dark-theme, 2%);\n\n    &.active {\n      background-color: $primary-dark-theme;\n      color: $dark-theme-text;\n      border-color: $primary-dark-theme;\n\n      &:hover,\n      &:focus {\n        color: $dark-theme-text;\n      }\n    }\n  }\n}\n\n.dark-theme .nav-tabs {\n  border-color: $primary-dark-theme;\n  background-color: darken($primary-dark-theme, 10%);\n\n  .nav-link {\n    border-color: transparent;\n\n    @include hover-focus {\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $dark-theme-text;\n    background-color: darken($primary-dark-theme, 10%);\n    border-color: darken($primary-dark-theme, 10%);\n    border-bottom-color: darken($secondary-dark-theme, 2%);\n  }\n}\n\n.dark-theme .bg-grey.lighten-4,\n.dark-theme .jr-card-header-color {\n  background-color: darken($secondary-dark-theme, 2%) !important;\n  color: $dark-theme-text;\n}\n\n//Default card style\n.dark-theme {\n  & .card,\n  & .jr-card {\n    background-color: darken($secondary-dark-theme, 5%);\n    border-color: darken($secondary-dark-theme, 2%);\n  }\n\n  .card-footer {\n    border-color: darken($secondary-dark-theme, 2%);\n    background-color: transparent !important;\n  }\n\n  & .sub-heading,\n  & .meta-date,\n  & .text-muted,\n  & .meta-comment,\n  & .user-detail .user-description {\n    color: darken($dark-theme-text, 20%) !important;\n  }\n\n  //- Bootstrap file Style\n  & a,\n  & a.text-primary {\n    color: darken($dark-theme-text, 5%);\n    &:focus,\n    &:hover {\n      color: darken($dark-theme-text, 10%) !important;\n    }\n  }\n\n  & a.badge-light {\n    color: darken($dark-theme-text, 50%);\n    &:focus,\n    &:hover {\n      color: darken($dark-theme-text, 60%) !important;\n    }\n  }\n\n  & .text-primary {\n    color: darken($dark-theme-text, 5%) !important;\n  }\n\n  & .page-link {\n    color: lighten($primary-dark-theme, 15%);\n    &:focus,\n    &:hover {\n      color: lighten($primary-dark-theme, 10%);\n    }\n  }\n\n  & .bg-primary,\n  & .badge-primary {\n    background-color: darken($primary-dark-theme, 5%) !important;\n    color: $dark-theme-text !important;\n  }\n\n  & .btn-primary,\n  & .jr-btn-primary,\n  & a.btn-primary,\n  & a.jr-btn-primary {\n    border-color: $primary-dark-theme;\n    background-color: darken($primary-dark-theme, 5%) !important;\n    color: $dark-theme-text !important;\n    @include box-shadow(none);\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.disabled,\n    &:disabled {\n      background-color: darken($primary-dark-theme, 5%) !important;\n      border-color: darken($primary-dark-theme, 5%) !important;\n      color: $link-hover-dark-theme !important;\n    }\n  }\n\n  //Secondary\n  & a.text-secondary {\n    color: $secondary-dark-theme;\n    &:focus,\n    &:hover {\n      color: darken($secondary-dark-theme, 10%) !important;\n    }\n  }\n\n  & .text-secondary {\n    color: $secondary-dark-theme !important;\n  }\n\n  & .bg-secondary {\n    background-color: $secondary-dark-theme !important;\n    color: $link-hover-dark-theme !important;\n  }\n\n  & .badge-secondary {\n    background-color: darken($secondary-dark-theme, 10%) !important;\n    color: $link-hover-dark-theme !important;\n  }\n\n  & .btn-secondary {\n    background-color: $secondary-dark-theme;\n    border-color: $secondary-dark-theme;\n    color: $link-hover-dark-theme;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: darken($secondary-dark-theme, 10%) !important;\n      border-color: darken($secondary-dark-theme, 10%) !important;\n      color: $link-hover-dark-theme !important;\n    }\n  }\n}\n\n//-Base-scss\n.dark-theme .right-arrow {\n  color: darken($dark-theme-text, 5%);\n  &:after {\n    color: darken($dark-theme-text, 5%);\n  }\n}\n\n//\n// Alternate buttons\n//\n@each $color, $value in $theme-colors {\n  .dark-theme .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-theme a.btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-theme .btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .dark-theme a.btn-outline-#{$color} {\n    @if $color == \"light\" {\n      @include button-outline-variant($value, $gray-900);\n    } @else {\n      @include button-outline-variant($value, $white);\n    }\n  }\n}\n\n.dark-theme .btn-outline-primary,\n.dark-theme a.btn-outline-primary {\n  color: darken($primary-dark-theme, 5%);\n  border-color: darken($primary-dark-theme, 5%);\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: darken($primary-dark-theme, 5%);\n    background-color: darken($primary-dark-theme, 5%);\n  }\n}\n\n.dark-theme .btn-outline-secondary,\n.dark-theme a.btn-outline-secondary {\n  color: $secondary-dark-theme;\n  border-color: $secondary-dark-theme;\n\n  &:focus,\n  &:hover,\n  &.disabled,\n  &:disabled,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: $white;\n    border-color: $secondary-dark-theme;\n    background-color: $secondary-dark-theme;\n  }\n}\n\n.dark-theme .btn-outline-primary {\n  color: $link-hover-dark-theme;\n  border-color: $link-hover-dark-theme;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: darken($primary-dark-theme, 5%);\n    border-color: darken($primary-dark-theme, 5%);\n    color: $link-hover-dark-theme;\n  }\n}\n\n.dark-theme .jr-flat-btn {\n  background-color: transparent !important;\n  color: $link-hover-dark-theme !important;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: map_get($gray, lighten-4) !important;\n    color: $body-color !important;\n  }\n}\n\n.dark-theme .jr-flat-btn.jr-btn-secondary {\n  background-color: transparent !important;\n  color: lighten($link-hover-dark-theme, 5%) !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($secondary-dark-theme, 0.5) !important;\n    color: lighten($link-hover-dark-theme, 5%) !important;\n  }\n}\n\n.dark-theme .jr-flat-btn.jr-btn-primary {\n  background-color: transparent !important;\n  color: $link-hover-dark-theme !important;\n  border-color: transparent !important;\n\n  &:hover,\n  &:focus {\n    background-color: rgba($primary-dark-theme, 0.5) !important;\n    color: $link-hover-dark-theme !important;\n  }\n}\n\n.dark-theme .btn-group,\n.dark-theme .btn-group-vertical {\n  > .jr-btn,\n  > .btn-default {\n    &.active {\n      background-color: $primary-dark-theme;\n      border-color: $primary-dark-theme;\n      color: $link-hover-dark-theme;\n    }\n\n  }\n\n  > .jr-flat-btn {\n    border-color: transparent;\n    &.active {\n      background-color: transparent;\n      color: darken($primary-dark-theme, 20%);\n\n      &:hover,\n      &:focus {\n        background-color: rgba($primary-dark-theme, 0.5);\n        color: darken($primary-dark-theme, 20%);\n      }\n    }\n  }\n}\n\n.dark-theme .bg-primary {\n  & .jr-flat-btn.jr-btn-primary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n.dark-theme .bg-secondary {\n  & .jr-flat-btn.jr-btn-secondary {\n    background-color: transparent !important;\n    color: $white !important;\n    border-color: transparent !important;\n\n    &:hover,\n    &:focus {\n      background-color: rgba($white, 0.12) !important;\n      color: $white !important;\n    }\n  }\n}\n\n//_header.scss\n.dark-theme .app-main-header {\n  background-color: darken($primary-dark-theme, 5%) !important;\n\n  & .search-bar input {\n    background-color: lighten($primary-dark-theme, 5%);\n\n    &:focus {\n      background-color: $white;\n    }\n  }\n\n  & .search-dropdown input {\n    @media screen and (max-width: 575px) {\n      background-color: $white;\n    }\n  }\n}\n\n.dark-theme .jr-card .app-main-header,\n.dark-theme .sidebar-header,\n.dark-theme .card-header,\n.dark-theme .col-with-divider div[class*=\"col-\"] {\n  border-color: darken($secondary-dark-theme, 2%);\n}\n\n.dark-theme .app-header .app-main-header {\n  border-color: darken($primary-dark-theme, 5%);\n}\n\n.dark-theme .app-header {\n  @include box-shadow(none);\n}\n\n//_footer.scss\n.dark-theme .app-footer {\n  padding: 0 24px;\n  border-color: darken($secondary-dark-theme, 2%);\n  background-color: $primary-dark-theme;\n  color: $dark-theme-text;\n\n  & a.text-secondary {\n    color: $dark-theme-text !important;\n    &:hover {\n      color: darken($dark-theme-text, 10%) !important;\n    }\n  }\n}\n\n.dark-theme .media-list:not(:last-child) {\n  border-color: darken($secondary-dark-theme, 2%);\n}\n\n.dark-theme .app-main-header.bg-white {\n  color: $white !important;\n}\n\n//_right-sidebar.scss\n.dark-theme .color-theme-header {\n  background-color: $primary-dark-theme;\n}\n\n//_sidebar.scss\n.dark-theme .side-nav {\n  background-color: darken($sidebar-dark-theme, 5%) !important;\n  color: $sidebar-text-dark-theme !important;\n  border-color: darken($secondary-dark-theme, 2%) !important;\n\n  & .user-profile {\n    background-color: $sidebar-darken-dark-theme;\n    position: relative;\n    z-index: 2;\n  }\n\n  & .customizer {\n    border-bottom: 0 none;\n  }\n\n  & .user-detail {\n    & .user-name {\n      color: $link-hover-dark-theme;\n    }\n  }\n}\n\n.dark-theme ul.nav-menu li a {\n  color: $sidebar-text-dark-theme;\n}\n\n.dark-theme ul.nav-menu {\n  & .nav-header {\n    color: $sidebar-text-dark-theme;\n  }\n}\n\n.dark-theme ul.nav-menu > li.open > a,\n.dark-theme ul.nav-menu > li > a:hover,\n.dark-theme ul.nav-menu > li > a:focus {\n  background-color: $sidebar-darken-dark-theme;\n  color: $link-hover-dark-theme;\n}\n\n.dark-theme ul.nav-menu li.menu.open > a {\n  border-color: $link-hover-dark-theme;\n}\n\n.dark-theme ul.nav-menu li.menu > a:focus:before,\n.dark-theme ul.nav-menu li.menu > a:hover:before {\n  color: $link-hover-dark-theme;\n}\n\n.dark-theme ul.nav-menu li ul {\n  background-color: $sidebar-darken-dark-theme;\n}\n\n.dark-theme ul.nav-menu li.menu > a:before {\n  color: $sidebar-text-dark-theme;\n}\n\n.dark-theme ul.nav-menu li.menu.open > a:before,\n.dark-theme ul.nav-menu li.menu > a:focus:before,\n.dark-theme ul.nav-menu li.menu li > a:hover:before {\n  color: $link-hover-dark-theme;\n}\n\n.dark-theme ul.nav-menu li.menu .sub-menu li > a:before {\n  color: $sidebar-text-dark-theme;\n}\n\n.dark-theme ul.nav-menu li.menu.open .sub-menu li > a.active {\n  background-color: darken($sidebar-dark-theme, 5%);\n  color: $white;\n}\n\n.dark-theme ul.nav-menu li.menu .sub-menu li > a:hover,\n.dark-theme ul.nav-menu li.menu .sub-menu li > a:focus,\n.dark-theme ul.nav-menu li.menu.open .sub-menu li > a.active:before,\n.dark-theme ul.nav-menu li.menu .sub-menu li > a:focus:before,\n.dark-theme ul.nav-menu li.menu .sub-menu li > a:hover:before {\n  background-color: darken($sidebar-dark-theme, 5%);\n  color: $white;\n}\n\n.dark-theme ul.nav-menu li.menu .sub-menu li > a.active .nav-text {\n  background-color: $primary-dark-theme;\n}\n\n/*Header top Navbar Styles*/\n.dark-theme .navbar-nav {\n  & li {\n    &:hover > a,\n    &:focus > a {\n      color: lighten($secondary-dark-theme, 40%);\n    }\n\n    & a {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      color: lighten($secondary-dark-theme, 40%);\n    }\n  }\n\n  & li.nav-item > a {\n    color: $white;\n  }\n\n  & li.nav-item:hover > a,\n  & li.nav-item:focus > a,\n  & li.nav-item > a:hover,\n  & li.nav-item > a:focus,\n  & li.nav-item.active > a {\n    color: lighten($secondary-dark-theme, 40%);\n  }\n\n  ul.sub-menu {\n    background-color: darken($secondary-dark-theme, 5%);\n    border-color: darken($secondary-dark-theme, 1%);\n\n    & li a.active,\n    & li.active > a {\n      color: lighten($secondary-dark-theme, 40%);\n    }\n  }\n\n  & .nav-arrow {\n    & > a:before {\n      color: $sidebar-text-color;\n    }\n\n    & a:hover,\n    & a:focus {\n      &:before {\n        color: lighten($secondary-dark-theme, 40%);\n      }\n    }\n\n    &:hover > a:before,\n    &:focus > a:before,\n    &.active > a:before {\n      color: lighten($secondary-dark-theme, 40%);\n    }\n  }\n}\n\n.dark-theme .app-top-nav {\n  background-color: $top-nav-bg-dark-theme !important;\n\n  & .navbar-nav {\n    & li.nav-item > a {\n      color: $white;\n    }\n\n    & li.nav-item:hover > a,\n    & li.nav-item:focus > a,\n    & li.nav-item > a:hover,\n    & li.nav-item > a:focus,\n    & li.nav-item.active > a {\n      color: lighten($secondary-dark-theme, 40%);\n    }\n  }\n}\n\n//_calendar.scss\n.dark-theme .rbc-event {\n  background-color: lighten($primary-dark-theme, 30%);\n}\n\n.dark-theme .rbc-event.rbc-selected {\n  background-color: darken($primary-dark-theme, 10%);\n}\n\n.dark-theme .rbc-slot-selection {\n  background-color: rgba($primary-dark-theme, 0.7);\n}\n\n.dark-theme .rbc-toolbar button:active,\n.dark-theme .rbc-toolbar button.rbc-active {\n  background-color: rgba($primary-dark-theme, 0.9);\n  border-color: lighten($primary-dark-theme, 40%);\n  color: lighten($white, 40%)\n}\n\n.dark-theme .rbc-toolbar button:active:hover,\n.dark-theme .rbc-toolbar button.rbc-active:hover,\n.dark-theme .rbc-toolbar button:active:focus,\n.dark-theme .rbc-toolbar button.rbc-active:focus {\n  background-color: rgba($primary-dark-theme, 0.9);\n  border-color: lighten($primary-dark-theme, 40%);\n  color: lighten(white, 20%)\n}\n\n.dark-theme .rbc-toolbar button:hover,\n.dark-theme .rbc-toolbar button:focus {\n  background-color: rgba($primary-dark-theme, 0.9);\n  border-color: lighten($primary-dark-theme, 40%);\n  color: lighten($white, 40%)\n}\n\n.dark-theme .rbc-toolbar button {\n  background-color: rgba($primary-dark-theme, 0.9);\n  border-color: lighten($primary-dark-theme, 40%);\n  color: lighten($primary-dark-theme, 40%)\n}\n\n.dark-theme .rbc-show-more {\n  background-color: lighten($primary-dark-theme, 30%);\n}\n\n.dark-theme .rbc-off-range-bg {\n  background-color: lighten($primary-dark-theme, 10%);\n}\n\n.dark-theme .rbc-day-slot .rbc-event {\n  border-color: $primary-dark-theme;\n}\n\n//_chat.scss\n.dark-theme .chat-sidenav-title {\n  color: $primary-dark-theme;\n}\n\n.dark-theme .chat-user-item {\n  border-color: darken($secondary-dark-theme, 2%);\n\n  &.active,\n  &:hover {\n    background-color: darken($primary-dark-theme, 10%);\n  }\n}\n\n//_dashboard.scss\n.dark-theme .contact-list {\n  & i {\n    color: $primary-dark-theme;\n  }\n}\n\n//_login.scss\n\n.dark-theme .login-content .form-control {\n  &:focus {\n    border-color: $primary-dark-theme;\n  }\n}\n\n//_portfolio.scss\n.dark-theme .filter-with-bg-color ul li {\n  & a {\n    border-color: $primary-dark-theme;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background-color: $primary-dark-theme;\n    }\n  }\n}\n\n//_card.scss\n.dark-theme .profile-intro {\n  & .icon {\n    color: lighten($primary-dark-theme, 20%);\n  }\n}\n\n.dark-theme .social-link {\n  & li.active a,\n  & li a:hover,\n  & li a:focus {\n    color: darken($dark-theme-text, 5%);\n  }\n}\n\n//_tables.scss\n.dark-theme .actions {\n  color: darken($dark-theme-text, 5%);\n}\n\n.dark-theme .table-hover tbody tr:hover {\n  background-color: rgba($primary-dark-theme, 0.075);\n}\n\n//Border Color\n\n.dark-theme .border-primary {\n  border-color: darken($dark-theme-text, 5%) !important;\n}\n\n//Breadcrumb\n.dark-theme .breadcrumb {\n  background-color: $primary-dark-theme;\n}\n\n//_typography.scss\n.dark-theme .desc-list.even-odd li:nth-child(2n) {\n  background-color: $primary-dark-theme;\n}\n\n//_timeline.scss\n.dark-theme .timeline-item::before {\n  border-color: darken($secondary-dark-theme, 2%);\n}\n\n.dark-theme .timeline-panel {\n  background-color: darken($secondary-dark-theme, 5%);\n  border-color: darken($secondary-dark-theme, 2%);\n\n  &:after {\n    border-color: transparent darken($secondary-dark-theme, 5%);\n  }\n\n  &:before {\n    border-color: transparent darken($secondary-dark-theme, 1%);\n  }\n}\n\n//login.scss\n.dark-theme .login-content {\n  background-color: darken($secondary-dark-theme, 5%);\n  border-color: darken($secondary-dark-theme, 2%);\n}\n\n//_app-module.scss\n.dark-theme .chat-sidenav-header,\n.dark-theme .chat-tabs {\n  background-color: darken($primary-dark-theme, 10%);\n}\n\n.dark-theme .module-nav {\n  & li a {\n    color: $gray-500 !important;\n\n    &:hover,\n    &:focus,\n    &.active {\n      color: $white !important;\n    }\n\n    &.active {\n      border-color: darken($primary-dark-theme, 10%);\n    }\n  }\n}\n\n//Module Style\n.dark-theme .module-side {\n  background-color: darken($secondary-dark-theme, 5%);\n}\n\n.dark-theme .module-box-header,\n.dark-theme .app-module-sidenav,\n.dark-theme .dropdown-menu {\n  background-color: darken($secondary-dark-theme, 5%);\n  border-color: darken($secondary-dark-theme, 2%);\n  color: $dark-theme-text;\n}\n\n.dark-theme .dropdown-item {\n  color: $dark-theme-text;\n\n  &:hover,\n  &:focus {\n    background-color: $primary-dark-theme;\n    color: $dark-theme-text;\n  }\n}\n\n.dark-theme .quick-menu .dropdown-menu {\n  & .jr-card-header {\n    @include box-shadow(none);\n    border-color: darken($secondary-dark-theme, 2%);\n  }\n\n  &:after {\n    border-inline-start: 5px solid transparent;\n    border-inline-end: 5px solid transparent;\n    border-bottom: 5px solid darken($secondary-dark-theme, 5%);\n  }\n\n  &:before {\n    border-inline-start: 5px solid transparent;\n    border-inline-end: 5px solid transparent;\n    border-bottom: 5px solid darken($secondary-dark-theme, 2%);\n  }\n}\n\n.dark-theme .module-box-header {\n  & .icon-btn {\n    color: $dark-theme-text;\n  }\n\n  & .search-bar input {\n    background-color: $primary-dark-theme;\n\n    &:focus {\n      background-color: $white;\n    }\n  }\n}\n\n.dark-theme .chat-sidenav-header .search-bar input {\n  background-color: $primary-dark-theme;\n\n  &:focus {\n    background-color: $white;\n  }\n}\n\n.dark-theme .module-box-topbar,\n.dark-theme .module-list-item,\n.dark-theme .module-side-header,\n.dark-theme .chat-main-footer,\n.dark-theme .messages-list ul li,\n.dark-theme hr,\n.dark-theme .chat-sidenav,\n.dark-theme .chat-main-header,\n.dark-theme .modal-header {\n  border-color: darken($secondary-dark-theme, 2%);\n}\n\n.dark-theme .module-logo,\n.dark-theme .user-nav .quick-menu .user-profile {\n  background-color: $primary-dark-theme;\n  color: $dark-theme-text;\n}\n\n.dark-theme .messages-list ul li .user-name a {\n  color: $dark-theme-text;\n}\n\n// App Modules\n\n.dark-theme .chat-module-box,\n.dark-theme .chat-sidenav-content,\n.dark-theme .chat-main-header,\n.dark-theme .chat-main-footer,\n.dark-theme .chat-textarea,\n.dark-theme .module-detail-header,\n.dark-theme .module-box-content,\n.dark-theme .modal-box-footer {\n  background-color: $primary-dark-theme;\n}\n\n.dark-theme .modal-box-content {\n  background-color: lighten($primary-dark-theme, 5%);\n}\n\n.dark-theme .chat-textarea {\n  color: $white;\n}\n\n.dark-theme .chat-item {\n  padding: 16px;\n\n  & .bubble {\n    background-color: lighten($primary-dark-theme, 10%);\n    border-color: darken($primary-dark-theme, 4%);\n\n    &:before {\n      border-inline-end: 9px solid lighten($primary-dark-theme, 10%);\n    }\n\n    &:after {\n      border-inline-end: 8px solid lighten($primary-dark-theme, 10%);\n    }\n  }\n\n  &.flex-row-reverse {\n    & .bubble {\n      margin-inline-end:16px;\n      margin-inline-start:0;\n      background-color: darken($primary-dark-theme, 10%);\n      border-color: lighten($primary-dark-theme, 10%);\n\n      &:before {\n       inset-inline-start:auto;\n       inset-inline-end:-9px;\n        border-inline-start: 9px solid darken($primary-dark-theme, 10%);\n        border-inline-end: 0 none;\n      }\n\n      &:after {\n       inset-inline-start:auto;\n       inset-inline-end:-8px;\n        border-inline-start: 8px solid darken($primary-dark-theme, 10%);\n        border-inline-end: 0 none;\n      }\n    }\n  }\n}\n\n.dark-theme .modal-box-footer {\n  padding-top: 12px;\n}\n\n// login page content\n\n.dark-theme .app-logo-content {\n  background-color: $primary-dark-theme;\n}\n\n.dark-theme .app-social-block {\n  & .social-link button {\n    border: solid 1px $primary-dark-theme;\n    color: $primary-dark-theme;\n\n    &:hover,\n    &:focus {\n      color: $white;\n      background-color: $primary-dark-theme;\n    }\n  }\n}\n\n.dark-theme .form-checkbox > input + .check,\n.dark-theme .form-checkbox > input.sm + .check {\n  color: $sidebar-text-color;\n}\n\n.dark-theme .rc-drawer-sidebar-dark-theme,\n.dark-theme .rc-drawer-pin {\n  color: $dark-theme-text;\n  background-color: $primary-dark-theme;\n}\n\n.dark-theme .rc-drawer-left .rc-drawer-sidebar-dark-theme,\n.dark-theme .rc-drawer-right .rc-drawer-sidebar-dark-theme {\n  @include display-flex(flex, column, nowrap);\n  height: 100vh;\n}\n\n.dark-theme .rc-drawer-pin {\n  @include display-flex(flex, column, nowrap);\n  height: 100%;\n  padding: 20px;\n}\n\n.dark-theme .rc-drawer-docked .rc-drawer-content {\n  border-inline-start: 0 none;\n}\n\n.dark-theme .rc-drawer-sidebar {\n  background-color: $primary-dark-theme;\n}\n\n.dark-theme .rc-collapse {\n  background-color: darken($secondary-dark-theme, 5%);\n  border-color: darken($secondary-dark-theme, 2%);\n\n  & > .rc-collapse-item {\n    border-color: darken($secondary-dark-theme, 2%);\n\n    & > .rc-collapse-header {\n      color: $dark-theme-text;\n    }\n\n    & > .rc-collapse-header .arrow {\n      border-inline-start-color: $dark-theme-text;\n    }\n  }\n\n  & .rc-collapse-content {\n    background-color: darken($secondary-dark-theme, 5%);\n    border-color: darken($secondary-dark-theme, 2%);\n    color: $dark-theme-text;\n  }\n\n  & .rc-collapse-item-disabled > .rc-collapse-header {\n    background-color: darken($secondary-dark-theme, 5%);\n    color: $dark-theme-text;\n  }\n}\n\n.dark-theme .rc-time-picker-panel {\n  color: $primary-dark-theme;\n}\n\n//The link which when clicked opens the collapsable ChatUserList\n.dark-theme .Collapsible__trigger {\n  background-color: darken($primary-dark-theme, 5%);\n}\n\n.dark-theme .Collapsible__contentInner {\n  background-color: darken($secondary-dark-theme, 5%);\n  border-color: darken($secondary-dark-theme, 2%);\n}\n\n.dark-theme .categories-list {\n  & li a:focus,\n  & li a:hover,\n  & li.active a {\n    color: darken($dark-theme-text, 25%);\n  }\n}\n\n.dark-theme .table {\n  & th,\n  & td {\n    border-color: darken($secondary-dark-theme, 2%);\n  }\n}\n\n.dark-theme .table-unbordered .th-border-b th {\n  border-color: darken($secondary-dark-theme, 2%) !important;\n}\n\n.dark-theme .ReactTable {\n  border-color: darken($secondary-dark-theme, 2%);\n\n  & .rt-thead {\n    & .rt-th,\n    & .rt-td {\n      border-color: darken($secondary-dark-theme, 2%);\n    }\n\n    &.-header {\n      border-color: darken($secondary-dark-theme, 2%);\n    }\n  }\n\n  & .rt-table .rt-thead.-headerGroups {\n    background-color: darken($secondary-dark-theme, 5%);\n    border-color: darken($secondary-dark-theme, 2%);\n  }\n\n  &.-striped .rt-tbody .rt-tr-group .rt-tr.-odd,\n  &.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n    background-color: darken($secondary-dark-theme, 2%) !important;\n  }\n\n  & .rt-tbody {\n    & .rt-tr-group,\n    & .rt-td {\n      border-color: darken($secondary-dark-theme, 2%);\n    }\n  }\n\n  & .-pagination {\n    border-color: darken($secondary-dark-theme, 2%);\n\n    & .-btn:not([disabled]) {\n      background-color: darken($secondary-dark-theme, 8%);\n      color: $dark-theme-text;\n\n      &:hover {\n        background-color: darken($secondary-dark-theme, 10%);\n        color: $dark-theme-text;\n      }\n    }\n\n    & .-btn[disabled] {\n      color: $dark-theme-text;\n    }\n  }\n}\n\n.dark-theme .card-strip,\n.dark-theme .contact-item {\n  border-color: darken($secondary-dark-theme, 2%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
